webpackJsonp([3],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = formattedLabelToSeconds;
/* harmony export (immutable) */ __webpack_exports__["e"] = secondsToFormattedLabel;
/* harmony export (immutable) */ __webpack_exports__["f"] = secondsToFormattedLabel2;
/* harmony export (immutable) */ __webpack_exports__["b"] = differenceFormattedAsDurationLabel;
/* unused harmony export toDateTimeString */
/* harmony export (immutable) */ __webpack_exports__["a"] = adjustBroadcastDatesForCrossingMidnight;
/* harmony export (immutable) */ __webpack_exports__["g"] = unreplaceDateTokens;
/* harmony export (immutable) */ __webpack_exports__["d"] = getDatesForClonedBroadcast;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
 // Given a time label (01:12:30), turn it into seconds

function formattedLabelToSeconds(label) {
  var parts = (label || '').split(':');

  if (parts.length == 1) {
    return parseInt(parts[0], 10);
  } else if (parts.length == 2) {
    return 60 * parseInt(parts[0], 10) + parseInt(parts[1], 10);
  } else if (parts.length == 3) {
    return 3600 * parseInt(parts[0], 10) + 60 * parseInt(parts[1], 10) + parseInt(parts[2], 10);
  } else {
    return undefined;
  }
} // Generate a nice time label from the given amount of seconds (H:mm:ss)

function secondsToFormattedLabel(seconds) {
  var showSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var showHoursIfZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var ss = _.padLeft(parseInt(Math.round(seconds % 60)).toString(), 2, '0');

  if (ss == '60') {
    ss = '59'; //rounding above, but 59.75 should not be displayed as 60.
  }

  var mins = seconds / 60 || 0;

  var mm = _.padLeft(parseInt(Math.floor(mins % 60)).toString(), 2, '0');

  var h = parseInt(Math.floor(mins / 60)).toString();
  var hStr = h > 0 || showHoursIfZero ? "".concat(h, ":") : '';

  if (showSeconds) {
    return "".concat(hStr).concat(mm, ":").concat(ss);
  } else {
    return "".concat(hStr).concat(mm);
  }
} // Generate a nice time label from the given amount of seconds in the format XdXhXmXs

function secondsToFormattedLabel2(s) {
  var totalSeconds = parseInt(Math.round(s || 0));
  var secondsPart = totalSeconds % 60;
  var totalMinutes = (totalSeconds - secondsPart) / 60;
  var minutesPart = totalMinutes % 60;
  var totalHours = (totalMinutes - minutesPart) / 60;
  var hoursPart = totalHours % 24;
  var daysPart = (totalHours - hoursPart) / 24;
  var secondsString = '';
  var minutesString = '';
  var hoursString = '';
  var daysString = '';

  if (daysPart == 0) {
    if (hoursPart == 0) {
      if (minutesPart == 0) {
        secondsString = "".concat(secondsPart.toString(), "s");
      } else {
        minutesString = "".concat(minutesPart.toString(), "m");
        secondsString = "".concat(secondsPart.toString(), "s");
      }
    } else {
      hoursString = "".concat(hoursPart.toString(), "h");
      minutesString = "".concat(minutesPart.toString(), "m");
      secondsString = "".concat(secondsPart.toString(), "s");
    }
  } else {
    daysString = "".concat(daysPart.toString(), "d");
    hoursString = "".concat(hoursPart.toString(), "h");
    minutesString = "".concat(minutesPart.toString(), "m");
    secondsString = "".concat(secondsPart.toString(), "s");
  }

  return "".concat(daysString).concat(hoursString).concat(minutesString).concat(secondsString);
} // Generate a nice duration label from the difference between the two dates

function differenceFormattedAsDurationLabel(start, end) {
  var showSeconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  end = !end || __WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(end) ? end : __WEBPACK_IMPORTED_MODULE_0_moment___default()(end);

  if (!end || end.year() >= 9999) {
    return ''; // XXX: Some broadcasts (specifically, simulated live) do not have an end time
  }

  var durationSecs = __WEBPACK_IMPORTED_MODULE_0_moment___default()(end).diff(__WEBPACK_IMPORTED_MODULE_0_moment___default()(start)) / 1000;

  if (durationSecs < 0) {
    return ''; // XXX: some broadcasts have a stops_at before starts_at
  }

  return secondsToFormattedLabel(durationSecs, showSeconds);
} // Use the date part of the given date object and the time part of the given time object
// and return a ISO 8601 formatted date/time in UTC.

function toDateTimeString(date, time) {
  var dateStr = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD');
  var timeStr = __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).format('HH:mm:00');
  var combined = __WEBPACK_IMPORTED_MODULE_0_moment___default()("".concat(dateStr, " ").concat(timeStr));
  return combined.toISOString(true);
} // Given a start date and start/end time objects, make sure they all
// line up with business rules around crossing midnight. Return a
// valid starts_at and stops_at string.

function adjustBroadcastDatesForCrossingMidnight(startDate, startTime, endTime, maxBroadcastDurationHours) {
  var endDate = startDate;

  if (!endTime) {
    endTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startTime).add(maxBroadcastDurationHours, 'hours').toDate();
  }

  if (__WEBPACK_IMPORTED_MODULE_0_moment___default()(endTime).format('HH:mm') <= __WEBPACK_IMPORTED_MODULE_0_moment___default()(startTime).format('HH:mm')) {
    endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate).add(1, 'days');
  }

  return {
    startDate: startDate,
    startTime: startTime,
    endDate: endDate,
    endTime: endTime,
    starts_at: toDateTimeString(startDate, startTime),
    stops_at: toDateTimeString(endDate, endTime)
  };
} // Look for the nicely formatted version (localized) of the start date and
// replace with the string "[date]"

function unreplaceDateTokens(text, date) {
  var now = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).local();
  var regExpWithoutSpace = new RegExp(now.format('LL'), 'g');
  var month = now.format('MMMM');
  var dayOfMonth = now.format('D');
  var year = now.format('YYYY');
  var extraSpace = dayOfMonth.length < 2 ? ' ' : '';
  var regExpWithSpace = new RegExp("".concat(month, " ").concat(extraSpace).concat(dayOfMonth, ", ").concat(year), 'g');
  return text.replace(regExpWithoutSpace, '[date]').replace(regExpWithSpace, '[date]');
}
function getDatesForClonedBroadcast(broadcast, now) {
  var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(broadcast.starts_at).clone();
  var stop = __WEBPACK_IMPORTED_MODULE_0_moment___default()(broadcast.stops_at).clone();
  var duration = stop.diff(start, 'minutes');

  if (broadcast.timeframe == 'future') {
    // If copying a future broadcast, keep broadcast.starts_at/stops_at from clone
    return {
      starts_at: broadcast.starts_at,
      stops_at: broadcast.stops_at
    };
  } else {
    // Otherwise, try to keep same start/stop time but advance the date to today
    // and always keep the same duration as the original broadcast.
    // If the start time has already elapsed for the day, bump the start to now.
    start.set({
      year: now.get('year'),
      month: now.get('month'),
      date: now.get('date')
    });

    if (start < now) {
      start = now;
    }

    stop = start.clone().add(duration, 'minutes');
    return {
      starts_at: start.format(),
      stops_at: stop.format()
    };
  }
}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wire;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_ui_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_ui_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_ui_router__);
// Helper method to wire a simple top-level component. This will do the following:
//  1. Register as new angular module
//  2. Add simple UI router State
//  3. Return reference to angular module
//
// TODO: consider expansion to nontrivial use cases:
// (extra module deps, sub-router-states, ...)


function wire(moduleName, template, controller, controllerName) {
  var url = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var resolve = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

  // Unless a custom URL is specified, use the module name
  if (url == null) {
    url = "/".concat(moduleName);
  }

  return __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module(moduleName, [__WEBPACK_IMPORTED_MODULE_1_angular_ui_router___default.a]).controller(controllerName, controller).config(function ($stateProvider) {
    'ngInject';

    $stateProvider.state(moduleName, {
      url: url,
      resolve: resolve ? resolve : {},
      template: template,
      controller: controller,
      controllerAs: 'vm'
    });
  });
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isSwitcherStudioAppShell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return storage; });
/* harmony export (immutable) */ __webpack_exports__["b"] = gotoLogin;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAuthToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basil_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basil_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_basil_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_sha256__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



 // Track a cookie (yes, always a cookie, not localStorage) to detect whether
// the user has ever logged in.  This is used by src/auth-xd/index.html as
// required by Safari tracking protections.

var EVER_LOGGED_IN_COOKIE = 'bxcauth'; // Export a variable that lets us know if we are inside Switcher Studio

var isSwitcherStudioAppShell = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.switcher; // The Storage class wraps localStorage and cookies to protect against Private Mode on Safari shenanigans

var Storage = /*#__PURE__*/function () {
  function Storage() {
    _classCallCheck(this, Storage);

    if (isSwitcherStudioAppShell) {
      console.warn('localStorage will not work; falling back to custom Switcher Studio strategy');
      this.strategy = new SwitcherStudioStorageStrategy();
    } else {
      try {
        this.strategy = __WEBPACK_IMPORTED_MODULE_0_basil_js___default.a.localStorage;
        this.set('__sentinel__', 'SENTINEL');

        if (this.get('__sentinel__') != 'SENTINEL') {
          throw 'localStorage non functional';
        }
      } catch (e) {
        console.warn('localStorage not working; falling back to cookies', e);
        this.strategy = __WEBPACK_IMPORTED_MODULE_0_basil_js___default.a.cookie;
      } finally {
        this.remove('__sentinel__');
      }
    }
  }

  _createClass(Storage, [{
    key: "get",
    value: function get(key) {
      return this.strategy.get(key);
    }
  }, {
    key: "getPromise",
    value: function getPromise(key) {
      var _this = this;

      if (this.strategy.getPromise) {
        return this.strategy.getPromise(key);
      } else {
        return new Promise(function (resolve, _) {
          return resolve(_this.strategy.get(key));
        });
      }
    }
  }, {
    key: "set",
    value: function set(key, value) {
      return this.strategy.set(key, value);
    }
  }, {
    key: "setPromise",
    value: function setPromise(key, value) {
      var _this2 = this;

      if (this.strategy.setPromise) {
        return this.strategy.setPromise(key, value);
      } else {
        return new Promise(function (resolve, _) {
          return resolve(_this2.strategy.set(key, value));
        });
      }
    }
  }, {
    key: "remove",
    value: function remove(key) {
      return this.strategy.remove(key);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._clearLoggedInCookie();

      return this.strategy.reset();
    }
  }, {
    key: "bumpLoggedInCookie",
    value: function bumpLoggedInCookie() {
      __WEBPACK_IMPORTED_MODULE_0_basil_js___default.a.cookie.set(EVER_LOGGED_IN_COOKIE, '1', {
        expireDays: 365,
        sameSite: 'none',
        secure: true,
        domain: 'boxcast.com'
      });
    }
  }, {
    key: "_clearLoggedInCookie",
    value: function _clearLoggedInCookie() {
      __WEBPACK_IMPORTED_MODULE_0_basil_js___default.a.cookie.remove(EVER_LOGGED_IN_COOKIE);
    }
  }]);

  return Storage;
}(); // The SwitcherStudioStorageStrategy implements a special type of storage layer
// that can mostly work inside their nested webview+iframe implementation.  Note
// that syncronous storage operations are not permitted.


var SwitcherStudioStorageStrategy = /*#__PURE__*/function () {
  function SwitcherStudioStorageStrategy() {
    _classCallCheck(this, SwitcherStudioStorageStrategy);
  }

  _createClass(SwitcherStudioStorageStrategy, [{
    key: "get",
    value: function get(key) {
      console.warn('Switcher Studio does not support a synchronous storage.get implementation');
      return null;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      console.warn('Switcher Studio does not support a synchronous storage.set implementation');
      this.setPromise(key, value);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      console.warn('Switcher Studio does not support removing from storage');
      return __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min___default.a.send(window.parent, 'ui', {
        method: 'setItem',
        params: {
          key: key,
          value: ''
        }
      }, {
        timeout: 2500
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      console.warn('Switcher Studio does not support clearing storage');
      this.remove('oauthState');
      this.remove('oauthVerifier');
      this.remove('oauthPath');
      this.remove('oauthToken');
    }
  }, {
    key: "getPromise",
    value: function getPromise(key) {
      return __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min___default.a.send(window.parent, 'ui', {
        method: 'getItem',
        params: {
          key: key
        }
      }, {
        timeout: 2500
      }).then(function (r) {
        return r.data;
      });
    }
  }, {
    key: "setPromise",
    value: function setPromise(key, value) {
      return __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min___default.a.send(window.parent, 'ui', {
        method: 'setItem',
        params: {
          key: key,
          value: value
        }
      }, {
        timeout: 2500
      });
    }
  }]);

  return SwitcherStudioStorageStrategy;
}(); // Export an instance of the storage class to be used throughout this page lifecycle


var storage = new Storage(); // Export a helper method for immediately redirecting to the login page

function gotoLogin() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  //$('body > app').hide();
  //$('body').append(`<h1 class="text-center">Redirecting in 5 sec ${message}</h1>`);
  //setTimeout(() => {
  var state = generateRandomString(8);
  var verifier = generateRandomString(48);
  var challenge = b64(__WEBPACK_IMPORTED_MODULE_1_js_sha256___default.a.array(verifier));
  var promises = [storage.setPromise('oauthState', state), storage.setPromise('oauthVerifier', verifier), storage.setPromise('oauthPath', window.location.href)];
  Promise.all(promises).then(function () {
    var authUrl = isSwitcherStudioAppShell ? SWITCHER_AUTH_URL : AUTH_URL;
    window.location.replace(authUrl + '&state=' + state + '&code_challenge_method=S256&code_challenge=' + challenge);
  }); //}, 5000)

  throw new Error('halt');
} // Export a function to retrieve the current auth token

function getAuthToken() {
  // XXX: The Switcher Studio app may inject the OAuth token into the document. Prefer that,
  // but resort to localStorage for all other requests.
  return document.switcherStudioAccessToken || storage.get('oauthToken');
}

function generateRandomString(n) {
  var bytes = new Uint8Array((n * 3 + 3) / 4);

  if (window.msCrypto) {
    msCrypto.getRandomValues(bytes);
  } else {
    crypto.getRandomValues(bytes);
  }

  return b64(bytes).substring(0, n);
}

function b64(bytes) {
  return btoa(String.fromCharCode.apply(null, bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getUISports;
/* harmony export (immutable) */ __webpack_exports__["b"] = getUIConnections;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateSportFromPrefix;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreScoreboardUIConfiguration;
/* harmony export (immutable) */ __webpack_exports__["d"] = mapScoreboardUIConfigurationToAPI;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearScoreboardConfig;
// The scoreboard utilities in here deal with a mismatch between the API
// configuration and how the UI wants to present the configuration.
//
// Starting with the standard `broadcast.scoreboard_configuration` object
// from the API, we introduce or change the following attributes:
//  * Split `sport` into `sport_prefix` and `sport_variation` in the UI to allow
//    a dependent selection between Basketball 4Q/2H
//  * Remove the idea of "Manual" as a scoreboard_make and flatten into a
//    top-level boolean option.
//  * Use a new notion of `connection` to switch between the 2 types of BoxCast
//    adapters as well as Sportzcast.
function getUISports() {
  return [{
    label: 'Baseball / Softball',
    value: 'Baseball/Softball',
    icon: '/img/sports/baseball.svg'
  }, {
    label: 'Basketball',
    value: 'Basketball',
    icon: '/img/sports/basketball.svg'
  }, {
    label: 'Football',
    value: 'Football',
    icon: '/img/sports/football.svg'
  }, {
    label: 'Hockey',
    value: 'Hockey',
    icon: '/img/sports/hockey.svg'
  }, {
    label: 'Lacrosse',
    value: 'Lacrosse',
    icon: '/img/sports/lacrosse.svg'
  }, {
    label: 'Soccer',
    value: 'Soccer',
    icon: '/img/sports/soccer.svg'
  }, {
    label: 'Volleyball',
    value: 'Volleyball',
    icon: '/img/sports/volleyball.svg'
  }, {
    label: 'Wrestling',
    value: 'Wrestling',
    icon: '/img/sports/wrestling.svg'
  }];
}
function getUIConnections(account) {
  var result = [];

  if (account.feature_flags.automated_scoreboard) {
    if (account.has_scoreboard_assists) {
      result.push({
        label: 'BoxCast Scoreboard Assist',
        value: 'scoreboard_assist',
        icon: '/img/sports/BoxCastScoreboardAssist.png',
        description: 'Supports Trans-Lux Fair-Play, Daktronics, and OES',
        is_new: true
      });
    }

    result.push({
      label: 'BoxCast Scoreboard Adapter',
      value: 'scoreboard_adapter',
      icon: '/img/sports/BoxCastScoreBug.png',
      description: '(Legacy) Supports Trans-Lux Fair-Play, Daktronics, and OES'
    });
  }

  if (account.feature_flags.sportzcast) {
    result.push({
      label: 'ScoreBot',
      value: 'scorebot',
      icon: '/img/sports/SportzCastLogo.png',
      description: 'Requires Sportzcast log in'
    });
  }

  return result;
}
function updateSportFromPrefix(scoreboard_configuration, sport_prefix) {
  scoreboard_configuration.sport_prefix = sport_prefix;

  if (sport_prefix == 'Basketball') {
    if (!scoreboard_configuration.sport_variation) {
      scoreboard_configuration.sport_variation = ' (4 Quarters)';
    }

    scoreboard_configuration.sport = scoreboard_configuration.sport_prefix + scoreboard_configuration.sport_variation;
  } else {
    scoreboard_configuration.sport = scoreboard_configuration.sport_prefix;
  }

  return scoreboard_configuration;
}
function restoreScoreboardUIConfiguration(sc) {
  if (sc.scoreboard_make == 'Manual') {
    sc.manual = true;
  } else if (sc.scoreboard_make == 'BoxCast') {
    sc.manual = false;
    sc.connection = 'scoreboard_assist';
  } else if (sc.scoreboard_make == 'Sportzcast') {
    sc.manual = false;
    sc.connection = 'scorebot';
  } else if (sc.scoreboard_make) {
    sc.manual = false;
    sc.connection = 'scoreboard_adapter';
  }

  if (sc.sport) {
    if (sc.sport.startsWith('Basketball')) {
      sc.sport_prefix = 'Basketball';
      sc.sport_variation = sc.sport.replace('Basketball', '');
    } else {
      sc.sport_prefix = sc.sport;
      sc.sport_variation = '';
    }
  }
}
function mapScoreboardUIConfigurationToAPI(sc) {
  if (sc.manual) {
    delete sc.manual;
    delete sc.connection;
    delete sc.sportzcast_bot_number;
    sc.scoreboard_make = 'Manual';
    sc.scoreboard_model = 'Manual Input';
  } else if (sc.connection == 'scoreboard_assist') {
    delete sc.manual;
    delete sc.connection;
    delete sc.sportzcast_bot_number;
    sc.scoreboard_make = 'BoxCast';
    sc.scoreboard_model = 'Scoreboard Assist';
  } else if (sc.connection == 'scorebot') {
    delete sc.manual;
    delete sc.connection;
    sc.scoreboard_make = 'Sportzcast';
    sc.scoreboard_model = 'ScoreBOT';
  } else if (sc.connection == 'scoreboard_adapter') {
    delete sc.manual;
    delete sc.connection;
    delete sc.sportzcast_bot_number;
  }

  if (sc.sport) {
    if (sc.sport_prefix == 'Basketball') {
      sc.sport = sc.sport_prefix + sc.sport_variation;
    } else {
      sc.sport = sc.sport_prefix;
    }
  }

  delete sc.sport_prefix;
  delete sc.sport_variation;
}
function clearScoreboardConfig(sc) {
  sc.sport = null;
  sc.sport_prefix = null;
  sc.sport_variation = null;
  sc.scoreboard_make = null;
  sc.scoreboard_model = null;
  delete sc.connection;
  delete sc.manual;
}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IsRtmpURLValid;
/* harmony export (immutable) */ __webpack_exports__["b"] = SanitizeRTMPURL;
/* harmony export (immutable) */ __webpack_exports__["c"] = TransformRTMPPushChannelAPIToClient;
/* harmony export (immutable) */ __webpack_exports__["d"] = TransformRTMPPushChannelClientToAPI;
var rtmpUrlIsValidRE = /^rtmps?:\/\/[^\s\/]+\/[^\s]+$/;
var rtmpUserInfoRE = /^rtmps?:\/\/([^:]+):([^@]+)@[^\s\/]+\/[^\s]+$/;
function IsRtmpURLValid(url) {
  return rtmpUrlIsValidRE.test(url);
} // Remove user info (username/password) from an RTMP URL.

function SanitizeRTMPURL(url) {
  var matches = url.match(rtmpUserInfoRE);

  if (matches && matches.length == 3) {
    var usernameEncoded = matches[1];
    var passwordEncoded = matches[2];
    return url.replace("://".concat(usernameEncoded, ":").concat(passwordEncoded, "@"), '://');
  }

  return url;
} // Modifies the object that is returned from the API into a format used by the client-side
// dashboard code. Specifically, it parses authentication information from the RTMP URL and
// places it in separate fields.

function TransformRTMPPushChannelAPIToClient(rtmpPushChannel) {
  var streamUrl = rtmpPushChannel.stream_url;
  var matches = streamUrl.match(rtmpUserInfoRE);

  if (matches && matches.length == 3) {
    var usernameEncoded = matches[1];
    var passwordEncoded = matches[2];
    rtmpPushChannel.stream_url = streamUrl.replace("://".concat(usernameEncoded, ":").concat(passwordEncoded, "@"), '://');
    rtmpPushChannel.username = decodeURIComponent(usernameEncoded);
    rtmpPushChannel.password = decodeURIComponent(passwordEncoded);
  }

  return rtmpPushChannel;
} // Modifies the object that is used by the client-side dashboard code into a format to be sent to
// the API. Specifically, it puts any authentication information kept in separate fields into the
// RTMP URL.

function TransformRTMPPushChannelClientToAPI(rtmpPushChannel) {
  if (rtmpPushChannel.username && rtmpPushChannel.password) {
    var usernameEncoded = encodeURIComponent(rtmpPushChannel.username);
    var passwordEncoded = encodeURIComponent(rtmpPushChannel.password);
    rtmpPushChannel.stream_url = rtmpPushChannel.stream_url.replace('://', "://".concat(usernameEncoded, ":").concat(passwordEncoded, "@"));
    delete rtmpPushChannel.username;
    delete rtmpPushChannel.password;
  }

  return rtmpPushChannel;
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = errorDescriptionFromResponse;
// Generate an error message from the server response
function errorDescriptionFromResponse(response) {
  var details = response.data ? response.data : response;

  if (details.error_hint || details.error_description || details.invalid_fields) {
    return "".concat(details.error_hint || details.error_description, " ").concat(invalidFieldsToSentence(details.invalid_fields));
  }

  return details;
}

function invalidFieldsToSentence(fields) {
  if (!fields) {
    return '';
  }

  var sentence = '';
  Object.keys(fields).forEach(function (k) {
    sentence += "".concat(cleanSlugKey(k), " ").concat(fields[k], ". ");
  });
  return sentence;
}

function cleanSlugKey(key) {
  key = key.replace(/_/g, ' ');
  return key[0].toUpperCase() + key.substr(1).toLowerCase();
}

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = forceBrowserDownload;
function forceBrowserDownload(uri, filename) {
  var encodedUri = encodeURI(uri);
  var link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', filename);

  if (navigator.userAgent.indexOf('Firefox') >= 0) {
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    link.click();
  }
}

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = decodeGeohash;
/* harmony export (immutable) */ __webpack_exports__["a"] = countCountries;
var BITS = [16, 8, 4, 2, 1];
var BASE32 = '0123456789bcdefghjkmnpqrstuvwxyz';
function decodeGeohash(geohash) {
  var even = true;
  var lat = [-90.0, 90.0];
  var lon = [-180.0, 180.0];
  var lat_err = 90.0;
  var lon_err = 180.0;
  var i, j;

  for (i = 0; i < geohash.length; i++) {
    var c = geohash[i];
    var cd = BASE32.indexOf(c);

    for (j = 0; j < 5; j++) {
      var mask = BITS[j];

      if (even) {
        lon_err /= 2;
        refineInterval(lon, cd, mask);
      } else {
        lat_err /= 2;
        refineInterval(lat, cd, mask);
      }

      even = !even;
    }
  }

  lat[2] = (lat[0] + lat[1]) / 2;
  lon[2] = (lon[0] + lon[1]) / 2;
  return {
    latitude: lat,
    longitude: lon
  };
}

function refineInterval(interval, cd, mask) {
  if (cd & mask) {
    interval[0] = (interval[0] + interval[1]) / 2;
  } else {
    interval[1] = (interval[0] + interval[1]) / 2;
  }
}

function countCountries(view_counts_by_region_code) {
  var map = {};

  _.each(view_counts_by_region_code, function (_, code) {
    var parts = code.split('-');
    map[parts[1]] = true;
  });

  return _.keys(map).length;
}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AllowSocial;
/**
 * Returns whether or not the user is allowed to share a broadcast (or highlight from a broadcast)
 * to social media. Based on a combination of the feature flags, account and broadcast settings.
 *
 * @param  {Object}    featureFlags A "feature flags" object
 * @param  {Account}   account The current account
 * @param  {Broadcast} broadcast The broadcast in question (or the broadcast to which the highlight belongs)
 * @return {bool}      True if the user can share to social media; false otherwise
 */
function AllowSocial(featureFlags, account, broadcast) {
  // Make a feature flags const that looks like an object no matter what
  var ff = featureFlags || {}; // Account content settings an extra features that look like an object no matter what

  var a = account || {};
  var accountContentSettings = a.content_settings || {};
  var accountExtraFeatures = a.extra_features || {}; // Broadcast content settings that looks like an object no matter what

  var b = broadcast || {};
  var broadcastContentSettings = b.content_settings || {}; // If media_token_restrictions, then flat-out "no".

  if (accountExtraFeatures.media_token_restrictions) {
    return false;
  } // No media token restrictions and no host restrictions feature -- good to go.


  if (!ff.host_restrictions) {
    return true;
  } // If we get here, the user has no media token restrictions, but they do have the host restrictions _feature_.
  // We need to see if it's actually configured, starting at the most specific level (broadcast) and moving up
  // to the account-level. We don't bother checking any channels because any social promotion would use the
  // single-broadcast channel.


  var hostRestrictionsAllowsSocial = function hostRestrictionsAllowsSocial(hostRestrictions) {
    // If there IS a redirect URL, we can allow social because we can send folks there.
    // If there's no redirect URL, we can't allow social because they'd be stranded on boxcast.tv and
    // we don't know where else to send them.
    return !!hostRestrictions.redirectUrl;
  };

  if (broadcastContentSettings.hostRestrictions) {
    return hostRestrictionsAllowsSocial(broadcastContentSettings.hostRestrictions);
  } else if (a.content_settings.hostRestrictions) {
    return hostRestrictionsAllowsSocial(accountContentSettings.hostRestrictions);
  } // By default, return true to allow social sharing


  return true;
}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VideoAudioConfig; });
var commonVideoBitrates = [{
  label: 'Audio Only',
  value: 10000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '300 kbps',
  value: 300000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '500 kbps',
  value: 500000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '700 kbps',
  value: 700000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '900 kbps',
  value: 900000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '1.2 Mbps',
  value: 1200000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '1.5 Mbps',
  value: 1572864,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '2.0 Mbps',
  value: 2000000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '2.5 Mbps',
  value: 2500000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '3.0 Mbps',
  value: 3000000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '4.0 Mbps',
  value: 4000000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '4.8 Mbps',
  value: 4800000,
  serial_prefixes: ['l', 'n', 'o']
}, {
  label: '5.0 Mbps',
  value: 5000000,
  serial_prefixes: ['p']
}, {
  label: '6.0 Mbps',
  value: 6000000,
  serial_prefixes: ['p']
}, {
  label: '7.0 Mbps',
  value: 7000000,
  serial_prefixes: ['p']
}, {
  label: '8.0 Mbps',
  value: 8000000,
  serial_prefixes: ['p']
}, {
  label: '9.0 Mbps',
  value: 9000000,
  serial_prefixes: ['p']
}, {
  label: '10.0 Mbps',
  value: 10000000,
  serial_prefixes: ['p']
}, {
  label: '11.0 Mbps',
  value: 11000000,
  serial_prefixes: ['p']
}, {
  label: '12.0 Mbps',
  value: 12000000,
  serial_prefixes: ['p']
}, {
  label: '13.0 Mbps',
  value: 13000000,
  serial_prefixes: ['p']
}, {
  label: '14.0 Mbps',
  value: 14000000,
  serial_prefixes: ['p']
}, {
  label: '15.0 Mbps',
  value: 15000000,
  serial_prefixes: ['p']
}, {
  label: '16.0 Mbps',
  value: 16000000,
  serial_prefixes: ['p']
}, {
  label: '17.0 Mbps',
  value: 17000000,
  serial_prefixes: ['p']
}, {
  label: '18.0 Mbps',
  value: 18000000,
  serial_prefixes: ['p']
}];
var boxcasterVideoBitrates = [{
  label: 'Auto-detect',
  value: 'default',
  serial_prefixes: ['l', 'n', 'o', 'p']
}].concat(commonVideoBitrates);
var streamVideoBitrates = [{
  label: 'Default',
  value: 'default',
  serial_prefixes: ['l', 'n', 'o', 'p']
}].concat(commonVideoBitrates);
var commonAudioBitrates = [{
  label: '48 kbps',
  value: 48000,
  serial_prefixes: ['l', 'n', 'o']
}, {
  label: '64 kbps',
  value: 64000,
  serial_prefixes: ['l', 'n', 'o']
}, {
  label: '96 kbps',
  value: 96000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '128 kbps',
  value: 128000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '192 kbps',
  value: 192000,
  serial_prefixes: ['p']
}, {
  label: '256 kbps',
  value: 256000,
  serial_prefixes: ['p']
}, {
  label: '320 kbps',
  value: 320000,
  serial_prefixes: ['p']
}];
var boxcasterAudioBitrates = [{
  label: 'Auto-detect',
  value: 'default',
  serial_prefixes: ['l', 'n', 'o', 'p']
}].concat(commonAudioBitrates);
var streamAudioBitrates = [{
  label: 'Default',
  value: 'default',
  serial_prefixes: ['l', 'n', 'o', 'p']
}].concat(commonAudioBitrates);
var VideoAudioConfig = {
  boxcaster: {
    video_bitrates: boxcasterVideoBitrates,
    audio_bitrates: boxcasterAudioBitrates
  },
  stream: {
    video_bitrates: streamVideoBitrates,
    audio_bitrates: streamAudioBitrates
  }
};

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = inferVisiblityOptionFromPriceSettings;
/* harmony export (immutable) */ __webpack_exports__["b"] = updatePriceSettingsFromVisibilityOption;
// BoxCast pricing helper methods
function inferVisiblityOptionFromPriceSettings(obj) {
  if (obj.is_ticketed) {
    if (obj.free_variant == 'none') {
      return 'ticketed';
    } else {
      return 'flex';
    }
  } else if (obj.is_private) {
    return 'private';
  } else {
    return 'public';
  }
} // FUTURE: it's debatable whether it should be split by type or combinations of
// is_private, is_ticketed, free_variant, etc. --  we should discuss this more
// when we talk through updating/simplifying the pricing model

function updatePriceSettingsFromVisibilityOption(obj, visibility) {
  var isChannel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  // Note: `obj` could be a channel or a broadcast
  // NOTE: We don't support ticketed channels in Video Portals (yet).
  // We don't mess with the validation here, because it should never reach that state.
  // If there are errors, it should show them during channel validation when creating/editing a channel.
  switch (visibility) {
    case 'public':
      obj.is_ticketed = false;
      if (!isChannel) obj.is_private = false;
      obj.ticket_price = null;
      obj.free_variant = null;
      break;

    case 'private':
      obj.is_ticketed = false;
      obj.is_private = true;
      obj.ticket_price = null;
      obj.free_variant = null;
      break;

    case 'ticketed':
      obj.is_ticketed = true;
      obj.is_private = isChannel ? true : false; // don't support ticketed channels in video portal yet

      obj.free_variant = 'none';
      break;

    case 'flex':
      obj.is_ticketed = true;
      obj.is_private = isChannel ? true : false; // don't support ticketed channels in video portal yet

      obj.free_variant = 'low';
      break;
  }

  return obj;
}

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmbedCodeGenerator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base64__ = __webpack_require__(388);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var EmbedCodeGenerator = /*#__PURE__*/function () {
  function EmbedCodeGenerator() {
    _classCallCheck(this, EmbedCodeGenerator);
  }

  _createClass(EmbedCodeGenerator, null, [{
    key: "v2WidgetEmbed",
    value: function v2WidgetEmbed(channelId, title, description, related) {
      var template = "\n      <div id=\"boxcast-widget-".concat(channelId, "\">\n      <script type=\"text/javascript\">\n      var s = document.createElement('script');\n      var a = String.fromCharCode;\n      var h = (('https:' == document.location.protocol) ? 'https:' : 'http:');\n      s.setAttribute('data-action', 'boxcast-widget-load');\n      s.setAttribute('data-handle', '").concat(channelId, "');\n      s.setAttribute('data-options', 'version=3").concat(title ? '&title=1' : '').concat(description ? '&description=1' : '').concat(related ? '&history=1' : '', "');\n      s.src = h + '").concat(WIDGET_JS, "';\n      document.getElementsByTagName('head')[0].appendChild(s);\n      </script>\n      </div>\n    "); // XXX: boxcastiframe.com requires a space

      var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, ' ').trim();
      return cleaned;
    }
  }, {
    key: "v2IframeEmbed",
    value: function v2IframeEmbed(channelId, title, description, related) {
      var params = __WEBPACK_IMPORTED_MODULE_0__base64__["a" /* default */].encode("'version=3".concat(title ? '&title=1' : '').concat(description ? '&description=1' : '').concat(related ? '&history=1' : '', "'"));
      var url = "http://boxcastiframe.com/index2.php/?id=".concat(channelId, "&widget_params=").concat(params);
      var template = "\n      <iframe width=\"720\" height=\"800\" src=\"".concat(url, "\" frameBorder=\"0\" scrolling=\"auto\" allowfullscreen=\"true\"></iframe>\n    ");
      var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '');
      return cleaned;
    }
  }, {
    key: "v3WidgetEmbed",
    value: function v3WidgetEmbed(channelId, args) {
      var embedUrl = BOXCAST_JS_EMBED_URL;

      if (args.version) {
        embedUrl = embedUrl.replace('/v3', "/".concat(args.version, "/v3"));
      }

      args = mungeArgs(args);
      var argString = JSON.stringify(args);
      var template = "\n      <div id=\"boxcast-widget-".concat(channelId, "\"></div>\n      <script type=\"text/javascript\" charset=\"utf-8\">\n      (function(d, s, c, o) {\n      var js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];\n      var h = (('https:' == document.location.protocol) ? 'https:' : 'http:');\n      js.src = h + '").concat(embedUrl, "';\n      js.onload = function() { boxcast.noConflict()('#boxcast-widget-'+c).loadChannel(c, o); };\n      js.charset = 'utf-8';\n      fjs.parentNode.insertBefore(js, fjs);\n      }(document, 'script', '").concat(channelId, "', ").concat(argString, "));\n      </script>\n    ");
      var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
      return cleaned;
    }
  }, {
    key: "v3Highlights",
    value: function v3Highlights(channelId, args) {
      var embedUrl = BOXCAST_JS_EMBED_URL;

      if (args.version) {
        embedUrl = embedUrl.replace('/v3', "/".concat(args.version, "/v3"));
      }

      args = mungeArgs(args);
      var argString = JSON.stringify(args);
      var template = "\n      <div id=\"boxcast-widget-".concat(channelId, "\"></div>\n      <script type=\"text/javascript\" charset=\"utf-8\">\n      (function(d, s, c, o) {\n      var js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];\n      var h = (('https:' == document.location.protocol) ? 'https:' : 'http:');\n      js.src = h + '").concat(embedUrl, "';\n      js.onload = function() { boxcast.noConflict()('#boxcast-widget-'+c).loadHighlights(c, o); };\n      js.charset = 'utf-8';\n      fjs.parentNode.insertBefore(js, fjs);\n      }(document, 'script', '").concat(channelId, "', ").concat(argString, "));\n      </script>\n    ");
      var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
      return cleaned;
    }
  }, {
    key: "v3IframeEmbed",
    value: function v3IframeEmbed(channelId, args) {
      var autoResize = args.iframeResize;
      args = mungeArgs(args);
      var params = [];

      for (var p in args) {
        if (args.hasOwnProperty(p)) {
          var val = args[p];

          if (typeof val !== 'undefined' && val !== null) {
            if (typeof val == 'boolean') {
              val = val ? '1' : '0';
            }

            params.push(encodeURIComponent(p) + '=' + encodeURIComponent(val));
          }
        }
      }

      params = params.join('&');
      var url = "".concat(BOXCAST_JS_IFRAME_URL, "/").concat(encodeURIComponent(channelId), "?").concat(params);
      var template;

      if (autoResize) {
        // NOTE: the problem with using a script to write the iframe is that CMS's prevent script tags
        // often, which is the usual driver for using iframe embed method.
        template = "\n        <script src=\"https://js.boxcast.com/libs/iframeResizer-3.5.2.min.js\"></script>\n        <script>(function(p,c,q){\n          document.write('<iframe width=\"100%\" id=\"'+p+c+'\" src=\"".concat(BOXCAST_JS_IFRAME_URL, "/'+c+'?'+q+'\" frameBorder=\"0\" scrolling=\"auto\" allowfullscreen=\"true\" allow=\"autoplay; fullscreen\"></iframe>');\n          iFrameResize({}, '#'+p+c);\n        })('boxcast-iframe-', '").concat(channelId, "', '").concat(params, "&hostname='+encodeURIComponent(location.hostname));\n        </script>\n      ");
      } else {
        // XXX: TODO: sometimes, the user may just need the `src` value without the <iframe> tag, depending
        // on their web site software. Not sure how we decide when/how to present that option.
        template = "\n        <iframe width=\"720\" height=\"800\" src=\"".concat(url, "\" frameBorder=\"0\" scrolling=\"auto\" allowfullscreen=\"true\" allow=\"autoplay; fullscreen\"></iframe>\n      ");
      }

      var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
      return cleaned;
    }
  }, {
    key: "v3Link",
    value: function v3Link(channelId, args) {
      var url = BOXCAST_TV_SHOW_URL + channelId; // Per Josh M, it's more likely that they just want the link URL and not a fully-formatted
      // anchor tag
      //var template = `
      //  <a href="${url}">View on BoxCast.tv</a>
      //`;

      args = mungeArgs(args);
      var params = args.applyBrandColor === false ? '?applyBrandColor=0' : '';
      var template = "\n      ".concat(url).concat(params, "\n    ");
      var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
      return cleaned;
    }
  }, {
    key: "v3App",
    value: function v3App(channelId, args) {
      args = mungeArgs(args);
      var params = [];

      for (var p in args) {
        if (args.hasOwnProperty(p)) {
          var val = args[p];

          if (typeof val !== 'undefined' && val !== null) {
            if (typeof val == 'boolean') {
              val = val ? '1' : '0';
            }

            params.push(encodeURIComponent(p) + '=' + encodeURIComponent(val));
          }
        }
      }

      params = params.join('&');
      var url = "".concat(BOXCAST_JS_APP_EMBED_URL, "#").concat(encodeURIComponent(channelId), "?").concat(params);
      return url;
    }
  }, {
    key: "v3Rss",
    value: function v3Rss(channelId, args) {
      var template = "".concat(SYNDICATION_SERVICE_BASE_URL, "/rss/").concat(channelId, ".rss");
      return template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
    }
  }, {
    key: "v3MRSS",
    value: function v3MRSS(channelId, media, args) {
      var template = "".concat(SYNDICATION_SERVICE_BASE_URL, "/mrss/").concat(media, "/").concat(channelId, ".rss");
      return template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
    }
  }, {
    key: "rokuDirectPublisher",
    value: function rokuDirectPublisher(channelId, args) {
      var template = "".concat(SYNDICATION_SERVICE_BASE_URL, "/direct-publisher/").concat(channelId, ".json");
      return template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
    }
  }, {
    key: "v3Podcast",
    value: function v3Podcast(channelId, media, args) {
      var template = "".concat(SYNDICATION_SERVICE_BASE_URL, "/podcasts/").concat(media, "/").concat(channelId, ".rss");
      return template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
    }
  }, {
    key: "highlightClipEmbed",
    value: function highlightClipEmbed(highlightId, args) {
      var embedUrl = BOXCAST_JS_EMBED_URL;
      args = mungeArgs(args);
      var argString = JSON.stringify(args);
      var template = "\n      <div id=\"boxcast-widget-".concat(highlightId, "\"></div>\n      <script type=\"text/javascript\" charset=\"utf-8\">\n      (function(d, s, c, o) {\n      var js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];\n      var h = (('https:' == document.location.protocol) ? 'https:' : 'http:');\n      js.src = h + '").concat(embedUrl, "';\n      js.onload = function() { boxcast.noConflict()('#boxcast-widget-'+c).loadHighlight(c, o); };\n      js.charset = 'utf-8';\n      fjs.parentNode.insertBefore(js, fjs);\n      }(document, 'script', '").concat(highlightId, "', ").concat(argString, "));\n      </script>\n    ");
      var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
      return cleaned;
    }
  }]);

  return EmbedCodeGenerator;
}();



function mungeArgs(options) {
  // Transform the UI options into the ones the player needs
  var args = angular.copy(options);

  if (args.showTitleAndDescription) {
    args.showTitle = 1;
    args.showDescription = 1;
    args.showHighlights = 1;
  } else {
    args.showTitle = 0;
    args.showDescription = 0;
    args.showHighlights = 0;
  }

  if (args.playlistOnRight) {
    args.layout = 'playlist-to-right';
  } // Convert string-y truth-y/false-y autoplay options to boolean


  if (args.autoplay === 'true') {
    args.autoplay = true;
  } else if (args.autoplay === 'false') {
    args.autoplay = false;
  } // Only pass along the brand color param if it's to disable it


  if (args.applyBrandColor) {
    delete args.applyBrandColor;
  } else {
    args.applyBrandColor = false;
  } // Some variables are used by UI but should never be passed along


  delete args.showTitleAndDescription;
  delete args.iframeResize;
  delete args.version;
  delete args.playlistOnRight;

  if (BOXCAST_JS_ENV != 'prod') {
    args.env = BOXCAST_JS_ENV;
  }

  return args;
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = splitRtmpUrl;
/* harmony export (immutable) */ __webpack_exports__["b"] = resolutionForBroadcast;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BroadcastWithRtmpController; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Regex for splitting an RTMP URL into base and stream key
var rtmpUrlRE = /(rtmp:\/\/[^\/]+\/[^\/]+)\/(.+)/; // Splits a complete RTMP URL (with stream key) into an array with base and stream key

function splitRtmpUrl(url) {
  var m = url.match(rtmpUrlRE);

  if (m && m.length == 3) {
    return [m[1], m[2]];
  } else {
    console.warn('Unable to parse RTMP URL into components:', url);
    return ['', ''];
  }
}
var validResolutions = [{
  width: 864,
  height: 480
}, {
  width: 1280,
  height: 720
}, {
  width: 1920,
  height: 1080
}];
function resolutionForBroadcast(broadcast) {
  var height;

  if (broadcast.target_video_resolution && broadcast.target_video_resolution != 'default') {
    height = parseInt(broadcast.target_video_resolution);
  } else {
    height = 720;
  }

  var width = 0;

  if (height != 0) {
    var deltas = validResolutions.map(function (v) {
      return Math.abs(v.height - height);
    }),
        bestFit = validResolutions[deltas.indexOf(Math.min.apply(Math, _toConsumableArray(deltas)))];
    width = bestFit.width;
    height = bestFit.height;
  }

  return {
    width: width,
    height: height
  };
}

var BroadcastWithRtmpController = /*#__PURE__*/function () {
  function BroadcastWithRtmpController($uibModalInstance, $interpolate, $scope, $timeout, $window, $q, $rootScope, JSZip, BandwidthTestClient, StaticRTMP, availableBandwidth, broadcast, encoderType) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, BroadcastWithRtmpController);

    this.$uibModalInstance = $uibModalInstance;
    this.$interpolate = $interpolate;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$window = $window;
    this.BandwidthTestClient = BandwidthTestClient;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.broadcast = broadcast;
    this.encoderType = encoderType;
    this.availableBandwidth = availableBandwidth;

    if (this.encoderType == 'TriCaster') {
      this.activeTab = 'tricaster';
    } else {
      this.activeTab = null;
    }

    this.loadingPromise = $q.all([JSZip.init()]).then(function (result) {
      var j = result[0];
      _this.JSZip = j;

      _this.selectTab(_this.activeTab);
    });
  }

  _createClass(BroadcastWithRtmpController, [{
    key: "selectTab",
    value: function selectTab(encoder) {
      this.activeTab = encoder;

      var _resolutionForBroadca = resolutionForBroadcast(this.broadcast),
          width = _resolutionForBroadca.width,
          height = _resolutionForBroadca.height,
          frameRate = this._getFramerate(),
          codec = this._getCodec(height),
          _this$_getBitrates = this._getBitrates(this.availableBandwidth, height, frameRate),
          videoBitrate = _this$_getBitrates.videoBitrate,
          audioBitrate = _this$_getBitrates.audioBitrate,
          minVideoBitrate = _this$_getBitrates.minVideoBitrate,
          maxVideoBitrate = _this$_getBitrates.maxVideoBitrate,
          rtmpUrl = this.broadcast.rtmp_ingestion_url,
          params = {
        width: width,
        height: height,
        videoBitrate: videoBitrate,
        audioBitrate: audioBitrate,
        rtmpUrl: rtmpUrl,
        codec: codec,
        frameRate: frameRate
      };

      this.minVideoBitrate = minVideoBitrate;
      this.maxVideoBitrate = maxVideoBitrate;

      switch (this.activeTab) {
        case 'tricaster': // fallthrough

        case 'fmle':
          this._constructTriCasterFMLE(params);

          break;

        case 'obs':
          this._constructObs(params);

          break;

        case 'wirecast':
          this._constructWirecast({
            videoBitrate: videoBitrate,
            audioBitrate: audioBitrate
          });

          break;

        default:
          this._constructGeneric(params);

          break;
      }
    }
  }, {
    key: "_constructTriCasterFMLE",
    value: function _constructTriCasterFMLE(params) {
      var _this2 = this;

      ['width', 'height', 'rtmpUrl'].forEach(function (p) {
        return _this2[p] = params[p];
      });
      this.videoBitrateKbps = params.videoBitrateKbps = Math.round(params.videoBitrate / 1000);
      this.audioBitrateKbps = params.audioBitrateKbps = Math.round(params.audioBitrate / 1000);
      var parts = splitRtmpUrl(params.rtmpUrl);
      this.rtmpUrl = params.rtmpUrl = parts[0];
      this.streamKey = params.streamKey = parts[1];
      this.streamName = params.streamName = this.broadcast.name;
      this.xmlDownloadName = this.encoderType == 'TriCaster' ? 'tricaster.xml' : 'fmle.xml';
      this.xmlUrl = "".concat(INTEGRATIONS_ROOT, "/").concat(this.xmlDownloadName, "?height=").concat(params.height, "&width=").concat(params.width, "&video_bitrate_kbps=").concat(params.videoBitrateKbps, "&audio_bitrate_kbps=").concat(params.audioBitrateKbps, "&rtmp_url=").concat(encodeURIComponent(params.rtmpUrl), "&stream_key=").concat(encodeURIComponent(params.streamKey), "&stream_name=").concat(encodeURIComponent(params.streamName));

      if (this.encoderType == 'TriCaster') {
        window.location.replace(this.xmlUrl);
      }
    }
  }, {
    key: "_constructObs",
    value: function _constructObs(params) {
      var _this3 = this;

      params.streamName = this.broadcast.channel_id;
      params.audioBitrateKbps = Math.round(params.audioBitrate / 1000);
      var parts = splitRtmpUrl(params.rtmpUrl);
      params.rtmpUrl = parts[0];
      params.streamKey = parts[1];
      var basicInfo = this.$interpolate(__webpack_require__(400))(params),
          serviceInfo = {
        type: 'rtmp_custom',
        settings: {
          key: params.streamKey,
          server: params.rtmpUrl
        }
      },
          streamEncoderInfo = {
        bitrate: Math.round(params.videoBitrate / 1000),
        keyint_sec: 2,
        profile: 'high',
        rate_control: 'CBR',
        use_bufsize: false,
        vfr: false
      },
          zip = new this.JSZip(),
          folder = zip.folder(this.broadcast.channel_id);
      folder.file('basic.ini', basicInfo);
      folder.file('service.json', JSON.stringify(serviceInfo));
      folder.file('streamEncoder.json', JSON.stringify(streamEncoderInfo));
      zip.generateAsync({
        type: 'blob'
      }).then(function (b) {
        _this3.$scope.$apply(function () {
          _this3.zipUrl = _this3.$window.URL.createObjectURL(b);
          _this3.zipDownloadName = _this3.broadcast.channel_id;
        });
      });
    }
  }, {
    key: "_constructGeneric",
    value: function _constructGeneric(params) {
      var _this4 = this;

      ['width', 'height', 'rtmpUrl', 'codec', 'frameRate'].forEach(function (p) {
        return _this4[p] = params[p];
      });
      this.videoBitrateKbps = Math.round(params.videoBitrate / 1000);
      this.audioBitrateKbps = Math.round(params.audioBitrate / 1000);
      this.streamName = this.broadcast.name;
      var parts = splitRtmpUrl(this.rtmpUrl);
      this.rtmpUrl = parts[0];
      this.streamKey = parts[1];
    }
  }, {
    key: "_constructWirecast",
    value: function _constructWirecast(params) {
      // These are meant to match https://github.com/boxcast/origin_server/blob/master/stream/variant.go#L4-L6
      // and https://github.com/boxcast/boxcast_api/blob/master/app/controllers/integrations/wirecast_controller.rb#L10-L136.
      var defaultBitrates = {
        480: 1128000,
        // 1 Mbps video + 128 kbps audio
        720: 2692000,
        // 2.5 Mbps video + 192 kbps audio
        1080: 4928000 // 4.8 Mbps video + 128 kbps audio

      };
      var totalChosenBitrate = params.videoBitrate + params.audioBitrate;
      var recommendedHeight = Object.keys(defaultBitrates).map(function (k) {
        return parseInt(k);
      }).sort(function (a, b) {
        return b - a;
      }).find(function (r) {
        return totalChosenBitrate >= defaultBitrates[r];
      });
      var encodings = {
        480: 'BoxCast: 480p 3:2',
        720: 'BoxCast: 720p 16:9',
        1080: 'BoxCast: 1080p 16:9'
      };
      this.encodingSelection = encodings[recommendedHeight || 480];
      this.streamName = this.broadcast.name;
    }
  }, {
    key: "_getBitrates",
    value: function _getBitrates(bandwidth, height, frameRate) {
      var videoBitrate, audioBitrate;

      if (this.broadcast.target_video_bitrate && this.broadcast.target_video_bitrate != 'default') {
        videoBitrate = parseInt(this.broadcast.target_video_bitrate);
      }

      if (this.broadcast.target_audio_bitrate && this.broadcast.target_audio_bitrate != 'default') {
        audioBitrate = parseInt(this.broadcast.target_audio_bitrate);
      }

      return this.BandwidthTestClient.getBitrates(bandwidth, videoBitrate, audioBitrate, height, frameRate);
    }
  }, {
    key: "_getCodec",
    value: function _getCodec(height) {
      // NOTE that RTMP doesn't support UHD resolutions so they're not accounted for here.
      switch (height) {
        case 1080:
          return 'h.264, high 10 profile, level 4.2';

        case 720:
          return 'h.264, high profile, level 4';

        default:
          return 'h.264, main profile, level 3.1';
      }
    }
  }, {
    key: "_getFramerate",
    value: function _getFramerate() {
      if (this.FeatureFlags.high_frame_rate && this.broadcast.target_high_frame_rate == 'default') {
        return 60;
      } else if (this.broadcast.target_high_frame_rate === true) {
        return 60;
      } else {
        return 30;
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.$uibModalInstance.dismiss('cancel');
    }
  }]);

  return BroadcastWithRtmpController;
}();



/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n\n<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">{{vm.mode == 'edit' ? 'Edit' : 'Add'}} Multi-Use RTMP Destination</h3>\n</div>\n<div class=\"modal-body\">\n  <div style=\"margin:0 0 15px 0\">\n    <label>Name</label>\n    <input type=\"text\" class=\"form-control\" ng-model=\"vm.config.name\" id=\"name\" name=\"name\" ng-maxlength=\"::vm.limits.name\" placeholder=\"e.g. Destination Name\" required>\n    <p ng-show=\"(form.name.$dirty || form.name.$touched) && !vm.config.name\">\n      <span class=\"text-danger\" ng-if=\"form.name.$error.maxlength\">The name is too long.</span>\n      <span class=\"text-danger\" ng-if=\"form.name.$error.required\">The name cannot be blank.</span>\n    </p>\n  </div>\n  <div style=\"margin:0 0 15px 0\">\n    <label>Server URL</label>\n    <input type=\"text\" class=\"form-control\" ng-model=\"vm.config.stream_url\" id=\"stream_url\" name=\"stream_url\" not-boxcast placeholder=\"e.g. rtmp://rtmp.service.com/live\" required>\n    <p>\n      <span class=\"text-danger\" ng-if=\"form.stream_url.$error.notBoxcast\">The stream URL cannot point to BoxCast.</span>\n    </p>\n  </div>\n  <div style=\"margin:0 0 15px 0\">\n    <label>Stream Key</label>\n    <input type=\"text\" class=\"form-control\" ng-model=\"vm.config.stream_key\" id=\"stream_key\" name=\"stream_key\" ng-maxlength=\"::vm.limits.stream_key\" required>\n    <p ng-show=\"(form.stream_key.$dirty || form.stream_key.$touched) && !vm.config.stream_key\">\n      <span class=\"text-danger\" ng-if=\"form.stream_key.$error.maxlength\">The stream key is too long.</span>\n      <span class=\"text-danger\" ng-if=\"form.stream_key.$error.required\">The stream key cannot be blank.</span>\n    </p>\n  </div>\n  <div style=\"margin:0 0 10px 0\">\n    <span id=\"use_authentication\" ng-click=\"vm.useAuthentication = !vm.useAuthentication;\" style=\"cursor:pointer;opacity:0.8\">\n      <i class=\"fa\" ng-class=\"vm.useAuthentication ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n    </span>\n    <label for=\"use_authentication\">Use Authentication (Username and Password)</label>\n  </div>\n  <div style=\"margin:0 15px\" ng-if=\"vm.useAuthentication\">\n    <div style=\"margin:0 0 15px 0\">\n      <label>Username</label>\n      <input type=\"text\" class=\"form-control\" ng-model=\"vm.config.username\" required>\n    </div>\n    <div style=\"margin:0 0 15px 0\">\n      <label>Password</label>\n      <input type=\"password\" class=\"form-control\" ng-model=\"vm.config.password\" required>\n    </div>\n  </div>\n  <div style=\"margin:0 0 10px 0\">\n    <label>Max Resolution</label>\n    <select class=\"form-control\"\n            ng-model=\"vm.config.max_resolution\"\n            ng-options=\"+(o.id) as o.text for o in [\n              {id: 0, text: 'None (use highest)'},\n              {id: 1080, text: '1080p'},\n              {id: 720, text: '720p'},\n              {id: 480, text: '480p'}\n            ]\">\n    </select>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Close</button>\n  <button class=\"btn btn-primary\" ng-click=\"vm.submit()\" ng-disabled=\"vm.submitting\">\n    <i ng-show=\"vm.submitting\" class=\"fa fa-spin fa-spinner\"></i>\n    Save Changes\n  </button>\n</div>\n\n</form>\n"

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalAddMultiUseRTMPChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_rtmp__ = __webpack_require__(16);


function validateStreamKey(key) {
  return !(!key || /^\s*$/.test(key));
}

function ModalAddMultiUseRTMPChannel(mode, config, RTMPPushChannel, toaster, $rootScope, $uibModalInstance) {
  'ngInject'; // passed in via `resolve`

  var _this = this;

  this.mode = mode;
  this.config = angular.copy(config);
  this.useAuthentication = this.config.username && this.config.password;
  this.limits = $rootScope.ApiConfig.modelFieldLimits('rtmp_push_channel', 'maximum');

  this.cancel = function () {
    return $uibModalInstance.dismiss();
  };

  this.submit = function () {
    if (!_this.config.name || !Object(__WEBPACK_IMPORTED_MODULE_0__utils_rtmp__["a" /* IsRtmpURLValid */])(_this.config.stream_url) || !validateStreamKey(_this.config.stream_key)) {
      alert('Please enter a valid name, stream URL, and stream key.');
      return;
    }

    if (!_this.useAuthentication) {
      delete _this.config.username;
      delete _this.config.password;
    }

    _this.submitting = true;
    RTMPPushChannel[_this.mode == 'add' ? 'create' : 'update'](_this.config, function (r) {
      $uibModalInstance.close(r);
    }, function (e) {
      console.error(e);
      toaster.pop('warning', 'Unable to save RTMP configuration. Please refresh and try again.');
      _this.submitting = false;
    });
  };
}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REMOTE_MIX_ADDON_LOOKUP_KEYS */
/* harmony export (immutable) */ __webpack_exports__["b"] = getStripeCard;
/* harmony export (immutable) */ __webpack_exports__["c"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["e"] = parseBilling;
/* unused harmony export hasRMAItem */
/* harmony export (immutable) */ __webpack_exports__["a"] = getActiveSubscriptions;
/* harmony export (immutable) */ __webpack_exports__["d"] = hasRemoteMixPaidAddon;
// only create 1 per app but re-mount it as necessary
var stripe;
var stripeCard;
var INVOICE_DAYS_UNTIL_DUE = 30;
var RMA_SKU_INDICATOR = 'return-label';
var PREMIUM_PLAN_PRODUCT = 'prod_GphxV14RtoEZnx';
var REMOTE_MIX_ADDON_LOOKUP_KEYS = ['addon:remotemix-tier10:monthly:1900', 'addon:remotemix-tier10:annual:9900'];
function getStripeCard() {
  if (!stripe && !stripeCard) {
    stripe = Stripe(STRIPE_KEY);
    stripeCard = stripe.elements().create('card');
  }

  return stripeCard;
}
function getToken(card) {
  return stripe.createToken(card).then(function (result) {
    if (result.error) {
      throw result.error.message;
    } else {
      return result.token;
    }
  });
}
function parseBilling(billing) {
  var result = {
    billing: billing,
    bankOnFile: null,
    cardOnFile: null,
    paidInvoices: [],
    outstandingInvoices: [],
    trialSub: null,
    daysUntilSuspend: 0,
    subscriptions: [],
    isBilledMonthly: false,
    formattedAddress: '',
    isPremiumPlan: false
  }; // Parse cards

  if (billing.stripe_token) {
    var cardId = billing.stripe_token;
    var cards = billing.sources.data;

    var card = _.find(cards, {
      id: cardId
    });

    if (card.object == 'card') {
      result.cardOnFile = card;
    } else if (card.object == 'bank_account') {
      result.bankOnFile = card;
    }
  } // Parse Invoices


  var maxDaysPastDue = 0;

  if (billing.invoices && billing.invoices.data.length) {
    billing.invoices.data.forEach(function (inv) {
      if (inv.status == 'void') {// Skip void invoices
      } else if (inv.status == 'draft' && !inv.closed) {// Skip invoices that are not yet viewable
      } else {
        inv.usage = [];

        if (inv.lines) {
          _.forEach(inv.lines.data, function (line) {
            if (line.plan && line.plan.usage_type == 'metered') {
              inv.usage.push({
                type: line.plan.metadata.usage_type,
                periodStart: line.period.start,
                periodEnd: line.period.end,
                subscriptionItemId: line.subscription_item,
                plan: line.plan
              });
            }
          });
        }

        if (inv.status == 'paid') {
          result.paidInvoices.push(inv);
          return;
        }

        inv.due_date = inv.due_date || inv.date;

        if (inv.due_date < new Date() && inv.billing == 'send_invoice') {
          inv.days_past_due = moment(new Date()).diff(inv.due_date * 1000, 'days');
          maxDaysPastDue = Math.max(maxDaysPastDue, inv.days_past_due);
        }

        if (inv.billing == 'charge_automatically') {
          if (inv.attempted && (inv.attempt_count > 1 || inv.next_payment_attempt)) {
            inv.detailedStatus = 'failed';
          } else if (!inv.attempted) {
            inv.detailedStatus = 'awaiting_payment';
          } else {
            inv.detailedStatus = 'pending';
          }
        } else {
          inv.detailedStatus = 'awaiting_payment';
        }

        result.outstandingInvoices.push(inv);
      }
    });
  }

  if (maxDaysPastDue > 0) {
    result.daysUntilSuspend = Math.max(INVOICE_DAYS_UNTIL_DUE - maxDaysPastDue, 0);
  } // Parse subscriptions


  result.subscriptions = [];

  if (billing.subscriptions && billing.subscriptions.total_count) {
    billing.subscriptions.data.forEach(function (sub) {
      sub.total_amount = 0;

      if (sub.items.data[0] && sub.items.data[0].plan.interval == 'year') {
        sub.annual_renewal = new Date(sub.current_period_end * 1000);
      } else if (sub.items.data[0] && sub.items.data[0].plan.interval == 'month') {
        result.isBilledMonthly = true;
      }

      sub.items.data.forEach(function (item) {
        item.plan.name = item.plan.metadata.display_name || item.plan.nickname || item.plan.id;
        item.plan.quantity = item.quantity || sub.quantity || 1;
        sub.total_amount += item.plan.amount * item.plan.quantity;

        if (item.plan.usage_type == 'metered') {
          sub.hasUsage = true;
        }

        if (item.plan.product == PREMIUM_PLAN_PRODUCT) {
          result.isPremiumPlan = true;
        }
      });

      if (sub.discount && sub.discount.coupon) {
        if (sub.discount.coupon.percent_off) {
          sub.discount.coupon.amount_off = sub.total_amount * sub.discount.coupon.percent_off / 100;
        }

        sub.total_amount -= sub.discount.coupon.amount_off;
      }

      result.subscriptions.push(sub);

      if (sub.status == 'trialing') {
        result.trialSub = sub;
      }
    });
  } // Other utilies


  cleanAddress(result.billing);

  if (billing.address != '' && billing.city != '' && billing.state != '' && billing.postal_code != '') {
    result.formattedAddress = "".concat(billing.address, "\n").concat(billing.city, ", ").concat(billing.state, " ").concat(billing.postal_code, " ").concat(billing.country);
  } else {
    result.formattedAddress = 'No Billing Address';
  }

  return result;
}
function hasRMAItem(proposal) {
  var hasRMA = false;

  _.forEach(proposal.products.invoice_items, function (item) {
    if (item.stripe_price.lookup_key.toLowerCase().indexOf(RMA_SKU_INDICATOR) >= 0) {
      hasRMA = true;
    }
  });

  return hasRMA;
}

function cleanAddress(addressObj) {
  if (!addressObj) return;
  if (addressObj.address == 'Unknown') addressObj.address = '';
  if (addressObj.city == 'Unknown') addressObj.city = '';
  if (addressObj.state == 'Unknown') addressObj.state = '';
  if (addressObj.postal_code == 'Unknown') addressObj.postal_code = '';
  if (addressObj.country == 'Unknown') addressObj.country = '';
  return addressObj;
}
/**
 * Extracts active subscriptions from billing data
 * @param {Object} billing - The billing data object
 * @returns {Array} Array of Stripe subscription objects with status 'active'
 *  - Docs: https://docs.stripe.com/api/subscriptions/object
 */


function getActiveSubscriptions(billing) {
  if (!billing || !billing.subscriptions || !billing.subscriptions.data) {
    return [];
  }

  return billing.subscriptions.data.filter(function (s) {
    return s.status === 'active';
  });
}
/**
 * Checks if any of the subscriptions has the RemoteMix paid addon
 * @param {Array} subscriptions - List of Stripe subscription objects
 *  - Docs: https://docs.stripe.com/api/subscriptions/object
 * @returns {Boolean} - Whether the RemoteMix paid addon exists
 */

function hasRemoteMixPaidAddon(subscriptions) {
  if (!subscriptions || !subscriptions.length) {
    return false;
  }

  return subscriptions.some(function (subscription) {
    return subscription.items.data.some(function (subscriptionItem) {
      return subscriptionItem.price.lookup_key && REMOTE_MIX_ADDON_LOOKUP_KEYS.includes(subscriptionItem.price.lookup_key);
    });
  });
}

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!function (e, r) {
  'object' == ( false ? "undefined" : _typeof(exports)) && 'object' == ( false ? "undefined" : _typeof(module)) ? module.exports = r() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (r),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 'object' == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.postRobot = r() : e.postRobot = r();
}(this, function () {
  return function (e) {
    function r(t) {
      if (n[t]) return n[t].exports;
      var o = n[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return e[t].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    var n = {};
    return r.m = e, r.c = n, r.i = function (e) {
      return e;
    }, r.d = function (e, n, t) {
      r.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: t
      });
    }, r.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return r.d(n, 'a', n), n;
    }, r.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, r.p = '', r(r.s = 26);
  }([function (e, r, n) {
    'use strict';

    var t = n(22);
    n.d(r, 'a', function () {
      return t.a;
    });
    var o = n(11);
    n.d(r, 'b', function () {
      return o.a;
    }), n.d(r, 'c', function () {
      return o.b;
    });
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      var r = e.location;
      if (!r) throw new Error('Can not read window location');
      var n = r.protocol;
      if (!n) throw new Error('Can not read window protocol');
      if (n === A.FILE_PROTOCOL) return A.FILE_PROTOCOL + '//';
      var t = r.host;
      if (!t) throw new Error('Can not read window host');
      return n + '//' + t;
    }

    function o(e) {
      e = e || window;
      var r = t(e);
      return r && e.mockDomain && 0 === e.mockDomain.indexOf(A.MOCK_PROTOCOL) ? e.mockDomain : r;
    }

    function i(e) {
      try {
        if (!e.location.href) return !0;
        if ('about:blank' === e.location.href) return !0;
      } catch (e) {}

      return !1;
    }

    function a(e) {
      try {
        var r = Object.getOwnPropertyDescriptor(e, 'location');
        if (r && !1 === r.enumerable) return !1;
      } catch (e) {}

      try {
        if (i(e)) return !0;
        if (t(e) === t(window)) return !0;
      } catch (e) {}

      return !1;
    }

    function u(e) {
      if (!a(e)) return !1;

      try {
        if (i(e)) return !0;
        if (o(window) === o(e)) return !0;
      } catch (e) {}

      return !1;
    }

    function c(e) {
      if (e) try {
        if (e.parent && e.parent !== e) return e.parent;
      } catch (e) {
        return;
      }
    }

    function s(e) {
      if (e && !c(e)) try {
        return e.opener;
      } catch (e) {
        return;
      }
    }

    function f(e) {
      var r = [];

      try {
        for (; e.parent !== e;) {
          r.push(e.parent), e = e.parent;
        }
      } catch (e) {}

      return r;
    }

    function d(e, r) {
      if (!e || !r) return !1;
      var n = c(r);
      return n ? n === e : -1 !== f(r).indexOf(e);
    }

    function l(e) {
      var r = [],
          n = void 0;

      try {
        n = e.frames;
      } catch (r) {
        n = e;
      }

      var t = void 0;

      try {
        t = n.length;
      } catch (e) {}

      if (0 === t) return r;

      if (t) {
        for (var o = 0; o < t; o++) {
          var i = void 0;

          try {
            i = n[o];
          } catch (e) {
            continue;
          }

          r.push(i);
        }

        return r;
      }

      for (var a = 0; a < 100; a++) {
        var u = void 0;

        try {
          u = n[a];
        } catch (e) {
          return r;
        }

        if (!u) return r;
        r.push(u);
      }

      return r;
    }

    function w(e) {
      for (var r = [], n = l(e), t = Array.isArray(n), o = 0, n = t ? n : n[Symbol.iterator]();;) {
        var i;

        if (t) {
          if (o >= n.length) break;
          i = n[o++];
        } else {
          if (o = n.next(), o.done) break;
          i = o.value;
        }

        var a = i;
        r.push(a);

        for (var u = w(a), c = Array.isArray(u), s = 0, u = c ? u : u[Symbol.iterator]();;) {
          var f;

          if (c) {
            if (s >= u.length) break;
            f = u[s++];
          } else {
            if (s = u.next(), s.done) break;
            f = s.value;
          }

          var d = f;
          r.push(d);
        }
      }

      return r;
    }

    function h(e) {
      if (e) {
        try {
          if (e.top) return e.top;
        } catch (e) {}

        if (c(e) === e) return e;

        try {
          if (d(window, e) && window.top) return window.top;
        } catch (e) {}

        try {
          if (d(e, window) && window.top) return window.top;
        } catch (e) {}

        for (var r = w(e), n = Array.isArray(r), t = 0, r = n ? r : r[Symbol.iterator]();;) {
          var o;

          if (n) {
            if (t >= r.length) break;
            o = r[t++];
          } else {
            if (t = r.next(), t.done) break;
            o = t.value;
          }

          var i = o;

          try {
            if (i.top) return i.top;
          } catch (e) {}

          if (c(i) === i) return i;
        }
      }
    }

    function p(e) {
      if (!e.contentWindow) return !0;
      if (!e.parentNode) return !0;
      var r = e.ownerDocument;
      return !(!r || !r.body || r.body.contains(e));
    }

    function v(e, r) {
      for (var n = 0; n < e.length; n++) {
        try {
          if (e[n] === r) return n;
        } catch (e) {}
      }

      return -1;
    }

    function y(e) {
      var r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];

      try {
        if (e === window) return !1;
      } catch (e) {
        return !0;
      }

      try {
        if (!e) return !0;
      } catch (e) {
        return !0;
      }

      try {
        if (e.closed) return !0;
      } catch (e) {
        return !e || e.message !== P;
      }

      if (r && u(e)) try {
        if (e.mockclosed) return !0;
      } catch (e) {}

      try {
        if (!e.parent || !e.top) return !0;
      } catch (e) {}

      try {
        n.i(g.a)(e === e);
      } catch (e) {
        return !0;
      }

      var t = v(T, e);

      if (-1 !== t) {
        var o = R[t];
        if (o && p(o)) return !0;
      }

      return !1;
    }

    function m(e) {
      e = e || window;
      var r = s(e);
      if (r) return r;
      var n = c(e);
      return n || void 0;
    }

    function b(e, r) {
      var n = m(r);
      if (n) return n === e;
      if (r === e) return !1;
      if (h(r) === r) return !1;

      for (var t = l(e), o = Array.isArray(t), i = 0, t = o ? t : t[Symbol.iterator]();;) {
        var a;

        if (o) {
          if (i >= t.length) break;
          a = t[i++];
        } else {
          if (i = t.next(), i.done) break;
          a = i.value;
        }

        if (a === r) return !0;
      }

      return !1;
    }

    function E() {
      return Boolean(s(window));
    }

    function _() {
      return Boolean(c(window));
    }

    function S(e, r) {
      if ('string' == typeof e) {
        if ('string' == typeof r) return e === A.WILDCARD || r === e;
        if (n.i(g.b)(r)) return !1;
        if (Array.isArray(r)) return !1;
      }

      return n.i(g.b)(e) ? n.i(g.b)(r) ? e.toString() === r.toString() : !Array.isArray(r) && Boolean(r.match(e)) : !!Array.isArray(e) && (Array.isArray(r) ? JSON.stringify(e) === JSON.stringify(r) : !n.i(g.b)(r) && e.some(function (e) {
        return S(e, r);
      }));
    }

    function O(e) {
      try {
        if (e === window) return !0;
      } catch (e) {
        if (e && e.message === P) return !0;
      }

      try {
        if ('[object Window]' === Object.prototype.toString.call(e)) return !0;
      } catch (e) {
        if (e && e.message === P) return !0;
      }

      try {
        if (window.Window && e instanceof window.Window) return !0;
      } catch (e) {
        if (e && e.message === P) return !0;
      }

      try {
        if (e && e.self === e) return !0;
      } catch (e) {
        if (e && e.message === P) return !0;
      }

      try {
        if (e && e.parent === e) return !0;
      } catch (e) {
        if (e && e.message === P) return !0;
      }

      try {
        if (e && e.top === e) return !0;
      } catch (e) {
        if (e && e.message === P) return !0;
      }

      try {
        n.i(g.a)(e === e);
      } catch (e) {
        return !0;
      }

      try {
        n.i(g.a)(e && e.__cross_domain_utils_window_check__);
      } catch (e) {
        return !0;
      }

      return !1;
    }

    r.i = t, r.g = o, r.h = a, r.f = y, r.a = m, r.j = b, r.c = E, r.d = _, r.b = S, r.e = O;
    var g = n(17),
        A = {
      MOCK_PROTOCOL: 'mock:',
      FILE_PROTOCOL: 'file:',
      WILDCARD: '*'
    },
        P = 'Call was rejected by callee.\r\n',
        T = [],
        R = [];
  }, function (e, r, n) {
    'use strict';

    var t = n(19);
    n.d(r, 'a', function () {
      return t.a;
    });
  }, function (e, r, n) {
    'use strict';

    n.d(r, 'a', function () {
      return o;
    });
    var t = n(0),
        o = window[t.b.WINDOW_PROPS.POSTROBOT] = window[t.b.WINDOW_PROPS.POSTROBOT] || {};

    o.registerSelf = function () {};
  }, function (e, r, n) {
    'use strict';

    var t = n(8);
    n.d(r, 'c', function () {
      return t.a;
    }), n.d(r, 'd', function () {
      return t.f;
    }), n.d(r, 'e', function () {
      return t.d;
    }), n.d(r, 'h', function () {
      return t.c;
    }), n.d(r, 'i', function () {
      return t.b;
    }), n.d(r, 'j', function () {
      return t.h;
    }), n.d(r, 'l', function () {
      return t.i;
    }), n.d(r, 'm', function () {
      return t.j;
    }), n.d(r, 'n', function () {
      return t.e;
    }), n.d(r, 'o', function () {
      return t.k;
    });
    var o = n(9);
    n.d(r, 'g', function () {
      return o.a;
    });
    var i = n(28);
    n.d(r, 'b', function () {
      return i.a;
    }), n.d(r, 'f', function () {
      return i.b;
    }), n.d(r, 'k', function () {
      return i.c;
    });
    var a = n(27);
    n.d(r, 'a', function () {
      return a.a;
    }), n.d(r, 'p', function () {
      return a.b;
    });
  }, function (e, r, n) {
    'use strict';

    var t = n(23);
    n.d(r, 'a', function () {
      return t.a;
    }), n.d(r, 'b', function () {
      return t.b;
    });
    var o = n(13);
    n.d(r, 'e', function () {
      return o.a;
    });
    var i = n(12);
    n.d(r, 'c', function () {
      return i.e;
    }), n.d(r, 'd', function () {
      return i.f;
    }), n.d(r, 'f', function () {
      return i.g;
    }), n.d(r, 'g', function () {
      return i.d;
    });
  }, function (e, r, n) {
    'use strict';

    function t() {
      a.a.initialized || (n.i(i.a)(), n.i(o.a)(), n.i(o.b)()), a.a.initialized = !0;
    }

    Object.defineProperty(r, '__esModule', {
      value: !0
    }), r.init = t, n.d(r, 'bridge', function () {
      return f;
    });
    var o = n(4),
        i = n(5),
        a = n(3),
        u = n(21);
    n.d(r, 'cleanUpWindow', function () {
      return u.a;
    });
    var c = n(31);
    n.d(r, 'parent', function () {
      return c.a;
    }), n.d(r, 'send', function () {
      return c.b;
    }), n.d(r, 'request', function () {
      return c.c;
    }), n.d(r, 'sendToParent', function () {
      return c.d;
    }), n.d(r, 'client', function () {
      return c.e;
    }), n.d(r, 'on', function () {
      return c.f;
    }), n.d(r, 'listen', function () {
      return c.g;
    }), n.d(r, 'once', function () {
      return c.h;
    }), n.d(r, 'listener', function () {
      return c.i;
    }), n.d(r, 'CONFIG', function () {
      return c.j;
    }), n.d(r, 'CONSTANTS', function () {
      return c.k;
    }), n.d(r, 'disable', function () {
      return c.l;
    });
    var s = n(2);
    n.d(r, 'Promise', function () {
      return s.a;
    }), t();
    var f = null;
  }, function (e, r, n) {
    'use strict';

    var t = n(10);
    n.d(r, 'a', function () {
      return t.WeakMap;
    });
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
      if (r >= 3) return 'stringifyError stack overflow';

      try {
        if (!e) return '<unknown error: ' + Object.prototype.toString.call(e) + '>';
        if ('string' == typeof e) return e;

        if (e instanceof Error) {
          var n = e && e.stack,
              o = e && e.message;
          if (n && o) return -1 !== n.indexOf(o) ? n : o + '\n' + n;
          if (n) return n;
          if (o) return o;
        }

        return 'function' == typeof e.toString ? e.toString() : Object.prototype.toString.call(e);
      } catch (e) {
        return 'Error while stringifying error: ' + t(e, r + 1);
      }
    }

    function o() {}

    function i(e, r, n) {
      return e.addEventListener ? e.addEventListener(r, n) : e.attachEvent('on' + r, n), {
        cancel: function cancel() {
          e.removeEventListener ? e.removeEventListener(r, n) : e.detachEvent('on' + r, n);
        }
      };
    }

    function a() {
      var e = '0123456789abcdef';
      return 'xxxxxxxxxx'.replace(/./g, function () {
        return e.charAt(Math.floor(Math.random() * e.length));
      });
    }

    function u(e, r) {
      for (var n = 0; n < e.length; n++) {
        r(e[n], n);
      }
    }

    function c(e, r) {
      for (var n in e) {
        e.hasOwnProperty(n) && r(e[n], n);
      }
    }

    function s(e, r) {
      Array.isArray(e) ? u(e, r) : 'object' === (void 0 === e ? 'undefined' : m(e)) && null !== e && c(e, r);
    }

    function f(e, r) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
      if (n >= 100) throw new Error('Self-referential object passed, or object contained too many layers');
      var t = void 0;

      if ('object' !== (void 0 === e ? 'undefined' : m(e)) || null === e || Array.isArray(e)) {
        if (!Array.isArray(e)) throw new Error('Invalid type: ' + (void 0 === e ? 'undefined' : m(e)));
        t = [];
      } else t = {};

      return s(e, function (e, o) {
        var i = r(e, o);
        void 0 !== i ? t[o] = i : 'object' === (void 0 === e ? 'undefined' : m(e)) && null !== e ? t[o] = f(e, r, n + 1) : t[o] = e;
      }), t;
    }

    function d(e, r) {
      function n() {
        t = setTimeout(n, r), e.call();
      }

      var t = void 0;
      return t = setTimeout(n, r), {
        cancel: function cancel() {
          clearTimeout(t);
        }
      };
    }

    function l(e) {
      return '[object RegExp]' === Object.prototype.toString.call(e);
    }

    function w() {
      return n.i(v.c)() ? y.b.WINDOW_TYPES.POPUP : n.i(v.d)() ? y.b.WINDOW_TYPES.IFRAME : y.b.WINDOW_TYPES.FULLPAGE;
    }

    function h(e, r, n) {
      var t = void 0,
          o = void 0;

      try {
        if ('{}' !== JSON.stringify({}) && (t = Object.prototype.toJSON, delete Object.prototype.toJSON), '{}' !== JSON.stringify({})) throw new Error('Can not correctly serialize JSON objects');
        if ('[]' !== JSON.stringify([]) && (o = Array.prototype.toJSON, delete Array.prototype.toJSON), '[]' !== JSON.stringify([])) throw new Error('Can not correctly serialize JSON objects');
      } catch (e) {
        throw new Error('Can not repair JSON.stringify: ' + e.message);
      }

      var i = JSON.stringify.call(this, e, r, n);

      try {
        t && (Object.prototype.toJSON = t), o && (Array.prototype.toJSON = o);
      } catch (e) {
        throw new Error('Can not repair JSON.stringify: ' + e.message);
      }

      return i;
    }

    function p(e) {
      return JSON.parse(e);
    }

    r.b = t, n.d(r, 'e', function () {
      return b;
    }), r.j = o, r.i = i, r.f = a, r.g = f, r.k = d, r.a = l, r.d = w, r.c = h, r.h = p;

    var v = (n(7), n(1)),
        y = n(0),
        m = 'function' == typeof Symbol && 'symbol' == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : _typeof(e);
    },
        b = function b(e) {
      if (!e) return e;
      var r = !1;
      return function () {
        if (!r) return r = !0, e.apply(this, arguments);
      };
    };
  }, function (e, r, n) {
    'use strict';

    n.d(r, 'a', function () {
      return u;
    });
    var t = n(8),
        o = n(0),
        i = 'function' == typeof Symbol && 'symbol' == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : _typeof(e);
    },
        a = ['debug', 'info', 'warn', 'error'];
    Function.prototype.bind && window.console && 'object' === i(console.log) && ['log', 'info', 'warn', 'error'].forEach(function (e) {
      console[e] = this.bind(console[e], console);
    }, Function.prototype.call);
    var u = {
      clearLogs: function clearLogs() {
        if (window.console && window.console.clear && window.console.clear(), o.a.LOG_TO_PAGE) {
          var e = document.getElementById('postRobotLogs');
          e && e.parentNode && e.parentNode.removeChild(e);
        }
      },
      writeToPage: function writeToPage(e, r) {
        setTimeout(function () {
          var o = document.getElementById('postRobotLogs');
          o || (o = document.createElement('div'), o.id = 'postRobotLogs', o.style.cssText = 'width: 800px; font-family: monospace; white-space: pre-wrap;', document.body && document.body.appendChild(o));
          var i = document.createElement('div'),
              a = new Date().toString().split(' ')[4],
              u = Array.prototype.slice.call(r).map(function (e) {
            if ('string' == typeof e) return e;
            if (!e) return Object.prototype.toString.call(e);
            var r = void 0;

            try {
              r = n.i(t.c)(e, null, 2);
            } catch (e) {
              r = '[object]';
            }

            return '\n\n' + r + '\n\n';
          }).join(' '),
              c = a + ' ' + e + ' ' + u;
          i.innerHTML = c;
          var s = {
            log: '#ddd',
            warn: 'orange',
            error: 'red',
            info: 'blue',
            debug: '#aaa'
          }[e];
          i.style.cssText = 'margin-top: 10px; color: ' + s + ';', o.childNodes.length ? o.insertBefore(i, o.childNodes[0]) : o.appendChild(i);
        });
      },
      logLevel: function logLevel(e, r) {
        setTimeout(function () {
          try {
            var i = window.LOG_LEVEL || o.a.LOG_LEVEL;
            if (a.indexOf(e) < a.indexOf(i)) return;
            if (r = Array.prototype.slice.call(r), r.unshift('' + window.location.host + window.location.pathname), r.unshift('::'), r.unshift('' + n.i(t.d)().toLowerCase()), r.unshift('[post-robot]'), o.a.LOG_TO_PAGE && u.writeToPage(e, r), !window.console) return;
            if (window.console[e] || (e = 'log'), !window.console[e]) return;
            window.console[e].apply(window.console, r);
          } catch (e) {}
        }, 1);
      },
      debug: function debug() {
        for (var e = arguments.length, r = Array(e), n = 0; n < e; n++) {
          r[n] = arguments[n];
        }

        u.logLevel('debug', r);
      },
      info: function info() {
        for (var e = arguments.length, r = Array(e), n = 0; n < e; n++) {
          r[n] = arguments[n];
        }

        u.logLevel('info', r);
      },
      warn: function warn() {
        for (var e = arguments.length, r = Array(e), n = 0; n < e; n++) {
          r[n] = arguments[n];
        }

        u.logLevel('warn', r);
      },
      error: function error() {
        for (var e = arguments.length, r = Array(e), n = 0; n < e; n++) {
          r[n] = arguments[n];
        }

        u.logLevel('error', r);
      }
    };
  }, function (e, r, n) {
    'use strict';

    Object.defineProperty(r, '__esModule', {
      value: !0
    });
    var t = n(16);
    n.d(r, 'WeakMap', function () {
      return t.a;
    });
  }, function (e, r, n) {
    'use strict';

    n.d(r, 'a', function () {
      return t;
    }), n.d(r, 'b', function () {
      return o;
    });
    var t = {
      POST_MESSAGE_TYPE: {
        REQUEST: 'postrobot_message_request',
        RESPONSE: 'postrobot_message_response',
        ACK: 'postrobot_message_ack'
      },
      POST_MESSAGE_ACK: {
        SUCCESS: 'success',
        ERROR: 'error'
      },
      POST_MESSAGE_NAMES: {
        METHOD: 'postrobot_method',
        READY: 'postrobot_ready',
        OPEN_TUNNEL: 'postrobot_open_tunnel'
      },
      WINDOW_TYPES: {
        FULLPAGE: 'fullpage',
        POPUP: 'popup',
        IFRAME: 'iframe'
      },
      WINDOW_PROPS: {
        POSTROBOT: '__postRobot__'
      },
      SERIALIZATION_TYPES: {
        METHOD: 'postrobot_method',
        ERROR: 'postrobot_error',
        PROMISE: 'postrobot_promise',
        ZALGO_PROMISE: 'postrobot_zalgo_promise',
        REGEX: 'regex'
      },
      SEND_STRATEGIES: {
        POST_MESSAGE: 'postrobot_post_message',
        BRIDGE: 'postrobot_bridge',
        GLOBAL: 'postrobot_global'
      },
      MOCK_PROTOCOL: 'mock:',
      FILE_PROTOCOL: 'file:',
      BRIDGE_NAME_PREFIX: '__postrobot_bridge__',
      POSTROBOT_PROXY: '__postrobot_proxy__',
      WILDCARD: '*'
    },
        o = Object.keys(t.POST_MESSAGE_NAMES).map(function (e) {
      return t.POST_MESSAGE_NAMES[e];
    });
  }, function (e, r, n) {
    'use strict';

    function t(e, r) {
      l.a.responseListeners[e] = r;
    }

    function o(e) {
      return l.a.responseListeners[e];
    }

    function i(e) {
      delete l.a.responseListeners[e];
    }

    function a(e) {
      l.a.erroredResponseListeners[e] = !0;
    }

    function u(e) {
      return Boolean(l.a.erroredResponseListeners[e]);
    }

    function c(e) {
      var r = e.name,
          t = e.win,
          o = e.domain;
      if (t === h.b.WILDCARD && (t = null), o === h.b.WILDCARD && (o = null), !r) throw new Error('Name required to get request listener');
      var i = l.a.requestListeners[r];
      if (i) for (var a = [t, l.a.WINDOW_WILDCARD], u = 0; u < a.length; u++) {
        var c = a[u],
            s = c && i.get(c);

        if (s) {
          if (o && 'string' == typeof o) {
            if (s[o]) return s[o];
            if (s[p]) for (var f = s[p], w = Array.isArray(f), v = 0, f = w ? f : f[Symbol.iterator]();;) {
              var y;

              if (w) {
                if (v >= f.length) break;
                y = f[v++];
              } else {
                if (v = f.next(), v.done) break;
                y = v.value;
              }

              var m = y,
                  b = m.regex,
                  E = m.listener;
              if (n.i(d.b)(b, o)) return E;
            }
          }

          if (s[h.b.WILDCARD]) return s[h.b.WILDCARD];
        }
      }
    }

    function s(e, r) {
      var t = e.name,
          o = e.win,
          i = e.domain;
      if (!t || 'string' != typeof t) throw new Error('Name required to add request listener');

      if (Array.isArray(o)) {
        for (var a = [], u = o, d = Array.isArray(u), v = 0, u = d ? u : u[Symbol.iterator]();;) {
          var y;

          if (d) {
            if (v >= u.length) break;
            y = u[v++];
          } else {
            if (v = u.next(), v.done) break;
            y = v.value;
          }

          var m = y;
          a.push(s({
            name: t,
            domain: i,
            win: m
          }, r));
        }

        return {
          cancel: function cancel() {
            for (var e = a, r = Array.isArray(e), n = 0, e = r ? e : e[Symbol.iterator]();;) {
              var t;

              if (r) {
                if (n >= e.length) break;
                t = e[n++];
              } else {
                if (n = e.next(), n.done) break;
                t = n.value;
              }

              t.cancel();
            }
          }
        };
      }

      if (Array.isArray(i)) {
        for (var b = [], E = i, _ = Array.isArray(E), S = 0, E = _ ? E : E[Symbol.iterator]();;) {
          var O;

          if (_) {
            if (S >= E.length) break;
            O = E[S++];
          } else {
            if (S = E.next(), S.done) break;
            O = S.value;
          }

          var g = O;
          b.push(s({
            name: t,
            win: o,
            domain: g
          }, r));
        }

        return {
          cancel: function cancel() {
            for (var e = b, r = Array.isArray(e), n = 0, e = r ? e : e[Symbol.iterator]();;) {
              var t;

              if (r) {
                if (n >= e.length) break;
                t = e[n++];
              } else {
                if (n = e.next(), n.done) break;
                t = n.value;
              }

              t.cancel();
            }
          }
        };
      }

      var A = c({
        name: t,
        win: o,
        domain: i
      });
      if (o && o !== h.b.WILDCARD || (o = l.a.WINDOW_WILDCARD), i = i || h.b.WILDCARD, A) throw o && i ? new Error('Request listener already exists for ' + t + ' on domain ' + i.toString() + ' for ' + (o === l.a.WINDOW_WILDCARD ? 'wildcard' : 'specified') + ' window') : o ? new Error('Request listener already exists for ' + t + ' for ' + (o === l.a.WINDOW_WILDCARD ? 'wildcard' : 'specified') + ' window') : i ? new Error('Request listener already exists for ' + t + ' on domain ' + i.toString()) : new Error('Request listener already exists for ' + t);
      var P = l.a.requestListeners,
          T = P[t];
      T || (T = new f.a(), P[t] = T);
      var R = T.get(o);
      R || (R = {}, T.set(o, R));
      var L = i.toString(),
          I = R[p],
          k = void 0;
      return n.i(w.c)(i) ? (I || (I = [], R[p] = I), k = {
        regex: i,
        listener: r
      }, I.push(k)) : R[L] = r, {
        cancel: function cancel() {
          R && (delete R[L], o && 0 === Object.keys(R).length && T["delete"](o), k && I.splice(I.indexOf(k, 1)));
        }
      };
    }

    r.f = t, r.b = o, r.d = i, r.g = a, r.a = u, r.c = c, r.e = s;
    var f = (n(2), n(7)),
        d = n(1),
        l = n(3),
        w = n(4),
        h = n(0);
    l.a.responseListeners = l.a.responseListeners || {}, l.a.requestListeners = l.a.requestListeners || {}, l.a.WINDOW_WILDCARD = l.a.WINDOW_WILDCARD || new function () {}(), l.a.erroredResponseListeners = l.a.erroredResponseListeners || {};
    var p = '__domain_regex__';
  }, function (e, r, n) {
    'use strict';

    function t(e, r, n) {
      return r in e ? Object.defineProperty(e, r, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = n, e;
    }

    function o(e, r) {
      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          o = n.i(s.d)(),
          i = n.i(s.e)(),
          u = n.i(a.g)(window);
      return d({}, r, t, {
        sourceDomain: u,
        id: r.id || o,
        windowType: i
      });
    }

    function i(e, r, i) {
      return u.a["try"](function () {
        r = o(e, r, {
          data: n.i(s.f)(e, i, r.data),
          domain: i
        });
        var d = void 0;
        if (d = -1 !== c.c.indexOf(r.name) || r.type === c.b.POST_MESSAGE_TYPE.ACK ? 'debug' : 'error' === r.ack ? 'error' : 'info', s.g.logLevel(d, ['\n\n\t', '#send', r.type.replace(/^postrobot_message_/, ''), '::', r.name, '::', i || c.b.WILDCARD, '\n\n', r]), e === window && !c.a.ALLOW_SAME_ORIGIN) throw new Error('Attemping to send message to self');
        if (n.i(a.f)(e)) throw new Error('Window is closed');
        s.g.debug('Running send message strategies', r);
        var l = [],
            w = n.i(s.h)(t({}, c.b.WINDOW_PROPS.POSTROBOT, r), null, 2);
        return u.a.map(Object.keys(f.a), function (r) {
          return u.a["try"](function () {
            if (!c.a.ALLOWED_POST_MESSAGE_METHODS[r]) throw new Error('Strategy disallowed: ' + r);
            return f.a[r](e, w, i);
          }).then(function () {
            return l.push(r + ': success'), !0;
          }, function (e) {
            return l.push(r + ': ' + n.i(s.i)(e) + '\n'), !1;
          });
        }).then(function (e) {
          var n = e.some(Boolean),
              t = r.type + ' ' + r.name + ' ' + (n ? 'success' : 'error') + ':\n  - ' + l.join('\n  - ') + '\n';
          if (s.g.debug(t), !n) throw new Error(t);
        });
      });
    }

    r.a = i;

    var a = n(1),
        u = n(2),
        c = n(0),
        s = n(4),
        f = n(25),
        d = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var n = arguments[r];

        for (var t in n) {
          Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
      }

      return e;
    };
  }, function (e, r, n) {
    'use strict';

    function t() {
      if (!window.WeakMap) return !1;
      if (!window.Object.freeze) return !1;

      try {
        var e = new window.WeakMap(),
            r = {};
        return window.Object.freeze(r), e.set(r, '__testvalue__'), '__testvalue__' === e.get(r);
      } catch (e) {
        return !1;
      }
    }

    r.a = t;
  }, function (e, r, n) {
    'use strict';

    function t(e, r) {
      for (var n = 0; n < e.length; n++) {
        try {
          if (e[n] === r) return n;
        } catch (e) {}
      }

      return -1;
    }

    function o() {}

    r.b = t, r.a = o;
  }, function (e, r, n) {
    'use strict';

    function t(e, r) {
      if (!(e instanceof r)) throw new TypeError('Cannot call a class as a function');
    }

    n.d(r, 'a', function () {
      return f;
    });

    var o = n(1),
        i = n(14),
        a = n(15),
        u = function () {
      function e(e, r) {
        for (var n = 0; n < r.length; n++) {
          var t = r[n];
          t.enumerable = t.enumerable || !1, t.configurable = !0, 'value' in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
        }
      }

      return function (r, n, t) {
        return n && e(r.prototype, n), t && e(r, t), r;
      };
    }(),
        c = Object.defineProperty,
        s = Date.now() % 1e9,
        f = function () {
      function e() {
        if (t(this, e), s += 1, this.name = '__weakmap_' + (1e9 * Math.random() >>> 0) + '__' + s, n.i(i.a)()) try {
          this.weakmap = new window.WeakMap();
        } catch (e) {}
        this.keys = [], this.values = [];
      }

      return u(e, [{
        key: '_cleanupClosedWindows',
        value: function value() {
          for (var e = this.weakmap, r = this.keys, t = 0; t < r.length; t++) {
            var i = r[t];

            if (n.i(o.e)(i) && n.i(o.f)(i)) {
              if (e) try {
                e["delete"](i);
              } catch (e) {}
              r.splice(t, 1), this.values.splice(t, 1), t -= 1;
            }
          }
        }
      }, {
        key: 'isSafeToReadWrite',
        value: function value(e) {
          if (n.i(o.e)(e)) return !1;

          try {
            n.i(a.a)(e && e.self), n.i(a.a)(e && e[this.name]);
          } catch (e) {
            return !1;
          }

          return !0;
        }
      }, {
        key: 'set',
        value: function value(e, r) {
          if (!e) throw new Error('WeakMap expected key');
          var t = this.weakmap;
          if (t) try {
            t.set(e, r);
          } catch (e) {
            delete this.weakmap;
          }

          if (this.isSafeToReadWrite(e)) {
            var o = this.name,
                i = e[o];
            i && i[0] === e ? i[1] = r : c(e, o, {
              value: [e, r],
              writable: !0
            });
          } else {
            this._cleanupClosedWindows();

            var u = this.keys,
                s = this.values,
                f = n.i(a.b)(u, e);
            -1 === f ? (u.push(e), s.push(r)) : s[f] = r;
          }
        }
      }, {
        key: 'get',
        value: function value(e) {
          if (!e) throw new Error('WeakMap expected key');
          var r = this.weakmap;
          if (r) try {
            if (r.has(e)) return r.get(e);
          } catch (e) {
            delete this.weakmap;
          }

          if (!this.isSafeToReadWrite(e)) {
            this._cleanupClosedWindows();

            var t = this.keys,
                o = n.i(a.b)(t, e);
            if (-1 === o) return;
            return this.values[o];
          }

          var i = e[this.name];
          if (i && i[0] === e) return i[1];
        }
      }, {
        key: 'delete',
        value: function value(e) {
          if (!e) throw new Error('WeakMap expected key');
          var r = this.weakmap;
          if (r) try {
            r["delete"](e);
          } catch (e) {
            delete this.weakmap;
          }

          if (this.isSafeToReadWrite(e)) {
            var t = e[this.name];
            t && t[0] === e && (t[0] = t[1] = void 0);
          } else {
            this._cleanupClosedWindows();

            var o = this.keys,
                i = n.i(a.b)(o, e);
            -1 !== i && (o.splice(i, 1), this.values.splice(i, 1));
          }
        }
      }, {
        key: 'has',
        value: function value(e) {
          if (!e) throw new Error('WeakMap expected key');
          var r = this.weakmap;
          if (r) try {
            return r.has(e);
          } catch (e) {
            delete this.weakmap;
          }

          if (this.isSafeToReadWrite(e)) {
            var t = e[this.name];
            return !(!t || t[0] !== e);
          }

          return this._cleanupClosedWindows(), -1 !== n.i(a.b)(this.keys, e);
        }
      }]), e;
    }();
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      return '[object RegExp]' === Object.prototype.toString.call(e);
    }

    function o() {}

    r.b = t, r.a = o;
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      if (-1 === a.indexOf(e)) {
        a.push(e), setTimeout(function () {
          throw e;
        }, 1);

        for (var r = 0; r < i.length; r++) {
          i[r](e);
        }
      }
    }

    function o(e) {
      return i.push(e), {
        cancel: function cancel() {
          i.splice(i.indexOf(e), 1);
        }
      };
    }

    r.a = t, r.b = o;
    var i = [],
        a = [];
  }, function (e, r, n) {
    'use strict';

    function t(e, r) {
      if (!(e instanceof r)) throw new TypeError('Cannot call a class as a function');
    }

    n.d(r, 'a', function () {
      return c;
    });

    var o = n(20),
        i = n(18),
        a = function () {
      function e(e, r) {
        for (var n = 0; n < r.length; n++) {
          var t = r[n];
          t.enumerable = t.enumerable || !1, t.configurable = !0, 'value' in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
        }
      }

      return function (r, n, t) {
        return n && e(r.prototype, n), t && e(r, t), r;
      };
    }(),
        u = window.__zalgopromise__ = window.__zalgopromise__ || {
      flushPromises: [],
      activeCount: 0
    },
        c = function () {
      function e(r) {
        var n = this;

        if (t(this, e), this.resolved = !1, this.rejected = !1, this.errorHandled = !1, this.handlers = [], r) {
          var o = void 0,
              i = void 0,
              a = !1,
              u = !1,
              c = !1;

          try {
            r(function (e) {
              c ? n.resolve(e) : (a = !0, o = e);
            }, function (e) {
              c ? n.reject(e) : (u = !0, i = e);
            });
          } catch (e) {
            return void this.reject(e);
          }

          c = !0, a ? this.resolve(o) : u && this.reject(i);
        }
      }

      return a(e, [{
        key: 'resolve',
        value: function value(e) {
          if (this.resolved || this.rejected) return this;
          if (n.i(o.a)(e)) throw new Error('Can not resolve promise with another promise');
          return this.resolved = !0, this.value = e, this.dispatch(), this;
        }
      }, {
        key: 'reject',
        value: function value(e) {
          var r = this;
          if (this.resolved || this.rejected) return this;
          if (n.i(o.a)(e)) throw new Error('Can not reject promise with another promise');

          if (!e) {
            var t = e && 'function' == typeof e.toString ? e.toString() : Object.prototype.toString.call(e);
            e = new Error('Expected reject to be called with Error, got ' + t);
          }

          return this.rejected = !0, this.error = e, this.errorHandled || setTimeout(function () {
            r.errorHandled || n.i(i.a)(e);
          }, 1), this.dispatch(), this;
        }
      }, {
        key: 'asyncReject',
        value: function value(e) {
          this.errorHandled = !0, this.reject(e);
        }
      }, {
        key: 'dispatch',
        value: function value() {
          var r = this,
              t = this.dispatching,
              i = this.resolved,
              a = this.rejected,
              c = this.handlers;

          if (!t && (i || a)) {
            this.dispatching = !0, u.activeCount += 1;

            for (var s = 0; s < c.length; s++) {
              (function (t) {
                var u = c[t],
                    s = u.onSuccess,
                    f = u.onError,
                    d = u.promise,
                    l = void 0;
                if (i) try {
                  l = s ? s(r.value) : r.value;
                } catch (e) {
                  return d.reject(e), 'continue';
                } else if (a) {
                  if (!f) return d.reject(r.error), 'continue';

                  try {
                    l = f(r.error);
                  } catch (e) {
                    return d.reject(e), 'continue';
                  }
                }
                l instanceof e && (l.resolved || l.rejected) ? (l.resolved ? d.resolve(l.value) : d.reject(l.error), l.errorHandled = !0) : n.i(o.a)(l) ? l instanceof e && (l.resolved || l.rejected) ? l.resolved ? d.resolve(l.value) : d.reject(l.error) : l.then(function (e) {
                  d.resolve(e);
                }, function (e) {
                  d.reject(e);
                }) : d.resolve(l);
              })(s);
            }

            c.length = 0, this.dispatching = !1, u.activeCount -= 1, 0 === u.activeCount && e.flushQueue();
          }
        }
      }, {
        key: 'then',
        value: function value(r, n) {
          if (r && 'function' != typeof r && !r.call) throw new Error('Promise.then expected a function for success handler');
          if (n && 'function' != typeof n && !n.call) throw new Error('Promise.then expected a function for error handler');
          var t = new e();
          return this.handlers.push({
            promise: t,
            onSuccess: r,
            onError: n
          }), this.errorHandled = !0, this.dispatch(), t;
        }
      }, {
        key: 'catch',
        value: function value(e) {
          return this.then(void 0, e);
        }
      }, {
        key: 'finally',
        value: function value(r) {
          return this.then(function (n) {
            return e["try"](r).then(function () {
              return n;
            });
          }, function (n) {
            return e["try"](r).then(function () {
              throw n;
            });
          });
        }
      }, {
        key: 'timeout',
        value: function value(e, r) {
          var n = this;
          if (this.resolved || this.rejected) return this;
          var t = setTimeout(function () {
            n.resolved || n.rejected || n.reject(r || new Error('Promise timed out after ' + e + 'ms'));
          }, e);
          return this.then(function (e) {
            return clearTimeout(t), e;
          });
        }
      }, {
        key: 'toPromise',
        value: function value() {
          if (!window.Promise) throw new Error('Could not find window.Promise');
          return window.Promise.resolve(this);
        }
      }], [{
        key: 'resolve',
        value: function value(r) {
          return r instanceof e ? r : n.i(o.a)(r) ? new e(function (e, n) {
            return r.then(e, n);
          }) : new e().resolve(r);
        }
      }, {
        key: 'reject',
        value: function value(r) {
          return new e().reject(r);
        }
      }, {
        key: 'all',
        value: function value(r) {
          var t = new e(),
              i = r.length,
              a = [];
          if (!i) return t.resolve(a), t;

          for (var u = 0; u < r.length; u++) {
            (function (u) {
              var c = r[u];

              if (c instanceof e) {
                if (c.resolved) return a[u] = c.value, i -= 1, 'continue';
              } else if (!n.i(o.a)(c)) return a[u] = c, i -= 1, 'continue';

              e.resolve(c).then(function (e) {
                a[u] = e, 0 === (i -= 1) && t.resolve(a);
              }, function (e) {
                t.reject(e);
              });
            })(u);
          }

          return 0 === i && t.resolve(a), t;
        }
      }, {
        key: 'hash',
        value: function value(r) {
          var n = {};
          return e.all(Object.keys(r).map(function (t) {
            return e.resolve(r[t]).then(function (e) {
              n[t] = e;
            });
          })).then(function () {
            return n;
          });
        }
      }, {
        key: 'map',
        value: function value(r, n) {
          return e.all(r.map(n));
        }
      }, {
        key: 'onPossiblyUnhandledException',
        value: function value(e) {
          return n.i(i.b)(e);
        }
      }, {
        key: 'try',
        value: function value(r, n, t) {
          var o = void 0;

          try {
            o = r.apply(n, t || []);
          } catch (r) {
            return e.reject(r);
          }

          return e.resolve(o);
        }
      }, {
        key: 'delay',
        value: function value(r) {
          return new e(function (e) {
            setTimeout(e, r);
          });
        }
      }, {
        key: 'isPromise',
        value: function value(r) {
          return !!(r && r instanceof e) || n.i(o.a)(r);
        }
      }, {
        key: 'flush',
        value: function value() {
          var r = new e();
          return u.flushPromises.push(r), 0 === u.activeCount && e.flushQueue(), r;
        }
      }, {
        key: 'flushQueue',
        value: function value() {
          var e = u.flushPromises;
          u.flushPromises = [];

          for (var r = e, n = Array.isArray(r), t = 0, r = n ? r : r[Symbol.iterator]();;) {
            var o;

            if (n) {
              if (t >= r.length) break;
              o = r[t++];
            } else {
              if (t = r.next(), t.done) break;
              o = t.value;
            }

            o.resolve();
          }
        }
      }]), e;
    }();
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      try {
        if (!e) return !1;
        if (window.Promise && e instanceof window.Promise) return !0;
        if (window.Window && e instanceof window.Window) return !1;
        if (window.constructor && e instanceof window.constructor) return !1;

        if (o) {
          var r = o.call(e);
          if ('[object Window]' === r || '[object global]' === r || '[object DOMWindow]' === r) return !1;
        }

        if ('function' == typeof e.then) return !0;
      } catch (e) {
        return !1;
      }

      return !1;
    }

    r.a = t;
    var o = {}.toString;
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      var r = o.a.requestPromises.get(e);
      if (r) for (var n = r, t = Array.isArray(n), i = 0, n = t ? n : n[Symbol.iterator]();;) {
        var a;

        if (t) {
          if (i >= n.length) break;
          a = n[i++];
        } else {
          if (i = n.next(), i.done) break;
          a = i.value;
        }

        var u = a;
        u.reject(new Error('No response from window - cleaned up'));
      }
      o.a.popupWindowsByWin && o.a.popupWindowsByWin["delete"](e), o.a.remoteWindows && o.a.remoteWindows["delete"](e), o.a.requestPromises["delete"](e), o.a.methods["delete"](e), o.a.readyPromises["delete"](e);
    }

    r.a = t;
    var o = n(3);
  }, function (e, r, n) {
    'use strict';

    function t(e, r, n) {
      return r in e ? Object.defineProperty(e, r, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = n, e;
    }

    n.d(r, 'a', function () {
      return a;
    });
    var o,
        i = n(11),
        a = {
      ALLOW_POSTMESSAGE_POPUP: !('__ALLOW_POSTMESSAGE_POPUP__' in window) || window.__ALLOW_POSTMESSAGE_POPUP__,
      LOG_LEVEL: 'info',
      BRIDGE_TIMEOUT: 5e3,
      ACK_TIMEOUT: -1 !== window.navigator.userAgent.match(/MSIE/i) ? 2e3 : 1e3,
      RES_TIMEOUT: 1 / 0,
      LOG_TO_PAGE: !1,
      ALLOWED_POST_MESSAGE_METHODS: (o = {}, t(o, i.a.SEND_STRATEGIES.POST_MESSAGE, !0), t(o, i.a.SEND_STRATEGIES.BRIDGE, !0), t(o, i.a.SEND_STRATEGIES.GLOBAL, !0), o),
      ALLOW_SAME_ORIGIN: !1
    };
    0 === window.location.href.indexOf(i.a.FILE_PROTOCOL) && (a.ALLOW_POSTMESSAGE_POPUP = !0);
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      var r = void 0;

      try {
        r = n.i(s.j)(e);
      } catch (e) {
        return;
      }

      if (r && 'object' === (void 0 === r ? 'undefined' : l(r)) && null !== r && (r = r[c.b.WINDOW_PROPS.POSTROBOT]) && 'object' === (void 0 === r ? 'undefined' : l(r)) && null !== r && r.type && 'string' == typeof r.type && d.a[r.type]) return r;
    }

    function o(e) {
      if (!window || window.closed) throw new Error('Message recieved in closed window');

      try {
        if (!e.source) return;
      } catch (e) {
        return;
      }

      var r = e.source,
          o = e.origin,
          i = e.data,
          a = t(i);

      if (a) {
        if (!a.sourceDomain || 'string' != typeof a.sourceDomain) throw new Error('Expected message to have sourceDomain');

        if (0 !== a.sourceDomain.indexOf(c.b.MOCK_PROTOCOL) && 0 !== a.sourceDomain.indexOf(c.b.FILE_PROTOCOL) || (o = a.sourceDomain), -1 === f.a.receivedMessages.indexOf(a.id)) {
          f.a.receivedMessages.push(a.id);
          var l = void 0;
          if (l = -1 !== c.c.indexOf(a.name) || a.type === c.b.POST_MESSAGE_TYPE.ACK ? 'debug' : 'error' === a.ack ? 'error' : 'info', s.g.logLevel(l, ['\n\n\t', '#receive', a.type.replace(/^postrobot_message_/, ''), '::', a.name, '::', o, '\n\n', a]), n.i(u.f)(r)) return void s.g.debug('Source window is closed - can not send ' + a.type + ' ' + a.name);
          a.data && (a.data = n.i(s.k)(r, o, a.data)), d.a[a.type](r, o, a);
        }
      }
    }

    function i(e) {
      try {
        e.source;
      } catch (e) {
        return;
      }

      var r = {
        source: e.source || e.sourceElement,
        origin: e.origin || e.originalEvent && e.originalEvent.origin,
        data: e.data
      };
      o(r);
    }

    function a() {
      n.i(s.l)(window, 'message', i);
    }

    r.b = i, r.a = a;
    var u = n(1),
        c = n(0),
        s = n(4),
        f = n(3),
        d = n(24),
        l = 'function' == typeof Symbol && 'symbol' == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : _typeof(e);
    };
    f.a.receivedMessages = f.a.receivedMessages || [];
  }, function (e, r, n) {
    'use strict';

    function t(e, r, n) {
      return r in e ? Object.defineProperty(e, r, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = n, e;
    }

    n.d(r, 'a', function () {
      return l;
    });

    var o,
        i = n(2),
        a = n(1),
        u = n(0),
        c = n(4),
        s = n(13),
        f = n(12),
        d = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var n = arguments[r];

        for (var t in n) {
          Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
      }

      return e;
    },
        l = (o = {}, t(o, u.b.POST_MESSAGE_TYPE.ACK, function (e, r, t) {
      if (!n.i(f.a)(t.hash)) {
        var o = n.i(f.b)(t.hash);
        if (!o) throw new Error('No handler found for post message ack for message: ' + t.name + ' from ' + r + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
        if (!n.i(a.b)(o.domain, r)) throw new Error('Ack origin ' + r + ' does not match domain ' + o.domain.toString());
        o.ack = !0;
      }
    }), t(o, u.b.POST_MESSAGE_TYPE.REQUEST, function (e, r, t) {
      function o(o) {
        return t.fireAndForget || n.i(a.f)(e) ? i.a.resolve() : n.i(s.a)(e, d({
          target: t.originalSource,
          hash: t.hash,
          name: t.name
        }, o), r);
      }

      var l = n.i(f.c)({
        name: t.name,
        win: e,
        domain: r
      });
      return i.a.all([o({
        type: u.b.POST_MESSAGE_TYPE.ACK
      }), i.a["try"](function () {
        if (!l) throw new Error('No handler found for post message: ' + t.name + ' from ' + r + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
        if (!n.i(a.b)(l.domain, r)) throw new Error('Request origin ' + r + ' does not match domain ' + l.domain.toString());
        var o = t.data;
        return l.handler({
          source: e,
          origin: r,
          data: o
        });
      }).then(function (e) {
        return o({
          type: u.b.POST_MESSAGE_TYPE.RESPONSE,
          ack: u.b.POST_MESSAGE_ACK.SUCCESS,
          data: e
        });
      }, function (e) {
        var r = n.i(c.i)(e).replace(/^Error: /, '');
        return o({
          type: u.b.POST_MESSAGE_TYPE.RESPONSE,
          ack: u.b.POST_MESSAGE_ACK.ERROR,
          error: r
        });
      })]).then(c.m)["catch"](function (e) {
        if (l && l.handleError) return l.handleError(e);
        c.g.error(n.i(c.i)(e));
      });
    }), t(o, u.b.POST_MESSAGE_TYPE.RESPONSE, function (e, r, t) {
      if (!n.i(f.a)(t.hash)) {
        var o = n.i(f.b)(t.hash);
        if (!o) throw new Error('No handler found for post message response for message: ' + t.name + ' from ' + r + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
        if (!n.i(a.b)(o.domain, r)) throw new Error('Response origin ' + r + ' does not match domain ' + o.domain);
        if (n.i(f.d)(t.hash), t.ack === u.b.POST_MESSAGE_ACK.ERROR) return o.respond(new Error(t.error), null);

        if (t.ack === u.b.POST_MESSAGE_ACK.SUCCESS) {
          var i = t.data || t.response;
          return o.respond(null, {
            source: e,
            origin: r,
            data: i
          });
        }
      }
    }), o);
  }, function (e, r, n) {
    'use strict';

    n.d(r, 'a', function () {
      return i;
    });
    var t = n(1),
        o = n(0),
        i = {};

    i[o.b.SEND_STRATEGIES.POST_MESSAGE] = function (e, r, i) {
      var a = void 0;
      a = Array.isArray(i) ? i : i ? [i] : [o.b.WILDCARD], a = a.map(function (r) {
        if (0 === r.indexOf(o.b.MOCK_PROTOCOL)) {
          if (window.location.protocol === o.b.FILE_PROTOCOL) return o.b.WILDCARD;
          if (!n.i(t.h)(e)) throw new Error('Attempting to send messsage to mock domain ' + r + ', but window is actually cross-domain');
          return n.i(t.i)(e);
        }

        return 0 === r.indexOf(o.b.FILE_PROTOCOL) ? o.b.WILDCARD : r;
      }), a.forEach(function (n) {
        return e.postMessage(r, n);
      });
    };
  }, function (e, r, n) {
    'use strict';

    Object.defineProperty(r, '__esModule', {
      value: !0
    });
    var t = n(6);
    n.d(r, 'cleanUpWindow', function () {
      return t.cleanUpWindow;
    }), n.d(r, 'init', function () {
      return t.init;
    }), n.d(r, 'bridge', function () {
      return t.bridge;
    }), n.d(r, 'Promise', function () {
      return t.Promise;
    }), n.d(r, 'parent', function () {
      return t.parent;
    }), n.d(r, 'send', function () {
      return t.send;
    }), n.d(r, 'request', function () {
      return t.request;
    }), n.d(r, 'sendToParent', function () {
      return t.sendToParent;
    }), n.d(r, 'client', function () {
      return t.client;
    }), n.d(r, 'on', function () {
      return t.on;
    }), n.d(r, 'listen', function () {
      return t.listen;
    }), n.d(r, 'once', function () {
      return t.once;
    }), n.d(r, 'listener', function () {
      return t.listener;
    }), n.d(r, 'CONFIG', function () {
      return t.CONFIG;
    }), n.d(r, 'CONSTANTS', function () {
      return t.CONSTANTS;
    }), n.d(r, 'disable', function () {
      return t.disable;
    }), r["default"] = t;
  }, function (e, r, n) {
    'use strict';

    function t() {
      n.i(s.on)(c.b.POST_MESSAGE_NAMES.READY, {
        domain: c.b.WILDCARD
      }, function (e) {
        var r = e.source,
            n = d.a.readyPromises.get(r);
        n ? n.resolve(e) : (n = new u.a().resolve(e), d.a.readyPromises.set(r, n));
      });
      var e = n.i(a.a)();
      e && n.i(s.send)(e, c.b.POST_MESSAGE_NAMES.READY, {}, {
        domain: c.b.WILDCARD,
        timeout: 1 / 0
      })["catch"](function (e) {
        f.a.debug(n.i(l.b)(e));
      });
    }

    function o(e) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 5e3,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 'Window',
          t = d.a.readyPromises.get(e);
      return t || (t = new u.a(), d.a.readyPromises.set(e, t), setTimeout(function () {
        return t.reject(new Error(n + ' did not load after ' + r + 'ms'));
      }, r), t);
    }

    r.a = t, r.b = o;
    var i = n(7),
        a = n(1),
        u = n(2),
        c = n(0),
        s = n(6),
        f = n(9),
        d = n(3),
        l = n(8);
    d.a.readyPromises = d.a.readyPromises || new i.a();
  }, function (e, r, n) {
    'use strict';

    function t(e, r) {
      return 'object' === (void 0 === e ? 'undefined' : g(e)) && null !== e && e.__type__ === r;
    }

    function o(e, r, t, o) {
      var i = n.i(E.f)(),
          a = O.a.methods.get(e);
      return a || (a = {}, O.a.methods.set(e, a)), a[i] = {
        domain: r,
        method: t
      }, {
        __type__: b.b.SERIALIZATION_TYPES.METHOD,
        __id__: i,
        __name__: o
      };
    }

    function i(e) {
      return {
        __type__: b.b.SERIALIZATION_TYPES.ERROR,
        __message__: n.i(E.b)(e)
      };
    }

    function a(e, r, n, t) {
      return {
        __type__: b.b.SERIALIZATION_TYPES.PROMISE,
        __then__: o(e, r, function (e, r) {
          return n.then(e, r);
        }, t + '.then')
      };
    }

    function u(e, r, n, t) {
      return {
        __type__: b.b.SERIALIZATION_TYPES.ZALGO_PROMISE,
        __then__: o(e, r, function (e, r) {
          return n.then(e, r);
        }, t + '.then')
      };
    }

    function c(e) {
      return {
        __type__: b.b.SERIALIZATION_TYPES.REGEX,
        __source__: e.source
      };
    }

    function s(e, r, t) {
      return n.i(E.g)({
        obj: t
      }, function (t, s) {
        return 'function' == typeof t ? o(e, r, t, s.toString()) : t instanceof Error ? i(t) : window.Promise && t instanceof window.Promise ? a(e, r, t, s.toString()) : m.a.isPromise(t) ? u(e, r, t, s.toString()) : n.i(E.a)(t) ? c(t) : void 0;
      }).obj;
    }

    function f(e, r, t) {
      function o() {
        var o = Array.prototype.slice.call(arguments);
        return S.a.debug('Call foreign method', t.__name__, o), n.i(_.send)(e, b.b.POST_MESSAGE_NAMES.METHOD, {
          id: t.__id__,
          name: t.__name__,
          args: o
        }, {
          domain: r,
          timeout: 1 / 0
        }).then(function (e) {
          var r = e.data;
          return S.a.debug('Got foreign method result', t.__name__, r.result), r.result;
        }, function (e) {
          throw S.a.debug('Got foreign method error', n.i(E.b)(e)), e;
        });
      }

      return o.__name__ = t.__name__, o.__xdomain__ = !0, o.source = e, o.origin = r, o;
    }

    function d(e, r, n) {
      return new Error(n.__message__);
    }

    function l(e, r, n) {
      return new m.a(function (t, o) {
        return f(e, r, n.__then__)(t, o);
      });
    }

    function w(e, r, n) {
      return window.Promise ? new window.Promise(function (t, o) {
        return f(e, r, n.__then__)(t, o);
      }) : l(e, r, n);
    }

    function h(e, r, n) {
      return new RegExp(n.__source__);
    }

    function p(e, r, o) {
      return n.i(E.g)({
        obj: o
      }, function (n, o) {
        if ('object' === (void 0 === n ? 'undefined' : g(n)) && null !== n) return t(n, b.b.SERIALIZATION_TYPES.METHOD) ? f(e, r, n) : t(n, b.b.SERIALIZATION_TYPES.ERROR) ? d(e, r, n) : t(n, b.b.SERIALIZATION_TYPES.PROMISE) ? w(e, r, n) : t(n, b.b.SERIALIZATION_TYPES.ZALGO_PROMISE) ? l(e, r, n) : t(n, b.b.SERIALIZATION_TYPES.REGEX) ? h(e, r, n) : void 0;
      }).obj;
    }

    n.d(r, 'a', function () {
      return A;
    }), r.b = s, r.c = p;

    var v = n(7),
        y = n(1),
        m = n(2),
        b = n(0),
        E = n(8),
        _ = n(6),
        S = n(9),
        O = n(3),
        g = 'function' == typeof Symbol && 'symbol' == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : _typeof(e);
    };

    O.a.methods = O.a.methods || new v.a();
    var A = n.i(E.e)(function () {
      n.i(_.on)(b.b.POST_MESSAGE_NAMES.METHOD, {
        origin: b.b.WILDCARD
      }, function (e) {
        var r = e.source,
            t = e.origin,
            o = e.data,
            i = O.a.methods.get(r);
        if (!i) throw new Error('Could not find any methods this window has privileges to call');
        var a = i[o.id];
        if (!a) throw new Error('Could not find method with id: ' + o.id);
        if (!n.i(y.b)(a.domain, t)) throw new Error('Method domain ' + a.domain + ' does not match origin ' + t);
        return S.a.debug('Call local method', o.name, o.args), m.a["try"](function () {
          return a.method.apply({
            source: r,
            origin: t,
            data: o
          }, o.args);
        }).then(function (e) {
          return {
            result: e,
            id: o.id,
            name: o.name
          };
        });
      });
    });
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      return c.a["try"](function () {
        if (!e.name) throw new Error('Expected options.name');
        var r = e.name,
            t = void 0,
            o = void 0;

        if ('string' == typeof e.window) {
          var i = document.getElementById(e.window);
          if (!i) throw new Error('Expected options.window ' + Object.prototype.toString.call(e.window) + ' to be a valid element id');
          if ('iframe' !== i.tagName.toLowerCase()) throw new Error('Expected options.window ' + Object.prototype.toString.call(e.window) + ' to be an iframe');
          if (!i.contentWindow) throw new Error('Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.');
          t = i.contentWindow;
        } else if (e.window instanceof HTMLIFrameElement) {
          if ('iframe' !== e.window.tagName.toLowerCase()) throw new Error('Expected options.window ' + Object.prototype.toString.call(e.window) + ' to be an iframe');
          if (e.window && !e.window.contentWindow) throw new Error('Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.');
          e.window && e.window.contentWindow && (t = e.window.contentWindow);
        } else t = e.window;

        if (!t) throw new Error('Expected options.window to be a window object, iframe, or iframe element id.');
        var a = t;
        o = e.domain || f.b.WILDCARD;
        var u = e.name + '_' + n.i(l.d)();
        if (n.i(s.f)(a)) throw new Error('Target window is closed');
        var h = !1,
            p = w.a.requestPromises.get(a);
        p || (p = [], w.a.requestPromises.set(a, p));
        var v = c.a["try"](function () {
          if (n.i(s.j)(window, a)) return c.a.resolve(n.i(l.p)(a));
        }).then(function () {
          return new c.a(function (t, i) {
            var c = void 0;
            if (e.fireAndForget || (c = {
              name: r,
              window: a,
              domain: o,
              respond: function respond(e, r) {
                e || (h = !0, p.splice(p.indexOf(v, 1))), e ? i(e) : t(r);
              }
            }, n.i(d.d)(u, c)), n.i(d.e)(a, {
              type: f.b.POST_MESSAGE_TYPE.REQUEST,
              hash: u,
              name: r,
              data: e.data,
              fireAndForget: e.fireAndForget
            }, o)["catch"](i), e.fireAndForget) return t();

            var l = f.a.ACK_TIMEOUT,
                w = e.timeout || f.a.RES_TIMEOUT,
                y = 100,
                m = function t() {
              if (!h) {
                if (n.i(s.f)(a)) return i(c.ack ? new Error('Window closed for ' + r + ' before response') : new Error('Window closed for ' + r + ' before ack'));
                l -= y, w -= y;

                if (c.ack) {
                  if (w === 1 / 0) return;
                  y = Math.min(w, 2e3);
                } else {
                  if (l <= 0) return i(new Error('No ack for postMessage ' + r + ' in ' + n.i(s.g)() + ' in ' + f.a.ACK_TIMEOUT + 'ms'));
                  if (w <= 0) return i(new Error('No response for postMessage ' + r + ' in ' + n.i(s.g)() + ' in ' + (e.timeout || f.a.RES_TIMEOUT) + 'ms'));
                }

                setTimeout(t, y);
              }
            };

            setTimeout(m, y);
          });
        });
        return v["catch"](function () {
          n.i(d.f)(u), n.i(d.g)(u);
        }), p.push(v), v;
      });
    }

    function o(e, r, n, o) {
      return o = o || {}, o.window = e, o.name = r, o.data = n, t(o);
    }

    function i(e, r, t) {
      var i = n.i(s.a)();
      return i ? o(i, e, r, t) : new c.a(function (e, r) {
        return r(new Error('Window does not have a parent'));
      });
    }

    function a() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      if (!e.window) throw new Error('Expected options.window');
      var r = e.window;
      return {
        send: function send(n, t) {
          return o(r, n, t, e);
        }
      };
    }

    n.d(r, 'a', function () {
      return o;
    }), r.b = t, r.c = i, r.d = a;
    var u = n(7),
        c = n(2),
        s = n(1),
        f = n(0),
        d = n(5),
        l = n(4),
        w = n(3);
    w.a.requestPromises = w.a.requestPromises || new u.a();
  }, function (e, r, n) {
    'use strict';

    function t() {
      delete window[o.b.WINDOW_PROPS.POSTROBOT], window.removeEventListener('message', i.b);
    }

    r.c = t;
    var o = n(0),
        i = n(5);
    n.d(r, 'a', function () {
      return o.a;
    }), n.d(r, 'b', function () {
      return o.b;
    });
  }, function (e, r, n) {
    'use strict';

    n.d(r, 'a', function () {
      return u;
    });
    var t = n(1),
        o = n(29);
    n.d(r, 'b', function () {
      return o.a;
    }), n.d(r, 'c', function () {
      return o.b;
    }), n.d(r, 'd', function () {
      return o.c;
    }), n.d(r, 'e', function () {
      return o.d;
    });
    var i = n(32);
    n.d(r, 'f', function () {
      return i.a;
    }), n.d(r, 'g', function () {
      return i.b;
    }), n.d(r, 'h', function () {
      return i.c;
    }), n.d(r, 'i', function () {
      return i.d;
    });
    var a = n(30);
    n.d(r, 'j', function () {
      return a.a;
    }), n.d(r, 'k', function () {
      return a.b;
    }), n.d(r, 'l', function () {
      return a.c;
    });
    var u = n.i(t.a)();
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      if (!e.name) throw new Error('Expected options.name');
      if (!e.handler) throw new Error('Expected options.handler');
      var r = e.name,
          t = e.window,
          o = e.domain,
          i = {
        handler: e.handler,
        handleError: e.errorHandler || function (e) {
          throw e;
        },
        window: t,
        domain: o || d.b.WILDCARD,
        name: r
      },
          a = n.i(f.c)({
        name: r,
        win: t,
        domain: o
      }, i);

      if (e.once) {
        var c = i.handler;
        i.handler = n.i(s.n)(function () {
          return a.cancel(), c.apply(this, arguments);
        });
      }

      if (i.window && e.errorOnClose) var w = n.i(s.o)(function () {
        t && 'object' === (void 0 === t ? 'undefined' : l(t)) && n.i(u.f)(t) && (w.cancel(), i.handleError(new Error('Post message target window is closed')));
      }, 50);
      return {
        cancel: function cancel() {
          a.cancel();
        }
      };
    }

    function o(e, r, n) {
      return 'function' == typeof r && (n = r, r = {}), r = r || {}, r.name = e, r.handler = n || r.handler, t(r);
    }

    function i(e) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments[2];
      'function' == typeof r && (n = r, r = {}), r = r || {}, n = n || r.handler;
      var o = r.errorHandler,
          i = new c.a(function (t, i) {
        r = r || {}, r.name = e, r.once = !0, r.handler = function (e) {
          if (t(e), n) return n(e);
        }, r.errorHandler = function (e) {
          if (i(e), o) return o(e);
        };
      }),
          a = t(r);
      return i.cancel = a.cancel, i;
    }

    function a() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return {
        on: function on(r, n) {
          return o(r, e, n);
        }
      };
    }

    n.d(r, 'a', function () {
      return o;
    }), r.b = t, r.c = i, r.d = a;
    var u = n(1),
        c = n(2),
        s = n(4),
        f = n(5),
        d = n(0),
        l = 'function' == typeof Symbol && 'symbol' == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : _typeof(e);
    };
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)(module)))

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeBrowser */
/* unused harmony export normalizeOS */
/* unused harmony export isTVApp */
/* unused harmony export isMobile */
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeBrowsers;
/* harmony export (immutable) */ __webpack_exports__["d"] = normalizeOSs;
/* harmony export (immutable) */ __webpack_exports__["e"] = normalizePlatform;
/* harmony export (immutable) */ __webpack_exports__["f"] = regionNameFromCode;
/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeHostData;
/* harmony export (immutable) */ __webpack_exports__["a"] = computeInsights;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geo__ = __webpack_require__(27);

function normalizeBrowser(b) {
  b = b || '';

  if (b.indexOf('Edg') >= 0) {
    // Microsoft Edge, Edg/XX, EdgiOS, EdgA)
    return 'Edge';
  } else if (b.indexOf('IE') >= 0) {
    return 'Internet Explorer';
  } else if (b.indexOf('Chrome Mobile') >= 0) {
    return 'Chrome Mobile';
  } else if (b.indexOf('Chrome') >= 0 && b.indexOf('Mobile Safari') >= 0) {
    return 'Chrome Mobile';
  } else if (b.indexOf('Mobile') >= 0 && b.indexOf('Safari') >= 0) {
    return 'Safari Mobile';
  } else if (b.indexOf('Safari') >= 0) {
    return 'Safari';
  } else if (b.indexOf('Chrome') >= 0) {
    return 'Chrome';
  } else if (b.indexOf('Firefox') >= 0) {
    return 'Firefox';
  } else {
    return 'Other';
  }
}
function normalizeOS(o) {
  if (!o || !o.trim()) {
    return 'Not reported';
  } else if (o.indexOf('Windows') >= 0) {
    return 'Windows';
  } else if (o.indexOf('Chrome OS') >= 0) {
    return 'Chrome OS';
  } else if (o.indexOf('OS X') >= 0 || o.indexOf('macOS') >= 0) {
    return 'macOS';
  } else if (o.indexOf('iOS') >= 0) {
    return 'iOS';
  } else if (o.indexOf('Android') >= 0) {
    return 'Android';
  } else if (o.indexOf('Linux') >= 0 || o.indexOf('Ubuntu') >= 0) {
    return 'Linux';
  } else {
    return 'Other';
  }
}
function isTVApp(o) {
  if (!o || !o.trim()) {
    return false;
  } else if (o.indexOf('Roku') >= 0) {
    return true;
  } else if (o.indexOf('AppleTV') >= 0) {
    return true;
  } else if (o.indexOf('Apple TV') >= 0) {
    return true;
  } else if (o.indexOf('Chromecast') >= 0) {
    return true;
  } else if (o.indexOf('ChromeCast') >= 0) {
    return true;
  } else if (o.indexOf('Fire TV') >= 0) {
    return true;
  } else if (o.indexOf('FireTV') >= 0) {
    return true;
  } else {
    return false;
  }
}
function isMobile(o) {
  if (!o || !o.trim()) {
    return false;
  } else if (o.indexOf('iOS') >= 0) {
    return true;
  } else if (o.indexOf('Android') >= 0) {
    return true;
  } else if (o.indexOf('Mobile') >= 0) {
    return true;
  } else if (o.indexOf('Phone') >= 0) {
    return true;
  } else if (o.indexOf('Tablet') >= 0) {
    return true;
  } else {
    return false;
  }
}
function normalizeBrowsers(map) {
  var result = {};

  _.each(map, function (count, label) {
    if (!result[normalizeBrowser(label)]) {
      result[normalizeBrowser(label)] = 0;
    }

    result[normalizeBrowser(label)] += count;
  });

  return result;
}
function normalizeOSs(map) {
  var result = {};

  _.each(map, function (count, label) {
    if (!result[normalizeOS(label)]) {
      result[normalizeOS(label)] = 0;
    }

    result[normalizeOS(label)] += count;
  });

  return result;
}
function normalizePlatform(osMap, browserMap) {
  var result = {
    Mobile: 0,
    Desktop: 0,
    'TV App': 0
  };

  _.each(osMap, function (count, label) {
    if (isMobile(label)) {
      result.Mobile += count;
    } else {
      result.Desktop += count;
    }
  }); // XXX: Roku doesn't send the `os` field, so we need to infer it from the browser field
  // and subtract those out of otherwise desktop views.


  _.each(browserMap, function (count, label) {
    if (isTVApp(label)) {
      console.log('detected tv app', label);
      result['TV App'] += count;
      result['Desktop'] -= count;
    }
  });

  return result;
}
function regionNameFromCode(code, regionDict) {
  var parts = code.split('-');
  if (parts.length != 2 || parts[0] == '' && parts[1] == '') return;
  var labelData = regionDict && regionDict["".concat(parts[1], "-").concat(parts[0])];
  var label = labelData && labelData.join(', ') || code || 'Unknown Location';

  if (code.startsWith('-')) {
    code = code.replace('-', '');

    _.each(regionDict, function (v, k) {
      if (k.startsWith(code)) {
        label = "".concat(v[0], " (unknown state)");
      }
    });
  }

  return label;
}
function normalizeHostData(analytics) {
  var totalViewCountForDestinationPercent = analytics.total_view_count;
  var hostData = [];

  _.keys(analytics.view_counts_by_host).forEach(function (l) {
    var viewCount = analytics.view_counts_by_host[l]; // Clean up some names

    if (!l || l == 'boxcastiframe.com') {
      l = 'Inline Frame (host not reported)';
    }

    if (!l || l == 'BoxCast.tv for AppleTV') {
      l = 'BoxCast.tv for Apple TV';
    } // Some special destinations get icons


    var icon = 'icon_website@30px.png';

    if (l == 'twitter.com') {
      icon = 'icon_twitter@30px.png';
    }

    if (l == 'BoxCast.tv for Roku') {
      icon = 'icon_roku@30px.png';
    }

    if (l == 'BoxCast.tv for Apple TV') {
      icon = 'icon_appletv@30px.png';
    }

    if (l == 'BoxCast.tv for Fire TV') {
      icon = 'icon_firetv@30px.png';
    }

    hostData.push({
      label: l,
      value: viewCount,
      percent: 100 * viewCount / totalViewCountForDestinationPercent,
      icon: icon
    });
  });

  return _.sortByOrder(hostData, ['value', 'label'], ['desc', 'asc']);
}
function computeInsights(broadcast, analytics) {
  var insights = {
    watchPercent: 0,
    geo: {
      countries: 0,
      states: 0
    },
    device: ''
  }; // Insight: watch percentage

  if (broadcast && broadcast.total_minutes_viewed > 0) {
    var durationSec = broadcast.recording_duration_seconds || (moment(broadcast.stops_at) - moment(broadcast.starts_at)) / 1000;
    var durationMin = Math.max(1, durationSec / 60);
    var avgViewDurationMin = broadcast.total_minutes_viewed / analytics.unique_viewer_count;
    insights.watchPercent = 100 * (avgViewDurationMin / durationMin);
  } // Insight: geo


  if (analytics.view_counts_by_region_code) {
    insights.geo.countries = Object(__WEBPACK_IMPORTED_MODULE_0__geo__["a" /* countCountries */])(analytics.view_counts_by_region_code);
    insights.geo.states = _.keys(analytics.view_counts_by_region_code).length;
  } // Insight: device


  if (analytics.view_counts_by_os) {
    var os = normalizePlatform(analytics.view_counts_by_os, analytics.view_counts_by_browser);
    var counts = {
      'desktop computers': os.Desktop,
      'mobile devices': os.Mobile,
      'TV apps': os['TV App']
    };
    insights.device = _.keys(counts).reduce(function (a, b) {
      return counts[a] > counts[b] ? a : b;
    });
  }

  return insights;
}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\" style=\"border-bottom:0;padding-bottom:0;\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span\n      aria-hidden=\"true\">&times;</span></button>\n\n  <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n    <li ng-class=\"!vm.activeTab ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.activeTab = ''\">Overview</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'schedule' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.activeTab = 'schedule'\">Schedule</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'scoreboard' ? 'active' : ''\" ng-if=\"vm.service.showAnyScoreboards\">\n      <a href=\"javascript://\" ng-click=\"vm.activeTab = 'scoreboard'\">Scoreboard</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'publish' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.activeTab = 'publish'\">Publish</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'advanced' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.activeTab = 'advanced'\">Advanced</a>\n    </li>\n  </ol>\n</div>\n<div class=\"modal-body\">\n\n  <main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n    <form name=\"form\" role=\"form\">\n\n      <div>\n        <div ng-if=\"vm.showError\">\n          <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n            {{vm.service.errors.join('. ') || 'Please fill out all required fields before proceeding.'}}\n          </div>\n        </div>\n\n        <div\n          ng-if=\"vm.service.broadcast.stream_source == 'recording' && vm.service.broadcast.timeframe != 'past' && vm.service.sourceBroadcastProblem\">\n          <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n            The source recording for this simulated live broadcast {{ vm.service.sourceBroadcastProblem }}.\n            Please delete the broadcast, or edit it to choose a new source broadcast.\n          </div>\n        </div>\n\n\n        <div ng-if=\"!vm.activeTab\">\n          <div class=\"form-group\">\n            <label for=\"eventName\">Broadcast Name <i class=\"fa fa-asterisk text-danger\" \n                style=\"font-size:10px;vertical-align:top\"></i></label>\n            <input type=\"text\" class=\"form-control\" id=\"eventName\" name=\"eventName\" ng-model=\"vm.service.broadcast.name\" \n              ng-maxlength=\"::vm.service.limits.name\" required>\n            <p ng-show=\"!vm.service.broadcast.name\">\n              <span class=\"text-danger\" ng-if=\"form.eventName.$error.maxlength\">The broadcast name is too long.</span>\n              <span class=\"text-danger\" ng-if=\"form.eventName.$error.required\">The broadcast name cannot be blank.</span>\n            </p>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group col-xs-12 col-sm-8\">\n              <label for=\"eventDescription\">Broadcast Description</label>\n              <textarea rows=\"3\" class=\"form-control\" id=\"eventDescription\"\n                ng-model=\"vm.service.broadcast.description\"></textarea>\n            </div>\n            <div class=\"form-group col-xs-12 col-sm-4\">\n              <div ng-if=\"vm.service.broadcast.content_settings.preview\" class=\"text-center\">\n                <img ng-src=\"{{vm.service.broadcast.content_settings.preview | trustedUrl}}\" class=\"img\"\n                  style=\"max-width:100%\">\n                <div><a href ng-click=\"vm.service.broadcast.content_settings.preview = null\">Change</a></div>\n              </div>\n              <div ng-if=\"!vm.service.broadcast.content_settings.preview\">\n                <upload-slot ng-model=\"vm.file\" ng-change=\"vm.service.uploadPreviewImage(vm.file)\" slot-name=\"'preview'\"\n                  allow-image=\"true\" allow-video=\"false\" compact=\"true\"></upload-slot>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"boxcaster\" ng-if=\"vm.service.broadcast.stream_source != 'imported'\">Source<i \n                class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <source-chooser edit-or-create-event-service=\"vm.service\"></source-chooser>\n            <label ng-if=\"vm.service.isSimulatedLive\" style=\"margin-top: 5px;\">Source Broadcast<i \n                class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <recording-source-chooser ng-if=\"vm.service.isSimulatedLive\" edit-or-create-event-service=\"vm.service\">\n            </recording-source-chooser>\n          </div>\n\n\n          <div class=\"row\" ng-show=\"vm.service.isRTMPBasedSource\">\n            <div class=\"form-group col-sm-6\" ng-hide=\"vm.service.hideOptionVideoResolution\">\n              <label for=\"video_resolution\">Video Resolution</label>\n              <div class=\"btn-group btn-group-justified\">\n                <label class=\"btn btn-default btn-sm\" ng-disabled=\"vm.service.broadcast.timeframe != 'future'\"\n                  ng-model=\"vm.service.broadcast.target_video_resolution\" uib-btn-radio=\"480\"\n                  ng-if=\"vm.service.resolutionLimit >= 480\">480p</label>\n                <label class=\"btn btn-default btn-sm\" ng-disabled=\"vm.service.broadcast.timeframe != 'future'\"\n                  ng-model=\"vm.service.broadcast.target_video_resolution\" uib-btn-radio=\"720\"\n                  ng-if=\"vm.service.resolutionLimit >= 720\">720p</label>\n                <label class=\"btn btn-default btn-sm\" ng-disabled=\"vm.service.broadcast.timeframe != 'future'\"\n                  ng-model=\"vm.service.broadcast.target_video_resolution\" uib-btn-radio=\"1080\"\n                  ng-if=\"vm.service.resolutionLimit >= 1080\">1080p</label>\n              </div>\n            </div>\n            <div class=\"form-group col-sm-6\" ng-hide=\"vm.service.hideHighFrameRate\">\n              <label for=\"target_high_frame_rate\">Frame Rate</label>\n              <div class=\"btn-group btn-group-justified btn-group-flex\">\n                <label class=\"btn btn-default btn-sm font-bold\" ng-disabled=\"vm.service.broadcast.timeframe != 'future'\"\n                  ng-model=\"vm.service.broadcast.target_high_frame_rate\" uib-btn-radio=\"false\">Standard&nbsp; <small\n                    style=\"font-weight: 400\">30fps max</small></label>\n                <label class=\"btn btn-default btn-sm font-bold\" ng-disabled=\"vm.service.broadcast.timeframe != 'future'\"\n                  ng-model=\"vm.service.broadcast.target_high_frame_rate\" uib-btn-radio=\"true\">High&nbsp; <small\n                    style=\"font-weight: 400\">60fps max</small></label>\n              </div>\n            </div>\n          </div>\n\n        </div>\n\n        <div ng-if=\"vm.activeTab == 'schedule'\">\n\n          <!-- allow full date editing for future events -->\n          <div class=\"row\" ng-if=\"vm.canEditStart\">\n            <div class=\"col-xs-12\" style=\"margin:0 0 15px 0\">\n              <div style=\"display:flex; flex-wrap:wrap;\">\n                <div style=\"width:290px;\">\n                  <div class=\"form-group\">\n                    <div class=\"datepicker\">\n                      <!-- hack: need wrapper class to target custom styles -->\n                      <uib-datepicker ng-model=\"vm.service.startDate\" ng-change=\"vm.service.getConflictingEvents(true)\"\n                        datepicker-options=\"vm.service.datepickerOptions\"></uib-datepicker>\n                    </div>\n                  </div>\n                </div>\n\n\n                <div style=\"width:225px;flex:1;\">\n                  <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\" \n                    ng-if=\"vm.service.broadcast.timeframe != 'past' && vm.service.account.max_simultaneous_streams > 0 && vm.service.worstCaseSimultaneousStreams >= vm.service.account.max_simultaneous_streams\">\n                    <h5 style=\"margin-top:0;font-weight:bold;\">\n                      Stream Limits\n                    </h5>\n                    <p>\n                      Your account is only able to stream {{ vm.service.account.max_simultaneous_streams }}\n                      simultaneous broadcast{{ vm.service.account.max_simultaneous_streams > 1 ? 's' : '' }}. This\n                      broadcast will not start if that count is exceeded. If you would like to add additional\n                      simultaneous broadcasts to your account, please <a href=\"mailto:questions@boxcast.com\" \n                      target=\"_blank\">contact customer support</a>.\n                    </p>\n                  </div>\n                  <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\" \n                    ng-if=\"vm.service.conflictingEvents.length > 0\">\n                    <h5 style=\"margin-top:0;font-weight:bold;\">\n                      Conflicting Broadcasts\n                    </h5>\n                    <ul class=\"list-unstyled\" style=\"margin:0\">\n                      <li ng-repeat=\"broadcast in vm.service.conflictingEvents track by broadcast.id\">\n                        {{::broadcast.name}}\n                        <span>({{::broadcast.starts_at | date:'h:mm a'}} - {{::broadcast.stops_at | date:'shortTime'}})</span>\n                      </li>\n                    </ul>\n                  </div>\n                  <div ng-if=\"vm.service.otherNonConflictingEvents.length > 0\">\n                    <h5 style=\"margin-top:0;font-weight:bold;\">\n                      Other Broadcasts on {{vm.service.startDate | date}}\n                    </h5>\n                    <ul class=\"list-unstyled\" style=\"margin:0\">\n                      <li class=\"text-muted\" ng-repeat=\"broadcast in vm.service.otherNonConflictingEvents track by broadcast.id\">\n                        {{::broadcast.name}}\n                        <span class=\"\"> -- ({{::broadcast.starts_at | date:'h:mm a'}}</span>\n                        <span class=\"\" ng-if=\"broadcast.stops_at && !broadcast.stops_at.startsWith('9999-12-31')\">\n                          - {{::broadcast.stops_at | date:'shortTime'}})\n                        </span>\n                      </li>\n                    </ul>\n                  </div>\n                </div>\n\n              </div>\n            </div>\n          </div>\n\n          <!-- no date editing for non-future events (only stop time if current) -->\n          <div class=\"row\" ng-if=\"!vm.canEditStart\">\n            <div class=\"col-xs-12\">\n              <div class=\"form-group\">\n                <label>Start Date</label>\n                <input class=\"form-control\" disabled value=\"{{vm.service.startDate | date:'mediumDate'}}\"\n                  style=\"max-width:360px\">\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-12\">\n              <div class=\"form-group pull-left\" style=\"max-width:200px;padding-right:15px;\">\n                <label>Start Time</label>\n                <time-picker ng-if=\"vm.canEditStart\" ng-model=\"vm.service.startTime\" start-time=\"vm.minStartTime\"\n                  scroll-item-into-focus=\"true\" ng-change=\"vm.service.getConflictingEvents()\"></time-picker>\n                <input ng-if=\"!vm.canEditStart\" class=\"form-control\" disabled\n                  value=\"{{vm.service.startTime | date:'shortTime'}}\">\n                <p class=\"text-warning\" ng-show=\"vm.service.recordingStorageExpires\">\n                  <i class=\"fa fa-warning\"></i>\n                  The source recording for this simulated live broadcast will be purged before the broadcast's start\n                  time.\n                </p>\n              </div>\n              <div class=\"form-group pull-left\" style=\"max-width:200px;padding-right:15px;\">\n                <label>End Time</label>\n                <time-picker ng-if=\"vm.canEditStop\" ng-hide=\"vm.service.isSimulatedLive\" ng-model=\"vm.service.endTime\"\n                  start-time=\"vm.service.startTime\" show-duration=\"true\" ng-change=\"vm.service.getConflictingEvents()\">\n                </time-picker>\n                <input ng-if=\"!vm.canEditStop && !vm.service.isSimulatedLive\" class=\"form-control\" disabled\n                  value=\"{{vm.service.endTime | date:'shortTime'}}\">\n                <p class=\"help-block\" ng-if=\"vm.canEditStop\"\n                  ng-show=\"vm.service.isSimulatedLive && !vm.service.simulatedLiveEndTime\">\n                  <i class=\"fa fa-clock-o\" style=\"width:15px;\"></i>\n                  End time will be calculated from the recording duration.\n                </p>\n                <input ng-if=\"vm.service.isSimulatedLive && vm.service.simulatedLiveEndTime\" class=\"form-control\"\n                  disabled value=\"{{vm.service.simulatedLiveEndTime | date:'shortTime' | lowercase}}\">\n              </div>\n              <div class=\"form-group pull-left\" ng-if=\"!vm.service.isSimulatedLive\">\n                <p class=\"help-block\">\n                  <i class=\"fa fa-clock-o\"></i>\n                  Duration: {{ vm.service.startTime | dateDuration : vm.service.endTime : false :\n                  vm.service.maxBroadcastDurationHours+':00' }} hours\n                </p>\n              </div>\n            </div>\n            <div class=\"col-xs-12\">\n              <p class=\"text-warning\"\n                ng-show=\"!vm.service.isSimulatedLive && vm.service.endTime.toTimeString() < vm.service.startTime.toTimeString()\">\n                <i class=\"fa fa-warning\"></i>\n                The end time is <em>before</em> the start time, so the broadcast will continue until the following day\n              </p>\n              <p class=\"text-danger\"\n                ng-show=\"!vm.service.isSimulatedLive && vm.service.endTime.toTimeString() == vm.service.startTime.toTimeString()\">\n                <i class=\"fa fa-warning\"></i>\n                A broadcast must have a non-zero duration\n              </p>\n              <p class=\"text-danger\"\n                ng-show=\"vm.service.broadcast.stream_source != 'imported' && vm.service.isInThePast && vm.canEditStart && vm.canEditStop\">\n                <i class=\"fa fa-warning\"></i>\n                A broadcast may not be scheduled in the past\n              </p>\n              <p class=\"help-block\">\n                <i class=\"fa fa-info-circle\"></i>\n                All times {{vm.currentTimezone}}\n              </p>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.activeTab == 'scoreboard'\">\n          <div ng-init=\"sc = vm.service.broadcast.scoreboard_configuration\"></div>\n          <div ng-if=\"vm.service.broadcast.timeframe != 'past'\" style=\"margin-top:-15px\">\n            <scoreboard-tab-config vm=\"vm\" sc=\"sc\" show-clear=\"true\"></scoreboard-tab-config>\n          </div>\n          <div ng-if=\"vm.service.broadcast.timeframe == 'past'\">\n            <div ng-if=\"!sc.sport\" class=\"form-group clearfix\">\n              <p><em>Scoreboard overlay not configured.</em></p>\n            </div>\n            <div ng-if=\"sc.sport\" class=\"form-group clearfix\">\n              <div class=\"col-sm-12\">\n                <scoreboard-config-summary service=\"vm.service\"\n                  scoreboard-configuration=\"vm.service.broadcast.scoreboard_configuration\" label-suffix=\"\"\n                  bold-labels=\"true\" bold-values=\"false\"></scoreboard-config-summary>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.activeTab == 'publish'\">\n\n          <div class=\"form-group\">\n            <label>Broadcast Type:<i class=\"fa fa-asterisk text-danger\" \n              style=\"font-size:10px;vertical-align:top\"></i></label>\n            <div>\n              <div class=\"btn-group\">\n                <label class=\"btn btn-default\"                                 ng-model=\"vm.service.visibility\" uib-btn-radio=\"'private'\"> Private</label>\n                <label class=\"btn btn-default\" ng-if=\"vm.service.showPublic\"   ng-model=\"vm.service.visibility\" uib-btn-radio=\"'public'\"> Public</label>\n                <label class=\"btn btn-default\" ng-if=\"vm.service.showFlex\"     ng-model=\"vm.service.visibility\" uib-btn-radio=\"'flex'\"> Flex (Ticketed HD)</label>\n                <label class=\"btn btn-default\" ng-if=\"vm.service.showTicketed\" ng-model=\"vm.service.visibility\" uib-btn-radio=\"'ticketed'\"> Ticketed</label>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"vm.service.showScrambleOption\">\n            <span ng-click=\"vm.service.scrambleChannelId = !vm.service.scrambleChannelId\"\n              style=\"cursor:pointer;opacity:0.8\">\n              <i class=\"fa\" ng-class=\"vm.service.scrambleChannelId ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Remove the existing boxcast.tv link\n            </span>\n            <i class=\"fa fa-question-circle\" uib-tooltip=\"Since you are toggling the visibility to private, we recommend\n                regenerating the boxcast.tv link in case it was ever shared. If the link was never shared, you can leave\n                the link as-is by unchecking this box.\"></i>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"vm.service.visibility == 'ticketed' || vm.service.visibility == 'flex'\">\n            <label for=\"ticket_price\">Ticket Price <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <div class=\"input-group display-flex align-items-center\">\n              <div class=\"input-group-addon\">$</div>\n              <input type=\"number\" step=\"0.01\" min=\"4\" class=\"form-control\" style=\"max-width: 100px\" id=\"ticket_price\" ng-model=\"vm.service.broadcast.ticket_price\">\n              <div ng-if=\"vm.service.visibility == 'flex'\">\n                <div style=\"padding: 0.5rem 1rem; display: inline-block;\">\n                  <i class=\"fa fa-info-circle\"></i>\n                  Viewers will receive a low-quality stream for free\n                </div>\n              </div>\n            </div>\n            <p class=\"help-block\"><i class=\"fa fa-info-circle\"></i> The minimum ticket price is $4.00</p>\n          </div>\n\n          <div class=\"form-group\" ng-show=\"vm.service.showChannelSelector\">\n            <label>Channels</label>\n            <div>\n              <select selectize config=\"{\n                valueField: 'id',\n                labelField: 'name',\n                placeholder: 'Select Channels...',\n                highlight: true,\n                searchField: 'name',\n                selectOnTab: true,\n                plugins: ['remove_button']\n              }\" options=\"vm.service.channels\" ng-model=\"vm.service.broadcast.in_channel_ids\"></select>\n            </div>\n            <p class=\"text-warning\" ng-if=\"vm.service.visibility == 'private'\">\n              <i class=\"fa fa-warning\"></i> Channels are not applicable to private broadcasts.\n            </p>\n          </div>\n\n          <div class=\"form-group\" ng-show=\"vm.service.showFeatured\">\n            <label>Tags</label>\n            <div>\n              <select id=\"tagSelect\" selectize config=\"{\n                valueField: 'name',\n                labelField: 'name',\n                placeholder: 'Select Tags...',\n                highlight: true,\n                searchField: 'name',\n                selectOnTab: true,\n                plugins: ['remove_button'],\n                create: true\n              }\" options=\"vm.service.tags\" ng-model=\"vm.service.broadcast.tags\"></select>\n            </div>\n          </div>\n\n          <div\n            ng-if=\"vm.service.broadcast.stream_source != 'imported' &&\n              (vm.service.broadcast.timeframe != 'past' || vm.service.broadcast.simulcast_configurations.length) &&\n              (vm.service.allowFacebookLive || vm.service.allowYoutubeLive || vm.service.allowGenericRtmpPush || vm.service.allowTwitter)\">\n            <div ng-if=\"vm.service.broadcast.timeframe == 'past'\">\n              <div class=\"form-group clearfix\" ng-repeat=\"s in vm.service.broadcast.simulcast_configurations\">\n                <label ng-if=\"s.destination == 'facebook'\">Facebook Live</label>\n                <div ng-if=\"s.destination == 'facebook'\">\n                  Streamed by FB user \"{{s.fb_user_name}}\"\n                  <span ng-if=\"s.fb_feed_id == 'user:me'\">to a timeline</span>\n                  <span ng-if=\"s.fb_feed_id != 'user:me'\">to {{ vm.facebookLiveSimulcastFeedType(s) }} {{\n                    vm.facebookLiveSimulcastFeedID(s) }}</span>\n                  with visibility \"{{s.fb_privacy}}\".\n                </div>\n                <label ng-if=\"s.destination == 'youtube'\">YouTube Live</label>\n                <div ng-if=\"s.destination == 'youtube'\">\n                  Streamed by YT user \"{{s.youtube_display_name}}\"\n                  with visibility \"{{s.privacy}}\".\n                </div>\n                <label ng-if=\"s.destination == 'periscope'\">Periscope</label>\n                <div ng-if=\"s.destination == 'periscope'\">\n                  Streamed by Periscope user \"{{s.periscope_display_name}}\".\n                </div>\n                <label ng-if=\"s.destination == 'twitter'\">Twitter</label>\n                <div ng-if=\"s.destination == 'twitter'\">\n                  Streamed by Twitter user \"{{s.twitter_display_name}}\".\n                </div>\n                <label ng-if=\"s.destination == 'generic' || s.destination == 'rtmp_push_channel'\">Other RTMP</label>\n                <div ng-if=\"s.destination == 'generic'\">\n                  Streamed to <code>{{s.stream_url}}/{{s.stream_key}}</code>\n                </div>\n                <div ng-if=\"s.destination == 'rtmp_push_channel'\">\n                  Streamed to <code>{{s.name}}</code>\n                </div>\n              </div>\n            </div>\n            <div ng-if=\"vm.service.broadcast.timeframe != 'past'\" class=\"row\">\n              <simulcast-configuration-editor vm=\"vm\" vertical-form=\"true\"></simulcast-configuration-editor>\n            </div>\n          </div>\n          <!--/ social simulcast wrapper-->\n\n        </div>\n\n        <div ng-if=\"vm.activeTab == 'advanced'\">\n\n          <div class=\"form-group\" ng-hide=\"vm.service.hideOptionRecord\">\n            <label ng-click=\"vm.toggleDoNotRecord()\" ng-style=\"vm.styleDoNotRecord\">\n              <i class=\"fa\" ng-class=\"vm.service.broadcast.do_not_record ? 'fa-square-o' : 'fa-check-square-o'\"\n                style=\"width:20px\"></i>\n              Record Broadcast\n              <i class=\"fa fa-question-circle\" tooltip-append-to-body=\"true\"\n                uib-tooltip=\"Disabling this option will make it so you and viewers can only watch the broadcast while it is live. The broadcast will not be stored.\"\n                tooltip-placement=\"bottom\" style=\"opacity:0.5\"></i>\n            </label>\n          </div>\n\n          <div class=\"form-group\"\n            ng-hide=\"!vm.service.FeatureFlags.automated_captioning || vm.service.FeatureFlags.live_automated_captioning || vm.service.broadcast.timeframe == 'past' || vm.service.broadcast.do_not_record || vm.service.isSimulatedLive\">\n            <label ng-click=\"vm.service.broadcast.requests_captioning = !vm.service.broadcast.requests_captioning\"\n              style=\"cursor:pointer\">\n              <i class=\"fa\" ng-class=\"vm.service.broadcast.requests_captioning ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Request Automated Captioning When Recorded\n            </label>\n          </div>\n\n          <div class=\"form-group\"\n            ng-hide=\"!vm.service.FeatureFlags.live_automated_captioning || vm.service.broadcast.timeframe != 'future' || vm.service.isSimulatedLive\">\n            <label ng-click=\"vm.service.broadcast.requests_captioning = !vm.service.broadcast.requests_captioning\"\n              style=\"cursor:pointer\">\n              <i class=\"fa\" ng-class=\"vm.service.broadcast.requests_captioning ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Automated Live Captioning\n            </label>\n          </div>\n\n          <div ng-if=\"::vm.service.FeatureFlags.password\" class=\"form-group\">\n            <label\n              ng-click=\"vm.service.broadcast.content_settings.cryptblock = vm.service.broadcast.content_settings.cryptblock ? null : {}\"\n              style=\"cursor:pointer\">\n              <i class=\"fa\"\n                ng-class=\"vm.service.broadcast.content_settings.cryptblock ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Enable Password Protection\n            </label>\n            <div ng-if=\"vm.service.broadcast.content_settings.cryptblock\" style=\"margin-top:5px\">\n              <div>\n                <span ng-show=\"vm.service.broadcast.content_settings.cryptblock.crypt\">Change Password</span>\n                <span ng-hide=\"vm.service.broadcast.content_settings.cryptblock.crypt\">Enter Password</span>\n              </div>\n              <input type=\"password\" autocomplete=\"hi-browser-plz-dont-autofill-this\" class=\"form-control\"\n                ng-model=\"vm.service.broadcast.content_settings.cryptblock.__password__\">\n            </div>\n          </div>\n\n          <div ng-if=\"::vm.service.FeatureFlags.host_restrictions\" class=\"form-group\">\n            <host-restrictions-settings content-settings=\"vm.service.broadcast.content_settings\">\n            </host-restrictions-settings>\n          </div>\n\n          <div ng-if=\"::vm.service.FeatureFlags.podcast\">\n            <p style=\"font-weight:bold;\">\n              <a ng-click=\"vm.showPodcast = !vm.showPodcast\" href>\n                <i class=\"fa\" ng-class=\"vm.showPodcast ? 'fa-caret-down' : 'fa-caret-right'\"></i>\n                {{vm.showPodcast ? 'Hide' : 'Show'}} Podcast-Specific Settings\n              </a>\n            </p>\n            <div ng-show=\"vm.showPodcast\">\n              <podcast-settings broadcast=\"vm.service.broadcast\"\n                on-upload-preview-image=\"vm.service.uploadPodcastPreviewImage\"></podcast-settings>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-show=\"vm.service.showOptionTargetBufferLatency\">\n            <label for=\"target_buffer_latency\">\n              BoxCast Flow Control\n              <i class=\"fa fa-question-circle\" style=\"opacity:0.5\"\n                uib-tooltip-html=\"vm.service.targetBufferLatencyTooltip\" tooltip-append-to-body=\"true\"></i>\n            </label>\n            <select class=\"form-control\" id=\"target_buffer_latency\"\n              ng-disabled=\"vm.service.broadcast.timeframe != 'future'\"\n              ng-model=\"vm.service.broadcast.target_buffer_latency\"\n              ng-options=\"e.value as e.label for e in vm.service.bufferLatencies\">\n            </select>\n          </div>\n          <div class=\"form-group\" ng-hide=\"vm.service.hideOptionTargetVideoBitRate\">\n            <label for=\"target_video_bitrate\">Target Video Bitrate</label>\n            <select class=\"form-control\" id=\"target_video_bitrate\" ng-disabled=\"vm.service.disableVideoBitrate\"\n              ng-model=\"vm.service.broadcast.target_video_bitrate\" ng-options=\"\n                        e.value as e.label\n                        disable when (\n                          (e.label == 'Audio Only' && vm.service.disableAudioOnlyOption)\n                          || (e.label == 'Default' && vm.service.disableDefaultVideoBitrateOption)\n                          || (e.label == 'Auto-detect' && vm.service.disableDefaultVideoBitrateOption)\n                        )\n                        for e in vm.service.videoBitrates\n                      \">\n            </select>\n            <p ng-if=\"vm.service.broadcast.timeframe == 'current' && vm.service.isAudioOnly\" class=\"help-block\">\n              <i class=\"fa fa-info-circle\"></i> Audio-only broadcasts cannot be changed to display video once started.\n            </p>\n          </div>\n          <div class=\"form-group\" ng-hide=\"vm.service.hideOptionTargetAudioBitRate\">\n            <label for=\"target_audio_bitrate\">Target Audio Bitrate</label>\n            <select class=\"form-control\" id=\"target_audio_bitrate\"\n              ng-disabled=\"vm.service.broadcast.timeframe == 'past'\"\n              ng-model=\"vm.service.broadcast.target_audio_bitrate\"\n              ng-options=\"e.value as e.label for e in vm.service.audioBitrates\">\n            </select>\n          </div>\n          <div class=\"form-group\" ng-hide=\"vm.service.hideOptionAudioSource\">\n            <label for=\"audio_source\">Audio Source</label>\n            <select class=\"form-control\" id=\"audio_source\" ng-disabled=\"vm.service.broadcast.timeframe == 'past'\"\n              ng-model=\"vm.service.broadcast.audio_source\"\n              ng-options=\"e.value as e.label for e in vm.service.audioSources\">\n            </select>\n          </div>\n          <div class=\"form-group\" ng-hide=\"vm.service.isRTMPBasedSource || vm.service.hideOptionVideoResolution\">\n            <label for=\"video_resolution\">Video Resolution</label>\n            <select class=\"form-control\" id=\"video_resolution\"\n              ng-disabled=\"vm.service.broadcast.timeframe != 'future' || vm.service.isAudioOnly\"\n              ng-model=\"vm.service.broadcast.target_video_resolution\"\n              ng-options=\"e.value as e.label for e in vm.service.videoResolutions\">\n            </select>\n          </div>\n          <div class=\"form-group\" ng-hide=\"vm.service.isRTMPBasedSource || vm.service.hideHighFrameRate\">\n            <label for=\"target_high_frame_rate\">High Frame Rate</label>\n            <select class=\"form-control\" id=\"target_high_frame_rate\"\n              ng-disabled=\"vm.service.broadcast.timeframe != 'future' || vm.service.isAudioOnly\"\n              ng-model=\"vm.service.broadcast.target_high_frame_rate\"\n              ng-options=\"e.value as e.label for e in vm.service.highFrameRates\">\n            </select>\n          </div>\n          <div class=\"form-group\" ng-hide=\"vm.service.hideOptionDSCPValue\">\n            <label for=\"dscp\">DSCP Value</label>\n            <select class=\"form-control\" id=\"dscp\" ng-disabled=\"vm.service.broadcast.timeframe == 'past'\"\n              ng-model=\"vm.service.broadcast.dscp_value\"\n              ng-options=\"e.value as e.label for e in ::vm.service.dscpValues\">\n            </select>\n          </div>\n        </div>\n\n\n      </div>\n</div>\n</form>\n</main>\n\n</div>\n<div class=\"modal-footer\" ng-if=\"vm.service.broadcast.id\">\n  <ul class=\"list-inline pull-left\">\n    <li ng-if=\"::vm.service.canDelete\">\n      <a href=\"javascript://\" ng-click=\"vm.delete()\" class=\"action-link\">\n        <i class=\"fa fa-trash\"></i>\n        Delete\n      </a>\n    </li>\n    <li>\n      <a href=\"javascript://\" ng-click=\"vm.clone()\" class=\"action-link\">\n        <i class=\"fa fa-copy\"></i>\n        Duplicate\n      </a>\n    </li>\n  </ul>\n\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Close</button>\n  <button class=\"btn btn-primary\" ng-click=\"vm.submit()\" ng-disabled=\"vm.submitting\">\n    <i ng-show=\"vm.submitting\" class=\"fa fa-spin fa-spinner\"></i>\n    Save Changes\n  </button>\n</div>"

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["uploadImageToOverlay"] = uploadImageToOverlay;
// overlay image directive
//
//   <overlay-image overlay="{...}" on-change="..." />
//
// works closely with the draggable and resizable directives
//
var module = angular.module('app.directives');
module.directive('overlayPreview', function () {
  'ngInject';

  return {
    scope: {
      overlay: '='
    },
    template: "\n      <div class=\"fixed-16-9 transparent-grid-bg\">\n        <div class=\"upload-image\" ng-style=\"{\n          'background-image': 'url(&quot;'+overlay.url+'&quot;)',\n          'background-repeat': 'no-repeat',\n          'background-position': '0% 0%',\n          'background-size': 'contain',\n        }\">\n        </div>\n      </div>\n    "
  };
});
module.directive('overlayImage', function () {
  'ngInject';

  return {
    scope: {
      overlay: '=',
      onChange: '='
    },
    template: "\n      <div class=\"overlay-image\"\n           ng-style=\"style\"\n           draggable=\"\"\n           resizable=\"\"\n           aspect-ratio=\"overlay.height / overlay.width\"\n           on-drag=\"onDrag\"\n           on-resize=\"onResize\"\n           ></div>\n    ",
    controller: function controller($scope) {
      'ngInject';

      var overlay = $scope.overlay;
      $scope.style = {
        position: 'absolute',
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"".concat(overlay.url, "\")"),
        top: 100 * overlay.offsetY + '%',
        left: 100 * overlay.offsetX + '%',
        width: 100 * overlay.scaleWidth + '%',
        height: 100 * overlay.scaleHeight + '%'
      };

      $scope.onDrag = function (xPct, yPct) {
        $scope.onChange(overlay, {
          offsetX: roundFloatTo5Decimals(xPct / 100),
          offsetY: roundFloatTo5Decimals(yPct / 100)
        });
      };

      $scope.onResize = function (wPct, hPct) {
        $scope.onChange(overlay, {
          scaleWidth: roundFloatTo5Decimals(wPct / 100),
          scaleHeight: roundFloatTo5Decimals(hPct / 100)
        });
      };
    }
  };
});
function uploadImageToOverlay(upload, width, height) {
  var scaleW = width / 1920.0; //simulated canvas assumes 1920x1080

  var scaleH = height / 1080.0; //simulated canvas assumes 1920x1080

  if (scaleW > 1) {
    scaleW = 1;
    scaleH = height / width * (1920 / 1080);
  }

  if (scaleH > 1) {
    scaleH = 1;
    scaleW = width / height * (1080 / 1920);
  }

  return {
    url: upload.view_url,
    width: width,
    height: height,
    scaleWidth: roundFloatTo5Decimals(scaleW),
    scaleHeight: roundFloatTo5Decimals(scaleH),
    offsetX: 0,
    offsetY: 0
  };
}

function roundFloatTo5Decimals(val) {
  // api/origin doesn't deal with long floating point well
  return Math.round(val * 100000) / 100000;
}

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = ComputeBroadcastStatus;
/* harmony export (immutable) */ __webpack_exports__["d"] = ComputePastBroadcastStarRating;
/* harmony export (immutable) */ __webpack_exports__["c"] = ComputePastBroadcastRecommendations;
/* harmony export (immutable) */ __webpack_exports__["f"] = GetBitrateLimitsForBroadcast;
/* harmony export (immutable) */ __webpack_exports__["k"] = V3Timestamps;
/* harmony export (immutable) */ __webpack_exports__["l"] = V3Values;
/* harmony export (immutable) */ __webpack_exports__["j"] = V3PlaceholderTimestamps;
/* harmony export (immutable) */ __webpack_exports__["g"] = HasIntegratedScoreboard;
/* harmony export (immutable) */ __webpack_exports__["i"] = V3HasAnyScoreboardData;
/* harmony export (immutable) */ __webpack_exports__["h"] = ParseScoreboardEvents;
/* harmony export (immutable) */ __webpack_exports__["e"] = FilterRSSIForLinkStatus;
/* harmony export (immutable) */ __webpack_exports__["a"] = BaselineIngestLatency;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var viewErrorMessages = {
  offline_title: 'The BoxCaster Is Offline',
  offline_subtitle: ' ',
  busy_title: 'BoxCaster Is Busy Streaming Another Broadcast',
  busy_subtitle: 'Once the other is finished, this broadcast will begin.',
  no_video_input_title: 'BoxCaster Cannot Detect an Audio/Video Signal',
  no_video_input_subtitle: ' ',
  updating_firmware_title: 'BoxCaster Is Busy Updating Firmware',
  updating_firmware_subtitle: 'Once finished, this broadcast will begin.'
};
var progressDescription = {
  rtmp: {
    1: 'Waiting to create a stream.',
    5: 'Waiting to allocate a server.',
    20: 'Preparing for your broadcast.',
    60: 'Stream settings configured.',
    90: ' '
  },
  boxcaster: {
    1: 'Waiting to allocate stream.',
    5: {
      title: 'Waiting for Your BoxCaster'
    },
    10: 'Preparing for your broadcast.',
    20: 'Testing your bandwidth.',
    40: 'Configuring your stream settings.',
    60: 'Stream settings configured.',
    90: ' '
  },
  app: {
    1: 'Waiting to allocate stream.',
    5: {
      title: 'Open the Broadcaster App to Start Streaming'
    },
    10: 'Preparing for your broadcast.',
    20: 'Testing your bandwidth.',
    40: 'Configuring your stream settings.',
    60: 'Stream settings configured.',
    90: ' '
  },
  recording: {
    1: 'Waiting to create a stream.',
    5: 'Waiting to allocate a server.',
    20: 'Preparing for your broadcast.',
    90: ' '
  },
  misc: {
    busy_another: {
      title: 'BoxCaster is Busy Streaming Another Broadcast'
    },
    simultaneous: {
      title: 'Waiting on Simultaneous Broadcast'
    }
  }
};
progressDescription.switcher = progressDescription.rtmp;
function ComputeBroadcastStatus(broadcast, view, boxcaster, streamDiagnostics, staticRTMPDiagnostics) {
  if (!view) {
    // wait for player to have _something_ to show
    return null;
  } else if (broadcast.timeframe != 'preroll' && broadcast.timeframe != 'current') {
    // only care during preroll+live
    return null;
  }

  var status = view.status,
      reason = view.reason,
      progress = view.progress;
  var stream_source = broadcast.stream_source,
      timeframe = broadcast.timeframe;
  var progressMsg = (progressDescription[stream_source] || {})[progress];

  var activeAlerts = _.pluck(_.where((streamDiagnostics || {}).alerts || [], {
    is_active: true
  }), 'message');

  var streamSourceName = 'BoxCaster';

  if (stream_source == 'rtmp') {
    streamSourceName = 'RTMP Encoder';
  } else if (stream_source == 'app') {
    streamSourceName = 'Broadcaster App';
  } else if (stream_source == 'switcher') {
    streamSourceName = 'Switcher Studio';
  } else if (stream_source == 'recording') {
    streamSourceName = 'Re-Broadcast (Simulated Live)';
  } // Special case of "busy broadcasting a different stream", which can't be
  // inferred from the broadcast/view directly.  Instead we assume if it's stuck at 1%
  // but the BoxCaster is reporting OK, it's caught in that scenario.


  if (boxcaster && boxcaster.status == 'broadcasting' && progress == 1) {
    progressMsg = progressDescription.misc.busy_another;
  }

  if (broadcast.is_limited_by_active_stream_count) {
    return angular.extend({
      status: 'error'
    }, progressDescription.misc.simultaneous);
  } // If the view has a specific reason or status that we've defined, those take
  // precedence over everything else, as they're very specific.


  if (viewErrorMessages["".concat(reason, "_title")]) {
    return {
      status: 'error',
      title: viewErrorMessages["".concat(reason, "_title")],
      subtitle: viewErrorMessages["".concat(reason, "_subtitle")]
    };
  } else if (viewErrorMessages["".concat(status, "_title")]) {
    return {
      status: 'error',
      title: viewErrorMessages["".concat(status, "_title")],
      subtitle: viewErrorMessages["".concat(status, "_subtitle")]
    };
  } // Take into account the static RTMP diagnostics when using RTMP.


  if (stream_source == 'rtmp' || stream_source == 'switcher') {
    if (!staticRTMPDiagnostics || !staticRTMPDiagnostics.connected) {
      return {
        status: 'error',
        title: 'The RTMP Source Is Not Connected'
      };
    }
  } // If we're supposed to be live and the view says we're live, let's
  // dig a little deeper into diagnostics.


  if (timeframe == 'current' && status == 'live') {
    if (activeAlerts.indexOf('Streaming interrupted') >= 0 || activeAlerts.indexOf('Waiting to receive data') >= 0) {
      return {
        status: 'error',
        title: "Connection from ".concat(streamSourceName, " Was Lost"),
        subtitle: ''
      };
    } else if (streamDiagnostics && streamDiagnostics.status == 'Critical') {
      return {
        status: 'error',
        title: 'Live (Broadcast Health Warning)',
        subtitle: activeAlerts.join(', ')
      };
    } else if (streamDiagnostics && streamDiagnostics.status == 'Warning') {
      return {
        status: 'warning',
        title: 'Live',
        subtitle: activeAlerts.join(', ')
      };
    } else {
      return {
        status: 'ok',
        title: 'Live',
        subtitle: ''
      };
    }
  } // Pre-roll states need to look at diagnostics and progress %


  if (timeframe == 'preroll') {
    if (streamDiagnostics && streamDiagnostics.status == 'OK') {
      return {
        status: 'ok',
        title: 'Ready To Go Live',
        subtitle: ''
      };
    } else {
      if (progressMsg && progressMsg.title) {
        return {
          status: 'warning',
          title: progressMsg.title,
          subtitle: progressMsg.subtitle || ''
        };
      } else {
        return {
          status: 'warning',
          title: 'Getting Ready',
          subtitle: progressMsg || "Catching up at ".concat(progress, "%")
        };
      }
    }
  } // Finally, if we're supposed to be live but aren't yet, let's look
  // at how much we know based on diagnostics/progress


  if ((streamDiagnostics || {}).status == 'OK' && progress == 90) {
    return {
      status: 'ok',
      title: 'Live',
      subtitle: 'Preparing the stream for viewers.'
    };
  } else if (progressMsg && progressMsg.title) {
    return {
      status: 'error',
      title: progressMsg.title,
      subtitle: progressMsg.subtitle || ''
    };
  } else {
    return {
      status: 'error',
      title: 'The Stream Has Not Yet Started',
      subtitle: progressMsg || "Catching up at ".concat(progress, "%")
    };
  }
}
function ComputePastBroadcastStarRating(streamDiagnostics) {
  var status = streamDiagnostics.summary_status;

  if (!status) {
    return 0;
  }

  var hasCritical = _.find(streamDiagnostics.alerts, {
    level: 'Critical'
  });

  var hasWarning = _.find(streamDiagnostics.alerts, {
    level: 'Warning'
  });

  if (status == 'OK' && (streamDiagnostics.alerts || []).length == 0) {
    return 5;
  }

  if (status == 'OK' && !hasCritical) {
    return 4.5;
  }

  if (status == 'OK') {
    return 4;
  }

  if (status == 'Warning') {
    return 3;
  }

  var avgTotalBitrate = streamDiagnostics.average_total_bitrate || streamDiagnostics.avg_bitrate;

  if (status == 'Critical' && avgTotalBitrate > 300) {
    return 2;
  }

  if (status == 'Critical' && avgTotalBitrate > 10) {
    return 1;
  }

  if (status == 'Critical' && avgTotalBitrate == 0) {
    return 0;
  }
}
function ComputePastBroadcastRecommendations(broadcast, streamDiagnostics) {
  var result = [];

  if (!streamDiagnostics.summary_status) {
    return result;
  }

  if (streamDiagnostics.packet_loss_per_minute > 5) {
    result.push({
      text: "Packet loss detected. This can be due to an unstable internet connection.",
      link: 'https://support.boxcast.com/en/articles/4235089',
      linkText: 'See tips for reducing packet loss.'
    });
  }

  if (findAlert(streamDiagnostics, 'Transcode delayed')) {
    result.push({
      text: "Transcode delay detected. Ensure proper RTMP encoder settings to avoid viewer buffering.",
      link: 'https://support.boxcast.com/en/articles/4235181',
      linkText: 'Learn how to configure your RTMP encoder.'
    });
  }

  if (findAlert(streamDiagnostics, 'Ingest latency too high')) {
    result.push({
      text: "High ingest latency detected; your encoder or network can't keep up.",
      link: 'https://support.boxcast.com/en/articles/4235181',
      linkText: 'Learn how to configure your RTMP encoder.'
    });
  }

  if (findAlert(streamDiagnostics, 'Ingest latency too low')) {
    result.push({
      text: "Negative ingest latency detected; your encoder is sending data too fast.",
      link: 'https://support.boxcast.com/en/articles/4235181',
      linkText: 'Learn how to configure your RTMP encoder.'
    });
  }

  if (findAlert(streamDiagnostics, 'Streaming interrupted')) {
    var x = findAlert(streamDiagnostics, 'Streaming interrupted'); // check if it only appears at the end of the broadcast; sign that you unplugged
    // early (probably intentionally), so different than losing internet mid-stream

    if (x.is_active || x.inactive_at >= broadcast.stops_at) {
      result.push({
        text: "Stream interruption detected at end of broadcast. Use the stop broadcast button on the dashboard before disconnecting your encoder to avoid viewer buffering.",
        link: '',
        linkText: ''
      });
    } else {
      result.push({
        text: "Stream interruption detected. This can be due to an unstable internet connection.",
        link: 'https://www.boxcast.com/blog/what-upload-speed-do-i-need-to-stream',
        linkText: 'Read about recommended upload speeds.'
      });
    }
  }

  return result;
}

function findAlert(streamDiagnostics, t) {
  var alerts = streamDiagnostics.alerts || [];

  for (var i = 0; i < alerts.length; i++) {
    if (alerts[i].message.toUpperCase().indexOf(t.toUpperCase()) >= 0) {
      return alerts[i];
    }
  }

  return null;
}

function GetBitrateLimitsForBroadcast(apiConfig, broadcast) {
  var ret = {}; // Pick off limits based on the stream source

  switch (broadcast.stream_source) {
    case 'boxcaster':
      switch ((broadcast.boxcaster_id || '')[0]) {
        // HDSD2 and friends
        case 'l': // fall-through

        case 'n': // fall-through

        case 'o':
          ret.video = ((apiConfig.boxcaster || {}).video_bitrate_limits || {}).hdsd2 || {};
          ret.audio = ((apiConfig.boxcaster || {}).audio_bitrate_limits || {}).hdsd2 || {};
          break;
        // BoxCaster Pro

        case 'p':
          ret.video = ((apiConfig.boxcaster || {}).video_bitrate_limits || {}).pro || {};
          ret.audio = ((apiConfig.boxcaster || {}).audio_bitrate_limits || {}).pro || {};
          break;

        default:
          return ret;
      }

      break;
    // Broadcaster

    case 'app':
      ret.video = ((apiConfig.boxcaster || {}).video_bitrate_limits || {}).broadcaster || {};
      ret.audio = ((apiConfig.boxcaster || {}).audio_bitrate_limits || {}).broadcaster || {};
      break;
    // RTMP and Switcher

    case 'rtmp': // fall-through

    case 'switcher':
      ret.video = ((apiConfig.boxcaster || {}).video_bitrate_limits || {}).rtmp || {};
      ret.audio = ((apiConfig.boxcaster || {}).audio_bitrate_limits || {}).rtmp || {};
      break;

    default:
      return ret;
  } // Now narrow down video based on transcoder profile


  var transcoderProfile = broadcast.transcoder_profile || '';

  if (transcoderProfile == 'audio') {
    delete ret.video;
  } else {
    var resolutionKey = parseInt(transcoderProfile).toString();
    var frameRateKey = transcoderProfile.match(/p60/) ? 'high_frame_rate' : 'low_frame_rate';
    var videoCodecKey = transcoderProfile.match(/:hevc/) ? 'hevc' : 'avc';
    ret.video = ((ret.video[resolutionKey] || {})[frameRateKey] || {})[videoCodecKey] || {};
  }

  return ret;
} // V3Timestamps plucks timestamps off of a data version 3 stream diagnostics result

function V3Timestamps(s) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  while (args.length > 0) {
    s = s[args.shift()] || {};
  }

  return _.pluck(s, 0);
} // V3Values plucks values off of a data version 3 stream diagnostics result

function V3Values(s) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  while (args.length > 0) {
    s = s[args.shift()] || {};
  }

  return _.pluck(s, 1);
} // V3PlaceholderTimestamps fills a data series (data values in `datas`, timestamps in `timestamps`) with a placeholder
// (currently `null`) for any missing timestamps. The full set of timestamps is passed in `fullTimestamps`.

function V3PlaceholderTimestamps(data, timestamps, fullTimestamps) {
  var newData = [];
  var PLACEHOLDER = null; // data and timestamps should have the same length; if they don't, yell loudly and
  // use the smaller value

  var dataLen = data.length;

  if (timestamps.length != dataLen) {
    console.error("placeholderTimestamps: data.length (".concat(dataLen, ") does not match timestamps.length (").concat(timestamps.length, ")!"));

    if (timestamps.length < dataLen) {
      dataLen = timestamps.length;
    }
  }

  var idx = 0;
  var fullIdx = 0;

  while (true) {
    if (fullIdx >= fullTimestamps.length) break;
    var nextData = data[idx];
    var nextTimestamp = timestamps[idx];
    var nextFullTimestamp = fullTimestamps[fullIdx];

    if (nextTimestamp == nextFullTimestamp) {
      // Timestamps match; emit data and advance both indices
      newData.push(nextData);
      idx++;
      fullIdx++;
    } else if (!nextTimestamp || nextFullTimestamp < nextTimestamp) {
      // Emit the placeholder and advance the full index
      newData.push(PLACEHOLDER);
      fullIdx++;
    } else {
      // This is unexpected, as all the timestamps should be included in fullTimestamps. Yell loudly,
      // omit this data from newData, and advance idx.
      console.error("placeholderTimestamps: timestamp ".concat(nextTimestamp, " was present in timestamps, but not in fullTimestamps!"));
      idx++;
    }
  }

  return newData;
}
function HasIntegratedScoreboard(scoreboardConfiguration) {
  if (scoreboardConfiguration && scoreboardConfiguration.scoreboard_make) {
    var m = scoreboardConfiguration.scoreboard_make;

    if (m == 'BoxCast' || m == 'Daktronics' || m == 'Trans-Lux Fair-Play' || m == 'OES') {
      return true;
    }
  }

  return false;
}

function hasAnyNonZeroData(data) {
  return _.some(data, function (d) {
    return d != 0;
  });
}

function V3HasAnyScoreboardData(streamDiagnostics) {
  if (!streamDiagnostics) return false;
  var scoreboardInformation = streamDiagnostics.scoreboard;

  if (scoreboardInformation) {
    if (!!scoreboardInformation.events && scoreboardInformation.events.length) return true;
    var scoreboardAssist = scoreboardInformation.scoreboard_assist;

    if (scoreboardAssist) {
      if (!!scoreboardAssist.events && scoreboardAssist.events.length) return true;
      if (scoreboardAssist.operation_mode) return true;
      var identity = scoreboardAssist.identity;
      if (!!identity && (!!identity.box || identity.scoreboard)) return true;
    }
  }

  var stats = streamDiagnostics.raw_stats || streamDiagnostics.raw_stats_coarse;

  if (stats) {
    var scoreBitrateData = V3Values(stats, 'bitrate', 'score');
    if (!!scoreBitrateData && hasAnyNonZeroData(scoreBitrateData)) return true;
    var scorePacketLossData = V3Values(stats, 'packet_loss', 'score');
    if (!!scorePacketLossData && hasAnyNonZeroData(scorePacketLossData)) return true;
  }

  var scoreboardStats = streamDiagnostics.raw_scoreboard_stats || streamDiagnostics.raw_scoreboard_stats_coarse;

  if (scoreboardStats) {
    var rssi = ((scoreboardStats || {}).scoreboard_assist || {}).rssi;

    if (rssi) {
      var boxRSSIData = V3Values(rssi, 'box');
      if (!!boxRSSIData && hasAnyNonZeroData(boxRSSIData)) return true;
      var scoreboardRSSIData = V3Values(rssi, 'scoreboard');
      if (!!scoreboardRSSIData && hasAnyNonZeroData(scoreboardRSSIData)) return true;
    }

    var linkStatus = ((scoreboardStats || {}).scoreboard_assist || {}).link_status;

    if (linkStatus) {
      var boxLinkStatusData = V3Values(linkStatus, 'box');
      if (!!boxLinkStatusData && hasAnyNonZeroData(boxLinkStatusData)) return true;
      var scoreboardLinkStatusData = V3Values(linkStatus, 'scoreboard');
      if (!!scoreboardLinkStatusData && hasAnyNonZeroData(scoreboardLinkStatusData)) return true;
    }
  }

  return false;
} // ParseScoreboardEvents walks through scoreboard events and scoreboard assist events, formatting them into objects
// suitable for listing/display in the scoreboard events section and sorting them by timestamp.

function ParseScoreboardEvents(streamDiagnostics, scoreboardConfiguration) {
  var scoreboardEvents = [];

  _.each(((streamDiagnostics || {}).scoreboard || {}).events || [], function (e) {
    switch (e.code) {
      case 'sport_change':
        var detectedSport = e.data.to;

        if (detectedSport.startsWith('Basketball')) {
          detectedSport = 'Basketball';
        }

        scoreboardEvents.push({
          timestamp: moment(e.timestamp).toDate(),
          message: "Detected sport ".concat(detectedSport)
        });
        break;

      case 'serial_port_state_change':
        var deviceName = 'Scoreboard adapter';
        if ((scoreboardConfiguration || {}).scoreboard_make == 'BoxCast') deviceName = 'Scoreboard Assist';
        var whatHappened = 'connected to';
        if (!e.data.to) whatHappened = 'disconnected from';
        scoreboardEvents.push({
          timestamp: moment(e.timestamp).toDate(),
          message: "".concat(deviceName, " ").concat(whatHappened, " BoxCaster")
        });
        break;
    }
  });

  _.each((((streamDiagnostics || {}).scoreboard || {}).scoreboard_assist || {}).events || [], function (e) {
    var side = {
      box: 'BoxCaster',
      scoreboard: 'Scoreboard',
      '': ''
    }[(e.data || {}).side || ''];

    switch (e.code) {
      case 'link_state':
        if (side) {
          scoreboardEvents.push({
            timestamp: moment(e.timestamp).toDate(),
            message: "".concat(side, " side link is now ").concat(e.data.to)
          });
        }

        break;

      case 'interface':
        var iface = {
          nevco: 'Nevco',
          'rs-232': 'RS-232',
          'rs-422': 'RS-422',
          '': ''
        }[e.data.to || ''];

        if (iface) {
          scoreboardEvents.push({
            timestamp: moment(e.timestamp).toDate(),
            message: "Switching to the ".concat(iface, " interface")
          });
        }

        break;

      case 'make_model':
        var make = e.data.to.make;
        var model = e.data.to.model;

        if (make != 'none' && model != 'none') {
          var startsWithVowel = false;
          if ('aeiou'.indexOf(make.toLowerCase()[0]) != -1) startsWithVowel = true;
          scoreboardEvents.push({
            timestamp: moment(e.timestamp).toDate(),
            message: "Detected a".concat(startsWithVowel ? 'n' : '', " ").concat(make, " ").concat(model)
          });
        }

        break;

      case 'rs422_jack_inserted':
        scoreboardEvents.push({
          timestamp: moment(e.timestamp).toDate(),
          message: "RS-422 jack inserted"
        });
        break;

      case 'rs422_jack_removed':
        scoreboardEvents.push({
          timestamp: moment(e.timestamp).toDate(),
          message: "RS-422 jack removed"
        });
        break;

      case 'pairing_mode_entered':
        if (side) {
          scoreboardEvents.push({
            timestamp: moment(e.timestamp).toDate(),
            message: "".concat(side, " side entered pairing mode")
          });
        }

        break;

      case 'pairing_mode_exited':
        if (side) {
          scoreboardEvents.push({
            timestamp: moment(e.timestamp).toDate(),
            message: "".concat(side, " side exited pairing mode")
          });
        }

        break;

      case 'rs422_termination_set':
        scoreboardEvents.push({
          timestamp: moment(e.timestamp).toDate(),
          message: "RS-422 termination turned ".concat(e.data.termination ? 'on' : 'off')
        });
        break;
      // IGNORING FOR NOW:
      // ScoreboardAssistEventCodeBaudRate  = ScoreboardAssistEventCode("baud_rate")
      // ScoreboardAssistEventCodeMiscellaneousFailure = ScoreboardAssistEventCode("miscellaneous_failure")
      // ScoreboardAssistEventCodeNevcoDetected        = ScoreboardAssistEventCode("nevco_detected")
      // ScoreboardAssistEventCodeNevcoSignalLost      = ScoreboardAssistEventCode("nevco_signal_lost")
      // ScoreboardAssistEventCodeUARTDetected         = ScoreboardAssistEventCode("uart_detected")
      // ScoreboardAssistEventCodeAutobaudLocked       = ScoreboardAssistEventCode("autobaud_locked")
      // ScoreboardAssistEventCodeAutobaudFailed       = ScoreboardAssistEventCode("autobaud_failed")
    }
  });

  return _.sortBy(scoreboardEvents, function (e) {
    return e.timestamp;
  });
} // FilterRSSIForLinkStatus filters the RSSI values to remove values when the pair was unlinked.

function FilterRSSIForLinkStatus(scoreboardAssistStats) {
  var rssi = (scoreboardAssistStats || {}).rssi || {};
  var boxRSSI = rssi.box || [];
  var scoreboardRSSI = rssi.scoreboard || [];
  var boxLinkStatus = ((scoreboardAssistStats || {}).link_status || {}).box || [];
  if (!boxRSSI.length || !scoreboardRSSI.length || !boxLinkStatus.length) return;
  var idxBoxRSSI = 0;
  var idxScoreboardRSSI = 0;

  for (var idxBoxLinkStatus = 0; idxBoxLinkStatus < boxLinkStatus.length; idxBoxLinkStatus++) {
    // Get the link status timestamp
    var linkStatusTimestamp = boxLinkStatus[idxBoxLinkStatus][0]; // Advance the other indices until we get to a matching timestamp

    var boxRSSITimestamp = (boxRSSI[idxBoxRSSI] || [])[0];

    while (idxBoxRSSI < boxRSSI.length && boxRSSITimestamp < linkStatusTimestamp) {
      idxBoxRSSI++;
      boxRSSITimestamp = (boxRSSI[idxBoxRSSI] || [])[0];
    }

    var scoreboardRSSITimestamp = (scoreboardRSSI[idxScoreboardRSSI] || [])[0];

    while (idxScoreboardRSSI < scoreboardRSSI.length && scoreboardRSSITimestamp < linkStatusTimestamp) {
      idxScoreboardRSSI++;
      scoreboardRSSITimestamp = (scoreboardRSSI[idxScoreboardRSSI] || [])[0];
    } // If the pair is not linked at this timestamp, set any values to null


    var linkValue = (boxLinkStatus[idxBoxLinkStatus] || [])[1];

    if (linkValue != 3) {
      if (idxBoxRSSI < boxRSSI.length && boxRSSITimestamp == linkStatusTimestamp) {
        boxRSSI[idxBoxRSSI][1] = null;
      }

      if (idxScoreboardRSSI < scoreboardRSSI.length && scoreboardRSSITimestamp == linkStatusTimestamp) {
        scoreboardRSSI[idxScoreboardRSSI][1] = null;
      }
    }
  }
} // baselineStats accepts an array of fine or coarse stats and baselines the values such that all
// values are greater than or equal to zero. It also returns the minimum value.

function baselineStats(stats) {
  if (!stats || stats.length == 0) {
    return 0;
  }

  var min = Math.min.apply(Math, _toConsumableArray(V3Values(stats)));
  stats.forEach(function (e) {
    return e[1] -= min;
  });
  return min;
} // maxFineStatTimeRange is the maximum broadcast duration under which the "fine" stats will be used
// for calculating ingest latency. Broadcasts longer than this will use the coarse stats.


var maxFineStatTimeRange = 60 * 60 * 1000; // BaselineIngestLatency baselines the fine and coarse RTMP ingest latency stats such that all
// values are greater than or equal to zero. It also adjusts the last, average, and max ingest
// latency (when present) to take into account the minimum recorded value.

function BaselineIngestLatency(streamDiagnostics, broadcast) {
  if (!streamDiagnostics) {
    return;
  }

  var fineLatencyMin = 0;

  if (streamDiagnostics.raw_stats && streamDiagnostics.raw_stats.ingest_latency) {
    fineLatencyMin = baselineStats(streamDiagnostics.raw_stats.ingest_latency);
  }

  var coarseLatencyMin = 0;

  if (streamDiagnostics.raw_stats_coarse && streamDiagnostics.raw_stats_coarse.ingest_latency) {
    coarseLatencyMin = baselineStats(streamDiagnostics.raw_stats_coarse.ingest_latency);
  } // last_ingest_latency should be adjusted by the fine results


  if (_.isNumber(streamDiagnostics.last_ingest_latency) && _.isNumber(fineLatencyMin)) {
    streamDiagnostics.last_ingest_latency -= fineLatencyMin;
  } // if broadcast duration > 1 hour, max_ingest_latency and average_ingest_latency use coarse results; otherwise they use fine results.


  var broadcastDuration = moment(broadcast.stops_at) - moment(broadcast.starts_at);
  var adjustmentLatency = broadcastDuration > maxFineStatTimeRange ? coarseLatencyMin : fineLatencyMin;

  if (_.isNumber(streamDiagnostics.max_ingest_latency) && _.isNumber(adjustmentLatency)) {
    streamDiagnostics.max_ingest_latency -= adjustmentLatency;
  }

  if (_.isNumber(streamDiagnostics.average_ingest_latency) && _.isNumber(adjustmentLatency)) {
    streamDiagnostics.average_ingest_latency -= adjustmentLatency;
  } // There was a bug in stream diagnostics service that took the max absolute value for
  // max_ingest_latency rather than the max value. So here we just sanity-check max_ingest_latency
  // in case average_ingest_latency or last_ingest_latency is higher.


  var maxFineLatency = 0;

  if (streamDiagnostics.raw_stats && streamDiagnostics.raw_stats.ingest_latency) {
    maxFineLatency = Math.max.apply(Math, _toConsumableArray(V3Values(streamDiagnostics.raw_stats.ingest_latency)));
  }

  var maxCoarseLatency = 0;

  if (streamDiagnostics.raw_stats_coarse && streamDiagnostics.raw_stats_coarse.ingest_latency) {
    maxCoarseLatency = Math.max.apply(Math, _toConsumableArray(V3Values(streamDiagnostics.raw_stats_coarse.ingest_latency)));
  }

  var maxLatency = Math.max(maxFineLatency, maxCoarseLatency, streamDiagnostics.last_ingest_latency || 0, streamDiagnostics.average_ingest_latency || 0);

  if (!streamDiagnostics.max_ingest_latency || maxLatency > streamDiagnostics.max_ingest_latency) {
    streamDiagnostics.max_ingest_latency = maxLatency;
  }
}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">{{vm.params.heading}}</h3>\n</div>\n<div class=\"modal-body text-center\">\n  <upload-slot ng-model=\"vm.file\"\n                slot-name=\"vm.params.slotName\"\n                allow-image=\"vm.params.allowImage\"\n                allow-video=\"vm.params.allowVideo\"\n                hide-stock-browse=\"true\"\n                hide-recent-browse=\"true\"\n                compact=\"false\">\n  </upload-slot>\n</div>\n<div class=\"modal-footer text-right\">\n  <a class=\"btn btn-primary\" ng-disabled=\"!vm.file || vm.uploading\" ng-click=\"vm.upload()\">\n      <i ng-if=\"vm.uploading\" class=\"fa fa-spin fa-spinner\"></i> Upload\n  </a>\n  <a class=\"btn btn-default\" ng-disabled=\"vm.uploading\" ng-click=\"vm.cancel()\">\n    Cancel\n  </a>\n</div>"

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var WebVTTParser = function WebVTTParser() {
  this.parse = function (input, mode) {
    //XXX need global search and replace for \0
    var NEWLINE = /\r\n|\r|\n/,
        startTime = Date.now(),
        linePos = 0,
        lines = input.split(NEWLINE),
        alreadyCollected = false,
        cues = [],
        errors = [];

    function err(message, col) {
      errors.push({
        message: message,
        line: linePos + 1,
        col: col
      });
    }

    var line = lines[linePos],
        lineLength = line.length,
        signature = 'WEBVTT',
        bom = 0,
        signature_length = signature.length;
    /* Byte order mark */

    if (line[0] === "\uFEFF") {
      bom = 1;
      signature_length += 1;
    }
    /* SIGNATURE */


    if (lineLength < signature_length || line.indexOf(signature) !== 0 + bom || lineLength > signature_length && line[signature_length] !== ' ' && line[signature_length] !== '\t') {
      err('No valid signature. (File needs to start with "WEBVTT".)');
    }

    linePos++;
    /* HEADER */

    while (lines[linePos] != '' && lines[linePos] != undefined) {
      err('No blank line after the signature.');

      if (lines[linePos].indexOf('-->') != -1) {
        alreadyCollected = true;
        break;
      }

      linePos++;
    }
    /* CUE LOOP */


    while (lines[linePos] != undefined) {
      var cue;

      while (!alreadyCollected && lines[linePos] == '') {
        linePos++;
      }

      if (!alreadyCollected && lines[linePos] == undefined) break;
      /* CUE CREATION */

      cue = {
        id: '',
        startTime: 0,
        endTime: 0,
        pauseOnExit: false,
        direction: 'horizontal',
        snapToLines: true,
        linePosition: 'auto',
        textPosition: 50,
        size: 100,
        alignment: 'middle',
        text: ''
      };
      var parseTimings = true;

      if (lines[linePos].indexOf('-->') == -1) {
        cue.id = lines[linePos];
        /* COMMENTS
             Not part of the specification's parser as these would just be ignored. However,
             we want them to be conforming and not get "Cue identifier cannot be standalone".
             */

        if (/^NOTE($|[ \t])/.test(cue.id)) {
          // .startsWith fails in Chrome
          linePos++;

          while (lines[linePos] != '' && lines[linePos] != undefined) {
            if (lines[linePos].indexOf('-->') != -1) err('Cannot have timestamp in a comment.');
            linePos++;
          }

          continue;
        }

        linePos++;

        if (lines[linePos] == '' || lines[linePos] == undefined) {
          err('Cue identifier cannot be standalone.');
          continue;
        }

        if (lines[linePos].indexOf('-->') == -1) {
          parseTimings = false;
          err('Cue identifier needs to be followed by timestamp.');
        }
      }
      /* TIMINGS */


      alreadyCollected = false;
      var timings = new WebVTTCueTimingsAndSettingsParser(lines[linePos], err);
      var previousCueStart = 0;

      if (cues.length > 0) {
        previousCueStart = cues[cues.length - 1].startTime;
      }

      if (parseTimings && !timings.parse(cue, previousCueStart)) {
        /* BAD CUE */
        cue = null;
        linePos++;
        /* BAD CUE LOOP */

        while (lines[linePos] != '' && lines[linePos] != undefined) {
          if (lines[linePos].indexOf('-->') != -1) {
            alreadyCollected = true;
            break;
          }

          linePos++;
        }

        continue;
      }

      linePos++;
      /* CUE TEXT LOOP */

      while (lines[linePos] != '' && lines[linePos] != undefined) {
        if (lines[linePos].indexOf('-->') != -1) {
          err('Blank line missing before cue.');
          alreadyCollected = true;
          break;
        }

        if (cue.text != '') cue.text += '\n';
        cue.text += lines[linePos];
        linePos++;
      }
      /* CUE TEXT PROCESSING */


      var cuetextparser = new WebVTTCueTextParser(cue.text, err, mode);
      cuetextparser.parse(cue.startTime, cue.endTime);
      cues.push(cue);
    }

    cues.sort(function (a, b) {
      if (a.startTime < b.startTime) return -1;
      if (a.startTime > b.startTime) return 1;
      if (a.endTime > b.endTime) return -1;
      if (a.endTime < b.endTime) return 1;
      return 0;
    });
    /* END */

    return {
      cues: cues,
      errors: errors,
      time: Date.now() - startTime
    };
  };
};

var WebVTTCueTimingsAndSettingsParser = function WebVTTCueTimingsAndSettingsParser(line, errorHandler) {
  var SPACE = /[\u0020\t\f]/,
      NOSPACE = /[^\u0020\t\f]/,
      line = line,
      pos = 0,
      err = function err(message) {
    errorHandler(message, pos + 1);
  },
      spaceBeforeSetting = true;

  function skip(pattern) {
    while (line[pos] != undefined && pattern.test(line[pos])) {
      pos++;
    }
  }

  function collect(pattern) {
    var str = '';

    while (line[pos] != undefined && pattern.test(line[pos])) {
      str += line[pos];
      pos++;
    }

    return str;
  }
  /* http://dev.w3.org/html5/webvtt/#collect-a-webvtt-timestamp */


  function timestamp() {
    var units = 'minutes',
        val1,
        val2,
        val3,
        val4; // 3

    if (line[pos] == undefined) {
      err('No timestamp found.');
      return;
    } // 4


    if (!/\d/.test(line[pos])) {
      err('Timestamp must start with a character in the range 0-9.');
      return;
    } // 5-7


    val1 = collect(/\d/);

    if (val1.length > 2 || parseInt(val1, 10) > 59) {
      units = 'hours';
    } // 8


    if (line[pos] != ':') {
      err('No time unit separator found.');
      return;
    }

    pos++; // 9-11

    val2 = collect(/\d/);

    if (val2.length != 2) {
      err('Must be exactly two digits.');
      return;
    } // 12


    if (units == 'hours' || line[pos] == ':') {
      if (line[pos] != ':') {
        err('No seconds found or minutes is greater than 59.');
        return;
      }

      pos++;
      val3 = collect(/\d/);

      if (val3.length != 2) {
        err('Must be exactly two digits.');
        return;
      }
    } else {
      val3 = val2;
      val2 = val1;
      val1 = '0';
    } // 13


    if (line[pos] != '.') {
      err('No decimal separator (".") found.');
      return;
    }

    pos++; // 14-16

    val4 = collect(/\d/);

    if (val4.length != 3) {
      err('Milliseconds must be given in three digits.');
      return;
    } // 17


    if (parseInt(val2, 10) > 59) {
      err('You cannot have more than 59 minutes.');
      return;
    }

    if (parseInt(val3, 10) > 59) {
      err('You cannot have more than 59 seconds.');
      return;
    }

    return parseInt(val1, 10) * 60 * 60 + parseInt(val2, 10) * 60 + parseInt(val3, 10) + parseInt(val4, 10) / 1000;
  }
  /* http://dev.w3.org/html5/webvtt/#parse-the-webvtt-settings */


  function parseSettings(input, cue) {
    var settings = input.split(SPACE),
        seen = [];

    for (var i = 0; i < settings.length; i++) {
      if (settings[i] == '') continue;
      var index = settings[i].indexOf(':'),
          setting = settings[i].slice(0, index),
          value = settings[i].slice(index + 1);

      if (seen.indexOf(setting) != -1) {
        err('Duplicate setting.');
      }

      seen.push(setting);

      if (value == '') {
        err('No value for setting defined.');
        return;
      }

      if (setting == 'vertical') {
        // writing direction
        if (value != 'rl' && value != 'lr') {
          err("Writing direction can only be set to 'rl' or 'rl'.");
          continue;
        }

        cue.direction = value;
      } else if (setting == 'line') {
        // line position
        if (!/\d/.test(value)) {
          err('Line position takes a number or percentage.');
          continue;
        }

        if (value.indexOf('-', 1) != -1) {
          err("Line position can only have '-' at the start.");
          continue;
        }

        if (value.indexOf('%') != -1 && value.indexOf('%') != value.length - 1) {
          err("Line position can only have '%' at the end.");
          continue;
        }

        if (value[0] == '-' && value[value.length - 1] == '%') {
          err('Line position cannot be a negative percentage.');
          continue;
        }

        if (value[value.length - 1] == '%') {
          if (parseInt(value, 10) > 100) {
            err('Line position cannot be >100%.');
            continue;
          }

          cue.snapToLines = false;
        }

        cue.linePosition = parseInt(value, 10);
      } else if (setting == 'position') {
        // text position
        if (value[value.length - 1] != '%') {
          err('Text position must be a percentage.');
          continue;
        }

        if (parseInt(value, 10) > 100) {
          err('Size cannot be >100%.');
          continue;
        }

        cue.textPosition = parseInt(value, 10);
      } else if (setting == 'size') {
        // size
        if (value[value.length - 1] != '%') {
          err('Size must be a percentage.');
          continue;
        }

        if (parseInt(value, 10) > 100) {
          err('Size cannot be >100%.');
          continue;
        }

        cue.size = parseInt(value, 10);
      } else if (setting == 'align') {
        // alignment
        var alignValues = ['start', 'middle', 'end', 'left', 'right'];

        if (alignValues.indexOf(value) == -1) {
          err('Alignment can only be set to one of ' + alignValues.join(', ') + '.');
          continue;
        }

        cue.alignment = value;
      } else {
        err('Invalid setting.');
      }
    }
  }

  this.parse = function (cue, previousCueStart) {
    skip(SPACE);
    cue.startTime = timestamp();

    if (cue.startTime == undefined) {
      return;
    }

    if (cue.startTime < previousCueStart) {
      err('Start timestamp is not greater than or equal to start timestamp of previous cue.');
    }

    if (NOSPACE.test(line[pos])) {
      err("Timestamp not separated from '-->' by whitespace.");
    }

    skip(SPACE); // 6-8

    if (line[pos] != '-') {
      err('No valid timestamp separator found.');
      return;
    }

    pos++;

    if (line[pos] != '-') {
      err('No valid timestamp separator found.');
      return;
    }

    pos++;

    if (line[pos] != '>') {
      err('No valid timestamp separator found.');
      return;
    }

    pos++;

    if (NOSPACE.test(line[pos])) {
      err("'-->' not separated from timestamp by whitespace.");
    }

    skip(SPACE);
    cue.endTime = timestamp();

    if (cue.endTime == undefined) {
      return;
    }

    if (cue.endTime <= cue.startTime) {
      err('End timestamp is not greater than start timestamp.');
    }

    if (NOSPACE.test(line[pos])) {
      spaceBeforeSetting = false;
    }

    skip(SPACE);
    parseSettings(line.substring(pos), cue);
    return true;
  };

  this.parseTimestamp = function () {
    var ts = timestamp();

    if (line[pos] != undefined) {
      err('Timestamp must not have trailing characters.');
      return;
    }

    return ts;
  };
};

var WebVTTCueTextParser = function WebVTTCueTextParser(line, errorHandler, mode) {
  var line = line,
      pos = 0,
      err = function err(message) {
    if (mode == 'metadata') return;
    errorHandler(message, pos + 1);
  };

  this.parse = function (cueStart, cueEnd) {
    var result = {
      children: []
    },
        current = result,
        timestamps = [];

    function attach(token) {
      current.children.push({
        type: 'object',
        name: token[1],
        classes: token[2],
        children: [],
        parent: current
      });
      current = current.children[current.children.length - 1];
    }

    function inScope(name) {
      var node = current;

      while (node) {
        if (node.name == name) return true;
        node = node.parent;
      }

      return;
    }

    while (line[pos] != undefined) {
      var token = nextToken();

      if (token[0] == 'text') {
        current.children.push({
          type: 'text',
          value: token[1],
          parent: current
        });
      } else if (token[0] == 'start tag') {
        if (mode == 'chapters') err('Start tags not allowed in chapter title text.');
        var name = token[1];

        if (name != 'v' && name != 'lang' && token[3] != '') {
          err('Only <v> and <lang> can have an annotation.');
        }

        if (name == 'c' || name == 'i' || name == 'b' || name == 'u' || name == 'ruby') {
          attach(token);
        } else if (name == 'rt' && current.name == 'ruby') {
          attach(token);
        } else if (name == 'v') {
          if (inScope('v')) {
            err('<v> cannot be nested inside itself.');
          }

          attach(token);
          current.value = token[3]; // annotation

          if (!token[3]) {
            err('<v> requires an annotation.');
          }
        } else if (name == 'lang') {
          attach(token);
          current.value = token[3]; // language
        } else {
          err('Incorrect start tag.');
        }
      } else if (token[0] == 'end tag') {
        if (mode == 'chapters') err('End tags not allowed in chapter title text.'); // XXX check <ruby> content

        if (token[1] == current.name) {
          current = current.parent;
        } else if (token[1] == 'ruby' && current.name == 'rt') {
          current = current.parent.parent;
        } else {
          err('Incorrect end tag.');
        }
      } else if (token[0] == 'timestamp') {
        if (mode == 'chapters') err('Timestamp not allowed in chapter title text.');
        var timings = new WebVTTCueTimingsAndSettingsParser(token[1], err),
            timestamp = timings.parseTimestamp();

        if (timestamp != undefined) {
          if (timestamp <= cueStart || timestamp >= cueEnd) {
            err('Timestamp must be between start timestamp and end timestamp.');
          }

          if (timestamps.length > 0 && timestamps[timestamps.length - 1] >= timestamp) {
            err('Timestamp must be greater than any previous timestamp.');
          }

          current.children.push({
            type: 'timestamp',
            value: timestamp,
            parent: current
          });
          timestamps.push(timestamp);
        }
      }
    }

    while (current.parent) {
      if (current.name != 'v') {
        err('Required end tag missing.');
      }

      current = current.parent;
    }

    return result;
  };

  function nextToken() {
    var state = 'data',
        result = '',
        buffer = '',
        classes = [];

    while (line[pos - 1] != undefined || pos == 0) {
      var c = line[pos];

      if (state == 'data') {
        if (c == '&') {
          buffer = c;
          state = 'escape';
        } else if (c == '<' && result == '') {
          state = 'tag';
        } else if (c == '<' || c == undefined) {
          return ['text', result];
        } else {
          result += c;
        }
      } else if (state == 'escape') {
        if (c == '&') {
          err('Incorrect escape.');
          result += buffer;
          buffer = c;
        } else if (/[abglmnsprt]/.test(c)) {
          buffer += c;
        } else if (c == ';') {
          if (buffer == '&amp') {
            result += '&';
          } else if (buffer == '&lt') {
            result += '<';
          } else if (buffer == '&gt') {
            result += '>';
          } else if (buffer == '&lrm') {
            result += "\u200E";
          } else if (buffer == '&rlm') {
            result += "\u200F";
          } else if (buffer == '&nbsp') {
            result += "\xA0";
          } else {
            err('Incorrect escape.');
            result += buffer + ';';
          }

          state = 'data';
        } else if (c == '<' || c == undefined) {
          err('Incorrect escape.');
          result += buffer;
          return ['text', result];
        } else {
          err('Incorrect escape.');
          result += buffer + c;
          state = 'data';
        }
      } else if (state == 'tag') {
        if (c == '\t' || c == '\n' || c == '\f' || c == ' ') {
          state = 'start tag annotation';
        } else if (c == '.') {
          state = 'start tag class';
        } else if (c == '/') {
          state = 'end tag';
        } else if (/\d/.test(c)) {
          result = c;
          state = 'timestamp tag';
        } else if (c == '>' || c == undefined) {
          if (c == '>') {
            pos++;
          }

          return ['start tag', '', [], ''];
        } else {
          result = c;
          state = 'start tag';
        }
      } else if (state == 'start tag') {
        if (c == '\t' || c == '\f' || c == ' ') {
          state = 'start tag annotation';
        } else if (c == '\n') {
          buffer = c;
          state = 'start tag annotation';
        } else if (c == '.') {
          state = 'start tag class';
        } else if (c == '>' || c == undefined) {
          if (c == '>') {
            pos++;
          }

          return ['start tag', result, [], ''];
        } else {
          result += c;
        }
      } else if (state == 'start tag class') {
        if (c == '\t' || c == '\f' || c == ' ') {
          classes.push(buffer);
          buffer = '';
          state = 'start tag annotation';
        } else if (c == '\n') {
          classes.push(buffer);
          buffer = c;
          state = 'start tag annotation';
        } else if (c == '.') {
          classes.push(buffer);
          buffer = '';
        } else if (c == '>' || c == undefined) {
          if (c == '>') {
            pos++;
          }

          classes.push(buffer);
          return ['start tag', result, classes, ''];
        } else {
          buffer += c;
        }
      } else if (state == 'start tag annotation') {
        if (c == '>' || c == undefined) {
          if (c == '>') {
            pos++;
          }

          buffer = buffer.split(/[\u0020\t\f\r\n]+/).filter(function (item) {
            if (item) return true;
          }).join(' ');
          return ['start tag', result, classes, buffer];
        } else {
          buffer += c;
        }
      } else if (state == 'end tag') {
        if (c == '>' || c == undefined) {
          if (c == '>') {
            pos++;
          }

          return ['end tag', result];
        } else {
          result += c;
        }
      } else if (state == 'timestamp tag') {
        if (c == '>' || c == undefined) {
          if (c == '>') {
            pos++;
          }

          return ['timestamp', result];
        } else {
          result += c;
        }
      } else {
        err('Never happens.'); // The joke is it might.
      } // 8


      pos++;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (WebVTTParser);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FindTimeZone;
/* harmony export (immutable) */ __webpack_exports__["c"] = JstzToTzInfo;
/* harmony export (immutable) */ __webpack_exports__["b"] = JstzMatchesTzInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jstz__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jstz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jstz__);
// Timezone support needs to map between different systems' naming conventions:
// * Browsers are all different.  JSTZ is a library that helps normalize them into a format that
//   Ruby on Rails also happens to enjoy.
// * The BoxCast API Config returns a list of "TZInfo" formatted values.

function FindTimeZone() {
  var oldIntl = window.Intl;
  var tz = '';

  try {
    window.Intl = undefined;
    tz = __WEBPACK_IMPORTED_MODULE_0_jstz___default.a.determine().name();
  } catch (e) {
    // sometimes (on android) you can't override intl
    tz = __WEBPACK_IMPORTED_MODULE_0_jstz___default.a.determine().name();
  } finally {
    try {
      window.Intl = oldIntl;
    } catch (ee) {}
  }

  return tz;
}
function JstzToTzInfo(jstz) {
  return _.invert(TZ_INFO_TO_JSTZ_MAP)[jstz];
}
function JstzMatchesTzInfo(jstz, tzInfo) {
  return JstzToTzInfo(jstz) == tzInfo;
} // Generated from https://github.com/rails/rails/blob/v4.1.15/activesupport/lib/active_support/values/time_zone.rb#L37

var TZ_INFO_TO_JSTZ_MAP = {
  'International Date Line West': 'Pacific/Midway',
  'Midway Island': 'Pacific/Midway',
  'American Samoa': 'Pacific/Pago_Pago',
  Hawaii: 'Pacific/Honolulu',
  Alaska: 'America/Juneau',
  'Pacific Time (US & Canada)': 'America/Los_Angeles',
  Tijuana: 'America/Tijuana',
  'Mountain Time (US & Canada)': 'America/Denver',
  Arizona: 'America/Phoenix',
  Chihuahua: 'America/Chihuahua',
  Mazatlan: 'America/Mazatlan',
  'Central Time (US & Canada)': 'America/Chicago',
  Saskatchewan: 'America/Regina',
  Guadalajara: 'America/Mexico_City',
  'Mexico City': 'America/Mexico_City',
  Monterrey: 'America/Monterrey',
  'Central America': 'America/Guatemala',
  'Eastern Time (US & Canada)': 'America/New_York',
  'Indiana (East)': 'America/Indiana/Indianapolis',
  Bogota: 'America/Bogota',
  Lima: 'America/Lima',
  Quito: 'America/Lima',
  'Atlantic Time (Canada)': 'America/Halifax',
  Caracas: 'America/Caracas',
  'La Paz': 'America/La_Paz',
  Santiago: 'America/Santiago',
  Newfoundland: 'America/St_Johns',
  Brasilia: 'America/Sao_Paulo',
  'Buenos Aires': 'America/Argentina/Buenos_Aires',
  Montevideo: 'America/Montevideo',
  Georgetown: 'America/Guyana',
  Greenland: 'America/Godthab',
  'Mid-Atlantic': 'Atlantic/South_Georgia',
  Azores: 'Atlantic/Azores',
  'Cape Verde Is.': 'Atlantic/Cape_Verde',
  Dublin: 'Europe/Dublin',
  Edinburgh: 'Europe/London',
  Lisbon: 'Europe/Lisbon',
  London: 'Europe/London',
  Casablanca: 'Africa/Casablanca',
  Monrovia: 'Africa/Monrovia',
  UTC: 'Etc/UTC',
  Belgrade: 'Europe/Belgrade',
  Bratislava: 'Europe/Bratislava',
  Budapest: 'Europe/Budapest',
  Ljubljana: 'Europe/Ljubljana',
  Prague: 'Europe/Prague',
  Sarajevo: 'Europe/Sarajevo',
  Skopje: 'Europe/Skopje',
  Warsaw: 'Europe/Warsaw',
  Zagreb: 'Europe/Zagreb',
  Brussels: 'Europe/Brussels',
  Copenhagen: 'Europe/Copenhagen',
  Madrid: 'Europe/Madrid',
  Paris: 'Europe/Paris',
  Amsterdam: 'Europe/Amsterdam',
  Berlin: 'Europe/Berlin',
  Bern: 'Europe/Berlin',
  Rome: 'Europe/Rome',
  Stockholm: 'Europe/Stockholm',
  Vienna: 'Europe/Vienna',
  'West Central Africa': 'Africa/Algiers',
  Bucharest: 'Europe/Bucharest',
  Cairo: 'Africa/Cairo',
  Helsinki: 'Europe/Helsinki',
  Kyiv: 'Europe/Kiev',
  Riga: 'Europe/Riga',
  Sofia: 'Europe/Sofia',
  Tallinn: 'Europe/Tallinn',
  Vilnius: 'Europe/Vilnius',
  Athens: 'Europe/Athens',
  Istanbul: 'Europe/Istanbul',
  Minsk: 'Europe/Minsk',
  Jerusalem: 'Asia/Jerusalem',
  Harare: 'Africa/Harare',
  Pretoria: 'Africa/Johannesburg',
  Kaliningrad: 'Europe/Kaliningrad',
  Moscow: 'Europe/Moscow',
  'St. Petersburg': 'Europe/Moscow',
  Volgograd: 'Europe/Volgograd',
  Samara: 'Europe/Samara',
  Kuwait: 'Asia/Kuwait',
  Riyadh: 'Asia/Riyadh',
  Nairobi: 'Africa/Nairobi',
  Baghdad: 'Asia/Baghdad',
  Tehran: 'Asia/Tehran',
  'Abu Dhabi': 'Asia/Muscat',
  Muscat: 'Asia/Muscat',
  Baku: 'Asia/Baku',
  Tbilisi: 'Asia/Tbilisi',
  Yerevan: 'Asia/Yerevan',
  Kabul: 'Asia/Kabul',
  Ekaterinburg: 'Asia/Yekaterinburg',
  Islamabad: 'Asia/Karachi',
  Karachi: 'Asia/Karachi',
  Tashkent: 'Asia/Tashkent',
  Chennai: 'Asia/Kolkata',
  Kolkata: 'Asia/Kolkata',
  Mumbai: 'Asia/Kolkata',
  'New Delhi': 'Asia/Kolkata',
  Kathmandu: 'Asia/Kathmandu',
  Astana: 'Asia/Dhaka',
  Dhaka: 'Asia/Dhaka',
  'Sri Jayawardenepura': 'Asia/Colombo',
  Almaty: 'Asia/Almaty',
  Novosibirsk: 'Asia/Novosibirsk',
  Rangoon: 'Asia/Rangoon',
  Bangkok: 'Asia/Bangkok',
  Hanoi: 'Asia/Bangkok',
  Jakarta: 'Asia/Jakarta',
  Krasnoyarsk: 'Asia/Krasnoyarsk',
  Beijing: 'Asia/Shanghai',
  Chongqing: 'Asia/Chongqing',
  'Hong Kong': 'Asia/Hong_Kong',
  Urumqi: 'Asia/Urumqi',
  'Kuala Lumpur': 'Asia/Kuala_Lumpur',
  Singapore: 'Asia/Singapore',
  Taipei: 'Asia/Taipei',
  Perth: 'Australia/Perth',
  Irkutsk: 'Asia/Irkutsk',
  Ulaanbaatar: 'Asia/Ulaanbaatar',
  Seoul: 'Asia/Seoul',
  Osaka: 'Asia/Tokyo',
  Sapporo: 'Asia/Tokyo',
  Tokyo: 'Asia/Tokyo',
  Yakutsk: 'Asia/Yakutsk',
  Darwin: 'Australia/Darwin',
  Adelaide: 'Australia/Adelaide',
  Canberra: 'Australia/Melbourne',
  Melbourne: 'Australia/Melbourne',
  Sydney: 'Australia/Sydney',
  Brisbane: 'Australia/Brisbane',
  Hobart: 'Australia/Hobart',
  Vladivostok: 'Asia/Vladivostok',
  Guam: 'Pacific/Guam',
  'Port Moresby': 'Pacific/Port_Moresby',
  Magadan: 'Asia/Magadan',
  Srednekolymsk: 'Asia/Srednekolymsk',
  'Solomon Is.': 'Pacific/Guadalcanal',
  'New Caledonia': 'Pacific/Noumea',
  Fiji: 'Pacific/Fiji',
  Kamchatka: 'Asia/Kamchatka',
  'Marshall Is.': 'Pacific/Majuro',
  Auckland: 'Pacific/Auckland',
  Wellington: 'Pacific/Auckland',
  "Nuku'alofa": 'Pacific/Tongatapu',
  'Tokelau Is.': 'Pacific/Fakaofo',
  'Chatham Is.': 'Pacific/Chatham',
  Samoa: 'Pacific/Apia'
};

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CaptureOrEditHighlightController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_error__ = __webpack_require__(17);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var CaptureOrEditHighlightController = /*#__PURE__*/function () {
  function CaptureOrEditHighlightController($location, $state, $scope, $uibModalInstance, Broadcast, Recording, Highlight, $q, $rootScope, $timeout, $uibModal, toaster, ConfirmDialog, highlightObj, recordingId) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, CaptureOrEditHighlightController);

    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$uibModal = $uibModal;
    this.toaster = toaster;
    this.ConfirmDialog = ConfirmDialog;
    this.Highlight = Highlight;
    this.queryParams = $location.search();
    this.limits = $rootScope.ApiConfig.modelFieldLimits('highlight', 'maximum');

    this.cancel = function () {
      // XXX: if this modal is being loaded from the highlights page with a ?capture or ?edit
      // query param supplied, that means we arrived here from the vue highlights page, and we're 
      // only using the capture modal, so redirect back to the vue broadcast details on-cancel.
      if (_this.handleVueRedirect()) return false;
      $uibModalInstance.dismiss('cancel');
      return true;
    };

    this.maxMonetizedHighlightTimeS = MAX_MONETIZED_HIGHLIGHT_TIME_S;
    this.broadcastIsMonetized = false;
    this.broadcast = Broadcast.get({
      id: $state.params.id
    }, function (b) {
      _this.broadcastIsMonetized = !b.is_private && b.is_ticketed;
    });
    this.recording = Recording.get({
      id: recordingId
    }); // Highlight is passed via modal `resolve`

    if (highlightObj) {
      this.title = "Edit ".concat(highlightObj.name);
      this.highlight = Highlight.get({
        id: highlightObj.id,
        broadcastId: $state.params.id
      }, function () {
        if (_this.highlight.start_segment !== '') {
          _this.startSegment = _this.highlight.start_segment;
          _this.stopSegment = _this.highlight.stop_segment;
        } else if (_this.highlight.start_seconds !== '') {
          _this.startSeconds = _this.highlight.start_seconds;
          _this.stopSeconds = _this.highlight.stop_seconds;
        }
      });
    } else {
      this.title = 'Capture New Highlight';
      this.highlight = {
        name: '',
        description: '',
        start_segment: '',
        stop_segment: '',
        start_seconds: 0,
        stop_seconds: 0
      };
    }

    this.startSeconds = 0;
    this.stopSeconds = 0;

    this.onChangeBounds = function (startSeconds, stopSeconds) {
      _this.startSeconds = startSeconds;
      _this.stopSeconds = stopSeconds;
      _this.duration = stopSeconds - startSeconds;
    };

    this.loadingPromises = [this.broadcast.$promise, this.recording.$promise, this.highlight.$promise];
  }

  _createClass(CaptureOrEditHighlightController, [{
    key: "handleVueRedirect",
    value: function handleVueRedirect() {
      var $state = this.$state;

      if (this.queryParams.capture || this.queryParams.edit) {
        window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/broadcasts/").concat($state.params.id, "/highlights"));
        return true;
      }

      return false;
    }
  }, {
    key: "showPreviewModal",
    value: function showPreviewModal() {
      var _this2 = this;

      var $uibModal = this.$uibModal,
          $timeout = this.$timeout;
      $uibModal.open({
        template: __webpack_require__(189),
        controller: function controller($scope, $uibModalInstance) {
          'ngInject';

          $scope.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };

          $scope.title = 'Preview Highlight Clip';
          $scope.broadcast = _this2.broadcast;
          $scope.options = {
            autostart: true,
            // TODO: ticketId = admin_token?
            //ticketId: BROADCAST_TICKET,
            trimSeconds: {
              start: _this2.startSeconds,
              stop: _this2.stopSeconds
            }
          };
        }
      });
    }
  }, {
    key: "delete",
    value: function _delete() {
      var _this3 = this;

      var Highlight = this.Highlight,
          ConfirmDialog = this.ConfirmDialog,
          $state = this.$state;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Delete Highlight',
        actionButtonClass: 'danger',
        headerText: 'Please Confirm',
        bodyText: 'Are you sure you want to permanently delete this highlight?'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        Highlight["delete"]({
          id: _this3.highlight.id,
          broadcastId: _this3.broadcast.id
        }, function () {
          _this3.toaster.pop('warning', 'Successfully deleted highlight'); // XXX: cancel() will return false on a redirect to vue, so only change
          // the angular state if we are _not_ redirecting.


          if (_this3.cancel()) {
            _this3.$state.go('events.highlights', {
              id: _this3.broadcast.id,
              recording: _this3.recording.id
            }, {
              reload: true
            });
          }
        }, function () {
          return alert('Error deleting highlight. Please reload this page and try again.');
        });
      });
    }
  }, {
    key: "saveChanges",
    value: function saveChanges() {
      var _this4 = this;

      this.isSaving = true;
      var startSeconds = this.startSeconds;
      var stopSeconds = this.stopSeconds;
      var promise;

      if (this.highlight.id) {
        promise = this.Highlight.update({
          broadcastId: this.broadcast.id,
          id: this.highlight.id
        }, {
          name: this.highlight.name,
          description: this.highlight.description,
          start_segment: '',
          stop_segment: '',
          start_seconds: startSeconds,
          stop_seconds: stopSeconds
        }).$promise;
      } else {
        promise = this.Highlight.create({
          broadcastId: this.broadcast.id
        }, {
          name: this.highlight.name,
          description: this.highlight.description,
          start_segment: '',
          stop_segment: '',
          start_seconds: startSeconds,
          stop_seconds: stopSeconds
        }).$promise;
      }

      promise.then(function () {
        _this4.isSaving = false;

        _this4.toaster.pop('success', 'Successfully created highlight'); // XXX: cancel() will return false on a redirect to vue, so only change
        // the angular state if we are _not_ redirecting.


        if (_this4.cancel()) {
          _this4.$state.go('events.highlights', {
            id: _this4.broadcast.id,
            recording: _this4.recording.id
          }, {
            reload: true
          });
        }
      })["catch"](function (error) {
        console.error(error);
        _this4.isSaving = false;
        var errorDetails = Object(__WEBPACK_IMPORTED_MODULE_0__utils_error__["a" /* errorDescriptionFromResponse */])(error);

        _this4.toaster.pop('warning', 'Unable to create highlight', errorDetails);
      });
    }
  }]);

  return CaptureOrEditHighlightController;
}();



/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">{{title}}</h3>\n</div>\n<div class=\"modal-body\">\n  <div id=\"trim-preview-placeholder\"></div>\n  <div ng-if=\"broadcast.channel_id\">\n    <boxcast-player channel-id=\"broadcast.channel_id\" options=\"options\"></boxcast-player>\n  </div>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Close</button>\n    <button ng-if=\"showSave\" class=\"btn btn-primary\" type=\"button\" ng-click=\"save()\">Save</button>\n</div>\n"

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HighlightPreviewController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_embed__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_allow_social__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_broadcast__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_download_or_export_highlight__ = __webpack_require__(192);




function HighlightPreviewController(
/* injected via normal angular DI */
$uibModal, $uibModalInstance, Highlight, ConfirmDialog, toaster, $rootScope, $timeout,
/* injected via `resolve` arguments to modal */
broadcast, highlightDetails, showSave) {
  'ngInject';

  var _this = this;

  this.FeatureFlags = $rootScope.account.feature_flags;
  this.Highlight = Highlight;
  this.ConfirmDialog = ConfirmDialog;
  this.toaster = toaster;
  this.highlight = highlightDetails;
  this.mediaTokenRestrictions = $rootScope.account.extra_features.media_token_restrictions;
  this.broadcast = broadcast;
  this.broadcastIsMonetized = !broadcast.is_private && broadcast.is_ticketed;
  this.highlightCanBeShared = !this.mediaTokenRestrictions && (!this.broadcastIsMonetized || this.highlight.duration <= MAX_MONETIZED_HIGHLIGHT_TIME_S);
  this.showSave = showSave;
  this.showPlayer = true;
  this.showEmbed = false;
  this.embedCode = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].highlightClipEmbed(this.highlight.id, {});
  this.showSocialShare = this.highlightCanBeShared && Object(__WEBPACK_IMPORTED_MODULE_1__utils_allow_social__["a" /* AllowSocial */])(this.FeatureFlags, $rootScope.account, this.broadcast);
  this.limits = $rootScope.ApiConfig.modelFieldLimits('highlight', 'maximum');

  if (highlightDetails.id) {
    this.channelId = highlightDetails.id;
    this.mode = 'highlight';
    this.options = {
      autoplay: true,
      showSocialShare: this.showSocialShare,
      selectedBroadcastId: broadcast.id,
      ticketId: broadcast.admin_token
    };
  } else {
    this.channelId = broadcast.channel_id;
    this.mode = 'channel';
    this.options = {
      autoplay: true,
      showSocialShare: false,
      //disable built-in sharing bc we're faking the highlight
      trimSeconds: {
        start: highlightDetails.start_seconds,
        stop: highlightDetails.stop_seconds
      },
      ticketId: broadcast.admin_token
    };
  }

  this.save = function () {
    return $uibModalInstance.close({
      name: _this.highlight.name,
      start_seconds: _this.options.trimSeconds.start,
      stop_seconds: _this.options.trimSeconds.stop
    });
  };

  this.cancel = function () {
    return $uibModalInstance.dismiss('cancel');
  };

  this.link = "".concat(BOXCAST_TV_HIGHLIGHT_URL).concat(this.broadcast.channel_id, "/").concat(this.broadcast.id, "/").concat(this.highlight.id);
  var broadcastAbbrev = broadcast.name || '';

  if (broadcastAbbrev.length > 15) {
    broadcastAbbrev = broadcastAbbrev.substring(0, 12) + '...';
  }

  var description = highlightDetails.description || "Highlight from ".concat(broadcastAbbrev);

  this.tweet = function () {
    var url = escape(_this.link);
    var text = escape("Watch ".concat(highlightDetails.name, " (").concat(description, ") at "));
    window.open('http://twitter.com/share?url=' + url + '&text=' + text, 'Promote on Twitter', 'dependent=1,height=400,width=600,resizable=1');
  };

  this.facebook = function () {
    // Use the graph API directly since we don't have proper opengraph
    // headers on our show page.
    // https://developers.facebook.com/docs/graph-api/reference/v2.4/post
    var previewImg = highlightDetails.preview;

    if (!previewImg) {
      previewImg = "".concat(IMG_ROOT, "boxcast_social_play_square.png");
    }

    FB.ui({
      method: 'share',
      href: _this.link,
      title: highlightDetails.name,
      name: highlightDetails.name,
      description: description,
      picture: Object(__WEBPACK_IMPORTED_MODULE_2__utils_broadcast__["a" /* ensureHttpOnProtocolRelativeUrl */])(previewImg),
      caption: 'BoxCast :: a smarter way to stream',
      type: 'video',
      display: 'popup'
    }, function (response) {});
  };

  this.nudge = function (side, offset) {
    var seconds = Math.max(_this.options.trimSeconds[side] + offset, 0); // Need to leave at least a 1-second gap so the bounds are valid.

    if (side === 'stop') {
      seconds = Math.max(seconds, _this.options.trimSeconds['start'] + 1);
    } else if (side === 'start') {
      seconds = Math.min(seconds, _this.options.trimSeconds['stop'] - 1);
    }

    _this.options.trimSeconds[side] = seconds;
    _this.showPlayer = false;
    $timeout(function () {
      return _this.showPlayer = true;
    }, 10);
  };

  this["delete"] = function () {
    var Highlight = _this.Highlight,
        ConfirmDialog = _this.ConfirmDialog;
    var modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Delete Highlight',
      actionButtonClass: 'danger',
      headerText: 'Please Confirm',
      bodyText: 'Are you sure you want to permanently delete this highlight?'
    };
    ConfirmDialog.show(modalOptions).then(function () {
      Highlight["delete"]({
        id: _this.highlight.id,
        broadcastId: _this.broadcast.id
      }, function () {
        _this.toaster.pop('warning', 'Successfully deleted highlight');

        _this.cancel();
      }, function () {
        return alert('Error deleting highlight. Please reload this page and try again.');
      });
    });
  };

  this.download = function () {
    $uibModal.open({
      template: __webpack_require__(193),
      controllerAs: 'vm',
      controller: __WEBPACK_IMPORTED_MODULE_3__modal_download_or_export_highlight__["a" /* default */],
      resolve: {
        broadcast: function broadcast() {
          return _this.broadcast;
        },
        highlight: function highlight() {
          return _this.highlight;
        }
      }
    });
  };
}

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export broadcastListToCSVString */
/* harmony export (immutable) */ __webpack_exports__["a"] = ensureHttpOnProtocolRelativeUrl;
function e(input) {
  // shortcut to escape the input string for csv encoding
  if (input === true) {
    return 'Y';
  }

  if (input === false) {
    return 'N';
  }

  if (input === null || input === undefined) {
    return '';
  }

  if (typeof input.indexOf == 'function') {
    if (input.indexOf('"') >= 0) {
      input = input.replace(/"/g, '""');
    }

    if (input.search(/("|,|\n)/g) >= 0) {
      input = '"' + input + '"';
    }
  }

  return input;
} // searialize the list of broadcasts as a CSV string


function broadcastListToCSVString(broadcasts) {
  var csvContent = 'Name,Channel,Start,Stop,Private,Ticketed,Flex,Ticket Price,BoxCaster,Total Views,Total Minutes Viewed\n';
  broadcasts.forEach(function (b, index) {
    var dataString = [e(b.name), e(b.channel_id), e(b.starts_at), e(b.stops_at), e(b.is_private), e(b.is_ticketed), e(b.is_ticketed && b.free_variant != 'none'), e(b.ticket_price), e(b.boxcaster_name), e(b.total_view_count), e(b.total_minutes_viewed)].join(',');
    csvContent += index < broadcasts.length ? dataString + '\n' : dataString;
  });
  return csvContent;
} // if a url is passed as a protocol-relative url (e.g. "//uploads.boxcast.com/foo.jpg"), make
// sure to preprend a protocol. this is required for some 3rd party application integrations.

function ensureHttpOnProtocolRelativeUrl(url) {
  if (url.startsWith('//')) {
    url = 'http:' + url;
  }

  return url;
}

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DownloadOrExportHighlightController;
function DownloadOrExportHighlightController($uibModalInstance, $scope, $timeout, $rootScope, toaster, Highlight, VimeoUser, YouTubeUser, $analytics, broadcast, highlight) {
  'ngInject';

  var _this = this;

  this.hasVideo = broadcast.transcoder_profile !== 'audio';
  this.activeTab = this.hasVideo ? 'mp4' : 'm4a';
  this.unlock = {};
  this.allowKaltura = false;
  this.allowYoutube = false;
  this.allowVimeo = false;
  this.youtubeUsers = [];
  this.youtubeUserId = null;
  this.youtubeLicense = 'youtube';
  this.youtubePrivacy = 'private';
  this.vimeoUsers = [];
  this.vimeoUserId = null;
  this.allowKaltura = $rootScope.account.extra_features.kaltura;
  this.allowYoutube = !!$rootScope.account.feature_flags.youtube_export;
  this.allowVimeo = !!$rootScope.account.feature_flags.vimeo_export;

  if (this.allowYoutube) {
    this.youtubeUsers = YouTubeUser.query({
      l: 1000
    });
    this.youtubeUsers.$promise.then(function () {
      _this.youtubeUserId = (_.first(_this.youtubeUsers) || {}).id;
    });
  }

  if (this.allowVimeo) {
    this.vimeoUsers = VimeoUser.query({
      l: 1000
    });
    this.vimeoUsers.$promise.then(function () {
      _this.vimeoUserId = (_.first(_this.vimeoUsers) || {}).id;
    });
  }

  this.recording = {};
  this.$reloadRecordingTimeout = null;

  this.reloadRecording = function () {
    $timeout.cancel(_this.$reloadRecordingTimeout);
    Highlight.get({
      broadcastId: broadcast.id,
      id: highlight.id
    }, function (recording) {
      // On completion of an export, make sure we re-lock
      _.each(['kaltura', 'vimeo', 'youtube'], function (e) {
        if (_this.recording["".concat(e, "_export_status")] !== 'ready' && recording["".concat(e, "_export_status")] == 'ready') {
          delete _this.unlock[e];
        }
      });

      _this.recording = recording;
      _this.$reloadRecordingTimeout = $timeout(_this.reloadRecording, 5000);
    }, function (error) {
      console.error(error);
      toaster.pop('warning', 'Unable to fetch highlight. Please try again.');

      _this.cancel();
    });
  };

  this.reloadRecording();
  $scope.$on('$destroy', function () {
    return $timeout.cancel(_this.$reloadRecordingTimeout);
  });

  this.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  this.canStart = function () {
    var processingStatuses = ['requesting', 'requested', 'awaiting_conversion'];

    var mp4DownloadInFlight = function mp4DownloadInFlight() {
      return _.contains(processingStatuses, _this.recording.download_status) || _.startsWith(_this.recording.download_status, 'processing:');
    };

    var m4aDownloadInFlight = function m4aDownloadInFlight() {
      return _.contains(processingStatuses, _this.recording.audio_download_status) || _.startsWith(_this.recording.audio_download_status, 'processing:');
    };

    var kalturaExportInFlight = function kalturaExportInFlight() {
      return _.contains(processingStatuses, _this.recording.kaltura_export_status) || _.startsWith(_this.recording.kaltura_export_status, 'processing:');
    };

    var vimeoExportInFlight = function vimeoExportInFlight() {
      return _.contains(processingStatuses, _this.recording.vimeo_export_status) || _.startsWith(_this.recording.vimeo_export_status, 'processing:');
    };

    var youtubeExportInFlight = function youtubeExportInFlight() {
      return _.contains(processingStatuses, _this.recording.youtube_export_status) || _.startsWith(_this.recording.youtube_export_status, 'processing:');
    };

    var exportInFlight = function exportInFlight() {
      return kalturaExportInFlight() || vimeoExportInFlight() || youtubeExportInFlight();
    };

    if (_this.activeTab === 'mp4') {
      return (!_this.recording.download_url || _this.recording.download_status == 'expired') && !mp4DownloadInFlight() && !exportInFlight();
    } else if (_this.activeTab === 'm4a') {
      return (!_this.recording.audio_download_url || _this.recording.audio_download_status == 'expired') && !m4aDownloadInFlight();
    } else if (_this.activeTab === 'kaltura') {
      return !mp4DownloadInFlight() && !kalturaExportInFlight();
    } else if (_this.activeTab === 'vimeo') {
      return !mp4DownloadInFlight() && !vimeoExportInFlight();
    } else if (_this.activeTab === 'youtube') {
      return !mp4DownloadInFlight() && !youtubeExportInFlight();
    }
  };

  this.changeTab = function (tabId) {
    _this.activeTab = tabId;
    _this.unlock = {};
  };

  this.start = function () {
    // the debounce in angular is dubious; just double-check here that we can start, and get out if we can't.
    if (!_this.canStart()) return;

    if (_this.activeTab === 'mp4') {
      _this.recording.download_status = 'requesting';
      Highlight.prepareDownload({
        id: highlight.id
      }, function (response) {
        _this.recording.download_status = 'requested';
        console.log('Submitted request to download mp4...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.download_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to prepare mp4 download. Please try again.');
        $analytics.eventTrack('highlight-download', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'm4a') {
      _this.recording.audio_download_status = 'requesting';
      Highlight.prepareDownload({
        id: highlight.id,
        audio_only: true
      }, function (response) {
        _this.recording.audio_download_status = 'requested';
        console.log('Submitted request to m4a download...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.audio_download_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to prepare m4a download. Please try again.');
        $analytics.eventTrack('highlight-download-audio', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'kaltura') {
      _this.recording.kaltura_export_status = 'requesting';
      Highlight.startKalturaExport({
        id: highlight.id
      }, function (response) {
        _this.recording.kaltura_export_status = 'requested';
        console.log('Submitted request to export to kaltura...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.kaltura_export_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to export video. Please try again.');
        $analytics.eventTrack('highlight-kaltura-export', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'vimeo') {
      // This isn't documented, but Vimeo limits the name to 128 characters (PLATFORM-6277)
      var videoInfo = {
        name: highlight.name.substr(0, 128),
        description: highlight.description
      };
      _this.recording.vimeo_export_status = 'requesting';
      Highlight.startVimeoExport({
        id: highlight.id,
        vimeo_user_id: _this.vimeoUserId,
        video_info: videoInfo
      }, function (response) {
        _this.recording.vimeo_export_status = 'requested';
        console.log('Submitted request to export to vimeo...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.vimeo_export_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to export video. Please try again.');
        $analytics.eventTrack('highlight-vimeo-export', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'youtube') {
      // https://developers.google.com/youtube/v3/docs/videos
      //
      // title (string): The video's title. The property value has a maximum length of 100 characters
      // and may contain all valid UTF-8 characters except < and >.
      //
      // description (string): The video's description. The property value has a maximum length of
      // 5000 bytes and may contain all valid UTF-8 characters except < and >.
      var _videoInfo = {
        snippet: {
          title: highlight.name.replace(/</g, '[').replace(/>/g, ']').substr(0, 100),
          description: highlight.description.replace(/</g, '[').replace(/>/g, ']').substr(0, 5000)
        },
        status: {
          privacyStatus: _this.youtubePrivacy,
          license: _this.youtubeLicense
        }
      };
      _this.recording.youtube_export_status = 'requesting';
      Highlight.startYoutubeExport({
        id: highlight.id,
        youtube_user_id: _this.youtubeUserId,
        video_info: _videoInfo
      }, function (response) {
        _this.recording.youtube_export_status = 'requested';
        console.log('Submitted request to export to youtube...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.youtube_export_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to export video. Please try again.');
        $analytics.eventTrack('highlight-youtube-export', {
          category: 'error'
        });
      });
    }
  };

  this.status = function () {
    var s = null;

    if (_this.activeTab === 'mp4') {
      s = _this.recording.download_status;
    } else if (_this.activeTab === 'm4a') {
      s = _this.recording.audio_download_status;
    } else if (_this.activeTab === 'kaltura') {
      s = _this.recording.kaltura_export_status;
    } else if (_this.activeTab === 'vimeo') {
      s = _this.recording.vimeo_export_status;
    } else if (_this.activeTab === 'youtube') {
      s = _this.recording.youtube_export_status;
    }

    if (_.startsWith(s, 'processing:')) {
      s = 'processing';
    }

    return s;
  };

  this.statusPercent = function () {
    var p = 0;

    if (_this.activeTab === 'mp4' || _this.activeTab === 'm4a') {
      var s = null;

      if (_this.activeTab === 'mp4') {
        s = _this.recording.download_status;
      } else if (_this.activeTab === 'm4a') {
        s = _this.recording.audio_download_status;
      }

      if (s === 'ready') {
        p = 100;
      } else if (_.startsWith(s, 'processing:')) {
        p = parseInt(s.replace('processing:', ''), 10) || 0;
      }
    } else {
      // Compensate for fact that download-preparation is only first half of the battle.
      // Now that we have an MP4 in S3, we need to get it over to the social provider.
      var _s = null;

      if (_this.activeTab === 'kaltura') {
        _s = _this.recording.kaltura_export_status;
      } else if (_this.activeTab === 'vimeo') {
        _s = _this.recording.vimeo_export_status;
      } else if (_this.activeTab === 'youtube') {
        _s = _this.recording.youtube_export_status;
      }

      if (_s === 'ready') {
        p = 100;
      } else if (_.contains(['awaiting_conversion', 'requested'], _s)) {
        if (_this.recording.download_status === 'ready') {
          p = 50;
        } else if (_.startsWith(_this.recording.download_status, 'processing:')) {
          p = Math.round((parseInt(_this.recording.download_status.replace('processing:', ''), 10) || 0) / 2);
        }
      } else if (_.startsWith(_s, 'processing:')) {
        p = 50 + Math.round((parseInt(_s.replace('processing:', ''), 10) || 0) / 2);
      }
    }

    return p;
  };
}

/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\" style=\"border-bottom:0;padding-bottom:0;\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n\n  <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n    <li ng-class=\"vm.activeTab == 'mp4' ? 'active' : ''\" ng-if=\"vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('mp4')\">Download</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'youtube' ? 'active' : ''\" ng-if=\"vm.allowYoutube && vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('youtube')\">YouTube</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'vimeo' ? 'active' : ''\" ng-if=\"vm.allowVimeo && vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('vimeo')\">Vimeo</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'kaltura' ? 'active' : ''\" ng-if=\"vm.allowKaltura && vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('kaltura')\">Kaltura</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'm4a' ? 'active' : ''\">\n      <a href ng-click=\"vm.changeTab('m4a')\">Audio</a>\n    </li>\n  </ol>\n\n</div>\n<div class=\"modal-body\" style=\"padding-top:0\" ng-show=\"vm.recording.id\">\n\n  <!-- download mp4 -->\n  <div ng-if=\"vm.activeTab == 'mp4'\">\n    <p class=\"help-block\">\n      <small>\n        Highlights can be downloaded in MP4 (video+audio) format. This process can take a few minutes while we convert your highlight to the proper format.\n      </small>\n    </p>\n    <div class=\"form-group text-center\">\n      <button class=\"btn btn-default\"\n        ng-hide=\"vm.recording.download_url && vm.status() != 'expired'\"\n        ng-disabled=\"!vm.canStart()\"\n        ng-click=\"vm.start()\">\n        <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n        Generate Download\n      </button>\n      <a class=\"btn btn-success\"\n        download\n        ng-show=\"vm.recording.download_url && vm.status() != 'expired'\"\n        ng-href=\"{{vm.recording.download_url}}\">\n        <i class=\"fa fa-download\"></i>\n        Download Video\n      </a>\n      <button type=\"button\" class=\"btn btn-link\"\n        ng-if=\"clipboard.supported\"\n        ng-show=\"vm.recording.download_url && vm.status() != 'expired'\"\n        clipboard\n        text=\"vm.recording.download_url\"\n        on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n        on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n        uib-tooltip=\"Copy the MP4 link to your clipboard\" tooltip-placement=\"bottom\">\n        <i class=\"fa fa-copy\" style=\"width:20px\"></i>\n        Copy Video Link\n      </button>\n    </div>\n  </div>\n\n  <!-- download m4a -->\n  <div ng-if=\"vm.activeTab == 'm4a'\">\n    <p class=\"help-block\">\n      <small>\n        Highlights can be downloaded in M4A (audio-only) format. This process can take a few minutes while we convert your highlight to the proper format.\n      </small>\n    </p>\n    <div class=\"form-group text-center\">\n      <button class=\"btn btn-default\"\n        ng-hide=\"vm.recording.audio_download_url && vm.status() != 'expired'\"\n        ng-disabled=\"!vm.canStart()\"\n        ng-click=\"vm.start()\">\n        <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n        Generate Download\n      </button>\n      <a class=\"btn btn-success\"\n        download\n        ng-show=\"vm.recording.audio_download_url && vm.status() != 'expired'\"\n        ng-href=\"{{vm.recording.audio_download_url}}\">\n        <i class=\"fa fa-download\"></i>\n        Download Audio\n      </a>\n      <button type=\"button\" class=\"btn btn-link\"\n        ng-if=\"clipboard.supported\"\n        ng-show=\"vm.recording.audio_download_url && vm.status() != 'expired'\"\n        clipboard\n        text=\"vm.recording.audio_download_url\"\n        on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n        on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n        uib-tooltip=\"Copy the M4A link to your clipboard\" tooltip-placement=\"bottom\">\n        <i class=\"fa fa-copy\" style=\"width:20px\"></i>\n        Copy Audio Link\n      </button>\n    </div>\n  </div>\n\n  <!-- youtube -->\n  <div ng-if=\"vm.activeTab == 'youtube'\">\n    <p class=\"help-block\">\n      <small>\n        Highlights can be exported to YouTube. This process can take a few minutes while we convert your highlight\n        to the proper format and then send it to YouTube.\n      </small>\n    </p>\n    <div ng-hide=\"vm.youtubeUsers.length\">\n      <p>\n        There are no linked YouTube accounts.\n        Please <a ui-sref=\"settings.youtube\" ng-click=\"vm.cancel()\">link your YouTube account</a> before attempting to export.\n      </p>\n    </div>\n    <div ng-show=\"vm.youtubeUsers.length && (vm.recording.youtube_export_status != 'ready' || vm.unlock.youtube)\">\n      <div class=\"form-group\">\n        <label for=\"youtube_user\">Export As User</label>\n        <select class=\"form-control\" id=\"youtube_user\" ng-model=\"vm.youtubeUserId\" ng-disabled=\"!vm.canStart()\" required>\n          <option ng-repeat=\"u in vm.youtubeUsers\" value=\"{{u.id}}\">{{u.display_name}}</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"youtube_license\">License</label>\n        <select class=\"form-control\" id=\"youtube_license\" ng-model=\"vm.youtubeLicense\" ng-disabled=\"!vm.canStart()\" required>\n          <option value=\"youtube\" ng-selected=\"true\">YouTube</option>\n          <option value=\"creativeCommon\">Creative Commons</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"youtube_privacy\">Privacy Status</label>\n        <select class=\"form-control\" id=\"youtube_privacy\" ng-model=\"vm.youtubePrivacy\" ng-disabled=\"!vm.canStart()\" required>\n          <option value=\"private\" ng-selected=\"true\">private</option>\n          <option value=\"public\">public</option>\n          <option value=\"unlisted\">unlisted</option>\n        </select>\n      </div>\n      <div class=\"form-group text-center\">\n        <button class=\"btn btn-default overflow-ellipse\"\n          ng-disabled=\"!vm.canStart()\"\n          ng-click=\"vm.start()\"\n          analytics-on analytics-event=\"event-edit\" analytics-category=\"youtube-export\" analytics-label=\"\">\n          <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n          <i class=\"fa fa-youtube-play\" style=\"width:20px\"></i>\n          Export To YouTube\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <!-- vimeo -->\n  <div ng-if=\"vm.activeTab == 'vimeo'\">\n    <p class=\"help-block\">\n      <small>\n        Highlights can be exported to Vimeo. This process can take a few minutes while we convert your highlight\n        to the proper format and then send it to Vimeo.\n      </small>\n    </p>\n    <div ng-hide=\"vm.vimeoUsers.length\">\n      <p>\n        There are no linked Vimeo accounts.\n        Please <a ui-sref=\"settings.vimeo\" ng-click=\"vm.cancel()\">link your Vimeo account</a> before attempting to export.\n      </p>\n    </div>\n    <div ng-show=\"vm.vimeoUsers.length && (vm.recording.vimeo_export_status != 'ready' || vm.unlock.vimeo)\">\n      <div class=\"form-group\">\n        <label for=\"vimeo_user\">Export As User</label>\n        <select class=\"form-control\" id=\"vimeo_user\" ng-model=\"vm.vimeoUserId\" ng-disabled=\"!vm.canStart()\" required>\n          <option ng-repeat=\"u in vm.vimeoUsers\" value=\"{{u.id}}\">{{u.display_name}}</option>\n        </select>\n      </div>\n      <div class=\"form-group text-center\">\n        <button class=\"btn btn-default overflow-ellipse\"\n          ng-disabled=\"!vm.canStart()\"\n          ng-click=\"vm.start()\"\n          analytics-on analytics-event=\"event-edit\" analytics-category=\"vimeo-export\" analytics-label=\"\">\n          <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n          <i class=\"fa fa-vimeo\" style=\"width:20px\"></i>\n          Export To Vimeo\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <!-- kaltura -->\n  <div ng-if=\"vm.activeTab == 'kaltura'\">\n    <p class=\"help-block\">\n      <small>\n        Highlights can be exported to Kaltura. This process can take a few minutes while we convert your highlight\n        to the proper format and then send it to Kaltura.\n      </small>\n    </p>\n    <div class=\"form-group text-center\" ng-show=\"(vm.recording.kaltura_export_status != 'ready' || vm.unlock.kaltura)\">\n      <button class=\"btn btn-default overflow-ellipse\"\n        ng-disabled=\"!vm.canStart()\"\n        ng-click=\"vm.start()\"\n        analytics-on analytics-event=\"event-edit\" analytics-category=\"kaltura-export\" analytics-label=\"\">\n        <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n        Export To Kaltura\n      </button>\n    </div>\n  </div>\n\n  <!-- status messaging -->\n  <div ng-switch=\"vm.status()\">\n    <div ng-switch-when=\"expired|unprocessed\" ng-switch-when-separator=\"|\">\n      <!-- nobody has requested this yet, or the previous one expired -->\n    </div>\n    <div ng-switch-when=\"requesting\">\n      <p class=\"text-center\">\n        <em>Loading...</em>\n      </p>\n    </div>\n    <div ng-switch-when=\"awaiting_conversion|processing|requested\" ng-switch-when-separator=\"|\">\n      <p class=\"text-center\">\n        Your request is processing. Feel free to close this window and come back later.\n      </p>\n      <uib-progressbar value=\"vm.statusPercent()\" max=\"100\">\n        {{vm.statusPercent()}}% Complete\n      </uib-progressbar>\n      <p class=\"text-center\">\n        <em><random-waiting-message interval=\"5000\"></random-waiting-message></em>\n      </p>\n    </div>\n    <div ng-switch-when=\"ready\">\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'mp4' || vm.activeTab == 'm4a'\">\n        Your download is ready!\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'kaltura' && !vm.unlock.kaltura\">\n        The video has been successfully exported to Kaltura.<br>\n        <button class=\"btn btn-link\" ng-click=\"vm.unlock.kaltura = true\"><small>Export this video again.</small></button>\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'vimeo' && !vm.unlock.vimeo\">\n        The video has been successfully exported to Vimeo.<br>\n        Look for an email from Vimeo or visit <a href=\"https://vimeo.com/home/myvideos\" target=\"_blank\">My Videos</a> for next steps.<br>\n        <button class=\"btn btn-link\" ng-click=\"vm.unlock.vimeo = true\"><small>Export this video again.</small></button>\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'youtube' && !vm.unlock.youtube\">\n        The video has been successfully exported to YouTube.<br>\n        Look for an email from YouTube or visit your <a href=\"https://www.youtube.com/my_videos\" target=\"_blank\">Video Manager</a> for next steps.<br>\n        <button class=\"btn btn-link\" ng-click=\"vm.unlock.youtube = true\"><small>Export this video again.</small></button>\n      </p>\n    </div>\n    <div ng-switch-when=\"failed\">\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'mp4' || vm.activeTab == 'm4a'\">\n        <i class=\"fa fa-warning\"></i>\n        The download request failed.\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'kaltura'\">\n        <i class=\"fa fa-warning\"></i>\n        The export request failed. Are your <a ng-click=\"vm.cancel()\" ui-sref=\"settings.overview\">Kaltura Configuration Settings</a> correct?\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'vimeo'\">\n        <i class=\"fa fa-warning\"></i>\n        The export request failed. Are your <a ng-click=\"vm.cancel()\" ui-sref=\"settings.vimeo\">Vimeo Configuration Settings</a> correct?\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'youtube'\">\n        <i class=\"fa fa-warning\"></i>\n        The export request failed. Are your <a ng-click=\"vm.cancel()\" ui-sref=\"settings.youtube\">YouTube Configuration Settings</a> correct?\n      </p>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClapprUtils; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var ClapprUtils = /*#__PURE__*/function () {
  function ClapprUtils(player) {
    var _this = this;

    _classCallCheck(this, ClapprUtils);

    this.player = player;
    var hls = this.getCurrentHlsJsInstance();

    if (hls) {
      hls.on('hlsLevelLoaded', function (evt, levelDetails) {
        return _this.onHlsLevelLoaded(evt, levelDetails);
      });
    }
  }

  _createClass(ClapprUtils, [{
    key: "onHlsLevelLoaded",
    value: function onHlsLevelLoaded(evt, levelDetails) {
      var _this2 = this;

      // XXX: there's an odd behavior in hls.js where it fires 2 levelLoaded events in quick
      // succession; the first is the one we want because the 2nd has a mutated "start" to be the
      // startPTS.  so ignore the subsequent one but keep the first.
      if (this._avoidDoubleLevel) {
        //console.log('hlsLevelLoaded - ignoring ',levelDetails.details.fragments.length,' framents');
        return;
      } else {
        this._avoidDoubleLevel = true;
        setTimeout(function () {
          return _this2._avoidDoubleLevel = false;
        }, 2000);
        var mediaOffset = 0.0;
        var mediaSN = levelDetails.details.startSN;
        var firstSN = -1;

        if (levelDetails.details.initSegment !== null) {
          var tagList = levelDetails.details.initSegment.tagList;

          for (var i = 0; i < tagList.length; i++) {
            if (tagList[i][0] == 'EXT-X-BOXCAST-OFFSET') {
              mediaOffset = parseFloat(tagList[i][1]);
              break;
            }
          }
        }

        this._levelFragments = _.map(levelDetails.details.fragments, function (data) {
          for (var i = 0; i < data.tagList.length; i++) {
            if (data.tagList[i][0] == 'EXT-X-BOXCAST-OFFSET') {
              mediaOffset = parseFloat(data.tagList[i][1]);
              break;
            }
          }

          var position = data.relurl.indexOf('.ts');
          var sn = parseInt(data.relurl.substring(position - 8, position), 10);

          if (firstSN == -1) {
            firstSN = sn;
          }

          return {
            start: data.start,
            duration: data.duration,
            sn: mediaSN + (sn - firstSN)
          };
        });
        this._mediaOffset = mediaOffset; //console.log('hlsLevelLoaded - loaded ',this._levelFragments.length,' fragments');
      }
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      // XXX: skip the clappr player.getCurrentTime nonsense that attempts to track itself on events,
      // and instead hit the <video> element
      return this.player.core.$el.find('video, audio').get(0).currentTime;
    }
  }, {
    key: "getCurrentHlsJsInstance",
    value: function getCurrentHlsJsInstance() {
      if (!this.player) return null;
      var playback = this.player.core.getCurrentPlayback();
      return playback._hls;
    }
  }, {
    key: "isUsingHlsJs",
    value: function isUsingHlsJs() {
      try {
        return this.getCurrentHlsJsInstance();
      } catch (e) {
        return false;
      }
    }
  }, {
    key: "getPlayerSegmentAndOffsetForTime",
    value: function getPlayerSegmentAndOffsetForTime(time) {
      var fragments = this._levelFragments;
      var currentSN = -1;
      var startTime = 0.0;

      for (var i = 0; i < fragments.length; i++) {
        var data = fragments[i]; // Multiple fragments can belong to the same MPEG-TS file so this captures the start time of
        // the very first fragment of an MPEG-TS file.

        if (currentSN != data.sn) {
          currentSN = data.sn;
          startTime = data.start;
        }

        if (data.start <= time && data.start + data.duration >= time) {
          console.log('Found segment for time [', time, ']: ', data);
          return [data.sn, time - startTime];
        }
      }

      console.warn('Unable to find segment matching time [', time, '] in list: ', fragments);
      return null;
    }
  }, {
    key: "getMediaAbsoluteTimeForTime",
    value: function getMediaAbsoluteTimeForTime(time) {
      return time + this._mediaOffset;
    }
  }]);

  return ClapprUtils;
}();



/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports = "<form name=\"highlightForm\" role=\"form\">\n\n<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">{{vm.title}}</h3>\n</div>\n<div class=\"modal-body\">\n\n  <div class=\"row\" style=\"position:relative\">\n\n    <div class=\"col-xs-12\">\n      <recording-trimmer broadcast-id=\"vm.broadcast.id\"\n                         recording-id=\"vm.recording.id\"\n                         start-segment=\"vm.startSegment\"\n                         stop-segment=\"vm.stopSegment\"\n                         start-seconds=\"vm.startSeconds\"\n                         stop-seconds=\"vm.stopSeconds\"\n                         on-change-bounds=\"vm.onChangeBounds\"></recording-trimmer>\n    </div>\n\n    <div class=\"col-xs-12\">\n      <div class=\"well\" style=\"margin-top:15px\">\n        <p>\n          <strong>Selected Clip Duration:</strong>\n          {{vm.duration | secondsFormatted:true:false}}\n        </p>\n        <div ng-show=\"vm.broadcastIsMonetized && vm.duration > vm.maxMonetizedHighlightTimeS\">\n          <p class=\"text-warning\">\n            <i class=\"fa fa-warning\"></i>\n            This broadcast is ticketed. Highlights longer than {{vm.maxMonetizedHighlightTimeS | secondsFormatted:true:false}} will not be shown to viewers.\n          </p>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"name\">\n            Highlight Name\n            <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i>\n          </label>\n          <input type=\"text\" class=\"form-control\" id=\"name\" name=\"name\" ng-model=\"vm.highlight.name\" ng-maxlength=\"::vm.limits.name\" required>\n          <p ng-show=\"(highlightForm.name.$dirty || highlightForm.name.$touched) && !vm.highlight.name\">\n            <span class=\"text-danger\" ng-if=\"highlightForm.name.$error.maxlength\">The name is too long.</span>\n            <span class=\"text-danger\" ng-if=\"highlightForm.name.$error.required\">The name cannot be blank.</span>\n          </p>\n        </div>\n        <div class=\"form-group\">\n          <label>\n            Highlight Description\n          </label>\n          <textarea class=\"form-control\" ng-model=\"vm.highlight.description\"></textarea>\n        </div>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n<div class=\"modal-footer\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <a href=\"javascript://\" ng-if=\"vm.highlight.id\" ng-click=\"vm.delete()\" class=\"action-link pull-left\">\n        <i class=\"fa fa-trash\"></i>\n        Delete Highlight\n      </a>\n      <div class=\"pull-right\">\n        <div class=\"form-group\">\n          <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">\n            Cancel\n          </button>\n          <button class=\"btn btn-primary\" ng-click=\"vm.showPreviewModal()\">\n            Preview Highlight Clip\n          </button>\n          <button ng-click=\"vm.saveChanges()\" ng-disabled=\"!highlightForm.$valid || vm.isSaving\" class=\"btn btn-success\">\n            <i ng-show=\"vm.isSaving\" class=\"fa fa-cog fa-spin\"></i>\n            Save Highlight Clip\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n</form>"

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = "<form name=\"highlightForm\" role=\"form\">\n\n<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\" ng-if=\"!vm.showSave\">{{vm.highlight.name || '(No description provided)'}}</h3>\n  <h3 class=\"modal-title\" ng-if=\"vm.showSave\">Highlight Preview</h3>\n</div>\n<div class=\"modal-body\">\n  <div id=\"trim-preview-placeholder\"></div>\n  <div ng-if=\"vm.broadcast.channel_id\">\n\n    <boxcast-player ng-if=\"vm.showPlayer\" channel-id=\"vm.channelId\" mode=\"vm.mode\" options=\"vm.options\"></boxcast-player>\n\n    <div class=\"row\" style=\"margin-top:15px\" ng-if=\"vm.showSave\">\n      <div class=\"col-xs-6 text-left\">\n        <button class=\"btn btn-xs btn-default\"\n                ng-click=\"vm.nudge('start', -10)\"\n                ng-disabled=\"vm.options.trimSeconds.start == 0\"\n                uib-tooltip=\"Adjust start to 10 seconds earlier\" tooltip-append-to-body=\"true\"><i class=\"fa fa-step-backward\"></i></button>&nbsp;\n        <button class=\"btn btn-xs btn-default\"\n                ng-click=\"vm.nudge('start', 10)\"\n                ng-disabled=\"vm.options.trimSeconds.start == vm.options.trimSeconds.stop - 1\"\n                uib-tooltip=\"Adjust start to 10 seconds later\" tooltip-append-to-body=\"true\"><i class=\"fa fa-step-forward\"></i></button>&nbsp;\n        <small>Adjust start</small>\n      </div>\n      <div class=\"col-xs-6 text-right\">\n        <small>Adjust stop</small>&nbsp;\n        <button class=\"btn btn-xs btn-default\"\n                ng-click=\"vm.nudge('stop', -10)\"\n                ng-disabled=\"vm.options.trimSeconds.start == vm.options.trimSeconds.stop - 1\"\n                uib-tooltip=\"Adjust stop to 10 seconds earlier\" tooltip-append-to-body=\"true\"><i class=\"fa fa-step-backward\"></i></button>&nbsp;\n        <button class=\"btn btn-xs btn-default\"\n                ng-click=\"vm.nudge('stop', 10)\"\n                uib-tooltip=\"Adjust stop to 10 seconds later\" tooltip-append-to-body=\"true\"><i class=\"fa fa-step-forward\"></i></button>\n      </div>\n    </div>\n\n    <div class=\"form-group\" style=\"margin: 15px 0 30px\" ng-if=\"vm.showSave\">\n      <label for=\"eventName\">Description <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n      <input type=\"text\" class=\"form-control\" id=\"eventName\" name=\"eventName\" ng-model=\"vm.highlight.name\" ng-maxlength=\"::vm.limits.name\" required placeholder=\"Enter a name for this clip...\">\n      <p ng-show=\"(highlightForm.eventName.$dirty || highlightForm.eventName.$touched) && !vm.highlight.name\">\n        <span class=\"text-danger\" ng-if=\"highlightForm.eventName.$error.maxlength\">The description is too long.</span>\n        <span class=\"text-danger\" ng-if=\"highlightForm.eventName.$error.required\">The description cannot be blank.</span>\n      </p>\n    </div>\n\n    <p class=\"text-center\" style=\"margin:15px 0 30px\" ng-if=\"!vm.showSave\">\n      {{vm.highlight.description}}\n      <span ng-if=\"vm.highlight.duration\">({{vm.highlight.duration | secondsFormatted:true:false}})</span>\n    </p>\n\n    <ol class=\"list-inline text-center\" ng-if=\"vm.highlight.id\">\n      <li ng-if=\"vm.showSocialShare\">\n        <button class=\"btn btn-default\"\n                ng-click=\"vm.tweet()\"\n                analytics-on analytics-event=\"highlight-preview\" analytics-category=\"\" analytics-label=\"twitter\"\n                uib-tooltip=\"Tweet a link to your Twitter followers\" tooltip-placement=\"bottom\">\n          <i class=\"fa-brands fa-x-twitter\" style=\"width:20px\"></i> Share on X\n        </button>\n      </li>\n      <li ng-if=\"vm.showSocialShare\">\n        <button class=\"btn btn-default\"\n                ng-click=\"vm.facebook()\"\n                analytics-on analytics-event=\"highlight-preview\" analytics-category=\"\" analytics-label=\"facebook\"\n                uib-tooltip=\"Post a link on your Facebook timeline\" tooltip-placement=\"bottom\">\n          <i class=\"fa fa-facebook\" style=\"width:20px\"></i> Share on Facebook\n        </button>\n      </li>\n      <li ng-if=\"clipboard.supported && vm.highlightCanBeShared\">\n        <button class=\"btn btn-default\"\n          clipboard\n          text=\"vm.link\"\n          on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n          on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n          analytics-on analytics-event=\"highlight-preview\" analytics-category=\"\" analytics-label=\"copy\"\n          uib-tooltip=\"Copy the BoxCast.tv event link to your clipboard\" tooltip-placement=\"bottom\">\n          <i class=\"fa fa-copy\" style=\"width:20px\"></i> Copy Link\n        </button>\n      </li>\n      <li>\n        <button class=\"btn btn-default\" ng-if=\"vm.highlightCanBeShared\"\n                ng-click=\"vm.showEmbed = !vm.showEmbed\"\n                analytics-on analytics-event=\"highlight-preview\" analytics-category=\"\" analytics-label=\"embed\"\n                uib-tooltip=\"Embed this clip on your web site\" tooltip-placement=\"bottom\">\n          <i class=\"fa fa-code\" style=\"width:20px\"></i> Embed\n        </button>\n      </li>\n      <li>\n        <button class=\"btn btn-default\"\n                ng-click=\"vm.download()\"\n                analytics-on analytics-event=\"highlight-preview\" analytics-category=\"\" analytics-label=\"download\"\n                uib-tooltip=\"Download this highlight\" tooltip-placement=\"bottom\">\n          <i class=\"fa fa-download\" style=\"width:20px\"></i> Download\n        </button>\n      </li>\n    </ol>\n\n    <div ng-if=\"vm.showEmbed\" style=\"position:relative\">\n      <textarea readonly class=\"form-control\" rows=\"7\" style=\"font-size:9pt\">{{vm.embedCode}}</textarea>\n      <button ng-if=\"clipboard.supported\"\n              class=\"btn btn-sm\"\n              style=\"padding:2px 5px; font-size: 8pt; position: absolute; right: 5px; bottom: 5px;\"\n              clipboard\n              text=\"vm.embedCode\"\n              on-copied=\"toaster.pop('success', 'Embed code successfully copied')\"\n              on-error=\"toaster.pop('warning', 'Embed code could not be copied')\"\n              >Copy to Clipboard <i class=\"fa fa-copy\"></i></button>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <a href=\"javascript://\" ng-click=\"vm.delete()\" class=\"action-link pull-left\" ng-if=\"vm.highlight.id\">\n        <i class=\"fa fa-trash\"></i>\n        Delete Highlight\n      </a>\n      <div class=\"pull-right\">\n        <div class=\"form-group\">\n          <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel()\">Close</button>\n          <button ng-if=\"vm.showSave\" class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.save()\" ng-disabled=\"!vm.highlight.name\">Save Highlight</button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n</form>\n"

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3>Order Status</h3>\n</div>\n<div class=\"modal-body row order-status-modal\" style=\"text-align:center\">\n  <div class=\"col-xs-12\" ng-show=\"vm.error\" style=\"padding:20px;\">\n    There was an error retrieving your order status. Please contact <a href=\"mailto:questions@boxcast.com\">questions@boxcast.com</a>\n    for assistance with checking your order status. \n  </div>\n\n  <div class=\"col-xs-12\" ng-show=\"vm.loading\" style=\"height:200px;margin-top:100px\">\n    <i class=\"fa fa-spin fa-spinner\"></i> Loading...\n  </div>\n\n  <div class=\"col-xs-12\" ng-if=\"!vm.error && !vm.loading\">\n    <table class=\"order-status\" align=\"center\">\n      <tr>\n        <td class=\"icon\">\n          <img src=\"/img/green_order_placed_icon.png\">\n        </td>\n        <td class=\"line\" >\n          <img ng-hide=\"vm.orderShipped\" src=\"/img/blue_dashed_line.png\">\n          <div ng-show=\"vm.orderShipped\">\n        </td>\n        <td class=\"icon\">\n          <img ng-hide=\"vm.orderShipped\" src=\"/img/blue_est_order_shipped_icon.png\">\n          <img ng-show=\"vm.orderShipped\" src=\"/img/green_order_shipped_icon.png\"\n        </td>\n        <td class=\"line\" >\n          <img src=\"/img/blue_dashed_line.png\">\n        </td>\n        <td class=\"icon\">\n          <img src=\"/img/blue_est_delivery_icon.png\">\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"form-group\">\n            <label>Order Placed</label><br>\n            {{vm.order.created_at | date}}\n          <div class=\"form-group\">\n        </td>\n        <td></td>\n        <td>\n          <div class=\"form-group\">\n            <label ng-hide=\"vm.orderShipped\">Shipping</label>\n            <label ng-show=\"vm.orderShipped\">Order Shipped</label><br>\n            <span ng-if=\"vm.orderShipped\">{{vm.order.ship_date | date}}</span>\n          </div>\n        </td>\n        <td></td>\n        <td>\n          <div class=\"form-group\">\n            <label>Delivery</label><br>\n            <a ng-if=\"vm.orderShipped\" ng-href=\"{{vm.trackingLink()}}\" target=\"_blank\">Track Package</a>\n          </div>\n        </td>\n      </tr>\n    </table>\n\n    <div class=\"row order-info\" style=\"margin-top:30px;padding-left:20px\">\n      <div class=\"col-xs-3\">\n        <div class=\"form-group\">\n          <label>Payment</label><br>\n          <span ng-show=\"vm.paid\" class=\"label label-success\">Payment Received</span>\n          <span ng-hide=\"vm.paid\" class=\"label label-warning\">\n            Awaiting Payment\n            <i ng-show=\"vm.account.payment_method == 'check'\" class=\"fa fa-question-circle\" tooltip-append-to-body=\"true\" uib-tooltip=\"We are waiting on your check payment\"></i>\n            <i ng-show=\"vm.account.payment_method == 'po'\" class=\"fa fa-question-circle\" tooltip-append-to-body=\"true\" uib-tooltip=\"We are waiting on your purchase order\"></i>\n            <i ng-show=\"vm.account.payment_method == 'ach'\" class=\"fa fa-question-circle\" tooltip-append-to-body=\"true\" uib-tooltip=\"We are waiting for your ACH payment to clear\"></i>\n          </span>\n        </div>\n        <div ng-show=\"vm.orderShipped\" class=\"form-group\" style=\"margin-top:20px;word-wrap: break-word;\">\n          <label>Tracking Number</label>\n          <a ng-if=\"vm.orderShipped\" ng-href=\"{{vm.trackingLink()}}\" target=\"_blank\">{{vm.order.tracking_number}}</a>\n        </div>\n      </div>\n      <div class=\"col-xs-3\">\n        <div class=\"form-group\">\n          <label>Order Status</label><br>\n          <span ng-show=\"vm.backordered\" class=\"label label-danger\">\n            Backordered\n            <i class=\"fa fa-question-circle\" tooltip-append-to-body=\"true\" uib-tooltip=\"You are currently on our waitlist\"></i>\n          </span>\n          <span ng-show=\"!vm.backordered && vm.paid\" class=\"label label-success\">Filled</span>\n        </div>\n        <div ng-if=\"vm.orderShipped\" class=\"form-group\" style=\"margin-top:20px;text-transform:capitalize;\">\n          <label>Service</label><br>\n          {{vm.order.service_code}}\n        </div>\n      </div>\n      <div class=\"col-xs-3\" style=\"text-align:left;\">\n        <div class=\"form-group\">\n          <label ng-hide=\"vm.orderShipped\">Shipping Address</label>\n          <label ng-show=\"vm.orderShipped\">Shipped To</label>\n          <small>\n            <div style=\"margin-bottom:5px\">{{vm.order.ship_to.name}}</div>\n            <div ng-show=\"vm.order.ship_to.company\" style=\"margin-bottom:5px\">{{vm.order.ship_to.company}}</div>\n            <div>{{vm.order.ship_to.line1}}</div>\n            <div>{{vm.order.ship_to.city}}, {{vm.order.ship_to.state}} {{vm.order.ship_to.postal_code}}</div>\n          </small>\n        </div>\n      </div>\n      <div class=\"col-xs-3\" style=\"text-align:left;padding-left:5px\">\n        <div class=\"form-group\">\n          <label ng-hide=\"vm.orderShipped\">Order Items</label>\n          <label ng-show=\"vm.orderShipped\">Items Shipped</label>\n          <div ng-repeat=\"item in vm.order.items\">\n            <small>{{item.quantity}} &#8212; {{item.name}}</small>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div ng-show=\"vm.showOrdersLink\" style=\"margin-top:25px\">\n      <a href=\"javascript://\" ng-click=\"vm.viewAllOrders()\">View all orders <i class=\"fa fa-caret-right\"></i></a>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalOrderStatus;
function ModalOrderStatus($uibModalInstance, $analytics, $state, Order, order, account, showOrdersLink) {
  'ngInject';

  var _this = this;

  this.orderId = order.id;
  this.account = account;
  this.showOrdersLink = showOrdersLink;
  this.$analytics = $analytics;
  this.loading = true;
  Order.get({
    id: this.orderId
  }).$promise.then(function (result) {
    _this.order = result;
  })["catch"](function (err) {
    console.error(err);
    _this.error = true;
  })["finally"](function () {
    _this.paid = false;
    _this.backordered = false;
    _this.orderShipped = false;
    _this.error = false;

    if (_this.order.status == 'awaiting_payment') {// no changes
    } else if (_this.order.status == 'on_hold') {
      _this.paid = true;
      _this.backordered = true;
    } else if (_this.order.status == 'awaiting_shipment') {
      _this.paid = true;
    } else if (_this.order.status == 'shipped') {
      _this.paid = true;
      _this.orderShipped = true;
      _this.order.service_code = _this.order.service_code.replace(/_/g, ' ');
    } else {
      _this.error = true;
    }

    _this.loading = false;
  });

  this.trackingLink = function () {
    switch (_this.order.carrier_code) {
      case 'fedex':
        return "https://www.fedex.com/apps/fedextrack/index.html?tracknumbers=".concat(_this.order.tracking_number);

      case 'stamps_com':
        return "https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=".concat(_this.order.tracking_number);

      case 'dhl_express':
        return "https://www.dhl.com/content/g0/en/express/tracking.shtml?AWB=".concat(_this.order.tracking_number, "&brand=DHL");
    }
  };

  this.viewAllOrders = function () {
    $uibModalInstance.dismiss('cancel');
    $state.go('settings.payment', {
      show_orders: true
    });

    _this.$analytics.eventTrack("view-all-orders", {
      category: 'open',
      label: ''
    });
  };

  this.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export salt */
/* unused harmony export hash */
/* unused harmony export check */
/* harmony export (immutable) */ __webpack_exports__["a"] = checkContentSettingsForChangesOnSave;
var sha512 = __webpack_require__(175);

function salt() {
  return Math.random().toString(36).substring(2);
}
function hash(password, salt) {
  var digest = (password || '') + (salt || '');

  for (var i = 0; i < 20; i++) {
    digest = sha512(digest);
  }

  return digest;
}
function check(password, crypt, salt) {
  return hash(password, salt) == crypt;
}
function checkContentSettingsForChangesOnSave(data) {
  // This method works against the UI's implementation of content_settings for
  // storing the cryptblock.
  if (data.cryptblock && data.cryptblock.__password__) {
    // Password changed; regenerate salt/hash
    var s = salt();
    data.cryptblock = {
      salt: s,
      crypt: hash(data.cryptblock.__password__, s)
    };
  } else if (data.cryptblock && data.cryptblock.crypt && data.cryptblock.salt) {// Keep existing password block as-is
  } else {
    delete data.cryptblock;
  }

  return data;
}

/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_expose_loader_angular_angular__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_expose_loader_angular_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_expose_loader_angular_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_expose_loader_lodash__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_expose_loader_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_expose_loader_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_expose_loader_moment_moment__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_expose_loader_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_expose_loader_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_polyfill__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utils_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_hacks__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_hacks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__browser_hacks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_bootstrap__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_normalize_css__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__auth_index__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_index__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filters_index__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_index__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__resources_index__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_index__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__thirdparty__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_main_scss__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_main_scss__);
// Expose core modules on the window scope to avoid importing them everywhere




 // Throw config on window scope as well
// eslint-disable-next-line no-unused-vars

 // Check authentication token from OAuth redirect straight away



var tokenPromise = Object(__WEBPACK_IMPORTED_MODULE_6__auth_bootstrap__["a" /* bootstrapOAuthTokenExchange */])(); // Inject Bootstrap CSS via webpack loaders

 // Create the core app angular module, depending on our sub-modules








var app = angular.module('app', [__WEBPACK_IMPORTED_MODULE_9__auth_index__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_10__directives_index__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_11__filters_index__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_12__pages_index__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_13__resources_index__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_14__services_index__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_15__thirdparty__["a" /* default */].name]); // Main app layout


app.directive('app', function () {
  'ngInject';

  return {
    restrict: 'E',
    template: __webpack_require__(564),
    controllerAs: 'vm',
    controller: function controller(Capabilities, $rootScope, $timeout) {
      'ngInject'; // Handle race condition of double feature flags initialization (we don't want $stateChangeStart
      // to fire until *after* its handler's Capabilities are initialized)

      var _this = this;

      this.loading = true;
      Capabilities.then(function () {
        $timeout(function () {
          // Prevent Go plan users from accessing the dashboard
          // TODO: This is fragile. We should use a feature flag or explicit
          //       plan names to determine Dashboard access.
          var isFreePlan = Capabilities.account.contract === 'free';
          var maxMinutes = Capabilities.account.max_streamed_minutes_per_month;
          var isGoPlan = isFreePlan && maxMinutes > 0 && maxMinutes <= 3 * 60;

          if (isGoPlan) {
            window.location.href = 'https://www.boxcast.com/go-plan/gated';
            return;
          } // Account and User were already retrieved by way of Capabilities
          // Pluck them from there to avoid double-requesting.


          _this.account = Capabilities.account;
          _this.user = Capabilities.user;
          _this.Capabilities = Capabilities; // Initialize DataDog logging

          remoteLogger.addContext('service', 'dashboard');
          remoteLogger.addContext('env', BOXCAST_JS_ENV);
          remoteLogger.addContext('account_id', _this.account.id);
          remoteLogger.addContext('user_id', _this.user.id); // Load the chat widget

          if (_this.account.chat_support && !_this.user.is_impersonating) {
            $rootScope.hasChat = true;
            loadChatWidget(_this.user, _this.account);
          } // Load ChurnZero


          loadChurnZero(_this.user, _this.account);
          _this.loading = false;
        }, 10);
      }); // App layout depends on whether the eyebrow is shown or not

      $rootScope.$on('show-eyebrow', function () {
        _this.showEyebrow = true;
      });
      $rootScope.$on('hide-eyebrow', function () {
        _this.showEyebrow = false;
      });
    }
  };
});

function loadChatWidget(user, account) {
  if (!window.Intercom) {
    console.warn('Intercom not properly loaded');
    return;
  }

  var convertToSeconds = function convertToSeconds(date) {
    if (date) {
      var newDate = new Date(date);
      return Math.floor(newDate / 1000);
    }

    return null;
  };

  window.Intercom('boot', {
    app_id: INTERCOM_APP_ID,
    user_id: user.id,
    email: user.email,
    name: user.name,
    company: {
      company_id: account.id,
      name: account.name
    },
    trial_milestone_stage: account.metadata.onboarding_step || null,
    trial_expiration_at: convertToSeconds(account.expires_on),
    account_status: account.status,
    can_stream: account.can_stream,
    has_streamed: account.has_streamed,
    market: account.market || null,
    contract_status: account.contract
  });
}

function loadChurnZero(user, account) {
  if (!window.ChurnZero) {
    console.warn('ChurnZero not loaded');
    return;
  }

  window.ChurnZero.push(['setAppKey', CHURNZERO_APP_KEY]);
  window.ChurnZero.push(['setContact', account.id, user.email]);
}

app.config(function ($urlRouterProvider, $stateProvider, $analyticsProvider, $compileProvider, ChartJsProvider) {
  'ngInject'; // Init UI-router

  $urlRouterProvider.otherwise('/?p=1,1,1&tab=current'); // go to home if route not found
  // Google Analytics

  $analyticsProvider.virtualPageviews(false); // explicitly track pages

  $analyticsProvider.firstPageview(false); // necessary for manual bootstrapping code

  $analyticsProvider.trackExceptions(true); // White-list blobs and other friendly URLs

  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|tel|blob):/); // Configure all charts

  ChartJsProvider.setOptions({
    chartColors: [// Based on Stephen Few’s book, Show Me the Numbers
    '#5DA5DA', //blue
    '#4D4D4D', //gray
    '#FAA43A', //orange
    '#60BD68', //green
    '#F17CB0', //pink
    '#B2912F', //brown
    '#B276B2', //purple
    '#DECF3F', //yellow
    '#F15854' //red
    ],
    responsive: true,
    legend: {
      display: true,
      position: 'bottom',
      labels: {
        boxWidth: 10,
        fontSize: 10
      }
    }
  });
  ChartJsProvider.setOptions('Line', {
    datasetFill: false
  });
});
var alreadyRan = false;
app.run(function ($rootScope, $urlRouter, toaster, $state, $q, $analytics, clipboard, ApiConfig, Capabilities) {
  'ngInject'; // Attach some template helpers so we don't have to go through a controller/directive injection

  $rootScope.$state = $state;
  $rootScope._ = _;
  $rootScope.toaster = toaster;
  $rootScope.clipboard = clipboard;
  $rootScope.browser = {
    iPhone: navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i)
  };
  $rootScope.vueDashboardRoot = '';

  if (window.location.hostname === 'localhost') {
    $rootScope.vueDashboardRoot = 'http://localhost:8001';
  } // Dealing with a little bit of a race condition here in the app startup lifecycle


  var loaded = false;
  Capabilities.then(function () {
    // Let other templates access a few important instances directly
    $rootScope.ApiConfig = ApiConfig;
    $rootScope.account = Capabilities.account;
    $rootScope.reseller = Capabilities.reseller;
    $rootScope.user = Capabilities.user;
    $rootScope.$state = $state;
    loaded = true; // Google Analytics custom dimensions are registered in GA Settings > Custom Variables

    try {
      ga('set', 'dimension1', $rootScope.account.market);
      ga('set', 'dimension2', $rootScope.account.contract);
    } catch (e) {
      console.log('Unable to set GA dimensions: ', e);
    }
  });

  if (!alreadyRan) {
    alreadyRan = true;
    $rootScope.$on('$locationChangeSuccess', function (evt, newUrl, oldUrl) {
      // Any time user succesfully navigates, scroll up and close mobile menu
      if (allowAutoScrollOnPageTransition(oldUrl, newUrl)) {
        window.scrollTo(0, 0);
      }

      $('left-navbar').parent().removeClass('nav-open');
      $('body').css({
        overflow: 'auto'
      }); // Also log the event in GA according to the route name rather than full URL

      $analytics.pageTrack($state.$current.name); // Also update Intercom

      window.Intercom && window.Intercom('update');
    });
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      if ($state.current.confirmOnExit && !confirm('There are unsaved changes. Are you sure you wish to leave this page?')) {
        console.log('Unsaved changes; preventing default');
        event.preventDefault();
      }

      if (!loaded) {
        // Flags not fully loaded, need to wait a tick and try again
        event.preventDefault();
        Capabilities.then(function () {
          $state.go(toState.name, toParams);
        });
      } else if (!Capabilities.canUserVisitState(toState)) {
        console.log('User blocked from visiting state');
        event.preventDefault();

        if (!Capabilities.account.authorized()) {
          // Redirect unauthorized users to home page
          $state.go('home');
        }
      }
    });
  }
});

function allowAutoScrollOnPageTransition(fromUrl, toUrl) {
  // By default, we always want to autoscroll.  There may be specific cases
  // where we don't (e.g. navigating in-page between channels and updating IDs)
  if (fromUrl.match(/\/channels/) && toUrl.match(/\/channels\?id=/)) {
    return false;
  }

  return true;
} // Custom bootstrapping code so we can wait on required network resources before
// spinning up any angular code at all.


function loadTheApp() {
  var rootElement = angular.element(document);
  app.provider({
    $rootElement: function $rootElement() {
      this.$get = function () {
        return rootElement;
      };
    }
  });
  var preBootstrapInjector = angular.injector(['ng', 'app']);
  var $q = preBootstrapInjector.get('$q');
  var ApiConfig = preBootstrapInjector.get('ApiConfig');
  var Capabilities = preBootstrapInjector.get('Capabilities');
  $q.all([ApiConfig.verifyResolved(), Capabilities.verifyResolved()]).then(function () {
    angular.bootstrap(rootElement, ['app']);
  })["catch"](function (err) {
    showGlobalError(err);
  });
}

function showGlobalError(err) {
  console.error(err);
  $('body > app').hide();
  setTimeout(function () {
    $('#global-error-message').fadeIn();
    remoteLogger.error("unable to load dashboard: ".concat(err), {
      err: err,
      isSwitcherStudioAppShell: __WEBPACK_IMPORTED_MODULE_7__auth_utils__["c" /* isSwitcherStudioAppShell */]
    });
  }, 1000); // delay a bit in case the error is masked by redirect for auth logic
}

if (tokenPromise) {
  tokenPromise.then(loadTheApp)["catch"](function (err) {
    showGlobalError(err);
  });
} else {
  loadTheApp();
}

/* harmony default export */ __webpack_exports__["default"] = (app);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["angular"] = __webpack_require__(11);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["_"] = __webpack_require__(26);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["moment"] = __webpack_require__(0);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 260 */
/***/ (function(module, exports) {

if (typeof String.prototype.startsWith !== 'function') {
  String.prototype.startsWith = function (str) {
    return this.indexOf(str) === 0;
  };
}

if (typeof String.prototype.endsWith !== 'function') {
  String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();

    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }

    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    'use strict';

    if (search instanceof RegExp) {
      throw TypeError('first argument must not be a RegExp');
    }

    if (start === undefined) {
      start = 0;
    }

    return this.indexOf(search, start) !== -1;
  };
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {// Prevent the backspace key from navigating back.
$(document).unbind('keydown').bind('keydown', function (event) {
  var doPrevent = false;

  if (event.keyCode === 8) {
    var d = event.srcElement || event.target,
        tag = d.tagName.toUpperCase(),
        type = (d.type || '').toUpperCase();

    if (tag === 'INPUT' && (type === 'TEXT' || type === 'PASSWORD' || type === 'FILE' || type === 'SEARCH' || type === 'EMAIL' || type === 'NUMBER' || type === 'DATE') || tag === 'TEXTAREA') {
      doPrevent = d.readOnly || d.disabled;
    } else {
      doPrevent = true;
    }
  }

  if (doPrevent) {
    event.preventDefault();
  }
}); // Prevent drag/drop image from navigating page (unless
// it's over an explicit upload drop target we want)

window.addEventListener('dragover', function (e) {
  e = e || event;
  e.preventDefault();
}, false);
window.addEventListener('drop', function (e) {
  e = e || event;
  e.preventDefault();
}, false);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
// The config module loads the appropriate configuration based on the URL being
// visited and attaches variables to the window scope.
 // Use the _shared as a base, but allow overriding in each environment

var _shared = __webpack_require__(263);

var configMap = {
  dev: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.extend({}, _shared, __webpack_require__(264)),
  localhost: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.extend({}, _shared, __webpack_require__(265)),
  prod: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.extend({}, _shared, __webpack_require__(266))
};
var ENV;

switch (location.hostname) {
  case 'localhost':
    ENV = 'localhost';
    break;

  case 'dashboard.dev.boxcast.com':
    ENV = 'dev';
    break;

  default:
    ENV = 'prod';
} // Throw variables on window


__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(configMap[ENV], function (value, key) {
  var override = localStorage.getItem(key);

  if (override) {
    console.warn('Overriding', key, 'with', override, 'instead of', value);
    value = override;
  }

  window[key] = value;
});

/* unused harmony default export */ var _unused_webpack_default_export = (ENV);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REFRESH_INTERVAL_MS", function() { return REFRESH_INTERVAL_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIFI_POLL_INTERVAL_MS", function() { return WIFI_POLL_INTERVAL_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIFI_POLL_TIMEOUT_MS", function() { return WIFI_POLL_TIMEOUT_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_RECURRING_EVENTS", function() { return MAX_RECURRING_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PREROLL_TIME", function() { return PREROLL_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_MONETIZED_HIGHLIGHT_TIME_S", function() { return MAX_MONETIZED_HIGHLIGHT_TIME_S; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUDIO_ONLY_BITRATE_HINT", function() { return AUDIO_ONLY_BITRATE_HINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_ENV", function() { return BOXCAST_JS_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_EMBED_URL", function() { return BOXCAST_JS_EMBED_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_IFRAME_URL", function() { return BOXCAST_JS_IFRAME_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_APP_EMBED_URL", function() { return BOXCAST_JS_APP_EMBED_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYNDICATION_SERVICE_BASE_URL", function() { return SYNDICATION_SERVICE_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FACEBOOK_API_VERSION", function() { return FACEBOOK_API_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GOOGLE_ANALYTICS_KEY", function() { return GOOGLE_ANALYTICS_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GOOGLE_ANALYTICS_DOMAIN", function() { return GOOGLE_ANALYTICS_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_SCOPE", function() { return YOUTUBE_SCOPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_ANALYTICS_SCOPE", function() { return YOUTUBE_ANALYTICS_SCOPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNSPLASH_APP_ID", function() { return UNSPLASH_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIMEO_CLIENT_ID", function() { return VIMEO_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIMEO_SCOPE", function() { return VIMEO_SCOPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TWITTER_CLIENT_ID", function() { return TWITTER_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPECTRUM_COLOR_PALETTE", function() { return SPECTRUM_COLOR_PALETTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STANDARD_COLOR_PALETTE", function() { return STANDARD_COLOR_PALETTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROTECTED_CONTENT_SETTINGS_KEYS", function() { return PROTECTED_CONTENT_SETTINGS_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HUBSPOT_MEETINGS_BASE_URL", function() { return HUBSPOT_MEETINGS_BASE_URL; });
var REFRESH_INTERVAL_MS = 60000; //refresh event list and details once per minute

var WIFI_POLL_INTERVAL_MS = 2500;
var WIFI_POLL_TIMEOUT_MS = 60000; //stop trying after 60sec

var MAX_RECURRING_EVENTS = 100;
var PREROLL_TIME = 10 * 60 * 1000; // 10 minutes in milliseconds
// 5 minutes -- see https://github.com/boxcast/boxcast_api/blob/master/app/models/highlight.rb for Highlight::MAX_DURATION

var MAX_MONETIZED_HIGHLIGHT_TIME_S = 300;
var AUDIO_ONLY_BITRATE_HINT = 10000;
var BOXCAST_JS_ENV = 'prod';
var BOXCAST_JS_EMBED_URL = '//js.boxcast.com/v3.min.js';
var BOXCAST_JS_IFRAME_URL = 'https://boxcast.tv/view-embed';
var BOXCAST_JS_APP_EMBED_URL = 'https://boxcast.tv/embed-app.html';
var SYNDICATION_SERVICE_BASE_URL = 'https://syndication.boxcast.com';
var FACEBOOK_API_VERSION = 'v17.0';
var GOOGLE_ANALYTICS_KEY = 'UA-15394876-6';
var GOOGLE_ANALYTICS_DOMAIN = null;
var YOUTUBE_SCOPE = 'https://www.googleapis.com/auth/youtube';
var YOUTUBE_ANALYTICS_SCOPE = 'https://www.googleapis.com/auth/yt-analytics.readonly';
var UNSPLASH_APP_ID = 'd95c25c1553e8c7e9a6177c9a6a04f6d107fda686347b65e15bd347f11810cec';
var VIMEO_CLIENT_ID = 'e4ac1782f4cbfa854a3f90c6ee955fb641c0db37';
var VIMEO_SCOPE = 'public private upload';
var TWITTER_CLIENT_ID = 'aspcGbqPb6k2SVLYLfwU57JpF';
var SPECTRUM_COLOR_PALETTE = {
  '#000000': 'Black',
  '#0496D4': 'Teal',
  '#99BFE5': 'Blue Light',
  '#648FCC': 'Blue Medium',
  '#002D73': 'Blue',
  '#0C2238': 'Navy',
  '#005F61': 'Aqua',
  '#3A7728': 'Green Light',
  '#00583D': 'Green',
  '#004438': 'Green Dark',
  '#FF3333': 'Red Light',
  '#C8141E': 'Red',
  '#990000': 'Maroon',
  '#FC4E04': 'Orange',
  '#E06F1F': 'Orange Burnt',
  '#6633CC': 'Purple Light',
  '#410F73': 'Purple',
  '#4E3227': 'Brown',
  '#9B8449': 'Gold Old',
  '#CC9933': 'Gold',
  '#969798': 'Silver'
};
var STANDARD_COLOR_PALETTE = SPECTRUM_COLOR_PALETTE;
var PROTECTED_CONTENT_SETTINGS_KEYS = ['app', 'boxcast_viewer_promotion', 'cryptblock', 'customPreroll', 'defaultVideo', 'donateContactEmail', 'donateMessage', 'geoblock', 'hostRestrictions', 'language', 'podcast', 'poster', 'preview', 'showCountdown', 'showDonations', 'website'];
var HUBSPOT_MEETINGS_BASE_URL = 'https://app.hubspot.com/meetings';

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "API_ROOT", function() { return API_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTEGRATIONS_ROOT", function() { return INTEGRATIONS_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_URL", function() { return LOGIN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTH_URL", function() { return AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SWITCHER_AUTH_URL", function() { return SWITCHER_AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOKEN_URL", function() { return TOKEN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT_URL", function() { return LOGOUT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GEO_URL", function() { return GEO_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS", function() { return BOXCAST_JS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_ENV", function() { return BOXCAST_JS_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_EMBED_URL", function() { return BOXCAST_JS_EMBED_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_IFRAME_URL", function() { return BOXCAST_JS_IFRAME_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_APP_EMBED_URL", function() { return BOXCAST_JS_APP_EMBED_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYNDICATION_SERVICE_BASE_URL", function() { return SYNDICATION_SERVICE_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BANDWIDTH_TEST_URL", function() { return BANDWIDTH_TEST_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIDGET_JS", function() { return WIDGET_JS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_SHOW_URL", function() { return BOXCAST_SHOW_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_SHOW_URL", function() { return BOXCAST_TV_SHOW_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_HIGHLIGHT_URL", function() { return BOXCAST_TV_HIGHLIGHT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_VIDEO_PORTAL_URL", function() { return BOXCAST_TV_VIDEO_PORTAL_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IMG_ROOT", function() { return IMG_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FACEBOOK_APP_ID", function() { return FACEBOOK_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STRIPE_KEY", function() { return STRIPE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_CLIENT_ID", function() { return YOUTUBE_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_OAUTH_REDIRECT", function() { return YOUTUBE_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIMEO_OAUTH_REDIRECT", function() { return VIMEO_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TWITTER_OAUTH_REDIRECT", function() { return TWITTER_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATADOG_LOGS_CLIENT_TOKEN", function() { return DATADOG_LOGS_CLIENT_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTERCOM_APP_ID", function() { return INTERCOM_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHURNZERO_APP_KEY", function() { return CHURNZERO_APP_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VUE_DASHBOARD_ROOT", function() { return VUE_DASHBOARD_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_DASHBOARD_ROOT", function() { return NG_DASHBOARD_ROOT; });
var API_ROOT = 'https://rest.dev.boxcast.com';
var INTEGRATIONS_ROOT = 'https://integration.dev.boxcast.com';
var LOGIN_URL = 'https://login.dev.boxcast.com';
var AUTH_URL = 'https://rest.dev.boxcast.com/oauth2/auth?response_type=code&client_id=fabmaqloe4wokqzincep&redirect_uri=https%3A%2F%2Fdashboard.dev.boxcast.com%2F&scope=dashboard';
var SWITCHER_AUTH_URL = 'https://rest.dev.boxcast.com/oauth2/auth?response_type=code&client_id=glolh40ngfpuvh84jzc4&redirect_uri=https%3A%2F%2Fdashboard.dev.boxcast.com%2F&scope=owner';
var TOKEN_URL = 'https://rest.dev.boxcast.com/oauth2/token';
var LOGOUT_URL = 'https://rest.dev.boxcast.com/oauth2/auth/sessions/login/revoke';
var GEO_URL = 'https://geo.dev.boxcast.com/json/'; // boxcast_js v3

var BOXCAST_JS = "//js.dev.boxcast.com/v3.min.js";
var BOXCAST_JS_ENV = 'dev';
var BOXCAST_JS_EMBED_URL = '//js.dev.boxcast.com/v3.min.js';
var BOXCAST_JS_IFRAME_URL = 'https://dev.boxcast.tv/view-embed';
var BOXCAST_JS_APP_EMBED_URL = 'https://dev.boxcast.tv/embed-app.html';
var SYNDICATION_SERVICE_BASE_URL = 'https://syndication.dev.boxcast.com';
var BANDWIDTH_TEST_URL = 'https://w35c8wpq1bdd4z59brit.dev.boxcast.com';
var WIDGET_JS = '//js.dev.boxcast.com/v2.widget.js';
var BOXCAST_SHOW_URL = 'https://dev.boxcast.tv/channel/';
var BOXCAST_TV_SHOW_URL = 'https://dev.boxcast.tv/channel/';
var BOXCAST_TV_HIGHLIGHT_URL = 'https://dev.boxcast.tv/highlights/';
var BOXCAST_TV_VIDEO_PORTAL_URL = 'https://dev.boxcast.tv/video-portal/';
var IMG_ROOT = 'https://dashboard.dev.boxcast.com/img/';
var FACEBOOK_APP_ID = '252291028958723';
var STRIPE_KEY = 'pk_test_jJXNd6tHTMtwyQWWHE4lGQvJ';
var YOUTUBE_CLIENT_ID = '272935062177-t44tv0ss9scbhseoajt0ie36ucgt5gcv.apps.googleusercontent.com';
var YOUTUBE_OAUTH_REDIRECT = 'https://dashboard.dev.boxcast.com?oauth_reply_from=youtube';
var VIMEO_OAUTH_REDIRECT = 'https://dashboard.dev.boxcast.com?oauth_reply_from=vimeo';
var TWITTER_OAUTH_REDIRECT = 'https://dashboard.dev.boxcast.com/#/settings/twitter';
var DATADOG_LOGS_CLIENT_TOKEN = 'pubd6bf579ae45e618194ddc4138bd04efb';
var INTERCOM_APP_ID = 'qjlz07dd';
var CHURNZERO_APP_KEY = '1!Sw-b5h-HzZWfHO6BE4SCQz4QEghhWHmBMEvXDaeOYYotC65';
var VUE_DASHBOARD_ROOT = 'https://dashboard.dev.boxcast.com';
var NG_DASHBOARD_ROOT = 'https://dashboard.dev.boxcast.com';

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "API_ROOT", function() { return API_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTEGRATIONS_ROOT", function() { return INTEGRATIONS_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_URL", function() { return LOGIN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTH_URL", function() { return AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SWITCHER_AUTH_URL", function() { return SWITCHER_AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOKEN_URL", function() { return TOKEN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT_URL", function() { return LOGOUT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GEO_URL", function() { return GEO_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_ENV", function() { return BOXCAST_JS_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS", function() { return BOXCAST_JS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_EMBED_URL", function() { return BOXCAST_JS_EMBED_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_IFRAME_URL", function() { return BOXCAST_JS_IFRAME_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_APP_EMBED_URL", function() { return BOXCAST_JS_APP_EMBED_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYNDICATION_SERVICE_BASE_URL", function() { return SYNDICATION_SERVICE_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_SHOW_URL", function() { return BOXCAST_SHOW_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_SHOW_URL", function() { return BOXCAST_TV_SHOW_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_HIGHLIGHT_URL", function() { return BOXCAST_TV_HIGHLIGHT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_VIDEO_PORTAL_URL", function() { return BOXCAST_TV_VIDEO_PORTAL_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIDGET_JS", function() { return WIDGET_JS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IMG_ROOT", function() { return IMG_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BANDWIDTH_TEST_URL", function() { return BANDWIDTH_TEST_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GOOGLE_ANALYTICS_DOMAIN", function() { return GOOGLE_ANALYTICS_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FACEBOOK_APP_ID", function() { return FACEBOOK_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STRIPE_KEY", function() { return STRIPE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_CLIENT_ID", function() { return YOUTUBE_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_OAUTH_REDIRECT", function() { return YOUTUBE_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIMEO_OAUTH_REDIRECT", function() { return VIMEO_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TWITTER_OAUTH_REDIRECT", function() { return TWITTER_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATADOG_LOGS_CLIENT_TOKEN", function() { return DATADOG_LOGS_CLIENT_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTERCOM_APP_ID", function() { return INTERCOM_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHURNZERO_APP_KEY", function() { return CHURNZERO_APP_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VUE_DASHBOARD_ROOT", function() { return VUE_DASHBOARD_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_DASHBOARD_ROOT", function() { return NG_DASHBOARD_ROOT; });
var API_ROOT = 'https://rest.dev.boxcast.com'; //try {
//  localStorage.setItem('oauthToken', 'user');
//}catch(e){}
//export const API_ROOT = 'http://localhost:3000';

var INTEGRATIONS_ROOT = 'https://integration.dev.boxcast.com';
var LOGIN_URL = 'https://login.dev.boxcast.com';
var AUTH_URL = 'https://rest.dev.boxcast.com/oauth2/auth?response_type=code&client_id=nofi891dxx1qgy8rlpox&redirect_uri=http%3A%2F%2Flocalhost%3A8000%2F&scope=dashboard';
var SWITCHER_AUTH_URL = 'https://rest.dev.boxcast.com/oauth2/auth?response_type=code&client_id=glolh40ngfpuvh84jzc4&redirect_uri=https%3A%2F%2Fdashboard.dev.boxcast.com%2F&scope=owner';
var TOKEN_URL = 'https://rest.dev.boxcast.com/oauth2/token';
var LOGOUT_URL = 'https://rest.dev.boxcast.com/oauth2/auth/sessions/login/revoke';
var GEO_URL = 'https://geo.boxcast.com/json/';
var BOXCAST_JS_ENV = 'dev'; //export const BOXCAST_JS = `http://localhost:8000/build/v3.js`;

var BOXCAST_JS = "https://js.dev.boxcast.com/v3.min.js";
var BOXCAST_JS_EMBED_URL = '//js.dev.boxcast.com/v3.min.js';
var BOXCAST_JS_IFRAME_URL = 'https://dev.boxcast.tv/view-embed';
var BOXCAST_JS_APP_EMBED_URL = 'https://dev.boxcast.tv/embed-app.html';
var SYNDICATION_SERVICE_BASE_URL = 'https://syndication.dev.boxcast.com';
var BOXCAST_SHOW_URL = 'https://dev.boxcast.tv/channel/';
var BOXCAST_TV_SHOW_URL = 'https://dev.boxcast.tv/channel/';
var BOXCAST_TV_HIGHLIGHT_URL = 'https://dev.boxcast.tv/highlights/';
var BOXCAST_TV_VIDEO_PORTAL_URL = 'https://dev.boxcast.tv/video-portal/';
var WIDGET_JS = '//js.dev.boxcast.com/v2.widget.js';
var IMG_ROOT = 'https://dashboard.dev.boxcast.com/img/';
var BANDWIDTH_TEST_URL = 'https://w35c8wpq1bdd4z59brit.dev.boxcast.com';
var GOOGLE_ANALYTICS_DOMAIN = 'none'; // hack for testing localhost
//export const FACEBOOK_APP_ID = '1748352278729649'; // test app id

var FACEBOOK_APP_ID = '252291028958723';
var STRIPE_KEY = 'pk_test_jJXNd6tHTMtwyQWWHE4lGQvJ';
var YOUTUBE_CLIENT_ID = '272935062177-t44tv0ss9scbhseoajt0ie36ucgt5gcv.apps.googleusercontent.com';
var YOUTUBE_OAUTH_REDIRECT = 'http://localhost:8000?oauth_reply_from=youtube';
var VIMEO_OAUTH_REDIRECT = 'http://localhost:8000?oauth_reply_from=vimeo';
var TWITTER_OAUTH_REDIRECT = 'http://localhost:8000/#/settings/twitter';
var DATADOG_LOGS_CLIENT_TOKEN = 'pubd6bf579ae45e618194ddc4138bd04efb';
var INTERCOM_APP_ID = 'qjlz07dd';
var CHURNZERO_APP_KEY = '1!Sw-b5h-HzZWfHO6BE4SCQz4QEghhWHmBMEvXDaeOYYotC65';
var VUE_DASHBOARD_ROOT = 'http://localhost:8001';
var NG_DASHBOARD_ROOT = 'http://localhost:8000';

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "API_ROOT", function() { return API_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTEGRATIONS_ROOT", function() { return INTEGRATIONS_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_URL", function() { return LOGIN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTH_URL", function() { return AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SWITCHER_AUTH_URL", function() { return SWITCHER_AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOKEN_URL", function() { return TOKEN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT_URL", function() { return LOGOUT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GEO_URL", function() { return GEO_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS", function() { return BOXCAST_JS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_EMBED_URL", function() { return BOXCAST_JS_EMBED_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIDGET_JS", function() { return WIDGET_JS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_SHOW_URL", function() { return BOXCAST_SHOW_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_SHOW_URL", function() { return BOXCAST_TV_SHOW_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_HIGHLIGHT_URL", function() { return BOXCAST_TV_HIGHLIGHT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_VIDEO_PORTAL_URL", function() { return BOXCAST_TV_VIDEO_PORTAL_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IMG_ROOT", function() { return IMG_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BANDWIDTH_TEST_URL", function() { return BANDWIDTH_TEST_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STRIPE_KEY", function() { return STRIPE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FACEBOOK_APP_ID", function() { return FACEBOOK_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_CLIENT_ID", function() { return YOUTUBE_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_OAUTH_REDIRECT", function() { return YOUTUBE_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIMEO_OAUTH_REDIRECT", function() { return VIMEO_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TWITTER_OAUTH_REDIRECT", function() { return TWITTER_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATADOG_LOGS_CLIENT_TOKEN", function() { return DATADOG_LOGS_CLIENT_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTERCOM_APP_ID", function() { return INTERCOM_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHURNZERO_APP_KEY", function() { return CHURNZERO_APP_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VUE_DASHBOARD_ROOT", function() { return VUE_DASHBOARD_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_DASHBOARD_ROOT", function() { return NG_DASHBOARD_ROOT; });
var API_ROOT = 'https://rest.boxcast.com';
var INTEGRATIONS_ROOT = 'https://integration.boxcast.com';
var LOGIN_URL = 'https://login.boxcast.com';
var AUTH_URL = 'https://rest.boxcast.com/oauth2/auth?response_type=code&client_id=kgsyfw5lrhvrzu89gsaj&redirect_uri=https%3A%2F%2Fdashboard.boxcast.com%2F&scope=dashboard';
var SWITCHER_AUTH_URL = 'https://rest.boxcast.com/oauth2/auth?response_type=code&client_id=izon8vdwo6n9fvlrydfn&redirect_uri=https%3A%2F%2Fdashboard.boxcast.com%2F&scope=owner';
var TOKEN_URL = 'https://rest.boxcast.com/oauth2/token';
var LOGOUT_URL = 'https://rest.boxcast.com/oauth2/auth/sessions/login/revoke';
var GEO_URL = 'https://geo.boxcast.com/json/';
var BOXCAST_JS = '//js.boxcast.com/v3.min.js';
var BOXCAST_JS_EMBED_URL = '//js.boxcast.com/v3.min.js';
var WIDGET_JS = '//js.boxcast.com/v2.widget.js';
var BOXCAST_SHOW_URL = 'https://boxcast.tv/channel/';
var BOXCAST_TV_SHOW_URL = 'https://boxcast.tv/channel/';
var BOXCAST_TV_HIGHLIGHT_URL = 'https://boxcast.tv/highlights/';
var BOXCAST_TV_VIDEO_PORTAL_URL = 'https://boxcast.tv/video-portal/';
var IMG_ROOT = 'https://dashboard.boxcast.com/img/';
var BANDWIDTH_TEST_URL = 'https://w35c8wpq1bdd4z59brit.boxcast.com';
var STRIPE_KEY = 'pk_live_UJ0NcpFDJTsAbVzzYkcohioj';
var FACEBOOK_APP_ID = '1748343348730542';
var YOUTUBE_CLIENT_ID = '272935062177-4207ghd9v3a0ldpuo4o4a35meu9duvfc.apps.googleusercontent.com';
var YOUTUBE_OAUTH_REDIRECT = 'https://dashboard.boxcast.com?oauth_reply_from=youtube';
var VIMEO_OAUTH_REDIRECT = 'https://dashboard.boxcast.com?oauth_reply_from=vimeo';
var TWITTER_OAUTH_REDIRECT = 'https://dashboard.boxcast.com/#/settings/twitter';
var DATADOG_LOGS_CLIENT_TOKEN = 'puba616154f05271b073ae9c7b73917e92c';
var INTERCOM_APP_ID = 'n4ioj8zx';
var CHURNZERO_APP_KEY = '1!Sw-b5h-HzZWfHO6BE4SCQz4QEghhWHmBMEvXDaeOYYotC65';
var VUE_DASHBOARD_ROOT = 'https://dashboard.boxcast.com';
var NG_DASHBOARD_ROOT = 'https://dashboard.boxcast.com';

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = bootstrapOAuthTokenExchange;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(9);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }


var AUTOLOGIN_STATE = 'autologin';
function bootstrapOAuthTokenExchange() {
  // Decode query string
  var query = window.location.search.substring(1);
  var params = {};
  query.split('&').forEach(function (v) {
    var pair = v.split('=');
    params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }); // Look to see if we're being redirected here by a third-party oauth response

  if (params['oauth_reply_from']) {
    return handleThirdPartyResponse(params);
  } // Look to see if we're being redirected here by the BoxCast login redirect


  if (params['code'] && params['state']) {
    var authUrl = __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* isSwitcherStudioAppShell */] ? SWITCHER_AUTH_URL : AUTH_URL;
    authUrl.substring(authUrl.indexOf('?') + 1).split('&').forEach(function (v) {
      var pair = v.split('=');
      params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    });
    return handleLoginServerResponse(params);
  } else if (params['error']) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].clear();
    var error_url = LOGIN_URL + '/error?error=' + params['error'];
    if (params['error_description']) error_url += '&error_description=' + params['error_description'];
    if (params['error_hint']) error_url += '&error_hint=' + params['error_hint'];
    window.location.replace(error_url);
    throw new Error('halt');
    return $.Deferred();
  } // Utilize redirect-dance and localStorage to authenticate a user via OAuth
  // In some cases, we are embedded inside the Switcher Studio app; look there for a token as well.


  var token = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* getAuthToken */])(); // If we've gotten a token in the URL, grab it then kill the URL to remove visibilty of the token.

  var hashParams = _.object(_.map(window.location.hash.replace(/^#/, '').split('&'), function (e) {
    return e.split('=');
  }));

  if (hashParams['token_type'] == 'bearer') {
    token = hashParams['access_token'];

    if (token && token.length > 0) {
      console.log('Token captured; resuming normal activity');

      if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* isSwitcherStudioAppShell */]) {
        document.switcherStudioAccessToken = token;
        __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].setPromise('oauthToken', token).then(function () {
          window.location.replace('/#/switcher-studio');
        });
        return;
      } else {
        __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].set('oauthToken', token);
        var path = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].get('oauthPath') || hashParams['path'] && decodeURIComponent(hashParams['path']) || '/';
        __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].remove('oauthPath');
        window.location.replace(path);
      }
    }
  }

  if (token) {
    // all good, move along
    __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].bumpLoggedInCookie();
    return;
  } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* isSwitcherStudioAppShell */]) {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].getPromise('oauthToken').then(function (token) {
      if (token) {
        document.switcherStudioAccessToken = token;
        window.location.replace('/#/switcher-studio');
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* gotoLogin */])('from storage lookup but missing token');
      }
    })["catch"](function (err) {
      console.error('Error looking for token', err);
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* gotoLogin */])('from token error: ' + err);
      throw err;
    });
  } else {
    // token not found, redirect over to login
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* gotoLogin */])('from token now found and not identified as switcher');
  }
}

function handleLoginServerResponse(params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].getPromise('oauthState').then(function (state) {
    if (params['state'] !== state && params['state'] != AUTOLOGIN_STATE) {
      console.error('Returned state', params['state'], 'does not match stored state', state);
      __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].remove('oauthState');
      __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].remove('oauthVerifier');
      __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].remove('oauthPath');
      throw new Error('Unable to complete login due to mismatched state.');
    }

    return __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].getPromise('oauthVerifier');
  }).then(function (verifier) {
    var code = params['code'];
    var data = 'grant_type=authorization_code&client_id=' + params['client_id'] + '&redirect_uri=' + params['redirect_uri'] + '&code=' + code;

    if (params['state'] != AUTOLOGIN_STATE) {
      data += '&code_verifier=' + verifier;
    }

    var post = $.ajax(TOKEN_URL, {
      method: 'POST',
      data: data
    });
    post.done(function (resp) {
      if (resp.token_type === 'bearer') {
        var token = resp.access_token;

        if (token && token.length > 0) {
          __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].set('oauthToken', token);
          __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].bumpLoggedInCookie();

          if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* isSwitcherStudioAppShell */]) {
            window.location.replace('/#/switcher-studio');
          } else {
            var path = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].get('oauthPath') || '/';
            __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].remove('oauthPath');
            window.location.replace(path);
          }

          throw new Error('halt');
        }
      }
    });
    post.fail(function (resp) {
      console.error('Error processing authorization callback: ', resp);
      var error = 'unknown_error';
      var error_description = 'An unknown error occurred; network status code ' + resp.status;
      var error_hint = '';
      var err = $.parseJSON(resp.responseText);

      if (_typeof(err) === 'object') {
        if (err['error']) error = err['error'];
        if (err['error_description']) error_description = err['error_description'];
        if (err['error_hint']) error_hint = err['error_hint'];
      }

      __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].clear();
      window.location.replace(LOGIN_URL + '/error?error=' + encodeURIComponent(error) + '&error_description=' + encodeURIComponent(error_description) + '&error_hint=' + encodeURIComponent(error_hint) + '&link=' + encodeURIComponent('Return to BoxCast Dashboard') + '&href=' + encodeURIComponent(window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')));
      throw new Error('halt');
    });
    return post;
  });
}

function handleThirdPartyResponse(params) {
  var thirdParty = params['oauth_reply_from'];

  switch (thirdParty) {
    case 'youtube':
      if (params['code']) {
        // Go to /settings/youtube with code
        var code = params['code'],
            l = window.location;
        window.location.replace("".concat(l.protocol, "//").concat(l.host).concat(l.pathname, "#/settings/youtube?code=").concat(code));
        throw 'halt';
      } else if (params['error']) {
        var error = params['error'],
            _l = window.location;
        window.location.replace("".concat(_l.protocol, "//").concat(_l.host).concat(_l.pathname, "#/settings/youtube?error=").concat(error));
        throw 'halt';
      } else {
        console.log("Missing 'code' parameter for YouTube oauth; going home.");
        window.location.replace('/');
        throw 'halt';
      }

      break;

    case 'vimeo':
      if (params['code']) {
        // Go to /settings/vimeo with code
        var _code = params['code'],
            _l2 = window.location;
        window.location.replace("".concat(_l2.protocol, "//").concat(_l2.host).concat(_l2.pathname, "#/settings/vimeo?code=").concat(_code));
        throw 'halt';
      } else {
        console.log("Missing 'code' parameter for Vimeo oauth; going home.");
        window.location.replace('/');
        throw 'halt';
      }

      break;

    default:
      console.log("Unknown thirdParty oauth provider: ".concat(thirdParty, "; going home."));
      window.location.replace('/');
      throw 'halt';
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(269);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!../postcss-loader/index.js!./normalize.css", function() {
			var newContent = require("!!../css-loader/index.js!../postcss-loader/index.js!./normalize.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css */\n\n/**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */\n\nhtml {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}\n\n/**\n * Remove the margin in all browsers (opinionated).\n */\n\nbody {\n  margin: 0;\n}\n\n/* HTML5 display definitions\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */\n\narticle,\naside,\ndetails, /* 1 */\nfigcaption,\nfigure,\nfooter,\nheader,\nmain, /* 2 */\nmenu,\nnav,\nsection,\nsummary { /* 1 */\n  display: block;\n}\n\n/**\n * Add the correct display in IE 9-.\n */\n\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in iOS 4-7.\n */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  vertical-align: baseline;\n}\n\n/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */\n\ntemplate, /* 1 */\n[hidden] {\n  display: none;\n}\n\n/* Links\n   ========================================================================== */\n\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\n\na {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}\n\n/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */\n\na:active,\na:hover {\n  outline-width: 0;\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */\n\nb,\nstrong {\n  font-weight: inherit;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * Add the correct font style in Android 4.3-.\n */\n\ndfn {\n  font-style: italic;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/**\n * Add the correct background and color in IE 9-.\n */\n\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Remove the border on images inside links in IE 10-.\n */\n\nimg {\n  border-style: none;\n}\n\n/**\n * Hide the overflow in IE.\n */\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct margin in IE 8.\n */\n\nfigure {\n  margin: 1em 40px;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Restore the font weight unset by the previous rule.\n */\n\noptgroup {\n  font-weight: bold;\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\nhtml [type=\"button\"], /* 1 */\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * Remove the default vertical scrollbar in IE.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */\n\n::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n", ""]);

// exports


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var authModule = angular.module('app.auth', []);

__webpack_require__(271);

__webpack_require__(272);

/* harmony default export */ __webpack_exports__["a"] = (authModule);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_basil_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_basil_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_basil_js__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }




var AuthService = /*#__PURE__*/function () {
  // Interfaces with the API OAuth provider and utilizes localStorage
  // to persist the username/token on the client.
  // https://assets.boxcast.com/api/reference/#authentication
  function AuthService($http, $rootScope, Facebook) {
    'ngInject';

    _classCallCheck(this, AuthService);

    this.$http = $http;
    this.user = $rootScope.user;
    this.Facebook = Facebook;
  }

  _createClass(AuthService, [{
    key: "testAccessToken",
    value: function testAccessToken() {
      // The access token is limited in time, so we need to be able to check if
      // when it's no longer good. Hit the /account API endpoint to see if it's
      // expired.
      return this.$http.get(API_ROOT + '/account').then(function () {
        return true;
      })["catch"](function () {
        return false;
      });
    }
  }, {
    key: "initHttpAuthorzation",
    value: function initHttpAuthorzation() {
      // Stuff the auth header in the $http service so all other requests are automagically authorized
      this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.getAuthToken();
    }
  }, {
    key: "logout",
    value: function logout() {
      this.Facebook.logout();
      __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].clear();
      __WEBPACK_IMPORTED_MODULE_1_basil_js___default.a.cookie.set('bxe-logged-out', '1', {
        expireDays: 365,
        sameSite: 'none',
        secure: true,
        domain: 'boxcast.com'
      });
      location.replace(LOGOUT_URL);
      throw new Error('halt');
    }
  }]);

  return AuthService;
}(); // Register the service with angular


angular.module('app.auth').service('AuthService', AuthService);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(9);

angular.module('app.auth').config(function ($httpProvider) {
  'ngInject';

  $httpProvider.interceptors.push(function ($q, $window, $injector) {
    return {
      request: function request(config) {
        var token = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* getAuthToken */])();

        if (!token) {
          Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* gotoLogin */])('from interceptor missing token');
        }

        if (config.url.startsWith('http://localhost:3000')) {
          config.headers['Authorization'] = "Bearer user";
        } else if (config.headers['Ignore-Http-Interceptor-Auth'] || config.url.match('^https?://.*s3.amazonaws.com/.*')) {// Some requests need to be in public scope, use this header
          // to indiciate request to ignore the auto-injection
        } else {
          config.headers['Authorization'] = "Bearer ".concat(token);
        }

        return config;
      },
      responseError: function responseError(rejection) {
        if (rejection.status == 401 && rejection.data && rejection.data.error == 'invalid_token') {
          Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* gotoLogin */])('from interceptor 401');
        }

        return $q.reject(rejection);
      }
    };
  });
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__(274);

__webpack_require__(281); // create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons


var module = angular.module('app.directives', ['app.directives.checkout', 'app.directives.schedule']); // The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.

__webpack_require__(308);

__webpack_require__(309);

__webpack_require__(310);

__webpack_require__(311);

__webpack_require__(312);

__webpack_require__(314);

__webpack_require__(315);

__webpack_require__(316);

__webpack_require__(317);

__webpack_require__(318);

__webpack_require__(319);

__webpack_require__(320);

__webpack_require__(321);

__webpack_require__(322);

__webpack_require__(323);

__webpack_require__(324);

__webpack_require__(325);

__webpack_require__(326);

__webpack_require__(183);

__webpack_require__(327);

__webpack_require__(328);

__webpack_require__(329);

__webpack_require__(333);

__webpack_require__(335);

__webpack_require__(337);

__webpack_require__(339);

__webpack_require__(340);

__webpack_require__(341);

__webpack_require__(342);

__webpack_require__(343);

__webpack_require__(345);

__webpack_require__(346);

__webpack_require__(347);

__webpack_require__(348);

__webpack_require__(352);

__webpack_require__(353);

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.directives.checkout', []);

__webpack_require__(275);

__webpack_require__(276);

__webpack_require__(277);

__webpack_require__(278);

__webpack_require__(279);

__webpack_require__(280);

/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 275 */
/***/ (function(module, exports) {

angular.module('app.directives.checkout').directive('checkoutAddOns', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    controller: ["$scope", function controller($scope) {
      $scope.scoreboardAssistQuantity = 0;
    }],
    template: "\n        <div class=\"pricing-col encoder-options\" style=\"margin-bottom: 15px;\">\n          <div class=\"add-on-container\">\n            <div ng-repeat=\"addOn in vm.addOns\">\n              <p class=\"price\" style=\"text-align: right;\" ng-hide=\"addOn.monthlyCost == 0\">{{ addOn.monthlyCost | currency }}/mo.\n              <span ng-hide=\"addOn.priceSubtext == ''\" style=\"font-size:12px; font-weight:normal\"><br>{{ addOn.priceSubtext }}</span></p>\n              <div class=\"checkbox\" style=\"margin-bottom:25px\" ng-if=\"vm.checkPlanRequirements(addOn.requirements.plan) && vm.checkEncoderRequirements(addOn.requirements.encoder)\">\n              <label ng-if=\"addOn.enabled\">\n                    <input type=\"checkbox\" name=\"{{ addOn.title }}\" ng-model=\"addOn.selected\" ng-value=\"addOn.title\">\n                    {{ addOn.title }}\n                </label>\n                <label ng-if=\"!addOn.enabled\" style=\"cursor: not-allowed\">\n                  <input type=\"checkbox\" name=\"{{ addOn.title }}\" ng-model=\"addOn.selected\" ng-value=\"addOn.title\" ng-disabled=\"true\">\n                  {{ addOn.title }}\n                </label>\n                <div class=\"subtext\" ng-if=\"addOn.enabled\">{{ addOn.description }}</div>\n                <div class=\"subtext\" ng-if=\"!addOn.enabled\">{{ addOn.description }} <br>                  \n                  <a href=\"javascript://\" ng-click=\"vm.popChatOrSchedule()\">Contact sales for help getting this add-on.</a>\n                </div>\n                <div class=\"subtext\" style=\"font-weight: bold; margin-top:8px;\" ng-if=\"addOn.costPerStream\">This add-on applies to all streams in a plan.</div>\n                <div ng-if=\"addOn.selected && addOn.quantityInput \" class=\"subtext add-on-quantity\">\n                  <input type=\"number\" name=\"{{ addOn.varName }}_quantity\" step=\"1\" ng-model=\"addOn.quantity\" min=\"1\" max=\"10\">\n                  <div class=\"small-text\"><span style=\"font-weight:bold;\">{{addOn.quantityInputHeadline}}</span><br>\n                  {{addOn.quantityInputText[vm.selectedBasePlan]}}</div>\n                </div>\n                <div ng-if=\"addOn.selected && addOn.varName == 'scoreboard'\">\n                  <div class=\"subtext add-on-quantity\">\n                    <input type=\"number\" name=\"{{ addOn.varName }}_quantity\" step=\"1\" ng-model=\"addOn.oneTimeCost.quantity\" min=\"1\" max=\"10\">\n                    <div class=\"small-text\">\n                      <span style=\"font-weight:bold;\">{{addOn.quantityInputHeadline}}</span><br>\n                      {{addOn.quantityInputText[vm.selectedBasePlan]}}<br>\n                      <div class=\"text-danger\" style=\"padding-left:0;\">{{vm.scoreboardAssistProduct.checkout_message}}</div>\n                    </div>\n                  </div>\n                </div>\n                <div ng-if=\"addOn.varName == 'scoreboard'\" class=\"subtext add-on-alert\">\n                  <div>Sign up for BoxCast\u2019s Automatic Scoreboard Overlays and receive your first Scoreboard Assist free! Additional devices are $599 each.</div>\n                </div>\n              </div>\n                <div class=\"checkbox\" style=\"margin-bottom:25px\" ng-if=\"!vm.checkPlanRequirements(addOn.requirements.plan) || !vm.checkEncoderRequirements(addOn.requirements.encoder)\">\n                  <label>\n                  <input type=\"checkbox\" name=\"add_scoreboard\" ng-model=\"vm.addScoreboard\" value=\"add_scoreboard\" ng-disabled=\"true\" disabled=\"disabled\">\n                  {{ addOn.title }}\n                  </label>\n                <div class=\"subtext\">{{ addOn.description }}</div>\n                <div class=\"subtext text-danger\">{{addOn.title}} requires:</div>\n                <ul class=\"text-danger\">\n                    <li class=\"subtext\" ng-if=\"!vm.checkPlanRequirements(addOn.requirements.plan)\">The Experience Plan <span ng-click=\"vm.goto(1)\"><a href=\"javascript://\">Switch to The Experience Plan</a></span></li>\n                    <li class=\"subtext\" ng-if=\"!vm.checkEncoderRequirements(addOn.requirements.encoder)\">A BoxCaster or BoxCaster Pro <span ng-click=\"vm.goto(2)\"><a href=\"javascript://\">Add a BoxCaster</a></span></li>\n                </ul>\n              </div>\n            </div>\n          </div>\n        </div> "
  };
});

/***/ }),
/* 276 */
/***/ (function(module, exports) {

angular.module('app.directives.checkout').directive('checkoutBillingAddress', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    template: "\n<div class=\"form-group\">\n  <label for=\"address\" class=\"control-label\">Street Address</label>\n  <input ng-model=\"vm.billing.address\" id=\"bill_address\" name=\"address\" type=\"text\" class=\"form-control\" autocomplete=\"address\" placeholder=\"\" required>\n</div>\n<div class=\"row\">\n  <div class=\"col-md-6\">\n    <div class=\"form-group\">\n      <label for=\"city\" class=\"control-label\">City</label>\n      <input ng-model=\"vm.billing.city\" id=\"city\" name=\"city\" type=\"text\" class=\"form-control\" autocomplete=\"city\" placeholder=\"\" required>\n    </div>\n  </div>\n  <div class=\"col-md-6\">\n    <div class=\"form-group\">\n      <label for=\"state\" class=\"control-label\">State/Region</label>\n      <input ng-if=\"vm.billing.country != 'US'\"\n              ng-model=\"vm.billing.state\" id=\"state\" name=\"state\" type=\"text\" class=\"form-control\" autocomplete=\"state\" placeholder=\"\" required>\n      <select ng-if=\"vm.billing.country == 'US'\"\n              ng-model=\"vm.billing.state\"\n              ng-options=\"c.code as c.name for c in vm.states\"\n              id=\"state\" name=\"state\" class=\"form-control\" required>\n      </select>\n    </div>\n  </div>\n</div>\n<div class=\"row\">\n  <div class=\"col-md-6\">\n    <div class=\"form-group\">\n      <label for=\"zip\" class=\"control-label\">Postal Code</label>\n      <input ng-model=\"vm.billing.postal_code\"\n             id=\"zip\" name=\"zip\" type=\"text\" class=\"form-control\" autocomplete=\"zip\" placeholder=\"\" required>\n      <p ng-show=\"vm.salesTaxCents > 0\" class=\"help-block\">\n        Sales tax on the hardware purchase is required for this zip code. Your total has been updated to reflect this charge.\n      </p>\n    </div>\n  </div>\n  <div class=\"col-md-6\">\n    <div class=\"form-group\">\n      <label for=\"country\" class=\"control-label\">Country</label>\n      <select ng-model=\"vm.billing.country\"\n              ng-init=\"vm.billing.country = vm.billing.country || 'US'\"\n              ng-options=\"c.code as c.name for c in vm.countries\"\n              id=\"country\" name=\"country\" class=\"form-control\" required>\n      </select>\n    </div>\n  </div>\n</div>\n      "
  };
});

/***/ }),
/* 277 */
/***/ (function(module, exports) {

angular.module('app.directives.checkout').directive('checkoutFinal', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    controller: ["$scope", function controller($scope) {}],
    template: "\n    <div class=\"col-xs-12 text-center\" ng-show=\"vm.waitingForFinalization\">\n      <h3 style=\"margin-bottom:20px\">Please wait while we finalize your account</h3>\n      <p class=\"help-block\" style=\"font-size:1.4em;margin:40px 0;\">\n        <i class=\"fa fa-spin fa-spinner\"></i> Finalizing\n      </p>\n      <p class=\"help-block\" style=\"font-size:16px;margin-bottom:50px\">\n        Sit tight. It should only take a few more moments while we put the finishing touches on your account...\n      </p>\n    </div>\n    <div class=\"col-xs-12 text-center\" ng-hide=\"vm.waitingForFinalization\">\n      <div ng-show=\"vm.method == 'check' || vm.method == 'po'\">\n        <h3 style=\"margin-bottom:20px\">Thank you for completing your account setup.</h3>\n        <div class=\"bg-info text-info\" style=\"padding:10px;border-radius:4px;font-size:15px;margin:15px auto;max-width:300px;\">\n          <p ng-if=\"vm.method == 'check'\">Make checks payable to <strong>BoxCast</strong> and mail to:</p>\n          <p ng-if=\"vm.method == 'po'\">\n            Send in your purchase order by email to\n            <strong><a href=\"mailto:billing@boxcast.com\" target=\"_blank\">billing@boxcast.com</a></strong> or mail to:</p>\n            <strong>\n              BoxCast<br>\n              Attn: Payments Dept<br>\n              2401 Superior Viaduct<br>\n              Cleveland, OH 44113\n            </strong>\n          </p>\n        </div>\n        <p style=\"font-size:16px\">Once your payment is received, your account will be fully activated.</p>\n      </div>\n\n      <div ng-hide=\"vm.method == 'check' || vm.method == 'po'\">\n        <h3 style=\"margin-bottom:20px\">Welcome to BoxCast! You're now ready to stream!</h3>\n        <img src=\"/img/onboarding-celebrate.png\" style=\"width:40%\">\n      </div>\n\n      <p style=\"font-size:16px;margin:15px 100px 30px 100px;\">\n        If you have any questions, visit our\n        <a href=\"https://support.boxcast.com\" target=\"_blank\" style=\"border-bottom:1px solid;\">Support Center</a>\n        or connect with one of our live streaming experts. We're always here to help!\n      </p>\n\n      <a class=\"btn btn-primary btn-lg\" ng-click=\"vm.dismiss()\" style=\"margin-bottom:20px\">\n        Let's Go!\n      </a>\n    </div>\n"
  };
});

/***/ }),
/* 278 */
/***/ (function(module, exports) {

angular.module('app.directives.checkout').directive('checkoutOrderSummary', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    controller: ["$scope", function controller($scope) {
      var orderSummaryContainer = document.getElementById('order-summary-container');
      var SUMMARY_CONTAINER_CSS_MAX_HEIGHT = 182;

      $scope.scrollUp = function () {
        orderSummaryContainer.scrollBy(0, -20);
      };

      $scope.scrollDown = function () {
        orderSummaryContainer.scrollBy(0, 20);
      };

      $scope.scrollDownDisabled = function () {
        if (orderSummaryContainer.scrollHeight - orderSummaryContainer.scrollTop === orderSummaryContainer.clientHeight) {
          return true;
        }

        return false;
      };

      $scope.scrollUpDisabled = function () {
        $scope.summaryScrollTop = orderSummaryContainer.scrollTop;

        if ($scope.summaryScrollTop > 0) {
          return false;
        }

        return true;
      };

      $scope.scrollDisabled = function () {
        if (orderSummaryContainer.scrollHeight < SUMMARY_CONTAINER_CSS_MAX_HEIGHT) {
          return false;
        }

        return true;
      };
    }],
    template: "\n          <div style=\"border: 1px #ddd solid; border-radius:4px;padding:10px;\" class=\"order-summary\">\n            <div class=\"order-summary-head\">\n              <p class=\"text-left\" style=\"font-size:16px\">\n                Order Summary\n              </p>\n              <div class=\"order-summary-scroll btn-group btn-breadcrumb\" ng-if=\"scrollDisabled()\">\n                <button class=\"btn btn-xs btn-default\" ng-click=\"scrollUp()\" ng-disabled=\"scrollUpDisabled()\">\n                  <i class=\"fa fa-caret-up\"></i>\n                </button>\n                <button class=\"btn btn-xs btn-default\" ng-click=\"scrollDown()\" ng-disabled=\"scrollDownDisabled()\">\n                  <i class=\"fa fa-caret-down\"></i>\n                </button>\n              </div>\n            </div>\n            <div id=\"order-summary-container\">\n              <table class=\"table order-summary-table\" style=\"margin-bottom:0\">\n                <tbody>\n                  <tr>\n                    <th>BoxCast <span style=\"text-transform:capitalize\">{{vm.selectedBasePlan}}</span> Plan (Streaming Subscription)</th>\n                    <td class=\"text-right\">\n                      {{vm.selectedBasePlanAmount() | currency}}\n                    </td>\n                  </tr>\n                  <tr ng-if=\"vm.selectedEncoder == 'app'\">\n                    <th>Broadcaster App\n                      <div class=\"checkout-message\">Free download from the App Store</div>\n                    </th>\n                    <td class=\"text-right\">$0.00</td>\n                  </tr>\n                  <tr ng-if=\"vm.selectedEncoder == 'boxcaster'\">\n                    <th>BoxCaster<span ng-if=\"vm.boxcasterProduct.checkout_message\" class=\"checkout-message\"><br>{{vm.boxcasterProduct.checkout_message}}</span></th>\n                    <td class=\"text-right\">$399.00</td>\n                  </tr>\n                  <tr ng-if=\"vm.selectedEncoder == 'pro'\">\n                    <th>BoxCaster Pro<span ng-if=\"vm.boxcasterProProduct.checkout_message\" class=\"checkout-message\"><br>{{vm.boxcasterProProduct.checkout_message}}</span></th>\n                    <td class=\"text-right\">$2,995.00</td>\n                  </tr>\n                  <tr ng-if=\"vm.shurePromoApplied\">\n                    <th>Promo: FREE Shure MV88+ Video Kit</th>\n                    <td class=\"text-right\"><strike>$288.00</strike> FREE</td>\n                  </tr>\n                  <tr ng-repeat=\"addOn in vm.addOns\" ng-if=\"addOn.selected\">\n                    <th>{{ addOn[\"title\"] }}</th>\n                    <td class=\"text-right\">\n                      {{ vm.checkAddOnPrice(addOn) | currency }}\n                    </td>\n                  </tr>\n                  <tr ng-if=\"vm.addOns.scoreboard.selected\">\n                    <th>Scoreboard Assist <br> (First FREE) <span ng-if=\"vm.scoreboardAssistProduct.checkout_message\" class=\"checkout-message\"><br>{{vm.scoreboardAssistProduct.checkout_message}}</span></th>\n                    <td class=\"text-right\" ng-if=\"vm.addOns.scoreboard.oneTimeCost.quantity == 1\"><del>$599</del></td>\n                    <td class=\"text-right\" ng-if=\"vm.addOns.scoreboard.oneTimeCost.quantity > 1\">\n                      {{ vm.scoreboardAssistPrice(vm.addOns.scoreboard.oneTimeCost.quantity) | currency }}</td>\n                  </tr>\n                  <tr ng-if=\"vm.addOns.smartTVApps.selected\">\n                    <th>Smart TV App Setup</th>\n                    <td class=\"text-right\">$1000</td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>"
  };
});

/***/ }),
/* 279 */
/***/ (function(module, exports) {

angular.module('app.directives.checkout').directive('checkoutPaymentMethod', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    controller: ["$scope", "$rootScope", function controller($scope, $rootScope) {
      $scope.allowMonthlyChecks = $rootScope.account.extra_features.allow_monthly_checks;
    }],
    template: "\n<div class=\"row text-center\">\n  <div class=\"col-xs-6\" style=\"margin-bottom:10px;\">\n    <button type=\"button\"\n            class=\"btn btn-lg btn-default btn-block\"\n            ng-class=\"vm.method == 'cc' ? 'btn-payment-selected' : 'btn-payment'\"\n            ng-click=\"vm.onSelectPaymentMethod('cc')\">\n      <i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i><br>\n      Credit Card\n    </button>\n  </div>\n  <div class=\"col-xs-6\" style=\"margin-bottom:10px\">\n    <button type=\"button\"\n            class=\"btn btn-lg btn-default btn-block\"\n            ng-class=\"vm.method == 'ach' ? 'btn-payment-selected' : 'btn-payment'\"\n            ng-click=\"vm.onSelectPaymentMethod('ach')\">\n      <i class=\"fa fa-university\" aria-hidden=\"true\"></i><br>\n      Bank / ACH\n    </button>\n  </div>\n  <a ng-if=\"!vm.showAllPaymentOptions\" ng-hide=\"vm.selectedInterval == 'monthly' && !allowMonthlyChecks\" href=\"javascript://\"\n    class=\"pull-left\"\n    ng-click=\"vm.showAllPaymentOptions = true\"\n    style=\"font-size:10pt;padding-left:25px\">\n    More Payment Options\n  </a>\n  <div ng-if=\"vm.showAllPaymentOptions\">\n    <div class=\"col-xs-6\" style=\"margin-bottom:10px\">\n      <button type=\"button\"\n              class=\"btn btn-lg btn-default btn-block\"\n              ng-class=\"vm.method == 'po' ? 'btn-payment-selected' : 'btn-payment'\"\n              ng-click=\"vm.onSelectPaymentMethod('po')\">\n        <i class=\"fa fa-envelope-o\" aria-hidden=\"true\"></i><br>\n        Purchase Order\n      </button>\n    </div>\n    <div class=\"col-xs-6\" style=\"margin-bottom:10px\">\n      <button type=\"button\"\n              class=\"btn btn-lg btn-default btn-block\"\n              ng-class=\"vm.method == 'check' ? 'btn-payment-selected' : 'btn-payment'\"\n              ng-click=\"vm.onSelectPaymentMethod('check')\">\n        <i class=\"fa fa-money\" aria-hidden=\"true\"></i><br>\n        Check\n      </button>\n    </div>\n  </div>\n</div>\n<div ng-if=\"vm.method == 'cc'\">\n  <h3>Credit Card Details</h3>\n  <div ng-if=\"!vm.cardOnFile\">\n    <div class=\"form-control\"\n      style=\"height:38px;padding-top:10px;\"\n      ng-init=\"vm.stripeCard.mount('#stripe-elements-card')\">\n      <div id=\"stripe-elements-card\"></div>\n    </div>\n  </div>\n  <div ng-if=\"vm.cardOnFile\" style=\"margin:0 20px\">\n    <radio-button-well heading=\"Use Card On File\"\n                      is-selected=\"!vm.addNewCard\"\n                      on-select=\"vm.addNewCard = false\"\n                      always-show-transclude=\"true\">\n      <i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i> {{vm.cardOnFile.brand}} **** **** **** {{vm.cardOnFile.last4}}\n    </radio-button-well>\n    <radio-button-well heading=\"Add New Card\"\n                      is-selected=\"vm.addNewCard == true\"\n                      on-select=\"vm.addNewCard = true\">\n      <div class=\"form-control\"\n        style=\"height:38px;padding-top:10px;margin-bottom:15px;\"\n        ng-init=\"vm.stripeCard.mount('#stripe-elements-card')\">\n        <div id=\"stripe-elements-card\"></div>\n      </div>\n    </radio-button-well>\n  </div>\n</div>\n\n<div ng-if=\"vm.method == 'ach'\">\n  <h3>Bank Account Details</h3>\n  <div style=\"margin:0 20px\">\n    <div ng-if=\"vm.bankOnFile\">\n      <radio-button-well heading=\"Use Account On File\"\n                      is-selected=\"!vm.addNewBankAccount\"\n                      on-select=\"vm.addNewBankAccount = false\"\n                      always-show-transclude=\"true\">\n        <i class=\"fa fa-university\" aria-hidden=\"true\"></i> {{vm.bankOnFile.bank_name}} **** **** **** {{vm.bankOnFile.last4}}\n      </radio-button-well>\n    </div>\n    <radio-button-well heading=\"Link New Bank (ACH) Account\"\n                      is-selected=\"vm.addNewBankAccount == true\"\n                      on-select=\"vm.openPlaid()\">\n      <div ng-if=\"vm.newBankOnFile\">\n        <i class=\"fa fa-university\" aria-hidden=\"true\"></i> {{vm.newBankOnFile.bank_name}} **** **** **** {{vm.newBankOnFile.last4}}\n      </div>\n    </radio-button-well>\n  </div>\n</div>\n\n<div ng-if=\"vm.isUpgrade && (vm.method == 'cc' || vm.method == 'ach')\">\n  <p ng-if=\"vm.isChangingPaymentSource() && !vm.allowDefaultPaymentSourceOverride()\" style=\"margin:10px 0 0 0\">\n    This source will become your account's default payment source for all future invoices.\n  </p>\n  <p ng-if=\"vm.isChangingPaymentSource() && vm.allowDefaultPaymentSourceOverride()\" style=\"margin:0\">\n    <label style=\"margin-top:10px\">\n      <input name=\"change_default_payment_source\"\n              type=\"checkbox\"\n              ng-model=\"vm.changeDefaultPaymentSource\"\n              ng-init=\"vm.changeDefaultPaymentSource = true\">\n      Make this my default payment source for all future invoices.\n    </label>\n  </p>\n</div>\n\n<div class=\"bg-info text-info\" ng-if=\"vm.method == 'check' || vm.method == 'po' || vm.method == 'ach'\"\n      style=\"padding:15px;border-radius:4px;margin-top:20px;\">\n  <i class=\"fa fa-info-circle\"></i>\n  <span ng-if=\"vm.method == 'ach'\">\n    Bank / ACH payments take up to 7 days to process. \n  </span>\n  <span>\n    Your purchase will not be finalized and any hardware in your order will not be shipped until payment is received. \n  </span>\n  <span ng-if=\"vm.isTrial\">\n    This could result in your account becoming <b>inactive</b> once your trial expires.\n  </span>\n</div>\n      "
  };
});

/***/ }),
/* 280 */
/***/ (function(module, exports) {

angular.module('app.directives.checkout').directive('checkoutShippingAddress', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    template: "\n<div style=\"margin:15px 0;\">\n  <input ng-model=\"vm.shippingSameAsBilling\"\n          ng-init=\"vm.shippingSameAsBilling = true\"\n          type=\"checkbox\"\n          name=\"shipping_same_as_billing\">\n    Shipping address is same as billing.\n</div>\n<div ng-if=\"!vm.shippingSameAsBilling\">\n  <div class=\"form-group\">\n    <label for=\"address\" class=\"control-label\">Street Address</label>\n    <input ng-model=\"vm.shipping.address\" id=\"bill_address\" name=\"address\" type=\"text\" class=\"form-control\" autocomplete=\"address\" placeholder=\"\" required>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-xs-6\">\n      <div class=\"form-group\">\n        <label for=\"city\" class=\"control-label\">City</label>\n        <input ng-model=\"vm.shipping.city\" id=\"city\" name=\"city\" type=\"text\" class=\"form-control\" autocomplete=\"city\" placeholder=\"\" required>\n      </div>\n    </div>\n    <div class=\"col-xs-6\">\n      <div class=\"form-group\">\n        <label for=\"state\" class=\"control-label\">State/Region</label>\n        <input ng-if=\"vm.shipping.country != 'US'\"\n                ng-model=\"vm.shipping.state\" id=\"state\" name=\"state\" type=\"text\" class=\"form-control\" autocomplete=\"state\" placeholder=\"\" required>\n        <select ng-if=\"vm.shipping.country == 'US'\"\n                ng-model=\"vm.shipping.state\"\n                ng-options=\"c.code as c.name for c in vm.states\"\n                id=\"state\" name=\"state\" class=\"form-control\" required>\n        </select>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-xs-6\">\n      <div class=\"form-group\">\n        <label for=\"zip\" class=\"control-label\">Postal Code</label>\n        <input ng-model=\"vm.shipping.postal_code\" id=\"zip\" name=\"zip\" type=\"text\" class=\"form-control\" autocomplete=\"zip\" placeholder=\"\" required>\n      </div>\n    </div>\n    <div class=\"col-xs-6\">\n      <div class=\"form-group\">\n        <label for=\"country\" class=\"control-label\">Country</label>\n        <select ng-model=\"vm.shipping.country\"\n                ng-init=\"vm.shipping.country = vm.shipping.country || 'US'\"\n                ng-options=\"c.code as c.name for c in vm.countries\"\n                id=\"country\" name=\"country\" class=\"form-control\" required>\n        </select>\n      </div>\n    </div>\n  </div>\n</div>\n      "
  };
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.directives.schedule', []);

__webpack_require__(282);

__webpack_require__(284);

__webpack_require__(285);

__webpack_require__(287);

__webpack_require__(289);

__webpack_require__(291);

__webpack_require__(293);

__webpack_require__(295);

__webpack_require__(297);

__webpack_require__(299);

__webpack_require__(301);

__webpack_require__(302);

__webpack_require__(304);

__webpack_require__(306);

/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["controller"] = controller;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__ = __webpack_require__(15);

angular.module('app.directives.schedule').directive('broadcastOverlayConfiguration', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    template: __webpack_require__(283),
    controller: controller
  };
});

function renderSelectizeOption(wrapperCssClass) {
  return function (item, escape) {
    var html = "<div class=\"".concat(wrapperCssClass, "\" style=\"vertical-align: middle;\">");
    html += "<div style=\"display: inline-flex; float: left; width: 32px; height: 32px; margin-right: 6px;\">";

    if (item.value.type == 'scoreboard') {
      html += '<img src="/img/sports/scoreboard_icon.svg">';
    } else if (item.value.type == 'overlay') {
      html += '<img src="/img/sports/overlay_icon.svg">';
    }

    html += "</div>";
    html += "<div class=\"overflow-ellipse\" style=\"line-height:32px;\">".concat(item.name, "</div></div>");
    return html;
  };
}

function controller($scope, $timeout) {
  'ngInject';

  var vm = $scope.vm; // Use `sc` as a shortcut in controller and template

  $scope.sc = vm.service.broadcast.scoreboard_configuration;
  $scope.canDoOverlays = vm.service.FeatureFlags.overlays && vm.service.user.can('update', 'broadcast/*:metadata/overlays');
  $scope.options = {
    dropdown: [],
    selected: null,
    showScoreboardConfiguration: !!$scope.sc.sport,
    showOverlayConfiguration: !!(vm.service.broadcast.metadata.overlays || []).length
  };

  if (vm.service.showAnyScoreboards) {
    $scope.options.dropdown.push({
      name: 'Manual or Automatic Scoring',
      value: {
        type: 'scoreboard'
      }
    });
    $scope.options.dropdown.forEach(function (a) {
      return a.valueJson = JSON.stringify(a.value);
    });
  }

  $scope.$watch(function () {
    return vm.service.allowDefaultOverlay && vm.overlays && vm.overlays.length > 0;
  }, function (allowed) {
    if (allowed) {
      $scope.options.dropdown.push({
        name: 'Default Graphic Overlay (e.g. Logo or Branding)',
        value: {
          type: 'overlay'
        }
      });
      $scope.options.dropdown.forEach(function (a) {
        return a.valueJson = JSON.stringify(a.value);
      });
    }
  });
  var selectizeConfigBase = {
    valueField: 'valueJson',
    labelField: 'name',
    highlight: true,
    searchField: 'name',
    selectOnTab: true,
    closeAfterSelect: true,
    maxItems: 1,
    render: {
      option: renderSelectizeOption('source-chooser--option'),
      item: renderSelectizeOption('source-chooser--selected')
    },
    onInitialize: function onInitialize(selectize) {
      $scope.selectize = selectize;
    },
    onChange: function onChange(value) {
      if (!value) return;
      value = JSON.parse(value);
      $timeout(function () {
        if (value.type == 'scoreboard') {
          $scope.options.showScoreboardConfiguration = true;
        } else if (value.type == 'overlay') {
          $scope.options.showOverlayConfiguration = true;
        } else {
          console.warn('invalid item selected: ', value);
        }
      }, 0);
      $scope.selectize.clear();
      $timeout(function () {
        $scope.options.selected = null;
      }, 500);
    }
  };
  $scope.selectizeConfig = angular.extend({
    placeholder: 'Select Scoreboard and/or Graphic Overlay...'
  }, selectizeConfigBase);

  $scope.clearScoreboardConfig = function () {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__["a" /* clearScoreboardConfig */])($scope.sc);
    $scope.options.showScoreboardConfiguration = false;
  };

  $scope.clearOverlayConfig = function () {
    delete vm.service.broadcast.metadata.overlays;
    $scope.options.showOverlayConfiguration = false;
  };
}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"::canDoOverlays\" class=\"form-group clearfix\">\n  <label class=\"col-sm-4\">\n    Overlays\n    <i class=\"fa fa-question-circle\" style=\"font-size:12px;vertical-align:top\" uib-tooltip=\"Add a scoreboard overlay or default cloud graphic overlay to your broadcast\"></i>\n  </label>\n  <div class=\"col-sm-8 text-left\">\n    <select selectize ng-model=\"options.selected\" options=\"options.dropdown\" config=\"selectizeConfig\"></select>\n  </div>\n</div>\n\n<div ng-if=\"options.showScoreboardConfiguration || options.showOverlayConfiguration\">\n  <div class=\"form-group clearfix\" style=\"border-top:1px solid #eee\"></div>\n</div>\n\n<div ng-if=\"options.showScoreboardConfiguration\" class=\"form-group clearfix\" style=\"padding-bottom:15px; border-bottom:1px solid #eee;\">\n  <div class=\"col-sm-4\" style=\"padding-top:15px;font-weight:bold\">\n    <button type=\"button\" ng-click=\"clearScoreboardConfig()\" aria-label=\"Remove scoreboard configuration\" class=\"btn-link\" style=\"color:#999;font-weight:100;\">\n      <i class=\"fa fa-times\"></i>\n    </button> Scoreboard\n  </div>\n  <div class=\"col-sm-8\">\n    <scoreboard-tab-config vm=\"vm\" sc=\"sc\"></scoreboard-tab-config>\n  </div>\n</div>\n\n<div ng-if=\"options.showOverlayConfiguration\" class=\"form-group clearfix\" style=\"padding-bottom:15px; border-bottom:1px solid #eee;\">\n  <div class=\"col-sm-4\" style=\"padding-top:15px;font-weight:bold\">\n    <button type=\"button\" ng-disabled=\"vm.service.broadcast.id\" ng-click=\"clearOverlayConfig()\" aria-label=\"Remove overlay configuration\" class=\"btn-link\" style=\"color:#999;font-weight:100;\">\n      <i class=\"fa fa-times\"></i>\n    </button> Graphic Overlay\n  </div>\n  <div class=\"col-sm-8\">\n    <div class=\"form-group\" ng-if=\"vm.service.broadcast.id\">\n      <p class=\"help-block\">Please use the Overlays tab on the broadcast details page to edit your graphic overlays</p>\n    </div>\n    <div class=\"form-group\" ng-if=\"!vm.service.broadcast.id\">\n      <select class=\"form-control\"\n              ng-model=\"vm.selectedOverlay\"\n              ng-options=\"o as o.filename for o in vm.overlays\"\n              ng-change=\"vm.selectOverlay(vm.selectedOverlay)\">\n      </select>\n      <p class=\"help-block\" ng-show=\"vm.processingOverlay\">\n        <em>Processing overlay. Please wait...</em>\n      </p>\n      <overlay-preview ng-show=\"vm.service.broadcast.metadata.overlays.length\" overlay=\"vm.service.broadcast.metadata.overlays[0]\"></overlay-preview>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__ = __webpack_require__(15);

angular.module('app.directives.schedule').directive('broadcastSelectScoreboardConnection', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    controller: function controller($scope, $rootScope) {
      'ngInject';

      var vm = $scope.vm;
      $scope.options = __WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__["b" /* getUIConnections */]($rootScope.account);
      var selectizeConfigBase = {
        valueField: 'value',
        labelField: 'label',
        highlight: true,
        searchField: 'label',
        selectOnTab: true,
        closeAfterSelect: true,
        maxItems: 1,
        render: {
          option: renderSelectizeOption('source-chooser--option'),
          item: renderSelectizeOption('source-chooser--selected')
        }
      };
      $scope.selectizeConfig = angular.extend({
        placeholder: 'Select the Hardware Sending the Score Data...'
      }, selectizeConfigBase);
    },
    template: "\n      <div class=\"form-group\">\n        <label>Scoreboard Connection</label>\n        <select selectize ng-model=\"vm.service.broadcast.scoreboard_configuration.connection\" options=\"options\" config=\"selectizeConfig\"></select>\n      </div>\n      "
  };
});

function renderSelectizeOption(wrapperCssClass) {
  return function (item, escape) {
    var html = "<div class=\"selectize-option ".concat(wrapperCssClass, "\">");
    html += "<div class=\"selectize-option__icon-wrapper\">";

    if (item.icon) {
      html += '<img class="selectize-option__icon" src="' + item.icon + '">';
    }

    html += "</div>";
    html += "<div class=\"selectize-option__content\">";
    html += "<div class=\"selectize-option__label-wrapper\">";
    html += "<strong class=\"selectize-option__label\">".concat(item.label, "</strong>");

    if (item.is_new) {
      html += "<span class=\"selectize-option__label-indicator text-bx-green font-bold\">(NEW)</span>";
    }

    html += "</div>";
    html += "<small class=\"selectize-option__description\">".concat(item.description, "</small>");
    html += "</div>"; // end .selectize-option__content

    html += "</div>";
    return html;
  };
}

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__ = __webpack_require__(15);

angular.module('app.directives.schedule').directive('broadcastSelectSport', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    controller: function controller($scope) {
      'ngInject';

      $scope.scoreboard_configuration = $scope.vm.service.broadcast.scoreboard_configuration;
      $scope.sports = __WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__["c" /* getUISports */]();

      $scope.onChange = function (value) {
        __WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__["f" /* updateSportFromPrefix */]($scope.scoreboard_configuration, value);
        $scope.vm.service.updateScoreboardMakes();
      };
    },
    template: __webpack_require__(286)
  };
});

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <div class=\"sport-tiles\">\n    <div \n      class=\"sport-tile\"\n      ng-repeat=\"s in ::sports\" ng-if=\"s.value != 'Basketball (4 Quarters)'\"\n    >\n      <button \n        class=\"sport-tile__inner btn btn-default btn-block\"\n        type=\"button\" \n        ng-click=\"onChange(s.value)\"\n        ng-class=\"scoreboard_configuration.sport_prefix == s.value ? 'active' : ''\"\n      >\n        <img class=\"sport-tile__icon\" ng-src=\"{{::s.icon}}\">\n        <small class=\"sport-tile__label\">{{::s.label}}</small>\n      </button>\n    </div>\n  </div>\n  <div class=\"form-group\" ng-if=\"scoreboard_configuration.sport_prefix == 'Basketball'\">\n    <label>Basketball Game Format</label>\n    <div>\n      <div class=\"btn-group\">\n        <label class=\"btn btn-default\" ng-model=\"scoreboard_configuration.sport_variation\" uib-btn-radio=\"' (4 Quarters)'\">4 Quarters</label>\n        <label class=\"btn btn-default\" ng-model=\"scoreboard_configuration.sport_variation\" uib-btn-radio=\"' (2 Halves)'\">2 Halves</label>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('broadcastTeamColorPicker', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      team: '@',
      label: '@'
    },
    template: __webpack_require__(288),
    controller: ["$scope", "$rootScope", function controller($scope, $rootScope) {
      'ngInject';

      var account = $rootScope.account;
      $scope.colors = account.extra_features.scoreboard_spectrum ? SPECTRUM_COLOR_PALETTE : STANDARD_COLOR_PALETTE;

      $scope.select = function (color) {
        $scope.vm.service.broadcast.scoreboard_configuration[$scope.team + '_team_logo'] = color;
      };
    }]
  };
});

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports = "<label>{{label}}</label>\n\n<div class=\"btn-group btn-block\" style=\"overflow:hidden\" uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body>\n  <button type=\"button\" class=\"btn btn-default btn-block btn-color-picker\" uib-dropdown-toggle\n    style=\"text-shadow: rgb(0, 0, 0) 0px 0px 3px; color: rgb(255, 255, 255);\"\n    ng-style=\"{\n      'background-color': vm.service.broadcast.scoreboard_configuration[team+'_team_logo']\n    }\">\n    <span style=\"white-space:pre;font-family:monospace;\">{{vm.service.broadcast.scoreboard_configuration[team+'_team_name'] | scoreboardTeamName}}</span>\n    <span class=\"caret\"></span>\n  </button>\n  <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"split-button\"\n                                                          style=\"width:300px;z-index:1060\"><!-- z-index needs to be higher than uib-modal -->\n    <li role=\"menuitem\" class=\"clearfix\">\n      <div class=\"col-xs-6\">\n        <label>Team Name</label>\n        <input class=\"form-control\" ng-model=\"vm.service.broadcast.scoreboard_configuration[team+'_team_name']\">\n      </div>\n      <div class=\"col-xs-6\">\n        <label>Color Code</label> <i class=\"fa fa-pencil\" ng-click=\"allowEditing = !allowEditing\"></i>\n        <input class=\"form-control\" ng-disabled=\"!allowEditing\" ng-model=\"vm.service.broadcast.scoreboard_configuration[team+'_team_logo']\">\n      </div>\n    </li>\n    <li role=\"menuitem\">\n      <div class=\"clearfix\" style=\"padding:5px 0 0 5px; margin-top:15px;\">\n        <div ng-repeat=\"(c, label) in ::colors\" class=\"col-xs-4\" style=\"width:14.28%; padding:0 5px 5px 0\">\n          <a href ng-click=\"select(c)\">\n            <div style=\"background-color:{{c}};height:20px;\"></div>\n          </a>\n        </div>\n      </div>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('fbLiveSimulcastSettings', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      config: '='
    },
    template: __webpack_require__(290),
    controller: ["$scope", "$filter", function controller($scope, $filter) {
      'ngInject';

      function renderSelectizeOption(wrapperCssClass, dateFilter) {
        return function (item, escape) {
          var html = "<div class=\"".concat(wrapperCssClass, "\" style=\"vertical-align: middle;\">");

          if (item.cover) {
            html += "<div style=\"display: inline-flex; float: left; width: 32px; height: 18px; margin-right: 6px; background-size: cover; background-repeat: no-repeat; background-position: center; background-image: url('".concat(item.cover.source, "');\"></div>");
          }

          if (item.start_time) {
            html += "<div class=\"date-range\" style=\"display: inline-flex; float: right; margin-left: 3px;\">(".concat(dateFilter(item.start_time), ")</div>");
          }

          html += "<div class=\"overflow-ellipse\">".concat(item.name, "</div></div>");
          return html;
        };
      }

      var selectizeConfigBase = {
        valueField: 'id',
        labelField: 'name',
        highlight: true,
        searchField: 'name',
        selectOnTab: true,
        closeAfterSelect: true,
        maxItems: 1,
        render: {
          option: renderSelectizeOption('source-chooser--option', $filter('date')),
          item: renderSelectizeOption('source-chooser--selected', $filter('date'))
        }
      };
      $scope.pagesSelectizeConfig = angular.extend({
        placeholder: 'Select Page...'
      }, selectizeConfigBase);
      $scope.groupsSelectizeConfig = angular.extend({
        placeholder: 'Select Group...'
      }, selectizeConfigBase);
      $scope.eventsSelectizeConfig = angular.extend({
        placeholder: 'Select Event...'
      }, selectizeConfigBase);
    }]
  };
});

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"(vm.fb.connected || config.fb_feed_id)\" style=\"position:relative\">\n  <div class=\"btn-group\" style=\"display: flex; margin-bottom: 5px;\">\n    <label class=\"btn btn-sm btn-default\" ng-model=\"config.feed_type\" ng-change=\"vm.service.facebookFeedTypeChanged(config)\" ng-disabled=\"config.fb_status\" uib-btn-radio=\"'user:me'\">My Timeline</label>\n    <label class=\"btn btn-sm btn-default\" ng-model=\"config.feed_type\" ng-change=\"vm.service.facebookFeedTypeChanged(config)\" ng-disabled=\"config.fb_status\" uib-btn-radio=\"'page'\">Page</label>\n    <label class=\"btn btn-sm btn-default\" ng-model=\"config.feed_type\" ng-change=\"vm.service.facebookFeedTypeChanged(config)\" ng-disabled=\"config.fb_status\" uib-btn-radio=\"'group'\">Group</label>\n    <label class=\"btn btn-sm btn-default\" ng-model=\"config.feed_type\" ng-change=\"vm.service.facebookFeedTypeChanged(config)\" ng-disabled=\"config.fb_status\" uib-btn-radio=\"'event'\">Event</label>\n  </div>\n  <select selectize\n    ng-if=\"config.feed_type == 'page' && vm.fb.accounts.length\"\n    ng-disabled=\"config.fb_status\"\n    ng-model=\"config.feed_id\"\n    options=\"vm.fb.accounts\"\n    config=\"pagesSelectizeConfig\"></select>\n  <select selectize\n    ng-if=\"config.feed_type == 'group' && vm.fb.groups.length\"\n    ng-disabled=\"config.fb_status\"\n    ng-model=\"config.feed_id\"\n    options=\"vm.fb.groups\"\n    config=\"groupsSelectizeConfig\"></select>\n  <select selectize\n    ng-if=\"config.feed_type == 'event' && vm.fb.events.length\"\n    ng-disabled=\"config.fb_status\"\n    ng-model=\"config.feed_id\"\n    options=\"vm.fb.events\"\n    config=\"eventsSelectizeConfig\"></select>\n  <div class=\"help-block\" style=\"margin-bottom: 5px;\" ng-if=\"config.feed_type == 'page' && !vm.fb.accounts.length\">\n    No pages available\n    <i class=\"fa fa-question-circle\" uib-tooltip=\"Facebook returned no pages that can be used as a destination for live video.\"></i>\n  </div>\n  <div class=\"help-block\" style=\"margin-bottom: 5px;\" ng-if=\"config.feed_type == 'group' && !vm.fb.groups.length\">\n    No groups available\n    <i class=\"fa fa-question-circle\" uib-tooltip=\"Facebook returned no groups that can be used as a destination for live video.\"></i>\n  </div>\n  <div class=\"help-block\" style=\"margin-bottom: 5px;\" ng-if=\"config.feed_type == 'event' && !vm.fb.events.length\">\n    No events available\n    <i class=\"fa fa-question-circle\" uib-tooltip=\"Facebook returned no events that can be used as a destination for live video.\"></i>\n  </div>\n  <div class=\"btn-group\" style=\"display: flex;\" ng-if=\"config.feed_type == 'user:me'\">\n    <label class=\"btn btn-sm btn-default\" ng-model=\"config.fb_privacy\" ng-disabled=\"config.fb_status\" uib-btn-radio=\"'SELF'\">Only Me</label>\n    <label class=\"btn btn-sm btn-default\" ng-model=\"config.fb_privacy\" ng-disabled=\"config.fb_status\" uib-btn-radio=\"'ALL_FRIENDS'\">Friends</label>\n    <label class=\"btn btn-sm btn-default\" ng-model=\"config.fb_privacy\" ng-disabled=\"config.fb_status\" uib-btn-radio=\"'EVERYONE'\">Public</label>\n  </div>\n  <div ng-if=\"vm.fbLiveShowGlass(config)\"\n        class=\"text-center\"\n        style=\"position:absolute;z-index:2;left:0;right:0;top:0;bottom:0;background:rgba(0,0,0,0.5);color:#fff;\">\n    <h4>Connected to Facebook as {{vm.fb.me.name}} but settings were configured by Facebook user ({{config.fb_user_name}}).</h4>\n  </div>\n</div>\n<div ng-if=\"!vm.fb.connected\">\n  <div ng-if=\"vm.fb.loading\">\n    <small>Loading Facebook status... (Stuck? <a href=\"javascript://\" ng-click=\"vm.initFacebook()\">Try again</a>.)</small>\n  </div>\n  <div ng-if=\"!vm.fb.loading && !vm.fb.connected\">\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.loginFacebook()\">\n      <i class=\"fa fa-facebook-official\" style=\"width:20px\"></i> Log in to Facebook\n    </button>\n  </div>\n</div>\n"

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('hostRestrictionsSettings', function () {
  return {
    restrict: 'E',
    scope: {
      contentSettings: '='
    },
    template: __webpack_require__(292)
  };
});

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports = "<label ng-click=\"contentSettings.hostRestrictions = contentSettings.hostRestrictions ? null : {allowedHosts: [''], redirectUrl: ''}\" style=\"cursor:pointer\">\n  <i class=\"fa\" ng-class=\"contentSettings.hostRestrictions ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n  Enable Embedding Restrictions\n</label>\n<div ng-if=\"contentSettings.hostRestrictions.allowedHosts\">\n  <p>Allow player to be embedded only on the following hosts:</p>\n  <div class=\"form-group\" ng-repeat=\"_ in contentSettings.hostRestrictions.allowedHosts track by $index\">\n    <div class=\"input-group\">\n      <input required type=\"text\" class=\"form-control\" ng-model=\"contentSettings.hostRestrictions.allowedHosts[$index]\" placeholder=\"example.com\">\n      <div class=\"input-group-addon\">\n        <a href class=\"action-link\" ng-click=\"contentSettings.hostRestrictions.allowedHosts.splice($index, 1)\">\n          <i class=\"fa fa-trash\"></i>\n        </a>\n      </div>\n    </div>\n  </div>\n  <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"contentSettings.hostRestrictions.allowedHosts.push('')\">Add Another Host</button>\n  <p style=\"margin-top:15px\">If view attempted on disallowed host, redirect to the following base URL. Note that the broadcast slug will be appended to the URL.</p>\n  <input required type=\"text\" class=\"form-control\" ng-model=\"contentSettings.hostRestrictions.redirectUrl\" placeholder=\"https://www.example.com/watch-live?channel_path=\">\n  <p class=\"help-block\" ng-show=\"contentSettings.hostRestrictions.redirectUrl\" style=\"font-size:10px\">\n    Example redirect: <span>{{contentSettings.hostRestrictions.redirectUrl}}/example-broadcast-9999</span>\n  </p>\n</div>\n"

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('twitterSimulcastSettings', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      config: '='
    },
    template: __webpack_require__(294)
  };
});

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports = "<div style=\"position:relative\">\n  <div ng-if=\"!config.isHelpRow && vm.service.twitterUsers.length > 0\">\n    <div>\n      <select class=\"form-control\" ng-model=\"config.twitter_account_id\" required ng-disabled=\"config.status\">\n        <option ng-repeat=\"u in vm.service.twitterUsers\" value=\"{{u.id}}\">{{u.display_name}}</option>\n      </select>\n    </div>\n    <div style=\"margin:15px 0 5px 0\">\n      <span id=\"should_not_tweet\" ng-click=\"config.should_not_tweet = !config.should_not_tweet\" style=\"cursor:pointer;opacity:0.8\">\n        <i class=\"fa\" ng-class=\"config.should_not_tweet ? 'fa-square-o' : 'fa-check-square-o'\" style=\"width:20px\"></i>\n        <label for=\"should_not_tweet\">Tweet?</label>\n      </span>\n    </div>\n  </div>\n  <div ng-if=\"config.isHelpRow\">\n    <p class=\"help-block\"><small>\n      Before adding a Twitter destination, you must link your account in Settings &gt; Integrations.\n      Note: you can finish scheduling this broadcast now and then link your Twitter account by editing the broadcast.\n    </small></p>\n  </div>\n</div>\n"

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('podcastSettings', function () {
  return {
    restrict: 'E',
    scope: {
      broadcast: '=',
      onUploadPreviewImage: '&'
    },
    link: function link(scope, element, attrs) {
      // unwrap the function
      scope.onUploadPreviewImage = scope.onUploadPreviewImage();
    },
    template: __webpack_require__(296)
  };
});

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-sm-8\">\n    <div style=\"margin-bottom:10px\">\n      <label for=\"podcastSubtitle\">\n        Subtitle\n        <i class=\"fa fa-question-circle\" uib-tooltip=\"For best results, choose a subtitle that is only a few words long. Leave blank to use the broadcast description.\"></i>\n      </label>\n      <textarea class=\"form-control\" rows=\"2\" class=\"form-control\" id=\"podcastSubtitle\" ng-model=\"broadcast.content_settings.podcast_subtitle\" placeholder=\"{{ broadcast.description }}\"></textarea>\n    </div>\n    <div style=\"margin-bottom:10px\">\n      <label for=\"podcastSummary\">\n        Summary\n        <i class=\"fa fa-question-circle\" uib-tooltip=\"Leave blank to use the broadcast description.\"></i>\n      </label>\n      <textarea class=\"form-control\" rows=\"2\" class=\"form-control\" id=\"podcastSummary\" ng-model=\"broadcast.content_settings.podcast_summary\" placeholder=\"{{ broadcast.description }}\"></textarea>\n    </div>\n    <div style=\"margin-bottom:10px\">\n      <label ng-click=\"broadcast.content_settings.podcast_explicit = !broadcast.content_settings.podcast_explicit\" style=\"cursor:pointer\">\n        <i class=\"fa\" ng-class=\"broadcast.content_settings.podcast_explicit ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n        Explicit?\n      </label>\n    </div>\n  </div>\n  <div class=\"col-sm-4\">\n    <div style=\"margin-bottom:10px\">\n      <label>\n        Preview Image:\n        <i class=\"fa fa-info-circle\"\n            tooltip-append-to-body=\"true\"\n            uib-tooltip=\"Artwork must be a minimum size of 1400 x 1400 pixels and a maximum size of 3000 x 3000 pixels, in JPEG or PNG format, 72 dpi, with appropriate file extensions (.jpg, .png), and in the RGB colorspace.\"></i>\n      </label>\n      <div ng-if=\"broadcast.content_settings.podcast_preview\" class=\"text-center\">\n        <img ng-src=\"{{broadcast.content_settings.podcast_preview | trustedUrl}}\" class=\"img\" style=\"max-width:100%\">\n        <div><a href ng-click=\"broadcast.content_settings.podcast_preview = null\">Change</a></div>\n      </div>\n      <div ng-if=\"!broadcast.content_settings.podcast_preview\">\n        <upload-slot ng-model=\"podcastPreviewfile\"\n                    ng-change=\"onUploadPreviewImage(podcastPreviewfile)\"\n                    slot-name=\"'podcast-preview'\"\n                    allow-image=\"true\"\n                    allow-video=\"false\"\n                    compact=\"true\"></upload-slot>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('recurrencePattern', function () {
  return {
    restrict: 'E',
    template: __webpack_require__(298)
  };
});

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-xs-12\">\n    <div class=\"form-group\" style=\"margin-left:0;margin-right:0\">\n      <span ng-click=\"vm.recurring.enabled = !vm.recurring.enabled\" style=\"cursor:pointer;opacity:0.8\">\n        <i class=\"fa\" ng-class=\"vm.recurring.enabled ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n        Make This a Recurring Broadcast\n      </span>\n    </div>\n  </div>\n</div>\n<div class=\"row\" ng-if=\"vm.recurring.enabled\">\n  <div class=\"col-sm-4\">\n    <div class=\"form-group\" style=\"margin-left:0;margin-right:0\">\n      <select class=\"form-control\" ng-model=\"vm.recurring.pattern\">\n        <option value=\"day\">Daily</option>\n        <option value=\"week\">Weekly ({{vm.service.startDate | date:'EEEE'}}s)</option>\n        <option value=\"weekbyday\">Weekly (Custom)</option>\n        <option value=\"month\">Monthly ({{vm.service.startDate | daySuffix:false}})</option>\n      </select>\n    </div>\n  </div>\n  <div class=\"col-sm-8\" ng-if=\"vm.recurring.pattern == 'weekbyday'\">\n    <label><input type=\"checkbox\" value=\"0\" ng-checked=\"vm.recurring.onDays.indexOf(0) > -1\" ng-click=\"vm.toggleOnDays(0)\"> Sun</label>\n    <label><input type=\"checkbox\" value=\"1\" ng-checked=\"vm.recurring.onDays.indexOf(1) > -1\" ng-click=\"vm.toggleOnDays(1)\"> Mon</label>\n    <label><input type=\"checkbox\" value=\"2\" ng-checked=\"vm.recurring.onDays.indexOf(2) > -1\" ng-click=\"vm.toggleOnDays(2)\"> Tue</label>\n    <label><input type=\"checkbox\" value=\"3\" ng-checked=\"vm.recurring.onDays.indexOf(3) > -1\" ng-click=\"vm.toggleOnDays(3)\"> Wed</label>\n    <label><input type=\"checkbox\" value=\"4\" ng-checked=\"vm.recurring.onDays.indexOf(4) > -1\" ng-click=\"vm.toggleOnDays(4)\"> Thu</label>\n    <label><input type=\"checkbox\" value=\"5\" ng-checked=\"vm.recurring.onDays.indexOf(5) > -1\" ng-click=\"vm.toggleOnDays(5)\"> Fri</label>\n    <label><input type=\"checkbox\" value=\"6\" ng-checked=\"vm.recurring.onDays.indexOf(6) > -1\" ng-click=\"vm.toggleOnDays(6)\"> Sat</label>\n  </div>\n  <div class=\"col-sm-3\">\n    <div class=\"form-group\" style=\"margin-left:0;margin-right:0\">\n      <select class=\"form-control\" ng-model=\"vm.recurring.end\">\n        <option value=\"after\">Ending After</option>\n        <option value=\"on\">Ending On</option>\n      </select>\n    </div>\n  </div>\n  <div class=\"col-sm-2\" ng-show=\"vm.recurring.end == 'after'\">\n    <div class=\"form-group\" ng-class=\"{'has-error':vm.recurring.endCount > vm.MAX_RECURRING_EVENTS || !vm.isRecurringPatternValid()}\" style=\"margin-left:0;margin-right:0\">\n      <input ng-model=\"vm.recurring.endCount\" type=\"number\" class=\"form-control\" placeholder=\"# of occurences\">\n      <small ng-if=\"vm.recurring.endCount > vm.MAX_RECURRING_EVENTS\">\n      Max is 100\n      </small>\n    </div>\n  </div>\n  <div class=\"col-sm-2\" ng-show=\"vm.recurring.end == 'after'\">\n    <div class=\"form-group\" style=\"margin-left:-15px;margin-right:0;line-height:32px;\">\n      <small>Occurences</small>\n    </div>\n  </div>\n  <div class=\"col-sm-5\" ng-if=\"vm.recurring.end == 'on'\">\n    <div class=\"form-group\">\n      <div class=\"datepicker\"><!-- hack: need wrapper class to target custom styles -->\n        <uib-datepicker ng-model=\"vm.recurring.endDate\" datepicker-options=\"vm.service.datepickerOptions\"></uib-datepicker>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-sm-12\" style=\"margin-top:0;margin-bottom:15px;\" ng-if=\"vm.recurring.end == 'after'\">\n    <strong>Final broadcast date: </strong>{{vm.getPatternLastRecurringDate().toDate() | date}}\n  </div>\n  <div class=\"col-sm-12\" style=\"margin-top:0;margin-bottom:15px\" ng-if=\"!vm.isRecurringPatternValid()\">\n    <p class=\"text-danger\">\n      The source broadcast will be auto-deleted on {{vm.service.sourceBroadcast.storage_expires_at | date:'mediumDate'}} at {{vm.service.sourceBroadcast.storage_expires_at | date:'h:mm a'}}, before the final broadcast date.\n    </p>\n    <p class=\"text-danger\">\n      Please adjust your recurring schedule, or, change your <a href=\"/settings/storage\">Storage Policy</a> to \"Auto-Bill\" to retain your recordings for longer than {{vm.service.account.storage_duration_days|storageDuration}}.\n    </p>\n  </div>\n  <div class=\"col-sm-12\">\n    <p class=\"help-block\" style=\"margin-top:0;margin-bottom:15px\">\n      <small ng-if=\"vm.timezoneMatchesAccount === false\" class=\"text-warning\">\n        <i class=\"fa fa-warning\" style=\"width:15px;\"></i>\n        Your browser's time zone does not match your <a ui-sref=\"settings.my_account\">account settings</a>. Check the selection to ensure proper date handling during DST and other cases.<br>\n      </small>\n      <small>\n        <i class=\"fa fa-info-circle\" style=\"width:15px;\"></i>\n        Tip: Add the token <span style=\"font-family:monospace\">[date]</span> to the name or description and it will be filled-in for each broadcast.\n      </small>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('rtmpSimulcastSettings', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      config: '='
    },
    template: __webpack_require__(300)
  };
});

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = "<form name=\"simulcastForm\" role=\"form\">\n\n<div style=\"position:relative\">\n\n  <ol class=\"inline-tabs list-inline\" style=\"margin:0 0 15px 0\">\n    <li ng-class=\"config.destination == 'rtmp_push_channel' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"config.destination = 'rtmp_push_channel'\">\n        Multi-Use &nbsp;\n        <i class=\"fa fa-question-circle\" style=\"opacity:0.5\" uib-tooltip=\"Multi-Use RTMP destinations help if your URL and stream key do not change between multiple broadcasts.\" tooltip-append-to-body=\"true\"></i>\n      </a>\n    </li>\n    <li ng-class=\"config.destination == 'generic' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"config.destination = 'generic'\">\n        Single-Use &nbsp;\n        <i class=\"fa fa-question-circle\" style=\"opacity:0.5\" uib-tooltip=\"Single-Use RTMP destinations are best when you do not plan on reusing the same URL and stream key in the future.\" tooltip-append-to-body=\"true\"></i>\n      </a>\n    </li>\n  </ol>\n\n  <div ng-if=\"config.destination == 'rtmp_push_channel'\">\n    <div ng-if=\"vm.service.rtmpPushChannels.length\">\n      <div style=\"margin:0 0 15px 0\">\n        <label>Select RTMP Destination</label>\n        <select class=\"form-control\" ng-model=\"config.rtmp_push_channel_id\" required>\n          <option ng-repeat=\"c in vm.service.rtmpPushChannels\" value=\"{{c.id}}\">{{c.name}}</option>\n        </select>\n      </div>\n      <div style=\"margin:0 0 15px 0\">\n        <a href ng-click=\"vm.service.addNewMultiUseChannel(config)\">Or, add another multi-use destination...</a>\n      </div>\n    </div>\n    <div style=\"margin:0 0 15px 0\" ng-if=\"!vm.service.rtmpPushChannels.length\">\n      <a href ng-click=\"vm.service.addNewMultiUseChannel(config)\">Add a multi-use destination...</a>\n    </div>\n  </div>\n\n  <div ng-if=\"config.destination == 'generic'\">\n    <div style=\"margin:0 0 15px 0\">\n      <label>Server URL</label>\n      <input type=\"text\" class=\"form-control\" ng-model=\"config.stream_url\" id=\"stream_url\" name=\"stream_url\" not-boxcast placeholder=\"e.g. rtmp://rtmp.service.com/live\" required>\n      <p>\n        <span class=\"text-danger\" ng-if=\"simulcastForm.stream_url.$error.notBoxcast\">The stream URL cannot point to BoxCast.</span>\n      </p>\n    </div>\n    <div style=\"margin:0 0 15px 0\">\n      <label>Stream Key</label>\n      <input type=\"text\" class=\"form-control\" ng-model=\"config.stream_key\" id=\"stream_key\" name=\"stream_key\" maxlength=\"{{ ::vm.service.genericRTMPPushLimits.stream_key }}\" required>\n      <p ng-show=\"(simulcastForm.stream_key.$dirty || simulcastForm.stream_key.$touched) && !config.stream_key\">\n        <span class=\"text-danger\" ng-if=\"simulcastForm.stream_key.$error.maxlength\">The stream key is too long.</span>\n        <span class=\"text-danger\" ng-if=\"simulcastForm.stream_key.$error.required\">The stream key cannot be blank.</span>\n      </p>\n    </div>\n    <div style=\"margin:0 0 10px 0\">\n      <label>Max Resolution</label>\n      <select class=\"form-control\" ng-model=\"config.max_resolution\">\n          <option value=\"0\">None (use highest)</option>\n          <option value=\"1080\">1080p</option>\n          <option value=\"720\">720p</option>\n          <option value=\"480\">480p</option>\n        </select>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 301 */
/***/ (function(module, exports) {

angular.module('app.directives.schedule').directive('scoreboardConfigSummary', function () {
  return {
    restrict: 'E',
    scope: {
      service: '=',
      scoreboardConfiguration: '=',
      labelSuffix: '@',
      boldLabels: '=',
      boldValues: '='
    },
    controller: ["$scope", function controller($scope) {
      'ngInject';

      $scope.labelStyle = {
        'font-weight': $scope.boldLabels ? 'bold' : 'normal'
      };
      $scope.valueStyle = {
        'font-weight': $scope.boldValues ? 'bold' : 'normal'
      };
    }],
    template: "\n      <p ng-style=\"labelStyle\">Sport{{labelSuffix}}<br>\n        <em ng-if=\"!scoreboardConfiguration.sport\">No Sport Selected</em>\n        <span ng-style=\"valueStyle\" ng-if=\"scoreboardConfiguration.sport\">{{service.sports | getById:scoreboardConfiguration.sport:'value':'label'}}</strong>\n      </p>\n      <div ng-if=\"scoreboardConfiguration.sport\">\n        <p ng-style=\"labelStyle\">Scoreboard{{labelSuffix}}<br>\n          <em ng-if=\"scoreboardConfiguration.manual === undefined\">No Scoreboard</em>\n          <span ng-style=\"valueStyle\" ng-if=\"scoreboardConfiguration.manual === true\">Manual</span>\n          <span ng-style=\"valueStyle\" ng-if=\"scoreboardConfiguration.manual === false && scoreboardConfiguration.connection === 'scoreboard_assist'\">Scoreboard Assist</span>\n          <span ng-style=\"valueStyle\" ng-if=\"scoreboardConfiguration.manual === false && scoreboardConfiguration.connection === 'scorebot'\">Sportzcast ScoreBot {{sc.sportzcast_bot_number}}</span>\n          <span ng-style=\"valueStyle\" ng-if=\"scoreboardConfiguration.manual === false && scoreboardConfiguration.connection === 'scoreboard_adapter'\">\n            {{service.scoreboards | getById:scoreboardConfiguration.scoreboard_make:'value':'label'}} /\n            {{service.scoreboardModels | getById:scoreboardConfiguration.scoreboard_model:'value':'label'}}\n          </span>\n        </p>\n        <p ng-style=\"labelStyle\">Team{{labelSuffix}}<br>\n          <button type=\"button\" class=\"btn btn-default btn-sm btn-color-picker\" uib-dropdown-toggle\n            style=\"text-shadow: rgb(0, 0, 0) 0px 0px 3px; color: rgb(255, 255, 255);\"\n            ng-style=\"{'background-color': scoreboardConfiguration.home_team_logo}\">\n            <span style=\"white-space:pre;font-family:monospace;\">{{scoreboardConfiguration.home_team_name | scoreboardTeamName}}</span>\n          </button>\n          vs.\n          <button type=\"button\" class=\"btn btn-default btn-sm btn-color-picker\" uib-dropdown-toggle\n            style=\"text-shadow: rgb(0, 0, 0) 0px 0px 3px; color: rgb(255, 255, 255);\"\n            ng-style=\"{'background-color': scoreboardConfiguration.away_team_logo}\">\n            <span style=\"white-space:pre;font-family:monospace;\">{{scoreboardConfiguration.away_team_name | scoreboardTeamName}}</span>\n          </button>\n        </p>\n        <p ng-style=\"labelStyle\">Video Overlay{{labelSuffix}}<br>\n          <span ng-style=\"valueStyle\" style=\"text-transform:capitalize\">{{scoreboardConfiguration.overlay_location}}</span>\n        </p>\n        </p>\n      </div>\n      "
  };
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__ = __webpack_require__(15);

angular.module('app.directives.schedule').directive('scoreboardTabConfig', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      sc: '=',
      showClear: '@'
    },
    template: __webpack_require__(303),
    controller: function controller($scope) {
      'ngInject';

      $scope.clearScoreboardConfig = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__["a" /* clearScoreboardConfig */])($scope.sc);
      };
    }
  };
});

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = "<p ng-if=\"showClear\" class=\"pull-right\" style=\"margin:10px 0 0 0;\" ng-show=\"sc.sport || sc.sport_prefix || sc.sport_variation\">\n  <a href=\"javascript://\" ng-click=\"clearScoreboardConfig()\">Reset Scoreboard Configuration</a>\n</p>\n<uib-tabset active=\"sc.manual === false || !vm.service.showManualScoreboard ? 1 : 0\">\n  <uib-tab select=\"sc.manual = true\" index=\"0\" ng-if=\"vm.service.showManualScoreboard\">\n    <uib-tab-heading>\n      Manual\n    </uib-tab-heading>\n    <div class=\"tab-container clearfix\">\n      <broadcast-select-sport vm=\"vm\"></broadcast-select-sport>\n      <div class=\"row\" ng-if=\"sc.sport\" style=\"margin-bottom:15px\">\n        <div class=\"col-sm-3 col-xs-6\"><broadcast-team-color-picker vm=\"vm\" team=\"home\" label=\"Home\"></broadcast-team-color-picker></div>\n        <div class=\"col-sm-3 col-xs-6\"><broadcast-team-color-picker vm=\"vm\" team=\"away\" label=\"Away\"></broadcast-team-color-picker></div>\n        <div class=\"col-sm-6 col-xs-12\">\n          <label>Overlay Placement</label>\n          <div>\n            <div class=\"btn-group\">\n              <label class=\"btn btn-default\" ng-model=\"sc.overlay_location\" uib-btn-radio=\"'top'\">Top</label>\n              <label class=\"btn btn-default\" ng-model=\"sc.overlay_location\" uib-btn-radio=\"'bottom'\">Bottom</label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </uib-tab>\n  <uib-tab select=\"sc.manual = false\" index=\"1\" ng-if=\"vm.service.showAutomatedScoreboard || vm.service.showSportzcast\">\n    <uib-tab-heading>\n      Automated\n    </uib-tab-heading>\n    <div class=\"tab-container clearfix\">\n      <broadcast-select-sport vm=\"vm\"></broadcast-select-sport>\n      <div ng-if=\"sc.sport\">\n        <broadcast-select-scoreboard-connection vm=\"vm\"></broadcast-select-scoreboard-conection>\n      </div>\n      <div ng-if=\"!$root.account.has_scoreboard_assists && sc.connection == 'scoreboard_assist'\">\n        <div class=\"bg-danger text-danger\" style=\"padding:10px; border:1px solid; margin:15px 0\">\n          <small>Your account does not have a registered Scoreboard Assist.</small>\n        </div>\n      </div>\n      <div ng-if=\"!vm.service.isBoxCaster && (sc.connection == 'scoreboard_adapter' || sc.connection == 'scoreboard_assist')\">\n        <div class=\"bg-danger text-danger\" style=\"padding:10px; border:1px solid; margin:15px 0\">\n          <small>The selected scoreboard connection requires a BoxCaster source.</small>\n        </div>\n      </div>\n      <div ng-if=\"sc.connection == 'scorebot' && !vm.service.sportzcast.username\">\n        <div class=\"bg-danger text-danger\" style=\"padding:10px; border:1px solid; margin:15px 0\">\n          <small>\n            Your Sportzcast account has not yet been configured.<br>\n            <a ui-sref=\"settings.integrations\">Configure Scoreboard Integration</a>.\n          </small>\n        </div>\n      </div>\n      <div class=\"form-group\" ng-if=\"sc.connection == 'scorebot'\">\n        <label>ScoreBOT Number</label>\n        <div style=\"max-width:181px\">\n          <input type=\"number\" class=\"form-control\" ng-model=\"sc.sportzcast_bot_number\">\n        </div>\n        <p class=\"help-block\" ng-if=\"vm.service.sportzcast.username\"><small>Linked to Sportzcast account {{vm.service.sportzcast.username}}</small></p>\n      </div>\n      <div class=\"row\" ng-if=\"vm.service.isBoxCaster && sc.connection == 'scoreboard_adapter'\" style=\"margin-bottom:15px\">\n        <div ng-init=\"vm.service.updateScoreboardMakes()\"></div>\n        <div class=\"col-sm-6\">\n          <label for=\"scoreboard_make\">Scoreboard <span ng-show=\"vm.service.showScoreboardModel\">Make</span></label>\n          <select class=\"form-control\" id=\"scoreboard_make\"\n                  ng-model=\"sc.scoreboard_make\"\n                  ng-change=\"vm.service.updateScoreboardModels()\"\n                  ng-options=\"e.value as e.label for e in vm.service.scoreboardMakes\">\n            <option value=\"\">None Selected</option>\n          </select>\n        </div>\n        <div class=\"col-sm-6\" ng-if=\"vm.service.showScoreboardModel\">\n          <label for=\"scoreboard_model\">Scoreboard Model <i ng-show=\"sc.scoreboard_make\" class=\"fa fa-asterisk text-danger\" style=\"font-size:12px;vertical-align:top\"></i></label>\n          <select class=\"form-control\" id=\"scoreboard_model\"\n                  ng-disabled=\"!sc.scoreboard_make\"\n                  ng-model=\"sc.scoreboard_model\"\n                  ng-options=\"e.value as e.label for e in vm.service.scoreboardModels\">\n          </select>\n        </div>\n      </div>\n      <div class=\"row\" ng-if=\"sc.connection\" style=\"margin-bottom:15px\">\n        <div class=\"col-sm-3 col-xs-6\"><broadcast-team-color-picker vm=\"vm\" team=\"home\" label=\"Home\"></broadcast-team-color-picker></div>\n        <div class=\"col-sm-3 col-xs-6\"><broadcast-team-color-picker vm=\"vm\" team=\"away\" label=\"Away\"></broadcast-team-color-picker></div>\n        <div class=\"col-sm-6 col-xs-12\">\n          <label>Overlay Placement</label>\n          <div>\n            <div class=\"btn-group\">\n              <label class=\"btn btn-default\" ng-model=\"sc.overlay_location\" uib-btn-radio=\"'top'\">Top</label>\n              <label class=\"btn btn-default\" ng-model=\"sc.overlay_location\" uib-btn-radio=\"'bottom'\">Bottom</label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </uib-tab>\n</uib-tabset>\n"

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('simulcastConfigurationEditor', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      verticalForm: '='
    },
    template: __webpack_require__(305),
    controller: ["$scope", "$filter", "$timeout", function controller($scope, $filter, $timeout) {
      'ngInject';

      var service = $scope.vm.service;

      function renderSelectizeOption(wrapperCssClass, dateFilter) {
        return function (item, escape) {
          var html = "<div class=\"".concat(wrapperCssClass, "\" style=\"vertical-align: middle;\">");
          html += "<div style=\"display: inline-flex; float: left; width: 32px; height: 32px; margin-right: 6px;\">";

          if (item.value.type == 'facebook' || item.value.type == 'youtube' || item.value.type == 'twitter') {
            html += "<span style=\"border-radius:0;width:32px;height:32px;\" class=\"integration-badge integration-badge--".concat(item.value.type, "\"></span>");
          } else {
            html += "<span style=\"border-radius:0;width:32px;height:32px;\" class=\"integration-badge integration-badge--rtmp_push\">RTMP</span>";
          }

          html += "</div>";
          html += "<div class=\"overflow-ellipse\" style=\"line-height:32px;\">".concat(item.name, "</div></div>");
          return html;
        };
      }

      var selectizeConfigBase = {
        valueField: 'valueJson',
        labelField: 'name',
        highlight: true,
        searchField: 'name',
        selectOnTab: true,
        closeAfterSelect: true,
        maxItems: 1,
        render: {
          option: renderSelectizeOption('source-chooser--option', $filter('date')),
          item: renderSelectizeOption('source-chooser--selected', $filter('date'))
        },
        onInitialize: function onInitialize(selectize) {
          $scope.selectize = selectize;
        },
        onChange: function onChange(value) {
          if (!value) return;
          value = JSON.parse(value);
          $timeout(function () {
            $scope.vm.addSimulcastDestination(value.type, value);
          }, 0);
          $scope.selectize.clear();
          $timeout(function () {
            $scope.selectedAccount = null;
          }, 500);
        }
      };
      $scope.selectizeConfig = angular.extend({
        placeholder: 'Select Social Media and/or RTMP Destinations...'
      }, selectizeConfigBase);
      $scope.selectedAccount = {};
      $scope.allAccounts = [];
      service.destinationPromise.then(function () {
        if (service.allowFacebookLive) {
          // FIXME: consider listing all fb accounts here?
          $scope.allAccounts.push({
            name: 'Facebook',
            value: {
              type: 'facebook'
            }
          });
        }

        if (service.allowYoutubeLive) {
          if (service.youtubeUsers.length) {
            service.youtubeUsers.forEach(function (u) {
              $scope.allAccounts.push({
                name: "YouTube: ".concat(u.display_name),
                value: {
                  type: 'youtube',
                  id: u.id
                }
              });
            });
          } else {
            $scope.allAccounts.push({
              name: 'YouTube',
              value: {
                type: 'youtube',
                isHelpRow: true
              }
            });
          }
        }

        if (service.allowTwitter) {
          if (service.twitterUsers.length) {
            service.twitterUsers.forEach(function (u) {
              $scope.allAccounts.push({
                name: "Twitter: ".concat(u.display_name),
                value: {
                  type: 'twitter',
                  id: u.id
                }
              });
            });
          } else {
            $scope.allAccounts.push({
              name: 'Twitter',
              value: {
                type: 'twitter',
                isHelpRow: true
              }
            });
          }
        }

        if (service.allowGenericRtmpPush && service.rtmpPushChannels.length) {
          service.rtmpPushChannels.forEach(function (u) {
            $scope.allAccounts.push({
              name: "Other RTMP: ".concat(u.name),
              value: {
                type: 'rtmp_push_channel',
                id: u.id
              }
            });
          });
        }

        if (service.allowGenericRtmpPush) {
          $scope.allAccounts.push({
            name: 'Other RTMP (Single-Use)',
            value: {
              type: 'generic'
            }
          });
        }

        $scope.allAccounts.forEach(function (a) {
          a.valueJson = JSON.stringify(a.value);
        });
      });
    }]
  };
});

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"(vm.service.visibility == 'ticketed' || vm.service.visibility == 'flex')\">\n  <p class=\"help-block\">\n    <small>\n      Social media streaming is not allowed for ticketed or flex broadcasts.\n    </small>\n  </p>\n</div>\n\n<div class=\"form-group clearfix\" ng-if=\"verticalForm && vm.service.showAddSimulcast\">\n  <div class=\"col-xs-12\">\n    <label>\n      Destinations\n      <i class=\"fa fa-question-circle\" style=\"font-size:12px;vertical-align:top\" uib-tooltip=\"Simultaneously broadcast to multiple social media and/or RTMP destinations.  Visit Settings > Integrations to add a destination.\"></i>\n    </label>\n    <select selectize\n      ng-model=\"selectedAccount\"\n      options=\"allAccounts\"\n      config=\"selectizeConfig\"></select>\n  </div>\n</div>\n\n<div class=\"form-group clearfix\" ng-if=\"!verticalForm && vm.service.showAddSimulcast\">\n  <label class=\"col-sm-4\">\n    Destinations\n    <i class=\"fa fa-question-circle\" style=\"font-size:12px;vertical-align:top\" uib-tooltip=\"Simultaneously broadcast to multiple social media and/or RTMP destinations.  Visit Settings > Integrations to add a destination.\"></i>\n  </label>\n  <div class=\"col-sm-8 text-left\">\n    <select selectize\n      ng-model=\"selectedAccount\"\n      options=\"allAccounts\"\n      config=\"selectizeConfig\"></select>\n  </div>\n</div>\n\n<div ng-if=\"vm.service.broadcast.simulcast_configurations.length && !(vm.service.visibility == 'ticketed' || vm.service.visibility == 'flex')\" style=\"margin-bottom:15px;\">\n  <div class=\"form-group clearfix\" style=\"border-top:1px solid #eee\"></div>\n  <div class=\"form-group clearfix\"\n      ng-repeat=\"s in vm.service.broadcast.simulcast_configurations | orderBy:'-'\"\n      style=\"margin-top: 15px; padding-top:15px; padding-bottom:15px; border-bottom:1px solid #eee;\">\n    <div class=\"col-sm-4\" style=\"font-weight:bold\">\n      <button type=\"button\"\n              ng-click=\"vm.removeSimulcastDestination(s)\"\n              aria-label=\"Remove simulcast destination\"\n              class=\"btn-link\"\n              style=\"color:#999;font-weight:100;\"\n              >\n        <i class=\"fa fa-times\"></i>\n      </button>\n      {{ s.destination | simulcast_destination }}\n    </div>\n    <div class=\"col-sm-8\">\n      <fb-live-simulcast-settings ng-if=\"s.destination == 'facebook'\" vm=\"vm\" config=\"s\"></fb-live-simulcast-settings>\n      <youtube-live-simulcast-settings ng-if=\"s.destination == 'youtube'\" vm=\"vm\" config=\"s\"></youtube-live-simulcast-settings>\n      <rtmp-simulcast-settings ng-if=\"s.destination == 'generic' || s.destination == 'rtmp_push_channel'\" vm=\"vm\" config=\"s\"></rtmp-simulcast-settings>\n      <twitter-simulcast-settings ng-if=\"s.destination == 'twitter'\" vm=\"vm\" config=\"s\"></twitter-simulcast-settings>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('youtubeLiveSimulcastSettings', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      config: '='
    },
    template: __webpack_require__(307)
  };
});

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = "<div style=\"position:relative\">\n  <div ng-if=\"!config.isHelpRow && vm.service.youtubeUsers.length > 0\">\n    <div>\n      <select class=\"form-control\" ng-model=\"config.youtube_account_id\" required ng-disabled=\"config.status\">\n        <option ng-repeat=\"u in vm.service.youtubeUsers\" value=\"{{u.id}}\">{{u.display_name}}</option>\n      </select>\n    </div>\n    <div style=\"margin:15px 0 5px 0\">\n      <div class=\"btn-group\">\n        <label class=\"btn btn-default\" ng-model=\"config.privacy\" ng-disabled=\"config.status\" uib-btn-radio=\"'private'\">Private</label>\n        <label class=\"btn btn-default\" ng-model=\"config.privacy\" ng-disabled=\"config.status\" uib-btn-radio=\"'public'\">Public</label>\n        <label class=\"btn btn-default\" ng-model=\"config.privacy\" ng-disabled=\"config.status\" uib-btn-radio=\"'unlisted'\">Unlisted</label>\n      </div>\n    </div>\n  </div>\n  <div ng-if=\"config.isHelpRow\">\n    <p class=\"help-block\"><small>\n      Before adding a YouTube destination, you must link your account in Settings &gt; Integrations.\n      Note: you can finish scheduling this broadcast now and then link your YouTube account by editing the broadcast.\n    </small></p>\n  </div>\n</div>\n"

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_geo__ = __webpack_require__(27);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }


var REGION_CODES = null;
angular.module('app.directives').directive('analyticsGeoChart', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      analytics: '='
    },
    link: function link(scope, element, attrs, ngModelCtrl) {},
    controller: AnalyticsGeoController,
    controllerAs: 'vm',
    template: "\n        <style>\n        .leaflet-container {\n            width: 100%;\n            height: calc(33vw);\n            max-height: 300px;\n            min-height: 100px;\n        }\n        </style>\n        <link rel=\"stylesheet\" href=\"//cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/leaflet.css\" />\n        <div ng-if=\"!vm.geoPoints\">\n          <i class=\"fa fa-spin fa-spinner\"></i> Loading...\n        </div>\n        <div ng-if=\"vm.geoPoints && !vm.geoPoints.length\">\n          <p style=\"margin-top:15px;opacity:0.8;text-align:center;\">\n            No geographic data is available.\n          </p>\n        </div>\n        <div ng-if=\"vm.geoPoints && vm.geoPoints.length\">\n          <leaflet defaults=\"{scrollWheelZoom: false, maxZoom: 8}\"\n                    bounds=\"vm.bounds\"\n                    paths=\"vm.paths\"\n                    ng-if=\"vm.bounds\"></leaflet>\n        </div>\n      "
  };
});

var AnalyticsGeoController = /*#__PURE__*/function () {
  function AnalyticsGeoController($scope, $http) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, AnalyticsGeoController);

    this.$scope = $scope;
    this.$http = $http;

    if (REGION_CODES) {
      this.regionDict = REGION_CODES;
    } else {
      $http.get('/img/region_codes.json').then(function (response) {
        REGION_CODES = _this.regionDict = response.data;
        _this.analytics && _this.computeGeo();
      });
    }

    __webpack_require__.e/* require.ensure */(1).then((function () {
      window.leaflet = window.L = __webpack_require__(200);
      $scope.$evalAsync(function () {
        _this.analytics = $scope.analytics;
        _this.analytics && _this.computeGeo();
      });
      $scope.$watch('analytics', function (analytics) {
        _this.analytics = analytics;

        if (analytics) {
          _this.computeGeo();
        }
      });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }

  _createClass(AnalyticsGeoController, [{
    key: "computeGeo",
    value: function computeGeo() {
      var _this2 = this;

      this.geoPoints = [];
      var maxCount = 0,
          minCount = 0;

      _.each(this.analytics.view_counts_by_geohash, function (count, geohash) {
        if (!geohash) return;
        var pos = Object(__WEBPACK_IMPORTED_MODULE_0__utils_geo__["b" /* decodeGeohash */])(geohash);

        _this2.geoPoints.push({
          latitude: pos.latitude[0],
          longitude: pos.longitude[0],
          count: count
        });

        if (!count || count > maxCount) maxCount = count;
        if (!count || count < minCount) minCount = count;
      });

      this.geoPoints.forEach(function (p) {
        // compute radius ... linear distribution between 1,000 and 100,000
        // TODO: the min/max bounds should probably account for the average distance
        // between points (e.g. if on 2 sides of globe, make each cluster larger
        // than if just in 3-4 different counties in same state)
        var count = p.count,
            radius = 0;

        if (count == minCount) {
          radius = 1000;
        } else if (count == maxCount) {
          radius = 100000;
        } else {
          radius = (100000 - 1000) / (maxCount - minCount) * count;
        }

        p.geoRadius = Math.round(radius);
      });
      this.geoPoints = _.sortBy(this.geoPoints, 'count');
      this.geoPoints.reverse();
      this.fitMap();
    }
  }, {
    key: "fitMap",
    value: function fitMap() {
      var _this3 = this;

      var geoPoints = this.geoPoints;
      if (!geoPoints) return;
      this.bounds = {
        northEast: {
          lat: _.min(_.pluck(this.geoPoints, 'latitude')),
          lng: _.min(_.pluck(this.geoPoints, 'longitude'))
        },
        southWest: {
          lat: _.max(_.pluck(this.geoPoints, 'latitude')),
          lng: _.max(_.pluck(this.geoPoints, 'longitude'))
        }
      };
      this.paths = {};
      var i = 0;
      this.geoPoints.forEach(function (p) {
        _this3.paths["path".concat(i++)] = {
          type: 'circle',
          color: '#5DA5DA',
          weight: '2',
          radius: parseInt(p.geoRadius, 10),
          latlngs: {
            lat: p.latitude,
            lng: p.longitude
          }
        };
      });
    }
  }]);

  return AnalyticsGeoController;
}();

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// directive
//   <authorize-account-form />
//
// Presented when the account has limited capabilities and needs to be authorized
// in order to proceed. Fires off an API call to begin authorization and presents
// a confirmation.
angular.module('app.directives').component('authorizeAccountForm', {
  restrict: 'E',
  template: "\n    <form>\n      <div class=\"form-group\">\n        <label for=\"eventName\">Organization Name <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"eventName\" ng-model=\"vm.service.broadcast.name\" required>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"eventName\">Organization Phone Number <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"eventName\" ng-model=\"vm.service.broadcast.name\" required>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"eventName\">Organization Web Site <span class=\"text-muted\" style=\"font-weight:normal\">(optional)</span></label>\n        <input type=\"text\" class=\"form-control\" id=\"eventName\" ng-model=\"vm.service.broadcast.name\" required>\n      </div>\n      <div class=\"form-group\" style=\"margin-top:15px\">\n        <span ng-click=\"vm.scheduleAgain = !vm.scheduleAgain\" style=\"cursor:pointer;opacity:0.8;line-height:30px;\">\n          <i class=\"fa fa-2x\" ng-class=\"vm.scheduleAgain ? 'fa-check-square-o' : 'fa-square-o'\"\n            style=\"width:30px;line-height:30px;vertical-align:bottom;\"></i>\n          I am authorized to stream events for this organization.\n        </span>\n      </div>\n      <button type=\"button\" class=\"btn btn-success btn-block\" ng-click=\"vm.submit()\" ng-disabled=\"vm.submitting\">\n        <i ng-show=\"vm.submitting\" class=\"fa fa-spin fa-spinner\"></i>\n        Authorize Account\n      </button>\n    </form>\n  ",
  controllerAs: 'vm',
  controller: ["Account", "$http", "$timeout", function AuthorizeAccountFormController(Account, $http, $timeout) {
    'ngInject';
  }]
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fixManuallyEnteredColor"] = fixManuallyEnteredColor;
function fixManuallyEnteredColor(color) {
  color = _.trim(color || '');

  if (color) {
    if (color.indexOf('#') != 0) {
      color = '#' + color;
    }

    if (color.length == 4) {
      // convert shorthand hex
      color = color.replace(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i, function (str, m1, m2, m3) {
        return "#".concat(m1).concat(m1).concat(m2).concat(m2).concat(m3).concat(m3);
      });
    }

    if (color.length != 7) {
      // otherwise just pad with black colorspace and trim to length
      color = (color + '000000').substring(0, 7);
    }

    if (!color.match(/^#[0-9a-f]{6}$/i)) {
      throw new Error('invalid color');
    }
  }

  return color;
}
angular.module('app.directives').directive('boxcastColorPicker', function ($rootScope, toaster) {
  'ngInject';

  return {
    restrict: 'E',
    require: 'ngModel',
    scope: {
      ngModel: '=',
      defaultColor: '@'
    },
    link: function link(scope, element, attrs, ngModelCtrl) {
      if (!scope.ngModel) {
        scope.ngModel = scope.defaultColor;
      }

      scope.select = function (value) {
        ngModelCtrl.$modelValue = value;
        ngModelCtrl.$viewValue = value;
        ngModelCtrl.$render();
        scope.ngModel = value;
        scope.isopen = false;
      };

      scope.onBlurColorPicker = function (api, color, $event) {
        // After user input, validate and coerce to sane string prior to selecting
        try {
          scope.select(fixManuallyEnteredColor(color));
        } catch (e) {
          console.error(e);
          toaster.pop('warning', "Invalid color ".concat(color, ". It should be in the format of #ABCDEF."));
        }
      };

      scope.onChangeColorPicker = function (api, color, $event) {
        // Don't validate here; this is fired while typing
        scope.select(color);
      };
    },
    controller: function controller($scope, $rootScope) {
      var account = $rootScope.account;
      $scope.isopen = false;

      if (account.extra_features.scoreboard_spectrum) {
        $scope.useSpectrumPalette = true;
        $scope.colors = SPECTRUM_COLOR_PALETTE;
      }
    },
    template: "\n        <color-picker ng-hide=\"useSpectrumPalette\"\n                      ng-model=\"ngModel\"\n                      options=\"{\n                        format: 'hexString',\n                        alpha: false,\n                        swatch: true,\n                        swatchBootstrap: true,\n                        preserveInputFormat: true,\n                        allowEmpty: true,\n                        inputClass: 'form-control',\n                      }\"\n                      event-api=\"{\n                        onChange: onChangeColorPicker,\n                        onBlur: onBlurColorPicker,\n                      }\"\n        ></color-picker>\n\n        <div ng-show=\"useSpectrumPalette\" class=\"btn-group btn-block\" uib-dropdown is-open=\"isopen\">\n          <button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle style=\"text-align:left\">\n            <color-swatch color=\"ngModel\" label=\"\"></color-swatch>\n            {{colors[ngModel] || ngModel || 'Not Selected'}}\n            <i class=\"pull-right fa fa-caret-down\"></i>\n          </button>\n          <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" style=\"width:100%\">\n            <li role=\"menuitem\" ng-repeat=\"(c, label) in ::colors\">\n              <a href ng-click=\"select(c)\">\n                <color-swatch color=\"c\" label=\"\" style=\"display:inline-block;max-width:50px;margin-right:10px;overflow:hidden\"></color-swatch>\n                {{::label}}\n              </a>\n            </li>\n          </ul>\n        </div>\n      "
  };
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_allow_social__ = __webpack_require__(28);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 // player directive
//
//   <boxcast-player channel-id="channel_id" options="{ autostart: false, ... }" />
//
// makes sure the boxcast.js script (per config) is properly loaded, and then
// initializes the player widget for the specified channel with the specified
// configuration.

var module = angular.module('app.directives');
module.directive('boxcastPlayer', function ($q, $timeout, $rootScope) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      channelId: '=',
      options: '=',
      mode: '='
    },
    template: "<div id=\"{{playerElementId}}\"></div>",
    // XXX: HACK: need custom ID
    link: function link(scope, element, attrs) {
      var options = scope.options || {
        autostart: false
      };
      options.disableMetrics = $rootScope.user.is_impersonating;
      options.disableRedirectRulesOnLoad = true;
      options.playInline = true;

      if (BOXCAST_JS_ENV && !options.env) {
        options.env = BOXCAST_JS_ENV; //options.debug = (options.env == 'dev');
      }

      var showSocialShare = Object(__WEBPACK_IMPORTED_MODULE_0__utils_allow_social__["a" /* AllowSocial */])($rootScope.account.feature_flags, $rootScope.account, null);

      if (!showSocialShare) {
        options.showSocialShare = false;
      } else if (options.showSocialShare === undefined) {
        options.showSocialShare = true;
      }

      if (options.showSocialShare) {
        options.facebookAppId = FACEBOOK_APP_ID;
      } else {
        delete options.facebookAppId;
      } // Disable geoblock and password block (note that `null` doesn't work, we need something truthy)


      options.geoblock = {};
      options.cryptblock = {}; // XXX: passing in an element reference directly barfs when multiple
      // videos on same screen.  Let's generate a random element ID here.

      scope.playerElementId = "player-".concat(Math.random().toString(36).substring(8)); // Wait for the channel to become available; then load the
      // player (could take a few ticks if broadcast is resolved via promise)

      var loaded = false;
      var boxcastElement = null;
      var boxcastPlayer = null;
      scope.$watch('channelId', function (channelId) {
        if (channelId && !loaded) {
          boxcastElement = boxcast("#".concat(scope.playerElementId));

          if (scope.mode == 'highlight') {
            boxcastElement.loadHighlight(channelId, _objectSpread(_objectSpread({}, options), {}, {
              onLoadPlayer: function onLoadPlayer(player) {
                boxcastPlayer = player;
                options.onLoadPlayer && options.onLoadPlayer(player);
              }
            }));
          } else {
            boxcastElement.loadChannel(channelId, _objectSpread(_objectSpread({}, options), {}, {
              onLoadPlayer: function onLoadPlayer(player) {
                boxcastPlayer = player;
                options.onLoadPlayer && options.onLoadPlayer(player);
              }
            }));
          }

          loaded = true;
        }
      });
      scope.$on('player:pause', function () {
        return boxcastPlayer && boxcastPlayer.pause();
      }); // Handle a custom refresh meta event to refresh all our metadata

      scope.$on('boxcast:refreshMeta', function () {
        if (boxcastElement) {
          boxcastElement._boxcast.model.Actions.RefreshSelectedBroadcastMeta();
        }
      }); // Clean up after ourselves

      scope.$on('$destroy', function () {
        if (boxcastElement) {
          boxcastElement.unload();
        }

        element.remove();
      });
    }
  };
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_analytics__ = __webpack_require__(181);
// broadcast basic analytics directive
//
//   <broadcast-basic-analytics broadcast="vm.broadcast" />

var module = angular.module('app.directives');
module.component('broadcastBasicAnalytics', {
  bindings: {
    broadcast: '<'
  },
  template: __webpack_require__(313),
  controllerAs: 'vm',
  controller: function controller($scope, $rootScope, $timeout, AnalyticsResource) {
    'ngInject';

    var _this = this;

    this.hasAnalyticsFeature = !!$rootScope.account.feature_flags.analytics;
    this.canReadViewerAnalyticsReports = !!$rootScope.user.can('read', 'viewer-analytics/*');

    this.scheduleNextReload = function () {
      switch (_this.broadcast.timeframe) {
        case 'future': // fall-through

        case 'preroll':
          // If the broadcast hasn't started yet, reload at the start time (just in case they keep this tab open forever)
          var msUntilStart = moment().valueOf() - moment(_this.broadcast.starts_at).valueOf();
          $timeout.cancel(_this._reloadHandle);
          _this._reloadHandle = $timeout(function () {
            return _this.reloadAnalytics();
          }, msUntilStart);
          break;

        case 'current':
          // If we've already loaded analytics once, use the refresh interval; otherwise load once right away
          var msUntilLoad = _this.analytics ? REFRESH_INTERVAL_MS : 0;
          $timeout.cancel(_this._reloadHandle);
          _this._reloadHandle = $timeout(function () {
            return _this.reloadAnalytics();
          }, msUntilLoad);
          break;

        case 'past':
          // Only load the first time
          if (!_this.analytics) {
            // But if there's an error, delay the retry for the refresh interval
            var _msUntilLoad = _this.error ? REFRESH_INTERVAL_MS : 0;

            $timeout.cancel(_this._reloadHandle);
            _this._reloadHandle = $timeout(function () {
              return _this.reloadAnalytics();
            }, _msUntilLoad);
          } else {
            _this._reloadHandle = null;
          }

          break;
      }
    };

    this.reloadAnalytics = function () {
      AnalyticsResource.get({
        channel_id: _this.broadcast.channel_id,
        since: moment(_this.broadcast.starts_at).local().set({
          h: 0,
          m: 0,
          s: 0,
          ms: 0
        }).format('YYYY-MM-DDTHH:mm:ssZ'),
        until: moment().add(1, 'day').local().set({
          h: 0,
          m: 0,
          s: 0,
          ms: 0
        }).format('YYYY-MM-DDTHH:mm:ssZ'),
        include_viewer_timeseries: true
      }).$promise.then(function (a) {
        _this.analytics = a;

        _this.postProcessAnalytics();
      }, function (e) {
        console.error(e);
        _this.error = e;
      })["finally"](function () {
        _this.loading = false;

        _this.scheduleNextReload();
      });
    };

    this.hasViews = function () {
      return _this.broadcast.total_view_count > 0;
    };

    this.postProcessAnalytics = function () {
      // glue on computed fields
      _this.analytics.total_view_count = _this.analytics.live_view_count + _this.analytics.recorded_view_count;
      _this.analytics.total_view_duration = _this.analytics.live_view_seconds + _this.analytics.recorded_view_seconds;
      _this.analytics.avg_view_duration = _this.analytics.total_view_duration / _this.analytics.total_view_count;

      if (_this.analytics.live_buffer_seconds == 0 || _this.analytics.live_view_seconds == 0) {
        _this.analytics.live_rebuffer_pct = 0;
      } else {
        _this.analytics.live_rebuffer_pct = 100 * (_this.analytics.live_buffer_seconds / (_this.analytics.live_buffer_seconds + _this.analytics.live_view_seconds));
      }

      if (_this.analytics.recorded_buffer_seconds == 0 || _this.analytics.recorded_view_seconds == 0) {
        _this.analytics.recorded_rebuffer_pct = 0;
      } else {
        _this.analytics.recorded_rebuffer_pct = 100 * (_this.analytics.recorded_buffer_seconds / (_this.analytics.recorded_buffer_seconds + _this.analytics.recorded_view_seconds));
      } // Better formatting on hosts


      _this.analytics.hostData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_analytics__["c" /* normalizeHostData */])(_this.analytics);
      _this.insights = Object(__WEBPACK_IMPORTED_MODULE_0__utils_analytics__["a" /* computeInsights */])(_this.broadcast, _this.analytics);
      _this.analytics.view_counts_by_os = Object(__WEBPACK_IMPORTED_MODULE_0__utils_analytics__["d" /* normalizeOSs */])(_this.analytics.view_counts_by_os); // Viewer engagement graph

      _this.viewsLabels = _.map(_this.analytics.active_viewer_log, function (l) {
        return moment(l[0] * 1000);
      });
      _this.viewsData = [_.map(_this.analytics.active_viewer_log, function (l) {
        return l[1];
      })];

      if (_this.viewsLabels.length) {
        if (_this.viewsLabels[0].toDate() > moment(_this.broadcast.starts_at).toDate()) {
          // Insert an extra datapoint at exact beginning if it's not already there
          _this.viewsLabels.splice(0, 0, moment(_this.broadcast.starts_at));

          _this.viewsData[0].splice(0, 0, 0);
        }

        while (_.last(_this.viewsLabels).toDate() > moment(_this.broadcast.stops_at).toDate()) {
          // Kill off datapoints after end of broadcast
          _this.viewsLabels.splice(_this.viewsLabels.length - 1, 1);

          _this.viewsData[0].splice(_this.viewsData[0].length - 1, 1);
        }

        if (_this.broadcast.timeframe == 'current') {
          if (moment().toDate() > _.last(_this.viewsLabels).toDate()) {
            // Insert an extra datapoint at exact *now* to stretch the line
            _this.viewsLabels.push(moment());

            _this.viewsData[0].push(_this.broadcast.total_active_viewer_count);
          } // Insert an extra NaN datapoint at end of broadcast (draws no line but keeps x-axis


          _this.viewsLabels.push(moment(_this.broadcast.stops_at));

          _this.viewsData[0].push(null);
        } else {
          if (_.last(_this.viewsLabels).toDate() < moment(_this.broadcast.stops_at).toDate()) {
            // Insert an extra datapoint at exact end if it's not already there
            _this.viewsLabels.push(moment(_this.broadcast.stops_at));

            _this.viewsData[0].push(0);
          }
        }
      }
    };

    this.viewsOptions = {
      lineTension: 0,
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          gridLines: {
            color: '#FFF',
            zeroLineColor: '#FFF',
            drawTicks: false,
            drawBorder: false,
            tickMarkLength: 0
          },
          ticks: {
            suggestedMax: 10,
            beginAtZero: true,
            callback: function callback(value, index, values) {
              return Math.round(value);
            },
            fontFamily: 'Arial, sans-serif',
            fontSize: 11
          },
          stacked: true
        }],
        xAxes: [{
          type: 'time',
          time: {
            unit: 'minute'
          },
          gridLines: {
            display: false
          },
          position: 'bottom',
          ticks: {
            fontSize: 11,
            fontFamily: 'Arial, sans-serif',
            autoSkip: true
          }
        }]
      },
      tooltips: {
        callbacks: {//title: (items, data) => {
          //  return this.viewsLabels[items[0].index].format('ddd MMM Do');
          //}
        }
      },
      animation: {
        duration: 0
      }
    };
    this.datasetOverride = [{
      pointRadius: 0,
      pointHitRadius: 5,
      pointHoverRadius: 4,
      lineTension: 0,
      steppedLine: true
    }]; // Load full analytics data

    if (this.hasAnalyticsFeature) {
      // Only set loading = true the first time to show the loading panel. On refresh, we already have data to show.
      this.loading = true;
      this.scheduleNextReload();
      $scope.$on('$destroy', function () {
        return $timeout.cancel(_this._reloadHandle);
      });
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = "<style>\n.fa-facebook-official {\n  color:#275282;margin-right:5px\n}\n.fa-youtube-play {\n  color:red;margin-right:5px\n}\n</style>\n<div ng-if=\"vm.error\">\n  <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin:15px 0\">\n    There was an error loading the broadcast analytics.  Please refresh and try again.\n  </div>\n</div>\n<div ng-if=\"vm.loading\">\n  <i class=\"fa fa-spin fa-spinner\"></i> Loading analytics...\n</div>\n\n<div ng-if=\"vm.broadcast.id && !vm.loading && !vm.hasViews()\">\n  <div style=\"margin:50px 0;\" class=\"text-center\">\n    <i class=\"fa fa-4x fa-line-chart\" style=\"font-size:175px\"></i>\n    <h2 class=\"text-bx-accessible-grey\">There is no viewership reported for this broadcast yet.</h2>\n    <p><a ui-sref=\"resources\">Check out our resources section to learn how to promote your broadcasts!</a></p>\n  </div>\n</div>\n\n<div ng-if=\"vm.broadcast.id && !vm.loading && vm.hasViews()\">\n  <div class=\"row text-left\">\n    <div class=\"col-md-6 col-lg-3\">\n      <h4 style=\"font-weight:bold\">Live</h4>\n      <table style=\"width:100%\">\n        <tr style=\"font-weight:bold;\">\n          <td class=\"text-bx-accessible-grey text-xs\" style=\"width:50%\">VIEWS</td>\n          <td class=\"text-bx-accessible-grey text-xs\" style=\"width:50%\">AVG DURATION</td>\n        </tr>\n        <tr style=\"font-weight:bold;font-size:1.6em\">\n          <td>{{vm.broadcast.live_view_count|number}}</td>\n          <td>{{((vm.broadcast.live_minutes_viewed*60)/(vm.broadcast.live_view_count||1))|secondsFormatted:true:false}}</td>\n        </tr>\n      </table>\n    </div>\n    <div class=\"col-md-6 col-lg-3\" style=\"border-left:1px solid #eee;border-right:1px solid #eee\">\n      <div style=\"{{vm.broadcast.timeframe != 'past' ? 'opacity:0.2' : ''}}\">\n        <h4 style=\"font-weight:bold\">Recorded</h4>\n        <table style=\"width:100%\">\n          <tr style=\"font-weight:bold;\">\n            <td class=\"text-bx-accessible-grey text-xs\" style=\"width:50%\">VIEWS</td>\n            <td class=\"text-bx-accessible-grey text-xs\" style=\"width:50%\">AVG DURATION</td>\n          </tr>\n          <tr style=\"font-weight:bold;font-size:1.6em\">\n            <td>{{vm.broadcast.recorded_view_count|number}}</td>\n            <td>{{((vm.broadcast.recorded_minutes_viewed*60)/(vm.broadcast.recorded_view_count||1))|secondsFormatted:true:false}}</td>\n          </tr>\n        </table>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\">\n      <h4 style=\"font-weight:bold\">Total</h4>\n      <table style=\"width:100%\">\n        <tr style=\"font-weight:bold;\">\n          <td class=\"text-bx-accessible-grey text-xs\" style=\"width:25%\">VIEWS</td>\n          <td class=\"text-bx-accessible-grey text-xs\" ng-if=\"::vm.hasAnalyticsFeature\" style=\"width:25%\">UNIQUE</td>\n          <td class=\"text-bx-accessible-grey text-xs\" style=\"width:25%\">WATCH TIME</td>\n          <td class=\"text-bx-accessible-grey text-xs\" style=\"width:25%\">AVG DURATION</td>\n        </tr>\n        <tr style=\"font-weight:bold;font-size:1.6em\">\n          <td>{{vm.broadcast.total_view_count|number}}</td>\n          <td ng-if=\"::vm.hasAnalyticsFeature\">{{vm.analytics.unique_viewer_count|number}}</td>\n          <td>\n            <span ng-if=\"vm.broadcast.total_minutes_viewed <= 9999\">{{vm.broadcast.total_minutes_viewed|number:0}} <small class=\"text-bx-accessible-grey\">min</small></span>\n            <span ng-if=\"vm.broadcast.total_minutes_viewed > 9999\">{{(vm.broadcast.total_minutes_viewed / 60)|number:1}} <small class=\"text-bx-accessible-grey\">hr</small></span>\n          </td>\n          <td>\n            {{((vm.broadcast.total_minutes_viewed*60)/(vm.broadcast.total_view_count||1))|secondsFormatted:true:false}}\n          </td>\n        </tr>\n      </table>\n    </div>\n\n  </div>\n\n  <hr>\n\n  <div ng-if=\"::vm.hasAnalyticsFeature\">\n    <div ng-if=\"vm.broadcast.live_view_count > 0 && vm.viewsLabels.length\">\n      <h4 style=\"font-weight:bold\">Live Viewer Engagement</h4>\n      <div style=\"margin:0 -15px 15px\">\n        <canvas height=\"50\"\n            class=\"chart chart-line\"\n            chart-data=\"vm.viewsData\"\n            chart-labels=\"vm.viewsLabels\"\n            chart-options=\"vm.viewsOptions\"\n            chart-dataset-override=\"vm.datasetOverride\"></canvas>\n      </div>\n      <p ng-if=\"vm.insights.watchPercent > 0 && vm.broadcast.timeframe == 'past'\" style=\"margin-top:15px\">\n        <strong class=\"text-bx-accessible-grey\">INSIGHT</strong>\n        The average viewer watched <strong>{{vm.insights.watchPercent|number:0}}%</strong> of the broadcast.\n      </p>\n      <hr>\n    </div>\n    <div class=\"row text-left\">\n      <div class=\"col-sm-6\">\n        <h4 style=\"font-weight:bold\">Location</h4>\n        <analytics-geo-chart analytics=\"vm.analytics\" ng-if=\"vm.analytics\"></analytics-geo-chart>\n      </div>\n      <div class=\"col-sm-6\">\n        <h4 style=\"font-weight:bold\">Viewership by Destination</h4>\n        <table style=\"width:100%;line-height:2.0em\">\n          <tr class=\"font-bold text-bx-accessible-grey\">\n            <td>DESTINATION</td>\n            <td colspan=\"2\" class=\"text-right\">VIEWS</td>\n          </tr>\n          <tr ng-repeat=\"h in vm.analytics.hostData\">\n            <td>\n              <img src=\"/img/{{h.icon}}\" style=\"display:inline-block;height:15px;width:15px;margin-right:5px;\">\n              {{h.label}}\n            </td>\n            <td class=\"text-right\"><strong>{{h.value|number}}</strong></td>\n            <td class=\"text-bx-accessible-grey text-right\" style=\"width:1%;padding-left:10px;\">{{h.percent|number:1}}%</td>\n          </tr>\n        </table>\n      </div>\n    </div>\n    <div class=\"row text-left\" style=\"margin-top:15px\">\n      <div class=\"col-sm-6\">\n        <p ng-if=\"vm.insights.geo.states > 1\">\n          <strong class=\"text-bx-accessible-grey\">INSIGHT</strong>\n          You have viewers in\n          <span ng-if=\"vm.insights.geo.countries > 1\"><strong>{{vm.insights.geo.countries}} countries</strong> and</span>\n          <strong>{{vm.insights.geo.states}} states</strong>.\n        </p>\n      </div>\n      <div class=\"col-sm-6\">\n        <p ng-if=\"vm.insights.device\">\n          <strong class=\"text-bx-accessible-grey\">INSIGHT</strong>\n          Most viewers watch on <strong>{{vm.insights.device}}</strong>.\n        </p>\n      </div>\n    </div>\n\n    <hr>\n\n    <a class=\"btn btn-default btn-block overflow-ellipse\" ng-if=\"::vm.canReadViewerAnalyticsReports\" ui-sref=\"reports.viewer({report:'broadcasts',id:vm.broadcast.id})\" style=\"text-align:left\">\n      <i class=\"fa fa-line-chart\" style=\"width:20px\"></i>\n      View Detailed Analytics\n    </a>\n  </div><!--/vm.hasAnalyticsFeature-->\n\n  <div ng-if=\"::!vm.hasAnalyticsFeature\" style=\"position:relative\">\n    <div style=\"filter:blur(2px);padding:2px;\">\n      <h4 style=\"font-weight:bold\">Live Viewer Engagement</h4>\n      <div style=\"margin-botom:15px\">\n        <img class=\"img\" src=\"/img/sample-engagement.jpg\" style=\"width:100%\">\n      </div>\n      <p style=\"margin-top:15px\">\n        <strong style=\"color:#aaa\">INSIGHT</strong> The average viewer watched <strong>23%</strong> of the broadcast.\n      </p>\n      <hr>\n      <div class=\"row text-left\">\n        <div class=\"col-sm-6\">\n          <h4 style=\"font-weight:bold\">Location</h4>\n          <img class=\"img\" src=\"/img/sample-geo-location.jpg\" style=\"width:100%\">\n        </div>\n        <div class=\"col-sm-6\">\n          <h4 style=\"font-weight:bold\">Viewership by Source</h4>\n          <table style=\"width:100%;\">\n            <tr style=\"font-weight:bold;color:#aaa;\">\n              <td>DESTINATION</td>\n              <td>VIEWS</td>\n            </tr>\n            <tr><td>mywebsite.com</td><td><strong>1,000</strong> (60%)</td></tr>\n            <tr><td>boxcast.tv</td><td><strong>7000</strong> (30%)</td></tr>\n            <tr><td>BoxCast.tv for Roku</td><td><strong>200</strong> (10%)</td></tr>\n          </table>\n        </div>\n      </div>\n      <div class=\"row text-left\" style=\"margin-top:15px\">\n        <div class=\"col-sm-6\">\n          <p>\n            <strong style=\"color:#aaa\">INSIGHT</strong> You have viewers in <strong>2 countries</strong> and</span> <strong>25 states</strong>.\n          </p>\n        </div>\n        <div class=\"col-sm-6\">\n          <p>\n            <strong style=\"color:#aaa\">INSIGHT</strong> Most viewers watch on <strong>mobile devices</strong>.\n          </p>\n        </div>\n      </div>\n    </div>\n    <div class=\"text-center\"\n      style=\"position:absolute;z-index:1;top:0;left:0;bottom:0;right:0;background:rgba(255,255,255,0.75);padding-top:100px\">\n\n      <h3>Upgrade to Enhanced Analytics</h3>\n      <p><upgrade-button></upgrade-button></p>\n\n    </div>\n  </div><!--/!vm.hasAnalyticsFeature-->\n\n</div>\n"

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);
// directive
//   <broadcast-card broadcast="broadcast" />

var module = angular.module('app.directives');
module.directive('broadcastCard', function ($window, $timeout, $state, $filter, $rootScope) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      broadcast: '=',
      showViewCount: '=',
      extraCssClasses: '=',
      preventEdit: '=',
      onSelect: '&'
    },
    controller: BroadcastCardController,
    controllerAs: 'vm',
    template: "\n      <!-- go from 4-across to 2-across to 1-across -->\n      <div class=\"broadcast-card {{extraCssClasses}}\" style=\"padding: 10px 0;\">\n        <div class=\"col-xs-12\">\n          <div class=\"broadcast-card-image-wrapper\">\n            <div ng-click=\"vm.select()\">\n              <div class=\"broadcast-card-image-preview\" ng-style=\"{ 'background-image': 'url(&quot;'+broadcast.preview+'&quot;)' }\"></div>\n              <div class=\"broadcast-card-image-wrapper__message message\" ng-if=\"messageTitle\">\n                  {{messageTitle}}\n                  <div><small>{{messageDetails}}</small></div>\n              </div>\n              <div class=\"broadcast-card__stats view-stats\">\n                <div class=\"broadcast-card__stats__left pull-left\">\n                  <span class=\"broadcast-card__duration\">{{duration}}</span>\n                  <span class=\"broadcast-card__views-count\" ng-if=\"(broadcast.total_view_count !== null && showViewCount)\">\n                    | {{broadcast.total_view_count | number}} view{{ broadcast.total_view_count != 1 ? \"s\" : \"\" }}\n                  </span>\n                </div>\n                <div class=\"broadcast-card__stats__right pull-right\">\n                  <span ng-if=\"broadcast.is_ticketed\" class=\"broadcast-card__ticket-label label label-success\">${{broadcast.ticket_price | number:2}} / ticket</span>\n                  <span ng-if=\"broadcast.is_private\" class=\"broadcast-card__private-label label label-danger\">Private</span>\n                </div>\n                <div class=\"clearfix\"></div>\n              </div>\n            </div>\n            <div style=\"position:absolute;left:5px;top:5px\" ng-if=\"broadcast.timeframe == 'current'\">\n              <label class=\"label label-danger\">LIVE</label>\n            </div>\n            <div class=\"broadcast-card__edit-toggle\" ng-if=\"!preventEdit && vm.canEdit\">\n              <a class=\"action-link\" href=\"javascript://\" ng-click=\"vm.edit()\">\n                <i class=\"fa fa-pencil\"></i> Edit\n              </a>\n            </div>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n        <div class=\"col-xs-12\">\n          <h4 class=\"broadcast-card--name broadcast-card__name\" style=\"margin:1rem 0 .4rem; white-space:nowrap; text-overflow:ellipsis; overflow:hidden; line-height:1.2;\">\n            <a href=\"javascript://\" ng-click=\"vm.select()\">\n              {{broadcast.name}}\n            </a>\n          </h4>\n          <div class=\"broadcast-card--date broadcast-card__date\" style=\"white-space:nowrap; text-overflow:ellipsis; overflow:hidden\">\n            <date-range start=\"broadcast.starts_at\" end=\"broadcast.stops_at\"></date-range>\n          </div>\n          <div class=\"broadcast-card--description broadcast-card__description\" style=\"white-space:nowrap; text-overflow:ellipsis; overflow:hidden\">\n            <strong><small>{{broadcast.description || '&nbsp;'}}</small></strong>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    ",
    link: function link(scope, element, attrs) {
      var account = $rootScope.account;
      scope.$watch('broadcast', function (broadcast) {
        scope.duration = Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["b" /* differenceFormattedAsDurationLabel */])(moment(broadcast.starts_at), moment(broadcast.stops_at));

        if (!broadcast.preview && broadcast.stream_source == 'imported' && broadcast.recording_id) {
          broadcast.preview = '/img/imported-recording.png';
        } // Show message overlay in some special cases. We don't handle all the cases
        // that the actual player widget does, but gets the point across.


        if (broadcast.recording_will_purge_at && new Date() > new Date(broadcast.recording_will_purge_at)) {
          scope.messageTitle = 'Recording was deleted.';
        } else if (broadcast.recording_will_purge_at) {
          scope.messageTitle = 'Recording is scheduled for deletion.';
          scope.messageDetails = "Will be deleted on ".concat($filter('date')(broadcast.recording_will_purge_at));
        } else if (account.storage_policy == 'auto-delete' && broadcast.storage_expires_at && new Date() > new Date(broadcast.storage_expires_at)) {
          scope.messageTitle = 'Recording has expired.';
        } else if (broadcast.recording_requested === false) {
          // This check is explicit, because it could be ''
          if (broadcast.timeframe == 'current') {
            scope.messageTitle = ''; // live badge
          } else if (broadcast.timeframe == 'preroll') {
            scope.messageTitle = 'Starting Soon';
          } else if (broadcast.timeframe == 'past' && broadcast.do_not_record) {
            scope.messageTitle = 'Broadcast was live-only';
          }
        } else if (moment(broadcast.starts_at) > moment()) {
          scope.messageTitle = "Scheduled to begin ".concat($filter('relativeTime')(broadcast.starts_at));
          scope.messageDetails = $filter('streamSourceName')(broadcast);
        } else if (!broadcast.preview) {
          if (broadcast.stream_source == 'imported' && !broadcast.recording_id) {
            scope.messageTitle = 'Recording is processing';
          } else {
            // (preroll, etc. are handled generally on live view by real player widget)
            scope.messageTitle = 'No recording was found';
          }
        }
      });
    }
  };
});

function BroadcastCardController($scope, $uibModal, $rootScope, $state) {
  'ngInject';

  this.videoLoaded = false;
  this.canEdit = $rootScope.user.can('update', 'broadcast/*');

  this.edit = function () {
    $uibModal.open({
      template: __webpack_require__(182),
      controller: 'EditEventController',
      controllerAs: 'vm',
      resolve: {
        broadcastId: function broadcastId() {
          return $scope.broadcast.id;
        },
        activeTab: function activeTab() {
          return null;
        }
      }
    }).result.then(function (broadcast) {
      $scope.broadcast = broadcast;
      $scope.$emit('broadcast:edited', broadcast);
    });
  };

  this.select = function () {
    // XXX: We would love to do something like:
    //   if ($scope.onSelect) { ... } else { ... }
    // here, but Angular _always_ binds $scope.onSelect to _something_, even if it's not bound
    // in the parent controller. So in order to determine if a function _actually_ handled the
    // onSelect event or not, we expect the caller to return true if dealt with, or false if not.
    // And if the function is not bound, it will return undefined, which is falsy.
    var handled = false;

    if ($scope.onSelect) {
      handled = $scope.onSelect({
        broadcast: $scope.broadcast
      });
    }

    if (!handled) {
      window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/broadcasts/").concat($scope.broadcast.id));
    }
  };
}

/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// broadcast label list directive
//
//   <broadcast-label-list broadcast="broadcast" />
var module = angular.module('app.directives');
module.directive('broadcastLabelList', function ($rootScope) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      broadcast: '='
    },
    template: "\n      <ul class=\"list-inline\">\n        <li ng-if=\"broadcast.timeframe == 'current'\">\n          <span class=\"label label-danger\">LIVE</span>\n        </li>\n        <li ng-if=\"broadcast.timeframe == 'preroll'\">\n          <span class=\"label label-warning\"><i class=\"fa fa-spin fa-cog\"></i> Preparing to Stream</span>\n        </li>\n        <li ng-if=\"broadcast.timeframe == 'future'\">\n          <span class=\"label label-warning\">Starts <span am-time-ago=\"broadcast.starts_at\"></span></span>\n        </li>\n        <li ng-if=\"broadcast.timeframe == 'past'\">\n          <span class=\"label label-default\">Ended <span am-time-ago=\"broadcast.stops_at\"></span></span>\n        </li>\n        <li ng-if=\"broadcast.is_ticketed\">\n          <span class=\"label label-success\">${{broadcast.ticket_price | number:2}} / ticket</span>\n        </li>\n        <li ng-if=\"broadcast.is_ticketed && broadcast.free_variant != 'none'\">\n          <span class=\"label label-success\">Free {{broadcast.free_variant}}</span>\n        </li>\n        <li ng-if=\"broadcast.is_private\">\n          <span class=\"label label-default\" style=\"background:#000\">Private</span>\n        </li>\n        <li ng-if=\"broadcast.transcoder_profile\">\n          <span ng-if=\"showLimitTranscoder()\" uib-tooltip=\"Limited to {{showLimitTranscoder()}} for viewers\" class=\"label label-default\">{{fixTranscoderProfile(broadcast.transcoder_profile)}}*</span>\n          <span ng-if=\"!showLimitTranscoder()\" class=\"label label-default\">{{fixTranscoderProfile(broadcast.transcoder_profile)}}</span>\n        </li>\n        <li ng-if=\"broadcast.actual_codec == 'hevc'\">\n          <span class=\"label label-default\">HEVC</span>\n        </li>\n      </ul>\n    ",
    link: function link(scope, element, attrs) {
      scope.fixTranscoderProfile = function (transcoder_profile) {
        // :hevc can be removed as it's accounted for elsewhere
        // :us is meaningless to customers
        var tp = transcoder_profile.replace(/:.*/, '');

        if (tp == 'audio') {
          tp = 'Audio';
        }

        return tp;
      };

      scope.showLimitTranscoder = function () {
        var resolution = parseInt(scope.fixTranscoderProfile(scope.broadcast.transcoder_profile || '').replace('p60', '').replace('p', ''), 10);

        if ($rootScope.account.resolution_limit < resolution) {
          return "".concat($rootScope.account.resolution_limit, "p");
        } else {
          return null;
        }
      };
    }
  };
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// color swatch directive
//
//   <color-swatch color="#8a7d0a" label="foo bar" />
var BASE_STYLE = {
  display: 'inline-block',
  width: '100px',
  backgroundColor: '--passed-in--',
  color: '#fff',
  textShadow: '0 0 2px rgba(0,0,0,0.3)',
  padding: '3px',
  textAlign: 'center',
  border: '1px solid #ccc',
  borderRadius: '4px'
};
var module = angular.module('app.directives');
module.directive('colorSwatch', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      color: '=',
      label: '=',
      extraStyle: '='
    },
    template: "\n      <span ng-style=\"style\">{{label}}</span>\n    ",
    link: function link(scope, element) {
      function computeStyle() {
        scope.style = _.extend({}, BASE_STYLE, scope.extraStyle || {}, {
          backgroundColor: scope.color
        });
      }

      computeStyle();
      scope.$watchCollection(function () {
        return [scope.color, scope.label];
      }, computeStyle);
    }
  };
});

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// compare-to-percent directive
//
//   <compare-to-percent base="10" compare="5" />
//
// yields
//
//   <strong class="text-success">
//     <i class="fa fa-caret-up"></i> 100%
//   </strong>
var module = angular.module('app.directives');
module.component('compareToPercent', {
  bindings: {
    base: '<',
    compare: '<'
  },
  template: "\n    <span ng-if=\"$ctrl.base == $ctrl.compare\">\n      <strong class=\"text-success\">-</strong>\n    </span>\n    <span ng-if=\"$ctrl.base != $ctrl.compare && !$ctrl.compare\">\n      <strong class=\"text-success\">\n        <i class=\"fa fa-caret-up\"></i> 1000%\n      </strong>\n    </span>\n    <span ng-if=\"$ctrl.compare && $ctrl.base > $ctrl.compare\">\n      <strong class=\"text-success\">\n        <i class=\"fa fa-caret-up\"></i>\n        {{100*($ctrl.base-$ctrl.compare)/$ctrl.compare|number:1}}%\n      </strong>\n    </span>\n    <span ng-if=\"$ctrl.compare && $ctrl.base < $ctrl.compare\">\n      <strong class=\"text-danger\">\n        <i class=\"fa fa-caret-down\"></i>\n        {{100*($ctrl.compare-$ctrl.base)/$ctrl.compare|number:1}}%\n      </strong>\n    </span>\n  "
});

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// date range directive
//
//   <date-range start="vm.startDate" end="vm.endDate" />
var module = angular.module('app.directives');
module.directive('dateRange', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      start: '=',
      end: '=',
      unstyled: '='
    },
    template: "\n      <span ng-class=\"{'date-range': !unstyled}\">{{start | date:'MMM d, y h:mm a'}}</span>\n      <span ng-if=\"end && !end.startsWith('9999-12-31')\">\n        - <span ng-class=\"{'date-range': !unstyled}\">{{endDateDisplay}}{{end | date:'shortTime'}}</span>\n      </span>\n    ",
    link: function link(scope, element) {
      scope.endDateDisplay = '';
      scope.$watchCollection(function () {
        return [scope.start, scope.end];
      }, function () {
        var startDay = moment(scope.start).format('MMM D'); // XXX: moment date format uses D while angular uses d

        var endDay = moment(scope.end).format('MMM D');

        if (startDay != endDay) {
          scope.endDateDisplay = endDay + ' ';
        } else {
          scope.endDateDisplay = '';
        }
      });
    }
  };
});

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// draggable and resizable directives
//
var module = angular.module('app.directives'); // Support both touch and non-touch interactions based on client type (iOS|Android).
// NOTE: attempting to detect whether using mouse or touch has a race condition,
// because by the time we'd check for first touch or mouse movement, the DOM
// could be filled already (specifically if user loads events page directly)

var events = {
  mousedown: 'mousedown',
  mousemove: 'mousemove',
  mouseup: 'mouseup',
  mouseover: 'mouseover',
  mouseout: 'mouseout'
};

if ((/iPad|iPhone|iPod/.test(navigator.userAgent) || navigator.userAgent.indexOf('Android') >= 0) && 'ontouchstart' in window) {
  events = {
    mousedown: 'touchstart',
    mousemove: 'touchmove',
    mouseup: 'touchend',
    mouseover: 'touchstart',
    mouseout: 'touchcancel'
  };
}

function getX(evt) {
  evt = evt.originalEvent || evt;

  if (evt.touches) {
    return evt.touches[0].clientX;
  } else if (evt.changedTouches) {
    return evt.changedTouches[0].clientX;
  } else {
    return evt.clientX;
  }
}

function getY(evt) {
  evt = evt.originalEvent || evt;

  if (evt.touches) {
    return evt.touches[0].clientY;
  } else if (evt.changedTouches) {
    return evt.changedTouches[0].clientY;
  } else {
    return evt.clientY;
  }
}

module.directive('resizable', ['$document', function ($document) {
  return {
    restrict: 'A',
    scope: {
      aspectRatio: '=aspectRatio',
      onResize: '=onResize',
      onDrag: '=' //<-- to avoid multiple directives requiring isolated scope

    },
    controller: ["$scope", function controller($scope) {
      'ngInject';

      this.onDrag = function () {
        return $scope.onDrag.apply($scope, arguments);
      };
    }],
    link: function link(scope, element, attr) {
      var container = element.parents('.resizable-parent').first();

      if (!container.length) {
        console.warn('Cannot make resizable. Unable to find .resizable-parent from', element);
        return;
      }

      if (!scope.aspectRatio) {
        console.warn('Cannot make resizable without aspect-ratio specified.');
        return;
      }

      var dimension = {};
      var position = {}; //create button for resizing

      var btn = document.createElement('span');
      btn.style.width = '15px';
      btn.style.height = '15px';
      btn.style.bottom = '0px';
      btn.style.right = '0px';
      btn.style.position = 'absolute';
      btn.style.visibility = 'hidden';
      btn.style.cursor = 'nwse-resize';
      btn.innerHTML = "\n          <svg>\n            <circle cx='12.5' cy='2.5' r='2' fill='#777777'></circle>\n            <circle cx='7.5' cy='7.5' r='2' fill='#777777'></circle>\n            <circle cx='12.5' cy='7.5' r='2' fill='#424242'></circle>\n            <circle cx='2.5' cy='12.5' r='2' fill='#777777'></circle>\n            <circle cx='7.5' cy='12.5' r='2' fill='#424242'></circle>\n            <circle cx='12.5' cy='12.5' r='2' fill='#212121'></circle>\n          </svg>";
      element.append(btn); //bind resize function to button;

      btn['on' + events.mousedown] = function ($event) {
        $event.stopImmediatePropagation();
        position.x = getX($event);
        position.y = getY($event);
        var bounds = element[0].getBoundingClientRect();
        dimension.width = bounds.width;
        dimension.height = bounds.height;
        $document.bind(events.mousemove, mousemove);
        $document.bind(events.mouseup, mouseup);
        return false;
      };

      var mousemove = function mousemove($event) {
        var dw = position.x - getX($event);
        var dh = position.y - getY($event);
        var bounds = container[0].getBoundingClientRect();
        var cW = bounds.width;
        var cH = bounds.height; // take smallest axis movement as constraint

        if (dw < dh) {
          var w = dimension.width - dw;
          var h = w * scope.aspectRatio;
        } else {
          var h = dimension.height - dh;
          var w = h / scope.aspectRatio;
        }

        var wPct = 100 * (w / cW);
        var hPct = 100 * (h / cH);

        if (wPct >= 100 || hPct >= 100) {
          if (wPct >= hPct) {
            wPct = 100;
            hPct = wPct * scope.aspectRatio * (cW / cH);
          } else {
            hPct = 100;
            wPct = hPct / scope.aspectRatio * (cH / cW);
          }
        }

        if (wPct < 1 || hPct < 1) {
          return false; // too small, don't let it shrinkify
        }

        element.css({
          width: wPct + '%',
          height: hPct + '%'
        });
        scope.onResize(wPct, hPct);
        return false;
      };

      var mouseup = function mouseup() {
        $document.unbind(events.mousemove, mousemove);
        $document.unbind(events.mouseup, mouseup);
      }; //show button on hover


      element.bind(events.mouseover, function () {
        btn.style.visibility = 'visible';
      });
      element.bind(events.mouseout, function () {
        btn.style.visibility = 'hidden';
      });
    }
  };
}]).directive('draggable', ['$document', function ($document) {
  return {
    restrict: 'A',
    require: 'resizable',
    link: function link(scope, element, attrs, resizableCtrl) {
      var container = element.parents('.draggable-parent').first();

      if (!container.length) {
        console.warn('Cannot make draggable. Unable to find .draggable-parent from', element);
        return;
      }

      var position = {};
      element.bind(events.mousedown, function ($event) {
        position.x = element.position().left;
        position.y = element.position().top;
        position.initialMouseX = getX($event);
        position.initialMouseY = getY($event);
        $document.bind(events.mousemove, mousemove);
        $document.bind(events.mouseup, mouseup);
        return false;
      });

      var mousemove = function mousemove($event) {
        var dx = getX($event) - position.initialMouseX;
        var dy = getY($event) - position.initialMouseY;
        var bounds = container[0].getBoundingClientRect();
        var cW = bounds.width;
        var cH = bounds.height;
        var x = position.x + dx;
        var y = position.y + dy;
        var xPct = 100 * (x / cW);
        var yPct = 100 * (y / cH);
        yPct = Math.min(Math.max(0, yPct), 100);
        xPct = Math.min(Math.max(0, xPct), 100);
        element.css({
          left: xPct + '%',
          top: yPct + '%'
        });
        resizableCtrl.onDrag(xPct, yPct);
        return false;
      };

      var mouseup = function mouseup() {
        $document.unbind(events.mousemove, mousemove);
        $document.unbind(events.mouseup, mouseup);
      };
    }
  };
}]);

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// facebook video directive
//
//   <facebook-video settings="broadcast.simulcast_configurations[0]" />
//
var module = angular.module('app.directives');
module.directive('facebookVideo', ["Facebook", function (Facebook) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      settings: '='
    },
    template: "\n      <div ng-show=\"readyToShow\" class=\"facebook-embed\"></div>\n    ",
    link: function link(scope, element) {
      scope.$watch(function () {
        return scope.settings && scope.settings.fb_id;
      }, function (id) {
        if (!id) return;
        scope.readyToShow = true;
        element.find('.facebook-embed').html("\n          <div class=\"fb-video\"\n               data-href=\"https://www.facebook.com/video.php?v=".concat(id, "\"\n               data-allowfullscreen=\"true\"\n               data-width=\"500\"></div>\n        "));
        setTimeout(function () {
          return window['FB'] && FB.XFBML.parse();
        }, 0);
      });
    }
  };
}]);

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// firmware version directive
//
//   <firmware-version boxcaster="vm.boxcaster" concise="false" />
var module = angular.module('app.directives');
module.component('firmwareVersion', {
  bindings: {
    boxcaster: '=',
    concise: '=?'
  },
  template: "\n    <span ng-if=\"vm.showVersion\">\n      {{vm.boxcaster.firmware_released_at | date:'shortDate'}}\n    </span>\n    <span ng-if=\"!vm.showVersion\">\n      (N/A)\n    </span>\n    &nbsp;|&nbsp;\n    <span ng-switch=\"vm.boxcaster.firmware_status\">\n      <span ng-switch-when=\"current\" class=\"text-success\">\n        <i class=\"fa fa-check\"></i>\n        <span ng-if=\"!vm.concise\">Up to date</span>\n      </span>\n      <a class=\"subtle-link\" href=\"https://support.boxcast.com/en/articles/4533001\" target=\"_blank\"\n          ng-switch-when=\"outdated\" uib-tooltip=\"Updated firmware is available for this BoxCaster. It is not urgent, but you should try to power on the BoxCaster when nothing is scheduled so that the firmware can remain up to date.\">\n        <span class=\"text-info\"><i class=\"fa fa-info-circle\"></i> <span ng-if=\"!vm.concise\">Update Available</span></span>\n      </a>\n      <a class=\"subtle-link\" href=\"https://support.boxcast.com/en/articles/4533001\" target=\"_blank\"\n          ng-switch-when=\"invalid\" uib-tooltip=\"The current BoxCaster firmware is invalid. You should power on the BoxCaster when no broadcasts are scheduled so that it can update to a valid firmware release.\">\n        <span class=\"text-danger\"><i class=\"fa fa-warning\"></i> <span ng-if=\"!vm.concise\">Invalid</span></span>\n      </a>\n    </span>\n  ",
  controllerAs: 'vm',
  controller: ["$scope", function controller($scope) {
    'ngInject';

    var _this = this;

    $scope.$watch(function () {
      return _this.boxcaster && _this.boxcaster.firmware_released_at;
    }, function () {
      if (_this.boxcaster && _this.boxcaster.firmware_released_at) {
        _this.showVersion = !_this.boxcaster.firmware_released_at.startsWith('1970');
      } else {
        _this.showVersion = false;
      }
    });
  }]
});

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// show a preview of an uploaded image in a fixed size container
//
//   <fixed-image-preview src="{...}" width="1280" height="720" />
//
var module = angular.module('app.directives');
module.directive('fixedImagePreview', function () {
  'ngInject';

  return {
    scope: {
      src: '=',
      width: '=',
      height: '=',
      onLoad: '&'
    },
    template: "\n      <div style=\"background:#eee;position:relative\" ng-style=\"{width: width, height: height}\">\n        <div style=\"position:absolute;left:0;top:0;right:0;bottom:0;display:flex;align-items:center;\" ng-style=\"{\n          'background-image': 'url(&quot;'+src+'&quot;)',\n          'background-repeat': 'no-repeat',\n          'background-position': '0% 0%',\n          'background-size': 'contain',\n        }\">\n          <small style=\"flex:1;color:#aaa;text-align:center;\" ng-show=\"!src\">Not Configured</small>\n          <img ng-src=\"{{src}}\" style=\"visibility:hidden;height:1px;width:1px;\" ng-onload=\"onLoad({$event: $event})\">\n        </div>\n      </div>\n    "
  };
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_download__ = __webpack_require__(19);

angular.module('app.directives').directive('lowLatencyPlayer', function ($timeout, $analytics) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      broadcast: '='
    },
    template: "\n        <div>\n          <div ng-show=\"no_op || !dismissed\" style=\"position:absolute; z-index:1; top:50px; left:20px; right:20px; padding:10px 30px 10px 10px; border: 1px solid;\" class=\"bg-warning text-warning text-center\" style=\"border:1px solid;margin:45px 15px 15px 15px;padding:15px;\">\n            <button type=\"button\" class=\"close\" ng-click=\"dismissed = true\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n            Low-Latency Preview requires Flash, which is no longer supported.<br>\n            You can still view the preview in BoxCast Broadcaster on your iOS device or in VLC if it is installed on your computer.\n            <ul class=\"list-inline\" style=\"margin-top:10px\">\n              <li>\n                <button type=\"button\" ng-click=\"openVLC(broadcast)\" class=\"btn btn-default\">\n                <img src=\"/img/icon-vlc.png\" style=\"height:32px\"> Open with VLC\n                </button>\n              </li>\n              <li>\u2022</li>\n              <li>\n                <a href=\"https://www.videolan.org/vlc/\" target=\"_blank\" class=\"subtle-link\">Download VLC</a>\n              </li>\n              <li>\u2022</li>\n              <li>\n                <a href=\"https://support.boxcast.com/en/articles/4235096-troubleshoot-remotely-using-low-latency-preview\" target=\"_blank\" class=\"subtle-link\">Learn More</a>\n              </li>\n            </ul>\n          </div>\n          <div id=\"{{:: id}}\" class=\"player\"></div>\n        </div>\n      ",
    link: function link(scope, element, attrs, ngModel) {
      scope.id = "player-".concat(0 | Math.random() * 1000000);
      scope.no_op = false;
      scope.dismissed = false;
      var ctx = boxcast("#".concat(scope.id));
      scope.$watch(function () {
        return scope.broadcast && scope.broadcast.rtmp_preview_url;
      }, function (rtmp_preview_url) {
        if (rtmp_preview_url) {
          ctx.unload();
          ctx.loadLowLatency(rtmp_preview_url, {
            disableMetrics: true,
            debug: true,
            env: BOXCAST_JS_ENV,
            onLoadPlayer: function onLoadPlayer(p) {
              if (p.core.getCurrentPlayback().name == 'no_op') {
                $analytics.eventTrack('playback-blocked', {
                  category: 'low-latency-player'
                });
                ctx.unload();
                scope.$evalAsync(function () {
                  return scope.no_op = true;
                });

                if (canRequestPermission) {
                  // in case, when flash is not available, try to prompt user to enable it
                  requestFlashPermission(); // Chrome requires user's click in order to allow iframe embeding

                  $(window).one('click', requestFlashPermission);
                }
              }
            }
          });
        } else {
          ctx.unload();
        }
      });

      scope.openVLC = function (broadcast) {
        var vlcPlaylist = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n          <playlist xmlns=\"http://xspf.org/ns/0/\" xmlns:vlc=\"http://www.videolan.org/vlc/playlist/ns/0/\" version=\"1\">\n            <title>BoxCast Preview</title>\n            <trackList>\n              <track>\n                <location>".concat(broadcast.rtmp_preview_url, "</location>\n                <extension application=\"http://www.videolan.org/vlc/playlist/0\">\n                  <vlc:id>0</vlc:id>\n                  <vlc:option>network-caching=1000</vlc:option>\n                </extension>\n              </track>\n            </trackList>\n            <extension application=\"http://www.videolan.org/vlc/playlist/0\">\n              <vlc:item tid=\"0\"/>\n            </extension>\n          </playlist>\n          ");
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_download__["a" /* forceBrowserDownload */])('data:application/octet-stream;charset=utf-8,' + vlcPlaylist, 'boxcast-playlist.xspf');
      };

      scope.$on('$destroy', function () {
        if (ctx) ctx.unload();
      });
      $analytics.eventTrack('playback-requested', {
        category: 'low-latency-player'
      });
    }
  };
});
/**
 * Tries to show browser's promt for enabling flash
 *
 * Chrome starting from 56 version and Edge from 15 are disabling flash
 * by default. To promt user to enable flash, they suggest to send user to
 * flash player download page. Then this browser will catch such request
 * and show a promt to user:
 * https://www.chromium.org/flash-roadmap#TOC-Developer-Recommendations
 * In this method we are forcing such promt by navigating user to adobe
 * site in iframe, instead of top window
 */

function requestFlashPermission() {
  var iframe = document.createElement('iframe');
  iframe.src = 'https://get.adobe.com/flashplayer';
  iframe.sandbox = '';
  document.body.appendChild(iframe);
  document.body.removeChild(iframe);
}

var isNewEdge = navigator.userAgent.match(/Edg\//) || (navigator.userAgent.match(/Edge\/(\d+)/) || [])[1] > 14;
var isNewSafari = (navigator.userAgent.match(/OS X (\d+)/) || [])[1] > 9;
var isNewChrome = (navigator.userAgent.match(/Chrom(e|ium)\/(\d+)/) || [])[2] > 56 && !/Mobile/i.test(navigator.userAgent);
var canRequestPermission = isNewEdge || isNewSafari || isNewChrome;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// onload directive
//
//   <img src="..." ng-onload="vm.onImageLoad($event)" />
var module = angular.module('app.directives');
module.directive('ngOnload', ['$parse', function ($parse) {
  'ngInject';

  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      var fn = $parse(attrs.ngOnload);
      elem.on('load', function (event) {
        scope.$apply(function () {
          fn(scope, {
            $event: event
          });
        });
      });
    }
  };
}]);

/***/ }),
/* 325 */
/***/ (function(module, exports) {

var BOXCAST_URL_REGEXP = /boxcast\.com/;
angular.module('app.directives').directive('notBoxcast', function () {
  'ngInject';

  return {
    require: 'ngModel',
    link: function link(scope, elm, attrs, ctrl) {
      ctrl.$validators.notBoxcast = function (modelValue, viewValue) {
        if (ctrl.$isEmpty(modelValue)) {
          // consider empty models to be valid
          return true;
        }

        return !BOXCAST_URL_REGEXP.test(viewValue);
      };
    }
  };
});

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {// number spinner directive
//
//   <number-spinner ng-model="vm.myNumber"
//                   min-value="0"
//                   max-value="100" />
var module = angular.module('app.directives');
module.directive('numberSpinner', ["$timeout", function ($timeout) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      minValue: '=',
      maxValue: '=',
      ngChange: '@',
      size: '@',
      width: '@'
    },
    require: 'ngModel',
    template: "\n      <div class=\"input-group\" style=\"width:{{width}}; margin:0 auto;\">\n        <div class=\"input-group-btn\">\n          <button class=\"btn btn-default btn-{{size}}\"\n                  style=\"padding-left:10px;padding-right:10px\"\n                  ng-click=\"decrement()\"\n                  tabindex=\"-1\">\n            <i class=\"fa fa-minus\" style=\"color: #999\"></i>\n          </button>\n        </div>\n        <input type=\"text\"\n               class=\"form-control input-{{size}}\"\n               style=\"min-width:20px; padding-left:0; padding-right:0; text-align:center;\"\n               ng-model=\"ngModel\"\n               onclick=\"this.setSelectionRange(0, this.value.length)\">\n        <div class=\"input-group-btn\">\n          <button class=\"btn btn-default btn-{{size}}\"\n                  style=\"padding-left:10px;padding-right:10px\"\n                  ng-click=\"increment()\"\n                  tabindex=\"-1\">\n            <i class=\"fa fa-plus\" style=\"color: #999\"></i>\n          </button>\n        </div>\n      </div>\n      <!--\n      <a href=\"javascript://\"\n         ng-click=\"decrement()\"><i class=\"fa fa-minus-square\"></i></a>\n      <span style=\"border:1px solid #aaa; padding:0 10px;\">{{ngModel}}</span>\n      <a href=\"javascript://\"\n         ng-click=\"increment()\"><i class=\"fa fa-plus-square\"></i></a>\n      -->\n    ",
    link: function link(scope, element, attrs, ngModelCtrl) {
      scope.minValue = typeof scope.minValue == 'undefined' ? 0 : scope.minValue;
      scope.maxValue = typeof scope.maxValue == 'undefined' ? 999 : scope.maxValue;

      if (attrs.ngChange) {
        ngModelCtrl.$viewChangeListeners.push(function () {
          scope.$eval(attrs.ngChange);
        });
      }

      scope.decrement = function () {
        var newValue = ngModelCtrl.$modelValue - 1;
        update(isNaN(newValue) ? scope.minValue : newValue);
      };

      scope.increment = function () {
        var newValue = ngModelCtrl.$modelValue + 1;
        update(isNaN(newValue) ? scope.minValue : newValue);
      };

      element.find('input.form-control').on('change', function () {
        var _this = this;

        $timeout(function () {
          return update($(_this).val());
        });
      });

      function update(value) {
        if (value === '' || value === null) {
          value = ''; //empty string is a valid state that shouldn't be coerced to 0
        } else {
          value = parseInt(value, 10);
          if (value > scope.maxValue) value = scope.maxValue;
          if (isNaN(value) || value < scope.minValue) value = scope.minValue;
        }

        scope.ngModel = value;
        ngModelCtrl.$setViewValue(value);
        ngModelCtrl.$commitViewValue();

        if (scope.onChange) {
          scope.onChange(value);
        }
      }

      scope.$watch('ngModel', function (newValue) {
        if (isNaN(ngModelCtrl.$modelValue)) {
          scope.increment(); // reset to min value if not defined
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 327 */
/***/ (function(module, exports) {

angular.module('app.directives').component('radioButtonWell', {
  transclude: true,
  controllerAs: 'vm',
  bindings: {
    heading: '@',
    onSelect: '&',
    isSelected: '&',
    alwaysShowTransclude: '<',
    hideCheckbox: '<'
  },
  template: "\n    <div class=\"row\">\n      <div class=\"col-sx-12\">\n        <div class=\"radio-button-well\" ng-class=\"vm.isSelected() ? 'radio-button-well-selected' : ''\">\n          <a href=\"javascript://\" ng-click=\"vm.onSelect()\">\n            <div class=\"row\" style=\"display:flex;align-items:center;\">\n              <div class=\"col-xs-1\" style=\"width:30px;\">\n                <i ng-hide=\"vm.hideCheckbox\" class=\"fa\" ng-class=\"vm.isSelected() ? 'fa-check-circle-o text-success' : 'fa-circle-o'\"\n                  style=\"font-size:16px;\"></i>\n              </div>\n              <div class=\"col-xs-11\">\n                <b>{{vm.heading}}</b>\n                <div ng-if=\"vm.isSelected() || vm.alwaysShowTransclude\">\n                  <div ng-transclude></div>\n                </div>\n              </div>\n            </div>\n          </a>\n        </div>\n      </div>\n    </div>\n    "
});

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// random waiting message directive to entertain your users while they sit
var module = angular.module('app.directives');
var MESSAGES = ['Locating the required gigapixels to render...', 'Spinning up the hamster...', 'Shovelling coal into the server...', 'Programming the flux capacitor...', 'Pay no attention to the man behind the curtain...', 'Enjoy the elevator music...', 'This server must be powered by a lemon and two electrodes...', 'The version I have of this in testing has much funnier waiting messages...', '999 bottles of soda on the wall...', 'Searching for Answer to Life, the Universe, and Everything...'];
module.directive('randomWaitingMessage', ["$interval", function ($interval) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      interval: '@'
    },
    template: "\n      <span>{{message}}</span>\n    ",
    link: function link(scope, element) {
      function changeMessage() {
        scope.message = _.sample(MESSAGES);
      }

      var cancelInterval = $interval(changeMessage, scope.interval);
      scope.$on('$destroy', cancelInterval);
      changeMessage();
    }
  };
}]);

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

// recording source chooser directive
//
//   <recording-source-chooser edit-or-create-event-service="vm.service" />
//
var module = angular.module('app.directives');
module.directive('recordingSourceChooserPreview', function () {
  return {
    restrict: 'E',
    scope: {
      broadcast: '='
    },
    template: "\n      <div>\n        <div style=\"display: inline-flex; float: left; width: 32px; height: 18px; margin-top: 1px; margin-right: 6px;\"\n             ng-style=\"{\n               'background-image': 'url(&quot;' + broadcast.preview + '&quot;)',\n               'background-size': 'contain',\n               'background-repeat': 'no-repeat'\n             }\">\n        </div>\n        <div class=\"date-range\" style=\"display: inline-flex; float: right; margin-left: 6px;\">\n          ({{broadcast.starts_at | date}})\n        </div>\n        <div class=\"overflow-ellipse\">\n          {{broadcast.name}}\n        </div>\n      </div>\n    "
  };
});
module.directive('recordingSourceChooser', function () {
  return {
    restrict: 'E',
    scope: {
      editOrCreateEventService: '=',
      onSelectBroadcast: '=',
      selectSourceTitle: '@',
      skipRecordingSourceValidation: '=',
      modalTitle: '@',
      broadcastValidator: '='
    },
    template: "\n      <div ng-show=\"editOrCreateEventService.sourceBroadcast\"\n           ng-click=\"chooseSource($event)\"\n           style=\"border: 1px solid #ccc; border-radius: 4px; padding: 8px;\"\n           ng-style=\"style\">\n        <recording-source-chooser-preview broadcast=\"editOrCreateEventService.sourceBroadcast\"></recording-source-chooser-preview>\n      </div>\n      <div ng-show=\"!editOrCreateEventService.sourceBroadcast\"\n           ng-click=\"chooseSource($event)\"\n           style=\"border: 1px solid #ccc; color: #757575; border-radius: 4px; padding: 8px;\"\n           ng-style=\"style\">\n        <span ng-show=\"!editOrCreateEventService.sourceBroadcastUnavailable\">\n          {{::(selectSourceTitle || 'Select Source...')}}\n        </span>\n        <span ng-show=\"editOrCreateEventService.sourceBroadcastUnavailable\">\n          Source Broadcast Unavailable\n        </span>\n      </div>\n    ",
    controller: ["$scope", "$uibModal", function controller($scope, $uibModal) {
      'ngInject';

      $scope.style = {};

      if (($scope.editOrCreateEventService.broadcast.timeframe || 'future') == 'future') {
        $scope.style.cursor = 'pointer';
      } else {
        $scope.style.cursor = 'not-allowed';
        $scope.style['background-color'] = '#eee';

        _.each(['-webkit-', '-khtml-', '-moz-', '-o-', ''], function (prefix) {
          return $scope.style["".concat(prefix, "user-select")] = 'none';
        });
      }

      $scope.chooseSource = function ($event) {
        if ($event.cancelable) {
          $event.preventDefault();
        }

        if (($scope.editOrCreateEventService.broadcast.timeframe || 'future') != 'future') return;
        $uibModal.open({
          template: __webpack_require__(330),
          controller: __webpack_require__(331)["default"],
          size: 'lg',
          controllerAs: 'vm',
          resolve: {
            options: function options() {
              return {
                activeTabIndex: 2,
                // start on past broadcast tab
                skipRecordingSourceValidation: $scope.skipRecordingSourceValidation,
                modalTitle: $scope.modalTitle,
                broadcastValidator: $scope.broadcastValidator
              };
            }
          }
        }).result.then(function (broadcast) {
          $scope.editOrCreateEventService.updateSourceBroadcast(broadcast);
          $scope.onSelectBroadcast && $scope.onSelectBroadcast(broadcast);
        });
      };
    }]
  };
});

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = "<div cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...'}\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n    <h3 class=\"modal-title\">{{vm.modalTitle}}</h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"pull-right\" style=\"width:200px\">\n      <form ng-submit=\"vm.search()\">\n        <div class=\"form-group\" style=\"margin-bottom:0;\">\n          <div class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"Search\" ng-model=\"vm.searchText\">\n            <span class=\"input-group-btn\">\n              <button class=\"btn btn-default btn-secondary\" type=\"submit\">\n                <i ng-hide=\"vm.searching\" class=\"fa fa-search\"></i>\n                <i ng-show=\"vm.searching\" class=\"fa fa-spin fa-spinner\"></i>\n              </button>\n            </span>\n          </div>\n        </div>\n      </form>\n    </div>\n\n    <uib-tabset active=\"vm.activeTab\">\n\n      <uib-tab select=\"vm.changeTab('current')\" index=\"0\"\n               ng-if=\"vm.broadcasts.current.data.length > 0\">\n        <uib-tab-heading>\n          <i class=\"fa fa-dot-circle-o text-danger\"></i> Current <span class=\"hidden-xs\">Broadcasts</span>\n        </uib-tab-heading>\n        <div class=\"tab-container clearfix\">\n          <p ng-if=\"vm.currentSearchText\" class=\"help-block\">\n            <i class=\"fa fa-info-circle\"></i> Search terms are not applied to current broadcasts.\n          </p>\n          <div>\n            <ul class=\"list-unstyled\" style=\"margin-top:15px\">\n              <li ng-repeat=\"broadcast in vm.broadcasts.current.data track by broadcast.id\">\n                <broadcast-card broadcast=\"broadcast\" show-view-count=\"false\" extra-css-classes=\"'col-lg-3 col-sm-6 col-xs-12'\" prevent-edit=\"true\" on-select=\"vm.select(broadcast)\"></broadcast-card>\n              </li>\n            </ul>\n            <div class=\"clearfix\"></div>\n          </div>\n        </div>\n      </uib-tab>\n\n      <uib-tab select=\"vm.changeTab('upcoming')\" index=\"1\">\n        <uib-tab-heading>\n          Upcoming <span class=\"hidden-xs\">Broadcasts</span>\n          <span class=\"label label-primary label-as-badge\">{{vm.eventCount(vm.broadcasts.upcoming)}}</span>\n        </uib-tab-heading>\n        <div class=\"tab-container\">\n          <p class=\"help-block\" ng-if=\"vm.broadcasts.upcoming.data.length\">\n            <i class=\"fa fa-search\"></i>\n            Showing results\n            {{vm.broadcasts.upcoming.pagination.resultMin}} -\n            {{vm.broadcasts.upcoming.pagination.resultMax}}\n            of {{vm.broadcasts.upcoming.pagination.total}}\n            <span ng-if=\"vm.currentSearchText\">\n              for search term \"{{vm.currentSearchText}}\"\n              (<a href=\"javascript://\" ng-click=\"((vm.searchText = '') || true) && vm.search()\" style=\"color:#aaa\" class=\"action-link\">clear search</a>)\n            </span>\n          </p>\n          <div>\n            <ul class=\"list-unstyled\" style=\"margin-top:15px\">\n              <li ng-repeat=\"broadcast in vm.broadcasts.upcoming.data track by broadcast.id\">\n                <broadcast-card broadcast=\"broadcast\" show-view-count=\"false\" extra-css-classes=\"'col-lg-3 col-sm-6 col-xs-12'\" prevent-edit=\"true\" on-select=\"vm.select(broadcast)\"></broadcast-card>\n              </li>\n            </ul>\n          </div>\n          <div class=\"clearfix\"></div>\n          <div ng-if=\"!vm.broadcasts.upcoming.data.length\" class=\"text-center\" style=\"padding-bottom:30px\">\n            <!-- empty state in upcoming tab -->\n            <div ng-if=\"!vm.currentSearchText\">\n              <h4 class=\"help-block\" style=\"margin:30px auto;\">\n                There are no scheduled broadcasts.\n              </h4>\n            </div>\n            <div ng-if=\"vm.currentSearchText\">\n              <h4 class=\"help-block\" style=\"margin:30px auto;\">\n                There are no scheduled broadcasts that match your search term \"{{vm.currentSearchText}}\".\n              </h4>\n              <a href ng-click=\"((vm.searchText = '') || true) && vm.search()\" class=\"btn btn-lg btn-default\">\n                <i class=\"fa fa-times\"></i> Clear Search\n              </a>\n            </div>\n          </div>\n          <uib-pagination ng-if=\"vm.broadcasts.upcoming.pagination.total > 12\"\n                          total-items=\"vm.eventCount(vm.broadcasts.upcoming)\"\n                          items-per-page=\"12\"\n                          max-size=\"10\"\n                          rotate=\"false\"\n                          class=\"pagination-sm\"\n                          ng-model=\"vm.broadcasts.upcoming.pagination.current\"\n                          ng-change=\"vm.loadBroadcast('upcoming')\"></uib-pagination>\n        </div>\n      </uib-tab>\n\n      <uib-tab select=\"vm.changeTab('past')\" index=\"2\">\n        <uib-tab-heading>\n          Past <span class=\"hidden-xs\">Broadcasts</span>\n          <span class=\"label label-default label-as-badge\">{{vm.eventCount(vm.broadcasts.past)}}</span>\n        </uib-tab-heading>\n        <div class=\"tab-container\">\n          <p class=\"help-block\" ng-if=\"vm.broadcasts.past.data.length\">\n            <i class=\"fa fa-search\"></i>\n            Showing results\n            {{vm.broadcasts.past.pagination.resultMin}} -\n            {{vm.broadcasts.past.pagination.resultMax}}\n            of {{vm.broadcasts.past.pagination.total}}\n            <span ng-if=\"vm.currentSearchText\">\n              for search term \"{{vm.currentSearchText}}\"\n              (<a href=\"javascript://\" ng-click=\"((vm.searchText = '') || true) && vm.search()\" style=\"color:#aaa\" class=\"action-link\">clear search</a>)\n            </span>\n          </p>\n          <div>\n            <ul class=\"list-unstyled\" style=\"margin-top:15px\">\n              <li ng-repeat=\"broadcast in vm.broadcasts.past.data track by broadcast.id\">\n                <broadcast-card broadcast=\"broadcast\" show-view-count=\"true\" extra-css-classes=\"'col-lg-3 col-sm-6 col-xs-12'\" prevent-edit=\"true\" on-select=\"vm.select(broadcast)\"></broadcast-card>\n              </li>\n            </ul>\n          </div>\n          <div class=\"clearfix\"></div>\n          <div ng-if=\"!vm.broadcasts.past.data.length\" class=\"text-center\" style=\"padding-bottom:30px\">\n            <!-- empty state in past tab -->\n            <div ng-if=\"!vm.currentSearchText\">\n              <h4 class=\"help-block\" style=\"margin:30px auto;\">\n                There are no past broadcasts.\n              </h4>\n            </div>\n            <div ng-if=\"vm.currentSearchText\">\n              <h4 class=\"help-block\" style=\"margin:30px auto;\">\n                There are no past broadcasts that match your search term \"{{vm.currentSearchText}}\".\n              </h4>\n              <a href ng-click=\"((vm.searchText = '') || true) && vm.search()\" class=\"btn btn-lg btn-default\">\n                <i class=\"fa fa-times\"></i> Clear Search\n              </a>\n            </div>\n          </div>\n\n          <uib-pagination ng-if=\"vm.broadcasts.past.pagination.total > 12\"\n                          total-items=\"vm.eventCount(vm.broadcasts.past)\"\n                          items-per-page=\"12\"\n                          max-size=\"10\"\n                          rotate=\"false\"\n                          class=\"pagination-sm\"\n                          ng-model=\"vm.broadcasts.past.pagination.current\"\n                          ng-change=\"vm.loadBroadcast('past')\"></uib-pagination>\n        </div>\n      </uib-tab>\n\n    </uib-tabset>\n  </div>\n</div>\n"

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = RecordingSourceChooserBrowseController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_search_query_builder__ = __webpack_require__(332);

var PAGE_SIZE = 12;
function RecordingSourceChooserBrowseController($uibModalInstance, $q, $http, Broadcast, Recording, toaster, options) {
  'ngInject'; // Parse options passed in from `resolve`

  var _this = this;

  this.skipRecordingSourceValidation = options.skipRecordingSourceValidation;
  this.modalTitle = options.modalTitle || 'Choose Source Broadcast';
  this.activeTab = options.activeTabIndex || 0;
  this.currentSearchText = '';
  this.searchText = '';
  this.searching = false;
  this.broadcasts = {
    upcoming: {
      $promise: null,
      data: [],
      pagination: {
        current: 1,
        resultMin: 0,
        resultMax: 0
      }
    },
    current: {
      $promise: null,
      data: [],
      pagination: {
        current: 1,
        resultMin: 0,
        resultMax: 0
      }
    },
    past: {
      $promise: null,
      data: [],
      pagination: {
        current: 1,
        resultMin: 0,
        resultMax: 0
      }
    }
  };

  this.cancel = function () {
    return $uibModalInstance.dismiss();
  };

  this.eventCount = function (broadcast) {
    if (broadcast.pagination && broadcast.pagination.total) {
      return "".concat(broadcast.pagination.total);
    } else {
      return broadcast.data.length;
    }
  };

  this.loadBroadcast = function (timeframe) {
    // Load the next page of events for the given broadcast set, and populate
    // the `this.broadcasts` data structure accordingly.
    // @param timeframe: one of 'upcoming', 'current', or 'past'
    var broadcast = _this.broadcasts[timeframe];
    var q = new __WEBPACK_IMPORTED_MODULE_0__utils_search_query_builder__["a" /* default */]();
    var s = 'starts_at'; //default sort order

    switch (timeframe) {
      case 'upcoming':
        q.append('timeframe:future');
        break;

      case 'current':
        q.append('timeframe:preroll').append('timeframe:current');
        break;

      case 'past':
        q.append('timeframe:past');
        s = '-starts_at'; //reverse sort

        break;
    } // NOTE: Current events tab is never filtered, as it's not expected to have
    // more than a handful ongoing and you wouldn't want to hide them anyway


    if (_this.searchText && timeframe != 'current') {
      q.appendSearchText(_this.searchText);
    }

    var query = Broadcast.query({
      q: q.toString(),
      s: s,
      p: broadcast.pagination.current - 1,
      l: PAGE_SIZE
    }, function (data, headers) {
      _this.currentSearchText = _this.searchText;
      broadcast.data = data;
      var pagination = JSON.parse(headers('x-pagination'));
      broadcast.pagination.total = pagination && pagination.total;
      broadcast.pagination.resultMin = PAGE_SIZE * (broadcast.pagination.current - 1) + 1;
      broadcast.pagination.resultMax = broadcast.pagination.resultMin + data.length - 1; // If current tab is selected but there's nothing in there, need to kick
      // user somewhere else (it's the only one that disappears)

      if (timeframe == 'current' && _this.activeTab === 0 && !data.length) {
        //console.log('Switching from current tab to upcoming since no more data', this.broadcasts);
        _this.activeTab = 1;
      }
    }, function (e) {
      console.error(e);
      toaster.pop('warning', 'Unable to load broadcasts. Please refresh the page and try again');
    });
    broadcast.$promise = query.$promise;
    _this.loadingPromises = [query.$promise];
  };

  this.reload = function () {
    _.each(_this.broadcasts, function (n, key) {
      _this.loadBroadcast(key);
    });

    _this.loadingPromises = [_this.broadcasts.upcoming.$promise, _this.broadcasts.current.$promise, _this.broadcasts.past.$promise];
  };

  this.search = function () {
    // Reset pagination and data
    _.each(_this.broadcasts, function (n, key) {
      var broadcast = _this.broadcasts[key];
      broadcast.pagination.current = 1;
      broadcast.pagination.total = 0;
    }); // Apply search term


    _this.reload(); // Handle loading spinner


    _this.searching = true;
    $q.all([_this.broadcasts.upcoming.$promise, _this.broadcasts.current.$promise, _this.broadcasts.past.$promise])["finally"](function () {
      return _this.searching = false;
    });
  };

  this.select = function (broadcast) {
    _this.loadingPromises = [Broadcast.get({
      id: broadcast.id
    }, function (b) {
      if (options.broadcastValidator) {
        try {
          options.broadcastValidator(b);
          $uibModalInstance.close(b);
        } catch (e) {
          toaster.pop('warning', e.toString());
        }
      } else if (_this.skipRecordingSourceValidation) {
        $uibModalInstance.close(b);
      } else if (b.timeframe != 'past') {
        if (b.stream_source == 'recording') {
          toaster.pop('warning', 'Please choose a non-simulated live broadcast.');
        } else {
          $uibModalInstance.close(b);
        }
      } else if (b.recording_duration_seconds > 0) {
        var segments = Recording.segments({
          id: b.recording_id
        });
        _this.loadingPromises = [segments.$promise];
        segments.$promise.then(function () {
          if (_.some(segments, function (s) {
            return s.byte_ranges;
          })) {
            $uibModalInstance.close(b);
          } else {
            toaster.pop('warning', "This broadcast's recording is not in the correct format. Please choose a newer broadcast, or upload a recording.");
          }
        })["catch"](function (e) {
          console.error(e);
          toaster.pop('warning', "This broadcast's recording could not be found, or is not in the correct format.");
        });
      } else {
        // Check to see if this is being uploaded
        if (!b.recording_id && b.stream_source == 'imported') {
          toaster.pop('warning', 'This broadcast is currently being uploaded; please try again when processing is complete.');
          return;
        }

        var uploadsPromise = $http.get("".concat(API_ROOT, "/account/broadcasts/").concat(broadcast.id, "/uploads"));
        _this.loadingPromises = [uploadsPromise];
        uploadsPromise.then(function (response) {
          if (!response || !response.data || !response.data.length) {
            toaster.pop('warning', 'Please choose a broadcast with a valid recording.');
            return;
          }

          var upload = response.data[0] || {};

          if (b.recording_id && ['created', 'uploaded', 'assigned', 'processing', 'failed'].indexOf(upload.status) >= 0) {
            toaster.pop('warning', 'This broadcast is currently being uploaded; please try again when processing is complete.');
            return;
          }

          toaster.pop('warning', 'Please choose a broadcast with a valid recording.');
        })["catch"](function (e) {
          console.error(e);
          toaster.pop('warning', "This broadcast's uploads could not be found.");
        });
      }
    }, function (e) {
      console.error(e);
      toaster.pop('warning', 'Unable to load broadcast. Please refresh the page and try again');
    }).$promise]; // This method returns true to let <broadcast-card/> know that we dealt with the selection and
    // it doesn't need to navigate / change state.

    return true;
  };

  this.reload();
}

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchQueryBuilder; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// Build a query to the API search service
var SearchQueryBuilder = /*#__PURE__*/function () {
  function SearchQueryBuilder() {
    _classCallCheck(this, SearchQueryBuilder);

    this.parts = [];
  }

  _createClass(SearchQueryBuilder, [{
    key: "toString",
    value: function toString() {
      return this.parts.join(' ').trim();
    }
  }, {
    key: "append",
    value: function append(term) {
      this.parts = this.parts.concat(term);
      return this;
    }
  }, {
    key: "appendSearchText",
    value: function appendSearchText(text) {
      var _this = this;

      text = (text || '').trim();

      if (isAdvancedQuery(text)) {
        // advanced mode detected
        this.append(text);
        return this;
      } else {
        splitQuoted(text).forEach(function (term) {
          _this.append(term);
        });
        return this;
      }
    }
  }]);

  return SearchQueryBuilder;
}();



function isAdvancedQuery(text) {
  // check if user is trying an advanced feature.  if so, we won't try
  // to interpret as a simple query
  return text.indexOf('starts_at:') >= 0;
}

function splitSimple(text) {
  return text.split(' ');
}

function splitQuoted(text) {
  var result = [];
  var words = splitSimple(text);
  var phrase = null;
  words.forEach(function (word) {
    if (!phrase && word.startsWith('"')) {
      // start of phrase
      if (word.endsWith('"')) {
        // single-word phrase
        phrase = '+' + word;
        result.push(phrase);
        phrase = null;
      } else {
        // multi-word phrase (need to keep looping)
        phrase = '+' + word;
      }
    } else if (phrase && word.endsWith('"')) {
      // end of current phrase
      phrase += ' ' + word;
      result.push(phrase);
      phrase = null;
    } else if (phrase) {
      // keep building...
      phrase += ' ' + word;
    } else {
      // just a plain word
      word = "+*".concat(word, "*");
      result.push(word);
    }
  });

  if (phrase) {
    // fix unbalanced quote
    phrase += '"';
    result.push(phrase);
  }

  return result;
}

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// directive for trimming a broadcast's recording
//
//    <recording-trimmer broadcast-id="10001"
//                       recording-id="20001"
//                       start-segment="vm.startSegment"
//                       stop-segment="vm.stopSegment"
//                       start-seconds="vm.startSeconds"
//                       stop-seconds="vm.stopSeconds"
//                       on-change-bounds="vm.updateBounds" />
//
//    updateBounds(startSeconds, stopSeconds, startSegment, stopSegment) {
//      ...
//    }

var THUMBNAIL_TIMEOUT = 1000;
var module = angular.module('app.directives');
module.directive('recordingTrimmer', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      broadcastId: '=',
      recordingId: '=',
      onChangeBounds: '=',
      startSegment: '=',
      stopSegment: '=',
      startSeconds: '=',
      stopSeconds: '='
    },
    template: __webpack_require__(334),
    link: function link(scope, element, attrs) {}
  };
});
module.controller('RecordingTrimmerController', /*#__PURE__*/function () {
  function RecordingTrimmerController($scope, Recording, $q, $timeout, toaster) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, RecordingTrimmerController);

    this.$scope = $scope;
    this.Recording = Recording;
    this.$q = $q;
    this.$timeout = $timeout;
    this.toaster = toaster;
    this.zoom = 1.0; // Wait for broadcast and recording to get attached to scope before initializing
    // XXX: work around inability to attach controller directly to directive
    // definition, and instead attaching it via ngController in the template

    var parentScope = $scope.$parent;
    $scope.$watchCollection(function () {
      return [parentScope.broadcastId, parentScope.recordingId];
    }, function (args) {
      return args[0] && args[1] && _this.init.apply(_this, _toConsumableArray(args));
    }); // Watch for external changes to the start/stop segments/seconds if the callee so chooses
    // (dangerous)

    $scope.$watchCollection(function () {
      return [parentScope.startSegment, parentScope.stopSegment];
    }, function (args) {
      return _this.setTrimBoundsFromSegments(args[0], args[1]);
    });
    $scope.$watchCollection(function () {
      return [parentScope.startSeconds, parentScope.stopSeconds];
    }, function (args) {
      return _this.setTrimBoundsFromSeconds(args[0], args[1]);
    });
  }

  _createClass(RecordingTrimmerController, [{
    key: "init",
    value: function init(broadcastId, recordingId) {
      var _this2 = this;

      var Broadcast = this.Broadcast,
          Recording = this.Recording,
          $q = this.$q,
          $timeout = this.$timeout,
          $scope = this.$scope;
      this.showPreviewStartTimer = 0;
      this.showPreviewStopTimer = 0;
      this.trimBounds = [0, 0];
      this.sliderOptsTrim = {
        floor: 0,
        ceil: 1,
        //draggableRange: true,
        onlyBindHandles: true,
        keyboardSupport: false,
        translate: function translate(index, id, what) {
          return _this2.labelFor(index, id, what);
        }
      };
      this.sliderOptsPlayhead = {
        floor: 0,
        ceil: 1,
        hideLimitLabels: true,
        translate: function translate(index, id, what) {
          return _this2.labelFor(index, id, what);
        }
      }; // XXX: there appears to be some sort of race condition, where 2 simultaenous requests to the
      // same URL will cause the the resource to only be resolved once (in the container controller,
      // not this directive).  Adding a `cb` (cachebust) querystring param works around this for now.

      this.recording = Recording.get({
        id: recordingId,
        cb: Math.random()
      });
      var recordingPromise = this.recording.$promise;
      this.segments = Recording.segments({
        id: recordingId,
        cb: Math.random()
      });
      var segmentsPromise = this.segments.$promise;
      $q.all([segmentsPromise, recordingPromise]).then(function (data) {
        _this2.initSegments(data[0]); //segments must come before recording so stopSegments can be populated


        _this2.initRecording(data[1]);

        _this2.sliderOptsTrim.ceil = _this2.stopSegments.length - 1;
        _this2.sliderOptsPlayhead.floor = _this2.trimBounds[0];
        _this2.sliderOptsPlayhead.ceil = _this2.trimBounds[1];
        _this2.playhead = _this2.trimBounds[0];
        _this2.recordingDuration = _this2.stopSegments[_this2.stopSegments.length - 1].label;

        _this2.initWatchers();

        $timeout(function () {
          // Need to kick the rzslider in the teeth a bit
          $scope.$broadcast('reCalcViewDimensions');
          $scope.$broadcast('rzSliderForceRender');
        }, 250);
      }); // XXX: $q.all swallows errors so need to do this individually

      segmentsPromise["catch"](function (e) {
        console.error(e);

        _this2.toaster.pop('warning', 'Unable to load segments. Please refresh the page and try again');
      });
      recordingPromise["catch"](function (e) {
        console.error(e);

        _this2.toaster.pop('warning', 'Unable to load the recording. Please refresh the page and try again');
      });
      this.loadingPromises = [recordingPromise, segmentsPromise];
    }
  }, {
    key: "labelFor",
    value: function labelFor(index, id, what) {
      // Custom angular-slider translate function uses "floor", "ceil", "model", "high" to distinguish
      // which of the 4 labels it's binding to.  We map those to either start segment or stop segment labels.
      if (what == 'floor' || what == 'model') {
        return this.startSegments && this.startSegments[index] && this.startSegments[index].label;
      } else {
        return this.stopSegments && this.stopSegments[index] && this.stopSegments[index].label;
      }
    }
  }, {
    key: "segmentPreviewURL",
    value: function segmentPreviewURL(segmentIdx) {
      if (!this.previewBaseURL || !this.previewQueryString) {
        return null;
      }

      var vodPaths = ((this.segments || [])[segmentIdx] || {}).vod_paths || {};
      var thumbPath = vodPaths.thumbs;

      if (!thumbPath) {
        // Some (older?) recordings don't have a `thumbs` key. So try to grab _any_ value from the
        // VOD paths and turn it into a jpg. If that doesn't work, just try string formatting it.
        var fname = _.find(vodPaths);

        if (fname && fname.match(/\d{8}\.[^\.]+$/)) {
          thumbPath = fname.replace(/\.[^\.]+$/, '.jpg');
        } else {
          thumbPath = ('00000000' + segmentIdx).slice(-8) + '.jpg'; // :shrug:
        }
      }

      return this.previewBaseURL + thumbPath + '?' + this.previewQueryString;
    }
  }, {
    key: "startTimerForPreviewStart",
    value: function startTimerForPreviewStart() {
      var _this3 = this;

      var $timeout = this.$timeout;
      this.showPreviewStartTimer = new Date().getTime();
      this.showPreviewStart = true;
      $timeout(function () {
        if (_this3.showPreviewStartTimer <= new Date().getTime() - THUMBNAIL_TIMEOUT) {
          _this3.showPreviewStart = false;
        }
      }, THUMBNAIL_TIMEOUT);
    }
  }, {
    key: "startTimerForPreviewStop",
    value: function startTimerForPreviewStop() {
      var _this4 = this;

      var $timeout = this.$timeout;
      this.showPreviewStopTimer = new Date().getTime();
      this.showPreviewStop = true;
      $timeout(function () {
        if (_this4.showPreviewStopTimer <= new Date().getTime() - THUMBNAIL_TIMEOUT) {
          _this4.showPreviewStop = false;
        }
      }, THUMBNAIL_TIMEOUT);
    }
  }, {
    key: "setTrimBoundsFromSeconds",
    value: function setTrimBoundsFromSeconds(startSeconds, stopSeconds) {
      if (this.stopSegments === undefined) {
        this.startSeconds = startSeconds;
        this.stopSeconds = stopSeconds;
        return;
      }

      startSeconds = this.numberOr(startSeconds, 0);
      stopSeconds = this.numberOr(stopSeconds, this.stopSegments[this.stopSegments.length - 1].seconds);

      var startIndex = _.findIndex(this.stopSegments, function (segment) {
        return startSeconds < segment.seconds;
      });

      var stopIndex = _.findIndex(this.stopSegments, function (segment) {
        return stopSeconds <= segment.seconds;
      });

      this.setTrimBounds(startIndex, stopIndex);
    }
  }, {
    key: "setTrimBoundsFromSegments",
    value: function setTrimBoundsFromSegments(startSegment, stopSegment) {
      if (this.startSegments === undefined) {
        this.startSegment = startSegment;
        this.stopSegment = stopSegment;
        return;
      }

      startSegment = this.numberOr(startSegment, 0);
      stopSegment = this.numberOr(stopSegment, this.segments.length - 1);

      var startIndex = _.findIndex(this.startSegments, function (segment) {
        return segment.segmentIndex === startSegment;
      });

      var stopIndex = this.startSegments.length - 1;

      _.each(this.stopSegments, function (segment) {
        // There could be multiple segments that have the same segmentIndex, so iterate through
        // all to get the last one.
        if (segment.segmentIndex === stopSegment) {
          stopIndex = segment.segmentIndex;
        } else if (segment.segmentIndex > stopSegment) {
          return false; // Exit early.
        }
      });

      this.setTrimBounds(startIndex, stopIndex);
    }
  }, {
    key: "setTrimBounds",
    value: function setTrimBounds(startIndex, stopIndex) {
      if (startIndex === -1) {
        startIndex = 0;
      }

      if (stopIndex === -1) {
        stopIndex = this.stopSegments.length - 1;
      }

      this.trimBounds = [startIndex, stopIndex];
      this.playhead = this.trimBounds[0];
      this.playheadControl = {};
    }
  }, {
    key: "numberOr",
    value: function numberOr(number, defaultValue) {
      // NOTE: "" or null should return the defaultValue but "0" should stay 0
      if (!isNaN(parseInt(number))) {
        return number;
      } else {
        return defaultValue;
      }
    }
  }, {
    key: "initWatchers",
    value: function initWatchers() {
      var _this5 = this;

      var $scope = this.$scope;
      $scope.$watch(function () {
        return _this5.segments && _this5.previewQueryString && _this5.previewBaseURL && _this5.trimBounds[0];
      }, function (v) {
        v = v || 0;
        var segmentIndex = _this5.startSegments[v].segmentIndex;
        _this5.previewStartUrl = _this5.segmentPreviewURL(segmentIndex) || '/img/recording-start.png';
        _this5.showPreviewStart = true;

        _this5.startTimerForPreviewStart();

        _this5.sliderOptsPlayhead.floor = _this5.trimBounds[0];
      });
      $scope.$watch(function () {
        return _this5.segments && _this5.previewQueryString && _this5.previewBaseURL && _this5.trimBounds[1];
      }, function (v) {
        v = (v || 0) + 1;

        if (_this5.startSegments.length == v) {
          _this5.previewStopUrl = '/img/recording-end.png';
        } else {
          var segmentIndex = _this5.startSegments[v].segmentIndex;
          _this5.previewStopUrl = _this5.segmentPreviewURL(segmentIndex);
        }

        _this5.showPreviewStop = true;

        _this5.startTimerForPreviewStop();

        _this5.sliderOptsPlayhead.ceil = _this5.trimBounds[1];
      });
      $scope.$watch(function () {
        return _this5.segments && _this5.previewQueryString && _this5.previewBaseURL && _this5.playhead;
      }, function (v) {
        v = v || 0;

        if (v == _this5.startSegments.length) {
          _this5.previewUrl = '/img/recording-end.png';
          _this5.previewCaption = _this5.stopSegments[v - 1].label;
        } else {
          var segmentIndex = _this5.startSegments[v].segmentIndex;
          _this5.previewUrl = _this5.segmentPreviewURL(segmentIndex);
          _this5.previewCaption = _this5.startSegments[v || 0].label;
        }
      });
      $scope.$watchCollection(function () {
        return _this5.trimBounds;
      }, function () {
        return _this5.onTrimBoundsChanged();
      });
    }
  }, {
    key: "onTrimBoundsChanged",
    value: function onTrimBoundsChanged() {
      var _this6 = this;

      // user dragged the left/right handles (or they changed externally)
      // show them the preview under their handles
      var $scope = this.$scope,
          $timeout = this.$timeout;
      /*
      * The following logic attempted to smartly keep the playhead where it was
      * when it made sense to do so but had some strange side-effects
      if (this.playhead < this.trimBounds[0]) {
      this.playhead = this.trimBounds[0];
      } else if (this.playhead > (1 + this.trimBounds[1])) {
      this.playhead = (1 + this.trimBounds[1]);
      }
      */
      // Any time you change bounds, reset playhead to start of clip

      this.playhead = this.trimBounds[0];

      if (_.isFunction($scope.onChangeBounds)) {
        $scope.onChangeBounds(this.startSegments[this.trimBounds[0]].seconds, this.stopSegments[this.trimBounds[1]].seconds, this.startSegments[this.trimBounds[0]].segmentIndex, this.stopSegments[this.trimBounds[1]].segmentIndex);
      }

      $timeout(function () {
        return _this6.positionMasks();
      });
    }
  }, {
    key: "positionMasks",
    value: function positionMasks() {
      // position the shaders over the to-be-hidden regions that were clipped
      // position the cut point previews exactly
      var handles = $('.trim .rz-pointer');
      var leftHandle = $(handles.get(0));
      var rightHandle = $(handles.get(1));
      $('.start-point-preview').css({
        left: leftHandle.css('left')
      });
      $('.end-point-preview').css({
        left: rightHandle.css('left')
      });
      $('.start-point-mask').css({
        width: leftHandle.css('left')
      });
      $('.end-point-mask').css({
        left: rightHandle.css('left')
      });
    }
  }, {
    key: "initRecording",
    value: function initRecording(recording) {
      // Initialize to be full length of recording, unless it was set externally already
      if (this.startSegment !== undefined) {
        this.setTrimBoundsFromSegments(this.startSegment, this.stopSegment);
      } else if (this.startSeconds !== undefined) {
        this.setTrimBoundsFromSeconds(this.startSeconds, this.stopSeconds);
      } else if (this.recording.start_segment !== '') {
        this.setTrimBoundsFromSegments(recording.start_segment, recording.stop_segment);
      } else if (this.recording.start_seconds !== '') {
        this.setTrimBoundsFromSeconds(recording.start_seconds, recording.stop_seconds);
      } else {
        this.setTrimBounds(0, this.startSegments.length - 1);
      } // Pick apart recording preview URL so that we can build thumbnail URLs later


      var idxQ = recording.preview.indexOf('?');

      if (idxQ > -1) {
        this.previewQueryString = recording.preview.substring(idxQ + 1);
        var previewWithoutQuery = recording.preview.substring(0, idxQ);

        if (previewWithoutQuery.match(/\/[^\/]+$/)) {
          this.previewBaseURL = previewWithoutQuery.replace(/[^\/]+$/, '');
        }
      }

      this.initPreviewMosaic();
    }
  }, {
    key: "initSegments",
    value: function initSegments(segments) {
      var _this7 = this;

      this.segments = segments;
      this.startSegments = [];
      this.stopSegments = [];
      this.segmentTimes = [0]; // Walk through each of the individual segment durations to build
      // accumlated totals for both starting and stopping at that index.

      var time = '0:00:00';
      var secs = 0.0;

      _.each(this.segments, function (segment, i) {
        if (segment.duration_ts === 0) {
          return;
        }

        var byteranges = segment.byte_ranges;

        if (byteranges !== undefined && Object.keys(byteranges).length > 0 && Object.keys(byteranges)[0].length > 0) {
          _.each(byteranges[Object.keys(byteranges)[0]], function (byterange) {
            var duration = byterange.dur / 90000.0;

            _this7.startSegments.push({
              segmentIndex: i,
              label: time,
              seconds: secs
            });

            secs += duration;

            _this7.segmentTimes.push(secs);

            time = Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["e" /* secondsToFormattedLabel */])(secs);

            _this7.stopSegments.push({
              segmentIndex: i,
              label: time,
              seconds: secs
            });
          });
        } else {
          var duration = segment.duration_ts / 90000.0;

          _this7.startSegments.push({
            segmentIndex: i,
            label: time,
            seconds: secs
          });

          secs += duration;

          _this7.segmentTimes.push(secs);

          time = Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["e" /* secondsToFormattedLabel */])(secs);

          _this7.stopSegments.push({
            segmentIndex: i,
            label: time,
            seconds: secs
          });
        }
      });
    }
  }, {
    key: "setZoom",
    value: function setZoom(zoom) {
      var _this8 = this;

      var $scope = this.$scope,
          $timeout = this.$timeout; // Force it between 100% and 1000%

      this.zoom = Math.max(1, Math.min(10, zoom));
      this.initPreviewMosaic(); // Attempt to keep left handle in same position before/after resize

      var currentScroll = $('.zoom-scroll-pan-container').get(0).scrollLeft;
      var handles = $('.trim .rz-pointer');
      var currentLeftHandleOffset = handles.get(0).offsetLeft;
      var currentLeftHandlePosInViewport = currentLeftHandleOffset - currentScroll;
      $timeout(function () {
        // Need to kick the rzslider in the teeth a bit
        $scope.$broadcast('reCalcViewDimensions');
        $scope.$broadcast('rzSliderForceRender'); // Wait for rzslider; then reposition window

        $timeout(function () {
          var newLeftHandleOffset = handles.get(0).offsetLeft;
          var newLeftHandlePosInViewport = newLeftHandleOffset - currentScroll;

          if (newLeftHandlePosInViewport != currentLeftHandlePosInViewport) {
            var nudge = currentLeftHandlePosInViewport - newLeftHandlePosInViewport;
            $('.zoom-scroll-pan-container').get(0).scrollLeft = $('.zoom-scroll-pan-container').get(0).scrollLeft - nudge; //console.log('nudged', nudge, 'to the left', $('.zoom-scroll-pan-container').get(0).scrollLeft);
          } else {//console.log('keeping zoom');
          }

          _this8.positionMasks();
        });
      });
    }
  }, {
    key: "zoomIn",
    value: function zoomIn() {
      this.setZoom(this.zoom + 0.5);
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      this.setZoom(this.zoom - 0.5);
    }
  }, {
    key: "panLeft",
    value: function panLeft() {
      var $container = $('.zoom-scroll-pan-container');
      var currentScroll = $container[0].scrollLeft;
      $container[0].scrollLeft = Math.max(0, currentScroll - 50);
    }
  }, {
    key: "panRight",
    value: function panRight() {
      var $container = $('.zoom-scroll-pan-container');
      var $content = $('.zoom-scroll-pan-container > div');
      var currentScroll = $container[0].scrollLeft;
      var padding = 20;
      var maxScroll = $content[0].offsetWidth + padding - $container[0].offsetWidth;
      $container[0].scrollLeft = Math.min(maxScroll, currentScroll + 50);
    }
  }, {
    key: "initPreviewMosaic",
    value: function initPreviewMosaic() {
      var _this9 = this;

      // Pick out N evenly spaced images out of the segments
      // Aim for background images approximately spaced every 75px
      var containerWidth = $('.mosaic').width();
      var numberImages = Math.ceil(containerWidth / 75);
      this.previewMosaic = [];

      if (this.segments.length <= numberImages) {
        // You can't always get what you want...
        numberImages = this.segments.length;
      } // Figure out start points we want
      // 0 sec, time / 8, 2 * time / 8, 3 * time / 8, ... 7 * time / 8
      // Figure out which segment image contains that time, and use it
      //let totalTime = _.last(this.stopSegments).seconds;
      //let cuePoints = _.range(8).map((i) => totalTime * i / 8.0);


      var totalSegments = this.segments.length;

      var cuePoints = _.range(numberImages).map(function (i) {
        return Math.floor(1.0 * totalSegments * i / numberImages);
      });

      _.each(cuePoints, function (frame) {
        return _this9.previewMosaic.push(_this9.segmentPreviewURL(frame));
      }); //console.log('Loaded mosaoic', this.segments, totalSegments, cuePoints, this.previewMosaic);

    }
  }]);

  return RecordingTrimmerController;
}());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = "<div class=\"recording-trimmer\"\n  ng-controller=\"RecordingTrimmerController as vm\"\n  cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\"\n  >\n\n  <div class=\"form-group\">\n\n    <div style=\"background:#000;\">\n      <div style=\"max-width:640px; margin:0 auto;\">\n        <div class=\"fixed-16-9\"\n            ng-style=\"{\n              'background-image': 'url(&quot;'+vm.previewUrl+'&quot;)',\n              'background-size': 'contain',\n              'background-repeat': 'no-repeat'\n            }\">\n        </div>\n      </div>\n    </div>\n    <div style=\"position:relative;bottom:2em;text-align:center;background:rgba(0,0,0,0.5);color:white;font:bold 150% sans-serif;z-index:1\">\n      {{vm.previewCaption}}\n    </div>\n    <div style=\"position:relative;top:-33px;margin-bottom:-18px;\">\n      <rzslider class=\"playhead\"\n                rz-slider-model=\"vm.playhead\"\n                rz-slider-options=\"vm.sliderOptsPlayhead\"></rzslider>\n    </div>\n\n    <div class=\"zoom-scroll-pan-container\">\n      <div style=\"position:relative; width:{{vm.zoom * 100}}%\">\n        <!--<div class=\"slider-zoom-trapezoid\">&nbsp;</div>-->\n        <div class=\"mosaic\">\n          <div ng-repeat=\"img in vm.previewMosaic track by $index\"\n            ng-style=\"{\n              'background-image': 'url(' + img + ')',\n              'width': (100.0 / vm.previewMosaic.length) + '%'\n            }\">\n            &nbsp;\n          </div>\n        </div>\n        <div>\n          <rzslider class=\"trim\"\n                    rz-slider-model=\"vm.trimBounds[0]\"\n                    rz-slider-high=\"vm.trimBounds[1]\"\n                    rz-slider-options=\"vm.sliderOptsTrim\"></rzslider>\n        </div>\n        <div class=\"clearfix\" style=\"position:relative;height:0px;overflow:visible\">\n          <div class=\"start-point-preview\" ng-show=\"vm.showPreviewStart\">\n            <div>\n              <img ng-src=\"{{vm.previewStartUrl}}\" alt=\"preview start\" />\n            </div>\n          </div>\n          <div class=\"end-point-preview\" ng-show=\"vm.showPreviewStop\">\n            <div>\n              <img ng-src=\"{{vm.previewStopUrl}}\" alt=\"preview stop\" />\n            </div>\n          </div>\n        </div>\n        <div class=\"start-point-mask hidden-region-mask\"></div>\n        <div class=\"end-point-mask hidden-region-mask\"></div>\n      </div>\n    </div>\n    <div class=\"clearfix\">\n      <div class=\"text-center\">\n        <table align=\"center\"><tr>\n          <td>\n            <button ng-show=\"vm.zoom > 1.0\" class=\"btn btn-default\" type=\"button\" ng-click=\"vm.panLeft()\">\n              <i class=\"fa fa-caret-left\"></i>\n            </button>&nbsp;\n          </td>\n          <td>\n            <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.zoomOut()\">\n              <i class=\"fa fa-search-minus\"></i>\n            </button>\n          </td>\n          <td style=\"text-align:center; padding:0 10px\"><small>Zoom ({{vm.zoom * 100}}%)</small></td>\n          <td>\n            <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.zoomIn()\">\n              <i class=\"fa fa-search-plus\"></i>\n            </button>\n          </td>\n          <td>\n            &nbsp;<button ng-show=\"vm.zoom > 1.0\" class=\"btn btn-default\" type=\"button\" ng-click=\"vm.panRight()\">\n              <i class=\"fa fa-caret-right\"></i>\n            </button>\n          </td>\n        </tr></table>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n\n"

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// directive
//   <scoreboard-diagnostics-status scoreboard-configuration="scoreboardConfiguration" stream-diagnostics="streamDiagnostics" />
//
angular.module('app.directives').component('scoreboardDiagnosticsStatus', {
  restrict: 'E',
  bindings: {
    scoreboardConfiguration: '=',
    streamDiagnostics: '='
  },
  template: __webpack_require__(336),
  controllerAs: 'vm',
  controller: ["$scope", function ScoreboardDiagnosticsStatusController($scope) {
    'ngInject';

    var _this = this;

    var recalculate = function recalculate() {
      _this.usingScoreboardAssist = (_this.scoreboardConfiguration || {}).scoreboard_make == 'BoxCast';
      _this.scoreboardMode = (((_this.streamDiagnostics || {}).scoreboard || {}).scoreboard_assist || {}).operation_mode;
      _this.serialPortIsOpen = (_this.streamDiagnostics || {}).serial_port_is_open;
      _this.serialPortIsOpenStyle = _this.serialPortIsOpen == undefined ? {
        'font-style': 'italic',
        color: '#848484'
      } : {};
      _this.scoreboardAssistLinked = (_this.streamDiagnostics || {}).scoreboard_assist_linked;
      _this.scoreboardAssistLinkedStyle = _this.scoreboardAssistLinked == undefined ? {
        'font-style': 'italic',
        color: '#848484'
      } : {};
      _this.scoreboardAssistConnected = (_this.streamDiagnostics || {}).scoreboard_assist_connected;
      _this.scoreboardAssistConnectedStyle = _this.scoreboardAssistConnected == undefined ? {
        'font-style': 'italic',
        color: '#848484'
      } : {};
      _this.receivingScoreboardData = (_this.streamDiagnostics || {}).receiving_scoreboard_data;
      _this.receivingScoreboardDataStyle = _this.receivingScoreboardData == undefined ? {
        'font-style': 'italic',
        color: '#848484'
      } : {};
      _this.decodeErrors = (_this.streamDiagnostics || {}).scoreboard_data_decode_errors;
      _this.decodeErrorsStyle = _this.decodeErrors == undefined ? {
        'font-style': 'italic',
        color: '#848484'
      } : {};
    };

    $scope.$watchGroup(['scoreboardConfiguration', 'streamDiagnostics'], recalculate);
    recalculate();
  }]
});

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = "<div style=\"position:relative\">\n  <div style=\"position:absolute; top:13px; border-bottom: 1px solid #eee; width: 100%; z-index:0;\"></div>\n<table class=\"scoreboard-diagnostics-status\"\n       ng-class=\"{\n        'five-wide': (vm.usingScoreboardAssist && vm.scoreboardMode == 'pair'),\n        'four-wide': (vm.usingScoreboardAssist && !vm.scoreboardMode == 'pair'),\n        'three-wide': (!vm.usingScoreboardAssist)\n       }\" style=\"position: relative; z-index: 1\">\n  <tr>\n\n    <!-- Is my scoreboard adapter / scoreboard assist connected to my BoxCaster? [legacy, pair/single] -->\n    <td>\n      <div ng-style=\"vm.serialPortIsOpenStyle\">\n        <i class=\"fa fa-check-circle\" style=\"color:#13640E\" ng-show=\"vm.serialPortIsOpen == true\"></i>\n        <i class=\"fa fa-times-circle\" style=\"color:#CE3D3E\" ng-show=\"vm.serialPortIsOpen == false\"></i>\n        <i class=\"fa fa-circle-thin\" ng-show=\"vm.serialPortIsOpen == undefined\"></i>\n        Scoreboard\n        <span ng-show=\"vm.usingScoreboardAssist\">Assist</span>\n        <span ng-hide=\"vm.usingScoreboardAssist\">adapter</span>\n        connected to BoxCaster\n      </div>\n\n    </td>\n\n    <!-- Is my scoreboard assist box side linked to the scoreboard side? [pair] -->\n    <td ng-if=\"vm.usingScoreboardAssist && vm.scoreboardMode == 'pair'\">\n      <div ng-style=\"vm.scoreboardAssistLinkedStyle\">\n        <i class=\"fa fa-check-circle\" style=\"color:#13640E\" ng-show=\"vm.scoreboardAssistLinked == true\"></i>\n        <i class=\"fa fa-times-circle\" style=\"color:#CE3D3E\" ng-show=\"vm.scoreboardAssistLinked == false\"></i>\n        <i class=\"fa fa-circle-thin\" ng-show=\"vm.scoreboardAssistLinked == undefined\"></i>\n        Scoreboard Assist pair linked\n      </div>\n    </td>\n\n    <!-- Is my scoreboard assist connected to a scoreboard controller? [pair/single] -->\n    <td ng-if=\"vm.usingScoreboardAssist\">\n      <div ng-style=\"vm.scoreboardAssistConnectedStyle\">\n        <i class=\"fa fa-check-circle\" style=\"color:#13640E\" ng-show=\"vm.scoreboardAssistConnected == true\"></i>\n        <i class=\"fa fa-times-circle\" style=\"color:#CE3D3E\" ng-show=\"vm.scoreboardAssistConnected == false\"></i>\n        <i class=\"fa fa-circle-thin\" ng-show=\"vm.scoreboardAssistConnected == undefined\"></i>\n        Scoreboard Assist connected to scoreboard controller\n      </div>\n    </td>\n\n    <!-- Is the server receiving scoreboard data? [legacy, pair/single] -->\n    <td>\n      <div ng-style=\"vm.receivingScoreboardDataStyle\">\n        <i class=\"fa fa-check-circle\" style=\"color:#13640E\" ng-show=\"vm.receivingScoreboardData == true\"></i>\n        <i class=\"fa fa-times-circle\" style=\"color:#CE3D3E\" ng-show=\"vm.receivingScoreboardData == false\"></i>\n        <i class=\"fa fa-circle-thin\" ng-show=\"vm.receivingScoreboardData == undefined\"></i>\n        Receiving data from\n        <span ng-show=\"vm.usingScoreboardAssist\">Scoreboard Assist</span>\n        <span ng-hide=\"vm.usingScoreboardAssist\">scoreboard adapter</span>\n\n    </td>\n\n    <!-- Is the server successfully decoding the scoreboard data? [legacy, pair/single] -->\n    <td>\n      <div ng-style=\"vm.decodeErrorsStyle\">\n        <i class=\"fa fa-check-circle\" style=\"color:#13640E\" ng-show=\"vm.decodeErrors == false\"></i>\n        <i class=\"fa fa-times-circle\" style=\"color:#CE3D3E\" ng-show=\"vm.decodeErrors == true\"></i>\n        <i class=\"fa fa-circle-thin\" ng-show=\"vm.decodeErrors == undefined\"></i>\n        Decoding data from\n        <span ng-show=\"vm.usingScoreboardAssist\">Scoreboard Assist</span>\n        <span ng-hide=\"vm.usingScoreboardAssist\">scoreboard adapter</span>\n      </div>\n    </td>\n\n  </tr>\n</table>\n</div>"

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

// directive
//   <scoreboard-link-status linked="linked" rssi="rssi" />
//
angular.module('app.directives').component('scoreboardLinkStatus', {
  restrict: 'E',
  bindings: {
    linked: '=',
    rssi: '='
  },
  template: __webpack_require__(338),
  controllerAs: 'vm',
  controller: ["$scope", "$sce", function ScoreboardDiagnosticsStatusController($scope, $sce) {
    'ngInject'; // convert dBm to a number between 0 and 1. This is based on some BoxCaster code:
    // https://github.com/boxcast/boxcaster/blob/master/lib/platform-specific/bc4k/wifi_config.rb#L250-L258

    var _this = this;

    var dbmToPercent = function dbmToPercent(dbm) {
      return dbm >= 0.0 ? 1.0 : _.min([_.max([0.982 - 0.00379 * dbm + -0.000154 * Math.pow(dbm, 2), 0.0]), 1.0]);
    };

    var recalculate = function recalculate() {
      _this.signalStrengthPercent = dbmToPercent(_this.rssi);

      if (_this.signalStrengthPercent < 0.25) {
        _this.faClass = 'text-danger';
      } else if (_this.signalStrengthPercent < 0.5) {
        _this.faClass = 'text-warning';
      } else if (_this.signalStrengthPercent < 0.75) {
        _this.faClass = 'text-success opacity-80';
      } else {
        _this.faClass = 'text-success';
      }

      _this.tooltipHTML = $sce.trustAsHtml("".concat(Math.round(100 * _this.signalStrengthPercent), "%<br/>(").concat(Math.round(_this.rssi), " dBm)"));
    };

    $scope.$watchGroup(['linked', 'rssi'], recalculate);
    recalculate();
  }]
});

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = "<div class=\"text-center\">\n  <div>\n    <div ng-show=\"vm.linked\" uib-tooltip-html=\"vm.tooltipHTML\" tooltip-append-to-body=\"true\">\n      <i class=\"fa fa-3x fa-signal {{vm.faClass}}\"></i>\n    </div>\n    <div ng-hide=\"vm.linked\" style=\"position:relative\" uib-tooltip=\"Not connected\" tooltip-append-to-body=\"true\">\n      <!--span class=\"fa-stack fa-3x\">\n        <i class=\"fa fa-signal fa-stack-1x\"></i>\n        <i class=\"fa fa-ban fa-stack-2x\"></i>\n      </span-->\n      <!--\n      <i class=\"fa fa-3x fa-signal opacity-40\"></i>\n      <div class=\"scoreboard-link-status--strike\"></div>\n      -->\n      <i class=\"fa fa-3x fa-ban opacity-40\"></i>\n    </div>\n  </div>\n  <div style=\"margin-top:10px\">\n    Link Status\n  </div>\n</div>"

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// show-password directive
// <input type=password show-password="showPassword" ng-model="thePassword">
var module = angular.module('app.directives');
module.directive('showPassword', function () {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      scope.$watch(attrs.showPassword, function (newValue) {
        if (newValue) {
          elem.attr('type', 'text');
        } else {
          elem.attr('type', 'password');
        }
      });
    }
  };
});

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// source chooser directive
//
//   <source-chooser edit-or-create-event-service="vm.service" />
//
var module = angular.module('app.directives');
module.directive('sourceChooser', function () {
  return {
    restrict: 'E',
    scope: {
      editOrCreateEventService: '='
    },
    template: "\n      <div ng-if=\"(editOrCreateEventService.broadcast.timeframe||'future') != 'future'\">\n        {{editOrCreateEventService.broadcast | streamSourceName}}\n      </div>\n      <div ng-if=\"(editOrCreateEventService.broadcast.timeframe||'future') == 'future'\">\n        <select selectize\n              ng-model=\"editOrCreateEventService.broadcast.boxcaster_id\"\n              ng-change=\"editOrCreateEventService.updateScoreboardMakes(); editOrCreateEventService.getConflictingEvents()\"\n              options=\"editOrCreateEventService.sources\"\n              config=\"selectizeConfig\"></select>\n        <div style=\"margin:5px 0 0 0\" ng-if=\"firmwareIssue || firmwareUpdate\">\n          <a ng-if=\"firmwareIssue\" href=\"{{vueDashboardRoot}}/sources?boxcaster_id={{editOrCreateEventService.broadcast.boxcaster_id}}\" class=\"label label-warning\">\n            Firmware Issue\n          </a>\n          <a ng-if=\"firmwareUpdate\" href=\"{{vueDashboardRoot}}/sources?boxcaster_id={{editOrCreateEventService.broadcast.boxcaster_id}}\" class=\"label label-info\">\n            Firmware Update Available\n          </a>\n        </div>\n      </div>\n    ",
    controller: ["$scope", function controller($scope) {
      'ngInject';

      $scope.$watch(function () {
        return $scope.editOrCreateEventService.selectedBoxCaster;
      }, function (boxcaster) {
        $scope.shouldBeBroadcasting = shouldBeBroadcasting(boxcaster);
        $scope.firmwareIssue = boxcaster && boxcaster.firmware_status == 'invalid';
        $scope.firmwareUpdate = boxcaster && boxcaster.firmware_status == 'outdated';
      });
      $scope.selectizeConfig = {
        valueField: 'id',
        labelField: 'name',
        placeholder: 'Select Source...',
        highlight: true,
        searchField: 'name',
        selectOnTab: true,
        closeAfterSelect: true,
        maxItems: 1,
        render: {
          option: renderSelectizeOption('source-chooser--option'),
          item: renderSelectizeOption('source-chooser--selected')
        }
      };
    }]
  };
});

function shouldBeBroadcasting(boxcaster) {
  if (boxcaster && boxcaster.next_broadcast_at) {
    return Date.now() > moment(boxcaster.next_broadcast_at);
  } else {
    return false;
  }
}

function renderSelectizeOption(wrapperCssClass) {
  return function (item, escape) {
    if (item.type.startsWith('boxcaster')) {
      return "\n        <div class=\"".concat(wrapperCssClass, "\">\n          <small class=\"pull-right\" style=\"text-transform:capitalize\">\n            ").concat(boxcasterStatusIcon(item), "\n          </small>\n          <span class=\"source-icon source-icon--").concat(item.type, "\"/>\n          ").concat(item.name, "\n        </div>\n      ");
    } else if (item.type === 'static_rtmp') {
      return "\n        <div class=\"".concat(wrapperCssClass, "\">\n          <small class=\"pull-right\" style=\"text-transform:capitalize\">\n            ").concat(staticRtmpStatusIcon(item), "\n          </small>\n          <span class=\"source-icon source-icon--").concat(item.type, "\"/>\n          ").concat(item.name, "\n        </div>\n      ");
    } else if (item.type === 'recording') {
      return "\n        <div class=\"".concat(wrapperCssClass, "\">\n          <i class=\"fa fa-repeat\" style=\"width:15px; margin-left: 5px; margin-right: 10px;\"></i>\n          ").concat(item.name, "\n        </div>\n      ");
    } else {
      return "\n        <div class=\"".concat(wrapperCssClass, "\">\n          <span class=\"source-icon source-icon--").concat(item.type, "\"/>\n          ").concat(item.name, "\n        </div>\n      ");
    }
  };
}

function boxcasterStatusIcon(item) {
  // Simplified version of <boxcaster-status-label /> logic
  if (item.status == 'ready') {
    return "<i class=\"source-icon--ready fa fa-circle\"></i> Online";
  } else if (item.status.indexOf('broadcast') >= 0) {
    return "<i class=\"source-icon--in-use fa fa-circle\"></i> Broadcasting";
  } else if (shouldBeBroadcasting(item)) {
    return "<i class=\"source-icon--issue fa fa-circle\"></i> Check Source";
  } else {
    return "<i class=\"source-icon--offline fa fa-circle\"></i> ".concat(item.status);
  }
}

function staticRtmpStatusIcon(item) {
  if (!(item.diagnostics || {}).connected) {
    return "<i class=\"source-icon--offline fa fa-circle\"></i> Offline";
  }

  if (item.diagnostics.broadcasting) {
    return "<i class=\"source-icon--in-use fa fa-circle\"></i> Broadcasting";
  }

  return "<i class=\"source-icon--ready fa fa-circle\"></i> Connected";
}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// star rating directive
//
//   <star-rating count="2.5" />
var module = angular.module('app.directives');
module.component('starRating', {
  restrict: 'E',
  bindings: {
    count: '='
  },
  controllerAs: '$ctrl',
  template: "\n    <span ng-switch=\"$ctrl.count\">\n      <span ng-switch-when=\"5\">\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n      </span>\n      <span ng-switch-when=\"4.5\">\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star-half-o\"></i>\n      </span>\n      <span ng-switch-when=\"4\">\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n      </span>\n      <span ng-switch-when=\"3\">\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n      </span>\n      <span ng-switch-when=\"2\">\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n      </span>\n      <span ng-switch-when=\"1\">\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n      </span>\n      <span ng-switch-default>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n      </span>\n    </span>\n  "
});

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// stat block directive
//
//   <stat-block label="Stat Name" value="123" />
var module = angular.module('app.directives');
module.directive('statBlock', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      label: '=',
      value: '=',
      format: '@',
      size: '@'
    },
    template: "\n      <div class=\"stat-block {{size}}\"\n           ng-class=\"{\n              'col-xs-12': size == 'full' || !size,\n              'col-xs-6': size == 'half-l' || size == 'half-r'\n           }\">\n        <h2 ng-if=\"format === undefined || format == 'number'\">\n          <span fittext>\n            {{value | number}}\n          </span>\n        </h2>\n        <h2 ng-if=\"format == 'currency'\" class=\"text-center\">\n          <span fittext>\n            ${{value | number:2}}\n          </span>\n        </h2>\n        <h2 ng-if=\"format == 'hours'\" class=\"text-center\">\n          <span fittext>\n            {{value | number:1}}\n          </span>\n        </h2>\n\n        <h5 class=\"text-center overflow-ellipse\">{{label}}</h5>\n      </div>\n    "
  };
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_rtmp__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_utils__ = __webpack_require__(9);
// directive
//   <stream-diagnostics broadcast="broadcast" />
//



var RELOAD_INTERVAL_MS = 30000; // The current implementation limits read sizes to 1 byte and completely ignores the message. This
// is just some data to keep the socket alive.

var WEBSOCKET_PING_MESSAGE = 'x';
var WEBSOCKET_PING_INTERVAL_MS = 10000;
var WEBSOCKET_ERROR_DELAY_MS = 10000;
var SCOREBOARD_ASSIST_FIRMWARE_IMAGE_NAME = 'wsa2_firmware.bin';
var xAxisTimeCfg = {
  type: 'time',
  gridLines: {
    display: false,
    drawBorder: false
  },
  position: 'bottom',
  distribution: 'series',
  source: 'auto',
  time: {
    unit: 'minute',
    displayFormats: {
      minute: 'h:mm a'
    }
  },
  ticks: {
    fontSize: 11,
    fontFamily: 'Arial, sans-serif',
    autoSkip: true
  }
};
angular.module('app.directives').component('streamDiagnostics', {
  restrict: 'E',
  bindings: {
    broadcast: '=',
    onReload: '='
  },
  template: __webpack_require__(344),
  controllerAs: 'vm',
  controller: function StreamDiagnosticsController($http, $interval, $q, $timeout, $scope, $rootScope, ScoreboardAssistFirmware) {
    'ngInject';

    var _this = this;

    this.broadcast; //<-- injected via binding

    this.graphType = this.broadcast.timeframe == 'past' ? 'coarse' : 'fine';
    this.timeoutHandle = null;
    this.activeTab = 'stream health'; // This may be overridden later if there's scoreboard data for this broadcast, even if it's currently disabled.

    this.showScoreboard = false; // Will be set later if/when we receive valid scoreboard data

    this.scoreboardMode = null;
    $scope.$on('$destroy', function () {
      return $timeout.cancel(_this.timeoutHandle);
    });
    this.latestScoreboardAssistFirmwareVersion = null;

    if (this.broadcast.timeframe != 'past' && (this.broadcast.scoreboard_configuration || {}).scoreboard_make == 'BoxCast') {
      // If we're using the scoreboard assist, go fetch the latest firmware version
      ScoreboardAssistFirmware.version({
        id: SCOREBOARD_ASSIST_FIRMWARE_IMAGE_NAME
      }, function (resp) {
        _this.latestScoreboardAssistFirmwareVersion = resp.version;
      }, function (e) {
        console.warn('Error getting latest Scoreboard Assist firmware version', e);
      });
    }

    this.pastSummary = function () {
      switch ((_this.streamDiagnostics || {}).summary_status) {
        case 'OK':
          return {
            icon: '',
            text: ''
          };

        case 'Warning':
          return {
            icon: '',
            text: ''
          };

        case 'Critical':
          return {
            icon: '',
            text: ''
          };

        default:
          return {
            icon: '',
            text: ''
          };
      }
    };

    this.alertsFilter = function (value) {
      return value.is_active;
    };

    this.updateGraph = function () {
      if (_this.streamDiagnostics) {
        processGraphData();
      }
    };

    this.handleNewData = function (data) {
      _this.streamDiagnostics = data;

      if (_this.streamDiagnostics) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["a" /* BaselineIngestLatency */])(_this.streamDiagnostics, _this.broadcast);
        _this.scoreboardMode = ((_this.streamDiagnostics.scoreboard || {}).scoreboard_assist || {}).operation_mode; // If this.showScoreboard is false, make it true if there's data here

        _this.showScoreboard = _this.streamDiagnostics.data_version >= 3 && Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["g" /* HasIntegratedScoreboard */])(_this.broadcast.scoreboard_configuration) || Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["i" /* V3HasAnyScoreboardData */])(_this.streamDiagnostics);
        processGraphData();

        if (_this.broadcast.timeframe == 'past') {
          _this.pastBroadcastStarCount = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["d" /* ComputePastBroadcastStarRating */])(_this.streamDiagnostics || {});
          _this.pastBroadcastRecommendations = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["c" /* ComputePastBroadcastRecommendations */])(_this.broadcast, _this.streamDiagnostics || []);
        }

        $timeout(function () {
          return _this.onReload(_this.streamDiagnostics);
        });
      }
    };

    this.loadViaGet = function () {
      return $http.get("".concat(API_ROOT, "/account/broadcasts/").concat(_this.broadcast.id, "/stream_diagnostics")).then(function (r) {
        _this.handleNewData(r.data); // Decide on whether or not to auto-reload


        if (_this.broadcast.timeframe != 'past') {
          $timeout.cancel(_this.timeoutHandle);
          _this.timeoutHandle = $timeout(function () {
            return _this.loadViaGet();
          }, RELOAD_INTERVAL_MS);
        }
      })["catch"](function (err) {
        console.error('Error getting stream diagnostics', err); // Try again after the reload interval

        $timeout.cancel(_this.timeoutHandle);
        _this.timeoutHandle = $timeout(function () {
          return _this.loadViaGet();
        }, RELOAD_INTERVAL_MS);
      });
    }; // Returns a promise indicating whether or not we successfully got the WebSocket set up. If
    // not, load falls back to using HTTP.


    this.loadViaWebSocket = function () {
      var d = $q.defer(); // First, get the websocket address from the API

      $http.get("".concat(API_ROOT, "/account/broadcasts/").concat(_this.broadcast.id, "/stream_diagnostics/wss_endpoint")).then(function (r) {
        // Second, open the websocket to the address
        var wssAddress = r.data;

        var makeWebSocket = function makeWebSocket() {
          var ws = new WebSocket(wssAddress + '?access_token=' + encodeURIComponent(Object(__WEBPACK_IMPORTED_MODULE_2__auth_utils__["a" /* getAuthToken */])()));
          var pingInterval = null;
          var scopeDestroying = false;
          var opened = false;
          ws.addEventListener('open', function (e) {
            opened = true;
            pingInterval = $interval(function () {
              return ws.send(WEBSOCKET_PING_MESSAGE);
            }, WEBSOCKET_PING_INTERVAL_MS, 0, false);
          });
          ws.addEventListener('close', function (e) {
            if (!scopeDestroying) {
              console.warn('Web socket closed unexpectedly', e);
              $interval.cancel(pingInterval);

              if (opened) {
                // If we DID successfully open the web socket, then just try again pretty much
                // right away, as we likely just got disconnected
                $timeout(function () {
                  try {
                    makeWebSocket();
                  } catch (err) {
                    console.error('Error creating the web socket', err);
                    remoteLogger.error('Error creating the web socket', {
                      error: err
                    });

                    _this.loadViaGet();
                  }
                });
              } else {
                // If we didn't actually open the web socket, the broadcast might have transitioned
                // to past/VOD. Retry from a higher level after a timeout.
                $timeout(_this.load, WEBSOCKET_ERROR_DELAY_MS);
              }
            }
          });
          var lastRawStatsCoarse = null;
          var lastRawScoreboardStatsCoarse = null;
          ws.addEventListener('message', function (e) {
            var data = null;

            try {
              data = JSON.parse(e.data);
            } catch (err) {
              console.error('Error parsing stream diagnostics data', err);
            }

            if (data) {
              // Not every update will contain coarse data, as the stream diagnostics service only
              // refreshes this every ~minute. So hang onto the latest one and glue it on when it's
              // missing.
              if (data.raw_stats_coarse) {
                lastRawStatsCoarse = data.raw_stats_coarse;
              } else {
                data.raw_stats_coarse = lastRawStatsCoarse;
              }

              if (data.raw_scoreboard_stats_coarse) {
                lastRawScoreboardStatsCoarse = data.raw_scoreboard_stats_coarse;
              } else {
                data.raw_scoreboard_stats_coarse = lastRawScoreboardStatsCoarse;
              }

              _this.handleNewData(data);
            }
          });
          $scope.$on('$destroy', function () {
            scopeDestroying = true;
            $interval.cancel(pingInterval);
            ws.close(1000);
          });
        };

        try {
          makeWebSocket();
          d.resolve(true);
        } catch (err) {
          console.error('Error creating the web socket', err);
          remoteLogger.error('Error creating the web socket', {
            error: err
          });
          d.reject(err);
        }
      })["catch"](function (err) {
        console.error('Error getting stream diagnostics web socket address', err);
        d.reject(err);
      });
      return d.promise;
    };

    this.load = function () {
      if (!_this.broadcast.id) {
        console.warn('Broadcast ID not available. Did you pass in an unresolved promise on accident?');
        return;
      }

      if (_this.broadcast.timeframe == 'future') {
        console.warn('Diagnostics not applicable for future broadcast');
        return;
      } // Figure out whether or not to open the websocket connection. Only do that if the broadcast
      // is current or preroll and web sockets appear to be supported.


      var supportsWebSockets = ('WebSocket' in window);

      if ((_this.broadcast.timeframe === 'preroll' || _this.broadcast.timeframe === 'current') && supportsWebSockets) {
        _this.loadViaWebSocket()["catch"](_this.loadViaGet);

        return;
      }

      _this.loadViaGet();
    };

    var statValuesForIndex = function statValuesForIndex(stats, i, j) {
      var series = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var r = ((stats || {}).results || [])[i];
      if (!r || !r.series || !r.series.length) return [];
      return _.map(r.series[series].values, function (t) {
        return t[j];
      });
    };

    var processGraphData = function processGraphData() {
      var stats = _this.streamDiagnostics.raw_stats;

      if (_this.graphType == 'coarse') {
        stats = _this.streamDiagnostics.raw_stats_coarse;
      }

      var dataVersion = _this.streamDiagnostics.data_version;
      var bitrateLimits = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["f" /* GetBitrateLimitsForBroadcast */])($rootScope.ApiConfig, _this.broadcast);

      var hasAnyData = function hasAnyData(data) {
        return !!data && data.length;
      };

      var hasAnyDataOrNull = function hasAnyDataOrNull(data) {
        return hasAnyData(data) ? data : null;
      };

      var bitrateSuggestedMax = 0;

      if (dataVersion >= 3) {
        _this.bitrateData = [];
        var videoBitrateData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'bitrate', 'video');

        if (hasAnyData(videoBitrateData)) {
          _this.bitrateData.push(videoBitrateData);

          bitrateSuggestedMax += (bitrateLimits.video || {}).nominal || 6000000;
        }

        var audioBitrateData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'bitrate', 'audio');

        if (hasAnyData(audioBitrateData)) {
          _this.bitrateData.push(audioBitrateData);

          bitrateSuggestedMax += (bitrateLimits.audio || {}).nominal || 128000;
        }

        _this.bitrateLabels = hasAnyDataOrNull(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(stats, 'bitrate', 'video')) || hasAnyDataOrNull(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(stats, 'bitrate', 'audio'));
        _this.framerateData = [];
        var videoFrameRateData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'frame_rate', 'video');
        if (videoFrameRateData) _this.framerateData.push(videoFrameRateData); // XXX: Although we likely have audio and score "frame" rate data, we pursposefully don't show it, as it's
        // potentially confusing to users.

        _this.framerateLabels = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(stats, 'frame_rate', 'video');
        _this.ingestLatencyData = [];
        _this.ingestLatencyLabels = [];

        if (stats.ingest_latency) {
          _this.ingestLatencyData.push(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'ingest_latency'));

          _this.ingestLatencyLabels = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(stats, 'ingest_latency');
        }

        _this.plData = [];
        _this.totalPacketsLost = 0;
        var videoPacketLossData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'packet_loss', 'video');

        if (hasAnyData(videoPacketLossData)) {
          _this.plData.push(videoPacketLossData);

          _this.totalPacketsLost += _.sum(videoPacketLossData);
        }

        var audioPacketLossData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'packet_loss', 'audio');

        if (hasAnyData(audioPacketLossData)) {
          _this.plData.push(audioPacketLossData);

          _this.totalPacketsLost += _.sum(audioPacketLossData);
        }

        var scorePacketLossData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'packet_loss', 'score');

        if (hasAnyData(scorePacketLossData) && _this.showScoreboard) {
          _this.plData.push(scorePacketLossData);

          _this.totalPacketsLost += _.sum(scorePacketLossData);
        }

        _this.plLabels = hasAnyDataOrNull(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(stats, 'packet_loss', 'video')) || hasAnyDataOrNull(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(stats, 'packet_loss', 'audio'));
        _this.simulcastData = [];
        _this.simulcastLabels = [];

        var rtmpURLs = _.keys(stats.simulcast_frame_rate || {}).sort();

        if (rtmpURLs.length > 0) {
          // XXX: Since simulcasts can be added and removed, and they're collected with fill(none), each RTMP URL
          // can potentially have a different set of timestamps than the others. Here we collect all the timestamps
          // and make sure that each series gets a placeholder for each timestamp.
          _this.simulcastLabels = _.uniq(_.flatten(_.map(_.values(stats.simulcast_frame_rate || {}), function (v) {
            return _.flatten([Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(v, 'video'), Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(v, 'audio')]);
          }))).sort();

          _.each(rtmpURLs, function (u) {
            var s = stats.simulcast_frame_rate[u];
            var videoSimulcastData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(s, 'video');

            if (hasAnyData(videoSimulcastData)) {
              var videoSimulcastTimestamps = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(s, 'video');

              _this.simulcastData.push(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["j" /* V3PlaceholderTimestamps */])(videoSimulcastData, videoSimulcastTimestamps, _this.simulcastLabels));
            }
          });
        }
      } else {
        var valuesForIndex = function valuesForIndex(i, j) {
          var series = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          return statValuesForIndex(stats || {}, i, j, series);
        };

        _this.bitrateData = [_([]).concat(valuesForIndex(0, 1), valuesForIndex(1, 1), valuesForIndex(2, 1)).value()];
        _this.bitrateLabels = _([]).concat(valuesForIndex(0, 0), valuesForIndex(1, 0), valuesForIndex(2, 0)).value();
        _this.framerateData = [valuesForIndex(3, 1)];
        _this.framerateLabels = valuesForIndex(3, 0);
        _this.ingestLatencyData = [];
        _this.ingestLatencyLabels = [];
        _this.plData = [valuesForIndex(7, 1), valuesForIndex(8, 1)];
        _this.plLabels = valuesForIndex(7, 0);
        _this.totalPacketsLost = _.sum(_this.plData[0]) + _.sum(_this.plData[1]); // Multiple series support for simulcast by destination

        if (stats.results && stats.results[4] && stats.results[4].series && stats.results[4].series.length) {
          _this.simulcastData = _.map(stats.results[4].series, function (s, i) {
            return valuesForIndex(4, 1, i);
          });
          _this.simulcastLabels = valuesForIndex(4, 0);
        }

        bitrateSuggestedMax = ((bitrateLimits.video || {}).nominal || 6000000) + ((bitrateLimits.audio || {}).nominal || 128000);
      }

      var expectedVideoFrameRate = (_this.broadcast.transcoder_profile || '').match(/p60/) ? 60 : 30;
      _this.plOptions = {
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        scales: {
          yAxes: [{
            gridLines: {
              color: '#EEEEEE',
              zeroLineColor: '#EEEEEE',
              drawTicks: false,
              drawBorder: false,
              tickMarkLength: 0
            },
            ticks: {
              suggestedMax: 100,
              beginAtZero: true,
              // use monospace font and 4 characters to align the graphs
              callback: function callback(value, index, values) {
                return padOut(Math.round(value), 4);
              },
              fontFamily: 'monospace',
              fontSize: 8
            },
            stacked: true
          }],
          xAxes: [_.extend({}, xAxisTimeCfg, {
            stacked: true
          })]
        },
        tooltips: {
          callbacks: {
            title: function title(items, data) {
              return moment(_this.plLabels[items[0].index]).format('ddd MMM Do, h:mm:ss a');
            },
            label: function label(item, data) {
              var kind = ['video ', 'audio ', 'serial '][item.datasetIndex] || '';
              return "".concat(item.yLabel, " ").concat(kind, "packets lost");
            }
          }
        }
      };
      _this.bitrateOptions = {
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        scales: {
          yAxes: [{
            gridLines: {
              color: '#EEEEEE',
              zeroLineColor: '#EEEEEE',
              drawTicks: false,
              drawBorder: false,
              tickMarkLength: 0
            },
            ticks: {
              suggestedMax: bitrateSuggestedMax,
              beginAtZero: true,
              // use monospace font and 4 characters to align the graphs
              callback: function callback(value, index, values) {
                return padOut(Math.round(value / 1000), 4);
              },
              fontFamily: 'monospace',
              fontSize: 8
            },
            stacked: true
          }],
          xAxes: [_.extend({}, xAxisTimeCfg, {
            stacked: true
          })]
        },
        tooltips: {
          callbacks: {
            title: function title(items, data) {
              return moment(_this.bitrateLabels[items[0].index]).format('ddd MMM Do, h:mm:ss a');
            },
            label: function label(item, data) {
              var kind = '';

              if (_this.bitrateData && _this.bitrateData.length > 1) {
                kind = ['Video: ', 'Audio: '][item.datasetIndex] || '';
              }

              return "".concat(kind).concat(Math.round(item.yLabel / 1000), " kbps");
            }
          }
        }
      };
      _this.bitrateDatasetOverride = [{
        pointRadius: 0,
        pointHitRadius: 5,
        pointHoverRadius: 4,
        cubicInterpolationMode: 'monotone'
      }, {
        pointRadius: 0,
        pointHitRadius: 5,
        pointHoverRadius: 4,
        cubicInterpolationMode: 'monotone'
      }];
      _this.framerateOptions = {
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        scales: {
          yAxes: [{
            gridLines: {
              color: '#EEEEEE',
              zeroLineColor: '#EEEEEE',
              drawTicks: false,
              drawBorder: false,
              tickMarkLength: 0
            },
            ticks: {
              suggestedMax: expectedVideoFrameRate,
              beginAtZero: true,
              // use monospace font and 4 characters to align the graphs
              callback: function callback(value, index, values) {
                return padOut(Math.round(value), 4);
              },
              fontFamily: 'monospace',
              fontSize: 8
            }
          }],
          xAxes: [xAxisTimeCfg]
        },
        tooltips: {
          callbacks: {
            title: function title(items, data) {
              return moment(_this.framerateLabels[items[0].index]).format('ddd MMM Do, h:mm:ss a');
            },
            label: function label(item, data) {
              return "".concat(Math.round(100 * item.yLabel) / 100.0, " FPS");
            }
          }
        }
      };
      _this.framerateDatasetOverride = [{
        pointRadius: 0,
        pointHitRadius: 5,
        pointHoverRadius: 4,
        cubicInterpolationMode: 'monotone'
      }];
      _this.ingestLatencyOptions = {
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        scales: {
          yAxes: [{
            gridLines: {
              color: '#EEEEEE',
              zeroLineColor: '#EEEEEE',
              drawTicks: false,
              drawBorder: false,
              tickMarkLength: 0
            },
            ticks: {
              suggestedMin: 0,
              suggestedMax: 10,
              fontFamily: 'monospace',
              fontSize: 8
            }
          }],
          xAxes: [xAxisTimeCfg]
        },
        tooltips: {
          callbacks: {
            title: function title(items, data) {
              return moment(_this.framerateLabels[items[0].index]).format('ddd MMM Do, h:mm:ss a');
            },
            label: function label(item, data) {
              if (Math.abs(item.yLabel) < 1.0) {
                return "".concat(Math.round(1000 * item.yLabel), " ms");
              }

              return "".concat(Math.round(1000 * item.yLabel) / 1000.0, " s");
            }
          }
        }
      };
      _this.ingestLatencyDatasetOverride = [{
        pointRadius: 0,
        pointHitRadius: 5,
        pointHoverRadius: 4,
        cubicInterpolationMode: 'monotone'
      }];
      _this.simulcastOptions = {
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        scales: {
          yAxes: [{
            gridLines: {
              color: '#EEEEEE',
              zeroLineColor: '#EEEEEE',
              drawTicks: false,
              drawBorder: false,
              tickMarkLength: 0
            },
            ticks: {
              suggestedMax: expectedVideoFrameRate,
              beginAtZero: true,
              // use monospace font and 4 characters to align the graphs
              callback: function callback(value, index, values) {
                return padOut(Math.round(value), 4);
              },
              fontFamily: 'monospace',
              fontSize: 8
            }
          }],
          xAxes: [xAxisTimeCfg]
        },
        tooltips: {
          callbacks: {
            title: function title(items, data) {
              return moment(_this.simulcastLabels[items[0].index]).format('ddd MMM Do, h:mm:ss a');
            },
            label: function label(item, data) {
              var i = item.datasetIndex;
              var rtmpUrl;

              if (dataVersion >= 3) {
                rtmpUrl = _.keys(stats.simulcast_frame_rate || {}).sort()[i];
              } else {
                rtmpUrl = stats.results[4].series[i].tags.rtmp_url;
              }

              var rtmpLabel = Object(__WEBPACK_IMPORTED_MODULE_1__utils_rtmp__["b" /* SanitizeRTMPURL */])(rtmpUrl);

              if (rtmpUrl.indexOf('facebook.com') >= 0) {
                rtmpLabel = 'Facebook';
              } else if (rtmpUrl.indexOf('youtube.com') >= 0) {
                rtmpLabel = 'YouTube';
              } else if (rtmpUrl.indexOf('pscp.tv') >= 0 || rtmpUrl.indexOf('twitter') >= 0) {
                rtmpLabel = 'Twitter';
              }

              return "".concat(Math.round(100 * item.yLabel) / 100.0, " FPS to ").concat(rtmpLabel);
            }
          }
        }
      };
      _this.simulcastDatasetOverride = [];

      for (var i = 0; i < (_this.simulcastData || []).length; i++) {
        _this.simulcastDatasetOverride.push({
          pointRadius: 0,
          pointHitRadius: 5,
          pointHoverRadius: 4,
          cubicInterpolationMode: 'monotone'
        });
      }

      var scoreboardStats = _this.streamDiagnostics.raw_scoreboard_stats;

      if (_this.graphType == 'coarse') {
        scoreboardStats = _this.streamDiagnostics.raw_scoreboard_stats_coarse;
      }

      _this.scoreDataRateData = [];
      _this.scoreDataRateLabels = [];

      if (dataVersion >= 3) {
        var scoreBitrateData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'bitrate', 'score');
        if (hasAnyData(scoreBitrateData) && _this.showScoreboard) _this.scoreDataRateData.push(scoreBitrateData);
        _this.scoreDataRateLabels = hasAnyDataOrNull(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(stats, 'bitrate', 'score'));
      }

      var scoreboardAssistStats = (scoreboardStats || {}).scoreboard_assist;
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["e" /* FilterRSSIForLinkStatus */])(scoreboardAssistStats);
      var rssi = (scoreboardAssistStats || {}).rssi || {};
      var boxRSSITimestamps = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(rssi, 'box');
      var scoreboardRSSITimestamps = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(rssi, 'scoreboard');
      _this.rssiLabels = _.uniq(_.flatten([boxRSSITimestamps, scoreboardRSSITimestamps])).sort();
      _this.rssiData = [];
      var boxRSSIData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(rssi, 'box');
      if (hasAnyData(boxRSSIData)) _this.rssiData.push(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["j" /* V3PlaceholderTimestamps */])(boxRSSIData, boxRSSITimestamps, _this.rssiLabels));
      var scoreboardRSSIData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(rssi, 'scoreboard');
      if (hasAnyData(scoreboardRSSIData)) _this.rssiData.push(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["j" /* V3PlaceholderTimestamps */])(scoreboardRSSIData, scoreboardRSSITimestamps, _this.rssiLabels));
      _this.scoreboardEvents = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["h" /* ParseScoreboardEvents */])(_this.streamDiagnostics, _this.broadcast.scoreboard_configuration);
      _this.scoreDataRateOptions = {
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        scales: {
          yAxes: [{
            gridLines: {
              color: '#EEEEEE',
              zeroLineColor: '#EEEEEE',
              drawTicks: false,
              drawBorder: false,
              tickMarkLength: 0
            },
            ticks: {
              beginAtZero: true,
              // use monospace font and 4 characters to align the graphs
              callback: function callback(value, index, values) {
                return padOut(value, 5);
              },
              fontFamily: 'monospace',
              fontSize: 8
            }
          }],
          xAxes: [xAxisTimeCfg]
        },
        tooltips: {
          callbacks: {
            title: function title(items, data) {
              return moment(_this.bitrateLabels[items[0].index]).format('ddd MMM Do, h:mm:ss a');
            },
            label: function label(item, data) {
              return "".concat(Math.round(item.yLabel), " bps");
            }
          }
        }
      };
      _this.scoreDataRateDatasetOverride = [{
        pointRadius: 0,
        pointHitRadius: 5,
        pointHoverRadius: 4,
        cubicInterpolationMode: 'monotone'
      }];
      _this.rssiOptions = {
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        scales: {
          yAxes: [{
            gridLines: {
              color: '#EEEEEE',
              zeroLineColor: '#EEEEEE',
              drawTicks: false,
              drawBorder: false,
              tickMarkLength: 0
            },
            ticks: {
              // use monospace font and 4 characters to align the graphs
              callback: function callback(value, index, values) {
                return padOut(Math.round(value), 4);
              },
              fontFamily: 'monospace',
              fontSize: 8
            }
          }],
          xAxes: [xAxisTimeCfg]
        },
        tooltips: {
          callbacks: {
            title: function title(items, data) {
              return moment(_this.framerateLabels[items[0].index]).format('ddd MMM Do, h:mm:ss a');
            },
            label: function label(item, data) {
              var side = '';

              if (_this.bitrateData && _this.bitrateData.length > 1) {
                side = ['Box Side: ', 'Scoreboard Side: '][item.datasetIndex] || '';
              }

              return "".concat(side).concat(Math.round(10 * item.yLabel) / 10.0, " dBm");
            }
          }
        }
      };
      _this.rssiDatasetOverride = [{
        pointRadius: 0,
        pointHitRadius: 5,
        pointHoverRadius: 4,
        fill: false,
        cubicInterpolationMode: 'monotone'
      }, {
        pointRadius: 0,
        pointHitRadius: 5,
        pointHoverRadius: 4,
        fill: false,
        cubicInterpolationMode: 'monotone'
      }];
    };

    this.load();
  }
});

function padOut(str, length) {
  str = '' + str; //cast int to str

  while (str.length < length) {
    str = ' ' + str;
  }

  return str;
}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\" style=\"margin-bottom:20px;\">\n  <div class=\"col-xs-12 text-center\" ng-if=\"vm.showScoreboard\">\n    <div class=\"btn-group\">\n      <label class=\"btn btn-default\" ng-model=\"vm.activeTab\" uib-btn-radio=\"'stream health'\">Stream Health</label>\n      <label class=\"btn btn-default\" ng-model=\"vm.activeTab\" uib-btn-radio=\"'scoreboard'\">Scoreboard</label>\n    </div>\n  </div>\n\n  <div class=\"col-xs-12 text-left\">\n    <ol class=\"list-inline\">\n      <li style=\"padding-bottom:0; padding-left:0; line-height: 28px;\">\n        <div class=\"checkbox\">\n          <label style=\"padding-left:0\">\n            <toggle-switch ng-model=\"vm.showAllAlerts\"></toggle-switch>\n            Show\n            <span ng-show=\"vm.activeTab == 'stream health'\">Alert</span>\n            <span ng-show=\"vm.activeTab == 'scoreboard'\">Event</span>\n            History\n          </label>\n        </div>\n      </li>\n      <li style=\"padding-bottom:0; padding-left:0px; line-height: 28px;\">\n        <div class=\"checkbox\">\n          <label>\n            <toggle-switch ng-model=\"vm.showGraphs\"></toggle-switch> Show Graphs\n          </label>\n        </div>\n      </li>\n      <li style=\"padding-bottom: 0;  padding-left: 10px; line-height:45px; float:right\">\n        <small>Updated: {{vm.streamDiagnostics.updated_at|date:'medium'}}</small>\n      </li>\n    </ol>\n  </div>\n</div>\n\n<!-- PAST BROADCAST VIEW, stream health -->\n<div class=\"row text-center\" ng-if=\"vm.activeTab == 'stream health' && vm.broadcast.timeframe == 'past' && vm.broadcast.stream_source != 'recording'\">\n  <div class=\"col-xs-12 col-sm-6 diagnostics--summary\">\n    <table style=\"width:100%;margin-top:15px;\">\n      <tr>\n        <td>\n          <h1 style=\"color:gold;font-size:12pt;\">\n            <star-rating count=\"vm.pastBroadcastStarCount\"></star-rating>\n          </h1>\n        </td>\n        <td>\n          <h1>{{vm.streamDiagnostics.average_total_bitrate|bits:1:'value'}} <small>{{vm.streamDiagnostics.average_total_bitrate|bits:1:'suffix'}}ps</small></h1>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <p class=\"help-block\"><small>Broadcast Health</small></p>\n        </td>\n        <td>\n          <p class=\"help-block\"><small>Avg Bitrate</small></p>\n        </td>\n      </tr>\n      <tr ng-if=\"vm.broadcast.stream_source == 'rtmp' || vm.broadcast.stream_source == 'switcher'\">\n        <td>\n          <h1>{{vm.streamDiagnostics.average_video_frame_rate|number:2}} <small>FPS</small></h1>\n        </td>\n        <td ng-if=\"vm.streamDiagnostics.max_ingest_latency\">\n          <h1>{{vm.streamDiagnostics.max_ingest_latency|number:2}} <small>s</small></h1>\n        </td>\n      </tr>\n      <tr ng-if=\"vm.broadcast.stream_source == 'rtmp' || vm.broadcast.stream_source == 'switcher'\">\n        <td>\n          <p class=\"help-block\"><small>Avg Frame Rate</small></p>\n        </td>\n        <td ng-if=\"vm.streamDiagnostics.max_ingest_latency\">\n          <p class=\"help-block\"><small>Max Ingest Latency</small></p>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div class=\"col-xs-12 col-sm-6 text-left\">\n    <!-- recommendations -->\n    <ul class=\"list-unstyled\" style=\"margin-top:15px\">\n      <li ng-repeat=\"r in vm.pastBroadcastRecommendations\" style=\"margin-bottom:5px\">\n        <i class=\"fa fa-lightbulb-o\"></i>\n        <strong>{{r.text}}</strong>\n        <a ng-if=\"r.link\" href=\"{{r.link}}\" target=\"_blank\">{{r.linkText}}</a>\n      </li>\n      <li><a class=\"action-link\" ui-sref=\"resources\"><small>Review resources to improve your stream.</small></a></li>\n    </ul>\n  </div>\n</div>\n\n<!-- PREROLL/CURRENT BROADCAST VIEW, stream health -->\n<div class=\"row diagnostics--summary\" ng-if=\"vm.activeTab == 'stream health' && vm.broadcast.timeframe != 'past'\">\n  <div class=\"col-sm-2 text-center\">\n    <h1>\n      <i ng-if=\"vm.streamDiagnostics.status == 'OK'\" class=\"fa fa-2x fa-check-circle diagnostics--icon-OK\"></i>\n      <i ng-if=\"vm.streamDiagnostics.status == 'Warning'\" class=\"fa fa-2x fa-exclamation-triangle diagnostics--icon-Warning\"></i>\n      <i ng-if=\"vm.streamDiagnostics.status == 'Critical'\" class=\"fa fa-2x fa-exclamation-circle diagnostics--icon-Critical\"></i>\n    </h1>\n  </div>\n\n  <div class=\"col-sm-5 text-left\">\n    <p ng-if=\"!vm.streamDiagnostics.alerts.length\" class=\"help-block\" style=\"margin-top:20px\">\n      No alerts detected!\n      <span ng-if=\"vm.streamDiagnostics.status == 'OK'\">The broadcast health is looking good.</span>\n    </p>\n    <div ng-if=\"vm.streamDiagnostics.alerts.length\">\n      <div ng-repeat=\"a in filteredAlerts = (vm.streamDiagnostics.alerts | filter:vm.alertsFilter)\" class=\"diagnostics--alert-{{a.is_active ? 'active' : 'inactive'}}\">\n        <span class=\"label label-{{a.level == 'Critical' ? 'danger' : 'warning'}}\">\n          {{a.detected_at|date:'shortTime'}}\n          <span ng-hide=\"a.is_active\">- {{a.inactive_at|date:'shortTime'}}</span>:\n          {{a.message}}\n        </span>\n      </div>\n      <div ng-if=\"filteredAlerts.length == 0\">\n        <p class=\"help-block\" style=\"margin-top:20px\">\n          No active alerts.\n          <span ng-if=\"vm.streamDiagnostics.status == 'OK'\">The broadcast health is looking good.</span>\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"col-sm-5\" ng-if=\"vm.broadcast.stream_source != 'recording'\">\n    <table class=\"text-center\" style=\"width:100%\">\n      <tr>\n        <td valign=\"top\">\n          <h3>\n            {{vm.streamDiagnostics.last_total_bitrate|bits:1:'value'}}\n            <small>{{vm.streamDiagnostics.last_total_bitrate|bits:1:'suffix'}}ps</small>\n          </h3>\n        </td>\n        <td valign=\"top\" ng-if=\"vm.broadcast.transcoder_profile != 'audio'\">\n          <h3>\n            {{vm.streamDiagnostics.last_video_frame_rate|number:2}}\n            <small>FPS</small>\n          </h3>\n        </td>\n        <td valign=\"top\" ng-if=\"vm.broadcast.stream_source == 'rtmp' || vm.broadcast.stream_source == 'switcher'\">\n          <h3>\n            {{vm.streamDiagnostics.last_ingest_latency|number:2}}\n            <small>s</small>\n          </h3>\n        </td>\n      </tr>\n      <tr>\n        <td><p class=\"help-block\"><small>Broadcast Bitrate</small></p></td>\n        <td ng-if=\"vm.broadcast.transcoder_profile != 'audio'\"><p class=\"help-block\"><small>Broadcast Frame Rate</small></p></td>\n        <td ng-if=\"vm.broadcast.stream_source == 'rtmp' || vm.broadcast.stream_source == 'switcher'\"><p class=\"help-block\"><small>Ingestion Latency (s)</small></p></td>\n      </tr>\n    </table>\n  </div>\n</div>\n\n<!-- scoreboard -->\n<div class=\"row diagnostics--summary\" ng-if=\"vm.activeTab == 'scoreboard'\">\n  <div class=\"col-xs-12 col-lg-2 text-center\" ng-if=\"vm.scoreboardMode == 'pair'\">\n    <scoreboard-link-status\n        linked=\"vm.streamDiagnostics.scoreboard_assist_linked\" rssi=\"vm.streamDiagnostics.scoreboard_assist_rssi\" />\n  </div>\n\n  <div class=\"col-xs-12\" ng-class=\"vm.scoreboardMode == 'pair' ? 'col-lg-10' : ''\">\n    <scoreboard-diagnostics-status scoreboard-configuration=\"vm.broadcast.scoreboard_configuration\" stream-diagnostics=\"vm.streamDiagnostics\" />\n  </div>\n\n  <div class=\"col-xs-12 text-right\" ng-if=\"vm.broadcast.scoreboard_configuration.scoreboard_make == 'BoxCast'\">\n    <div style=\"font-size:10px\">\n      Identity:\n      <!-- Box side -->\n      <span ng-if=\"vm.scoreboardMode == 'pair' && vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.box\">\n        <span style=\"opacity:0.4\" uib-tooltip=\"Firmware: {{ vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.box.firmware_version }}\" tooltip-append-to-body=\"true\">\n        BoxCaster-side:\n        <span style=\"font-family:monospace\">{{ vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.box.serial_number }}</span>\n        </span>\n        <span class=\"label label-info\" ng-if=\"vm.latestScoreboardAssistFirmwareVersion != null && vm.latestScoreboardAssistFirmwareVersion != vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.box.firmware_version\">\n          Firmware Update Available\n        </span>\n      </span>\n      <!-- Scoreboard side -->\n      <span ng-if=\"vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.scoreboard\">\n        <span style=\"opacity:0.4\" uib-tooltip=\"Firmware: {{ vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.scoreboard.firmware_version }}\" tooltip-append-to-body=\"true\">\n        <span ng-show=\"vm.scoreboardMode == 'pair'\">Scoreboard-side:</span>\n        <span ng-hide=\"vm.scoreboardMode == 'pair'\">Scoreboard:</span>\n        <span style=\"font-family:monospace\">{{ vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.scoreboard.serial_number }}</span>\n        </span>\n        <span class=\"label label-info\" ng-if=\"vm.latestScoreboardAssistFirmwareVersion != null && vm.latestScoreboardAssistFirmwareVersion != vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.scoreboard.firmware_version\">\n          Firmware Update Available\n        </span>\n      </div>\n    </div>\n  </div>\n</div>\n\n<hr ng-if=\"vm.showAllAlerts\">\n\n<!-- ALERT HISTORY, stream health -->\n<div class=\"row text-center\" ng-if=\"vm.activeTab == 'stream health' && vm.showAllAlerts\">\n  <div class=\"col-xs-12\">\n    <p ng-if=\"!vm.streamDiagnostics.alerts.length\" class=\"help-block text-center\" style=\"margin-top:20px\">\n      No alerts were detected!\n    </p>\n    <div ng-if=\"vm.streamDiagnostics.alerts.length\">\n      <table class=\"table-condensed table-hover text-left\" style=\"width:100%\">\n        <tbody>\n          <tr ng-repeat=\"a in vm.streamDiagnostics.alerts\">\n            <td><span class=\"label label-{{a.level == 'Critical' ? 'danger' : 'warning'}}\">{{a.level}}</span></td>\n            <td>{{a.message}}</td>\n            <td class=\"text-right\">\n              {{a.detected_at|date:'shortTime'}} <span ng-hide=\"a.is_active\">- {{a.inactive_at|date:'shortTime'}}</span>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n\n<!-- EVENT HISTORY, scoreboard -->\n<div class=\"row text-center\" ng-if=\"vm.activeTab == 'scoreboard' && vm.showAllAlerts\">\n  <div class=\"col-xs-12\">\n    <p ng-if=\"!vm.scoreboardEvents.length\" class=\"help-block text-center\" style=\"margin-top:20px\">\n      No events have been logged!\n    </p>\n    <div ng-if=\"vm.scoreboardEvents.length\">\n      <table class=\"table-condensed table-hover text-left\" style=\"width:100%\">\n        <tbody>\n          <tr ng-repeat=\"e in vm.scoreboardEvents\">\n            <td>{{e.message}}</td>\n            <td class=\"text-right\">{{e.timestamp|date:'mediumTime'}}</td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n\n<hr ng-if=\"vm.showGraphs\">\n\n<!-- GRAPHS, stream health -->\n<div class=\"row text-center\" ng-if=\"vm.activeTab == 'stream health' && vm.showGraphs\">\n  <div class=\"clearfix\">\n    <div class=\"col-xs-12 text-right\">\n      <ol class=\"list-inline\">\n        <li><small>Graph Type:</small></li>\n        <li>\n          <div class=\"btn-group\">\n            <label class=\"btn btn-xs btn-default\"\n                  ng-model=\"vm.graphType\" uib-btn-radio=\"'fine'\"\n                  ng-click=\"vm.updateGraph()\">Last 60m (fine-grained)</label>\n            <label class=\"btn btn-xs btn-default\"\n                  ng-model=\"vm.graphType\" uib-btn-radio=\"'coarse'\"\n                  ng-click=\"vm.updateGraph()\">Full Broadcast (coarse)</label>\n          </div>\n        </li>\n      </ol>\n    </div>\n  </div>\n\n  <div style=\"margin-top:30px\" ng-if=\"vm.broadcast.stream_source != 'recording'\">\n    <p style=\"margin-bottom:0\"><strong>Broadcast Bitrate (kbps)</strong></p>\n    <canvas ng-if=\"vm.bitrateLabels.length\"\n        height=\"50\"\n        class=\"chart chart-line\"\n        chart-data=\"vm.bitrateData\"\n        chart-labels=\"vm.bitrateLabels\"\n        chart-options=\"vm.bitrateOptions\"\n        chart-dataset-override=\"vm.bitrateDatasetOverride\"></canvas>\n    <p class=\"help-block\" ng-if=\"vm.bitrateLabels.length == 0\">\n      No bitrate data available.\n    </p>\n  </div>\n  <div style=\"margin-top:30px\" ng-if=\"vm.broadcast.stream_source != 'recording' && vm.broadcast.transcoder_profile != 'audio'\">\n    <p style=\"margin-bottom:0\"><strong>Broadcast Frame Rate (FPS)</strong></p>\n    <canvas ng-if=\"vm.framerateLabels.length\"\n        height=\"50\"\n        class=\"chart chart-line\"\n        chart-data=\"vm.framerateData\"\n        chart-labels=\"vm.framerateLabels\"\n        chart-options=\"vm.framerateOptions\"\n        chart-dataset-override=\"vm.framerateDatasetOverride\"></canvas>\n    <p class=\"help-block\" ng-if=\"vm.framerateLabels.length == 0\">\n      No frame rate data available.\n    </p>\n  </div>\n  <div style=\"margin-top:30px\" ng-if=\"vm.broadcast.stream_source == 'rtmp' || vm.broadcast.stream_source == 'switcher'\">\n    <p style=\"margin-bottom:0\"><strong>Ingestion Latency (s)</strong></p>\n    <canvas ng-if=\"vm.ingestLatencyLabels.length\"\n        height=\"50\"\n        class=\"chart chart-line\"\n        chart-data=\"vm.ingestLatencyData\"\n        chart-labels=\"vm.ingestLatencyLabels\"\n        chart-options=\"vm.ingestLatencyOptions\"\n        chart-dataset-override=\"vm.ingestLatencyDatasetOverride\"></canvas>\n    <p class=\"help-block\" ng-if=\"vm.ingestLatencyLabels.length == 0\">\n      No ingestion latency data available.\n    </p>\n  </div>\n  <div style=\"margin-top:30px\" ng-if=\"vm.simulcastLabels.length || vm.broadcast.simulcast_configurations.length\">\n    <p style=\"margin-bottom:0\"><strong>Simulcast (FPS)</strong></p>\n    <canvas ng-if=\"vm.simulcastLabels.length\"\n        height=\"50\"\n        class=\"chart chart-line\"\n        chart-data=\"vm.simulcastData\"\n        chart-labels=\"vm.simulcastLabels\"\n        chart-options=\"vm.simulcastOptions\"\n        chart-dataset-override=\"vm.simulcastDatasetOverride\"></canvas>\n    <p class=\"help-block\" ng-if=\"!vm.simulcastLabels || vm.simulcastLabels.length == 0\">\n      No simulcast data available.\n    </p>\n  </div>\n  <div style=\"margin-top:30px\" ng-if=\"vm.broadcast.stream_source != 'rtmp' && vm.broadcast.stream_source != 'recording'\">\n    <p style=\"margin-bottom:0\"><strong>Packet Loss</strong></p>\n    <div ng-if=\"vm.totalPacketsLost > 0\">\n      <canvas height=\"50\"\n          class=\"chart chart-bar\"\n          chart-data=\"vm.plData\"\n          chart-labels=\"vm.plLabels\"\n          chart-options=\"vm.plOptions\"\n          chart-colors=\"[{backgroundColor:'#F15854', borderColor:'#F15854'},{backgroundColor:'#DECF3F',borderColor:'#DECF3F'}]\"\n          chart-dataset-override=\"[{hitRadius:5},{hitRadius:5}]\"></canvas>\n    </div>\n    <p class=\"help-block\" ng-if=\"vm.totalPacketsLost == 0\">\n      No packet loss reported. <span style=\"font-family:monospace\">＼(＾O＾)／</span>\n    </p>\n  </div>\n</div>\n\n<!-- GRAPHS, scoreboard -->\n<div class=\"row text-center\" ng-if=\"vm.activeTab == 'scoreboard' && vm.showGraphs\">\n  <div class=\"clearfix\">\n    <div class=\"col-xs-12 text-right\">\n      <ol class=\"list-inline\">\n        <li><small>Graph Type:</small></li>\n        <li>\n          <div class=\"btn-group\">\n            <label class=\"btn btn-xs btn-default\"\n                  ng-model=\"vm.graphType\" uib-btn-radio=\"'fine'\"\n                  ng-click=\"vm.updateGraph()\">Last 60m (fine-grained)</label>\n            <label class=\"btn btn-xs btn-default\"\n                  ng-model=\"vm.graphType\" uib-btn-radio=\"'coarse'\"\n                  ng-click=\"vm.updateGraph()\">Full Broadcast (coarse)</label>\n          </div>\n        </li>\n      </ol>\n    </div>\n  </div>\n\n  <div style=\"margin-top:30px\">\n    <p style=\"margin-bottom:0\"><strong>Scoreboard Data Rate</strong></p>\n    <canvas ng-if=\"vm.scoreDataRateLabels.length\"\n        height=\"50\"\n        class=\"chart chart-line\"\n        chart-data=\"vm.scoreDataRateData\"\n        chart-labels=\"vm.scoreDataRateLabels\"\n        chart-options=\"vm.scoreDataRateOptions\"\n        chart-dataset-override=\"vm.scoreDataRateDatasetOverride\"></canvas>\n    <p class=\"help-block\" ng-if=\"vm.scoreDataRateLabels.length == 0\">\n      No scoreboard data rate data available.\n    </p>\n  </div>\n\n  <div style=\"margin-top:30px\" ng-if=\"vm.scoreboardMode == 'pair'\">\n    <p style=\"margin-bottom:0\"><strong>Wireless Signal Strength</strong></p>\n    <canvas ng-if=\"vm.rssiLabels.length\"\n        height=\"50\"\n        class=\"chart chart-line\"\n        chart-data=\"vm.rssiData\"\n        chart-labels=\"vm.rssiLabels\"\n        chart-options=\"vm.rssiOptions\"\n        chart-dataset-override=\"vm.rssiDatasetOverride\"></canvas>\n    <p class=\"help-block\" ng-if=\"vm.rssiLabels.length == 0\">\n      No signal strength data available.\n    </p>\n  </div>\n</div>\n"

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {// time picker directive
//
//  <time-picker ng-model="dateTimeObj"
//               start-time="dateTimeObj"
//               end-time="dateTimeObj"
//               display-format="h:mm a"
//               step-minutes="30"
//               show-duration="false"
//               scroll-item-into-focus="false"
//               ></time-picker>
//
//  options:
//    - start-time: defaults to Now
//    - end-time: defaults to Now + 1 day
//    - display-format: defaults to 'h:mm a' (moment.js format parameters)
//    - step-minutes: defaults to 30
//    - show-duration: defaults to false
var module = angular.module('app.directives');
module.directive('timePicker', function () {
  'ngInject';

  return {
    restrict: 'E',
    require: 'ngModel',
    scope: {
      ngModel: '=',
      displayFormat: '@',
      startTime: '=?',
      endTime: '=?',
      stepMinutes: '@',
      showDuration: '@'
    },
    template: "\n      <div class=\"input-group\">\n        <input type=\"text\"\n               class=\"form-control\"\n               ng-click=\"showOptions()\"\n               ng-model=\"dateModelFn\"\n               ng-model-options=\"{getterSetter: true, updateOn: 'blur'}\">\n        <div class=\"input-group-btn\">\n          <button type=\"button\" class=\"btn btn-default dropdown-toggle\" ng-click=\"toggleOptions()\"><span class=\"caret\"></span></button>\n          <ul class=\"dropdown-menu\"\n              role=\"menu\"\n              style=\"max-height:200px; overflow-y:scroll;\"\n              >\n            <li ng-repeat=\"option in options\"\n                ng-class=\"{active: option.hourValue == ngModelHourValue}\"\n                data-hour-value=\"{{option.hourValue}}\"\n                >\n              <a href=\"javascript://\" ng-click=\"selectOption(option.value)\">\n                {{option.label}}\n              </a>\n            </li>\n          </ul>\n        </div>\n      </div>\n    ",
    link: function link(scope, element, attrs, ngModelCtrl) {
      var displayFormat = scope.displayFormat || 'h:mm a';
      var startTime = scope.startTime || moment().startOf('day').toDate();
      var endTime = scope.endTime || moment(startTime).add(1, 'day').toDate();
      var stepMinutes = scope.stepMinutes || 30;

      if (stepMinutes < 0) {
        throw Error('Invalid value for step-minutes: ' + stepMinutes);
      }

      scope.dateModelFn = function (value) {
        if (arguments.length) {
          value = tryParseTime(value);
          ngModelCtrl.$setViewValue(value ? value.toDate() : null);
          ngModelCtrl.$commitViewValue();
        } else {
          value = ngModelCtrl.$modelValue;
        }

        if (value) {
          scope.ngModelHourValue = moment(value).format('HHmm');
          return moment(value).format(displayFormat);
        } else {
          return '';
        }
      };

      scope.$watch('startTime', _.throttle(function (newStartTime) {
        startTime = newStartTime || moment().startOf('day').toDate();
        endTime = scope.endTime || moment(startTime).add(1, 'day').toDate();

        if (ngModelCtrl.$modelValue < startTime) {
          // Make sure current time is after start time
          console.log('Adjusting current time to', startTime);
          ngModelCtrl.$setViewValue(startTime);
          ngModelCtrl.$commitViewValue();
        }

        scope.options = buildOptions(startTime, endTime, stepMinutes, scope.showDuration, displayFormat);
      }, 100));
      var menu = element.find('.dropdown-menu');
      var isMenuVisible = false;

      scope.showOptions = function () {
        if (!isMenuVisible) {
          menu.show();
          isMenuVisible = true;
          scrollItemIntoFocus(); // hack the position relative to the input, not the button

          var inputWidth = element.find('input').css('width');
          menu.css({
            left: "-".concat(inputWidth)
          });
        }
      };

      function scrollItemIntoFocus() {
        // scroll the closest option into focus
        var currentValue = moment(ngModelCtrl.$modelValue).format('HHmm');
        var closest = null;
        menu.find('li').each(function (i, item) {
          var itemValue = $(item).data('hour-value');
          var diff = Math.abs(itemValue - currentValue);

          if (!closest || diff < closest.diff) {
            closest = {
              diff: diff,
              item: item
            };
          }
        });

        if (closest) {
          menu.get(0).scrollTop = closest.item.offsetTop;
        }
      }

      scope.hideOptions = function () {
        setTimeout(function () {
          return menu.hide();
        }, 50);
        isMenuVisible = false;
      };

      scope.toggleOptions = function () {
        if (isMenuVisible) {
          scope.hideOptions();
        } else {
          scope.showOptions();
        }
      };

      scope.selectOption = function (option) {
        //console.log('selecting option', option);
        ngModelCtrl.$setViewValue(option);
        ngModelCtrl.$commitViewValue();
        scope.hideOptions();
      }; // Let stray clicks off the menu close the menu


      var strayClickHandler = function strayClickHandler(e) {
        if (!isMenuVisible) {
          return true;
        }

        if ($.contains(element.find('.input-group')[0], e.target)) {
          //console.log('click was inside directive; leaving menu open');
          e.preventDefault();
          e.stopPropagation();
        } else {
          //console.log('hiding from body click');
          scope.hideOptions();
        }
      };

      $('body').on('click', strayClickHandler);
      scope.$on('$destroy', function () {
        $('body').off('click', strayClickHandler);
      });
    }
  };
});

function buildOptions(startTime, endTime, stepMinutes, showDuration, displayFormat) {
  // Dynamically determine which options to show
  // Account for 24-hour wrap-around if necessary
  var options = [];

  if (endTime < startTime || !endTime || !startTime) {
    console.warn('Unable to generate options between', startTime, 'and', endTime);
    return options;
  }

  var startDate = moment(startTime).date();
  var ticker = moment(startTime).startOf('hour');
  var i = 0;

  while (ticker.isBefore(endTime)) {
    if (++i > 1000) {
      console.error('Infinite loop?', startTime, ticker, endTime, stepMinutes);
      return;
    }

    var option = {
      value: ticker.toDate(),
      label: ticker.format(displayFormat),
      hourValue: ticker.format('HHmm')
    };

    if (showDuration) {
      var diff = ticker.diff(startTime, 'minutes');

      if (diff < 0) {
        ticker = ticker.clone().add(stepMinutes, 'minutes');
        continue; //skip negatives
      }

      var label = labelForDuration(diff, ticker.date() != startDate);
      option.label += ' (' + label + ')';
    }

    options.push(option);
    ticker = ticker.clone().add(stepMinutes, 'minutes');
  }

  return options;
}

function labelForDuration(diff, isDifferentDay) {
  var displayDiff;

  if (diff < 60) {
    displayDiff = "".concat(diff, " minutes");
  } else {
    var fracHours = Math.round(10.0 * diff / 60.0) / 10.0;
    displayDiff = "".concat(fracHours, " hours");
  }

  if (isDifferentDay) {
    displayDiff += ' - Following Day';
  }

  return displayDiff;
}

function tryParseTime(string) {
  var formats = ['h:mm a', 'h:mm A', 'h:mma', 'h:mmA', 'h:m a', 'h:m A', 'h:ma', 'h:mA', 'HH:mm'];
  var result = null;
  if (!string) return result;

  _.each(formats, function (f) {
    result = moment(string, f);

    if (result.isValid()) {
      return false; //stop iteration
    } else {
      console.log('Unable to parse time', string, 'as', f);
    }
  });

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (module);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// upgrade button
//
//   <upgrade-botton >
//
var module = angular.module('app.directives');
module.directive('upgradeButton', function () {
  return {
    restrict: 'E',
    scope: {},
    template: "\n      <button type=\"button\" ng-click=\"vm.onClick($event)\" class=\"btn btn-default\" style=\"margin:15px\">\n        {{::vm.title()}}\n      </button>\n    ",
    controllerAs: 'vm',
    controller: ["$rootScope", "MeetingsService", function controller($rootScope, MeetingsService) {
      'ngInject';

      var account = $rootScope.account;

      this.title = function () {
        return 'Review Upgrade Options';
      };

      this.onClick = function ($event) {
        MeetingsService.openPreferredMethod();
      };
    }]
  };
});

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {


UploadModalController.$inject = ["params", "$uibModalInstance"];function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var module = angular.module('app.directives');
module.directive('uploadModalLauncher', ["$uibModal", function ($uibModal) {
  'ngInject';

  return _defineProperty({
    restrict: 'E',
    transclude: true,
    scope: {
      slotName: '=',
      allowImage: '=',
      allowVideo: '=',
      modalHeading: '@',
      onUploaded: '&'
    },
    template: __webpack_require__(185),
    link: function link(scope) {
      var allowVideo = scope.allowVideo,
          allowImage = scope.allowImage,
          slotName = scope.slotName,
          modalHeading = scope.modalHeading;

      scope.openUploadModal = function () {
        $uibModal.open({
          template: __webpack_require__(185),
          controller: UploadModalController,
          controllerAs: 'vm',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            params: function params() {
              return {
                slotName: slotName,
                allowVideo: allowVideo,
                allowImage: allowImage,
                heading: modalHeading,
                file: scope.uploadedFile
              };
            }
          }
        }).result.then(function () {
          scope.onUploaded({
            file: scope.uploadedFile
          });
        });
      };
    }
  }, "template", "\n    <a ng-click=\"openUploadModal()\" class=\"class\" style=\"style\">\n      <div ng-transclude></div>\n    </a>\n    ");
}]);

function UploadModalController(params, $uibModalInstance) {
  var _this = this;

  this.params = params;

  this.cancel = function () {
    return $uibModalInstance.dismiss('cancel');
  };

  this.upload = function () {
    if (!_this.file || !_this.file.upload) {
      return;
    }

    _this.uploading = true;

    _this.file.upload().then(function (result) {
      _this.uploading = false;
      $uibModalInstance.close(result);
    });
  };
}

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

// upload slot directive
//
// allows you to use the BoxCast media hosting infrastructure to
// input a URL or allow a new uploaded image/video.
//
//   <upload-slot ng-model="vm.myUploadedFile"
//                ng-change="vm.onUploadChange()"
//                allow-image="true"
//                allow-video="true"
//                slot-name="account"
//                ></upload-slot>
//
// the ng-model object that you get out is a special FileReader-like object
// with a few additional attributes:
//
//    upload() - function, returns promise when upload is complete with the
//               AccountUpload metadata response from the BoxCast API
//    videoDuration - float, seconds, if able to be computed by the browser
//
//
// Depends on https://github.com/danialfarid/ng-file-upload
var module = angular.module('app.directives');
module.directive('uploadSlot', ["toaster", "$q", "$uibModal", "$timeout", "AccountUploadsService", function (toaster, $q, $uibModal, $timeout, AccountUploadsService) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      ngChange: '@',
      slotName: '=',
      allowImage: '=',
      allowVideo: '=',
      compact: '=',
      hideRecentBrowse: '=',
      hideStockBrowse: '=',
      clearOnSuccess: '='
    },
    require: 'ngModel',
    template: __webpack_require__(349),
    link: function link(scope, element, attrs, ngModelCtrl) {
      var allowVideo = scope.allowVideo,
          allowImage = scope.allowImage,
          slotName = scope.slotName,
          hideRecentBrowse = scope.hideRecentBrowse,
          hideStockBrowse = scope.hideStockBrowse;
      var cfg = AccountUploadsService.uploadConfiguration(allowVideo, allowImage, slotName);
      scope.rules = cfg.rules;
      scope.fileTypeSentence = cfg.fileTypeSentence;
      scope.helpText = cfg.helpText;
      scope.showVideoHelp = cfg.showVideoHelp;
      scope.skipBrowseModal = hideRecentBrowse && hideStockBrowse;

      if (attrs.ngChange) {
        ngModelCtrl.$viewChangeListeners.push(function () {
          scope.$eval(attrs.ngChange);
        });
      }

      scope.browse = function () {
        return showBrowseDialog();
      };

      scope.$watch('file', function (newFile, oldFile) {
        if (newFile && newFile.__avoidUpload) {// Do nothing; result of browsing for other file
        } else if (newFile) {
          updateDataBinding({
            upload: function upload(args) {
              return uploadFile(args);
            },
            file: newFile
          });
        } else if (oldFile) {
          scope.file = null;
          updateDataBinding(null);
        } else {
          scope.file = null; // first load, no need to do anything
        }

        if (newFile && newFile.type) {
          var parts = newFile.type.split('/');
          scope.fileType = parts.length < 2 ? '' : parts[1];
        } else {
          scope.fileType = '';
        }
      }); // Wait for <video> preview to render so that we can try to compute duration

      scope.$watch(function () {
        return scope.file && element.find('video').get(0);
      }, function (videoElement) {
        if (videoElement) {
          videoElement.addEventListener('loadeddata', function () {
            console.log('Assigning video duration to upload candidate');
            scope.ngModel.videoDuration = videoElement.duration;
            updateDataBinding(scope.ngModel);
          });
        }
      });
      scope.$watch('invalidFile', function (err) {
        if (err) {
          console.warn('Invalid file upload attempted', err);
          toaster.pop('warning', "Invalid file (".concat(err.$error, " should be ").concat(err.$errorParam, "). Please try another file."));
        }
      });
      scope.$on('$destroy', function () {
        AccountUploadsService.destroy();
      });

      function updateDataBinding(value) {
        scope.ngModel = value;
        ngModelCtrl.$setViewValue(value);
        ngModelCtrl.$commitViewValue();

        if (value && scope.onChange) {
          scope.onChange(value);
        }
      }

      function showBrowseDialog() {
        $uibModal.open({
          template: __webpack_require__(350),
          controller: __webpack_require__(351)["default"],
          controllerAs: 'vm',
          resolve: {
            params: function params() {
              return {
                slotName: scope.slotName,
                allowImage: scope.allowImage,
                allowVideo: scope.allowVideo,
                hideRecentBrowse: scope.hideRecentBrowse,
                hideStockBrowse: scope.hideStockBrowse
              };
            }
          }
        }).result.then(function (result) {
          console.log('Back in <upload-slot>. Browse completed with result', result);

          if (result.type == 'file') {
            // Trigger watcher as if you had drag/dropped
            scope.file = result.result;
          } else if (result.type == 'upload') {
            // Already in our uploads subsystem, skip ahead a bit
            // XXX: touching `file` here triggers the watcher
            var f = result.result;
            scope.file = {
              __avoidUpload: true,
              name: f.filename,
              type: f.mimetype,
              size: f.filesize
            };
            updateDataBinding({
              upload: function upload() {
                return $q(function (resolve) {
                  return resolve(result.result);
                });
              },
              videoDuration: null
            });
          } else if (result.type == 'url') {
            // Skip ahead even further by just passing the URL along
            updateDataBinding({
              upload: function upload() {
                return $q(function (resolve) {
                  return resolve({
                    view_url: result.result
                  });
                });
              },
              videoDuration: null
            });
          }
        });
      }

      function uploadFile(args) {
        var file = scope.file,
            slotName = scope.slotName;
        return AccountUploadsService.processFileAndUpload(file, slotName, args).then(function (data) {
          if (scope.clearOnSuccess) {
            $timeout(function () {
              return scope.file = null;
            }, 1000);
          }

          return data;
        })["catch"](function (err) {
          console.error('Error acquiring upload path:', err);
          toaster.pop('warning', "File ".concat(file.name, " failed to upload."));
          file.status = 'error';
          throw err;
        });
      }
    }
  };
}]);

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports = "<div ng-show=\"!file\"\n     ngf-drop\n     ngf-multiple=\"false\"\n     ngf-keep=\"false\"\n     ngf-validate=\"rules\",\n     ngf-max-size=\"allow\"\n     ngf-model-invalid=\"invalidFile\"\n     ng-model=\"file\"\n     name=\"file\"\n     class=\"drop-box\"\n     ng-class=\"compact?'compact':''\"\n>\n\n  <div class=\"drop-target text-center\">\n\n    <div class=\"no-file\">\n      <i class=\"fa fa-cloud-upload\"></i>\n      <div ng-show=\"!skipBrowseModal\">\n        <a class=\"browse-link\" href ng-click=\"browse()\">Upload {{fileTypeSentence}}</a>\n        or drag & drop\n      </div>\n      <form ng-show=\"skipBrowseModal\" name=\"myForm\">\n        <div class=\"form-group\">\n          <!-- Skip modal and go straight to file explorer if stock photos and recent uploads are hidden -->\n          <label class=\"browse-link\">\n            Upload {{fileTypeSentence}}\n            <input type=\"file\"\n                    name=\"file\"\n                    ngf-select\n                    ng-model=\"file\"\n                    ngf-multiple=\"false\"\n                    ngf-keep=\"false\"\n                    ngf-validate=\"rules\",\n                    ngf-model-invalid=\"invalidFile\"\n                    hidden\n                    >\n          </label>\n         or drag & drop\n          <div class=\"text-danger\" ng-show=\"myForm.file.$error.pattern\">\n            <i>Invalid file type ({{invalidFile.$errorParam}} required)</i>\n          </div>\n          <div class=\"text-danger\" ng-show=\"myForm.file.$error.maxSize\">\n            <i>File too large {{invalidFile.size / 1000000|number:1}}MB: max {{invalidFile.$errorParam}}</i>\n          </div>\n        </div>\n      </form>\n\n      {{helpText}}\n      <p ng-show=\"showVideoHelp\">\n        Recommend 720p with FastStart.<br/>\n        <a\n          href=\"https://support.boxcast.com/en/articles/4235102\"\n          target=\"_blank\">\n          Get help preparing video for upload.\n        </a>\n      </p>\n    </div>\n  </div>\n</div>\n\n<div ng-show=\"file\" class=\"text-center\">\n  <div class=\"has-file\" ng-class=\"file.type.startsWith('image') ? 'transparent-grid-bg' : ''\">\n    <a href class=\"pull-right\" ng-click=\"file = null\" title=\"Remove File\"><i class=\"fa fa-times-circle remove-icon\"></i></a>\n    <img ng-if=\"file.type.startsWith('image')\" class=\"img\" ngf-thumbnail=\"file\">\n    <video ng-if=\"file.type.startsWith('video')\" controls ngf-src=\"file\"></video>\n    <p ng-if=\"file.type.startsWith('application/pdf')\" class=\"text-center\"><i class=\"fa fa-file-pdf-o file-icon\"></i></p>\n    <p ng-if=\"file.name.endsWith('.vtt')\" class=\"text-center\"><i class=\"fa fa-file-text-o file-icon\"></i></p>\n  </div>\n  <p class=\"help-block overflow-ellipse\">\n    {{file.name}}<br>\n    <small>\n      {{fileType ? fileType+',' : ''}}\n      {{file.size|bytes}}\n    </small>\n  </p>\n  <p ng-show=\"file.status == 'error'\" class=\"text-danger\">\n    Error uploading.\n  </p>\n  <p ng-show=\"file.status == 'done'\" class=\"text-info\">\n    Successfully Uploaded!\n  </p>\n  <uib-progressbar value=\"file.progressPct\" ng-show=\"file.status == 'uploading'\" max=\"100\">\n    {{file.progressPct}}% Uploaded\n  </uib-progressbar>\n  <p ng-show=\"file.estimatedTimeRemainingMs\" class=\"text-info\">\n    Upload will finish in {{ file.estimatedTimeRemainingMs | remainingTime }}...\n  </p>\n</div>\n"

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">Browse for File</h3>\n</div>\n<div class=\"modal-body\">\n\n  <h5 style=\"font-weight:bold\">Browse Your Computer</h5>\n  <form name=\"myForm\">\n    <div class=\"form-group\">\n      <input type=\"file\"\n             name=\"file\"    \n             ngf-select\n             ng-model=\"vm.file\"\n             ngf-multiple=\"false\"\n             ngf-keep=\"false\"\n             ngf-validate=\"vm.rules\",\n             ngf-model-invalid=\"vm.invalidFile\"\n             >\n        <div class=\"text-danger\" ng-show=\"myForm.file.$error.pattern\">\n          <i>Invalid file type ({{vm.invalidFile.$errorParam}} required)</i>\n        </div>\n        <div class=\"text-danger\" ng-show=\"myForm.file.$error.maxSize\">\n          <i>File too large {{vm.invalidFile.size / 1000000|number:1}}MB: max {{vm.invalidFile.$errorParam}}</i>\n        </div>\n      <img ng-if=\"myForm.file.$valid\"\n           ngf-thumbnail=\"vm.file\"\n           class=\"img\" style=\"max-width:160px;max-height:120px;margin:15px 0;\">\n    </div>\n    <div class=\"form-group\">\n      <button class=\"btn btn-primary btn-block\"\n              ng-if=\"vm.file && myForm.file.$valid\" \n              ng-click=\"vm.selectByFile(vm.file)\">Use This File</button>\n    </div>\n  </form>\n\n  <div ng-if=\"vm.uploads.length && !vm.hideRecentBrowse\">\n    <h5 style=\"font-weight:bold\">Other Recent Uploads</h5>\n\n    <ol class=\"list-inline\">\n      <li ng-repeat=\"f in vm.uploads track by f.id\" style=\"width:33%;margin-bottom:15px;\">\n        <div class=\"fixed-16-9\"\n             style=\"cursor:pointer\"\n             ng-click=\"vm.selectByUploadObject(f)\">\n          <div ng-if=\"f.mimetype.startsWith('image')\" style=\"background-image:url(&quot;{{f.view_url | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n          <video ng-if=\"f.mimetype.startsWith('video')\" ng-src=\"{{f.view_url | trustedUrl}}\" style=\"max-width:100%\"></video>\n          <div ng-if=\"f.mimetype.startsWith('application/pdf')\" class=\"fixed-16-9 text-center\" style=\"background:#fff;border:1px solid #111\">\n            <p>\n              <i class=\"fa fa-file-pdf-o fa-2x\" style=\"display:block !important;margin:15px\"></i>\n              {{f.filename}} ({{f.filesize|bytes}})\n            </p>\n          </div>\n        </div>\n        <div ng-if=\"!f.mimetype.startsWith('application/pdf')\" class=\"overflow-ellipse\" style=\"font-weight:bold;font-size:0.8em;color:#aaa;\">\n          {{f.filename}} ({{f.created_at|date}})\n        </div>\n      </li>\n    </ol>\n    <div>\n      <uib-pagination\n        total-items=\"vm.pagination.total\"\n        items-per-page=\"12\"\n        rotate=\"false\"\n        class=\"pagination-sm\"\n        ng-model=\"vm.pagination.current\"\n        ng-change=\"vm.loadUploadsForPage(vm.pagination.current, vm.q)\"></uib-pagination>\n    </div>\n\n  </div>\n\n  <div ng-if=\"vm.allowImage && !vm.hideStockBrowse\">\n    <h5 style=\"font-weight:bold\">Find Free Stock Photos</h5>\n    <form name=\"unsplashForm\" ng-submit=\"vm.searchUnsplash()\">\n      <div class=\"form-group\">\n        <div class=\"input-group\">\n          <input type=\"text\" class=\"form-control\" placeholder=\"Cats, basketball, flowers, ...\" ng-model=\"vm.unsplashQuery\">\n          <span class=\"input-group-btn\">\n            <button class=\"btn btn-default btn-secondary\" type=\"submit\">\n              <i ng-hide=\"vm.unsplashSearching\" class=\"fa fa-search\"></i>\n              <i ng-show=\"vm.unsplashSearching\" class=\"fa fa-spin fa-spinner\"></i>\n            </button>\n          </span>\n        </div>\n      </div>\n    </form>\n\n    <ol class=\"list-inline\" ng-if=\"vm.unsplashResults\">\n      <p class=\"help-block text-center\">Found {{vm.unsplashResults.total}} results. <span ng-show=\"vm.unsplashResults.total > 15\">Showing first 15.</span></p>\n      <li ng-repeat=\"f in vm.unsplashResults.results track by f.id\" style=\"width:33%;\">\n        <div class=\"fixed-16-9\"\n             style=\"cursor:pointer\"\n             ng-click=\"vm.selectByUrl(f.urls.regular)\">\n          <div style=\"background-image:url({{f.urls.thumb | trustedUrl}});background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n        </div>\n        <p class=\"help-block text-center\">\n          <small>\n            Image by <a href=\"{{f.user.links.html}}\" target=\"_blank\">{{f.user.first_name}} {{f.user.last_name}}</a>\n          </small>\n        </p>\n      </li>\n    </ol>\n\n    <p class=\"help-block text-center\">\n      Photo search powered by <a href=\"https://unsplash.com\" target=\"_blank\" class=\"action-link\" style=\"color:#000\"><i class=\"fa fa-camera\"></i> Unsplash</a>\n    </p>\n\n  </div>\n\n</div>\n\n"

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = UploadSlotBrowseController;
var PAGE_SIZE = 12;
function UploadSlotBrowseController(params, $uibModalInstance, $http, toaster, AccountUploadsService) {
  'ngInject';

  this.slotName = params.slotName;
  this.allowImage = params.allowImage;
  this.allowVideo = params.allowVideo;
  this.hideStockBrowse = params.hideStockBrowse;
  this.hideRecentBrowse = params.hideRecentBrowse;
  var cfg = AccountUploadsService.uploadConfiguration(this.allowVideo, this.allowImage, this.slotName);
  this.rules = cfg.rules;

  this.cancel = function () {
    return $uibModalInstance.dismiss();
  };

  this.selectByFile = function (file) {
    $uibModalInstance.close({
      type: 'file',
      result: file
    });
  };

  this.selectByUploadObject = function (upload) {
    $uibModalInstance.close({
      type: 'upload',
      result: upload
    });
  };

  this.selectByUrl = function (url) {
    // The Unsplash API *wants* us to hotlink to their image hosting so that
    // they can properly track hits, which is awesome for us!
    $uibModalInstance.close({
      type: 'url',
      result: url
    });
  };

  this.searchUnsplash = function () {
    var _this = this;

    this.unsplashSearching = true;
    this.unsplashResults = null;
    AccountUploadsService.searchUnsplash(this.unsplashQuery).then(function (results) {
      _this.unsplashResults = results;
    })["finally"](function () {
      return _this.unsplashSearching = false;
    });
  };

  this.q = '';

  this.loadUploadsForPage = function (p, q) {
    var _this2 = this;

    var filters = {};

    if (this.slotName) {
      filters['filter.slot'] = this.slotName;
    }

    return AccountUploadsService.listUploadsForPage(p, q, filters, PAGE_SIZE).then(function (response) {
      _this2.uploads = response.uploads;
      _this2.pagination = response.pagination;
    })["catch"](function (err) {
      toaster.pop('warning', 'Unable to load uploads. Please refresh the page and try again.');
    });
  };

  this.loadUploadsForPage(1, this.q);
}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// wifi signal strength directive
//
//   <wifi-signal-strength pct="0.5" label-position="'left'" />
//
var module = angular.module('app.directives');
module.directive('wifiSignalStrength', function () {
  return {
    restrict: 'E',
    scope: {
      pct: '=pct',
      labelPosition: '=labelPosition'
    },
    template: "\n      <div style=\"position:relative;text-align:center;top:5px;\">\n        <span class=\"hidden-xs\" style=\"position:relative;top:-5px;\" ng-if=\"labelPosition == 'left'\">{{(pct * 100) | number:0}}%</span>\n        <div style=\"display:inline-block;\" class=\"wifi-icon {{suppClass}}\"></div>\n        <span class=\"hidden-xs\" style=\"position:relative;top:-5px;\" ng-if=\"labelPosition == 'right'\">{{(pct * 100) | number:0}}%</span>\n      </div>\n    ",
    link: function link(scope) {
      // 4 bars: 0-9%=0 bars, 10-19%=0 bars, 20-39=2 bars, 40-59%=3 bars, ...
      if (scope.pct < 0.25) {
        scope.suppClass = 'none';
      } else if (scope.pct < 0.5) {
        scope.suppClass = 'weak';
      } else if (scope.pct < 0.75) {
        scope.suppClass = 'medium';
      } else {
        scope.suppClass = '';
      }
    }
  };
});

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// toggle switch directive
//
// example:
//   <p ng-init="checkedState = true">
//     Toggle
//     <toggle-switch ng-model="checkedState" color="blue"></toggle-switch>
//     Checked: '{{checkedState}}'
//   </p>
//
// note:
//  * `color` value must match the CSS options in app/styles/components/_toggle_switch.scss
var module = angular.module('app.directives');
var DEFAULT_COLOR = 'green';
module.directive('toggleSwitch', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      ngChange: '&',
      color: '@',
      label: '@'
    },
    require: 'ngModel',
    template: "\n      <label style=\"line-height: 24px\">\n        <span class=\"toggle-switch toggle-switch--{{::color}}\">\n          <input type=\"checkbox\" ng-model=\"ngModel\" ng-change=\"ngChange($event)\">\n          <span class=\"slider\"></span>\n        </span>\n        <span ng-if=\"label\" style=\"display: inline-block; margin-left: 5px;\">{{label}}</span>\n      </label>\n    ",
    link: function link(scope, element, attrs, ngModelCtrl) {
      scope.color = scope.color || DEFAULT_COLOR;
    }
  };
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
var module = angular.module('app.filters', []); // The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.

__webpack_require__(355);

__webpack_require__(356);

__webpack_require__(357);

__webpack_require__(358);

__webpack_require__(359);

__webpack_require__(360);

__webpack_require__(361);

__webpack_require__(362);

__webpack_require__(363);

__webpack_require__(364);

__webpack_require__(365);

__webpack_require__(366);

__webpack_require__(367);

__webpack_require__(368);

__webpack_require__(369);

__webpack_require__(370);

__webpack_require__(371);

__webpack_require__(372);

__webpack_require__(373);

module.filter('escape', function () {
  return window.encodeURIComponent;
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 355 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('bytes', function () {
  'ngInject';

  return function (bytes, precision) {
    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
    if (typeof precision === 'undefined') precision = 1;
    if (bytes == 0) return '0 B';
    var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB'],
        number = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
  };
});
angular.module('app.filters').filter('bits', function () {
  'ngInject';

  return function (bytes, precision) {
    var part = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'all';
    var value, suffix;

    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
      value = '-';
      suffix = '';
    } else {
      if (typeof precision === 'undefined') {
        precision = 1;
      }

      if (bytes == 0) {
        value = 0;
        suffix = 'b';
      } else {
        var units = ['b', 'kb', 'Mb', 'Gb', 'Tb', 'Pb'],
            number = Math.floor(Math.log(bytes) / Math.log(1024));
        value = (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision);
        suffix = units[number];
      }
    }

    if (part == 'value') {
      return value;
    } else if (part == 'suffix') {
      return suffix;
    } else {
      return "".concat(value, " ").concat(suffix);
    }
  };
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);
// dateDuration filter
//
//    {{ startTime | dateDuration : endTime : showSeconds : defaultIfEndNull }}

angular.module('app.filters').filter('dateDuration', function ($filter) {
  'ngInject';

  return function (start, end, showSeconds, defaultIfEndNull) {
    if (defaultIfEndNull && !end) {
      return defaultIfEndNull;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["b" /* differenceFormattedAsDurationLabel */])(start, end, showSeconds);
  };
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_video_and_audio_config__ = __webpack_require__(29);

angular.module('app.filters').filter('configLabel', function ($rootScope) {
  'ngInject';

  var ApiConfig = $rootScope.ApiConfig;
  return function (value, section, subsection) {
    var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var cfg = (ApiConfig[section] || {})[subsection] || (__WEBPACK_IMPORTED_MODULE_0__utils_video_and_audio_config__["a" /* VideoAudioConfig */][section] || {})[subsection];

    var result = _.find(cfg, function (item) {
      return item.value == value;
    });

    return _.get(result, 'label', defaultValue);
  };
});

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// daySuffix filter
//
//  Returns "February 1st", "March 2nd", etc. for a given date. You can
//  also choose to just return "1st" or "2nd" by passing false as the 2nd arg.
angular.module('app.filters').filter('daySuffix', ["$filter", function ($filter) {
  'ngInject';

  var suffixes = ['th', 'st', 'nd', 'rd'];
  return function (input) {
    var withMonthName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!input) return '';
    var fullDate = $filter('date')(input, 'MMMM dd');
    var day = parseInt(fullDate.slice(-2));
    var relevantDigits = day < 30 ? day % 20 : day % 30;
    var suffix = relevantDigits <= 3 ? suffixes[relevantDigits] : suffixes[0];

    if (withMonthName) {
      return fullDate + suffix;
    } else {
      return day + suffix;
    }
  };
}]);

/***/ }),
/* 359 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('getById', function () {
  'ngInject';

  return function (map, searchValue) {
    var keyField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
    var displayField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var defaultValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    var result = _.find(map, function (item) {
      return item[keyField] == searchValue;
    });

    if (displayField) {
      return _.get(result, displayField, defaultValue);
    } else {
      return result;
    }
  };
});

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// macAddress filter -- formats a 12-character string as a MAC address. The default separator is a colon.
//
//    {{ address | macAddress : separator }}
angular.module('app.filters').filter('macAddress', ["$filter", function ($filter) {
  'ngInject';

  return function (input) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
    return input.toUpperCase().match(/.{1,2}/g).join(separator);
  };
}]);

/***/ }),
/* 361 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('metricSuffix', ["$filter", function ($filter) {
  'ngInject';

  var numberWithUnitFilter = $filter('numberWithUnit');
  return function (number, extraText) {
    if (!number) return '';
    if (!extraText) extraText = '';
    if (!_.isNumber(number)) return number; // Reduce the number to be < 1000

    var tridecadic_reduction = 0;

    while (number >= 1000.0) {
      number = number / 1000.0;
      tridecadic_reduction += 1;
    }

    var prefix;

    switch (tridecadic_reduction) {
      case 0:
        prefix = '';
        break;

      case 1:
        prefix = 'k';
        break;

      case 2:
        prefix = 'M';
        break;

      case 3:
        prefix = 'G';
        break;

      case 4:
        prefix = 'T';
        break;

      case 5:
        prefix = 'P';
        break;

      default:
        prefix = "10^".concat(3 * tridecadic_reduction);
    }

    return numberWithUnitFilter(number, 1, prefix + extraText);
  };
}]);

/***/ }),
/* 362 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('numberWithUnit', ["$filter", function ($filter) {
  'ngInject';

  var numberFilter = $filter('number');
  return function (number, fractionSize, unit) {
    if (!number) return '';
    if (!unit) unit = '';
    return "".concat(numberFilter(number, fractionSize), " ").concat(unit);
  };
}]);

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// Some global config for moment -- treat every interval as its unit right up to the next one
moment.relativeTimeThreshold('s', 60);
moment.relativeTimeThreshold('m', 60);
moment.relativeTimeThreshold('h', 24);
moment.relativeTimeThreshold('d', 30);
moment.relativeTimeThreshold('M', 12); // relativeTime filter -- formats date/time string into a relative time much like moment().fromNow(), but with slightly more intelligence.

angular.module('app.filters').filter('relativeTime', ["$filter", function ($filter) {
  'ngInject';

  return function (input) {
    var t = moment(input);
    var val = t.fromNow();

    if (val.match(/days?$/)) {
      // If moment wants to say "day" or "days", it's possible that this could be rounded in a non-intuitive way.
      // The most intuitive thing for users is the number of midnights crossed between now and then. The easiest
      // way to get that is to set the time (not the date) of the moment in question to match the time of "now",
      // then let moment do its thing.
      var now = moment();
      t.hours(now.hours());
      t.minutes(now.minutes());
      t.seconds(now.seconds());
      t.millisecond(now.millisecond());
      val = t.fromNow();
    }

    return val;
  };
}]);

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// remainingTime filter -- formats a number of milliseconds into a human-readable (and not overly-precise) form
angular.module('app.filters').filter('remainingTime', ["$filter", function ($filter) {
  'ngInject';

  return function (ms) {
    var rt = $filter('relativeTime')(new Date(Date.now() + ms));

    if (rt.indexOf('ago') != -1) {
      rt = 'in a few seconds';
    } else if (rt.startsWith('in ') && !rt.startsWith('in a few')) {
      rt = rt.replace(/^in /, 'in about ');
    }

    rt = rt.replace(/^in /, '');
    return rt;
  };
}]);

/***/ }),
/* 365 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('scoreboardTeamName', function () {
  'ngInject';

  return function (label) {
    var dflt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    // See origin_task/scorelayout#sanitizeName
    label = label || dflt;
    label = label.toUpperCase();

    if (label.length > 4) {
      label = label.substring(0, 4);
    }

    label = label.replace(/[^\x20-\x7E]+/g, '-');

    while (label.length < 4) {
      label += ' ';
    }

    return label;
  };
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);
// secondsFormatted filter
//
//    {{ numberSeconds | secondsFormatted }}

angular.module('app.filters').filter('secondsFormatted', function ($filter) {
  'ngInject';

  return function (seconds) {
    var showSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var showHoursIfZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["e" /* secondsToFormattedLabel */])(seconds, showSeconds, showHoursIfZero);
  };
});

/***/ }),
/* 367 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('simulcast_destination', function () {
  'ngInject';

  return function (destination) {
    switch (destination) {
      case 'facebook':
        return 'Facebook Live';

      case 'youtube':
        return 'YouTube Live';

      case 'generic':
        return 'Other RTMP';

      case 'rtmp_push_channel':
        return 'Other RTMP';

      case 'twitter':
        return 'Twitter';

      default:
        console.warn('Invalid simulcast_destination', destination);
        return "(invalid destination type: ".concat(destination, ")");
    }
  };
});

/***/ }),
/* 368 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('simulcastStatus', ["$filter", function ($filter) {
  'ngInject';

  return function (status) {
    switch (status) {
      case null:
        return 'N/A';

      default:
        return $filter('unslugify')(status);
    }
  };
}]);

/***/ }),
/* 369 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('streamSourceName', ["$filter", function ($filter) {
  'ngInject';

  return function (broadcast) {
    switch (broadcast.stream_source) {
      case 'switcher':
        return 'Switcher Studio (iOS)';

      case 'app':
        return 'Broadcaster App';

      case 'rtmp':
        if (broadcast.static_rtmp_name) {
          return "RTMP: ".concat(broadcast.static_rtmp_name);
        } else {
          return 'RTMP';
        }

      case 'recording':
        return 'Re-Broadcast (Simulated Live)';

      case 'producer':
        return 'Producer (Browser-based streaming)';

      default:
        return broadcast.boxcaster_name;
    }
  };
}]);

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// storageDuration filter
//
//    {{ vm.account.storage_duration_days | storageDuration }}
angular.module('app.filters').filter('storageDuration', ["$filter", function ($filter) {
  'ngInject';

  return function (durationDays) {
    var days = parseInt(durationDays, 10);

    switch (days) {
      case 365:
        return '1 year';
        break;

      case 731:
        return '2 years';
        break;

      case 1096:
        return '3 years';
        break;

      case 1461:
        return '4 years';
        break;

      case 1826:
        return '5 years';
        break;

      default:
        return "".concat(durationDays, " days");
        break;
    }
  };
}]);

/***/ }),
/* 371 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('trustedUrl', ["$sce", function ($sce) {
  'ngInject';

  return function (string) {
    return $sce.trustAsResourceUrl(string);
  };
}]);

/***/ }),
/* 372 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('unslugify', ["$filter", function ($filter) {
  'ngInject';

  function titlecase(s) {
    return s.toString().toLowerCase().replace(/\b([a-z])/g, function (ch) {
      return ch.toUpperCase();
    });
  }

  return function (string) {
    return titlecase((string || '').replace(/_/g, ' '));
  };
}]);

/***/ }),
/* 373 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('usageType', ["$filter", function ($filter) {
  'ngInject';

  return function (input) {
    switch (input) {
      case 'broadcast_duration':
        return 'broadcast';

      case 'viewership':
        return 'viewership';

      case 'captioning':
        return 'caption';
    }

    return '';
  };
}]);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);

var subPages = [__webpack_require__(375), __webpack_require__(378), __webpack_require__(383), __webpack_require__(386), __webpack_require__(396), __webpack_require__(420), __webpack_require__(423), __webpack_require__(424), __webpack_require__(425), __webpack_require__(427), __webpack_require__(428), __webpack_require__(434), __webpack_require__(435), __webpack_require__(444), __webpack_require__(478), __webpack_require__(482)];
var module = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('app.pages', subPages.map(function (s) {
  return s["default"].name;
}));
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bulk_import_html__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bulk_import_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__bulk_import_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bulk_import_controller__ = __webpack_require__(377);



var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('bulk-import', __WEBPACK_IMPORTED_MODULE_1__bulk_import_html___default.a, __WEBPACK_IMPORTED_MODULE_2__bulk_import_controller__["a" /* default */], 'BulkImportController');
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports = "<style>\n.bulk-import-progress-container {\n  max-width: 500px;\n  margin: 30px auto;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  padding: 20px;\n}\n.bulk-import-progress-container .row {\n  margin: 15px -15px;\n}\n.bulk-import-progress-container h1 {\n  margin: 0;\n}\n.bulk-import-progress-container i {\n  display: none;\n}\n.bulk-import-progress-container .todo {\n  color: #ccc;\n}\n.bulk-import-progress-container .complete,\n.bulk-import-progress-container .error {\n  color: #333;\n}\n.bulk-import-progress-container .todo i.fa-spinner,\n.bulk-import-progress-container .error i.fa-warning,\n.bulk-import-progress-container .complete i.fa-check {\n  display: inline-block;\n}\n</style>\n<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n\n\n      <div class=\"well\" ng-if=\"!vm.file\">\n        <h3>Import Broadcasts from CSV</h3>\n        <div class=\"row\">\n          <div class=\"col-sm-6\">\n            <h4>Instructions</h4>\n            <ol>\n              <li><a href=\"javascript://\" ng-disabled=\"vm.downloadingTemplate\" ng-click=\"vm.downloadTemplate()\">Download the Excel Template</a>.  Note that the file is customized for your BoxCast account -- do not share the template with others.</li>\n              <li>Open the file in Microsoft Excel or Google Sheets, and locate the tab labeled \"Broadcasts\" (the other tabs are only for reference).</li>\n              <li>Add one row per broadcast, leaving the header row in-tact.\n                <ul>\n                  <li>On many fields, we have configured the spreadsheet to load supported values as a dropdown. Please use the dropdown to select the value.  If the value does not match exactly, the import may be rejected.</li>\n                  <li>Leave non-required fields blank that you do not need (for example, if you don't want a scoreboard overlay).  Do not remove any columns or the import may fail.</li>\n                </ul>\n              </li>\n              <li>Export the \"Broadcasts\" tab as a CSV file (comma separated values). Leave the header row in place if given the option.</li>\n              <li>Drag and drop the CSV file into the area above to complete your scheduling.</li>\n            </ol>\n            <h4>FAQs</h4>\n            <ul>\n              <li>\n                <strong>Can I use something other than Microsoft Excel or Google Sheets?</strong>\n                <div>Yes, but other spreadsheet software does not support the dynamic lookup feature that is built into\n                  the template, so the import may fail if field values are not typed in precisely.\n                  Please refer to the extra tabs to find proper values to use for Sources, Channels, etc.</div>\n              </li>\n              <li>\n                <strong>Can I just reupload the XLSX file after editing?</strong>\n                <div>No, please export as a CSV (comma separated values) file.</div>\n              </li>\n              <li>\n                <strong>How many records are supported?</strong>\n                <div>You may import up to 1000 records at a time.</div>\n              </li>\n              <li>\n                <strong>How can I add social media broadcast destinations or a thumbnail image? I don't see it in the template.</strong>\n                <div>After you upload the file, you will have the option to attach social media broadcast destinations\n                  in bulk, or to upload thumbnail images for each broadcast. These actions are not easily represented in a spreadsheet, so we have\n                  expanded the upload tool to assist.</div>\n              </li>\n            </ul>\n          </div>\n          <div class=\"col-sm-6\">\n            <button ng-disabled=\"vm.downloadingTemplate\" type=\"button\" class=\"btn btn-block btn-lg btn-default\" ng-click=\"vm.downloadTemplate()\">\n              <i ng-hide=\"vm.downloadingTemplate\" class=\"fa fa-file-excel-o\"></i>\n              <i ng-show=\"vm.downloadingTemplate\" class=\"fa fa-spinner fa-spin\"></i>\n              Download Excel Template\n            </button>\n            <div style=\"margin:30px auto;max-width:800px;\">\n              <upload-slot ng-model=\"vm.file\"\n                          ng-change=\"vm.uploadCSV(vm.file)\"\n                          slot-name=\"'csv'\"\n                          allow-image=\"true\"\n                          allow-video=\"false\"\n                          hide-stock-browse=\"true\"\n                          hide-recent-browse=\"true\"></upload-slot>\n            </div>\n          </div>\n        </div>\n      </div>\n\n\n\n      <div class=\"well\" ng-if=\"vm.file\">\n\n        <div class=\"row\">\n          <div class=\"col-xs-6 text-left\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.file = null\">\n              <i class=\"fa fa-caret-left\"></i>\n              Back\n            </button>\n          </div>\n          <div class=\"col-xs-6 text-right\" ng-if=\"vm.showConfirm\">\n            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.saveAll()\">Finalize Import</button>\n          </div>\n        </div>\n\n        <div class=\"bulk-import-progress-container\" ng-if=\"vm.showProgress\">\n          <div class=\"row {{vm.progress.upload}}\">\n            <div class=\"col-xs-6\">\n              <h1>Uploading</h1>\n            </div>\n            <div class=\"col-xs-6 text-right\">\n              <i class=\"fa fa-2x text-success fa-check\"></i>\n              <i class=\"fa fa-2x text-danger fa-warning\"></i>\n              <i class=\"fa fa-2x fa-spinner fa-spin\"></i>\n            </div>\n          </div>\n          <div class=\"row {{vm.progress.process}}\">\n            <div class=\"col-xs-6\">\n              <h1>Processing File</h1>\n            </div>\n            <div class=\"col-xs-6 text-right\">\n              <i class=\"fa fa-2x text-success fa-check\"></i>\n              <i class=\"fa fa-2x text-danger fa-warning\"></i>\n              <i class=\"fa fa-2x fa-spinner fa-spin\"></i>\n            </div>\n          </div>\n          <div class=\"row {{vm.progress.validate}}\">\n            <div class=\"col-xs-6\">\n              <h1>Validating</h1>\n            </div>\n            <div class=\"col-xs-6 text-right\">\n              <i class=\"fa fa-2x text-success fa-check\"></i>\n              <i class=\"fa fa-2x text-danger fa-warning\"></i>\n              <i class=\"fa fa-2x fa-spinner fa-spin\"></i>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.showErrors\">\n          <h4>Error Importing CSV</h4>\n          <p>\n            There were one or more errors with your import. Please correct the issues in your CSV file and\n            <a href=\"javascript://\" ng-click=\"vm.file = null\">try the upload again</a>.\n          </p>\n\n          <ul>\n            <li ng-repeat=\"e in vm.errors\">\n              <strong class=\"text-danger\">{{e.error}}</strong> (from CSV line {{e.rowIndex+1}})\n            </li>\n          </ul>\n        </div>\n\n        <div ng-if=\"vm.showSaveProgress\">\n          <h4>Finalizing Import</h4>\n          <p>Please wait while the broadcasts are imported.  This could take some time, but please do not close this page until the import is complete.</p>\n\n          <div style=\"margin:50px 0\">\n            <h1 class=\"text-center\">\n              <i class=\"fa fa-spinner fa-spin\"></i>\n              Saving broadcast {{vm.submittingIndex + 1}} of {{vm.broadcasts.length}}\n            </h1>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.showComplete\">\n          <h4>Import Complete</h4>\n          <p>{{vm.broadcasts.length}} broadcasts were successfully imported.</p>\n          <div style=\"margin:50px 0\" class=\"text-center\">\n            <h1>\n              <i class=\"fa fa-check-square\" style=\"font-size:200px;color:#1AA8A1\"></i>\n            </h1>\n            <p>\n              <a href=\"/\">Return to Dashboard</a>\n            </p>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.showConfirm\">\n          <h4>Confirm Broadcast Import</h4>\n          <p>\n            {{vm.broadcasts.length}} broadcasts are ready to be imported. Please confirm the list below, and then\n            click to finalize the import.\n          </p>\n\n          <h4>Additional Actions</h4>\n          <div style=\"margin-bottom:15px\">\n            <div ng-if=\"(vm.service.allowFacebookLive || vm.service.allowYoutubeLive || vm.service.allowGenericRtmpPush || vm.service.allowTwitter)\">\n              <div>\n                <span ng-click=\"vm.showSocial = !vm.showSocial\" style=\"cursor:pointer\">\n                  <i class=\"fa\" ng-class=\"vm.showSocial ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n                  Add Social Media Destinations to All Imported Broadcasts\n                </span>\n              </div>\n              <div class=\"well clearfix\" uib-collapse=\"vm.showSocial !== true\">\n                <div class=\"form-horizontal\">\n                  <simulcast-configuration-editor vm=\"vm\"></simulcast-configuration-editor>\n                </div>\n              </div>\n            </div>\n            <div>\n              <span ng-click=\"vm.showThumbnailPicker = !vm.showThumbnailPicker\" style=\"cursor:pointer\">\n                <i class=\"fa\" ng-class=\"vm.showThumbnailPicker ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n                Add Thumbnails to Each Broadcast\n              </span>\n            </div>\n          </div>\n\n          <h4>Preview Imported Broadcasts</h4>\n          <div style=\"max-width:100%;max-height:calc(50vh);overflow:scroll;border:1px solid #ddd;\">\n            <table class=\"table table-condensed table-striped\">\n              <thead>\n                <tr>\n                  <th ng-if=\"vm.showThumbnailPicker\">Thumbnail</th>\n                  <th>Name</th>\n                  <th>Date/Time</th>\n                  <th>Accessibility</th>\n                  <th>Source</th>\n                  <th>Channels</th>\n                  <th ng-if=\"vm.service.showAnyScoreboards\">Sport/Scoreboard</th>\n                  <th ng-if=\"vm.showTeams\">Home</th>\n                  <th ng-if=\"vm.showTeams\">Home Color</th>\n                  <th ng-if=\"vm.showTeams\">Away</th>\n                  <th ng-if=\"vm.showTeams\">Away Color</th>\n                  <th>Advanced</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"b in vm.broadcasts track by $index\">\n                  <td ng-if=\"vm.showThumbnailPicker\" style=\"width:175px\">\n                    <div ng-if=\"b.content_settings.preview\" class=\"text-center\">\n                      <img ng-src=\"{{b.content_settings.preview | trustedUrl}}\" class=\"img\" style=\"max-width:100%\">\n                      <div><a href ng-click=\"b.content_settings.preview = null\">Change</a></div>\n                    </div>\n                    <div ng-if=\"!b.content_settings.preview\">\n                      <upload-slot ng-model=\"vm.thumbnails[$index]\"\n                                   ng-change=\"vm.uploadThumbnail($index)\"\n                                   slot-name=\"'preview'\"\n                                   allow-image=\"true\"\n                                   allow-video=\"false\"\n                                   compact=\"true\"></upload-slot>\n                    </div>\n                  </td>\n                  <td>\n                    {{b.name}}\n                    <div ng-show=\"b.description\" style=\"font-size:8pt;max-width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;\">{{b.description}}</></div>\n                  </td>\n                  <td><date-range start=\"b.starts_at\" end=\"b.stops_at\"></date-range></td>\n                  <td>\n                    <span ng-if=\"b.is_ticketed\" class=\"label label-success\">${{b.ticket_price | number:2}} / ticket</span>\n                    <span ng-if=\"b.is_private\" class=\"label label-danger\">Private</span>\n                    <span ng-if=\"!b.is_ticketed && !b.is_private\" class=\"label label-default\">Public</span>\n                  </td>\n                  <td>{{b | streamSourceName}}</td>\n                  <td>{{b.__channel_name__}}</td>\n                  <td ng-if=\"vm.service.showAnyScoreboards\">\n                    <div ng-if=\"b.sport\">{{b.sport}}</div>\n                    <div ng-if=\"b.scoreboard_make\">\n                      {{b.scoreboard_make}} - {{b.scoreboard_model}}\n                      <span ng-if=\"b.overlay_location\">({{b.overlay_location}})</span>\n                    </div>\n                  </td>\n                  <td ng-if=\"vm.showTeams\">{{b.home_team_name}}</td>\n                  <td ng-if=\"vm.showTeams\"><boxcast-color-picker ng-model=\"b.home_team_logo\"></boxcast-color-picker></td>\n                  <td ng-if=\"vm.showTeams\">{{b.away_team_name}}</td>\n                  <td ng-if=\"vm.showTeams\"><boxcast-color-picker ng-model=\"b.away_team_logo\"></boxcast-color-picker></td>\n                  <td>\n                    <span ng-if=\"b.target_video_resolution != 'default'\">\n                      {{b.target_video_resolution}}p\n                    </span>\n                    <span ng-if=\"b.target_high_frame_rate === true\">\n                      (up to 60 FPS) \n                    </span>\n                    <span ng-if=\"b.target_high_frame_rate === false\">\n                      (up to 30 FPS) \n                    </span>\n                    <span ng-if=\"b.requests_captioning === true\">\n                      Automated Captioning\n                    </span>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </div><!--/end overflow-x:scroll-->\n\n          <p class=\"text-center\" style=\"margin: 30px 0\">\n            <button type=\"button\" class=\"btn btn-lg btn-block btn-primary\" ng-click=\"vm.saveAll()\">Finalize Import</button>\n          </p>\n\n        </div><!--/end showConfirm-->\n\n      </div><!--/end .well-->\n\n    </div>\n</main>\n"

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BulkImportController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_pricing__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_date__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_download__ = __webpack_require__(19);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }




var MAX_IMPORT_RECORDS = 1000;

var BulkImportController = /*#__PURE__*/function () {
  function BulkImportController($timeout, $rootScope, $http, EditOrCreateEventService, Facebook, toaster) {
    'ngInject';

    _classCallCheck(this, BulkImportController);

    var ApiConfig = $rootScope.ApiConfig;
    this.$timeout = $timeout;
    this.$http = $http;
    this.toaster = toaster;
    this.service = EditOrCreateEventService.getInstance();
    this.service.initBroadcast();
    this.service.bulkImportMode = true;
    this.fb = Facebook;
    this.fb.init();
    this.validSports = ApiConfig.stream.sports.map(function (s) {
      return s.value;
    });
  }

  _createClass(BulkImportController, [{
    key: "loginFacebook",
    value: function loginFacebook() {
      this.fb.login();
    }
  }, {
    key: "logoutFacebook",
    value: function logoutFacebook() {
      var _this = this;

      this.fb.logout().then(function () {
        return _this.fb.init();
      });
    }
  }, {
    key: "downloadTemplate",
    value: function downloadTemplate() {
      var _this2 = this;

      var $http = this.$http;
      this.downloadingTemplate = true;
      $http.get("".concat(API_ROOT, "/account/broadcast_import_template"), {
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this2.downloadingTemplate = false;
        console.log('loaded template', response);
        var blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_download__["a" /* forceBrowserDownload */])(URL.createObjectURL(blob), 'broadcast_import.xlsx');
      })["catch"](function (data, status) {
        _this2.downloadingTemplate = false;
        console.error('Error loading template', data, status);
        alert('Unable to download template. Please refresh your browser and try again. For best results, try using Google Chrome.');
      });
    }
  }, {
    key: "uploadThumbnail",
    value: function uploadThumbnail(index) {
      var file = this.thumbnails[index];
      var broadcast = this.broadcasts[index];
      file.upload().then(function (result) {
        broadcast.content_settings = broadcast.content_settings || {};
        broadcast.content_settings.preview = result.view_url;
        broadcast.content_settings.poster = result.view_url;
      });
    }
  }, {
    key: "uploadCSV",
    value: function uploadCSV(result) {
      var _this3 = this;

      var $timeout = this.$timeout;
      this.errors = [];
      this.broadcasts = [];
      this.progress = {
        upload: 'todo',
        process: 'todo',
        validate: 'todo'
      };
      this.showProgress = true;
      this.showErrors = false;
      this.showConfirm = false;
      var r = new FileReader();

      r.onload = function (e) {
        $timeout(function () {
          _this3.progress.upload = 'complete';

          _this3.parseFile(e.target.result);
        }, 100);
      };

      r.oneror = function (e) {
        $timeout(function () {
          _this3.progress.upload = 'error';
        }, 0);
      };

      r.readAsText(result.file);
    }
  }, {
    key: "parseFile",
    value: function parseFile(fileContents) {
      var _this4 = this;

      var $timeout = this.$timeout;
      this.fileContents = fileContents;
      this.rows = CSVToListOfDicts(this.fileContents);
      this.errors = [];
      this.broadcasts = [];
      this.thumbnails = {};
      this.showTeams = false;
      this.rows.forEach(function (r, i) {
        try {
          _this4.broadcasts.push(_this4.validateAndTransform(r));
        } catch (e) {
          _this4.errors.push({
            row: r,
            rowIndex: i,
            error: e.toString()
          });
        }
      });

      if (this.broadcasts.length > MAX_IMPORT_RECORDS) {
        this.errors.push({
          row: {},
          rowIndex: MAX_IMPORT_RECORDS,
          error: "A maximum of ".concat(MAX_IMPORT_RECORDS, " imported broadcasts are supported. Please remove some from your import file and try again.")
        });
      } // Artificial delays to make it look like we're working hard


      $timeout(function () {
        return _this4.progress.process = 'complete';
      }, 1000);
      $timeout(function () {
        if (_this4.errors.length) {
          _this4.progress.validate = 'error';
          $timeout(function () {
            _this4.showErrors = true;
            _this4.showProgress = false;
          }, 1000);
        } else {
          _this4.progress.validate = 'complete';
          $timeout(function () {
            _this4.showConfirm = true;
            _this4.showProgress = false;
          }, 1000);
        }
      }, 2500);
    }
  }, {
    key: "validateAndTransform",
    value: function validateAndTransform(r) {
      var b = {
        id: Math.random(),
        //<-- required for ng-repeat unique key
        content_settings: {},
        simulcast_configurations: [],
        do_not_record: this.service.account.feature_flags.no_recordings
      };
      this.service.broadcast = b; //<-- later methods have mutations that occur here
      // Map CSV field names to broadcast fields

      b.name = r.Name;
      if (!b.name) throw 'Name is required';
      b.description = r.Description; // Date/Time handling (note the actual saving process does more validation)

      b.startDate = this.service.startDate = moment(r['Date']).toDate();
      if (!r['Date'] || !b.startDate || isNaN(b.startDate.getTime())) throw "A valid, future start date is required. Please verify the date format in your CSV file.";
      b.startTime = this.service.startTime = parseTime(r['Start Time']);
      if (!b.startTime) throw "Invalid start time ".concat(startTime);
      b.endTime = this.service.endTime = parseTime(r['End Time']);
      if (!b.endTime) throw "Invalid end time ".concat(endTime);
      var dates = Object(__WEBPACK_IMPORTED_MODULE_1__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(b.startDate, b.startTime, b.endTime, this.service.maxBroadcastDurationHours);
      b.starts_at = dates.starts_at;
      b.stops_at = dates.stops_at;

      if (moment(b.starts_at).toDate() < new Date()) {
        throw "A valid, future start date and time is required";
      }

      if (!this.service.isWithinAccountBroadcastDurationLimit) {
        throw "You are not allowed to stream for longer than ".concat(this.service.maxBroadcastDurationHours, " hours");
      } // Source handling (note that the actual saving process sets stream_source, etc)


      var s = r['Source'];

      var box = _.find(this.service.boxcasters, {
        name: s
      });

      var staticRtmp = _.find(this.service.staticRTMPs, {
        name: s
      });

      if (s == 'BoxCast Broadcaster (iOS)') {
        b.boxcaster_id = 'stream_source:app';
      } else if (box != null) {
        b.boxcaster_id = box.id;
        b.boxcaster_name = box.name;
      } else if (staticRtmp != null) {
        b.boxcaster_id = "stream_source:rtmp:".concat(staticRtmp.id);
      } else if (s == 'Producer') {
        b.boxcaster_id = 'stream_source:producer';
      } else {
        throw "Source ".concat(s, " not found");
      }

      this.service.explodeStreamSourceSettings(b); // Accessibility and Ticketing

      var t = r['Broadcast Type'];
      b.visibility = {
        'Private/Test': 'private',
        Public: 'public',
        'Flex (Ticketed HD)': 'flex',
        Ticketed: 'ticketed'
      }[t];
      if (!b.visibility) throw "Broadcast type ".concat(t, " invalid");
      b.ticket_price = parseFloat((r['Ticket Price'] || '').replace('$', ''), 10);

      if (b.visibility == 'ticketed' || b.visibility == 'flex') {
        if (isNaN(b.ticket_price) || b.ticket_price < this.service.minTicketPrice) {
          throw "Minimum ticket price is $".concat(this.service.minTicketPrice);
        }
      } else if (b.ticket_price) {
        throw "A ticket price should not be set on non-ticketed broadcasts";
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils_pricing__["b" /* updatePriceSettingsFromVisibilityOption */])(b, b.visibility); // Channel handling

      var c = r['Channels'];

      if (c) {
        var channel = _.find(this.service.channels, {
          name: c
        });

        if (!channel) throw "Channel ".concat(c, " not found");
        b.in_channel_ids = [channel.id];
        b.__channel_name__ = channel.name; //for display purposes on confirm screen
      } // Advanced Settings


      b.target_video_resolution = 'default';

      if (r['Video Resolution']) {
        b.target_video_resolution = parseInt(r['Video Resolution'], 10);

        if (!_.find(this.service.videoResolutions, {
          value: b.target_video_resolution
        })) {
          throw "Invalid video resolution ".concat(this.b.target_video_resolution);
        }
      }

      b.target_high_frame_rate = 'default';

      if ((r['High Frame Rate'] || '').toUpperCase() == 'YES') {
        b.target_high_frame_rate = true;
      } else if ((r['High Frame Rate'] || '').toUpperCase() == 'NO') {
        b.target_high_frame_rate = false;
      }

      if (this.service.account.feature_flags.automated_captioning || this.service.account.feature_flags.live_automated_captioning) {
        b.requests_captioning = this.service.account.content_settings.requestsCaptioning;
      } // Scoreboard


      if (r['Sport']) {
        if (this.validSports.includes(r['Sport'])) {
          b.sport = r['Sport'];
        } else {
          throw "".concat(r['Sport'], " is an invalid sport option");
        }
      }

      if (r['Scoreboard']) {
        this.service.scoreboards.forEach(function (s) {
          if (r['Scoreboard'].startsWith(s.value)) {
            b.scoreboard_make = s.value;
            s.models.forEach(function (m) {
              if (r['Scoreboard'].endsWith(m.value)) {
                b.scoreboard_model = m.value;
              }
            });
          }
        });

        if (!b.scoreboard_make || !b.scoreboard_model) {
          throw "Invalid scoreboard ".concat(r['Scoreboard']);
        }
      }

      b.overlay_location = (r['Scoreboard Location'] || '').toLowerCase();
      b.sportzcast_bot_number = r['SportzCast ScoreBOT Number'];
      b.home_team_name = r['Home Team Name'];

      if (b.home_team_name) {
        b.home_team_logo = this.service.accountScoreboard.home_team_logo;
      }

      b.away_team_name = r['Away Team Name']; // Expose home/away color picker if *any* record has a team name defined

      if (b.scoreboard_make || b.home_team_name || b.away_team_name) {
        this.showTeams = true;
      }

      return b;
    }
  }, {
    key: "addSimulcastDestination",
    value: function addSimulcastDestination(d) {
      return this.service.addSimulcastDestination(d);
    }
  }, {
    key: "removeSimulcastDestination",
    value: function removeSimulcastDestination(d) {
      return this.service.removeSimulcastDestination(d);
    }
  }, {
    key: "saveAll",
    value: function saveAll() {
      this.showSaveProgress = true;
      this.showConfirm = false;
      this.__sharedSimulcastConfigurations = angular.copy(this.service.broadcast.simulcast_configurations || []);
      this.submittingIndex = 0;

      try {
        this.workSaveQueue();
      } catch (e) {
        console.error(e);
        this.toaster.pop('warning', 'There was an error saving the broadcast. Please refresh and try again after verifying which broadcasts were created.');
      }
    }
  }, {
    key: "workSaveQueue",
    value: function workSaveQueue(i) {
      var _this5 = this;

      if (this.submittingIndex >= this.broadcasts.length) {
        this.showSaveProgress = false;
        this.showComplete = true;
        console.log('Completed all save operations');
        return;
      }

      var b = angular.copy(this.broadcasts[this.submittingIndex]);
      b.simulcast_configurations = this.__sharedSimulcastConfigurations;
      console.log('Saving', b);
      this.service.broadcast = b; // Derived value things

      this.service.visibility = b.visibility;
      this.service.startDate = b.startDate;
      this.service.startTime = b.startTime;
      this.service.endTime = b.endTime;
      this.service.compensateEndDate();

      if (this.service.showAnyScoreboards) {
        this.service.broadcast.scoreboard_configuration = {
          sport: b.sport,
          scoreboard_make: b.scoreboard_make,
          scoreboard_model: b.scoreboard_model,
          overlay_location: b.overlay_location,
          home_team_name: b.home_team_name,
          home_team_logo: b.home_team_logo,
          away_team_name: b.away_team_name,
          away_team_logo: b.away_team_logo,
          sportzcast_bot_number: b.sportzcast_bot_number
        };
      }

      delete b.id;
      this.service.saveChanges(true, true).then(function () {
        console.log('Saved!');
        _this5.submittingIndex++;

        _this5.workSaveQueue();
      })["catch"](function (e) {
        console.error('Error saving', e);
        _this5.submittingIndex++;

        _this5.workSaveQueue();
      });
    }
  }]);

  return BulkImportController;
}();



function CSVToListOfDicts(data) {
  var result = [];
  var arr = CSVToArray(data);

  if (arr.length < 2) {
    return result;
  }

  var keyIndex = arr[0];

  for (var i = 1; i < arr.length; i++) {
    if (!_.filter(arr[i]).length) {
      continue;
    }

    var row = {};
    arr[i].forEach(function (v, j) {
      row[keyIndex[j]] = v;
    });
    result.push(row);
  }

  return result;
} // ref: http://stackoverflow.com/a/1293163/2343
// This will parse a delimited string into an array of arrays.


function CSVToArray(data) {
  var delimiter = ',';
  var reQuotedValue = new RegExp('""', 'g');
  var rePattern = new RegExp( // Delimiters.
  '(\\' + delimiter + '|\\r?\\n|\\r|^)' + // Quoted fields.
  '(?:"([^"]*(?:""[^"]*)*)"|' + // Standard fields.
  '([^"\\' + delimiter + '\\r\\n]*))', 'gi'); // Create an array to hold our data. Give the array
  // a default empty first row.

  var arrData = [[]]; // Create an array to hold our individual pattern
  // matching groups.

  var arrMatches = null; // Keep looping over the regular expression matches
  // until we can no longer find a match.

  while (arrMatches = rePattern.exec(data)) {
    // Get the delimiter that was found.
    var matchedDelimiter = arrMatches[1]; // Check to see if the given delimiter has a length
    // (is not the start of string) and if it matches
    // field delimiter. If id does not, then we know
    // that this delimiter is a row delimiter.

    if (matchedDelimiter.length && matchedDelimiter !== delimiter) {
      // Since we have reached a new row of data,
      // add an empty row to our data array.
      arrData.push([]);
    }

    var matchedValue; // Now that we have our delimiter out of the way,
    // let's check to see which kind of value we
    // captured (quoted or unquoted).

    if (arrMatches[2]) {
      // We found a quoted value. When we capture
      // this value, unescape any double quotes.
      matchedValue = arrMatches[2].replace(reQuotedValue, '"');
    } else {
      // We found a non-quoted value.
      matchedValue = arrMatches[3];
    } // Now that we have our value string, let's add
    // it to the data array.


    arrData[arrData.length - 1].push(matchedValue);
  } // Return the parsed data.


  return arrData;
}

function parseTime(timeStr, dt) {
  if (!dt) {
    dt = new Date();
  }

  var time = timeStr.match(/(\d+)(?::(\d\d))?\s*(p?)/i);

  if (!time) {
    return NaN;
  }

  var hours = parseInt(time[1], 10);

  if (hours == 12 && !time[3]) {
    hours = 0;
  } else {
    hours += hours < 12 && time[3] ? 12 : 0;
  }

  dt.setHours(hours);
  dt.setMinutes(parseInt(time[2], 10) || 0);
  dt.setSeconds(0, 0);
  return dt;
}

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__caption_editor_html__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__caption_editor_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__caption_editor_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__caption_editor_controller__ = __webpack_require__(380);



var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('caption-editor', __WEBPACK_IMPORTED_MODULE_1__caption_editor_html___default.a, __WEBPACK_IMPORTED_MODULE_2__caption_editor_controller__["a" /* default */], 'CaptionEditorController', '/caption-editor/:broadcastId');

__webpack_require__(382); //<-- require *After* we create angular module above


/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports = "<style>\n.btn-transparent {\n  border: none;\n  background: none;\n  box-shadow: none;\n  margin: 0;\n  padding: 0;\n}\n</style>\n<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n\n  <div class=\"row\" style=\"margin-bottom:15px\">\n    <div class=\"col-sm-4\">\n      <a href=\"{{vueDashboardRoot}}?tab=captions\" class=\"btn btn-default\">\n        <i class=\"fa fa-caret-left\"></i>\n        Back to Broadcast Details\n      </a>\n    </div>\n    <div class=\"col-sm-8 text-right\">\n      <div ng-if=\"vm.captionMeta\">\n        <span ng-if=\"vm.captionMeta.failure_reason\" class=\"label label-danger\">Failed: {{vm.captionMeta.failure_reason}}</span>\n        <span class=\"label label-default\">{{vm.captionMeta.publish_status|unslugify}}</span>\n        <span class=\"label label-default\">Updated: {{vm.captionMeta.updated_at|date:'short'}}</span>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row\" ng-if=\"vm.broadcast.timeframe != 'past'\">\n    <p class=\"text-center\">\n      Captioning is only supported for recorded broadcasts.\n    </p>\n  </div>\n\n  <div class=\"row text-center\" ng-if=\"vm.broadcast.timeframe == 'past' && (vm.captionMeta||{}).status != 'completed'\">\n    <caption-details caption-meta=\"vm.captionMeta\" on-create=\"vm.startCaptioning(upload)\"></caption-details>\n  </div>\n\n\n  <div class=\"row\" ng-if=\"vm.captionMeta.status == 'completed'\">\n\n    <div class=\"col-xs-8\">\n\n      <div class=\"panel caption-table\" style=\"margin-bottom:0; background:transparent;\">\n        <div class=\"caption-table--header\">\n          <div class=\"row\">\n            <div class=\"col-xs-1\">Start</div>\n            <div class=\"col-xs-1\">Stop</div>\n            <div class=\"col-xs-10\">\n              <div class=\"pull-right\" ng-show=\"vm.canEdit\">\n                <div class=\"btn-group\" uib-dropdown dropdown-append-to-body>\n                  <button tabindex=\"-1\" id=\"btn-append-to-body\" type=\"button\" class=\"btn btn-transparent\" uib-dropdown-toggle>\n                    <i class=\"fa fa-cog\" style=\"border:none;color:#fff;\"></i>\n                  </button>\n                  <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\n                    <li role=\"menuitem\">\n                      <a href=\"javascript://\" ng-click=\"vm.mode = (vm.mode == 'full' ? 'review' : 'full')\">\n                        <i ng-show=\"vm.mode == 'review'\" class=\"fa fa-check\" style=\"margin:0 5px 0 -15px;font-size:8pt;width:6px;line-height:17px;\"></i>\n                        Review Low-Confidence Cues\n                      </a>\n                    </li>\n                    <li role=\"menuitem\">\n                      <a href=\"javascript://\" ng-click=\"vm.timestampEdit = !vm.timestampEdit\">\n                        <i ng-show=\"vm.timestampEdit\" class=\"fa fa-check\" style=\"margin:0 5px 0 -15px;font-size:8pt;width:6px;line-height:17px;\"></i>\n                        Allow Timestamp Editing\n                      </a>\n                    </li>\n                    <li ng-if=\"vm.captionMeta.publish_status != 'publishing'\" role=\"menuitem\">\n                      <a href=\"javascript://\" ng-click=\"vm.showReplaceCaptions = true\">Replace Captions with WebVTT File</a>\n                    </li>\n                    <li role=\"menuitem\"><a href=\"javascript://\" ng-click=\"vm.findAndReplace()\">Find and Replace...</a></li>\n                  </ul>\n                </div>\n              </div>\n              Caption\n            </div>\n          </div>\n        </div>\n        <div class=\"caption-table-scroll\">\n          <div vs-repeat=\"{\n                  scrollParent: '.caption-table-scroll',\n                  scrollMargin: 200,\n                }\">\n            <div ng-repeat=\"c in vm.captions | filter : vm.filterByConfidenceMode\"\n                 id=\"caption--index-{{c.absoluteIndex}}\"\n                 class=\"row caption--row\"\n                 ng-class=\"{\n                   'caption--low-confidence': (c.confidence < vm.CONFIDENCE_THRESHOLD),\n                   'caption--playback-active': (c.absoluteIndex === vm.activeCaptionIndex)\n                 }\"\n                 >\n              <div class=\"col-xs-12 text-center\" ng-if=\"c.type == 'silence'\">\n                <small style=\"color:#ccc\" ng-if=\"!c.isLast\">... no captions ...</small>\n                <small ng-if=\"c.isLast\">\n                  <a href=\"javascript://\" ng-click=\"vm.insertCueAfter(c.absoluteIndex - 1)\">Insert Cue</a>\n                </small>\n              </div>\n              <div ng-if=\"c.type == 'cue'\" >\n                <div class=\"col-xs-1 no-padding caption--start\">\n                  <span ng-show=\"(c.timestampEdit || vm.timestampEdit) && vm.canEdit\">\n                    <input type=\"text\" ng-model=\"c.start_time_fmt\" ng-change=\"vm.onChangeTime(c)\" ng-model-options=\"{getterSetter: true, updateOn: 'blur'}\" style=\"max-width:100%\">\n                  </span>\n                  <span ng-hide=\"(c.timestampEdit || vm.timestampEdit) && vm.canEdit\">{{c.start_time_fmt.replace('.000','.0')}}</span>\n                </div>\n                <div class=\"col-xs-1 no-padding caption--stop\">\n                  <span ng-show=\"(c.timestampEdit || vm.timestampEdit) && vm.canEdit\">\n                    <input type=\"text\" ng-model=\"c.end_time_fmt\" ng-change=\"vm.onChangeTime(c)\" ng-model-options=\"{getterSetter: true, updateOn: 'blur'}\" style=\"max-width:100%\">\n                  </span>\n                  <span ng-hide=\"(c.timestampEdit || vm.timestampEdit) && vm.canEdit\">{{c.end_time_fmt.replace('.000','.0')}}</span>\n                </div>\n                <div class=\"col-xs-9 caption--text\" >\n                  <textarea rows=\"2\" type=\"text\" ng-model=\"c.text\" ng-change=\"vm.onEditCaption(c)\" ng-disabled=\"!vm.canEdit\"></textarea>\n                </div>\n                <div class=\"col-xs-1 no-padding caption--actions text-right\" style=\"white-space:nowrap\">\n                  <button type=\"button\" tabindex=\"-1\" class=\"btn btn-transparent\" ng-click=\"vm.player.pause()\" ng-show=\"c.absoluteIndex == vm.activeCaptionIndex && vm.isPlayerPlaying\">\n                    <i class=\"fa fa-pause\"></i>\n                  </button>\n                  <button type=\"button\" tabindex=\"-1\" class=\"btn btn-transparent\" ng-click=\"vm.play(c)\" ng-hide=\"c.absoluteIndex == vm.activeCaptionIndex && vm.isPlayerPlaying\">\n                    <i class=\"fa fa-play\"></i>\n                  </button>\n                  <div class=\"btn-group\" uib-dropdown dropdown-append-to-body ng-show=\"vm.canEdit\">\n                    <button tabindex=\"-1\" id=\"btn-append-to-body\" type=\"button\" class=\"btn btn-transparent\" uib-dropdown-toggle>\n                      <i class=\"fa fa-ellipsis-h\"></i>\n                    </button>\n                    <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\n                      <li role=\"menuitem\" ng-if=\"!(c.timestampEdit || vm.timestampEdit)\"><a href=\"javascript://\" ng-click=\"c.timestampEdit = true\">Edit Start/Stop Times</a></li>\n                      <li role=\"menuitem\" ng-if=\"vm.canInsertBeforeCue(c.absoluteIndex)\">\n                        <a href=\"javascript://\" ng-click=\"vm.insertCueBefore(c.absoluteIndex)\">Insert Cue Before</a>\n                      </li>\n                      <li role=\"menuitem\" ng-if=\"vm.canInsertAfterCue(c.absoluteIndex)\">\n                        <a href=\"javascript://\" ng-click=\"vm.insertCueAfter(c.absoluteIndex)\">Insert Cue After</a>\n                      </li>\n                      <li role=\"menuitem\" ng-if=\"c.confidence < vm.CONFIDENCE_THRESHOLD\"><a href=\"javascript://\" ng-click=\"c.confidence = 1.0 && vm.onEditCaption(c)\">Mark Accurate</a></li>\n                      <li role=\"menuitem\"><a href=\"javascript://\" ng-click=\"vm.deleteCue(c.absoluteIndex)\">Delete Cue</a></li>\n                    </ul>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div><!--/panel-->\n\n    </div>\n\n    <div class=\"col-xs-4\">\n      <div ng-if=\"vm.playerOptions\">\n          <div style=\"position:relative\">\n            <boxcast-player channel-id=\"vm.broadcast.channel_id\" options=\"vm.playerOptions\"></boxcast-player>\n\n            <div class=\"caption--preview\" ng-show=\"vm.activeCaptionIndex !== null && vm.captions[vm.activeCaptionIndex].text\">\n              <span>{{vm.captions[vm.activeCaptionIndex].text}}</span>\n            </div>\n          </div>\n      </div>\n      <div ng-if=\"vm.cuesDirty || vm.captionMeta.publish_status == 'unpublished'\" style=\"margin-top:15px;\">\n        <button type=\"button\" class=\"btn btn-lg btn-primary btn-block\"\n                ng-disabled=\"vm.saving\"\n                ng-click=\"vm.save()\">\n          <i class=\"fa fa-spin fa-spinner\" ng-show=\"vm.saving\"></i>\n          Publish {{vm.captionMeta.publish_status == 'published' ? 'Changes' : ''}}\n        </button>\n      </div>\n      <div ng-if=\"vm.captionMeta.publish_status == 'publishing'\" style=\"margin-top:15px;\">\n        <div class=\"bg-info text-info\" style=\"padding:10px; border:1px solid\">\n          <i class=\"fa fa-spin fa-spinner\"></i>\n          The captions are being published. Note that you cannot make further edits until publishing is complete.\n        </div>\n      </div>\n      <div ng-if=\"vm.recordingIsTrimmed\" class=\"help-block\" style=\"margin-top:15px;\">\n        <i class=\"fa fa-info-circle\" style=\"width:15px;\"></i>\n        The caption editor is currently showing the complete recorded broadcast, but the published version will still be trimmed.\n      </div>\n\n      <div style=\"margin-top:15px;\">\n        <div ng-if=\"vm.showReplaceCaptions\" class=\"well\" style=\"margin-top:15px;\">\n          <div class=\"row\">\n            <div class=\"col-sm-12\">\n              <div class=\"caption-upload-cell\" style=\"margin:0 auto; max-width:300px\">\n                <upload-slot ng-model=\"vm.captionFile\"\n                            ng-change=\"vm.uploadCaption(vm.captionFile)\"\n                            slot-name=\"'caption'\"\n                            allow-image=\"false\"\n                            allow-video=\"false\"\n                            hide-stock-browse=\"true\"\n                            hide-recent-browse=\"true\"\n                            compact=\"true\"></upload-slot>\n              </div>\n            </div>\n            <div class=\"col-sm-12\">\n              <p ng-hide=\"vm.uploadWebVTT\" class=\"help-block\" style=\"margin:15px 0\">\n                WebVTT caption files generated from other services and tools may be uploaded to BoxCast.\n                <a href=\"https://support.boxcast.com/en/articles/4235125\" target=\"_blank\">Learn More</a>\n              </p>\n              <div ng-show=\"vm.uploadWebVTT && vm.uploadWebVTT.errors.length\">\n                <h4>Error Processing WebVTT File</h4>\n                <ul class=\"text-left text-danger\">\n                  <li ng-repeat=\"e in vm.uploadWebVTT.errors\">{{e.message}} (line {{e.line}}, col {{e.col}})</li>\n                </ul>\n              </div>\n              <div ng-show=\"vm.uploadWebVTT && !vm.uploadWebVTT.errors.length\">\n                <h4>Review WebVTT Upload</h4>\n                <textarea class=\"form-control\" rows=\"15\" style=\"font-size:8pt;font-family:monospace\" readonly>{{vm.uploadWebVTTText}}</textarea>\n              </div>\n            </div>\n          </div>\n          <div style=\"margin-top:15px\" ng-if=\"vm.uploadWebVTT && vm.uploadWebVTT.cues.length && !vm.uploadWebVTT.errors.length\">\n            <button ng-click=\"vm.saveUploadedCaptions(vm.uploadWebVTT)\" type=\"button\" class=\"btn btn-lg btn-primary\">\n              Replace Captions with Upload\n            </button>\n          </div>\n        </div>\n      </div>\n\n    </div>\n\n  </div><!--/row-->\n\n</main>\n"

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CaptionEditorController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_caption__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__webvtt_parser__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_date__ = __webpack_require__(4);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }




var CAPTION_RELOAD_INTERVAL_MS = 10000;
var CAPTION_SILENCE_NOTIFY_GAP = 5.0;
var CAPTION_MIN_GAP_TO_INSERT = 1.0;

function scrollToElementInsideContainer(el, container) {
  if (container && el) {
    container.scrollTop = el.offsetTop; // TODO: try to align in center of viewport
  }
}

var CaptionEditorController = /*#__PURE__*/function () {
  function CaptionEditorController($state, $timeout, $scope, Broadcast, Caption, Recording, toaster) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, CaptionEditorController);

    this.$state = $state;
    this.$timeout = $timeout;
    this.Broadcast = Broadcast;
    this.Caption = Caption;
    this.toaster = toaster;
    this.CONFIDENCE_THRESHOLD = 0.4;
    this.id = $state.params.broadcastId;
    this.broadcast = Broadcast.get({
      id: this.id
    }, function (b) {
      return _this.recording = Recording.get({
        id: b.recording_id
      });
    }, function (e) {
      return toaster.pop('warning', 'Unable to load broadcast');
    });
    var promise = this.broadcast.$promise.then(function () {
      return _this.safeReloadCaptions();
    }).then(function () {
      return _this.onLoadComplete();
    })["catch"](function (e) {
      console.error(e);
    });
    this.caption = {};
    this.mode = 'full';

    this.filterByConfidenceMode = function (cue) {
      if (_this.mode == 'full') {
        return true;
      } else {
        return cue.originalConfidence < 0.4;
      }
    };

    this.loadingPromises = [promise];
    $scope.$on('$destroy', function () {
      $timeout.cancel(_this.captionReloadHandle);
    });
  }

  _createClass(CaptionEditorController, [{
    key: "progress",
    get: function get() {
      if (!this.captionMeta) return 0;
      var _this$captionMeta = this.captionMeta,
          status = _this$captionMeta.status,
          publish_status = _this$captionMeta.publish_status;
      if (status == 'failed') return 0;
      if (status == 'requested') return 10;
      if (status == 'processing_audio') return 20;
      if (status == 'transcribing') return 30;
      if (status == 'processing_transcription') return 80;
      if (status == 'completed' && publish_status == 'unpublished') return 90;
      if (status == 'completed' && publish_status == 'publishing') return 95;
      return 100;
    }
  }, {
    key: "canEdit",
    get: function get() {
      if (this.saving) return false;
      if (this.captionMeta.publish_status == 'publishing') return false;
      return true;
    }
  }, {
    key: "cuesDirty",
    get: function get() {
      return this._cuesDirty;
    },
    set: function set(val) {
      this.$state.current.confirmOnExit = val;
      this._cuesDirty = val;
    }
  }, {
    key: "recordingIsTrimmed",
    get: function get() {
      if (!this.recording) return false;
      var r = this.recording;
      return r.start_seconds != '' && r.start_seconds != 0 || r.stop_seconds != '' && r.stop_seconds != r.duration_seconds;
    }
  }, {
    key: "onLoadComplete",
    value: function onLoadComplete() {
      var _this2 = this;

      var $timeout = this.$timeout;
      this.activeCaptionIndex = null;

      var updateActiveCaption = function updateActiveCaption(currentTime) {
        for (var i = 0; i < _this2.captions.length; i++) {
          var c = _this2.captions[i];

          if (c.start_time <= currentTime && c.end_time >= currentTime) {
            _this2.activeCaptionIndex = i;
            return;
          }

          if (c.start_time > currentTime) {
            _this2.activeCaptionIndex = null;
            return;
          }
        }
      };

      var updateActiveCaptionDebounced = _.throttle(updateActiveCaption, 500);

      this.playerOptions = {
        alwaysShowMediaControl: true,
        onPlayerStateChanged: function onPlayerStateChanged(eventName, arg) {
          $timeout(function () {
            _this2.isPlayerPlaying = eventName == 'play';

            if (eventName == 'seek') {
              updateActiveCaption(arg);

              if (_this2.__avoidNextAutoSeek) {
                _this2.__avoidNextAutoSeek = false;
              } else {
                scrollToElementInsideContainer($("#caption--index-".concat(_this2.activeCaptionIndex))[0], $('.caption-table-scroll')[0]);
              }
            } else {
              updateActiveCaption(_this2.player.getCurrentTime());
            }
          }, 0);
        },
        onTimeUpdate: function onTimeUpdate(t) {
          $timeout(function () {
            return updateActiveCaptionDebounced(t);
          }, 0);
        },
        onLoadPlayer: function onLoadPlayer(player) {
          _this2.player = player; // Disable caption plugin since captions will always be displayed.

          _.each(_this2.player.core.plugins, function (p) {
            if (p.name === 'closed_captions') {
              p.disable();
            }
          });
        },
        trimSeconds: {
          start: 0,
          stop: 365 * 24 * 60 * 60
        }
      };
    }
  }, {
    key: "onEditCaption",
    value: function onEditCaption(c) {
      this.cuesDirty = true;
      c.confidence = 1.0;
    }
  }, {
    key: "startCaptioning",
    value: function startCaptioning() {
      var _this3 = this;

      var upload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var Caption = this.Caption,
          toaster = this.toaster;
      this.saving = true;
      var data = {
        source: 'on-demand'
      };

      if (upload != null) {
        data = {
          source: 'uploaded',
          status: 'complete',
          cues: upload.cues.map(function (c) {
            return {
              start_time: c.startTime,
              end_time: c.endTime,
              text: c.text,
              confidence: 1.0
            };
          })
        };
      }

      Caption.create({
        broadcast_id: this.id
      }, data).$promise.then(function () {
        _this3.saving = false;
        toaster.pop('success', 'Successfully started captioning.');

        _this3.safeReloadCaptions();
      })["catch"](function (err) {
        _this3.saving = false;
        toaster.pop('warning', 'Unable to start captioning. Please refresh and try again.');
        console.error(err);
      });
    }
  }, {
    key: "save",
    value: function save() {
      var _this4 = this;

      var Caption = this.Caption,
          toaster = this.toaster; // Process the UI representation of the cues

      var cuesToSave = angular.copy(this.captions).filter(function (c) {
        return c.type == 'cue';
      });
      var data = {
        publish_status: 'publishing',
        cues: cuesToSave
      };
      this.saving = true;
      Caption.update({
        broadcast_id: this.id,
        id: this.captionMeta.id
      }, data).$promise.then(function () {
        _this4.saving = false;
        toaster.pop('success', 'Saved captions');

        _this4.safeReloadCaptions();
      })["catch"](function (err) {
        _this4.saving = false;
        toaster.pop('warning', 'Unable to save captions, please check your entry and try again.');
        console.error(err);
      });
    }
  }, {
    key: "play",
    value: function play(caption) {
      this.__avoidNextAutoSeek = true;
      this.player.seek(caption.start_time);
      this.player.play();
    }
  }, {
    key: "processCaptionsAndInjectSilence",
    value: function processCaptionsAndInjectSilence(cues) {
      var newCaptions = [];
      var absoluteIndexCounter = 0;
      cues.forEach(function (c, i) {
        // check for previous gap
        if (i > 0) {
          var lastCaption = cues[i - 1];

          if (c.start_time - lastCaption.end_time > CAPTION_SILENCE_NOTIFY_GAP) {
            newCaptions.push({
              absoluteIndex: absoluteIndexCounter++,
              type: 'silence',
              start_time: lastCaption.end_time + 0.1,
              end_time: c.start_time - 0.1,
              start_time_fmt: Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["e" /* secondsToFormattedLabel */])(lastCaption.end_time + 0.1),
              end_time_fmt: Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["e" /* secondsToFormattedLabel */])(c.start_time - 0.1)
            });
          }
        }

        c.absoluteIndex = absoluteIndexCounter++;
        c.type = 'cue';
        c.start_time = rounded(c.start_time);
        c.end_time = rounded(c.end_time);
        c.originalConfidence = c.confidence;
        c.start_time_fmt = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["e" /* secondsToFormattedLabel */])(c.start_time);
        c.end_time_fmt = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["e" /* secondsToFormattedLabel */])(c.end_time);
        newCaptions.push(c);
      });
      var lastCaptionEndTime = newCaptions.length && newCaptions[newCaptions.length - 1].end_time || 0;

      if (lastCaptionEndTime + CAPTION_MIN_GAP_TO_INSERT < this.broadcast.recording_duration_seconds) {
        newCaptions.push({
          absoluteIndex: absoluteIndexCounter++,
          type: 'silence',
          isLast: true,
          start_time: lastCaptionEndTime + 0.1,
          end_time: this.broadcast.recording_duration_seconds,
          start_time_fmt: Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["e" /* secondsToFormattedLabel */])(lastCaptionEndTime + 0.1),
          end_time_fmt: Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["e" /* secondsToFormattedLabel */])(this.broadcast.recording_duration_seconds)
        });
      }

      this.captions = newCaptions;
    }
  }, {
    key: "safeReloadCaptions",
    value: function safeReloadCaptions() {
      var _this5 = this;

      var Caption = this.Caption,
          toaster = this.toaster,
          $timeout = this.$timeout;
      var captionQuery = Caption.query({
        broadcast_id: this.id
      }, function (results) {
        _this5.noCaptions = results.length == 0;
        _this5.captionMeta = _.find(results, function (r) {
          return r.recording_id == _this5.broadcast.recording_id;
        });

        _this5.processCaptionsAndInjectSilence((_this5.captionMeta || {}).cues || []);

        _this5.cuesDirty = false;
        var publishStatus = (_this5.captionMeta || {}).publish_status;

        if (publishStatus == 'publishing') {
          _this5.captionReloadHandle = $timeout(function () {
            return _this5.safeReloadCaptions();
          }, CAPTION_RELOAD_INTERVAL_MS);
        }
      }, function (err) {
        toaster.pop('warning', 'Unable to load captions.');
      });
      return captionQuery.$promise;
    }
  }, {
    key: "findAndReplace",
    value: function findAndReplace() {
      var find = prompt('Find Text:');
      if (!find) return;
      var regEx = new RegExp(find, 'ig');
      var matches = [];
      this.captions.forEach(function (c) {
        if (c.type != 'cue') return;
        if (c.text.match(regEx)) matches.push(c);
      });

      if (!matches.length) {
        alert('No matches found');
        return;
      }

      var replace = prompt("Found ".concat(matches.length, " matches. Replace With:"));
      if (!replace) return;
      matches.forEach(function (c) {
        c.text = c.text.replace(regEx, replace);
      });
      this.cuesDirty = true;
    }
  }, {
    key: "canInsertBeforeCue",
    value: function canInsertBeforeCue(index) {
      var c = this.captions[index];
      if (c.start_time == 0) return false;
      var prev = this.captions[index - 1] || {
        end_time: 0
      };

      if (prev.type == 'silence') {
        return true;
      } else {
        return c.start_time - prev.end_time > CAPTION_MIN_GAP_TO_INSERT;
      }
    }
  }, {
    key: "canInsertAfterCue",
    value: function canInsertAfterCue(index) {
      var c = this.captions[index];
      var next = this.captions[index + 1];

      if (!next || next.type == 'silence') {
        return true;
      } else {
        return next.start_time - c.end_time > CAPTION_MIN_GAP_TO_INSERT;
      }
    }
  }, {
    key: "insertCueBefore",
    value: function insertCueBefore(index) {
      var start_time = this.captions[index].start_time - CAPTION_SILENCE_NOTIFY_GAP;

      if (this.captions[index - 1] && this.captions[index - 1].type != 'silence') {
        if (this.captions[index - 1].end_time > start_time) {
          start_time = this.captions[index - 1].end_time + 0.1;
        }
      }

      this.captions.splice(index, 0, {
        text: 'Text...',
        start_time: Math.max(start_time, 0),
        end_time: this.captions[index].start_time - 0.1,
        confidence: 1.0,
        timestampEdit: true
      });
      this.processCaptionsAndInjectSilence(this.captions.filter(function (c) {
        return c.type != 'silence';
      }));
      this.cuesDirty = true;
    }
  }, {
    key: "insertCueAfter",
    value: function insertCueAfter(index) {
      var end_time = this.captions[index].end_time + CAPTION_SILENCE_NOTIFY_GAP;

      if (this.captions[index + 1] && this.captions[index + 1].type != 'silence') {
        if (end_time > this.captions[index + 1].start_time) {
          end_time = this.captions[index + 1].start_time - 0.1;
        }
      }

      this.captions.splice(index + 1, 0, {
        text: 'Text...',
        start_time: this.captions[index].end_time + 0.1,
        end_time: end_time,
        confidence: 1.0,
        timestampEdit: true
      });
      this.processCaptionsAndInjectSilence(this.captions.filter(function (c) {
        return c.type != 'silence';
      }));
      this.cuesDirty = true;
    }
  }, {
    key: "deleteCue",
    value: function deleteCue(index) {
      this.captions.splice(index, 1);
      this.processCaptionsAndInjectSilence(this.captions.filter(function (c) {
        return c.type != 'silence';
      }));
      this.cuesDirty = true;
    }
  }, {
    key: "onChangeTime",
    value: function onChangeTime(c) {
      c.start_time = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["c" /* formattedLabelToSeconds */])(c.start_time_fmt);
      c.end_time = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["c" /* formattedLabelToSeconds */])(c.end_time_fmt);
      this.processCaptionsAndInjectSilence(this.captions.filter(function (c) {
        return c.type != 'silence';
      }));
      this.cuesDirty = true;
    }
  }, {
    key: "uploadCaption",
    value: function uploadCaption(result) {
      var _this6 = this;

      var $timeout = this.$timeout;

      if (!result) {
        return;
      }

      var r = new FileReader();

      r.onload = function (e) {
        $timeout(function () {
          _this6.parseFile(e.target.result);
        }, 100);
      };

      r.oneror = function (e) {
        $timeout(function () {
          _this6.uploadWebVTT = {
            errors: [{
              message: 'Unable to read file.',
              line: 0,
              col: 0
            }]
          };
        }, 0);
      };

      r.readAsText(result.file);
    }
  }, {
    key: "parseFile",
    value: function parseFile(fileContents) {
      var _this7 = this;

      var $timeout = this.$timeout;
      this.parser = this.parser || new __WEBPACK_IMPORTED_MODULE_1__webvtt_parser__["a" /* default */]();
      $timeout(function () {
        // Replace plain & with &amp; (but leave &amp; as-is);
        fileContents = fileContents.replace(/&amp;/g, '&').replace(/&/g, '&amp;');
        _this7.uploadWebVTT = _this7.parser.parse(fileContents);
        _this7.uploadWebVTTText = _this7.uploadWebVTT.cues.map(function (c) {
          return "".concat(Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["e" /* secondsToFormattedLabel */])(c.startTime), " - ").concat(c.text);
        }).join('\n');
      }, 0);
    }
  }, {
    key: "saveUploadedCaptions",
    value: function saveUploadedCaptions(upload) {
      var _this8 = this;

      var Caption = this.Caption,
          toaster = this.toaster;
      var data = {
        status: 'complete',
        publish_status: 'publishing',
        cues: upload.cues.map(function (c) {
          return {
            start_time: c.startTime,
            end_time: c.endTime,
            text: c.text,
            confidence: 1.0
          };
        })
      };
      this.saving = true;
      Caption.update({
        broadcast_id: this.id,
        id: this.captionMeta.id
      }, data).$promise.then(function () {
        _this8.saving = false;
        _this8.captionFile = null;
        _this8.uploadWebVTT = null;
        _this8.uploadWebVTTText = null;
        _this8.showReplaceCaptions = null;
        toaster.pop('success', 'Saved captions');

        _this8.safeReloadCaptions();
      })["catch"](function (err) {
        _this8.saving = false;
        toaster.pop('warning', 'Unable to save captions, please check your entry and try again.');
        console.error(err);
      });
    }
  }]);

  return CaptionEditorController;
}();



function rounded(floatOrString) {
  var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  // round to at most 4 decimals, and ensure strings are cast to floats
  var f = parseFloat(floatOrString, 10);
  var str = f.toFixed(places).replace(/0+$/, '');
  return parseFloat(str, 10);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__date__ = __webpack_require__(4);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var CaptionUtils = /*#__PURE__*/function () {
  function CaptionUtils() {
    _classCallCheck(this, CaptionUtils);
  }

  _createClass(CaptionUtils, null, [{
    key: "findCaptionAt",
    value: // Return the caption that is contains the given timestamp (or null)
    function findCaptionAt(timestamp, captions) {
      return _.find(CaptionUtils.mapCaptionsWithStartAndEndTimestamps(captions), function (c) {
        return c.start <= timestamp && c.end >= timestamp;
      });
    } // Find the end of the last captioned segment prior to the provided timestamp

  }, {
    key: "findLastEndPointPriorTo",
    value: function findLastEndPointPriorTo(timestamp, captions) {
      captions = _.sortBy(CaptionUtils.mapCaptionsWithStartAndEndTimestamps(captions), 'end');

      var i = _.findLastIndex(captions, function (c) {
        return timestamp > c.end;
      });

      return i > 0 ? captions[i] : null;
    } // Glue start and end timestamps on the list of captions

  }, {
    key: "mapCaptionsWithStartAndEndTimestamps",
    value: function mapCaptionsWithStartAndEndTimestamps(captions) {
      return _.map(_.sortByAll(captions, ['playback_start_time_fmt', 'id']), function (c) {
        return _.extend({}, c, {
          start: Object(__WEBPACK_IMPORTED_MODULE_0__date__["c" /* formattedLabelToSeconds */])(c.playback_start_time_fmt),
          end: Object(__WEBPACK_IMPORTED_MODULE_0__date__["c" /* formattedLabelToSeconds */])(c.playback_stop_time_fmt)
        });
      });
    } // Look for any overlapping captions in the list

  }, {
    key: "findOverlapping",
    value: function findOverlapping(captions) {
      captions = CaptionUtils.mapCaptionsWithStartAndEndTimestamps(captions);
      var results = [];

      for (var i = 0, l = captions.length; i < l; i++) {
        var caption = captions[i];
        var overlaps = [];

        for (var j = 0; j < l; j++) {
          var caption2 = captions[j];

          if (i != j && (caption2.start < caption.end && caption2.end > caption.start || caption2.end < caption.start && caption2.start > caption.end)) {
            overlaps.push(caption2);
          }
        }

        if (overlaps.length) {
          results.push(_.extend({}, caption, {
            overlaps: overlaps
          }));
        }
      }

      return results;
    }
  }]);

  return CaptionUtils;
}();



/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__webvtt_parser__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_date__ = __webpack_require__(4);


var MAX_CAPTION_TRANSCRIBE_TIME_SEC = 2 * 60 * 60; //2 hrs

var module = angular.module('caption-editor');
module.directive('captionTranscribeProgress', function () {
  return {
    restrict: 'E',
    scope: {
      broadcast: '=',
      captionMeta: '='
    },
    template: "\n    <div class=\"well\" style=\"margin:30px 0\">\n      <uib-progressbar value=\"vm.progress()\" max=\"100\" style=\"margin:15px 0\">\n        {{vm.progress()}}% Processed\n      </uib-progressbar>\n      <table style=\"width:100%;font-size:8pt;\">\n        <tr>\n          <td width=\"5%\">Starting</td>\n          <td width=\"25%\">Processing Audio</td>\n          <td width=\"40%\">Transcribing</td>\n          <td width=\"20%\">Processing Transcription</td>\n          <td width=\"10%\">Complete</td>\n        </tr>\n      </table>\n    </div>\n    ",
    controllerAs: 'vm',
    controller: function controller($scope) {
      'ngInject';

      this.progress = function () {
        if (!$scope.captionMeta) return 0;
        var _$scope$captionMeta = $scope.captionMeta,
            status = _$scope$captionMeta.status,
            updated_at = _$scope$captionMeta.updated_at;
        if (status == 'failed') return 0;
        if (status == 'requested') return 5;
        if (status == 'requesting_audio') return 10;

        if (status == 'processing_audio') {
          // estimate percent of way through the extraction based on start date
          var totalDuration = $scope.broadcast.recording_duration_seconds || 60 * 30;
          var processingTime = moment().diff(updated_at, 'seconds') || 0;
          return 10 + Math.round(20 * Math.min(1, processingTime / totalDuration));
        }

        if (status == 'transcribing') {
          // estimate percent of way through the transcribe process based on start date
          var totalDuration = $scope.broadcast.recording_duration_seconds || 60 * 30;
          var processingTime = Math.min(moment().diff(updated_at, 'seconds') || 0, MAX_CAPTION_TRANSCRIBE_TIME_SEC);
          return 30 + Math.round(50 * Math.min(1, processingTime / totalDuration));
        }

        if (status == 'processing_transcription') return 90;
        if (status == 'completed') return 100;
        return 100;
      };
    }
  };
});
var PARTIAL_TEMPLATE_WEBVTT_UPLOAD = "\n  <div class=\"row\">\n    <div class=\"col-sm-6\">\n      <div class=\"caption-upload-cell\" style=\"margin:15px auto 0; max-width:300px\">\n        <upload-slot ng-model=\"vm.captionFile\"\n                    ng-change=\"vm.uploadCaption(vm.captionFile)\"\n                    slot-name=\"'caption'\"\n                    allow-image=\"false\"\n                    allow-video=\"false\"\n                    hide-stock-browse=\"true\"\n                    hide-recent-browse=\"true\"\n                    compact=\"true\"></upload-slot>\n      </div>\n    </div>\n    <div class=\"col-sm-6\">\n      <p ng-hide=\"vm.uploadWebVTT\" class=\"help-block\" style=\"margin:45px 15px 0\">\n        WebVTT caption files generated from other services and tools may be uploaded to BoxCast.\n        <a href=\"https://support.boxcast.com/en/articles/4235125\" target=\"_blank\">Learn More</a>\n      </p>\n      <div ng-show=\"vm.uploadWebVTT && vm.uploadWebVTT.errors.length\">\n        <h4>Error Processing WebVTT File</h4>\n        <ul class=\"text-left text-danger\">\n          <li ng-repeat=\"e in vm.uploadWebVTT.errors\">{{e.message}} (line {{e.line}}, col {{e.col}})</li>\n        </ul>\n      </div>\n      <div ng-show=\"vm.uploadWebVTT && !vm.uploadWebVTT.errors.length\">\n        <h4>Review WebVTT Upload</h4>\n        <textarea class=\"form-control\" rows=\"15\" style=\"font-size:8pt;font-family:monospace\" readonly>{{vm.uploadWebVTTText}}</textarea>\n      </div>\n    </div>\n  </div>\n\n  <div style=\"margin-top:15px\" ng-if=\"vm.uploadWebVTT && vm.uploadWebVTT.cues.length && !vm.uploadWebVTT.errors.length\">\n    <button ng-click=\"onCreate({upload: vm.uploadWebVTT})\" type=\"button\" class=\"btn btn-lg btn-primary\">\n      Saved Uploaded Caption File\n    </button>\n  </div>\n";
module.directive('captionDetails', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      broadcast: '=',
      captionMeta: '=',
      linkToEditor: '=',
      onCreate: '&',
      onDownload: '&'
    },
    template: "\n    <div>\n\n      <div ng-if=\"!captionMeta\" style=\"max-width:800px; margin:0 auto;\">\n        <div ng-if=\"::($root.account.feature_flags.automated_captioning || $root.account.feature_flags.live_automated_captioning)\">\n          <h4><strong>Add Captions Automatically</strong></h4>\n          <p class=\"help-block text-center\" style=\"margin:15px 0\">\n            Click \"Generate Captions\" to start the automatic transcription and captioning of your broadcast.\n            This process will usually take around 1 hour. You will then be able to edit the captions before publishing.\n          </p>\n          <button ng-click=\"onCreate()\" type=\"button\" class=\"btn btn-lg btn-primary\">\n            Generate Captions\n          </button>\n        </div>\n\n        <div ng-if=\"::(!$root.account.feature_flags.automated_captioning && !$root.account.feature_flags.live_automated_captioning)\">\n          <div class=\"row\">\n            <div class=\"col-sm-6\">\n              <img class=\"img\" src=\"/img/sample-automated-captions.png\" style=\"max-width:100%\">\n            </div>\n            <div class=\"col-sm-6 text-left\">\n              <h4><strong>Add Captions Automatically</strong></h4>\n              <p class=\"help-block\" style=\"margin:15px 0\">\n                A 1 hour broadcast can take up to 3 hours to manually caption. Save yourself the time and\n                automatically caption your recorded broadcasts with the touch of a button.\n                <a href=\"https://support.boxcast.com/en/articles/4235130\" target=\"_blank\">Learn More</a>\n              </p>\n              <upgrade-button></upgrade-button>\n            </div>\n          </div>\n        </div>\n\n        <hr style=\"width:50%;margin:30px auto\">\n        <h4 class=\"text-center\"><strong>Add Captions Manually</strong></h4>\n        <div>".concat(PARTIAL_TEMPLATE_WEBVTT_UPLOAD, "</div>\n      </div>\n\n      <div ng-if=\"captionMeta.status == 'failed'\" style=\"max-width:800px; margin:0 auto;\">\n        <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:30px;\">\n          The captioning process failed. Reason: {{captionMeta.failure_reason}}.\n        </div>\n        <button ng-click=\"onCreate()\" type=\"button\" class=\"btn btn-lg btn-primary\">\n          Try Captioning Again\n        </button>\n      </div>\n\n      <div ng-if=\"captionMeta && (captionMeta.status != 'completed')\" style=\"max-width:800px; margin:0 auto;\">\n        <h4 class=\"text-center\"><strong>Generating Captions...</strong></h4>\n        <p class=\"help-block text-center\" style=\"margin:15px 0\">\n          This process will usually take around 1 hour. You will then be able to edit the captions\n          before publishing. Feel free to leave the page and come back later.\n        </p>\n        <caption-transcribe-progress broadcast=\"broadcast\" caption-meta=\"captionMeta\"></caption-transcribe-progress>\n      </div>\n\n      <div ng-if=\"captionMeta && captionMeta.publish_status == 'publishing'\" style=\"max-width:800px; margin:0 auto;\">\n        <div class=\"bg-info text-info\" style=\"padding:10px; border:1px solid;margin-bottom:15px;\">\n          <i class=\"fa fa-spin fa-spinner\"></i>\n          The captions are being published and will be available for viewers within a few minutes.\n        </div>\n      </div>\n\n      <div ng-if=\"linkToEditor && captionMeta && captionMeta.status == 'completed'\">\n        <div ng-if=\"captionMeta.publish_status == 'unpublished'\">\n          <h4 class=\"text-center\"><strong>Captions Generated &amp; Ready For Review</strong></h4>\n          <p class=\"help-block text-center\" style=\"margin:15px 0\">\n            Review &amp; Publish your captions to make them available to viewers.\n            <br>\n            <small>(Hint: Click the settings icon &amp; \"Review Low-Confidence Cues\" to edit quickly)</small>\n          </p>\n          <a ui-sref=\"caption-editor({broadcastId: broadcast.id})\" class=\"btn btn-lg btn-primary\">\n            Review and Edit\n          </a>\n        </div>\n        <div ng-if=\"captionMeta.publish_status != 'unpublished'\" class=\"row\">\n          <div class=\"col-xs-6 text-left\">\n            <a ui-sref=\"caption-editor({broadcastId: broadcast.id})\" class=\"btn btn-sm btn-default\">\n              <i class=\"fa fa-edit\"></i>\n              Edit Captions\n            </a>\n            <div class=\"btn-group\" uib-dropdown>\n              <button tabindex=\"-1\" type=\"button\" class=\"btn btn-default btn-sm\" uib-dropdown-toggle>\n                Download Captions\n                <i class=\"fa fa-caret-down\" style=\"margin-left: 5px;\"></i>\n              </button>\n              <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\n                <li role=\"menuitem\"><a href=\"javascript://\" ng-click=\"onDownload({format: 'webvtt'})\">WebVTT File (.vtt)</a></li>\n                <li role=\"menuitem\"><a href=\"javascript://\" ng-click=\"onDownload({format: 'text'})\">Text File (.txt)</a></li>\n              </ul>\n            </div>\n          </div>\n          <div class=\"col-xs-6\">\n            <table class=\"text-left\" align=\"right\">\n              <tr><th class=\"font-bold text-bx-accessible-grey\">Status:</th><td>&nbsp;</td><td>{{captionMeta.publish_status|unslugify}}</td></tr>\n              <tr><th class=\"font-bold text-bx-accessible-grey\">Updated:</th><td>&nbsp;</td><td>{{captionMeta.updated_at|date:'medium'}}</td></tr>\n            </table>\n          </div>\n        </div>\n      </div>\n\n    </div>\n    "),
    controller: function controller($scope, $timeout) {
      'ngInject';

      var _this = this;

      var parser = new __WEBPACK_IMPORTED_MODULE_0__webvtt_parser__["a" /* default */]();

      this.uploadCaption = function (result) {
        if (!result) {
          return;
        }

        var r = new FileReader();

        r.onload = function (e) {
          $timeout(function () {
            _this.parseFile(e.target.result);
          }, 100);
        };

        r.oneror = function (e) {
          $timeout(function () {
            _this.uploadWebVTT = {
              errors: [{
                message: 'Unable to read file.',
                line: 0,
                col: 0
              }]
            };
          }, 0);
        };

        r.readAsText(result.file);
      };

      this.parseFile = function (fileContents) {
        $timeout(function () {
          // Replace plain & with &amp; (but leave &amp; as-is);
          fileContents = fileContents.replace(/&amp;/g, '&').replace(/&/g, '&amp;');
          _this.uploadWebVTT = parser.parse(fileContents);
          _this.uploadWebVTTText = _this.uploadWebVTT.cues.map(function (c) {
            return "".concat(Object(__WEBPACK_IMPORTED_MODULE_1__utils_date__["e" /* secondsToFormattedLabel */])(c.startTime), " - ").concat(c.text);
          }).join('\n');
        }, 0);
      };
    },
    controllerAs: 'vm'
  };
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contributors_html__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contributors_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__contributors_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contributors_js__ = __webpack_require__(385);
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var ContributorsController = /*#__PURE__*/_createClass(function ContributorsController() {
  'ngInject';

  _classCallCheck(this, ContributorsController);

  this.contributors = __WEBPACK_IMPORTED_MODULE_2__contributors_js__["a" /* default */];
});

var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('contributors', __WEBPACK_IMPORTED_MODULE_1__contributors_html___default.a, ContributorsController, 'ContributorsController');
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports = "<main class=\"container-fluid\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\"> \n        <div class=\"well\">\n          <div class=\"row\">\n            <div class=\"col-xs-6 col-md-3\" ng-repeat=\"contributor in vm.contributors\">\n              <div class=\"thumbnail\">\n                <img class=\"img-circle\" ng-src=\"{{contributor.profile_img}}\" ng-alt=\"{{contributor.name}} headshot\">\n                <div class=\"caption\">\n                  <h3 class=\"h4\">{{contributor.name}}</h3>\n                  <p>{{contributor.title}}</p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </main>\n"

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var contributors = [{
  name: 'Jeremy Hutchcraft',
  title: 'Front End Developer',
  profile_img: 'https://i.imgur.com/g7gswnL.jpg'
}, {
  name: 'Greg DiPietro',
  title: 'Front End Developer',
  profile_img: 'https://pbs.twimg.com/profile_images/674262058226069505/43jnHbB2_400x400.jpg'
}, {
  name: 'Mike Griffith',
  title: 'Software Engineer',
  profile_img: 'https://avatars.githubusercontent.com/u/167782?v=4'
}];
/* harmony default export */ __webpack_exports__["a"] = (contributors);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(8);

var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('embed', "", function () {
  // Migrated to dashboard_vue
  window.location.href = "".concat(window.VUE_DASHBOARD_ROOT, "/embed");
}, 'EmbedController');

__webpack_require__(387);

/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_embed__ = __webpack_require__(31);

var module = angular.module('embed');
module.component('embedBroadcasts', {
  bindings: {
    account: '=',
    sourcesCombined: '=',
    channels: '=',
    output: '=',
    // Fix data flow
    singleEvent: '=?'
  },
  template: __webpack_require__(389),
  controllerAs: 'vm',
  controller: EmbedDirectiveController
});
module.component('embedHighlights', {
  bindings: {
    account: '=',
    sourcesCombined: '=',
    channels: '=',
    output: '=',
    // Fix data flow
    singleEvent: '=?'
  },
  template: __webpack_require__(390),
  controllerAs: 'vm',
  controller: EmbedDirectiveController
});
module.component('embedOther', {
  bindings: {
    account: '=',
    sourcesCombined: '=',
    channels: '=',
    output: '=',
    // Fix data flow
    singleEvent: '=?'
  },
  template: __webpack_require__(391),
  controllerAs: 'vm',
  controller: EmbedDirectiveController
});
module.component('embedSelectBroadcasts', {
  bindings: {
    parentVM: '=parentVm',
    mode: '@',
    hideAll: '=',
    hideChannels: '=',
    hideSources: '=',
    hideSingleBroadcast: '=',
    broadcastValidator: '='
  },
  controllerAs: 'vm',
  controller: function controller() {
    var _this = this;

    this.$onInit = function () {
      if (_this.mode == 'highlights') {
        _this.label = 'Highlights';
      } else {
        _this.label = 'Broadcasts';
      }
    }; // Fake the EditOrCreateEventService for purposes on the <recording-source-chooser />


    this.service = {
      sourceBroadcast: null,
      sourceBroadcastUnavailable: null,
      broadcast: {},
      updateSourceBroadcast: function updateSourceBroadcast(b) {
        return _this.service.sourceBroadcast = b;
      }
    };
  },
  template: __webpack_require__(392)
});
module.component('embedCopyPaste', {
  bindings: {
    parentVM: '=parentVm',
    type: '@'
  },
  controllerAs: 'vm',
  template: __webpack_require__(393)
});
module.component('embedAdvancedSettings', {
  bindings: {
    parentVM: '=parentVm'
  },
  controllerAs: 'vm',
  template: __webpack_require__(394)
});

function EmbedDirectiveController($uibModal, $scope, $rootScope, Account, BoxCaster, StaticRTMP, Broadcast, Channel, clipboard) {
  'ngInject';

  var _this2 = this;

  this.FeatureFlags = $rootScope.account.feature_flags;
  this.showHighlights = !!this.FeatureFlags.highlights;
  this.m3u8Enabled = !$rootScope.account.extra_features.static_m3u8_disabled && $rootScope.user.can('embed', 'broadcast/*:m3u8');
  this.BoxCaster = BoxCaster;
  this.StaticRTMP = StaticRTMP;
  this.Broadcast = Broadcast;
  this.Channel = Channel;

  this.$onInit = function () {
    _this2.changeLayout(_this2.output.layout);
  }; // Set embed defaults based on account content settings


  var a = $rootScope.account;
  var cs = a.content_settings;
  if (cs.showDonations) this.output.args.showDonations = true;
  if (cs.showCountdown) this.output.args.showCountdown = true;

  if (cs.poster) {
    this.showPoster = true;
    this.output.args.poster = cs.poster;
  }

  if (cs.customPreroll) {
    this.showPreroll = true;
    this.output.args.customPreroll = cs.customPreroll;
  }

  this.showAutoplayOptions = !!this.output.args.autoplay;
  $scope.clipboard = clipboard; //isolate scope here to didn't inherit this from $rootScope

  $scope.$watch(function () {
    return _this2.output.args.market;
  }, function (market) {
    return _this2.showVersionOverride = market == 'internal';
  });
  this.showPreroll = false;
  this.showPoster = false;

  this.showPodcastOption = function (which) {
    if (!_this2.FeatureFlags.podcast) return false;
    if (_this2.output.type != 'channel') return false;
    if (!_this2.output.channel) return false;
    if (_this2.output.channel.id !== _this2.output.channelId) return false;
    return true;
  };

  this.allowPodcastForChannel = function (which) {
    if (!_this2.showPodcastOption(which)) return false;
    var ccs = _this2.output.channel.content_settings || {};
    if (!ccs.podcast) return false;
    if (!which) return true;
    return ccs.podcast[which];
  };

  var ngResources = {};

  this.clearPrerollIfNecessary = function () {
    if (!_this2.showPreroll) delete _this2.output.args.customPreroll;
  };

  this.clearPosterIfNecessary = function () {
    if (!_this2.showPoster) delete _this2.output.args.poster;
  };

  this.clearPlayerVersionIfNecessary = function () {
    if (!_this2.showPlayerVersion) delete _this2.output.args.version;
  };

  var checkAndUnselectPodcast = function checkAndUnselectPodcast() {
    if ((_this2.output.embedType === 'audio-podcast' || _this2.output.embedType === 'video-podcast') && !_this2.allowPodcastForChannel()) {
      // User had 'Podcast' selected, but that is no longer valid.
      _this2.output.embedType = 'javascript';
    }
  };

  this.selectAllBroadcasts = function () {
    _this2.output.channelId = _this2.account.channel_id;
    _this2.output.all_m3u8 = _this2.account.static_playlist_url;
    checkAndUnselectPodcast();
  };

  this.selectCustomChannel = function (channel) {
    _this2.output.type = 'channel';
    _this2.output.channel = channel;
    if (!channel) return;
    _this2.output.channelId = channel.id;

    if (_this2.m3u8Enabled || _this2.FeatureFlags.podcast) {
      _this2.output.channel_m3u8 = '';
      ngResources.channel = _this2.Channel.get({
        id: _this2.output.channelId
      }, function (c) {
        if (channel.id != c.id) return; //race condition

        _this2.output.channel = c;
        _this2.output.channel_m3u8 = c.static_playlist_url;
        checkAndUnselectPodcast();
      });
    } else {
      checkAndUnselectPodcast();
    }
  };

  this.selectOneSource = function (source) {
    _this2.output.type = 'source';
    _this2.output.source = source;
    if (!source) return;
    _this2.output.sourceId = source.id;
    _this2.output.channelId = source.channel_id;

    if (_this2.m3u8Enabled) {
      _this2.output.source_m3u8 = '';

      if (source.type == 'boxcaster') {
        ngResources.boxcaster = _this2.BoxCaster.get({
          id: _this2.output.sourceId
        }, function (b) {
          if (source.id != b.id) return; //race condition

          _this2.output.source_m3u8 = b.static_playlist_url;
        });
      } else if (source.type == 'static_rtmp') {
        ngResources.staticRTMP = _this2.StaticRTMP.get({
          id: _this2.output.sourceId
        }, function (s) {
          if (source.id != s.id) return; //race condition

          _this2.output.source_m3u8 = s.static_playlist_url;
        });
      }
    }

    checkAndUnselectPodcast();
  };

  this.selectSingleBroadcast = function (broadcast) {
    //console.log('selecting single broadcast', broadcast.id);
    _this2.output.broadcast = broadcast;

    if (!broadcast) {
      _this2.output.broadcastId = '';
      _this2.output.channelId = '';
      _this2.output.single_m3u8 = '';
      checkAndUnselectPodcast();
      return;
    }

    _this2.output.broadcastId = broadcast.id;
    _this2.output.channelId = broadcast.channel_id;

    if (_this2.m3u8Enabled) {
      _this2.output.single_m3u8 = '';
      ngResources.broadcast = _this2.Broadcast.get({
        id: _this2.output.broadcastId
      }, function (b) {
        if (broadcast.id != b.id) return; //race condition

        _this2.output.single_m3u8 = b.static_playlist_url;
      });
    }

    checkAndUnselectPodcast();
  };

  this.validateBroadastSelection = function (b) {
    // block ticketed broadcasts from static m3u8
    if (_this2.output.integrationType == 'm3u8') {
      if (b.is_ticketed) {
        throw new Error('This broadcast is ticketed, which is not supported by static M3U8.');
      }
    }
  };

  this.changeAutoplayOptions = function () {
    if (_this2.output.args.autoplay === 'try-muted') {
      _this2._savePlayInline = _this2.output.args.playInline;
      _this2.output.args.playInline = true;
      _this2.disablePlayInline = true;
    } else {
      _this2.output.args.playInline = _this2._savePlayInline;
      delete _this2._savePlayInline;
      delete _this2.disablePlayInline;
    }
  };

  this.showHideAutoplayOptions = function () {
    if (_this2.showAutoplayOptions) {
      _this2._lastAutoplay = _this2.output.args.autoplay;
      delete _this2.output.args.autoplay;
      _this2.showAutoplayOptions = false;
    } else {
      if (_this2._lastAutoplay) {
        _this2.output.args.autoplay = _this2._lastAutoplay;
        delete _this2._lastAutoplay;
      } else {
        _this2.output.args.autoplay = 'true';
      }

      _this2.showAutoplayOptions = true;
    }

    _this2.changeAutoplayOptions();
  };

  this.loading = function () {
    function check(ngResourceObj) {
      return ngResourceObj && ngResourceObj.$promise && !ngResourceObj.$resolved;
    }

    return check(ngResources.boxcaster) || check(ngResources.broadcast) || check(ngResources.channel);
  };

  this.formatSourceOpt = function (b) {
    if (b.type == 'boxcaster') {
      return "".concat(b.name, " (").concat(b.status, ")");
    } else {
      return "RTMP: ".concat(b.name);
    }
  };

  this.formatBroadcastOpt = function (b) {
    var starts_at = moment(b.starts_at).format('lll');
    return "".concat(b.name, " (").concat(starts_at, ")");
  };

  this.showPreview = function (type) {
    // NOTE: v3 needs special argument to be previewable on dashboard without
    // intpreting our window.location.hash as part of a redirect
    var args = angular.copy(_this2.output.args);
    args.disableRedirectRulesOnLoad = true;
    var script;

    if (type == 'highlights') {
      script = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Highlights(_this2.output.channelId, args);
    } else {
      script = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3WidgetEmbed(_this2.output.channelId, args);
    }

    $uibModal.open({
      size: 'lg',
      template: __webpack_require__(395),
      controller: function controller($scope, $uibModalInstance, $timeout) {
        'ngInject';

        $scope.cancel = function () {
          return $uibModalInstance.dismiss('cancel');
        };

        $timeout(function () {
          return iframeify(script);
        });
      }
    });
  };

  this.uploadPoster = function (file) {
    file.upload().then(function (response) {
      _this2.output.args.poster = response.view_url;
    });
  };

  this.uploadCustomPreroll = function (file) {
    file.upload().then(function (response) {
      _this2.output.args.customPreroll = response.view_url;
    });
  };

  this.showSDKs = function () {
    _this2.output.integrationType = 'sdk';
  };

  this.changeLayout = function (layout) {
    // toggle appropriate advanced settings
    if (layout == 'player-only') {
      _this2.output.args.showTitleAndDescription = false;
      _this2.output.args.showDocuments = false;
      _this2.output.args.showIndex = false;
      _this2.output.args.showRelated = false;
      _this2.output.args.showHighlights = false;
      _this2.output.args.playlistOnRight = false;
      _this2.output.args.showDonations = false; // always hide donations because it would cause title to appear

      delete _this2.output.args.showChat;
    } else if (layout == 'player-and-title') {
      _this2.output.args.showTitleAndDescription = true;
      _this2.output.args.showDocuments = false;
      _this2.output.args.showIndex = false;
      _this2.output.args.showRelated = false;
      _this2.output.args.showHighlights = false;
      _this2.output.args.playlistOnRight = false;
      _this2.output.args.showDonations = !!cs.showDonations; // default to account content settings

      delete _this2.output.args.showChat;
    } else if (layout == 'player-with-playlist') {
      _this2.output.args.showTitleAndDescription = true;
      _this2.output.args.showDocuments = true;
      _this2.output.args.showIndex = true;
      _this2.output.args.showRelated = true;
      _this2.output.args.showHighlights = true;
      _this2.output.args.playlistOnRight = true;
      _this2.output.args.showDonations = !!cs.showDonations; // default to account content settings

      if (_this2.FeatureFlags.viewer_chat) {
        _this2.output.args.showChat = true;
      }
    }
  };

  this.checkFilterForIntegration = function (integrationType) {
    if (integrationType == 'feeds') {
      // single broadcast filter is not supported
      if (_this2.output.type == 'single') {
        _this2.output.type = 'all';
      }
    } else if (integrationType == 'podcast') {
      // the only valid option is a channel filter
      if (_this2.output.type != 'channel') {
        _this2.selectCustomChannel(_this2.channels[0]);
      }
    } else if (integrationType == 'm3u8') {// all filter options are supported
    } else if (integrationType == 'app') {// all filter options are supported
    }
  };

  this.outputCode = function (type) {
    if (type == 'broadcasts') {
      if (_this2.output.embedType == 'javascript') {
        return _this2.output.embedCode3;
      } else if (_this2.output.embedType == 'iframe') {
        return _this2.output.iframeCode3;
      } else if (_this2.output.embedType == 'link') {
        return _this2.output.linkCode3;
      }
    } else if (type == 'highlights') {
      return _this2.output.highlightsCode3;
    } else if (type == 'other') {
      if (_this2.output.integrationType == 'app') {
        return _this2.output.appCode3;
      } else if (_this2.output.integrationType == 'm3u8') {
        return _this2.output.m3u8;
      } else if (_this2.output.integrationType == 'feeds' && _this2.output.mediaType == 'rss') {
        return _this2.output.rss3;
      } else if (_this2.output.integrationType == 'feeds' && _this2.output.mediaType == 'audio-mrss') {
        return _this2.output.audioMRSS3;
      } else if (_this2.output.integrationType == 'feeds' && _this2.output.mediaType == 'video-mrss') {
        return _this2.output.videoMRSS3;
      } else if (_this2.output.integrationType == 'feeds' && _this2.output.mediaType == 'roku-direct-publisher') {
        return _this2.output.rokuDirectPublisher;
      } else if (_this2.output.integrationType == 'podcast' && _this2.output.mediaType == 'audio-podcast') {
        return _this2.output.audioPodcast3;
      } else if (_this2.output.integrationType == 'podcast' && _this2.output.mediaType == 'video-podcast') {
        return _this2.output.videoPodcast3;
      }
    }
  };

  this.copyLabel = function (type) {
    if (type == 'broadcasts') {
      if (_this2.output.embedType == 'link') {
        return 'Copy this Link to Share';
      } else {
        return 'Copy & Paste into your Website';
      }
    } else if (type == 'highlights') {
      return 'Copy & Paste into your Website';
    } else if (type == 'other') {
      if (_this2.output.integrationType == 'app') {
        return 'Copy this Web View URL';
      } else if (_this2.output.integrationType == 'm3u8') {
        return 'Copy this M3U8 URL';
      } else if (_this2.output.integrationType == 'podcast') {
        return 'Copy this Feed URL';
      } else if (_this2.output.integrationType == 'feeds') {
        return 'Copy this Feed URL';
      }
    }
  };

  this.showPreviewEmbed = function (type) {
    if (type == 'broadcasts' || type == 'highlights') {
      if (_this2.output.embedType == 'link') {
        return false;
      }

      return true;
    }

    return false;
  };
}

function iframeify(script) {
  var iframe = document.createElement('iframe');
  iframe.style.border = 'none';
  iframe.style.width = '100%';
  iframe.src = '/404-just-so-i-have-right-protocol-on-window';
  $('#modal-preview-script').html(iframe);
  setTimeout(function () {
    var doc;

    if (iframe.contentDocument) {
      // FF Chrome
      doc = iframe.contentDocument;
    } else if (iframe.contentWindow) {
      // IE
      doc = iframe.contentWindow.document;
    }

    doc.open(); //'text/htmlreplace');

    doc.write('<link rel="stylesheet" href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css" integrity="sha384-1q8mTJOASx8j1Au+a5WDVnPi2lkFfwwEAa8hDDdjZlpLegxhjVME1fgjWPGmkzs7" crossorigin="anonymous">');
    doc.write(script);
    doc.write('<script src="//js.boxcast.com/libs/iframeResizer-3.5.2.contentWindow.min.js"></script>');
    doc.close();
    setTimeout(function () {
      return $(iframe).iFrameResize();
    }, 0);
  }, 0);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/* jshint ignore:start */
var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

var Base64 = /*#__PURE__*/function () {
  function Base64() {
    _classCallCheck(this, Base64);
  }

  _createClass(Base64, [{
    key: "encode",
    value: function encode(input) {
      var output = '';
      var chr1,
          chr2,
          chr3 = '';
      var enc1,
          enc2,
          enc3,
          enc4 = '';
      var i = 0;

      do {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }

        output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < input.length);

      return output;
    }
  }, {
    key: "decode",
    value: function decode(input) {
      var output = '';
      var chr1,
          chr2,
          chr3 = '';
      var enc1,
          enc2,
          enc3,
          enc4 = '';
      var i = 0; // remove all characters that are not A-Z, a-z, 0-9, +, /, or =

      var base64test = /[^A-Za-z0-9\+\/\=]/g;

      if (base64test.exec(input)) {
        window.alert('There were invalid base64 characters in the input text.\n' + "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" + 'Expect errors in decoding.');
      }

      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

      do {
        enc1 = keyStr.indexOf(input.charAt(i++));
        enc2 = keyStr.indexOf(input.charAt(i++));
        enc3 = keyStr.indexOf(input.charAt(i++));
        enc4 = keyStr.indexOf(input.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        output = output + String.fromCharCode(chr1);

        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }

        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }

        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < input.length);

      return output;
    }
  }]);

  return Base64;
}();

var base64 = new Base64();
/* harmony default export */ __webpack_exports__["a"] = (base64);
/* jshint ignore:end */

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"vm.mediaTokenRestrictions\">\n  <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px\">\n    Your account has a custom authentication mechanism enabled.  Please note that the standard embed code\n    is unlikely to function properly as a result, and you should instead rely on the custom API integration.\n  </div>\n</div>\n\n<div ng-if=\"!vm.singleEvent\">\n  <div class=\"form-group\">\n    <label>Filter</label>\n    <embed-select-broadcasts parent-vm=\"vm\"></embed-select-broadcasts>\n  </div>\n</div>\n\n<div class=\"form-group\">\n  <label>\n    Integration Method\n    <i class=\"fa fa-question-circle\" uib-tooltip=\"The JavaScript widget is preferred, but you may need to use the Inline\n      Frame if your web site does not allow script tags or if you have conflicting libraries that cause the video player\n      to not function correctly.\"></i>\n  </label>\n  <div>\n    <div class=\"btn-group\">\n      <label class=\"btn btn-default\"\n            ng-model=\"vm.output.embedType\"\n            style=\"width:160px\"\n            uib-btn-radio=\"'javascript'\">JavaScript</label>\n      <label class=\"btn btn-default\"\n            ng-model=\"vm.output.embedType\"\n            style=\"width:160px\"\n            uib-btn-radio=\"'iframe'\">Inline Frame</label>\n      <label class=\"btn btn-default\"\n            ng-if=\"!vm.mediaTokenRestrictions\"\n            ng-model=\"vm.output.embedType\"\n            ng-click=\"vm.showAdvancedFeatures = false\"\n            style=\"width:160px\"\n            uib-btn-radio=\"'link'\">Link</label>\n    </div>\n  </div>\n  <div class=\"checkbox\" ng-if=\"vm.output.embedType === 'iframe'\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.output.args.iframeResize\"> Auto-Resize Inline Frame\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"Please note that this requires JavaScript\"></i>\n    </label>\n  </div>\n  <div class=\"checkbox\" ng-if=\"vm.output.embedType === 'link'\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.output.args.applyBrandColor\"> Apply Brand Color\n    </label>\n  </div>\n</div>\n\n<div class=\"form-group\" ng-if=\"vm.output.embedType == 'javascript' || vm.output.embedType == 'iframe' || vm.output.embedType == 'app'\">\n  <label>Layout</label>\n  <div>\n    <div class=\"btn-group\">\n      <label class=\"btn btn-default btn-square\"\n          ng-model=\"vm.output.layout\"\n          uib-btn-radio=\"'player-with-playlist'\"\n          ng-click=\"vm.changeLayout('player-with-playlist')\"\n          style=\"width:160px\">\n        <img class=\"img\" src=\"/img/embed-player-with-playlist.png\">\n        <small>Full Featured</small>\n      </label>\n      <label class=\"btn btn-default btn-square\"\n          ng-model=\"vm.output.layout\"\n          uib-btn-radio=\"'player-and-title'\"\n          ng-click=\"vm.changeLayout('player-and-title')\"\n          style=\"width:160px\">\n        <img class=\"img\" src=\"/img/embed-player-and-title.png\">\n        <small>Player + Description</small>\n      </label>\n      <label class=\"btn btn-default btn-square\"\n          ng-model=\"vm.output.layout\"\n          uib-btn-radio=\"'player-only'\"\n          ng-click=\"vm.changeLayout('player-only')\"\n          style=\"width:160px\">\n        <img class=\"img\" src=\"/img/embed-player-only.png\">\n        <small>Player</small>\n      </label>\n    </div>\n  </div>\n</div>\n\n<div class=\"form-group\" ng-if=\"vm.output.embedType == 'javascript' || vm.output.embedType == 'iframe' || vm.output.embedType == 'app'\">\n  <strong><a href=\"javascript://\" ng-click=\"vm.showAdvancedFeatures = !vm.showAdvancedFeatures\">Advanced Settings &gt;&gt;</a></strong>\n</div>\n<div class=\"form-group\" ng-if=\"vm.showAdvancedFeatures\">\n  <embed-advanced-settings parent-vm=\"vm\"></embed-advanced-settings>\n</div>\n\n<div class=\"form-group\" ng-hide=\"vm.output.type == 'single' && !vm.output.channelId\">\n  <embed-copy-paste type=\"broadcasts\" parent-vm=\"vm\"></embed-copy-paste>\n</div>\n"

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"vm.mediaTokenRestrictions\">\n  <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px\">\n    Your account has a custom authentication mechanism enabled.  Please note that the standard embed code\n    is unlikely to function properly as a result, and you should instead rely on the custom API integration.\n  </div>\n</div>\n\n<div class=\"form-group\">\n  <label>Filter</label>\n  <embed-select-broadcasts mode=\"highlights\" parent-vm=\"vm\"></embed-select-broadcasts>\n</div>\n\n<div ng-hide=\"!vm.output.channelId\">\n  <div class=\"form-group\">\n    <embed-copy-paste type=\"highlights\" parent-vm=\"vm\"></embed-copy-paste>\n  </div>\n</div>\n"

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\">\n  <label>Integration Type</label>\n  <div class=\"integration-type-controls\">\n    <div class=\"btn-group\">\n      <label class=\"btn btn-default btn-square\"\n             ng-if=\"::!vm.singleEvent\"\n             ng-model=\"vm.output.integrationType\"\n             ng-click=\"vm.checkFilterForIntegration('sdk')\"\n             uib-btn-radio=\"'sdk'\">API / SDK Integration</label>\n      <label class=\"btn btn-default btn-square\"\n             ng-if=\"::$root.account.feature_flags.podcast && !vm.singleEvent\"\n             ng-model=\"vm.output.integrationType\"\n             ng-click=\"vm.checkFilterForIntegration('feeds')\"\n             uib-btn-radio=\"'feeds'\">RSS, MRSS, or JSON Feed</label>\n      <label class=\"btn btn-default btn-square\"\n             ng-if=\"$root.account.feature_flags.podcast && !vm.singleEvent && vm.channels.length\"\n             ng-model=\"vm.output.integrationType\"\n             ng-click=\"vm.checkFilterForIntegration('podcast')\"\n             uib-btn-radio=\"'podcast'\">Podcast Feed</label>\n      <label class=\"btn btn-default btn-square\"\n             ng-if=\"::vm.m3u8Enabled\"\n             ng-model=\"vm.output.integrationType\"\n             ng-click=\"vm.checkFilterForIntegration('m3u8')\"\n             uib-btn-radio=\"'m3u8'\">Static M3U8</label>\n      <label class=\"btn btn-default btn-square\"\n             ng-model=\"vm.output.integrationType\"\n             ng-click=\"vm.checkFilterForIntegration('app')\"\n             uib-btn-radio=\"'app'\">Web View (Third-Party App)</label>\n    </div>\n\n    <div ng-if=\"vm.output.integrationType == 'app'\" class=\"integration-type-controls__info\">\n      <div style=\"padding:10px; border:1px solid;\" class=\"bg-info text-info text-sm\">\n        <i class=\"fa fa-info-circle\"></i>\n        Web Views can be useful for integrating with apps like Subsplash. For more control, consider an API integration <a href=\"javascript://\" ng-click=\"vm.showSDKs()\">using one of our supported SDKs</a>.\n      </div>\n    </div>\n    <div class=\"clearfix\"></div>\n  </div>\n</div>\n\n<div class=\"form-group\" ng-hide=\"vm.singleEvent || !vm.output.integrationType || vm.output.integrationType == 'sdk'\">\n  <label>Filter Broadcasts</label>\n  <embed-select-broadcasts\n    parent-vm=\"vm\"\n    hide-all=\"vm.output.integrationType == 'podcast'\"\n    hide-sources=\"vm.output.integrationType == 'podcast'\"\n    hide-single-broadcast=\"vm.output.integrationType == 'podcast' || vm.output.integrationType == 'feeds'\"\n    broadcast-validator=\"vm.validateBroadastSelection\"\n    ></embed-select-broadcasts>\n</div>\n\n<div ng-if=\"vm.output.integrationType == 'app'\">\n  <div class=\"form-group\">\n    <label>Layout</label>\n    <div>\n      <div class=\"btn-group\">\n        <label class=\"btn btn-default btn-square\"\n            ng-model=\"vm.output.layout\"\n            uib-btn-radio=\"'player-with-playlist'\"\n            ng-click=\"vm.changeLayout('player-with-playlist')\"\n            style=\"width:160px\">\n          <img class=\"img\" src=\"/img/embed-player-with-playlist.png\">\n          <small>Full Featured</small>\n        </label>\n        <label class=\"btn btn-default btn-square\"\n            ng-model=\"vm.output.layout\"\n            uib-btn-radio=\"'player-and-title'\"\n            ng-click=\"vm.changeLayout('player-and-title')\"\n            style=\"width:160px\">\n          <img class=\"img\" src=\"/img/embed-player-and-title.png\">\n          <small>Player + Description</small>\n        </label>\n        <label class=\"btn btn-default btn-square\"\n            ng-model=\"vm.output.layout\"\n            uib-btn-radio=\"'player-only'\"\n            ng-click=\"vm.changeLayout('player-only')\"\n            style=\"width:160px\">\n          <img class=\"img\" src=\"/img/embed-player-only.png\">\n          <small>Player</small>\n        </label>\n      </div>\n    </div>\n  </div>\n  <div class=\"form-group\" ng-if=\"vm.output.embedType == 'javascript' || vm.output.embedType == 'iframe' || vm.output.embedType == 'app'\">\n    <strong><a href=\"javascript://\" ng-click=\"vm.showAdvancedFeatures = !vm.showAdvancedFeatures\">Advanced Settings &gt;&gt;</a></strong>\n  </div>\n  <div class=\"form-group\" ng-if=\"vm.showAdvancedFeatures\">\n    <embed-advanced-settings parent-vm=\"vm\"></embed-advanced-settings>\n  </div>\n</div>\n\n<div ng-hide=\"vm.output.type == 'single' && !vm.output.broadcast\">\n\n  <div class=\"form-group\" ng-if=\"vm.output.integrationType == 'podcast'\">\n    <label>Feed Type</label>\n    <div>\n      <div class=\"btn-group\">\n        <label class=\"btn btn-default btn-square\" ng-model=\"vm.output.mediaType\" uib-btn-radio=\"'audio-podcast'\">Audio Podcast</label>\n        <label class=\"btn btn-default btn-square\" ng-model=\"vm.output.mediaType\" uib-btn-radio=\"'video-podcast'\">Video Podcast</label>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"form-group\" ng-if=\"vm.output.integrationType == 'feeds'\">\n    <label>Feed Type</label>\n    <div>\n      <div class=\"btn-group\">\n        <label class=\"btn btn-default btn-square\" ng-model=\"vm.output.mediaType\" uib-btn-radio=\"'rss'\">RSS With Links</label>\n        <label class=\"btn btn-default btn-square\" ng-model=\"vm.output.mediaType\" uib-btn-radio=\"'audio-mrss'\">Audio MRSS</label>\n        <label class=\"btn btn-default btn-square\" ng-model=\"vm.output.mediaType\" uib-btn-radio=\"'video-mrss'\">Video MRSS</label>\n        <label class=\"btn btn-default btn-square\" ng-model=\"vm.output.mediaType\" uib-btn-radio=\"'roku-direct-publisher'\">Roku Direct Publisher</label>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.output.integrationType === 'm3u8'\">\n    <div class=\"text-warning bg-warning\" style=\"border:1px solid; padding:10px; margin:15px 0;\">\n      <i class=\"fa fa-warning\"></i> This URL can be used for integration into certain third party app providers.  It\n      should <em>never</em> be distributed directly to viewers. Also be aware that the use of this URL for watching\n      the broadcast will skew your analytics.  If you would like to retain analytics, your app should be updated to\n      use one of the supported <a href=\"javascript://\" ng-click=\"vm.showSDKs()\">BoxCast SDKs</a>.\n      <div style=\"margin-top:15px\">\n        <span ng-click=\"vm.output.showM3U8Confirmed = true\" style=\"cursor:pointer; font-weight:bold;\">\n          <i class=\"fa\" ng-class=\"{ 'fa-square-o': !vm.output.showM3U8Confirmed, 'fa-check-square-o': vm.output.showM3U8Confirmed }\"></i>\n          I understand, show me the URL.\n        </span>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.output.integrationType == 'podcast'\">\n    <div ng-if=\"vm.output.mediaType == 'audio-podcast' && !vm.allowPodcastForChannel('audio')\">\n      <div class=\"text-warning bg-warning\" style=\"border:1px solid; padding:10px; margin:15px 0;\">\n        <p><strong>The audio podcast settings must be configured for the channel prior to selecting this option.</strong></p>\n        <a ui-sref=\"channels({id: vm.output.channel.id})\">View Channel Settings</a>\n      </div>\n    </div>\n    <div ng-if=\"vm.output.mediaType == 'video-podcast' && !vm.allowPodcastForChannel('video')\">\n      <div class=\"text-warning bg-warning\" style=\"border:1px solid; padding:10px; margin:15px 0;\">\n        <p><strong>The video podcast settings must be configured for the channel prior to selecting this option.</strong></p>\n        <a ui-sref=\"channels({id: vm.output.channel.id})\">View Channel Settings</a>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"form-group\"\n      ng-hide=\"!vm.outputCode('other')\n        || (vm.output.integrationType == 'm3u8' && !vm.output.showM3U8Confirmed)\n        || (vm.output.integrationType === 'podcast' && vm.output.mediaType == 'audio-podcast' && !vm.allowPodcastForChannel('audio'))\n        || (vm.output.integrationType === 'podcast' && vm.output.mediaType == 'video-podcast' && !vm.allowPodcastForChannel('video'))\n      \">\n    <embed-copy-paste type=\"other\" parent-vm=\"vm\"></embed-copy-paste>\n  </div>\n\n</div>\n\n\n<div ng-if=\"vm.output.integrationType == 'sdk'\">\n  <p><strong>Review API Documentation and Platform SDKs</strong></p>\n  <style>\n    .sdk-list small {\n        opacity: 0.6;\n    }\n    .sdk-list .label {\n        padding: 4px 6px 4px 6px;\n        font-size: 1.2rem;\n    }\n    .sdk-list .label-default {\n    }\n  </style>\n  <table class=\"table sdk-list\">\n    <tbody>\n      <tr>\n        <td>REST API documentation.</td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://boxcast.github.io/boxcast_api/\" target=\"_blank\">\n            <i class=\"fa fa-flask\"></i> Developer Docs\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td>Build your own AppleTV app (TVML).\n          <div><span class=\"label label-default\">JavaScript</span></div></td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://github.com/boxcast/boxcast-sdk-tvos\" target=\"_blank\">\n            <i class=\"fa fa-code-fork\"></i> BoxCast SDK for TVML\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td>Build your own iOS, macOS, watchOS, or tvOS app.\n          <div><span class=\"label label-default\">Swift</span></div></td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://github.com/boxcast/boxcast-sdk-apple\" target=\"_blank\">\n            <i class=\"fa fa-code-fork\"></i> BoxCast SDK for Apple\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td>Build your own Roku app.\n          <div><span class=\"label label-default\">BrightScript</span></div></td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://github.com/boxcast/boxcast-sdk-roku\" target=\"_blank\">\n            <i class=\"fa fa-code-fork\"></i> BoxCast SDK for Roku\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td>Build your own Android app.\n          <div><span class=\"label label-default\">Java</span></div></td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://github.com/boxcast/boxcast-sdk-android\" target=\"_blank\">\n            <i class=\"fa fa-code-fork\"></i> BoxCast SDK for Android\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td>Build your own React Native app.\n          <div><span class=\"label label-default\">JavaScript</span></div></td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://github.com/boxcast/boxcast-sdk-react-native\" target=\"_blank\">\n            <i class=\"fa fa-code-fork\"></i> BoxCast SDK for React Native\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td>Integrate a custom video player (e.g. JW Player, Video.js).\n          <div><span class=\"label label-default\">JavaScript</span></div></td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://github.com/boxcast/boxcast-sdk-js\" target=\"_blank\">\n            <i class=\"fa fa-code-fork\"></i> BoxCast SDK for JavaScript\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td>Host a custom video website portal.\n          <div><span class=\"label label-default\">JavaScript</span> <span class=\"label label-default\">HTML</span> <span class=\"label label-default\">CSS</span></div></td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://github.com/boxcast/example_video_portal_vuejs\" target=\"_blank\">\n            <i class=\"fa fa-code-fork\"></i> Sample Vue.js Website\n          </a>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n\n  <p><strong>Additional Resources</strong></p>\n  <ol class=\"list-inline\">\n    <li>\n      <a class=\"btn btn-default\" href=\"https://www.boxcast.com/dev-support\" target=\"_blank\">\n        <i class=\"fa fa-question-circle\"></i> Developer Support\n      </a>\n    </li>\n    <li>\n      <a class=\"btn btn-default\" href=\"https://www.boxcast.com/status\" target=\"_blank\">\n        <i class=\"fa fa-heartbeat\"></i> Platform Status\n      </a>\n    </li>\n    <li ng-if=\"::$root.user.can('list', 'api-keys')\">\n      <a class=\"btn btn-default\" ui-sref=\"settings.api_keys\">\n        <i class=\"fa fa-key\"></i> Manage API Keys\n      </a>\n    </li>\n  </ol>\n</div>\n"

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <div class=\"btn-group\">\n    <label class=\"btn btn-default\"\n          ng-model=\"vm.parentVM.output.type\"\n          uib-btn-radio=\"'all'\"\n          style=\"width:120px\"\n          ng-click=\"vm.parentVM.selectAllBroadcasts()\"\n          ng-if=\"!vm.hideAll\">All</label>\n    <label class=\"btn btn-default\"\n          ng-model=\"vm.parentVM.output.type\"\n          uib-btn-radio=\"'channel'\"\n          style=\"width:120px\"\n          ng-click=\"vm.parentVM.selectCustomChannel(vm.parentVM.channels[0])\"\n          ng-if=\"vm.parentVM.channels.length > 0 && !vm.hideChannels\">By Channel</label>\n    <label class=\"btn btn-default\"\n          ng-model=\"vm.parentVM.output.type\"\n          uib-btn-radio=\"'source'\"\n          style=\"width:120px\"\n          ng-click=\"vm.parentVM.selectOneSource(vm.parentVM.sourcesCombined[0])\"\n          ng-if=\"vm.parentVM.sourcesCombined.length > 0 && !vm.hideSources\">By Source</label>\n    <label class=\"btn btn-default\"\n          ng-model=\"vm.parentVM.output.type\"\n          uib-btn-radio=\"'single'\"\n          style=\"width:120px\"\n          ng-click=\"vm.parentVM.selectSingleBroadcast(vm.parentVM.output.broadcast)\"\n          ng-if=\"!vm.hideSingleBroadcast\">By Broadcast</label>\n  </div>\n\n  <div ng-if=\"!vm.hideSources && vm.parentVM.output.type == 'source'\" class=\"form-group\" style=\"width:480px;margin-top:15px;\">\n    <label>Source</label>\n    <select class=\"form-control\"\n            ng-model=\"vm.parentVM.output.source\"\n            ng-change=\"vm.parentVM.selectOneSource(vm.parentVM.output.source)\"\n            ng-options=\"b as vm.parentVM.formatSourceOpt(b) for b in vm.parentVM.sourcesCombined track by b.id\"\n            required>\n    </select>\n  </div>\n\n  <div ng-if=\"!vm.hideChannels && vm.parentVM.output.type == 'channel'\" class=\"form-group\" style=\"width:480px;margin-top:15px;\">\n    <label>Channel</label>\n    <select class=\"form-control\"\n            ng-model=\"vm.parentVM.output.channel\"\n            ng-change=\"vm.parentVM.selectCustomChannel(vm.parentVM.output.channel)\"\n            ng-options=\"c as c.name for c in vm.parentVM.channels track by c.id\"\n            required>\n    </select>\n  </div>\n\n  <div ng-if=\"!vm.hideSingleBroadcast && vm.parentVM.output.type == 'single'\" class=\"form-group\" style=\"width:480px;margin-top:15px;\">\n    <label>Broadcast</label>\n    <recording-source-chooser edit-or-create-event-service=\"vm.service\"\n                              skip-recording-source-validation=\"true\"\n                              select-source-title=\"Select Broadcast...\"\n                              modal-title=\"Select Broadcast\"\n                              broadcast-validator=\"vm.broadcastValidator\"\n                              on-select-broadcast=\"vm.parentVM.selectSingleBroadcast\"></recording-source-chooser>\n  </div>\n</div>\n"

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <hr>\n  <label ng-show=\"vm.parentVM.loading()\">Loading, please wait...</label>\n  <div ng-hide=\"vm.parentVM.loading()\">\n\n    <div class=\"pull-right\">\n      <ol class=\"list-inline\">\n        <li ng-show=\"vm.parentVM.showPreviewEmbed(vm.type)\">\n          <button ng-click=\"vm.parentVM.showPreview(vm.type)\" type=\"button\" class=\"btn btn-default\">\n            Preview Embed Code\n          </button>\n        </li>\n        <li ng-show=\"vm.parentVM.output.embedType == 'link'\">\n          <a href=\"{{vm.parentVM.outputCode(vm.type)}}\" target=\"_blank\" class=\"btn btn-default\">\n            <i class=\"fa fa-external-link\"></i> View on BoxCast.tv\n          </a>\n        </li>\n        <li ng-if=\"$root.clipboard.supported\">\n          <button class=\"btn btn-success\" clipboard\n                  text=\"vm.parentVM.outputCode(vm.type)\"\n                  on-copied=\"$root.toaster.pop('success', 'Copied!')\"\n                  on-error=\"$root.toaster.pop('warning', 'Could not copy :(')\"\n                  >Copy Embed Code <i class=\"fa fa-copy\"></i></button>\n        </li>\n      </ol>\n    </div>\n\n    <label>{{vm.parentVM.copyLabel(vm.type)}}</label>\n\n    <div ng-if=\"!vm.parentVM.loading() && vm.type == 'other' && vm.parentVM.output.integrationType == 'm3u8' && !vm.parentVM.output.m3u8\">\n      <div class=\"text-warning bg-warning\" style=\"border:1px solid;padding:10px\">\n        The M3U8 link is not available.  Are you trying to access a ticketed resource?\n      </div>\n    </div>\n\n    <textarea readonly class=\"form-control\" rows=\"7\">{{vm.parentVM.outputCode(vm.type)}}</textarea>\n\n    <p class=\"help-block\" ng-if=\"vm.type == 'broadcasts' && vm.parentVM.output.integrationType == 'iframe'\">\n      <small>\n        <i class=\"fa fa-info-circle\"></i>\n        If the iframe code above does not work, you may need copy just the value inside the src=\"...\" attribute,\n        depending on how your web site hosting provider functions.\n      </small>\n    </p>\n  </div>\n\n</div>\n"

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports = "<div style=\"width:290px\" class=\"pull-left\">\n  <p><strong>Player Settings</strong></p>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-click=\"vm.parentVM.showHideAutoplayOptions()\"> Customize Auto-play Behavior\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"If selected, you can customize the auto-play behavior. Do Not Auto-play will never attempt to auto-play video; Try With Sound will try to auto-play with sound; Try With Sound or Muted will first try with sound, then try again with the video muted if the first attempt fails.\" tooltip-append-to-body=\"true\"></i>\n      <select class=\"form-control\" ng-change=\"vm.parentVM.changeAutoplayOptions()\" ng-show=\"vm.parentVM.showAutoplayOptions\" ng-model=\"vm.parentVM.output.args.autoplay\" required>\n        <option value=\"false\">Do Not Auto-play</option>\n        <option value=\"true\">Try With Sound</option>\n        <option value=\"try-muted\">Try With Sound or Muted</option>\n      </select>\n    </label>\n  </div>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-disabled=\"vm.parentVM.disablePlayInline\" ng-model=\"vm.parentVM.output.args.playInline\"> Play Inline\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"If selected, the broadcast video will play 'inline' on mobile devices (rather than full-screen). If customizing auto-play behavior, you will likely want this too.\"></i>\n    </label>\n  </div>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.dvr\" ng-true-value=\"false\" ng-false-value=\"true\"> Disable Live DVR\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"By default, DVR scrubbing is enabled for all live videos. If checked, the player will disable the feature. \"></i>\n    </label>\n  </div>\n  <div class=\"checkbox\" ng-if=\"vm.parentVM.showVersionOverride\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.showPlayerVersion\" ng-click=\"vm.parentVM.clearPlayerVersionIfNecessary()\" ng-disabled=\"vm.parentVM.output.embedType === 'iframe'\">\n      Player Version Override\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"Pin to a specific version of the BoxCast Video Player\"></i>\n    </label>\n  </div>\n  <div class=\"form-group\" ng-if=\"vm.parentVM.showPlayerVersion && vm.parentVM.output.embedType !== 'iframe'\">\n    <input type=\"url\" class=\"form-control\" ng-model=\"vm.parentVM.output.args.version\" placeholder=\"e.g. 3.1.8\">\n    <p class=\"help-block\">\n      <i class=\"fa fa-info-circle\"></i> Only override for testing new features or if Support has given you a specific reason to use an older version. By default, we use the latest stable version of the player.\n    </p>\n  </div>\n  <p><strong>Additional Features</strong></p>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.showCountdown\"> Countdown Timer\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"If selected, the player will show a large countdown timer for future broadcasts.\"></i>\n    </label>\n  </div>\n  <div class=\"checkbox\" ng-if=\"::vm.parentVM.FeatureFlags.donations\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.showDonations\"> Collect Donations\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"If selected, the player title area will add a button to collect online donations from viewers.\"></i>\n    </label>\n  </div>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.showPoster\" ng-click=\"vm.parentVM.clearPosterIfNecessary()\">\n      Custom Thumbnail Image\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"This image will show behind the play button instead of the automatically captured frame.\"></i>\n    </label>\n  </div>\n  <div class=\"form-group\" ng-if=\"vm.parentVM.showPoster\">\n    <div ng-if=\"vm.parentVM.output.args.poster\" class=\"text-center\">\n      <div>\n        <img ng-src=\"{{vm.parentVM.output.args.poster | trustedUrl}}\" class=\"img\" style=\"max-width:100%\">\n      </div>\n      <a href ng-click=\"vm.parentVM.output.args.poster = null\">Change</a>\n    </div>\n    <div ng-if=\"!vm.parentVM.output.args.poster\">\n      <upload-slot ng-model=\"vm.parentVM.posterFile\"\n                    ng-change=\"vm.parentVM.uploadPoster(vm.parentVM.posterFile)\"\n                    slot-name=\"'poster'\"\n                    allow-image=\"true\"\n                    allow-video=\"false\"\n                    compact=\"true\"></upload-slot>\n    </div>\n  </div>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.showPreroll\" ng-click=\"vm.parentVM.clearPrerollIfNecessary()\">\n      Custom Pre-Broadcast Video\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"This video will play in a loop before the broadcast starts\"></i>\n    </label>\n  </div>\n  <div class=\"form-group\" ng-if=\"vm.parentVM.showPreroll\">\n    <div ng-if=\"vm.parentVM.output.args.customPreroll\" class=\"text-center\">\n      <div>\n        <video ng-src=\"{{vm.parentVM.output.args.customPreroll | trustedUrl}}\" controls style=\"max-width:100%;\"></video>\n      </div>\n      <a href ng-click=\"vm.parentVM.output.args.customPreroll = null\">Change</a>\n    </div>\n    <div ng-if=\"!vm.parentVM.output.args.customPreroll\">\n      <upload-slot ng-model=\"vm.parentVM.customPrerollFile\"\n                    ng-change=\"vm.parentVM.uploadCustomPreroll(vm.parentVM.customPrerollFile)\"\n                    slot-name=\"'preroll'\"\n                    allow-image=\"false\"\n                    allow-video=\"true\"\n                    compact=\"true\"></upload-slot>\n    </div>\n  </div>\n</div>\n<div class=\"pull-left\">\n  <div ng-if=\"!vm.parentVM.singleEvent\">\n    <p><strong>Default Video Selection</strong></p>\n    <div class=\"radio\">\n      <label>\n        <input type=\"radio\" ng-model=\"vm.parentVM.output.args.defaultVideo\" value=\"next\"> Show next broadcast immediately\n        <i class=\"fa fa-question-circle\" uib-tooltip=\"With this option, the widget will default to showing and selecting\n          the next future broadcast as soon as the current live broadcast ends. A countdown timer will be displayed on\n          this broadcast until it begins.\" tooltip-append-to-body=\"true\"></i>\n      </label>\n    </div>\n    <div class=\"radio\">\n      <label>\n        <input type=\"radio\" ng-model=\"vm.parentVM.output.args.defaultVideo\" value=\"closest\"> Show closest broadcast\n        <i class=\"fa fa-question-circle\" uib-tooltip=\"With the *closest* option, the widget will only show the\n          the next upcoming broadcast when it is closer in time than the previous recording.\" tooltip-append-to-body=\"true\"></i>\n      </label>\n    </div>\n  </div>\n  <p><strong>Layout Customization</strong></p>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.applyBrandColor\"> Apply Brand Color to Video Progress Bar\n    </label>\n  </div>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.showTitleAndDescription\"> Show Description Below Player\n    </label>\n  </div>\n  <div class=\"checkbox\" ng-if=\"::vm.parentVM.FeatureFlags.documents\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.showDocuments\"> Show Documents\n    </label>\n  </div>\n  <div class=\"checkbox\" ng-if=\"::vm.parentVM.FeatureFlags.cue_points\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.showIndex\"> Show Video Index\n    </label>\n  </div>\n  <div class=\"checkbox\" ng-if=\"!vm.parentVM.singleEvent\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.showRelated\"> Show Playlist\n    </label>\n  </div>\n  <div class=\"checkbox\" ng-if=\"::vm.parentVM.FeatureFlags.viewer_chat\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.showChat\"> Show Viewer Chat\n    </label>\n  </div>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.playlistOnRight\"> Two-Column Layout\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"If selected, the widget will show the playlist and list of highlights to the right of the video player. By default, the list is shown below the video.\"></i>\n    </label>\n  </div>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.hidePreBroadcastTextOverlay\"> Hide Overlay Messages Before Broadcast\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"If selected, the player text overlays and countdown timer will not appear before a broadcast.  This is often used in conjunction with a pre-broadcast video or poster image.\" tooltip-append-to-body=\"true\"></i>\n    </label>\n  </div>\n</div>\n<div class=\"clearfix\"></div>\n"

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">Preview Embed Code</h3>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <p class=\"help-block\">\n        <i class=\"fa fa-info-circle\"></i>\n        You can place this anywhere on your web site. The embed is shown inside an inline frame here, but you can place it\n        directly alongside your other website content so that it inherits the typography and other style elements.\n      </p>\n      <div id=\"modal-preview-script\">Loading...</div>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Close Preview</button>\n</div>\n\n"

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__edit__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__detail__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__highlights__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__trim_recordings__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scoreboard_controls__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__player_with_highlight_capture__ = __webpack_require__(413);





 // The `wire` helper only deals with simple states. We need to add the
// detail sub-states as well, so we'll just do it by hand here.

var module = angular.module('events', []);
module.controller('EditEventController', __WEBPACK_IMPORTED_MODULE_0__edit__["a" /* default */]);
module.controller('EventDetailController', __WEBPACK_IMPORTED_MODULE_1__detail__["a" /* default */]);
module.controller('HighlightsController', __WEBPACK_IMPORTED_MODULE_2__highlights__["a" /* default */]);
module.controller('TrimRecordingsController', __WEBPACK_IMPORTED_MODULE_3__trim_recordings__["a" /* default */]);
module.directive('scoreboardControls', __WEBPACK_IMPORTED_MODULE_4__scoreboard_controls__["a" /* default */]);
module.component('playerWithHighlightCapture', __WEBPACK_IMPORTED_MODULE_5__player_with_highlight_capture__["a" /* default */]);
module.config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('events', {
    url: '/events',
    template: "<div ui-view></div>",
    "abstract": true
  }).state('events.detail', {
    url: '/:id?tab&action&from_producer',
    template: __webpack_require__(417),
    controller: __WEBPACK_IMPORTED_MODULE_1__detail__["a" /* default */],
    controllerAs: 'vm',
    reloadOnSearch: false
  }).state('events.trim', {
    url: '/:id/trim/:recording',
    template: __webpack_require__(418),
    controller: __WEBPACK_IMPORTED_MODULE_3__trim_recordings__["a" /* default */],
    controllerAs: 'vm'
  }).state('events.highlights', {
    url: '/:id/highlights/:recording?show&capture&edit',
    template: __webpack_require__(419),
    controller: __WEBPACK_IMPORTED_MODULE_2__highlights__["a" /* default */],
    controllerAs: 'vm'
  }); //.state('events.edit', {
  //  url: '/:id/edit',
  //  template: require('./edit.html'),
  //  controller: EditEventController,
  //  controllerAs: 'vm',
  //})
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditEventController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_pricing__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_error__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_timezone__ = __webpack_require__(187);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }





var EditEventController = /*#__PURE__*/function () {
  function EditEventController($scope, $state, $uibModalInstance, $q, $uibModal, Broadcast, Facebook, ConfirmDialog, EditOrCreateEventService, OneOrAllDialog, toaster, broadcastId, activeTab, $rootScope) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, EditEventController);

    this.$scope = $scope;
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.$uibModalInstance = $uibModalInstance;
    this.Broadcast = Broadcast;
    this.ConfirmDialog = ConfirmDialog;
    this.OneOrAllDialog = OneOrAllDialog;
    this.toaster = toaster;
    this.activeTab = activeTab;
    this.fb = Facebook;
    this.fb.init();
    this.service = EditOrCreateEventService.getInstance();
    this.service.initBroadcast(broadcastId);
    this.service.initScope($scope);
    this.showError = false;
    var accountTimezone__tzInfo = $rootScope.account.time_zone;
    var currentTimezone__jstz = Object(__WEBPACK_IMPORTED_MODULE_2__utils_timezone__["a" /* FindTimeZone */])();
    this.currentTimezoneValue = currentTimezone__jstz;
    this.currentTimezone = Object(__WEBPACK_IMPORTED_MODULE_2__utils_timezone__["c" /* JstzToTzInfo */])(currentTimezone__jstz);
    this.timezoneMatchesAccount = Object(__WEBPACK_IMPORTED_MODULE_2__utils_timezone__["b" /* JstzMatchesTzInfo */])(currentTimezone__jstz, accountTimezone__tzInfo);
    this.minStartTime = moment().startOf('day').toDate();

    if (this.service.broadcast.$promise) {
      this.service.broadcast.$promise.then(function () {
        _this.showSocial = _this.service.broadcast.simulcast_configurations.length > 0;

        _this.fb.init(); // Derived data for editing


        _this.isImported = _this.service.broadcast.stream_source == 'imported';
        _this.canEditStart = _this.service.broadcast.timeframe == 'future' || _this.isImported;
        _this.canEditStop = _this.service.broadcast.timeframe != 'past' || _this.isImported;

        if (_this.isImported) {
          _this.minStartTime = moment(_this.service.broadcast.starts_at).startOf('day').toDate();
        } // Podcast settings expanded only if already updated


        var cs = _this.service.broadcast.content_settings;
        _this.showPodcast = cs.podcast_preview || cs.podcast_subtitle || cs.podcast_summary;
      });
    } else {
      this.fb.init();
    }

    this.loadingPromises = [this.service.broadcast.$promise, this.service.boxcasters.$promise, this.service.account.$promise, this.service.channels.$promise];
    $q.all(this.loadingPromises)["catch"](function (e) {
      console.error(e);
      toaster.pop('warning', 'Error loading broadcast', 'Sorry, we were not able to load the broadcast. Please refresh this page and try again.');

      _this.cancel();
    });
    this.confirmOnExit = false;
    $scope.$watch(function () {
      return $scope.form.$pristine;
    }, function (isPristine) {
      _this.confirmOnExit = _this.confirmOnExit || !isPristine;
    });
  }

  _createClass(EditEventController, [{
    key: "loginFacebook",
    value: function loginFacebook() {
      var _this2 = this;

      this.fb.login().then(function () {
        _this2.service.initializeEmptyFacebookAccountIDs();
      });
    }
  }, {
    key: "logoutFacebook",
    value: function logoutFacebook() {
      var _this3 = this;

      this.fb.logout().then(function () {
        return _this3.fb.init();
      });
    }
  }, {
    key: "facebookLiveSimulcastFeedType",
    value: function facebookLiveSimulcastFeedType(config) {
      return config.fb_feed_id.split(':', 1)[0];
    }
  }, {
    key: "facebookLiveSimulcastFeedID",
    value: function facebookLiveSimulcastFeedID(config) {
      return config.fb_feed_id.replace(/^[^:]*:/, '');
    }
  }, {
    key: "fbLiveShowGlass",
    value: function fbLiveShowGlass(config) {
      return config.fb_feed_id && config.facebook_account_id && config.facebook_account_id != this.fb.facebook_account_id;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var doIt = true;

      if (this.confirmOnExit) {
        doIt = confirm('Are you sure you want to abandon your changes?');
      }

      if (doIt) {
        this.$uibModalInstance.dismiss('cancel');
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      this.cancel(); //route to vue - that will handle if it should route back to angular or not.

      window.location.href = "".concat(window.VUE_DASHBOARD_ROOT, "/schedule/broadcast?cloneId=").concat(this.service.broadcast.id);
    }
  }, {
    key: "delete",
    value: function _delete() {
      var _this4 = this;

      var Broadcast = this.Broadcast,
          ConfirmDialog = this.ConfirmDialog,
          OneOrAllDialog = this.OneOrAllDialog,
          toaster = this.toaster,
          $state = this.$state,
          $uibModalInstance = this.$uibModalInstance;

      var deleteThisBroadcast = function deleteThisBroadcast() {
        var resource = Broadcast["delete"]({
          id: _this4.service.broadcast.id
        }, function () {
          $uibModalInstance.dismiss();

          _this4.cancel();

          $state.go('home', {}, {
            reload: true
          });
        }, function (e) {
          if (e.status === 409 && e.data && e.data.error_description && RegExp('uses? the recording of this broadcast').test(e.data.error_description)) {
            toaster.pop('warning', 'Error deleting broadcast', e.data.error_description + '.');
          } else {
            alert('Error deleting broadcast. Please reload this page and try again.');
          }
        });
        _this4.loadingPromises = [resource.$promise];
      };

      var deleteBroadcastWithRecurrences = function deleteBroadcastWithRecurrences() {
        var resource = Broadcast.deleteRecurring({
          id: _this4.service.broadcast.id
        }, {
          id: _this4.service.broadcast.id,
          recurrence: {
            id: _this4.service.broadcast.recurrence.id,
            broadcasts: _this4.service.broadcast.recurrence.broadcasts
          }
        }, function () {
          $uibModalInstance.dismiss();

          _this4.cancel();

          $state.go('home', {}, {
            reload: true
          });
        }, function (e) {
          if (e.status === 409 && e.data && e.data.error_description && RegExp('scheduled to use the recording of this broadcast').test(e.data.error_description)) {
            toaster.pop('warning', 'Error deleting broadcast', e.data.error_description.replace('of this broadcast', 'of one or more of these broadcasts') + '.');
          } else {
            alert('Error deleting broadcasts. Please reload this page and try again.');
          }
        });
        _this4.loadingPromises = [resource.$promise];
      };

      var promptAndDelete = function promptAndDelete(deleteFn) {
        var modalOptions = {
          closeButtonText: 'Cancel',
          actionButtonText: 'Delete Broadcast',
          actionButtonClass: 'danger',
          headerText: 'Please Confirm',
          bodyText: 'Are you sure you want to permanently delete this broadcast? Once deleted, a broadcast cannot be recovered.'
        };

        if (deleteFn === deleteBroadcastWithRecurrences) {
          modalOptions.actionButtonText = 'Delete Broadcasts';
          modalOptions.bodyText = 'Are you sure you want to permanently delete these broadcasts? Once deleted, broadcasts cannot be recovered.';
        }

        ConfirmDialog.show(modalOptions).then(deleteFn);
      };

      if (this.service.broadcast.timeframe != 'past' && this.service.broadcast.recurrence && this.service.broadcast.recurrence.broadcasts && this.service.broadcast.recurrence.broadcasts.length) {
        var otherBroadcasts = [];
        var otherBroadcastsText = '';

        if (this.service.broadcast.timeframe == 'future') {
          // If this broadcast is in the future, then "other broadcasts" is only other future broadcasts
          otherBroadcasts = _.filter(this.service.broadcast.recurrence.broadcasts, function (b) {
            return b.timeframe == 'future';
          });
          otherBroadcastsText = 'future';
        } else {
          // If this broadcast is pre-roll or current, then "other broadcasts" is current AND future broadcasts
          otherBroadcasts = _.filter(this.service.broadcast.recurrence.broadcasts, function (b) {
            return b.timeframe != 'past';
          });
          otherBroadcastsText = 'current and future';
        }

        if (otherBroadcasts.length) {
          // Other non-past recurring broadcasts in the series!
          var modalOptions = {
            headerText: "Delete all ".concat(otherBroadcastsText, " broadcasts in the series?"),
            bodyText: "This broadcast is one of ".concat(otherBroadcasts.length + 1, " ").concat(otherBroadcastsText, " broadcasts in a recurring series. Do you want to delete this broadcast only, or all ").concat(otherBroadcastsText, " broadcasts in the series?"),
            allButtonClass: 'danger',
            oneButtonClass: 'danger'
          };
          OneOrAllDialog.show(modalOptions).then(function (result) {
            if (result == 'one') {
              // Just delete this one
              promptAndDelete(deleteThisBroadcast);
            } else {
              // Delete all the future ones
              _this4.service.broadcast.recurrence.broadcasts = otherBroadcasts;
              promptAndDelete(deleteBroadcastWithRecurrences);
            }
          });
        } else {
          // All other recurring broadcasts in the series are past, so we're just operating on this one.
          promptAndDelete(deleteThisBroadcast);
        }
      } else {
        // This is a past broadcast or single non-recurring broadcast
        promptAndDelete(deleteThisBroadcast);
      }
    }
  }, {
    key: "addSimulcastDestination",
    value: function addSimulcastDestination(d, params) {
      this.confirmOnExit = true;
      return this.service.addSimulcastDestination(d, params);
    }
  }, {
    key: "removeSimulcastDestination",
    value: function removeSimulcastDestination(d) {
      this.confirmOnExit = true;
      return this.service.removeSimulcastDestination(d);
    }
  }, {
    key: "styleDoNotRecord",
    get: function get() {
      if (this.service.broadcast.timeframe == 'future') {
        return {
          cursor: 'pointer'
        };
      } else {
        return {
          cursor: 'not-allowed',
          color: '#aaa'
        };
      }
    }
  }, {
    key: "toggleDoNotRecord",
    value: function toggleDoNotRecord() {
      // Don't toggle unless it's in the future
      if (this.service.broadcast.timeframe != 'future') return;
      this.service.broadcast.do_not_record = !this.service.broadcast.do_not_record;
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this5 = this;

      var $uibModal = this.$uibModal,
          OneOrAllDialog = this.OneOrAllDialog;

      var saveThisBroadcast = function saveThisBroadcast() {
        _this5.showError = false;
        _this5.submitting = true;

        _this5.service.saveChanges().then(function (broadcast) {
          _this5.submitting = false;

          _this5.$uibModalInstance.close(broadcast);
        })["catch"](function (error) {
          var errorDetails = Object(__WEBPACK_IMPORTED_MODULE_1__utils_error__["a" /* errorDescriptionFromResponse */])(error);

          if (errorDetails == 'invalid') {
            _this5.showError = true;
          } else {
            alert('Unable to save broadcast. Please check your fields and try again.\n\n' + errorDetails);
          }

          _this5.submitting = false;
        });
      };

      var checkForRecurringUpdates = function checkForRecurringUpdates() {
        if (_this5.service.broadcast.timeframe != 'past' && _this5.service.broadcast.recurrence && _this5.service.broadcast.recurrence.broadcasts && _this5.service.broadcast.recurrence.broadcasts.length) {
          var otherBroadcasts = [];
          var otherBroadcastsText = '';

          if (_this5.service.broadcast.timeframe == 'future') {
            // If this broadcast is in the future, then "other broadcasts" is only other future broadcasts
            otherBroadcasts = _.filter(_this5.service.broadcast.recurrence.broadcasts, function (b) {
              return b.timeframe == 'future';
            });
            otherBroadcastsText = 'future';
          } else {
            // If this broadcast is pre-roll or current, then "other broadcasts" is current AND future broadcasts
            otherBroadcasts = _.filter(_this5.service.broadcast.recurrence.broadcasts, function (b) {
              return b.timeframe != 'past';
            });
            otherBroadcastsText = 'current and future';
          }

          if (otherBroadcasts.length) {
            // Other recurring broadcasts in the series!
            var modalOptions = {
              headerText: "Update all ".concat(otherBroadcastsText, " broadcasts in the series?"),
              bodyText: "This broadcast is one of ".concat(otherBroadcasts.length + 1, " ").concat(otherBroadcastsText, " broadcasts in a recurring series. Do you want to apply your edits to this broadcast only, or all ").concat(otherBroadcastsText, " broadcasts in the series?")
            };
            OneOrAllDialog.show(modalOptions).then(function (result) {
              if (result == 'one') {
                // Just update this one
                delete _this5.service.broadcast.recurrence;
                saveThisBroadcast();
              } else {
                // Update all the future ones
                _this5.service.broadcast.recurrence.broadcasts = otherBroadcasts;
                saveThisBroadcast();
              }
            });
          } else {
            // All other recurring broadcasts in the series are past, so we're just operating on this one.
            delete _this5.service.broadcast.recurrence;
            saveThisBroadcast();
          }
        } else {
          // This is a past broadcast or single non-recurring broadcast
          delete _this5.service.broadcast.recurrence;
          saveThisBroadcast();
        }
      };

      if (this.service.broadcast.timeframe != 'past' && this.service.conflictingEvents.length > 0) {
        var conflictingEvents = this.service.conflictingEvents;
        $uibModal.open({
          template: __webpack_require__(398),
          controller: function controller($scope, $uibModalInstance) {
            'ngInject';

            $scope.conflictingEvents = conflictingEvents;

            $scope.ok = function (result) {
              return $uibModalInstance.close(result);
            };

            $scope.close = function () {
              return $uibModalInstance.dismiss('cancel');
            };
          }
        }).result.then(checkForRecurringUpdates);
      } else {
        checkForRecurringUpdates();
      }
    }
  }]);

  return EditEventController;
}();



/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Overlapping Broadcast Detected</h3>\n</div>\n<div class=\"modal-body\">\n  <p>This broadcast conflicts with:</p>\n  <ul>\n    <li ng-repeat=\"b in ::conflictingEvents\"><strong>{{::b.name}}</strong> ({{::b.starts_at | date:'h:mm a'}} - {{::b.stops_at | date:'shortTime'}})</li>\n  </ul>\n  <p>\n    If this was an accident, tap Edit and fix the scheduled times.\n    If you wish to proceed with the conflict, tap Schedule below, but\n    understand you may need to stop one broadcast before the other can proceed.\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-default\" ng-click=\"close()\">Edit</button>\n  <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Schedule</button>\n</div>\n"

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventDetailController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__broadcast_with_rtmp_controller__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_capture_highlight_recorded__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__embed_single_event_controller__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_download_or_export_recording__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_highlight_preview__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_upload_event__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_allow_social__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_clappr__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_date__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_broadcast__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_download__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_rtmp__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_stream_diagnostics__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_uploads__ = __webpack_require__(404);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
















var UPLOAD_PROGRESS_INTERVAL_MS = 5000;
var SIMULCAST_FPS_THRESHOLD = 10; // if we're getting at least 10 fps through, we're OK

var EventDetailController = /*#__PURE__*/function () {
  function EventDetailController($state, $scope, $sanitize, $timeout, $http, $location, AccountUploadsService, Broadcast, Channel, $uibModal, ConfirmDialog, Overlays, Facebook, Highlight, Caption, BandwidthTestClient, toaster, $analytics, $sce, $rootScope, BoxCaster, Recording, StaticRTMP) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, EventDetailController);

    this.$state = $state;
    this.$http = $http;
    this.$location = $location;
    this.AccountUploadsService = AccountUploadsService;
    this.Broadcast = Broadcast;
    this.$uibModal = $uibModal;
    this.ConfirmDialog = ConfirmDialog;
    this.Highlight = Highlight;
    this.BoxCaster = BoxCaster;
    this.Recording = Recording;
    this.Caption = Caption;
    this.BandwidthTestClient = BandwidthTestClient;
    this.Overlays = Overlays;
    this.toaster = toaster;
    this.$analytics = $analytics;
    this.$sce = $sce;
    this.$sanitize = $sanitize;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.account = $rootScope.account;
    this.user = $rootScope.user;
    this.sanitizeRTMPURL = __WEBPACK_IMPORTED_MODULE_11__utils_rtmp__["b" /* SanitizeRTMPURL */];
    this.StaticRTMP = StaticRTMP;
    this.fb = Facebook;
    this.queryParams = this.$location.search(); // XXX: this page now lives in Vue, hooray! so redirect all requests thataway.

    window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/broadcasts/").concat(window.location.hash.replace('#/events/', '')));
    return;

    if (this.queryParams.from_producer === 'true') {
      $timeout(function () {
        toaster.pop('success', 'Thank you for streaming with Producer');
      });
    }

    var ApiConfig = $rootScope.ApiConfig;
    var FeatureFlags = $rootScope.account.feature_flags;
    this.channelMap = {};
    this.channels = Channel.query({
      l: 1000
    }, function () {
      _this.channels.forEach(function (c) {
        return _this.channelMap[c.id] = c;
      });
    });
    this.enableScoreboardControls = false;
    this.showRtmpConfig = false;
    this.isTriCaster = navigator.userAgent.indexOf('Tricaster') > 0;
    this.activeOverlays = [];
    this.FeatureFlags = FeatureFlags;
    this.canCreate = this.user.can('create', 'broadcast');
    this.canEdit = this.user.can('update', 'broadcast/*');
    this.canUpload = this.user.can('create', 'broadcast/*:upload');
    this.sports = ApiConfig.stream.sports;
    this.hasAnalyticsFeature = !!FeatureFlags.analytics;
    this.allowEmbed = this.user.can('embed', 'broadcast/*');
    this.allowPromote = this.user.can('promote', 'broadcast/*') && !this.account.extra_features.media_token_restrictions;
    this.allowSimulatedLive = !!FeatureFlags.simulated_live;
    this.allowHighlights = this.user.can('list', 'broadcast/*:highlights');
    this.allowOverlays = FeatureFlags.overlays && this.user.can('update', 'broadcast/*:metadata/overlays');
    this.allowLiveAutomatedCaptioning = FeatureFlags.live_automated_captioning; // allowSocial is complicated... it will be determined after the broadcast is loaded in fixBroadcast() => computeAllowSocial()

    this.allowSocial = false;
    this.activeDestinationStatus = {};
    this.activeDestinationDetails = {};

    this.toggleActiveDestinationDetails = function (i) {
      _this.activeDestinationDetails[i] = !_this.activeDestinationDetails[i];
    };

    this.onStreamDiagnosticsReload = function (data) {
      // For static RTMP broadcasts, if stream diagnostics reports a change in standard, then reload the
      // static RTMP with diagnostics; this will update our source icon with the latest information.
      if (_this.broadcast && _this.broadcast.stream_source == 'rtmp' && _this.broadcast.static_rtmp_id) {
        var lastRTMPStandard = (_this.streamDiagnostics || {}).last_rtmp_standard || '';
        var newRTMPStandard = (data || {}).last_rtmp_standard || '';

        if (lastRTMPStandard != newRTMPStandard) {
          StaticRTMP.get({
            id: _this.broadcast.static_rtmp_id,
            include_diagnostics: true
          }, function (r) {
            _this.staticRTMPDiagnostics = r.diagnostics;
          });
        }
      }

      _this.streamDiagnostics = data; // reconcile active simulcast destinations against the stream diagnostics data

      if ((_this.broadcast || {}).simulcast_configurations) {
        _this.broadcast.simulcast_configurations.forEach(function (s, i) {
          var possibleConfiguredUrls = ["".concat(s.rtmps_url, "/").concat(s.stream_key), "".concat(s.rtmp_url, "/").concat(s.stream_key), s.fb_secure_stream_url, s.fb_stream_url];

          if (s.stream_url) {
            possibleConfiguredUrls.push("".concat(Object(__WEBPACK_IMPORTED_MODULE_11__utils_rtmp__["b" /* SanitizeRTMPURL */])(s.stream_url), "/").concat(encodeURIComponent(s.stream_key)));
          }

          if (data.data_version >= 3) {
            _.each(data.raw_stats.simulcast_frame_rate || {}, function (s, rtmpURL) {
              var sanitizedURL = Object(__WEBPACK_IMPORTED_MODULE_11__utils_rtmp__["b" /* SanitizeRTMPURL */])(rtmpURL);
              possibleConfiguredUrls.forEach(function (url) {
                if (sanitizedURL == url && !!s && !!s.video && s.video.length > 0) {
                  var fps = s.video[s.video.length - 1][1];
                  _this.activeDestinationStatus[i] = {
                    connected: fps > SIMULCAST_FPS_THRESHOLD,
                    fps: fps
                  };
                }
              });
            });
          } else {
            var influxSeries = data.raw_stats.results && data.raw_stats.results[4] && data.raw_stats.results[4].series || [];
            influxSeries.forEach(function (d) {
              var seriesUrl = (d.tags || {}).rtmp_url;
              possibleConfiguredUrls.forEach(function (url) {
                if (seriesUrl == url) {
                  var fps;
                  var values = d.values || [];

                  if (values.length > 1) {
                    fps = values[values.length - 2][1]; //2nd from last accounts for a "full" period
                  } else {
                    fps = (values[values.length - 1] || [0, 0])[1];
                  }

                  _this.activeDestinationStatus[i] = {
                    connected: fps > SIMULCAST_FPS_THRESHOLD,
                    fps: fps
                  };
                }
              });
            });
          }
        });
      }

      _this.computeBroadcastStatus();
    };

    if (this.user.can('list', 'broadcast/*:captions') && this.user.can('create', 'broadcast/*:caption') && this.user.can('read', 'broadcast/*:caption/*') && this.user.can('update', 'broadcast/*:caption/*')) {
      this.allowCaptions = true;
    }

    if (FeatureFlags.cue_points) {
      this.cue = {};
    }

    if (FeatureFlags.documents) {
      this.documents = {};
    }

    this.graphType = 'fine';

    if (this.allowOverlays) {
      this.loadUploadsForPage(1);
    }

    this.reload(true).then(function (res) {
      /**
       * Wait until after the broadcast has loaded, then check If the user has edit permissions
       * if so, open the edit dialog
       */
      if (_this.queryParams.action === 'open_edit') {
        _this.edit();
      }
    })["catch"](function (err) {
      console.error(err);
    }); // Support auto-reloading of page silently

    this._reloadHandle = $timeout(function () {
      return _this.reloadSilent();
    }, REFRESH_INTERVAL_MS);
    $scope.$on('$destroy', function () {
      $timeout.cancel(_this._reloadHandle);
      $timeout.cancel(_this._calculateRecordingUploadHandle);
      $timeout.cancel(_this._captionReloadHandle);

      _this.BandwidthTestClient.cancelIfInFlight();
    }); // Workaround for binding scope issue

    this.onOverlayChange = this.onOverlayChange.bind(this);
    this.saveOverlays = this.saveOverlays.bind(this);

    this.reloadPlayerMeta = function () {
      return $scope.$broadcast('boxcast:refreshMeta');
    };
  }

  _createClass(EventDetailController, [{
    key: "sanitizedDescription",
    get: function get() {
      return this.$sanitize(this.broadcast.description);
    } ///
    /// Recording Uploads
    ///

  }, {
    key: "canDownloadOrExport",
    get: function get() {
      var user = this.user; // If the user is not capable of creating any download or export, then don't show it

      if (user.cannot('create', 'recording/*:download') && user.cannot('create', 'recording/*:kaltura-export') && user.cannot('create', 'recording/*:vimeo-export') && user.cannot('create', 'recording/*:youtube-export')) {
        return false;
      } // If there's no transcoded recording, then don't show it.


      if (!this.recordingIsTranscoded) {
        return false;
      }

      return true;
    }
  }, {
    key: "recordingIsAvailable",
    get: function get() {
      return this.broadcast.timeframe === 'past' && (this.broadcast.stream_source === 'imported' || this.publicView && this.publicView.status && this.publicView.status === 'recorded');
    }
  }, {
    key: "storageIsExpired",
    get: function get() {
      return this.publicView && this.publicView.status && this.publicView.status === 'not_recorded' && _.contains(['expired', 'purged'], this.publicView.reason);
    }
  }, {
    key: "recordingUploadMostRecent",
    get: function get() {
      if (!this.recordingUploads || !this.recordingUploads.length) return null;
      return this.recordingUploads[0];
    }
  }, {
    key: "recordingUploadStatus",
    get: function get() {
      return (this.recordingUploadMostRecent || {}).status;
    }
  }, {
    key: "recordingUploadFailureReason",
    get: function get() {
      return (this.recordingUploadMostRecent || {}).failure_reason;
    }
  }, {
    key: "recordingUploadProgress",
    get: function get() {
      if (!this.recordingUploads || !this.recordingUploads.length) return null;
      if (this.recordingUploadStatus == 'failed') return null;
      return this.recordingUploads[0].progress;
    }
  }, {
    key: "recordingIsTranscoded",
    get: function get() {
      if (!this.broadcast) {
        return false;
      } else if (this.broadcast.recording_id && this.broadcast.recording_duration_seconds) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "recordingIsBeingUploaded",
    get: function get() {
      if (!this.broadcast) {
        return false;
      } else if (!this.broadcast.recording_id && this.broadcast.stream_source == 'imported') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "recordingIsBeingReplaced",
    get: function get() {
      if (!this.broadcast || !this.recordingUploads || !this.recordingUploads.length) {
        return false;
      } else if (this.broadcast.recording_id && ['created', 'uploaded', 'assigned', 'processing', 'failed'].indexOf(this.recordingUploadStatus) >= 0) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "recordingIsWaitingToBePublished",
    get: function get() {
      if (!this.broadcast || !this.recordingUploads || !this.recordingUploads.length) {
        return false;
      } else if (this.broadcast.recording_id && this.broadcast.stream_source == 'imported' && this.recordingUploadStatus == 'completed' && this.broadcast.is_private) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "recordingUploadStatusMessage",
    get: function get() {
      // Support normal upload workflow
      var s = this.recordingUploadStatus;
      if (!s) return null;

      if (s == 'failed') {
        var reason = this.recordingUploadFailureReason;

        if (reason == 'transcode_failed') {
          return "Video failed to process due to an error transcoding your video. Please verify the file is the correct format before trying again.";
        } else if (reason == 'internal_server_error') {
          return "Video failed to process due to an internal server error.";
        } else if (_.contains(reason, 'CannotStartContainerError') && _.contains(reason, 'ThrottlingException')) {
          return "Video failed to process due to an internal error allocating a server for processing the upload.";
        } else if (reason) {
          return "Video failed to process: ".concat(reason, ".");
        } else {
          return 'Video failed to process. Please verify the file is the correct format before trying again.';
        }
      }

      return {
        created: 'Video has not finished uploading',
        uploaded: 'Video is waiting to be processed',
        assigned: 'Video is about to be processed',
        processing: 'Video is being transcoded',
        completed: 'Video will be ready momentarily'
      }[s] || 'Video upload status is unknown';
    }
  }, {
    key: "recordingReplacementStatusMessage",
    get: function get() {
      var s = this.recordingUploadStatus;
      if (!s) return null;

      if (s == 'failed') {
        var reason = this.recordingUploadFailureReason;

        if (reason == 'transcode_failed') {
          return "Video failed to process due to an error transcoding your video. Please verify the file is the correct format before trying again.";
        } else if (reason == 'internal_server_error') {
          return "Video failed to process due to an internal server error.";
        } else if (_.contains(reason, 'CannotStartContainerError') && _.contains(reason, 'ThrottlingException')) {
          return "Replacement video failed to process due to an internal error allocating a server for processing the upload.";
        } else if (reason) {
          return "Replacement video failed to process: ".concat(reason, ".");
        } else {
          return 'Replacement video failed to process. Please verify the file is the correct format before trying again';
        }
      }

      return {
        created: 'Replacement video has not finished uploading',
        uploaded: 'Replacement video is waiting to be processed',
        assigned: 'Replacement video is about to be processed',
        processing: 'Replacement video is being transcoded',
        completed: 'Replacement video will be ready momentarily'
      }[s] || 'Replacement video upload status is unknown';
    }
  }, {
    key: "recordingProcessingEstimate",
    get: function get() {
      return Object(__WEBPACK_IMPORTED_MODULE_13__utils_uploads__["a" /* estimateProcessingTimeRemaining */])({
        broadcast: this.broadcast,
        upload: this.recordingUploadMostRecent
      });
    }
  }, {
    key: "emailMeWhenComplete",
    get: function get() {
      return ((this.broadcast || {}).metadata || {})['notify:uploaded_completed_email'] == this.user.email;
    },
    set: function set(val) {
      var _this2 = this;

      var user = this.user,
          Broadcast = this.Broadcast,
          toaster = this.toaster;
      var metadata = this.broadcast.metadata || {};

      if (val) {
        metadata['notify:uploaded_completed_email'] = user.email;
      } else {
        metadata['notify:uploaded_completed_email'] = undefined;
      }

      Broadcast.update({
        id: this.broadcast.id
      }, {
        metadata: metadata
      }, function (b) {
        return _this2.setBroadcast(b);
      }, function (e) {
        console.error(e);
        toaster.pop('warning', "Unable to add ".concat(user.email, " to notification for upload"));

        _this2.reloadSilent();
      });
    }
  }, {
    key: "showHighlights",
    get: function get() {
      return this.allowHighlights && (this.broadcast.recording_requested || this.broadcast.stream_source == 'imported') && (this.recordingIsTranscoded && !this.storageIsExpired || this.broadcast.timeframe == 'current');
    }
  }, {
    key: "producerBroadcastURL",
    get: function get() {
      return window.VUE_DASHBOARD_ROOT + '/producer/' + this.broadcast.id;
    }
  }, {
    key: "loadRecordingUploads",
    value: function loadRecordingUploads() {
      var _this3 = this;

      var $http = this.$http,
          toaster = this.toaster,
          $timeout = this.$timeout;
      $http.get("".concat(API_ROOT, "/account/broadcasts/").concat(this.$state.params.id, "/uploads")).then(function (response) {
        _this3.recordingUploads = response.data;
      }).then(function () {
        $timeout.cancel(_this3._calculateRecordingUploadHandle);

        if (_this3.recordingIsBeingUploaded || _this3.recordingIsBeingReplaced) {
          _this3._calculateRecordingUploadHandle = $timeout(function () {
            _this3.loadRecordingUploads();
          }, UPLOAD_PROGRESS_INTERVAL_MS);
        }
      })["catch"](function (e) {
        toaster.pop('warning', 'Could not load recording uploads');
      });
    }
  }, {
    key: "uploadReplacement",
    value: function uploadReplacement() {
      var _this4 = this;

      var $uibModal = this.$uibModal;
      $uibModal.open({
        template: __webpack_require__(405),
        controllerAs: 'vm',
        controller: __WEBPACK_IMPORTED_MODULE_5__modal_upload_event__["a" /* default */],
        size: 'lg',
        //  Prevent accidental close...
        backdrop: 'static',
        keyboard: false,
        resolve: {
          broadcast: function broadcast() {
            return _this4.broadcast;
          },
          highlights: function highlights() {
            return _this4.highlights;
          }
        }
      }).result.then(function (b) {
        _this4.reloadSilent();
      });
    }
  }, {
    key: "cancelUpload",
    value: function cancelUpload() {
      var _this5 = this;

      if (confirm('Do you wish to cancel this upload?')) {
        var $http = this.$http,
            toaster = this.toaster,
            $timeout = this.$timeout,
            recordingUploadMostRecent = this.recordingUploadMostRecent;
        $http.put("".concat(API_ROOT, "/account/broadcasts/").concat(this.$state.params.id, "/uploads/").concat(recordingUploadMostRecent.id), {
          status: 'canceled'
        }).then(function () {
          _this5.loadRecordingUploads();
        })["catch"](function (e) {
          toaster.pop('warning', 'Could not cancel upload. Please refresh and try again.');
        });
      }
    } ///
    /// Overlays
    ///

  }, {
    key: "loadUploadsForPage",
    value: function loadUploadsForPage(p) {
      var _this6 = this;

      var Overlays = this.Overlays,
          toaster = this.toaster;
      this.uploadsPromise = Overlays.loadOverlaysForPage(p).then(function (result) {
        _this6.uploads = result.uploads;
        _this6.uploadsPagination = result.pagination;
      })["catch"](function (err) {
        toaster.pop('warn', 'Unable to load overlay image gallery.');
      });
    }
  }, {
    key: "uploadOverlay",
    value: function uploadOverlay(file) {
      var _this7 = this;

      file.upload().then(function (result) {
        console.log('Overlay image uploaded', result);
        _this7.file = null;

        _this7.loadUploadsForPage(1);
      });
    }
  }, {
    key: "addOverlay",
    value: function addOverlay(upload) {
      var _this8 = this;

      var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var Overlays = this.Overlays,
          activeOverlays = this.activeOverlays,
          uploads = this.uploads,
          $rootScope = this.$rootScope,
          toaster = this.toaster;
      upload.__showOverlay = false;
      Overlays.prepareUploadForOverlay(upload).then(function (overlay) {
        if (replace) {
          uploads.forEach(function (u) {
            return u.__inUse = false;
          });

          while (activeOverlays.length) {
            activeOverlays.pop();
          }
        }

        activeOverlays.push(overlay);
        upload.__inUse = true;
        _this8.overlaysChanged = true;
      })["catch"](function (err) {
        console.error(err);
        toaster.pop('warn', 'Unable to select overlay image.');
      });
    }
  }, {
    key: "deleteUpload",
    value: function deleteUpload(upload) {
      var _this9 = this;

      var ConfirmDialog = this.ConfirmDialog,
          AccountUploadsService = this.AccountUploadsService,
          toaster = this.toaster;
      upload.__showOverlay = false;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Delete Image From Gallery',
        actionButtonClass: 'danger',
        headerText: 'Please Confirm',
        bodyText: 'Are you sure you want to delete this image from your gallery? It will no longer be accessible.'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        AccountUploadsService.deleteUpload(upload).then(function () {
          toaster.pop('success', 'The image was successfully deleted.');
        }).then(function () {
          _this9.loadUploadsForPage(1);
        })["catch"](function (error) {
          console.error(error);
          toaster.pop('warning', 'An error occurred while trying to delete the image. Please refresh and try again.');
        });
      });
    }
  }, {
    key: "removeOverlay",
    value: function removeOverlay(upload) {
      upload.__showOverlay = false;

      _.remove(this.activeOverlays, {
        url: upload.view_url
      });

      upload.__inUse = false;
      this.overlaysChanged = true;
    }
  }, {
    key: "onOverlayChange",
    value: function onOverlayChange(overlay, attrs) {
      var i = this.activeOverlays.indexOf(overlay);

      if (i < 0) {
        console.warn('Unable to locate changed overlay', overlay, 'in', this.activeOverlays);
        return;
      }

      _.assign(this.activeOverlays[i], attrs);

      this.overlaysChanged = true;
    }
  }, {
    key: "restoreOverlaysFromMetadata",
    value: function restoreOverlaysFromMetadata() {
      var _this10 = this;

      if (!this.allowOverlays) return;

      if (!this.overlaysChanged) {
        this.activeOverlays = angular.copy((this.broadcast.metadata || {}).overlays || []); //make copy so that we can restore later

        this.activeOverlays.forEach(function (o) {
          _this10.uploadsPromise.then(function () {
            _.where(_this10.uploads, {
              view_url: o.url
            }).forEach(function (u) {
              return u.__inUse = true;
            });
          });
        });
      }
    }
  }, {
    key: "discardOverlays",
    value: function discardOverlays() {
      this.overlaysChanged = false;
      this.uploads.forEach(function (u) {
        return u.__inUse = false;
      });
      this.restoreOverlaysFromMetadata();
    }
  }, {
    key: "saveOverlays",
    value: function saveOverlays() {
      var _this11 = this;

      var Broadcast = this.Broadcast,
          broadcast = this.broadcast,
          toaster = this.toaster;
      var metadata = broadcast.metadata || {};
      metadata.overlays = this.activeOverlays;
      this.overlaysSaving = true;
      Broadcast.update({
        id: this.broadcast.id
      }, {
        metadata: metadata
      }, function (b) {
        _this11.overlaysChanged = false;
        _this11.overlaysSaving = false;

        _this11.setBroadcast(b);

        toaster.pop('success', 'Overlay activated.');
      }, function (err) {
        _this11.overlaysSaving = false;
        console.error(err);
        toaster.pop('warning', "Unable to activate overlays. Please refresh and try again.");
      });
    } ///
    /// Cue Points
    ///

  }, {
    key: "addCue",
    value: function addCue() {
      var _this12 = this;

      var Broadcast = this.Broadcast;

      if (!this.cue.name) {
        this.toaster.pop('warning', 'Please enter a title for the video index entry');
        return;
      }

      var timestamp = this.clapprUtils.getCurrentTime();
      var segmentAndOffset = this.clapprUtils.getPlayerSegmentAndOffsetForTime(timestamp);
      console.log(segmentAndOffset);

      if (!segmentAndOffset) {
        this.toaster.pop('warning', 'Please make sure the start time is within the valid range of the video.');
        return;
      }

      var content_settings = this.broadcast.content_settings || {};
      content_settings.cues = angular.copy(content_settings.cues || []);
      content_settings.cues.push({
        name: this.cue.name,
        description: '',
        playback_start_time_fmt: Object(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* secondsToFormattedLabel */])(timestamp),
        // XXX: TODO: can we map to VOD timestamp when live?
        segment: segmentAndOffset[0],
        time_offset_in_segment: segmentAndOffset[1]
      });
      content_settings.cues = _.sortBy(content_settings.cues, 'playback_start_time_fmt');
      Broadcast.update({
        id: this.$state.params.id
      }, {
        content_settings: content_settings
      }).$promise.then(function (b) {
        _this12.toaster.pop('success', 'Saved video index entry');

        _this12.setBroadcast(b);

        _this12.reloadPlayerMeta();

        _this12.cue.name = '';
      })["catch"](function (err) {
        _this12.toaster.pop('warning', 'Unable to save video index entry, please check your entry and try again.');

        console.error(err);
      });
    }
  }, {
    key: "seekCue",
    value: function seekCue(c) {
      this.player.seek(Object(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formattedLabelToSeconds */])(c.playback_start_time_fmt));
      this.player.play();
    }
  }, {
    key: "deleteCue",
    value: function deleteCue(c) {
      var _this13 = this;

      var Broadcast = this.Broadcast;
      var idx = this.broadcast.content_settings.cues.indexOf(c);

      if (idx < 0) {
        this.toaster.pop('warning', 'Unable to delete video index entry, please refresh and try again.');
        return;
      }

      var cs = angular.copy(this.broadcast.content_settings);
      cs.cues.splice(idx, 1);
      Broadcast.update({
        id: this.$state.params.id
      }, {
        content_settings: cs
      }).$promise.then(function (b) {
        _this13.toaster.pop('success', 'Deleted video index entry');

        _this13.setBroadcast(b);

        _this13.reloadPlayerMeta();
      })["catch"](function (err) {
        _this13.toaster.pop('warning', 'Unable to delete video index entry, please refresh and try again.');

        console.error(err);
      });
    }
  }, {
    key: "editCue",
    value: function editCue(c) {
      var _this14 = this;

      var Broadcast = this.Broadcast;
      delete c.__enableEditMode;
      Broadcast.update({
        id: this.$state.params.id
      }, {
        content_settings: this.broadcast.content_settings
      }).$promise.then(function (b) {
        _this14.toaster.pop('success', 'Saved video index entry');

        _this14.setBroadcast(b);

        _this14.reloadPlayerMeta();
      })["catch"](function (err) {
        _this14.toaster.pop('warning', 'Unable to save video index entry, please check your entry and try again.');

        console.error(err);
      });
    } ///
    /// Documents
    ///

  }, {
    key: "saveDocument",
    value: function saveDocument(d, file) {
      var _this15 = this;

      var Broadcast = this.Broadcast,
          toaster = this.toaster;

      if (!file) {
        toaster.pop('warning', 'Please select a file');
        return;
      }

      if (!d || !d.name || !d.name.trim()) {
        toaster.pop('warning', 'Please enter a valid document name');
        return;
      }

      file.upload().then(function (result) {
        console.log('Document uploaded', result);
        var cs = angular.copy(_this15.broadcast.content_settings) || {};
        cs.documents = cs.documents || [];
        cs.documents.push({
          name: d.name,
          url: result.view_url
        });
        Broadcast.update({
          id: _this15.$state.params.id
        }, {
          content_settings: cs
        }).$promise.then(function (b) {
          toaster.pop('success', 'Successfully uploaded document');

          _this15.setBroadcast(b);

          _this15.newDocumentFile = null;
        }).then(function () {
          _this15.document = {};
        })["catch"](function (err) {
          toaster.pop('warning', 'Unable to upload document, please check your entry and try again.');
          console.error(err);
        });
      });
    }
  }, {
    key: "deleteDocument",
    value: function deleteDocument(d) {
      var _this16 = this;

      var Broadcast = this.Broadcast,
          ConfirmDialog = this.ConfirmDialog;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Remove Document',
        actionButtonClass: 'danger',
        headerText: 'Please Confirm',
        bodyText: 'Are you sure you want to remove this document from the broadcast?'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        var idx = _this16.broadcast.content_settings.documents.indexOf(d);

        if (idx < 0) {
          _this16.toaster.pop('warning', 'Unable to delete document, please check your entry and try again.');

          return;
        }

        var cs = angular.copy(_this16.broadcast.content_settings);
        cs.documents.splice(idx, 1);
        Broadcast.update({
          id: _this16.$state.params.id
        }, {
          content_settings: cs
        }).$promise.then(function (b) {
          _this16.toaster.pop('success', 'Deleted document');

          _this16.setBroadcast(b);
        })["catch"](function (err) {
          _this16.toaster.pop('warning', 'Unable to delete document, please check your entry and try again.');

          console.error(err);
        });
      });
    }
  }, {
    key: "editDocument",
    value: function editDocument(d) {
      var _this17 = this;

      var Broadcast = this.Broadcast;
      delete d.__enableEditMode;
      Broadcast.update({
        id: this.$state.params.id
      }, {
        content_settings: this.broadcast.content_settings
      }).$promise.then(function (b) {
        _this17.toaster.pop('success', 'Saved document');

        _this17.setBroadcast(b);
      })["catch"](function (err) {
        _this17.toaster.pop('warning', 'Unable to save document, please check your entry and try again.');

        console.error(err);
      });
    } ///
    /// Captions
    ///

  }, {
    key: "startCaptioning",
    value: function startCaptioning() {
      var _this18 = this;

      var upload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var Caption = this.Caption,
          toaster = this.toaster;
      var data = {
        source: 'on-demand'
      };

      if (upload != null) {
        data = {
          source: 'uploaded',
          status: 'complete',
          cues: upload.cues.map(function (c) {
            return {
              start_time: c.startTime,
              end_time: c.endTime,
              text: c.text,
              confidence: 1.0
            };
          })
        };
      }

      Caption.create({
        broadcast_id: this.broadcast.id
      }, data).$promise.then(function () {
        toaster.pop('success', 'Successfully started captioning.');

        _this18.safeReloadCaptions();
      })["catch"](function (err) {
        toaster.pop('warning', 'Unable to start captioning. Please refresh and try again.');
        console.error(err);
      });
    }
  }, {
    key: "safeReloadCaptions",
    value: function safeReloadCaptions() {
      var _this19 = this;

      var Caption = this.Caption,
          $timeout = this.$timeout,
          toaster = this.toaster;

      if (!this.allowCaptions) {
        return;
      }

      var CAPTION_RELOAD_INTERVAL_MS = 30000;
      this.loadingCaptions = true;
      Caption.query({
        broadcast_id: this.$state.params.id
      }, function (captions) {
        _this19.loadingCaptions = false;
        _this19.caption = null;

        _.each(captions, function (c) {
          if (c.recording_id === _this19.broadcast.recording_id) {
            _this19.caption = c;
          }
        });

        if (_this19.caption) {
          if (_this19.caption.status != 'completed' && _this19.caption.status != 'failed') {
            _this19._captionReloadHandle = $timeout(function () {
              return _this19.safeReloadCaptions();
            }, CAPTION_RELOAD_INTERVAL_MS);
          }

          if (_this19.caption.cues) {
            _this19.captionTranscipt = _this19.caption.cues.map(function (c) {
              return "".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* secondsToFormattedLabel */])(c.start_time), "   ").concat(c.text);
            }).join('\n');
          }
        }
      }, function (err) {
        console.error(err);
        _this19.loadingCaptions = false;
        toaster.pop('warning', 'Unable to load captions', 'There was an issue loading the captions for the broadcast. Please reload and try again.');
      });
    }
  }, {
    key: "downloadCaption",
    value: function downloadCaption(format) {
      var _this20 = this;

      var Caption = this.Caption,
          toaster = this.toaster;
      Caption.render({
        broadcast_id: this.$state.params.id,
        id: this.caption.id,
        format: format
      }, function (response) {
        var extension = format === 'text' ? 'txt' : 'vtt';
        var filename = _this20.$state.params.id + '_captions.' + extension;
        Object(__WEBPACK_IMPORTED_MODULE_10__utils_download__["a" /* forceBrowserDownload */])(URL.createObjectURL(response.blob), filename);
      }, function (err) {
        console.error(err);
        toaster.pop('warning', 'Unable to download captions', 'There was an issue downloading the captions for the broadcast. Please reload and try again.');
      });
    }
  }, {
    key: "canEnterProducer",
    get: function get() {
      var account = this.account;
      return account.feature_flags.producer;
    } ///
    /// RTMP
    ///

  }, {
    key: "canUsePreview",
    get: function get() {
      var account = this.account; // Low-latency preview is gated by feature flag PLUS browser-compatibility
      // Note that we're not feature-detecting Flash specifically (although we could)
      // because this allows us to advertise to desktop users who might only have
      // to install the flash plugin to get it to work.

      if (!account.extra_features.low_latency_preview) {
        return false;
      }

      if (navigator.userAgent.indexOf('iOS') >= 0 || navigator.userAgent.indexOf('Android') >= 0) {
        return false;
      }

      if ((this.broadcast || {}).actual_codec == 'hevc') {
        return false;
      }

      return !!(this.broadcast || {}).rtmp_preview_url;
    }
  }, {
    key: "configureRTMP",
    value: function configureRTMP() {
      if (this.broadcast.stream_source != 'rtmp' && this.broadcast.stream_source != 'switcher') {
        this.showRtmpConfig = false;
        return;
      }

      this.rtmpVideoParams = Object(__WEBPACK_IMPORTED_MODULE_0__broadcast_with_rtmp_controller__["b" /* resolutionForBroadcast */])(this.broadcast);
      this.rtmpVideoParams.framerate = 30;

      if (this.FeatureFlags.high_frame_rate && this.broadcast.target_high_frame_rate === true) {
        this.rtmpVideoParams.framerate = 60;
      }

      if (this.broadcast.static_rtmp_id || this.broadcast.rtmp_ingestion_url) {
        // If we have static RTMP, or API has already assigned the single-use address, go ahead
        // and show settings unless broadcast is already over.
        this.showRtmpConfig = this.broadcast.timeframe != 'past';
      } else {
        // For Generic RTMP, we won't have the RTMP config until at least pre-roll, but we also
        // need to take the extra step of making a stream.  Go ahead and try that as long as we're
        // eligible to based ont he timeframe. Note that static RTMP channels do this automagically.
        this.showRtmpConfig = false;
      }
    }
  }, {
    key: "_openRtmpModal",
    value: function _openRtmpModal(_encoderType) {
      var _this21 = this;

      var BandwidthTestClient = this.BandwidthTestClient;
      var RUN_TEST_EVERY_TIME = false; //useful for testing

      var showFullRTMPSettingsModal = function showFullRTMPSettingsModal() {
        _this21.$uibModal.open({
          template: __webpack_require__(406),
          controllerAs: 'vm',
          controller: __WEBPACK_IMPORTED_MODULE_0__broadcast_with_rtmp_controller__["a" /* default */],
          size: 'lg',
          resolve: {
            availableBandwidth: function availableBandwidth() {
              return _this21.availableBandwidth;
            },
            broadcast: function broadcast() {
              return _this21.broadcast;
            },
            encoderType: function encoderType() {
              return _encoderType;
            }
          }
        });
      };

      if (this.availableBandwidth && !RUN_TEST_EVERY_TIME) {
        showFullRTMPSettingsModal();
      } else {
        this.BandwidthTestClient.cancelIfInFlight();
        this.$uibModal.open({
          template: "\n        <div class=\"modal-header\">\n          <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n          <h3>Testing Bandwidth</h3>\n        </div>\n        <div class=\"modal-body text-center\">\n          <p>Please wait while we run a bandwidth test to determinte appropriate settings.</p>\n          <h1>\n            <small>ESTIMATED UPLOAD SPEED</small>\n            <span class=\"throb-in-progress\" style=\"display:inline-block;min-width:175px;text-align:right;font-weight:bold;\">\n              {{vm.estimatedBandwidth|bits}}ps\n            </span>\n          </h1>\n        </div>\n        ",
          controllerAs: 'vm',
          controller: function controller($uibModalInstance, $timeout) {
            'ngInject';

            var _this22 = this;

            this.close = function () {
              return $uibModalInstance.dismiss('cancel');
            };

            this.estimatedBandwidth = 0;

            this.onProgress = function (stats) {
              $timeout(function () {
                _this22.estimatedBandwidth = stats.estimatedBandwidth;

                if (isNaN(_this22.estimatedBandwidth) || _this22.estimatedBandwidth < 0) {
                  _this22.estimatedBandwidth = 0;
                }
              }, 0);
            };

            BandwidthTestClient.runTestOrUseRecentCached(this.onProgress, RUN_TEST_EVERY_TIME).then(function (result) {
              var delay = result.fromCache ? 0 : 1000;
              $timeout(function () {
                $uibModalInstance.close(result);
              }, delay);
            });
          },
          size: 'lg'
        }).result.then(function (result) {
          _this21.availableBandwidth = result.availableBandwidth;
          showFullRTMPSettingsModal();
        });
      }
    }
  }, {
    key: "tricaster",
    value: function tricaster() {
      this._openRtmpModal('TriCaster');
    }
  }, {
    key: "rtmp",
    value: function rtmp() {
      this._openRtmpModal('Other Encoder');
    } ///
    /// Misc
    ///

  }, {
    key: "showDiagnostics",
    get: function get() {
      if (!this.broadcast) return false;
      return this.broadcast.timeframe != 'future' && this.broadcast.stream_source != 'imported';
    }
  }, {
    key: "activeLiveAutomatedCaptions",
    get: function get() {
      // A broadcast has active live, automated captions if:
      //  - live automated captioning is allowed;
      //  - the broadcast requests captioning; and
      //  - the broadcast is current or preroll,
      if (!this.allowLiveAutomatedCaptioning) return false;
      if (!this.broadcast.requests_captioning) return false;
      return ['preroll', 'current'].indexOf(this.broadcast.timeframe) >= 0;
    }
  }, {
    key: "showCaptionsTab",
    get: function get() {
      // If captions aren't allowed, don't show the tab
      if (!this.allowCaptions) return false; // If recordingIsAvailable, then the user can do captions things, so show the tab.

      if (this.recordingIsAvailable) return true; // If we get here, the only reason to show the tab is if the broadcast has active live
      // automated captions and the user can edit the broadcast.

      return this.activeLiveAutomatedCaptions && this.canEdit;
    }
  }, {
    key: "showRecordingControls",
    get: function get() {
      return (this.canEdit || this.canCreate) && this.publicView && this.broadcast.timeframe == 'past' && !this.storageIsExpired || this.showReplayViaSimulatedLive;
    }
  }, {
    key: "showUploadReplacement",
    get: function get() {
      return this.canUpload && this.broadcast.timeframe == 'past' && this.broadcast.stream_source != 'recording' && !this.broadcast.do_not_record;
    }
  }, {
    key: "showEditHighlightClips",
    get: function get() {
      return this.showHighlights && this.recordingIsTranscoded;
    }
  }, {
    key: "showReplayViaSimulatedLive",
    get: function get() {
      return this.allowSimulatedLive && (this.broadcast.timeframe != 'past' || this.recordingIsAvailable && this.recordingIsV2a);
    }
  }, {
    key: "boxCasterStatusLabel",
    get: function get() {
      // get the status label CSS class ... only shown for future/current broadcasts
      if (!this.boxcaster) {
        return 'unknown';
      } // boxcaster statuses include:
      // * unregistered probing decommissioned (admin only)
      // * ready preparing_broadcast broadcasting
      // * offline
      // boxcaster warnings include:
      // * no_video_input updating_firmware
      // * none


      if (this.broadcast.timeframe == 'future') {
        // Future broadcasts are OK to be in strange states
        if (['broadcasting', 'preparing_broadcast', 'ready'].indexOf(this.boxcaster.status) >= 0) {
          return 'connected';
        } else {
          return 'unknown';
        }
      } else {
        // If the timeframe is current/preroll, it's a warning to be anything other than broadcasting/preparing
        if (['broadcasting', 'preparing_broadcast'].indexOf(this.boxcaster.status) >= 0) {
          if (this.boxcaster.next_broadcast_id != this.broadcast.id) {
            // Special case of "broadcasting" but with some *other* broadcast
            return 'warning';
          } else if (this.boxcaster.warning && this.boxcaster.warning != 'none') {
            return 'warning';
          } else {
            return 'connected';
          }
        } else {
          return 'warning';
        }
      }
    }
  }, {
    key: "diagnosticsIconStyle",
    value: function diagnosticsIconStyle(s, idx) {
      if (s.status === 'error') {
        return 'warning';
      } else if (this.activeDestinationStatus[idx] && this.activeDestinationStatus[idx].connected) {
        return 'connected';
      }

      return '';
    }
  }, {
    key: "setBroadcast",
    value: function setBroadcast(broadcast) {
      // If the broadcast is going from non-past to past and the captions tab is selected, select the
      // overview tab to avoid a goofy interim state in the captions tab.
      if (this.broadcast.timeframe !== 'past' && broadcast.timeframe === 'past' && this.activeTab === 'captions') {
        this.changeTab('');
      }

      this.broadcast = broadcast;
      this.fixBroadcast();
      this.computeBroadcastStatus();
    }
  }, {
    key: "reloadSilent",
    value: function reloadSilent() {
      var _this23 = this;

      var $timeout = this.$timeout,
          FeatureFlags = this.FeatureFlags;
      $timeout.cancel(this._reloadHandle);
      this.Broadcast.get({
        id: this.$state.params.id
      }, function (b) {
        _this23.setBroadcast(b);

        _this23._reloadHandle = $timeout(function () {
          return _this23.reloadSilent();
        }, REFRESH_INTERVAL_MS);
      }, function (error) {
        console.error('Unable to reload broadcast metadata, will try again.', error);
        _this23._reloadHandle = $timeout(function () {
          return _this23.reloadSilent();
        }, REFRESH_INTERVAL_MS);
      });
    }
  }, {
    key: "reload",
    value: function reload(firstTime) {
      var _this24 = this;

      return new Promise(function (resolve, reject) {
        var $timeout = _this24.$timeout,
            FeatureFlags = _this24.FeatureFlags;
        var id = _this24.$state.params.id;
        _this24.broadcast = _this24.Broadcast.get({
          id: id
        }, function (b) {
          _this24.setBroadcast(b);

          _this24.safeReloadCaptions();

          _this24.playerOptions = {
            autoplay: false,
            ticketId: _this24.ticketId,
            onLoadBroadcast: function onLoadBroadcast() {
              $timeout(function () {
                var SelectedBroadcastStore = boxcast.model.SelectedBroadcastStore;
                _this24.publicView = SelectedBroadcastStore.view;
                _this24.publicBroadcast = SelectedBroadcastStore.broadcast;

                _this24.computeBroadcastStatus(); // The first time this is loaded, if the captions tab was requested via URL and it's
                // now able to be shown (showCaptionsTab depends on publicView), select it.


                if (firstTime && _this24.$state.params.tab === 'captions' && _this24.showCaptionsTab) {
                  _this24.activeTab = _this24.$state.params.tab;
                }
              }, 0);
            },
            onRefresh: function onRefresh(SelectedBroadcastStore) {
              // Player refreshed its metadata; keep dashboard in sync
              _this24.reloadSilent();

              $timeout(function () {
                _this24.publicView = SelectedBroadcastStore.view;
                _this24.publicBroadcast = SelectedBroadcastStore.broadcast;

                _this24.computeBroadcastStatus();
              }, 0);
            },
            onLoadPlayer: function onLoadPlayer(player) {
              return $timeout(function () {
                _this24.player = player;
                _this24.clapprUtils = new __WEBPACK_IMPORTED_MODULE_7__utils_clappr__["a" /* default */](player);

                if (_this24.clapprUtils.isUsingHlsJs() && _this24.broadcast.recording_id) {
                  _this24.isUsingHlsJsOnRecording = true;
                }
              }, 0);
            }
          };

          if (_this24.broadcast.scoreboard_configuration && _this24.broadcast.scoreboard_configuration.sport && _this24.broadcast.scoreboard_configuration.scoreboard_make === 'Manual') {
            _this24.enableScoreboardControls = true;
          }

          if (firstTime) {
            if (_this24.$state.params.tab && _this24.$state.params.tab !== 'captions') {
              _this24.activeTab = _this24.$state.params.tab;
            }

            if (_this24.$state.params.action && _this24.$state.params.action === 'export' && _this24.canDownloadOrExport) {
              _this24.downloadOrExport();
            }

            _this24.fb.init();
          }

          resolve(b);
        }, function (error) {
          if (error && error.data && error.data.error == 'not_found') {
            // If broadcast was not found, kick them back to home screen
            _this24.$state.go('home');

            _this24.toaster.pop('warning', "Broadcast ".concat(id, " could not be found"));
          } else if (error && error.data && error.data.error == 'gone') {
            // If broadcast was deleted, kick them back to home screen
            _this24.$state.go('home');

            _this24.toaster.pop('warning', "Broadcast ".concat(id, " was deleted"));
          } else {
            console.error(error);

            _this24.toaster.pop('warning', "There was an error loading the broadcast. Please refresh the page and try again.", '', 0);
          }

          reject(error);
        });
        _this24.highlights = _this24.Highlight.query({
          broadcastId: _this24.$state.params.id,
          s: 'streamed_at'
        }, function (data, headers) {
          var pagination = JSON.parse(headers('x-pagination'));
          _this24.totalHighlights = pagination.total;
        });
        _this24.loadingPromises = [_this24.broadcast.$promise, _this24.highlights.$promise];
      });
    }
  }, {
    key: "computeAllowSocial",
    value: function computeAllowSocial() {
      var FeatureFlags = this.FeatureFlags,
          account = this.account,
          broadcast = this.broadcast;
      this.allowSocial = Object(__WEBPACK_IMPORTED_MODULE_6__utils_allow_social__["a" /* AllowSocial */])(FeatureFlags, account, broadcast);
    }
  }, {
    key: "computeBroadcastStatus",
    value: function computeBroadcastStatus() {
      this.broadcastStatus = Object(__WEBPACK_IMPORTED_MODULE_12__utils_stream_diagnostics__["b" /* ComputeBroadcastStatus */])(this.broadcast, this.publicView, this.boxcaster, this.streamDiagnostics, this.staticRTMPDiagnostics);
    }
  }, {
    key: "fixBroadcast",
    value: function fixBroadcast() {
      var _this25 = this;

      var canUpload = this.canUpload,
          BoxCaster = this.BoxCaster,
          Broadcast = this.Broadcast,
          Recording = this.Recording,
          StaticRTMP = this.StaticRTMP,
          $http = this.$http;
      this.ticketId = '.' + this.broadcast.admin_token;
      this.generateEmailLink();
      this.restoreOverlaysFromMetadata();
      this.configureRTMP();

      if (canUpload) {
        this.loadRecordingUploads();
      }

      var cs = this.broadcast.content_settings || {};

      if (cs.agenda_url && !cs.documents) {
        this.broadcast.content_settings.documents = [{
          name: 'Agenda',
          url: this.broadcast.content_settings.agenda_url
        }];
        delete this.broadcast.content_settings.agenda_url;
      }

      if (this.broadcast.stream_source == 'boxcaster' && this.broadcast.boxcaster_id) {
        BoxCaster.get({
          id: this.broadcast.boxcaster_id
        }, function (b) {
          _this25.boxcaster = b;

          _this25.computeBroadcastStatus();
        });
      }

      if (this.broadcast.stream_source == 'rtmp' && this.broadcast.static_rtmp_id) {
        StaticRTMP.get({
          id: this.broadcast.static_rtmp_id,
          include_diagnostics: true
        }, function (r) {
          _this25.staticRTMPDiagnostics = r.diagnostics;
        });
      }

      if (this.broadcast.stream_source === 'recording' && this.broadcast.source_broadcast_id) {
        if (!this.sourceBroadcast || this.sourceBroadcast.id !== this.broadcast.source_broadcast_id) {
          /**
           * We need to get the source broadcast if we have not already, or if the broadcast was edited and the source broadcast changed
           */
          Broadcast.get({
            id: this.broadcast.source_broadcast_id
          }, function (b) {
            _this25.sourceBroadcast = b;

            if (_this25.broadcast.timeframe !== 'past') {
              var durationSeconds = (_this25.sourceBroadcast || {}).recording_duration_seconds;

              if (durationSeconds) {
                _this25.broadcast.stops_at = moment(_this25.broadcast.starts_at).add(durationSeconds, 'seconds').toDate();
              }
            }
          }, function (e) {
            if (e.status === 404 || e.status === 410) {
              _this25.sourceBroadcastUnavailable = true;
            } else {
              console.error(e);
            }
          });
        } else if (this.broadcast.stops_at.indexOf('9999-12-31') === 0) {
          /**
           * this is not the functions first time running, so we already have the source broadcast, we just need to re-upate the stops_at to match source broadcast
           **/
          var durationSeconds = (this.sourceBroadcast || {}).recording_duration_seconds;

          if (durationSeconds) {
            this.broadcast.stops_at = moment(this.broadcast.starts_at).add(durationSeconds, 'seconds').toDate();
          }
        }
      }

      if (!this.simulatedLiveBroadcasts) {
        this.Broadcast.query({
          'filter.source_broadcast_id': this.broadcast.id,
          l: 1000,
          s: 'starts_at'
        }, function (results) {
          return _this25.simulatedLiveBroadcasts = results;
        }, function (e) {
          return console.error(e);
        });
      }

      if (this.broadcast.recording_id && !this.recordingSegments) {
        this.recordingSegments = Recording.segments({
          id: this.broadcast.recording_id
        }, function (segments) {
          return _this25.recordingIsV2a = _.some(segments, function (s) {
            return s.byte_ranges;
          });
        });
      }

      this.computeAllowSocial();
      var broadcastStartsAt = moment(this.broadcast.starts_at);
      var latestFacebookLiveScheduledEventTime = moment().add(7, 'days');
      this.canCreateFacebookLiveScheduledEvent = broadcastStartsAt < latestFacebookLiveScheduledEventTime; // Persist state values to allow 2-way binding separate from the computed properties

      this.showChatStateValue = this.showChat;
      this.enableCaptionsStateValue = this.enableCaptions;
    }
  }, {
    key: "youtubeEmbedUrl",
    value: function youtubeEmbedUrl(config) {
      return this.$sce.trustAsResourceUrl("https://www.youtube.com/embed/".concat(config.youtube_broadcast_id, "?autoplay=1"));
    }
  }, {
    key: "youtubeWatchUrl",
    value: function youtubeWatchUrl(config) {
      return this.$sce.trustAsResourceUrl("https://www.youtube.com/watch/".concat(config.youtube_broadcast_id));
    }
  }, {
    key: "periscopeWatchUrl",
    value: function periscopeWatchUrl(config) {
      return this.$sce.trustAsResourceUrl(config.share_url);
    }
  }, {
    key: "twitterWatchUrl",
    value: function twitterWatchUrl(config) {
      return this.$sce.trustAsResourceUrl(config.share_url);
    }
  }, {
    key: "canShowFacebookLiveProducerURL",
    value: function canShowFacebookLiveProducerURL(config) {
      // Can't show it if doesn't exist
      if (!config.live_producer_url) return false; // Can't show it if not logged in or for another user, as it won't work

      if (config.facebook_account_id != this.fb.facebook_account_id) return false; // Pretty sure the live producer page only works when the broadcast is scheduled

      return config.status == 'scheduled';
    }
  }, {
    key: "canShowFacebookPermalinkURL",
    value: function canShowFacebookPermalinkURL(config) {
      // Can't show it if it doesn't exist
      if (!config.permalink_url) return false; // XXX: https://developers.facebook.com/support/bugs/673296246903206/
      // XXX: https://www.facebook.com/business/help/2087325741287572?id=1123223941353904
      // The permalink_url doesn't actually go active until the live stream is live.

      return _.contains(['published', 'scheduled_live', 'stopping', 'stopped'], config.status);
    }
  }, {
    key: "createFacebookLiveScheduledEvent",
    value: function createFacebookLiveScheduledEvent(config) {
      var Broadcast = this.Broadcast,
          broadcast = this.broadcast,
          toaster = this.toaster;
      config.__updating = true;
      var promise = Broadcast.scheduleSimulcast({
        id: broadcast.id,
        simulcast_id: config.id
      }).$promise;
      promise.then(function (response) {
        _.assign(config, response);
      })["catch"](function (e) {
        console.error(e);
        toaster.pop('warning', 'Unable to schedule the Facebook Live event. Please check the status of your Facebook account on the settings page and try again.');
      })["finally"](function () {
        config.__updating = false;
      });
      this.loadingPromises.push(promise);
    }
  }, {
    key: "facebookLiveSimulcastFeedType",
    value: function facebookLiveSimulcastFeedType(config) {
      return config.fb_feed_id.split(':', 1)[0];
    }
  }, {
    key: "facebookLiveSimulcastFeedID",
    value: function facebookLiveSimulcastFeedID(config) {
      return config.fb_feed_id.replace(/^[^:]*:/, '');
    }
  }, {
    key: "createYouTubeEvent",
    value: function createYouTubeEvent(config) {
      var _this26 = this;

      var Broadcast = this.Broadcast,
          broadcast = this.broadcast,
          toaster = this.toaster;
      config.__updating = true;
      var promise = Broadcast.scheduleSimulcast({
        id: broadcast.id,
        simulcast_id: config.id
      }).$promise;
      promise.then(function (response) {
        _.assign(config, response);
      })["catch"](function (e) {
        console.error(e);

        _this26.toaster.pop('warning', 'Unable to create the linked YouTube event. Please check the status of your YouTube account on the settings page and try again.');
      })["finally"](function () {
        config.__updating = false;
      });
      this.loadingPromises.push(promise);
    }
  }, {
    key: "scheduleSimulatedLive",
    value: function scheduleSimulatedLive() {
      this.$state.go('new-event', {
        streamSource: 'recording',
        sourceBroadcastId: this.broadcast.id
      });
    }
  }, {
    key: "downloadOrExport",
    value: function downloadOrExport() {
      var $uibModal = this.$uibModal,
          _broadcast = this.broadcast,
          $analytics = this.$analytics;
      $uibModal.open({
        template: __webpack_require__(407),
        controllerAs: 'vm',
        controller: __WEBPACK_IMPORTED_MODULE_3__modal_download_or_export_recording__["a" /* default */],
        resolve: {
          broadcast: function broadcast() {
            return _broadcast;
          }
        }
      });
    }
  }, {
    key: "changeTab",
    value: function changeTab(newActiveTab) {
      if (newActiveTab != this.activeTab) {
        if (newActiveTab != '') {
          this.$location.search('tab', newActiveTab).replace();
        } else {
          this.$location.search('tab', null).replace();
        }
      }

      this.activeTab = newActiveTab;
    }
  }, {
    key: "edit",
    value: function edit() {
      var _this27 = this;

      var _activeTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var $uibModal = this.$uibModal,
          canEdit = this.canEdit;

      if (!canEdit) {
        console.warn('Not allowed to edit');
        return;
      }

      $uibModal.open({
        template: __webpack_require__(182),
        controller: 'EditEventController',
        controllerAs: 'vm',
        resolve: {
          broadcastId: function broadcastId() {
            return _this27.broadcast.id;
          },
          activeTab: function activeTab() {
            return _activeTab;
          }
        }
      }).result.then(function (broadcast) {
        //this.broadcast = broadcast;
        var params = {
          id: broadcast.id,
          tab: _activeTab
        };

        if (_this27.queryParams.action === 'open_edit') {
          // the broadcast edit dialog was saved, we dont want it to re-open after the update has succeeded
          params.action = null;
        } // Refresh entire state of page (e.g. scoreboard)


        _this27.$state.go('events.detail', params, {
          reload: true
        });
      });
    }
  }, {
    key: "openHighlight",
    value: function openHighlight(highlight) {
      var _this28 = this;

      var Highlight = this.Highlight,
          $uibModal = this.$uibModal;
      var highlightDetails = Highlight.get({
        broadcastId: this.broadcast.id,
        id: highlight.id
      });
      highlightDetails.$promise.then(function () {
        if (!_this28.broadcast.is_private && _this28.broadcast.is_ticketed && highlightDetails.duration > MAX_MONETIZED_HIGHLIGHT_TIME_S) {
          // Can't preview -- open the editor
          $uibModal.open({
            size: 'lg',
            backdrop: 'static',
            // don't allow accidental clicks on backdrop to close
            template: __webpack_require__(195),
            controllerAs: 'vm',
            controller: __WEBPACK_IMPORTED_MODULE_1__modal_capture_highlight_recorded__["a" /* default */],
            resolve: {
              highlightObj: function highlightObj() {
                return highlightDetails;
              },
              recordingId: function recordingId() {
                return _this28.broadcast.recording_id;
              }
            }
          });
        } else {
          // Open the preview
          var modalInstance = _this28.openHighlightPreviewModal(highlightDetails);

          modalInstance.closed.then(function () {
            // Refresh highlights in case the user deleted this one in the modal.
            _this28.highlights = _this28.Highlight.query({
              broadcastId: _this28.broadcast.id
            });
          });
        }
      });
    }
  }, {
    key: "openHighlightPreviewModal",
    value: function openHighlightPreviewModal(_highlightDetails) {
      var _this29 = this;

      var _showSave = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var $uibModal = this.$uibModal;
      return $uibModal.open({
        template: __webpack_require__(196),
        resolve: {
          broadcast: function broadcast() {
            return _this29.broadcast;
          },
          highlightDetails: function highlightDetails() {
            return _highlightDetails;
          },
          showSave: function showSave() {
            return _showSave;
          }
        },
        controller: __WEBPACK_IMPORTED_MODULE_4__modal_highlight_preview__["a" /* default */],
        controllerAs: 'vm',
        size: 'lg'
      });
    }
  }, {
    key: "openLowLatencyPreview",
    value: function openLowLatencyPreview() {
      this.preview = true;
    }
  }, {
    key: "onNewHighlightCaptured",
    value: function onNewHighlightCaptured() {
      this.toaster.pop('success', 'Highlight saved');
      this.highlights = this.Highlight.query({
        broadcastId: this.broadcast.id
      });
    }
  }, {
    key: "enterProducer",
    value: function enterProducer() {
      window.location.replace(this.producerBroadcastURL);
    }
  }, {
    key: "startASAP",
    value: function startASAP() {
      var _this30 = this;

      var Broadcast = this.Broadcast,
          ConfirmDialog = this.ConfirmDialog;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Start Now',
        actionButtonClass: 'success',
        headerText: 'Please Confirm',
        bodyText: 'Are you ready to go live with your broadcast now? This will make your broadcast go live to viewers as soon as possible.'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        var params = {
          starts_at: 'now'
        };

        if (!_this30.broadcast.source_broadcast_id) {
          // XXX: API will accidentally change the stops_at date because it is a function of
          // starts_at + duration (in minutes). So we need to remind it to keep it the same.
          params.stops_at = _this30.broadcast.stops_at;
        }

        Broadcast.update({
          id: _this30.broadcast.id
        }, params, function (b) {
          return _this30.reload();
        }, function (e) {
          console.error(e);
          alert('Error starting broadcast. Please reload this page and try again.');
        });
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this31 = this;

      var Broadcast = this.Broadcast,
          ConfirmDialog = this.ConfirmDialog;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Stop Broadcast',
        actionButtonClass: 'danger',
        headerText: 'Please Confirm',
        bodyText: 'Are you sure you want to stop this broadcast?'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        Broadcast.update({
          id: _this31.broadcast.id
        }, {
          stops_at: 'now'
        }, function () {
          _this31.reload();

          if (_this31.activeTab == 'captions') {
            _this31.changeTab('');
          }
        }, function () {
          return alert('Error stopping broadcast. Please reload this page and try again.');
        });
      });
    }
  }, {
    key: "generateEmailLink",
    value: function generateEmailLink() {
      var startDateTime = moment(this.broadcast.starts_at).format('dddd, MMMM Do [at] h:mma');
      var subject = escape("Invitation to ".concat(this.broadcast.name));
      var body = escape("Broadcast: ".concat(this.broadcast.name, "\n") + "Date: ".concat(startDateTime, "\n") + "\n" + "".concat(this.broadcast.description, "\n") + "\n" + "To view this event just click the link below:\n" + "".concat(this.broadcast.viewer_url, "\n") + "\n" + "If the above URL does not work try copying and pasting it into your browser.\n");
      this.emailLink = "mailto:?subject=".concat(subject, "&body=").concat(body);
    }
  }, {
    key: "embed",
    value: function embed() {
      var _this32 = this;

      var $uibModal = this.$uibModal;
      $uibModal.open({
        template: __webpack_require__(408),
        size: 'lg',
        controllerAs: 'vm',
        controller: __WEBPACK_IMPORTED_MODULE_2__embed_single_event_controller__["a" /* default */],
        resolve: {
          broadcast: function broadcast() {
            return _this32.broadcast;
          }
        }
      });
    }
  }, {
    key: "tweet",
    value: function tweet() {
      var url = escape(this.broadcast.viewer_url);
      var text = escape("Watch ".concat(this.broadcast.name, " online at"));
      window.open('http://twitter.com/share?url=' + url + '&text=' + text, 'Promote on Twitter', 'dependent=1,height=400,width=600,resizable=1');
    }
  }, {
    key: "facebook",
    value: function facebook() {
      // Use the graph API directly since we don't have proper opengraph
      // headers on our show page.
      // https://developers.facebook.com/docs/graph-api/reference/v2.4/post
      var previewImg = this.broadcast.preview;

      if (!previewImg) {
        previewImg = "".concat(IMG_ROOT, "boxcast_social_play_square.png");
      } // Use the "share" dialog (rather than "feed") so we can post into groups as well.
      // NOTE: the FB docs suggest that some of these params only work for "feed" but
      // they seem to work for share as well, so we're running with it!


      FB.ui({
        method: 'share',
        href: this.broadcast.viewer_url,
        name: this.broadcast.name,
        title: this.broadcast.name,
        description: this.broadcast.description,
        picture: Object(__WEBPACK_IMPORTED_MODULE_9__utils_broadcast__["a" /* ensureHttpOnProtocolRelativeUrl */])(previewImg),
        caption: 'BoxCast :: a smarter way to stream',
        type: 'video',
        display: 'popup'
      }, function (response) {});
    } ///
    /// BoxCaster Settings
    ///

  }, {
    key: "videoInputStandard",
    get: function get() {
      var d = this.streamDiagnostics || {}; // If BoxCaster has locked in, return that.  Otherwise, base it on the Box's preference to use SDI before HDMI before Composite

      if (d.locked_input == 'SDI') {
        return d.last_sdi_standard;
      } else if (d.locked_input == 'HDMI') {
        return d.last_hdmi_standard;
      } else if (d.locked_input == 'Composite2') {
        return d.last_composite_standard;
      } else {
        return d.last_sdi_standard || d.last_hdmi_standard || d.last_composite_standard || '';
      }
    }
  }, {
    key: "videoInputName",
    get: function get() {
      var d = this.streamDiagnostics || {}; // If BoxCaster has locked in, return that.  Otherwise, base it on the Box's preference to use SDI before HDMI before Composite

      if (d.locked_input == 'Composite2') {
        return 'RCA';
      } else if (d.locked_input) {
        return d.locked_input; //SDI or HDMI
      } else {
        return d.last_sdi_standard && 'SDI' || d.last_hdmi_standard && 'HDMI' || d.last_composite_standard && 'RCA' || '';
      }
    }
  }, {
    key: "streamingProfileName",
    get: function get() {
      var tp = (this.broadcast || {}).transcoder_profile || '';
      tp = tp.replace(/:.*/, '').replace('p60', 'p');

      if (tp == 'audio') {
        tp = 'Audio';
      }

      return tp;
    }
  }, {
    key: "lockedInputMismatchWarning",
    get: function get() {
      var d = this.streamDiagnostics || {};
      var locked = d.locked_standard;
      var current = this.videoInputStandard;

      if (!locked || !current || locked == current) {
        return false;
      } // Don't worry about framerate changes; only about resolution or interlaced/progressive


      function stripFramerate(r) {
        if (r.indexOf('i') >= 0) {
          return r.substring(0, r.indexOf('i') + 1);
        } else if (r.indexOf('p') >= 0) {
          return r.substring(0, r.indexOf('p') + 1);
        } else {
          return r;
        }
      }

      return stripFramerate(locked) != stripFramerate(current);
    }
  }, {
    key: "streamingProfileMatchesVideoInput",
    get: function get() {
      var is = this.videoInputStandard;
      var sp = this.streamingProfileName;

      if (!is || !sp) {
        return true; //don't bother warning if one of them doesn't exist yet
      }

      var inputRes = is.substring(0, is.indexOf('p')) || is.substring(0, is.indexOf('i')) || '';
      var transcodeRes = sp.substring(0, sp.indexOf('p')) || '';
      var hfr = (this.broadcast || {}).actual_high_frame_rate === true; // Check for same resolution

      if (inputRes != transcodeRes) {
        return false;
      } // Check for high framerate on p60/i60 input


      var framerate = is.match(/[0-9.]+$/);
      framerate = parseFloat(framerate && framerate[0], 10);
      var inputHighFramerate = framerate > 30 && !isNaN(framerate);

      if (inputHighFramerate && !hfr) {
        return false;
      }

      return true;
    } ///
    /// Static RTMP Settings
    ///

  }, {
    key: "staticRTMPStatusLabel",
    get: function get() {
      if (!this.staticRTMPDiagnostics || !this.staticRTMPDiagnostics.connected) {
        return 'unknown';
      }

      return 'connected';
    }
  }, {
    key: "staticRTMPStatus",
    get: function get() {
      var diagnostics = this.staticRTMPDiagnostics || {};

      if (diagnostics.broadcasting) {
        return 'Broadcasting';
      } else if (diagnostics.connected) {
        return 'Connected';
      } else if (diagnostics.connected === false) {
        return 'Offline';
      } else {
        return '';
      }
    }
  }, {
    key: "staticRTMPVideoInput",
    get: function get() {
      if (!this.staticRTMPDiagnostics || !this.staticRTMPDiagnostics.connected) {
        return '';
      }

      var height = this.staticRTMPDiagnostics.video_height;
      var width = this.staticRTMPDiagnostics.video_width;
      var frameRate = this.staticRTMPDiagnostics.frame_rate;

      if (height == 0 || width == 0 || frameRate == 0) {
        return '';
      }

      return width + 'x' + height + ', ' + frameRate + ' FPS';
    } ///
    /// Viewer Chat
    ///

  }, {
    key: "showChat",
    get: function get() {
      // A broadcast content_settings override always takes precedence
      if (this.showChatHasBroadcastOverride) {
        return this.broadcast.content_settings.showChat;
      }

      return this.account.content_settings.showChat;
    }
  }, {
    key: "showChatHasBroadcastOverride",
    get: function get() {
      return this.broadcast.content_settings.showChat !== undefined;
    }
  }, {
    key: "updateShowChat",
    value: function updateShowChat() {
      var _this33 = this;

      var Broadcast = this.Broadcast,
          toaster = this.toaster;
      Broadcast.get({
        id: this.broadcast.id
      }, function (b) {
        var cs = _objectSpread(_objectSpread({}, b.content_settings), {}, {
          showChat: _this33.showChatStateValue
        });

        Broadcast.update({
          id: _this33.broadcast.id
        }, {
          content_settings: cs
        }, function (b) {
          _this33.setBroadcast(b);

          toaster.pop('success', _this33.showChatStateValue ? 'Enabled chat' : 'Disabled chat');
        }, function (e) {
          console.error(e);
          toaster.pop('warning', "Unable to ".concat(_this33.showChatStateValue ? 'enable' : 'disable', " chat. Please refresh the page and try again."));

          _this33.reloadSilent();
        });
      });
    } ///
    /// Live captions
    ///

  }, {
    key: "enableCaptions",
    get: function get() {
      // If there's a value specified in the broadcast metadata, use it.
      var captionsConfiguration = this.broadcast.metadata.live_captions || {};

      if (captionsConfiguration.enabled !== undefined) {
        return captionsConfiguration.enabled;
      } // If there's nothing specified in the metadata, assume it's enabled.


      return true;
    }
  }, {
    key: "updateEnableCaptions",
    value: function updateEnableCaptions() {
      var _this34 = this;

      var Broadcast = this.Broadcast,
          toaster = this.toaster;
      Broadcast.get({
        id: this.broadcast.id
      }, function (b) {
        var md = _objectSpread(_objectSpread({}, b.metadata), {}, {
          live_captions: {
            enabled: _this34.enableCaptionsStateValue
          }
        });

        Broadcast.update({
          id: _this34.broadcast.id
        }, {
          metadata: md
        }, function (b2) {
          _this34.setBroadcast(b2);

          toaster.pop('success', _this34.enableCaptionsStateValue ? 'Enabled live captions' : 'Disabled live captions');
        }, function (e) {
          console.error(e);
          toaster.pop('warning', "Unable to ".concat(_this34.enableCaptionsStateValue ? 'enable' : 'disable', " live captions. Please refresh the page and try again."));

          _this34.reloadSilent();
        });
      });
    }
  }]);

  return EventDetailController;
}();



/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports = "[General]\nName={{streamName}}\n\n[Output]\nMode=Advanced\n\n[SimpleOutput]\nUseAdvanced=false\n\n[AdvOut]\nRescaleRes=2880x1800\nTrackIndex=1\nRecType=Standard\nRecRescaleRes=2880x1800\nRecTracks=1\nFFOutputToFile=true\nFFRescaleRes=2880x1800\nFFVEncoderId=0\nFFAEncoderId=0\nFFAudioTrack=1\nApplyServiceSettings=true\nFFFormat=\nFFFormatMimeType=\nFFVEncoder=\nFFAEncoder=\nTrack1Bitrate={{audioBitrateKbps}}\n\n[Video]\nBaseCX={{width}}\nBaseCY={{height}}\nOutputCX={{width}}\nOutputCY={{height}}\n"

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmbedSingleEventController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_embed__ = __webpack_require__(31);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var EmbedSingleEventController = /*#__PURE__*/function () {
  function EmbedSingleEventController(ApiConfig, Account, $rootScope, $scope, $uibModalInstance, broadcast) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, EmbedSingleEventController);

    this.$scope = $scope;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.$uibModalInstance = $uibModalInstance; // This is passed via `resolve`

    this.broadcast = broadcast; // Output of embed directive

    this.output = {
      type: 'single',
      embedType: 'javascript',
      channelId: this.broadcast.channel_id,
      broadcast: this.broadcast,
      title: true,
      description: true,
      related: false,
      args: {
        applyBrandColor: true,
        showTitleAndDescription: true,
        showTitle: true,
        showDescription: true,
        showHighlights: false,
        showRelated: false,
        showCountdown: true
      },
      embedCode: '',
      iframeCode: '',
      boxcastLink: '',
      boxcastTVLink: '',
      m3u8: this.broadcast.static_playlist_url,
      layout: 'player-and-title'
    };
    $scope.$watch(function () {
      return [_this.output.type, _this.output.channelId, _this.output.title, _this.output.description, _this.output.related, _this.output.args];
    }, function (newVal, oldVal) {
      var _newVal = _slicedToArray(newVal, 6),
          type = _newVal[0],
          channelId = _newVal[1],
          title = _newVal[2],
          description = _newVal[3],
          related = _newVal[4],
          args = _newVal[5];

      _this.output.embedCode = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v2WidgetEmbed(channelId, title, description, related);
      _this.output.embedCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3WidgetEmbed(channelId, args);
      _this.output.iframeCode = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v2IframeEmbed(channelId, title, description, related);
      _this.output.iframeCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3IframeEmbed(channelId, args);
      _this.output.linkCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Link(channelId, args);
      _this.output.appCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3App(channelId, args);
      _this.output.highlightsCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Highlights(channelId, args);
      _this.output.rss3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Rss(channelId, args);
      _this.output.audioMRSS3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3MRSS(channelId, 'audio', args);
      _this.output.videoMRSS3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3MRSS(channelId, 'video', args);
      _this.output.rokuDirectPublisher = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].rokuDirectPublisher(channelId, args);
      _this.output.audioPodcast3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Podcast(channelId, 'audio', args);
      _this.output.videoPodcast3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Podcast(channelId, 'video', args);
      _this.output.boxcastLink = BOXCAST_SHOW_URL + channelId;
      _this.output.boxcastTVLink = BOXCAST_TV_SHOW_URL + channelId;
    }, true);
    this.output.args.market = $rootScope.account.market;
  }

  _createClass(EmbedSingleEventController, [{
    key: "cancel",
    value: function cancel() {
      this.$uibModalInstance.dismiss('cancel');
    }
  }]);

  return EmbedSingleEventController;
}();



/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DownloadOrExportRecordingController;
function DownloadOrExportRecordingController($uibModalInstance, $scope, $timeout, $rootScope, toaster, Recording, VimeoUser, YouTubeUser, $analytics, broadcast) {
  'ngInject';

  var _this = this;

  this.hasVideo = broadcast.transcoder_profile !== 'audio';
  this.activeTab = this.hasVideo ? 'mp4' : 'm4a';
  this.unlock = {};
  this.allowKaltura = false;
  this.allowYoutube = false;
  this.allowVimeo = false;
  this.youtubeUsers = [];
  this.youtubeUserId = null;
  this.youtubeLicense = 'youtube';
  this.youtubePrivacy = 'private';
  this.vimeoUsers = [];
  this.vimeoUserId = null;
  this.allowKaltura = $rootScope.account.extra_features.kaltura;
  this.allowYoutube = !!$rootScope.account.feature_flags.youtube_export;
  this.allowVimeo = !!$rootScope.account.feature_flags.vimeo_export;

  if (this.allowYoutube) {
    this.youtubeUsers = YouTubeUser.query({
      l: 1000
    });
    this.youtubeUsers.$promise.then(function () {
      _this.youtubeUserId = (_.first(_this.youtubeUsers) || {}).id;
    });
  }

  if (this.allowVimeo) {
    this.vimeoUsers = VimeoUser.query({
      l: 1000
    });
    this.vimeoUsers.$promise.then(function () {
      _this.vimeoUserId = (_.first(_this.vimeoUsers) || {}).id;
    });
  }

  this.recording = {};
  this.$reloadRecordingTimeout = null;

  this.reloadRecording = function () {
    $timeout.cancel(_this.$reloadRecordingTimeout);
    Recording.get({
      id: broadcast.recording_id
    }, function (recording) {
      // On completion of an export, make sure we re-lock
      _.each(['kaltura', 'vimeo', 'youtube'], function (e) {
        if (_this.recording["".concat(e, "_export_status")] !== 'ready' && recording["".concat(e, "_export_status")] == 'ready') {
          delete _this.unlock[e];
        }
      });

      _this.recording = recording;
      _this.$reloadRecordingTimeout = $timeout(_this.reloadRecording, 5000);
    }, function (error) {
      console.error(error);
      toaster.pop('warning', 'Unable to fetch recording. Please try again.');

      _this.cancel();
    });
  };

  this.reloadRecording();
  $scope.$on('$destroy', function () {
    return $timeout.cancel(_this.$reloadRecordingTimeout);
  });

  this.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  this.canStart = function () {
    var processingStatuses = ['requesting', 'requested', 'awaiting_conversion'];

    var mp4DownloadInFlight = function mp4DownloadInFlight() {
      return _.contains(processingStatuses, _this.recording.download_status) || _.startsWith(_this.recording.download_status, 'processing:');
    };

    var m4aDownloadInFlight = function m4aDownloadInFlight() {
      return _.contains(processingStatuses, _this.recording.audio_download_status) || _.startsWith(_this.recording.audio_download_status, 'processing:');
    };

    var kalturaExportInFlight = function kalturaExportInFlight() {
      return _.contains(processingStatuses, _this.recording.kaltura_export_status) || _.startsWith(_this.recording.kaltura_export_status, 'processing:');
    };

    var vimeoExportInFlight = function vimeoExportInFlight() {
      return _.contains(processingStatuses, _this.recording.vimeo_export_status) || _.startsWith(_this.recording.vimeo_export_status, 'processing:');
    };

    var youtubeExportInFlight = function youtubeExportInFlight() {
      return _.contains(processingStatuses, _this.recording.youtube_export_status) || _.startsWith(_this.recording.youtube_export_status, 'processing:');
    };

    var exportInFlight = function exportInFlight() {
      return kalturaExportInFlight() || vimeoExportInFlight() || youtubeExportInFlight();
    };

    if (_this.activeTab === 'mp4') {
      return (!_this.recording.download_url || _this.recording.download_status == 'expired') && !mp4DownloadInFlight() && !exportInFlight();
    } else if (_this.activeTab === 'm4a') {
      return (!_this.recording.audio_download_url || _this.recording.audio_download_status == 'expired') && !m4aDownloadInFlight();
    } else if (_this.activeTab === 'kaltura') {
      return !mp4DownloadInFlight() && !kalturaExportInFlight();
    } else if (_this.activeTab === 'vimeo') {
      return !mp4DownloadInFlight() && !vimeoExportInFlight();
    } else if (_this.activeTab === 'youtube') {
      return !mp4DownloadInFlight() && !youtubeExportInFlight();
    }
  };

  this.changeTab = function (tabId) {
    _this.activeTab = tabId;
    _this.unlock = {};
  };

  this.start = function () {
    // the debounce in angular is dubious; just double-check here that we can start, and get out if we can't.
    if (!_this.canStart()) return;

    if (_this.activeTab === 'mp4') {
      _this.recording.download_status = 'requesting';
      Recording.prepareDownload({
        id: broadcast.recording_id
      }, function (response) {
        _this.recording.download_status = 'requested';
        console.log('Submitted request to download mp4...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.download_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to prepare mp4 download. Please try again.');
        $analytics.eventTrack('event-download', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'm4a') {
      _this.recording.audio_download_status = 'requesting';
      Recording.prepareDownload({
        id: broadcast.recording_id,
        audio_only: true
      }, function (response) {
        _this.recording.audio_download_status = 'requested';
        console.log('Submitted request to m4a download...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.audio_download_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to prepare m4a download. Please try again.');
        $analytics.eventTrack('event-download-audio', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'kaltura') {
      _this.recording.kaltura_export_status = 'requesting';
      Recording.startKalturaExport({
        id: broadcast.recording_id
      }, function (response) {
        _this.recording.kaltura_export_status = 'requested';
        console.log('Submitted request to export to kaltura...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.kaltura_export_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to export video. Please try again.');
        $analytics.eventTrack('event-kaltura-export', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'vimeo') {
      // This isn't documented, but Vimeo limits the name to 128 characters (PLATFORM-6277)
      var videoInfo = {
        name: broadcast.name.substr(0, 128),
        description: broadcast.description
      };
      _this.recording.vimeo_export_status = 'requesting';
      Recording.startVimeoExport({
        id: broadcast.recording_id,
        vimeo_user_id: _this.vimeoUserId,
        video_info: videoInfo
      }, function (response) {
        _this.recording.vimeo_export_status = 'requested';
        console.log('Submitted request to export to vimeo...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.vimeo_export_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to export video. Please try again.');
        $analytics.eventTrack('event-vimeo-export', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'youtube') {
      // https://developers.google.com/youtube/v3/docs/videos
      //
      // title (string): The video's title. The property value has a maximum length of 100 characters
      // and may contain all valid UTF-8 characters except < and >.
      //
      // description (string): The video's description. The property value has a maximum length of
      // 5000 bytes and may contain all valid UTF-8 characters except < and >.
      var _videoInfo = {
        snippet: {
          title: broadcast.name.replace(/</g, '[').replace(/>/g, ']').substr(0, 100),
          description: broadcast.description.replace(/</g, '[').replace(/>/g, ']').substr(0, 5000)
        },
        status: {
          privacyStatus: _this.youtubePrivacy,
          license: _this.youtubeLicense
        }
      };
      _this.recording.youtube_export_status = 'requesting';
      Recording.startYoutubeExport({
        id: broadcast.recording_id,
        youtube_user_id: _this.youtubeUserId,
        video_info: _videoInfo
      }, function (response) {
        _this.recording.youtube_export_status = 'requested';
        console.log('Submitted request to export to youtube...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.youtube_export_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to export video. Please try again.');
        $analytics.eventTrack('event-youtube-export', {
          category: 'error'
        });
      });
    }
  };

  this.status = function () {
    var s = null;

    if (_this.activeTab === 'mp4') {
      s = _this.recording.download_status;
    } else if (_this.activeTab === 'm4a') {
      s = _this.recording.audio_download_status;
    } else if (_this.activeTab === 'kaltura') {
      s = _this.recording.kaltura_export_status;
    } else if (_this.activeTab === 'vimeo') {
      s = _this.recording.vimeo_export_status;
    } else if (_this.activeTab === 'youtube') {
      s = _this.recording.youtube_export_status;
    }

    if (_.startsWith(s, 'processing:')) {
      s = 'processing';
    }

    return s;
  };

  this.statusPercent = function () {
    var p = 0;

    if (_this.activeTab === 'mp4' || _this.activeTab === 'm4a') {
      var s = null;

      if (_this.activeTab === 'mp4') {
        s = _this.recording.download_status;
      } else if (_this.activeTab === 'm4a') {
        s = _this.recording.audio_download_status;
      }

      if (s === 'ready') {
        p = 100;
      } else if (_.startsWith(s, 'processing:')) {
        p = parseInt(s.replace('processing:', ''), 10) || 0;
      }
    } else {
      // Compensate for fact that download-preparation is only first half of the battle.
      // Now that we have an MP4 in S3, we need to get it over to the social provider.
      var _s = null;

      if (_this.activeTab === 'kaltura') {
        _s = _this.recording.kaltura_export_status;
      } else if (_this.activeTab === 'vimeo') {
        _s = _this.recording.vimeo_export_status;
      } else if (_this.activeTab === 'youtube') {
        _s = _this.recording.youtube_export_status;
      }

      if (_s === 'ready') {
        p = 100;
      } else if (_.contains(['awaiting_conversion', 'requested'], _s)) {
        if (_this.recording.download_status === 'ready') {
          p = 50;
        } else if (_.startsWith(_this.recording.download_status, 'processing:')) {
          p = Math.round((parseInt(_this.recording.download_status.replace('processing:', ''), 10) || 0) / 2);
        }
      } else if (_.startsWith(_s, 'processing:')) {
        p = 50 + Math.round((parseInt(_s.replace('processing:', ''), 10) || 0) / 2);
      }
    }

    return p;
  };
}

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ModalUploadEventController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);
// State machine for creating a new broadcast from upload:
// 1. create backdated broadcast with stream_source: imported
// 2. POST to create new placeholder for upload slot on the broadcast
// 3. upload into the presigned URL given by #2
// 4. monitor progress of upload
// 5. poke API to update status of broadcast upload and initiate transcode
// 6. redirect to broadcast page to monitor transcode status

function ModalUploadEventController($uibModalInstance, $scope, $http, toaster, $timeout, $q, BandwidthTestClient, Broadcast, $rootScope, broadcast, highlights) {
  'ngInject';

  var _this = this;

  this.FeatureFlags = $rootScope.account.feature_flags;
  this.error = null;
  this.highlights = highlights;

  if (broadcast == null) {
    this.mode = 'new';
    broadcast = {
      name: ''
    };
  } else {
    this.mode = 'replacement';
  }

  this.maxDate = new Date(); // Fake the EditOrCreateEventService for this context

  this.yesterday = moment().add(-1, 'day').set({
    hour: 0,
    minute: 0,
    second: 0
  }).toDate();
  this.service = {
    broadcast: broadcast,
    startDate: moment(this.yesterday).clone().toDate(),
    startTime: moment(this.yesterday).clone().set({
      hour: 12,
      minute: 0,
      second: 0
    }).toDate(),
    maxBroadcastDurationHours: $rootScope.account.max_broadcast_duration_hrs,
    resolutionLimit: $rootScope.account.resolution_limit
  };
  this.file = null;

  var estimateUploadAndProcessingTime = function estimateUploadAndProcessingTime() {
    $timeout.cancel(_this._videoDurationPoll); // If we don't have an available bandwidth yet, clear the estimates and return

    if (!_this.availableBandwidth) {
      delete _this.uploadEstimateMs;
      delete _this.processingEstimateMs;
      return;
    }

    var bandwidth = _this.availableBandwidth; // If we don't have a file or size/duration yet, clear the estimates and return

    if (!_this.file || !_this.file.file || !_this.file.file.size) {
      delete _this.uploadEstimateMs;
      delete _this.processingEstimateMs;
      return;
    }

    var uploadSize = _this.file.file.size;

    if (!_this.file.videoDuration) {
      // Unfortunately it seems like $scope.$watch doesn't always fire when the videoDuration
      // property gets added. This is a little dirty, but kind of "polls" for the presence of that property
      delete _this.uploadEstimateMs;
      delete _this.processingEstimateMs;
      _this._videoDurationPoll = $timeout(estimateUploadAndProcessingTime, 250);
      return;
    }

    var videoDurationSeconds = _this.file.videoDuration; // bandwidth is in bps (bits per second), but uploadSize is bytes, so do math; also convert seconds to ms

    _this.uploadEstimateMs = uploadSize * 8.0 / bandwidth * 1000.0; // XXX: Here is where we could replace this logic with actual calls to the upload service to
    // get more accurate estimates. But for now, assume a couple minutes of overhead for task
    // assignment, spin-up, shutdown, daemon polling, etc.; and assume that processing duration
    // matches video duration.

    _this.processingEstimateMs = 2 * 60 * 1000 + // overhead
    videoDurationSeconds * 1000; // video duration
  };

  $scope.$on('$destroy', function () {
    return $timeout.cancel(_this._videoDurationPoll);
  }); // Start a bandwidth test in the background when this dialog opens

  BandwidthTestClient.runTestOrUseRecentCached().then(function (result) {
    if (result && result.success && result.availableBandwidth) {
      _this.availableBandwidth = result.availableBandwidth;
      estimateUploadAndProcessingTime();
    }
  });
  $scope.$on('$destroy', BandwidthTestClient.cancelIfInFlight); // Watch for file changes to estimate upload duration

  $scope.$watch(function () {
    return _this.file;
  }, estimateUploadAndProcessingTime);

  this.submit = function () {
    if (!_this.file) {
      _this.error = 'Please select a file.';
      return;
    }

    if (_this.mode == 'new' && (!_this.service.broadcast.name || !_this.service.startDate || !_this.service.startTime)) {
      _this.error = 'Please enter all required fields.';
      return;
    }

    var startDateTime = moment(_this.service.startDate).clone();
    startDateTime.set({
      hour: moment(_this.service.startTime).get('hour'),
      minute: moment(_this.service.startTime).get('minute'),
      second: 0
    });

    if (startDateTime.toDate() > _this.maxDate) {
      _this.error = 'Future dated broadcasts are not allowed';
      return;
    }

    _this.error = null;
    _this.submitting = true;
    var promise;

    if (_this.mode == 'new') {
      // Use <video> duration, rounded up to nearest minute, for at least 1 minute.
      var videoDurationSeconds = _this.file.videoDuration || 60 * 60; //assume 1hr

      var videoDurationMinutes = Math.max(1, Math.ceil(videoDurationSeconds / 60));
      _this.service.endTime = moment(_this.service.startTime).clone().add(videoDurationMinutes, 'minutes').toDate();

      if (_this.service.endTime > _this.maxDate) {
        _this.service.endTime = _this.maxDate;
      }

      var dates = Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(_this.service.startDate, _this.service.startTime, _this.service.endTime, _this.service.maxBroadcastDurationHours);

      if (moment(dates.stops_at).toDate() > _this.maxDate) {
        _this.submitting = false;
        _this.error = "Invalid broadcast date/time. Please set the start time earlier to avoid having the end in the future (computed video duration of ".concat(videoDurationMinutes, " minutes).");
        return;
      }

      var newBroadcast = Broadcast.save({
        name: _this.service.broadcast.name,
        starts_at: dates.starts_at,
        stops_at: dates.stops_at,
        stream_source: 'imported',
        is_private: true
      });
      promise = newBroadcast.$promise.then(function () {
        console.log('Broadcast saved, now uploading video', newBroadcast);
        return newBroadcast;
      });
    } else if (_this.mode == 'replacement') {
      // Replacement is much simpler; no need to create a new broadcast.
      promise = $q(function (res, _) {
        return res(broadcast);
      });
    } else {
      throw Error("Unsupported mode: ".concat(_this.mode));
    }

    promise.then(function (b) {
      broadcast = b;
      return _this.file.upload({
        broadcast_id: broadcast.id
      });
    }).then(function (response) {
      console.log('Upload completed', response);
      toaster.pop('success', 'Successfully uploaded broadcast');
      $uibModalInstance.close(broadcast);
    })["catch"](function (err) {
      _this.submitting = false;
      _this.error = 'An error occurred while trying to upload the broadcast.';
      console.error(err);
      toaster.pop('warning', 'An error occurred while trying to save the broadcast.', 'Please refresh and try again.', 0 //don't auto-timeout
      );
    });
  };

  this.cancel = function () {
    return $uibModalInstance.dismiss('cancel');
  };
}

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = estimateProcessingTimeRemaining;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
 // Assume (guess?) that we'll have a two-minute overhead for things like daemon polling, task
// assignment, startup, teardown, etc.

var PROCESSING_OVERHEAD_MS = 2 * 60 * 1000;

var estimatePreProcessingTimeRemaining = function estimatePreProcessingTimeRemaining(broadcast) {
  // Assume (guess?) that we'll have a two-minute overhead, followed by a transcode that
  // matches the broadcast duration
  var broadcastDurationMs = __WEBPACK_IMPORTED_MODULE_0_moment___default()(broadcast.stops_at).toDate().getTime() - __WEBPACK_IMPORTED_MODULE_0_moment___default()(broadcast.starts_at).toDate().getTime();
  return PROCESSING_OVERHEAD_MS + broadcastDurationMs;
};

var estimateCurrentProcessingTimeRemaining = function estimateCurrentProcessingTimeRemaining(broadcast, upload, now) {
  // If we're processing, balance the duration estimate with one based on the upload creation
  // time and completion percentage.
  var progressPercent = upload.progress || 0.0; // First, the estimate based on broadcast duration and percentage remaining

  var broadcastDurationMs = __WEBPACK_IMPORTED_MODULE_0_moment___default()(broadcast.stops_at).toDate().getTime() - __WEBPACK_IMPORTED_MODULE_0_moment___default()(broadcast.starts_at).toDate().getTime();
  var broadcastDurationEstimateMs = broadcastDurationMs * (100.0 - progressPercent) / 100.0; // Next, the estimate based on upload creation time and progress (if possible)

  var uploadProgressEstimateMs = null;

  if (progressPercent > 0.0) {
    if (upload.created_at) {
      var uploadCreatedAt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(upload.created_at).toDate().getTime();

      if (now > uploadCreatedAt) {
        var elapsed = now - uploadCreatedAt;
        var estimatedTotalDuration = elapsed * 100.0 / progressPercent;
        var estimatedCompletion = uploadCreatedAt + estimatedTotalDuration;
        uploadProgressEstimateMs = estimatedCompletion - now;
      }
    }
  }

  if (!uploadProgressEstimateMs) {
    // If this is null, just set it to broadcastDurationEstimateMs because progressPercent is
    // likely zero and the math is a wash
    uploadProgressEstimateMs = broadcastDurationEstimateMs;
  } // Calculate a weighted average of our two estimates (based on percentage complete)


  return broadcastDurationEstimateMs * (100.0 - progressPercent) / 100.0 + uploadProgressEstimateMs * progressPercent / 100.0;
};
/**
 * Estimate the amount of processing (transcoding) time remaining (in milliseconds) for a broadcast
 * with an upload.
 *
 * @param  {Object} opts An object containing the keys:
 *                       - broadcast: The broadcast object
 *                       - upload: The upload object
 * @return {Number}      The estimated processing time remaining, in milliseconds, or null if the
 *                       arguments don't make sense.
 */


function estimateProcessingTimeRemaining(opts) {
  var broadcast = opts.broadcast;
  var upload = opts.upload;

  if (!broadcast || !upload) {
    return null;
  }

  if (upload.status == 'uploaded' || upload.status == 'assigned') {
    return estimatePreProcessingTimeRemaining(broadcast);
  }

  if (upload.status == 'processing') {
    var now = opts.now || Date.now();
    return estimateCurrentProcessingTimeRemaining(broadcast, upload, now);
  } // Catch-all


  return null;
}

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body upload-modal\" style=\"padding:0\">\n  <form name=\"form\" role=\"form\">\n    <div class=\"row\">\n      <div class=\"col-sm-6 left-col\" style=\"padding:35px;\">\n        <upload-slot ng-model=\"vm.file\"\n                     slot-name=\"'broadcast'\"\n                     allow-image=\"false\"\n                     allow-video=\"true\"\n                     hide-stock-browse=\"true\"\n                     hide-recent-browse=\"true\"></upload-slot>\n        <span ng-if=\"vm.file.file && !vm.submitting\">\n          <p class=\"text-center text-info\" ng-hide=\"vm.uploadEstimateMs && vm.processingEstimateMs\">\n            Estimating uploading and processing time...\n          </p>\n          <p class=\"text-center text-info\" ng-show=\"vm.uploadEstimateMs && vm.processingEstimateMs\">\n            Estimated time to upload and process this file:<br>\n            {{ (vm.uploadEstimateMs + vm.processingEstimateMs) | remainingTime }}\n          </p>\n        </span>\n      </div>\n      <div class=\"col-sm-6 right-col\">\n        <div ng-hide=\"vm.submitting\">\n          <div style=\"position:absolute;right:30px;top:15px\">\n            <a href ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></a>\n          </div>\n          <h3 class=\"text-center\" style=\"margin-top:0\" ng-show=\"vm.mode == 'new'\">\n            Upload Broadcast\n          </h3>\n          <h3 class=\"text-center\" style=\"margin-top:0\" ng-show=\"vm.mode == 'replacement'\">\n            Broadcast Replacement\n          </h3>\n\n          <p style=\"font-weight:bold;margin-bottom:0\">\n            Recommended Upload Settings &nbsp;\n            <a title=\"Help documentation\" href=\"https://support.boxcast.com/en/articles/4235131\" target=\"_blank\"><i class=\"fa fa-question-circle help-block\"></i></a>\n          </p>\n          <table class=\"text-sm\" style=\"width:100%;;margin-bottom:15px;\">\n            <tr>\n              <th>Format:</th>\n              <td>MP4 or MOV</td>\n            </tr>\n            <tr>\n              <th>Quality:</th>\n              <td>\n                <span ng-show=\"vm.service.resolutionLimit >= 1080\">1080p at 7 Mbps</span>\n                <span ng-hide=\"vm.service.resolutionLimit >= 720\">720p at 3 Mbps</span>\n              </td>\n            </tr>\n            <tr>\n              <th>Video Codec:</th>\n              <td>H.264/AVC (High Profile) or H.265/HEVC.<br>Progressive scan (no interlacing).</td>\n            </tr>\n            <tr>\n              <th>Keyframe Interval:</th>\n              <td>One keyframe at least every 2s-10s</td>\n            </tr>\n            <tr>\n              <th>Audio Codec:</th>\n              <td>AAC, 44.1kHz or 48kHz</td>\n            </tr>\n          </table>\n\n          <div ng-if=\"vm.error\">\n            <div class=\"bg-danger text-danger text-center text-xs\" style=\"padding:5px;margin-bottom:15px;border:1px solid;\">\n              {{vm.error}}\n            </div>\n          </div>\n\n          <div ng-if=\"vm.mode != 'new'\">\n            <p class=\"help-block\">Once you click upload below, the video will begin processing.  The original\n            video will remain available until this replacement has been fully processed. Once the replacement\n            is fully processed, the original video\n            <span ng-show=\"vm.highlights.length > 0\">(and any highlight clips from it)</span> will be deleted\n            and the uploaded video will become active.</p>\n          </div>\n          <div ng-if=\"vm.mode == 'new'\">\n            <div class=\"form-group\" ng-class=\"(form.eventName.$invalid && vm.error ? 'has-error' : '')\">\n              <label for=\"eventName\">Broadcast Name</label>\n              <input type=\"text\" class=\"form-control\" name=\"eventName\" id=\"eventName\" ng-model=\"vm.service.broadcast.name\" required>\n            </div>\n            \n            <div class=\"row\">\n              <div class=\"col-sm-6\">\n                <div class=\"form-group\">\n                  <label>Broadcast Date</label>\n                  <p class=\"input-group\">\n                    <input type=\"text\" class=\"form-control\"\n                          uib-datepicker-popup\n                          ng-model=\"vm.service.startDate\"\n                          is-open=\"startDateOpened\"\n                          datepicker-options=\"{maxDate: vm.maxDate, showWeeks: false}\"\n                          ng-required=\"true\"\n                          close-text=\"Close\" />\n                    <span class=\"input-group-btn\">\n                      <button type=\"button\" class=\"btn btn-default\" ng-click=\"startDateOpened = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                  </p>\n                </div>\n              </div>\n              <div class=\"col-sm-6\">\n                <div class=\"form-group\">\n                  <label>Start Time</label>\n                  <time-picker ng-model=\"vm.service.startTime\"\n                               start-time=\"vm.yesterday\"\n                               scroll-item-into-focus=\"true\"></time-picker>\n                </div>\n              </div>\n\n              <div class=\"col-sm-12\" ng-show=\"vm.mode == 'new' && vm.FeatureFlags.simulated_live\">\n                <div class=\"text-info bg-info text-sm\" style=\"padding:10px; margin:15px 0; border:1px solid;\">\n                  <i class=\"fa fa-info-circle\"></i>\n                  If you are uploading this for a simulated live broadcast, choose an arbitrary date in the past;\n                  once the upload has been processed, you'll be able to use it as a \"source\" for a future simulated live broadcast.\n                </div>\n              </div>\n\n            </div>\n          </div>\n\n          <div class=\"row\" style=\"margin-top:15px\">\n            <div class=\"form-group col-sm-10\">\n              <button class=\"btn btn-block btn-success\" ng-click=\"vm.submit()\" ng-disabled=\"vm.submitting || !vm.file\">\n                <i class=\"fa fa-spin fa-spinner\" ng-show=\"vm.submitting\"></i>\n                Upload and Save Broadcast\n              </button>\n            </div>\n            <div class=\"col-sm-2 text-right\" style=\"line-height:34px\">\n              <a href ng-click=\"vm.cancel()\">Cancel</a>\n            </div>\n          </div>\n\n        </div>\n\n        <div ng-show=\"vm.submitting\">\n          <div class=\"text-info bg-info\" style=\"margin:50px 15px; padding:30px; border:1px solid\">\n            <h3>The broadcast is uploading...</h3>\n            <p>Please do not close this window.  You will be redirected to the broadcast details page once the upload\n            has completed.</p>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"vm.encoderType != 'TriCaster'\" class=\"modal-header\" style=\"border-bottom:0;padding-bottom:0;\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n\n  <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n    <li ng-class=\"!vm.activeTab ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.selectTab(null)\">RTMP Encoder Settings</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'obs' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.selectTab('obs')\">OBS Profile</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'fmle' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.selectTab('fmle')\">FMLE Configuration</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'wirecast' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.selectTab('wirecast')\">Wirecast Configuration</a>\n    </li>\n  </ol>\n</div>\n\n<!-- TriCaster custom logic ... remember, it's accessed from inside custom webview -->\n<div ng-if=\"vm.encoderType == 'TriCaster'\" class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">Broadcast from {{ vm.encoderType }}</h3>\n</div>\n<div class=\"modal-body\" ng-if=\"vm.encoderType == 'TriCaster'\">\n<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromise, message: 'Loading...', minDuration: 500}\">\n  <div class=\"bg-info text-info\" style=\"padding:10px; border:1px solid\">\n    You're all set! Your configuration file should automatically download. Simply choose \"BoxCast\" From your list of streaming configuration presets.\n  </div>\n  <p class=\"help-block\">\n    Your configuration file contains the following settings:\n  </p>\n  <table class=\"table\">\n    <tr>\n      <td>Video parameters</td>\n      <th>{{vm.width}}x{{vm.height}}, {{vm.frameRate}}fps</th>\n    </tr>\n    <tr>\n      <td>Audio parameters</td>\n      <th>Stereo (2-channel), 48 kHz sampling rate</th>\n    </tr>\n    <tr>\n      <td>Video bitrate</td>\n      <th>\n        {{vm.videoBitrateKbps}} kbps\n\n        <small class=\"pull-right\" style=\"font-weight:normal;opacity:0.8;\">Detected {{vm.availableBandwidth|bytes}}ps upload speed</small>\n      </th>\n    </tr>\n    <tr>\n      <td>Audio bitrate</td>\n      <th>{{vm.audioBitrateKbps}} kbps</th>\n    </tr>\n    <tr>\n      <td>Video codec</td>\n      <th>{{vm.codec}}</th>\n    </tr>\n    <tr>\n      <td>Audio codec</td>\n      <th>AAC</th>\n    </tr>\n    <tr>\n      <td>Rate control</td>\n      <th>CBR</th>\n    </tr>\n    <tr>\n      <td>RTMP URL</td>\n      <td>\n        <ul style=\"margin-bottom:0\">\n          <li>RTMP URL \n            <strong>{{vm.rtmpUrl}}</strong>\n            <button ng-if=\"clipboard.supported\"\n              class=\"btn btn-link\"\n              clipboard\n              text=\"vm.rtmpUrl\"\n              on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n              on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n              uib-tooltip=\"Copy the RTMP base URL to your clipboard\" tooltip-placement=\"bottom\"\n              style=\"padding:0;\">\n              <i class=\"fa fa-clipboard\" style=\"width:20px\"></i>\n            </button>\n          </li>\n          <li>Stream key \n            <strong>{{vm.streamKey}}</strong>\n            <button ng-if=\"clipboard.supported\"\n              class=\"btn btn-link\"\n              clipboard\n              text=\"vm.streamKey\"\n              on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n              on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n              uib-tooltip=\"Copy the stream key to your clipboard\" tooltip-placement=\"bottom\"\n              style=\"padding:0;\">\n              <i class=\"fa fa-clipboard\" style=\"width:20px\"></i>\n            </button>\n          </li>\n        </ul>\n      </td>\n    </tr>\n  </table>\n  <p class=\"text-center\">\n    <a class=\"btn btn-primary\" ng-href=\"{{ vm.xmlUrl }} \" download=\"{{ vm.xmlDownloadName }}\">Download Configuration File</a>\n  </p>\n</main>\n</div>\n\n<!-- FMLE tab -->\n<div class=\"modal-body\" ng-if=\"vm.activeTab == 'fmle'\" style=\"padding-top:0\">\n<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromise, message: 'Loading...', minDuration: 500}\">\n  <p class=\"help-block\" style=\"margin-top:0\">\n    To encode with Flash Media Live Encoder:\n  </p>\n  <ol>\n    <li>Download <a ng-href=\"{{ vm.xmlUrl }} \" download=\"{{ vm.xmlDownloadName }}\">the configuration XML file</a>.</li>\n    <li>Start Flash Media Live Encoder.</li>\n    <li>From the <em>File</em> menu, click <em>Open Profile</em>. Open the file you downloaded in step 1.</li>\n    <li>If you receive a <em>Profile Validation</em> warning, click <em>OK</em>.</li>\n    <li>Configure video inputs and any other settings you wish to customize.</li>\n    <li>Click <em>Start</em> to begin streaming.</li>\n  </ol>\n  <p class=\"text-center\">\n    <a class=\"btn btn-primary\" ng-href=\"{{ vm.xmlUrl }} \" download=\"{{ vm.xmlDownloadName }}\">Download Configuration File</a>\n  </p>\n</main>\n</div>\n\n\n<!-- OBS tab -->\n<div class=\"modal-body\" ng-if=\"vm.activeTab == 'obs'\" style=\"padding-top:0\">\n<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromise, message: 'Loading...', minDuration: 500}\">\n  <p class=\"help-block\" style=\"margin-top:0\">\n    To encode with Open Broadcaster Software:\n  </p>\n  <ol>\n    <li>Download <a ng-href=\"{{ vm.zipUrl }} \" download=\"{{ vm.zipDownloadName }}\">the profile zip file</a>.</li>\n    <li>Open OBS.</li>\n    <li>From the <em>File</em> menu, click <em>Show Profile Folder</em>.</li>\n    <li>Unzip the downloaded profile zip file and place the unzipped folder in the Profile Folder opened in the previous step.</li>\n    <li>Exit and restart OBS.</li>\n    <li>From the <em>Profile</em> menu, click on the <strong>{{ vm.broadcast.channel_id }}</strong> profile.\n    <li>Configure video inputs and any other settings you wish to customize.</li>\n    <li>Click <em>Start Streaming</em>.</li>\n  </ol>\n  <p class=\"text-center\">\n    <a class=\"btn btn-primary\" ng-href=\"{{ vm.zipUrl }} \" download=\"{{ vm.zipDownloadName }}\">Download Profile File</a>\n  </p>\n</main>\n</div>\n\n\n<!-- Generic RTMP Settings tab -->\n<div class=\"modal-body\" ng-if=\"!vm.activeTab\" style=\"padding-top:0\">\n<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromise, message: 'Loading...', minDuration: 500}\">\n  <h4 style=\"margin:0\">RTMP URL</h4>\n  <p style=\"margin:0 0 10px\" class=\"help-block\">\n    <small>Depending on your encoder, you may need to enter the URL and stream key separately.</small>\n  </p>\n\n  <div class=\"clearfix\">\n    <div class=\"pull-left\">\n      <p style=\"margin:0\">Server URL and Stream Key</p>\n      <div style=\"font-weight: bold; border:1px solid #ddd; border-radius:4px; padding:3px 12px;\">\n        {{vm.rtmpUrl}}/{{vm.streamKey}}\n        <button ng-if=\"clipboard.supported\"\n          class=\"btn btn-link\"\n          clipboard\n          text=\"vm.rtmpUrl + '/' + vm.streamKey\"\n          on-copied=\"toaster.pop('success', 'URL successfully copied')\"\n          on-error=\"toaster.pop('warning', 'URL could not be copied')\"\n          uib-tooltip=\"Copy the RTMP URL to your clipboard\" tooltip-placement=\"bottom\"\n          style=\"padding:0;\">\n          <i class=\"fa fa-clipboard\" style=\"width:20px\"></i>\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"clearfix\" style=\"margin:10px 0 30px\">\n    <div class=\"pull-left\">\n      <p style=\"margin:0\">Server URL</p>\n      <div style=\"font-weight: bold; border:1px solid #ddd; border-radius:4px; padding:3px 12px;\">\n        {{vm.rtmpUrl}}\n        <button ng-if=\"clipboard.supported\"\n          class=\"btn btn-link\"\n          clipboard\n          text=\"vm.rtmpUrl\"\n          on-copied=\"toaster.pop('success', 'URL successfully copied')\"\n          on-error=\"toaster.pop('warning', 'URL could not be copied')\"\n          uib-tooltip=\"Copy the RTMP URL to your clipboard\" tooltip-placement=\"bottom\"\n          style=\"padding:0;\">\n          <i class=\"fa fa-clipboard\" style=\"width:20px\"></i>\n        </button>\n      </div>\n    </div>\n    <div class=\"pull-left\" style=\"margin-left:10px\">\n      <p style=\"margin:0\">Stream Key</p>\n      <div style=\"font-weight: bold; border:1px solid #ddd; border-radius:4px; padding:3px 12px;\">\n        {{vm.streamKey}}\n        <button ng-if=\"clipboard.supported\"\n          class=\"btn btn-link\"\n          clipboard\n          text=\"vm.streamKey\"\n          on-copied=\"toaster.pop('success', 'Stream key successfully copied')\"\n          on-error=\"toaster.pop('warning', 'Stream key could not be copied')\"\n          uib-tooltip=\"Copy the Stream Key to your clipboard\" tooltip-placement=\"bottom\"\n          style=\"padding:0;\">\n          <i class=\"fa fa-clipboard\" style=\"width:20px\"></i>\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"pull-right\">\n    <small class=\"pull-right\" style=\"font-weight:normal;opacity:0.8;\">Detected {{vm.availableBandwidth|bytes}}ps upload speed</small>\n  </div>\n  <h4>Encoder Settings</h4>\n\n  <div class=\"row\">\n    <div class=\"col-sm-6\" style=\"padding-right:0\">\n      <table class=\"table\" style=\"border-bottom:1px solid #ddd;border-right:1px solid #ddd\">\n        <tr>\n          <td>Video parameters</td>\n          <th>{{vm.width}}x{{vm.height}}, {{vm.frameRate}}fps</th>\n        </tr>\n        <tr>\n          <td>Audio parameters</td>\n          <th>Stereo (2-channel)</th>\n        </tr>\n        <tr>\n          <td>Audio Sample Rate</td>\n          <th>44.1 kHz or 48 kHz</th>\n        </tr>\n        <tr>\n          <td>Rate control</td>\n          <th>CBR</th>\n        </tr>\n      </table>\n    </div>\n    <div class=\"col-sm-6\" style=\"padding-left:0\">\n      <table class=\"table\" style=\"border-bottom:1px solid #ddd\">\n        <tr>\n          <td>Video bitrate</td>\n          <th>\n            {{vm.videoBitrateKbps}} kbps\n\n            <i class=\"pull-right fa fa-question-circle\" style=\"opacity:0.4\"\n                uib-tooltip=\"The BoxCast server can handle variable bitrates, but please do not exceed\n                {{vm.maxVideoBitrate/1000000|number:1}} Mbps or we cannot guarantee that your stream will perform appropriately.\"\n                tooltip-append-to-body=\"true\"></i>\n\n            <span ng-if=\"(vm.videoBitrateKbps * 1000) < vm.minVideoBitrate\">\n              <i class=\"pull-right text-danger fa fa-warning\"\n                  uib-tooltip=\"Your available bandwidth is too low. For best performance, your network should be able to\n                  support a video bitrate of at least {{vm.minVideoBitrate/1000000|number:1}} Mbps for the selected resolution and frame rate.\"\n                  tooltip-append-to-body=\"true\"></i>\n            </span>\n          </th>\n        </tr>\n        <tr>\n          <td>Audio bitrate</td>\n          <th>{{vm.audioBitrateKbps}} kbps</th>\n        </tr>\n        <tr>\n          <td>Video codec</td>\n          <th>{{vm.codec}}</th>\n        </tr>\n        <tr>\n          <td>Audio codec</td>\n          <th>AAC</th>\n        </tr>\n      </table>\n    </div>\n  </div>\n</main>\n</div>\n\n\n<!-- Wirecast tab -->\n<div class=\"modal-body\" ng-if=\"vm.activeTab == 'wirecast'\" style=\"padding-top:0\">\n<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromise, message: 'Loading...', minDuration: 500}\">\n  <p class=\"help-block\" style=\"margin-top:0\">\n    First, follow the one-time setup instructions at:\n    <br>\n    <a href=\"https://support.boxcast.com/en/articles/4235188\" target=\"_blank\">\n      https://support.boxcast.com/en/articles/4235188\n      <i class=\"fa fa-external-link\"></i> \n    </a>\n  </p>\n  <p class=\"help-block\">\n    To encode with Wirecast:\n    <ul>\n      <li>Within Wirecast, click <em>Output</em>, then <em>Output Settings...</em></li>\n      <li>In the <em>Destination</em> box, choose <em>BoxCast</em> and click <em>OK</em>.</li>\n      <li>From the <em>Encoding</em> box, choose <strong>{{ vm.encodingSelection }}</strong>.</li>\n      <li>In the <em>Username</em> box, enter <strong>{{ user.email }}</strong> and click <em>Authenticate</em>.</li>\n      <li>In the popup box, enter your BoxCast password and click <em>OK</em>.</li>\n      <li>In the <em>Channel:</em> box, choose <strong>{{ vm.streamName }}</strong>.</li>\n      <li>Click <em>OK</em>.</li>\n      <li>Activate streaming within Wirecast by selecting <em>Output</em> -> <em>Start / Stop Broadcasting</em> -> <em>Start All</em>\n          or <em>Start BoxCast: {{ vm.streamName }}</em></li>\n    </ul>\n  </p>\n  <p class=\"help-block\">\n    Alternatively, for more control over the streaming parameters, follow the <b>RTMP Encoder Settings</b>,\n    using Wirecast's <b>RTMP Server</b> output.\n  </p>\n</main>\n</div>\n"

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\" style=\"border-bottom:0;padding-bottom:0;\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n\n  <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n    <li ng-class=\"vm.activeTab == 'mp4' ? 'active' : ''\" ng-if=\"vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('mp4')\">Download</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'youtube' ? 'active' : ''\" ng-if=\"vm.allowYoutube && vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('youtube')\">YouTube</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'vimeo' ? 'active' : ''\" ng-if=\"vm.allowVimeo && vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('vimeo')\">Vimeo</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'kaltura' ? 'active' : ''\" ng-if=\"vm.allowKaltura && vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('kaltura')\">Kaltura</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'm4a' ? 'active' : ''\">\n      <a href ng-click=\"vm.changeTab('m4a')\">Audio</a>\n    </li>\n  </ol>\n\n</div>\n<div class=\"modal-body\" style=\"padding-top:0\" ng-show=\"vm.recording.id\">\n\n  <!-- download mp4 -->\n  <div ng-if=\"vm.activeTab == 'mp4'\">\n    <p class=\"help-block\">\n      <small>\n        Recordings can be downloaded in MP4 (video+audio) format. This process can take a few minutes while we convert your recording to the proper format.\n      </small>\n    </p>\n    <div class=\"form-group text-center\">\n      <button class=\"btn btn-default\"\n        ng-hide=\"vm.recording.download_url && vm.status() != 'expired'\"\n        ng-disabled=\"!vm.canStart()\"\n        ng-click=\"vm.start()\">\n        <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n        Generate Download\n      </button>\n      <a class=\"btn btn-success\"\n        download\n        ng-show=\"vm.recording.download_url && vm.status() != 'expired'\"\n        ng-href=\"{{vm.recording.download_url}}\">\n        <i class=\"fa fa-download\"></i>\n        Download Video\n      </a>\n      <button type=\"button\" class=\"btn btn-link\"\n        ng-if=\"clipboard.supported\"\n        ng-show=\"vm.recording.download_url && vm.status() != 'expired'\"\n        clipboard\n        text=\"vm.recording.download_url\"\n        on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n        on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n        uib-tooltip=\"Copy the MP4 link to your clipboard\" tooltip-placement=\"bottom\">\n        <i class=\"fa fa-copy\" style=\"width:20px\"></i>\n        Copy Video Link\n      </button>\n    </div>\n  </div>\n\n  <!-- download m4a -->\n  <div ng-if=\"vm.activeTab == 'm4a'\">\n    <p class=\"help-block\">\n      <small>\n        Recordings can be downloaded in M4A (audio-only) format. This process can take a few minutes while we convert your recording to the proper format.\n      </small>\n    </p>\n    <div class=\"form-group text-center\">\n      <button class=\"btn btn-default\"\n        ng-hide=\"vm.recording.audio_download_url && vm.status() != 'expired'\"\n        ng-disabled=\"!vm.canStart()\"\n        ng-click=\"vm.start()\">\n        <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n        Generate Download\n      </button>\n      <a class=\"btn btn-success\"\n        download\n        ng-show=\"vm.recording.audio_download_url && vm.status() != 'expired'\"\n        ng-href=\"{{vm.recording.audio_download_url}}\">\n        <i class=\"fa fa-download\"></i>\n        Download Audio\n      </a>\n      <button type=\"button\" class=\"btn btn-link\"\n        ng-if=\"clipboard.supported\"\n        ng-show=\"vm.recording.audio_download_url && vm.status() != 'expired'\"\n        clipboard\n        text=\"vm.recording.audio_download_url\"\n        on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n        on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n        uib-tooltip=\"Copy the M4A link to your clipboard\" tooltip-placement=\"bottom\">\n        <i class=\"fa fa-copy\" style=\"width:20px\"></i>\n        Copy Audio Link\n      </button>\n    </div>\n  </div>\n\n  <!-- youtube -->\n  <div ng-if=\"vm.activeTab == 'youtube'\">\n    <p class=\"help-block\">\n      <small>\n        Recordings can be exported to YouTube. This process can take a few minutes while we convert your recording\n        to the proper format and then send it to YouTube.\n      </small>\n    </p>\n    <div ng-hide=\"vm.youtubeUsers.length\">\n      <p>\n        There are no linked YouTube accounts.\n        Please <a ui-sref=\"settings.youtube\" ng-click=\"vm.cancel()\">link your YouTube account</a> before attempting to export.\n      </p>\n    </div>\n    <div ng-show=\"vm.youtubeUsers.length && (vm.recording.youtube_export_status != 'ready' || vm.unlock.youtube)\">\n      <div class=\"form-group\">\n        <label for=\"youtube_user\">Export As User</label>\n        <select class=\"form-control\" id=\"youtube_user\" ng-model=\"vm.youtubeUserId\" ng-disabled=\"!vm.canStart()\" required>\n          <option ng-repeat=\"u in vm.youtubeUsers\" value=\"{{u.id}}\">{{u.display_name}}</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"youtube_license\">License</label>\n        <select class=\"form-control\" id=\"youtube_license\" ng-model=\"vm.youtubeLicense\" ng-disabled=\"!vm.canStart()\" required>\n          <option value=\"youtube\" ng-selected=\"true\">YouTube</option>\n          <option value=\"creativeCommon\">Creative Commons</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"youtube_privacy\">Privacy Status</label>\n        <select class=\"form-control\" id=\"youtube_privacy\" ng-model=\"vm.youtubePrivacy\" ng-disabled=\"!vm.canStart()\" required>\n          <option value=\"private\" ng-selected=\"true\">private</option>\n          <option value=\"public\">public</option>\n          <option value=\"unlisted\">unlisted</option>\n        </select>\n      </div>\n      <div class=\"form-group text-center\">\n        <button class=\"btn btn-default overflow-ellipse\"\n          ng-disabled=\"!vm.canStart()\"\n          ng-click=\"vm.start()\"\n          analytics-on analytics-event=\"event-edit\" analytics-category=\"youtube-export\" analytics-label=\"\">\n          <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n          <i class=\"fa fa-youtube-play\" style=\"width:20px\"></i>\n          Export To YouTube\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <!-- vimeo -->\n  <div ng-if=\"vm.activeTab == 'vimeo'\">\n    <p class=\"help-block\">\n      <small>\n        Recordings can be exported to Vimeo. This process can take a few minutes while we convert your recording\n        to the proper format and then send it to Vimeo.\n      </small>\n    </p>\n    <div ng-hide=\"vm.vimeoUsers.length\">\n      <p>\n        There are no linked Vimeo accounts.\n        Please <a ui-sref=\"settings.vimeo\" ng-click=\"vm.cancel()\">link your Vimeo account</a> before attempting to export.\n      </p>\n    </div>\n    <div ng-show=\"vm.vimeoUsers.length && (vm.recording.vimeo_export_status != 'ready' || vm.unlock.vimeo)\">\n      <div class=\"form-group\">\n        <label for=\"vimeo_user\">Export As User</label>\n        <select class=\"form-control\" id=\"vimeo_user\" ng-model=\"vm.vimeoUserId\" ng-disabled=\"!vm.canStart()\" required>\n          <option ng-repeat=\"u in vm.vimeoUsers\" value=\"{{u.id}}\">{{u.display_name}}</option>\n        </select>\n      </div>\n      <div class=\"form-group text-center\">\n        <button class=\"btn btn-default overflow-ellipse\"\n          ng-disabled=\"!vm.canStart()\"\n          ng-click=\"vm.start()\"\n          analytics-on analytics-event=\"event-edit\" analytics-category=\"vimeo-export\" analytics-label=\"\">\n          <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n          <i class=\"fa fa-vimeo\" style=\"width:20px\"></i>\n          Export To Vimeo\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <!-- kaltura -->\n  <div ng-if=\"vm.activeTab == 'kaltura'\">\n    <p class=\"help-block\">\n      <small>\n        Recordings can be exported to Kaltura. This process can take a few minutes while we convert your recording\n        to the proper format and then send it to Kaltura.\n      </small>\n    </p>\n    <div class=\"form-group text-center\" ng-show=\"(vm.recording.kaltura_export_status != 'ready' || vm.unlock.kaltura)\">\n      <button class=\"btn btn-default overflow-ellipse\"\n        ng-disabled=\"!vm.canStart()\"\n        ng-click=\"vm.start()\"\n        analytics-on analytics-event=\"event-edit\" analytics-category=\"kaltura-export\" analytics-label=\"\">\n        <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n        Export To Kaltura\n      </button>\n    </div>\n  </div>\n\n  <!-- status messaging -->\n  <div ng-switch=\"vm.status()\">\n    <div ng-switch-when=\"expired|unprocessed\" ng-switch-when-separator=\"|\">\n      <!-- nobody has requested this yet, or the previous one expired -->\n    </div>\n    <div ng-switch-when=\"requesting\">\n      <p class=\"text-center\">\n        <em>Loading...</em>\n      </p>\n    </div>\n    <div ng-switch-when=\"awaiting_conversion|processing|requested\" ng-switch-when-separator=\"|\">\n      <p class=\"text-center\">\n        Your request is processing. Feel free to close this window and come back later.\n      </p>\n      <uib-progressbar value=\"vm.statusPercent()\" max=\"100\">\n        {{vm.statusPercent()}}% Complete\n      </uib-progressbar>\n      <p class=\"text-center\">\n        <em><random-waiting-message interval=\"5000\"></random-waiting-message></em>\n      </p>\n    </div>\n    <div ng-switch-when=\"ready\">\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'mp4' || vm.activeTab == 'm4a'\">\n        Your download is ready!\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'kaltura' && !vm.unlock.kaltura\">\n        The video has been successfully exported to Kaltura.<br>\n        <button class=\"btn btn-link\" ng-click=\"vm.unlock.kaltura = true\"><small>Export this video again.</small></button>\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'vimeo' && !vm.unlock.vimeo\">\n        The video has been successfully exported to Vimeo.<br>\n        Look for an email from Vimeo or visit <a href=\"https://vimeo.com/home/myvideos\" target=\"_blank\">My Videos</a> for next steps.<br>\n        <button class=\"btn btn-link\" ng-click=\"vm.unlock.vimeo = true\"><small>Export this video again.</small></button>\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'youtube' && !vm.unlock.youtube\">\n        The video has been successfully exported to YouTube.<br>\n        Look for an email from YouTube or visit your <a href=\"https://www.youtube.com/my_videos\" target=\"_blank\">Video Manager</a> for next steps.<br>\n        <button class=\"btn btn-link\" ng-click=\"vm.unlock.youtube = true\"><small>Export this video again.</small></button>\n      </p>\n    </div>\n    <div ng-switch-when=\"failed\">\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'mp4' || vm.activeTab == 'm4a'\">\n        <i class=\"fa fa-warning\"></i>\n        The download request failed.\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'kaltura'\">\n        <i class=\"fa fa-warning\"></i>\n        The export request failed. Are your <a ng-click=\"vm.cancel()\" ui-sref=\"settings.overview\">Kaltura Configuration Settings</a> correct?\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'vimeo'\">\n        <i class=\"fa fa-warning\"></i>\n        The export request failed. Are your <a ng-click=\"vm.cancel()\" ui-sref=\"settings.vimeo\">Vimeo Configuration Settings</a> correct?\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'youtube'\">\n        <i class=\"fa fa-warning\"></i>\n        The export request failed. Are your <a ng-click=\"vm.cancel()\" ui-sref=\"settings.youtube\">YouTube Configuration Settings</a> correct?\n      </p>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body\">\n  <button type=\"button\" class=\"pull-right close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <uib-tabset active=\"vm.activeTab\">\n    <uib-tab>\n      <uib-tab-heading>\n        Website Embed\n      </uib-tab-heading>\n      <div class=\"tab-container\" style=\"border:none;padding:0\">\n        <div style=\"padding:15px 0 0 0;\">\n          <div class=\"help-block\" style=\"margin-top:0\">\n            <small>This embed code is good for this broadcast only. If you want a playlist with other broadcasts to show up on your website, <a ng-click=\"vm.cancel()\" ui-sref=\"embed\">visit the Embed page</a>.</small>\n          </div>\n          <div style=\"max-width:1000px\">\n            <embed-broadcasts account=\"{}\"\n                              channels=\"[]\"\n                              sources-combined=\"[]\"\n                              show-preview=\"vm.showPreview\"\n                              output=\"vm.output\"\n                              single-event=\"vm.broadcast\"\n                              ></embed-broadcasts>\n          </div>\n        </div>\n      </div>\n    </uib-tab>\n    <uib-tab>\n      <uib-tab-heading>\n        Other Integrations\n      </uib-tab-heading>\n      <div class=\"tab-container\" style=\"border:none;padding:0\">\n        <div style=\"padding:15px 0 0 0;\">\n          <div style=\"max-width:1000px\">\n            <embed-other account=\"{}\"\n                         channels=\"[]\"\n                         sources-combined=\"[]\"\n                         show-preview=\"vm.showPreview\"\n                         output=\"vm.output\"\n                         single-event=\"vm.broadcast\"\n                         ></embed-other>\n          </div>\n        </div>\n      </div>\n    </uib-tab>\n  </uib-tabset>\n</div>\n"

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighlightsController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_capture_highlight_recorded__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_download_or_export_highlight__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_highlight_preview__ = __webpack_require__(190);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }





var HighlightsController = /*#__PURE__*/function () {
  function HighlightsController($location, $state, Broadcast, Highlight, ConfirmDialog, $rootScope, $uibModal, toaster) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, HighlightsController);

    this.$state = $state;
    this.$uibModal = $uibModal;
    this.toaster = toaster;
    this.Highlight = Highlight;
    this.ConfirmDialog = ConfirmDialog;
    this.user = $rootScope.user;
    this.queryParams = $location.search();
    this.HIGHLIGHTS_PAGE_SIZE = 10;
    this.maxMonetizedHighlightTimeS = MAX_MONETIZED_HIGHLIGHT_TIME_S;
    this.broadcastIsMonetized = false;
    this.broadcast = Broadcast.get({
      id: $state.params.id
    }, function (b) {
      _this.broadcastIsMonetized = !b.is_private && b.is_ticketed;
    });
    this.loadHighlightsForPage(1);
    this.loadingPromises = [this.broadcast.$promise, this.highlights.$promise]; // if a 'show' URL param was supplied with a highlight id, load that highlight
    // and show it in the modal.

    if (this.queryParams.show) {
      var highlightForModal = Highlight.get({
        id: this.queryParams.show,
        broadcastId: $state.params.id
      });
      highlightForModal.$promise.then(function () {
        _this.showHighlight(highlightForModal);
      });
    } // if a ?capture or ?edit=:id URL param was supplied, show the capture/edit modal on page load.


    if (this.queryParams.capture || this.queryParams.edit) {
      this.broadcast.$promise.then(function () {
        if (_this.queryParams.edit) {
          var _highlightForModal = Highlight.get({
            id: _this.queryParams.edit,
            broadcastId: $state.params.id
          });

          _highlightForModal.$promise.then(function () {
            _this.showCaptureModal(_highlightForModal);
          });
        } else {
          _this.showCaptureModal();
        }
      });
    }
  }

  _createClass(HighlightsController, [{
    key: "canDownloadOrExport",
    get: function get() {
      var user = this.user; // If the user is not capable of creating any download or export, then don't show it

      if (user.cannot('create', 'highlight/*:download') && user.cannot('create', 'highlight/*:kaltura-export') && user.cannot('create', 'highlight/*:vimeo-export') && user.cannot('create', 'highlight/*:youtube-export')) {
        return false;
      } // If there's no transcoded recording, then don't show it.


      if (!this.recordingIsTranscoded) {
        return false;
      }

      return true;
    }
  }, {
    key: "recordingIsTranscoded",
    get: function get() {
      if (!this.broadcast) {
        return false;
      } else if (this.broadcast.recording_id && this.broadcast.recording_duration_seconds) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "showCaptureModal",
    value: function showCaptureModal(highlight) {
      var _this2 = this;

      var $uibModal = this.$uibModal,
          Highlight = this.Highlight;
      $uibModal.open({
        size: 'lg',
        backdrop: 'static',
        // don't allow accidental clicks on backdrop to close
        template: __webpack_require__(195),
        controllerAs: 'vm',
        controller: __WEBPACK_IMPORTED_MODULE_0__modal_capture_highlight_recorded__["a" /* default */],
        resolve: {
          highlightObj: function highlightObj() {
            return highlight;
          },
          recordingId: function recordingId() {
            return _this2.broadcast.recording_id;
          }
        }
      });
    }
  }, {
    key: "showHighlight",
    value: function showHighlight(highlight) {
      if (!this.broadcastIsMonetized || highlight.duration <= this.maxMonetizedHighlightTimeS) {
        this.playHighlight(highlight);
      } else {
        this.showCaptureModal(highlight);
      }
    }
  }, {
    key: "playHighlight",
    value: function playHighlight(highlight) {
      var _this3 = this;

      var $uibModal = this.$uibModal,
          $timeout = this.$timeout,
          Highlight = this.Highlight;
      $uibModal.open({
        template: __webpack_require__(196),
        resolve: {
          broadcast: function broadcast() {
            return _this3.broadcast;
          },
          highlightDetails: function highlightDetails() {
            return highlight;
          },
          showSave: function showSave() {
            return false;
          }
        },
        controller: __WEBPACK_IMPORTED_MODULE_2__modal_highlight_preview__["a" /* default */],
        controllerAs: 'vm'
      });
    }
  }, {
    key: "delete",
    value: function _delete(highlight) {
      var _this4 = this;

      var Highlight = this.Highlight,
          ConfirmDialog = this.ConfirmDialog,
          $state = this.$state;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Delete Highlight',
        actionButtonClass: 'danger',
        headerText: 'Please Confirm',
        bodyText: 'Are you sure you want to permanently delete this highlight?'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        Highlight["delete"]({
          id: highlight.id,
          broadcastId: _this4.broadcast.id
        }, function () {
          _this4.toaster.pop('warning', 'Successfully deleted highlight');

          _this4.highlights = Highlight.query({
            broadcastId: _this4.broadcast.id
          });
        }, function () {
          return alert('Error deleting highlight. Please reload this page and try again.');
        });
      });
    }
  }, {
    key: "download",
    value: function download(_highlight) {
      var _this5 = this;

      this.$uibModal.open({
        template: __webpack_require__(193),
        controllerAs: 'vm',
        controller: __WEBPACK_IMPORTED_MODULE_1__modal_download_or_export_highlight__["a" /* default */],
        resolve: {
          broadcast: function broadcast() {
            return _this5.broadcast;
          },
          highlight: function highlight() {
            return _highlight;
          }
        }
      });
    }
  }, {
    key: "loadHighlightsForPage",
    value: function loadHighlightsForPage(p) {
      var _this6 = this;

      this.highlights = this.Highlight.query({
        broadcastId: this.$state.params.id,
        p: p - 1,
        l: this.HIGHLIGHTS_PAGE_SIZE,
        s: 'streamed_at'
      }, function (data, headers) {
        var pagination = JSON.parse(headers('x-pagination'));
        _this6.highlightsPagination = {
          current: p,
          total: pagination.total,
          resultMin: _this6.HIGHLIGHTS_PAGE_SIZE * (p - 1) + 1,
          resultMax: _this6.HIGHLIGHTS_PAGE_SIZE * (p - 1) + data.length
        };
      }, function (err) {
        console.log(err);

        _this6.toaster.pop('warning', 'Unable to load highlights.');
      });
    }
  }]);

  return HighlightsController;
}();



/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrimRecordingsController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var TrimRecordingsController = /*#__PURE__*/function () {
  function TrimRecordingsController($state, $scope, Broadcast, Recording, $q, $timeout, $uibModal) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, TrimRecordingsController);

    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$uibModal = $uibModal;
    this.broadcast = Broadcast.get({
      id: $state.params.id
    });
    this.recording = Recording.get({
      id: $state.params.recording
    });
    this.segmentRange = [0, 0];
    this.startSeconds = 0;
    this.stopSeconds = 0;

    this.onChangeBounds = function (startSeconds, stopSeconds, startSegment, stopSegment) {
      _this.startSeconds = startSeconds;
      _this.stopSeconds = stopSeconds;
      _this.segmentRange = [startSegment, stopSegment];
    };

    this.loadingPromises = [this.broadcast.$promise, this.recording.$promise];
  }

  _createClass(TrimRecordingsController, [{
    key: "showPreviewModal",
    value: function showPreviewModal() {
      var _this2 = this;

      var $uibModal = this.$uibModal,
          $timeout = this.$timeout;
      $uibModal.open({
        template: __webpack_require__(189),
        controller: function controller($scope, $uibModalInstance) {
          'ngInject';

          $scope.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };

          $scope.title = 'Preview Trimmed Recording';
          $scope.broadcast = _this2.broadcast;
          $scope.options = {
            autostart: true,
            // TODO: ticketId = admin_token?
            //ticketId: BROADCAST_TICKET,
            trimSeconds: {
              // Support for v3 player
              start: _this2.startSeconds,
              stop: _this2.stopSeconds
            },
            onLoadBroadcast: function onLoadBroadcast(b) {
              // Support for v2 player
              b.start_segment = _this2.segmentRange[0];
              b.stop_segment = _this2.segmentRange[1];
            }
          };
        }
      });
    }
  }, {
    key: "saveChanges",
    value: function saveChanges() {
      var _this3 = this;

      this.isSaving = true;
      this.recording.start_segment = '';
      this.recording.stop_segment = '';
      this.recording.start_seconds = this.startSeconds;
      this.recording.stop_seconds = this.stopSeconds;
      this.recording.$update(function () {
        window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/broadcasts/").concat(_this3.$state.params.id));
      }, function () {
        _this3.isSaving = false;
        alert('Unable to save trimmed recording. Please try again.');
      });
    }
  }]);

  return TrimRecordingsController;
}();



/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scoreboardControls;
/* unused harmony export defaultScoreForSport */
/* unused harmony export configForSport */
// directive for controlling the score of a broadcasted sporting event
//
//    <scoreboard-controls broadcast="vm.broadcast"
//                         scoreboard="vm.scoreboard" />
//
//
// depending on the sport inside the scoreboard configuration object, different
// controls will be presented.
//
// upon changing the score, the change will be persisted back to the server.
var SCOREBOARD_CHANGE_DEBOUNCE_MS = 500; //batch subsequent changes

function scoreboardControls(ApiConfig, Broadcast, $interval) {
  'ngInject';

  return {
    template: __webpack_require__(412),
    scope: {
      broadcast: '=',
      scoreboard: '='
    },
    link: function link(scope, element) {
      ApiConfig.then(function () {
        return scope.sports = ApiConfig.stream.sports;
      });
      var config = configForSport(scope.scoreboard.sport);
      scope.controls = config.controls;
      scope.increments = config.increments;
      scope.presets = config.presets;

      function reloadScore() {
        if (!scope.broadcast.id) {
          console.warn('Broadcast is not defined; cannot load score', scope.broadcast);
          return;
        }

        return Broadcast.getScore({
          id: scope.broadcast.id
        }, function (score) {
          return scope.score = score || {};
        }).$promise;
      }

      scope.update = function (key) {
        console.log('Update fired for', key, 'to', scope.score[key]);
        saveScoreDebounced();
      };

      scope.handlePresetClick = function (preset) {
        console.log('Preset clicked', preset);

        if (preset.confirm) {
          if (!confirm(preset.confirm)) {
            return;
          }
        }

        scope.score = preset.set(scope.score);
        scope.update();
      };

      scope.handleIncrementClick = function (field, increment) {
        console.log('Increment clicked', field, increment);
        scope.score[field] = scope.score[field] + increment;
        scope.update();
      };

      function saveScore() {
        // TODO: der grabbing server score first, then merging changes if
        // necessary (or warning user that someone else might be editing). this
        // could be easier to manage oddities than trying to refresh from the
        // server except while in a control editing.
        if (!scope.broadcast.id) {
          console.warn('Cannot save score; broadcast is not defined');
          return;
        }

        Broadcast.saveScore({
          id: scope.broadcast.id
        }, scope.score, function (score) {
          return console.log('Saved score successfully!');
        });
      }

      var saveScoreDebounced = _.debounce(saveScore, SCOREBOARD_CHANGE_DEBOUNCE_MS);

      scope.loadingPromise = reloadScore(); // XXX: should we poll for other browsers making changes to scoreboard or
      // assume this user is source of truth?
      //let SCOREBOARD_REFRESH_INTERVAL_MS = 10000;
      //let reloadHandle = $interval(reloadScore, SCOREBOARD_REFRESH_INTERVAL_MS);
      //scope.$on('$destroy', () => $interval.cancel(reloadHandle));
    }
  };
}
function defaultScoreForSport(sport) {
  var _configForSport = configForSport(sport),
      controls = _configForSport.controls;

  var data = {};
  controls.forEach(function (c) {
    if (c.radioGroup && c.radioGroup.length) {
      data[c.key] = c.radioGroup[0].key;
    } else {
      data[c.key] = c.min;
    }
  });
  return data;
}
function configForSport(sport) {
  var controls = [];
  var increments = []; // in addition to the standard +/- 1

  var presets = [{
    label: 'Reset Scoreboard',
    confirm: 'Are you sure you want to reset the scoreboard?',
    set: function set(x) {
      x = _.merge(x, defaultScoreForSport(sport));
      x.home_score = 0;
      x.away_score = 0;
      return x;
    }
  }];

  switch (sport.toLowerCase()) {
    case 'basketball (2 halves)':
      controls = [{
        label: 'Half',
        key: 'period',
        min: 1,
        max: 9,
        className: 'col-xs-12'
      }];
      increments = [1, 2, 3];
      break;

    case 'basketball (4 quarters)':
      controls = [{
        label: 'Quarter',
        key: 'period',
        min: 1,
        max: 9,
        className: 'col-xs-12'
      }];
      increments = [1, 2, 3];
      break;

    case 'soccer':
      controls = [{
        label: 'Quarter/Half',
        key: 'period',
        min: 1,
        max: 9,
        className: 'col-xs-12'
      }];
      break;

    case 'lacrosse':
      controls = [{
        label: 'Quarter/Half',
        key: 'period',
        min: 1,
        max: 9,
        className: 'col-xs-12'
      }];
      break;

    case 'hockey':
      controls = [{
        label: 'Period',
        key: 'period',
        min: 1,
        max: 9,
        className: 'col-xs-12'
      }];
      break;

    case 'wrestling':
      controls = [{
        label: 'Round',
        key: 'round',
        min: 1,
        max: 9,
        className: 'col-xs-12'
      }];
      increments = [1, 2, 3];
      break;

    case 'baseball/softball':
      controls = [{
        label: 'Inning',
        key: 'inning',
        min: 1,
        max: 99,
        className: 'col-xs-12 col-md-6'
      }, {
        label: null,
        key: 'inning_half',
        className: 'col-xs-12 col-md-6',
        radioGroup: [{
          label: 'Top',
          key: 'top'
        }, {
          label: 'Bottom',
          key: 'bottom'
        }]
      }, {
        label: 'Outs',
        key: 'outs',
        min: 0,
        max: 3,
        className: 'col-xs-12 col-md-4'
      }, {
        label: 'Balls',
        key: 'balls',
        min: 0,
        max: 4,
        className: 'col-xs-12 col-md-4'
      }, {
        label: 'Strikes',
        key: 'strikes',
        min: 0,
        max: 3,
        className: 'col-xs-12 col-md-4'
      }];
      increments = [1, 2, 3, 4];
      presets = presets.concat([{
        label: 'Next Batter',
        set: function set(x) {
          x.balls = 0;
          x.strikes = 0;
          return x;
        }
      }, {
        label: 'Next Half-Inning',
        set: function set(x) {
          if (x.inning_half == 'top') {
            x.inning_half = 'bottom';
          } else {
            x.inning_half = 'top';
            x.inning = (x.inning || 0) + 1;
          }

          x.outs = 0;
          x.balls = 0;
          x.strikes = 0;
          return x;
        }
      }]);
      break;

    case 'football':
      controls = [{
        label: 'Quarter',
        key: 'period',
        min: 1,
        max: 9,
        className: 'col-xs-12 col-md-4 col-lg-3'
      }, {
        label: 'Down',
        key: 'down',
        min: 1,
        max: 4,
        className: 'col-xs-6 col-md-4 col-lg-3'
      }, {
        label: 'Yards to Go',
        key: 'yards_to_go',
        min: 1,
        max: 100,
        className: 'col-xs-6 col-md-4 col-lg-3'
      }, {
        label: 'Possession',
        key: 'possession',
        className: 'col-xs-12 col-lg-3 no-padding',
        radioGroup: [{
          label: 'Away',
          key: 'away'
        }, {
          label: 'Home',
          key: 'home'
        }]
      }];
      increments = [1, 2, 3, 6];
      presets = presets.concat([{
        label: 'New Set of Downs',
        set: function set(x) {
          x.yards_to_go = 10;
          x.down = 1;
          return x;
        }
      }]);
      break;

    case 'volleyball':
      controls = [{
        label: 'Service',
        key: 'service',
        className: 'col-xs-12 col-lg-3 no-padding',
        radioGroup: [{
          label: 'Away',
          key: 'away'
        }, {
          label: 'Home',
          key: 'home'
        }]
      }, {
        label: 'Set',
        key: 'set',
        min: 1,
        max: 9,
        className: 'col-xs-12 col-lg-3'
      }, {
        label: 'Home Games Won',
        key: 'home_games_won',
        min: 0,
        max: 99,
        className: 'col-xs-6 col-lg-3'
      }, {
        label: 'Away Games Won',
        key: 'away_games_won',
        min: 0,
        max: 99,
        className: 'col-xs-6 col-lg-3'
      }];
      break;

    default:
      console.warn('Unknown sport', scoreboard);
      break;
  }

  return {
    controls: controls,
    increments: increments,
    presets: presets
  };
}

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports = "<div cg-busy=\"{promise: vm.loadingPromise, message: 'Loading...', minDuration: 500}\">\n  <div ng-if=\"loadingPromise.$$state.status != 0\"> <!-- don't load the ng-change events into the DOM until after we've loaded the score -->\n\n    <div class=\"row\" style=\"margin-bottom:10px\">\n      <div class=\"col-xs-6 col-sm-5 text-center\">\n            <color-swatch color=\"scoreboard.away_team_logo\"\n                          label=\"scoreboard.away_team_name + ' (Away)'\"\n                          extra-style=\"{width: '100%'}\"></color-swatch>\n      </div>\n      <div class=\"hidden-xs col-sm-2 text-center\">\n            vs.\n      </div>\n      <div class=\"col-xs-6 col-sm-5 text-center\">\n            <color-swatch color=\"scoreboard.home_team_logo\"\n                          label=\"scoreboard.home_team_name + ' (Home)'\"\n                          extra-style=\"{width: '100%'}\"></color-swatch>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-xs-6 col-sm-5 text-center\">\n            <number-spinner ng-model=\"score.away_score\"\n                            ng-change=\"update('away_score')\"\n                            size=\"lg\"\n                            width=\"auto\"\n                            min-value=\"0\"\n                            max-value=\"999\"></number-spinner>\n            <div ng-if=\"increments.length\">\n              <ul class=\"list-inline\" style=\"font-size:14pt\">\n                <li ng-repeat=\"increment in ::increments\" style=\"padding:5px 10px\">\n                <a class=\"btn btn-default\" href=\"javascript://\" ng-click=\"handleIncrementClick('away_score', increment)\">\n                  {{(increment > 0 ? '+' : '') + increment}}\n                </a>\n                </li>\n              </ul>\n              <div class=\"clearfix\"></div>\n            </div>\n      </div>\n      <div class=\"hidden-xs col-sm-2 text-center\">\n      </div>\n      <div class=\"col-xs-6 col-sm-5 text-center\">\n            <number-spinner ng-model=\"score.home_score\"\n                            ng-change=\"update('home_score')\"\n                            size=\"lg\"\n                            input-width=\"auto\"\n                            min-value=\"0\"\n                            max-value=\"999\"></number-spinner>\n            <div ng-if=\"increments.length\">\n              <ul class=\"list-inline\" style=\"font-size:14pt\">\n                <li ng-repeat=\"increment in ::increments\" style=\"padding:5px 10px\">\n                <a class=\"btn btn-default\" href=\"javascript://\" ng-click=\"handleIncrementClick('home_score', increment)\">\n                  {{(increment > 0 ? '+' : '') + increment}}\n                </a>\n                </li>\n              </ul>\n              <div class=\"clearfix\"></div>\n            </div>\n      </div>\n    </div>\n\n    <div class=\"row\" style=\"margin-top:0; margin-bottom:15px;\">\n      <div ng-repeat=\"control in controls track by $index\"\n           class=\"{{control.className}}\"\n           style=\"vertical-align:bottom; text-align:center; padding-bottom:15px;\">\n        <strong ng-if=\"control.label\">{{control.label}}</strong>\n        <strong ng-if=\"!control.label\">&nbsp;</strong>\n        <div ng-if=\"!control.radioGroup\">\n          <number-spinner ng-model=\"score[control.key]\"\n                          ng-change=\"update(control.key)\"\n                          size=\"lg\"\n                          width=\"130px\"\n                          min-value=\"control.min\"\n                          max-value=\"control.max\"></number-spinner>\n        </div>\n        <div ng-if=\"control.radioGroup\">\n          <div class=\"btn-group\">\n            <label ng-repeat=\"b in ::control.radioGroup\"\n                    class=\"btn btn-default btn-lg\"\n                    ng-model=\"score[control.key]\"\n                    ng-change=\"update(control.key)\"\n                    uib-btn-radio=\"b.key\">{{b.label}}</label>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"clearfix\"></div>\n\n    <div ng-if=\"presets.length\">\n      <ul class=\"list-inline\">\n        <li ng-repeat=\"preset in ::presets\" style=\"margin-right:15px\">\n          <a class=\"action-link\" href=\"javascript://\" ng-click=\"handlePresetClick(preset)\">{{preset.label}}</a>\n        </li>\n      </ul>\n      <div class=\"clearfix\"></div>\n    </div>\n\n    <p class=\"help-block\">\n    <small>\n      <i class=\"fa fa-info-circle\"></i>\n      The scoreboard data is updated at the same time as other live action at your venue. If you\n      are watching the broadcast above while updating the scoreboard information, remember that the\n      video lags the live data by at least 30 seconds, so expect to see your updated\n      scoreboard information with the same delay.\n    </small>\n    </p>\n\n  </div>\n</div>\n"

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_error__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_clappr__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__player_highlight_capture_plugin__ = __webpack_require__(414);


 // angular.component definition for a modified boxcast-player that
// supports a highlight capture component.

var playerWithHighlightCapture = {
  bindings: {
    channelId: '<',
    options: '<',
    broadcast: '<',
    onOpenHighlightPreview: '=',
    onNewHighlightCaptured: '=',
    onOpenLowLatencyPreview: '=',
    parentVm: '<'
  },
  template: "\n    <boxcast-player ng-if=\"vm.__readyToLoadPlayer\"\n                    channel-id=\"vm.channelId\"\n                    options=\"vm.options\"></boxcast-player>\n  ",
  controllerAs: 'vm',
  controller: PlayerWithHighlightCaptureController
};

function PlayerWithHighlightCaptureController($scope, $element, $attrs, $timeout, $rootScope, $sce, toaster, Highlight) {
  'ngInject';

  var _this = this;

  var account = $rootScope.account,
      user = $rootScope.user;
  this.FeatureFlags = account.feature_flags;
  this.account = account;
  this.$sce = $sce;
  this.toaster = toaster;
  this.Highlight = Highlight;
  /* the following are provided automagically by angular.component bindings...
  this.channelId = channelId;
  this.options = options;
  this.onOpenHighlightPreview = onOpenHighlightPreview;
  this.onNewHighlightCaptured = onNewHighlightCaptured;
  this.onOpenLowLatencyPreview = onOpenLowLatencyPreview;
  this.parentVm = parentVm;
  */

  var watchFn = function watchFn() {
    if (!_this.channelId) return;
    if (!_this.options.ticketId) return;

    if (_this.FeatureFlags.highlights && _this.broadcast.recording_requested !== false && user.can('create', 'broadcast/*:highlight')) {
      var origOnLoadPlayer = _this.options.onLoadPlayer || function () {};

      _this.options.onLoadPlayer = function (player) {
        _this.clapprUtils = new __WEBPACK_IMPORTED_MODULE_1__utils_clappr__["a" /* default */](player);
        origOnLoadPlayer(player);
      };

      _this.options.clapprPlugins = [__WEBPACK_IMPORTED_MODULE_2__player_highlight_capture_plugin__["a" /* default */]];
      _this.options.clapprConfig = {
        highlightCapturePlugin: {
          onPreview: function onPreview(data) {
            return $timeout(function () {
              return _this.onHighlightCapturePreview(data);
            }, 0);
          },
          onSave: function onSave(data) {
            return $timeout(function () {
              return _this.onHighlightCaptureSave(data);
            }, 0);
          }
        }
      };
    }

    _this.__readyToLoadPlayer = true;
  };

  $scope.$watch(function () {
    return _this.channelId;
  }, watchFn);
  $scope.$watch(function () {
    return _this.options;
  }, watchFn, true);

  this._unpackAndValidateHighlightData = function (data) {
    var highlight = {
      name: data.name,
      start_seconds: data.start_seconds || _this.clapprUtils.getMediaAbsoluteTimeForTime(data.start),
      stop_seconds: data.stop_seconds || _this.clapprUtils.getMediaAbsoluteTimeForTime(data.end)
    };

    if (highlight.start_seconds === null || highlight.stop_seconds === null) {
      console.warn('error getting start/stop seconds', data, highlight);

      _this.toaster.pop('warning', 'Unable to generate highlight. Please check the selected time and duration and then try again.');

      return;
    }

    return highlight;
  };

  this.onHighlightCapturePreview = function (data) {
    var highlight = _this._unpackAndValidateHighlightData(data);

    if (!highlight) return;

    _this.onOpenHighlightPreview.bind(_this.parentVm)(highlight, true).result.then(function (result) {
      console.log('saving with original data', data, 'and updates from preview', result); // User opted to save the highlight from within the preview

      _this.onHighlightCaptureSave(angular.extend({}, data, result));
    });
  };

  this.onHighlightCaptureSave = function (data) {
    var highlight = _this._unpackAndValidateHighlightData(data);

    if (!highlight) return;

    if (!highlight.name) {
      _this.toaster.pop('warning', 'Please provide a name for the highlight before saving.');

      return;
    }

    _this.Highlight.create({
      broadcastId: _this.broadcast.id
    }, highlight).$promise.then(function () {
      _this.onNewHighlightCaptured.bind(_this.parentVm)();

      data.fnClose();
    })["catch"](function (err) {
      console.error(err);

      _this.toaster.pop('warning', "The highlight could not be created: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__utils_error__["a" /* errorDescriptionFromResponse */])(err)));
    });
  };

  this.openLowLatencyPreview = function () {
    _this.onOpenLowLatencyPreview.bind(_this.parentVm)();
  };
}

/* harmony default export */ __webpack_exports__["a"] = (playerWithHighlightCapture);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighlightCapturePlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_utils_date__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__highlight_capture_plugin_scss__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__highlight_capture_plugin_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__highlight_capture_plugin_scss__);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }



var Clappr = boxcast.libs.Clappr;
var UICorePlugin = Clappr.UICorePlugin,
    Events = Clappr.Events,
    $ = Clappr.$;

var HighlightCapturePlugin = /*#__PURE__*/function (_UICorePlugin) {
  _inherits(HighlightCapturePlugin, _UICorePlugin);

  var _super = _createSuper(HighlightCapturePlugin);

  function HighlightCapturePlugin(core) {
    var _this;

    _classCallCheck(this, HighlightCapturePlugin);

    _this = _super.call(this, core);
    var options = core.options.highlightCapturePlugin || {};

    _this._onPreview = options.onPreview || function () {};

    _this._onSave = options.onSave || function () {};

    return _this;
  }

  _createClass(HighlightCapturePlugin, [{
    key: "supportedVersion",
    get: function get() {
      return {
        min: '0.4.0'
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'highlight-capture';
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        "class": this.name
      };
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core.mediaControl, Events.MEDIACONTROL_RENDERED, this._onMediaControlRendered);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(HighlightCapturePlugin.prototype), "destroy", this).call(this);

      this._$form.find('.close').off('click');

      this._$form.find('.preview').off('click');

      this._$form.find('.save').off('click');

      this._$form.find('input,select').off('keydown');
    }
  }, {
    key: "_getCurrentTime",
    value: function _getCurrentTime() {
      // XXX: playback.getCurrentTime is often wildly inaccurate. Asking the <video> element directly is better.
      //var time = this.core.getCurrentPlayback().getCurrentTime();
      var time = this.core.$el.find('video, audio').get(0).currentTime;
      console.log('Clicked at', time, ' on video element. Playback reports', this.core.getCurrentPlayback().getCurrentTime());
      return time;
    }
  }, {
    key: "_getVideoDuration",
    value: function _getVideoDuration() {
      //return this.core.getCurrentPlayback().getDuration();
      return this.core.$el.find('video, audio').get(0).duration;
    }
  }, {
    key: "_getFormSelections",
    value: function _getFormSelections() {
      var _this2 = this;

      var name = this._$form.find('.description').val();

      var start = Object(__WEBPACK_IMPORTED_MODULE_0__app_utils_date__["c" /* formattedLabelToSeconds */])(this._$form.find('.start-time').val());
      console.log('start is', start, 'from', this._$form.find('.start-time').val());
      var duration = parseInt(this._$form.find('.duration').val(), 10) * parseInt(this._$form.find('.duration-relative').val(), 10);
      var end = start + duration;
      start = Math.max(0, start);
      end = Math.max(0, end);
      start = Math.min(start, this._getVideoDuration());
      end = Math.min(end, this._getVideoDuration());

      if (start > end) {
        var _ref = [end, start];
        start = _ref[0];
        end = _ref[1];
      }

      var fnClose = function fnClose() {
        return _this2._onCloseForm();
      };

      return {
        start: start,
        end: end,
        name: name,
        fnClose: fnClose
      };
    }
  }, {
    key: "_onMediaControlRendered",
    value: function _onMediaControlRendered() {
      var playback = this.core.getCurrentPlayback();

      if (playback.name == 'hls') {
        this._appendCameraIcon();

        this._appendForm();
      } else {
        console.log('Playback does not support time-to-segment mapping; cannot load highlight capture plugin.');
      }
    }
  }, {
    key: "_appendForm",
    value: function _appendForm() {
      var _this3 = this;

      this._$form = $(FORM_HTML);

      this._$form.hide();

      this._$form.find('.close').on('click', function () {
        return _this3._onCloseForm();
      });

      this._$form.find('.preview').on('click', function () {
        return _this3._onPreview(_this3._getFormSelections());
      });

      this._$form.find('.save').on('click', function () {
        return _this3._onSave(_this3._getFormSelections());
      });

      this._$form.find('.refresh-start-time').on('click', function (e) {
        return _this3._updateStartTime(e);
      });

      this._$form.find('input,select').on('keydown', function (e) {
        return e.stopPropagation();
      });

      if (this._$form[0]) {
        // Clappr 0.4+
        this.core.mediaControl.$el.append(this._$form[0]);
      } else {
        this.core.mediaControl.$el.append(this._$form);
      }
    }
  }, {
    key: "_appendCameraIcon",
    value: function _appendCameraIcon() {
      var _this4 = this;

      var mc = this.core.mediaControl;
      mc.$('.media-control-right-panel .media-control-icon').last().after(CAMERA_HTML);
      mc.$('.highlight-capture-plugin-camera-container button').click(function (e) {
        return _this4._onCameraClick(e);
      });
    }
  }, {
    key: "_onCameraClick",
    value: function _onCameraClick(e) {
      var playback = this.core.getCurrentPlayback();
      this._wasPlaying = playback.isPlaying();
      this.core.mediaControl.pause();
      this.core.mediaControl.setKeepVisible();

      this._updateStartTime();

      this._$form.show();
    }
  }, {
    key: "_updateStartTime",
    value: function _updateStartTime() {
      var clickedAtTime = this._getCurrentTime();

      this._$form.find('.start-time').val(Object(__WEBPACK_IMPORTED_MODULE_0__app_utils_date__["e" /* secondsToFormattedLabel */])(clickedAtTime));
    }
  }, {
    key: "_onCloseForm",
    value: function _onCloseForm() {
      this._$form.hide();

      this.core.mediaControl.resetKeepVisible();

      if (this._wasPlaying) {
        this.core.getCurrentPlayback().play();
      }
    }
  }]);

  return HighlightCapturePlugin;
}(UICorePlugin);


var CAMERA_HTML = "\n<div class=\"highlight-capture-plugin-camera-container\" style=\"padding: 0; margin-top: 6px;\">\n  <button type=\"button\" class=\"boxcast-clappr-button\">\n    <i class=\"fa fa-camera\" />\n  </button>\n</div>\n";
var FORM_HTML = "\n<div class=\"highlight-form\">\n  <div class=\"close-container\">\n    <i class=\"close fa fa-times-circle\" />\n  </div>\n  <h3>Capture a Highlight</h3>\n  <div style=\"display:flex;\">\n    <div style=\"width:75%;text-align:left;margin-right:10px;\">\n      <div style=\"margin-bottom:10px\">\n        Description<br>\n        <input type=\"text\" class=\"description form-control\" placeholder=\"Enter a name for this clip...\" maxlength=\"255\">\n      </div>\n      <div style=\"display:flex\">\n        <div style=\"margin-right:10px;line-height:32px\">\n          <select class=\"duration form-control\">\n            <option selected value=\"10\">10 sec</option>\n            <option value=\"20\">20 sec</option>\n            <option value=\"30\">30 sec</option>\n            <option value=\"40\">40 sec</option>\n            <option value=\"50\">50 sec</option>\n            <option value=\"60\">60 sec</option>\n            <option value=\"90\">90 sec</option>\n            <option value=\"120\">2 min</option>\n            <option value=\"180\">3 min</option>\n          </select>\n        </div>\n        <div style=\"margin-right:10px;line-height:32px\">\n          <select class=\"duration-relative form-control\">\n            <option selected value=\"-1\">before</option>\n            <option value=\"1\">after</option>\n          </select>\n        </div>\n        <div style=\"line-height:32px;margin-right:10px;\">\n          <input type=\"text\" class=\"start-time form-control\">\n        </div>\n        <div style=\"line-height:32px\">\n          <i class=\"refresh-start-time fa fa-refresh\"></i>\n        </div>\n      </div>\n    </div>\n    <div style=\"width:25%;\">\n      &nbsp;<br>\n      <button class=\"preview btn btn-warning btn-block\">Preview</button>\n      <button class=\"save btn btn-primary btn-block\">Save Highlight</button>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(416);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js!./highlight-capture-plugin.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js!./highlight-capture-plugin.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "[data-player] .highlight-capture-plugin-camera-container {\n  display: inline-block;\n  height: 32px;\n  padding: 9px 12px 0 5px;\n  vertical-align: top; }\n  [data-player] .highlight-capture-plugin-camera-container a {\n    color: #fff;\n    opacity: 1; }\n  [data-player] .highlight-capture-plugin-camera-container a:hover {\n    opacity: 0.8; }\n\n[data-player] i.fa {\n  font: normal normal normal 14px/1 FontAwesome; }\n\n[data-player] .highlight-form {\n  position: relative;\n  z-index: 1;\n  pointer-events: all;\n  background: rgba(0, 0, 0, 0.2);\n  padding: 10px; }\n  [data-player] .highlight-form .close-container {\n    float: right; }\n    [data-player] .highlight-form .close-container i {\n      cursor: pointer;\n      color: #fff;\n      opacity: 1; }\n  [data-player] .highlight-form i.refresh-start-time {\n    cursor: pointer; }\n  [data-player] .highlight-form input,\n  [data-player] .highlight-form select {\n    color: #333; }\n", ""]);

// exports


/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = "<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-sm-8\">\n      <h1 style=\"margin-top:0;font-size:16pt;\">{{vm.broadcast.name}}</h1>\n    </div>\n    <div ng-if=\"vm.allowPromote && (vm.broadcast.timeframe != 'past' || vm.recordingIsAvailable)\" class=\"hidden-xs col-sm-4 overflow-ellipse text-right\">\n      <a ng-href=\"{{vm.broadcast.viewer_url}}\" target=\"_blank\">{{vm.broadcast.viewer_url}} <i class=\"fa fa-external-link\"></i></a>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-sm-8 col-lg-9\">\n\n      <div ng-if=\"vm.account.max_simultaneous_streams > 0 && vm.broadcast.is_limited_by_active_stream_count\">\n        <div class=\"bg-warning text-warning\" style=\"border:1px solid;padding:10px;margin-bottom:15px;\">\n          <p>Your account is only able to stream {{ vm.account.max_simultaneous_streams }} simultaneous broadcast{{ vm.account.max_simultaneous_streams != 1 ? 's' : '' }}. This broadcast will start once other broadcasts have ended.</p>\n          <p style=\"margin-bottom:0px\">If you would like to add additional simultaneous broadcasts to your account, please <a href=\"mailto:questions@boxcast.com\" target=\"_blank\">contact customer support</a>.</p>\n        </div>\n      </div>\n\n      <div ng-if=\"vm.broadcastStatus\">\n        <div class=\"well\" style=\"border-bottom:3px solid {{vm.broadcastStatus.status == 'ok' ? 'green' : vm.broadcastStatus.status == 'warning' ? 'orange' : 'red'}};padding:10px;\">\n          <div class=\"clearfix\">\n            <div class=\"col-sm-8 no-padding\">\n              <span style=\"color:#aaa;font-weight:bold;font-size:10pt;\">STATUS</span>&nbsp;\n              <strong>{{vm.broadcastStatus.title}}</strong>\n            </div>\n            <div class=\"col-sm-4 no-padding text-sm-right\">\n              <small>{{vm.broadcastStatus.subtitle}}</small>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div ng-if=\"!vm.preview && !vm.recordingIsBeingUploaded\" style=\"background:#000;\">\n        <!-- NOTE: capping width to avoid a massive height -->\n        <div class=\"cap-player-width-container\">\n          <player-with-highlight-capture\n                broadcast=\"vm.broadcast\"\n                channel-id=\"vm.broadcast.channel_id\"\n                options=\"vm.playerOptions\"\n                parent-vm=\"vm\"\n                on-open-highlight-preview=\"vm.openHighlightPreviewModal\"\n                on-new-highlight-captured=\"vm.onNewHighlightCaptured\"\n                on-open-low-latency-preview=\"vm.openLowLatencyPreview\"\n                ></player-with-highlight-capture>\n        </div>\n      </div>\n      <div ng-if=\"vm.preview\" class=\"low-latency-wrapper\">\n        <!-- NOTE: capping width to avoid a massive height -->\n        <div class=\"cap-player-width-container\">\n          <div class=\"fixed-16-9\">\n            <low-latency-player broadcast=\"vm.broadcast\"></low-latency-player>\n          </div>\n          <button class=\"btn btn-link close-btn\" ng-click=\"vm.preview = false\">&times;</button>\n          <a class=\"label label-info indicator-overlay\" href=\"https://support.boxcast.com/en/articles/4235096-troubleshoot-remotely-using-low-latency-preview\" target=\"_blank\">\n            Low-Latency Preview\n          </a>\n        </div>\n      </div>\n\n      <div ng-if=\"vm.recordingIsBeingUploaded\" style=\"background:#000;\">\n        <div class=\"cap-player-width-container\">\n          <div class=\"fixed-16-9\">\n            <h3 style=\"color:#fff;display:flex;align-items:center;justify-content:center;padding:0 15px;\">\n              <div>\n                <i ng-hide=\"vm.recordingUploadStatus == 'failed'\" class=\"fa fa-spin fa-spinner\" style=\"margin-right:15px\"></i>\n                {{vm.recordingUploadStatusMessage}}\n                <uib-progressbar value=\"vm.recordingUploadProgress\" ng-show=\"vm.recordingUploadProgress > 0\" max=\"100\" style=\"margin-top:15px\">\n                  {{vm.recordingUploadProgress}}% Processed\n                </uib-progressbar>\n                <p ng-show=\"vm.recordingProcessingEstimate\" style=\"font-size:0.6em;margin:15px 0 0 0\">\n                  Estimated time remaining: {{ vm.recordingProcessingEstimate | remainingTime }}\n                </p>\n                <p ng-if=\"vm.recordingUploadStatus == 'failed'\" style=\"font-size:0.6em;margin:15px 0 30px;\">\n                  If you need assistance, <a title=\"Support documentation\" href=\"https://support.boxcast.com/en/articles/4235131\" target=\"_blank\">please review the support documentation</a>.\n                </p>\n                <div class=\"form-group\" ng-if=\"vm.recordingUploadStatus != 'failed'\" style=\"font-size:0.5em;margin:15px 0 0 0\">\n                  <span ng-click=\"vm.emailMeWhenComplete = !vm.emailMeWhenComplete\" style=\"cursor:pointer;opacity:0.8\">\n                    <i class=\"fa\" ng-class=\"vm.emailMeWhenComplete ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n                    Email me when completed\n                  </span>\n                </div>\n              </div>\n            </h3>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"row\" ng-if=\"vm.recordingIsBeingReplaced\">\n        <div class=\"col-xs-12\">\n          <div class=\"bg-info text-info\" style=\"padding:15px;border:1px solid;margin-top:15px;\">\n            <i ng-hide=\"vm.recordingUploadStatus == 'failed'\" class=\"fa fa-spin fa-spinner\"></i>\n            {{vm.recordingReplacementStatusMessage}}\n            <uib-progressbar value=\"vm.recordingUploadProgress\" ng-show=\"vm.recordingUploadProgress> 0\" max=\"100\" style=\"margin-top:15px\">\n              {{vm.recordingUploadProgress}}% Processed\n            </uib-progressbar>\n            <p ng-show=\"vm.recordingProcessingEstimate\" style=\"margin:15px 0 0 0\">\n                  Estimated time remaining: {{ vm.recordingProcessingEstimate | remainingTime }}\n                </p>\n            <p ng-if=\"vm.recordingUploadStatus == 'created'\">\n              If the upload has failed, <a href=\"javascript://\" ng-click=\"vm.cancelUpload()\">click here to cancel and try the upload again</a>.\n            </p>\n            <p ng-if=\"vm.recordingUploadStatus == 'failed'\">\n              If you need assistance, <a title=\"Support documentation\" href=\"https://support.boxcast.com/en/articles/4235131\" target=\"_blank\">please review the support documentation</a>.\n            </p>\n            <div class=\"form-group\" ng-if=\"vm.recordingUploadStatus != 'failed'\" style=\"margin:15px 0 0 0\">\n              <span ng-click=\"vm.emailMeWhenComplete = !vm.emailMeWhenComplete\" style=\"cursor:pointer;opacity:0.8\">\n                <i class=\"fa\" ng-class=\"vm.emailMeWhenComplete ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n                Email me when completed\n              </span>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"row\" ng-if=\"vm.recordingIsWaitingToBePublished\">\n        <div class=\"col-xs-12\">\n          <div class=\"bg-info text-info\" style=\"padding:15px;border:1px solid;margin-top:15px;\">\n            Congratulations! The broadcast is ready to be published.\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" ng-click=\"vm.edit('publish')\" ng-if=\"::vm.canEdit\"\n              analytics-on analytics-event=\"event-edit\" analytics-category=\"open-modal\" analytics-label=\"\">\n              Publish and Review Settings\n            </button>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <div class=\"well well-with-inline-tabs\" style=\"margin-top:15px\">\n            <ol class=\"inline-tabs inline-tabs--dont-increase-font-size list-inline\" style=\"margin-bottom:15px\">\n              <li ng-class=\"!vm.activeTab ? 'active' : ''\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"overview\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('')\">Overview</a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'diagnostics' ? 'active' : ''\" ng-if=\"vm.showDiagnostics\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"diagnostics\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('diagnostics')\">\n                  <i ng-if=\"vm.streamDiagnostics.status\" class=\"fa fa-circle\"\n                    ng-style=\"{color: vm.streamDiagnostics.status=='OK' ? 'green' : vm.streamDiagnostics.status=='Warning' ? 'orange' : vm.streamDiagnostics.status=='Critical' ? 'red' : ''}\">\n                  </i>\n                  Diagnostics\n                </a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'analytics' ? 'active' : ''\" ng-if=\"vm.broadcast.timeframe != 'future'\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"analytics\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('analytics')\">Analytics</a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'scoreboard' ? 'active' : ''\" ng-if=\"vm.enableScoreboardControls\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"scoreboard\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('scoreboard')\">Scoreboard</a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'overlays' ? 'active' : ''\" ng-if=\"vm.allowOverlays && vm.broadcast.timeframe != 'past' && vm.broadcast.stream_source != 'recording' && vm.broadcast.stream_source != 'producer'\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"overlays\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('overlays')\">\n                  <i ng-if=\"vm.activeOverlays.length\" class=\"fa fa-circle\" style=\"color: green;\"></i>\n                  Overlays\n                </a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'captions' ? 'active' : ''\" ng-if=\"vm.showCaptionsTab\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"captions\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('captions')\">\n                  <i ng-if=\"vm.activeLiveAutomatedCaptions\" class=\"fa fa-circle\"\n                    ng-style=\"{color: vm.enableCaptions ? 'green' : 'orange'}\">\n                  </i>\n                  Captions\n                </a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'documents' ? 'active' : ''\" ng-if=\"vm.FeatureFlags.documents && (vm.broadcast.timeframe != 'past' || vm.recordingIsAvailable)\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"documents\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('documents')\">Documents</a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'video_index' ? 'active' : ''\" ng-if=\"vm.FeatureFlags.cue_points && vm.recordingIsAvailable\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"video_index\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('video_index')\">Video Index</a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'viewer_chat' ? 'active' : ''\" ng-if=\"vm.FeatureFlags.viewer_chat\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"viewer_chat\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('viewer_chat')\">\n                  <i ng-if=\"vm.showChatStateValue\" class=\"fa fa-circle\" style=\"color: green\"></i>\n                  Chat\n                </a>\n              </li>\n              <li class=\"pull-right\">\n                <a href=\"javascript://\" ng-click=\"vm.edit()\" ng-if=\"::vm.canEdit\"\n                  analytics-on analytics-event=\"event-edit\" analytics-category=\"open-modal\" analytics-label=\"\">\n                  <i class=\"fa fa-pencil\"></i> Edit Broadcast\n                </a>\n              </li>\n            </ol>\n\n            <div ng-show=\"!vm.activeTab\">\n              <broadcast-label-list broadcast=\"vm.broadcast\"></broadcast-label-list>\n              <p style=\"font-size:10pt; white-space:pre-line\">{{vm.broadcast.description}}</p>\n              <p>\n                <date-range start=\"vm.broadcast.starts_at\" end=\"vm.broadcast.stops_at\"></date-range>\n              </p>\n              <p ng-if=\"vm.allowPromote && (vm.broadcast.timeframe != 'past' || vm.recordingIsAvailable)\">\n                <strong>View on BoxCast.tv:</strong><br>\n                <a ng-href=\"{{vm.broadcast.viewer_url}}\" target=\"_blank\">{{vm.broadcast.viewer_url}}<i class=\"fa fa-external-link\" style=\"margin-left: 5px;\"></i></a>\n              </p>\n              <div ng-if=\"vm.broadcast.in_channel_ids.length > 0 || vm.broadcast.tags.length > 0\" style=\"margin-bottom: 10px;\">\n                <strong>Published Channels</strong><br>\n                <ul class=\"list-inline\">\n                  <li ng-repeat=\"channel_id in vm.broadcast.in_channel_ids\">\n                    <a ui-sref=\"channels({id: channel_id})\" class=\"label label-info\">\n                      {{vm.channels | getById:channel_id:'id':'name'}}\n                    </a>\n                  </li>\n                  <li ng-repeat=\"tag in vm.broadcast.tags\">\n                    <span class=\"label label-info\">Tag: {{tag}}</span>\n                  </li>\n                </ul>\n              </div>\n              <div ng-if=\"vm.showHighlights && vm.highlights.length > 0\" style=\"margin-bottom: 10px;\">\n                <strong>Highlight Clips</strong><br>\n                <ul class=\"list-inline\">\n                  <li ng-repeat=\"highlight in vm.highlights track by highlight.id\" class=\"text-center\">\n                    <a href=\"javascript://\" ng-click=\"vm.openHighlight(highlight)\">\n                      <img class=\"img img-thumbnail\" style=\"width:100px\" ng-src=\"{{highlight.preview}}\"><br>\n                      <p class=\"overflow-ellipse\" style=\"width:100px\"><small>{{highlight.name}}</small></p>\n                    </a>\n                  </li>\n                </ul>\n                <div ng-if=\"vm.totalHighlights > vm.highlights.length\" class=\"text-center\" style=\"margin-top:5px;\">\n                  <a\n                    ui-sref=\"events.highlights({id: vm.broadcast.id, recording: vm.broadcast.recording_id})\"\n                    href=\"javascript://\"\n                    style=\"padding-right:50px\">\n                    <small><strong>View all highlights</strong></small>\n                  </a>\n                </div>\n              </div>\n              <div ng-if=\"vm.simulatedLiveBroadcasts.length > 0\" style=\"margin-bottom: 10px;\">\n                <strong>Re-Broadcasts (Simulated Live):</strong><br>\n                <table class=\"table table-condensed table-striped table-hover\">\n                  <thead>\n                    <tr>\n                      <th>Name</th>\n                      <th>Date/Time</th>\n                      <th>Status</th>\n                      <th>Accessibility</th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr ng-repeat=\"broadcast in vm.simulatedLiveBroadcasts track by broadcast.id\"\n                        ng-click=\"$state.go('events.detail', {id: broadcast.id})\">\n                      <td>{{broadcast.name}}</td>\n                      <td><date-range start=\"broadcast.starts_at\" end=\"broadcast.stops_at\"></date-range></td>\n                      <td>\n                        <span ng-if=\"broadcast.timeframe == 'past' && broadcast.do_not_record\" class=\"label label-default\">Not Recorded</span>\n                        <span ng-if=\"broadcast.timeframe == 'past' && !broadcast.do_not_record\" class=\"label label-primary\">Recorded</span>\n                        <span ng-if=\"broadcast.timeframe == 'current'\" class=\"label label-success\">Live</span>\n                        <span ng-if=\"broadcast.timeframe == 'preroll' || broadcast.timeframe == 'future'\" class=\"label label-info\">Upcoming</span>\n                      </td>\n                      <td>\n                        <span ng-if=\"broadcast.is_ticketed\" class=\"label label-success\">${{broadcast.ticket_price | number:2}} / ticket</span>\n                        <span ng-if=\"broadcast.is_private\" class=\"label label-danger\">Private</span>\n                        <span ng-if=\"!broadcast.is_ticketed && !broadcast.is_private\" class=\"label label-default\">Public</span>\n                      </td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div><!-- end overview tab -->\n\n            <div ng-show=\"vm.activeTab == 'diagnostics'\" ng-if=\"vm.showDiagnostics\">\n              <stream-diagnostics ng-if=\"vm.broadcast.id\"\n                                  broadcast=\"vm.broadcast\"\n                                  on-reload=\"vm.onStreamDiagnosticsReload\"\n                                  ></stream-diagnostics>\n            </div><!-- end diagnostics tab -->\n\n            <div ng-if=\"vm.activeTab == 'analytics'\">\n              <broadcast-basic-analytics broadcast=\"vm.broadcast\"></broadcast-basic-analytics>\n            </div><!-- end analyticstab -->\n\n            <div ng-show=\"vm.activeTab == 'scoreboard'\" ng-if=\"vm.enableScoreboardControls && vm.broadcast.id && vm.broadcast.scoreboard_configuration.sport\">\n              <scoreboard-controls broadcast=\"vm.broadcast\" scoreboard=\"vm.broadcast.scoreboard_configuration\"></scoreboard-controls>\n            </div><!-- end scoreboard tab -->\n\n\n            <div ng-show=\"vm.activeTab == 'overlays'\">\n\n              <div style=\"padding:15px; overflow:hidden;\">\n                <div style=\"border:1px solid #aaa\">\n                  <div class=\"fixed-16-9 transparent-grid-bg overlay-canvas draggable-parent resizable-parent\">\n                    <div>\n                      <div ng-repeat=\"o in vm.activeOverlays\">\n                        <overlay-image overlay=\"o\" on-change=\"vm.onOverlayChange\"></overlay-image>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div ng-show=\"vm.overlaysChanged\" class=\"text-center\">\n                <button ng-click=\"vm.discardOverlays()\" ng-disabled=\"vm.overlaysSaving\" class=\"btn btn-default\" type=\"button\">Discard Changes</button>\n                <button ng-click=\"vm.saveOverlays()\" ng-disabled=\"vm.overlaysSaving\" class=\"btn btn-primary\" type=\"button\">\n                  <span ng-hide=\"vm.overlaysSaving\">\n                    Apply Changes\n                  </span>\n                  <span ng-show=\"vm.overlaysSaving\">\n                    <i class=\"fa fa-spin fa-spinner\"></i> Saving...\n                  </span>\n                </button>\n              </div>\n\n              <h4>Overlay Gallery</h4>\n              <div class=\"row overlay-gallery\">\n                <div class=\"col-xs-6 col-sm-4 col-lg-3 text-center\" style=\"margin-bottom:15px\"\n                     ng-repeat=\"u in vm.uploads\">\n                  <div class=\"fixed-16-9 transparent-grid-bg\">\n                    <div class=\"upload-image\"\n                         ng-style=\"{'background-image': 'url(&quot;'+u.view_url+'&quot;)'}\"\n                         ng-class=\"{active: u.__inUse}\"\n                         ng-mouseover=\"u.__showOverlay = true\"\n                         ng-mouseout=\"u.__showOverlay = false\">\n                      <div ng-show=\"u.__showOverlay\" class=\"upload-details\">\n                        <p class=\"overflow-ellipse\">{{u.filename}}</p>\n                        <div ng-if=\"!u.__inUse\" style=\"position:absolute;top:20px;left:0;right:0;\">\n                          <button ng-click=\"vm.addOverlay(u)\" class=\"btn btn-primary\">Add</button>\n                        </div>\n                        <div ng-if=\"!u.__inUse && vm.activeOverlays.length\" style=\"position:absolute;bottom:5px;left:5px\">\n                          <button ng-click=\"vm.addOverlay(u, true)\" class=\"btn btn-xs btn-default\">Replace</button>\n                        </div>\n                        <div ng-if=\"!u.__inUse\" style=\"position:absolute;bottom:5px;right:5px\">\n                          <button ng-click=\"vm.deleteUpload(u)\" class=\"btn btn-xs btn-danger\" title=\"Delete from gallery\"><i class=\"fa fa-trash\"></i></button>\n                        </div>\n                        <div ng-if=\"u.__inUse\" style=\"position:absolute;bottom:5px;right:5px\">\n                          <button ng-click=\"vm.removeOverlay(u)\" class=\"btn btn-xs btn-default\">Remove</button>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"col-xs-6 col-sm-4 col-lg-3\">\n                    <upload-slot ng-model=\"vm.file\"\n                                ng-change=\"vm.uploadOverlay(vm.file)\"\n                                slot-name=\"'overlay'\"\n                                allow-image=\"true\"\n                                allow-video=\"false\"\n                                hide-stock-browse=\"true\"\n                                hide-recent-browse=\"true\"\n                                compact=\"true\"\n                                clear-on-success=\"true\"></upload-slot>\n                </div>\n              </div>\n              <div ng-show=\"vm.uploadsPagination.total > 20\">\n                <uib-pagination total-items=\"vm.uploadsPagination.total\"\n                                items-per-page=\"20\"\n                                max-size=\"10\"\n                                rotate=\"false\"\n                                class=\"pagination-sm\"\n                                ng-model=\"vm.uploadsPagination.current\"\n                                ng-change=\"vm.loadUploadsForPage(vm.uploadsPagination.current)\"></uib-pagination>\n              </div>\n\n              <p class=\"help-block\" style=\"margin-top:30px\"><small>\n                <i class=\"fa fa-info-circle\"></i>\n                Overlays can be used to mix sponsor graphics or full slate messages into your video. Just like\n                scoreboard overlays, these are updated at the same time as other live action at your venue.\n                If you are watching the broadcast above while updating the overlays, remember that the\n                video lags the live data by at least 30 seconds, so expect to see your updated\n                overlays with the same delay.\n              </small></p>\n\n            </div><!-- end overlays tab -->\n\n            <div ng-if=\"vm.activeTab == 'documents'\">\n              <table class=\"table table-striped\" ng-if=\"vm.broadcast.content_settings.documents.length > 0\" style=\"margin-bottom:30px\">\n                <thead>\n                  <tr><th colspan=\"2\">Documents</th></tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"d in vm.broadcast.content_settings.documents\">\n                    <td class=\"text-left\">\n                      <div ng-if=\"!d.__enableEditMode\">\n                        <ol class=\"list-inline\">\n                          <li><a href=\"javascript://\" ng-click=\"d.__enableEditMode = true\"><i class=\"fa fa-pencil-square-o\"></i></a></li>\n                          <li><a target=\"_blank\" href=\"{{::d.url}}\"><i class=\"fa fa-file-pdf-o\"></i></a></li>\n                          <li><strong>{{::d.name}}</strong></li>\n                        </ol>\n                      </div>\n                      <div ng-if=\"d.__enableEditMode\">\n                        <div class=\"row\">\n                          <div class=\"col-sm-8\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"d.name\" placeholder=\"Enter document title\" required>\n                          </div>\n                          <div class=\"col-sm-4 text-sm-right\">\n                            <ol class=\"list-inline\">\n                              <li>\n                                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.editDocument(d)\">Save Changes</button>\n                              </li>\n                              <li>\n                                <button type=\"button\" class=\"btn btn-default\" ng-click=\"d.__enableEditMode = false\">Cancel</button>\n                              </li>\n                            </ol>\n                          </div>\n                        </div>\n                      </div>\n                    </td>\n                    <td align=\"right\" nowrap>\n                      <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.deleteDocument(d)\"><i class=\"fa fa-trash\"></i> Delete</button>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n\n              <div class=\"row\">\n                <div class=\"col-sm-6\">\n                  <upload-slot ng-model=\"vm.newDocumentFile\"\n                               slot-name=\"'document'\"\n                               allow-image=\"false\"\n                               allow-video=\"false\"\n                               hide-stock-browse=\"true\"\n                               hide-recent-browse=\"false\"\n                               compact=\"true\"></upload-slot>\n                </div>\n                <div class=\"col-sm-6\">\n                  <label>Add a Document</label>\n                  <div>\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vm.document.name\" placeholder=\"Document name\" required>\n                    <p class=\"help-block\"><small><i class=\"fa fa-info-circle\"></i> The name should be concise (e.g. Agenda). The name is displayed to viewers in the embedded player.</small></p>\n                  </div>\n                  <div style=\"margin:10px 0\">\n                    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.saveDocument(vm.document, vm.newDocumentFile, true)\">Save Document</button>\n                  </div>\n                </div>\n              </div>\n\n            </div><!--/ Documents -->\n\n\n            <div ng-if=\"vm.activeTab == 'video_index'\">\n              <form role=\"form\">\n                <div class=\"row\">\n                  <div class=\"col-xs-12\">\n                    <div class=\"form-group\" ng-if=\"!vm.isUsingHlsJsOnRecording\">\n                      <p class=\"help-block\">\n                        <small>Video Index entry is not available. Make sure the broadcast has finished recording and that you\n                          are using Chrome or Firefox.</small>\n                      </p>\n                    </div>\n                    <div class=\"form-group\" ng-if=\"vm.isUsingHlsJsOnRecording\">\n                      <label for=\"cueText\">Enter title for a new video index...</label>\n                      <div class=\"input-group\">\n                        <input type=\"text\" class=\"form-control\" id=\"cueText\" ng-model=\"vm.cue.name\" required>\n                        <span class=\"input-group-btn\">\n                          <button ng-click=\"vm.addCue()\" class=\"btn btn-primary btn-block overflow-ellipse\" style=\"width:100px\">\n                            Save\n                          </button>\n                        </span>\n                      </div>\n                      <p class=\"help-block\">\n                        <small>Video indexing allows you to tag individual spots in the broadcast for quick seeking by\n                          viewers.  The point in time is syncronized with the video player above.</small>\n                      </p>\n                    </div>\n                  </div>\n                </div>\n              </form>\n\n              <table class=\"table table-striped\" ng-if=\"vm.broadcast.content_settings.cues.length > 0\">\n                <thead>\n                  <tr><th colspan=\"3\">Video Index</th></tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"c in vm.broadcast.content_settings.cues\">\n                    <td class=\"text-left\" colspan=\"{{c.__enableEditMode ? 2 : 1}}\">\n                      <div ng-if=\"!c.__enableEditMode\">\n                        <strong><small>{{c.name}}</small></strong><br>\n                        <small>{{c.playback_start_time_fmt}}</small>\n                      </div>\n                      <div ng-if=\"c.__enableEditMode\">\n                        <div class=\"row\">\n                          <div class=\"col-xs-12\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"c.name\" placeholder=\"Enter video index title\" required>\n                          </div>\n                        </div>\n                        <div class=\"row\" style=\"margin-top:15px\">\n                          <div class=\"col-sm-3\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"c.playback_start_time_fmt\" required>\n                          </div>\n                          <div class=\"col-sm-9 text-sm-right\">\n                            <button type=\"button\" class=\"btn btn-default\" ng-click=\"c.__enableEditMode = false\">Cancel</button>\n                            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.deleteCue(c)\"><i class=\"fa fa-trash\"></i> Delete</button>\n                            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.editCue(c)\">Save Changes</button>\n                          </div>\n                        </div>\n                      </div>\n                    </td>\n                    <td align=\"right\" nowrap ng-if=\"!c.__enableEditMode\">\n                      <a href=\"javascript://\" ng-click=\"vm.seekCue(c)\"><i class=\"fa fa-play\"></i></a> &nbsp;\n                      <a href=\"javascript://\" ng-click=\"c.__enableEditMode = true\"><i class=\"fa fa-pencil-square-o\"></i></a>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </div><!--/ cues -->\n\n            <div ng-if=\"vm.activeTab == 'captions'\">\n              <div ng-if=\"!vm.caption && vm.broadcast.content_settings.caption_url || vm.publicBroadcast.has_captions\" class=\"bg-warning text-warning\" style=\"padding:10px; border:1px solid; margin: 15px 0\">\n                <h4>This broadcast was captioned with the legacy caption tool.</h4>\n                <p>We are in the process of testing a vastly improved closed captioning workflow.  Please\n                <a href=\"mailto:questions@boxcast.com\">contact support</a> for assistance upgrading this broadcast.</p>\n                <p><a href=\"{{vm.broadcast.content_settings.caption_url || vm.publicView.caption_url}}\" target=\"_blank\">Current WebVTT File</a></p>\n              </div>\n              <div ng-if=\"vm.broadcast.timeframe == 'past' && !vm.recordingIsTranscoded\" class=\"bg-warning text-warning\" style=\"padding:10px; border:1px solid; margin: 15px 0\">\n                <h4>This broadcast cannot be captioned.</h4>\n                <p>\n                  Only fully transcoded recordings are able to be captioned.  If this was an older upload, you may need\n                  to re-upload the video to ensure it is properly processed.\n                </p>\n              </div>\n              <div ng-if=\"vm.broadcast.timeframe == 'past' && vm.recordingIsTranscoded\">\n                <div ng-if=\"vm.loadingCaptions && !vm.caption\">\n                  <p><i class=\"fa fa-spin fa-spinner\"></i> Loading...</p>\n                </div>\n                <div class=\"text-center\" ng-if=\"!vm.loadingCaptions || vm.caption\">\n                  <caption-details broadcast=\"vm.broadcast\"\n                                              caption-meta=\"vm.caption\"\n                                              link-to-editor=\"true\"\n                                              on-create=\"vm.startCaptioning(upload)\"\n                                              on-download=\"vm.downloadCaption(format)\"></caption-details>\n                  <div ng-if=\"vm.captionTranscipt && vm.caption.publish_status != 'unpublished'\" style=\"margin-top:15px\">\n                    <pre class=\"text-xs\" style=\"text-align:left;\">{{::vm.captionTranscipt}}</pre>\n                  </div>\n                </div>\n              </div>\n              <div ng-if=\"vm.broadcast.timeframe == 'preroll' || vm.broadcast.timeframe == 'current'\">\n                <div class=\"row\" style=\"margin-top: 30px\">\n                  <div class=\"col-md-6 col-md-offset-3 text-center\">\n                    <p class=\"help-block\" style=\"font-size:10pt\">\n                      This broadcast is being captioned in real time. You can pause and resume captioning below.\n                    </p>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-xs-12 text-center\">\n                    <toggle-switch ng-model=\"vm.enableCaptionsStateValue\" ng-change=\"vm.updateEnableCaptions()\" label=\"Enable live captioning for this broadcast\"></toggle-switch>\n                  </div>\n                </div>\n              </div>\n            </div><!--/captions-->\n\n            <div ng-if=\"vm.activeTab == 'viewer_chat' && vm.FeatureFlags.viewer_chat\">\n\n              <div class=\"row\" style=\"margin-top: 30px\">\n                <div class=\"col-md-6 col-md-offset-3 text-center\">\n                  <p class=\"help-block\">\n                    <span ng-if=\"vm.account.content_settings.showChat\">\n                      Your account has enabled chat by default on all broadcasts.\n                    </span>\n                    <span ng-if=\"!vm.account.content_settings.showChat\">\n                      Your account has not enabled chat by default for all broadcasts.\n                    </span>\n                    You can override that setting below, or <a href=\"/settings/preferences\">update your account default settings</a>.\n                  </p>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-xs-12 text-center\">\n                  <ol class=\"list-inline\" style=\"line-height: 30px\">\n                    <li>\n                      <toggle-switch ng-model=\"vm.showChatStateValue\" ng-change=\"vm.updateShowChat()\" label=\"Enable chat for this broadcast\"></toggle-switch>\n                    </li>\n                    <li>\n                      <span style=\"border-right:1px solid #ccc; display:inline-block; height: 30px; vertical-align: bottom; margin: 0 15px 0\"></span>\n                    </li>\n                    <li>\n                      <a ng-disabled=\"vm.broadcast.timeframe == 'past'\" class=\"btn btn-primary\" href=\"/events/{{vm.broadcast.id}}/moderate-chat\">Moderate Chat</a>\n                    </li>\n                  </ol>\n                </div>\n              </div>\n            </div><!--/viewer_chat-->\n\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-sm-4 col-lg-3 broadcast-details-right-col\">\n      <!-- start/stop to keep visible at all times -->\n      <div style=\"margin-bottom:30px;\">\n        <table class=\"inner-border-only\" style=\"width:100%;margin:0;\">\n          <tr>\n            <td style=\"padding-left:0\">\n              <h4 style=\"margin:0\">DATE</h4>\n              <strong>{{vm.broadcast.starts_at|date}}</strong>\n            </td>\n            <td>\n              <h4 style=\"margin:0\">START</h4>\n              <strong>{{vm.broadcast.starts_at|date:'shortTime'}}</strong>\n            </td>\n            <td ng-if=\"vm.broadcast.stops_at && !vm.broadcast.stops_at.startsWith('9999-12-31')\">\n              <h4 style=\"margin:0\">STOP</h4>\n              <strong>{{vm.broadcast.stops_at|date:'shortTime'}}</strong>\n            </td>\n          </tr>\n        </table>\n      </div>\n\n      <!-- only show full boxcaster details/status if event isn't already over -->\n      <div ng-if=\"vm.canUsePreview || vm.canEdit && ((vm.broadcast.timeframe == 'preroll') || (vm.broadcast.timeframe == 'current') || (vm.broadcast.stream_source == 'producer' && vm.broadcast.timeframe !== 'past'))\" style=\"margin-bottom:30px;\">\n        <h4 style=\"margin-top:0\">Broadcast Controls</h4>\n        <p>\n          <a ng-href=\"{{ vm.producerBroadcastURL }}\" \n            ng-if=\"vm.canEnterProducer && vm.broadcast.stream_source == 'producer' && vm.broadcast.timeframe !== 'past'\"\n            analytics-on analytics-event=\"enter-producer\" analytics-category=\"enter\" analytics-label=\"\"\n            class=\"btn btn-block btn-lagoon overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fak fa-producer-clapper\" style=\"width:20px\"></i>\n            Enter Broadcast in Producer\n          </a>\n          <button ng-if=\"vm.canUsePreview\"\n                  ng-click=\"vm.preview = !vm.preview\"\n                  analytics-on analytics-event=\"event-edit\" analytics-category=\"preview\" analytics-label=\"\"\n                  class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-video-camera\" style=\"width:20px\"></i>\n            <span ng-hide=\"vm.preview\">Show Preview</span>\n            <span ng-show=\"vm.preview\">Exit Preview</span>\n          </button>\n          <button ng-if=\"::vm.canEdit\"\n                  ng-show=\"vm.broadcast.timeframe == 'preroll' && vm.broadcast.stream_source !== 'producer'\"\n                  ng-click=\"vm.startASAP()\"\n                  analytics-on analytics-event=\"event-edit\" analytics-category=\"start-asap\" analytics-label=\"\"\n                  class=\"btn btn-block btn-success overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-power-off\" style=\"width:20px\"></i>\n            Start Now\n          </button>\n          <button ng-if=\"::vm.canEdit\"\n                  ng-show=\"vm.broadcast.timeframe == 'current' || vm.broadcast.timeframe == 'preroll'\"\n                  ng-click=\"vm.stop()\"\n                  analytics-on analytics-event=\"event-edit\" analytics-category=\"stop\" analytics-label=\"\"\n                  class=\"btn btn-block btn-danger overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"far fa-stop-circle\" style=\"width:20px\"></i>\n            Stop Broadcast\n          </button>\n        </p>\n      </div>\n\n      <!-- only show recording controls if recording is available and that recording is not an imported MP4 -->\n      <div ng-if=\"vm.showRecordingControls\" style=\"margin-bottom:30px\">\n        <h4 style=\"margin-top:0\">Recording Controls</h4>\n        <p ng-if=\"vm.recordingIsTranscoded\">\n          <a ui-sref=\"events.trim({id: vm.broadcast.id, recording: vm.broadcast.recording_id})\"\n            analytics-on analytics-event=\"event-edit\" analytics-category=\"trim\" analytics-label=\"\"\n            class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-crop\" style=\"width:20px\"></i>\n            Trim Recording\n          </a>\n        </p>\n        <!-- XXX: TODO: make edit highlights not depend on recording ID so we can edit them while still live -->\n        <p ng-if=\"vm.showEditHighlightClips\">\n          <a ui-sref=\"events.highlights({id: vm.broadcast.id, recording: vm.broadcast.recording_id})\"\n            analytics-on analytics-event=\"event-edit\" analytics-category=\"highlight\" analytics-label=\"edit-clips\"\n            class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-camera\" style=\"width:20px\"></i>\n            Edit Highlight Clips\n          </a>\n        </p>\n        <p ng-if=\"vm.canDownloadOrExport\">\n          <button ng-click=\"vm.downloadOrExport()\"\n                  analytics-on analytics-event=\"event-edit\" analytics-category=\"download\" analytics-label=\"\"\n                  class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-download\" style=\"width:20px\"></i>\n            Download or Export Recording\n          </button>\n        </p>\n        <p ng-if=\"vm.showUploadReplacement\">\n          <button ng-click=\"vm.uploadReplacement()\"\n                  analytics-on analytics-event=\"event-edit\" analytics-category=\"upload\" analytics-label=\"\"\n                  class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-upload\" style=\"width:20px\"></i>\n            Upload Replacement Video\n          </button>\n        </p>\n        <p ng-if=\"vm.showReplayViaSimulatedLive\">\n          <button ng-click=\"vm.scheduleSimulatedLive()\"\n                  analytics-on analytics-event=\"event-edit\" analytics-category=\"simulated-live\" analytics-label=\"\"\n                  class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-repeat\" style=\"width:20px\"></i>\n            Re-Broadcast (Simulated Live)\n          </button>\n        </p>\n      </div>\n\n      <!-- only show full boxcaster details/status if broadcast isn't already over -->\n      <div style=\"margin-bottom:30px\">\n        <h4 style=\"margin-top:0\">Source</h4>\n\n        <div ng-if=\"vm.broadcast.stream_source == 'boxcaster'\">\n          <div ng-if=\"vm.broadcast.timeframe == 'past'\">\n            <a href=\"{{vueDashboardRoot}}/sources?boxcaster_id={{vm.broadcast.boxcaster_id}}\" class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n              <i class=\"pull-right fa fa-chevron-right\"></i>\n              BoxCaster {{vm.broadcast.boxcaster_name}}\n            </a>\n          </div>\n          <div ng-if=\"vm.broadcast.timeframe != 'past'\">\n            <button ng-if=\"vm.broadcast.boxcaster_id\"\n                    class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                    ng-click=\"vm.showSourceDetails = !vm.showSourceDetails\">\n              <i class=\"fa fa-circle diagnostics--icon-{{vm.boxCasterStatusLabel}}\" style=\"width:20px\"></i>\n              <i class=\"pull-right fa fa-chevron-{{vm.showSourceDetails?'up':'down'}}\"></i>\n              BoxCaster {{vm.broadcast.boxcaster_name}}\n            </button>\n            <div class=\"destination-details\" ng-show=\"vm.showSourceDetails\">\n              <table class=\"inner-border-only\" style=\"width:100%\">\n                <tr ng-if=\"vm.boxcaster.warning != 'none'\">\n                  <td colspan=\"2\">\n                    <div class=\"bg-warning text-warning text-center\" style=\"padding:5px 3px;border:1px solid;margin:0;\">\n                      <strong>{{vm.boxcaster.warning | unslugify}}</strong>\n                    </div>\n                  </td>\n                </tr>\n                <tr ng-if=\"vm.boxcaster.status == 'broadcasting' && vm.boxcaster.next_broadcast_id && vm.boxcaster.next_broadcast_id != vm.broadcast.id\">\n                  <td colspan=\"2\">\n                    <div class=\"bg-warning text-warning text-center\" style=\"padding:5px 3px;border:1px solid;margin:0;\">\n                      Broadcasting Another Broadcast<br>\n                      <a ui-sref=\"events.detail({id: vm.boxcaster.next_broadcast_id})\">{{vm.boxcaster.next_broadcast_name}}</a>\n                    </div>\n                  </td>\n                </tr>\n                <tr>\n                  <td colspan=\"{{vm.broadcast.timeframe != 'future' ? 1 : 2}}\" valign=\"top\">\n                    Status<br>\n                    <strong>{{vm.boxcaster.status | unslugify}}</strong>\n                  </td>\n                  <td ng-if=\"vm.broadcast.timeframe != 'future'\" valign=\"top\">\n                    Video Source<br>\n                    <strong>{{vm.videoInputName || '-'}}</strong>\n                  </td>\n                </tr>\n                <tr ng-if=\"vm.broadcast.timeframe != 'future'\">\n                  <td ng-class=\"(vm.lockedInputMismatchWarning ? 'text-warning bg-warning' : '')\" valign=\"top\">\n                    Video Input<br>\n                    <strong ng-hide=\"vm.lockedInputMismatchWarning\">{{vm.videoInputStandard || '-'}}</strong>\n                    <strong ng-show=\"vm.lockedInputMismatchWarning\">\n                      Need: {{vm.streamDiagnostics.locked_standard || '-'}}<br>\n                      Currently: {{vm.videoInputStandard || '-'}}\n                    </strong>\n                  </td>\n                  <td valign=\"top\">\n                    Streaming Profile<br>\n                    <strong>\n                      {{vm.streamingProfileName || '-'}}\n                    </strong>\n                    <span ng-if=\"vm.broadcast.actual_high_frame_rate === true\">\n                      (up to 60 FPS)\n                    </span>\n                  </td>\n                </tr>\n                <tr ng-if=\"!vm.streamingProfileMatchesVideoInput\" class=\"text-center\">\n                  <td colspan=\"2\">\n                    <a href=\"https://support.boxcast.com/en/articles/4235058\" target=\"_blank\">Why are these different? <i class=\"fa fa-external-link\"></i></a>\n                  </td>\n                </tr>\n                <tr>\n                  <td colspan=\"2\">\n                    WAN IP Address<br>\n                    <strong>{{vm.boxcaster.last_seen_ip || '-'}}</strong>\n                  </td>\n                </tr>\n                <tr>\n                  <td colspan=\"2\">\n                    <p style=\"margin-bottom:0;text-align:center\">\n                      <a href=\"{{vueDashboardRoot}}/sources?boxcaster_id={{vm.broadcast.boxcaster_id}}\">BoxCaster Settings</a>\n                    </p>\n                  </td>\n                </tr>\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.broadcast.stream_source == 'rtmp'\">\n          <div ng-if=\"vm.broadcast.timeframe == 'past'\">\n            <div ng-if=\"vm.broadcast.static_rtmp_name && vm.broadcast.static_rtmp_id\">\n              <a  href=\"{{vueDashboardRoot}}/sources?static_rtmp_id={{vm.broadcast.static_rtmp_id}}\" class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n                <i class=\"pull-right fa fa-chevron-right\"></i>\n                {{vm.broadcast.static_rtmp_name}}\n              </a>\n            </div>\n            <div ng-if=\"vm.broadcast.static_rtmp_name && !vm.broadcast.static_rtmp_id\">\n              <strong>{{vm.broadcast.static_rtmp_name}}</strong>\n            </div>\n            <div ng-if=\"!vm.broadcast.static_rtmp_name\">\n              <strong>Single-Use RTMP</strong>\n            </div>\n          </div>\n          <div ng-if=\"vm.broadcast.timeframe != 'past'\">\n            <button ng-if=\"vm.showRtmpConfig && vm.isTriCaster\"\n                    ng-click=\"vm.tricaster()\"\n                    class=\"btn btn-block btn-primary overflow-ellipse\" style=\"text-align:left\">\n              <i class=\"fa fa-cog\" style=\"width:20px\"></i>\n              Broadcast From TriCaster\n            </button>\n            <button ng-if=\"vm.showRtmpConfig && !vm.isTriCaster && !vm.broadcast.static_rtmp_name\"\n                    class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                    ng-click=\"vm.showSourceDetails = !vm.showSourceDetails\">\n              <i class=\"pull-right fa fa-chevron-{{vm.showSourceDetails?'up':'down'}}\"></i>\n              <i class=\"fa fa-cog\" style=\"width:20px\"></i>\n              RTMP Encoder Settings\n            </button>\n            <button ng-if=\"vm.showRtmpConfig && !vm.isTriCaster && vm.broadcast.static_rtmp_name\"\n                    class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                    ng-click=\"vm.showSourceDetails = !vm.showSourceDetails\">\n              <i class=\"fa fa-circle diagnostics--icon-{{vm.staticRTMPStatusLabel}}\" style=\"width:20px\"></i>\n              <i class=\"pull-right fa fa-chevron-{{vm.showSourceDetails?'up':'down'}}\"></i>\n              {{vm.broadcast.static_rtmp_name}}\n            </button>\n            <div class=\"destination-details\" ng-show=\"vm.showSourceDetails\">\n              <table class=\"inner-border-only\" style=\"width:100%;table-layout:fixed;overflow:hidden;\">\n                <tr>\n                  <td colspan=\"2\" valign=\"top\">\n                    Server URL and Stream Key<br>\n                    <div style=\"position:relative;\">\n                      <strong title=\"{{vm.broadcast.rtmp_ingestion_url || '-'}}\" style=\"display:inline-block;max-width:90%;word-wrap: break-word;\">\n                        {{vm.broadcast.rtmp_ingestion_url || '-'}}\n                      </strong>\n                      <span ng-if=\"$root.clipboard.supported\" style=\"position:absolute;right:0;top:0;\">\n                        <a href=\"javascript://\"\n                          clipboard\n                          text=\"vm.broadcast.rtmp_ingestion_url\"\n                          on-copied=\"$root.toaster.pop('success', 'Successfully copied')\"\n                          on-error=\"$root.toaster.pop('warning', 'Could not be copied')\">\n                          <i class=\"fa fa-copy\"></i>\n                        </a>\n                      </span>\n                    </div>\n                  </td>\n                </tr>\n                <tr ng-if=\"vm.broadcast.static_rtmp_name\">\n                  <td valign=\"top\">\n                    Status<br>\n                    <strong>{{vm.staticRTMPStatus}}</strong>\n                  </td>\n                  <td valign=\"top\">\n                    Video Input<br>\n                    <strong>{{vm.staticRTMPVideoInput || '-'}}</strong>\n                  </td>\n                </tr>\n                <tr ng-if=\"vm.broadcast.timeframe != 'future'\">\n                  <td valign=\"top\">\n                    Video Parameters<br>\n                    <strong>\n                      {{vm.rtmpVideoParams.width}}x{{vm.rtmpVideoParams.height}},\n                      {{vm.rtmpVideoParams.framerate}} FPS\n                    </strong>\n                  </td>\n                  <td valign=\"top\">\n                    Streaming Profile<br>\n                    <strong>\n                      {{vm.streamingProfileName || '-'}}\n                    </strong>\n                    <span ng-if=\"vm.broadcast.actual_high_frame_rate === false\">\n                      (up to 30 FPS)\n                    </span>\n                    <span ng-if=\"vm.broadcast.actual_high_frame_rate === true\">\n                      (up to 60 FPS)\n                    </span>\n                  </td>\n                </tr>\n                <tr>\n                  <td colspan=\"2\" valign=\"top\" class=\"text-center\">\n                    <a href=\"javascript://\" ng-click=\"vm.rtmp()\">Show Full RTMP Settings</a>\n                  </td>\n                </tr>\n                <tr>\n                  <td colspan=\"2\" valign=\"top\" class=\"text-center\">\n                    <a href=\"https://support.boxcast.com/en/articles/4235181\" target=\"_blank\">RTMP Help <i class=\"fa fa-external-link\"></i></a>\n                  </td>\n                </tr>\n              </table>\n            </div>\n            <div ng-if=\"!vm.showRtmpConfig\">\n              <strong>RTMP Encoder Settings Not Yet Available</strong>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.broadcast.stream_source == 'app'\">\n          <div ng-if=\"vm.broadcast.timeframe == 'past'\">\n            <a href=\"{{vueDashboardRoot}}/sources?broadcaster_app=true\" class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n              <i class=\"pull-right fa fa-chevron-right\"></i>\n              Broadcaster App\n            </a>\n          </div>\n          <div ng-if=\"vm.broadcast.timeframe != 'past'\">\n            <button class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                    ng-click=\"vm.showSourceDetails = !vm.showSourceDetails\">\n              <i class=\"pull-right fa fa-chevron-{{vm.showSourceDetails?'up':'down'}}\"></i>\n              Broadcaster App\n            </button>\n            <div class=\"destination-details\" ng-show=\"vm.showSourceDetails\">\n              <table class=\"inner-border-only\" style=\"width:100%\">\n                <tr>\n                  <td valign=\"top\">\n                    Streaming Profile<br>\n                    <strong>\n                      {{vm.streamingProfileName || '-'}}\n                    </strong>\n                    <span ng-if=\"vm.broadcast.actual_high_frame_rate === true\">\n                      (up to 60 FPS)\n                    </span>\n                  </td>\n                </tr>\n                <tr>\n                  <td valign=\"top\">\n                    <a href=\"https://support.boxcast.com/en/articles/4235049\" target=\"_blank\">Help using Broadcaster <i class=\"fa fa-external-link\"></i></a>\n                  </td>\n                </tr>\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.broadcast.stream_source == 'switcher'\">\n          <strong>Switcher Studio</strong>\n        </div>\n\n        <div ng-if=\"vm.broadcast.stream_source == 'imported'\">\n          <strong>Imported File</strong>\n        </div>\n\n        <div ng-if=\"vm.broadcast.stream_source == 'recording'\">\n          <a ng-if=\"!vm.sourceBroadcastUnavailable && vm.sourceBroadcast\"\n             ui-sref=\"events.detail({id: vm.broadcast.source_broadcast_id})\"\n             class=\"btn btn-block btn-default\"\n             style=\"text-align:left\">\n            <recording-source-chooser-preview broadcast=\"vm.sourceBroadcast\"></recording-source-chooser-preview>\n          </a>\n          <div ng-if=\"!vm.sourceBroadcastUnavailable && !vm.sourceBroadcast\"><i class=\"fa fa-spin fa-spinner\"></i> Re-Broadcast (Simulated Live)</div>\n          <div ng-if=\"vm.sourceBroadcastUnavailable\" class=\"btn btn-block btn-default\" style=\"text-align: left; cursor: default; pointer-events: none;\">\n            <i class=\"fa fa-repeat\"></i> Re-Broadcast (Simulated Live)\n          </div>\n        </div>\n\n        <div ng-if=\"vm.broadcast.stream_source == 'producer'\">\n          <strong>Producer (Browser-based streaming)</strong>\n        </div>\n\n      </div>\n\n      <!-- used to only show destination for non-past, but let's keep them around -->\n      <div ng-if=\"!vm.broadcast.is_ticketed && vm.broadcast.simulcast_configurations.length\" style=\"margin-bottom:30px\">\n        <h4 style=\"margin-top:0\">Destinations</h4>\n\n        <div ng-repeat=\"s in vm.broadcast.simulcast_configurations\" style=\"margin-bottom:10px\">\n          <div ng-switch=\"s.destination\">\n            <div ng-switch-when=\"facebook\">\n              <button class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                      ng-click=\"vm.toggleActiveDestinationDetails($index)\">\n                <i ng-if=\"vm.broadcast.timeframe != 'past'\" class=\"fa fa-circle diagnostics--icon-{{vm.diagnosticsIconStyle(s, $index)}}\" style=\"width:20px\"></i>\n                <i class=\"pull-right fa fa-chevron-{{vm.activeDestinationDetails[$index]?'up':'down'}}\"></i>\n                <span class=\"font-medium\">Facebook</span>\n                <span class=\"body-3 text-muted\">{{s.fb_user_name}}</span>\n              </button>\n              <div class=\"destination-details\" ng-if=\"vm.activeDestinationDetails[$index]\">\n                <p class=\"help-block\" ng-show=\"vm.broadcast.timeframe == 'future' && !s.fb_id && vm.canCreateFacebookLiveScheduledEvent\">\n                  BoxCast will automatically create the Facebook Live event on the linked\n                  account at the time of the broadcast. Want to create a scheduled live post?\n                  <span ng-hide=\"s.__updating\">\n                    <br><a href analytics-on analytics-event=\"create-scheduled-fb\" analytics-category=\"destinations\" ng-click=\"vm.createFacebookLiveScheduledEvent(s)\">Create the scheduled live event now</a>.\n                  </span>\n                  <span ng-show=\"s.__updating\">\n                    <br><i class=\"fa fa-spin fa-spinner\"></i> Scheduling live event...\n                  </span>\n                </p>\n                <p class=\"help-block\" ng-show=\"vm.broadcast.timeframe == 'future' && !s.fb_id && !vm.canCreateFacebookLiveScheduledEvent\">\n                  BoxCast will automatically create the Facebook Live event on the linked\n                  account at the time of the broadcast. Want to create a scheduled live post? Return here within 7\n                  days of the broadcast start date to schedule the live broadcast.\n                </p>\n                <p>\n                  Streaming Status:<br>\n                  <strong>{{s.status | simulcastStatus}}</strong>\n                  <div ng-if=\"s.status === 'error' && s.fb_status\" class=\"bg-danger text-danger\" style=\"padding:10px; margin:10px 0;border:1px solid\">\n                    {{s.fb_status}}\n                  </div>\n                </p>\n                <p ng-if=\"vm.broadcast.timeframe != 'past' && vm.activeDestinationStatus[$index]\">\n                  Last Detected Frame Rate:<br>\n                  <strong>{{vm.activeDestinationStatus[$index].fps}} FPS</strong>\n                </p>\n                <p>\n                  Linked to Account:<br>\n                  <strong>{{s.fb_user_name}}</strong>\n                  <span ng-if=\"s.fb_feed_id == 'user:me'\">(to timeline)</span>\n                  <span ng-if=\"s.fb_feed_id != 'user:me'\">\n                    <a href=\"https://www.facebook.com/{{vm.facebookLiveSimulcastFeedID(s)}}\" target=\"_blank\">\n                      (to {{ vm.facebookLiveSimulcastFeedType(s) }} ID {{ vm.facebookLiveSimulcastFeedID(s) }})\n                      <i class=\"fa fa-external-link\"></i>\n                    </a>\n                  </span>\n                </p>\n                <p style=\"margin-bottom:0\">Links:</p>\n                <ul>\n                  <li><a ui-sref=\"settings.facebook\">BoxCast Facebook Account Settings</a></li>\n                  <li ng-if=\"vm.canShowFacebookLiveProducerURL(s)\">\n                    <a ng-href=\"{{s.live_producer_url}}\" target=\"_blank\">Facebook Live Producer</a>\n                    <i class=\"fa fa-question-circle\" uib-tooltip=\"Facebook Live Producer can give you more information about your stream. Be careful not change any settings, as they have already been configured by BoxCast.\"></i>\n                  </li>\n                  <li ng-if=\"vm.canShowFacebookPermalinkURL(s)\"><a ng-href=\"{{s.permalink_url}}\" target=\"_blank\">Facebook Video Page</a></li>\n                </ul>\n              </div>\n            </div>\n            <div ng-switch-when=\"youtube\">\n              <button class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                      ng-click=\"vm.toggleActiveDestinationDetails($index)\">\n                <i ng-if=\"vm.broadcast.timeframe != 'past'\" class=\"fa fa-circle diagnostics--icon-{{vm.activeDestinationStatus[$index].connected ? 'connected' : ''}}\" style=\"width:20px\"></i>\n                <i class=\"pull-right fa fa-chevron-{{vm.activeDestinationDetails[$index]?'up':'down'}}\"></i>\n                <span class=\"font-medium\">YouTube</span>\n                <span class=\"body-3 text-muted\"> - {{s.youtube_display_name}}</span>\n              </button>\n              <div class=\"destination-details\" ng-if=\"vm.activeDestinationDetails[$index]\">\n                <div ng-if=\"!s.youtube_broadcast_id\">\n                  <p class=\"help-block\" ng-show=\"vm.broadcast.timeframe == 'past'\">\n                    It appears that the YouTube Live simulcast was not properly linked.\n                  </p>\n                  <p class=\"help-block\" ng-show=\"vm.broadcast.timeframe == 'future'\">\n                    BoxCast will automatically create the YouTube Live event on the linked\n                    account at the time of the broadcast. Need the watch URL prior to the start of the broadcast?\n                    <span ng-hide=\"s.__updating\">\n                      <br><a analytics-on analytics-event=\"create-scheduled-yt\" analytics-category=\"destinations\" href ng-click=\"vm.createYouTubeEvent(s)\">Create the YouTube event now</a>.\n                    </span>\n                    <span ng-show=\"s.__updating\">\n                      <br><i class=\"fa fa-spin fa-spinner\"></i> Scheduling live event...\n                    </span>\n                  </p>\n                </div>\n                <div ng-if=\"s.youtube_broadcast_id || vm.broadcast.timeframe == 'current' || vm.broadcast.timeframe == 'preroll'\">\n                  <p>\n                    Streaming Status:<br>\n                    <strong>{{s.status | simulcastStatus}}</strong>\n                    <div ng-if=\"s.youtube_error\" class=\"bg-danger text-danger\" style=\"padding:10px; margin:10px 0;border:1px solid\">\n                      {{s.youtube_error}}\n                    </div>\n                  </p>\n                  <p ng-if=\"vm.broadcast.timeframe != 'past' && vm.activeDestinationStatus[$index]\">\n                    Last Detected Frame Rate:<br>\n                    <strong>{{vm.activeDestinationStatus[$index].fps}} FPS</strong>\n                  </p>\n                  <p>\n                    Linked to Account:<br>\n                    <strong>{{s.youtube_display_name}}</strong>\n                  </p>\n                  <p style=\"margin-bottom:0\">Links:</p>\n                  <ul>\n                    <li><a ui-sref=\"settings.youtube\">BoxCast YouTube Account Settings</a></li>\n                    <li ng-show=\"s.youtube_broadcast_id\">\n                      <a ng-href=\"https://www.youtube.com/live_event_analytics?v={{s.youtube_broadcast_id}}\"\n                         target=\"_blank\">YouTube Live Control Room</a>\n                    </li>\n                    <li ng-show=\"s.youtube_broadcast_id\">\n                      <a ng-href=\"{{vm.youtubeWatchUrl(s)}}\" target=\"_blank\">YouTube Watch Page</a>\n                    </li>\n                  </ul>\n                  <div class=\"fixed-16-9\" style=\"margin-left:-10px;margin-right:-10px;margin-bottom:-5px;\">\n                    <iframe ng-if=\"s.youtube_broadcast_id\"\n                            ng-src=\"{{vm.youtubeEmbedUrl(s)}}\"\n                            frameborder=\"0\" allowfullscreen></iframe>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div ng-switch-when=\"periscope\">\n              <button class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                      ng-click=\"vm.toggleActiveDestinationDetails($index)\">\n                <i class=\"pull-right fa fa-chevron-{{vm.activeDestinationDetails[$index]?'up':'down'}}\"></i>\n                <span class=\"font-medium\">Periscope</span>\n                <span class=\"body-3 text-muted\">{{s.periscope_display_name}}</span>\n              </button>\n              <div class=\"destination-details\" ng-if=\"vm.activeDestinationDetails[$index]\">\n                <div ng-if=\"!s.share_url\">\n                  <p class=\"help-block\">\n                    It appears that the Periscope simulcast was not properly linked.\n                  </p>\n                </div>\n                <div ng-if=\"s.share_url\">\n                  <p>\n                    Linked to Account:<br>\n                    <strong>{{s.periscope_display_name}}</strong>\n                  </p>\n                  <p style=\"margin-bottom:0\">Links:</p>\n                  <ul>\n                    <li ng-show=\"s.share_url\">\n                      <a ng-href=\"{{vm.periscopeWatchUrl(s)}}\" target=\"_blank\">Watch on pscp.tv</a>\n                    </li>\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div ng-switch-when=\"rtmp_push_channel\">\n              <button class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                      ng-click=\"vm.toggleActiveDestinationDetails($index)\">\n                <i ng-if=\"vm.broadcast.timeframe != 'past'\" class=\"fa fa-circle diagnostics--icon-{{vm.activeDestinationStatus[$index].connected ? 'connected' : ''}}\" style=\"width:20px\"></i>\n                <i class=\"pull-right fa fa-chevron-{{vm.activeDestinationDetails[$index]?'up':'down'}}\"></i>\n                <span class=\"font-medium\">RTMP</span>\n                <span class=\"body-3 text-muted\"> - {{s.name}} <small>({{vm.sanitizeRTMPURL(s.stream_url)}})</small></span>\n              </button>\n              <div class=\"destination-details\" ng-if=\"vm.activeDestinationDetails[$index]\">\n                <p class=\"mb-0 mt-base\">Simulcasting to RTMP Destination:</p>\n                <p class=\"font-bold mb-base\">{{s.name}}</p>\n                <p class=\"mb-0\">Stream URL:</p>\n                <p class=\"font-bold\">{{vm.sanitizeRTMPURL(s.stream_url)}}</p>\n\n                <p ng-if=\"vm.broadcast.timeframe != 'past' && vm.activeDestinationStatus[$index]\">\n                  Last Detected Frame Rate:<br>\n                  <strong>{{vm.activeDestinationStatus[$index].fps}} FPS</strong>\n                </p>\n                <p></p>\n              </div>\n            </div>\n            <div ng-switch-when=\"twitter\">\n              <button class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                ng-click=\"vm.toggleActiveDestinationDetails($index)\">\n                <i ng-if=\"vm.broadcast.timeframe != 'past'\"\n                  class=\"fa fa-circle diagnostics--icon-{{vm.activeDestinationStatus[$index].connected ? 'connected' : ''}}\"\n                  style=\"width:20px\"></i>\n                <i class=\"pull-right fa fa-chevron-{{vm.activeDestinationDetails[$index]?'up':'down'}}\"></i>\n                <span class=\"font-medium\">Twitter</span>\n                <span class=\"body-3 text-muted\">{{s.twitter_display_name}}</span>\n              </button>\n              <div class=\"destination-details\" ng-if=\"vm.activeDestinationDetails[$index]\">\n                <div ng-if=\"!s.share_url\">\n                  <p class=\"help-block mt-base\" ng-show=\"vm.broadcast.timeframe == 'past'\">\n                    It appears that the Twitter simulcast was not properly linked.\n                  </p>\n                  <p class=\"help-block\" ng-show=\"vm.broadcast.timeframe == 'future'\">\n                    BoxCast will automatically create the Twitter event on the linked account at\n                    the time of the broadcast.\n                  </p>\n                </div>\n                <div ng-if=\"s.share_url || vm.broadcast.timeframe == 'current' || vm.broadcast.timeframe == 'preroll'\">\n                  <p class=\"mt-base\">\n                    Streaming Status:<br>\n                    <strong>{{s.status | simulcastStatus}}</strong>\n                  </p>\n                  <p ng-if=\"vm.broadcast.timeframe != 'past' && vm.activeDestinationStatus[$index]\">\n                    Last Detected Frame Rate:<br>\n                    <strong>{{vm.activeDestinationStatus[$index].fps}} FPS</strong>\n                  </p>\n                  <p>\n                    Linked to Account:<br>\n                    <strong>{{s.twitter_display_name}}</strong>\n                  </p>\n                  <p style=\"margin-bottom:0\">Links:</p>\n                  <ul>\n                    <li><a ui-sref=\"settings.twitter\">BoxCast Twitter Account Settings</a></li>\n                    <li ng-show=\"s.share_url\">\n                      <a ng-href=\"{{vm.twitterWatchUrl(s)}}\" target=\"_blank\">Watch on Twitter</a>\n                    </li>\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div ng-switch-default>\n              <button class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                      ng-click=\"vm.toggleActiveDestinationDetails($index)\">\n                <i ng-if=\"vm.broadcast.timeframe != 'past'\" class=\"fa fa-circle diagnostics--icon-{{vm.activeDestinationStatus[$index].connected ? 'connected' : ''}}\" style=\"width:20px\"></i>\n                <i class=\"pull-right fa fa-chevron-{{vm.activeDestinationDetails[$index]?'up':'down'}}\"></i>\n                <span class=\"font-medium\">Custom RTMP</span>\n                <span class=\"body-3 text-muted\"> - {{s.stream_url}}</span>\n              </button>\n              <div class=\"destination-details\" ng-if=\"vm.activeDestinationDetails[$index]\">\n                <p class=\"mt-base\">\n                  Simulcasting to Stream URL:<br>\n                  <strong>{{s.stream_url}}</strong>\n                  <!--{{s.stream_key}}-->\n                </p>\n                <p ng-if=\"vm.broadcast.timeframe != 'past' && vm.activeDestinationStatus[$index]\">\n                  Last Detected Frame Rate:<br>\n                  <strong>{{vm.activeDestinationStatus[$index].fps}} FPS</strong>\n                </p>\n                <p></p>\n              </div>\n            </div>\n          </div>\n        </div>\n\n      </div>\n\n\n      <div ng-if=\"vm.broadcast.timeframe != 'future'\" style=\"margin-bottom:30px;\">\n        <h4 style=\"margin-top:0\">\n          Analytics Summary\n        </h4>\n        <div style=\"background:#fff;border:1px solid #ccc;border-radius:4px;padding:10px;\">\n          <table style=\"width:100%\" class=\"text-left\">\n            <tr class=\"font-medium text-xs text-bx-accessible-grey\">\n              <td style=\"width:33%\">ACTIVE</td>\n              <td style=\"width:33%\" ng-if=\"::vm.hasAnalyticsFeature\">PEAK</td>\n              <td style=\"width:33%\">TOTAL VIEWS</td>\n            </tr>\n            <tr style=\"font-weight:bold;font-size:1.6em\">\n              <td>{{vm.broadcast.total_active_viewer_count|number}}</td>\n              <td ng-if=\"::vm.hasAnalyticsFeature\">{{vm.broadcast.peak_active_viewer_count|number}}</td>\n              <td>{{vm.broadcast.total_view_count|number}}</td>\n            </tr>\n          </table>\n        </div>\n      </div>\n\n      <div ng-if=\"vm.broadcast.is_ticketed || vm.broadcast.sold_ticket_count > 0\">\n        <h4 style=\"margin-top:0\">\n          Ticketing\n        </h4>\n        <div style=\"background:#fff;border:1px solid #ccc;border-radius:4px;padding:10px;margin-bottom:30px;\">\n          <table style=\"width:100%\" class=\"text-left\">\n            <tr style=\"border-bottom:1px solid #eee;font-weight:bold;\">\n              <td class=\"text-bx-accessible-grey\" style=\"padding-bottom:10px;\">TICKET PRICE</td>\n              <td style=\"padding-bottom:10px;\">\n                {{vm.broadcast.ticket_price|currency}}\n                <a href=\"javascript://\" ng-click=\"vm.edit('publish')\" ng-if=\"::vm.canEdit\" class=\"action-link\" style=\"color:#333;\"><i class=\"fa fa-pencil\"></i></a>\n              </td>\n            </tr>\n            <tr style=\"font-weight:bold;\">\n              <td class=\"text-bx-accessible-grey\" style=\"width:50%;padding-top:10px;\">TICKETS SOLD</td>\n              <td class=\"text-bx-accessible-grey\" style=\"width:50%;padding-top:10px;\">TICKET REVENUE</td>\n            </tr>\n            <tr style=\"font-weight:bold;font-size:1.6em;border-bottom:1px solid #eee\">\n              <td>{{vm.broadcast.sold_ticket_count|number:0}}</td>\n              <td>${{vm.broadcast.sold_ticket_total|number:2}}</td>\n            </tr>\n            <tr>\n              <td colspan=\"2\" style=\"padding-top:10px\">\n                <a ui-sref=\"reports.tickets({report: 'broadcasts', id: vm.broadcast.id})\" class=\"btn btn-sm btn-block btn-default\" style=\"text-align:left;\">\n                  <i class=\"fa fa-ticket\"></i> Ticket Report\n                </a>\n              </td>\n            </tr>\n            <tr ng-repeat=\"channel_id in vm.broadcast.in_channel_ids\"\n                ng-if=\"::vm.channelMap[channel_id].ticket_price\">\n              <td colspan=\"2\" style=\"padding-top:5px;\">\n                <a ui-sref=\"reports.tickets({report: 'channels', id: channel_id})\" class=\"btn btn-sm btn-block btn-default\" style=\"text-align:left;height:auto;white-space:initial;\">\n                  <i class=\"fa fa-ticket\"></i> Ticket Report: {{::vm.channelMap[channel_id].name}}\n                </a>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n\n      <div ng-if=\"(vm.allowPromote || vm.allowEmbed) && (vm.broadcast.timeframe != 'past' || vm.recordingIsAvailable)\">\n        <h4 style=\"margin-top:0\">Promote this Broadcast</h4>\n        <div class=\"text-center\">\n          <ul class=\"list-inline\">\n            <li ng-if=\"vm.allowPromote\">\n              <a class=\"btn btn-primary\" href=\"{{vm.emailLink}}\"\n                analytics-on analytics-event=\"event-promote\" analytics-category=\"email\" analytics-label=\"\"\n                uib-tooltip=\"Email event invitation\" tooltip-placement=\"bottom\">\n                <i class=\"fa fa-envelope\" style=\"width:20px\"></i>\n              </a>\n            </li>\n            <li ng-if=\"vm.allowSocial\">\n              <button class=\"btn btn-primary\"\n                      ng-click=\"vm.tweet()\"\n                      analytics-on analytics-event=\"event-promote\" analytics-category=\"tweet\" analytics-label=\"\"\n                      uib-tooltip=\"Tweet a link to your Twitter followers\" tooltip-placement=\"bottom\">\n                <i class=\"fa-brands fa-x-twitter\" style=\"width:20px\"></i>\n              </button>\n            </li>\n            <li ng-if=\"vm.allowSocial\">\n              <button class=\"btn btn-primary\"\n                      ng-click=\"vm.facebook()\"\n                      analytics-on analytics-event=\"event-promote\" analytics-category=\"facebook\" analytics-label=\"\"\n                      uib-tooltip=\"Post a link on your Facebook timeline\" tooltip-placement=\"bottom\">\n                <i class=\"fa fa-facebook\" style=\"width:20px\"></i>\n              </button>\n            </li>\n            <li ng-if=\"vm.allowEmbed\">\n              <button class=\"btn btn-primary\"\n                      ng-click=\"vm.embed()\"\n                      analytics-on analytics-event=\"event-promote\" analytics-category=\"embed\" analytics-label=\"\"\n                      uib-tooltip=\"Embed this event on your web site\" tooltip-placement=\"bottom\">\n                <i class=\"fa fa-code\" style=\"width:20px\"></i>\n              </button>\n            </li>\n            <li ng-if=\"vm.allowPromote && clipboard.supported\">\n              <button class=\"btn btn-primary\"\n                clipboard\n                text=\"vm.broadcast.viewer_url\"\n                on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n                on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n                analytics-on analytics-event=\"event-promote\" analytics-category=\"copy\" analytics-label=\"\"\n                uib-tooltip=\"Copy the BoxCast.tv event link to your clipboard\" tooltip-placement=\"bottom\">\n                <i class=\"fa fa-copy\" style=\"width:20px\"></i>\n              </button>\n            </li>\n          </ul>\n        </div>\n      </div>\n\n    </div>\n  </main>\n"

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports = "<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n\n    <form id=\"recording-form\" name=\"form\" role=\"form\">\n\n      <div class=\"col-sm-12\">\n        <a href=\"{{vueDashboardRoot}}/broadcasts/{{vm.broadcast.id}}\" class=\"btn btn-default\">\n          <i class=\"fa fa-caret-left\"></i>\n          Back to Broadcast Details\n        </a>\n      </div>\n\n      <div class=\"col-sm-12\">\n        <h3>Adjust Start/Stop Times</h3>\n      </div>\n\n      <div class=\"col-sm-12\">\n        <recording-trimmer broadcast-id=\"vm.broadcast.id\"\n                           recording-id=\"vm.recording.id\"\n                           on-change-bounds=\"vm.onChangeBounds\"></recording-trimmer>\n      </div>\n\n      <div class=\"col-sm-12\">\n        <div class=\"form-group text-center\">\n          <a href=\"{{vueDashboardRoot}}/broadcasts/{{vm.broadcast.id}}\" class=\"btn btn-default\">\n            Cancel\n          </a>\n          <button class=\"btn btn-primary\" ng-click=\"vm.showPreviewModal()\">\n            Preview Trimmed Recording\n          </button>\n          <button ng-click=\"vm.saveChanges()\"\n                  ng-disabled=\"!form.$valid || vm.isSaving\"\n                  class=\"btn btn-success\">\n            <i ng-show=\"vm.isSaving\" class=\"fa fa-cog fa-spin\"></i>\n            Save Trimmed Recording\n          </button>\n        </div>\n      </div>\n\n      <div class=\"col-sm-12\">\n        <p class=\"help-block\"><i class=\"fa fa-question-circle\"></i> Drag the tall yellow bars below the video to trim any unnecessary\n        content from the beginning or end of the recording (the area inside the yellow indicates how much of the video is kept).\n        Then drag the red circle to scrub through the trimmed video as a quick preview. When you are finished, you\n        can preview the video and then Save the trimmed recording.</p>\n      </div>\n\n    </form>\n  </div>\n</main>\n"

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports = "<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <a href=\"{{vueDashboardRoot}}/broadcasts/{{vm.broadcast.id}}\" class=\"btn btn-default\">\n        <i class=\"fa fa-caret-left\"></i>\n        Back to Broadcast Details\n      </a>\n      <button ng-click=\"vm.showCaptureModal()\" class=\"btn btn-success pull-right\">\n        Capture New Highlight\n      </button>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h3>Highlight Clips for {{vm.broadcast.name}}</h3>\n      <p ng-if=\"vm.highlights.length == 0\">\n        <em>There are no highlights currently captured.</em>\n      </p>\n      <div ng-if=\"vm.highlights.length\">\n        <table class=\"table table-striped\">\n          <tbody>\n            <tr ng-repeat=\"highlight in vm.highlights track by highlight.id\">\n              <td style=\"width:100px\">\n                <img ng-src=\"{{highlight.preview}}\" ng-click=\"vm.showHighlight(highlight)\" class=\"img img-thumbnail\" style=\"width:100px; cursor:pointer;\">\n              </td>\n              <td>\n                {{highlight.name}}\n                ({{highlight.duration | secondsFormatted:true:false}})\n                <div><small>{{highlight.description}}</small></div>\n              </td>\n              <td class=\"text-right\">\n                <button class=\"btn btn-default\" ng-click=\"vm.delete(highlight)\">\n                  <i class=\"fa fa-trash\"></i>\n                </button>\n                <button class=\"btn btn-default\" ng-if=\"vm.canDownloadOrExport\" ng-click=\"vm.download(highlight)\">\n                  <i class=\"fa fa-cloud-download\"></i>\n                </button>\n                <button class=\"btn btn-default\" ng-click=\"vm.showCaptureModal(highlight)\">\n                  <i class=\"fa fa-pencil\"></i>\n                </button>\n                <button ng-show=\"!vm.broadcastIsMonetized || highlight.duration <= vm.maxMonetizedHighlightTimeS\" class=\"btn btn-default\" ng-click=\"vm.playHighlight(highlight)\">\n                  <i class=\"fa fa-share\"></i> Share\n                </button>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        <uib-pagination\n            total-items=\"vm.highlightsPagination.total\" items-per-page=\"vm.HIGHLIGHTS_PAGE_SIZE\" max-size=\"10\"\n            rotate=\"false\" class=\"pagination-sm\" style=\"margin:0 0 5px 0\" ng-model=\"vm.highlightsPagination.current\"\n            ng-change=\"vm.loadHighlightsForPage(vm.highlightsPagination.current)\"></uib-pagination>\n        <p class=\"help-block\" style=\"margin:0 0 0 2px\">\n          Showing results\n          {{vm.highlightsPagination.resultMin}} -\n          {{vm.highlightsPagination.resultMax}}\n          of {{vm.highlightsPagination.total}}\n        </p>\n      </div>\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extended_test_html__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extended_test_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__extended_test_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extended_test_controller__ = __webpack_require__(422);



var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('extended-test', __WEBPACK_IMPORTED_MODULE_1__extended_test_html___default.a, __WEBPACK_IMPORTED_MODULE_2__extended_test_controller__["a" /* default */], 'ExtendedTestController', '/extended-test');
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports = "<style>\n  tags-input .host {\n    margin: 0px;\n  }\n  tags-input .tags .tag-item {\n    background: #428bca;\n  }\n</style>\n<div class=\"container-fluid\"\n     style=\"max-width:720px\">\n  <form name=\"form\" role=\"form\">\n    <div class=\"row form-horizontal\">\n      <div class=\"col-xs-12\">\n        <div class=\"well clearfix\">  \n          <h3>Create New Extended Tests</h3><br/>\n          <div class=\"form-group\">\n            <label class=\"col-sm-4\">Duration: </label>\n            <div class=\"col-sm-8\">\n              <select id=\"duration\" \n                      ng-model=\"vm.duration\" \n                      required class=\"form-control\" \n                      ng-options=\"d.value as d.label for d in ::vm.DURATIONS\">\n              </select>\n            </div>\n          </div>\n  \n          <div class=\"form-group\">\n            <label class=\"col-sm-4\">Start in: </label>\n            <div class=\"col-sm-8\">\n              <select id=\"start_offset\" \n                      ng-model=\"vm.start_offset\" \n                      required class=\"form-control\"\n                      ng-options=\"o.value as o.label for o in ::vm.START_OFFSETS\">\n              </select>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label class=\"col-sm-4\">BoxCasters: <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <div class=\"col-sm-8\">\n              <tags-input required class=\"bootstrap\" \n                          ng-model=\"vm.boxcasters_to_test\" \n                          add-on-paste=\"true\" \n                          add-from-autocomplete-only=\"true\" \n                          placeholder=\"Add a BoxCaster\" \n                          display-property=\"id\"\n                          on-tag-added=\"vm.onBoxCasterAdd($tag)\">\n                <auto-complete source=\"vm.loadBoxCasters($query)\" min-length=\"0\" debounce-delay=\"0\"></auto-complete>\n              </tags-input>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label class=\"col-sm-4\">Target video bitrate: <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <div class=\"col-sm-8\">\n              <select id=\"target_video_bitrate\" \n                      ng-model=\"vm.target_video_bitrate\" \n                      required class=\"form-control\"\n                      ng-options=\"b.value as b.label for b in vm.service.videoBitrates\">\n              </select>\n            </div>\n          </div>\n    \n          <div class=\"form-group\">\n            <label class=\"col-sm-4\">Target audio bitrate: <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <div class=\"col-sm-8\">\n              <select id=\"target_audio_bitrate\" \n                      ng-model=\"vm.target_audio_bitrate\" \n                      required class=\"form-control\"\n                      ng-options=\"b.value as b.label for b in vm.service.audioBitrates\">\n              </select>\n            </div>\n          </div>  \n          <button type=\"button\" class=\"btn btn-success pull-right\" ng-click=\"vm.submit()\" ng-disabled=\"!form.$valid\">\n            <i ng-show=\"vm.submitting\" class=\"fa fa-spin fa-spinner\"></i>\n            Create\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</form>"

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExtendedTestController; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var ExtendedTestController = /*#__PURE__*/function () {
  function ExtendedTestController(BoxCaster, EditOrCreateEventService, toaster, $scope, $state, $q) {
    'ngInject';

    _classCallCheck(this, ExtendedTestController);

    this.BoxCaster = BoxCaster;
    this.service = EditOrCreateEventService.getInstance();
    this.boxcasters = [];
    this.getAllBoxCasters();
    this.toaster = toaster;
    this.$scope = $scope;
    this.$state = $state;
    this.$q = $q; // Valid extended test durations and a default duration.

    this.DURATIONS = [{
      label: '1 hour',
      value: 1 * 60 * 60 * 1000
    }, {
      label: '2 hours',
      value: 2 * 60 * 60 * 1000
    }, {
      label: '3 hours',
      value: 3 * 60 * 60 * 1000
    }, {
      label: '4 hours',
      value: 4 * 60 * 60 * 1000
    }, {
      label: '5 hours',
      value: 5 * 60 * 60 * 1000
    }, {
      label: '6 hours',
      value: 6 * 60 * 60 * 1000
    }, {
      label: '7 hours',
      value: 7 * 60 * 60 * 1000
    }, {
      label: '8 hours',
      value: 8 * 60 * 60 * 1000
    }];
    this.DEFAULT_DURATION = 6 * 60 * 60 * 1000; // Offset from "now" for the start time (15 minutes minimum).
    //
    // The API's forecaster looks at the schedule of upcoming broadcasts to know how many servers to
    // keep up, plus some reserve. During off-peak hours when nothing is broadcasting, only the
    // reserve is kept alive, and starting a large number of extended tests at once will completely
    // consume the reserve servers and delay any "real" broadcasts from starting. Since it takes 10-12
    // minutes to bring up new servers, scheduling extended tests 15 minutes in advance gives the API
    // forecaster enough advance warning to bring up the servers needed for these broadcasts, as well
    // as maintain the reserve in case any new (real) broadcasts are added on the fly.

    this.START_OFFSETS = [{
      label: '15 minutes',
      value: 15 * 60 * 1000
    }, {
      label: '1 hour',
      value: 1 * 60 * 60 * 1000
    }, {
      label: '2 hours',
      value: 2 * 60 * 60 * 1000
    }, {
      label: '3 hours',
      value: 3 * 60 * 60 * 1000
    }, {
      label: '4 hours',
      value: 4 * 60 * 60 * 1000
    }, {
      label: '5 hours',
      value: 5 * 60 * 60 * 1000
    }, {
      label: '6 hours',
      value: 6 * 60 * 60 * 1000
    }, {
      label: '7 hours',
      value: 7 * 60 * 60 * 1000
    }, {
      label: '8 hours',
      value: 8 * 60 * 60 * 1000
    }];
    this.DEFAULT_START_OFFSET = 15 * 60 * 1000;
    this.DEFAULT_AUDIO_BITRATE = 'default';
    this.DEFAULT_VIDEO_BITRATE = 'default';
    this.duration = this.DEFAULT_DURATION;
    this.start_offset = this.DEFAULT_START_OFFSET;
    this.target_video_bitrate = this.DEFAULT_VIDEO_BITRATE;
    this.target_audio_bitrate = this.DEFAULT_AUDIO_BITRATE;
    this.boxcasters_to_test = [];
    this.service.initBroadcast();
    this.service.initScope(this.$scope);
  }

  _createClass(ExtendedTestController, [{
    key: "loadBoxCasters",
    value: function loadBoxCasters(query) {
      var _this = this;

      var found = [];

      for (var i = 0; i < this.boxcasters.length; i++) {
        if (this.boxcasters[i].id.indexOf(query) > -1) {
          found.push(this.boxcasters[i]);
        }
      } // ensure only boxcasters with the same prefix are loaded


      if (this.boxcasters_to_test && this.boxcasters_to_test.length) {
        found = found.filter(function (b) {
          return b.id[0] == _this.boxcasters_to_test[0].id[0];
        });
      }

      return found;
    }
  }, {
    key: "onBoxCasterAdd",
    value: function onBoxCasterAdd(tag) {
      this.service.broadcast.boxcaster_id = tag.id;
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this2 = this;

      var $q = this.$q;
      this.submitting = true;
      var startTime = new Date(Date.now() + parseInt(this.start_offset));
      var stopTime = new Date(startTime.getTime() + parseInt(this.duration));
      var promiseChain = this.boxcasters_to_test.reduce(function (promise, b) {
        return promise.then(function () {
          console.log("Scheduling extended test for ".concat(b.id));

          _this2.service.initBroadcast();

          _this2.service.startDate = startTime;
          _this2.service.startTime = startTime;
          _this2.service.endTime = stopTime;
          _this2.service.visibility = 'private';
          _this2.service.broadcast.boxcaster_id = b.id;
          _this2.service.broadcast.target_audio_bitrate = _this2.target_audio_bitrate;
          _this2.service.broadcast.target_video_bitrate = _this2.target_video_bitrate;
          _this2.service.broadcast.name = "Extended ".concat(b.id);
          _this2.service.broadcast.description = "Extended test of ".concat(b.id, " from ").concat(startTime, " to ").concat(stopTime, " using target bitrates\n                        ").concat(_this2.target_video_bitrate, " video / ").concat(_this2.target_audio_bitrate, " audio");
          return _this2.service.saveChanges();
        })["catch"](function (error) {
          console.error(error);
          throw error;
        });
      }, $q.when());
      promiseChain.then(function () {
        _this2.toaster.pop({
          type: 'success',
          title: 'Successfully scheduled extended tests'
        });

        _this2.submitting = false;

        _this2.$state.go('home');
      })["catch"](function (error) {
        _this2.toaster.pop({
          type: 'warning',
          title: 'Error scheduling extended tests'
        });

        _this2.submitting = false;
      });
    }
  }, {
    key: "getAllBoxCasters",
    value: function getAllBoxCasters() {
      var _this3 = this;

      var l = 500;
      var s = 'name';
      var q = 'credentialed:true';
      this.BoxCaster.query({
        l: l,
        s: s,
        q: q,
        p: 0
      }, function (results, headers) {
        var pagination = JSON.parse(headers('x-pagination'));
        _this3.boxcasters = _this3.boxcasters.concat(results);

        for (var p = 1; p <= pagination.last; p++) {
          _this3.BoxCaster.query({
            l: l,
            s: s,
            q: q,
            p: p
          }, function (results) {
            _this3.boxcasters = _this3.boxcasters.concat(results);
          });
        }
      });
    }
  }]);

  return ExtendedTestController;
}();



/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_utils__ = __webpack_require__(9);


var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('home', '', function ($rootScope, Account) {
  'ngInject'; // check for homepage version redirect to vue /home or /dashboard

  var homeKey = __WEBPACK_IMPORTED_MODULE_1__auth_utils__["d" /* storage */].get('new-home');
  var url = homeKey === '0' ? 'home' : 'broadcasts'; // Function to handle redirection based on account data

  var redirectBasedOnAccount = function redirectBasedOnAccount(account) {
    if (account.metadata && account.metadata.remote_mix_sign_up) {
      window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/remote-mix/redirect"));
    } else {
      // Redirect to Vue dashboard
      window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/").concat(url));
    }

    return; // Ensure no further execution
  }; // Check if account info is already in $rootScope before making a fresh call


  if ($rootScope.account && $rootScope.account.metadata) {
    // Use the existing account info
    redirectBasedOnAccount($rootScope.account);
  } else {
    // If account info is not available, get it before redirecting
    // Getting it here ensures we have the account info before redirecting, hopefully avoiding any race conditions or reactivity issues
    Account.get(function (acc) {
      redirectBasedOnAccount(acc);
    });
  }
}, 'HomeController', '/');
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(8);

var template = "\n  <div style=\"position:fixed;left:0;right:0;bottom:0;top:0;background:#000;z-index:99999999\">\n    <div class=\"turn-off screen\">\n    </div>\n  </div>\n";
var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('logout', template, function LogoutController(AuthService, $timeout) {
  'ngInject';

  $timeout(function () {
    AuthService.logout();
  }, 1000);
}, 'LogoutController');
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marketing_corner_html__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marketing_corner_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__marketing_corner_html__);
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var MarketingCornerController = /*#__PURE__*/_createClass(function MarketingCornerController($rootScope, $http, toaster, ConfirmDialog, MeetingsService) {
  'ngInject';

  var _this = this;

  _classCallCheck(this, MarketingCornerController);

  this.account = $rootScope.account;
  this.$http = $http;
  this.toaster = toaster;
  this.ConfirmDialog = ConfirmDialog;
  this.MeetingsService = MeetingsService;
  this.user = $rootScope.user;
  this.ff = this.account.feature_flags;
  this.features = [{
    name: 'Analytics',
    enabled: this.ff.analytics,
    info: 'Understand your reach with engagement graphs and data on total views, unique viewers, and average view duration. See where in the world your viewers are watching, with a live interactive map. Take a detailed look at how viewers watch your content with data on viewing destinations, devices, browsers and operating systems, and playback quality'
  }, {
    name: 'Graphic Overlays',
    enabled: this.ff.overlays,
    info: 'Enhance your broadcast with graphics like logos, watermarks, lower thirds, full screen overlays or basic advertisements.'
  }, {
    name: 'Ticketing',
    enabled: !this.ff.no_ticketed,
    info: 'Generate revenue by selling tickets to your live or recorded broadcasts. Includes 25% revenue share for viewer support and processing.'
  }, {
    name: 'Automatic Recording',
    enabled: !this.ff.no_recordings,
    info: 'Let viewers watch the automatically recorded broadcast using the same links and embeds.'
  }, {
    name: 'Password Protection',
    enabled: this.ff.password,
    info: 'Protect your broadcasts with a single password.'
  }, {
    name: 'API Access',
    enabled: this.ff.api_keys,
    info: "Customize your video workflow using BoxCast's API."
  }, {
    name: 'Stream to Smart TV Apps',
    enabled: this.ff.appletv_roku,
    info: 'Let viewers watch your stream on their Smart TVs using the BoxCast App for Apple TV, Roku, and Amazon Fire TV'
  }, {
    name: 'Scoreboard Overlays',
    enabled: this.ff.manual_scoreboard,
    info: 'Overlay a live scoreboard on your broadcast. Control the scoreboard on your computer, phone, or tablet or integrate with your onsite scoreboard.'
  }, {
    name: 'Concurrent Broadcasts',
    enabled: this.account.max_simultaneous_streams != 1,
    info: 'Account for overlapping events by streaming two or more broadcasts simultaneously.'
  }, {
    name: 'Donations',
    enabled: this.ff.donations,
    info: 'Accept donations for your organization. Includes 6% processing fee.'
  }, {
    name: 'Automated Captioning',
    enabled: this.ff.automated_captioning,
    info: 'Save time, adhere to compliance standards, and make your recorded broadcasts more accessible by automatically adding closed captions'
  }, {
    name: 'Multi-Site Player',
    enabled: this.ff.multi_site,
    info: 'Stream to multiple remote campuses in high-quality without buffering.'
  }, {
    name: 'Highlight Clipping',
    enabled: this.ff.highlights,
    info: 'Capture important moments and share them on social media by quickly clipping highlights mid-broadcast or after your broadcast is over.'
  }, {
    name: 'Simulated Live',
    enabled: this.ff.simulated_live,
    info: 'Re-broadcast recorded or uploaded broadcasts to any destination.'
  }, {
    name: 'Geo-Blocking',
    enabled: this.ff.geoblock,
    info: 'Restrict viewership geographically based on zipcode or point and radius.'
  }, {
    name: 'Embedding Restrictions',
    enabled: this.ff.host_restrictions,
    info: 'Maintain control of your content by limiting the destinations or URLs where the broadcast can be watched.'
  }, {
    name: 'Video Markers',
    enabled: this.ff.cue_points,
    info: 'Help viewers easily find significant moments by naming and tagging points in a recorded broadcast.'
  }];
  this.additionalOptions = [{
    name: 'Additional Concurrent Broadcasts',
    info: 'Account for overlapping events by streaming two or more broadcasts simultaneously.'
  }, {
    name: 'Custom Smart TV Apps',
    info: 'Let viewers access your streams on your own branded TV app on Apple TV and Roku.'
  }, {
    name: 'Additional Features',
    info: "We're always listening and looking for ways to improve your experience. Some of our newer features may not be listed here."
  }];

  this.scheduleTime = function () {
    _this.MeetingsService.scheduleMeeting();
  };
});

var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('marketing-corner', __WEBPACK_IMPORTED_MODULE_1__marketing_corner_html___default.a, MarketingCornerController, 'MarketingCornerController');
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports = "<style>\n  .upgrade-options td {\n    font-size: 14pt;\n    margin: 5px 3%;\n    min-width: 300px;\n    text-align: left;\n  }\n  .upgrade-options h2 {\n    font-family: Stratum2-bold;\n    margin-bottom: 20px;\n  }\n  .info {\n    margin-left: 20px;\n    color: grey;\n    text-align: right !important;\n  }\n  .enabled {\n    color: #5cb85c;\n  }\n\n</style>\n<main class=\"container-fluid upgrade-options\">\n\n  <div class=\"row text-center\">\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <h2 class=\"text-center\" style=\"margin-bottom:10px\">Available Features</h2>\n        <table align=\"center\" style=\"margin-bottom:10px;max-width:1250px;\">\n          <tr>\n            <td ng-repeat=\"feature in vm.features\" style=\"display:inline-block\">\n              <div style=\"float:left;width:90%;\">\n                <i class=\"fa\" ng-class=\"{ 'fa-square-o': !feature.enabled, 'fa-check enabled': feature.enabled }\" style=\"padding-right:5px\"></i>\n                <span>{{feature.name}}</span>\n              </div>\n              <div style=\"float:right;width:10%;\">\n                <i class=\"info fa fa-info-circle\" \n                   uib-tooltip=\"{{feature.info}}\"\n                   tooltip-append-to-body=\"true\">\n                </i>\n              </div>\n            </td>\n            <!-- Need placeholders that make the table look nice when the number of elements is not a multiple of 3 -->\n            <td style=\"display:inline-block\"></td>\n            <td style=\"display:inline-block\"></td>\n          </tr>\n        </table>\n        <h2 class=\"text-center\" style=\"margin-bottom:10px\">Need More?</h2>\n        <table align=\"center\" style=\"margin-bottom:10px;max-width:1250px;\">\n          <tr>\n            <td ng-repeat=\"option in vm.additionalOptions\" style=\"display:inline-block\">\n              <span>{{option.name}}</span>\n              <i class=\"info fa fa-info-circle\"\n                  uib-tooltip=\"{{option.info}}\"\n                  tooltip-append-to-body=\"true\">\n              </i>\n            </td>\n            <!-- Need placeholders that make the table look nice when the number of elements is not a multiple of 3 -->\n            <td style=\"display:inline-block\"></td>\n            <td style=\"display:inline-block\"></td>\n          </tr>\n        </table>\n        <p style=\"font-size:12pt\">\n          Interested in discussing upgrade opportunities for your account? We're happy to help!</br>\n          Schedule a time to talk to your client manager.\n        </p>\n        <a class=\"btn btn-primary btn-lg\" style=\"padding:10px\" ng-click=\"vm.scheduleTime()\">\n          Schedule Time\n        </a>\n      </div>\n    </div>\n  </div>\n\n</main>"

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(8);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('multi-site', "", function () {
  // Migrated to dashboard_vue
  window.location.href = '/multi-site';
}, 'MultiSiteController'));

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var navbarModule = angular.module('app.pages.navbar', []);
navbarModule.directive('topNavbar', function () {
  return {
    restrict: 'E',
    scope: {},
    template: __webpack_require__(429),
    controller: __webpack_require__(430)["default"],
    controllerAs: 'vm',
    bindToController: true
  };
});
navbarModule.directive('leftNavbar', function () {
  return {
    restrict: 'E',
    template: __webpack_require__(432),
    controller: __webpack_require__(433)["default"],
    controllerAs: 'vm',
    bindToController: true
  };
});
/* harmony default export */ __webpack_exports__["default"] = (navbarModule);

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navbar navbar-fixed-top navbar-default\">\n\n  <div ng-if=\"vm.isIE11 && !vm.isIE11Hidden\" style=\"position:fixed; z-index:1; top: 5px; padding: 5px; width: 100%\">\n    <div uib-alert class=\"alert-warning text-center\" close=\"vm.onDismissIE11()\"\n      style=\"max-width: 700px; margin: 0 auto;\">\n      You’re using a web browser that will stop being supported on June 15, 2021. Please upgrade to a compatible browser\n      for optimal performance and security.\n      <a href=\"https://support.boxcast.com/en/articles/5307468-upgrade-from-internet-explorer-11\" target=\"_blank\">Learn\n        more</a>\n    </div>\n  </div>\n\n  <!-- show expiration and payment notifications in an \"eyebrow\"-->\n  <div ng-if=\"vm.eyebrowReason\" class=\"eyebrow row\">\n    <div class=\"col-xs-12\">\n      <a href=\"javascript://\">\n        <div ng-if=\"vm.eyebrowReason == 'trial_will_expire'\"\n          ng-click=\"(vm.upgrades && vm.upgrades.length) ? vm.viewProposal() : vm.onCompleteSetup()\" class=\"row\">\n          <div class=\"col-xs-6\">\n            <span class=\"visible-xs\">\n              <strong>Trial</strong> ends\n            </span>\n            <span class=\"hidden-xs\">\n              Your trial <span ng-show=\"vm.planName\">of the <strong>{{vm.planName}}</strong></span> ends\n            </span>\n            <strong ng-if=\"vm.expiresIn == 0\">today.</strong>\n            <span ng-if=\"vm.expiresIn > 0\">in <strong>{{vm.expiresIn}} {{vm.expiresIn == 1 ? 'day' :\n                'days'}}.</strong></span>\n            <span class=\"hidden-xs\" ng-if=\"!(vm.upgrades && vm.upgrades.length)\">\n              View <strong style=\"border-bottom:1px solid;\">plan features</strong>\n              or <strong style=\"border-bottom:1px solid;\"\n                onclick=\"window.open('https://www.boxcast.com/shure-promotion-details', '_blank'); return false;\">available\n                promotions</strong>.\n            </span>\n          </div>\n          <div ng-if=\"vm.upgrades && vm.upgrades.length\" class=\"col-xs-6 text-right\">\n            <span class=\"hidden-xs hidden-sm\">New pricing and plan proposal available</span> <strong\n              style=\"border-bottom:1px solid;margin-left:20px\">View Proposal</strong>\n          </div>\n          <div ng-if=\"!(vm.upgrades && vm.upgrades.length)\" class=\"col-xs-6 text-right\">\n            <span class=\"hidden-xs hidden-sm\">Ready to sign up?</span>\n            <strong>\n              <span style=\"border-bottom:1px solid\" class=\"hidden-xs\">Get started today</span>\n              <span style=\"border-bottom:1px solid\" class=\"hidden-sm hidden-md hidden-lg\">Sign up</span>\n            </strong>\n          </div>\n        </div>\n        <div ng-if=\"vm.eyebrowReason == 'activation_will_expire'\" ng-click=\"vm.$state.go('settings.payment')\"\n          class=\"row\">\n          <div class=\"col-sm-6\">\n            <strong>Your <span class=\"hidden-xs\">BoxCast</span> subscription</strong> ends\n            <strong ng-if=\"vm.expiresIn == 0\">today</strong>\n            <span ng-if=\"vm.expiresIn > 0\">in <strong>{{vm.expiresIn}} {{vm.expiresIn == 1 ? 'day' :\n                'days'}}</strong></span>\n          </div>\n          <div class=\"col-sm-6 text-right hidden-xs\">\n            Please <strong style=\"border-bottom:1px solid\">update your billing details</strong>\n            or call (888) 392-2278 to ensure uninterrupted service.\n          </div>\n        </div>\n        <div ng-if=\"vm.eyebrowReason == 'need_payment'\" ng-click=\"vm.$state.go('settings.payment')\" class=\"row\">\n          <div class=\"col-xs-12 text-center\">\n            <strong class=\"hidden-xs hidden-sm\" style=\"margin-right:5px\">We had some trouble processing your\n              payment.</strong>\n            Please <strong style=\"border-bottom:1px solid\">update your billing details</strong> <span\n              class=\"hidden-xs\">or call (888) 392-2278 to ensure uninterrupted service.</span>\n          </div>\n        </div>\n        <div ng-if=\"vm.eyebrowReason == 'has_upgrade'\">\n          <div class=\"col-xs-10 col-xs-offset-1 text-center\" ng-click=\"vm.viewProposal()\" style=\"padding:0\">\n            <span class=\"hidden-xs\" style=\"margin-right:5px\">You have an upgrade available for your account.</span>\n            <strong style=\"border-bottom:1px solid\">View Proposal</strong>\n          </div>\n          <div class=\"col-xs-1 text-right\" style=\"padding:0\">\n            <i ng-click=\"vm.hideEyebrow()\" class=\"fa fa-times pull-right\"></i>\n          </div>\n        </div>\n        <div ng-if=\"vm.eyebrowReason == 'unverified_email_address'\" ng-click=\"vm.$state.go('settings.my_account')\"\n          class=\"row\">\n          <div class=\"col-xs-12 text-center\">\n            <span class=\"hidden-xs hidden-sm\" style=\"margin-right:5px\">Please verify your email address.</span>\n            <strong style=\"border-bottom:1px solid\">Take action to secure your account.</strong>\n          </div>\n        </div>\n      </a>\n    </div>\n  </div>\n  <!-- end if -->\n\n  <!-- mobile top nav -->\n  <div class=\"visible-xs visible-sm visible-md-lg\">\n    <div class=\"navbar-header mobile\">\n      <div class=\"pull-left\">\n        <a ng-click=\"vm.toggleNav()\" href=\"javascript://\"><i class=\"fa fa-bars\" style=\"color:#000\"></i></a>\n      </div>\n      <div ng-if=\"vm.currentState == 'home' && !$root.user.is_impersonating\">\n        <h3><img src=\"/img/boxcast_logo_dark.png\" class=\"logo\" alt=\"BoxCast Logo\" /></h3>\n      </div>\n      <div ng-if=\"vm.currentState != 'home' && !$root.user.is_impersonating\">\n        <h3>{{vm.currentPageTitle}}</h3>\n      </div>\n      <div ng-if=\"$root.user.is_impersonating\">\n        <!-- use view title as placeholder for reminder that admin user is in impersonation mode -->\n        <h3\n          style=\"color: #bf2525; border: 1px solid; border-radius: 4px; line-height: 30px; margin: 10px auto; font-size: 14px; padding: 0 10px; max-width: 230px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;\">\n          Impersonating {{$root.account.name}}\n        </h3>\n      </div>\n    </div>\n  </div>\n\n  <!-- desktop top nav -->\n  <div class=\"hidden-xs hidden-sm hidden-md-lg\">\n    <div class=\"navbar-header\" style=\"position:relative; display: flex;\">\n      \n      <div ng-if=\"vm.Products.length > 1\" uib-dropdown class=\"productSwitcher dropdown\">\n        <button uib-dropdown-toggle class=\"dropdown-toggle\"  data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"\">\n          <i class=\"fa fa-grid\"></i>\n        </button>\n        <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\n          <li style=\"margin: 8px; margin-left:16px;\"><strong>Switch to&hellip;</strong></li>\n          <li role=\"menuitem\" ng-repeat=\"p in ::vm.Products\">\n            <button ng-click=\"p.handler()\" class=\"productSwitcher__button\">\n              <span class=\"productSwitcher__button__icon\"><i class=\"{{::p.icon}}\"></i></span>\n              <span class=\"productSwitcher__button__label\">{{::p.label}}</span>\n            </button>\n          </li>\n        </ul>\n      </div>\n\n      <a href=\"/\" class=\"navbar-brand\" style=\"position:relative\">\n        <img src=\"/img/boxcast_logo_dark.png\" class=\"logo\"  alt=\"BoxCast Logo\">\n        <div ng-show=\"vm.showLoading\">\n          <div class=\"spin-box-bg\"></div>\n          <div class=\"spin-box\"></div>\n        </div>\n      </a>\n    </div>\n    <div class=\"navbar-links\">\n      <div class=\"container-fluid\">\n        <div style=\"float:left; padding:0 15px;\">\n          <!-- use view title as placeholder for reminder that admin user is in impersonation mode -->\n          <h3 ng-if=\"!$root.user.is_impersonating\">{{vm.currentPageTitle}}</h3>\n          <h3 ng-if=\"$root.user.is_impersonating\"\n            style=\"color: #bf2525; border: 1px solid; border-radius: 4px; line-height: 30px; margin: 10px 0; font-size: 14px; padding: 0 10px; max-width: 230px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;\">\n            Impersonating {{$root.account.name}}\n          </h3>\n        </div>\n\n        <ul class=\"nav navbar-nav pull-right\">\n          <li class=\"dropdown\" ng-class=\"{open: vm.isDropdownOpen}\">\n            <a href id=\"topnav-user-dropdown\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">\n              <span class=\"visually-hidden\">Toggle User Menu</span>\n              <i ng-if=\"!$root.account.content_settings.profile_img\" class=\"fa fa-user\"></i>\n              <div ng-if=\"$root.account.content_settings.profile_img\" class=\"fixed-square\"\n                style=\"float:left;width:36px;height:36px;margin-right:3px;background:#fff\">\n                <div\n                  style=\"background-image:url(&quot;{{$root.account.content_settings.profile_img | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\">\n                </div>\n              </div>\n              <span class=\"caret\"></span>\n            </a>\n            <ul class=\"dropdown-menu dropdown-menu-right\" style=\"max-height:300px; overflow-y:scroll;\">\n              <li ng-if=\"vm.user.authorized_accounts.length > 1\"\n                ng-repeat=\"a in ::vm.user.authorized_accounts | orderBy:'name'\" role=\"menuitem\"\n                ng-class=\"{active: a.id == vm.account.id}\">\n                <a ng-if=\"a.id != vm.account.id\" href ng-click=\"vm.switchAccount(a)\">{{a.name}}</a>\n                <a ng-if=\"a.id == vm.account.id\" href disabled\n                  style=\"background-color: #444; cursor: default;\">{{a.name}}</a>\n              </li>\n              <li ng-if=\"vm.user.authorized_accounts.length > 1\" class=\"divider\"></li>\n              <li><a ui-sref=\"settings.my_account\">My Account</a></li>\n              <li><a ui-sref=\"logout\">Sign Out</a></li>\n            </ul>\n          </li>\n        </ul>\n\n        <div class=\"notification-icons pull-right\">\n          <ul class=\"list-inline\">\n            <li class=\"block text-xs font-medium text-bx-accessible-grey\" ng-show=\"vm.boxcastersOnline > 0\" style=\"line-height: 12px; text-align: center; padding-top: 10px;\">\n              <i class=\"fa fa-check-circle\" style=\"font-size: 1.6rem; color: var(--color-bx-green)\"></i>\n              <br>\n              <small class=\"block mt-tight text-xs\" style=\"white-space:nowrap;\">\n                <ng-pluralize count=\"vm.boxcastersOnline\" when=\"{\n                  '1': 'BoxCaster Online',\n                  'other': 'BoxCasters Online'\n                }\"></ng-pluralize>\n              </small>\n            </li>\n            <li class=\"block text-xs font-medium text-bx-accessible-grey\" ng-show=\"vm.boxcastersNeedAttention > 0\" style=\"line-height: 12px; text-align: center; padding-top: 10px;\">\n              <i class=\"fa fa-exclamation-circle\" style=\"font-size: 1.6rem; color:var(--color-bx-red)\"></i>\n              <br>\n              <small class=\"block mt-tight text-xs\" style=\"white-space:nowrap;\">\n                <a class=\"subtle-link\" href=\"{{$root.vueDashboardRoot}}/sources\" style=\"text-decoration: none\">\n                  <ng-pluralize count=\"vm.boxcastersNeedAttention\" when=\"{\n                    '1': 'BoxCaster Needs Attention',\n                    'other': 'BoxCasters Need Attention'\n                  }\">\n                  </ng-pluralize>\n                </a>\n              </small>\n            </li>\n          </ul>\n        </div>\n\n        <ul ng-show=\"vm.hasOrder\" class=\"nav navbar-nav pull-right\" style=\"padding:7px 20px 0 0\">\n          <li text-s>\n            <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.openOrderStatus()\">\n              <img src=\"/img/box_open_icon.png\" height=\"15px\"></i> Check Order Status\n            </button>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n</nav>"

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page_names__ = __webpack_require__(431);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var TopNavController = /*#__PURE__*/function () {
  function TopNavController($scope, $state, $timeout, $rootScope, AuthService, BoxCaster, User, ConfirmDialog, Account, MeetingsService, Checkout, Order, $uibModal, $analytics, Products, $q) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, TopNavController);

    this.$state = $state;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.AuthService = AuthService;
    this.Products = Products;
    this.BoxCaster = BoxCaster;
    this.User = User;
    this.Account = Account;
    this.ConfirmDialog = ConfirmDialog;
    this.reloadInterval = REFRESH_INTERVAL_MS;
    this.$uibModal = $uibModal;
    this.$analytics = $analytics;
    this.MeetingsService = MeetingsService;
    this.Order = Order;
    this.user = $rootScope.user;
    this.account = $rootScope.account;
    this.FeatureFlags = this.account.feature_flags;
    var ua = window.navigator.userAgent;
    this.isIE11 = ua.indexOf('Windows ') >= 0 && ua.indexOf('Trident/') >= 0;

    this.onDismissIE11 = function () {
      _this.isIE11Hidden = true;
    };

    this.showLoading = false;
    $rootScope.$on('loading:state', function (state) {
      _this.showLoading = state;
    });
    $rootScope.$on('user:switchAccount', function (evt, a) {
      return _this.switchAccount(a);
    }); // Keep track of state of the account's BoxCasters to show online/warning indicators

    this.checkBoxcasterOnline();
    this.checkForNewOrders();
    this.planName = '';

    if (this.account.isTrialing()) {
      this.Account.getBilling().$promise.then(function (result) {
        _this.planName = Checkout.stripeBasePlanNameShortFromBillingResult(result);
      });
    }

    if (this.user.can('list', 'upgrades')) {
      this.upgrades = this.Account.getUpgrades();
      this.upgrades.$promise.then(function () {
        // Filter out proposals that were generated via self-service
        _this.upgrades = _this.upgrades.filter(function (u) {
          return !u.self_service;
        }); // Show "eyebrow" in certain situations

        if (_this.account.authorized()) {
          if (_this.account.contract == 'trial') {
            _this.expiresIn = moment(_this.account.expires_on).diff(moment(), 'days');
            _this.eyebrowReason = 'trial_will_expire';
          } else if (_this.account.payment_method == 'activation') {
            _this.expiresIn = moment(_this.account.expires_on).diff(moment(), 'days');

            if (_this.expiresIn < 30) {
              _this.eyebrowReason = 'activation_will_expire';
            }
          } else if (_this.account.payment_status == 'info_requested' || _this.account.payment_status == 'declined') {
            _this.eyebrowReason = 'need_payment';
          } else if (_this.upgrades && _this.upgrades.length && _this.user.metadata.alert_upgrade) {
            _this.eyebrowReason = 'has_upgrade';
          } else if (_this.user.pending_email_update) {
            _this.eyebrowReason = 'unverified_email_address';
          } else if (_this.user.metadata.alert_upgrade) {
            // Remove the metadata since there are no upgrades to alert about
            delete _this.user.metadata.alert_upgrade;
            User.update({
              metadata: _this.user.metadata
            }, function (user) {
              $rootScope.user.reloadFromResource(user);
            }, function () {
              console.error('Error updating user metadata');
            });
          }

          if (_this.eyebrowReason) {
            $scope.$emit('show-eyebrow');
          }
        }
      });
    }

    this.viewProposal = function () {
      var hasUpgrade = _this.upgrades && _this.upgrades.length == 1;

      if (hasUpgrade) {
        $state.go('checkout', {
          pd_did: _this.upgrades[0].pandadoc_id,
          pd_sid: _this.upgrades[0].share_id
        }, {
          reload: true
        });
      } else {
        $state.go('settings.payment');
      }

      $analytics.eventTrack('view-proposal', {
        category: 'upgrade'
      });
    };

    this.onContactUs = function () {
      _this.MeetingsService.openPreferredMethod();
    };

    this.onCompleteSetup = function () {
      var checkoutURL = window.VUE_DASHBOARD_ROOT + "/checkout";

      if (_this.account.metadata.remote_mix_sign_up === true) {
        checkoutURL += '/remote-mix';
      }

      window.location.href = checkoutURL;
    };

    this.hideEyebrow = function () {
      _this.eyebrowReason = null;
      $scope.$emit('hide-eyebrow');
      delete _this.user.metadata.alert_upgrade;
      User.update({
        metadata: _this.user.metadata
      }, function (user) {
        $rootScope.user.reloadFromResource(user);
      }, function () {
        console.error('Error updating user metadata');
      });
      $analytics.eventTrack('hide-eyebrow', {
        category: 'upgrade'
      });
    }; // Need to watch this because it changes as user navigates


    $scope.$watch(function () {
      return $state.current.name;
    }, function (name) {
      _this.currentState = name;
      _this.currentPageTitle = __WEBPACK_IMPORTED_MODULE_0__page_names__["a" /* default */][name];
    }); // Always let clicks of document not on the exact opener close it

    $(document).click(function (e) {
      var TARGET_ID = 'topnav-user-dropdown'; // Assume the user has clicked elsewhere and we'll be closing the dropdown.

      var isDropdownOpen = false; // Any click on the topnav user dropdown (or any of its children) means toggle state; so go
      // looking at the click target to see if it's the dropdown or any of its children.

      var target = e.target;

      while (target) {
        if (target.id == TARGET_ID) {
          isDropdownOpen = !_this.isDropdownOpen;
          break;
        }

        target = target.parentNode;
      } // Toggle it async


      $scope.$evalAsync(function () {
        return _this.isDropdownOpen = isDropdownOpen;
      });
    });
  }

  _createClass(TopNavController, [{
    key: "switchAccount",
    value: function switchAccount(a) {
      var ConfirmDialog = this.ConfirmDialog,
          User = this.User;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Switch Account',
        actionButtonClass: 'primary',
        headerText: 'Confirm Account Switch',
        bodyText: "Your user will be moved to the ".concat(a.name, " account.  All other logged in sessions for your user (including on other devices) will be affected.")
      };
      ConfirmDialog.show(modalOptions).then(function () {
        User.switchAccount({
          accountId: a.id
        }).$promise.then(function () {
          window.location.reload();
        });
      });
    }
  }, {
    key: "checkBoxcasterOnline",
    value: function checkBoxcasterOnline() {
      var _this2 = this;

      var BoxCaster = this.BoxCaster,
          $rootScope = this.$rootScope,
          $timeout = this.$timeout;
      var boxcasters = BoxCaster.query({
        l: 1000
      }, function () {
        $rootScope.boxcasters = boxcasters;
        $rootScope.$broadcast('data:boxcasters', boxcasters);
        _this2.boxcastersOnline = _.reduce(boxcasters, function (total, box) {
          return box.status == 'offline' ? total : total + 1;
        }, 0);
        _this2.boxcastersNeedAttention = _.reduce(boxcasters, function (total, box) {
          // TODO: also consider if box is offline but should be broadcasting; not that
          // offline by itself is a normal state
          return box.firmware_status != 'current' ? total + 1 : total;
        }, 0);
        _this2.reloadInterval = REFRESH_INTERVAL_MS;
        $timeout(function () {
          return _this2.checkBoxcasterOnline();
        }, _this2.reloadInterval);
      }, function (error) {
        _this2.reloadInterval = Math.min(2 * _this2.reloadInterval, 120000); //exponential backoff up to 2min

        $timeout(function () {
          return _this2.checkBoxcasterOnline();
        }, _this2.reloadInterval);
      });
    }
  }, {
    key: "toggleNav",
    value: function toggleNav() {
      var $container = $('left-navbar').parent();
      $container.toggleClass('nav-open'); // Disable touch scroll bubbling to background

      if ($container.hasClass('nav-open')) {
        $('body').css({
          overflow: 'hidden'
        });
      } else {
        $('body').css({
          overflow: 'auto'
        });
      }
    }
  }, {
    key: "checkForNewOrders",
    value: function checkForNewOrders() {
      var _this3 = this;

      this.hasOrder = false;

      if (!this.account.metadata.has_new_order) {
        return;
      }

      this.Order.query().$promise.then(function (result) {
        var isOutdated = false;

        var filtered = _.filter(result, function (o) {
          return o.status != 'cancelled';
        });

        if (filtered.length > 0) {
          _this3.hasOrder = true;

          _this3.Order.query({
            id: filtered[0].id
          }).$promise.then(function (result) {
            isOutdated = _this3.order.ship_date && Date.now() > moment(_this3.order.ship_date).add(_this3.order.is_international ? 21 : 14, 'days');
          });
        }

        if (!_this3.order || isOutdated) {
          delete _this3.account.metadata.has_new_order;

          _this3.Account.update({
            metadata: _this3.account.metadata
          }, function (account) {
            _this3.$rootScope.account = account;
          }, function () {
            console.error('Error updating account metadata');
          });

          _this3.hasOrder = false;
        }
      });
    }
  }, {
    key: "openOrderStatus",
    value: function openOrderStatus() {
      var _this4 = this;

      this.$uibModal.open({
        template: __webpack_require__(197),
        resolve: {
          order: function order() {
            return _this4.order;
          },
          account: function account() {
            return _this4.account;
          },
          showOrdersLink: function showOrdersLink() {
            return true;
          }
        },
        controller: __webpack_require__(198)["default"],
        controllerAs: 'vm'
      });
      this.$analytics.eventTrack("order-status-modal", {
        category: 'open',
        label: ''
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      this.$state.go('logout');
    }
  }]);

  return TopNavController;
}();

/* harmony default export */ __webpack_exports__["default"] = (TopNavController);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Map of page route -> title
// NOTE: This needs to be updated whenever a new page is added.
// There's probably a better way in UI router to configure/communicate
// the name of the active route, but this is what we got for now.
var PAGE_NAMES = {
  home: 'Broadcasts',
  'bulk-import': 'Bulk Import',
  'caption-editor': 'Caption Editor',
  channels: 'Channels',
  contributors: 'Contributors',
  embed: 'Embed Code Generator',
  'extended-test': 'Create Extended Test',
  'marketing-corner': 'Upgrade Options',
  'multi-site': 'Multi-Site Player',
  'new-event': 'Schedule',
  resources: 'Resources',
  sources: 'Sources',
  uploads: 'Uploads',
  'settings.overview': 'Settings',
  'settings.integrations': 'Settings',
  'settings.users': 'Settings',
  'settings.facebook': 'Settings',
  'settings.my_account': 'Settings',
  'settings.payment': 'Settings',
  'settings.rtmp_push_channels': 'Settings',
  'settings.youtube': 'Settings',
  'settings.twitter': 'Settings',
  'settings.vimeo': 'Settings',
  events: 'Broadcasts',
  'events.detail': 'Broadcast Details',
  'events.edit': 'Edit Broadcast Details',
  'events.trim': 'Trim Recording',
  'events.highlights': 'Broadcast Highlights',
  reports: 'Reports',
  'reports.donations': 'Donations Report',
  'reports.tickets': 'Tickets Report',
  'reports.viewer': 'Viewer Analytics'
};
/* harmony default export */ __webpack_exports__["a"] = (PAGE_NAMES);

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports = "<div style=\"position:relative;min-height:95%;\">\n  <section class=\"navProducts\" ng-if=\"vm.Products.length > 1\">\n    <p class=\"navProducts__heading\">Switch to&hellip;</p>\n    <ul class=\"navProducts__list\">\n      <li ng-repeat=\"p in ::vm.Products\">\n        <button ng-click=\"p.handler()\" class=\"navProducts__button\">\n          <span class=\"navProducts__icon\"><i class=\"{{p.icon}}\"></i></span>\n          <span class=\"navProducts__label\">{{p.label}}</span>\n        </button>\n      </li>\n    </ul>\n  </section>\n\n  <div class=\"user\">\n  </div>\n  <ul class=\"nav\">\n    <li ui-sref-active=\"active\">\n      <a href=\"{{vueDashboardRoot}}/\">\n        <span class=\"nav-icon\"><i class=\"fa fa-home\"></i></span>\n        <span class=\"nav-label\">Broadcasts</span>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.canScheduleBroadcast\">\n      <a href=\"{{vueDashboardRoot}}/schedule\">\n        <span class=\"nav-icon\"><i class=\"fa fa-calendar-plus-o\"></i></span>\n        <span class=\"nav-label\">Schedule</span>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.account.is_manufacturer\">\n      <a ui-sref=\"extended-test\">\n        <span class=\"nav-icon\" style=\"position: relative\">\n          <i class=\"fa fa-server\"></i>\n        </span>\n        <span class=\"nav-label\">Extended Test</span>\n      </a>\n    </li>\n    <li class=\"divider\"></li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.canAccessSharing\">\n      <a href=\"{{vueDashboardRoot}}/sharing\">\n        <span class=\"nav-icon\"><i class=\"fa-kit fa-sharing\" style=\"margin-left: 6px;\"></i></span>\n        <span class=\"nav-label\">Sharing</span>\n        <div style=\"display: inline-block; background-color: var(--color-bx-shallot); color: white; padding: .25rem 1rem; margin-left: 1.2rem; font-size: 1.2rem; font-weight: 500; border-radius: 9999px;\">Beta</div>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.canAccessPosts\">\n      <a href=\"{{vueDashboardRoot}}/posts\">\n        <span class=\"nav-icon\"><i class=\"fa-kit fa-social-post\"></i></span>\n        <span class=\"nav-label\">Posts</span>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.canEditChannel\">\n      <a href=\"{{vueDashboardRoot}}/channels\">\n        <span class=\"nav-icon\"><i class=\"fa fa-television\"></i></span>\n        <span class=\"nav-label\">Channels</span>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.canEmbed\">\n      <a ui-sref=\"embed\">\n        <span class=\"nav-icon\"><i class=\"fa fa-code\"></i></span>\n        <span class=\"nav-label\">Embed</span>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.canUpload\">\n      <a ng-href=\"{{vm.uploadsRoute}}\">\n        <span class=\"nav-icon\"><i class=\"fa fa-image\"></i></span>\n        <span class=\"nav-label\">Media Uploads</span>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.FeatureFlags.multi_site\">\n      <a href=\"{{vueDashboardRoot}}/multi-site\">\n        <span class=\"nav-icon\"><i class=\"fa fa-building-o\"></i></span>\n        <span class=\"nav-label\">Multi-Site Player</span>\n      </a>\n    </li>\n    <li ng-class=\"{active:$state.includes('reports')}\" ng-if=\"vm.canAccessReports && vm.account.defaultReportState()\">\n      <a ng-href=\"{{$state.href(vm.account.defaultReportState())}}\">\n        <span class=\"nav-icon\"><i class=\"fa fa-line-chart\"></i></span>\n        <span class=\"nav-label\">Reports</span>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.canEditBoxcaster\">\n      <a href=\"{{vueDashboardRoot}}/sources\">\n        <span class=\"nav-icon\"><i class=\"fa fa-video-camera\"></i></span>\n        <span class=\"nav-label\">Sources</span>\n      </a>\n    </li>\n    <li ng-class=\"{active:$state.includes('settings')}\">\n      <a href=\"{{vueDashboardRoot}}/settings/my-account\">\n        <span class=\"nav-icon\"><i class=\"fa fa-cog\"></i></span>\n        <span class=\"nav-label\">Settings</span>\n      </a>\n    </li>\n\n    <!-- some of the hidden top-nav options move in here on small screen -->\n    <li class=\"divider visible-xs visible-sm visible-md-lg\"></li>\n    <li class=\"visible-xs visible-sm visible-md-lg dropdown\" ng-class=\"{open: vm.isDropdownOpen}\"\n      ng-show=\"vm.user.authorized_accounts.length > 1\">\n      <a href ng-click=\"vm.isDropdownOpen = !vm.isDropdownOpen\" class=\"dropdown-toggle\" data-toggle=\"dropdown\"\n        role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">\n        <span class=\"nav-icon\"><i class=\"fa fa-user\"></i></span>\n        <span class=\"nav-label\">Switch User</span>\n      </a>\n      <ul class=\"dropdown-menu\">\n        <li ng-repeat=\"a in ::vm.user.authorized_accounts | orderBy:'name'\" role=\"menuitem\"\n          ng-class=\"{active: a.id == vm.account.id}\">\n          <a ng-if=\"a.id != vm.account.id\" href ng-click=\"vm.switchAccount(a)\">{{a.name}}</a>\n          <a ng-if=\"a.id == vm.account.id\" href disabled style=\"background-color: #444; cursor: default;\">{{a.name}}</a>\n        </li>\n      </ul>\n    </li>\n    <li class=\"visible-xs visible-sm visible-md-lg\">\n      <a ng-click=\"vm.logout()\">\n        <span class=\"nav-icon\"><i class=\"fa fa-sign-out\"></i></span>\n        <span class=\"nav-label\">Sign Out</span>\n      </a>\n    </li>\n  </ul>\n\n  <div class=\"clearfix\"></div>\n\n\n  <div style=\"position:absolute; bottom:-110px; left:0; right:0; padding:5px;\" class=\"text-center\">\n    <ol class=\"list-inline text-center\">\n      <li>\n        <a href=\"https://support.boxcast.com\" target=\"_blank\" class=\"need-help\">\n          Need Help?\n        </a>\n      </li>\n    </ol>\n    <ol class=\"list-inline text-center\" ng-hide=\"vm.account.isTrialing() || !vm.canUpgrade\">\n      <li>\n        <a ui-sref=\"settings.payment\" style=\"font-size:1.4rem; font-weight:bold; color: rgba(255, 255, 255, 0.6)\">\n          Upgrade Options\n        </a>\n      </li>\n    </ol>\n    <ol class=\"list-inline text-center\">\n      <li>\n        <a href ng-click=\"vm.openGrowSurf()\" style=\"font-size:1.4rem; font-weight:bold; color: rgba(255, 255, 255, 0.6)\">Refer + Earn</a>\n      </li>\n    </ol>\n    <ol class=\"list-inline text-center\">\n      <li>\n        <a href=\"https://intercom.news/boxcast\" target=\"_blank\"\n          style=\"font-size:1.4rem; font-weight:bold; color: rgba(255, 255, 255, 0.6)\">\n          See What's New\n          <i class=\"fa-regular fa-arrow-up-right-from-square\"\n            style=\"font-size:1.4rem; font-weight:bold; color: rgba(255, 255, 255, 0.6)\"></i>\n        </a>\n      </li>\n    </ol>\n  </div>\n\n</div>"

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_utils__ = __webpack_require__(9);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var LeftNavController = /*#__PURE__*/function () {
  function LeftNavController(AuthService, $scope, $state, $rootScope, Products) {
    'ngInject';

    _classCallCheck(this, LeftNavController);

    this.AuthService = AuthService;
    this.Products = Products;
    this.$state = $state;
    this.user = AuthService.user;
    this.account = $rootScope.account;
    this.FeatureFlags = this.account.feature_flags;
    this.canEditBoxcaster = $rootScope.user.can('update', 'boxcaster/*');
    this.canEditChannel = $rootScope.user.can('update', 'channel/*');
    this.canUpload = $rootScope.user.can('create', 'upload');
    this.canAccessReports = $rootScope.user.can('read', 'viewer-analytics/*');
    this.canScheduleBroadcast = $rootScope.user.can('create', 'broadcast');
    this.canEmbed = $rootScope.user.can('embed', 'broadcast/*');
    this.canUpgrade = $rootScope.user.can('create', 'upgrade');
    this.currentYear = new Date().getFullYear();

    this.switchAccount = function (a) {
      return $rootScope.$emit('user:switchAccount', a);
    };

    this.allowProducer = $rootScope.user.can('create', 'broadcast') && this.FeatureFlags.producer;
    this.uploadsRoute = $rootScope.user.can('create', 'broadcast') && $rootScope.user.can('create', 'broadcast/*:upload') ? $rootScope.vueDashboardRoot + '/uploads' : $rootScope.vueDashboardRoot + '/uploads/thumbnail-images';
    this.canAccessSharing = $rootScope.user.can('list', 'clips') && this.FeatureFlags.clips;
    this.canAccessPosts = $rootScope.user.can('list', 'posts') && this.FeatureFlags.clips;
  }

  _createClass(LeftNavController, [{
    key: "openGrowSurf",
    value: function openGrowSurf() {
      console.log('open growsurf');

      if (window.growsurf.getParticipantId()) {
        window.growsurf.init({
          email: this.user.email,
          hash: window.growsurf.getCampaign()
        });
        window.growsurf.open();
      } else {
        var name = this.user.name.split(' ');
        window.growsurf.addParticipant({
          email: this.user.email,
          firstName: name[0],
          lastName: name[1]
        });
        window.growsurf.open();
      }
    }
  }, {
    key: "logout",
    value: function logout() {
      this.$state.go('logout');
    }
  }]);

  return LeftNavController;
}();

/* harmony default export */ __webpack_exports__["default"] = (LeftNavController);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(8);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('new-event', "", function () {
  // Migrated to dashboard_vue
  window.location.href = "".concat(window.VUE_DASHBOARD_ROOT, "/schedule/broadcast?showBanner=1");
}, 'NewEventController'));

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// The `wire` helper only deals with simple states. We need to add the
// detail sub-states as well, so we'll just do it by hand here.
var module = angular.module('app.pages.reports', []);
module.config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('reports', {
    url: '/reports',
    template: __webpack_require__(436),
    "abstract": true
  }).state('reports.viewer', {
    url: '/viewer?report&id&preset&since&until',
    template: __webpack_require__(437),
    controller: __webpack_require__(438)["default"],
    controllerAs: 'vm'
  }).state('reports.donations', {
    url: '/donations',
    template: __webpack_require__(439),
    controller: __webpack_require__(440)["default"],
    controllerAs: 'vm'
  }).state('reports.tickets', {
    url: '/tickets?report&id',
    template: __webpack_require__(441),
    controller: __webpack_require__(442)["default"],
    controllerAs: 'vm'
  });
});

__webpack_require__(443);

/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = "<main class=\"analytics container-fluid\">\n\n  <div class=\"col-xs-12\">\n    <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n      <li ui-sref-active=\"active\" ng-if=\"::($root.account.feature_flags.analytics && $root.user.can('read', 'viewer-analytics/*'))\">\n        <a ui-sref=\"reports.viewer\">Viewer Analytics</a>\n      </li>\n      <li ui-sref-active=\"active\" ng-if=\"::(!$root.account.feature_flags.no_ticketed && $root.user.can('read', 'broadcast/*:tickets:summary') && $root.user.can('read', 'channel/*:tickets:summary') && $root.user.can('read', 'tickets:summary'))\">\n        <a ui-sref=\"reports.tickets\">Ticket Reports</a>\n      </li>\n      <li ui-sref-active=\"active\" ng-if=\"::($root.account.feature_flags.donations && $root.user.can('read', 'donations:summary'))\">\n        <a ui-sref=\"reports.donations\">Donations Report</a>\n      </li>\n    </ol>\n  </div>\n  <div class=\"clearfix\"></div>\n\n  <div ui-view></div>\n\n</main>\n\n"

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports = "<style>\n.graph-element-container .graph-tooltip {\n  visibility: hidden\n}\n.graph-element-container:hover .graph-tooltip {\n    visibility: visible;\n}\n.graph-tooltip text {\n    fill: #FFFFFF;\n    font-size: 12px;\n    font-family: sans-serif;\n    font-weight: bold;\n}\n.graph-tooltip rect {\n    fill: #111111;\n    stroke: #000000;\n}\n</style>\n\n<main class=\"container-fluid\" ng-if=\"::vm.canDoAnalytics\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-sm-4\" style=\"margin-bottom:15px\">\n      <div class=\"btn-group btn-block\" uib-dropdown is-open=\"dropdown_channel.isopen\">\n        <button type=\"button\" class=\"btn btn-primary btn-block\" uib-dropdown-toggle style=\"text-align:left\">\n          <div style=\"display:flex; align-items:center\">\n            <div style=\"flex: 1; margin-right: 10px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\">\n              <div><small>Select Channel</small></div>\n              <div class=\"font-bold\" style=\"overflow: hidden; text-overflow: ellipsis;\">\n                {{vm.selectedChannelName}}\n              </div>\n            </div>\n            <i class=\"fa fa-caret-down\"></i>\n          </div>\n        </button>\n        <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" style=\"width:100%\">\n          <li role=\"menuitem\">\n            <a ui-sref=\"reports.viewer({report:null, id:null, preset:vm.datePreset, since:vm.since, until:vm.until})\">Entire Account</a>\n          </li>\n          <li class=\"divider\"></li>\n          <li role=\"menuitem\" ng-repeat=\"c in vm.channels track by c.id\">\n            <a\n               style=\"overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\"\n               ui-sref=\"reports.viewer({report:'channels', id:c.id, preset:vm.datePreset, since:vm.since, until:vm.until})\"\n            >{{c.name}}</a>\n          </li>\n        </ul>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-sm-4\" style=\"margin-bottom:15px\">\n      <div class=\"btn-group btn-block\" uib-dropdown is-open=\"vm.dateDropdownOpened\">\n        <button type=\"button\" class=\"btn btn-primary btn-block\" uib-dropdown-toggle style=\"text-align: left;\">\n          <div style=\"display:flex; align-items:center\">\n            <div style=\"flex: 1; margin-right: 10px;\">\n              <div><small>Select Date Range</small></div>\n              <div class=\"font-bold\">\n                {{vm.since|date}} - {{vm.until|date}}\n              </div>\n            </div>\n            <i class=\"fa fa-calendar\"></i>\n          </div>\n        </button>\n        <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" style=\"width:100%\">\n          <li role=\"menuitem\"><a href ng-click=\"vm.selectDatePreset('past_week')\">Past Week </a></li>\n          <li role=\"menuitem\"><a href ng-click=\"vm.selectDatePreset('past_month')\">Past Month </a></li>\n          <li role=\"menuitem\"><a href ng-click=\"vm.selectDatePreset('past_year')\">Past Year</a></li>\n          <li role=\"menuitem\"><a href ng-click=\"vm.selectDatePreset('this_cal_month')\">This Calendar Month</a></li>\n          <li role=\"menuitem\"><a href ng-click=\"vm.selectDatePreset('last_cal_month')\">Last Calendar Month</a></li>\n          <li class=\"divider\"></i>\n          <li role=\"menuitem\" ng-click=\"$event.stopPropagation()\">\n            <div class=\"col-xs-12\">Custom Date Range</div>\n            <div class=\"col-xs-12\">\n              <ol class=\"list-inline\">\n                <li>\n                  <div class=\"input-group\" style=\"max-width:150px\">\n                    <input type=\"text\" class=\"form-control\"\n                            ng-model=\"vm.customSince\"\n                            uib-datepicker-popup=\"MM/dd/yyyy\"\n                            is-open=\"vm.customSinceDatePopupOpened\"\n                            ng-required=\"true\"\n                            datepicker-options=\"{showWeeks: false}\">\n                    <span class=\"input-group-btn\">\n                      <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.customSinceDatePopupOpened = !vm.customSinceDatePopupOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                  </div>\n                </li>\n                <li>\n                  <div class=\"input-group\" style=\"max-width:150px\">\n                    <input type=\"text\" class=\"form-control\"\n                            ng-model=\"vm.customUntil\"\n                            uib-datepicker-popup=\"MM/dd/yyyy\"\n                            is-open=\"vm.customUntilDatePopupOpened\"\n                            ng-required=\"true\"\n                            datepicker-options=\"{minDate: vm.customSince, showWeeks: false}\">\n                    <span class=\"input-group-btn\">\n                      <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.customUntilDatePopupOpened = !vm.customUntilDatePopupOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                  </div>\n                </li>\n                <li>\n                  <div class=\"input-group\">\n                    <button type=\"button\"\n                            class=\"btn btn-primary btn-sm\"\n                            ng-click=\"vm.selectDatePreset('custom', {since: vm.customSince, until: vm.customUntil})\"\n                            >Apply</button>\n                  </div>\n                </li>\n              </ol>\n            </div>\n          </li>\n        </ul>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-sm-4\" style=\"margin-bottom:15px\">\n      <div class=\"text-center text-sm\">\n        Note: some aggregated statistics (live&nbsp;vs&nbsp;recorded, quality, avg&nbsp;duration)\n        are delayed by up to 24 hours.\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"hidden-xs col-sm-12\" style=\"margin-bottom:5px;\">\n      <p class=\"text-sm\">\n        <span style=\"display: inline-block; background-color: var(--color-bx-lagoon); color: white; padding: .3rem .7rem; border-radius: .4rem; margin-right: 1rem; font-size: 1rem; font-weight: 500; vertical-align: middle;\">BETA</span>\n        <a ng-if=\"vm.canExport()\" \n          href=\"javascript://\" \n          ng-click=\"vm.downloadAnalytics()\" \n          style=\"display: inline-block; margin-right: 1rem; {{vm.isExporting ? 'cursor: not-allowed; opacity: 0.7;' : ''}}\"\n        ><i class=\"fa fa-file-csv\"></i> Export data to CSV <i ng-if=\"vm.isExporting\" class=\"fa fa-spin fa-spinner\"></i></a>\n        <span class=\"text-xs text-bx-accessible-grey\">\n          <i class=\"fa fa-info-circle\"></i> Exports are available for up to 50,000 views. Note: data may be delayed by up to 24 hours.\n        </span>\n      </p>\n    </div>\n  </div>\n\n  <!-- Empty State -->\n  <div class=\"row\" ng-if=\"!vm.hasViews()\">\n    <div style=\"margin:50px 0;\" class=\"text-center\">\n      <i class=\"fa fa-4x fa-line-chart\" style=\"font-size:175px;\"></i>\n      <h2 class=\"text-bx-accessible-grey\">You don't have any viewership data yet for this channel.</h2>\n      <p><a ui-sref=\"resources\">Check out our resources section to learn how to promote your broadcasts!</a></p>\n    </div>\n  </div>\n\n  <!-- Container for All Analytics Graphs/Charts -->\n  <div class=\"row\" ng-if=\"vm.hasViews()\">\n\n    <div class=\"col-sm-12\">\n      <div class=\"well\">\n        <h4>\n          {{vm.selectedChannelName}} Summary\n          <a style=\"float:right; color:#aaa; border-bottom:1px dotted; font-size:12px;\" href=\"{{vueDashboardRoot}}/broadcasts/{{vm.broadcast.id}}\" ng-if=\"vm.broadcast.id\">\n            View Broadcast\n          </a>\n        </h4>\n        <div class=\"row text-center\">\n          <div class=\"col-xs-12 col-sm-6\">\n\n            <!-- multi-broadcast summary -->\n            <div class=\"row text-center\" ng-if=\"vm.report != 'broadcasts'\">\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;\">\n                <p style=\"font-weight:bold;\">Total Views</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.analytics.total_view_count|number}}</h1>\n                <p class=\"text-sm text-muted\">\n                  <compare-to-percent base=\"vm.analytics.total_view_count\" compare=\"vm.analyticsCompare.total_view_count\"></compare-to-percent>\n                  vs prev period\n                </p>\n              </div>\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;\">\n                <p style=\"font-weight:bold;\">Unique Viewers</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.analytics.unique_viewer_count|number}}</h1>\n                <p class=\"text-sm text-muted\">\n                  <compare-to-percent base=\"vm.analytics.unique_viewer_count\" compare=\"vm.analyticsCompare.unique_viewer_count\"></compare-to-percent>\n                  vs prev period\n                </p>\n              </div>\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;margin-top:15px;\">\n                <p style=\"font-weight:bold;\">Avg. View Duration</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.analytics.avg_view_duration|secondsFormatted}}</h1>\n                <p class=\"text-sm text-muted\">\n                  <compare-to-percent base=\"vm.analytics.avg_view_duration\" compare=\"vm.analyticsCompare.avg_view_duration\"></compare-to-percent>\n                  vs prev period\n                </p>\n              </div>\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;margin-top:15px;\">\n                <p style=\"font-weight:bold;\">Watched Broadcasts</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.analytics.viewed_broadcast_count|number}}</h1>\n                <p class=\"text-sm text-muted\">\n                  <compare-to-percent base=\"vm.analytics.viewed_broadcast_count\" compare=\"vm.analyticsCompare.viewed_broadcast_count\"></compare-to-percent>\n                  vs prev period\n                </p>\n              </div>\n            </div>\n\n            <!-- single broadcast summary -->\n            <div class=\"row text-center\" ng-if=\"vm.report == 'broadcasts'\">\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;\">\n                <p style=\"font-weight:bold;\">All-Time Views</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.broadcast.total_view_count|number}}</h1>\n                <p class=\"text-sm text-muted\">&nbsp;</p>\n              </div>\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;\">\n                <p style=\"font-weight:bold;\">Views This Period</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.analytics.total_view_count|number}}</h1>\n                <p class=\"text-sm text-muted\">\n                  <compare-to-percent base=\"vm.analytics.total_view_count\" compare=\"vm.analyticsCompare.total_view_count\"></compare-to-percent>\n                  vs prev period\n                </p>\n              </div>\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;margin-top:15px;\">\n                <p style=\"font-weight:bold;\">Unique Viewers</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.analytics.unique_viewer_count|number}}</h1>\n                <p class=\"text-sm text-muted\">\n                  <compare-to-percent base=\"vm.analytics.unique_viewer_count\" compare=\"vm.analyticsCompare.unique_viewer_count\"></compare-to-percent>\n                  vs prev period\n                </p>\n              </div>\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;margin-top:15px;\">\n                <p style=\"font-weight:bold;\">Avg. View Duration</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.analytics.avg_view_duration|secondsFormatted}}</h1>\n                <p class=\"text-sm text-muted\">\n                  <compare-to-percent base=\"vm.analytics.avg_view_duration\" compare=\"vm.analyticsCompare.avg_view_duration\"></compare-to-percent>\n                  vs prev period\n                </p>\n              </div>\n            </div>\n\n          </div>\n\n          <div class=\"col-xs-12 col-sm-6\">\n            <p class=\"text-center\"><strong>Cumulative Views vs. Prev Period</strong></p>\n\n            <canvas height=\"105\"\n                class=\"chart chart-line\"\n                chart-data=\"vm.viewsVsData\"\n                chart-labels=\"vm.viewsVsLabels\"\n                chart-options=\"vm.viewsVsOptions\"></canvas>\n          </div>\n\n        </div>\n      </div>\n    </div>\n\n\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <h4>When Viewers Watch</h4>\n\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-6\">\n            <p class=\"text-center\"><strong>By Day</strong></p>\n            <div>\n              <canvas height=\"175\"\n                  class=\"chart chart-line\"\n                  chart-data=\"vm.viewsData\"\n                  chart-labels=\"vm.viewsLabels\"\n                  chart-options=\"vm.viewsOptions\"></canvas>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-sm-6\">\n            <p class=\"text-center\"><strong>By Time of Day / Day of Week</strong></p>\n            <table class=\"table\" style=\"font-size:0.8em\">\n              <tr>\n                <td>12am</td>\n                <td colspan=\"7\" rowspan=\"6\">\n                  <svg viewBox=\"0 0 100 50\" xmlns=\"http://www.w3.org/2000/svg\">\n                    <svg id=\"bubble-grid\" viewBox=\"0 0 100 50\">\n                      <g id=\"outer_{{$index}}\" ng-repeat=\"day in vm.bubbleGraphRows track by $index\" ng-cloak>\n                        <g ng-repeat=\"hr in day.hours track by $index\"\n                           id=\"inner_{{$index}}\"\n                           class=\"graph-element-container\"\n                           ng:attr:transform=\"translate({{vm.bubbleGraphX(day, hr, $index, $parent.$index)}}, {{vm.bubbleGraphY(day, hr, $index, $parent.$index)}})\"\n                           ng-cloak\n                           >\n                          <circle x=\"0\" y=\"0\"\n                                  ng:attr:r=\"{{vm.bubbleGraphR(day, hr, $index, $parent.$index)}}\"\n                                  fill=\"#044B94\"\n                                  fill-opacity=\"0.4\"\n                                  />\n                          <!--\n                            XXX: SVG tooltips are a pain. Problems with z-index and clipping\n                            near edges are not easy to solve.  The default <title> implementation\n                            is not robust (nonconfigurable delay/style) but it's at least reliable.\n                          <g class=\"graph-tooltip\" transform=\"translate(0,0),scale(0.3)\" opacity=\"0.75\">\n                              <rect rx=\"4\" width=\"125\" height=\"20\"></rect>\n                              <text x=\"4\" y=\"14\">\n                                {{vm.bubbleGraphTitle(day, hr, $index, $parent.$index)}}\n                              </text>\n                          </g>\n                          -->\n                          <title>{{vm.bubbleGraphTitle(day, hr, $index, $parent.$index)}}</title>\n                        </g>\n                      </g>\n                    </svg>\n                  </svg>\n                </td>\n              </tr>\n              <tr><td>4am</td></tr>\n              <tr><td>8am</td></tr>\n              <tr><td>12pm</td></tr>\n              <tr><td>4pm</td></tr>\n              <tr><td>8pm</td></tr>\n              <tr class=\"text-center\">\n                <td style=\"width:50px\"></td>\n                <td style=\"width:14.28%\">Sun</td>\n                <td style=\"width:14.28%\">Mon</td>\n                <td style=\"width:14.28%\">Tue</td>\n                <td style=\"width:14.28%\">Wed</td>\n                <td style=\"width:14.28%\">Thu</td>\n                <td style=\"width:14.28%\">Fri</td>\n                <td style=\"width:14.28%\">Sat</td>\n              </tr>\n            </table>\n          </div>\n          <div class=\"col-xs-12\" style=\"margin-top:15px;\" ng-if=\"vm.liveData\">\n            <p class=\"text-center\">\n              <strong>\n                {{100*vm.liveData[0]|number:0}}% Watch <span style=\"border-bottom:1px dotted #5DA5DA\">Live</span>\n                <span style=\"opacity:0.5\">&nbsp;/&nbsp;</span>\n                {{100*vm.liveData[1]|number:0}}% Watch <span style=\"border-bottom:1px dotted #4D4D4D\">Recorded</span>\n              </strong>\n            </p>\n            <div style=\"position:relative;height:10px;\">\n              <div style=\"position:absolute;height:10px;top:0;left:0;width:{{100*vm.liveData[0]}}%;border:2px solid #5DA5DA;background:rgba(93,165,218,0.4);border-right:none;\">\n              </div>\n              <div style=\"position:absolute;height:10px;top:0;left:{{100*vm.liveData[0]}}%;width:{{100*vm.liveData[1]}}%;border:2px solid #4D4D4D;background:rgba(77,77,77,0.4);border-left:none;\">\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <h4>How Viewers Watch</h4>\n        <div class=\"row\">\n          <div class=\"col-sm-8\">\n            <div class=\"row\">\n              <div class=\"col-sm-6\">\n                <p class=\"text-center\"><strong>Playback Quality</strong></p>\n                <canvas class=\"chart chart-pie\"\n                        chart-data=\"vm.qualityData\"\n                        chart-labels=\"vm.qualityLabels\"\n                        chart-legend=\"true\"\n                        chart-options=\"vm.qualityPieChartOptions\"\n                        ></canvas>\n              </div>\n              <div class=\"col-sm-6\">\n                <p class=\"text-center\"><strong>Device Type</strong></p>\n                <canvas class=\"chart chart-pie\"\n                        chart-data=\"vm.mobileData\"\n                        chart-labels=\"vm.mobileLabels\"\n                        chart-legend=\"true\"\n                        chart-options=\"vm.pieChartOptions\"\n                        ></canvas>\n              </div>\n            </div>\n            <div class=\"row\" style=\"margin-top:30px\">\n              <div class=\"col-sm-6\">\n                <p class=\"text-center\"><strong>Browser</strong></p>\n                <canvas class=\"chart chart-pie\"\n                        chart-data=\"vm.browserData\"\n                        chart-labels=\"vm.browserLabels\"\n                        chart-legend=\"true\"\n                        chart-options=\"vm.pieChartOptions\"\n                        ></canvas>\n              </div>\n              <div class=\"col-sm-6\">\n                <p class=\"text-center\"><strong>Operating System</strong></p>\n                <canvas class=\"chart chart-pie\"\n                        chart-data=\"vm.osData\"\n                        chart-labels=\"vm.osLabels\"\n                        chart-legend=\"true\"\n                        chart-options=\"vm.pieChartOptions\"\n                        ></canvas>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-sm-4\">\n            <p class=\"text-center\"><strong>Viewership By Destination</strong></p>\n            <table class=\"table table-condensed\">\n              <thead style=\"text-align:center;font-size:0.8em\">\n                <tr>\n                  <td></td><td></td><td class=\"text-right\">Views</td>\n                  <!--td class=\"text-right\">Pct.</td-->\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"h in vm.analytics.hostData\">\n                  <td class=\"text-center\">\n                    <strong>{{$index + 1}}.</strong>\n                  </td>\n                  <td class=\"text-left\">\n                    <img src=\"/img/{{h.icon}}\" style=\"display:inline-block;height:15px;width:15px;margin-right:5px;\">\n                    <strong>{{h.label}}</strong>\n                  </td>\n                  <td class=\"text-right\"><strong>{{h.value|number}}</strong></td>\n                  <!--td class=\"text-right\" style=\"color:#aaa;width:1%;padding-left:10px;\">{{h.percent|number:1}}%</td-->\n                </tr>\n              </tbody>\n            </table>\n            <p ng-if=\"vm.insights.device\">\n              <strong style=\"color:#aaa\">INSIGHT</strong>\n              Most viewers watch on <strong>{{vm.insights.device}}</strong>.\n            </p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div class=\"col-xs-12\" ng-if=\"vm.regionData && vm.regionData.length\">\n      <div class=\"well\">\n        <h4>Where Viewers Watch</h4>\n        <div class=\"row\">\n          <div class=\"col-sm-8\">\n            <p class=\"text-center\"><strong>Geolocation</strong></p>\n            <analytics-geo-chart analytics=\"vm.analytics\"></analytics-geo-chart>\n            <p ng-if=\"vm.insights.geo.states > 1\">\n              <strong style=\"color:#aaa\">INSIGHT</strong>1\n              You have viewers in\n              <span ng-if=\"vm.insights.geo.countries > 1\"><strong>{{vm.insights.geo.countries}} countries</strong> and</span>\n              <strong>{{vm.insights.geo.states}} states</strong>.\n            </p>\n          </div>\n          <div class=\"col-sm-4\">\n            <p class=\"text-center\"><strong>Top Regions</strong></p>\n            <table class=\"table table-condensed\">\n              <thead style=\"text-align:center;font-size:0.8em\">\n                <tr>\n                  <td></td><td></td><td class=\"text-right\">Views</td>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"region in vm.regionDataSlice\">\n                  <td class=\"text-center\">\n                    <strong>{{$index + 1}}.</strong>\n                  </td>\n                  <td class=\"text-left\">\n                    <strong>{{region.label}}</strong>\n                  </td>\n                  <td class=\"text-right\">\n                    <strong>{{region.count}}</strong>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n            <p ng-if=\"vm.regionData.length > vm.regionDataSlice.length\" class=\"text-center\">\n              <a href=\"javascript://\" ng-click=\"vm.loadMoreRegionData()\">\n                <strong><small>Show More</small></strong>\n              </a>\n            </p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div class=\"col-xs-12\" ng-if=\"vm.report != 'broadcasts'\">\n      <div class=\"well\">\n        <h4>Hall of Fame</h4>\n        <div class=\"row\">\n          <div class=\"col-sm-6\">\n            <p class=\"text-center\"><strong>Most Viewed Broadcasts</strong></p>\n\n            <table style=\"margin-top:15px\" class=\"table table-condensed table-fixed\">\n              <thead class=\"text-sm\" style=\"text-align:center;\">\n                <tr>\n                  <td style=\"width: 40px;\"></td><!-- Col 1 -->\n                  <td></td><!-- Col 2 -->\n                  <td style=\"width: 80px;\">Views this Period</td><!-- Col 3 -->\n                  <td style=\"width: 80px;\">All-time Views</td><!-- Col 4 -->\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"broadcast in vm.analytics.most_popular_broadcasts\">\n                  <td class=\"text-right\">\n                    <strong>{{$index + 1}}.</strong>\n                  </td>\n                  <td>\n                    <a class=\"body-3 text-bx-lagoon underline\" href=\"{{vueDashboardRoot}}/broadcasts/{{broadcast.broadcast_id}}\" style=\"overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: block; line-height: 1.3;\">\n                      <strong>{{broadcast.broadcast_name}}</strong>\n                    </a>\n                    <span class=\"text-muted\" style=\"display: block;\">\n                        <date-range start=\"broadcast.broadcast_starts_at\" end=\"broadcast.broadcast_stops_at\"></date-range>\n                    </span>\n                  </td>\n                  <td class=\"text-center\">\n                    <strong>{{broadcast.view_count | number}}</strong>\n                  </td>\n                  <td class=\"text-center\">\n                    <strong>{{broadcast.total_view_count | number}}</strong>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n\n          </div>\n          <div class=\"col-sm-6\">\n            <p class=\"text-center\"><strong>Achievements Unlocked</strong></p>\n\n            <div class=\"flex-grid achievements\">\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.views_over_1000\" name=\"&gt;1000 Channel Views\" description=\"Great job on getting over 1000 total views!\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.views_over_10000\" name=\"&gt;10,000 Channel Views\" description=\"Amazing job on getting over 10,000 total views!\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.hotspot\" name=\"Hotspot!\" description=\"Hotspot! Your viewers love to watch at the same time of day and same day of week!\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.hifi\" name=\"Hi-Fi Viewers\" description=\"You've got some high-fidelity viewers - they're all watching in HD!\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.do_it_live\" name=\"In The Moment\" description=\"More than 95% of viewers are watching live - that's awesome!\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.engaged\" name=\"Engaged!\" description=\"Your viewers are engaged, demonstrated by a high average view duration\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.daily_double\" name=\"Daily Double\" description=\"You've more than doubled viewership compared to the previous period. Nice work!\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.world_traveler\" name=\"World Traveler\" description=\"Your broadcasts are being watched internationally in multiple countries!\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"false\" name=\"\" description=\"\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"false\" name=\"\" description=\"\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"false\" name=\"\" description=\"\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"false\" name=\"\" description=\"\"></achievements-cell>\n            </div>\n\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</main>\n"

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_geo__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_download__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_analytics__ = __webpack_require__(181);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }






var ViewerAnalyticsController = /*#__PURE__*/function () {
  function ViewerAnalyticsController(AnalyticsResource, AnalyticsExportResource, Broadcast, Channel, ApiConfig, $state, $rootScope, $q, toaster, $http, $scope) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, ViewerAnalyticsController);

    this.AnalyticsResource = AnalyticsResource;
    this.AnalyticsExportResource = AnalyticsExportResource;
    this.Broadcast = Broadcast;
    this.Channel = Channel;
    this.toaster = toaster;
    this.$q = $q;
    this.canDoAnalytics = $rootScope.account.feature_flags.analytics && $rootScope.user.can('read', 'viewer-analytics/*');

    if (!this.canDoAnalytics) {
      return;
    }

    this.report = $state.params.report;
    this.id = $state.params.id;
    this.account = $rootScope.account;
    this.channels = Channel.query({
      l: 1000
    });
    this.regionDictPromise = $http.get('/img/region_codes.json').then(function (response) {
      _this.regionDict = response.data;
    }); // Analytics exports are restricted to <= 50,000 views.

    this.exportViewLimit = 50000; // isExporting designates whether an export request is actively being processed.

    this.isExporting = false;
    var commonPieChartOptions = {
      aspectRatio: 2.5,
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontSize: 12,
          boxWidth: 12,
          padding: 5
        }
      }
    };

    var pieChartLabel = function pieChartLabel(point, context) {
      var views = context.datasets[point.datasetIndex].data[point.index];

      var totalViews = _.sum(context.datasets[point.datasetIndex].data);

      var label = context.labels[point.index];
      var valueString = "".concat(views, " view").concat(views == 1 ? '' : 's');
      var percentString = '';

      if (totalViews > 0) {
        percentString = " (".concat(Math.round(100.0 * views / totalViews), "%)");
      }

      return "".concat(label, ": ").concat(valueString).concat(percentString);
    };

    var qualityPieChartLabel = function qualityPieChartLabel(point, context) {
      var duration = context.datasets[point.datasetIndex].data[point.index];

      var totalDuration = _.sum(context.datasets[point.datasetIndex].data);

      var label = context.labels[point.index];
      var valueString = Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["f" /* secondsToFormattedLabel2 */])(duration);
      var percentString = '';

      if (totalDuration > 0) {
        percentString = " (".concat(Math.round(100.0 * duration / totalDuration), "%)");
      }

      return "".concat(label, ": ").concat(valueString).concat(percentString);
    };

    this.pieChartOptions = _.extend({}, commonPieChartOptions, {
      tooltips: {
        callbacks: {
          label: pieChartLabel
        }
      }
    });
    this.qualityPieChartOptions = _.extend({}, commonPieChartOptions, {
      tooltips: {
        callbacks: {
          label: qualityPieChartLabel
        }
      }
    });
    this.loadingPromises = [this.channels.$promise, this.regionDictPromise];
    var preset = $state.params.preset;

    if (!preset) {
      if (this.report == 'broadcasts') {
        preset = 'all_time';
      } else {
        preset = 'past_week';
      }
    }

    this.selectDatePreset(preset, $state.params);
  }

  _createClass(ViewerAnalyticsController, [{
    key: "selectDatePreset",
    value: function selectDatePreset(preset) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var toaster = this.toaster;

      if (this.datePreset == preset && preset != 'custom') {
        return;
      }

      this.datePreset = preset;

      switch (preset) {
        case 'all_time':
          this.since = moment(); //<-- XXX: this needs reset below after we get the broadcast resource

          this.until = moment(); // Ensure equal number of days in comparison period...

          var days = this.until.diff(this.since, 'days');
          this.compareSince = null;
          this.compareUntil = null;
          this.graphGranularity = 'day';
          break;

        case 'custom':
          this.since = moment(args.since);
          this.until = moment(args.until); // Ensure equal number of days in comparison period...

          var days = this.until.diff(this.since, 'days');
          this.compareSince = moment(this.since).clone().subtract(days, 'days');
          this.compareUntil = this.compareSince.clone().add(days, 'days');
          this.graphGranularity = 'day';
          break;

        case 'past_week':
          // subtract 6 days, not the full 7, as it's inclusive of the current day.
          this.since = moment().subtract(6, 'days');
          this.until = moment(); // Ensure equal number of days in comparison period...

          var days = this.until.diff(this.since, 'days');
          this.compareSince = moment(this.since).clone().subtract(6, 'days');
          this.compareUntil = this.compareSince.clone().add(days, 'days');
          this.graphGranularity = 'day';
          break;

        case 'past_month':
          this.since = moment().subtract(1, 'month');
          this.until = moment(); // Ensure equal number of days in comparison period...

          var days = this.until.diff(this.since, 'days');
          this.compareSince = moment(this.since).clone().subtract(1, 'month');
          this.compareUntil = this.compareSince.clone().add(days, 'days');
          this.graphGranularity = 'day';
          break;

        case 'past_year':
          this.since = moment().subtract(1, 'year');
          this.until = moment(); // Ensure equal number of days in comparison period...

          var days = this.until.diff(this.since, 'days');
          this.compareSince = moment(this.since).clone().subtract(1, 'year');
          this.compareUntil = this.compareSince.clone().add(days, 'days');
          this.graphGranularity = 'month';
          break;

        case 'this_cal_month':
          this.since = moment().startOf('month');
          this.until = moment(); // Get entire previous month as comparison, even if it has more days

          this.compareSince = moment(this.since).clone().subtract(1, 'month').startOf('month');
          this.compareUntil = moment(this.since).clone().subtract(1, 'month').endOf('month');
          this.graphGranularity = 'day';
          break;

        case 'last_cal_month':
          this.since = moment().subtract(1, 'month').startOf('month');
          this.until = moment().subtract(1, 'month').endOf('month'); // Get entire previous month as comparison, even if it has more days

          this.compareSince = moment().subtract(2, 'month').startOf('month');
          this.compareUntil = moment().subtract(2, 'month').endOf('month');
          this.graphGranularity = 'day';
          break;

        default:
          toaster.pop('warning', 'Unknown date preset');
      } // Defaults for custom date picker


      this.customSince = this.since.clone().toDate();
      this.customUntil = this.until.clone().toDate(); // Normalize to DateTime objects instead of moment instances

      this.since = this.since.toDate();
      this.until = this.until.toDate();
      this.compareSince = this.compareSince ? this.compareSince.toDate() : null;
      this.compareUntil = this.compareUntil ? this.compareUntil.toDate() : null;
      this.dateDropdownOpened = false;
      this.reload();
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this2 = this;

      var account = this.account,
          report = this.report,
          id = this.id,
          Broadcast = this.Broadcast,
          Channel = this.Channel;

      switch (report) {
        case 'broadcasts':
          this.broadcast = Broadcast.get({
            id: id
          }, function (broadcast) {
            if (_this2.datePreset == 'all_time') {
              _this2.since = moment(_this2.broadcast.starts_at);
              _this2.customSince = _this2.since.clone().toDate();
              _this2.since = _this2.since.toDate();
            }

            _this2.selectedChannelName = broadcast.name;

            _this2.queryAnalytics(broadcast.channel_id);
          });
          break;

        case 'channels':
          Channel.get({
            id: id
          }, function (channel) {
            return _this2.selectedChannelName = channel.name;
          });
          this.queryAnalytics(id);
          break;

        default:
          this.selectedChannelName = 'Entire Account';
          this.queryAnalytics(account.channel_id);
          break;
      }
    }
  }, {
    key: "hasViews",
    value: function hasViews() {
      if (!this.analytics) return false;
      return this.analytics.total_view_count > 0;
    } // Analytics exports are restricted based on the # of views in the current report.

  }, {
    key: "canExport",
    value: function canExport() {
      return this.hasViews() && this.analytics.total_view_count <= this.exportViewLimit;
    }
  }, {
    key: "queryAnalytics",
    value: function queryAnalytics(channel_id) {
      var _this3 = this;

      var $q = this.$q,
          toaster = this.toaster,
          AnalyticsResource = this.AnalyticsResource; // TODO: configurable timezone
      // NOTE: the time portion is ignored by API, only the date is used, but we need the
      // time so that you can pass the timezone in. Time logic is: since <= date < until

      this.analytics = AnalyticsResource.get({
        channel_id: channel_id,
        since: moment(this.since).local().set({
          h: 0,
          m: 0,
          s: 0,
          ms: 0
        }).format('YYYY-MM-DDTHH:mm:ssZ'),
        until: moment(this.until).clone().add(1, 'day').local().set({
          h: 0,
          m: 0,
          s: 0,
          ms: 0
        }).format('YYYY-MM-DDTHH:mm:ssZ')
      });

      if (this.datePreset == 'all_time') {
        this.analyticsCompare = {};
      } else {
        this.analyticsCompare = AnalyticsResource.get({
          channel_id: channel_id,
          since: moment(this.compareSince).local().set({
            h: 0,
            m: 0,
            s: 0,
            ms: 0
          }).format('YYYY-MM-DDTHH:mm:ssZ'),
          until: moment(this.compareUntil).clone().add(1, 'day').local().set({
            h: 0,
            m: 0,
            s: 0,
            ms: 0
          }).format('YYYY-MM-DDTHH:mm:ssZ')
        });
      }

      this.loadingPromises = [this.analytics.$promise, this.analyticsCompare.$promise, this.regionDictPromise];
      $q.all([this.analytics.$promise, this.analyticsCompare.$promise, this.regionDictPromise]).then(function () {
        // If no collected view data for selected option; API returns null. We coerce into something
        // that avoids explosion or other special handling by UI.
        var dummy = function dummy() {
          return {
            live_view_count: 0,
            recorded_view_count: 0,
            live_view_seconds: 0,
            recorded_view_seconds: 0,
            unique_viewer_count: 0,
            viewed_broadcast_count: 0,
            daily_view_counts: [],
            weekday_hourly_view_counts: [],
            view_durations_by_quality: {},
            view_counts_by_host: {},
            most_popular_broadcasts: []
          };
        };

        if (_this3.analytics.live_view_count === undefined) {
          _this3.analytics = angular.extend(_this3.analytics, dummy());
        }

        if (_this3.analyticsCompare.live_view_count === undefined) {
          _this3.analyticsCompare = angular.extend(_this3.analyticsCompare, dummy());
        } // glue on computed fields


        _this3.analytics.total_view_count = _this3.analytics.live_view_count + _this3.analytics.recorded_view_count;
        _this3.analytics.total_view_duration = _this3.analytics.live_view_seconds + _this3.analytics.recorded_view_seconds;
        _this3.analytics.avg_view_duration = _this3.analytics.total_view_duration / _this3.analytics.total_view_count;

        if (_this3.analytics.live_buffer_seconds == 0 || _this3.analytics.live_view_seconds == 0) {
          _this3.analytics.live_rebuffer_pct = 0;
        } else {
          _this3.analytics.live_rebuffer_pct = 100 * (_this3.analytics.live_buffer_seconds / (_this3.analytics.live_buffer_seconds + _this3.analytics.live_view_seconds));
        }

        if (_this3.analytics.recorded_buffer_seconds == 0 || _this3.analytics.recorded_view_seconds == 0) {
          _this3.analytics.recorded_rebuffer_pct = 0;
        } else {
          _this3.analytics.recorded_rebuffer_pct = 100 * (_this3.analytics.recorded_buffer_seconds / (_this3.analytics.recorded_buffer_seconds + _this3.analytics.recorded_view_seconds));
        } // shared graph config


        _this3.barOptions = {
          barPercentage: 0.95,
          categoryPercentage: 0.5,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false
              },
              position: 'bottom',
              ticks: {
                fontSize: 10
              }
            }]
          }
        }; // compute graph data

        _this3.viewsLabels = [];
        _this3.viewsData = [[]];
        _this3.viewsOptions = {
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                unit: 'day',
                displayFormats: {
                  day: 'MMM Do'
                }
              },
              //categoryPercentage: 0.20, //1 every 5 labels
              gridLines: {
                display: false
              },
              position: 'bottom',
              ticks: {
                fontSize: 11,
                fontFamily: 'Arial, sans-serif',
                //maxRotation: 0,
                autoSkip: true
              }
            }] //yAxes: [{
            //  gridLines: { display: false }
            //}]

          },
          tooltips: {
            callbacks: {
              title: function title(items, data) {
                return _this3.viewsLabels[items[0].index].format('ddd MMM Do');
              }
            }
          }
        };
        (_this3.analytics.daily_view_counts || []).forEach(function (c, i) {
          _this3.viewsLabels.push(moment(_this3.since).clone().add(i, 'day'));

          _this3.viewsData[0].push(c);
        });
        _this3.qualityData = _.values(_this3.analytics.view_durations_by_quality);
        _this3.qualityLabels = _.keys(_this3.analytics.view_durations_by_quality).map(function (l) {
          return l || 'Not reported';
        }); // Compute insights before we mutate the view_counts_by_* dictionaries

        _this3.insights = Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["a" /* computeInsights */])(null, _this3.analytics); // Better formatting on hosts

        _this3.analytics.hostData = Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["c" /* normalizeHostData */])(_this3.analytics); // NOTE: this has to happen before we mutate the view_counts_by_* dictionaries below

        var mobile = Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["e" /* normalizePlatform */])(_this3.analytics.view_counts_by_os, _this3.analytics.view_counts_by_browser);
        _this3.mobileData = _.values(mobile);
        _this3.mobileLabels = _.keys(mobile);
        _this3.analytics.view_counts_by_browser = Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["b" /* normalizeBrowsers */])(_this3.analytics.view_counts_by_browser);

        var sortedBrowsers = _(_this3.analytics.view_counts_by_browser).pairs().sortBy(1).reverse().value();

        _this3.browserData = sortedBrowsers.map(function (p) {
          return p[1];
        });
        _this3.browserLabels = sortedBrowsers.map(function (p) {
          return p[0];
        });
        _this3.analytics.view_counts_by_os = Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["d" /* normalizeOSs */])(_this3.analytics.view_counts_by_os);

        var sortedOS = _(_this3.analytics.view_counts_by_os).pairs().sortBy(1).reverse().value();

        _this3.osData = sortedOS.map(function (p) {
          return p[1];
        });
        _this3.osLabels = sortedOS.map(function (p) {
          return p[0];
        });
        _this3.regionData = [];

        _.each(_this3.analytics.view_counts_by_region_code, function (count, code) {
          var label = Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["f" /* regionNameFromCode */])(code, _this3.regionDict);

          _this3.regionData.push({
            code: code,
            count: count,
            label: label
          });
        });

        _this3.regionData = _.sortBy(_this3.regionData, 'count');

        _this3.regionData.reverse();

        _this3.regionDataCount = 10;
        _this3.regionDataSlice = _this3.regionData.slice(0, _this3.regionDataCount);

        if (_this3.analytics.live_view_count || _this3.analytics.recorded_view_count) {
          var totalViewCount = _this3.analytics.live_view_count + _this3.analytics.recorded_view_count;
          _this3.liveData = [_this3.analytics.live_view_count / totalViewCount, _this3.analytics.recorded_view_count / totalViewCount];
        } else {
          _this3.liveData = null;
        }

        _this3.bubbleGraphRows = [];
        var maxWeekDayHourVal = 1;

        _.range(7).forEach(function (d, i) {
          var day = {
            dayIndex: d,
            hours: []
          };

          _.range(24).forEach(function (h, i) {
            var viewCount = (_this3.analytics.weekday_hourly_view_counts || [])[d * 24 + h] || 0;
            maxWeekDayHourVal = Math.max(viewCount, maxWeekDayHourVal);
            day.hours.push(viewCount);
          });

          _this3.bubbleGraphRows.push(day);
        });

        _this3.bubbleGraphScaleFactor = 0.05 * (100 / maxWeekDayHourVal); // compute comparison graph data structure

        _this3.viewsVsLabels = [];
        _this3.viewsVsTooltips = [];

        _.range(Math.max((_this3.analytics.daily_view_counts || []).length, _this3.analyticsCompare.daily_view_counts.length)).forEach(function (i) {
          var curr = moment(_this3.since).clone().add(i, 'day');
          var comp = moment(_this3.compareSince).clone().add(i, 'day');

          _this3.viewsVsLabels.push(curr);

          _this3.viewsVsTooltips.push("".concat(curr.format('ddd MMM Do'), " vs ").concat(comp.format('ddd MMM Do')));
        });

        _this3.viewsVsData = [[], //cululative count of current period
        [] //cumulative count of comparison period
        ];
        _this3.viewsVsOptions = {
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                unit: 'day',
                displayFormats: {
                  day: 'MMM Do'
                }
              },
              //categoryPercentage: 0.20, //1 every 5 labels
              gridLines: {
                display: false
              },
              position: 'bottom',
              ticks: {
                fontSize: 11,
                fontFamily: 'Arial, sans-serif',
                //maxRotation: 0,
                autoSkip: true
              }
            }] //yAxes: [{
            //  gridLines: { display: false }
            //}]

          },
          tooltips: {
            callbacks: {
              title: function title(items, data) {
                return _this3.viewsVsTooltips[items[0].index];
              }
            }
          }
        };
        var sum = 0;
        (_this3.analytics.daily_view_counts || []).forEach(function (c) {
          return _this3.viewsVsData[0].push(sum += c);
        });
        sum = 0;
        (_this3.analyticsCompare.daily_view_counts || []).forEach(function (c) {
          return _this3.viewsVsData[1].push(sum += c);
        }); // compute comparison stats

        _this3.analyticsCompare.total_view_count = _this3.analyticsCompare.live_view_count + _this3.analyticsCompare.recorded_view_count;
        _this3.analyticsCompare.total_view_duration = _this3.analyticsCompare.live_view_seconds + _this3.analyticsCompare.recorded_view_seconds;
        _this3.analyticsCompare.avg_view_duration = _this3.analyticsCompare.total_view_duration / _this3.analyticsCompare.total_view_count;

        _this3.computeAchievements();
      })["catch"](function (err) {
        console.error(err);
        toaster.pop('warning', 'Unable to load analytics. Please refresh the page and try again.');
      });
    } // downloadAnalytics handles click events from the "export analytics" link on the reports/viewer page.

  }, {
    key: "downloadAnalytics",
    value: function downloadAnalytics() {
      var _this4 = this;

      var account = this.account,
          report = this.report,
          id = this.id,
          Broadcast = this.Broadcast,
          Channel = this.Channel; // block download requests if: exports are not allowed (i.e. the date range exceeds the allowed limit);
      // or if an export is already in progress.

      if (!this.canExport() || this.isExporting) return; // designate that we're now actively processing an export request.

      this.isExporting = true;

      switch (report) {
        case 'broadcasts':
          this.broadcast = Broadcast.get({
            id: id
          }, function (broadcast) {
            if (_this4.datePreset == 'all_time') {
              _this4.since = moment(_this4.broadcast.starts_at);
              _this4.customSince = _this4.since.clone().toDate();
              _this4.since = _this4.since.toDate();
            }

            _this4.exportAnalytics(broadcast.channel_id);
          });
          break;

        case 'channels':
          Channel.get({
            id: id
          }, function (channel) {
            return _this4.selectedChannelName = channel.name;
          });
          this.exportAnalytics(id);
          break;

        default:
          this.exportAnalytics(account.channel_id);
          break;
      }
    } // exportAnalytics calls on the viewer_analytics_service to get detailed view analytics for the
    // currently-viewed analytics and prompts a csv file download.

  }, {
    key: "exportAnalytics",
    value: function exportAnalytics(channel_id) {
      var _this5 = this;

      var AnalyticsExportResource = this.AnalyticsExportResource,
          toaster = this.toaster; // TODO: configurable timezone
      // NOTE: the time portion is ignored by API, only the date is used, but we need the
      // time so that you can pass the timezone in. Time logic is: since <= date < until

      var params = {
        channel_id: channel_id,
        since: moment(this.since).local().set({
          h: 0,
          m: 0,
          s: 0,
          ms: 0
        }).format('YYYY-MM-DDTHH:mm:ssZ'),
        until: moment(this.until).clone().add(1, 'day').local().set({
          h: 0,
          m: 0,
          s: 0,
          ms: 0
        }).format('YYYY-MM-DDTHH:mm:ssZ')
      };
      AnalyticsExportResource.render(params, function (response) {
        // got our response, so the export is done processing.
        _this5.isExporting = false;
        var disposition = response.headers['content-disposition'];
        var filename = disposition.match(/filename=(\"?)(.+)\1/)[2];
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_download__["a" /* forceBrowserDownload */])(URL.createObjectURL(response.blob), filename);
      }, function (err) {
        // error, but the export is done processing.
        _this5.isExporting = false;
        console.error(err);
        toaster.pop('warning', 'Unable to export analytics', 'There was an issue exporting your analytics. Please reload and try again.');
      });
    }
  }, {
    key: "loadMoreRegionData",
    value: function loadMoreRegionData() {
      this.regionDataCount += 10;
      this.regionDataSlice = this.regionData.slice(0, this.regionDataCount);
    }
  }, {
    key: "computeAchievements",
    value: function computeAchievements() {
      this.achievements = {
        // was total view count over 1000?
        views_over_1000: this.analytics.total_view_count > 1000,
        // was total view count over 10000?
        views_over_10000: this.analytics.total_view_count > 10000,
        // were 75% of views from a single time-of-day & day-of-week combo?
        hotspot: Math.max(this.analytics.weekday_hourly_view_counts) > 0.75 * (this.analytics.weekday_hourly_view_counts || []).reduce(function (a, b) {
          return a + b;
        }, 0),
        // were more than 75% of views at 720 or 1080 quality?
        hifi: ((this.analytics.view_durations_by_quality || {})['720p'] || 0) + ((this.analytics.view_durations_by_quality || {})['1080p'] || 0) > 0.75 * this.analytics.total_view_count,
        // were live views more than 95% of total?
        do_it_live: this.analytics.live_view_count / this.analytics.total_view_count > 0.95,
        // was avg view duration at least 10 min?
        engaged: this.analytics.avg_view_duration > 10 * 60,
        // did total view count more than double compared to prior?
        daily_double: this.analytics.total_view_count > 2 * this.analyticsCompare.total_view_count,
        // multiple countries
        world_traveler: Object(__WEBPACK_IMPORTED_MODULE_1__utils_geo__["a" /* countCountries */])(this.analytics.view_counts_by_region_code) > 1
      };
    }
  }, {
    key: "bubbleGraphX",
    value: function bubbleGraphX(day, hr, hrIndex, dayIndex) {
      // based on 100x50 grid
      return 100 * ((day.dayIndex + 0.5) / 7);
    }
  }, {
    key: "bubbleGraphY",
    value: function bubbleGraphY(day, hr, hrIndex, dayIndex) {
      // based on 100x50 grid
      return 50 * ((hrIndex + 0.5) / 24);
    }
  }, {
    key: "bubbleGraphR",
    value: function bubbleGraphR(day, hr, hrIndex, dayIndex) {
      // based on 100x100 grid
      return Math.min(5, hr * this.bubbleGraphScaleFactor);
    }
  }, {
    key: "bubbleGraphTitle",
    value: function bubbleGraphTitle(day, hr, hrIndex, dayIndex) {
      var hrLabel;

      if (hrIndex > 12) {
        hrLabel = "".concat(hrIndex - 12, "pm");
      } else if (hrIndex == 12) {
        hrLabel = '12pm';
      } else if (hrIndex == 0) {
        hrLabel = '12am';
      } else {
        hrLabel = "".concat(hrIndex, "am");
      }

      var dayLabel = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'][dayIndex];
      return "".concat(hr, " (").concat(dayLabel, " at ").concat(hrLabel, ")");
    }
  }]);

  return ViewerAnalyticsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (ViewerAnalyticsController);

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\" ng-if=\"::vm.canReadDonations\">\n  <div class=\"col-xs-12\">\n    <div class=\"well\">\n      <p>This report lists recent donations to your account, sorted by date. BoxCast will issue your payments in\n      accordance with your contract terms.</p>\n\n      <div style=\"margin:15px 0\">\n        <span class=\"pull-right\" ng-show=\"vm.start && vm.end\">\n          Showing donations from {{vm.start|date}} - {{vm.end|date}}.\n        </span>\n        <div class=\"btn-group\">\n          <label class=\"btn btn-sm btn-default\" ng-click=\"vm.setTimePeriod(null)\" ng-model=\"vm.timePeriod\" uib-btn-radio=\"null\">All Time</label>\n          <label class=\"btn btn-sm btn-default\" ng-click=\"vm.setTimePeriod('this_q')\" ng-model=\"vm.timePeriod\" uib-btn-radio=\"'this_q'\">This Quarter</label>\n          <label class=\"btn btn-sm btn-default\" ng-click=\"vm.setTimePeriod('last_q')\" ng-model=\"vm.timePeriod\" uib-btn-radio=\"'last_q'\">Last Quarter</label>\n        </div>\n      </div>\n\n      <div ng-if=\"vm.donations.length == 0\" class=\"bg-info text-info\" style=\"padding:15px;margin-bottom:15px;border:1px solid;\">\n        <small>\n          No donations have been recorded for your account.\n          <a ui-sref=\"settings.overview\">You can enable donations on the account settings page</a>.\n        </small>\n      </div>\n\n      <div ng-if=\"vm.donations.length > 0\">\n\n        <!-- summary block -->\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <div class=\"well\">\n              <div class=\"row text-center\">\n                <div class=\"col-xs-6 col-sm-4\" style=\"border-right:1px solid #eee;\">\n                  <p style=\"font-weight:bold;\">Donation Count</p>\n                  <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.summary.count | number}}</h1>\n                  <p style=\"font-size:0.8em\">Number of donation transactions.</p>\n                </div>\n                <div class=\"col-xs-6 col-sm-4\" style=\"border-right:1px solid #eee;\">\n                  <p style=\"font-weight:bold;\">Gross Revenue</p>\n                  <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.summary.total | currency}}</h1>\n                  <p style=\"font-size:0.8em\">Total value of donations.</p>\n                </div>\n                <div class=\"col-xs-12 col-sm-4\">\n                  <p style=\"font-weight:bold;\">Net Proceeds</p>\n                  <h1 style=\"margin:0 0 10px;line-height:34px;\">{{((vm.summary.total - vm.summary.total_refund)*0.94) | currency}}</h1>\n                  <p style=\"font-size:0.8em\">\n                    Gross\n                    <span ng-if=\"vm.summary.total_refund\">minus {{vm.summary.count_refund}} refunds</span>\n                    minus 6% processing.\n                  </p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <p class=\"help-block\">\n          Showing results\n          {{vm.donationsPagination.resultMin}} -\n          {{vm.donationsPagination.resultMax}}\n          of {{vm.donationsPagination.total}}\n        </p>\n        <table class=\"table table-condensed\">\n          <thead>\n            <tr>\n              <th>Donor Name</th>\n              <th>Email</th>\n              <th>Address</th>\n              <th>Amount</th>\n              <th>Invoice</th>\n              <th>Date</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"d in vm.donations track by d.id\">\n              <td>{{::d.name}}</td>\n              <td>{{::d.email}}</td>\n              <td>\n                <em ng-hide=\"::(d.address || d.city || d.state || d.zip)\" style=\"opacity:0.5\">\n                  Not entered\n                </em>\n                <span ng-show=\"::(d.address || d.city || d.state || d.zip)\">\n                  {{::d.address}}<br>\n                  {{::d.city}}, {{::d.state}} {{::d.zip}}\n                </span>\n              </td>\n              <td class=\"text-right\">\n                <span ng-show=\"::d.is_refunded\">\n                  <strike>${{::d.amount|number:2}}</strike>\n                  <span class=\"label label-default\">Refunded</span>\n                </span>\n                <span ng-hide=\"::d.is_refunded\">\n                  ${{::d.amount|number:2}}\n                </span>\n              </td>\n              <td>{{::d.invoice_handle}}</td>\n              <td>{{::d.created_at|date}}</td>\n            </tr>\n          </tbody>\n        </table>\n        <uib-pagination ng-if=\"vm.donationsPagination.total > 20\"\n                        total-items=\"vm.donationsPagination.total\"\n                        items-per-page=\"20\"\n                        max-size=\"10\"\n                        rotate=\"false\"\n                        class=\"pagination-sm\"\n                        ng-model=\"vm.donationsPagination.current\"\n                        ng-change=\"vm.loadDonationsForPage(vm.donationsPagination.current)\"></uib-pagination>\n      </div>\n    </div>\n  </div>\n</div>\n\n"

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PAGE_SIZE = 20;

var DonationsController = /*#__PURE__*/function () {
  function DonationsController($rootScope, Donation, toaster) {
    'ngInject';

    _classCallCheck(this, DonationsController);

    this.Donation = Donation;
    this.account = $rootScope.account;
    this.toaster = toaster;
    this.canReadDonations = $rootScope.user.can('read', 'donations:summary');

    if (!this.canReadDonations) {
      return;
    }

    this.loadingPromises = [];
    this.setTimePeriod(null); //start at "all time"
  }

  _createClass(DonationsController, [{
    key: "setTimePeriod",
    value: function setTimePeriod(value) {
      // moment.month gives 0-11
      // we'll translate into quarter number 1-4
      var currentQuarterNumber = Math.ceil((moment().month() + 1) / 3);
      var startMonth = (currentQuarterNumber - 1) * 3;
      var endMonth = currentQuarterNumber * 3 - 1;

      if (value == 'this_q') {
        this.timePeriod = value;
        this.start = moment().month(startMonth).startOf('month').toDate();
        this.end = moment().month(endMonth).endOf('month').toDate();
      } else if (value == 'last_q') {
        this.timePeriod = value;
        this.start = moment().month(startMonth).subtract(3, 'months').startOf('month').toDate();
        this.end = moment().month(endMonth).subtract(3, 'months').endOf('month').toDate();
      } else {
        this.timePeriod = null;
        this.start = null;
        this.end = null;
      }

      this.loadDonationsForPage(1);
    }
  }, {
    key: "loadDonationsForPage",
    value: function loadDonationsForPage(p) {
      var _this = this;

      var Donation = this.Donation,
          account = this.account,
          toaster = this.toaster;
      var q = undefined;

      if (this.start && this.end) {
        q = "created_at:[".concat(this.start.toISOString(), " TO ").concat(this.end.toISOString(), "]");
      }

      var donations = Donation.query({
        q: q,
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: '-created_at'
      }, function (data, headers) {
        _this.donations = data;
        var pagination = JSON.parse(headers('x-pagination'));
        _this.donationsPagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + data.length
        };
      }, function (err) {
        toaster.pop('warning', 'Unable to load donations. Please refresh the page and try again.');
      });
      this.summary = Donation.summary({
        q: q
      });
      this.loadingPromises.push(donations.$promise);
      this.loadingPromises.push(this.summary.$promise);
    }
  }]);

  return DonationsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (DonationsController);

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports = "<div class=\"analytics row\" ng-if=\"::(!vm.FeatureFlags.no_ticketed && vm.canReadTicketSummaries)\">\n  <div class=\"col-xs-12\">\n    <div class=\"well\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...'}\">\n\n      <ol class=\"breadcrumb\" ng-if=\"vm.report\">\n        <li>\n          <a ui-sref=\"reports.tickets({report: null, id: null})\">Ticket Reports</a>\n        </li>\n        <li ng-if=\"vm.report && vm.report != 'account'\" ng-class=\"vm.report && !vm.id ? 'active' : ''\">\n          <a ui-sref=\"reports.tickets({report: vm.report, id: null})\">{{vm.reportName}}</a>\n        </li>\n        <li ng-if=\"vm.report && vm.report != 'account' && vm.id\" ng-class=\"vm.report && vm.id ? 'active' : ''\">\n          <a ui-sref=\"reports.tickets({report: vm.report, id: vm.id})\">{{vm.entity.name}}</a>\n        </li>\n        <li ng-if=\"vm.report == 'account'\" ng-class=\"active\">\n          {{vm.reportName}}\n        </li>\n      </ol>\n\n      <!-- No report type selected yet -->\n      <div ng-if=\"!vm.report\">\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-6\" style=\"margin-bottom:30px\">\n            <p>Select the report you would like to view.</p>\n            <div style=\"max-width: 350px\">\n              <a ui-sref=\"reports.tickets({report: 'account', id: 'broadcast'})\" class=\"btn btn-primary btn-block\" style=\"text-align:left\">\n                <div><small><i class=\"fa fa-ticket\"></i> Ticket Purchase Report</small></div>\n                <span class=\"font-bold\">All Single Broadcast Tickets</span>\n                <i class=\"pull-right fa fa-caret-right\" style=\"position:relative;top:-9px;\"></i>\n              </a>\n            </div>\n            <div style=\"max-width: 350px; margin-top:15px;\">\n              <a ui-sref=\"reports.tickets({report: 'account', id: 'channel'})\" class=\"btn btn-primary btn-block\" style=\"text-align:left\">\n                <div><small><i class=\"fa fa-ticket\"></i> Ticket Purchase Report</small></div>\n                <span class=\"font-bold\">All Channel Tickets</span>\n                <i class=\"pull-right fa fa-caret-right\" style=\"position:relative;top:-9px;\"></i>\n              </a>\n            </div>\n            <div style=\"max-width: 350px; margin-top:15px;\">\n              <a ui-sref=\"reports.tickets({report: 'broadcasts'})\" class=\"btn btn-primary btn-block\" style=\"text-align:left\">\n                <div><small><i class=\"fa fa-ticket\"></i> Ticket Purchase Report</small></div>\n                <span class=\"font-bold\">Single Broadcast Tickets By Broadcast</span>\n                <i class=\"pull-right fa fa-caret-right\" style=\"position:relative;top:-9px;\"></i>\n              </a>\n            </div>\n            <div style=\"max-width: 350px; margin-top:15px;\">\n              <a ui-sref=\"reports.tickets({report: 'channels'})\" class=\"btn btn-primary btn-block\" style=\"text-align:left\">\n                <div><small><i class=\"fa fa-ticket\"></i> Ticket Purchase Report</small></div>\n                <span class=\"font-bold\">Channel Tickets By Channel</span>\n                <i class=\"pull-right fa fa-caret-right\" style=\"position:relative;top:-9px;\"></i>\n              </a>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-sm-6\">\n            <p class=\"text-center\"><strong>Recent Ticket Purchases</strong></p>\n            <canvas height=\"200\"\n                class=\"chart chart-line\"\n                chart-data=\"vm.ticketsGraphData\"\n                chart-labels=\"vm.ticketsGraphLabels\"\n                chart-options=\"vm.ticketsGraphOptions\"\n                chart-series=\"['Single Broadcast Ticket Count', 'Channel Ticket Count']\"></canvas>\n          </div>\n        </div>\n      </div>\n\n      <!-- No specific broadcast/channel selected yet -->\n      <div ng-if=\"vm.report == 'broadcasts' && !vm.id\">\n        <p>Select the broadcast you would like to view.</p>\n\n        <table class=\"table table-condensed table-hover\">\n          <thead>\n            <tr>\n              <th>Name</th>\n              <th>Date/Time</th>\n              <th>Accessibility</th>\n              <th class=\"hidden-xs\">Sold Count</th>\n              <th class=\"hidden-xs\">Sold Total</th>\n              <th></th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"broadcast in vm.broadcasts track by broadcast.id\"\n                ng-click=\"$state.go('reports.tickets', {report: vm.report, id: broadcast.id})\">\n              <th>{{broadcast.name}}</th>\n              <td><date-range start=\"broadcast.starts_at\" end=\"broadcast.stops_at\"></date-range></td>\n              <td>\n                <span ng-if=\"broadcast.is_ticketed\" class=\"label label-success\">${{broadcast.ticket_price | number:2}} / ticket</span>\n                <span ng-if=\"broadcast.is_private\" class=\"label label-danger\">Private</span>\n                <span ng-if=\"!broadcast.is_ticketed && !broadcast.is_private\" class=\"label label-default\">Public</span>\n              </td>\n              <td class=\"hidden-xs text-right\">\n                <strong>{{broadcast.sold_ticket_count | number}}</strong>\n              </td>\n              <td class=\"hidden-xs text-right\">\n                <strong>{{broadcast.sold_ticket_total | currency}}</strong>\n              </td>\n              <td class=\"text-right\">\n                <a class=\"small-link\"><i class=\"fa fa-list\"></i> View Report</a>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        <uib-pagination ng-if=\"vm.broadcastsPagination.total > 20\"\n                        total-items=\"vm.broadcastsPagination.total\"\n                        items-per-page=\"20\"\n                        max-size=\"10\"\n                        rotate=\"false\"\n                        class=\"pagination-sm\"\n                        ng-model=\"vm.broadcastsPagination.current\"\n                        ng-change=\"vm.loadBroadcastsForPage(vm.broadcastsPagination.current)\"></uib-pagination>\n      </div>\n      <div ng-if=\"vm.report == 'channels' && !vm.id\">\n        <p>Select the channel you would like to view.</p>\n\n        <table class=\"table table-condensed table-hover\">\n          <thead>\n            <tr>\n              <th>Name</th>\n              <th>Accessibility</th>\n              <th></th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"channel in vm.channels track by channel.id\"\n                ng-click=\"$state.go('reports.tickets', {report: vm.report, id: channel.id})\">\n              <th>{{channel.name}}</th>\n              <td>\n                <span ng-if=\"channel.is_ticketed\" class=\"label label-success\">${{channel.ticket_price | number:2}} / ticket</span>\n                <span ng-if=\"!channel.is_ticketed\" class=\"label label-default\">Public</span>\n              </td>\n              <td class=\"text-right\">\n                <a class=\"small-link\"><i class=\"fa fa-list\"></i> View Report</a>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        <uib-pagination ng-if=\"vm.channelsPagination.total > 20\"\n                        total-items=\"vm.channelsPagination.total\"\n                        items-per-page=\"20\"\n                        max-size=\"10\"\n                        rotate=\"false\"\n                        class=\"pagination-sm\"\n                        ng-model=\"vm.channelsPagination.current\"\n                        ng-change=\"vm.loadChannelsForPage(vm.channelsPagination.current)\"></uib-pagination>\n      </div>\n\n      <!-- Show ticket list -->\n      <div ng-if=\"vm.report && vm.id\">\n        <p>This report lists recent ticket purchases, sorted by date. BoxCast will issue your payments in\n        accordance with your contract terms.</p>\n\n        <div style=\"margin:15px 0\">\n          <span class=\"pull-right\" ng-show=\"vm.start && vm.end\">\n            Showing tickets from {{vm.start|date}} - {{vm.end|date}}.\n          </span>\n          <div class=\"btn-group\">\n            <label class=\"btn btn-sm btn-default\" ng-click=\"vm.setTimePeriod(null)\" ng-model=\"vm.timePeriod\" uib-btn-radio=\"null\">All Time</label>\n            <label class=\"btn btn-sm btn-default\" ng-click=\"vm.setTimePeriod('this_q')\" ng-model=\"vm.timePeriod\" uib-btn-radio=\"'this_q'\">This Quarter</label>\n            <label class=\"btn btn-sm btn-default\" ng-click=\"vm.setTimePeriod('last_q')\" ng-model=\"vm.timePeriod\" uib-btn-radio=\"'last_q'\">Last Quarter</label>\n          </div>\n        </div>\n\n        <div class=\"row\" style=\"margin-bottom:15px\">\n          <div class=\"col-sm-12\">\n            <div class=\"well\">\n              <div class=\"row text-center\">\n                <div class=\"col-xs-6 col-sm-4\" style=\"border-right:1px solid #eee;\">\n                  <p style=\"font-weight:bold;\">Total Tickets Sold</p>\n                  <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.summary.count | number}}</h1>\n                  <p style=\"font-size:0.8em\">Count of tickets sold for all time.</p>\n                </div>\n                <div class=\"col-xs-6 col-sm-4\" style=\"border-right:1px solid #eee;\">\n                  <p style=\"font-weight:bold;\">Gross Ticket Revenue</p>\n                  <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.summary.total | currency}}</h1>\n                  <p style=\"font-size:0.8em\">Total value of tickets sold for all time.</p>\n                </div>\n                <div class=\"col-xs-12 col-sm-4\">\n                  <p style=\"font-weight:bold;\">Gross Minus Refunds</p>\n                  <h1 style=\"margin:0 0 10px;line-height:34px;\">{{(vm.summary.total - vm.summary.total_refund) | currency}}</h1>\n                  <p style=\"font-size:0.8em\">\n                    Gross ticket revenue minus {{vm.summary.count_refund}} refunds.</span>\n                  </p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.tickets.length == 0\" class=\"bg-info text-info\" style=\"padding:15px;margin-bottom:15px;border:1px solid;\">\n          <small>\n            No tickets recorded for {{vm.entity.name}}.\n          </small>\n        </div>\n\n        <div ng-if=\"vm.tickets.length > 0\">\n          <p class=\"help-block\">\n            Showing results\n            {{vm.ticketsPagination.resultMin}} -\n            {{vm.ticketsPagination.resultMax}}\n            of {{vm.ticketsPagination.total}}\n          </p>\n          <table class=\"table table-condensed\">\n            <thead>\n              <tr>\n                <th>Name</th>\n                <th>Email</th>\n                <th ng-if=\"vm.id == 'broadcast'\">Broadcast</th>\n                <th ng-if=\"vm.id == 'channel'\">Channel</th>\n                <th>Price</th>\n                <th>Invoice</th>\n                <th>Date</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"d in vm.tickets track by d.id\">\n                <td>{{d.name}}</td>\n                <td>{{d.email_masked}}</td>\n                <td ng-if=\"vm.id == 'broadcast'\">{{d.broadcast_name}}</td>\n                <td ng-if=\"vm.id == 'channel'\">{{d.channel_name}}</td>\n                <td class=\"text-right\">\n                  <span ng-show=\"d.is_refunded\">\n                    <strike>${{d.price|number:2}}</strike>\n                    <span class=\"label label-default\">Refunded</span>\n                  </span>\n                  <span ng-hide=\"d.is_refunded\">\n                    ${{d.price|number:2}}\n                  </span>\n                </td>\n                <td>{{d.invoice_handle}}</td>\n                <td>{{d.created_at|date}}</td>\n              </tr>\n            </tbody>\n          </table>\n          <uib-pagination ng-if=\"vm.ticketsPagination.total > 20\"\n                          total-items=\"vm.ticketsPagination.total\"\n                          items-per-page=\"20\"\n                          max-size=\"10\"\n                          rotate=\"false\"\n                          class=\"pagination-sm\"\n                          ng-model=\"vm.ticketsPagination.current\"\n                          ng-change=\"vm.loadTicketsForPage(vm.ticketsPagination.current)\"></uib-pagination>\n        </div>\n      </div>\n\n\n    </div>\n  </div>\n</div>\n\n"

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PAGE_SIZE = 20;

var TicketsController = /*#__PURE__*/function () {
  function TicketsController($state, $q, toaster, Ticket, Channel, Broadcast, $rootScope) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, TicketsController);

    this.toaster = toaster;
    this.Ticket = Ticket;
    this.Channel = Channel;
    this.Broadcast = Broadcast;
    this.$q = $q;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.canReadTicketSummaries = $rootScope.user.can('read', 'broadcast/*:tickets:summary') && $rootScope.user.can('read', 'channel/*:tickets:summary') && $rootScope.user.can('read', 'tickets:summary');

    if (this.FeatureFlags.no_ticketed || !this.canReadTicketSummaries) {
      return;
    }

    this.report = $state.params.report;
    this.id = $state.params.id;
    this.account = $rootScope.account;
    this.timePeriod = null;
    this.loadingPromises = [];

    switch (this.report) {
      case 'broadcasts':
        this.reportName = 'Single Broadcast';

        if (this.id) {
          Broadcast.get({
            id: this.id
          }, function (obj) {
            return _this.entity = obj;
          });
          this.loadTicketsForPage(1);
        } else {
          this.loadBroadcastsForPage(1);
        }

        break;

      case 'channels':
        this.reportName = 'Channel';

        if (this.id) {
          Channel.get({
            id: this.id
          }, function (obj) {
            return _this.entity = obj;
          });
          this.loadTicketsForPage(1);
        } else {
          this.loadChannelsForPage(1);
        }

        break;

      case 'account':
        this.entity = this.account;

        if (this.id == 'channel') {
          this.reportName = 'All Channel Tickets';
        } else {
          this.reportName = 'All Broadcast Tickets';
        }

        this.loadTicketsForPage(1);
        break;

      default:
        this.loadGraph();
    }
  }

  _createClass(TicketsController, [{
    key: "loadGraph",
    value: function loadGraph() {
      var _this2 = this;

      var Ticket = this.Ticket,
          $q = this.$q;
      var NUM_DAYS = 30;
      var start = moment().subtract(NUM_DAYS, 'day');
      var end = moment();
      var q = "created_at:[".concat(start.toISOString(), " TO ").concat(end.toISOString(), "]");
      var p1 = Ticket.queryAll({
        type: 'broadcast',
        l: 1000,
        s: '-created_at',
        q: q
      });
      var p2 = Ticket.queryAll({
        type: 'channel',
        l: 1000,
        s: '-created_at',
        q: q
      });
      $q.all([p1, p2]).then(function (results) {
        var tickets = results[0];
        var channelTickets = results[1];
        _this2.ticketsByDay = _.groupBy(tickets, function (t) {
          return moment(t.created_at).format('YYYY-MM-DD');
        });
        _this2.channelTicketsByDay = _.groupBy(channelTickets, function (t) {
          return moment(t.created_at).format('YYYY-MM-DD');
        });
        _this2.ticketsGraphLabels = [];
        _this2.ticketsGraphTooltips = [];
        _this2.ticketsGraphData = [[], //daily count of broadcast tickets
        [] //daily count of channel tickets
        ];

        _.range(NUM_DAYS - 1, -1, -1).forEach(function (i) {
          var dt = moment().clone().subtract(i, 'day');
          var dtf = dt.format('YYYY-MM-DD');

          _this2.ticketsGraphLabels.push(dt);

          _this2.ticketsGraphTooltips.push("Tickets sold on ".concat(dt.format('ddd MMM Do')));

          _this2.ticketsGraphData[0].push((_this2.ticketsByDay[dtf] || {}).length || 0);

          _this2.ticketsGraphData[1].push((_this2.channelTicketsByDay[dtf] || {}).length || 0);
        });

        _this2.ticketsGraphOptions = {
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                unit: 'day',
                displayFormats: {
                  day: 'MMM Do'
                }
              },
              //categoryPercentage: 0.20, //1 every 5 labels
              gridLines: {
                display: false
              },
              position: 'bottom',
              ticks: {
                fontSize: 11,
                fontFamily: 'Arial, sans-serif',
                //maxRotation: 0,
                autoSkip: true
              }
            }],
            yAxes: [{
              ticks: {
                min: 0,
                beginAtZero: true,
                suggestedMax: 10
              }
            }]
          },
          tooltips: {
            callbacks: {
              title: function title(items, data) {
                return _this2.ticketsGraphTooltips[items[0].index];
              }
            }
          }
        };
      });
    }
  }, {
    key: "loadBroadcastsForPage",
    value: function loadBroadcastsForPage(p) {
      var _this3 = this;

      var Broadcast = this.Broadcast,
          toaster = this.toaster;
      var query = Broadcast.query({
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: '-starts_at'
      }, function (data, headers) {
        _this3.broadcasts = data;
        var pagination = JSON.parse(headers('x-pagination'));
        _this3.broadcastsPagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + data.length
        };
      }, function (err) {
        toaster.pop('warning', 'Unable to load broadcasts. Please refresh the page and try again.');
      });
      this.loadingPromises.push(query.$promise);
      if (p > 1) window.scrollTo(0, 0);
    }
  }, {
    key: "loadChannelsForPage",
    value: function loadChannelsForPage(p) {
      var _this4 = this;

      var Channel = this.Channel,
          toaster = this.toaster;
      var query = Channel.query({
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: 'name'
      }, function (data, headers) {
        _this4.channels = data;
        var pagination = JSON.parse(headers('x-pagination'));
        _this4.channelsPagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + data.length
        };
      }, function (err) {
        toaster.pop('warning', 'Unable to load channels. Please refresh the page and try again.');
      });
      this.loadingPromises.push(query.$promise);
      if (p > 1) window.scrollTo(0, 0);
    }
  }, {
    key: "loadTicketsForPage",
    value: function loadTicketsForPage(p) {
      var _this5 = this;

      var Ticket = this.Ticket,
          toaster = this.toaster;
      var params = {
        resource: this.report,
        id: this.id
      };

      if (params.resource == 'account') {
        params.type = this.id; //type=channel or type=broadcast passed as querystring

        delete params.resource;
        delete params.id;
      }

      if (this.start && this.end) {
        params.q = "created_at:[".concat(this.start.toISOString(), " TO ").concat(this.end.toISOString(), "]");
      }

      var query = Ticket.query(angular.extend({}, params, {
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: '-created_at'
      }), function (data, headers) {
        _this5.tickets = data;
        var pagination = JSON.parse(headers('x-pagination'));
        _this5.ticketsPagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + data.length
        };
      }, function (err) {
        toaster.pop('warning', 'Unable to load tickets. Please refresh the page and try again.');
      });
      this.summary = Ticket.summary(params);
      this.loadingPromises.push(query.$promise);
      this.loadingPromises.push(this.summary.$promise);
      if (p > 1) window.scrollTo(0, 0);
    }
  }, {
    key: "setTimePeriod",
    value: function setTimePeriod(value) {
      // moment.month gives 0-11
      // we'll translate into quarter number 1-4
      var currentQuarterNumber = Math.ceil((moment().month() + 1) / 3);
      var startMonth = (currentQuarterNumber - 1) * 3;
      var endMonth = currentQuarterNumber * 3 - 1;

      if (value == 'this_q') {
        this.timePeriod = value;
        this.start = moment().month(startMonth).startOf('month').toDate();
        this.end = moment().month(endMonth).endOf('month').toDate();
      } else if (value == 'last_q') {
        this.timePeriod = value;
        this.start = moment().month(startMonth).subtract(3, 'months').startOf('month').toDate();
        this.end = moment().month(endMonth).subtract(3, 'months').endOf('month').toDate();
      } else {
        this.timePeriod = null;
        this.start = null;
        this.end = null;
      }

      this.loadTicketsForPage(1);
    }
  }]);

  return TicketsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (TicketsController);

/***/ }),
/* 443 */
/***/ (function(module, exports) {

angular.module('app.pages.reports').component('achievementsCell', {
  bindings: {
    enabled: '<',
    name: '@',
    description: '@'
  },
  template: "\n      <div ng-class=\"$ctrl.enabled ? 'unlocked' : 'locked'\">\n        <i ng-if=\"!$ctrl.enabled\" class=\"fa fa-4x fa-trophy\"></i>\n        <i ng-if=\"$ctrl.enabled\" class=\"fa fa-4x fa-trophy\" uib-tooltip=\"{{$ctrl.description}}\" tooltip-append-to-body=\"true\"></i>\n        <label ng-if=\"$ctrl.enabled\" uib-tooltip=\"{{$ctrl.description}}\" tooltip-append-to-body=\"true\">{{$ctrl.name}}</label>\n        <label ng-if=\"!$ctrl.enabled\">&nbsp;</label>\n      </div>\n    "
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rtmp_push_channels__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appearance__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wifi_configuration_service__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(452);



 // The `wire` helper only deals with simple states. We need to add the
// detail sub-states as well, so we'll just do it by hand here.

var module = angular.module('settings', []);
module.service('WifiConfigurationService', __WEBPACK_IMPORTED_MODULE_2__wifi_configuration_service__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* default */])(module);
module.config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('settings', {
    url: '/settings',
    template: __webpack_require__(453),
    "abstract": true,
    controllerAs: 'vm'
  }).state('settings.appearance', {
    url: '/appearance',
    template: __webpack_require__(454),
    controller: __WEBPACK_IMPORTED_MODULE_1__appearance__["a" /* default */],
    controllerAs: 'vm'
  }).state('settings.integrations', {
    url: '/integrations?integration_id',
    template: __webpack_require__(455),
    controller: __webpack_require__(456)["default"],
    controllerAs: 'vm'
  }).state('settings.facebook', {
    url: '/facebook',
    template: __webpack_require__(460),
    controller: __webpack_require__(461)["default"],
    controllerAs: 'vm'
  }).state('settings.youtube', {
    url: '/youtube?code&error&link',
    template: __webpack_require__(462),
    controller: __webpack_require__(463)["default"],
    controllerAs: 'vm'
  }).state('settings.vimeo', {
    url: '/vimeo?code&link',
    template: __webpack_require__(464),
    controller: __webpack_require__(465)["default"],
    controllerAs: 'vm'
  }).state('settings.payment', {
    url: '/payment?pd_did&pd_sid&show_orders&action',
    template: __webpack_require__(466),
    controller: __webpack_require__(467)["default"],
    controllerAs: 'vm'
  }).state('settings.twitter', {
    url: '/twitter?link',
    template: __webpack_require__(475),
    controller: __webpack_require__(476)["default"],
    controllerAs: 'vm'
  }).state('settings.rtmp_destinations', {
    url: '/rtmp-push-channels',
    template: __webpack_require__(477),
    controller: __WEBPACK_IMPORTED_MODULE_0__rtmp_push_channels__["a" /* default */],
    controllerAs: 'vm'
  }).state('settings.upgrade', {
    url: '/upgrade?pd_did&pd_sid',
    // The upgrade page is deprecated, but there still may be links our there to it
    // Redirect to the payment page
    controller: function controller($state) {
      'ngInject';

      $state.go('settings.payment', $state.params);
    }
  }) // Migrated pages to dashboard_vue
  .state('settings.overview', {
    url: '/',
    template: "",
    controller: function controller() {
      return window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/settings/preferences"));
    }
  }).state('settings.my_account', {
    url: '/my-account?password_changed',
    template: "",
    controller: function controller() {
      return window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/settings/my-account"));
    }
  }).state('settings.users', {
    url: '/users',
    template: "",
    controller: function controller() {
      return window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/settings/users"));
    }
  }).state('settings.storage', {
    url: '/storage',
    template: '',
    controller: function controller() {
      return window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/settings/storage"));
    }
  }).state('settings.api_keys', {
    url: '/api-keys',
    template: "",
    controller: function controller() {
      return window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/settings/api-keys"));
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RTMPPushChannelsController = /*#__PURE__*/_createClass(function RTMPPushChannelsController($state) {
  'ngInject';

  _classCallCheck(this, RTMPPushChannelsController);

  $state.go('settings.integrations');
});

/* harmony default export */ __webpack_exports__["a"] = (RTMPPushChannelsController);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SettingsAppearanceController; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var APPLE_CATEGORIES = ['Books', 'Business', 'Developer Tools', 'Education', 'Entertainment', 'Finance', 'Food & Drink', 'Games', 'Graphics & Design', 'Health & Fitness', 'Lifestyle', 'Magazines & Newspapers', 'Medical', 'Music', 'Navigation', 'News', 'Photo & Video', 'Productivity', 'Reference', 'Shopping', 'Social Networking', 'Sports', 'Stickers', 'Travel', 'Utilities', 'Weather'];
var ROKU_CATEGORIES = ['Animals & Pets', 'Apps', 'Cars & Motorcycles', 'Classic TV', 'Comedy', 'Crime & Mystery', 'Drama', 'Educational', 'eSports & Gaming', 'Faith-Based', 'Food & Home', 'Games', 'Health & Wellness', 'How To', 'International', 'Kids & Family', 'Lifestyle', 'Local News', 'Movies & TV', 'Music', 'News', 'Personal Media', 'Photo Apps', 'Premium Services', 'Reality & Pop Culture', 'Relaxation & Meditation', 'Rent/Buy Movies', 'Sci & Tech', 'Screensavers', 'Shopping', 'Special Interest', 'Sports', 'Subscription Channels', 'TV en Español', 'Travel', 'Watch With Cable', 'Weather', 'Web Video'];

var SettingsAppearanceController = /*#__PURE__*/function () {
  function SettingsAppearanceController(Account, Broadcast, $rootScope, $uibModal, $q, toaster, AppleTvApp, RokuApp) {
    'ngInject';

    _classCallCheck(this, SettingsAppearanceController);

    this.Account = Account;
    this.Broadcast = Broadcast;
    this.$uibModal = $uibModal;
    this.$q = $q;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.canEditAccountSettings = $rootScope.user.can('update', 'account');
    this.toaster = toaster;
    this.AppleTvApp = AppleTvApp;
    this.RokuApp = RokuApp;
    this.refresh();
  }

  _createClass(SettingsAppearanceController, [{
    key: "rokuImageList",
    value: function rokuImageList() {
      if (!this.rokuApp) {
        return null;
      }

      if (this._rokuImageList) {
        return this._rokuImageList;
      }

      var r = this.rokuApp;
      this._rokuImageList = [{
        id: 'logo',
        name: 'Logo',
        src: r.logo,
        noValidate: true,
        preview_w: 300,
        preview_h: 100
      }, {
        id: 'icon',
        name: 'App Icon',
        src: r.icon,
        w: 540,
        h: 405,
        preview_w: 180,
        preview_h: 135
      }, {
        id: 'channel_store_icon_fhd',
        name: 'Store Icon Full HD',
        src: r.channel_store_icon_fhd,
        w: 540,
        h: 405,
        preview_w: 180,
        preview_h: 135
      }, {
        id: 'channel_store_icon_large',
        name: 'Store Icon Large',
        src: r.channel_store_icon_large,
        w: 336,
        h: 210,
        preview_w: 168,
        preview_h: 105
      }, {
        id: 'channel_store_icon_small',
        name: 'Store Icon Small',
        src: r.channel_store_icon_small,
        w: 246,
        h: 140,
        preview_w: 123,
        preview_h: 70
      }, {
        id: 'splash_screen_fhd',
        name: 'Splash Full HD',
        src: r.splash_screen_fhd,
        w: 1920,
        h: 1080,
        preview_w: 384,
        preview_h: 216
      }, {
        id: 'splash_screen_hd',
        name: 'Splash Large',
        src: r.splash_screen_hd,
        w: 1280,
        h: 720,
        preview_w: 240,
        preview_h: 135
      }, {
        id: 'splash_screen_sd',
        name: 'Splash Small',
        src: r.splash_screen_sd,
        w: 720,
        h: 480,
        preview_w: 162,
        preview_h: 108
      }];
      return this._rokuImageList;
    }
  }, {
    key: "appleTVImageList",
    value: function appleTVImageList() {
      if (!this.appleTVApp) {
        return null;
      }

      if (this._appleTVImageList) {
        return this._appleTVImageList;
      }

      var a = this.appleTVApp;
      this._appleTVImageList = [{
        id: 'app_icon_background_layer',
        name: 'App Icon Background',
        src: a.app_icon_background_layer,
        w: 1280,
        h: 768,
        preview_w: 360,
        preview_h: 216
      }, {
        id: 'app_icon_foreground_layer',
        name: 'App Icon Foreground',
        src: a.app_icon_foreground_layer,
        w: 1280,
        h: 768,
        preview_w: 360,
        preview_h: 216
      }, {
        id: 'app_icon_small_background_layer_2x',
        name: 'App Icon Small Background',
        src: a.app_icon_small_background_layer_2x,
        w: 800,
        h: 480,
        preview_w: 180,
        preview_h: 108
      }, {
        id: 'app_icon_small_foreground_layer_2x',
        name: 'App Icon Small Foreground',
        src: a.app_icon_small_foreground_layer_2x,
        w: 800,
        h: 480,
        preview_w: 180,
        preview_h: 108
      }, {
        id: 'launch_image',
        name: 'Launch Image',
        src: a.launch_image,
        w: 1920,
        h: 1080,
        preview_w: 384,
        preview_h: 216
      }, {
        id: 'top_shelf_image_2x',
        name: 'Top Shelf Image',
        src: a.top_shelf_image_2x,
        w: 3840,
        h: 1440,
        preview_w: 317,
        preview_h: 119
      }, {
        id: 'top_shelf_wide_image_2x',
        name: 'Top Shelf Wide Image',
        src: a.top_shelf_wide_image_2x,
        w: 4640,
        h: 1440,
        preview_w: 384,
        preview_h: 119
      }];
      return this._appleTVImageList;
    }
  }, {
    key: "statusText",
    value: function statusText(app) {
      if (app && app.status) {
        return {
          waiting_on_customer: 'Waiting for Your Submission',
          submitted_to_boxcast: 'In Development',
          submitted_for_review: 'In Review',
          released: 'Released',
          removed: 'Removed'
        }[app.status] || 'Unknown';
      }

      return 'Unknown';
    }
  }, {
    key: "statusLabelLevel",
    value: function statusLabelLevel(app) {
      if (app && app.status) {
        return {
          waiting_on_customer: 'warning',
          submitted_to_boxcast: 'info',
          submitted_for_review: 'info',
          released: 'success',
          removed: 'danger'
        }[app.status] || 'default';
      }

      return 'default';
    }
  }, {
    key: "statusLabelTooltip",
    value: function statusLabelTooltip(app) {
      if (app && app.status) {
        return {
          waiting_on_customer: 'Configure your organization\'s app information and images by selecting "Edit Information". When complete, click "Submit to BoxCast".',
          submitted_to_boxcast: "Your organization's information has been sent, and your app is being built by BoxCast.",
          submitted_for_review: "Your organization's app has been submitted for review.",
          released: "Your organization's app is live.",
          removed: "Your organization's app has been removed."
        }[app.status] || '';
      }

      return '';
    }
  }, {
    key: "allAppleTVFieldsSet",
    value: function allAppleTVFieldsSet() {
      return hasAllFieldsSet(this.appleTVApp, ['apple_developer_account_name', 'name', 'subtitle', 'category', 'promotional_text', 'keywords', 'description', 'app_icon_background_layer', 'app_icon_foreground_layer', 'app_icon_small_background_layer_2x', 'app_icon_small_foreground_layer_2x', 'launch_image', 'top_shelf_image_2x', 'top_shelf_wide_image_2x']);
    }
  }, {
    key: "updateAppleTVAppReadyToSubmit",
    value: function updateAppleTVAppReadyToSubmit() {
      if (this.appleTVApp) {
        this.appleTVApp._ready_to_submit = this.allAppleTVFieldsSet() && !this.needPublicRecordedBroadcasts;
      }
    }
  }, {
    key: "allRokuFieldsSet",
    value: function allRokuFieldsSet() {
      return hasAllFieldsSet(this.rokuApp, ['roku_developer_account_name', 'channel_name', 'channel_description', 'web_description', 'category', 'more_information_url', 'splash_screen_fhd', 'splash_screen_hd', 'splash_screen_sd', 'channel_store_icon_fhd', 'channel_store_icon_large', 'channel_store_icon_small', 'logo', 'icon']);
    }
  }, {
    key: "updateRokuAppReadyToSubmit",
    value: function updateRokuAppReadyToSubmit() {
      if (this.rokuApp) {
        this.rokuApp._ready_to_submit = this.allRokuFieldsSet() && !this.needPublicRecordedBroadcasts;
      }
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var _this = this;

      this.account = this.Account.get();
      var appleTVPromise = this.AppleTvApp.query({
        s: '-created_at',
        l: 1
      }).$promise.then(function (result) {
        if (result && result.length) {
          _this.appleTVApp = _this.AppleTvApp.get({
            id: result[0].id
          });
          return _this.appleTVApp.$promise;
        }
      }).then(function () {
        _this.updateAppleTVAppReadyToSubmit();

        delete _this._appleTVImageList;
      });
      var rokuPromise = this.RokuApp.query({
        s: '-created_at',
        l: 1
      }).$promise.then(function (result) {
        if (result && result.length) {
          _this.rokuApp = _this.RokuApp.get({
            id: result[0].id
          });
          return _this.rokuApp.$promise;
        }
      }).then(function () {
        _this.updateRokuAppReadyToSubmit();

        delete _this._rokuImageList;
      }); // Keep track of loading state of AJAX requests

      this.loadingPromises = [this.account.$promise, appleTVPromise, rokuPromise]; // After we get the apple tv and roku apps, check to see if we need to look for public, recorded broadcasts

      this.needPublicRecordedBroadcasts = false;
      this.$q.all([appleTVPromise, rokuPromise]).then(function () {
        // We only need to check for public, recorded broadcasts if at least one app exists and is waiting_on_customer.
        var needsBroadcastQuery = false;

        if (_this.rokuApp && _this.rokuApp.status == 'waiting_on_customer' || _this.appleTVApp && _this.appleTVApp.status == 'waiting_on_customer') {
          needsBroadcastQuery = true;
        }

        if (!needsBroadcastQuery) {
          return;
        } // If we get here, we need to go check for public, recorded broadcasts


        _this.needPublicRecordedBroadcasts = true;

        _this.updateAppleTVAppReadyToSubmit();

        _this.updateRokuAppReadyToSubmit();

        _this.loadingPromises.push(_this.Broadcast.query({
          'filter.exclude_past_live_only': true,
          q: "timeframe:past",
          l: 1000,
          s: "-starts_at"
        }, function (broadcasts) {
          return _.find(broadcasts, function (b) {
            if (!b.is_private && !b.is_ticketed && b.recording_duration_seconds > 0) {
              _this.needPublicRecordedBroadcasts = false;

              _this.updateAppleTVAppReadyToSubmit();

              _this.updateRokuAppReadyToSubmit();

              return true;
            }

            return false;
          });
        }, function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to find recorded broadcasts.');
        }).$promise);
      });
    }
  }, {
    key: "submitToBoxCast",
    value: function submitToBoxCast(type, app) {
      var _this2 = this;

      var RokuApp = this.RokuApp,
          AppleTvApp = this.AppleTvApp,
          toaster = this.toaster;

      if (type == 'roku') {
        this.rokuApp._submitting = true;
        RokuApp.update({
          id: app.id,
          status: 'submitted_to_boxcast'
        }, function (app) {
          _this2.rokuApp = app;
        }, function (err) {
          console.error(err);
          _this2.rokuApp._submitting = false;
          toaster.pop('warning', 'Unable to submit app. Please confirm all fields have been filed out and try again.');
        });
      } else if (type == 'appletv') {
        this.appleTVApp._submitting = true;
        AppleTvApp.update({
          id: app.id,
          status: 'submitted_to_boxcast'
        }, function (app) {
          _this2.appleTVApp = app;
        }, function (err) {
          console.error(err);
          _this2.appleTVApp._submitting = false;
          toaster.pop('warning', 'Unable to submit app. Please confirm all fields have been filed out and try again.');
        });
      } else {
        console.error('Unknown submission type: ', type, app);
      }
    }
  }, {
    key: "showEditAppearanceModal",
    value: function showEditAppearanceModal() {
      var $uibModal = this.$uibModal;

      var _parentVM = this;

      $uibModal.open({
        template: __webpack_require__(447),
        controller: __webpack_require__(448)["default"],
        controllerAs: 'vm',
        resolve: {
          parentVM: function parentVM() {
            return _parentVM;
          }
        },
        //  Prevent accidental close...
        keyboard: false,
        backdrop: 'static'
      });
    }
  }, {
    key: "showEditRokuModal",
    value: function showEditRokuModal() {
      var $uibModal = this.$uibModal;

      var _parentVM2 = this;

      $uibModal.open({
        template: __webpack_require__(449),
        controller: ModalEditRokuController,
        controllerAs: 'vm',
        resolve: {
          parentVM: function parentVM() {
            return _parentVM2;
          }
        },
        size: 'lg',
        //  Prevent accidental close...
        keyboard: false,
        backdrop: 'static'
      });
    }
  }, {
    key: "showEditAppleTVModal",
    value: function showEditAppleTVModal() {
      var $uibModal = this.$uibModal;

      var _parentVM3 = this;

      $uibModal.open({
        template: __webpack_require__(450),
        controller: ModalEditAppleTVController,
        controllerAs: 'vm',
        resolve: {
          parentVM: function parentVM() {
            return _parentVM3;
          }
        },
        size: 'lg',
        //  Prevent accidental close...
        keyboard: false,
        backdrop: 'static'
      });
    }
  }]);

  return SettingsAppearanceController;
}();



function ModalEditRokuController(parentVM, $uibModalInstance, $rootScope, RokuApp, toaster) {
  'ngInject';

  var _this3 = this;

  this.app = angular.copy(parentVM.rokuApp);
  this.images = angular.copy(parentVM.rokuImageList());
  this.categories = ROKU_CATEGORIES;
  var account = parentVM.account;
  this.app.channel_name = this.app.channel_name || account.content_settings.display_name || account.name;
  this.app.channel_description = this.app.channel_description || account.content_settings.description;
  this.app.web_description = this.app.web_description || account.content_settings.description;
  this.app.more_information_url = this.app.more_information_url || account.content_settings.website;
  this.app.end_user_support_contact = this.app.end_user_support_contact || 'questions@boxcast.com';
  var defaultCategory = account.market === 'house-of-worship' ? 'Faith-Based' : 'Special Interest';
  this.app.category = this.app.category || defaultCategory;
  this.uploads = {};
  this.files = {};
  this.images.forEach(function (img) {
    _this3.uploads[img.id] = null;
    _this3.files[img.id] = null;
  });
  this.limits = $rootScope.ApiConfig.modelFieldLimits('roku_app', 'maximum');

  this.cancel = function () {
    return $uibModalInstance.dismiss();
  };

  this.onChangeImage = function (img) {
    img.src = '';
    _this3.app[img.id] = '';
    _this3.uploads[img.id] = null;
    _this3.files[img.id] = null;
  };

  this.onLoadImage = function (img, $event) {
    _this3.uploads[img.id] = {
      naturalWidth: $event.target.naturalWidth,
      naturalHeight: $event.target.naturalHeight
    };
  };

  this.uploadInto = function (img, file) {
    file.upload().then(function (response) {
      img.src = response.view_url;
      _this3.app[img.id] = response.view_url;
    });
  };

  this.update = function () {
    _this3.showError = false;
    _this3.saving = true;
    var appUpdate = angular.copy(_this3.app);
    delete appUpdate.status;
    RokuApp.update(appUpdate, function (app) {
      parentVM.refresh();

      _this3.cancel();
    }, function (err) {
      _this3.saving = false;
      console.error(err);
      toaster.pop('warning', 'There was an error saving your app submission. Please try again.');
    });
  };
}

function ModalEditAppleTVController(parentVM, $uibModalInstance, $rootScope, AppleTvApp, toaster) {
  'ngInject';

  var _this4 = this;

  this.app = angular.copy(parentVM.appleTVApp);
  this.images = angular.copy(parentVM.appleTVImageList());
  this.categories = APPLE_CATEGORIES;
  var account = parentVM.account;
  this.app.name = this.app.name || account.content_settings.display_name || account.name;
  this.app.description = this.app.description || account.content_settings.description;
  this.app.marketing_url = this.app.marketing_url || account.content_settings.website;
  this.app.support_url = this.app.support_url || 'https://support.boxcast.com';
  this.app.category = this.app.category || 'Lifestyle';
  this.uploads = {};
  this.files = {};
  this.images.forEach(function (img) {
    _this4.uploads[img.id] = null;
    _this4.files[img.id] = null;
  });
  this.limits = $rootScope.ApiConfig.modelFieldLimits('apple_tv_app', 'maximum');

  this.cancel = function () {
    return $uibModalInstance.dismiss();
  };

  this.onChangeImage = function (img) {
    img.src = '';
    _this4.app[img.id] = '';
    _this4.uploads[img.id] = null;
    _this4.files[img.id] = null;
  };

  this.onLoadImage = function (img, $event) {
    _this4.uploads[img.id] = {
      naturalWidth: $event.target.naturalWidth,
      naturalHeight: $event.target.naturalHeight
    };
  };

  this.uploadInto = function (img, file) {
    file.upload().then(function (response) {
      img.src = response.view_url;
      _this4.app[img.id] = response.view_url;
    });
  };

  var resizeURL = function resizeURL(origURL, w, h) {
    return "https://images.weserv.nl/?url=".concat(encodeURIComponent(origURL), "&w=").concat(w, "&h=").concat(h, "&fit=fill");
  };

  var shapeUpdateParams = function shapeUpdateParams(app) {
    // Make a copy to not mutate the original object
    var ret = angular.copy(_this4.app); // Don't post the status, which isn't changing

    delete ret.status; // Fill in resize URLs for 1x versions of 2x images

    if (ret.top_shelf_image_2x) {
      ret.top_shelf_image = resizeURL(ret.top_shelf_image_2x, 1920, 720);
    }

    if (ret.top_shelf_wide_image_2x) {
      ret.top_shelf_wide_image = resizeURL(ret.top_shelf_wide_image_2x, 2320, 720);
    }

    if (ret.app_icon_small_background_layer_2x) {
      ret.app_icon_small_background_layer = resizeURL(ret.app_icon_small_background_layer_2x, 400, 240);
    }

    if (ret.app_icon_small_foreground_layer_2x) {
      ret.app_icon_small_foreground_layer = resizeURL(ret.app_icon_small_foreground_layer_2x, 400, 240);
    }

    return ret;
  };

  this.update = function () {
    _this4.showError = false;
    _this4.saving = true;
    AppleTvApp.update(shapeUpdateParams(_this4.app), function (app) {
      parentVM.refresh();

      _this4.cancel();
    }, function (err) {
      _this4.saving = false;
      console.error(err);
      toaster.pop('warning', 'There was an error saving your app submission. Please try again.');
    });
  };
}

function hasAllFieldsSet(app, fields) {
  var missingAny = false;
  fields.forEach(function (k) {
    return missingAny = missingAny || !app[k].trim();
  });
  return !missingAny;
}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">Edit Appearance Settings</h3>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row\">\n\n    <div ng-if=\"vm.showError\" class=\"col-xs-12\">\n      <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n        Please fill out all required fields before submitting.\n      </div>\n    </div>\n\n    <div class=\"col-xs-12\">\n\n      <div ng-if=\"::!vm.FeatureFlags.appletv_roku\">\n        <p class=\"help-block text-center\" style=\"margin:15px\">\n        Your account is not currently eligible to show in the BoxCast Apps (Roku, Apple TV, Amazon Fire TV).<br>\n          <upgrade-button ng-click=\"vm.cancel()\"></upgrade-button>\n        </p>\n      </div><!--/appletv-tease-->\n      <div ng-if=\"::vm.FeatureFlags.appletv_roku\">\n        <div ng-click=\"vm.onShowInAppsClick()\" class=\"checkbox\" style=\"cursor:pointer\">\n          <i class=\"fa\" ng-class=\"vm.account.enable_public_discovery ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n          Show My Account Channel in the BoxCast Apps (Roku, Apple TV, Amazon Fire TV)\n        </div>\n        <div ng-if=\"vm.showPublicAppSettingsWarning()\">\n          <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin:15px 0\">\n            Before enabling, please ensure your poster images are uploaded below.\n          </div>\n        </div>\n      </div><!--/ appletv-->\n\n      <div class=\"form-group\">\n        <label>Brand Color</label>\n        <boxcast-color-picker ng-model=\"vm.content_settings.color\" default-color=\"#FFFFFF\"></boxcast-color-picker>\n      </div>\n\n      <div class=\"row\">\n\n        <div class=\"form-group col-sm-6\">\n          <label>Profile Image<br><small style=\"font-weight:normal\">(400px &times; 400px, PNG or JPG, under 200kb in size)</small></label>\n          <div ng-if=\"vm.profile_img && (vm.profile_img.naturalWidth != 400 || vm.profile_img.naturalHeight != 400)\">\n            <div class=\"label label-warning\" style=\"display:inline-block;margin-bottom:10px\">\n              Logo is {{vm.profile_img.naturalWidth}}x{{vm.profile_img.naturalHeight}} but should be 400x400\n            </div>\n          </div>\n          <button ng-if=\"vm.content_settings.profile_img\" class=\"btn btn-xs btn-default\" ng-click=\"vm.onChangeImage('profile_img')\">Change</button>\n        </div>\n        <div class=\"form-group col-sm-6\">\n          <div ng-if=\"vm.content_settings.profile_img\" class=\"text-center\">\n            <div class=\"fixed-16-9\" style=\"background:#fff\">\n              <div style=\"width:56.25%;margin:0 21.875%;\">\n                <div class=\"fixed-square transparent-grid-bg\" style=\"color:#ccc;\">\n                  <div style=\"background-image:url(&quot;{{vm.content_settings.profile_img | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n                  <img ng-src=\"{{vm.content_settings.profile_img | trustedUrl}}\"\n                      ng-onload=\"vm.onLoadImage('profile_img', $event)\"\n                      style=\"width:0;height:0;opacity:0;\">\n                </div>\n              </div>\n            </div>\n          </div>\n          <div ng-if=\"!vm.content_settings.profile_img\">\n            <upload-slot ng-model=\"vm.profileImgFile\"\n                          ng-change=\"vm.uploadIntoCS('profile_img', vm.profileImgFile)\"\n                          slot-name=\"'app-assets'\"\n                          allow-image=\"true\"\n                          allow-video=\"false\"\n                          compact=\"true\"></upload-slot>\n          </div>\n        </div>\n\n        <div class=\"form-group col-sm-6\">\n          <label>Account Poster (Large)<br><small style=\"font-weight:normal\">Used on Apple TV and Fire TV apps<br>(1280px &times; 720px, PNG or JPG, under 300kb in size)</small></label>\n          <div ng-if=\"vm.logo_img && (vm.logo_img.naturalWidth != 1280 || vm.logo_img.naturalHeight != 720)\">\n            <div class=\"label label-warning\" style=\"display:inline-block;margin-bottom:10px\">\n              Logo is {{vm.logo_img.naturalWidth}}x{{vm.logo_img.naturalHeight}} but should be 1280x720\n            </div>\n          </div>\n          <button ng-if=\"vm.content_settings.logo_img\" class=\"btn btn-xs btn-default\" ng-click=\"vm.onChangeImage('logo_img')\">Change</button>\n        </div>\n        <div class=\"form-group col-sm-6\">\n          <div ng-if=\"vm.content_settings.logo_img\" class=\"text-center\">\n            <div class=\"fixed-16-9 transparent-grid-bg\" style=\"color:#ccc;\">\n              <div style=\"background-image:url(&quot;{{vm.content_settings.logo_img | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n              <img ng-src=\"{{vm.content_settings.logo_img | trustedUrl}}\"\n                   ng-onload=\"vm.onLoadImage('logo_img', $event)\"\n                   style=\"width:0;height:0;opacity:0;\">\n            </div>\n          </div>\n          <div ng-if=\"!vm.content_settings.logo_img\">\n            <upload-slot ng-model=\"vm.appLogoFile\"\n                          ng-change=\"vm.uploadIntoCS('logo_img', vm.appLogoFile)\"\n                          slot-name=\"'app-assets'\"\n                          allow-image=\"true\"\n                          allow-video=\"false\"\n                          compact=\"true\"></upload-slot>\n          </div>\n        </div>\n\n        <div class=\"form-group col-sm-6\">\n          <label>Account Poster (Small)<br><small style=\"font-weight:normal\">Used in Roku app<br>(300px &times; 169px, PNG or JPG, under 150kb in size)</small></label>\n          <div ng-if=\"vm.thumb_img && (vm.thumb_img.naturalWidth != 300 || vm.thumb_img.naturalHeight != 169)\">\n            <div class=\"label label-warning\" style=\"display:inline-block;margin-bottom:10px\">\n              Logo is {{vm.thumb_img.naturalWidth}}x{{vm.thumb_img.naturalHeight}} but should be 300x169\n            </div>\n          </div>\n          <button ng-if=\"vm.content_settings.thumb_img\" class=\"btn btn-xs btn-default\" ng-click=\"vm.onChangeImage('thumb_img')\">Change</button>\n        </div>\n        <div class=\"form-group col-sm-6\">\n          <div ng-if=\"vm.content_settings.thumb_img\" class=\"text-center\">\n            <div class=\"fixed-16-9 transparent-grid-bg\" style=\"color:#ccc;\">\n              <div style=\"background-image:url(&quot;{{vm.content_settings.thumb_img | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n              <img ng-src=\"{{vm.content_settings.thumb_img | trustedUrl}}\"\n                   ng-onload=\"vm.onLoadImage('thumb_img', $event)\"\n                   style=\"width:0;height:0;opacity:0;\">\n            </div>\n          </div>\n          <div ng-if=\"!vm.content_settings.thumb_img\">\n            <upload-slot ng-model=\"vm.appThumbFile\"\n                          ng-change=\"vm.uploadIntoCS('thumb_img', vm.appThumbFile)\"\n                          slot-name=\"'app-assets'\"\n                          allow-image=\"true\"\n                          allow-video=\"false\"\n                          compact=\"true\"></upload-slot>\n          </div>\n        </div>\n\n      </div>\n\n    </div>\n\n  </div>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n    <button ng-disabled=\"vm.saving\"\n            ng-click=\"vm.update()\"\n            class=\"btn btn-primary\">\n      <i ng-show=\"vm.saving\" class=\"fa fa-spin fa-spinner\"></i>\n      Update Settings\n    </button>\n</div>\n"

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalEditContentSettingsController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_password__ = __webpack_require__(199);

function ModalEditContentSettingsController($uibModal, $uibModalInstance, $cacheFactory, $rootScope, Account, $httpParamSerializer, $sce, toaster, parentVM) {
  'ngInject';

  var _this = this;

  this.cancel = function () {
    return $uibModalInstance.dismiss('cancel');
  };

  this.account = angular.copy(parentVM.account);
  this.FeatureFlags = parentVM.FeatureFlags;
  this.activeTab = '';
  this.content_settings = this.account.content_settings;
  this.showPoster = this.content_settings.poster;
  this.showPreroll = this.content_settings.customPreroll;

  this.onLoadImage = function (which, $event) {
    _this[which] = $event.target;
  };

  this.onChangeImage = function (which) {
    _this.content_settings[which] = null;
    _this[which] = null;
  };

  this.onShowInAppsClick = function () {
    _this.account.enable_public_discovery = !_this.account.enable_public_discovery;

    if (_this.account.enable_public_discovery && !_this.content_settings.display_name) {
      _this.content_settings.display_name = _this.account.name;
    }
  };

  this.uploadIntoCS = function (key, file) {
    file.upload().then(function (response) {
      console.log(response);

      if (key.indexOf('.') >= 0) {
        setValue(key, response.view_url, _this.content_settings);
      } else {
        _this.content_settings[key] = response.view_url;
      }
    });
  };

  this.showPublicAppSettingsWarning = function () {
    if (!_this.account.enable_public_discovery) {
      return false;
    } else {
      return !(_this.content_settings.thumb_img && _this.content_settings.logo_img);
    }
  };

  this.update = function () {
    _this.showError = false;
    _this.saving = true;
    var data = angular.copy(_this.content_settings); // Remove as many keys as we can to keep the payload small when sent to the player

    if (!_.trim(data.donateMessage)) delete data.donateMessage;
    if (!_this.showPoster) delete data.poster;
    if (!_this.showPreroll) delete data.customPreroll;
    if (!data.hide_linkback) delete data.hide_linkback; // If they set up the app, make sure we don't have a null thumb/image

    var enablePublicDiscovery = _this.account.enable_public_discovery;

    if (enablePublicDiscovery && !(data.thumb_img && data.logo_img)) {
      _this.showError = true;
      _this.saving = false;
      toaster.pop('warning', 'Please fill in all BoxCast App Settings fields, including logos.');
      return false;
    } // Look at possible password changes.


    Object(__WEBPACK_IMPORTED_MODULE_0__utils_password__["a" /* checkContentSettingsForChangesOnSave */])(data);
    Account.update({
      content_settings: data,
      enable_public_discovery: enablePublicDiscovery
    }, function (account) {
      // Invalidate cache
      $cacheFactory.get('$http').remove("".concat(API_ROOT, "/account"));
      $rootScope.account = account;
      parentVM.refresh();

      _this.cancel();
    }, function () {
      _this.saving = false;
      alert('There was an error trying to save the settings. Please try again.');
    });
  };
}

function setValue(path, val, obj) {
  var fields = path.split('.');
  var result = obj;

  for (var i = 0, n = fields.length; i < n && result !== undefined; i++) {
    var field = fields[i];

    if (i === n - 1) {
      result[field] = val;
    } else {
      if (typeof result[field] === 'undefined' || !_.isObject(result[field])) {
        result[field] = {};
      }

      result = result[field];
    }
  }
}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3>Edit Roku Channel Store Information</h3>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row\">\n    <div ng-if=\"vm.showError\" class=\"col-xs-12\">\n      <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n        Please fill out all required fields before submitting.\n      </div>\n    </div>\n\n    <div class=\"col-xs-12\">\n      <div class=\"bg-info text-info\" style=\"padding:15px;margin-bottom:15px;border-radius:4px;\">\n        Need help filling out these fields? Check out our <a href=\"https://support.boxcast.com/en/articles/4550679-branded-app-fulfillment-process\" target=\"_blank\">support article <i class=\"fa fa-external-link\"></i></a> to get started.\n      </div>\n    </div>\n\n    <div class=\"col-xs-12\">\n      <div class=\"form-group\">\n        <label for=\"channel_name\">Channel Name <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"channel_name\" name=\"channel_name\" ng-model=\"vm.app.channel_name\" ng-maxlength=\"::vm.limits.channel_name\" required>\n        <p class=\"help-block\"><small>This channel name must be globally unique across all Roku apps. If there is a conflict, we will need to work with you when submitting the app to find a new unique name.</small></p>\n        <p ng-show=\"(form.channel_name.$dirty || form.channel_name.$touched) && !vm.app.channel_name\">\n        <span class=\"text-danger\" ng-if=\"form.channel_name.$error.maxlength\">The Channel Name is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.channel_name.$error.required\">The Channel Name cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"category\">Preferred Category <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <select class=\"form-control\" ng-model=\"vm.app.category\">\n          <option ng-repeat=\"c in vm.categories\">{{c}}</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"channel_description\">Channel Description ({{ ::vm.limits.channel_description }} character max)<i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <textarea class=\"form-control\" id=\"channel_description\" name=\"channel_description\" ng-model=\"vm.app.channel_description\" ng-maxlength=\"::vm.limits.channel_description\" required></textarea>\n        <p ng-show=\"(form.channel_description.$dirty || form.channel_description.$touched) && !vm.app.channel_description\">\n        <span class=\"text-danger\" ng-if=\"form.channel_description.$error.maxlength\">The Channel Description is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.channel_description.$error.required\">The Channel Description cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"more_information_url\">Preferred URL for More Information <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"more_information_url\" name=\"more_information_url\" ng-model=\"vm.app.more_information_url\" ng-maxlength=\"::vm.limits.more_information_url\" required>\n        <p ng-show=\"(form.more_information_url.$dirty || form.more_information_url.$touched) && !vm.app.more_information_url\">\n        <span class=\"text-danger\" ng-if=\"form.more_information_url.$error.maxlength\">The URL is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.more_information_url.$error.required\">The URL cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"end_user_support_contact\">End User Support Contact <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"end_user_support_contact\" name=\"end_user_support_contact\" ng-model=\"vm.app.end_user_support_contact\" ng-maxlength=\"::vm.limits.end_user_support_contact\" required>\n        <p ng-show=\"(form.end_user_support_contact.$dirty || form.end_user_support_contact.$touched) && !vm.app.end_user_support_contact\">\n        <span class=\"text-danger\" ng-if=\"form.end_user_support_contact.$error.maxlength\">The Email is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.end_user_support_contact.$error.required\">The Email cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"web_description\">Web Description ({{ ::vm.limits.web_description }} character max) <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <textarea class=\"form-control\" id=\"web_description\" name=\"web_description\" ng-model=\"vm.app.web_description\" ng-maxlength=\"::vm.limits.web_description\" required></textarea>\n        <p ng-show=\"(form.web_description.$dirty || form.web_description.$touched) && !vm.app.web_description\">\n        <span class=\"text-danger\" ng-if=\"form.web_description.$error.maxlength\">The Description is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.web_description.$error.required\">The Description cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"app_background_color\">App Background Color <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <boxcast-color-picker ng-model=\"vm.app.app_background_color\" default-color=\"#FFFFFF\"></boxcast-color-picker>\n        </p>\n      </div>\n    </div>\n\n    <div ng-repeat=\"img in vm.images\" class=\"clearfix\">\n      <div class=\"form-group col-md-6\">\n        <label>{{img.name}}<br><small style=\"font-weight:normal\">(<span ng-if=\"img.w && img.h\">{{img.w}}px &times; {{img.h}}px, </span>PNG or JPG, under 2MB in size)</small></label>\n        <div ng-if=\"!img.noValidate && vm.uploads[img.id] && (vm.uploads[img.id].naturalWidth != img.w || vm.uploads[img.id].naturalHeight != img.h)\">\n          <div class=\"label label-warning\" style=\"display:inline-block;margin-bottom:10px\">\n            Image is {{vm.uploads[img.id].naturalWidth}}x{{vm.uploads[img.id].naturalHeight}} but should be {{img.w}}x{{img.h}}\n          </div>\n        </div>\n        <button ng-if=\"img.src\" class=\"btn btn-xs btn-default\" ng-click=\"vm.onChangeImage(img)\">Change</button>\n      </div>\n      <div class=\"form-group col-md-6\">\n        <div ng-if=\"img.src\" class=\"text-center\">\n          <fixed-image-preview src=\"img.src\" height=\"img.preview_h\" width=\"img.preview_w\" on-load=\"vm.onLoadImage(img, $event)\"></fixed-image-preview>\n        </div>\n        <div ng-if=\"!img.src\">\n          <upload-slot ng-model=\"vm.files[img.id]\"\n                       ng-change=\"vm.uploadInto(img, vm.files[img.id])\"\n                       slot-name=\"'app-assets'\"\n                       allow-image=\"true\"\n                       allow-video=\"false\"\n                       compact=\"true\"></upload-slot>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n  <button ng-disabled=\"vm.saving || form.$invalid\"\n          ng-click=\"vm.update()\"\n          class=\"btn btn-primary\">\n    <i ng-show=\"vm.saving\" class=\"fa fa-spin fa-spinner\"></i>\n    Update Settings\n  </button>\n</div>\n</form>\n"

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3>Edit Apple TV App Store Information</h3>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row\">\n    <div ng-if=\"vm.showError\" class=\"col-xs-12\">\n      <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n        Please fill out all required fields before submitting.\n      </div>\n    </div>\n\n    <div class=\"col-xs-12\">\n      <div class=\"bg-info text-info\" style=\"padding:15px;margin-bottom:15px;border-radius:4px;\">\n        Need help filling out these fields? Check out our <a href=\"https://support.boxcast.com/en/articles/4550679-branded-app-fulfillment-process\" target=\"_blank\">support article <i class=\"fa fa-external-link\"></i></a> to get started.\n      </div>\n    </div>\n\n    <div class=\"col-xs-12\">\n      <div class=\"form-group\">\n        <label for=\"name\">Name in the App Store <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"name\" name=\"name\" ng-model=\"vm.app.name\" ng-maxlength=\"::vm.limits.name\" required>\n        <p class=\"help-block\"><small>This name must be globally unique across all Apple apps. If there is a conflict, we will need to work with you when submitting the app to find a new unique name.</small></p>\n        <p ng-show=\"(form.name.$dirty || form.name.$touched) && !vm.app.name\">\n        <span class=\"text-danger\" ng-if=\"form.name.$error.maxlength\">The Name is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.name.$error.required\">The Name cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"category\">Category <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <select class=\"form-control\" ng-model=\"vm.app.category\">\n          <option ng-repeat=\"c in vm.categories\">{{c}}</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"keywords\">Keywords <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"keywords\" name=\"keywords\" ng-model=\"vm.app.keywords\" ng-maxlength=\"::vm.limits.keywords\" required>\n        <p ng-show=\"(form.keywords.$dirty || form.keywords.$touched) && !vm.app.keywords\">\n        <span class=\"text-danger\" ng-if=\"form.keywords.$error.maxlength\">The Keywords are too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.keywords.$error.required\">The Keywords cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"subtitle\">Subtitle <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"subtitle\" name=\"subtitle\" ng-model=\"vm.app.subtitle\" ng-maxlength=\"::vm.limits.subtitle\" required>\n        <p ng-show=\"(form.subtitle.$dirty || form.subtitle.$touched) && !vm.app.subtitle\">\n        <span class=\"text-danger\" ng-if=\"form.subtitle.$error.maxlength\">The Subtitle is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.subtitle.$error.required\">The Subtitle cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"promotional_text\">Promotional Text <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"promotional_text\" name=\"promotional_text\" ng-model=\"vm.app.promotional_text\" ng-maxlength=\"::vm.limits.promotional_text\" required>\n        <p ng-show=\"(form.promotional_text.$dirty || form.promotional_text.$touched) && !vm.app.promotional_text\">\n        <span class=\"text-danger\" ng-if=\"form.promotional_text.$error.maxlength\">The Promotional Text is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.promotional_text.$error.required\">The Promotional Text cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"description\">Description <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <textarea class=\"form-control\" id=\"description\" name=\"description\" ng-model=\"vm.app.description\" ng-maxlength=\"::vm.limits.description\" required></textarea>\n        <p ng-show=\"(form.description.$dirty || form.description.$touched) && !vm.app.description\">\n        <span class=\"text-danger\" ng-if=\"form.description.$error.maxlength\">The Description is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.description.$error.required\">The Description cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"support_url\">Support URL <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"support_url\" name=\"support_url\" ng-model=\"vm.app.support_url\" ng-maxlength=\"::vm.limits.support_url\" required>\n        <p ng-show=\"(form.support_url.$dirty || form.support_url.$touched) && !vm.app.support_url\">\n        <span class=\"text-danger\" ng-if=\"form.support_url.$error.maxlength\">The URL is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.support_url.$error.required\">The URL cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"marketing_url\">Marketing URL <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"marketing_url\" name=\"marketing_url\" ng-model=\"vm.app.marketing_url\" ng-maxlength=\"::vm.limits.marketing_url\" required>\n        <p ng-show=\"(form.marketing_url.$dirty || form.marketing_url.$touched) && !vm.app.marketing_url\">\n        <span class=\"text-danger\" ng-if=\"form.marketing_url.$error.maxlength\">The URL is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.marketing_url.$error.required\">The URL cannot be blank.</span>\n        </p>\n      </div>\n    </div>\n\n    <div ng-repeat=\"img in vm.images\" class=\"clearfix\">\n      <div class=\"form-group col-md-6\">\n        <label>{{img.name}}<br><small style=\"font-weight:normal\">({{img.w}}px &times; {{img.h}}px, PNG or JPG, under 2MB in size)</small></label>\n        <div ng-if=\"!img.noValidate && vm.uploads[img.id] && (vm.uploads[img.id].naturalWidth != img.w || vm.uploads[img.id].naturalHeight != img.h)\">\n          <div class=\"label label-warning\" style=\"display:inline-block;margin-bottom:10px\">\n            Image is {{vm.uploads[img.id].naturalWidth}}x{{vm.uploads[img.id].naturalHeight}} but should be {{img.w}}x{{img.h}}\n          </div>\n        </div>\n        <button ng-if=\"img.src\" class=\"btn btn-xs btn-default\" ng-click=\"vm.onChangeImage(img)\">Change</button>\n      </div>\n      <div class=\"form-group col-md-6\">\n        <div ng-if=\"img.src\" class=\"text-center\">\n          <fixed-image-preview src=\"img.src\" height=\"img.preview_h\" width=\"img.preview_w\" on-load=\"vm.onLoadImage(img, $event)\"></fixed-image-preview>\n        </div>\n        <div ng-if=\"!img.src\">\n          <upload-slot ng-model=\"vm.files[img.id]\"\n                       ng-change=\"vm.uploadInto(img, vm.files[img.id])\"\n                       slot-name=\"'app-assets'\"\n                       allow-image=\"true\"\n                       allow-video=\"false\"\n                       compact=\"true\"></upload-slot>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n  <button ng-disabled=\"vm.saving || form.$invalid\"\n          ng-click=\"vm.update()\"\n          class=\"btn btn-primary\">\n    <i ng-show=\"vm.saving\" class=\"fa fa-spin fa-spinner\"></i>\n    Update Settings\n  </button>\n</div>\n</form>\n\n"

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WifiConfigurationService; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var WifiConfigurationService = /*#__PURE__*/function () {
  function WifiConfigurationService($q, BoxCaster, $timeout) {
    'ngInject';

    _classCallCheck(this, WifiConfigurationService);

    this.$q = $q;
    this.BoxCaster = BoxCaster;
    this.$timeout = $timeout;
  }

  _createClass(WifiConfigurationService, [{
    key: "getConfig",
    value: function getConfig(boxcasterId) {
      var _this = this;

      // Returns a promise that is fullfilled when the result of the
      // `get_wifi_config` RPC completes.
      var BoxCaster = this.BoxCaster,
          $timeout = this.$timeout,
          $q = this.$q;
      var deferred = $q.defer();
      var startTime = new Date().getTime();
      var pollingId = null;
      var wifiConfig = null;

      var handleResult = function handleResult() {
        if (wifiConfig.response && !wifiConfig.error) {
          deferred.resolve(_this.mungeApiResponse(wifiConfig.response));
        } else if (wifiConfig.error) {
          deferred.reject(wifiConfig.response);
        } else if (new Date().getTime() - startTime > WIFI_POLL_TIMEOUT_MS) {
          deferred.reject('timeout');

          _this.destroy();
        } else {
          _this.timeoutHandle = $timeout(poll, WIFI_POLL_INTERVAL_MS);
        }
      };

      var poll = function poll() {
        if (!pollingId) {
          // Start the RPC
          wifiConfig = BoxCaster.postRPC({
            id: boxcasterId
          }, {
            request: 'get_wifi_config'
          }, function () {
            pollingId = wifiConfig.id;
            handleResult();
          }, function () {
            return deferred.reject('Unable to get Wi-Fi config');
          });
        } else {
          // Check status of existing RPC call to get wireless networks
          wifiConfig = BoxCaster.getRPC({
            id: boxcasterId,
            rpcId: pollingId
          }, function () {
            return handleResult();
          }, function () {
            return deferred.reject('Unable to get Wi-Fi config');
          });
        }
      };

      this.destroy = function () {
        console.log('Destroying the old RPC call');

        _this.$timeout.cancel(_this.timeoutHandle);

        BoxCaster.deleteRPC({
          id: boxcasterId,
          rpcId: pollingId
        });
      };

      poll();
      return deferred.promise;
    }
  }, {
    key: "setConfig",
    value: function setConfig(boxcasterId, config) {
      var _this2 = this;

      // Returns a promise that is fullfilled when the result of the
      // `set_wifi_config` RPC completes.
      var BoxCaster = this.BoxCaster,
          $timeout = this.$timeout,
          $q = this.$q;
      var deferred = $q.defer();
      var pollingId = null;
      var wifiConfig = null;

      var handleResult = function handleResult() {
        if (wifiConfig.response && !wifiConfig.error) {
          deferred.resolve(wifiConfig.response);
        } else if (wifiConfig.error) {
          deferred.reject(wifiConfig.response);
        } else {
          _this2.timeoutHandle = $timeout(poll, WIFI_POLL_INTERVAL_MS);
        }
      };

      var poll = function poll() {
        if (!pollingId) {
          // Start the RPC
          wifiConfig = BoxCaster.postRPC({
            id: boxcasterId
          }, {
            request: {
              message: 'set_wifi_config',
              config: config
            }
          }, function () {
            pollingId = wifiConfig.id;
            handleResult();
          }, function () {
            return deferred.reject('Unable to set Wi-Fi config');
          });
        } else {
          // Check status of existing RPC call to get wireless networks
          wifiConfig = BoxCaster.getRPC({
            id: boxcasterId,
            rpcId: pollingId
          }, function () {
            return handleResult();
          }, function () {
            return deferred.reject('Unable to set Wi-Fi config');
          });
        }
      };

      poll();
      return deferred.promise;
    }
  }, {
    key: "mungeApiResponse",
    value: function mungeApiResponse(response) {
      // XXX: looks like Ruby is doing some weird stuff to the RPC result (turning
      // empty arrays to nulls). We'll work around it here to avoid hacking away
      // at the ruby code.
      if (response.current && !response.current.networks) {
        response.current.networks = [];
      }

      if (!response.scan_results) {
        response.scan_results = [];
      }

      return response;
    }
  }]);

  return WifiConfigurationService;
}();



/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerComponents;
function registerComponents(module) {
  // <integration-row-header />
  module.component('integrationRowHeader', {
    controllerAs: 'vm',
    bindings: {
      account: '=',
      onToggleDetails: '&'
    },
    controller: function controller($scope) {
      'ngInject';

      var _this = this;

      this.$onInit = function () {
        $scope.a = _this.account; //shortcut for template
      };

      this.getBroadcastNames = function () {
        return _.pluck(_this.account.details, 'name').join(', ');
      };

      this.showOnline = function () {
        return _this.shouldBeBroadcasting() && !_this.showError();
      };

      this.showOffline = function () {
        return !_this.showError() && !_this.shouldBeBroadcasting();
      };

      this.showError = function () {
        return _this.account.token_is_invalid || _this.account.type === 'youtube' && !_this.account.__isYTLiveEnabled__;
      };

      this.shouldBeBroadcasting = function () {
        return _this.account.details && _this.account.details.length > 0;
      };

      this.isProbablyBroadcastingForReal = function () {
        return _.any(_.pluck(_this.account.details, 'transcoder_profile')) || _.any(_.pluck(_this.account.details, 'stream_source'), function (ss) {
          return ss === 'recording';
        });
      };
    },
    template: "\n      <div class=\"row integration-card-header\" ng-click=\"vm.onToggleDetails(a)\">\n        <div class=\"hidden-xs col-sm-1\" style=\"width:90px\">\n          <span class=\"integration-badge integration-badge--{{a.type}}\">\n            <img src=\"/img/ss-144x144.png\" class=\"icon-image\" ng-if=\"::a.type == 'ss'\">\n            <i class=\"fa fa-facebook\" ng-if=\"::a.type == 'facebook'\"></i>\n            <i class=\"fa fa-youtube-play\" ng-if=\"::a.type == 'youtube'\"></i>\n            <i class=\"fa fa-vimeo\" ng-if=\"::a.type == 'vimeo'\"></i>\n            <i class=\"fa-brands fa-x-twitter\" ng-if=\"::a.type == 'twitter'\"></i>\n            <span ng-if=\"::a.type == 'rtmp_push'\">RTMP Push</span>\n            <span ng-if=\"::a.type == 'sportzcast'\">SPORTZ CAST</span>\n          </span>\n        </div>\n        <div class=\"col-sm-1\" style=\"width:30px\">\n          <div ng-hide=\"a.hideStatusDot\">\n            <i class=\"fa fa-circle color--online\" ng-if=\"vm.showOnline()\"></i>\n            <i class=\"fa fa-circle color--red\" ng-if=\"vm.showError()\"></i>\n            <i class=\"fa fa-circle color--grey\" ng-if=\"vm.showOffline()\"></i>\n          </div>\n        </div>\n        <div class=\"hidden-xs col-sm-5 text-left\" style=\"flex:1\">\n          <p class=\"overflow-ellipse body-2\" style=\"margin-bottom:0\"><strong>{{a.display_name}}</strong></p>\n          <p class=\"overflow-ellipse\" ng-if=\"a.display_subtitle\" style=\"margin-bottom:0\"><small>{{a.display_subtitle}}</small></p>\n        </div>\n        <div class=\"col-sm-5 text-left\" style=\"flex:1\">\n          <p class=\"visible-xs overflow-ellipse body-2\" style=\"margin-bottom:0\"><strong>{{a.display_name}}</strong></p>\n          <div class=\"overflow-ellipse\">\n            <span ng-if=\"vm.shouldBeBroadcasting()\">\n              <strong class=\"color--green\" ng-show=\"vm.isProbablyBroadcastingForReal()\">Broadcasting</strong>\n              <strong class=\"color--red\" ng-hide=\"vm.isProbablyBroadcastingForReal()\">Not Connected</strong>\n              <br><small>{{vm.getBroadcastNames()}}</small>\n            </span>\n          </div>\n        </div>\n        <div class=\"col-sm-1 text-center\">\n          <i class=\"fa fa-chevron-{{a.__showDetails?'up':'down'}}\"></i>\n        </div>\n      </div>\n    "
  }); // <integration-row-details />

  module.component('integrationRowDetails', {
    controllerAs: 'vm',
    bindings: {
      account: '=',
      onDeleteLink: '&',
      onEditRtmp: '&',
      onDeleteRtmp: '&',
      onRelink: '&',
      onEditSportzcast: '&'
    },
    controller: function controller($scope, $rootScope) {
      'ngInject';

      var _this2 = this;

      this.user = $rootScope.user;

      this.$onInit = function () {
        $scope.a = _this2.account; //shortcut for template
      };

      this.dateValid = function (d) {
        return d && Date.parse(d) != 0;
      };

      this.vueDashboardRoot = $rootScope.vueDashboardRoot;

      this.userCan = function (action, account) {
        switch (account.type) {
          case 'facebook': // fall-through

          case 'twitter': // fall-through

          case 'vimeo': // fall-through

          case 'youtube':
            return _this2.user.can(action, account.type + '-user/*');
            break;

          case 'rtmp_push':
            return _this2.user.can(action, 'static-rtmp-channel/*');
            break;

          default:
            // shrug
            return true;
        }
      };

      this.warningMessage = function () {
        if (_this2.account.token_is_invalid) {
          return _this2.account.token_invalid_reason;
        } else if (_this2.account.type === 'youtube' && !_this2.account.__isYTLiveEnabled__) {
          return 'YouTube Live permission is not set';
        }

        return null;
      };
    },
    template: "\n      <div class=\"row\" style=\"display:block\">\n        <div class=\"col-sm-8\">\n          <table class=\"table table-condensed body-3\">\n            <thead ng-if=\"vm.warningMessage()\">\n              <tr><th colspan=\"2\" class=\"text-xs\">ERROR</th></tr>\n              <tr><td colspan=\"2\">\n                <div class=\"bg-danger text-danger\" style=\"padding:10px;margin:0px 0 10px;border:1px solid\">{{ vm.warningMessage() }}</div>\n              </td></tr>\n            </thead>\n            <tr><th colspan=\"2\" class=\"text-xs\">CONFIGURATION</th></tr>\n            <tr ng-if=\"a.type == 'sportzcast'\"><td>Username</td><td>{{a.username}}</td></tr>\n            <tr ng-if=\"a.type != 'rtmp_push' && a.type != 'ss' && a.type != 'sportzcast'\"><td>Linked</td><td>{{a.created_at | date}}</td></tr>\n            <tr ng-if=\"vm.dateValid(a.token_last_used_at)\"><td>Last Used</td><td>{{a.token_last_used_at | date}}</td></tr>\n            <tr ng-if=\"vm.dateValid(a.token_expires_at)\"><td>Expires</td><td>{{a.token_expires_at | date}}</td></tr>\n\n            <tr ng-if=\"a.type == 'rtmp_push'\"><td>Stream URL</td><td>{{a.stream_url}}</td></tr>\n            <tr ng-if=\"a.type == 'rtmp_push'\"><td>Stream Key</td><td style=\"overflow-wrap: anywhere;\">{{a.stream_key}}</td></tr>\n            <tr ng-if=\"a.type == 'rtmp_push' && a.username\"><td>Username</td><td>{{a.username}}</td></tr>\n            <tr ng-if=\"a.type == 'rtmp_push' && a.password\"><td>Password</td><td><i class=\"fa fa-lock\"></i> \u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022</td></tr>\n            <tr ng-if=\"a.type == 'rtmp_push'\"><td>Max Resolution</td><td>{{a.max_resolution == 0 ? 'None (use highest)' : (a.max_resolution+'p')}}</td></tr>\n          </table>\n          <table ng-if=\"a.type == 'facebook' && a.pages_managed && a.pages_managed.length\" class=\"table table-condensed body-3\">\n            <tr><th class=\"text-xs\">PAGES MANAGED</th></tr>\n            <tr ng-repeat=\"p in a.pages_managed\">\n              <td>\n                {{p.name}}\n                <a href=\"https://www.facebook.com/profile.php?id={{p.id}}\" target=\"_blank\"><i class=\"fa fa-external-link\"></i></a>\n              </td>\n            </tr>\n          </table>\n          <p class=\"help-block\" ng-if=\"a.type == 'youtube'\">\n            <i class=\"fa fa-info-circle\"></i>\n            BoxCast uses YouTube API Services to create and manage your YouTube Live broadcasts.  By using this integration, you are\n            bound to the <a href=\"https://www.youtube.com/t/terms\" target=\"_blank\">YouTube Terms of Service</a>.\n          </p>\n          <p class=\"help-block\" ng-if=\"a.type == 'facebook'\">\n            <i class=\"fa fa-info-circle\"></i>\n            BoxCast uses the Facebook Live API to create and manage your Facebook Live broadcasts. Facebook's Platform Policy requires that\n            you don't put third-party video ads in your live video (for example, don't include bumpers, pre-roll, mid-roll or post-roll).\n            You must also ensure that any pre-recorded content is clearly distinguishable from live content. For more information, see the\n            <a href=\"https://developers.facebook.com/policy/#liveAPI\" target=\"_blank\">Live API section of Facebook's Platform Policy</a>.\n          </p>\n        </div>\n        <div class=\"col-sm-4\">\n          <p class=\"text-center\" ng-repeat=\"broadcast in a.details\">\n            <a class=\"btn btn-default btn-block\" href=\"{{vm.vueDashboardRoot}}/broadcasts/{{broadcast.id}}\" target=\"_blank\">\n              View Current Broadcast\n            </a>\n          </p>\n          <p class=\"text-center\" ng-if=\"a.type == 'rtmp_push'\">\n            <button type=\"button\" class=\"btn btn-default btn-block\" ng-if=\"::vm.userCan('update', a)\" ng-click=\"vm.onEditRtmp(a)\">\n              Edit Settings\n            </button>\n          </p>\n          <p class=\"text-center\" ng-if=\"a.type == 'facebook' || a.type == 'twitter'  || a.type == 'youtube'\">\n            <button type=\"button\" class=\"btn btn-default btn-block\" ng-if=\"::vm.userCan('update', a)\" ng-click=\"vm.onRelink(a)\">\n              Re-link Integration\n            </button>\n          </p>\n          <p class=\"text-center\" ng-if=\"a.type == 'rtmp_push'\">\n            <button type=\"button\" class=\"btn btn-default btn-block\" ng-if=\"::vm.userCan('delete', a)\" ng-click=\"vm.onDeleteRtmp(a)\">\n              Delete RTMP Push Channel\n            </button>\n          </p>\n          <p class=\"text-center\" ng-if=\"a.type != 'rtmp_push' && a.type != 'ss' && a.type != 'sportzcast'\">\n            <button type=\"button\" class=\"btn btn-default btn-block\" ng-if=\"::vm.userCan('delete', a)\" ng-click=\"vm.onDeleteLink(a)\">\n              Delete Link from BoxCast\n            </button>\n          </p>\n          <p class=\"text-center\" ng-if=\"a.type == 'sportzcast'\">\n            <button type=\"button\" class=\"btn btn-default btn-block\" ng-if=\"::vm.userCan('update', a)\" ng-click=\"vm.onEditSportzcast(a)\">\n              Edit Settings\n            </button>\n          </p>\n        </div>\n      </div>\n    "
  });
}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = "\n<div class=\"row\" ng-if=\"$root.account.showOnboarding()\">\n  <onboarding upcoming-broadcasts=\"{}\" current-broadcasts=\"{}\" past-broadcasts=\"{}\"></onboarding>\n</div>\n\n<div class=\"col-xs-12\">\n  <ol ng-if=\"$root.account.authorized()\" class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n    <li>\n      <a ui-sref=\"settings.my_account\">Account</a>\n    </li>\n    <li>\n      <a ui-sref=\"settings.overview\">Preferences</a>\n    </li>\n    <li ng-if=\"::$root.user.can('list', 'users')\">\n      <a ui-sref=\"settings.users\">Users</a>\n    </li>\n    <li ng-if=\"::(\n                  $root.user.can('list', 'facebook-users') ||\n                  $root.user.can('list', 'twitter-users') ||\n                  $root.user.can('list', 'rtmp-push-channels') ||\n                  $root.user.can('read', 'sportzcast-configuration') ||\n                  $root.user.can('list', 'vimeo-users') ||\n                  $root.user.can('list', 'youtube-users')\n               )\"\n        ng-class=\"{active: ($state.is('settings.integrations')\n                         || $state.is('settings.rtmp_destinations')\n                         || $state.is('settings.facebook')\n                         || $state.is('settings.youtube')\n                         || $state.is('settings.vimeo')\n                         || $state.is('settings.twitter'))}\">\n      <a ui-sref=\"settings.integrations\">Integrations</a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::$root.user.can('list', 'orders') && $root.user.can('update', 'billing')\">\n      <a ui-sref=\"settings.payment\">Billing</a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::($root.user.can('update', 'billing') && $root.user.can('list', 'storage-bills') && (account.storage_policy == 'auto-bill' || account.storage_policy == 'auto-delete'))\">\n      <a ui-sref=\"settings.storage\">Storage</a>\n    </li>\n    <li ng-if=\"::$root.user.can('list', 'api-keys')\">\n      <a ui-sref=\"settings.api_keys\">API Keys</a>\n    </li>\n    <li ui-sref-active=\"active\">\n      <a ui-sref=\"settings.appearance\">Appearance &amp; Apps</a>\n    </li>\n  </ol>\n</div>\n<div class=\"clearfix\"></div>\n\n<div ui-view></div>\n"

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = "<style>\n.well .pull-right a { font-weight: bold; text-decoration: none; }\n.account-settings .well .table { margin-left: -8px; /*counteract padding*/ }\n.account-settings .data-value { text-transform: none; }\n@media (min-width: 768px) {\n  .account-settings .data-value { width: 400px; text-align: left; }\n}\n</style>\n<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"well\">\n    <div class=\"pull-right\" ng-if=\"::vm.canEditAccountSettings\">\n      <a href=\"javascript://\" ng-click=\"vm.showEditAppearanceModal()\">Edit <i class=\"fa fa-pencil-square-o\"></i></a>\n    </div>\n    <h3>BoxCast Apps &amp; Branding</h3>\n    <p class=\"help-block\"><small>\n      These settings are used to customize the BoxCast embedded player and your channel on the BoxCast apps\n      for Apple TV, Roku, and Amazon Fire TV.\n    </small></p>\n    <div style=\"max-width:768px; margin-bottom:15px;\">\n      <p>Show in BoxCast Apps <strong class=\"data-value\">{{vm.account.enable_public_discovery ? 'Enabled' : 'Disabled'}}</strong></p>\n      <div style=\"margin:0 0 10px;\">\n        Brand Color\n        <div class=\"data-value\">\n          <color-swatch ng-if=\"vm.account.content_settings.color\" color=\"vm.account.content_settings.color\" label=\"vm.account.content_settings.color\"></color-swatch>\n          <strong ng-if=\"!vm.account.content_settings.color\">Not Configured</strong>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-xs-6 col-sm-4 col-md-3\">\n        <p>Profile Image</p>\n        <div class=\"fixed-16-9\" style=\"background:#fff\">\n          <div style=\"width:56.25%;margin:0 21.875%;\">\n            <div class=\"fixed-square transparent-grid-bg\" style=\"color:#ccc;\">\n              <div ng-if=\"vm.account.content_settings.profile_img\" style=\"background-image:url(&quot;{{vm.account.content_settings.profile_img | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n              <div ng-if=\"!vm.account.content_settings.profile_img\" style=\"display:flex;align-items:center;justify-content:center;background:#fafafa;\"><small>Not Configured</small></div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-xs-6 col-sm-4 col-md-3\">\n        <p>Account Poster (Large)</p>\n        <div class=\"fixed-16-9 transparent-grid-bg\" style=\"color:#ccc;\">\n          <div style=\"background-image:url(&quot;{{vm.account.content_settings.logo_img | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n          <div ng-if=\"!vm.account.content_settings.logo_img\" style=\"display:flex;align-items:center;justify-content:center;background:#fafafa;\"><small>Not Configured</small></div>\n        </div>\n      </div>\n      <div class=\"col-xs-6 col-sm-4 col-md-3\">\n        <p>Account Poster (Small)</p>\n        <div class=\"fixed-16-9 transparent-grid-bg\" style=\"color:#ccc;\">\n          <div style=\"background-image:url(&quot;{{vm.account.content_settings.thumb_img | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n          <div ng-if=\"!vm.account.content_settings.thumb_img\" style=\"display:flex;align-items:center;justify-content:center;;background:#fafafa;\"><small>Not Configured</small></div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"well\" ng-if=\"vm.rokuApp\">\n    <div class=\"pull-right\">\n      <span class=\"label label-{{vm.statusLabelLevel(vm.rokuApp)}}\"\n            style=\"margin-right:15px\"\n            uib-tooltip=\"{{vm.statusLabelTooltip(vm.rokuApp)}}\"\n            tooltip-append-to-body=\"true\">\n        {{vm.statusText(vm.rokuApp)}}\n      </span>\n    </div>\n    <h3>Roku Channel Store Information</h3>\n\n    <div ng-if=\"vm.rokuApp.status == 'waiting_on_customer'\" class=\"bg-info text-info\" style=\"padding:15px;margin:15px 0;border:1px solid;\">\n      <p>\n        Let's get ready to build your app!\n        You can submit the form to BoxCast once you have filled out all required information, uploaded your images, and\n        we have received your invitation to your Roku Developer account.\n      </p>\n      <p>\n        <table>\n          <tr>\n            <td style=\"padding-right: 10px;\">\n              <i class=\"fa fa-check-circle onboarding-item-heading\" ng-show=\"vm.rokuApp.roku_developer_account_name\"></i>\n              <i class=\"fa fa-circle-o onboarding-item-heading\" ng-hide=\"vm.rokuApp.roku_developer_account_name\"></i>\n              <span class=\"onboarding-item-heading\"><strong>Developer Account:</strong></span>\n            </td>\n            <td>\n              <span ng-show=\"vm.rokuApp.roku_developer_account_name\">You have invited BoxCast to collaborate with your Roku developer account.</span>\n              <span ng-hide=\"vm.rokuApp.roku_developer_account_name\">\n                Please invite BoxCast to collaborate with your Roku developer account.\n                <a href=\"https://support.boxcast.com/en/articles/4298779-linking-developer-accounts-to-boxcast-for-publishing-custom-branded-apps-to-roku-and-apple-tv\" target=\"_blank\">\n                  (<i class=\"fa fa-external-link\"></i> Need help?)\n                </a>\n              </span>\n            </td>\n          </tr>\n          <tr>\n            <td style=\"padding-right: 10px;\">\n              <i class=\"fa fa-check-circle onboarding-item-heading\" ng-hide=\"vm.needPublicRecordedBroadcasts\"></i>\n              <i class=\"fa fa-circle-o onboarding-item-heading\" ng-show=\"vm.needPublicRecordedBroadcasts\"></i>\n              <span class=\"onboarding-item-heading\"><strong>Content:</strong></span>\n            </td>\n            <td>\n              <span ng-show=\"vm.needPublicRecordedBroadcasts\">Please ensure you have public, recorded broadcasts available for app review.</span>\n              <span ng-hide=\"vm.needPublicRecordedBroadcasts\">You have public, recorded broadcasts available for app review.</span>\n            </td>\n          </tr>\n          <tr>\n            <td style=\"padding-right: 10px;\">\n              <i class=\"fa fa-check-circle onboarding-item-heading\" ng-show=\"vm.allRokuFieldsSet()\"></i>\n              <i class=\"fa fa-circle-o onboarding-item-heading\" ng-hide=\"vm.allRokuFieldsSet()\"></i>\n              <span class=\"onboarding-item-heading\"><strong>App Info:</strong></span>\n            </td>\n            <td>\n              <span ng-hide=\"vm.allRokuFieldsSet()\">\n                Please fill out all required app information and images.\n                <a href=\"https://support.boxcast.com/en/articles/4550679-branded-app-fulfillment-process\" target=\"_blank\">\n                  (<i class=\"fa fa-external-link\"></i> Need help?)\n                </a>\n              </span>\n              <span ng-show=\"vm.allRokuFieldsSet()\">You have provided all required app information and images.</span>\n            </td>\n          </tr>\n        </table>\n      </p>\n      <button type=\"button\" class=\"btn\"\n              ng-class=\"vm.rokuApp._ready_to_submit ? 'btn-default' : 'btn-primary'\"\n              ng-click=\"vm.showEditRokuModal()\">\n        Edit Information\n      </button>\n      <button type=\"button\" class=\"btn btn-primary\"\n              ng-click=\"vm.submitToBoxCast('roku', vm.rokuApp)\"\n              ng-disabled=\"!vm.rokuApp._ready_to_submit || vm.rokuApp._submitting\">\n        Submit to BoxCast\n      </button>\n    </div>\n\n    <table class=\"table table-no-border\">\n      <tr>\n        <th>Channel Name</th>\n        <th>Preferred Category</th>\n        <th>Channel Description</th>\n      </tr>\n      <tr>\n        <td>{{vm.rokuApp.channel_name}}</td>\n        <td>{{vm.rokuApp.category}}</td>\n        <td>{{vm.rokuApp.channel_description}}</td>\n      </tr>\n      <tr>\n        <th>Information URL</th>\n        <th>End User Support Contact</th>\n        <th>Web Description</th>\n      </tr>\n      <tr>\n        <td>{{vm.rokuApp.more_information_url}}</td>\n        <td>{{vm.rokuApp.end_user_support_contact}}</td>\n        <td>{{vm.rokuApp.web_description}}</td>\n      </tr>\n      <tr>\n        <th>App Background Color</th>\n      </tr>\n      <tr>\n        <td><color-swatch ng-if=\"vm.rokuApp.app_background_color\" color=\"vm.rokuApp.app_background_color\" label=\"vm.rokuApp.app_background_color\"></color-swatch></td>\n      </tr>\n    </table>\n    <p><strong>Roku App Images</strong></p>\n    <p><small>Roku Apps require a custom set of images. Here's an example of what each asset looks like. Still looking\n      for help? Reach out to support and we can happily walk you through the process.</small></p>\n    <div class=\"table-horiz-scroll-container\">\n      <!--div class=\"scroll-shadow\"></div-->\n      <div class=\"scroll-container\">\n        <table class=\"table table-no-border\">\n          <tr>\n            <td ng-repeat=\"img in vm.rokuImageList()\">\n              <div>{{::img.name}}</div>\n              <fixed-image-preview src=\"::img.src\" height=\"img.preview_h\" width=\"img.preview_w\"></fixed-image-preview>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"well\" ng-if=\"vm.appleTVApp\">\n    <div class=\"pull-right\">\n      <span class=\"label label-{{vm.statusLabelLevel(vm.appleTVApp)}}\"\n            style=\"margin-right:15px\"\n            uib-tooltip=\"{{vm.statusLabelTooltip(vm.appleTVApp)}}\"\n            tooltip-append-to-body=\"true\">\n        {{vm.statusText(vm.appleTVApp)}}\n      </span>\n    </div>\n    <h3>Apple TV App Store Information</h3>\n\n    <div ng-if=\"vm.appleTVApp.status == 'waiting_on_customer'\" class=\"bg-info text-info\" style=\"padding:15px;margin:15px 0;border:1px solid;\">\n      <p>\n        Let's get ready to build your app!\n        You can submit the form to BoxCast once you have filled out all required information, uploaded your images, and\n        we have received your invitation to your Apple Developer account.\n      </p>\n      <p>\n        <table>\n          <tr>\n            <td style=\"padding-right: 10px;\">\n              <i class=\"fa fa-check-circle onboarding-item-heading\" ng-show=\"vm.appleTVApp.apple_developer_account_name\"></i>\n              <i class=\"fa fa-circle-o onboarding-item-heading\" ng-hide=\"vm.appleTVApp.apple_developer_account_name\"></i>\n              <span class=\"onboarding-item-heading\"><strong>Developer Account:</strong></span>\n            </td>\n            <td>\n              <span ng-show=\"vm.appleTVApp.apple_developer_account_name\">You have invited BoxCast to collaborate with your Apple developer account.</span>\n              <span ng-hide=\"vm.appleTVApp.apple_developer_account_name\">\n                Please invite BoxCast to collaborate with your Apple developer account.\n                <a href=\"https://support.boxcast.com/en/articles/4298779-linking-developer-accounts-to-boxcast-for-publishing-custom-branded-apps-to-roku-and-apple-tv\" target=\"_blank\">\n                  (<i class=\"fa fa-external-link\"></i> Need help?)\n                </a>\n              </span>\n            </td>\n          </tr>\n          <tr>\n            <td style=\"padding-right: 10px;\">\n              <i class=\"fa fa-check-circle onboarding-item-heading\" ng-hide=\"vm.needPublicRecordedBroadcasts\"></i>\n              <i class=\"fa fa-circle-o onboarding-item-heading\" ng-show=\"vm.needPublicRecordedBroadcasts\"></i>\n              <span class=\"onboarding-item-heading\"><strong>Content:</strong></span>\n            </td>\n            <td>\n              <span ng-show=\"vm.needPublicRecordedBroadcasts\">Please ensure you have public, recorded broadcasts available for app review.</span>\n              <span ng-hide=\"vm.needPublicRecordedBroadcasts\">You have public, recorded broadcasts available for app review.</span>\n            </td>\n          </tr>\n          <tr>\n            <td style=\"padding-right: 10px;\">\n              <i class=\"fa fa-check-circle onboarding-item-heading\" ng-show=\"vm.allAppleTVFieldsSet()\"></i>\n              <i class=\"fa fa-circle-o onboarding-item-heading\" ng-hide=\"vm.allAppleTVFieldsSet()\"></i>\n              <span class=\"onboarding-item-heading\"><strong>App Info:</strong></span>\n            </td>\n            <td>\n              <span ng-hide=\"vm.allAppleTVFieldsSet()\">\n                Please fill out all required app information and images.\n                <a href=\"https://support.boxcast.com/en/articles/4550679-branded-app-fulfillment-process\" target=\"_blank\">\n                  (<i class=\"fa fa-external-link\"></i> Need help?)\n                </a>\n              </span>\n              <span ng-show=\"vm.allAppleTVFieldsSet()\">You have provided all required app information and images.</span>\n            </td>\n          </tr>\n        </table>\n      </p>\n      <button type=\"button\" class=\"btn\"\n              ng-class=\"vm.appleTVApp._ready_to_submit ? 'btn-default' : 'btn-primary'\"\n              ng-click=\"vm.showEditAppleTVModal()\">\n        Edit Information\n      </button>\n      <button type=\"button\" class=\"btn btn-primary\"\n              ng-click=\"vm.submitToBoxCast('appletv', vm.appleTVApp)\"\n              ng-disabled=\"!vm.appleTVApp._ready_to_submit || vm.appleTVApp._submitting\">\n        Submit to BoxCast\n      </button>\n    </div>\n\n    <table class=\"table table-no-border\">\n      <tr>\n        <th>Name in the App Store</th>\n        <th>Category</th>\n        <th>Keywords</th>\n      </tr>\n      <tr>\n        <td>{{vm.appleTVApp.name}}</td>\n        <td>{{vm.appleTVApp.category}}</td>\n        <td>{{vm.appleTVApp.keywords}}</td>\n      </tr>\n      <tr>\n        <th>Subtitle</th>\n        <th>Promotional Text</th>\n        <th>Description</th>\n      </tr>\n      <tr>\n        <td>{{vm.appleTVApp.subtitle}}</td>\n        <td>{{vm.appleTVApp.promotional_text}}</td>\n        <td>{{vm.appleTVApp.description}}</td>\n      </tr>\n      <tr>\n        <th>Support URL</th>\n        <th>Marketing URL</th>\n      </tr>\n      <tr>\n        <td>{{vm.appleTVApp.support_url}}</td>\n        <td>{{vm.appleTVApp.marketing_url}}</td>\n      </tr>\n    </table>\n    <p><strong>Apple TV App Images</strong></p>\n    <p><small>Apple TV Apps require a custom set of images. Here's an example of what each asset looks like. Still looking\n      for help? Reach out to support and we can happily walk you through the process.</small></p>\n    <div class=\"table-horiz-scroll-container\">\n      <!--div class=\"scroll-shadow\"></div-->\n      <div class=\"scroll-container\">\n        <table class=\"table table-no-border\">\n          <tr>\n            <td ng-repeat=\"img in vm.appleTVImageList()\">\n              <div>{{::img.name}}</div>\n              <fixed-image-preview src=\"::img.src\" height=\"img.preview_h\" width=\"img.preview_w\"></fixed-image-preview>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n\n</main>\n"

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n\n      <div class=\"well\">\n        <h3>Streaming Destinations</h3>\n\n        <div ng-if=\"vm.adBlockerEnabled\">\n          <div class=\"col-md-9 bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\">\n            <strong>It appears as though you have an ad-blocking extension enabled on your browser.</strong> These extensions can often\n            interfere with social media integrations, especially Facebook.  Please disable the ad-blocking extension for\n            dashboard.boxcast.com and refresh this page.\n          </div>\n        </div>\n\n        <div ng-if=\"vm.allAccounts.length == 0\" class=\"text-center\">\n          <h4 class=\"help-block\" style=\"margin:30px auto;\">\n            There are no integrations currently linked to your account.\n          </h4>\n          <button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"vm.showLinkModal()\">\n            &plus; Add Integration\n          </button>\n        </div>\n\n        <div class=\"row\" ng-if=\"vm.allAccounts.length > 0\">\n          <div class=\"col-md-9\">\n            <div ng-repeat=\"a in vm.allAccounts\"\n                 id=\"{{a.type}}-{{a.id}}\"\n                 style=\"margin-bottom:15px\">\n              <div class=\"integration-card integration-{{a.type}} integration-card-{{a.__showDetails?'expanded':'collapsed'}}\">\n                <integration-row-header account=\"a\"\n                                        on-toggle-details=\"vm.onToggleDetails(a)\"\n                                        ></integration-row-header>\n                <div class=\"integration-card-details\" uib-collapse=\"!a.__showDetails\" style=\"\">\n                  <integration-row-details account=\"a\"\n                                           on-edit-rtmp=\"vm.onEditRtmp(a)\"\n                                           on-delete-rtmp=\"vm.onDeleteRtmp(a)\"\n                                           on-delete-link=\"vm.onDeleteLink(a)\"\n                                           on-relink=\"vm.onRelink(a)\"\n                                           ></integration-row-details>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-md-3 text-center\">\n            <p>\n              <button type=\"button\" class=\"btn btn-success btn-lg btn-block\" ng-if=\"::vm.canAddAnyIntegration\" ng-click=\"vm.showLinkModal()\">\n                &plus; Add Integration\n              </button>\n            </p>\n            <div ng-if=\"vm.Facebook.loading\" class=\"help-block\">\n              <hr>\n              <p>\n                <small>\n                  Loading Facebook status...\n                  (Stuck? <a href=\"javascript://\" ng-click=\"vm.fbInit()\">Try again</a>.)\n                </small>\n              </p>\n            </div>\n            <div ng-if=\"vm.Facebook.connected\">\n              <hr>\n              <p>\n                <button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.logoutFacebook()\">\n                  Log out of Facebook\n                </button>\n              </p>\n            </div>\n            <div ng-if=\"vm.usingFirefox\" class=\"bg-info text-info\" style=\"padding:10px;border:1px solid;margin:15px 0;\">\n              Please note, the Facebook Container extension for Firefox can interfere with the integration used for\n              streaming. If you are using this extension and have issues configuring the Facebook integration, please\n              <a href=\"https://support.mozilla.org/en-US/kb/disable-or-remove-add-ons\" target=\"_blank\">disable\n                the the Facebook Container extension</a> and refresh this page.\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"well\" ng-if=\"::($root.account.feature_flags.sportzcast && $root.user.can('read', 'sportzcast-configuration'))\">\n        <h3>Scoreboard Integrations</h3>\n        <div ng-if=\"!vm.sportzcast.username\" class=\"text-center\">\n          <h4 class=\"help-block\" style=\"margin:30px auto;\">\n            There are no scoreboard integrations currently linked to your account.\n          </h4>\n          <button type=\"button\" class=\"btn btn-lg btn-success\" ng-if=\"::$root.user.can('update', 'sportzcast-configuration')\" ng-click=\"vm.onEditSportzcast()\">\n            &plus; Add Scoreboard Integration\n          </button>\n        </div>\n        <div class=\"row\" ng-if=\"vm.sportzcast.username\">\n          <div class=\"col-md-9\">\n            <div id=\"sportzcast-1\" style=\"margin-bottom:15px\">\n              <div class=\"integration-card integration-sportzcast integration-card-{{vm.sportzcast.__showDetails?'expanded':'collapsed'}}\">\n                <integration-row-header account=\"vm.sportzcast\" on-toggle-details=\"vm.onToggleDetails(vm.sportzcast)\" ></integration-row-header>\n                <div class=\"integration-card-details\" uib-collapse=\"!vm.sportzcast.__showDetails\" style=\"\">\n                  <integration-row-details account=\"vm.sportzcast\" on-edit-sportzcast=\"vm.onEditSportzcast()\"></integration-row-details>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var IntegrationsController = /*#__PURE__*/function () {
  function IntegrationsController($rootScope, $scope, Account, toaster, Facebook, YouTubeUser, TwitterUser, RTMPPushChannel, VimeoUser, Broadcast, $q, $uibModal, FacebookUser, $timeout, $state) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, IntegrationsController);

    this.account = $rootScope.account;
    this.user = $rootScope.user;
    this.FeatureFlags = this.account.feature_flags;
    this.$scope = $scope;
    this.Account = Account;
    this.toaster = toaster;
    this.Facebook = Facebook;
    this.YouTubeUser = YouTubeUser;
    this.TwitterUser = TwitterUser;
    this.RTMPPushChannel = RTMPPushChannel;
    this.VimeoUser = VimeoUser;
    this.Broadcast = Broadcast;
    this.$q = $q;
    this.$uibModal = $uibModal;
    this.FacebookUser = FacebookUser;
    this.$timeout = $timeout;
    this.$state = $state;
    this.canAddTwitterUsers = this.user.can('create', 'twitter-user');
    this.canAddAnyIntegration = this.user.can('create', 'facebook-user') || this.user.can('create', 'youtube-user') || this.user.can('create', 'twitter-user') || this.user.can('create', 'vimeo-user') || this.user.can('create', 'rtmp-push-channel');
    this.loadingPromises = [];
    this.expandCurrentFacebookUser = false;
    this.reload();
    this.fbInit(); // Detect traits that can cause social media integration problems

    this.adBlockerEnabled = false;
    blockAdBlock.on(true, function () {
      $timeout(function () {
        return _this.adBlockerEnabled = true;
      }, 0);
    });
    blockAdBlock.check();
    this.usingFirefox = false;

    if (navigator.userAgent.indexOf('Firefox') >= 0) {
      this.usingFirefox = true;
    }
  }

  _createClass(IntegrationsController, [{
    key: "reload",
    value: function reload() {
      var _this2 = this;

      var FacebookUser = this.FacebookUser,
          YouTubeUser = this.YouTubeUser,
          toaster = this.toaster,
          TwitterUser = this.TwitterUser,
          RTMPPushChannel = this.RTMPPushChannel,
          VimeoUser = this.VimeoUser,
          Broadcast = this.Broadcast,
          $q = this.$q,
          user = this.user;
      this.allAccounts = []; // Facebook

      if (user.can('list', 'facebook-users')) {
        this.loadingPromises.push(FacebookUser.query({
          l: 1000
        }).$promise.then(function (users) {
          _this2.facebookAccounts = users;

          _this2.facebookAccounts.forEach(function (a) {
            return a.type = 'facebook';
          });

          _this2.allAccounts = _this2.allAccounts.concat(_this2.facebookAccounts);

          _this2.processFacebookLinkToCurrentUser();
        })["catch"](function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to load your linked Facebook accounts. Please reload this page and try again.');
        }));
      } // YouTube


      if (user.can('list', 'youtube-users')) {
        this.loadingPromises.push(YouTubeUser.query({
          l: 1000
        }).$promise.then(function (users) {
          _this2.youtubeUsers = users;

          _this2.youtubeUsers.forEach(function (u) {
            u.type = 'youtube';
            u.__isYTLiveEnabled__ = _.reduce(u.scope, function (c, s) {
              return c + (s == 'https://www.googleapis.com/auth/youtube' ? 1 : 0);
            }, 0) > 0;
          });

          _this2.allAccounts = _this2.allAccounts.concat(_this2.youtubeUsers);
        })["catch"](function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to load your linked YouTube accounts. Please reload this page and try again.');
        }));
      } // Twitter


      if (user.can('list', 'twitter-users')) {
        this.loadingPromises.push(TwitterUser.query({
          l: 1000
        }).$promise.then(function (users) {
          _this2.twitterUsers = users;

          _this2.twitterUsers.forEach(function (a) {
            return a.type = 'twitter';
          });

          _this2.allAccounts = _this2.allAccounts.concat(_this2.twitterUsers);
        })["catch"](function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to load your linked X accounts. Please reload this page and try again.');
        }));
      } // Vimeo


      if (user.can('list', 'vimeo-users')) {
        this.loadingPromises.push(VimeoUser.query({
          l: 1000
        }).$promise.then(function (users) {
          _this2.vimeoUsers = users;

          _this2.vimeoUsers.forEach(function (a) {
            return a.type = 'vimeo';
          });

          _this2.allAccounts = _this2.allAccounts.concat(_this2.vimeoUsers);
        })["catch"](function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to load your linked Vimeo accounts. Please reload this page and try again.');
        }));
      } // RTMP Push


      if (user.can('list', 'rtmp-push-channels')) {
        this.loadingPromises.push(RTMPPushChannel.query({
          l: 1000
        }).$promise.then(function (channels) {
          _this2.rtmpPushChannels = channels;

          _this2.rtmpPushChannels.forEach(function (a) {
            return a.type = 'rtmp_push';
          });

          _this2.allAccounts = _this2.allAccounts.concat(_this2.rtmpPushChannels);
        })["catch"](function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to load your destinations. Please reload this page and try again.');
        }));
      } // All Live Broadcasts ... to use to see which simulcast implementations are active,
      // so we need to get each live one in *show* scope, not *list* scope


      this.loadingPromises.push($q(function (resolve, reject) {
        Broadcast.query({
          q: 'timeframe:current',
          l: 100
        }, function (broadcasts) {
          $q.all(broadcasts.map(function (b) {
            var broadcast = Broadcast.get({
              id: b.id
            });
            return broadcast.$promise;
          })).then(function (broadcasts) {
            _this2.broadcasts = broadcasts;
            resolve(broadcasts);
          })["catch"](function (err) {
            reject(err);
          });
        }, function (err) {
          return reject(err);
        });
      })); // Sportzcast configuration is modeled as an integration

      if (this.FeatureFlags.sportzcast && this.user.can('read', 'sportzcast-configuration')) {
        this.sportzcast = this.Account.getSportzcast(function () {
          // Work with <integration-row> components
          _this2.sportzcast.type = 'sportzcast';
          _this2.sportzcast.hideStatusDot = true;
          _this2.sportzcast.display_name = "ScoreBOT";
          _this2.sportzcast.display_subtitle = "Username ".concat(_this2.sportzcast.username);
        });
        this.loadingPromises.push(this.sportzcast.$promise);
      } // Once everything is done loading, match up the live broadcast configurations with the
      // linked social accounts;


      $q.all(this.loadingPromises).then(function () {
        _this2.allAccounts.forEach(function (a) {
          // Normalize display_name across various configuration types
          a.display_name = a.display_name || a.fb_user_name || a.name;
        });

        _this2.broadcasts.forEach(function (b) {
          b.simulcast_configurations.forEach(function (c) {
            if (c.destination == 'facebook') {
              _this2.facebookAccounts.forEach(function (a) {
                if (a.id == c.facebook_account_id) {
                  a.details = a.details || [];
                  a.details.push(b);
                }
              });
            } else if (c.destination == 'youtube') {
              _this2.youtubeUsers.forEach(function (a) {
                if (a.id == c.youtube_account_id) {
                  a.details = a.details || [];
                  a.details.push(b);
                }
              });
            } else if (c.destination == 'twitter') {
              _this2.twitterUsers.forEach(function (a) {
                if (a.id == c.twitter_account_id) {
                  a.details = a.details || [];
                  a.details.push(b);
                }
              });
            } else if (c.destination == 'rtmp_push_channel') {
              _this2.rtmpPushChannels.forEach(function (a) {
                if (a.id == c.rtmp_push_channel_id) {
                  a.details = a.details || [];
                  a.details.push(b);
                }
              });
            }
          });
        });

        _this2.allAccounts = _.sortBy(_this2.allAccounts, function (a) {
          var hasActivePrefix = a.details && a.details.length ? '0' : '1';
          return "".concat(hasActivePrefix, "-").concat(a.display_name, "-").concat(a.type);
        });
        var integrationID = _this2.$state.params.integration_id;

        if (integrationID) {
          var scrollToID;

          var _iterator = _createForOfIteratorHelper(_this2.allAccounts),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var a = _step.value;

              if (a.id == integrationID) {
                a.__showDetails = true;
                scrollToID = "#".concat(a.type, "-").concat(a.id);
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          if (scrollToID) {
            _this2.$timeout(function () {
              $('html, body').animate({
                scrollTop: $(scrollToID).offset().top - 100
              });
            }, 10);
          }
        }
      });
    }
  }, {
    key: "processFacebookLinkToCurrentUser",
    value: function processFacebookLinkToCurrentUser() {
      var _this3 = this;

      this.allAccounts.forEach(function (a) {
        if (a.type == 'facebook' && _this3.Facebook.connected && _this3.Facebook.me.id === a.fb_user_id) {
          a.pages_managed = _this3.Facebook.accounts;

          if (_this3.expandCurrentFacebookUser) {
            a.__showDetails = true;

            _this3.$timeout(function () {
              $('html, body').animate({
                scrollTop: $("#".concat(a.type, "-").concat(a.id)).offset().top - 100
              });
            }, 10);
          }
        } else {
          a.pages_managed = null;
        }
      });
    }
  }, {
    key: "showLinkModal",
    value: function showLinkModal() {
      var _this5 = this;

      var $uibModal = this.$uibModal,
          Facebook = this.Facebook,
          FeatureFlags = this.FeatureFlags,
          toaster = this.toaster,
          user = this.user;
      var parentVM = this;
      $uibModal.open({
        template: __webpack_require__(457),
        controller: function controller($uibModalInstance, $scope) {
          'ngInject';

          var _this4 = this;

          this.user = user;
          this.FeatureFlags = FeatureFlags;

          this.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };

          this.linkFacebook = function () {
            Facebook.login().then(function () {
              $scope.$evalAsync(function () {
                parentVM.expandCurrentFacebookUser = true;
                parentVM.fbInit();
                parentVM.reload();

                _this4.cancel();
              });

              if (Facebook.connected) {
                toaster.pop('success', "Linked Facebook account.");
              } else {
                toaster.pop('warning', 'Unable to link the Facebook account');
              }
            })["catch"](function (err) {
              toaster.pop('warning', 'Unable to link the Facebook account');
              remoteLogger.error('Error linking Facebook account', {
                error: err
              });
            });
          };

          this.addRtmp = function () {
            _this4.cancel();

            parentVM.onAddRtmp();
          };
        },
        controllerAs: 'vm'
      }).result.then(function (r) {
        _this5.reload();
      });
    }
  }, {
    key: "onToggleDetails",
    value: function onToggleDetails(a) {
      if (a.__showDetails) {
        a.__showDetails = false;
      } else {
        a.__showDetails = true;
      }
    }
  }, {
    key: "onDeleteLink",
    value: function onDeleteLink(a) {
      var _this6 = this;

      var Facebook = this.Facebook,
          FacebookUser = this.FacebookUser,
          toaster = this.toaster,
          YouTubeUser = this.YouTubeUser,
          VimeoUser = this.VimeoUser,
          TwitterUser = this.TwitterUser;

      if (a.type == 'facebook') {
        if (!confirm('Are you sure you want to unlink the account? Any future events linked to this account will not stream to Facebook.')) {
          return false;
        }

        var deleteLinkedAccount = function deleteLinkedAccount() {
          FacebookUser["delete"]({
            id: a.id
          }).$promise.then(function () {
            toaster.pop('success', 'Deleted linked Facebook account.');

            _this6.reload();
          })["catch"](function (err) {
            console.error(err);
            toaster.pop('warning', 'Unable to delete your linked Facebook account. Please reload this page and try again.');
          });
        };

        if (Facebook.connected && Facebook.me.id == a.fb_user_id) {
          Facebook.logout().then(deleteLinkedAccount);
        } else {
          deleteLinkedAccount();
        }
      }

      if (a.type == 'youtube') {
        if (!confirm('Are you sure you want to unlink the account? Any future events linked to this account will not stream to YouTube.')) {
          return false;
        }

        YouTubeUser["delete"]({
          id: a.id
        }, function () {
          toaster.pop('success', 'Deleted linked YouTube account.');

          _this6.reload();
        }, function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to delete your linked YouTube account. Please reload this page and try again.');
        });
      }

      if (a.type == 'twitter') {
        if (!confirm('Are you sure you want to unlink the account?')) {
          return false;
        }

        TwitterUser["delete"]({
          id: a.id
        }, function () {
          toaster.pop('success', 'Deleted linked X account.');

          _this6.reload();
        }, function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to delete your linked X account. Please reload this page and try again.');
        });
      }

      if (a.type == 'vimeo') {
        if (!confirm('Are you sure you want to unlink the account?')) {
          return false;
        }

        VimeoUser["delete"]({
          id: a.id
        }, function () {
          toaster.pop('success', 'Deleted linked Vimeo account.');

          _this6.reload();
        }, function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to delete your linked Vimeo account. Please reload this page and try again.');
        });
      }
    }
  }, {
    key: "onDeleteRtmp",
    value: function onDeleteRtmp(a) {
      var _this7 = this;

      var RTMPPushChannel = this.RTMPPushChannel,
          toaster = this.toaster;

      if (!confirm('Are you sure you want to delete this destination? This will also unlink it from any broadcasts that use it.')) {
        return false;
      }

      RTMPPushChannel["delete"]({
        id: a.id
      }, function () {
        toaster.pop('success', 'Deleted destination.');

        _this7.reload();
      }, function (err) {
        console.error(err);
        toaster.pop('warning', 'Unable to delete your destination. Please reload this page and try again.');
      });
    }
  }, {
    key: "onRelink",
    value: function onRelink(a) {
      var _this8 = this;

      var $scope = this.$scope,
          $state = this.$state,
          Facebook = this.Facebook,
          toaster = this.toaster;

      if (a.type == 'facebook') {
        Facebook.login().then(function () {
          $scope.$evalAsync(function () {
            _this8.expandCurrentFacebookUser = true;

            _this8.fbInit();

            _this8.reload();
          });

          if (Facebook.connected) {
            var fb_name = _this8.allAccounts.find(function (x) {
              return x.id == Facebook.facebook_account_id;
            }).fb_user_name;

            toaster.pop('success', "Relinked Facebook account: ".concat(fb_name));
          } else {
            toaster.pop('warning', "Facebook account was not relinked.");
          }
        });
      } else {
        $state.go("settings.".concat(a.type), {
          link: 1
        });
      }
    }
  }, {
    key: "onEditSportzcast",
    value: function onEditSportzcast() {
      var _this9 = this;

      var $uibModal = this.$uibModal,
          Account = this.Account;
      $uibModal.open({
        template: __webpack_require__(458),
        controller: __webpack_require__(459)["default"],
        controllerAs: 'vm',
        resolve: {
          sportzcast: function sportzcast() {
            return _this9.sportzcast;
          }
        }
      }).result.then(function (r) {
        _this9.reload();
      });
    }
  }, {
    key: "onEditRtmp",
    value: function onEditRtmp(a) {
      var _this10 = this;

      var $uibModal = this.$uibModal,
          RTMPPushChannel = this.RTMPPushChannel;
      $uibModal.open({
        template: __webpack_require__(33),
        controller: __webpack_require__(34)["default"],
        controllerAs: 'vm',
        resolve: {
          mode: function mode() {
            return 'edit';
          },
          config: function config() {
            return a;
          }
        }
      }).result.then(function (r) {
        _this10.reload();
      });
    }
  }, {
    key: "onAddRtmp",
    value: function onAddRtmp() {
      var _$uibModal$open,
          _this11 = this;

      var $uibModal = this.$uibModal,
          RTMPPushChannel = this.RTMPPushChannel;
      $uibModal.open((_$uibModal$open = {
        controllerAs: 'vm',
        template: __webpack_require__(33),
        controller: __webpack_require__(34)["default"]
      }, _defineProperty(_$uibModal$open, "controllerAs", 'vm'), _defineProperty(_$uibModal$open, "resolve", {
        mode: function mode() {
          return 'add';
        },
        config: function config() {
          return {
            max_resolution: 0
          };
        }
      }), _$uibModal$open)).result.then(function (r) {
        _this11.reload();
      });
    }
  }, {
    key: "logoutFacebook",
    value: function logoutFacebook() {
      var _this12 = this;

      this.Facebook.logout().then(function () {
        return _this12.reload();
      });
    }
  }, {
    key: "fbInit",
    value: function fbInit() {
      var _this13 = this;

      this.Facebook.init().then(function () {
        if (_this13.expandCurrentFacebookUser) {
          return _this13.Facebook.loadStatus({
            force: true
          });
        }
      }).then(function () {
        _this13.$timeout(function () {
          _this13.processFacebookLinkToCurrentUser();
        }, 50); //wait 50ms because Facebook.accounts doesn't appear to be there in some cases

      })["catch"](function (e) {
        remoteLogger.error('Error initializing Facebook API', {
          error: e
        });

        _this13.toaster.pop('warning', 'Error initializing Facebook API');
      });
    }
  }]);

  return IntegrationsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (IntegrationsController);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n  <div class=\"modal-header\">\n    <a href class=\"pull-right\" ng-click=\"vm.cancel()\" title=\"Close Dialog\"><i class=\"fa fa-times\"></i></a>\n    <h3 class=\"modal-title\">Add an Integration</h3>\n  </div>\n  <div class=\"modal-body add-integration\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <ul class=\"list-unstyled\">\n          <li ng-if=\"::vm.user.can('create', 'facebook-user')\">\n            <button class=\"btn btn-default btn-lg btn-block\" ng-click=\"vm.linkFacebook()\">\n              <span class=\"pull-left integration-badge integration-badge--facebook\">\n                <i class=\"fa fa-facebook\"></i>\n              </span>\n              Facebook\n              <i class=\"pull-right fa fa-caret-right\"></i>\n            </button>\n          </li>\n          <li ng-if=\"::vm.user.can('create', 'youtube-user')\">\n            <a class=\"btn btn-default btn-lg btn-block\" ui-sref=\"settings.youtube({link: 1})\" ng-click=\"vm.cancel()\">\n              <span class=\"pull-left integration-badge integration-badge--youtube\">\n                <i class=\"fa fa-youtube-play\"></i>\n              </span>\n              YouTube\n              <i class=\"pull-right fa fa-caret-right\"></i>\n            </a>\n          </li>\n          <li ng-if=\"::vm.user.can('create', 'twitter-user')\">\n            <a class=\"btn btn-default btn-lg btn-block\" ui-sref=\"settings.twitter({link: 1})\" ng-click=\"vm.cancel()\">\n              <span class=\"pull-left integration-badge integration-badge--twitter\">\n                <i class=\"fa-brands fa-x-twitter\"></i>\n              </span>\n              X\n              <span>(Premium Subscription Required)</span>\n              <i class=\"pull-right fa fa-caret-right\"></i>\n            </a>\n          </li>\n          <li ng-if=\"::vm.user.can('create', 'vimeo-user')\">\n            <a class=\"btn btn-default btn-lg btn-block\" ui-sref=\"settings.vimeo({link: 1})\" ng-click=\"vm.cancel()\">\n              <span class=\"pull-left integration-badge integration-badge--vimeo\">\n                <i class=\"fa fa-vimeo\"></i>\n              </span>\n              Vimeo\n              <i class=\"pull-right fa fa-caret-right\"></i>\n            </a>\n          </li>\n          <li ng-if=\"::vm.user.can('create', 'rtmp-push-channel')\">\n            <button class=\"btn btn-default btn-lg btn-block\" ng-click=\"vm.addRtmp()\">\n              <span class=\"pull-left integration-badge integration-badge--rtmp_push\">\n                <span>RTMP Push</span>\n              </span>\n              RTMP Destination\n              <i class=\"pull-right fa fa-caret-right\"></i>\n            </button>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n</form>\n"

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n    <h3 class=\"modal-title\">Edit Sportzcast Settings</h3>\n  </div>\n  <div class=\"modal-body\" ng-if=\"::($root.account.feature_flags.sportzcast && $root.user.can('update', 'sportzcast-configuration'))\">\n\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <div class=\"form-group\">\n          <label for=\"sportzcastUsername\">SportzCast Username <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n          <input type=\"text\" class=\"form-control\" id=\"sportzcastUsername\" name=\"sportzcastUsername\" ng-model=\"vm.sportzcast.username\" ng-maxlength=\"::vm.limits.username\" required>\n          <p ng-show=\"(form.sportzcastUsername.$dirty || form.sportzcastUsername.$touched) && !vm.sportzcast.username\">\n            <span class=\"text-danger\" ng-if=\"form.sportzcastUsername.$error.maxlength\">The username is too long.</span>\n            <span class=\"text-danger\" ng-if=\"form.sportzcastUsername.$error.required\">The username cannot be blank.</span>\n          </p>\n        </div>\n        <div ng-if=\"!vm.previouslyEnabledSportzcast\">\n          <div class=\"form-group\">\n            <label for=\"password\">SportzCast Password <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <input type=\"password\" class=\"form-control\" id=\"password\" ng-model=\"vm.sportzcast.password\" required>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"password_confirm\">Confirm Password <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <input type=\"password\" class=\"form-control\" id=\"password_confirm\" ng-model=\"vm.passwordConfirm\" required>\n          </div>\n        </div>\n        <div ng-if=\"vm.previouslyEnabledSportzcast\">\n          <p>\n            <a href=\"javascript://\" ng-click=\"vm.showChangePassword = !vm.showChangePassword\">\n              Update SportzCast Password\n            </a>\n          </p>\n          <div class=\"well\" ng-if=\"vm.showChangePassword == true\">\n            <div class=\"form-group\">\n              <label for=\"password\">SportzCast Password <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n              <input type=\"password\" class=\"form-control\" id=\"password\" ng-model=\"vm.sportzcast.password\" required>\n            </div>\n            <div class=\"form-group\">\n              <label for=\"password_confirm\">Confirm Password <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n              <input type=\"password\" class=\"form-control\" id=\"password_confirm\" ng-model=\"vm.passwordConfirm\" required>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n  <div class=\"modal-footer\">\n      <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n      <button ng-disabled=\"saving\"\n              ng-click=\"vm.update()\"\n              class=\"btn btn-primary\">\n        <i ng-show=\"saving\" class=\"fa fa-spin fa-spinner\"></i>\n        Update Settings\n      </button> \n  </div>\n</form>\n\n"

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalEditSportzcast;
function ModalEditSportzcast(sportzcast, Account, $rootScope, toaster, $uibModalInstance) {
  'ngInject';

  var _this = this;

  var account = $rootScope.account; // passed in via `resolve`

  this.sportzcast = angular.copy(sportzcast);

  this.cancel = function () {
    return $uibModalInstance.dismiss();
  };

  this.limits = $rootScope.ApiConfig.modelFieldLimits('sportzcast_integration', 'maximum');
  this.showChangePassword = false;
  this.previouslyEnabledSportzcast = !!sportzcast.username;
  this.passwordConfirm = '';

  this.update = function () {
    // SportzCast validation
    var data = {
      username: _this.sportzcast.username
    };

    if (!data.username) {
      toaster.pop('warning', 'SportzCast username is required');
      return;
    }

    if (!_this.previouslyEnabledSportzcast || _this.showChangePassword) {
      if (!_this.sportzcast.password) {
        toaster.pop('warning', 'SportzCast password is required');
        return;
      }

      if (_this.sportzcast.password != _this.passwordConfirm) {
        toaster.pop('warning', 'SportzCast passwords do not match');
        return;
      }

      data.password = _this.sportzcast.password;
    } // Update common scoreboard settings separate from SportzCast


    _this.submitting = true;
    Account.updateSportzcast({
      id: account.id
    }, data).$promise.then(function (r) {
      $uibModalInstance.close(r);
    })["catch"](function (err) {
      console.error(e);
      toaster.pop('warning', 'Unable to save Sportzcast configuration. Please refresh and try again.');
      _this.submitting = false;
    });
  };
}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <p class=\"help-block\">\n        Please wait while you are redirected.\n        If you are stuck here, <a ui-sref=\"settings.integrations\">return to the integrations page</a>.\n        </p>\n      </div>\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FacebookSettingsController = /*#__PURE__*/_createClass(function FacebookSettingsController($state) {
  'ngInject';

  _classCallCheck(this, FacebookSettingsController);

  $state.go('settings.integrations');
});

/* harmony default export */ __webpack_exports__["default"] = (FacebookSettingsController);

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <p class=\"help-block\">\n        Please wait while your account link is processed.\n        If you are stuck here, <a ui-sref=\"settings.integrations\">return to the integrations page</a>.\n        </p>\n      </div>\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var GOOGLE_EMAIL_SCOPE = 'email';
var GOOGLE_PROFILE_SCOPE = 'profile';
var GOOGLE_AUTH_SCOPES = [GOOGLE_EMAIL_SCOPE, GOOGLE_PROFILE_SCOPE, YOUTUBE_SCOPE, YOUTUBE_ANALYTICS_SCOPE];
var GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth';

var YouTubeSettingsController = /*#__PURE__*/function () {
  function YouTubeSettingsController(YouTubeUser, toaster, $state, $timeout) {
    'ngInject';

    _classCallCheck(this, YouTubeSettingsController);

    this.YouTubeUser = YouTubeUser;
    this.toaster = toaster;
    this.$state = $state;
    this.youtubeUsers = []; // If this page was loaded with `code`

    var code = $state.params.code,
        error = $state.params.error;

    if (code) {
      this.addCode(code);
    } else if (error) {
      var error_message = "Unable to link the requested YouTube account (YouTube said: \"".concat(error, "\"). Please try again.");

      if (error == 'access_denied') {
        error_message = 'Unable to link the requested YouTube account, as access was denied. Please try again.';
      }

      $timeout(function () {
        return toaster.pop('warning', error_message);
      }, 0);
    } else if ($state.params.link) {
      this.linkAccount();
    } else {
      $state.go('settings.integrations');
    }
  }

  _createClass(YouTubeSettingsController, [{
    key: "addCode",
    value: function addCode(code) {
      var YouTubeUser = this.YouTubeUser,
          toaster = this.toaster,
          $state = this.$state; // Ask the API to get the token for this code and redirect_uri

      var user = new YouTubeUser({
        code: code,
        redirect_uri: YOUTUBE_OAUTH_REDIRECT
      });
      var promise = user.$save().then(function (u) {
        toaster.pop('success', 'Successfully linked YouTube account.');
        $state.go('settings.integrations', {
          integration_id: u.id
        });
      })["catch"](function (err) {
        console.error(err);

        if (err.status == 422 && err.data && err.data.invalid_fields && err.data.invalid_fields.refresh_token) {
          toaster.pop('warning', 'Unable to link the requested YouTube account. Is it already linked?');
        } else {
          toaster.pop('warning', 'Unable to link the requested YouTube account. Please reload this page and try again.');
        }

        $state.go('settings.integrations');
      });
      this.loadingPromises = [promise];
    }
  }, {
    key: "linkAccount",
    value: function linkAccount() {
      var authParams = {
        client_id: YOUTUBE_CLIENT_ID,
        redirect_uri: YOUTUBE_OAUTH_REDIRECT,
        scope: GOOGLE_AUTH_SCOPES.join(' '),
        response_type: 'code',
        access_type: 'offline',
        prompt: 'consent'
      };
      var queryStr = Object.keys(authParams).map(function (k) {
        return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(authParams[k]));
      }).join('&');
      window.location.replace("".concat(GOOGLE_AUTH_URL, "?").concat(queryStr));
    }
  }]);

  return YouTubeSettingsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (YouTubeSettingsController);

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <p class=\"help-block\">\n        Please wait while your account link is processed.\n        If you are stuck here, <a ui-sref=\"settings.integrations\">return to the integrations page</a>.\n        </p>\n      </div>\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var VIMEO_AUTH_URL = 'https://api.vimeo.com/oauth/authorize';

var VimeoSettingsController = /*#__PURE__*/function () {
  function VimeoSettingsController(VimeoUser, toaster, $state) {
    'ngInject';

    _classCallCheck(this, VimeoSettingsController);

    this.VimeoUser = VimeoUser;
    this.toaster = toaster;
    this.$state = $state;
    this.vimeoUsers = []; // If this page was loaded with `code`

    var code = $state.params.code;

    if (code) {
      this.addCode(code);
    } else if ($state.params.link) {
      this.linkAccount();
    } else {
      $state.go('settings.integrations');
    }
  }

  _createClass(VimeoSettingsController, [{
    key: "addCode",
    value: function addCode(code) {
      var VimeoUser = this.VimeoUser,
          toaster = this.toaster,
          $state = this.$state; // Ask the API to get the token for this code and redirect_uri

      var user = new VimeoUser({
        code: code,
        redirect_uri: VIMEO_OAUTH_REDIRECT
      });
      var promise = user.$save().then(function (u) {
        $state.go('settings.integrations', {
          integration_id: u.id
        });
      })["catch"](function (err) {
        console.error(err);
        toaster.pop('warning', 'Unable to link the requested Vimeo account. Please reload this page and try again.');
      });
      this.loadingPromises = [promise];
    }
  }, {
    key: "linkAccount",
    value: function linkAccount() {
      var authParams = {
        response_type: 'code',
        client_id: VIMEO_CLIENT_ID,
        redirect_uri: VIMEO_OAUTH_REDIRECT,
        scope: VIMEO_SCOPE,
        state: 'vimeo'
      };
      var queryStr = Object.keys(authParams).map(function (k) {
        return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(authParams[k]));
      }).join('&');
      window.location.replace("".concat(VIMEO_AUTH_URL, "?").concat(queryStr));
    }
  }]);

  return VimeoSettingsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (VimeoSettingsController);

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\"\n  cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n\n  <div class=\"row\" ng-if=\"!vm.loading && (vm.upgradesAvailable && !vm.upgradesAvailable.length) && (vm.subscriptions && !vm.subscriptions.length)\">\n    <div class=\"col-sm-12\">\n      <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\">\n        Your account does not have an active subscription.  Please contact <a href=\"mailto:questions@boxcast.com\">questions@boxcast.com</a> or call <a href=\"tel:888-392-2278\">(888) 392-2278</a>.\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-sm-12\"\n      ng-if=\"(vm.upgradesAvailable && !vm.upgradesAvailable.length) && vm.account.isTrialing() && (!vm.billing || vm.billing.payment_method == 'other')\">\n      <div class=\"well\">\n        <h3>Proposals</h3>\n        <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\">\n          <small>\n            Your trial expires on {{vm.account.expires_on | date}}. Your proposal to continue streaming should be\n            available here shortly. If you would like to begin sooner, please contact <a\n              href=\"mailto:questions@boxcast.com\">questions@boxcast.com</a> or call <a href=\"tel:888-392-2278\">(888) 392-2278</a>.\n          </small>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-sm-12\" ng-if=\"vm.upgradesAvailable && vm.upgradesAvailable.length\">\n      <div class=\"well\">\n        <h3>Proposals</h3>\n        <div ng-if=\"vm.account.status == 'initial' && vm.account.isTrialing()\">\n          <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\">\n            <small>\n              Your trial expires on {{vm.account.expires_on | date}}. Review your proposal to ensure uninterrupted\n              service.\n            </small>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-8\">\n            <table class=\"table table-noborders\" style=\"margin:0 0 0 0;padding-bottom:0;\">\n              <thead>\n                <tr>\n                  <th style=\"width:40%\">Name</th>\n                  <th style=\"width:20%\">Date</th>\n                  <th></th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"u in vm.upgradesAvailable\">\n                  <td>{{u.name}}</td>\n                  <td>{{u.created_at|date}}</td>\n                  <td class=\"text-left\">\n                    <button class=\"btn btn-default btn-sm\" ng-if=\"::vm.canEditPaymentSettings\" ng-click=\"vm.review(u.pandadoc_id, u.share_id)\">Review <i class=\"fa fa-caret-right\"></i></button>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-sm-12\" ng-if=\"vm.outstandingInvoices.length\">\n      <div class=\"well\">\n        <h3>Outstanding Payments</h3>\n        <div class=\"row\">\n          <div class=\"col-sm-8\">\n            <div ng-if=\"vm.daysUntilSuspend > 0\" class=\"bg-warning text-warning\"\n              style=\"padding:10px;border:1px solid;margin-bottom:5px;\">\n              Your account will be suspended if payment is not received in {{vm.daysUntilSuspend}} day(s).\n            </div>\n            <table class=\"table table-condensed table-noborders\">\n              <thead>\n                <tr>\n                  <th>Due On</th>\n                  <th>Status</th>\n                  <th class=\"text-right\">Balance</th>\n                  <th></th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"inv in vm.outstandingInvoices\">\n                  <td>{{(inv.due_date*1000) | date}}</td>\n                  <td ng-switch=\"inv.detailedStatus\">\n                    <span ng-switch-when=\"failed\" class=\"label label-danger\">\n                      Failed Payment\n                    </span>\n                    <span ng-switch-when=\"pending\" class=\"label label-default\">\n                      Payment Pending\n                    </span>\n                    <span ng-switch-when=\"awaiting_payment\">\n                      <span ng-show=\"inv.days_past_due > 0\" class=\"label label-warning\" style=\"margin-right:5px\">\n                        {{inv.days_past_due}} Days Past Due\n                      </span>\n                      <span ng-show=\"vm.billing.payment_method == 'check'\" class=\"label label-default\">\n                        Awaiting Check\n                      </span>\n                      <span ng-show=\"vm.billing.payment_method == 'po'\" class=\"label label-default\">\n                        Awaiting Purchase Order\n                      </span>\n                      <span\n                        ng-show=\"!inv.past_due && vm.billing.payment_method != 'po' && vm.billing.payment_method != 'check'\"\n                        class=\"label label-default\">\n                        Awaiting Payment\n                      </span>\n                    </span>\n                    <span ng-switch-default class=\"label label-default\">\n                      Awaiting Payment\n                    </span>\n                  </td>\n                </div>\n                <td class=\"text-right\">{{(inv.amount_due / 100) | currency}}</td>\n                <td class=\"text-right\">\n                  <a ng-if=\"inv.hosted_invoice_url\" href=\"{{inv.hosted_invoice_url}}\" target=\"_blank\">\n                    <strong>View invoice <i class=\"fa fa-external-link\"></i></strong>\n                  </a>\n                  <span ng-if=\"inv.status == 'draft' && inv.closed\">\n                    <i class=\"fa fa-exclamation-circle\" \n                      tooltip-placement=\"top\"\n                      tooltip-append-to-body=\"true\"\n                      uib-tooltip=\"This invoice is not currently payable. Please contact us at billing@boxcast.com or (888) 392-2278.\"></i>\n                  </span>\n                  <span ng-if=\"inv.usage && inv.usage.length > 0\" ng-repeat=\"usage in inv.usage\">\n                    &nbsp;|&nbsp;\n                    <a\n                      href=\"javascript://\"\n                      ng-click=\"vm.showUsageSummary(usage.subscriptionItemId, usage.plan, usage.periodStart, usage.periodEnd)\">\n                      View {{usage.type | usageType}} usage\n                    </a>\n                  </span>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div ng-hide=\"!vm.subscriptions || vm.account.isTrialing()\" class=\"col-sm-12\">\n    <div class=\"well\">\n      <h3>Current Subscription</h3>\n      <p ng-if=\"!vm.subscriptions.length\">\n        You currently do not have an active subscription.\n      </p>\n      <div class=\"row\">\n        <div class=\"col-sm-8\">\n          <div ng-if=\"vm.subscriptions.length\" ng-repeat=\"sub in vm.subscriptions\">\n            <div ng-if=\"vm.subscriptions.length > 1\">\n              <hr ng-if=\"$index > 0\">\n              <h4>Subscription {{$index + 1}}</h4>\n            </div>\n            <table class=\"table table-noborders table-condensed\">\n              <tbody>\n                <tr ng-repeat=\"item in sub.items.data\">\n                  <th style=\"width:60%\">\n                    <span ng-if=\"item.plan.quantity != 1\">{{item.plan.quantity}} x </span>{{item.plan.name}}\n                  </th>\n                  <td ng-show=\"item.plan.usage_type != 'metered'\" class=\"text-left\">\n                    {{(item.plan.quantity * item.plan.amount / 100) | currency}}/{{item.plan.interval}}\n                    <span ng-if=\"item.plan.interval == 'month'\" class=\"text-muted\">\n                      | {{(item.plan.quantity * item.plan.amount * 12 / 100) | currency}} annually\n                    </span>\n                  </td>\n                  <td ng-show=\"item.plan.usage_type == 'metered'\" class=\"text-left\">\n                    <a href=\"javascript://\" ng-click=\"vm.showUsageSummary(item.id, item.plan, sub.current_period_start, null)\">\n                      View usage\n                    </a>\n                  </td>\n                </tr>\n                <tr ng-if=\"sub.discount && sub.discount.coupon\">\n                  <th style=\"width:60%\">\n                    Discount\n                  </th>\n                  <td class=\"text-left\">\n                    -{{(sub.discount.coupon.amount_off / 100) | currency}}{{vm.isBilledMonthly ? '/month' : '/year'}}\n                    <span ng-if=\"vm.isBilledMonthly\" class=\"text-muted\">\n                        | {{(sub.discount.coupon.amount_off * 12 / 100) | currency}} annually\n                    </span>\n                  </td>\n                </tr>\n              </tbody>\n              <tfoot>\n                <tr>\n                  <th>Next Payment</th>\n                  <td>\n                    {{(sub.total_amount / 100) | currency}} <span ng-show=\"sub.hasUsage\"> + usage </span>on {{sub.current_period_end * 1000 | date}}\n                  </td>\n                </tr>\n                <tr ng-if=\"sub.annual_renewal\">\n                  <th>Annual Contract Renew</th>\n                  <td>{{sub.annual_renewal | date}}</td>\n                </tr>\n              </tfoot>\n            </table>\n          </div>\n        </div>\n        <div ng-if=\"vm.canEditPaymentSettings && vm.subscriptions.length\" class=\"col-sm-4\">\n          <p>\n            Need help? \n            <span ng-if=\"vm.canChat\">\n              <a href=\"javascript://\" ng-click=\"vm.onLetsChat()\" ng-if=\"vm.canChat\">Talk to us</a>\n              or\n            </span> \n            <a href=\"https://support.boxcast.com/en/articles/8663328\" target=\"_blank\">\n              <span ng-if=\"vm.canChat\">learn</span>\n              <span ng-if=\"!vm.canChat\">Learn</span>\n              how to adjust your plan</a>.\n          </p>\n          <p ng-show=\"!vm.isPremium\" class=\"text-right\">\n            <button class=\"btn btn-default btn-block\" ng-click=\"vm.doChangePlan()\" style=\"max-width:250px\">\n              Upgrade Plan\n            </button>\n          </p>\n          <p ng-show=\"!vm.isPremium && !vm.isFree\" class=\"text-right\">\n            <button class=\"btn btn-default btn-block\" ng-click=\"vm.doPurchaseAddons()\" style=\"max-width:250px\">\n              Purchase Add-Ons\n            </button>\n          </p>\n          <p class=\"text-right\">\n            <button ng-click=\"vm.showActivationModal()\" class=\"btn btn-default btn-block\" style=\"max-width:250px\">\n              Activation Codes\n            </button>\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.billing\" class=\"col-sm-12\">\n    <div class=\"well\">\n      <div class=\"pull-right\" ng-if=\"::vm.canEditPaymentSettings\">\n        <a href=\"javascript://\" ng-click=\"vm.showEditPaymentModal()\">\n          Edit <i class=\"fa fa-pencil-square-o\"></i>\n        </a>\n      </div>\n      <h3>Payment Information</h3>\n      <div class=\"row\">\n        <div class=\"col-sm-8\">\n          <div ng-if=\"vm.billing.payment_method == 'activation' && vm.accountExpired\" class=\"bg-danger text-danger\"\n            style=\"padding:10px;border:1px solid;margin-bottom:5px;\">\n            Your activation code has expired. Please \n            <a href=\"javascript://\" ng-click=\"vm.showEditPaymentModal()\" style=\"border-bottom:1px dotted;\">add a payment source</a> \n            to ensure uninterrupted service.\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'activation' && !vm.accountExpired && vm.accountExpiresSoon\" class=\"bg-warning text-warning\"\n            style=\"padding:10px;border:1px solid;margin-bottom:5px;\">\n            Your activation code will expire soon. Please \n            <a href=\"javascript://\" ng-click=\"vm.showEditPaymentModal()\" style=\"border-bottom:1px dotted;\">add a payment source</a> \n            to ensure uninterrupted service.\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'cc' && vm.cardOnFile && vm.account.payment_status == 'declined' && vm.outstandingInvoices.length\"\n            class=\"bg-danger text-danger\" style=\"padding:10px;border:1px solid;margin-bottom:5px;\">\n            There was an issue charging your card. Please \n            <a href=\"javascript://\" ng-click=\"vm.showEditPaymentModal()\" style=\"border-bottom:1px dotted;\">update your payment source</a> \n            to ensure uninterrupted service.\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'ach' && vm.cardOnFile && vm.account.payment_status == 'declined' && vm.outstandingInvoices.length\"\n            class=\"bg-danger text-danger\" style=\"padding:10px;border:1px solid;margin-bottom:5px;\">\n            There was an issue with your ACH payment. Please \n            <a href=\"javascript://\" ng-click=\"vm.showEditPaymentModal()\" style=\"border-bottom:1px dotted;\">update your payment source</a> \n            to ensure uninterrupted service.\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-4\" style=\"width:39%\">\n          <div class=\"form-group\">\n            <label>Billing Email</label>\n            <h4 style=\"word-wrap:break-word\">{{vm.billing.email}}</h4>\n          </div>\n          <div class=\"form-group\" style=\"margin-top:30px\">\n            <label>Billing Address</label>\n            <h4 style=\"white-space:pre-wrap;\">{{vm.formattedAddress}}</h4>\n          </div>\n        </div>\n        <div class=\"col-sm-4\">\n          <div class=\"form-group\">\n            <label>Payment Method</label>\n            <div ng-if=\"vm.billing.payment_method == 'cc'\">\n              <h4 ng-if=\"vm.cardOnFile\">\n                <div style=\"margin-bottom:10px\">Paying by Credit Card</div>\n                <i class=\" fa fa-credit-card\"></i> {{vm.cardOnFile.brand}} **** **** **** {{vm.cardOnFile.last4}}\n              </h4>\n            </div>\n            <div ng-if=\"vm.billing.payment_method == 'ach'\">\n              <h4 ng-if=\"vm.cardOnFile\">\n                <div style=\"margin-bottom:10px\">Paying by Bank (ACH)</div>\n                <i class=\" fa fa-university\"></i> {{vm.cardOnFile.bank_name}} **** **** {{vm.cardOnFile.last4}}\n              </h4>\n            </div>\n            <h4 ng-if=\"vm.billing.payment_method == 'po'\">\n              Paying by Purchase Order\n              (<a href=\"javascript://\" ng-click=\"vm.showPurchaseOrderInstructions()\">Instructions</a>)\n            </h4>\n            <h4 ng-if=\"vm.billing.payment_method == 'check'\">\n              Paying by Check\n              (<a href=\"javascript://\" ng-click=\"vm.showCheckInstructions()\">Instructions</a>)\n            </h4>\n            <h4 ng-if=\"vm.billing.payment_method == 'activation'\">\n              Activation Code\n            </h4>\n            <h4 ng-if=\"vm.billing.payment_method == 'other' || ((vm.billing.payment_method == 'cc' || vm.billing.payment_method == 'ach') && !vm.cardOnFile)\">\n              <div style=\"margin-bottom:10px\">No Payment Source On File</div>\n              <button type=\"button\" ng-click=\"vm.showEditPaymentModal()\" class=\"btn btn-primary\">Add a Payment Source</button>\n            </h4>\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'cc' && vm.cardOnFile\" class=\"form-group\" style=\"margin-top:30px\">\n            <label>Expires</label>\n            <h4>{{vm.cardOnFile.exp_month}}/{{vm.cardOnFile.exp_year}}</h4>\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'ach' && vm.cardOnFile\" class=\"form-group\" style=\"margin-top:30px\">\n            <label>Status</label>\n            <h4 style=\"text-transform:capitalize;\">{{vm.cardOnFile.status}}</h4>\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'activation'\" class=\"form-group\" style=\"margin-top:30px\">\n            <label>Expires</label>\n            <h4>{{vm.account.expires_on | date}}</h4>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.paidInvoices.length\" class=\"col-sm-12\">\n    <div class=\"well\">\n      <h3>Payment History</h3>\n      <div class=\"row\">\n        <div class=\"col-sm-12\">\n          <table class=\"table table-condensed table-noborders\">\n            <thead>\n              <tr>\n                <th style=\"width:20%\">Date</th>\n                <th style=\"width:20%\">Total</th>\n                <th></th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"inv in vm.paidInvoices\">\n                <td>{{(inv.date*1000) | date}}</td>\n                <td>{{(inv.amount_due / 100) | currency}}</td>\n                <td class=\"text-left\">\n                  <a ng-if=\"inv.hosted_invoice_url\" href=\"{{inv.hosted_invoice_url}}\" target=\"_blank\">\n                    <strong>View invoice <i class=\"fa fa-external-link\"></i></strong>\n                  </a>\n                  <span ng-if=\"inv.usage && inv.usage.length > 0\" ng-repeat=\"usage in inv.usage\">\n                    &nbsp;|&nbsp;\n                    <a \n                      href=\"javascript://\"\n                      ng-click=\"vm.showUsageSummary(usage.subscriptionItemId, usage.plan, usage.periodStart, usage.periodEnd)\">\n                      View {{usage.type | usageType}} usage\n                    </a>\n                  </span>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div id=\"shipment-history\" ng-show=\"vm.orders\" class=\"col-sm-12\">\n    <div ng-if=\"vm.orders\" class=\"well\">\n      <h3>Shipment History</h3>\n      <div class=\"row\" ng-if=\"vm.orders.length\">\n        <div class=\"col-sm-12\">\n          <table class=\"table table-condensed table-noborders\">\n            <thead>\n              <tr>\n                <th style=\"width:20%\">Order Date</th>\n                <th style=\"width:20%\">Status</th>\n                <th style=\"width:30%\">Items</th>\n                <th></th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"order in vm.orders\">\n                <td>{{order.created_at | date}}</td>\n                <td ng-switch=\"order.status\" style=\"padding-right: 1rem\">\n                  <span ng-switch-when=\"on_hold\" class=\"label label-danger\">Backordered</span>\n                  <span ng-switch-when=\"awaiting_payment\" class=\"label label-warning\">Awaiting Payment</span>\n                  <span ng-switch-when=\"awaiting_shipment\" class=\"label label-success\">Awaiting Shipment</span>\n                  <span ng-switch-when=\"shipped\" class=\"label label-success\">Shipped</span>\n                </td>\n                <td style=\"padding-right: 1rem\">\n                  <div ng-repeat=\"item in order.items\">\n                    <small>{{item.quantity}} &#8212; {{item.name}}</small>\n                  </div>\n                </td>\n                <td>\n                  <button class=\"btn btn-default btn-sm\" ng-click=\"vm.showOrderStatus(order)\">\n                    View Details\n                  </button>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n      <div class=\"row\" ng-if=\"!vm.orders.length\">\n        <div class=\"col-sm-8\">\n          No shipment history.\n        </div>\n      </div>\n    </div>\n  </div>\n\n  </div>\n</main>"

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_stripe__ = __webpack_require__(35);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var UpdatePaymentController = /*#__PURE__*/function () {
  function UpdatePaymentController($rootScope, $http, $uibModal, $timeout, $state, $q, Account, ActivationCodes, Order, MeetingsService, toaster, $scope) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, UpdatePaymentController);

    this.account = $rootScope.account;
    this.user = $rootScope.user;
    this.$http = $http;
    this.$uibModal = $uibModal;
    this.$timeout = $timeout;
    this.Account = Account;
    this.ActivationCodes = ActivationCodes;
    this.Order = Order;
    this.MeetingsService = MeetingsService;
    this.toaster = toaster;
    this.$state = $state;
    this.$scope = $scope;
    this.canEditPaymentSettings = $rootScope.user.can('update', 'billing');
    this.codes = this.ActivationCodes.query();
    this.accountExpired = moment(this.account.expires_on).toDate() < new Date();
    this.accountExpiresSoon = moment(this.account.expires_on).add(-30, 'day').toDate() < new Date();
    this.loadingPromises = [];
    this.isFree = this.account.contract == 'free' || this.account.contract == 'free2';
    this.vueDashboardRoot = $rootScope.vueDashboardRoot;
    this.reload();

    if (this.user.can('list', 'upgrades')) {
      this.loadingPromises.push(this.Account.getUpgrades(function (r) {
        _this.upgradesAvailable = r.filter(function (u) {
          return !u.self_service;
        });
      }).$promise);
    }

    this.loadingPromises.push(this.Order.query({
      page: 1,
      page_size: 10
    }, function (result) {
      _this.orders = _.filter(result, function (order) {
        return order.status != 'cancelled';
      });
    }).$promise);
    this.loading = true;
    $q.all(this.loadingPromises)["finally"](function () {
      _this.loading = false; // Do scrolling if requested

      var params = $state.params;

      if (params.show_orders) {
        $timeout(function () {
          $('html, body').animate({
            scrollTop: $('#shipment-history').offset().top - 90
          });
        });
      }
    }); // Check for passed-in parameters

    var params = $state.params;

    if (params.pd_did && params.pd_sid) {
      this.review(params.pd_did, params.pd_sid);
    } else if (params.action === 'checkout') {
      this.completeCheckout({});
    } else if (params.action === 'order_status') {
      $q.all(this.loadingPromises).then(function () {
        if (_this.orders.length) {
          _this.showOrderStatus(_this.orders[0]);
        }
      });
    }
  }

  _createClass(UpdatePaymentController, [{
    key: "reload",
    value: function reload() {
      var _this2 = this;

      var $http = this.$http,
          toaster = this.toaster;
      if (this.user.cannot('read', 'billing')) return;
      this.billing = this.Account.getBilling();
      this.billing.$promise.then(function () {
        var billingResult = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stripe__["e" /* parseBilling */])(_this2.billing);
        _this2.cardOnFile = billingResult.cardOnFile || billingResult.bankOnFile;
        _this2.paidInvoices = billingResult.paidInvoices;
        _this2.outstandingInvoices = billingResult.outstandingInvoices;
        _this2.daysUntilSuspend = billingResult.daysUntilSuspend;
        _this2.subscriptions = billingResult.subscriptions;
        _this2.isBilledMonthly = billingResult.isBilledMonthly;
        _this2.formattedAddress = billingResult.formattedAddress;
        _this2.isPremium = billingResult.isPremiumPlan;
      })["catch"](function (err) {
        if (err.status == 404) {// No Stripe customer for this account
        } else {
          console.error(err);
          toaster.pop('warning', 'Unable to load your current payment information. Please reload this page and try again.');
        }
      });
      this.loadingPromises.push(this.billing.$promise);
    }
  }, {
    key: "showEditPaymentModal",
    value: function showEditPaymentModal() {
      var $uibModal = this.$uibModal;

      var _parentVM = this;

      $uibModal.open({
        template: __webpack_require__(468),
        controller: __webpack_require__(469)["default"],
        controllerAs: 'vm',
        resolve: {
          parentVM: function parentVM() {
            return _parentVM;
          }
        },
        //  Prevent accidental close...
        keyboard: false,
        backdrop: 'static'
      });
    }
  }, {
    key: "showActivationModal",
    value: function showActivationModal() {
      var $uibModal = this.$uibModal;
      var parentVM = this;
      $uibModal.open({
        template: __webpack_require__(470),
        controller: function controller($scope, $rootScope, $uibModalInstance, toaster, ActivationCodes) {
          'ngInject';

          $scope.toaster = toaster;
          $scope.ActivationCodes = ActivationCodes;
          $scope.codes = angular.copy(parentVM.codes);

          $scope.validateAndUseActivationCode = function () {
            $scope.activating = true;
            $scope.activation_code = $scope.formatActivationCode($scope.activation_code || '');

            if ($scope.activation_code.length !== 24) {
              $scope.activating = false;
              $scope.toaster.pop('warning', 'Invalid activation code.');
              return;
            }

            $scope.ActivationCodes.activateAddon({
              id: $scope.activation_code
            }).$promise.then(function (data) {
              $scope.activating = false;
              $scope.toaster.pop('success', 'Successfully activated.');
              window.location = window.location.href.split('?')[0];
              window.location.reload();
              return;
            }, function (err) {
              console.error(err);
              $scope.activating = false;
              $scope.toaster.pop('warning', "Unable to activate code. ".concat(err.data.error_description));
              return;
            });
          };

          $scope.formatActivationCode = function (id) {
            try {
              return id.split('-').join('').match(new RegExp('.{1,4}', 'g')).join('-').toUpperCase();
            } catch (e) {
              return id;
            }
          };

          $scope.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };
        }
      });
    }
  }, {
    key: "doChangePlan",
    value: function doChangePlan() {
      var checkoutURL = window.VUE_DASHBOARD_ROOT + '/checkout';

      if (this.account.metadata.remote_mix_sign_up === true) {
        var activeSubscriptions = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stripe__["a" /* getActiveSubscriptions */])(this.billing);
        var isTrial = this.account.contract === 'trial'; // if they are RemoteMix originated account and are either on a trial, or have not yet paid for the RemoteMix addon, then we need to send them to the RemoteMix checkout flow

        if (isTrial || !Object(__WEBPACK_IMPORTED_MODULE_0__utils_stripe__["d" /* hasRemoteMixPaidAddon */])(activeSubscriptions)) {
          checkoutURL += '/remote-mix';
        }
      }

      window.location.href = checkoutURL;
    }
  }, {
    key: "doPurchaseAddons",
    value: function doPurchaseAddons() {
      var checkoutURL = window.VUE_DASHBOARD_ROOT + '/checkout?start_step=add-on';
      window.location.href = checkoutURL;
    }
  }, {
    key: "onLetsChat",
    value: function onLetsChat() {
      if (window.Intercom) {
        window.Intercom('show');
      }
    }
  }, {
    key: "canChat",
    value: function canChat() {
      return !!window.Intercom;
    }
  }, {
    key: "showCheckInstructions",
    value: function showCheckInstructions() {
      var $uibModal = this.$uibModal;
      $uibModal.open({
        template: __webpack_require__(471),
        controller: function controller($scope, $uibModalInstance) {
          'ngInject';

          $scope.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };
        }
      });
    }
  }, {
    key: "showPurchaseOrderInstructions",
    value: function showPurchaseOrderInstructions() {
      var $uibModal = this.$uibModal;
      $uibModal.open({
        template: __webpack_require__(472),
        controller: function controller($scope, $uibModalInstance) {
          'ngInject';

          $scope.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };
        }
      });
    }
  }, {
    key: "review",
    value: function review(pd_did, pd_sid) {
      var account = this.account;
      var params = {
        pd_did: pd_did,
        pd_sid: pd_sid
      };

      if (!account.isTrialing()) {
        params.is_upgrade = true;
      }

      this.completeCheckout(params);
    }
  }, {
    key: "completeCheckout",
    value: function completeCheckout(params) {
      var $scope = this.$scope;
      var checkoutURL = window.VUE_DASHBOARD_ROOT + "/checkout?pd_did=".concat(params.pd_did, "&pd_sid=").concat(params.pd_sid);
      window.location.href = checkoutURL;
      $scope.$on('$destroy', function () {
        if (instance) instance.close();
      });
    }
  }, {
    key: "showOrderStatus",
    value: function showOrderStatus(_order) {
      var _this3 = this;

      this.$uibModal.open({
        template: __webpack_require__(197),
        resolve: {
          order: function order() {
            return _order;
          },
          account: function account() {
            return _this3.account;
          },
          showOrdersLink: function showOrdersLink() {
            return false;
          }
        },
        controller: __webpack_require__(198)["default"],
        controllerAs: 'vm'
      });
    }
  }, {
    key: "showUsageSummary",
    value: function showUsageSummary(_subscriptionItemId, _plan, _periodStart, _periodEnd) {
      this.$uibModal.open({
        template: __webpack_require__(473),
        resolve: {
          subscriptionItemId: function subscriptionItemId() {
            return _subscriptionItemId;
          },
          plan: function plan() {
            return _plan;
          },
          periodStart: function periodStart() {
            return _periodStart;
          },
          periodEnd: function periodEnd() {
            return _periodEnd;
          }
        },
        controller: __webpack_require__(474)["default"],
        controllerAs: 'vm'
      });
    }
  }]);

  return UpdatePaymentController;
}();

/* harmony default export */ __webpack_exports__["default"] = (UpdatePaymentController);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n    <h3 class=\"modal-title\">Edit Payment Info</h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <div class=\"form-group\">\n          <div ng-if=\"vm.hasPaymentMethod()\" class=\"pull-right\">\n            <a href=\"javascript://\" ng-click=\"vm.changePaymentMethod()\" style=\"font-size:10pt;border-bottom:1px dotted;\">\n              Change Payment Method\n            </a>\n          </div>\n          <label>Payment Method</label>\n          <div ng-if=\"!vm.hasPaymentMethod()\" class=\"col-xs-12 col-md-8 col-md-offset-2\">\n            <div class=\"row text-center\" style=\"margin-top:30px\">\n              <checkout-payment-method vm=\"vm\"></checkout-payment-method>\n            </div>\n          </div>\n      \n          <div ng-if=\"vm.billing.payment_method == 'cc'\">\n            Paying by Credit Card\n            <div ng-if=\"vm.cardOnFile\" style=\"margin-top:5px;\">\n              <i class=\"fa fa-credit-card\"></i> {{vm.cardOnFile.brand}} **** **** **** {{vm.cardOnFile.last4}}\n              (Expires: {{vm.cardOnFile.exp_month}}/{{vm.cardOnFile.exp_year}})\n              <div ng-if=\"vm.changingPaymentMethod\" class=\"bg-info text-info\" style=\"padding:10px;border:1px solid;margin-bottom:5px;margin-top:5px;\">\n                This card will be used for all future payments\n              </div>\n            </div>\n            <div ng-if=\"!vm.cardOnFile\">\n              <div class=\"well\" style=\"margin:15px 0 0 0\">\n                <div class=\"form-control\"\n                      style=\"height:38px;padding-top:10px;margin-bottom:15px;\"\n                      ng-init=\"vm.stripeCard.mount('#stripe-elements-card')\">\n                  <div id=\"stripe-elements-card\"></div>\n                </div>\n                  <p><button type=\"button\" class=\"btn btn-block btn-primary\" ng-click=\"vm.addNewCard()\"\n                    ng-disabled=\"vm.addingCard\">Add</button></p>\n              </div>\n            </div>\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'ach'\">\n            Paying by Bank (ACH)\n            <div ng-if=\"vm.cardOnFile\" style=\"margin-top:5px;\">\n              <i class=\" fa fa-university\"></i>  {{vm.cardOnFile.bank_name}} **** **** {{vm.cardOnFile.last4}}\n              <span style=\"text-transform: capitalize\">({{vm.cardOnFile.status}})</span>\n              <div ng-if=\"vm.changingPaymentMethod\" class=\"bg-info text-info\" style=\"padding:10px;border:1px solid;margin-bottom:5px;margin-top:5px;\">\n                This bank account will be used for all future payments\n              </div>\n            </div>\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'po'\">\n            Paying by Purchase Order\n            <div ng-if=\"vm.changingPaymentMethod\" class=\"bg-info text-info\" style=\"padding:10px;border:1px solid;margin-bottom:5px;margin-top:5px;\">\n              <p>Purchase orders are to be emailed to <strong>billing@boxcast.com</strong> or mailed to </p>\n              <strong>\n                BoxCast Inc.</br>\n                Attn: Payments Dept</br>\n                2401 Superior Via</br>\n                Cleveland, OH 44113</br></br>\n              </strong>\n              <p>by the due date indicated on each invoice. This payment change will apply to all future invoices.</p>\n            </div>\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'check'\">\n            Paying by Check\n            <div ng-if=\"vm.changingPaymentMethod\" class=\"bg-info text-info\" style=\"padding:10px;border:1px solid;margin-bottom:5px;margin-top:5px;\">\n              <p>Checks are to be made payable to <strong>BoxCast</strong> and mailed to </p>\n              <strong>\n                BoxCast Inc.</br>\n                PO BOX 8112</br>\n                Carol Stream, IL 60197-8112\n              </strong>\n              <p class=\"mt-base\">by the due date indicated on each invoice. This payment change will apply to all future invoices.</p></div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"col-xs-12\">\n        <div class=\"form-group\">\n          <label>Billing Email</label>\n          <input type=\"email\" class=\"form-control\" ng-model=\"vm.billing.email\" required>\n        </div>\n        <div class=\"form-group\">\n          <label>Billing Address</label>\n          <input type=\"text\" class=\"form-control\" ng-model=\"vm.billing.address\" placeholder=\"Address\" required>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-5\">\n            <div class=\"form-group\">\n              <input type=\"text\" class=\"form-control\" ng-model=\"vm.billing.city\" placeholder=\"City\" required>\n            </div>\n          </div>\n          <div class=\"col-xs-4\">\n            <div class=\"form-group\">\n              <input ng-if=\"vm.billing.country != 'US'\" type=\"text\" class=\"form-control\" ng-model=\"vm.billing.state\" placeholder=\"State\" required>\n              <select ng-if=\"vm.billing.country == 'US'\"\n                ng-model=\"vm.billing.state\"\n                ng-options=\"c.code as c.name for c in vm.states\"\n                id=\"state\" name=\"state\" class=\"form-control\" required>\n              </select>\n            </div>\n          </div>\n          <div class=\"col-xs-3\">\n            <div class=\"form-group\">\n              <input type=\"text\" class=\"form-control\" ng-model=\"vm.billing.postal_code\" placeholder=\"Postal Code\" required>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"form-group\">\n            <div class=\"col-xs-4\">\n              <select ng-model=\"vm.billing.country\"\n                ng-options=\"c.code as c.name for c in vm.countries\"\n                id=\"country\" name=\"country\" class=\"form-control\" required>\n              </select>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n      <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n      <button ng-disabled=\"vm.submitting || !form.$valid || (vm.billing.payment_method == 'cc' && !vm.cardOnFile)\"\n              ng-click=\"vm.update()\"\n              class=\"btn btn-primary\">\n        <i ng-show=\"vm.submitting\" class=\"fa fa-spin fa-spinner\"></i>\n        Update Settings\n      </button> \n  </div>\n</form>\n"

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalEditPaymentController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_stripe__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_error__ = __webpack_require__(17);


function ModalEditPaymentController(Account, Checkout, $uibModal, $uibModalInstance, $http, $timeout, toaster, $rootScope, $cacheFactory, parentVM) {
  'ngInject';

  var _this = this;

  this.cancel = function () {
    return $uibModalInstance.dismiss('cancel');
  };

  this.$http = $http;
  this.$timeout = $timeout;
  this.$cacheFactory = $cacheFactory;
  this.$rootScope = $rootScope;
  this.toaster = toaster;
  this.account = $rootScope.account;
  this.Account = Account;
  this.states = [];
  this.$http.get('/img/states.json').then(function (response) {
    _this.states = response.data;
  });
  this.countries = [];
  this.$http.get('/img/countries.json').then(function (response) {
    _this.countries = response.data;
  });
  this.billing = angular.copy(parentVM.billing);
  this.cardOnFile = angular.copy(parentVM.cardOnFile);

  if (!this.billing.country || this.billing.country == '') {
    this.billing.country = 'US';
  }

  this.stripeCard = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stripe__["b" /* getStripeCard */])();

  this.checkPreviousSelectedPayment = function () {
    var paymentException = _this.billing.payment_method === 'check' || _this.billing.payment_method === 'po';

    if (Checkout.currentInterval(_this.billing) === 'month' && paymentException) {
      _this.showAllPaymentOptions = true;
    }
  };

  this.changePaymentMethod = function () {
    _this.checkPreviousSelectedPayment();

    _this.billing.payment_method = null;
    _this.cardOnFile = null;
    _this.newStripeToken = null;
    _this.changingPaymentMethod = true;

    if (Checkout.currentInterval(_this.billing) === 'month') {
      _this.selectedInterval = 'monthly';
    }
  };

  this.hasPaymentMethod = function () {
    return _this.billing.payment_method && _.includes(['cc', 'ach', 'po', 'check'], _this.billing.payment_method);
  };

  if (!this.hasPaymentMethod()) {
    this.changePaymentMethod();
  }

  this.addNewCard = function () {
    _this.addingCard = true;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_stripe__["c" /* getToken */])(_this.stripeCard).then(function (token) {
      _this.$timeout(function () {
        _this.newStripeToken = token.id;
        _this.cardOnFile = token.card;
      });
    })["catch"](function (err) {
      _this.$timeout(function () {
        _this.toaster.pop('warning', 'Unable to process credit card: ' + err);
      });
    })["finally"](function () {
      _this.addingCard = false;
    });
  };

  this.openPlaidLink = function () {
    _createLinkToken().then(function (linkToken) {
      Plaid.create({
        token: linkToken,
        onSuccess: function onSuccess(public_token, metadata) {
          return _onBankAccountLinkedViaPlaid(public_token, metadata);
        }
      }).open();
    });
  };

  this.onSelectPaymentMethod = function (m) {
    _this.billing.payment_method = m;

    if (m == 'ach') {
      _this.openPlaidLink();
    }
  };

  var _createLinkToken = function _createLinkToken() {
    console.log('Creating Plaid link token');
    return _this.$http.post("".concat(API_ROOT, "/plaid/create_link_token")).then(function (response) {
      var linkToken = response.data.link_token;
      console.log('Plaid link_token', linkToken);
      return linkToken;
    })["catch"](function (err) {
      console.error('Error creating Plaid link token', err);

      _this.toaster.pop('warning', 'We were unable to connect to our payment provider.');
    });
  };

  var _onBankAccountLinkedViaPlaid = function _onBankAccountLinkedViaPlaid(public_token, metadata) {
    console.log('Plaid public_token', public_token);
    console.log('Plaid metadata', metadata);

    _this.$http.post("".concat(API_ROOT, "/plaid/exchange_token"), {
      public_token: public_token,
      plaid_account_id: metadata.account_id
    }).then(function (response) {
      _this.billing.payment_method = 'ach';
      _this.newStripeToken = response.data.stripe_bank_account_token;
      _this.cardOnFile = null;
    })["catch"](function (err) {
      console.error('Error exchanging Plaid token', err);

      _this.toaster.pop('warning', 'We were unable to associate your bank account with our payment provider.'); // XXX: TODO: save the public_token so that we can manually exchange/link

    });
  };

  this.update = function () {
    _this.submitting = true;
    var updates = {
      address: _this.billing.address,
      city: _this.billing.city,
      country: _this.billing.country,
      state: _this.billing.state,
      email: _this.billing.email,
      postal_code: _this.billing.postal_code
    };

    if (_this.changingPaymentMethod) {
      updates.payment_method = _this.billing.payment_method;
    }

    if (_this.newStripeToken) {
      updates.stripe_token = _this.newStripeToken;
    }

    _this.Account.updateBilling(updates).$promise.then(function (billing) {
      // Invalidate cache
      _this.$cacheFactory.get('$http').remove("".concat(API_ROOT, "/account"));

      _this.$rootScope.account.payment_method = billing.payment_method;

      _this.cancel();

      parentVM.reload();
    })["catch"](function (err) {
      console.log(err);
      var errorDetails = Object(__WEBPACK_IMPORTED_MODULE_1__utils_error__["a" /* errorDescriptionFromResponse */])(err);

      _this.toaster.pop('warning', 'Error updating payment settings', errorDetails);
    })["finally"](function () {
      _this.submitting = false;
    });
  };
}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n    <h3 class=\"modal-title\">Activation Codes</h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <table class=\"table\" ng-if=\"codes.length\">\n        <thead>\n          <tr>\n            <th>Existing Activation(s)</th>\n            <th class=\"text-right\">Activated On</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"code in codes\">\n            <td>{{code.plan_name}}</td>\n            <td class=\"text-right\">{{code.activated_at | date:'MMM d, yyyy':'UTC'}}</td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n      <p class=\"col-xs-12\" class=\"help-block\">If you have purchased an add-on activation code from an authorized\n        reseller, please enter it here.</p>\n      <div class=\"form-group col-xs-8\">\n        <input type=\"text\" class=\"form-control\" id=\"code\" ng-model=\"activation_code\" required\n          placeholder=\"XXXX-XXXX-XXXX-XXXX-XXXX\" autocomplete=\"off\">\n      </div>\n      <button ng-disabled=\"activating\"\n            ng-click=\"validateAndUseActivationCode()\"\n            class=\"btn btn-primary\">\n        <i ng-show=\"activating\" class=\"fa fa-spin fa-spinner\"></i>\n        Activate\n      </button> \n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Cancel</button>\n  </div>\n</form>\n"

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">Pay via Check</h3>\n</div>\n<div class=\"modal-body\">\n  <p>1) Make the check payable to <strong>BoxCast</strong></p>\n  <p>2) Mail the check to:<br>\n    <strong>\n      BoxCast Inc<br>\n      PO BOX 8112<br>\n      Carol Stream, IL 60197-8112<br>\n    </strong>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Cancel</button>\n</div>\n"

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">Paying via Purchase Order</h3>\n</div>\n<div class=\"modal-body\">\n  <p>1) Review open invoices.</p>\n  <p>2) Send in the Purchase Order by one of the following methods:</p>\n  <p>\n    <table>\n      <tr>\n        <td>Email:</td>\n        <td>&nbsp;</td>\n        <td><a href=\"mailto:payments@boxcast.com\" target=\"_blank\">payments@boxcast.com</a></td>\n      </tr>\n      <tr>\n        <td valign=\"top\">Mail:</td>\n        <td>&nbsp;</td>\n        <td>BoxCast<br>\n          Attn: Payments Dept<br>\n          2401 Superior Viaduct<br>\n          Cleveland, OH 44113\n        </td>\n      </tr>\n    </table>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Cancel</button>\n</div>\n"

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h4 class=\"modal-title\">\n    <span style=\"text-transform:capitalize\">{{vm.usageType | usageType}}</span>\n    Usage for <strong>{{vm.periodStart*1000 | date}}</strong> to\n    <strong ng-show=\"vm.periodEnd\">{{vm.periodEnd*1000 | date}}</strong>\n    <strong ng-show=\"!vm.periodEnd\">Now</strong>\n  </h4>\n</div>\n<div class=\"modal-body\">\n  <main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\"></main>\n  <div ng-if=\"!vm.summary && !vm.loading\">\n    <p>\n      There is no usage recorded for this period.\n      <span ng-show=\"!vm.periodEnd\">\n        Usage can take up to 24 hours to appear in the Dashboard. Please check back later.\n      </span>\n    </p>\n  </div>\n  <div ng-if=\"vm.summary\">\n    <p class=\"text-muted\">Last collected on: {{vm.summary.last_collected | date : 'short'}}</p>\n    <p class=\"text-muted\"><small>\n      Usage may take up to 24 hours to be collected. Because of this, usage at the end of the month\n      may not be charged until the following billing period.\n    </small></p>\n    <div class=\"row\" style=\"padding:5px\">\n      <div ng-show=\"vm.summary.total_usage || vm.summary.total_usage == 0\" class=\"col-xs-6 text-center\" style=\"border-right:1px solid #ccc;border-top:1px solid #ccc;padding:10px\">\n        <h4 class=\"text-muted\" style=\"margin-top:0\"><strong>QUANTITY</strong></h4>\n        <h2 style=\"margin-top:0\">\n          {{vm.summary.total_usage}}\n          <span ng-show=\"vm.summary.total_usage == 1\">hour</span>\n          <span ng-show=\"vm.summary.total_usage != 1\">hours</span>\n        </h2>\n      </div>\n      <div ng-show=\"vm.summary.amount_cents || vm.summary.amount_cents == 0\" class=\"col-xs-6 text-center\" style=\"border-top:1px solid #ccc;padding:10px\">\n        <h4 class=\"text-muted\" style=\"margin-top:0\"><strong>COST</strong></h4>\n        <h2 style=\"margin-top:0\">{{vm.summary.amount_cents/100 | currency}}</h2>\n      </div>\n      <div ng-show=\"!vm.summary.records || vm.summary.records.length == 0\" class=\"col-xs-12\" style=\"padding:10px\">\n        There is no usage recorded for this period.\n      </div>\n      <div ng-show=\"vm.summary.records.length > 0\" class=\"col-xs-12 tex-center\" style=\"background:#fff;border-top:1px solid #ccc;padding:10px\">\n        <h4 class=\"text-muted text-center\" style=\"margin-top:0\"><strong>DETAILS</strong></h4>\n        <div class=\"table-fix-head\">\n        <table class=\"table table-condensed table-striped\" style=\"margin-bottom:0\">\n          <thead>\n            <tr>\n              <th>Broadcast Name</th>\n              <th class=\"text-center\">Broadcast Date</th>\n              <th class=\"text-right\" style=\"padding:5px 10px 5px 10px;white-space:nowrap\">\n                <span ng-switch=\"vm.summary.type\">\n                  <span ng-switch-when=\"viewership\">\n                    Total Viewer Minutes\n                  </span>\n                  <span ng-switch-default>\n                    Broadcast Duration\n                  </span>\n                </span>\n              </th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"record in vm.summary.records\">\n              <td ng-show=\"!record.broadcast.deleted\">\n                <a href=\"{{vueDashboardRoot}}/broadcasts/{{record.broadcast.id}}\" target=\"_blank\">{{record.broadcast.name}}</a>\n              </td>\n              <td ng-show=\"record.broadcast.deleted\">\n                <i class=\"fa fa-minus-circle\" uib-tooltip=\"Broadcast was deleted\" tooltip-append-to-body=\"true\"></i>\n                {{record.broadcast.name}}\n              </td>\n              <td class=\"text-center\" style=\"white-space:nowrap\"><span>{{record.broadcast.starts_at | date : 'short'}}</span></td>\n              <td class=\"text-right\" style=\"padding-right:25px\">{{record.duration}}</td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalUsageSummary;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);

function ModalUsageSummary(Account, $uibModalInstance, $filter, toaster, subscriptionItemId, plan, periodStart, periodEnd) {
  'ngInject';

  var _this = this;

  this.subscriptionItemId = subscriptionItemId;
  this.plan = plan;
  this.periodStart = periodStart;
  this.periodEnd = periodEnd;
  this.usageType = plan.metadata.usage_type;
  this.summaries = Account.getUsageSummaries({
    stripe_subscription_item_id: this.subscriptionItemId,
    subscription_period_start: periodStart
  });
  this.loadingPromises = [this.summaries.$promise];
  this.loading = true;
  this.summaries.$promise.then(function (r) {
    if (r.length > 0) {
      _this.summary = r[0];

      _.forEach(_this.summary.records, function (record) {
        switch (_this.summary.type) {
          case 'broadcast_duration':
          case 'captioning':
            record.duration = Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["e" /* secondsToFormattedLabel */])(record.qty);
            break;

          case 'viewership':
            record.duration = $filter('number')(Math.round(record.qty / 60));
        }
      });
    }

    _this.loading = false;
  })["catch"](function (err) {
    toaster.pop('warning', 'Unable to load usage summary. Please refresh the page and try again.');
    console.error(err);
    _this.loading = false;
  });

  this.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <p class=\"help-block\">\n        Please wait while your account link is processed.\n        If you are stuck here, <a ui-sref=\"settings.integrations\">return to the integrations page</a>.\n        </p>\n      </div>\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_utils__ = __webpack_require__(9);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// TODO: Should I be using this, or just use local storage directly?

var TWITTER_AUTH_URL = 'https://api.twitter.com/oauth/authorize';

var TwitterSettingsController = /*#__PURE__*/function () {
  function TwitterSettingsController(TwitterUser, toaster, $http, $state, $window) {
    'ngInject';

    _classCallCheck(this, TwitterSettingsController);

    this.TwitterUser = TwitterUser;
    this.toaster = toaster;
    this.$http = $http;
    this.$state = $state;
    this.$window = $window;

    if ($state.params.link) {
      this._linkAccount();
    } else {
      var urlParams = new URLSearchParams($window.location.search);
      var denied = urlParams.get('denied');
      var oauthToken = urlParams.get('oauth_token');
      var oauthVerifier = urlParams.get('oauth_verifier');

      if (oauthToken && oauthVerifier || denied) {
        this._handleOauthCallback(oauthToken, oauthVerifier, denied);
      } else {
        $state.go('settings.integrations');
      }
    }
  }

  _createClass(TwitterSettingsController, [{
    key: "_handleOauthCallback",
    value: function _handleOauthCallback(token, verifier, denied) {
      var _this = this;

      if (denied) return this._handleLinkError('Authorize was denied');
      if (!token) return this._handleLinkError('Missing oauth_token');
      if (!verifier) return this._handleLinkError('Missing oauth_verifier');
      var storedToken = __WEBPACK_IMPORTED_MODULE_0__auth_utils__["d" /* storage */].get('twitterToken');
      if (storedToken != token) return this._handleLinkError('Unexpected oauth_token');
      var secret = __WEBPACK_IMPORTED_MODULE_0__auth_utils__["d" /* storage */].get('twitterTokenSecret');
      var user = new this.TwitterUser({
        token: token,
        secret: secret,
        verifier: verifier
      });
      var promise = user.$save().then(function (u) {
        var l = _this.$window.location;
        l.href = l.protocol + '//' + l.host + l.pathname + "#/settings/integrations?integration_id=".concat(u.id);
      })["catch"](function (err) {
        return _this._handleLinkError(err);
      });
      this.loadingPromises = [promise];
    }
  }, {
    key: "_linkAccount",
    value: function _linkAccount() {
      var _this2 = this;

      var promise = this.$http.post("".concat(API_ROOT, "/twitter/oauth/request_token"), {
        oauth_callback: TWITTER_OAUTH_REDIRECT
      }).then(function (resp) {
        return _this2._requestTokenResponse(resp.data);
      }, function (err) {
        return _this2._handleLinkError(err);
      });
      this.loadingPromises = [promise];
    }
  }, {
    key: "_handleLinkError",
    value: function _handleLinkError(errorMsg, obj) {
      var _console;

      (_console = console).error.apply(_console, _toConsumableArray([errorMsg, obj].filter(function (e) {
        return e;
      })));

      this.toaster.pop('warning', 'Unable to link the requested Twitter account. Please reload this page and try again.');
    }
  }, {
    key: "_requestTokenResponse",
    value: function _requestTokenResponse(resp) {
      // Ok, got a request token! Let's make sure it's confirmed
      if (!resp.oauth_callback_confirmed || !resp.oauth_token || !resp.oauth_token_secret) {
        return this._handleLinkError('Request token request failed', resp);
      }

      var twitterToken = resp.oauth_token;
      var twitterTokenSecret = resp.oauth_token_secret; // Ok, callback confirmed. Store the token and secret in local storage for later.

      __WEBPACK_IMPORTED_MODULE_0__auth_utils__["d" /* storage */].set('twitterToken', twitterToken);
      __WEBPACK_IMPORTED_MODULE_0__auth_utils__["d" /* storage */].set('twitterTokenSecret', twitterTokenSecret); // Send to oauth/authorize?oauth_token=XXX (Step 2); they'll come back with a token and a verifier

      window.location.replace(TWITTER_AUTH_URL + '?oauth_token=' + twitterToken);
    }
  }]);

  return TwitterSettingsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (TwitterSettingsController);

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <p class=\"help-block\">\n        Please wait while you are redirected.\n        If you are stuck here, <a ui-sref=\"settings.integrations\">return to the integrations page</a>.\n        </p>\n      </div>\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// The `wire` helper only deals with simple states. We need to add the
// detail sub-states as well, so we'll just do it by hand here.
var module = angular.module('switcher-studio', []);
module.config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('switcher-studio', {
    url: '/switcher-studio',
    template: '<div ui-view></div>',
    "abstract": true
  }).state('switcher-studio.events', {
    url: '',
    template: __webpack_require__(479),
    controller: __webpack_require__(480)["default"],
    controllerAs: 'vm'
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"vm.loading\" id=\"loading\">\n  <div>\n    <div class=\"frosted-o\"></div>\n  </div>\n</div>\n\n<main ng-hide=\"vm.loading\" class=\"container\" style=\"margin-top:15px\">\n\n  <div class=\"col-xs-4 text-left\" style=\"line-height:32px\">\n    <img src=\"/img/boxcast_logo_dark.png\" class=\"logo\"  alt=\"BoxCast Logo\" style=\"max-width:100%;max-height:32px;\">\n  </div>\n  <div class=\"col-xs-8 text-center\">\n    <div class=\"btn-group btn-group-justified\" role=\"group\">\n      <button ng-class=\"vm.tab=='scheduled'?'active':''\" ng-click=\"vm.tab = 'scheduled'\" type=\"button\" class=\"btn btn-boxcast\" style=\"width:33.33%\">\n        <i class=\"fa fa-calendar\"></i> <!--Scheduled Events-->\n      </button>\n      <button ng-class=\"vm.tab=='new'?'active':''\" ng-click=\"vm.tab = 'new'\" type=\"button\" class=\"btn btn-boxcast\" style=\"width:33.33%\">\n        <i class=\"fa fa-plus\"></i> <!--New Event-->\n      </button>\n      <button ng-class=\"vm.tab=='help'?'active':''\" ng-click=\"vm.tab = 'help'\" type=\"button\" class=\"btn btn-boxcast\" style=\"width:33.33%\">\n        <i class=\"fa fa-question\"></i> <!--Help-->\n      </button>\n    </div>\n  </div>\n  <div class=\"clearfix\"></div>\n\n  <div ng-show=\"vm.tab == 'new'\" class=\"container-fluid\" style=\"max-width:720px;margin-top:15px;\">\n    <!-- XXX: form needs to be here so it is accessible in service for validation -->\n    <form name=\"form\" role=\"form\">\n      <new-event-quick></new-event-quick>\n\n      <div style=\"text-align:center;margin:15px 0\">\n        <div ng-show=\"vm.bandwidth\">\n          Detected upload bandwidth of {{vm.bandwidth.availableBandwidth | bytes}}ps\n        </div>\n        <div ng-hide=\"vm.bandwidth\">\n          <i class=\"fa fa-spin fa-spinner\"></i> Checking available bandwidth...\n        </div>\n      </div>\n\n    </form>\n  </div>\n\n  <div ng-show=\"vm.tab == 'help'\" class=\"container-fluid\" style=\"max-width:720px\">\n    <h3>BoxCast Help</h3>\n    <p>To stream to BoxCast from the Switcher iOS app, you must have an active broadcast\n    at the time of the streaming.</p>\n    <p>You can schedule a broadcast on the BoxCast web dashboard from your computer, and as\n    long as you set \"Source\" to \"Switcher Studio (iOS)\", when you access this app during\n    the time of the broadcast, you will be able to stream directly to it.</p>\n    <p>You can also schedule a new BoxCast broadcast right here. Make sure the selected time is appropriate\n    for the start and end of your event, and BoxCast will take care of the rest!</p>\n  </div>\n\n  <div ng-show=\"vm.tab == 'scheduled'\" class=\"container-fluid\" style=\"max-width:720px\">\n\n    <div ng-if=\"vm.switcherAppMode == 'web'\" class=\"bg-warning text-warning\" style=\"margin:15px 0;border:1px solid;padding:15px\">\n      <div ng-show=\"vm.initializingSwitcherStudioV3\">\n        Initializing Switcher Studio integration...\n      </div>\n      <div ng-hide=\"vm.initializingSwitcherStudioV3\">\n        Switcher Studio app not detected. This page is intended to be accessed from inside the app and may not perform\n        appropriately otherwise.\n      </div>\n    </div>\n\n    <div ng-if=\"vm.futureBroadcasts.length == 0\">\n      <p class=\"text-center\" style=\"margin: 45px 0; padding: 10px;\">\n        There are no scheduled broadcasts. Create a new broadcast to begin streaming.\n      </p>\n      <p class=\"text-center\">\n        <button type=\"button\" class=\"btn btn-boxcast btn-lg btn-block\" ng-click=\"vm.tab = 'new'\">\n          Create Broadcast\n        </button>\n      </p>\n    </div>\n    <div class=\"switcher-event-row\"\n        ng-class=\"vm.isActive(broadcast) ? 'selected' : ''\"\n        ng-repeat=\"broadcast in vm.futureBroadcasts track by broadcast.id\">\n      <div class=\"col-xs-1\" ng-click=\"vm.toggleSelectedBroadcast(broadcast)\" style=\"cursor:pointer\">\n        <i class=\"fa\" ng-class=\"vm.isSelected(broadcast) ? 'fa-check-square-o' : 'fa-square-o'\" style=\"font-size:22px\"></i>\n      </div>\n      <div class=\"col-xs-11\" ng-click=\"vm.toggleSelectedBroadcast(broadcast)\" style=\"cursor:pointer\">\n        <div class=\"pull-right\">\n          <span ng-if=\"vm.isActive(broadcast)\" class=\"label\" style=\"background:#fff;color:#1AA8A1;border:1px solid #1AA8A1;\">Active</span>\n          <span ng-if=\"broadcast.is_ticketed\" class=\"label label-success\">${{broadcast.ticket_price | number:2}} / ticket</span>\n          <span ng-if=\"broadcast.is_private\" class=\"label label-danger\">Private</span>\n          <span ng-if=\"broadcast.timeframe == 'current'\" class=\"label label-danger\">LIVE NOW</span>\n        </div>\n        <div><strong>{{broadcast.name}}</strong></div>\n        <div class=\"text-bx-accessible-grey\" style=\"white-space:nowrap; text-overflow:ellipsis; overflow:hidden\">\n          <date-range start=\"broadcast.starts_at\" end=\"broadcast.stops_at\"></date-range>\n        </div>\n      </div>\n      <div class=\"clearfix\"></div>\n    </div>\n    <div class=\"row\" ng-if=\"vm.selectedBroadcast\" style=\"margin-top:15px\">\n      <div class=\"col-sm-6\" ng-hide=\"vm.isActive(vm.selectedBroadcast)\" style=\"margin-bottom:15px\">\n        <button type=\"button\" ng-click=\"vm.activateBroadcast(vm.selectedBroadcast)\" class=\"btn btn-primary btn-lg btn-block\">\n          Activate Selected Broadcast\n        </button>\n        <p class=\"help-block\">\n          <small>\n            Tap to start the BoxCast broadcast and link it to Switcher Studio.\n            You will still need to begin the stream in Switcher Studio after this window closes.\n          </small>\n        </p>\n      </div>\n      <div class=\"col-sm-6\" ng-show=\"vm.selectedBroadcast.timeframe == 'current' || vm.selectedBroadcast.timeframe == 'preroll'\" style=\"margin-bottom:15px\">\n        <button type=\"button\" ng-click=\"vm.stopBroadcast(vm.selectedBroadcast)\" class=\"btn btn-danger btn-lg btn-block\">\n          Stop Selected Broadcast\n        </button>\n      </div>\n    </div>\n\n    <div class=\"row\" style=\"margin-top:30px\">\n      <div class=\"col-xs-12 text-center\">\n        <small><a href ng-click=\"vm.loadFutureBroadcasts()\">Refresh Broadcast List</a></small>\n      </div>\n    </div>\n\n  </div>\n\n  <!-- XXX: HACK: whitespace to work around problem where viewport magically shrinks\n  inside the iOS webview when typing in a text field or opening the channel picker.\n  Gabe appears to have fixed it for now; leaving it commented in case of reports that\n  it occurs still under certain circumstances.\n  <div id=\"switcher-webview-hack\" style=\"height:320px;\">\n  </div>\n  -->\n\n\n  <div style=\"margin-top:50px;text-align:center\">\n    <hr>\n    <small><a ui-sref=\"logout\" class=\"subtle-link\">Log out of BoxCast</a></small>\n  </p>\n\n</main>\n\n\n<style type=\"text/css\">\n  body {\n    background-color: #FFF !important;\n    color: #333;\n  }\n\n  .well {\n    background-color: #FFF;\n    border: 1px solid #1AA8A1;\n  }\n\n\n  .switcher-event-row {\n    padding: 20px;\n    border: 1px solid #1AA8A1;\n    border-radius: 4px;\n    color: #333;\n    margin-top:15px;\n  }\n  .switcher-event-row.selected {\n    border: 1px solid #1AA8A1;\n    background-color: rgba(26, 168, 161, 0.60);\n    color: #000;\n  }\n\n\n  .btn-boxcast {\n      border: 1px solid #1AA8A1;\n      background-color: transparent;\n      color: #1AA8A1;\n  }\n\n  .btn-boxcast:hover,\n  .btn-boxcast:focus {\n      border: 1px solid #1AA8A1;\n      outline: 0;\n      color: #000;\n      background-color: #1AA8A1;\n  }\n  .btn-boxcast:active, .btn-boxcast.active {\n      border-color: #1AA8A1;\n      color: #333;\n      background-color: rgba(26, 168, 161, 0.60);\n      outline: 0;\n  }\n  .btn-boxcast:active:hover, .btn-boxcast.active:hover,\n  .btn-boxcast:active:focus, .btn-boxcast.active:focus,\n  .btn-boxcast:active.focus, .btn-boxcast.active.focus {\n      border-color: #1AA8A1;\n      background-color: rgba(26, 168, 161, 0.80);\n      outline: 0;\n  }\n</style>\n\n"

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_error__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_broadcast_with_rtmp_controller__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }




var PROVIDER_ID = '62B54187-6E38-43C8-9EC4-28709EEEC382';
var V3_INITIALIZE_TIMEOUT_MS = 10000;

var EventsController = /*#__PURE__*/function () {
  function EventsController($scope, $state, $analytics, $q, $http, $timeout, $uibModal, EditOrCreateEventService, Broadcast, toaster, BandwidthTestClient, Requester) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, EventsController);

    this.$scope = $scope;
    this.$state = $state;
    this.$analytics = $analytics;
    this.EditOrCreateEventService = EditOrCreateEventService;
    this.Broadcast = Broadcast;
    this.toaster = toaster;
    this.BandwidthTestClient = BandwidthTestClient;
    this.Requester = Requester;
    this.$q = $q;
    this.$http = $http;
    this.$timeout = $timeout;
    this.$uibModal = $uibModal;
    this.postRobot = __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min___default.a;
    this.switcherAppMode = 'web';

    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.switcher) {
      // Decide if v2 (BoxCast Switcher) or v3 (Switcher Studio). Assume v2 unless the postMessage
      // calls return, in which case we're in the v3 shell.
      this.switcherAppMode = 'boxcast_switcher_webview';
      this.initializingSwitcherStudioV3 = true;
      this.postMessage('api', {
        method: 'GET',
        path: "/api/StreamingProviders/".concat(PROVIDER_ID)
      }).then(function (event) {
        console.log('Switcher provider settings', event);
        $timeout(function () {
          _this.initializingSwitcherStudioV3 = false;
          _this.switcherAppMode = 'studio_v3';
          _this.provider = event.data;
        });
      })["catch"](function (err) {
        console.error(err);
        $timeout(function () {
          return _this.initializingSwitcherStudioV3 = false;
        });
      });
      this.postMessage('api', {
        method: 'GET',
        path: "/api/StreamingProviders/".concat(PROVIDER_ID, "/SwitcherStreamSettings")
      }).then(function (event) {
        console.log('Current Switcher channel settings', event);
        $timeout(function () {
          return _this.currentSwitcherChannelSettings = event.data;
        });

        _this.postMessage('ui', {
          method: 'hideCover'
        });
      })["catch"](function (err) {
        console.error(err);
        $timeout(function () {
          return _this.currentSwitcherChannelSettings = {};
        });

        _this.postMessage('ui', {
          method: 'hideCover'
        });
      });
      $timeout(function () {
        if (_this.initializingSwitcherStudioV3) {
          _this.initializingSwitcherStudioV3 = false;
        }
      }, V3_INITIALIZE_TIMEOUT_MS);
    }

    this.tab = 'scheduled';
    this.loadFutureBroadcasts();
    this.newEventQuickSettings = {
      showModeToggle: false,
      showBoxCasters: false,
      showClone: false,
      showRecurring: false,
      showFBLive: false,
      // XXX: FB.ui api cannot be used inside Switcher webview
      showPreview: false
    };
    this.$analytics.eventTrack("new-event-switcher", {
      category: 'open',
      label: ''
    });
    this.service = EditOrCreateEventService.getInstance();
    this.service.initBroadcast();
    this.service.initScope($scope);
    this.service.visibility = 'private'; //default to private for Switcher events

    this.maxValidStep = 1;
    this.step = 1;
    this.showError = false; // XXX: don't need BoxCasters here since inside switcher

    this.service.boxcasters.$promise.then(function () {
      _this.service.broadcast.boxcaster_id = 'stream_source:switcher';
    });
    this.testBandwidth().then(function (bw) {
      $scope.$evalAsync(function () {
        _this.bandwidth = bw; // initialize the broadcast

        var _this$BandwidthTestCl = _this.BandwidthTestClient.getBitrates(bw.availableBandwidth),
            videoBitrate = _this$BandwidthTestCl.videoBitrate,
            audioBitrate = _this$BandwidthTestCl.audioBitrate;

        if (_this.service.broadcast.target_video_bitrate == 'default') {
          _this.service.broadcast.target_video_bitrate = videoBitrate;
        }

        if (_this.service.broadcast.target_audio_bitrate == 'default') {
          _this.service.broadcast.target_audio_bitrate = audioBitrate;
        }
      });
    });
    this.loading = true;
    this.loadingPromises = [this.service.boxcasters.$promise, this.service.channels.$promise, this.futureBroadcasts.$promise];
    $q.all(this.loadingPromises).then(function () {
      return _this.loading = false;
    }); // Auto-focus on page load

    setTimeout(function () {
      return $('#eventName').focus();
    }, 0);
  }

  _createClass(EventsController, [{
    key: "postMessage",
    value: function postMessage(route, params) {
      params = params || {};
      var method = params.method;
      var path = params.path;
      return __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min___default.a.send(window.parent, route, params).then(function (event) {
        return event;
      })["catch"](function (err) {
        throw err;
      });
    }
  }, {
    key: "testBandwidth",
    value: function testBandwidth() {
      return this.BandwidthTestClient.runTestOrUseRecentCached();
    }
  }, {
    key: "loadFutureBroadcasts",
    value: function loadFutureBroadcasts() {
      this.futureBroadcasts = this.Broadcast.query({
        'filter.stream_source': 'switcher',
        q: 'timeframe:current timeframe:preroll timeframe:future',
        s: 'starts_at',
        l: '20'
      });
    }
  }, {
    key: "isActive",
    value: function isActive(broadcast) {
      // TODO: reconcile difference between "active" (meaning switcher knows about it)
      // and "current" (meaning it's scheduled to be running now)
      return broadcast.timeframe == 'current' && this.currentSwitcherChannelSettings && this.currentSwitcherChannelSettings['channel-name'] == broadcast.name;
    }
  }, {
    key: "isSelected",
    value: function isSelected(broadcast) {
      return this.selectedBroadcast == broadcast;
    }
  }, {
    key: "toggleSelectedBroadcast",
    value: function toggleSelectedBroadcast(broadcast) {
      if (this.selectedBroadcast === broadcast) {
        this.selectedBroadcast = null;
      } else {
        this.selectedBroadcast = broadcast;
      }
    }
  }, {
    key: "activateBroadcast",
    value: function activateBroadcast(broadcast) {
      var _this2 = this;

      var $q = this.$q,
          toaster = this.toaster;
      var promise;

      if (broadcast.timeframe == 'current') {
        promise = $q(function (res, rej) {
          _this2.Broadcast.get({
            id: broadcast.id
          }, function (b) {
            return res(b);
          }, function (err) {
            return rej(err);
          });
        });
      } else {
        promise = this.EditOrCreateEventService.activateBroadcast(broadcast);
      }

      promise.then(function (broadcast) {
        _this2.waitForOrigin(broadcast).then(function (broadcast) {
          if (_this2.switcherAppMode == 'boxcast_switcher_webview') {
            window.webkit.messageHandlers.switcher.postMessage({
              action: 'dismiss'
            });
          } else {
            _this2.pokeV3APIWithNewBroadcast(broadcast, function () {
              _this2.postMessage('ui', {
                method: 'terminateBCProfileCreation',
                params: {
                  profile: _this2.currentSwitcherChannelSettings
                }
              });
            }, function () {
              _this2.toaster.pop('warning', 'Unable to communicate with Switcher Studio.');
            });
          }
        });
      })["catch"](function (response) {
        var errorDetails = Object(__WEBPACK_IMPORTED_MODULE_0__utils_error__["a" /* errorDescriptionFromResponse */])(response);

        _this2.toaster.pop('warning', 'Unable to activate the broadcast.\n\n' + errorDetails);
      });
      this.selectedBroadcast = null;
      this.loadingPromises = [promise];
    }
  }, {
    key: "pokeV3APIWithNewBroadcast",
    value: function pokeV3APIWithNewBroadcast(broadcast) {
      var _this3 = this;

      var successCB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var errorCB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var $timeout = this.$timeout,
          toaster = this.toaster;
      var rtmpParts = Object(__WEBPACK_IMPORTED_MODULE_1__events_broadcast_with_rtmp_controller__["c" /* splitRtmpUrl */])(broadcast.rtmp_ingestion_url);
      var resolution = Object(__WEBPACK_IMPORTED_MODULE_1__events_broadcast_with_rtmp_controller__["b" /* resolutionForBroadcast */])(broadcast);
      var data = angular.extend({}, this.currentSwitcherChannelSettings, {
        StreamingProviderId: PROVIDER_ID,
        url: rtmpParts[0],
        'rtmp-stream': rtmpParts[1],
        //'version': '1',
        'audio-channel-count': 2,
        'audio-sample-rate': 44100,
        'video-frame-height': resolution.height,
        'video-frame-width': resolution.width,
        //'user-editable': true,
        'channel-name': broadcast.name
      });

      if (broadcast.target_audio_bitrate && !isNaN(broadcast.target_audio_bitrate)) {
        data['audio-bit-rate'] = broadcast.target_audio_bitrate;
      }

      if (broadcast.target_video_bitrate && !isNaN(broadcast.target_video_bitrate)) {
        data['video-bit-rate'] = broadcast.target_video_bitrate;
      }

      var method = 'PUT';

      if (Object.keys(this.currentSwitcherChannelSettings).length == 0) {
        method = 'POST';
      }

      return this.postMessage('api', {
        method: method,
        path: "/api/StreamingProviders/".concat(PROVIDER_ID, "/SwitcherStreamSettings"),
        data: data
      }).then(function (event) {
        console.log('Updated Switcher channel settings', event);

        if (event.data && event.data.ExceptionMessage) {
          $timeout(function () {
            return toaster.pop('warning', "There was an error communicating with Switcher Studio: ".concat(event.data.ExceptionMessage));
          });
        } else {
          $timeout(function () {
            return _this3.currentSwitcherChannelSettings = event.data;
          });
        }

        if (successCB) {
          $timeout(function () {
            return successCB();
          });
        }
      })["catch"](function (err) {
        console.error(err);
        $timeout(function () {
          return _this3.initializingSwitcherStudioV3 = false;
        });

        if (errorCB) {
          $timeout(function () {
            return errorCB();
          });
        }
      });
    }
  }, {
    key: "stopBroadcast",
    value: function stopBroadcast(broadcast) {
      var _this4 = this;

      var promise = this.EditOrCreateEventService.stopBroadcast(broadcast).then(function () {
        _this4.loadFutureBroadcasts();
      })["catch"](function (response) {
        var errorDetails = Object(__WEBPACK_IMPORTED_MODULE_0__utils_error__["a" /* errorDescriptionFromResponse */])(response);

        _this4.toaster.pop('warning', 'Unable to stop broadcast. Please check your fields and try again.\n\n' + errorDetails);
      });
      this.selectedBroadcast = null;
      this.loadingPromises = [promise];
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this5 = this;

      // XXX: called by new-event-quick directive when scheduling
      var toaster = this.toaster;
      this.showError = false;
      this.submitting = true;
      this.service.saveChanges().then(function (broadcast) {
        _this5.submitting = false;

        _this5.$analytics.eventTrack("new-event-".concat(_this5.wizard ? 'wizard' : 'quick'), {
          category: 'saved',
          label: ''
        }); // NOTE: now that the event is "active" (due to time-based scheduling), we can dismiss
        // the web view and let the app take over.


        _this5.toaster.pop('success', 'Event successfully scheduled.');

        if (_this5.switcherAppMode == 'boxcast_switcher_webview') {
          window.webkit.messageHandlers.switcher.postMessage({
            action: 'dismiss'
          });
        } else {
          if (broadcast.timeframe == 'current') {
            _this5.waitForOrigin(broadcast).then(function (broadcast) {
              console.log('Origin ready for broadcast', broadcast);

              _this5.pokeV3APIWithNewBroadcast(broadcast, function () {
                _this5.postMessage('ui', {
                  method: 'terminateBCProfileCreation',
                  params: {
                    profile: _this5.currentSwitcherChannelSettings
                  }
                });
              }, function () {
                _this5.toaster.pop('warning', 'Unable to communicate with Switcher Studio.');
              });
            });
          } else {
            _this5.loadFutureBroadcasts();

            _this5.tab = 'scheduled';
          }
        }
      })["catch"](function (error) {
        var errorDetails = Object(__WEBPACK_IMPORTED_MODULE_0__utils_error__["a" /* errorDescriptionFromResponse */])(error);

        if (errorDetails == 'invalid') {
          _this5.showError = true;
          $('html, body').animate({
            scrollTop: 0
          });
        } else {
          console.error(error);

          _this5.toaster.pop('warning', 'Unable to save broadcast. Please check your fields and try again.\n\n' + errorDetails);
        }

        _this5.submitting = false;

        _this5.$analytics.eventTrack("new-event-".concat(_this5.wizard ? 'wizard' : 'quick'), {
          category: 'error',
          label: errorDetails
        });
      });
    }
  }, {
    key: "waitForOrigin",
    value: function waitForOrigin(broadcast) {
      var _this7 = this;

      var $uibModal = this.$uibModal;
      var updatedBroadcast;
      return $uibModal.open({
        template: __webpack_require__(481),
        controller: function controller($http, $interval, $uibModalInstance, $scope) {
          'ngInject';

          var _this6 = this;

          this.statusPct = 0;
          this.interval = $interval(function () {
            $http.get("".concat(API_ROOT, "/account/broadcasts/").concat(broadcast.id, "/view?channel_id=").concat(broadcast.channel_id)).then(function (view) {
              _this6.statusPct = view.data.progress;

              if (_this6.statusPct >= 90 || view.data.status != 'catching_up') {
                _this6.cancel();
              }
            });
          }, 1000);
          $scope.$on('$destroy', function () {
            $interval.cancel(_this6.interval);
          });

          this.cancel = function () {
            $uibModalInstance.close();
          };
        },
        controllerAs: 'vm'
      }).result.then(function () {
        updatedBroadcast = _this7.Broadcast.get({
          id: broadcast.id
        });
        return updatedBroadcast.$promise;
      }).then(function () {
        return updatedBroadcast;
      });
    }
  }]);

  return EventsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (EventsController);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">Please Wait</h3>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-center\">Broadcast is preparing...</p>\n  <uib-progressbar value=\"vm.statusPct\" max=\"100\">\n    {{vm.statusPct}}% Complete\n  </uib-progressbar>\n</div>\n<div class=\"modal-footer\">\n    <div class=\"pull-right\">\n      <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel()\">Close</button>\n    </div>\n</div>\n"

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('checkout', []);
module.config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('checkout', {
    url: '/:pd_did?pd_sid?start_step',
    template: "",
    controller: function controller($state) {
      // Remove undefined params
      Object.keys($state.params).forEach(function (key) {
        if (!$state.params[key]) {
          delete $state.params[key];
        }
      });
      var urlParams = new URLSearchParams($state.params);
      window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/checkout?") + urlParams);
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
var module = angular.module('app.resources', []); // The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.

__webpack_require__(484);

__webpack_require__(486);

__webpack_require__(487);

__webpack_require__(488);

__webpack_require__(489);

__webpack_require__(490);

__webpack_require__(491);

__webpack_require__(492);

__webpack_require__(493);

__webpack_require__(494);

__webpack_require__(495);

__webpack_require__(496);

__webpack_require__(497);

__webpack_require__(498);

__webpack_require__(499);

__webpack_require__(500);

__webpack_require__(501);

__webpack_require__(502);

__webpack_require__(503);

__webpack_require__(504);

__webpack_require__(505);

__webpack_require__(506);

__webpack_require__(507);

__webpack_require__(508);

__webpack_require__(509);

__webpack_require__(510);

__webpack_require__(511);

__webpack_require__(512);

__webpack_require__(513);

__webpack_require__(514);

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_objectify__ = __webpack_require__(485);

var module = angular.module('app.resources');

var transformAccountResponse = function transformAccountResponse(data) {
  var account = angular.fromJson(data); // Some fields that might be blank strings we actually want to be empty hashes

  if (!account['content_settings']) account['content_settings'] = {};
  if (!account['metadata']) account['metadata'] = {}; // Some fields are space-separated lists (or arrays) of flags. Turn these into objects
  // where the flags become keys and the values are boolean.

  account['feature_flags'] = Object(__WEBPACK_IMPORTED_MODULE_0__utils_objectify__["a" /* arrayToObject */])(account['feature_flags'] || []);
  account['extra_features'] = Object(__WEBPACK_IMPORTED_MODULE_0__utils_objectify__["b" /* fieldsToObject */])(account['extra_features'] || '');
  account['usage_flags'] = Object(__WEBPACK_IMPORTED_MODULE_0__utils_objectify__["b" /* fieldsToObject */])(account['usage_flags'] || '');
  return account;
};

module.factory('Account', function ($resource, $cacheFactory) {
  'ngInject';

  var Account = $resource("".concat(API_ROOT, "/account"), {}, {
    get: {
      method: 'GET',
      cache: true,
      transformResponse: transformAccountResponse
    },
    update: {
      method: 'PUT',
      transformResponse: transformAccountResponse
    },
    // Scoreboard configuration
    getScoreboard: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/scoreboard_configuration")
    },
    updateScoreboard: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/account/scoreboard_configuration")
    },
    // Sportzcast Integration
    getSportzcast: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/sportzcast_configuration")
    },
    updateSportzcast: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/account/sportzcast_configuration")
    },
    // Kaltura Integration
    getKaltura: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/kaltura_configuration")
    },
    updateKaltura: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/account/kaltura_configuration")
    },
    // Billing
    getBilling: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/billing")
    },
    updateBilling: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/account/billing")
    },
    // Upgrades
    getUpgrades: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/upgrades"),
      isArray: true
    },
    createUpgrade: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/upgrades")
    },
    getProducts: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/products"),
      isArray: true
    },
    // Caption Vocabulary
    getCaptionVocabulary: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/caption_vocabulary")
    },
    updateCaptionVocabulary: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/account/caption_vocabulary")
    },
    // Usage summaries
    getUsageSummaries: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/usage_summaries"),
      isArray: true
    }
  });
  angular.extend(Account.prototype, {
    authorized: function authorized() {
      var ret = this.can_stream;

      if (this.contract == 'trial' && moment(this.expires_on).toDate() < new Date()) {
        ret = false;
      } else if (this.contract == 'trial' && this.status == 'initial') {
        ret = false;
      }

      return ret;
    },
    defaultReportState: function defaultReportState() {
      // Prefer viewer analytics, but fall back to tickets or donations
      if (!this.feature_flags.analytics) {
        if (!this.feature_flags.no_ticketed) {
          return 'reports.tickets';
        } else if (this.feature_flags.donations) {
          return 'reports.donations';
        }
      }

      return 'reports.viewer';
    },
    isTrialing: function isTrialing() {
      return this.contract == 'trial';
    },
    refresh: function refresh() {
      var _this = this;

      $cacheFactory.get('$http').remove("".concat(API_ROOT, "/account"));
      return Account.get().$promise.then(function (newAccount) {
        Object.keys(newAccount).forEach(function (k) {
          _this[k] = newAccount[k];
        });
        return _this;
      });
    },
    showOnboarding: function showOnboarding() {
      // TODO remove this when no longer testing product tours [UA-1023]
      var hasProductTourFlag = this.extra_features.product_tour;
      return this.status == 'onboarding' && this.metadata.onboarding_step && !hasProductTourFlag;
    }
  });
  return Account;
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = arrayToObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = fieldsToObject;
/**
 * Converts an array of field strings into an object with the fields as keys and true as values.
 *
 * @param  {Array} array An array of field strings. E.g. `["foo", "bar"]`
 * @return {Object}      An object with the fields as keys and true as values.
 *                       E.g. `{foo: true, bar: true}`
 */
function arrayToObject(array) {
  return _.reduce(array, function (m, flag) {
    if (flag) {
      m[flag] = true;
    }

    return m;
  }, {});
}
/**
 * Converts a string of space-separated fields into an object with the fields as keys and true as
 * values.
 *
 * @param  {String} fields A string with space-separated field values. E.g. `"foo bar"`
 * @return {Object}        An object with the fields as keys and true as values.
 *                         E.g. `{foo: true, bar: true}`
 */

function fieldsToObject(fields) {
  return arrayToObject(fields.split(/\s+/));
}

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources'); // XXX: Let the reader beware! I tried doing this with an interceptor on the resource below, but
// Angular 1.whatever does some _shenanigans_ with resource interceptors, and no matter what I
// tried, I could not get this to work that way. So this http interceptor looks for 404 responses
// on the current account reseller route and resolves them with an empty object.

module.config(function ($httpProvider) {
  'ngInject';

  $httpProvider.interceptors.push(function ($q) {
    return {
      responseError: function responseError(rejection) {
        if ((rejection.config || {}).url == "".concat(API_ROOT, "/account/reseller")) {
          rejection.status = 200;
          rejection.data = {};
          return $q.resolve(rejection);
        }

        return $q.reject(rejection);
      }
    };
  });
});
module.factory('AccountReseller', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/reseller"));
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('ActivationCodes', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/activations/:id"), {
    id: '@id'
  }, {
    activateAddon: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/account/activations/:id/addon")
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('AnalyticsResource', function AnalyticsResource($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/viewer_analytics/:channel_id"), {
    channel_id: '@channel_id'
  }, {});
});
module.factory('AnalyticsExportResource', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/viewer_analytics/:channel_id/export"), {
    channel_id: '@channel_id'
  }, {
    render: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/viewer_analytics/:channel_id/export"),
      responseType: 'arraybuffer',
      transformResponse: function transformResponse(data, headers) {
        return {
          blob: new Blob([data], {
            type: headers('content-type')
          }),
          headers: headers()
        };
      }
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('AppleTvApp', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/apple_tv_apps/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT'
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('BoxCaster', function ($resource) {
  'ngInject';

  var BoxCaster = $resource("".concat(API_ROOT, "/account/boxcasters/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT'
    },
    postRPC: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/boxcasters/:id/rpcs/:rpcId"),
      params: {
        id: '@id',
        rpcId: '@rpcId'
      }
    },
    getRPC: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/boxcasters/:id/rpcs/:rpcId"),
      params: {
        id: '@id',
        rpcId: '@rpcId'
      }
    },
    deleteRPC: {
      method: 'DELETE',
      url: "".concat(API_ROOT, "/account/boxcasters/:id/rpcs/:rpcId"),
      params: {
        id: '@id',
        rpcId: '@rpcId'
      }
    },
    getRegistration: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/boxcaster/registration")
    },
    postRegistration: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/boxcasters")
    }
  });

  BoxCaster.prototype.hasWifi = function () {
    return this.id.startsWith('o') || this.id.startsWith('p');
  };

  BoxCaster.prototype.isPro = function () {
    return this.id.startsWith('p');
  };

  return BoxCaster;
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Broadcast', function Broadcast($resource, $q, $http) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/broadcasts/:id"), {
    id: '@id',
    simulcast_id: '@simulcast_id'
  }, {
    get: {
      method: 'GET',
      transformResponse: function transformResponse(data) {
        var broadcast = angular.fromJson(data);

        if (!broadcast.content_settings) {
          broadcast.content_settings = {};
        }

        if (!broadcast.metadata) {
          broadcast.metadata = {};
        }

        return broadcast;
      }
    },
    create: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/broadcasts")
    },
    patch: {
      method: 'PATCH'
    },
    update: {
      method: 'PUT'
    },
    view: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/broadcasts/:id/view")
    },
    deleteRecurring: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/broadcasts/:id/delete_recurring")
    },
    // Score here is the actual game/match score
    getScore: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/broadcasts/:id/metadata/scoreboard")
    },
    saveScore: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/account/broadcasts/:id/metadata/scoreboard")
    },
    scheduleSimulcast: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/broadcasts/:id/simulcast_configuration/:simulcast_id/schedule")
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Caption', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/broadcasts/:broadcast_id/captions/:id"), {
    broadcast_id: '@broadcast_id',
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true
    },
    create: {
      method: 'POST'
    },
    "delete": {
      method: 'DELETE'
    },
    update: {
      method: 'PUT'
    },
    render: {
      method: 'GET',
      params: {
        type: '@format'
      },
      url: "".concat(API_ROOT, "/account/broadcasts/:broadcast_id/captions/:id/render?format=:format"),
      responseType: 'arraybuffer',
      transformResponse: function transformResponse(data, headers) {
        return {
          blob: new Blob([data], {
            type: headers('Content-Type')
          })
        };
      }
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Channel', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/channels/:id"), {
    id: '@id'
  }, {
    create: {
      method: 'POST'
    },
    update: {
      method: 'PUT'
    },
    getBroadcasts: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/channels/:id/broadcasts"),
      isArray: true
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('BroadcastTags', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/broadcast_tags/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/broadcast_tags?l=1000"),
      isArray: true
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Donation', function Donation($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/donations/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT'
    },
    summary: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/donations/summary")
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('FacebookUser', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/facebook_users/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true
    },
    create: {
      method: 'POST'
    },
    "delete": {
      method: 'DELETE'
    },
    update: {
      method: 'PUT'
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var module = angular.module('app.resources'); // From https://dev.maxmind.com/geoip/legacy/codes

var CONTINENT_CODE_FROM_COUNTRY_CODE = {
  AD: 'EU',
  AE: 'AS',
  AF: 'AS',
  AG: 'NA',
  AI: 'NA',
  AL: 'EU',
  AM: 'AS',
  AN: 'NA',
  AO: 'AF',
  AP: 'AS',
  AQ: 'AN',
  AR: 'SA',
  AS: 'OC',
  AT: 'EU',
  AU: 'OC',
  AW: 'NA',
  AX: 'EU',
  AZ: 'AS',
  BA: 'EU',
  BB: 'NA',
  BD: 'AS',
  BE: 'EU',
  BF: 'AF',
  BG: 'EU',
  BH: 'AS',
  BI: 'AF',
  BJ: 'AF',
  BL: 'NA',
  BM: 'NA',
  BN: 'AS',
  BO: 'SA',
  BR: 'SA',
  BS: 'NA',
  BT: 'AS',
  BV: 'AN',
  BW: 'AF',
  BY: 'EU',
  BZ: 'NA',
  CA: 'NA',
  CC: 'AS',
  CD: 'AF',
  CF: 'AF',
  CG: 'AF',
  CH: 'EU',
  CI: 'AF',
  CK: 'OC',
  CL: 'SA',
  CM: 'AF',
  CN: 'AS',
  CO: 'SA',
  CR: 'NA',
  CU: 'NA',
  CV: 'AF',
  CX: 'AS',
  CY: 'AS',
  CZ: 'EU',
  DE: 'EU',
  DJ: 'AF',
  DK: 'EU',
  DM: 'NA',
  DO: 'NA',
  DZ: 'AF',
  EC: 'SA',
  EE: 'EU',
  EG: 'AF',
  EH: 'AF',
  ER: 'AF',
  ES: 'EU',
  ET: 'AF',
  EU: 'EU',
  FI: 'EU',
  FJ: 'OC',
  FK: 'SA',
  FM: 'OC',
  FO: 'EU',
  FR: 'EU',
  FX: 'EU',
  GA: 'AF',
  GB: 'EU',
  GD: 'NA',
  GE: 'AS',
  GF: 'SA',
  GG: 'EU',
  GH: 'AF',
  GI: 'EU',
  GL: 'NA',
  GM: 'AF',
  GN: 'AF',
  GP: 'NA',
  GQ: 'AF',
  GR: 'EU',
  GS: 'AN',
  GT: 'NA',
  GU: 'OC',
  GW: 'AF',
  GY: 'SA',
  HK: 'AS',
  HM: 'AN',
  HN: 'NA',
  HR: 'EU',
  HT: 'NA',
  HU: 'EU',
  ID: 'AS',
  IE: 'EU',
  IL: 'AS',
  IM: 'EU',
  IN: 'AS',
  IO: 'AS',
  IQ: 'AS',
  IR: 'AS',
  IS: 'EU',
  IT: 'EU',
  JE: 'EU',
  JM: 'NA',
  JO: 'AS',
  JP: 'AS',
  KE: 'AF',
  KG: 'AS',
  KH: 'AS',
  KI: 'OC',
  KM: 'AF',
  KN: 'NA',
  KP: 'AS',
  KR: 'AS',
  KW: 'AS',
  KY: 'NA',
  KZ: 'AS',
  LA: 'AS',
  LB: 'AS',
  LC: 'NA',
  LI: 'EU',
  LK: 'AS',
  LR: 'AF',
  LS: 'AF',
  LT: 'EU',
  LU: 'EU',
  LV: 'EU',
  LY: 'AF',
  MA: 'AF',
  MC: 'EU',
  MD: 'EU',
  ME: 'EU',
  MF: 'NA',
  MG: 'AF',
  MH: 'OC',
  MK: 'EU',
  ML: 'AF',
  MM: 'AS',
  MN: 'AS',
  MO: 'AS',
  MP: 'OC',
  MQ: 'NA',
  MR: 'AF',
  MS: 'NA',
  MT: 'EU',
  MU: 'AF',
  MV: 'AS',
  MW: 'AF',
  MX: 'NA',
  MY: 'AS',
  MZ: 'AF',
  NA: 'AF',
  NC: 'OC',
  NE: 'AF',
  NF: 'OC',
  NG: 'AF',
  NI: 'NA',
  NL: 'EU',
  NO: 'EU',
  NP: 'AS',
  NR: 'OC',
  NU: 'OC',
  NZ: 'OC',
  OM: 'AS',
  PA: 'NA',
  PE: 'SA',
  PF: 'OC',
  PG: 'OC',
  PH: 'AS',
  PK: 'AS',
  PL: 'EU',
  PM: 'NA',
  PN: 'OC',
  PR: 'NA',
  PS: 'AS',
  PT: 'EU',
  PW: 'OC',
  PY: 'SA',
  QA: 'AS',
  RE: 'AF',
  RO: 'EU',
  RS: 'EU',
  RU: 'EU',
  RW: 'AF',
  SA: 'AS',
  SB: 'OC',
  SC: 'AF',
  SD: 'AF',
  SE: 'EU',
  SG: 'AS',
  SH: 'AF',
  SI: 'EU',
  SJ: 'EU',
  SK: 'EU',
  SL: 'AF',
  SM: 'EU',
  SN: 'AF',
  SO: 'AF',
  SR: 'SA',
  ST: 'AF',
  SV: 'NA',
  SY: 'AS',
  SZ: 'AF',
  TC: 'NA',
  TD: 'AF',
  TF: 'AN',
  TG: 'AF',
  TH: 'AS',
  TJ: 'AS',
  TK: 'OC',
  TL: 'AS',
  TM: 'AS',
  TN: 'AF',
  TO: 'OC',
  TR: 'EU',
  TT: 'NA',
  TV: 'OC',
  TW: 'AS',
  TZ: 'AF',
  UA: 'EU',
  UG: 'AF',
  UM: 'OC',
  US: 'NA',
  UY: 'SA',
  UZ: 'AS',
  VA: 'EU',
  VC: 'NA',
  VE: 'SA',
  VG: 'NA',
  VI: 'NA',
  VN: 'AS',
  VU: 'OC',
  WF: 'OC',
  WS: 'OC',
  YE: 'AS',
  YT: 'AF',
  ZA: 'AF',
  ZM: 'AF',
  ZW: 'AF'
};

var Geolocation = /*#__PURE__*/function () {
  function Geolocation($q, $timeout) {
    _classCallCheck(this, Geolocation);

    this.$q = $q;
    this.$timeout = $timeout;
  }

  _createClass(Geolocation, [{
    key: "get",
    value: function get() {
      var _this = this;

      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.$q(function (resolve, reject) {
        if (!window.fetch) {
          // your browser is bad and you should feel bad
          reject("your browser does not support 'fetch'");
          return;
        }

        var timeout = opts && opts.timeout;
        var timedOut = false;

        if (timeout) {
          _this.$timeout(function () {
            timedOut = true;
            reject('timed out');
          }, timeout);
        }

        fetch(GEO_URL).then(function (res) {
          return res.json();
        }).then(function (resp) {
          // Try to glue on the continent code from the response. Ideally this would happen in the
          // geoip_service, but it's not quite so straightforward, unfortunately.
          if (resp.country_code) {
            var continentCode = CONTINENT_CODE_FROM_COUNTRY_CODE[resp.country_code];

            if (continentCode) {
              resp.continent_code = continentCode;
            }
          }

          if (!timedOut) {
            resolve(resp);
          }
        })["catch"](function (error) {
          if (!timedOut) {
            reject(error);
          }
        });
      });
    }
  }]);

  return Geolocation;
}();

module.factory('Geolocation', function ($q, $timeout) {
  'ngInject';

  return new Geolocation($q, $timeout);
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// Highlights are very similar to regular broadcasts recordings with a trimmed
// start and stop segment.
//
// The list of all highlights for a given broadcast is at:
//    GET /account/broadcasts/{BID}/highlights
//
// The segment list for a given highlight is at:
//    GET /account/broadcasts/{BID}/highlights/{HID}/segments
//
// ... which can be found via the "view" endpoint:
//    GET /highlights/{HID}/view
//
// The trim points can be managed at:
//    GET/PUT /account/broadcasts/{BID}/highlights/{HID}
//        start_seconds & stop_seconds
//
var module = angular.module('app.resources');
module.factory('Highlight', function Highlight($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/broadcasts/:broadcastId/highlights/:id"), {
    broadcastId: '@broadcastId',
    id: '@id'
  }, {
    create: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/broadcasts/:broadcastId/highlights")
    },
    update: {
      method: 'PUT'
    },
    view: {
      method: 'GET',
      url: "".concat(API_ROOT, "/highlights/:id/view")
    },
    prepareDownload: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/highlights/:id/download")
    },
    getKalturaExportStatus: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/highlights/:id/kaltura_export")
    },
    startKalturaExport: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/highlights/:id/kaltura_export")
    },
    getYoutubeExportStatus: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/highlights/:id/youtube_export")
    },
    startYoutubeExport: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/highlights/:id/youtube_export")
    },
    getVimeoExportStatus: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/highlights/:id/vimeo_export")
    },
    startVimeoExport: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/highlights/:id/vimeo_export")
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Order', function ($resource) {
  'ngInject';

  var Order = $resource("".concat(API_ROOT, "/account/orders/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true
    }
  });
  return Order;
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('TwitterUser', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/twitter_users/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true
    },
    create: {
      method: 'POST'
    },
    "delete": {
      method: 'DELETE'
    },
    update: {
      method: 'PUT'
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Podcast', function ($resource) {
  'ngInject';

  return $resource("".concat(SYNDICATION_SERVICE_BASE_URL, "/podcasts"), {}, {
    getCategories: {
      method: 'GET',
      url: "".concat(SYNDICATION_SERVICE_BASE_URL, "/config/podcast-categories")
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Recording', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/recordings/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT'
    },
    segments: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/recordings/:id/segments"),
      isArray: true
    },
    prepareDownload: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/recordings/:id/download")
    },
    getKalturaExportStatus: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/recordings/:id/kaltura_export")
    },
    startKalturaExport: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/recordings/:id/kaltura_export")
    },
    getYoutubeExportStatus: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/recordings/:id/youtube_export")
    },
    startYoutubeExport: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/recordings/:id/youtube_export")
    },
    getVimeoExportStatus: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/recordings/:id/vimeo_export")
    },
    startVimeoExport: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/recordings/:id/vimeo_export")
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 503 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var module = angular.module('app.resources');
var lastRequesterAddress = null;
module.config(["$httpProvider", function ($httpProvider) {
  'ngInject';

  $httpProvider.interceptors.push(["$q", function ($q) {
    return {
      response: function response(_response) {
        var requesterAddress = _response.headers('BoxCast-Requester-Address');

        if (requesterAddress) {
          lastRequesterAddress = requesterAddress;
        }

        return _response;
      }
    };
  }]);
}]);
module.service('Requester', /*#__PURE__*/function () {
  function AuthService() {
    _classCallCheck(this, AuthService);
  }

  _createClass(AuthService, [{
    key: "address",
    get: function get() {
      return lastRequesterAddress;
    }
  }]);

  return AuthService;
}());

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('RokuApp', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/roku_apps/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT'
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_rtmp__ = __webpack_require__(16);

var module = angular.module('app.resources');
module.factory('RTMPPushChannel', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/rtmp_push_channels/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true,
      transformResponse: function transformResponse(data, headersGetter, status) {
        return _.map(angular.fromJson(data), __WEBPACK_IMPORTED_MODULE_0__utils_rtmp__["c" /* TransformRTMPPushChannelAPIToClient */]);
      }
    },
    get: {
      method: 'GET',
      transformResponse: function transformResponse(data, headersGetter, status) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils_rtmp__["c" /* TransformRTMPPushChannelAPIToClient */])(angular.fromJson(data));
      }
    },
    create: {
      method: 'POST',
      transformRequest: function transformRequest(data, headersGetter) {
        return angular.toJson(Object(__WEBPACK_IMPORTED_MODULE_0__utils_rtmp__["d" /* TransformRTMPPushChannelClientToAPI */])(data));
      },
      transformResponse: function transformResponse(data, headersGetter, status) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils_rtmp__["c" /* TransformRTMPPushChannelAPIToClient */])(angular.fromJson(data));
      }
    },
    "delete": {
      method: 'DELETE'
    },
    update: {
      method: 'PUT',
      transformRequest: function transformRequest(data, headersGetter) {
        return angular.toJson(Object(__WEBPACK_IMPORTED_MODULE_0__utils_rtmp__["d" /* TransformRTMPPushChannelClientToAPI */])(data));
      },
      transformResponse: function transformResponse(data, headersGetter, status) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils_rtmp__["c" /* TransformRTMPPushChannelAPIToClient */])(angular.fromJson(data));
      }
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('ScoreboardAssistFirmware', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/scoreboard-assist/firmware/:id"), {
    id: '@id'
  }, {
    version: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/scoreboard-assist/firmware/:id/version"),
      transformResponse: function transformResponse(data) {
        return {
          version: data
        };
      }
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('StaticRTMP', function StaticRTMP($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/static_rtmps/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true
    },
    update: {
      method: 'PUT'
    },
    create: {
      method: 'POST'
    },
    "delete": {
      method: 'DELETE'
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Ticket', function Ticket($resource, $q) {
  'ngInject';

  var resource = $resource("".concat(API_ROOT, "/account/:resource/:id/tickets"), {
    id: '@id',
    resource: '@resource'
  }, {
    summary: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/:resource/:id/tickets/summary")
    }
  });

  resource.queryAll = function (params) {
    var tickets = [];
    var d = $q.defer();
    var paramsCopy = angular.copy(params);
    resource.query(paramsCopy, function (results, headers) {
      tickets = tickets.concat(results);
      var pagination = JSON.parse(headers('x-pagination'));

      if (!pagination || !pagination.last) {
        d.resolve(tickets);
        return;
      }

      var promises = [];

      for (var p = 1; p <= pagination.last; p++) {
        var paramsCopy2 = angular.copy(params);
        paramsCopy2.p = p;
        promises.push(resource.query(paramsCopy2).$promise);
      }

      $q.all(promises).then(function (results) {
        var i;

        for (i = 0; i < results.length; i++) {
          tickets = tickets.concat(results[i]);
        }

        d.resolve(tickets);
      })["catch"](function (e) {
        return d.reject(e);
      });
    }, function (err) {
      d.reject(err);
    });
    return d.promise;
  };

  return resource;
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('User', function ($resource) {
  'ngInject';

  var User = $resource("".concat(API_ROOT, "/user"), {
    accountId: '@accountId'
  }, {
    get: {
      method: 'GET',
      transformResponse: function transformResponse(data) {
        var user = angular.fromJson(data);

        if (!user.metadata) {
          user.metadata = {};
        }

        return user;
      }
    },
    update: {
      method: 'PUT'
    },
    updatePassword: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/user/password")
    },
    resendEmailVerification: {
      method: 'POST',
      url: "".concat(API_ROOT, "/user/resend_email_verification")
    },
    switchAccount: {
      method: 'POST',
      url: "".concat(API_ROOT, "/user/switch_account/:accountId")
    },
    validateEmail: {
      method: 'POST',
      url: "".concat(API_ROOT, "/checkout/validate_email")
    },
    getContact: {
      method: 'GET',
      url: "".concat(API_ROOT, "/user/contact")
    },
    updateContact: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/user/contact")
    }
  });
  angular.extend(User.prototype, {
    can: function can(action, resource) {
      var possibleActions = (this._capsByResource || {})[resource] || [];
      return possibleActions.some(function (possibleAction) {
        return action === possibleAction;
      });
    },
    cannot: function cannot(action, resource) {
      return !this.can(action, resource);
    },
    configureCapabilities: function configureCapabilities(capsByResource) {
      this._capsByResource = capsByResource;
    },
    reloadFromResource: function reloadFromResource(reloadedResource) {
      var _this = this;

      Object.keys(reloadedResource).forEach(function (k) {
        _this[k] = reloadedResource[k];
      });
    }
  });
  return User;
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('UserCapabilities', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/user/capabilities"), {}, {
    get: {
      method: 'GET',
      isArray: true
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('VimeoUser', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/vimeo_users/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true
    },
    create: {
      method: 'POST'
    },
    "delete": {
      method: 'DELETE'
    },
    update: {
      method: 'PUT'
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('YouTubeUser', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/youtube_users/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true
    },
    create: {
      method: 'POST'
    },
    "delete": {
      method: 'DELETE'
    },
    update: {
      method: 'PUT'
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Products', function ($rootScope, Sites, toaster) {
  'ngInject';

  var Products = [{
    label: 'Streaming',
    icon: 'fa-kit fa-app-live-streaming',
    isAllowed: true,
    handler: function handler() {
      window.location.href = window.VUE_DASHBOARD_ROOT;
    }
  }, {
    label: 'RemoteMix',
    icon: 'fa-kit fa-remotemix-secondary',
    isAllowed: !$rootScope.reseller.id,
    handler: function handler() {
      window.location.href = "".concat(window.VUE_DASHBOARD_ROOT, "/remote-mix");
    }
  }, {
    label: 'Sites',
    icon: 'fa-kit fa-app-sites',
    isAllowed: true,
    handler: function handler() {
      if (!$rootScope.account.feature_flags.sites) {
        window.location.href = "".concat(window.VUE_DASHBOARD_ROOT, "/sites");
        return;
      }

      Sites.getSites({}, function (response) {
        if (response.length === 0) {
          window.location.href = "".concat($rootScope.vueDashboardRoot, "/sites");
        } else {
          Sites.getSSOLink({}, function (data) {
            if (data.url) {
              window.location.href = data.url;
            }
          }, function (err) {
            return error(err);
          });
        }
      }, function (err) {
        return error(err);
      });

      function error(err) {
        toaster.pop('error', 'Something went wrong. Unable to connect to Sites.');
        console.log('Something went wrong connecting to Sites', err);
      }
    }
  }].filter(function (item) {
    return item.isAllowed;
  });
  return Products;
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Sites', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/sites"), {}, {
    getSSOLink: {
      method: 'GET',
      url: "".concat(API_ROOT, "/sites/sso/link")
    },
    getSites: {
      method: 'GET',
      isArray: true,
      url: "".concat(API_ROOT, "/account/sites/")
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__account_uploads_service__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_config__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bandwidth_test_client__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__capabilities__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__checkout__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__confirm_dialog__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__edit_or_create_event_service__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__facebook__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__jszip__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__meetings_service__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__multi_part_upload__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__one_or_all_dialog__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__overlays__ = __webpack_require__(532);













var module = angular.module('app.services', [__WEBPACK_IMPORTED_MODULE_0__account_uploads_service__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__api_config__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__bandwidth_test_client__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__capabilities__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__checkout__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__confirm_dialog__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__edit_or_create_event_service__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__facebook__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_8__jszip__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_9__meetings_service__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_10__multi_part_upload__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_11__one_or_all_dialog__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_12__overlays__["a" /* default */].name]);
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_files__ = __webpack_require__(517);

var module = angular.module('app.services.account-uploads-service', []); // Break large broadcast uploads into 100 MB pieces for multi-part upload

var MAX_CHUNK_SIZE = 100 * 1024 * 1024; // Amazon has a hard-limit on multi-part uploads of 5TB. However, there is a maximum number of
// 10,000 parts. So the limit is the minimum of 5 TB and 10,000 x MAX_CHUNK_SIZE.

var MAX_MULTI_PART_UPLOAD_SIZE = Math.min(5 * 1024 * 1024 * 1024 * 1024, 10000 * MAX_CHUNK_SIZE); // Put this in GB (and just round down) for the file size rule.

var MAX_MULTI_PART_UPLOAD_SIZE_GB = Math.floor(MAX_MULTI_PART_UPLOAD_SIZE / (1024 * 1024 * 1024)); // How long to be uploading before we start estimating time remaining (10s)

var TIME_REMAINING_THRESHOLD_MS = 10000;
module.service('AccountUploadsService', function ($http, $timeout, $q, $window, toaster, Upload, MultiPartUpload) {
  this.uploadConfiguration = function (allowVideo, allowImage, slotName) {
    var result = {};
    result.rules = {
      size: allowVideo ? {
        max: '5GB'
      } : {
        max: '1MB'
      },
      pattern: (allowImage ? '.jpg,.jpeg,.png,.gif' : '') + (allowVideo && allowImage ? ',' : '') + (allowVideo ? '.mp4' : '')
    };

    switch (slotName) {
      case 'broadcast':
        result.rules.pattern = '.mp4,.mov';
        result.rules.size = {
          max: "".concat(MAX_MULTI_PART_UPLOAD_SIZE_GB, "GB")
        };
        result.fileTypeSentence = 'a video';
        result.helpText = '[MP4, MOV]';
        result.showVideoHelp = false;
        break;

      case 'preview': //thumbnail

      case 'poster':
        result.fileTypeSentence = 'an image';
        result.helpText = '[PNG, JPG] [1920x1080px]';
        break;

      case 'preroll':
        result.fileTypeSentence = 'an MP4';
        result.showVideoHelp = true; // XXX: need to figure out how to inject link

        result.helpText = '[Recommend 720p with FastStart]';
        break;

      case 'overlay':
        result.fileTypeSentence = 'a PNG';
        result.helpText = '[up to 1920x1080px] [5MB]';
        result.rules.size = {
          max: '5MB'
        };
        result.rules.pattern = '.png';
        break;

      case 'document':
        result.fileTypeSentence = 'a PDF';
        result.helpText = '[5MB]';
        result.rules.size = {
          max: '5MB'
        };
        result.rules.pattern = '.pdf';
        break;

      case 'caption':
        result.fileTypeSentence = 'a WebVTT file';
        result.helpText = '(up to 5MB)';
        result.rules.size = {
          max: '5MB'
        };
        result.rules.pattern = '.vtt';
        break;

      case 'csv':
        result.fileTypeSentence = 'a CSV file';
        result.helpText = '(up to 5MB)';
        result.rules.size = {
          max: '5MB'
        };
        result.rules.pattern = '.csv';
        break;

      case 'podcast-preview':
        result.fileTypeSentence = 'an image';
        result.helpText = '[PNG, JPG] [Min 1400x1400px] [Max 3000x3000px] [12MB] [72dpi] [RGB]';
        result.rules.size = {
          max: '12MB'
        };
        break;

      case 'app-assets':
        result.fileTypeSentence = 'an image';
        result.helpText = '[PNG, JPG]';
        break;

      default:
        result.fileTypeSentence = 'a file to upload';
    }

    return result;
  };

  this.searchUnsplash = function (query) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15;
    this.unsplashSearching = true;
    this.unsplashResults = null;
    return $http({
      method: 'GET',
      url: 'https://api.unsplash.com/search/photos',
      params: {
        query: query,
        page: page,
        per_page: pageSize
      },
      headers: {
        'Ignore-Http-Interceptor-Auth': true,
        Authorization: "Client-ID ".concat(UNSPLASH_APP_ID)
      }
    }).then(function (response) {
      return response.data;
    });
  };

  this.listUploadsForPage = function (p, q, filters, pageSize) {
    return $http.get("".concat(API_ROOT, "/account/uploads"), {
      params: _.extend({
        q: q,
        p: Math.max(0, p - 1),
        l: pageSize,
        s: '-created_at'
      }, filters)
    }).then(function (response) {
      var pagination = JSON.parse(response.headers('x-pagination'));
      return {
        uploads: response.data,
        pagination: {
          current: p,
          total: pagination.total,
          resultMin: pageSize * (p - 1) + 1,
          resultMax: pageSize * (p - 1) + response.data.length
        }
      };
    });
  };

  this.deleteUpload = function (upload) {
    return $http["delete"]("".concat(API_ROOT, "/account/uploads/").concat(upload.id));
  };

  this.destroy = function () {
    MultiPartUpload.destroy();
  };

  var monotonicTime = function monotonicTime() {
    if ($window.performance && $window.performance.now) {
      return $window.performance.now();
    }

    return Date.now();
  };

  var updateFileProgress = function updateFileProgress(file, evt) {
    // Update the total percentage
    file.progressPct = parseInt(100.0 * evt.loaded / evt.total); // See how long we've been at it

    var now = monotonicTime();
    var elapsedTimeMs = now - file.uploadStartedAt;

    if (elapsedTimeMs < TIME_REMAINING_THRESHOLD_MS) {
      return;
    } // If we've been uploading for longer than TIME_REMAINING_THRESHOLD_MS, then start estimating
    // the remaining upload time.


    var totalEstimateMs = elapsedTimeMs * 1.0 * evt.total / evt.loaded;
    file.estimatedTimeRemainingMs = totalEstimateMs - elapsedTimeMs;
  };

  this.processFileAndUpload = function (file, slotName, args) {
    var uploadMetaUrl;
    var statusUploaded = 'uploaded';
    var statusFailed = 'error';

    if (slotName == 'broadcast') {
      if (!(args || {}).broadcast_id) {
        throw Error('broadcast_id is required');
      }

      uploadMetaUrl = "".concat(API_ROOT, "/account/broadcasts/").concat(args.broadcast_id, "/uploads");
      statusFailed = 'failed'; //XXX: upload_service uses `failed` instead of `error`
    } else {
      uploadMetaUrl = "".concat(API_ROOT, "/account/uploads");
    }

    file.status = 'uploading';
    file.progressPct = 0;
    file.uploadStartedAt = monotonicTime();
    var promise = $http.post(uploadMetaUrl, {
      filename: Object(__WEBPACK_IMPORTED_MODULE_0__utils_files__["a" /* sanitizeFilenameForUpload */])(file.name),
      mimetype: file.type || 'application/octet-stream',
      mime_type: file.type || 'application/octet-stream',
      filesize: file.size,
      slot: slotName,
      max_chunk_size: MAX_CHUNK_SIZE
    }).then(function (result) {
      console.log('Created upload slot', result);
      var uploadId = result.data.id;
      var s3UploadPromise;

      if (result.data.parts && result.data.parts.length > 0) {
        // Multi-part upload
        s3UploadPromise = MultiPartUpload.start("".concat(uploadMetaUrl, "/").concat(uploadId), file, result.data.parts);
      } else if (result.data.presigned_url) {
        // XXX: Upload.http is required because multipart/form-data doesn't work with presigned PUT
        s3UploadPromise = Upload.http({
          url: result.data.presigned_url,
          headers: {
            'Content-Type': file.type
          },
          method: 'PUT',
          data: file
        });
      } else {
        var psp = result.data.signed_upload;
        s3UploadPromise = Upload.upload({
          url: psp.url,
          method: 'POST',
          data: _.extend({}, psp.params, {
            file: file
          })
        });
      }

      return s3UploadPromise.then(function (resp) {
        console.log('Successfully uploaded', resp.data);
        file.status = 'done';
        return $http.put("".concat(uploadMetaUrl, "/").concat(uploadId), {
          status: statusUploaded
        });
      }, function (err) {
        console.error('Error uploading:', err);
        toaster.pop('warning', "File ".concat(file.name, " failed to upload."));
        file.status = 'error';
        return $http.put("".concat(uploadMetaUrl, "/").concat(uploadId), {
          status: statusFailed
        });
      }, function (evt) {
        return updateFileProgress(file, evt);
      });
    }).then(function (response) {
      return response.data; //peel off artifact of using $http rather than ngResource
    });
    return promise;
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sanitizeFilenameForUpload;
function removeAllButLast(haystack, needle) {
  if (haystack.indexOf(needle) < 0) {
    return haystack;
  } else {
    var parts = haystack.split(needle);
    return parts.slice(0, -1).join('') + needle + parts.slice(-1);
  }
}

function sanitizeFilenameForUpload(filename) {
  var defaultFilename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'file';
  // Only keep the simplest set of url-safe characters to avoid ever escaping
  var cleaned = filename.replace(/\s+/g, '_').replace(/[^0-9a-zA-Z\._]/g, '_') || defaultFilename; // Only 1 period to avoid weird MIME issues

  return removeAllButLast(cleaned, '.');
}

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var module = angular.module('api-config', []); // Keep this around for lifetime of window/application, regardless of
// angular service lifecycle.

var globalState = {};
module.service('ApiConfig', function ($q, $http) {
  'ngInject'; // Once loading is complete, broadcast when our
  // promises have resolved to allow routing

  var _this = this;

  var deferredResolve = $q.defer();

  this.verifyResolved = function (res) {
    return deferredResolve.promise;
  }; // Stub


  this.account = {};
  this.stream = {};
  this.boxcaster = {};
  this.time_zones = [];
  this.content_languages = [];
  this.ticket = {};
  this.currentPage = 1; // Grab actual config values from API

  if (!_.keys(globalState).length) {
    $http.get("".concat(API_ROOT, "/api_configuration")).then(function (result) {
      _.each(result.data, function (value, key) {
        _this[key] = angular.copy(value);
        globalState[key] = angular.copy(value);
      });

      deferredResolve.resolve();
    });
  } else {
    _.each(globalState, function (value, key) {
      return _this[key] = value;
    });

    deferredResolve.resolve();
  }

  this.scopes = function () {
    return $http.get("".concat(API_ROOT, "/api_configuration/scopes")).then(function (r) {
      return r.data;
    });
  }; // Support basic promise API


  this.then = function () {
    var _deferredResolve$prom;

    return (_deferredResolve$prom = deferredResolve.promise).then.apply(_deferredResolve$prom, arguments);
  }; // Function to return field limits as a flattened hash per model


  this.modelFieldLimits = function (modelName, constraintName) {
    var constraints = angular.copy(_this.model_constraints[modelName] || {});

    _.each(constraints, function (v, k) {
      v = v[constraintName];

      if (!v) {
        delete constraints[k];
      } else {
        constraints[k] = v;
      }
    });

    return constraints;
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_video_and_audio_config__ = __webpack_require__(29);


var DefaultBandwidth = 2000000; // hope they have at least 2 MBps up

var BandwidthTextExpiresInMs = 10 * 60 * 1000; // 10 minutes

var OverallTimeoutInSec = 60; //1 minute

var bandwidthFactor = 0.6,
    // Only use ~60% of the available bandwidth
videoToAudioBitrateScale = 8; // Starting at the minimum, for every 1 bit we add to audio, we add this many bits to video

var module = angular.module('bandwidth-test-client', []);
module.service('BandwidthTestClient', function (Requester, $q) {
  'ngInject';

  var _this = this;

  var audioBitrates = _(__WEBPACK_IMPORTED_MODULE_1__utils_video_and_audio_config__["a" /* VideoAudioConfig */].stream.audio_bitrates).pluck('value').map(function (x) {
    return parseInt(x, 10);
  }).filter().value();

  var videoBitrates = _(__WEBPACK_IMPORTED_MODULE_1__utils_video_and_audio_config__["a" /* VideoAudioConfig */].stream.video_bitrates).pluck('value').map(function (x) {
    return parseInt(x, 10);
  }).filter(function (x) {
    return x && x > 10000;
  }).value();

  this.init = function () {
    return $q(function (resolve, reject) {
      __webpack_require__.e/* require.ensure */(2).then((function () {
        var BandwidthTestClient = __webpack_require__(565);

        resolve(BandwidthTestClient);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    });
  };

  this.cancelIfInFlight = function () {
    if (_this._bandwidthTest) {
      _this._bandwidthTest.cancel();
    }
  };

  this.runTestOrUseRecentCached = function () {
    var onProgress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var alwaysRun = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return $q(function (resolve, reject) {
      _this.init().then(function (BandwidthTest) {
        // In order to prevent extra bandwidth probing, we can skip the bandwidth test if:
        //  - A bandwidth test has been done before, and
        //  - It was done from the same internet-facing address, and
        //  - It was done within the last 10 minutes.
        var lastBandwidthTest = __WEBPACK_IMPORTED_MODULE_0__auth_utils__["d" /* storage */].get('lastBwTest') && JSON.parse(__WEBPACK_IMPORTED_MODULE_0__auth_utils__["d" /* storage */].get('lastBwTest'));
        var skipBandwidthTest = lastBandwidthTest && lastBandwidthTest.success && (!Requester.address || lastBandwidthTest.requesterAddress == Requester.address) && lastBandwidthTest.timestamp && Date.now() - lastBandwidthTest.timestamp < BandwidthTextExpiresInMs;

        if (skipBandwidthTest && !alwaysRun) {
          console.log('Skipping another bandwidth test');
          resolve(angular.extend({
            fromCache: true
          }, lastBandwidthTest));
          return;
        }

        _this._bandwidthTest = new BandwidthTest({
          overallTimeout: OverallTimeoutInSec,
          onProgress: onProgress
        });
        var uploadTestUrl = "".concat(BANDWIDTH_TEST_URL, "/upload");

        _this._bandwidthTest.testUpload({
          url: uploadTestUrl
        }).then(function (r) {
          resolve({
            success: true,
            requesterAddress: Requester.address,
            availableBandwidth: r.bandwidth,
            rSquared: r.rSquared,
            timestamp: Date.now()
          });
        })["catch"](function (e) {
          console.warn('Failed to get available bandwidth; using default.', e);
          resolve({
            success: false,
            requesterAddress: Requester.address,
            availableBandwidth: DefaultBandwidth,
            timestamp: Date.now()
          });
        });
      });
    }).then(function (bw) {
      if (bw.success) {
        __WEBPACK_IMPORTED_MODULE_0__auth_utils__["d" /* storage */].set('lastBwTest', JSON.stringify(bw));
      }

      return bw;
    });
  };

  function getBitrateLimits(height, frameRate) {
    // Attempt to match bitrate based on other parameters to line up closely to the
    // transcoded output https://github.com/boxcast/origin_task/blob/master/stream/variant.go
    // NOTE that RTMP doesn't support UHD resolutions so they're not accounted for here.
    var audioMin = 48000,
        audioMax = 192000,
        videoMin = 300000,
        videoMax = 6000000;

    if (height < 720) {
      videoMax = 1700000;
    } else if (height == 720 && frameRate == 30) {
      videoMax = 2750000;
    } else if (height == 720 && frameRate == 60) {
      videoMax = 2750000;
    } else if (height == 1080 && frameRate == 30) {
      videoMax = 6000000;
    } else if (height == 1080 && frameRate == 60) {
      videoMax = 8000000;
    }

    return {
      audio: {
        min: audioMin,
        max: audioMax
      },
      video: {
        min: videoMin,
        max: videoMax
      },
      inflectionPoint: audioMax + videoMin + (audioMax - audioMin) * videoToAudioBitrateScale
    };
  }

  this.getBitrates = function (bandwidth) {
    var videoBitrate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var audioBitrate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var frameRate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var availableBandwidth = bandwidthFactor * bandwidth;
    var bitrateLimits = getBitrateLimits(height || 720, frameRate || 30);
    console.log('availableBandwidth', availableBandwidth);
    console.log('bitrateLimits', bitrateLimits);

    if (videoBitrate && !audioBitrate) {
      // Video bitrate fixed, choose audio
      audioBitrate = Math.min(Math.max(Math.round(availableBandwidth - videoBitrate), bitrateLimits.audio.min), bitrateLimits.audio.max);
    } else if (!videoBitrate && audioBitrate) {
      // Audio bitrate fixed, choose video
      videoBitrate = Math.min(Math.max(Math.round(availableBandwidth - audioBitrate), bitrateLimits.video.min), bitrateLimits.video.max);
    } else if (!videoBitrate && !audioBitrate) {
      // Choose both bitrates
      var min = bitrateLimits.audio.min + bitrateLimits.video.min;

      if (availableBandwidth <= min) {
        audioBitrate = bitrateLimits.audio.min;
        videoBitrate = bitrateLimits.video.min;
      } else if (availableBandwidth < bitrateLimits.inflectionPoint) {
        var max = bitrateLimits.audio.max + bitrateLimits.video.max,
            dX = (availableBandwidth - min) / (max - min);
        audioBitrate = Math.round(bitrateLimits.audio.min + dX * (bitrateLimits.audio.max - bitrateLimits.audio.min));
        videoBitrate = Math.round(bitrateLimits.video.min + dX * (bitrateLimits.video.max - bitrateLimits.video.min));
      } else {
        audioBitrate = bitrateLimits.audio.max;
        var leftoverForVideo = Math.round(availableBandwidth - audioBitrate);
        videoBitrate = Math.max(Math.min(leftoverForVideo, bitrateLimits.video.max), bitrateLimits.video.min);
      }
    }

    if (!videoBitrate) {
      videoBitrate = 0; //could be NaN
    } // Scale to nearest supported value


    videoBitrate = floorToClosest(videoBitrate, videoBitrates);
    audioBitrate = floorToClosest(audioBitrate, audioBitrates); // Recommend between 75% and 150% of the stated transcode limit for the given
    // resolution/framerate

    var minVideoBitrate = 0.75 * bitrateLimits.video.max;
    var maxVideoBitrate = 1.5 * bitrateLimits.video.max;
    return {
      videoBitrate: videoBitrate,
      audioBitrate: audioBitrate,
      minVideoBitrate: minVideoBitrate,
      maxVideoBitrate: maxVideoBitrate
    };
  };

  function floorToClosest(val, vals) {
    for (var i = 0; i < vals.length; i++) {
      if (vals[i] > val) {
        return vals[Math.max(0, i - 1)];
      }
    }

    return vals[vals.length - 1];
  }
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export globalState */
/* unused harmony export Capabilities */
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var module = angular.module('capabilities', []); // Keep this around for lifetime of window/application, regardless of
// angular service lifecycle.  Only export for testing purposes.

var globalState = {
  account: null,
  reseller: null,
  capabilities: null,
  user: null
};
function Capabilities(Account, AccountReseller, User, UserCapabilities, $q) {
  'ngInject'; // Wrap the loading in a basic promise API

  var _this = this;

  var promise;

  this.verifyResolved = function () {
    return promise;
  };

  this.then = function () {
    var _promise;

    (_promise = promise).then.apply(_promise, arguments);
  }; // Expose helper methods


  this.canUserVisitState = function (state) {
    if (_this.account.authorized()) {
      switch (state.name) {
        case 'channels':
          return _this.user.can('update', 'channel/*');

        case 'settings.boxcasters':
        case 'settings.edit_boxcaster':
        case 'sources':
          return _this.user.can('update', 'boxcaster/*');

        case 'settings.payment':
          return _this.user.can('list', 'orders');

        case 'settings.api_keys':
          return _this.user.can('create', 'api-key');

        case 'settings.integrations':
          return _this.user.can('list', 'facebook-users') || _this.user.can('list', 'twitter-users') || _this.user.can('list', 'vimeo-users') || _this.user.can('list', 'youtube-users') || _this.user.can('list', 'rtmp-push-channels') || _this.user.can('read', 'sportzcast-configuration');

        case 'settings.storage':
          return _this.user.can('update', 'billing') && _this.user.can('list', 'storage-bills') && (_this.account.storage_policy == 'auto-bill' || account.storage_policy == 'auto-delete');

        case 'embed':
          return _this.user.can('embed', 'broadcast/*');

        case 'reports.viewer':
          return _this.user.can('read', 'viewer-analytics/*');

        case 'reports.tickets':
          return _this.user.can('read', 'viewer-analytics/*') && _this.user.can('read', 'broadcast/*:tickets:summary') && _this.user.can('read', 'channel/*:tickets:summary') && _this.user.can('read', 'tickets:summary');

        case 'reports.donations':
          return _this.user.can('read', 'viewer-analytics/*') && _this.user.can('read', 'donations:summary');

        case 'new-event':
          return _this.user.can('create', 'broadcast');

        case 'uploads':
          return _this.user.can('create', 'upload');

        case 'extended-test':
          return _this.account.is_manufacturer;

        default:
          return true;
      }
    } else {
      switch (state.name) {
        case 'home':
        case 'logout':
        case 'settings.payment':
        case 'settings.upgrade':
        case 'checkout':
          return true;

        default:
          return false;
      }
    }
  };

  var init = function init(account, reseller, user, capabilities) {
    // Turn the list of capabilities into a hash keyed by resource
    var capsByResource = {};
    capabilities.forEach(function (cap) {
      var actions = capsByResource[cap.resource] || [];
      actions.push.apply(actions, _toConsumableArray(cap.actions));
      capsByResource[cap.resource] = actions;
    }); // Configure the user with the list of capabilities. This lets its `can` and `cannot` methods work.

    user.configureCapabilities(capsByResource);
  }; // Initialize with the account, capabilities, and user. Note that other services will ask for the
  // account and user, and use the capabilities via the user object.


  if (!globalState.account || !globalState.reseller || !globalState.user || !globalState.capabilities) {
    this.account = Account.get(function () {
      globalState.account = _this.account;
    });
    this.reseller = AccountReseller.get();
    this.user = User.get(function () {
      globalState.user = _this.user;
    });
    var capabilities = UserCapabilities.get();
    promise = $q.all([this.account.$promise, this.reseller.$promise, this.user.$promise, capabilities.$promise]).then(function () {
      return init(_this.account, _this.reseller, _this.user, capabilities);
    });
  } else {
    this.account = globalState.account;
    this.reseller = globalState.reseller;
    this.user = globalState.user;
    var _capabilities = globalState.capabilities;
    promise = $q.all([this.account.$promise, this.reseller.$promise, this.user.$promise, _capabilities.$promise]);
    init(this.account, this.reseller, this.user, _capabilities);
  }
}
module.service('Capabilities', Capabilities);
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CheckoutService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_stripe__ = __webpack_require__(35);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }


var module = angular.module('app.services.checkout', []);
var CheckoutService = /*#__PURE__*/function () {
  function CheckoutService($window, $timeout, $q, $http, Account) {
    'ngInject'; // Various SKU constants

    _classCallCheck(this, CheckoutService);

    this.BOXCASTER_SKU = 'BXC-HDSD2';
    this.BOXCASTER_PRO_SKU = 'BXC-PRO-2995';
    this.RETURN_LABEL_SKU = 'shipping-return-label';
    this.SHURE_KIT_SKU = 'BXC-AUDIO-IOS';
    this.SHURE_COUPON_SKU = 'coupon:one-time:promotion-bxc-audio-ios:28800'; // PD Template IDs

    this.PANDADOC_TEMPLATE_FREE_TRIAL = 'WAbYt2SgSbviDpwSfzdJpe';
    this.PANDADOC_TEMPLATE_FREE_TRIAL_WITH_PROMO = 'YE6QEWNPK3UvsZABvyTQkJ';
    this.$window = $window;
    this.$timeout = $timeout;
    this.$q = $q;
    this.$http = $http;
    this.Account = Account;
  }

  _createClass(CheckoutService, [{
    key: "registerPandadocWatcher",
    value: function registerPandadocWatcher($scope, handler) {
      var $window = this.$window;

      var onMessage = function onMessage(evt) {
        if (evt && evt.data) {
          try {
            var message = JSON.parse(evt.data);

            if (message && message.event) {
              onHandlePandadocMessage(message.event, message.data);
            }
          } catch (e) {
            console.warn(e);
          }
        }
      };

      var onHandlePandadocMessage = function onHandlePandadocMessage(event, data) {
        $scope.$evalAsync(function () {
          handler && handler(event, data);
        });
      };

      $window.addEventListener('message', onMessage, false);
      $scope.$on('$destroy', function () {
        $window.removeEventListener('message', onMessage);
      });
    }
  }, {
    key: "openPlaidLink",
    value: function openPlaidLink() {
      var _this = this;

      var deferred = this.$q.defer();
      Plaid.create({
        env: PLAID_ENV,
        key: PLAID_KEY,
        apiVersion: 'v2',
        clientName: 'BoxCast',
        product: ['auth'],
        selectAccount: true,
        onSuccess: function onSuccess(public_token, metadata) {
          _this.$http.post("".concat(INTEGRATIONS_ROOT, "/plaid/exchange_token"), {
            public_token: public_token,
            plaid_account_id: metadata.account_id
          }).then(function (response) {
            deferred.resolve({
              metadata: metadata,
              tokenResponse: response
            });
          })["catch"](function (err) {
            deferred.reject(err);
          });
        }
      }).open();
      return deferred.promise;
    }
  }, {
    key: "submitCard",
    value: function submitCard(stripeCard) {
      var _this2 = this;

      var deferred = this.$q.defer();
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_stripe__["c" /* getToken */])(stripeCard).then(function (token) {
        _this2.$timeout(function () {
          deferred.resolve(token);
        });
      })["catch"](function (err) {
        _this2.$timeout(function () {
          deferred.reject(err);
        });
      });
      return deferred.promise;
    }
  }, {
    key: "getLocations",
    value: function getLocations() {
      var _this3 = this;

      var deferred = this.$q.defer();
      var promises = [];
      this.states = [];
      this.countries = [];
      promises.push(this.$http.get('/img/states.json').then(function (response) {
        _this3.states = response.data;
      }));
      promises.push(this.$http.get('/img/countries.json').then(function (response) {
        _this3.countries = response.data;
      }));
      this.$q.all(promises).then(function () {
        deferred.resolve({
          states: _this3.states,
          countries: _this3.countries
        });
      });
      return deferred.promise;
    }
  }, {
    key: "getBilling",
    value: function getBilling() {
      var deferred = this.$q.defer();
      this.Account.getBilling().$promise.then(function (data) {
        deferred.resolve(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stripe__["e" /* parseBilling */])(data || {}));
      })["catch"](function (err) {
        if (err.status == 404) {
          // No linked Stripe customer
          deferred.resolve({}, null, null);
        } else {
          deferred.reject(err);
        }
      });
      return deferred.promise;
    }
  }, {
    key: "isPurchasingSubscription",
    value: function isPurchasingSubscription(proposal) {
      return proposal.products.subscription_items.length > 0;
    }
  }, {
    key: "validateBillingAddress",
    value: function validateBillingAddress(billing) {
      if (!billing) return false;
      return !!billing.address && !!billing.city && !!billing.state && !!billing.country && !!billing.postal_code;
    }
  }, {
    key: "validateShippingAddress",
    value: function validateShippingAddress(shipping) {
      return !!shipping.address && !!shipping.city && !!shipping.state && !!shipping.country && !!shipping.postal_code;
    }
  }, {
    key: "isDocumentSelfServiceGenerated",
    value: function isDocumentSelfServiceGenerated(currentUpgrade) {
      var pdMetadata = ((currentUpgrade.proposal || {}).document || {}).metadata || {};
      return isTruthy(pdMetadata.SelfService);
    }
  }, {
    key: "stripeBasePlanNameShortFromBillingResult",
    value: function stripeBasePlanNameShortFromBillingResult(billingResult) {
      var name = '';

      if (!billingResult.subscriptions || !billingResult.subscriptions.data) {
        return name;
      }

      billingResult.subscriptions.data.forEach(function (sub) {
        sub.items.data.forEach(function (subItem) {
          if (subItem.plan.metadata.is_addon == 'false') {
            var planNameContains = function planNameContains(str) {
              if (subItem.plan.id.toLowerCase().indexOf(str) >= 0) {
                return true;
              }

              if (((subItem.plan.metadata || {}).display_name || '').toLowerCase().indexOf(str) >= 0) {
                return true;
              }

              return false;
            };

            if (planNameContains('experience')) {
              name = 'Experience Plan';
            } else if (planNameContains('growth')) {
              name = 'Growth Plan';
            } else if (planNameContains('essential')) {
              name = 'Essential Plan';
            }
          }
        });
      });
      return name;
    }
  }, {
    key: "stripeBasePlanAmountFromBillingResult",
    value: function stripeBasePlanAmountFromBillingResult(billingResult) {
      var amount = 0;

      if (!billingResult.subscriptions || !billingResult.subscriptions.data) {
        return name;
      }

      billingResult.subscriptions.data.forEach(function (sub) {
        sub.items.data.forEach(function (subItem) {
          if (subItem.plan.metadata.is_addon == 'false') {
            amount = subItem.plan.amount / 100;
          }
        });
      });
      return amount;
    }
  }, {
    key: "stripeBasePlanLookupKeyFromBillingResult",
    value: function stripeBasePlanLookupKeyFromBillingResult(billingResult) {
      var lookupkey = '';
      billingResult.subscriptions.data.forEach(function (sub) {
        sub.items.data.forEach(function (subItem) {
          if (subItem.plan.metadata.is_addon == 'false') {
            lookupkey = subItem.price.lookup_key;
          }
        });
      });
      return lookupkey;
    }
  }, {
    key: "stripePlanIDs",
    value: function stripePlanIDs(basePlan, interval, selectedAddOns) {
      var IDs = [];

      if (interval == 'annual') {
        IDs.push("".concat(basePlan, ":").concat(interval));
      } else if (basePlan == 'essential') {
        IDs.push('essential:monthly:9900');
      } else if (basePlan == 'growth') {
        IDs.push('growth:monthly:14900');
      } else if (basePlan == 'experience') {
        IDs.push('experience:monthly:19900');
      }

      IDs.push.apply(IDs, _toConsumableArray(selectedAddOns || []));
      return IDs;
    }
  }, {
    key: "stripeSKUs",
    value: function stripeSKUs(encoder, oneTimeCharges) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var res = [];
      res.push.apply(res, _toConsumableArray(oneTimeCharges || []));

      if (encoder == 'boxcaster') {
        res.push(this.BOXCASTER_SKU);
      } else if (encoder == 'pro') {
        res.push(this.BOXCASTER_PRO_SKU);
      }

      if (options.shure_promo) {
        res.push(this.SHURE_KIT_SKU);
        res.push(this.SHURE_COUPON_SKU);
      }

      return res;
    }
  }, {
    key: "paymentMethodFromAccount",
    value: function paymentMethodFromAccount(account) {
      return _.find(['po', 'check', 'cc', 'ach'], function (m) {
        return account.payment_method == m;
      }) || 'cc';
    }
  }, {
    key: "currentInterval",
    value: function currentInterval(billing) {
      var subData = (billing.subscriptions || {}).data || [];
      var interval = '';

      if (subData.length > 0 && (subData[0].items.data || []).length > 0) {
        interval = subData[0].items.data[0].plan.interval;
      }

      return interval;
    }
  }]);

  return CheckoutService;
}();

function isTruthy(metadataValue) {
  return metadataValue === true || metadataValue === 'true';
}

module.service('Checkout', CheckoutService);
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var module = angular.module('confirm-dialog', []);
module.service('ConfirmDialog', function ($uibModal) {
  'ngInject';

  var modalDefaults = {
    backdrop: true,
    keyboard: true,
    modalFade: true,
    template: "\n      <div class=\"modal-header\">\n        <h3 class=\"modal-title\">{{modalOptions.headerText}}</h3>\n      </div>\n      <div class=\"modal-body\">\n        <p>{{modalOptions.bodyText}}</p>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-{{modalOptions.closeButtonClass}}\" data-ng-click=\"modalOptions.close()\">{{modalOptions.closeButtonText}}</button>\n        <button class=\"btn btn-{{modalOptions.actionButtonClass}}\" data-ng-click=\"modalOptions.ok();\">{{modalOptions.actionButtonText}}</button>\n      </div>\n    "
  };
  var modalOptions = {
    closeButtonText: 'Close',
    closeButtonClass: 'default',
    actionButtonText: 'OK',
    actionButtonClass: 'primary',
    headerText: 'Proceed?',
    bodyText: 'Perform this action?'
  };

  this.showModal = function (customModalOptions, customModalDefaults) {
    if (!customModalDefaults) customModalDefaults = {};
    customModalDefaults.backdrop = 'static';
    return this.show(customModalDefaults, customModalOptions);
  };

  this.show = function (customModalOptions, customModalDefaults) {
    //Create temp objects to work with since we're in a singleton service
    var tempModalDefaults = {};
    var tempModalOptions = {}; //Map angular-ui modal custom defaults to modal defaults defined in service

    angular.extend(tempModalDefaults, modalDefaults, customModalDefaults); //Map modal.html $scope custom properties to defaults defined in service

    angular.extend(tempModalOptions, modalOptions, customModalOptions);

    if (!tempModalDefaults.controller) {
      tempModalDefaults.controller = function ($scope, $uibModalInstance) {
        'ngInject';

        $scope.modalOptions = tempModalOptions;

        $scope.modalOptions.ok = function (result) {
          $uibModalInstance.close(result);
        };

        $scope.modalOptions.close = function (result) {
          $uibModalInstance.dismiss('cancel');
        };
      };
    }

    return $uibModal.open(tempModalDefaults).result;
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EditOrCreateEventService */
/* unused harmony export _EditOrCreateEventServiceImpl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_pricing__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_date__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_password__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_rtmp__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_timezone__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_scoreboard__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_video_and_audio_config__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_boxcast_flow_control__ = __webpack_require__(524);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }









var module = angular.module('edit-or-create-event-service', []); // Emulate factory pattern

var EditOrCreateEventService = /*#__PURE__*/function () {
  function EditOrCreateEventService($q, BoxCaster, Broadcast, Recording, Account, Channel, BroadcastTags, $rootScope, YouTubeUser, StaticRTMP, Facebook, TwitterUser, RTMPPushChannel, toaster, $window, $uibModal, $sce) {
    'ngInject';

    _classCallCheck(this, EditOrCreateEventService);

    this.$q = $q;
    this.Broadcast = Broadcast;
    this.Recording = Recording;
    this.BoxCaster = BoxCaster;
    this.Account = Account;
    this.Channel = Channel;
    this.BroadcastTags = BroadcastTags;
    this.$rootScope = $rootScope;
    this.YouTubeUser = YouTubeUser;
    this.StaticRTMP = StaticRTMP;
    this.Facebook = Facebook;
    this.TwitterUser = TwitterUser;
    this.RTMPPushChannel = RTMPPushChannel;
    this.toaster = toaster;
    this.$window = $window;
    this.$uibModal = $uibModal;
    this.$sce = $sce;
  }

  _createClass(EditOrCreateEventService, [{
    key: "getInstance",
    value: function getInstance() {
      return new _EditOrCreateEventServiceImpl(this.$q, this.BoxCaster, this.Broadcast, this.Recording, this.Account, this.Channel, this.BroadcastTags, this.$rootScope, this.YouTubeUser, this.StaticRTMP, this.Facebook, this.TwitterUser, this.RTMPPushChannel, this.toaster, this.$window, this.$uibModal, this.$sce);
    }
  }, {
    key: "activateBroadcast",
    value: function activateBroadcast(broadcast) {
      // XXX: activating a broadcast means resetting the start/end date.
      // If we're in pre-roll, keep the same end date, but if you're trying to activate
      // something much further out, keep the exact same duration.
      var stops_at = broadcast.stops_at;

      if (broadcast.timeframe == 'future') {
        var duration = moment(broadcast.stops_at) - moment(broadcast.starts_at);
        stops_at = moment().add(duration).toDate().toISOString();
      }

      return this.Broadcast.update({
        id: broadcast.id
      }, {
        stream_source: 'switcher',
        starts_at: 'now',
        stops_at: stops_at
      }).$promise;
    }
  }, {
    key: "stopBroadcast",
    value: function stopBroadcast(broadcast) {
      return this.Broadcast.update({
        id: broadcast.id
      }, {
        stops_at: 'now'
      }).$promise;
    }
  }]);

  return EditOrCreateEventService;
}();
var _EditOrCreateEventServiceImpl = /*#__PURE__*/function () {
  function _EditOrCreateEventServiceImpl($q, BoxCaster, Broadcast, Recording, Account, Channel, BroadcastTags, $rootScope, YouTubeUser, StaticRTMP, Facebook, TwitterUser, RTMPPushChannel, toaster, $window, $uibModal, $sce) {
    'ngInject';

    _classCallCheck(this, _EditOrCreateEventServiceImpl);

    this.$q = $q;
    this.Broadcast = Broadcast;
    this.Recording = Recording;
    this.ApiConfig = $rootScope.ApiConfig;
    this.account = $rootScope.account;
    this.user = $rootScope.user;
    this.FeatureFlags = this.account.feature_flags;
    this.BoxCaster = BoxCaster;
    this.Account = Account;
    this.Channel = Channel;
    this.BroadcastTags = BroadcastTags;
    this.YouTubeUser = YouTubeUser;
    this.StaticRTMP = StaticRTMP;
    this.fb = Facebook;
    this.TwitterUser = TwitterUser;
    this.RTMPPushChannel = RTMPPushChannel;
    this.toaster = toaster;
    this.$window = $window;
    this.$uibModal = $uibModal;
    this.limits = $rootScope.ApiConfig.modelFieldLimits('broadcast', 'maximum');
    this.genericRTMPPushLimits = $rootScope.ApiConfig.modelFieldLimits('generic_rtmp_push', 'maximum');
    this.canDelete = $rootScope.user.can('delete', 'broadcast/*');
    this.enhancedBoxCastFlowControlTooltip = $sce.trustAsHtml(__WEBPACK_IMPORTED_MODULE_7__utils_boxcast_flow_control__["a" /* EnhancedBoxCastFlowControlTooltipHTML */]);
    this.maximumBoxCastFlowControlTooltip = $sce.trustAsHtml(__WEBPACK_IMPORTED_MODULE_7__utils_boxcast_flow_control__["b" /* MaximumBoxCastFlowControlTooltipHTML */]);
    this.selectedBoxCaster = null;
    this.scrambleChannelId = true; //... but only if the scramble option is shown

    this.bulkImportMode = false;
    this.initConfig();
    this.initRelatedData();
  }

  _createClass(_EditOrCreateEventServiceImpl, [{
    key: "initScope",
    value: function initScope($scope) {
      var _this = this;

      var ApiConfig = this.ApiConfig,
          BoxCaster = this.BoxCaster;
      this.$scope = $scope;
      $scope.$watchCollection(function () {
        return [_this.startDate, _this.startTime, _this.endTime];
      }, function () {
        return _this.compensateEndDate();
      });
      $scope.$watch(function () {
        return _this.boxCasterIdSafe;
      }, function (id) {
        _this.selectedBoxCaster = _.findWhere(_this.boxcasters, {
          id: id
        });

        _this.initAdvancedSettingsBySource();

        if (id && !id.startsWith('stream_source:')) {
          _this.boxcaster = BoxCaster.get({
            id: id
          }, function () {
            return _this.initAdvancedSettingsBySource();
          });
        } else {
          _this.boxcaster = null;
        }
      });
      $scope.$watchCollection(function () {
        return [_this.startTime, _this.sourceBroadcast];
      }, function () {
        var durationSeconds = (_this.sourceBroadcast || {}).recording_duration_seconds;

        if (!durationSeconds) {
          _this.simulatedLiveEndTime = null;
          return;
        }

        _this.simulatedLiveEndTime = moment(_this.startTime).add(durationSeconds, 'seconds').toDate();
      });
      $scope.$watch(function () {
        return _this.boxCasterIdSafe;
      }, function (newValue, oldValue) {
        if (oldValue == 'stream_source:recording' && newValue != 'stream_source:recording') {
          // If switching from simulated live, initialize advanced settings to sane defaults
          _this.broadcast.do_not_record = _this.doNotRecordDefault;
          _this.broadcast.requests_captioning = _this.requestsCaptioningDefault;
        } else if (newValue == 'stream_source:recording' && oldValue != 'stream_source:recording') {
          // If switching to simulated live, initialize advanced settings.
          if (oldValue || !_this.broadcast.id) {
            // If switching TO simulated live either from some other non-empty value (like an
            // actual BoxCaster) OR this is a new broadcast, set live-only from accout default.
            // The $watch can and will fire when the broadcast loads as well, so we have to be extra
            // careful we don't touch this unless it was something before (i.e. this is not the
            // initial load) or it's a new broadcast (there's no ID yet), where it makes sense to
            // be toggling values at startup.
            _this.broadcast.do_not_record = !_this.account.default_record_simulated_live;
          }

          _this.broadcast.requests_captioning = false;
        } else if (oldValue == 'stream_source:app' && newValue != 'stream_source:app') {
          // Switching from Broadcaster app to something else
          if (_this.broadcast && _this.broadcast.target_buffer_latency == 'standard') {
            // If the user had selected standard latency, put it back to 'default'
            _this.broadcast.target_buffer_latency = 'default';
          }
        }
      });
    }
  }, {
    key: "initConfig",
    value: function initConfig() {
      var account = this.account,
          ApiConfig = this.ApiConfig,
          FeatureFlags = this.FeatureFlags; // Get account feature flags

      this.showAutomatedScoreboard = FeatureFlags.automated_scoreboard;
      this.showSportzcast = FeatureFlags.sportzcast;
      this.showManualScoreboard = FeatureFlags.manual_scoreboard;
      this.showAnyScoreboards = this.showAutomatedScoreboard || this.showSportzcast || this.showManualScoreboard;
      this.showFlex = FeatureFlags.flex;
      this.showPublic = !FeatureFlags.no_public;
      this.showTicketed = !FeatureFlags.no_ticketed;
      this.showFeatured = account.extra_features.featured_broadcasts;
      this.showSportzCast = FeatureFlags.sportzcast;
      this.allowBroadcasterApp = account.usage_flags.broadcaster_app && !FeatureFlags.broadcaster_app_source_disabled;
      this.allowRtmp = FeatureFlags.rtmp;
      this.allowSwitcher = account.usage_flags.switcher;
      this.allowFacebookLive = FeatureFlags.facebook_live;
      this.allowYoutubeLive = FeatureFlags.youtube_live;
      this.allowGenericRtmpPush = FeatureFlags.generic_rtmp_push;
      this.allowTwitter = FeatureFlags.twitter;
      this.allowSimulatedLive = FeatureFlags.simulated_live;
      this.allowDefaultOverlay = true;
      this.resolutionLimit = account.resolution_limit;
      this.allowHighFrameRate = FeatureFlags.high_frame_rate;
      this.maxBroadcastDurationHours = account.max_broadcast_duration_hrs;
      this.allowProducer = FeatureFlags.producer; // Grab shared config values

      this.sports = ApiConfig.stream.sports;
      this.scoreboards = ApiConfig.stream.scoreboards;
      this.dscpValues = ApiConfig.stream.dscp_values;
      this.minTicketPrice = ApiConfig.ticket.minimum_price;
      this.initAdvancedSettingsBySource();
    }
  }, {
    key: "initAdvancedSettingsBySource",
    value: function initAdvancedSettingsBySource() {
      var _this2 = this;

      var ApiConfig = this.ApiConfig;
      this.videoResolutions = _.filter(ApiConfig.stream.video_resolutions, function (b) {
        return b.value == 'default' || b.value <= _this2.resolutionLimit;
      });
      this.videoBitrates = __WEBPACK_IMPORTED_MODULE_6__utils_video_and_audio_config__["a" /* VideoAudioConfig */].stream.video_bitrates;
      this.audioBitrates = __WEBPACK_IMPORTED_MODULE_6__utils_video_and_audio_config__["a" /* VideoAudioConfig */].stream.audio_bitrates;
      this.audioSources = ApiConfig.stream.audio_sources;
      this.highFrameRates = ApiConfig.stream.high_frame_rates;
      this.bufferLatencies = ApiConfig.stream.buffer_latencies; // Restrict BoxCaster source capabilities based on capabilities (inferred by serial number prefix)

      if (this.isBoxCaster && this.boxCasterIdSafe) {
        var filter = function filter(b) {
          return _.contains(b.serial_prefixes, _this2.boxcasterPrefix);
        };

        this.videoResolutions = _.filter(this.videoResolutions, filter);
        this.videoBitrates = _.filter(this.videoBitrates, filter);
        this.audioBitrates = _.filter(this.audioBitrates, filter);
        this.audioSources = _.filter(this.audioSources, filter);
        this.highFrameRates = _.filter(this.highFrameRates, filter);
        this.bufferLatencies = _.filter(this.bufferLatencies, filter);

        if (this.isBoxCasterPro) {
          // BoxCaster Pro doesn't currently support audio-only.
          this.videoBitrates = _.filter(this.videoBitrates, function (b) {
            return b.value != AUDIO_ONLY_BITRATE_HINT;
          }); // If video bitrate was set to audio only, then switched to pro reset to default

          if (this.broadcast.target_video_bitrate == AUDIO_ONLY_BITRATE_HINT) {
            this.broadcast.target_video_bitrate = 'default';
          }
        }
      } // Prevent scoreboards and overlays for simulated live as well as producer broadcasts


      if (this.isSimulatedLive || this.isProducerBroadcast) {
        this.showAnyScoreboards = false;
        this.allowDefaultOverlay = false;
      } else {
        this.showAnyScoreboards = this.showAutomatedScoreboard || this.showSportzcast || this.showManualScoreboard;
        this.allowDefaultOverlay = true;
      } // Default RTMP sources to the account resolution and frame rate limit


      if (this.broadcast && this.broadcast.timeframe != 'past') {
        if (this.isRTMPBasedSource) {
          if (this.broadcast.target_video_resolution == 'default') {
            this.broadcast.target_video_resolution = this.resolutionLimit;
          }

          if (this.broadcast.target_high_frame_rate == 'default') {
            this.broadcast.target_high_frame_rate = this.allowHighFrameRate;
          }
        }
      } // Dynamic advanced settings labels


      var overridden = function overridden(field) {
        return _this2.boxcaster && _this2.boxcaster[field] && _this2.boxcaster[field] != 'default';
      };

      var sourceName = this.isBroadcasterApp ? 'Broadcaster App' : 'BoxCaster';

      var updateLabel = function updateLabel(field, settings) {
        var defaultVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Auto-detect';

        if (!settings || !settings.length) {
          return;
        } else if (_this2.isRTMPBasedSource) {
          settings[0].label = "Default";
        } else if (overridden(field)) {
          var label = (_.first(_.filter(settings, function (s) {
            return s.value == _this2.boxcaster[field];
          })) || {}).label;
          settings[0].label = "".concat(sourceName, " Default: ").concat(label);
        } else {
          settings[0].label = defaultVal;
        }
      };

      updateLabel('target_video_bitrate', this.videoBitrates);
      updateLabel('target_audio_bitrate', this.audioBitrates);
      updateLabel('audio_source', this.audioSources, 'All Sources');
      updateLabel('target_video_resolution', this.videoResolutions);
      updateLabel('target_high_frame_rate', this.highFrameRates);
      updateLabel('dscp_value', this.dscpValues, 'No DSCP');

      if (this.isBroadcasterApp) {
        // For Broadcaster, don't allow the "default" buffer latency (as there's no BoxCaster to "default" to)
        this.bufferLatencies = _.reject(this.bufferLatencies, function (v) {
          return v.value == 'default';
        });

        if (this.broadcast && this.broadcast.target_buffer_latency == 'default') {
          this.broadcast.target_buffer_latency = 'standard';
        }
      } else {
        updateLabel('target_buffer_latency', this.bufferLatencies, 'Standard');
      }
    }
  }, {
    key: "initRelatedData",
    value: function initRelatedData() {
      var _this3 = this;

      var BoxCaster = this.BoxCaster,
          Account = this.Account,
          Channel = this.Channel,
          BroadcastTags = this.BroadcastTags,
          FeatureFlags = this.FeatureFlags,
          YouTubeUser = this.YouTubeUser,
          StaticRTMP = this.StaticRTMP,
          TwitterUser = this.TwitterUser,
          RTMPPushChannel = this.RTMPPushChannel,
          $q = this.$q;
      this.boxcasters = BoxCaster.query({
        l: 1000,
        s: 'name'
      }, function () {
        _this3.selectedBoxCaster = _.findWhere(_this3.boxcasters, {
          id: _this3.boxCasterIdSafe
        });
      });
      this.channels = Channel.query({
        l: 1000
      });
      this.tags = BroadcastTags.query();
      this.accountScoreboard = Account.getScoreboard();

      if (this.showSportzcast) {
        this.sportzcast = Account.getSportzcast();
      } else {
        this.sportzcast = {};
      }

      var destinationPromsises = [];
      this.youtubeUsers = [];

      if (this.allowYoutubeLive) {
        destinationPromsises.push(YouTubeUser.query({
          l: 1000
        }).$promise.then(function (users) {
          _this3.youtubeUsers = users.filter(function (user) {
            return user.scope && _.contains(user.scope, YOUTUBE_SCOPE);
          });
        }));
      }

      this.staticRTMPs = [];

      if (this.allowRtmp) {
        this.staticRTMPs = StaticRTMP.query({
          l: 1000,
          include_diagnostics: true
        });
        destinationPromsises.push(this.staticRTMPs.$promise);
      }

      this.twitterUsers = [];

      if (this.allowTwitter) {
        this.twitterUsers = TwitterUser.query({
          l: 1000
        });
        destinationPromsises.push(this.twitterUsers.$promise);
      }

      this.rtmpPushChannels = [];

      if (this.allowGenericRtmpPush) {
        this.rtmpPushChannels = RTMPPushChannel.query({
          l: 1000
        });
        destinationPromsises.push(this.rtmpPushChannels.$promise);
      }

      this.destinationPromise = $q.all(destinationPromsises);
      this.sourcesPromise = $q.all([this.boxcasters.$promise, this.staticRTMPs.$promise]).then(function () {
        _this3.sources = [];
        _this3.sources = _this3.sources.concat(_this3.boxcasters.map(function (b) {
          return angular.extend({
            type: "boxcaster".concat(b.id.startsWith('p') ? '_pro' : '')
          }, b);
        }));

        if (_this3.allowSwitcher) {
          _this3.sources = _this3.sources.concat({
            type: 'switcher',
            id: 'stream_source:switcher',
            name: 'Switcher Studio (iOS)'
          });
        }

        if (_this3.allowBroadcasterApp) {
          _this3.sources = _this3.sources.concat({
            type: 'broadcaster',
            id: 'stream_source:app',
            name: 'Broadcaster App'
          });
        }

        if (_this3.allowProducer) {
          _this3.sources = _this3.sources.concat({
            type: 'producer',
            id: 'stream_source:producer',
            name: 'Producer (Browser-based streaming)'
          });
        }

        if (_this3.allowRtmp) {
          _this3.sources = _this3.sources.concat(_this3.staticRTMPs.map(function (r) {
            return angular.extend({
              type: 'static_rtmp'
            }, r, {
              id: "stream_source:rtmp:".concat(r.id)
            });
          }));
        }

        var sourceIsEditable = (_this3.broadcast.timeframe || 'future') == 'future';

        if (_this3.allowSimulatedLive || !sourceIsEditable && !_this3.broadcast.source_broadcast_id) {
          _this3.sources = _this3.sources.concat({
            type: 'recording',
            id: 'stream_source:recording',
            name: 'Re-Broadcast (Simulated Live)'
          });
        }
      });
    }
  }, {
    key: "initBroadcast",
    value: function initBroadcast(id, clone) {
      var _this4 = this;

      var ApiConfig = this.ApiConfig,
          Broadcast = this.Broadcast,
          FeatureFlags = this.FeatureFlags,
          $q = this.$q;

      if (id) {
        // Edit broadcast mode...
        this.broadcast = Broadcast.get({
          id: id,
          include_recurrence: true
        }, function () {
          _this4.minDate = new Date();

          if (clone) {
            _this4.broadcast.id = null;

            var _getDatesForClonedBro = Object(__WEBPACK_IMPORTED_MODULE_1__utils_date__["d" /* getDatesForClonedBroadcast */])(_this4.broadcast, moment()),
                starts_at = _getDatesForClonedBro.starts_at,
                stops_at = _getDatesForClonedBro.stops_at;

            _this4.broadcast.starts_at = starts_at;
            _this4.broadcast.stops_at = stops_at;
            delete _this4.broadcast.id;
            delete _this4.broadcast.timeframe;
            delete _this4.broadcast.channel_id;
            delete _this4.broadcast.recurrence; // we don't support the new "make private after stopped" in the angular form.

            if (_this4.broadcast.metadata && 'private_after_stopped' in _this4.broadcast.metadata) {
              delete _this4.broadcast.metadata.private_after_stopped;
            }
          }

          if (_this4.broadcast.recurrence && _this4.broadcast.recurrence.id) {
            // Un-replace date tokens for the purpose of editing (only for broadcasts that are part of a recurrence)
            _this4.broadcast.name = Object(__WEBPACK_IMPORTED_MODULE_1__utils_date__["g" /* unreplaceDateTokens */])(_this4.broadcast.name || '', _this4.broadcast.starts_at);
            _this4.broadcast.description = Object(__WEBPACK_IMPORTED_MODULE_1__utils_date__["g" /* unreplaceDateTokens */])(_this4.broadcast.description || '', _this4.broadcast.starts_at); // Make sure time zone attribute is set for any date changes

            _this4.broadcast.recurrence.time_zone = Object(__WEBPACK_IMPORTED_MODULE_4__utils_timezone__["a" /* FindTimeZone */])();
          }

          _this4.startDate = moment(_this4.broadcast.starts_at).toDate();
          _this4.startTime = moment(_this4.broadcast.starts_at).toDate(); // XXX: compensate for old indefinite broadcasts ... we don't suppport that anymore

          if (!_this4.broadcast.stops_at || _this4.broadcast.stops_at.startsWith('9999-12-31')) {
            _this4.endTime = moment(_this4.startTime).add(_this4.maxBroadcastDurationHours, 'hours').subtract(1, 'minute');
          } else {
            _this4.endTime = moment(_this4.broadcast.stops_at).toDate(); // XXX: API stops_at is a derived field; it only really stores starts_at and duration in minutes
            // so we need to work around an off-by-one error when there are non-zero seconds in the starts_at

            if (moment(_this4.endTime).seconds() > 0) {
              _this4.endTime = moment(_this4.endTime).add(1, 'minute').toDate();
            } // XXX: Broadcaster for iOS uses 24:00:00 hours for duration rather than 23:59:59, which
            // causes some issues with other assumptions throughout the app. Correct for that minute here.


            if (moment(_this4.startTime).add(1, 'days').format('YYYY-MM-DD HH:mm') == moment(_this4.endTime).format('YYYY-MM-DD HH:mm')) {
              _this4.endTime = moment(_this4.endTime).subtract(1, 'minute').toDate();
            }
          }

          if (_this4.broadcast.stream_source == 'imported') {
            _this4.datepickerOptions = {
              maxDate: _this4.minDate,
              showWeeks: false
            };
          } else {
            _this4.datepickerOptions = {
              minDate: _this4.minDate,
              showWeeks: false
            };
          }

          _this4.visibility = Object(__WEBPACK_IMPORTED_MODULE_0__utils_pricing__["a" /* inferVisiblityOptionFromPriceSettings */])(_this4.broadcast);
          _this4.origVisibility = _this4.visibility;
          _this4.isFeatured = _.contains(_this4.broadcast.tags, 'featured');

          if (!_this4.broadcast.ticket_price) {
            _this4.broadcast.ticket_price = _this4.account.ticket_price || ApiConfig.ticket.default_price;
          }

          if (_this4.broadcast.stream_source && _this4.broadcast.stream_source != 'boxcaster') {
            if (_this4.broadcast.stream_source == 'rtmp' && _this4.broadcast.static_rtmp_id) {
              _this4.broadcast.boxcaster_id = "stream_source:rtmp:".concat(_this4.broadcast.static_rtmp_id);
            } else {
              // If this is static RTMP, add that to the sources list.
              if (_this4.broadcast.stream_source === 'rtmp') {
                // XXX: Ideally, this would be in the middle of the list next to the other RTMP stream sources, but
                // that logic is really complicated. Since this is meant to be "edit only" (and no one should be
                // configuring new broadcasts with single-use RTMP), we're just going to stick it at the end.
                _this4.sourcesPromise.then(function () {
                  _this4.sources = _this4.sources.concat({
                    type: 'rtmp',
                    id: 'stream_source:rtmp',
                    name: 'Single-Use RTMP'
                  });
                });
              }

              _this4.broadcast.boxcaster_id = "stream_source:".concat(_this4.broadcast.stream_source);
            }
          } // If the previously-selected video bitrate option is "Audio Only", then the user
          // cannot change the bitrate, so we'll use this to disable the select control.


          _this4.disableVideoBitrate = _this4.broadcast.timeframe == 'past' || _this4.broadcast.timeframe == 'current' && _this4.isAudioOnly;
          _this4.disableAudioOnlyOption = _this4.broadcast.timeframe == 'current' && !_this4.isAudioOnly; // Once user selects an actual video bitrate, they can't go back to "default",
          // which really means "auto-detect" (too late)

          _this4.disableDefaultVideoBitrateOption = _this4.broadcast.timeframe == 'current' && _this4.broadcast.target_video_bitrate != 'default'; // integer to string values for max_resolution

          _this4.broadcast.simulcast_configurations.filter(function (s) {
            return s.destination === 'generic';
          }).forEach(function (s) {
            return s.max_resolution = s.max_resolution.toString();
          }); // Glue `max_resolution` onto each rtmp_push_channel in case the user edits them


          _this4.broadcast.simulcast_configurations.filter(function (s) {
            return s.destination === 'rtmp_push_channel';
          }).forEach(function (s) {
            if (!s.max_resolution) {
              s.max_resolution = '0';
            }
          }); // Separate out feed type and ID for facebook


          _this4.broadcast.simulcast_configurations.filter(function (s) {
            return s.destination === 'facebook';
          }).forEach(function (s) {
            if (s.fb_feed_id === 'user:me') {
              s.feed_type = 'user:me';
            } else {
              s.feed_type = s.fb_feed_id.split(':', 1)[0];
              s.feed_id = s.fb_feed_id.replace(/^[^:]*:/, '');
            }
          });

          _this4.otherEvents = [];
          _this4.eventsFromThisSource = [];
          _this4.conflictingEvents = [];
          _this4.worstCaseSimultaneousStreams = 0;

          _this4.getConflictingEvents(true);

          _this4.broadcast.content_settings = _this4.broadcast.content_settings || {};
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_scoreboard__["e" /* restoreScoreboardUIConfiguration */])(_this4.broadcast.scoreboard_configuration);

          if (_this4.broadcast.source_broadcast_id) {
            _this4.fromBroadcast(_this4.broadcast.source_broadcast_id, clone);
          }
        }, function (error) {});
        this.broadcast.$promise.then(function () {
          return _this4.updateScoreboardMakes();
        });
      } else {
        var _this$broadcast;

        // Create new broadcast mode (no ID specified)...
        this.broadcast = (_this$broadcast = {
          name: null,
          description: null,
          boxcaster_id: null,
          stream_source: 'boxcaster',
          do_not_record: this.doNotRecordDefault,
          sport: null,
          target_high_frame_rate: 'default',
          target_video_bitrate: 'default',
          target_audio_bitrate: 'default',
          transcoder_profile: 'default',
          dscp_value: 'default',
          audio_source: 'default',
          target_video_resolution: 'default',
          target_codec: 'default',
          ticket_price: null,
          free_variant: null,
          in_channel_ids: [],
          simulcast_configurations: [],
          content_settings: {}
        }, _defineProperty(_this$broadcast, "ticket_price", this.account.ticket_price || ApiConfig.ticket.default_price), _defineProperty(_this$broadcast, "scoreboard_configuration", {
          overlay_location: 'bottom'
        }), _defineProperty(_this$broadcast, "metadata", {}), _defineProperty(_this$broadcast, "requests_captioning", this.requestsCaptioningDefault), _defineProperty(_this$broadcast, "target_buffer_latency", 'default'), _this$broadcast);
        this.isFeatured = false;
        this.accountScoreboard.$promise.then(function () {
          _this4.broadcast.scoreboard_configuration.home_team_name = _this4.accountScoreboard.home_team_name;
          _this4.broadcast.scoreboard_configuration.home_team_logo = _this4.accountScoreboard.home_team_logo;
        });
        var now = moment().set({
          second: 0,
          millisecond: 0
        });
        this.startDate = now.clone().toDate();
        this.startTime = now.clone().toDate();
        this.originalStartTime = new Date(this.startTime.getTime());
        this.minDate = now.clone().toDate();
        this.endTime = now.clone().add(30, 'minutes').toDate();
        this.originalEndTime = new Date(this.endTime.getTime());
        this.visibility = this.showPublic ? 'public' : 'private';
        this.datepickerOptions = {
          minDate: this.minDate,
          showWeeks: false
        };
        this.otherEvents = [];
        this.eventsFromThisSource = [];
        this.conflictingEvents = [];
        this.worstCaseSimultaneousStreams = 0;
        this.getConflictingEvents(true);
      }
    }
  }, {
    key: "fromBroadcast",
    value: function fromBroadcast(broadcastId) {
      var _this5 = this;

      var clone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var account = this.account,
          broadcast = this.broadcast,
          Broadcast = this.Broadcast;
      broadcast.stream_source = 'recording';
      Broadcast.get({
        id: broadcastId
      }, function (b) {
        return _this5.updateSourceBroadcast(b);
      }, function (err) {
        if (err && (err.status == 404 || err.status == 410)) {
          // 404/410 means this source isn't available anymore
          if (clone) {
            // Cloning, so just clear out the source info and let them pick something else
            _this5.sourceBroadcast = null;
            broadcast.source_broadcast_id = null;
            _this5.datepickerOptions.minDate = _this5.minDate;
          } else {
            // Not cloning -- let them know the source broadcast is not available anymore.
            _this5.sourceBroadcastUnavailable = true;
            _this5.sourceBroadcastProblem = 'is unavailable';
          }
        } else {
          console.error('Failed to get source broadcast', err);
        }
      });
    }
  }, {
    key: "updateSourceBroadcast",
    value: function updateSourceBroadcast(b) {
      var account = this.account,
          broadcast = this.broadcast;
      this.sourceBroadcast = b;
      broadcast.source_broadcast_id = b.id;
      this.datepickerOptions.minDate = new Date(Math.max(this.minDate.getTime(), moment(this.sourceBroadcast.stops_at).toDate().getTime()));

      if (account.storage_policy == 'auto-delete') {
        this.datepickerOptions.maxDate = moment(this.sourceBroadcast.storage_expires_at).toDate();
      }

      if (b.timeframe == 'past' && b.recording_duration_seconds <= 0) {
        this.sourceBroadcastProblem = 'does not exist';
      } else if (this.recordingStorageExpires) {
        this.sourceBroadcastProblem = "will be purged before the broadcast's start time";
      }
    }
  }, {
    key: "showChannelSelector",
    get: function get() {
      // If account doesn't have channels defined, never show it.
      // If it's a private event, only show selector if they've got channels selected
      if (!this.channels || this.channels.length == 0) {
        return false;
      }

      var selectedChannels = this.broadcast.in_channel_ids || [];
      var hasChannelsSelected = selectedChannels.length > 0;
      return this.visibility != 'private' || hasChannelsSelected;
    }
  }, {
    key: "showScoreboardModel",
    get: function get() {
      return this.scoreboardModels && this.scoreboardModels.length > 1;
    }
  }, {
    key: "boxcasterPrefix",
    get: function get() {
      return this.boxCasterIdSafe[0];
    }
  }, {
    key: "boxCasterIdSafe",
    get: function get() {
      return (this.broadcast || {}).boxcaster_id || '';
    }
  }, {
    key: "hideOptionRecord",
    get: function get() {
      return this.FeatureFlags.no_recordings;
    }
  }, {
    key: "isAudioOnly",
    get: function get() {
      return !!((this.broadcast || {}).target_video_bitrate <= AUDIO_ONLY_BITRATE_HINT);
    }
  }, {
    key: "isBoxCaster",
    get: function get() {
      return !this.boxCasterIdSafe.startsWith('stream_source:');
    }
  }, {
    key: "isBoxCasterHDSD2",
    get: function get() {
      return (this.boxcasterPrefix || '').startsWith('o');
    }
  }, {
    key: "isBoxCasterPro",
    get: function get() {
      return (this.boxcasterPrefix || '').startsWith('p');
    }
  }, {
    key: "isBroadcasterApp",
    get: function get() {
      return this.boxCasterIdSafe.startsWith('stream_source:app');
    }
  }, {
    key: "isRTMPSelected",
    get: function get() {
      return this.boxCasterIdSafe.startsWith('stream_source:rtmp');
    }
  }, {
    key: "isSimulatedLive",
    get: function get() {
      return this.boxCasterIdSafe == 'stream_source:recording';
    }
  }, {
    key: "isSwitcher",
    get: function get() {
      return this.boxCasterIdSafe.startsWith('stream_source:switcher');
    }
  }, {
    key: "isProducerBroadcast",
    get: function get() {
      return this.boxCasterIdSafe.startsWith('stream_source:producer');
    }
  }, {
    key: "isRTMPBasedSource",
    get: function get() {
      return this.isRTMPSelected || this.isSwitcher;
    }
  }, {
    key: "hideOptionTargetAudioBitRate",
    get: function get() {
      return this.isRTMPBasedSource || this.isSimulatedLive || this.isProducerBroadcast;
    }
  }, {
    key: "hideHighFrameRate",
    get: function get() {
      return !this.allowHighFrameRate || this.isSwitcher || this.isSimulatedLive || this.isProducerBroadcast || !(this.isRTMPSelected || this.isBroadcasterApp || this.isBoxCasterPro);
    }
  }, {
    key: "hideOptionTargetVideoBitRate",
    get: function get() {
      return this.isRTMPBasedSource || this.isSimulatedLive || this.isProducerBroadcast;
    }
  }, {
    key: "hideOptionAudioSource",
    get: function get() {
      return this.isBroadcasterApp || this.isRTMPBasedSource || this.isSimulatedLive || this.isProducerBroadcast;
    }
  }, {
    key: "hideOptionVideoResolution",
    get: function get() {
      return this.isSimulatedLive || this.isProducerBroadcast;
    }
  }, {
    key: "hideOptionDSCPValue",
    get: function get() {
      return this.isBroadcasterApp || this.isRTMPBasedSource || this.isSimulatedLive || this.isProducerBroadcast;
    }
  }, {
    key: "showOptionTargetBufferLatency",
    get: function get() {
      // If they don't have the BoxCast Flow Control feature, don't show it
      if (this.account.feature_flags.boxcast_flow_control_disabled) {
        return false;
      } // Only show for BoxCaster HDSD2, Pro,  or Broadcaster app


      return this.isBoxCasterHDSD2 || this.isBoxCasterPro || this.isBroadcasterApp;
    }
  }, {
    key: "requestsCaptioningDefault",
    get: function get() {
      return (this.FeatureFlags.automated_captioning || this.FeatureFlags.live_automated_captioning) && this.account.content_settings.requestsCaptioning;
    }
  }, {
    key: "doNotRecordDefault",
    get: function get() {
      return !!this.FeatureFlags.no_recordings;
    }
  }, {
    key: "targetBufferLatencyTooltip",
    get: function get() {
      if (this.isBoxCasterPro || this.isBroadcasterApp) {
        return this.maximumBoxCastFlowControlTooltip;
      }

      return this.enhancedBoxCastFlowControlTooltip;
    }
  }, {
    key: "chooseDefaultSourceForNewBroadcast",
    value: function chooseDefaultSourceForNewBroadcast() {
      // Force a selection if user has multiple BoxCasters registered
      if (this.boxcasters.length > 1) {
        return;
      } // Choose one and only BoxCaster


      if (this.boxcasters.length == 1) {
        this.selectedBoxCaster = this.boxcasters[0];
        this.broadcast.boxcaster_id = this.selectedBoxCaster.id;
        return;
      } // Force a selection if user has multiple static RTMP channels defined


      if (this.staticRTMPs.length > 1) {
        return;
      } // Choose one and only static RTMP channel


      if (this.staticRTMPs.length == 1) {
        this.broadcast.boxcaster_id = "stream_source:rtmp:".concat(this.staticRTMPs[0].id);
        return;
      } // Otherwise, prefer Broadcaster > Switcher Studio


      if (this.allowBroadcasterApp) {
        this.broadcast.boxcaster_id = 'stream_source:app';
      } else if (this.allowSwitcher) {
        this.broadcast.boxcaster_id = 'stream_source:switcher';
      } else if (this.allowSimulatedLive) {
        this.broadcast.boxcaster_id = 'stream_source:recording';
      }
    }
  }, {
    key: "initializeEmptyFacebookAccountIDs",
    value: function initializeEmptyFacebookAccountIDs() {
      var _this6 = this;

      (this.broadcast.simulcast_configurations || []).forEach(function (sc) {
        if (sc.destination === 'facebook' && !sc.facebook_account_id) {
          sc.facebook_account_id = _this6.fb.facebook_account_id;
        }
      });
    }
  }, {
    key: "addSimulcastDestination",
    value: function addSimulcastDestination(destination, params) {
      this.broadcast.simulcast_configurations = this.broadcast.simulcast_configurations || [];
      params = params || {};
      var destConfig = {
        destination: destination,
        isHelpRow: params.isHelpRow
      };

      switch (destination) {
        case 'facebook':
          var id = params.id || this.fb.facebook_account_id;

          if (!id) {
            // only allow 1 "unlinked" account to show up in the UI
            var unlinkedFBConfigs = _.filter(this.broadcast.simulcast_configurations, function (sc) {
              return sc.destination == 'facebook' && !sc.facebook_account_id;
            });

            if (unlinkedFBConfigs.length > 0) {
              return;
            }
          }

          destConfig.facebook_account_id = id;
          destConfig.feed_type = 'user:me';
          destConfig.fb_privacy = 'EVERYONE';
          break;

        case 'youtube':
          destConfig.youtube_account_id = params.id || (this.youtubeUsers[0] || {}).id;
          destConfig.privacy = 'unlisted';
          break;

        case 'generic':
          destConfig.stream_url = '';
          destConfig.stream_key = '';
          destConfig.max_resolution = '0';
          break;

        case 'twitter':
          destConfig.twitter_account_id = params.id || (this.twitterUsers[0] || {}).id;
          destConfig.should_not_tweet = false;
          break;

        case 'rtmp_push_channel':
          destConfig.rtmp_push_channel_id = params.id || (this.rtmpPushChannels[0] || {}).id;
          destConfig.max_resolution = '0';
          break;

        default:
          return;
      }

      this.broadcast.simulcast_configurations.push(destConfig);
    }
  }, {
    key: "removeSimulcastDestination",
    value: function removeSimulcastDestination(obj) {
      _.remove(this.broadcast.simulcast_configurations, obj);
    }
  }, {
    key: "facebookFeedTypeChanged",
    value: function facebookFeedTypeChanged(config) {
      // For pages, events, and groups, only public visibility is permitted.
      switch (config.feed_type) {
        case 'page':
          config.feed_id = (this.fb.accounts[0] || {}).id || '';
          config.fb_privacy = 'EVERYONE';
          break;

        case 'group':
          config.feed_id = (this.fb.groups[0] || {}).id || '';
          config.fb_privacy = 'EVERYONE';
          break;

        case 'event':
          config.feed_id = (this.fb.events[0] || {}).id || '';
          config.fb_privacy = 'EVERYONE';
          break;
      }
    }
  }, {
    key: "addNewMultiUseChannel",
    value: function addNewMultiUseChannel(config) {
      var _$uibModal$open,
          _this7 = this;

      var $uibModal = this.$uibModal,
          RTMPPushChannel = this.RTMPPushChannel;
      $uibModal.open((_$uibModal$open = {
        controllerAs: 'vm',
        template: __webpack_require__(33),
        controller: __webpack_require__(34)["default"]
      }, _defineProperty(_$uibModal$open, "controllerAs", 'vm'), _defineProperty(_$uibModal$open, "resolve", {
        mode: function mode() {
          return 'add';
        },
        config: function config() {
          return {
            max_resolution: 0
          };
        }
      }), _$uibModal$open)).result.then(function (r) {
        _this7.rtmpPushChannels = RTMPPushChannel.query(function () {
          config.rtmp_push_channel_id = r.id;
        });
      });
    }
  }, {
    key: "uploadPreviewImage",
    value: function uploadPreviewImage(file) {
      var _this8 = this;

      file.upload().then(function (result) {
        _this8.broadcast.content_settings = _this8.broadcast.content_settings || {};
        _this8.broadcast.content_settings.preview = result.view_url;
        _this8.broadcast.content_settings.poster = result.view_url;
      });
    }
  }, {
    key: "uploadPodcastPreviewImage",
    value: function uploadPodcastPreviewImage(file) {
      var _this9 = this;

      file.upload().then(function (result) {
        _this9.broadcast.content_settings = _this9.broadcast.content_settings || {};
        _this9.broadcast.content_settings.podcast_preview = result.view_url;
      });
    }
  }, {
    key: "updateScoreboardMakes",
    value: function updateScoreboardMakes() {
      var _this10 = this;

      var FeatureFlags = this.FeatureFlags; // Grab the list of valid makes for the selected sport

      this.scoreboardMakes = [];

      if (this.isBoxCaster) {
        _.each(this.scoreboards, function (s) {
          if (s.require_tag && !FeatureFlags[s.require_tag]) {
            return;
          }

          if (!_this10.bulkImportMode) {
            if (s.value == 'BoxCast' || s.value == 'Sportzcast' || s.value == 'Manual') {
              // skip scoreboard makes that are handled separately in the UI
              return;
            }
          }

          _.each(s.models, function (m) {
            if (!_this10.broadcast.scoreboard_configuration.sport || m.sports.indexOf(_this10.broadcast.scoreboard_configuration.sport) >= 0) {
              _this10.scoreboardMakes.push(s);

              return false;
            }
          });
        });
      } else if (this.bulkImportMode) {
        // Only manual and Sportzcast allowed without a BoxCaster
        if (FeatureFlags.manual_scoreboard) {
          this.scoreboardMakes.push(_.find(this.scoreboards, {
            value: 'Manual'
          }));
        }

        if (FeatureFlags.sportzcast) {
          this.scoreboardMakes.push(_.find(this.scoreboards, {
            value: 'Sportzcast'
          }));
        }
      } else {// Only manual and Sportzcast allowed without a BoxCaster, and these are
        // handled directly in the UI
      } // See if the make the user has selected is valid per this sport, otherwise reset it


      if (!this.scoreboardMakes || !_.find(this.scoreboardMakes, {
        value: this.broadcast.scoreboard_configuration.scoreboard_make
      })) {
        this.broadcast.scoreboard_configuration.scoreboard_make = null;
      }

      this.updateScoreboardModels();
    }
  }, {
    key: "updateScoreboardModels",
    value: function updateScoreboardModels() {
      var _this11 = this;

      // Grab the list of valid models for the selected make
      var selectedMake = _.find(this.scoreboards, {
        value: this.broadcast.scoreboard_configuration.scoreboard_make
      });

      var allModels = _.result(selectedMake, 'models');

      this.scoreboardModels = [];

      _.each(allModels, function (m) {
        if (!_this11.broadcast.scoreboard_configuration.sport || m.sports.indexOf(_this11.broadcast.scoreboard_configuration.sport) >= 0) {
          _this11.scoreboardModels.push(m);
        }
      }); //console.log('New scoreboard models', this.scoreboardModels);
      // See if the model the user has selected is valid per this make, otherwise reset it


      if (!this.scoreboardModels || !_.find(this.scoreboardModels, {
        value: this.broadcast.scoreboard_configuration.scoreboard_model
      })) {
        this.broadcast.scoreboard_configuration.scoreboard_model = null;
      } // If the selected make only has 1 model, go ahead and pre-select it


      if (this.scoreboardModels && this.scoreboardModels.length == 1) {
        this.broadcast.scoreboard_configuration.scoreboard_model = this.scoreboardModels[0].value;
      }
    }
  }, {
    key: "getConflictingEvents",
    value: function getConflictingEvents() {
      var _this12 = this;

      var refreshDayEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var getEventsOnSelectedDayFn = function getEventsOnSelectedDayFn() {
        // NOTE: the dates used in the query need to be converted to UTC directly (not just with ISO 8601 offset specified)
        var dateStart = moment(_this12.startDate).startOf('day').utc().format();
        var dateEnd = moment(_this12.startDate).startOf('day').add(1, 'days').utc().format();
        var query = "+starts_at:[".concat(dateStart, " TO ").concat(dateEnd, "]");
        return _this12.Broadcast.query({
          q: query,
          l: 1000
        }, function (events) {
          // Get rid of this event
          _this12.otherEvents = _.reject(events, {
            id: _this12.broadcast.id
          });
        }).$promise;
      };

      var getConflictingEventsFn = function getConflictingEventsFn() {
        // First, find other events on the same source
        _this12.eventsFromThisSource = [];

        if (_this12.broadcast.boxcaster_id && _this12.broadcast.boxcaster_id.startsWith('stream_source:rtmp')) {
          // RTMP
          if (_this12.broadcast.boxcaster_id.startsWith('stream_source:rtmp:')) {
            // static RTMP
            var staticRtmpId = _this12.broadcast.boxcaster_id.replace('stream_source:rtmp:', '');

            _this12.eventsFromThisSource = _.filter(_this12.otherEvents, function (b) {
              return b.stream_source === 'rtmp' && b.static_rtmp_id === staticRtmpId;
            });
          } else {
            // single-use RTMP
            _this12.eventsFromThisSource = _.filter(_this12.otherEvents, function (b) {
              return b.stream_source === 'rtmp' && b.static_rtmp_id === '';
            });
          }
        } else if (_this12.broadcast.boxcaster_id && _this12.broadcast.boxcaster_id.startsWith('stream_source:app')) {
          // Broadcaster
          _this12.eventsFromThisSource = _.filter(_this12.otherEvents, function (b) {
            return b.stream_source === 'app';
          });
        } else if (_this12.broadcast.boxcaster_id && !_this12.broadcast.boxcaster_id.startsWith('stream_source:')) {
          // BoxCaster
          _this12.eventsFromThisSource = _.filter(_this12.otherEvents, function (b) {
            return b.stream_source === 'boxcaster' && b.boxcaster_id === _this12.broadcast.boxcaster_id;
          });
        } else if (_this12.broadcast.boxcaster_id == 'stream_source:recording') {
          // Simulated Live (ignoring for now)
          // TODO: FIXME: attempt a better overlap check, but may require a little
          // more work to understand durations
          _this12.worstCaseSimultaneousStreams = 0;
          return;
        } // Next, find any that overlap


        var dates = Object(__WEBPACK_IMPORTED_MODULE_1__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(_this12.startDate, _this12.startTime, _this12.endTime);
        var startsAt = Date.parse(dates.starts_at);
        var stopsAt = Date.parse(dates.stops_at);
        _this12.conflictingEvents = _.filter(_this12.eventsFromThisSource, function (b) {
          var thisStartsAt = Date.parse(b.starts_at);
          var thisStopsAt = Date.parse(b.stops_at);
          return !(stopsAt <= thisStartsAt || thisStopsAt <= startsAt);
        }); // Next, see how many other events are running at this time NOT from this source (to see how
        // many simultaneous) broadcasts might be going at once

        var eventsNotFromThisSource = _.reject(_this12.otherEvents, function (b) {
          return _.some(_this12.eventsFromThisSource, function (e) {
            return e.id === b.id;
          });
        });

        var conflictingEventsNotFromThisSource = _.filter(eventsNotFromThisSource, function (b) {
          if (b.stream_source == 'recording') {
            // TODO: FIXME: Ignoring Simulated Live for now
            return false;
          }

          var thisStartsAt = Date.parse(b.starts_at);
          var thisStopsAt = Date.parse(b.stops_at);
          return !(stopsAt <= thisStartsAt || thisStopsAt <= startsAt);
        }); // Finally, see how many unique "sources" there are for these conflicting events from other
        // sources. While the static RTMP and BoxCaster sources can only stream one broadcast at a
        // time, single-use RTMP and broadcaster broadcasts can (in theory) be used simultaneously.
        // Therefore, the length of this source list is the worst-case number of simultaneous
        // broadcasts at the proposed time. It could actually be less than this. But we use this
        // number to indicate to the user that they may hit their stream limit.


        var otherConflictingEventsSources = _.uniq(_.map(conflictingEventsNotFromThisSource, function (b) {
          if (b.stream_source === 'rtmp') {
            if (b.static_rtmp_id === '') {
              return "single-use-rtmp-".concat(b.id);
            } else {
              return b.static_rtmp_id;
            }
          } else if (b.stream_source === 'app') {
            return "broadcaster-".concat(b.id);
          } else {
            return b.boxcaster_id;
          }
        }));

        _this12.worstCaseSimultaneousStreams = otherConflictingEventsSources.length;
      };

      if (refreshDayEvents) {
        getEventsOnSelectedDayFn().then(getConflictingEventsFn);
      } else {
        getConflictingEventsFn();
      }
    }
  }, {
    key: "compensateEndDate",
    value: function compensateEndDate() {
      // Make sure end date is same day-of-month as start date
      // NOTE: Need to be careful to make minimum set of mutations in here since these objects
      // are in an angular watcher and will choke the digest cycle if changed willy nilly.
      var start = moment(this.startTime);
      var end = this.endTime ? moment(this.endTime) : null;

      if (!end) {// Open-ended event
      } else if (this.originalStartTime && this.originalEndTime && this.originalStartTime.getTime() != this.startTime.getTime() && this.originalEndTime.getTime() == this.endTime.getTime()) {
        // User changed start time but not end ... keep end locked 30 mins after start
        this.endTime = start.clone().add(30, 'minutes').toDate();
        this.originalEndTime = new Date(this.endTime.getTime());
        this.originalStartTime = new Date(this.startTime.getTime()); //avoid infinite digest
        //console.log('keeping end time locked 30 mins after start');
      } else if (end.format('HH:mm') < start.format('HH:mm')) {
        // Compensate for rolling across midnight (keep hours/minutes but bump to day after start)
        if (end.subtract(1, 'days').format('YYYY-MM-DD') != start.format('YYYY-MM-DD')) {
          this.endTime = end.set({
            year: start.get('year'),
            month: start.get('month'),
            date: start.get('date')
          }).add(1, 'days').toDate(); //console.log('adding a day to end datetime (rolled across midnight)');
        } else {//console.log('already compensated?');
        }
      } else if (end.format('YYYY-MM-DD') != start.format('YYYY-MM-DD')) {
        this.endTime = end.set({
          year: start.get('year'),
          month: start.get('month'),
          date: start.get('date')
        }).toDate(); //console.log('resetting end date');
      } else {//console.log('nothing to see here');
      }
    }
  }, {
    key: "explodeStreamSourceSettings",
    value: function explodeStreamSourceSettings(broadcast) {
      if (this.isBoxCaster) {
        broadcast.stream_source = 'boxcaster';
      } else {
        broadcast.stream_source = broadcast.boxcaster_id.replace('stream_source:', '');
        broadcast.boxcaster_id = null;
      } // Deal with static RTMP channel


      if (broadcast.stream_source.startsWith('rtmp:')) {
        broadcast.static_rtmp_id = broadcast.stream_source.replace('rtmp:', '');
        broadcast.stream_source = 'rtmp';
      }
    }
  }, {
    key: "validateAll",
    value: function validateAll() {
      this.errors = [];
      var result = true;
      result = this.validateOverview() && result;
      result = this.validateSchedule() && result;
      result = this.validateScoreboard() && result;
      result = this.validatePublish() && result;
      result = this.validateAdvanced() && result;

      if (result && this.$scope.form.$invalid) {
        console.dir(this.$scope.form);
        var e = this.$scope.form.$error || {};

        if (e.required) {
          this.errors.push('Please fill out all required fields');
        } else {
          this.errors.push('Please check all fields for proper values');
        }

        result = false;
      }

      return result;
    }
  }, {
    key: "validateOverview",
    value: function validateOverview() {
      var result = true;

      if (!this.broadcast.name) {
        this.errors.push('Broadcast Name is required');
        result = false;
      }

      if (!this.broadcast.boxcaster_id) {
        this.errors.push('Source is required');
        result = false;
      }

      if (this.isSimulatedLive && !this.broadcast.source_broadcast_id) {
        this.errors.push('Source broadcast is required');
        result = false;
      }

      return result;
    }
  }, {
    key: "otherNonConflictingEvents",
    get: function get() {
      var _this13 = this;

      // if it is a conflicting broadcast (uses the same source adn either the start or stop overlap), dont include it
      var results = this.otherEvents.filter(function (o) {
        var found = _this13.conflictingEvents.find(function (e) {
          return e.id == o.id;
        });

        return !found || found.length == 0;
      }); // If the start and end time are both in the past, dont show it

      results = results.filter(function (b) {
        var thisStartsAt = Date.parse(b.starts_at);
        var thisStopsAt = Date.parse(b.stops_at);
        var dates = Object(__WEBPACK_IMPORTED_MODULE_1__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(_this13.startDate, _this13.startTime, _this13.endTime);
        var startsAt = Date.parse(dates.starts_at);
        var stopsAt = Date.parse(dates.stops_at);
        var isPast = startsAt <= thisStartsAt && stopsAt <= thisStopsAt;
        return isPast;
      });
      return results;
    }
  }, {
    key: "isInThePast",
    get: function get() {
      // if this event is set to happen entirely in the past, don't allow it to be scheduled
      var now = new Date().getTime();
      var dates = Object(__WEBPACK_IMPORTED_MODULE_1__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(this.startDate, this.startTime, this.endTime, this.maxBroadcastDurationHours);
      var startsAt = moment(dates.starts_at).toDate().getTime();
      var stopsAt = moment(dates.stops_at).toDate().getTime();
      return now > startsAt && now > stopsAt;
    }
  }, {
    key: "validateSchedule",
    value: function validateSchedule() {
      var result = true;

      if (this.broadcast.timeframe != 'past') {
        if (!this.isWithinAccountBroadcastDurationLimit) {
          this.errors.push("You are not allowed to stream for longer than ".concat(this.maxBroadcastDurationHours, " hours (contact us if you would like to upgrade your account)"));
          result = false;
        }

        if (this.recordingStorageExpires) {
          this.errors.push('The recording storage expires before the simulated live broadcast is scheduled to begin.');
          result = false;
        }

        if (this.isInThePast) {
          this.errors.push('A broadcast may not be scheduled in the past.');
          result = false;
        }
      }

      return result;
    }
  }, {
    key: "validateScoreboard",
    value: function validateScoreboard() {
      var result = true;
      var sc = this.broadcast.scoreboard_configuration;

      if (this.broadcast.timeframe == 'past' || !sc.sport) {
        return result;
      }

      if (sc.manual) {// manual scoreboard settings do not need validated
      } else if (sc.connection == 'scoreboard_adapter') {
        if (!sc.scoreboard_make || !sc.scoreboard_model) {
          this.errors.push('Scoreboard Make and Model are required');
          result = false;
        }
      } else if (sc.connection == 'scoreboard_assist') {// scoreboard assist settings do not need validated
      } else if (sc.connection == 'scorebot') {
        if (isNaN(parseInt(sc.sportzcast_bot_number, 10))) {
          this.errors.push('A valid ScoreBOT number is required');
          result = false;
        }
      } else {
        this.errors.push('A scoreboard connection is required');
        result = false;
      }

      return result;
    }
  }, {
    key: "validatePublish",
    value: function validatePublish() {
      var result = true;

      if (!this.visibility) {
        this.errors.push("Broadcast Type is required");
        result = false;
      }

      if (this.visibility == 'ticketed' || this.visibility == 'flex') {
        if (!this.broadcast.ticket_price || this.broadcast.ticket_price < this.minTicketPrice) {
          this.errors.push("The ticket price must be at least ".concat(this.minTicketPrice));
          result = false;
        }
      }

      var validSimulcast = this.broadcast.simulcast_configurations.filter(function (s) {
        return s.destination === 'generic';
      }).every(function (s) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__utils_rtmp__["a" /* IsRtmpURLValid */])(s.stream_url);
      });

      if (!validSimulcast) {
        this.errors.push('Invalid RTMP URL');
        result = false;
      }

      var validFbSimulcast = this.broadcast.simulcast_configurations.filter(function (s) {
        return s.destination === 'facebook';
      }).every(function (s) {
        return s.feed_type === 'user:me' || !!s.feed_id;
      });

      if (!validFbSimulcast) {
        this.errors.push('Invalid Facebook Destination');
        result = false;
      }

      var validMaxResolution = this.broadcast.simulcast_configurations.filter(function (s) {
        return s.destination === 'generic';
      }).every(function (s) {
        return !!s.max_resolution;
      });

      if (!validMaxResolution) {
        this.errors.push('Invalid Max Resolution');
        result = false;
      }

      return result;
    }
  }, {
    key: "validateAdvanced",
    value: function validateAdvanced() {
      var _this14 = this;

      var result = true;

      if (this.broadcast.simulcast_configurations.length > 0 && this.isAudioOnly) {
        this.errors.push('Audio-only broadcasts cannot be sent to simulcast destinations.');
        result = false;
      }

      var hostRestrictions = this.broadcast.content_settings.hostRestrictions;

      if (hostRestrictions) {
        if (!hostRestrictions.allowedHosts.length) {
          this.errors.push('At least one allowed host is required');
          result = false;
        }

        hostRestrictions.allowedHosts.forEach(function (h) {
          if (!h) {
            _this14.errors.push('Allowed host cannot be blank');

            result = false;
          }
        });
      } else {
        delete this.broadcast.content_settings.hostRestrictions;
      }

      var passwordBlock = this.broadcast.content_settings.cryptblock;

      if (passwordBlock) {
        if (!passwordBlock.__password__ && !passwordBlock.crypt) {
          this.errors.push('Please choose a password');
          result = false;
        }
      } else {
        delete this.broadcast.content_settings.cryptblock;
      }

      return result;
    }
  }, {
    key: "isWithinAccountBroadcastDurationLimit",
    get: function get() {
      if (!this.endTime) return true;
      if (this.isSimulatedLive) return true; // ¯\_(ツ)_/¯

      var dates = Object(__WEBPACK_IMPORTED_MODULE_1__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(this.startDate, this.startTime, this.endTime, this.maxBroadcastDurationHours);
      var duration = (moment(dates.stops_at) - moment(dates.starts_at)) / (60 * 60 * 1000);
      return duration <= this.maxBroadcastDurationHours;
    }
  }, {
    key: "recordingStorageExpires",
    get: function get() {
      if (this.broadcast.timeframe && this.broadcast.timeframe !== 'past') {
        return false;
      }

      if (!this.isSimulatedLive) {
        return false;
      }

      if (!this.sourceBroadcast) {
        return false;
      }

      if (this.account.storage_policy !== 'auto-delete') {
        return false;
      }

      var storageExpiresAt = Date.parse(this.sourceBroadcast.storage_expires_at);
      var dates = Object(__WEBPACK_IMPORTED_MODULE_1__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(this.startDate, this.startTime, this.endTime);
      var startsAt = Date.parse(dates.starts_at);
      return storageExpiresAt < startsAt;
    }
  }, {
    key: "showScrambleOption",
    get: function get() {
      return this.visibility == 'private' && this.origVisibility != 'private';
    }
  }, {
    key: "showAddSimulcast",
    get: function get() {
      return this.visibility != 'ticketed' && this.visibility != 'flex' && (this.allowFacebookLive && !this.fb.loading && this.fb.connected || this.allowYoutubeLive && this.youtubeUsers.length || this.allowTwitter && this.twitterUsers.length || this.allowGenericRtmpPush && this.rtmpPushChannels.length || this.allowGenericRtmpPush);
    }
  }, {
    key: "saveChanges",
    value: function saveChanges() {
      var skipFormValidation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var skipCustomStreamSourceHandling = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var $scope = this.$scope,
          $q = this.$q,
          Broadcast = this.Broadcast,
          toaster = this.toaster;
      var deferred = $q.defer();

      if (!skipFormValidation && !this.validateAll()) {
        console.log('Invalid form', this.errors);
        deferred.reject('invalid');
        return deferred.promise;
      } // Adjust dates when broadcast crosses midnight


      var dates = Object(__WEBPACK_IMPORTED_MODULE_1__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(this.startDate, this.startTime, this.endTime, this.maxBroadcastDurationHours);
      this.broadcast.starts_at = dates.starts_at;
      this.broadcast.stops_at = dates.stops_at; // Make a copy so we can mutate the original in ways that might be incompatible with the
      // edit/create pages

      var broadcast = angular.copy(this.broadcast); // Clean up the visibility settings on the broadcast object

      broadcast = Object(__WEBPACK_IMPORTED_MODULE_0__utils_pricing__["b" /* updatePriceSettingsFromVisibilityOption */])(broadcast, this.visibility); // Clean up cruft from UI shenanigans

      Object(__WEBPACK_IMPORTED_MODULE_2__utils_password__["a" /* checkContentSettingsForChangesOnSave */])(broadcast.content_settings);

      if (broadcast.content_settings.preview === null) {
        delete broadcast.content_settings.preview;
      }

      if (!this.bulkImportMode) {
        Object(__WEBPACK_IMPORTED_MODULE_5__utils_scoreboard__["d" /* mapScoreboardUIConfigurationToAPI */])(broadcast.scoreboard_configuration);
      }

      if (this.showFeatured) {
        if (this.isFeatured) {
          if (!_.contains(broadcast.tags, 'featured')) {
            broadcast.tags.push('featured');
          }
        } else {
          _.remove(broadcast.tags, function (t) {
            return t == 'featured';
          });
        }
      } // Simulcast configuration managed separately


      var simulcastMeta = broadcast.simulcast_configurations;
      delete broadcast.simulcast_configurations; // Remove instructional rows

      simulcastMeta.filter(function (s) {
        return !s.isHelpRow;
      }); // Someone may have clicked the "Multi-Use" tab to see what that was about _AFTER_ filling out
      // the single-use fields. In that case, flip it back to generic.

      simulcastMeta.filter(function (s) {
        return s.destination === 'rtmp_push_channel';
      }).forEach(function (s) {
        if (!s.rtmp_push_channel_id && s.stream_url && s.stream_key) {
          s.destination = 'generic';

          if (!s.max_resolution) {
            s.max_resolution = '0';
          }
        }
      }); // string to integers for max_resolution

      simulcastMeta.filter(function (s) {
        return s.destination === 'generic';
      }).forEach(function (s) {
        return s.max_resolution = parseInt(s.max_resolution);
      }); // filter out any multi-use RTMP that don't actually have a channel selected

      simulcastMeta = simulcastMeta.filter(function (s) {
        return s.destination !== 'rtmp_push_channel' || !!s.rtmp_push_channel_id;
      }); // Recombine feed type and ID for facebook

      simulcastMeta.filter(function (s) {
        return s.destination === 'facebook';
      }).forEach(function (s) {
        if (s.feed_type === 'user:me') {
          s.fb_feed_id = 'user:me';
        } else {
          s.fb_feed_id = s.feed_type + ':' + s.feed_id;
        }

        delete s.feed_type;
        delete s.feed_id;
      }); // Support regenerating the channel ID

      if (this.showScrambleOption && this.scrambleChannelId) {
        broadcast.regenerate_channel_id = '1';
        broadcast.metadata = broadcast.metadata || {};
        broadcast.metadata.original_channel_id = broadcast.metadata.original_channel_id || broadcast.channel_id;
      } else {
        delete broadcast.regenerate_channel_id;
      } // Deal with custom stream sources


      if (!skipCustomStreamSourceHandling) {
        this.explodeStreamSourceSettings(broadcast);
      } // Handle start/stop time editibility


      if (broadcast.stream_source != 'imported') {
        if (broadcast.timeframe == 'current') {
          // If this broadcast is live, API won't let us change the start time
          delete broadcast.starts_at;
        } else if (broadcast.timeframe == 'past') {
          // If this broadcast was in the past, API won't let us change the start or stop time
          delete broadcast.starts_at;
          delete broadcast.stops_at;
        }
      } // Remove unnecessary fields for imported/simulated live broadcasts


      if (broadcast.stream_source == 'imported' || broadcast.stream_source == 'recording') {
        broadcast.target_video_bitrate = null;
        broadcast.target_audio_bitrate = null;
        broadcast.audio_source = null;
        broadcast.target_video_resolution = null;
        broadcast.target_high_frame_rate = null;
        broadcast.dscp_value = null;
      } // Simulated live broadcasts have some special values


      if (broadcast.stream_source == 'recording') {
        broadcast.requests_captioning = false;

        if (broadcast.stops_at) {
          broadcast.stops_at = null;
        }
      } // Do not attempt to change the stream source for *past* broadcasts (can cause
      // weird issues with archived BoxCasters, RTMP Sources, etc.)


      if (broadcast.timeframe == 'past') {
        delete broadcast.stream_source;
        delete broadcast.static_rtmp_id;
        delete broadcast.boxcaster_id;
        delete broadcast.source_broadcast_id;
      }

      if (broadcast.timeframe && broadcast.timeframe != 'future') {
        // Do not attempt to change the target_buffer_latency for any non-future broadcast
        delete broadcast.target_buffer_latency;
      } else {
        // Make sure target_buffer_latency makes sense
        if (this.account.feature_flags.boxcast_flow_control_disabled) {
          broadcast.target_buffer_latency = 'default';
        } else if (this.isBoxCasterHDSD2) {
          if (broadcast.target_buffer_latency == 'maximum') {
            broadcast.target_buffer_latency = 'enhanced';
          }
        } else if (!this.isBoxCasterHDSD2 && !this.isBoxCasterPro && !this.isBroadcasterApp) {
          broadcast.target_buffer_latency = 'default';
        }
      } // Detach from old static RTMP channel if switching to non-RTMP source


      if (broadcast.stream_source != 'rtmp' && broadcast.static_rtmp_id) {
        broadcast.static_rtmp_id = null;
      }

      var promise;

      if (broadcast.id) {
        // Update existing broadcast
        if (broadcast.timeframe != 'past') {
          broadcast.simulcast_configurations = simulcastMeta;
        } else {
          delete broadcast.scoreboard_configuration;
        }

        promise = Broadcast.update({
          id: broadcast.id
        }, broadcast).$promise;
      } else {
        // Save new broadcast
        broadcast.simulcast_configurations = simulcastMeta;
        promise = Broadcast.save(broadcast).$promise;
      }

      promise.then(function (response) {
        // Handle any warnings/errors from simulcast
        (response.simulcast_configurations || []).forEach(function (c) {
          if (c.error) {
            console.error(c);
            toaster.pop('warning', "There was an error saving the simulcast configuration: ".concat(c.error.error_description));
          }
        });
        deferred.resolve(response);
      })["catch"](function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    }
  }]);

  return _EditOrCreateEventServiceImpl;
}();
module.service('EditOrCreateEventService', EditOrCreateEventService);
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EnhancedBoxCastFlowControlTooltipHTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MaximumBoxCastFlowControlTooltipHTML; });
// EnhancedBoxCastFlowControlTooltipHTML is the HTML of the tooltip that explains standard and enhanced
// BoxCast flow control. It is used for creating/editing broadcasts and editing BoxCaster sources.
var EnhancedBoxCastFlowControlTooltipHTML = "<b>Standard:</b> Minimizes viewer latency; recovers lost data for up to 2 seconds.\n  <br/>\n  <b>Enhanced:</b> Recovers lost data for up to 15s (and adds 15 seconds to viewer latency)."; // MaximumBoxCastFlowControlTooltipHTML is the HTML of the tooltip that explains standard, enhanced, and
// maximum BoxCast flow control. It is used for creating/editing broadcasts and editing BoxCaster sources.

var MaximumBoxCastFlowControlTooltipHTML = EnhancedBoxCastFlowControlTooltipHTML + "<br/><b>Maximum:</b> Recovers lost data for up to 45-90 seconds (and adds 45-90 seconds to viewer latency).";

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FacebookService */
var module = angular.module('boxcast.services.facebook', []); // NOTE: Changing the scope of permissions from Facebook requires
// that you submit the app for approval for the permissions using
// the tools at developer.facebook.com.

var FACEBOOK_SCOPE = ['business_management', 'pages_manage_metadata', 'pages_manage_posts', 'pages_read_engagement', 'pages_show_list', 'publish_video'].join(',');
var FB_LOAD_STATUS_DEBOUNCE_MS = 60000; //only poll once per minute at most

module.service('Facebook', FacebookService);
function FacebookService($http, $q, $timeout) {
  'ngInject';

  var _this = this;

  this.loading = false;
  this.auth = {};

  this.init = function () {
    _this.loading = true;
    return waitForSDK().then(function () {
      return _this.loadStatus({
        silent: true
      });
    }).then(function () {
      _this.loading = false;
    })["catch"](function (err) {
      _this.loading = false;
      remoteLogger.error('Unable to initialize Facebook', {
        error: err
      });
    });
  };

  this._loadStatusInFlight = false;
  this._lastLoadStatusComplete = 0;

  this.loadStatus = function (options) {
    return $q(function (resolve, reject) {
      var checkAgainTimer = $timeout(function () {
        // getLoginStatus sometimes hangs the first time...
        _this.loadStatus(options).then(function () {
          resolve(_this);
        });
      }, 1000);

      if (_this._loadStatusInFlight) {
        console.log('Facebook#loadStatus -- in flight, will not start another FB API call');
        return; //let checkAgainTimer resolve in a bit
      }

      if (!options.force && new Date() - _this._lastLoadStatusComplete < FB_LOAD_STATUS_DEBOUNCE_MS) {
        console.log('Facebook#loadStatus -- using cached loadStatus value');
        $timeout.cancel(checkAgainTimer);
        resolve(_this);
        return;
      }

      _this._loadStatusInFlight = true;
      FB.getLoginStatus(function (response) {
        if (checkAgainTimer) {
          $timeout.cancel(checkAgainTimer);
        }

        $timeout(function () {
          _this._loadStatusInFlight = false;
          _this._lastLoadStatusComplete = new Date();
          updateInstanceFromAuthResponse(response, options).then(function () {
            return resolve(_this);
          })["catch"](function (e) {
            return reject(e);
          });
        }, 0);
      }, true);
    });
  };

  var updateInstanceFromAuthResponse = function updateInstanceFromAuthResponse(response) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _this.connected = response.status == 'connected';
    _this.status = response.status;
    _this.auth = response.authResponse || {};

    if (_this.connected) {
      return $q.all([_this.queryMe(options), _this.queryAccounts(), _this.queryEvents(), _this.queryGroups()]);
    } else {
      _this.me = {};
      _this.accounts = [];
      return $q(function (r) {
        return r();
      });
    }
  };

  this.queryMe = function (options) {
    return $q(function (resolve, reject) {
      FB.api('/me', function (response) {
        // name, id
        $timeout(function () {
          _this.me = response;

          if (_this.auth.accessToken) {
            _this.linkAccount(options).then(function () {
              return resolve(response);
            })["catch"](function (e) {
              return reject(e);
            });
          } else {
            resolve(response);
          }
        }, 0);
      });
    });
  };

  var doFbApi = function doFbApi(url) {
    return $q(function (resolve, reject) {
      FB.api(url, function (response) {
        $timeout(function () {
          if (response.error) {
            remoteLogger.error("Error from Facebook URL", {
              facebook_url: url,
              error: response.error
            });
            reject(response.error);
          } else {
            resolve(response);
          }
        }, 0);
      });
    });
  }; // It seems that by default, Facebook returns about 25 results per page, taking 500-900ms to do so (all
  // server-side, not network). In order to prevent unbounded recursion and a long delay when loading the
  // Facebook account, we limit results to 10 pages or 250 results (whichever comes first). In general,
  // this should keep load times below 5-10s (and usually lower, assuming most people don't have _that_
  // many pages, groups, and events).


  var fbRecursiveCallLimit = 10;
  var fbResultLimit = 250;

  var paginateFbApi = function paginateFbApi(url) {
    return $q(function (resolve, reject) {
      // Closure variable to collect results
      var results = [];
      var totalCalls = 0; // Error and success callbacks

      var completionSuccess = function completionSuccess(response) {
        results = results.concat(response.data || []);

        if (response.paging && response.paging.next) {
          // More pages, apparently
          if (totalCalls >= fbRecursiveCallLimit) {
            console.warn("Facebook would provide more results, but we stopped after ".concat(totalCalls, " to the API. Results will be limited."));
            resolve(results);
          } else if (results.length >= fbResultLimit) {
            console.warn("Facebook would provide more results, but we stopped after finding ".concat(results.length, " results. Results will be limited."));
            resolve(results);
          } else {
            totalCalls += 1;
            doFbApi(response.paging.next).then(completionSuccess)["catch"](function (e) {
              return reject(e);
            });
          }
        } else {
          // No more pages, resolve
          resolve(results);
        }
      }; // Now kick off the first API call


      totalCalls += 1;
      doFbApi(url).then(completionSuccess)["catch"](function (e) {
        return reject(e);
      });
    });
  };

  this.queryAccounts = function () {
    return paginateFbApi('/me/accounts?fields=id,name,cover').then(function (results) {
      _this.accounts = _.sortBy(results, function (a) {
        return (a.name || '').toLowerCase();
      });
      return results;
    })["catch"](function (error) {
      _this.accounts = [];
      throw error;
    });
  };

  this.queryEvents = function () {
    return paginateFbApi('/me/events?fields=id,name,cover,start_time').then(function (results) {
      _this.events = _.sortBy(results, function (e) {
        return Date.parse(e.start_time);
      });
      return results;
    })["catch"](function (error) {
      _this.events = [];
      throw error;
    });
  };

  this.queryGroups = function () {
    return paginateFbApi('/me/groups?fields=id,name,cover').then(function (results) {
      _this.groups = _.sortBy(results, function (g) {
        return (g.name || '').toLowerCase();
      });
      return results;
    })["catch"](function (error) {
      _this.groups = [];
      throw error;
    });
  };

  this.logout = function () {
    return $q(function (resolve, reject) {
      if (!window.FB) {
        return resolve(false);
      }

      FB.logout(function () {
        _this.facebook_account_id = null;
        _this.connected = false;
        _this.status = {};
        _this.auth = {};
        _this.me = {};
        _this.accounts = [];
        _this.events = [];
        _this.groups = [];
        resolve(true);
      });
    });
  };

  this.login = function () {
    return $q(function (resolve, reject) {
      FB.login(function (resp) {
        updateInstanceFromAuthResponse(resp).then(function () {
          resolve(true);
        })["catch"](function (err) {
          reject(err);
        });
      }, {
        scope: FACEBOOK_SCOPE
      });
    });
  };

  this.linkAccount = function (options) {
    return $q(function (resolve, reject) {
      $http.get("".concat(API_ROOT, "/account/facebook_users/").concat(_this.me.id)).then(function (response) {
        // User already exists, extend the token
        $http.put("".concat(API_ROOT, "/account/facebook_users/").concat(_this.me.id), {
          fb_user_access_token: _this.auth.accessToken,
          fb_user_name: _this.me.name
        }).then(function (response) {
          console.log('Updated Facebook->BoxCast linkage:', response.data);
          _this.facebook_account_id = response.data.id;
          resolve(_this.facebook_account_id);
        })["catch"](function (err) {
          reject(err);
        });
      })["catch"](function (err) {
        if (err.status != 404) {
          remoteLogger.error('Error linking facebook account:', {
            error: err
          });
          reject(err);
          return;
        }

        if (options && options.silent) {
          // 404, user doesn't exist in BoxCast DB ... don't auto-create it since
          // we're in silent mode. Wait for user to explicitly want to link.
          _this.connected = false;
          _this.status = {};
          _this.auth = {};
          _this.me = {};
          _this.accounts = [];
          _this.events = [];
          _this.groups = [];
          resolve({});
        } else {
          // 404, user doesn't exist in BoxCast DB ... create it!
          $http.post("".concat(API_ROOT, "/account/facebook_users"), {
            fb_user_id: _this.me.id,
            fb_user_access_token: _this.auth.accessToken,
            fb_user_name: _this.me.name
          }).then(function (response) {
            console.log('Linked Facebook->BoxCast:', response.data); // XXX: is there a race condition?

            _this.facebook_account_id = response.data.id;
            resolve(_this.facebook_account_id);
          })["catch"](function (err) {
            reject(err);
          });
        }
      });
    });
  }; // Private helpers


  var waitForSDK = function waitForSDK() {
    var deferred = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (deferred === null) {
      deferred = $q.defer();
    }

    if (window['FB']) {
      deferred.resolve(FB);
      _this.FB = FB;
      return deferred.promise;
    } else {
      console.log('FB SDK not yet loaded, checking again');
      $timeout.cancel(_this._waitForSDKTimer);
      _this._waitForSDKTimer = $timeout(function () {
        return waitForSDK(deferred);
      }, 100);
      return deferred.promise;
    }
  };
}
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var module = angular.module('jszip', []);
module.service('JSZip', function () {
  this.init = function () {
    return new Promise(function (resolve, reject) {
      __webpack_require__.e/* require.ensure */(0).then((function () {
        var jszip = __webpack_require__(566);

        resolve(jszip);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    });
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var module = angular.module('app.services.meetings-service', []);
module.service('MeetingsService', function ($uibModal, $rootScope) {
  var _this = this;

  var account = $rootScope.account;

  this.openPreferredMethod = function () {
    // Prefer chat if it's available
    if (_this.openChat()) {
      return;
    } // Otherwise, schedule a meeting


    _this.scheduleMeeting();
  };

  this.openChat = function () {
    if (window.Intercom) {
      window.Intercom('show');
      return true;
    }

    return false;
  };

  this.scheduleMeeting = function () {
    var _title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Schedule time with a live streaming expert';

    var url = "".concat(HUBSPOT_MEETINGS_BASE_URL, "/brian-lee/meeting-with-boxcast?embed=true");

    if (account.isTrialing()) {
      url = "".concat(HUBSPOT_MEETINGS_BASE_URL, "/brian-lee/boxcast-live-stream-meeting?embed=true");
    }

    $uibModal.open({
      template: __webpack_require__(528),
      controller: __webpack_require__(529)["default"],
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        title: function title() {
          return _title;
        },
        meetingLink: function meetingLink() {
          return url;
        }
      }
    });
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\" style=\"text-align:center;border-bottom:none 0;padding-bottom:0\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h4 class=\"modal-title\"><strong>{{::vm.title}}</strong></h4>\n</div>\n<div class=\"modal-body\" style=\"text-align:center;padding-top:0\">\n  <iframe frameborder=\"0\" width=\"100%\" height=\"700px\" class=\"embed-responsive-item\" style=\"padding-top:10px!important\" ng-src=\"{{::vm.meetingLink}}\"></iframe>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n</div>"

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalScheduleMeeting;
function ModalScheduleMeeting($uibModalInstance, $rootScope, $sce, title, meetingLink) {
  'ngInject';

  this.cancel = function () {
    return $uibModalInstance.dismiss('cancel');
  };

  this.account = $rootScope.account;
  this.user = $rootScope.user;
  this.title = title;
  var meetingLink = meetingLink;
  var nameParts = this.user.name.split(' ');
  meetingLink += "&email=".concat(this.user.email, "&firstName=").concat(nameParts[0], "&lastName=").concat(nameParts[1], "&organization_name=").concat(this.account.name);
  this.meetingLink = $sce.trustAsResourceUrl(meetingLink);
}

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var module = angular.module('app.services.multi-part-upload', []);
var MAX_SIMULTANEOUS_UPLOAD_PARTS = 4;
var MAX_BACKOFF_MS = 10000;
var EXP_BACKOFF_FACTOR = 1.75;
module.service('MultiPartUpload', function ($q, $http, $timeout, Upload) {
  var MultiPartUpload = /*#__PURE__*/function () {
    function MultiPartUpload(baseUrl, file, parts) {
      _classCallCheck(this, MultiPartUpload);

      this._baseUrl = baseUrl;
      this._file = file;
      this._parts = parts;
      this._destroyed = false;
      this._totalUploadSize = _.reduce(this._parts, function (m, p) {
        return m + p.size;
      }, 0);
      this._advanceDelay = 0;
      this._deferred = $q.defer();
      this._promise = this._deferred.promise; // Glue on a state for each part

      _.each(this._parts, function (p) {
        if (p.complete) {
          p.state = 'complete';
        } else {
          p.state = 'not-started';
        }
      });

      this._advance();
    }

    _createClass(MultiPartUpload, [{
      key: "$promise",
      get: function get() {
        return this._promise;
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this._destroyed = true;

        if (this._timeout) {
          $timeout.cancel(this._timeout);
        }
      } // This function advances the state of the multi-part upload

    }, {
      key: "_advance",
      value: function _advance() {
        var _this = this;

        if (this._destroyed) return; // Each part has an state (internal, maintained by this class, NOT provided from the API), one of:
        //  - not-started
        //  - uploading (PUT of the part content in flight)
        //  - uploaded (will have set complete: true and etag: <something>)
        //  - updating (PUT of the part status in flight)
        //  - complete
        // If there are >= MAX_SIMULTANEOUS_UPLOAD_PARTS parts still in flight, nothing to do.

        var numInFlight = _.filter(this._parts, function (p) {
          return _.contains(['uploading', 'updating'], p.state);
        }).length;

        if (numInFlight >= MAX_SIMULTANEOUS_UPLOAD_PARTS) return; // First, let's look for a part to update

        var partToUpdate = _.find(this._parts, function (p) {
          return p.state === 'uploaded';
        });

        if (partToUpdate) {
          this._startPartUpdate(partToUpdate); // Call ourselves recursively, as we might be able to start more.


          return this._advance();
        } // Next, let's go looking for a part to upload


        var partToUpload = _.find(this._parts, function (p) {
          return p.state === 'not-started';
        });

        if (partToUpload) {
          partToUpload.$promise = this._startPartUpload(partToUpload); // Call ourselves recursively, as we might be able to start more.

          return this._advance();
        } // If there are still some in flight, wait until they're done


        if (numInFlight > 0) return; // All done, I guess... this promise _should_ resolve immediately since all the child
        // promises have already resolved.

        $q.all(_.map(this._parts, function (p) {
          return p.$promise;
        })).then(function (r) {
          return _this._deferred.resolve(r);
        }, function (e) {
          return _this._deferred.reject(e);
        });
      } // This function calls _advance asynchronously with the appropriate backoff

    }, {
      key: "_advanceAsync",
      value: function _advanceAsync(lastCallSuccessful) {
        var _this2 = this;

        this._timeout = $timeout(function () {
          return _this2._advance();
        }, this._nextAdvanceDelay(lastCallSuccessful));
      } // Get the next delay for calling _advance

    }, {
      key: "_nextAdvanceDelay",
      value: function _nextAdvanceDelay(lastCallSuccessful) {
        if (lastCallSuccessful) {
          this._advanceDelay = 0;
        } else {
          this._advanceDelay = Math.min(Math.max(1000, this._advanceDelay) * EXP_BACKOFF_FACTOR, MAX_BACKOFF_MS);
        }

        return this._advanceDelay;
      } // A function to notify the promise of progress; it is called with an individual
      // progress event, and converts it into a new event that summarizes total progress.

    }, {
      key: "_notifyProgress",
      value: function _notifyProgress(e) {
        var _this3 = this;

        var newEvent = {
          loaded: this._totalLoaded(),
          total: this._totalUploadSize,
          type: e.type,
          config: e.config,
          lengthComputable: true,
          target: e.target
        };

        if (this._deferred.notify) {
          this._deferred.notify(newEvent);
        }

        if (this._promise.progressFunc) {
          $timeout(function () {
            return _this3._promise.progressFunc(newEvent);
          });
        }
      } // Called after successfully updating a part status with the API

    }, {
      key: "_partUpdateComplete",
      value: function _partUpdateComplete(resp, part) {
        part.state = 'complete';

        this._advanceAsync(true);
      } // Called if updating a part status with the API fails

    }, {
      key: "_partUpdateError",
      value: function _partUpdateError(err, part) {
        console.error('Error updating part:', part, err);
        part.state = 'uploaded';

        this._advanceAsync(false);
      } // Called when a part upload has completed successfully

    }, {
      key: "_partUploadComplete",
      value: function _partUploadComplete(resp, part) {
        part.complete = true;
        part.etag = resp.headers('ETag');
        part.state = 'uploaded';

        this._advanceAsync(true);
      } // Called when a part upload failed

    }, {
      key: "_partUploadError",
      value: function _partUploadError(err, part) {
        var _this4 = this;

        console.error('Error uploading part:', part, err);
        part.state = 'not-started'; // The upload service refreshes the presigned PUT URLs for any incomplete parts when we GET
        // the upload again. Refresh it here and update the presigned URL for any incomplete parts
        // in case we've hit their signature expiration.

        $http.get(this._baseUrl).then(function (resp) {
          _.each(_.where(_this4._parts, function (p) {
            return _.contains(['not-started', 'uploading'], p.state);
          }), function (p) {
            var refreshedPart = _.find(resp.data.parts, function (p2) {
              return p2.part_number === p.part_number;
            });

            if (refreshedPart) {
              p.presigned_url = refreshedPart.presigned_url;
            }
          });

          _this4._advanceAsync(false);
        }, function (err) {
          console.error('Error refreshing upload:', err);

          _this4._advanceAsync(false);
        });
      } // Called for progress/notify on a part upload

    }, {
      key: "_partUploadProgress",
      value: function _partUploadProgress(evt, part) {
        part.loaded = evt.loaded;

        this._notifyProgress(evt);
      } // Start the update of a part status with the API and return its promise

    }, {
      key: "_startPartUpdate",
      value: function _startPartUpdate(part) {
        var _this5 = this;

        part.state = 'updating';
        return $http.put("".concat(this._baseUrl, "/parts/").concat(part.part_number), {
          complete: part.complete,
          etag: part.etag
        }).then(function (r) {
          return _this5._partUpdateComplete(r, part);
        }, function (e) {
          return _this5._partUpdateError(e, part);
        });
      } // Start the upload of a part and return its promise

    }, {
      key: "_startPartUpload",
      value: function _startPartUpload(part) {
        var _this6 = this;

        part.state = 'uploading';
        return Upload.http({
          url: part.presigned_url,
          headers: {
            'Content-Type': this._file.type
          },
          method: 'PUT',
          data: this._file.slice(part.offset, part.offset + part.size)
        }).then(function (r) {
          return _this6._partUploadComplete(r, part);
        }, function (e) {
          return _this6._partUploadError(e, part);
        }, function (n) {
          return _this6._partUploadProgress(n, part);
        });
      } // A function to calculate total loaded amount across all promises

    }, {
      key: "_totalLoaded",
      value: function _totalLoaded() {
        return _.reduce(this._parts, function (m, p) {
          return m + (p.loaded || 0);
        }, 0);
      }
    }]);

    return MultiPartUpload;
  }();

  this.destroy = function () {
    if (this._mpu) {
      this._mpu.destroy();
    }
  };

  this.start = function (baseUrl, file, parts) {
    this._mpu = new MultiPartUpload(baseUrl, file, parts);
    return this._mpu.$promise;
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var module = angular.module('one-or-all-dialog', []);
module.service('OneOrAllDialog', function ($uibModal) {
  'ngInject';

  var modalDefaults = {
    backdrop: true,
    keyboard: true,
    modalFade: true,
    template: "\n      <div class=\"modal-header\">\n        <h3 class=\"modal-title\">{{modalOptions.headerText}}</h3>\n      </div>\n      <div class=\"modal-body\">\n        <p>{{modalOptions.bodyText}}</p>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-{{modalOptions.closeButtonClass}}\" data-ng-click=\"modalOptions.close()\">{{modalOptions.closeButtonText}}</button>\n        <button class=\"btn btn-{{modalOptions.allButtonClass}}\" data-ng-click=\"modalOptions.ok('all');\">{{modalOptions.allButtonText}}</button>\n        <button class=\"btn btn-{{modalOptions.oneButtonClass}}\" data-ng-click=\"modalOptions.ok('one');\">{{modalOptions.oneButtonText}}</button>\n      </div>\n    "
  };
  var modalOptions = {
    headerText: 'Proceed?',
    bodyText: 'Perform this action?',
    closeButtonText: 'Close',
    closeButtonClass: 'default',
    allButtonText: 'All Upcoming Broadcasts In The Series',
    allButtonClass: 'primary',
    oneButtonText: 'This Broadcast Only',
    oneButtonClass: 'primary'
  };

  this.show = function (customModalOptions, customModalDefaults) {
    //Create temp objects to work with since we're in a singleton service
    var tempModalDefaults = {};
    var tempModalOptions = {}; //Map angular-ui modal custom defaults to modal defaults defined in service

    angular.extend(tempModalDefaults, modalDefaults, customModalDefaults); //Map modal.html $scope custom properties to defaults defined in service

    angular.extend(tempModalOptions, modalOptions, customModalOptions);

    if (!tempModalDefaults.controller) {
      tempModalDefaults.controller = function ($scope, $uibModalInstance) {
        'ngInject';

        $scope.modalOptions = tempModalOptions;

        $scope.modalOptions.ok = function (result) {
          $uibModalInstance.close(result);
        };

        $scope.modalOptions.close = function (result) {
          $uibModalInstance.dismiss('cancel');
        };
      };
    }

    return $uibModal.open(tempModalDefaults).result;
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_overlay_image__ = __webpack_require__(183);

var module = angular.module('app.services.overlays', []);
var PAGE_SIZE = 20;
module.service('Overlays', function ($q, $http) {
  'ngInject';

  var _this = this;

  this.loadOverlaysForPage = function (p) {
    return $http.get("".concat(API_ROOT, "/account/uploads"), {
      params: {
        'filter.slot': 'overlay',
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: '-created_at'
      }
    }).then(function (response) {
      var pagination = JSON.parse(response.headers('x-pagination'));
      return {
        uploads: response.data,
        pagination: {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + response.data.length
        }
      };
    });
  };

  this.preloadUploadImage = function (upload) {
    return $q(function (resolve, reject) {
      // this needs to be in the initialization logic when first dragging onto canvas
      $('<img/>') // Make in memory copy of image to avoid css issues
      .attr('src', upload.view_url).load(function () {
        var width = this.width,
            height = this.height; // get actual image dimensions from <img>

        resolve({
          width: width,
          height: height
        });
      }).error(function (err) {
        reject(err);
      });
    });
  };

  this.prepareUploadForOverlay = function (upload) {
    return _this.preloadUploadImage(upload).then(function (dims) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__directives_overlay_image__["uploadImageToOverlay"])(upload, dims.width, dims.height);
    });
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular_ui_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular_ui_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular_ui_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_resource__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_resource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular_sanitize__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular_sanitize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angular_sanitize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angulartics__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angulartics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angulartics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angulartics_google_analytics__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angulartics_google_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angulartics_google_analytics__);
// 3rd party angular modules




__webpack_require__(167);

__webpack_require__(536);

__webpack_require__(169);

__webpack_require__(172);

__webpack_require__(537);

__webpack_require__(539);

__webpack_require__(541);

__webpack_require__(542);

__webpack_require__(544);

__webpack_require__(545);

__webpack_require__(546);

__webpack_require__(547);

__webpack_require__(171);

__webpack_require__(548);

__webpack_require__(550);




__webpack_require__(173);

__webpack_require__(554);

__webpack_require__(177);

__webpack_require__(178);

__webpack_require__(556);

__webpack_require__(558);

__webpack_require__(20);

__webpack_require__(37);

__webpack_require__(166);

__webpack_require__(560);

__webpack_require__(561);

var module = angular.module('app.thirdparty', ['angular-clipboard', 'ngSanitize', 'angularMoment', 'angulartics', 'angulartics.google.analytics', 'cgBusy', //angular-busy
'chart.js', 'color.picker', 'ngFileUpload', 'ngFitText', 'ngTagsInput', 'ngResource', 'rzModule', //angularjs-slider
'selectize', 'toaster', 'ui.bootstrap', 'ui.router', 'leaflet-directive', 'vs-repeat']);
module.value('fitTextConfig', {
  config: {
    debounce: _.debounce,
    delay: 100,
    loadDelay: 250,
    min: 13,
    max: 30
  }
}); // Init Google Analytics

(function (i, s, o, g, r, a, m) {
  i['GoogleAnalyticsObject'] = r;
  i[r] = i[r] || function () {
    (i[r].q = i[r].q || []).push(arguments);
  }, i[r].l = 1 * new Date();
  a = s.createElement(o), m = s.getElementsByTagName(o)[0];
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m);
})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

ga('create', GOOGLE_ANALYTICS_KEY, GOOGLE_ANALYTICS_DOMAIN); ////
// Init Facebook

window.fbAsyncInit = function () {
  FB.init({
    appId: FACEBOOK_APP_ID,
    xfbml: true,
    cookie: true,
    version: FACEBOOK_API_VERSION
  });
};

(function (d, s, id) {
  var js,
      fjs = d.getElementsByTagName(s)[0];

  if (d.getElementById(id)) {
    return;
  }

  js = d.createElement(s);
  js.id = id;
  js.src = '//connect.facebook.net/en_US/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk'); ////
// Init DataDog logging


if (window.DD_LOGS) {
  DD_LOGS.init({
    clientToken: DATADOG_LOGS_CLIENT_TOKEN,
    forwardErrorsToLogs: false,
    sampleRate: 100
  });
  window.remoteLogger = DD_LOGS.logger;

  if (window.location.hostname == 'localhost') {
    // Use console logging for local development
    window.remoteLogger.setHandler('console');
  }
} else {
  console.warn('DD_LOGS not available so remote troubleshooting will be limited. Do you have an ad blocker enabled?');
} ////


/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(535);
module.exports = 'ngSanitize';


/***/ }),
/* 535 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.5.10
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $sanitizeMinErr = angular.$$minErr('$sanitize');
var bind;
var extend;
var forEach;
var isDefined;
var lowercase;
var noop;
var htmlParser;
var htmlSanitizeWriter;

/**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * # ngSanitize
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 *
 * <div doc-module-components="ngSanitize"></div>
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */

/**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   Sanitizes an html string by stripping all potentially dangerous tokens.
 *
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
 *   then serialized back to properly escaped html string. This means that no unsafe input can make
 *   it into the returned string.
 *
 *   The whitelist for URL sanitization of attribute values is configured using the functions
 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
 *   `$compileProvider`}.
 *
 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */


/**
 * @ngdoc provider
 * @name $sanitizeProvider
 * @this
 *
 * @description
 * Creates and configures {@link $sanitize} instance.
 */
function $SanitizeProvider() {
  var svgEnabled = false;

  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
    if (svgEnabled) {
      extend(validElements, svgElements);
    }
    return function(html) {
      var buf = [];
      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
      }));
      return buf.join('');
    };
  }];


  /**
   * @ngdoc method
   * @name $sanitizeProvider#enableSvg
   * @kind function
   *
   * @description
   * Enables a subset of svg to be supported by the sanitizer.
   *
   * <div class="alert alert-warning">
   *   <p>By enabling this setting without taking other precautions, you might expose your
   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
   *   link). Such behavior can then result in phishing incidents.</p>
   *
   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
   *   tags within the sanitized content:</p>
   *
   *   <br>
   *
   *   <pre><code>
   *   .rootOfTheIncludedContent svg {
   *     overflow: hidden !important;
   *   }
   *   </code></pre>
   * </div>
   *
   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
   *    without an argument or self for chaining otherwise.
   */
  this.enableSvg = function(enableSvg) {
    if (isDefined(enableSvg)) {
      svgEnabled = enableSvg;
      return this;
    } else {
      return svgEnabled;
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////
  // Private stuff
  //////////////////////////////////////////////////////////////////////////////////////////////////

  bind = angular.bind;
  extend = angular.extend;
  forEach = angular.forEach;
  isDefined = angular.isDefined;
  lowercase = angular.lowercase;
  noop = angular.noop;

  htmlParser = htmlParserImpl;
  htmlSanitizeWriter = htmlSanitizeWriterImpl;

  // Regular Expressions for parsing tags and attributes
  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
    // Match everything outside of normal chars and " (quote character)
    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;


  // Good source of info about elements and attributes
  // http://dev.w3.org/html5/spec/Overview.html#semantics
  // http://simon.html5.org/html-elements

  // Safe Void Elements - HTML5
  // http://dev.w3.org/html5/spec/Overview.html#void-elements
  var voidElements = toMap('area,br,col,hr,img,wbr');

  // Elements that you can, intentionally, leave open (and which close themselves)
  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
  var optionalEndTagBlockElements = toMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
      optionalEndTagInlineElements = toMap('rp,rt'),
      optionalEndTagElements = extend({},
                                              optionalEndTagInlineElements,
                                              optionalEndTagBlockElements);

  // Safe Block Elements - HTML5
  var blockElements = extend({}, optionalEndTagBlockElements, toMap('address,article,' +
          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));

  // Inline Elements - HTML5
  var inlineElements = extend({}, optionalEndTagInlineElements, toMap('a,abbr,acronym,b,' +
          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));

  // SVG Elements
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
  // They can potentially allow for arbitrary javascript to be executed. See #11290
  var svgElements = toMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
          'radialGradient,rect,stop,svg,switch,text,title,tspan');

  // Blocked Elements (will be stripped)
  var blockedElements = toMap('script,style');

  var validElements = extend({},
                                     voidElements,
                                     blockElements,
                                     inlineElements,
                                     optionalEndTagElements);

  //Attributes that have href and hence need to be sanitized
  var uriAttrs = toMap('background,cite,href,longdesc,src,xlink:href');

  var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
      'valign,value,vspace,width');

  // SVG attributes (without "id" and "name" attributes)
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
  var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);

  var validAttrs = extend({},
                                  uriAttrs,
                                  svgAttrs,
                                  htmlAttrs);

  function toMap(str, lowercaseKeys) {
    var obj = {}, items = str.split(','), i;
    for (i = 0; i < items.length; i++) {
      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
    }
    return obj;
  }

  var inertBodyElement;
  (function(window) {
    var doc;
    if (window.document && window.document.implementation) {
      doc = window.document.implementation.createHTMLDocument('inert');
    } else {
      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
    }
    var docElement = doc.documentElement || doc.getDocumentElement();
    var bodyElements = docElement.getElementsByTagName('body');

    // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
    if (bodyElements.length === 1) {
      inertBodyElement = bodyElements[0];
    } else {
      var html = doc.createElement('html');
      inertBodyElement = doc.createElement('body');
      html.appendChild(inertBodyElement);
      doc.appendChild(html);
    }
  })(window);

  /**
   * @example
   * htmlParser(htmlString, {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * });
   *
   * @param {string} html string
   * @param {object} handler
   */
  function htmlParserImpl(html, handler) {
    if (html === null || html === undefined) {
      html = '';
    } else if (typeof html !== 'string') {
      html = '' + html;
    }
    inertBodyElement.innerHTML = html;

    //mXSS protection
    var mXSSAttempts = 5;
    do {
      if (mXSSAttempts === 0) {
        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
      }
      mXSSAttempts--;

      // strip custom-namespaced attributes on IE<=11
      if (window.document.documentMode) {
        stripCustomNsAttrs(inertBodyElement);
      }
      html = inertBodyElement.innerHTML; //trigger mXSS
      inertBodyElement.innerHTML = html;
    } while (html !== inertBodyElement.innerHTML);

    var node = inertBodyElement.firstChild;
    while (node) {
      switch (node.nodeType) {
        case 1: // ELEMENT_NODE
          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
          break;
        case 3: // TEXT NODE
          handler.chars(node.textContent);
          break;
      }

      var nextNode;
      if (!(nextNode = node.firstChild)) {
      if (node.nodeType === 1) {
          handler.end(node.nodeName.toLowerCase());
        }
        nextNode = node.nextSibling;
        if (!nextNode) {
          while (nextNode == null) {
            node = node.parentNode;
            if (node === inertBodyElement) break;
            nextNode = node.nextSibling;
          if (node.nodeType === 1) {
              handler.end(node.nodeName.toLowerCase());
            }
          }
        }
      }
      node = nextNode;
    }

    while ((node = inertBodyElement.firstChild)) {
      inertBodyElement.removeChild(node);
    }
  }

  function attrToMap(attrs) {
    var map = {};
    for (var i = 0, ii = attrs.length; i < ii; i++) {
      var attr = attrs[i];
      map[attr.name] = attr.value;
    }
    return map;
  }


  /**
   * Escapes all potentially dangerous characters, so that the
   * resulting string can be safely inserted into attribute or
   * element text.
   * @param value
   * @returns {string} escaped text
   */
  function encodeEntities(value) {
    return value.
      replace(/&/g, '&amp;').
      replace(SURROGATE_PAIR_REGEXP, function(value) {
        var hi = value.charCodeAt(0);
        var low = value.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
      }).
      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
        return '&#' + value.charCodeAt(0) + ';';
      }).
      replace(/</g, '&lt;').
      replace(/>/g, '&gt;');
  }

  /**
   * create an HTML/XML writer which writes to buffer
   * @param {Array} buf use buf.join('') to get out sanitized html string
   * @returns {object} in the form of {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * }
   */
  function htmlSanitizeWriterImpl(buf, uriValidator) {
    var ignoreCurrentElement = false;
    var out = bind(buf, buf.push);
    return {
      start: function(tag, attrs) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && blockedElements[tag]) {
          ignoreCurrentElement = tag;
        }
        if (!ignoreCurrentElement && validElements[tag] === true) {
          out('<');
          out(tag);
          forEach(attrs, function(value, key) {
            var lkey = lowercase(key);
            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
            if (validAttrs[lkey] === true &&
              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
              out(' ');
              out(key);
              out('="');
              out(encodeEntities(value));
              out('"');
            }
          });
          out('>');
        }
      },
      end: function(tag) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
          out('</');
          out(tag);
          out('>');
        }
        // eslint-disable-next-line eqeqeq
        if (tag == ignoreCurrentElement) {
          ignoreCurrentElement = false;
        }
      },
      chars: function(chars) {
        if (!ignoreCurrentElement) {
          out(encodeEntities(chars));
        }
      }
    };
  }


  /**
   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
   * to allow any of these custom attributes. This method strips them all.
   *
   * @param node Root element to process
   */
  function stripCustomNsAttrs(node) {
    while (node) {
      if (node.nodeType === window.Node.ELEMENT_NODE) {
        var attrs = node.attributes;
        for (var i = 0, l = attrs.length; i < l; i++) {
          var attrNode = attrs[i];
          var attrName = attrNode.name.toLowerCase();
          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
            node.removeAttributeNode(attrNode);
            i--;
            l--;
          }
        }
      }

      var nextNode = node.firstChild;
      if (nextNode) {
        stripCustomNsAttrs(nextNode);
      }

      node = node.nextSibling;
    }
  }
}

function sanitizeText(chars) {
  var buf = [];
  var writer = htmlSanitizeWriter(buf, noop);
  writer.chars(chars);
  return buf.join('');
}


// define ngSanitize module and register $sanitize service
angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);

/**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
 *
 *    Can be one of:
 *
 *    - `object`: A map of attributes
 *    - `function`: Takes the url as a parameter and returns a map of attributes
 *
 *    If the map of attributes contains a value for `target`, it overrides the value of
 *    the target parameter.
 *
 *
 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
     <file name="index.html">
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <th>Filter</th>
           <th>Source</th>
           <th>Rendered</th>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="linky-custom-attributes">
          <td>linky custom attributes</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="script.js">
       angular.module('linkyExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.snippet =
             'Pretty text with some links:\n' +
             'http://angularjs.org/,\n' +
             'mailto:us@somewhere.org,\n' +
             'another@somewhere.org,\n' +
             'and one more: ftp://127.0.0.1/.';
           $scope.snippetWithSingleURL = 'http://angularjs.org/';
         }]);
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });

       it('should optionally add custom attributes', function() {
        expect(element(by.id('linky-custom-attributes')).
            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
       });
     </file>
   </example>
 */
angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
  var LINKY_URL_REGEXP =
        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
      MAILTO_REGEXP = /^mailto:/i;

  var linkyMinErr = angular.$$minErr('linky');
  var isDefined = angular.isDefined;
  var isFunction = angular.isFunction;
  var isObject = angular.isObject;
  var isString = angular.isString;

  return function(text, target, attributes) {
    if (text == null || text === '') return text;
    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);

    var attributesFn =
      isFunction(attributes) ? attributes :
      isObject(attributes) ? function getAttributesObject() {return attributes;} :
      function getEmptyAttributesObject() {return {};};

    var match;
    var raw = text;
    var html = [];
    var url;
    var i;
    while ((match = raw.match(LINKY_URL_REGEXP))) {
      // We can not end in these as they are sometimes found at the end of the sentence
      url = match[0];
      // if we did not match ftp/http/www/mailto then assume mailto
      if (!match[2] && !match[4]) {
        url = (match[3] ? 'http://' : 'mailto:') + url;
      }
      i = match.index;
      addText(raw.substr(0, i));
      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
      raw = raw.substring(i + match[0].length);
    }
    addText(raw);
    return $sanitize(html.join(''));

    function addText(text) {
      if (!text) {
        return;
      }
      html.push(sanitizeText(text));
    }

    function addLink(url, text) {
      var key, linkAttributes = attributesFn(url);
      html.push('<a ');

      for (key in linkAttributes) {
        html.push(key + '="' + linkAttributes[key] + '" ');
      }

      if (isDefined(target) && !('target' in linkAttributes)) {
        html.push('target="',
                  target,
                  '" ');
      }
      html.push('href="',
                url.replace(/"/g, '&quot;'),
                '">');
      addText(text);
      html.push('</a>');
    }
  };
}]);


})(window, window.angular);


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory(require('angular'));
    } else {
        root.angularClipboard = factory(root.angular);
  }
}(this, function (angular) {

return angular.module('angular-clipboard', [])
    .factory('clipboard', ['$document', '$window', function ($document, $window) {
        function createNode(text, context) {
            var node = $document[0].createElement('textarea');
            node.style.position = 'absolute';
            node.style.fontSize = '12pt';
            node.style.border = '0';
            node.style.padding = '0';
            node.style.margin = '0';
            node.style.left = '-10000px';
            node.style.top = ($window.pageYOffset || $document[0].documentElement.scrollTop) + 'px';
            node.textContent = text;
            return node;
        }

        function copyNode(node) {
            try {
                // Set inline style to override css styles
                $document[0].body.style.webkitUserSelect = 'initial';

                var selection = $document[0].getSelection();
                selection.removeAllRanges();

                var range = document.createRange();
                range.selectNodeContents(node);
                selection.addRange(range);
                // This makes it work in all desktop browsers (Chrome)
                node.select();
                // This makes it work on Mobile Safari
                node.setSelectionRange(0, 999999);

                try {
                    if(!$document[0].execCommand('copy')) {
                        throw('failure copy');
                    }
                } finally {
                    selection.removeAllRanges();
                }
            } finally {
                // Reset inline style
                $document[0].body.style.webkitUserSelect = '';
            }
        }

        function copyText(text, context) {
            var left = $window.pageXOffset || $document[0].documentElement.scrollLeft;
            var top = $window.pageYOffset || $document[0].documentElement.scrollTop;
            
            var node = createNode(text, context);
            $document[0].body.appendChild(node);
            copyNode(node);

            $window.scrollTo(left, top);
            $document[0].body.removeChild(node);
        }

        return {
            copyText: copyText,
            supported: 'queryCommandSupported' in $document[0] && $document[0].queryCommandSupported('copy')
        };
    }])
    .directive('clipboard', ['clipboard', function (clipboard) {
        return {
            restrict: 'A',
            scope: {
                onCopied: '&',
                onError: '&',
                text: '=',
                supported: '=?'
            },
            link: function (scope, element) {
                scope.supported = clipboard.supported;

                element.on('click', function (event) {
                    try {
                        clipboard.copyText(scope.text, element[0]);
                        if (angular.isFunction(scope.onCopied)) {
                            scope.$evalAsync(scope.onCopied());
                        }
                    } catch (err) {
                        if (angular.isFunction(scope.onError)) {
                            scope.$evalAsync(scope.onError({err: err}));
                        }
                    }
                });
            }
        };
    }]);

}));


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(538);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/index.js!./rzslider.min.css", function() {
			var newContent = require("!!../../css-loader/index.js!../../postcss-loader/index.js!./rzslider.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "/*! angularjs-slider - v2.11.0 -  (c) Rafal Zajac <rzajac@gmail.com>, Valentin Hervieu <valentin@hervieu.me>, Jussi Saarivirta <jusasi@gmail.com>, Angelin Sirbu <angelin.sirbu@gmail.com> -  https://github.com/angular-slider/angularjs-slider -  2016-04-01 */\nrzslider{position:relative;display:inline-block;width:100%;height:4px;margin:35px 0 15px 0;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}rzslider[disabled]{cursor:not-allowed}rzslider[disabled] .rz-pointer{cursor:not-allowed;background-color:#d8e0f3}rzslider span{position:absolute;display:inline-block;white-space:nowrap}rzslider .rz-base{width:100%;height:100%;padding:0}rzslider .rz-bar-wrapper{left:0;z-index:1;width:100%;height:32px;padding-top:16px;margin-top:-16px;box-sizing:border-box}rzslider .rz-bar-wrapper.rz-draggable{cursor:move}rzslider .rz-bar{left:0;z-index:1;width:100%;height:4px;background:#d8e0f3;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px}rzslider .rz-bar.rz-selection{z-index:2;background:#0db9f0;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px}rzslider .rz-pointer{top:-14px;z-index:3;width:32px;height:32px;cursor:pointer;background-color:#0db9f0;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px}rzslider .rz-pointer:after{position:absolute;top:12px;left:12px;width:8px;height:8px;background:#fff;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;content:''}rzslider .rz-pointer:hover:after{background-color:#fff}rzslider .rz-pointer.rz-active{z-index:4}rzslider .rz-pointer.rz-active:after{background-color:#451aff}rzslider .rz-bubble{bottom:16px;padding:1px 3px;color:#55637d;cursor:default}rzslider .rz-bubble.rz-selection{top:16px}rzslider .rz-bubble.rz-limit{color:#55637d}rzslider .rz-ticks{position:absolute;top:-3px;left:0;z-index:1;display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;height:0;padding:0 11px;margin:0;list-style:none;box-sizing:border-box;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}rzslider .rz-ticks .rz-tick{width:10px;height:10px;text-align:center;cursor:pointer;background:#d8e0f3;border-radius:50%}rzslider .rz-ticks .rz-tick.rz-selected{background:#0db9f0}rzslider .rz-ticks .rz-tick .rz-tick-value{position:absolute;top:-30px;transform:translate(-50%,0)}rzslider.rz-vertical{position:relative;width:4px;height:100%;padding:0;margin:0 20px;vertical-align:baseline}rzslider.rz-vertical .rz-base{width:100%;height:100%;padding:0}rzslider.rz-vertical .rz-bar-wrapper{top:auto;left:0;width:32px;height:100%;padding:0 0 0 16px;margin:0 0 0 -16px}rzslider.rz-vertical .rz-bar{bottom:0;left:auto;width:4px;height:100%}rzslider.rz-vertical .rz-pointer{top:auto;bottom:0;left:-14px!important}rzslider.rz-vertical .rz-bubble{bottom:0;left:16px!important;margin-left:3px}rzslider.rz-vertical .rz-bubble.rz-selection{top:auto;left:16px!important}rzslider.rz-vertical .rz-ticks{top:0;left:-3px;z-index:1;width:0;height:100%;padding:11px 0;-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}rzslider.rz-vertical .rz-ticks .rz-tick{vertical-align:middle}rzslider.rz-vertical .rz-ticks .rz-tick .rz-tick-value{top:auto;left:22px;transform:translate(0,-28%)}", ""]);

// exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(540);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./angular-busy.min.css", function() {
			var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./angular-busy.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".cg-busy{position:absolute;top:0;left:0;right:0;bottom:0;z-index:1001}.cg-busy-animation.ng-hide-add,.cg-busy-animation.ng-hide-remove{-webkit-transition:all .3s ease;-moz-transition:all .3s ease;-o-transition:all .3s ease;transition:all .3s ease;display:block!important}.cg-busy-animation.ng-hide-remove{opacity:0;-webkit-transform:translate(0px,-40px);-moz-transform:translate(0px,-40px);-ms-transform:translate(0px,-40px);-o-transform:translate(0px,-40px);transform:translate(0px,-40px)}.cg-busy-animation.ng-hide-add,.cg-busy-animation.ng-hide-remove.ng-hide-remove-active{opacity:1;-webkit-transform:translate(0px,0);-moz-transform:translate(0px,0);-ms-transform:translate(0px,0);-o-transform:translate(0px,0);transform:translate(0px,0)}.cg-busy-animation.ng-hide-add.ng-hide-add-active{opacity:0;-webkit-transform:translate(0px,-40px);-moz-transform:translate(0px,-40px);-ms-transform:translate(0px,-40px);-o-transform:translate(0px,-40px);transform:translate(0px,-40px)}.cg-busy-backdrop{background-color:#fff;opacity:.7}.cg-busy-backdrop-animation.ng-hide-add,.cg-busy-backdrop-animation.ng-hide-remove{-webkit-transition:opacity .3s ease;-moz-transition:opacity .3s ease;-o-transition:opacity .3s ease;transition:opacity .3s ease;display:block!important}.cg-busy-backdrop-animation.ng-hide{opacity:0}.cg-busy-default-wrapper{text-align:center}.cg-busy-default-sign{display:inline-block;position:relative;z-index:1002;padding-bottom:6px;color:#333;text-shadow:0 1px 1px rgba(255,255,255,.75);background-color:#e9eeee;border:1px solid #ddd;border-top-width:0;-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px;border-top-left-radius:0;border-top-right-radius:0;-webkit-box-shadow:inset 0 1px 0 rgba(255,255,255,.2),0 1px 2px rgba(0,0,0,.05);-moz-box-shadow:inset 0 1px 0 rgba(255,255,255,.2),0 1px 2px rgba(0,0,0,.05);box-shadow:inset 0 1px 0 rgba(255,255,255,.2),0 1px 2px rgba(0,0,0,.05)}.cg-busy-default-text{margin:13px 12px 6px 49px;font-size:16px;color:#555;text-align:left;max-width:400px}.cg-busy-default-spinner{position:absolute;width:25px;height:25px;display:inline-block;top:12px;left:14px}.cg-busy-default-spinner div{width:12%;height:26%;background:#000;position:absolute;left:44.5%;top:37%;opacity:0;-webkit-animation:cg-busy-spinner-anim 1s linear infinite;-moz-animation:cg-busy-spinner-anim 1s linear infinite;-ms-animation:cg-busy-spinner-anim 1s linear infinite;-o-animation:cg-busy-spinner-anim 1s linear infinite;animation:cg-busy-spinner-anim 1s linear infinite;-webkit-border-radius:50px;-moz-border-radius:50px;border-radius:50px;-webkit-box-shadow:0 0 3px rgba(0,0,0,.2);-moz-box-shadow:0 0 3px rgba(0,0,0,.2);box-shadow:0 0 3px rgba(0,0,0,.2)}.cg-busy-default-spinner div.bar1{-webkit-transform:rotate(0deg) translate(0,-142%);-moz-transform:rotate(0deg) translate(0,-142%);-ms-transform:rotate(0deg) translate(0,-142%);-o-transform:rotate(0deg) translate(0,-142%);transform:rotate(0deg) translate(0,-142%);-webkit-animation-delay:0s;-moz-animation-delay:0s;-ms-animation-delay:0s;-o-animation-delay:0s;animation-delay:0s}.cg-busy-default-spinner div.bar2{-webkit-transform:rotate(30deg) translate(0,-142%);-moz-transform:rotate(30deg) translate(0,-142%);-ms-transform:rotate(30deg) translate(0,-142%);-o-transform:rotate(30deg) translate(0,-142%);transform:rotate(30deg) translate(0,-142%);-webkit-animation-delay:-.9167s;-moz-animation-delay:-.9167s;-ms-animation-delay:-.9167s;-o-animation-delay:-.9167s;animation-delay:-.9167s}.cg-busy-default-spinner div.bar3{-webkit-transform:rotate(60deg) translate(0,-142%);-moz-transform:rotate(60deg) translate(0,-142%);-ms-transform:rotate(60deg) translate(0,-142%);-o-transform:rotate(60deg) translate(0,-142%);transform:rotate(60deg) translate(0,-142%);-webkit-animation-delay:-.833s;-moz-animation-delay:-.833s;-ms-animation-delay:-.833s;-o-animation-delay:-.833s;animation-delay:-.833s}.cg-busy-default-spinner div.bar4{-webkit-transform:rotate(90deg) translate(0,-142%);-moz-transform:rotate(90deg) translate(0,-142%);-ms-transform:rotate(90deg) translate(0,-142%);-o-transform:rotate(90deg) translate(0,-142%);transform:rotate(90deg) translate(0,-142%);-webkit-animation-delay:-.75s;-moz-animation-delay:-.75s;-ms-animation-delay:-.75s;-o-animation-delay:-.75s;animation-delay:-.75s}.cg-busy-default-spinner div.bar5{-webkit-transform:rotate(120deg) translate(0,-142%);-moz-transform:rotate(120deg) translate(0,-142%);-ms-transform:rotate(120deg) translate(0,-142%);-o-transform:rotate(120deg) translate(0,-142%);transform:rotate(120deg) translate(0,-142%);-webkit-animation-delay:-.667s;-moz-animation-delay:-.667s;-ms-animation-delay:-.667s;-o-animation-delay:-.667s;animation-delay:-.667s}.cg-busy-default-spinner div.bar6{-webkit-transform:rotate(150deg) translate(0,-142%);-moz-transform:rotate(150deg) translate(0,-142%);-ms-transform:rotate(150deg) translate(0,-142%);-o-transform:rotate(150deg) translate(0,-142%);transform:rotate(150deg) translate(0,-142%);-webkit-animation-delay:-.5833s;-moz-animation-delay:-.5833s;-ms-animation-delay:-.5833s;-o-animation-delay:-.5833s;animation-delay:-.5833s}.cg-busy-default-spinner div.bar7{-webkit-transform:rotate(180deg) translate(0,-142%);-moz-transform:rotate(180deg) translate(0,-142%);-ms-transform:rotate(180deg) translate(0,-142%);-o-transform:rotate(180deg) translate(0,-142%);transform:rotate(180deg) translate(0,-142%);-webkit-animation-delay:-.5s;-moz-animation-delay:-.5s;-ms-animation-delay:-.5s;-o-animation-delay:-.5s;animation-delay:-.5s}.cg-busy-default-spinner div.bar8{-webkit-transform:rotate(210deg) translate(0,-142%);-moz-transform:rotate(210deg) translate(0,-142%);-ms-transform:rotate(210deg) translate(0,-142%);-o-transform:rotate(210deg) translate(0,-142%);transform:rotate(210deg) translate(0,-142%);-webkit-animation-delay:-.41667s;-moz-animation-delay:-.41667s;-ms-animation-delay:-.41667s;-o-animation-delay:-.41667s;animation-delay:-.41667s}.cg-busy-default-spinner div.bar9{-webkit-transform:rotate(240deg) translate(0,-142%);-moz-transform:rotate(240deg) translate(0,-142%);-ms-transform:rotate(240deg) translate(0,-142%);-o-transform:rotate(240deg) translate(0,-142%);transform:rotate(240deg) translate(0,-142%);-webkit-animation-delay:-.333s;-moz-animation-delay:-.333s;-ms-animation-delay:-.333s;-o-animation-delay:-.333s;animation-delay:-.333s}.cg-busy-default-spinner div.bar10{-webkit-transform:rotate(270deg) translate(0,-142%);-moz-transform:rotate(270deg) translate(0,-142%);-ms-transform:rotate(270deg) translate(0,-142%);-o-transform:rotate(270deg) translate(0,-142%);transform:rotate(270deg) translate(0,-142%);-webkit-animation-delay:-.25s;-moz-animation-delay:-.25s;-ms-animation-delay:-.25s;-o-animation-delay:-.25s;animation-delay:-.25s}.cg-busy-default-spinner div.bar11{-webkit-transform:rotate(300deg) translate(0,-142%);-moz-transform:rotate(300deg) translate(0,-142%);-ms-transform:rotate(300deg) translate(0,-142%);-o-transform:rotate(300deg) translate(0,-142%);transform:rotate(300deg) translate(0,-142%);-webkit-animation-delay:-.1667s;-moz-animation-delay:-.1667s;-ms-animation-delay:-.1667s;-o-animation-delay:-.1667s;animation-delay:-.1667s}.cg-busy-default-spinner div.bar12{-webkit-transform:rotate(330deg) translate(0,-142%);-moz-transform:rotate(330deg) translate(0,-142%);-ms-transform:rotate(330deg) translate(0,-142%);-o-transform:rotate(330deg) translate(0,-142%);transform:rotate(330deg) translate(0,-142%);-webkit-animation-delay:-.0833s;-moz-animation-delay:-.0833s;-ms-animation-delay:-.0833s;-o-animation-delay:-.0833s;animation-delay:-.0833s}@-webkit-keyframes cg-busy-spinner-anim{from{opacity:1}to{opacity:.25}}@-moz-keyframes cg-busy-spinner-anim{from{opacity:1}to{opacity:.25}}@keyframes cg-busy-spinner-anim{from{opacity:1}to{opacity:.25}}", ""]);

// exports


/***/ }),
/* 541 */
/***/ (function(module, exports) {

angular.module("cgBusy",[]),angular.module("cgBusy").factory("_cgBusyTrackerFactory",["$timeout","$q",function(a,b){return function(){var c={};c.promises=[],c.delayPromise=null,c.durationPromise=null,c.delayJustFinished=!1,c.reset=function(b){c.minDuration=b.minDuration,c.promises=[],angular.forEach(b.promises,function(a){a&&!a.$cgBusyFulfilled&&d(a)}),0!==c.promises.length&&(c.delayJustFinished=!1,b.delay&&(c.delayPromise=a(function(){c.delayPromise=null,c.delayJustFinished=!0},parseInt(b.delay,10))),b.minDuration&&(c.durationPromise=a(function(){c.durationPromise=null},parseInt(b.minDuration,10)+(b.delay?parseInt(b.delay,10):0))))},c.isPromise=function(a){var b=a&&(a.then||a.$then||a.$promise&&a.$promise.then);return"undefined"!=typeof b},c.callThen=function(a,c,d){var e;a.then||a.$then?e=a:a.$promise?e=a.$promise:a.denodeify&&(e=b.when(a));var f=e.then||e.$then;f.call(e,c,d)};var d=function(a){if(!c.isPromise(a))throw new Error("cgBusy expects a promise (or something that has a .promise or .$promise");-1===c.promises.indexOf(a)&&(c.promises.push(a),c.callThen(a,function(){a.$cgBusyFulfilled=!0,-1!==c.promises.indexOf(a)&&c.promises.splice(c.promises.indexOf(a),1)},function(){a.$cgBusyFulfilled=!0,-1!==c.promises.indexOf(a)&&c.promises.splice(c.promises.indexOf(a),1)}))};return c.active=function(){return c.delayPromise?!1:c.delayJustFinished?(c.delayJustFinished=!1,0===c.promises.length&&(c.durationPromise=null),c.promises.length>0):c.durationPromise?!0:c.promises.length>0},c}}]),angular.module("cgBusy").value("cgBusyDefaults",{}),angular.module("cgBusy").directive("cgBusy",["$compile","$templateCache","cgBusyDefaults","$http","_cgBusyTrackerFactory",function(a,b,c,d,e){return{restrict:"A",link:function(f,g,h){var i=g.css("position");("static"===i||""===i||"undefined"==typeof i)&&g.css("position","relative");var j,k,l,m,n,o=e(),p={templateUrl:"angular-busy.html",delay:0,minDuration:0,backdrop:!0,message:"Please Wait...",wrapperClass:"cg-busy cg-busy-animation"};angular.extend(p,c),f.$watchCollection(h.cgBusy,function(c){if(c||(c={promise:null}),angular.isString(c))throw new Error("Invalid value for cg-busy. cgBusy no longer accepts string ids to represent promises/trackers.");(angular.isArray(c)||o.isPromise(c))&&(c={promise:c}),c=angular.extend(angular.copy(p),c),c.templateUrl||(c.templateUrl=p.templateUrl),angular.isArray(c.promise)||(c.promise=[c.promise]),m||(m=f.$new()),m.$message=c.message,angular.equals(o.promises,c.promise)||o.reset({promises:c.promise,delay:c.delay,minDuration:c.minDuration}),m.$cgBusyIsActive=function(){return o.active()},j&&l===c.templateUrl&&n===c.backdrop||(j&&j.remove(),k&&k.remove(),l=c.templateUrl,n=c.backdrop,d.get(l,{cache:b}).then(function(b){if(c.backdrop="undefined"==typeof c.backdrop?!0:c.backdrop,c.backdrop){var d='<div class="cg-busy cg-busy-backdrop cg-busy-backdrop-animation ng-hide" ng-show="$cgBusyIsActive()"></div>';k=a(d)(m),g.append(k)}var e='<div class="'+c.wrapperClass+' ng-hide" ng-show="$cgBusyIsActive()">'+b.data+"</div>";j=a(e)(m),angular.element(j.children()[0]).css("position","absolute").css("top",0).css("left",0).css("right",0).css("bottom",0),g.append(j)},function(a){throw new Error("Template specified for cgBusy ("+c.templateUrl+") could not be loaded. "+a)}))},!0)}}}]),angular.module("cgBusy").run(["$templateCache",function(a){"use strict";a.put("angular-busy.html",'<div class="cg-busy-default-wrapper">\n\n   <div class="cg-busy-default-sign">\n\n      <div class="cg-busy-default-spinner">\n         <div class="bar1"></div>\n         <div class="bar2"></div>\n         <div class="bar3"></div>\n         <div class="bar4"></div>\n         <div class="bar5"></div>\n         <div class="bar6"></div>\n         <div class="bar7"></div>\n         <div class="bar8"></div>\n         <div class="bar9"></div>\n         <div class="bar10"></div>\n         <div class="bar11"></div>\n         <div class="bar12"></div>\n      </div>\n\n      <div class="cg-busy-default-text">{{$message}}</div>\n\n   </div>\n\n</div>')}]);

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(543);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./selectize.default.css", function() {
			var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./selectize.default.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "/**\n * selectize.default.css (v0.12.6) - Default Theme\n * Copyright (c) 2013–2015 Brian Reavis & contributors\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\"); you may not use this\n * file except in compliance with the License. You may obtain a copy of the License at:\n * http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software distributed under\n * the License is distributed on an \"AS IS\" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF\n * ANY KIND, either express or implied. See the License for the specific language\n * governing permissions and limitations under the License.\n *\n * @author Brian Reavis <brian@thirdroute.com>\n */\n.selectize-control.plugin-drag_drop.multi > .selectize-input > div.ui-sortable-placeholder {\n  visibility: visible !important;\n  background: #f2f2f2 !important;\n  background: rgba(0, 0, 0, 0.06) !important;\n  border: 0 none !important;\n  -webkit-box-shadow: inset 0 0 12px 4px #fff;\n  box-shadow: inset 0 0 12px 4px #fff;\n}\n.selectize-control.plugin-drag_drop .ui-sortable-placeholder::after {\n  content: '!';\n  visibility: hidden;\n}\n.selectize-control.plugin-drag_drop .ui-sortable-helper {\n  -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n.selectize-dropdown-header {\n  position: relative;\n  padding: 5px 8px;\n  border-bottom: 1px solid #d0d0d0;\n  background: #f8f8f8;\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n.selectize-dropdown-header-close {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  color: #303030;\n  opacity: 0.4;\n  margin-top: -12px;\n  line-height: 20px;\n  font-size: 20px !important;\n}\n.selectize-dropdown-header-close:hover {\n  color: #000000;\n}\n.selectize-dropdown.plugin-optgroup_columns .optgroup {\n  border-right: 1px solid #f2f2f2;\n  border-top: 0 none;\n  float: left;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.selectize-dropdown.plugin-optgroup_columns .optgroup:last-child {\n  border-right: 0 none;\n}\n.selectize-dropdown.plugin-optgroup_columns .optgroup:before {\n  display: none;\n}\n.selectize-dropdown.plugin-optgroup_columns .optgroup-header {\n  border-top: 0 none;\n}\n.selectize-control.plugin-remove_button [data-value] {\n  position: relative;\n  padding-right: 24px !important;\n}\n.selectize-control.plugin-remove_button [data-value] .remove {\n  z-index: 1;\n  /* fixes ie bug (see #392) */\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 17px;\n  text-align: center;\n  font-weight: bold;\n  font-size: 12px;\n  color: inherit;\n  text-decoration: none;\n  vertical-align: middle;\n  display: inline-block;\n  padding: 2px 0 0 0;\n  border-left: 1px solid #0073bb;\n  -webkit-border-radius: 0 2px 2px 0;\n  -moz-border-radius: 0 2px 2px 0;\n  border-radius: 0 2px 2px 0;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.selectize-control.plugin-remove_button [data-value] .remove:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n.selectize-control.plugin-remove_button [data-value].active .remove {\n  border-left-color: #00578d;\n}\n.selectize-control.plugin-remove_button .disabled [data-value] .remove:hover {\n  background: none;\n}\n.selectize-control.plugin-remove_button .disabled [data-value] .remove {\n  border-left-color: #aaaaaa;\n}\n.selectize-control.plugin-remove_button .remove-single {\n  position: absolute;\n  right: 0;\n  top: 0;\n  font-size: 23px;\n}\n.selectize-control {\n  position: relative;\n}\n.selectize-dropdown,\n.selectize-input,\n.selectize-input input {\n  color: #303030;\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 18px;\n  -webkit-font-smoothing: inherit;\n}\n.selectize-input,\n.selectize-control.single .selectize-input.input-active {\n  background: #fff;\n  cursor: text;\n  display: inline-block;\n}\n.selectize-input {\n  border: 1px solid #d0d0d0;\n  padding: 8px 8px;\n  display: inline-block;\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.1);\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  border-radius: 3px;\n}\n.selectize-control.multi .selectize-input.has-items {\n  padding: 5px 8px 2px;\n}\n.selectize-input.full {\n  background-color: #fff;\n}\n.selectize-input.disabled,\n.selectize-input.disabled * {\n  cursor: default !important;\n}\n.selectize-input.focus {\n  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);\n}\n.selectize-input.dropdown-active {\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n.selectize-input > * {\n  vertical-align: baseline;\n  display: -moz-inline-stack;\n  display: inline-block;\n  zoom: 1;\n  *display: inline;\n}\n.selectize-control.multi .selectize-input > div {\n  cursor: pointer;\n  margin: 0 3px 3px 0;\n  padding: 2px 6px;\n  background: #1da7ee;\n  color: #fff;\n  border: 1px solid #0073bb;\n}\n.selectize-control.multi .selectize-input > div.active {\n  background: #92c836;\n  color: #fff;\n  border: 1px solid #00578d;\n}\n.selectize-control.multi .selectize-input.disabled > div,\n.selectize-control.multi .selectize-input.disabled > div.active {\n  color: #ffffff;\n  background: #d2d2d2;\n  border: 1px solid #aaaaaa;\n}\n.selectize-input > input {\n  display: inline-block !important;\n  padding: 0 !important;\n  min-height: 0 !important;\n  max-height: none !important;\n  max-width: 100% !important;\n  margin: 0 1px !important;\n  text-indent: 0 !important;\n  border: 0 none !important;\n  background: none !important;\n  line-height: inherit !important;\n  -webkit-user-select: auto !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n.selectize-input > input::-ms-clear {\n  display: none;\n}\n.selectize-input > input:focus {\n  outline: none !important;\n}\n.selectize-input::after {\n  content: ' ';\n  display: block;\n  clear: left;\n}\n.selectize-input.dropdown-active::before {\n  content: ' ';\n  display: block;\n  position: absolute;\n  background: #f0f0f0;\n  height: 1px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.selectize-dropdown {\n  position: absolute;\n  z-index: 10;\n  border: 1px solid #d0d0d0;\n  background: #fff;\n  margin: -1px 0 0 0;\n  border-top: 0 none;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  -webkit-border-radius: 0 0 3px 3px;\n  -moz-border-radius: 0 0 3px 3px;\n  border-radius: 0 0 3px 3px;\n}\n.selectize-dropdown [data-selectable] {\n  cursor: pointer;\n  overflow: hidden;\n}\n.selectize-dropdown [data-selectable] .highlight {\n  background: rgba(125, 168, 208, 0.2);\n  -webkit-border-radius: 1px;\n  -moz-border-radius: 1px;\n  border-radius: 1px;\n}\n.selectize-dropdown .option,\n.selectize-dropdown .optgroup-header {\n  padding: 5px 8px;\n}\n.selectize-dropdown .option,\n.selectize-dropdown [data-disabled],\n.selectize-dropdown [data-disabled] [data-selectable].option {\n  cursor: inherit;\n  opacity: 0.5;\n}\n.selectize-dropdown [data-selectable].option {\n  opacity: 1;\n}\n.selectize-dropdown .optgroup:first-child .optgroup-header {\n  border-top: 0 none;\n}\n.selectize-dropdown .optgroup-header {\n  color: #303030;\n  background: #fff;\n  cursor: default;\n}\n.selectize-dropdown .active {\n  background-color: #f5fafd;\n  color: #495c68;\n}\n.selectize-dropdown .active.create {\n  color: #495c68;\n}\n.selectize-dropdown .create {\n  color: rgba(48, 48, 48, 0.5);\n}\n.selectize-dropdown-content {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 200px;\n  -webkit-overflow-scrolling: touch;\n}\n.selectize-control.single .selectize-input,\n.selectize-control.single .selectize-input input {\n  cursor: pointer;\n}\n.selectize-control.single .selectize-input.input-active,\n.selectize-control.single .selectize-input.input-active input {\n  cursor: text;\n}\n.selectize-control.single .selectize-input:after {\n  content: ' ';\n  display: block;\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  margin-top: -3px;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 5px 5px 0 5px;\n  border-color: #808080 transparent transparent transparent;\n}\n.selectize-control.single .selectize-input.dropdown-active:after {\n  margin-top: -4px;\n  border-width: 0 5px 5px 5px;\n  border-color: transparent transparent #808080 transparent;\n}\n.selectize-control.rtl.single .selectize-input:after {\n  left: 15px;\n  right: auto;\n}\n.selectize-control.rtl .selectize-input > input {\n  margin: 0 4px 0 -2px !important;\n}\n.selectize-control .selectize-input.disabled {\n  opacity: 0.5;\n  background-color: #fafafa;\n}\n.selectize-control.multi .selectize-input.has-items {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.selectize-control.multi .selectize-input.disabled [data-value] {\n  color: #999;\n  text-shadow: none;\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.selectize-control.multi .selectize-input.disabled [data-value],\n.selectize-control.multi .selectize-input.disabled [data-value] .remove {\n  border-color: #e6e6e6;\n}\n.selectize-control.multi .selectize-input.disabled [data-value] .remove {\n  background: none;\n}\n.selectize-control.multi .selectize-input [data-value] {\n  text-shadow: 0 1px 0 rgba(0, 51, 83, 0.3);\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  border-radius: 3px;\n  background-color: #1b9dec;\n  background-image: -moz-linear-gradient(top, #1da7ee, #178ee9);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#1da7ee), to(#178ee9));\n  background-image: -webkit-linear-gradient(top, #1da7ee, #178ee9);\n  background-image: -o-linear-gradient(top, #1da7ee, #178ee9);\n  background-image: linear-gradient(to bottom, #1da7ee, #178ee9);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff1da7ee', endColorstr='#ff178ee9', GradientType=0);\n  -webkit-box-shadow: 0 1px 0 rgba(0,0,0,0.2),inset 0 1px rgba(255,255,255,0.03);\n  box-shadow: 0 1px 0 rgba(0,0,0,0.2),inset 0 1px rgba(255,255,255,0.03);\n}\n.selectize-control.multi .selectize-input [data-value].active {\n  background-color: #0085d4;\n  background-image: -moz-linear-gradient(top, #008fd8, #0075cf);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#008fd8), to(#0075cf));\n  background-image: -webkit-linear-gradient(top, #008fd8, #0075cf);\n  background-image: -o-linear-gradient(top, #008fd8, #0075cf);\n  background-image: linear-gradient(to bottom, #008fd8, #0075cf);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff008fd8', endColorstr='#ff0075cf', GradientType=0);\n}\n.selectize-control.single .selectize-input {\n  -webkit-box-shadow: 0 1px 0 rgba(0,0,0,0.05), inset 0 1px 0 rgba(255,255,255,0.8);\n  box-shadow: 0 1px 0 rgba(0,0,0,0.05), inset 0 1px 0 rgba(255,255,255,0.8);\n  background-color: #f9f9f9;\n  background-image: -moz-linear-gradient(top, #fefefe, #f2f2f2);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#fefefe), to(#f2f2f2));\n  background-image: -webkit-linear-gradient(top, #fefefe, #f2f2f2);\n  background-image: -o-linear-gradient(top, #fefefe, #f2f2f2);\n  background-image: linear-gradient(to bottom, #fefefe, #f2f2f2);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffefefe', endColorstr='#fff2f2f2', GradientType=0);\n}\n.selectize-control.single .selectize-input,\n.selectize-dropdown.single {\n  border-color: #b8b8b8;\n}\n.selectize-dropdown .optgroup-header {\n  padding-top: 7px;\n  font-weight: bold;\n  font-size: 0.85em;\n}\n.selectize-dropdown .optgroup {\n  border-top: 1px solid #f0f0f0;\n}\n.selectize-dropdown .optgroup:first-child {\n  border-top: 0 none;\n}\n", ""]);

// exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Selectize"] = __webpack_require__(179);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 545 */
/***/ (function(module, exports) {

/**
 * Angular Selectize2
 * https://github.com/machineboy2045/angular-selectize
 **/

angular.module('selectize', []).value('selectizeConfig', {}).directive("selectize", ['selectizeConfig', function(selectizeConfig) {
  return {
    restrict: 'EA',
    require: '^ngModel',
    scope: { ngModel: '=', config: '=?', options: '=?', ngDisabled: '=', ngRequired: '&' },
    link: function(scope, element, attrs, modelCtrl) {

      var selectize,
          settings = angular.extend({}, Selectize.defaults, selectizeConfig, scope.config);

      scope.options = scope.options || [];
      scope.config = scope.config || {};

      var isEmpty = function(val) {
        return val === undefined || val === null || !val.length; //support checking empty arrays
      };

      var toggle = function(disabled) {
        disabled ? selectize.disable() : selectize.enable();
      }

      var validate = function() {
        var isInvalid = (scope.ngRequired() || attrs.required || settings.required) && isEmpty(scope.ngModel);
        modelCtrl.$setValidity('required', !isInvalid);
      };

      var setSelectizeOptions = function(curr, prev) {
        angular.forEach(prev, function(opt){
          if(curr.indexOf(opt) === -1){
            var value = opt[settings.valueField];
            selectize.removeOption(value, true);
          }
        });

        selectize.addOption(curr, true);

        setSelectizeValue();
      }

      var setSelectizeValue = function() {
        validate();

        selectize.$control.toggleClass('ng-valid', modelCtrl.$valid);
        selectize.$control.toggleClass('ng-invalid', modelCtrl.$invalid);
        selectize.$control.toggleClass('ng-dirty', modelCtrl.$dirty);
        selectize.$control.toggleClass('ng-pristine', modelCtrl.$pristine);

        if (!angular.equals(selectize.items, scope.ngModel)) {
          selectize.setValue(scope.ngModel, true);
        }
      }

      settings.onChange = function(value) {
        var value = angular.copy(selectize.items);
        if (settings.maxItems == 1) {
          value = value[0]
        }
        modelCtrl.$setViewValue( value );

        if (scope.config.onChange) {
          scope.config.onChange.apply(this, arguments);
        }
      };

      settings.onOptionAdd = function(value, data) {
        if( scope.options.indexOf(data) === -1 ) {
          scope.options.push(data);

          if (scope.config.onOptionAdd) {
            scope.config.onOptionAdd.apply(this, arguments);
          }
        }
      };

      settings.onInitialize = function() {
        selectize = element[0].selectize;

        setSelectizeOptions(scope.options);

        //provides a way to access the selectize element from an
        //angular controller
        if (scope.config.onInitialize) {
          scope.config.onInitialize(selectize);
        }

        scope.$watchCollection('options', setSelectizeOptions);
        scope.$watch('ngModel', setSelectizeValue);
        scope.$watch('ngDisabled', toggle);
      };

      element.selectize(settings);

      element.on('$destroy', function() {
        if (selectize) {
          selectize.destroy();
          element = null;
        }
      });
    }
  };
}]);


/***/ }),
/* 546 */
/***/ (function(module, exports) {

!function(t,e,i,n){"use strict";i.module("ngFitText",[]).value("fitTextDefaultConfig",{debounce:!1,delay:250,loadDelay:10,compressor:1,min:0,max:Number.POSITIVE_INFINITY}).directive("fittext",["$timeout","fitTextDefaultConfig","fitTextConfig",function(e,n,o){return{restrict:"A",scope:!0,link:function(f,a,l){function r(){var t=T*h/s.offsetWidth/h;return Math.max(Math.min((c[0].offsetWidth-6)*t*p,parseFloat(y)),parseFloat(m))}function u(){s.offsetHeight*s.offsetWidth!==0&&(d.fontSize=T+"px",d.lineHeight="1",d.display="inline-block",d.fontSize=r()+"px",d.lineHeight=b,d.display=v)}i.extend(n,o.config);var c=a.parent(),s=a[0],d=s.style,x=t.getComputedStyle(a[0],null),h=a.children().length||1,g=l.fittextLoadDelay||n.loadDelay,p=l.fittext||n.compressor,m=("inherit"===l.fittextMin?x["font-size"]:l.fittextMin)||n.min,y=("inherit"===l.fittextMax?x["font-size"]:l.fittextMax)||n.max,b=x["line-height"],v=x.display,T=10;e(function(){u()},g),f.$watch(l.ngBind,function(){u()}),n.debounce?i.element(t).bind("resize",n.debounce(function(){f.$apply(u)},n.delay)):i.element(t).bind("resize",function(){f.$apply(u)})}}}]).provider("fitTextConfig",function(){var t=this;return this.config={},this.$get=function(){var e={};return e.config=t.config,e},this})}(window,document,angular);

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["tinycolor"] = __webpack_require__(23);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(549);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/index.js!./angularjs-color-picker.min.css", function() {
			var newContent = require("!!../../css-loader/index.js!../../postcss-loader/index.js!./angularjs-color-picker.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "/*!\r\n * angularjs-color-picker v3.4.8\r\n * https://github.com/ruhley/angular-color-picker/\r\n *\r\n * Copyright 2017 ruhley\r\n *\r\n * 2017-10-06 09:52:03\r\n *\r\n */.color-picker-wrapper{position:relative}.color-picker-wrapper .color-picker-input-wrapper{display:table;position:relative}.color-picker-wrapper .input-group{position:relative;border-collapse:separate}.color-picker-wrapper .input-group .color-picker-input,.color-picker-wrapper .input-group .input-group-addon{display:table-cell}.color-picker-wrapper .input-group .color-picker-input{position:relative;z-index:2;float:left;margin-bottom:0}.color-picker-wrapper .input-group .input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc}.color-picker-wrapper .input-group .input-group-addon:first-child{border-right-width:0}.color-picker-wrapper .input-group .input-group-addon:last-child{border-left-width:0}.color-picker-wrapper .input-group .color-picker-input-swatch{padding-left:12px}.color-picker-wrapper .color-picker-input-swatch{padding-left:36px}.color-picker-wrapper .color-picker-swatch{cursor:pointer;z-index:3}.color-picker-wrapper .color-picker-swatch:not(.input-group-addon){position:absolute;top:3px;width:28px;height:70%;box-sizing:border-box;border-radius:3px;vertical-align:middle;background-position:-80px 0;border:solid 1px #ccc;padding:0;margin:0;display:inline-block}.color-picker-wrapper .color-picker-swatch:not(.input-group-addon).color-picker-swatch-left{left:3px}.color-picker-wrapper .color-picker-swatch:not(.input-group-addon).color-picker-swatch-right{right:3px}.color-picker-wrapper .color-picker-panel{position:absolute;background:#fff;border:solid 1px #ccc;box-shadow:0 0 20px rgba(0,0,0,.5);z-index:99999;width:150px;table-layout:fixed;border:1px solid #fff;padding-right:1px;box-sizing:content-box}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper{display:table;width:100%}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row{display:table-row}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-overlay{position:absolute;width:100%;height:150px;top:0;left:0;z-index:2}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation{background-image:linear-gradient(45deg,grey 25%,transparent 25%),linear-gradient(-45deg,grey 25%,transparent 25%),linear-gradient(45deg,transparent 75%,grey 75%),linear-gradient(-45deg,transparent 75%,grey 75%);background-size:10px 10px;background-position:0 0,0 5px,5px -5px,-5px 0}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation{display:table-cell;position:relative;left:1px;width:20px;background-color:#fff;cursor:row-resize}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-slider{position:absolute;top:0;left:0;width:18px;height:2px;background:#fff;border:solid 1px #000;box-sizing:content-box;margin-top:-1px;z-index:3}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid{display:table-cell;position:relative;width:150px;height:150px;cursor:crosshair}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-grid-inner{width:150px;height:150px;z-index:9}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-overlay{background-image:url(data:image/png;base64,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);pointer-events:none}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-picker{position:absolute;top:70px;left:70px;width:12px;height:12px;border:solid 1px #000;border-radius:10px;margin-top:-6px;margin-left:-6px;background:0 0;box-sizing:content-box;z-index:99}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-picker>div{position:absolute;top:0;left:0;width:8px;height:8px;border-radius:8px;border:solid 2px #fff;box-sizing:content-box}.color-picker-wrapper .color-picker-panel .color-picker-actions .color-picker-action{width:calc(33.3333% - 6px);margin:3px}.color-picker-wrapper .color-picker-panel.color-picker-show-inline{position:relative}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-saturation.color-picker-show-lightness.color-picker-show-alpha{width:230px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-saturation.color-picker-show-lightness{width:210px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-saturation.color-picker-show-alpha{width:210px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-lightness.color-picker-show-alpha{width:210px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-saturation{width:190px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-lightness{width:190px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-alpha{width:190px}.color-picker-wrapper .color-picker-panel.color-picker-show-saturation.color-picker-show-alpha{width:190px}.color-picker-wrapper .color-picker-panel.color-picker-show-saturation.color-picker-show-lightness{width:190px}.color-picker-wrapper .color-picker-panel.color-picker-show-saturation.color-picker-show-lightness.color-picker-show-alpha{width:210px}.color-picker-wrapper .color-picker-panel.color-picker-show-lightness.color-picker-show-alpha{width:190px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue{width:170px}.color-picker-wrapper .color-picker-panel.color-picker-show-saturation{width:170px}.color-picker-wrapper .color-picker-panel.color-picker-show-lightness{width:170px}.color-picker-wrapper .color-picker-panel.color-picker-show-alpha{width:170px}.color-picker-wrapper .color-picker-panel.color-picker-panel-bottom{top:auto}.color-picker-wrapper .color-picker-panel.color-picker-panel-top{bottom:100%}.color-picker-wrapper .color-picker-panel.color-picker-panel-left{left:0}.color-picker-wrapper .color-picker-panel.color-picker-panel-right{right:0}.color-picker-wrapper .color-picker-panel.color-picker-panel-round .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-overlay{background-image:url(data:image/png;base64,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);border-radius:50%}.color-picker-wrapper .color-picker-panel.color-picker-panel-round .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-grid-inner{background-color:#fff}.color-picker-wrapper .color-picker-hidden{display:none}.color-picker-wrapper.color-picker-disabled .color-picker-grid,.color-picker-wrapper.color-picker-disabled .color-picker-hue,.color-picker-wrapper.color-picker-disabled .color-picker-input,.color-picker-wrapper.color-picker-disabled .color-picker-opacity,.color-picker-wrapper.color-picker-disabled .color-picker-swatch{cursor:not-allowed!important}.color-picker-wrapper.color-picker-swatch-only .color-picker-input{padding-left:33px;padding-right:0;width:35px}.color-picker-wrapper.color-picker-swatch-only .input-group .input-group-addon{width:35px;height:100%;border-right:1px solid #ccc}.color-picker-wrapper.color-picker-swatch-only .input-group .input-group-addon:first-child{border-right-width:1px}.color-picker-wrapper.color-picker-swatch-only .input-group .input-group-addon:last-child{border-left-width:1px}.color-picker-wrapper.color-picker-swatch-only .input-group .color-picker-input{padding:0;width:1px;opacity:0;cursor:pointer}.color-picker-wrapper.color-picker-swatch-only .input-group .color-picker-input:focus{outline:0}.color-picker-wrapper.color-picker-closed .color-picker-panel{display:none}.color-picker-wrapper.color-picker-horizontal .color-picker-panel{width:150px!important}.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row{display:block}.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid{display:block}.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation{cursor:col-resize;display:block;left:0;width:150px;height:20px}.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue .color-picker-overlay,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness .color-picker-overlay,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity .color-picker-overlay,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation .color-picker-overlay{height:20px}.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue .color-picker-slider,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness .color-picker-slider,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity .color-picker-slider,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation .color-picker-slider{width:2px;height:18px;margin-top:0}", ""]);

// exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(551);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./angularjs-color-picker-bootstrap.min.css", function() {
			var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./angularjs-color-picker-bootstrap.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "/*!\r\n * angularjs-color-picker v3.4.8\r\n * https://github.com/ruhley/angular-color-picker/\r\n *\r\n * Copyright 2017 ruhley\r\n *\r\n * 2017-10-06 09:52:03\r\n *\r\n */.color-picker-wrapper .color-picker-input-wrapper{width:100%}.color-picker-wrapper .color-picker-swatch:not(.input-group-addon){height:28px}.color-picker-wrapper.color-picker-swatch-only .input-group .input-group-addon{border-radius:4px}", ""]);

// exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(553)
module.exports = 'angulartics.google.analytics'


/***/ }),
/* 553 */
/***/ (function(module, exports) {

(function(window, angular, undefined) {'use strict';

/**
 * @ngdoc overview
 * @name angulartics.google.analytics
 * Enables analytics support for Google Analytics (http://google.com/analytics)
 */
angular.module('angulartics.google.analytics', ['angulartics'])
.config(['$analyticsProvider', function ($analyticsProvider) {

  // GA already supports buffered invocations so we don't need
  // to wrap these inside angulartics.waitForVendorApi

  $analyticsProvider.settings.pageTracking.trackRelativePath = true;

  // Set the default settings for this module
  $analyticsProvider.settings.ga = {
    // array of additional account names (only works for analyticsjs)
    additionalAccountNames: undefined,
    userId: null
  };

  function setDimensionsAndMetrics(properties) {
    if (window.ga) {
      // add custom dimensions and metrics
      for(var idx = 1; idx<=200;idx++) {
        if (properties['dimension' +idx.toString()]) {
          ga('set', 'dimension' +idx.toString(), properties['dimension' +idx.toString()]);
        }
        if (properties['metric' +idx.toString()]) {
          ga('set', 'metric' +idx.toString(), properties['metric' +idx.toString()]);
        }
      }
    }
  }

  $analyticsProvider.registerPageTrack(function (path) {
    if (window._gaq) {
      _gaq.push(['_trackPageview', path]);
      angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
        _gaq.push([accountName + '._trackPageview', path]);
      });
    }
    if (window.ga) {
      if ($analyticsProvider.settings.ga.userId) {
        ga('set', '&uid', $analyticsProvider.settings.ga.userId);
      }
      ga('send', 'pageview', path);
      angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
        ga(accountName +'.send', 'pageview', path);
      });
    }
  });

  /**
   * Track Event in GA
   * @name eventTrack
   *
   * @param {string} action Required 'action' (string) associated with the event
   * @param {object} properties Comprised of the mandatory field 'category' (string) and optional  fields 'label' (string), 'value' (integer) and 'noninteraction' (boolean)
   *
   * @link https://developers.google.com/analytics/devguides/collection/gajs/eventTrackerGuide#SettingUpEventTracking
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/events
   */
  $analyticsProvider.registerEventTrack(function (action, properties) {

    // Google Analytics requires an Event Category
    if (!properties || !properties.category) {
      properties = properties || {};
      properties.category = 'Event';
    }
    // GA requires that eventValue be an integer, see:
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#eventValue
    // https://github.com/luisfarzati/angulartics/issues/81
    if (properties.value) {
      var parsed = parseInt(properties.value, 10);
      properties.value = isNaN(parsed) ? 0 : parsed;
    }

    if (window.ga) {

      var eventOptions = {
        eventCategory: properties.category,
        eventAction: action,
        eventLabel: properties.label,
        eventValue: properties.value,
        nonInteraction: properties.noninteraction,
        page: properties.page || window.location.hash.substring(1) || window.location.pathname,
        userId: $analyticsProvider.settings.ga.userId
      };

      // add custom dimensions and metrics
      setDimensionsAndMetrics(properties);

      if ($analyticsProvider.settings.ga.transport) {
        ga('send', 'event', eventOptions, { transport: $analyticsProvider.settings.ga.transport});
      }
      else {
        ga('send', 'event', eventOptions);
      }

      angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
        ga(accountName +'.send', 'event', eventOptions);
      });
    }

    else if (window._gaq) {
      _gaq.push(['_trackEvent', properties.category, action, properties.label, properties.value, properties.noninteraction]);
    }

  });

  /**
   * Exception Track Event in GA
   * @name exceptionTrack
   *
   * @param {object} properties Comprised of the mandatory fields 'appId' (string), 'appName' (string) and 'appVersion' (string) and 
   * optional  fields 'fatal' (boolean) and 'description' (string)
   *
   * @https://developers.google.com/analytics/devguides/collection/analyticsjs/exceptions
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/events
   */
  $analyticsProvider.registerExceptionTrack(function (properties) {
    if (!properties || !properties.appId || !properties.appName || !properties.appVersion) {
        console.error('Must be setted appId, appName and appVersion.');
        return;
    }

    if(properties.fatal === undefined) {
        console.log('No "fatal" provided, sending with fatal=true');
        properties.exFatal = true;
    }

    properties.exDescription = properties.description;

    ga('send', 'exception', properties);
  });

  $analyticsProvider.registerSetUsername(function (userId) {
    $analyticsProvider.settings.ga.userId = userId;
  });

  $analyticsProvider.registerSetUserProperties(function (properties) {
    // add custom dimensions and metrics
    setDimensionsAndMetrics(properties);
  });

  /**
   * User Timings Event in GA
   * @name userTimings
   *
   * @param {object} properties Comprised of the mandatory fields:
   *     'timingCategory' (string),
   *     'timingVar' (string),
   *     'timingValue' (number)
   * Properties can also have the optional fields:
   *     'timingLabel' (string)
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/user-timings
   */
  $analyticsProvider.registerUserTimings(function (properties) {
    if (!properties || !properties.timingCategory || !properties.timingVar || !properties.timingValue) {
      console.error('Properties timingCategory, timingVar, and timingValue are required to be set.');
      return;
    }

    if(window.ga) {
      ga('send', 'timing', properties);
    }
  });

}]);
})(window, window.angular);


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(555);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!../postcss-loader/index.js!./toaster.min.css", function() {
			var newContent = require("!!../css-loader/index.js!../postcss-loader/index.js!./toaster.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "/*!\r\n * Toastr\r\n * Version 2.0.1\r\n * Copyright 2012 John Papa and Hans Fjallemark.\r\n * All Rights Reserved.\r\n * Use, reproduction, distribution, and modification of this code is subject to the terms and\r\n * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php\r\n *\r\n * Author: John Papa and Hans Fjallemark\r\n * Project: https://github.com/CodeSeven/toastr\r\n */\r\n.toast-title{font-weight:700}.toast-message{-ms-word-wrap:break-word;word-wrap:break-word}.toast-message a,.toast-message label{color:#fff}.toast-message a:hover{color:#ccc;text-decoration:none}.toast-close-button{position:relative;right:-.3em;top:-.3em;float:right;font-size:20px;font-weight:700;color:#fff;-webkit-text-shadow:0 1px 0 #fff;text-shadow:0 1px 0 #fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80)}.toast-close-button:focus,.toast-close-button:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.4;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);filter:alpha(opacity=40)}button.toast-close-button{padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.toast-top-full-width{top:0;right:0;width:100%}.toast-bottom-full-width{bottom:0;right:0;width:100%}.toast-top-left{top:12px;left:12px}.toast-top-center{top:12px}.toast-top-right{top:12px;right:12px}.toast-bottom-right{right:12px;bottom:12px}.toast-bottom-center{bottom:12px}.toast-bottom-left{bottom:12px;left:12px}.toast-center{top:45%}#toast-container{position:fixed;z-index:999999;pointer-events:auto;}#toast-container.toast-bottom-center,#toast-container.toast-center,#toast-container.toast-top-center{width:100%;pointer-events:none}#toast-container.toast-bottom-center>div,#toast-container.toast-center>div,#toast-container.toast-top-center>div{margin:auto;pointer-events:auto}#toast-container.toast-bottom-center>button,#toast-container.toast-center>button,#toast-container.toast-top-cente>button{pointer-events:auto}#toast-container *{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}#toast-container>div{margin:0 0 6px;padding:15px 15px 15px 50px;width:300px;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;background-position:15px center;background-repeat:no-repeat;-moz-box-shadow:0 0 12px #999;-webkit-box-shadow:0 0 12px #999;box-shadow:0 0 12px #999;color:#fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80)}#toast-container>:hover{-moz-box-shadow:0 0 12px #000;-webkit-box-shadow:0 0 12px #000;box-shadow:0 0 12px #000;opacity:1;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);filter:alpha(opacity=100);cursor:pointer}#toast-container>.toast-info{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=)!important}#toast-container>.toast-wait{background-image:url(data:image/gif;base64,R0lGODlhIAAgAIQAAAQCBISGhMzKzERCROTm5CQiJKyurHx+fPz+/ExOTOzu7Dw+PIyOjCwqLFRWVAwKDIyKjMzOzOzq7CQmJLy6vFRSVPTy9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQJCQAXACwAAAAAIAAgAAAF3eAljmRpnmh6VRSVqLDpIDTixOdUlFSNUDhSQUAT7ES9GnD0SFQAKWItMqr4bqKHVPDI+WiTkaOFFVlrFe83rDrT0qeIjwrT0iLdU0GOiBxhAA4VeSk6QYeIOAsQEAuJKgw+EI8nA18IA48JBAQvFxCXDI8SNAQikV+iiaQIpheWX5mJmxKeF6g0qpQmA4yOu8C7EwYWCgZswRcTFj4KyMAGlwYxDwcHhCXMXxYxBzQHKNo+3DDeCOAn0V/TddbYJA0K48gAEAFQicMWFsfwNA3JSgAIAAFfwIMIL4QAACH5BAkJABoALAAAAAAgACAAhAQCBIyKjERCRMzOzCQiJPTy9DQyNGRmZMTCxOTm5CwqLHx+fBQWFJyenNTW1Pz6/Dw6PGxubAwKDIyOjNTS1CQmJCwuLPz+/Dw+PHRydAAAAAAAAAAAAAAAAAAAAAAAAAXboCaOZGmeaKoxWcSosMkk15W8cZ7VdZaXkcEgQtrxfD9RhHchima1GwlCGUBSFCaFxMrgRtnLFhWujWHhs2nJc8KoVlWGQnEn7/i8XgOwWAB7JwoONQ4KgSQAZRcOgHgSCwsSIhZMNRZ5CzULIgaWF5h4mhecfIQ8jXmQkiODhYeIiRYGjrG2PxgBARi3IhNMAbcCnwI5BAQpAZ8TIwK6vCQVDwUVKL+WzAANTA210g/VJ8OWxQefByQE4dZMzBoInwh4zrtgn2p725YNthUFTNRuGYB3AYGBHCEAACH5BAkJAB0ALAAAAAAgACAAhAQCBISChFRWVMzKzCQiJOTm5GxqbCwuLJSWlPz6/NTW1AwODJSSlGRmZCwqLOzu7HR2dDQ2NAQGBISGhFxaXNTS1CQmJOzq7GxubDQyNKSmpPz+/Nza3AAAAAAAAAAAAAXfYCeOZGmeaKqurHBdAiuP17Zdc0lMAVHWt9yI8LA9fCPB4xEjARoNSWpis01kBpshFahurqzsZosiGpErScMAUO0maKF8Tq/bTQCIQgFp30cQXhB1BHEcXhx0FgkJFiOHVYlzi42AgoRxeRx8fn+en3UABwedKgsBAwMBCygOCjYKDisLFV4VrCUAtVUKpSZdXl8mB8EbByQWcQPFAyYZxccdB7sV0cvBzbmvvG0LBV4FrFTBYCWuNhyyHRTFFB20trh4BxmdYl4YIqepq0IRxRE+IfDCAFQHARo0NGERAgAh+QQJCQAgACwAAAAAIAAgAIUEAgSEgoRMTkzMyswcHhzk5uR0cnQUFhRcXlwsKiz09vQMCgyMiozU1tQkJiR8fnxkZmT8/vwEBgSEhoRcWlzU0tQkIiT08vR0dnQcGhxkYmQ0MjT8+vwMDgyMjozc2twAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG+UCQcEgsGo/IpHLJXDweC6Z0+IhEHlOjRGIMWLHZoUZx0RQlAajxkFFKFFYFl5m5KNpIySU+X2bIBEoQZBBZGQdMElFhjI2Oj5AgHQEDAw8dQxYeDBaNHRVWVhWYCXsRFwmMXqFWEyAerB6MA6xWA6+xs7URt6VWqIwTu64gDh4eDp6goaORQ5OVAZjO1EgEGhB4RwAYDQ0YAEwIcBEKFEgYrBhLBORxgUYfrB9LELuF8fNDAAaVBuEg7NXCVyRdqHVCGLBiIIQAB1Yc4BXh9uEbwAXuyi2iQI7DuSwHdiFqCEGDtizLRFUDsaGAlQIbVoJYIEDAIiZBAAAh+QQJCQAbACwAAAAAIAAgAIQEAgSMioxcWlz08vQcHhysqqwMDgx8enwsKiykoqRkZmT8+vzEwsQMCgyUlpQkJiS0srQEBgSMjoxcXlz09vQkIiSsrqwUEhQ0MjRsamz8/vwAAAAAAAAAAAAAAAAAAAAF7+AmjmRpnmiqruz2PG0sIssCj4CQJAIgj4/abRNJaI6agu9kCAQaphdJgEQKUIFjgGWsahJYLdf7RTWfLKr3+jsBClVlG5Xb9eb4fImgUBBKDVB4ExRHFGwbGRQLGXMEhUgUfw2QC4IyCmSNDQtHlm2ZXgoiGQsUjW0EnUgLfyKBeYSeiHojfH61uS0GBisVEgEVLRcWRxAXKAgDRwMILMVIECgSVRIrBmS9JtRI1iMVBweuGxerSNolyszOIhjLGs0jEFXSKA8SEkMbcEgWIxfzNBxrw6AKgxIGkM05UOWALhERHJhysOThBgAVWYQAACH5BAkJABkALAAAAAAgACAAhAQGBIyKjERCRMzOzCwuLGRiZPz6/OTm5AwODLSytFRSVNTW1Dw6PHx6fAwKDJSSlERGRNTS1DQyNGxqbPz+/BQSFLy6vFRWVNza3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAXqYCaO5FgFwxBUZeu61ULNFMa+eBvQdJD/owFvFhkBBAwHsBQZUooZyWF2YOQkBNJu6ANMaQeli0AxSEwymi0DcUJeEgPlbEJFAghRe/h+Eeg/Dl9UYks5DF9VhksOAgKFi5GSSwh5kzgVCXIJNxknD5aSCTwJIw8zD5MITpanFKmSCHI8NxUPoJejNKWXLZkznL0vCJ3CxsckDpA/ChYJFzkTBgYTSxc80C4OswbLLhY8Fi/bMwYAJVgl4DTiL9LUJADrFuci1zTZLwD1IwU8BSQuWLCQb1EDHg2QiSDALYvCDAISJLDy8FIIACH5BAkJAB4ALAAAAAAgACAAhAQGBISGhFRSVNTW1CQiJKyqrGRmZOzu7CwuLIyOjGxubPz6/BQSFGRiZOTi5CwqLLy6vDQ2NIyKjFRWVCQmJKyurGxqbPT29DQyNJSSlHRydPz+/BQWFOzq7AAAAAAAAAXhoCeOJElYClGubOs117YtjWuvxCLLi3qbhc6h4FPsdorfiNI5dige43GT9AAkHUcCwCpMNxVP7tgTJY4J1uF7EBl0M8Ooueuo2SOCIkVa11kVX2E2EmgsFH4yBz4uAAkdHVstBAUHQ4xKmZqbnJ2bAhAQAiURGJ4eE0cTIxgzpp0QRxCsrp6xO7MjpaepO6unKxOhv8DFxsfIJBwaChw2DAkZDEocDjIOzi0ZMhlKUjIaLtsb3T8aR+EtDBkJ0yQUBQVQI9XX2ZsDMgMlyxr3mzE2XEgmotCGAARFIHiQ0FMIACH5BAkJABgALAAAAAAgACAAhAQCBISGhDw+POTi5CwuLLS2tPTy9BQSFJyenGRiZDQ2NIyOjLy+vPz6/BweHIyKjFRSVOzq7DQyNLy6vBQWFHRydDw6PPz+/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXXICaOZHkcZaquIjVd10SxtFrAcFGrVhBYIwoON9uNAsOA6DCEFTEKBEKxEjQvAtELNxkpGrAGNfW4Plpb2QgxRKjKzfPoVGLj3CnLNUv7hscpSDhKOxJSgDwPP0ZGAACMjAQFDQYFBJA0BAZDBpeYGBQVFUU3TV2YFAMwAzNgTQ2PkBVDFRiuQ7CYszi1pUOnkKmrM5qcnqiiTwQTDQ2Wn9DR0tPUfRKQEBEREDQSFw3XRhEwEd3f4TvjF+XWKgJ8JNnb0QkwCdUlCzAL+CQODAwc9BtIMAQAOw==)!important}#toast-container>.toast-error{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=)!important}#toast-container>.toast-success{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==)!important}#toast-container>.toast-warning{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=)!important}#toast-container.toast-bottom-full-width>div,#toast-container.toast-top-full-width>div{width:96%;margin:auto}.toast{background-color:#030303}.toast-success{background-color:#51a351}.toast-error{background-color:#bd362f}.toast-info,.toast-wait{background-color:#2f96b4}.toast-warning{background-color:#f89406}@media all and (max-width:240px){#toast-container>div{padding:8px 8px 8px 50px;width:11em}#toast-container .toast-close-button{right:-.2em;top:-.2em}}@media all and (min-width:241px) and (max-width:480px){#toast-container>div{padding:8px 8px 8px 50px;width:18em}#toast-container .toast-close-button{right:-.2em;top:-.2em}}@media all and (min-width:481px) and (max-width:768px){#toast-container>div{padding:15px 15px 15px 50px;width:25em}}:not(.no-enter)#toast-container>div.ng-enter,:not(.no-leave)#toast-container>div.ng-leave{-webkit-transition:1000ms cubic-bezier(.25,.25,.75,.75) all;-moz-transition:1000ms cubic-bezier(.25,.25,.75,.75) all;-ms-transition:1000ms cubic-bezier(.25,.25,.75,.75) all;-o-transition:1000ms cubic-bezier(.25,.25,.75,.75) all;transition:1000ms cubic-bezier(.25,.25,.75,.75) all}:not(.no-enter)#toast-container>div.ng-enter.ng-enter-active,:not(.no-leave)#toast-container>div.ng-leave{opacity:.8}:not(.no-enter)#toast-container>div.ng-enter,:not(.no-leave)#toast-container>div.ng-leave.ng-leave-active{opacity:0}", ""]);

// exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(557);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/index.js!./ng-tags-input.min.css", function() {
			var newContent = require("!!../../css-loader/index.js!../../postcss-loader/index.js!./ng-tags-input.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "tags-input{display:block}tags-input *,tags-input :after,tags-input :before{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}tags-input .host{position:relative;margin-top:5px;margin-bottom:5px;height:100%}tags-input .host:active{outline:0}tags-input .tags{-moz-appearance:textfield;-webkit-appearance:textfield;padding:1px;overflow:hidden;word-wrap:break-word;cursor:text;background-color:#fff;border:1px solid #a9a9a9;box-shadow:1px 1px 1px 0 #d3d3d3 inset;height:100%}tags-input .tags.focused{outline:0;-webkit-box-shadow:0 0 3px 1px rgba(5,139,242,.6);-moz-box-shadow:0 0 3px 1px rgba(5,139,242,.6);box-shadow:0 0 3px 1px rgba(5,139,242,.6)}tags-input .tags .tag-list{margin:0;padding:0;list-style-type:none}tags-input .tags .tag-item{margin:2px;padding:0 5px;display:inline-block;float:left;font:14px \"Helvetica Neue\",Helvetica,Arial,sans-serif;height:26px;line-height:25px;border:1px solid #acacac;border-radius:3px;background:-webkit-linear-gradient(top,#f0f9ff 0,#cbebff 47%,#a1dbff 100%);background:linear-gradient(to bottom,#f0f9ff 0,#cbebff 47%,#a1dbff 100%)}tags-input .tags .tag-item.selected{background:-webkit-linear-gradient(top,#febbbb 0,#fe9090 45%,#ff5c5c 100%);background:linear-gradient(to bottom,#febbbb 0,#fe9090 45%,#ff5c5c 100%)}tags-input .tags .tag-item .remove-button{margin:0 0 0 5px;padding:0;border:none;background:0 0;cursor:pointer;vertical-align:middle;font:700 16px Arial,sans-serif;color:#585858}tags-input .tags .input.invalid-tag,tags-input .tags .tag-item .remove-button:active{color:red}tags-input .tags .input{border:0;outline:0;margin:2px;padding:0 0 0 5px;float:left;height:26px;font:14px \"Helvetica Neue\",Helvetica,Arial,sans-serif}tags-input .tags .input::-ms-clear{display:none}tags-input.ng-invalid .tags{-webkit-box-shadow:0 0 3px 1px rgba(255,0,0,.6);-moz-box-shadow:0 0 3px 1px rgba(255,0,0,.6);box-shadow:0 0 3px 1px rgba(255,0,0,.6)}tags-input[disabled] .host:focus{outline:0}tags-input[disabled] .tags{background-color:#eee;cursor:default}tags-input[disabled] .tags .tag-item{opacity:.65;background:-webkit-linear-gradient(top,#f0f9ff 0,rgba(203,235,255,.75) 47%,rgba(161,219,255,.62) 100%);background:linear-gradient(to bottom,#f0f9ff 0,rgba(203,235,255,.75) 47%,rgba(161,219,255,.62) 100%)}tags-input[disabled] .tags .tag-item .remove-button{cursor:default}tags-input[disabled] .tags .tag-item .remove-button:active{color:#585858}tags-input[disabled] .tags .input{background-color:#eee;cursor:default}tags-input .autocomplete{margin-top:5px;position:absolute;padding:5px 0;z-index:999;width:100%;background-color:#fff;border:1px solid rgba(0,0,0,.2);-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);-moz-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2)}tags-input .autocomplete .suggestion-list{margin:0;padding:0;list-style-type:none;max-height:280px;overflow-y:auto;position:relative}tags-input .autocomplete .suggestion-item{padding:5px 10px;cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font:16px \"Helvetica Neue\",Helvetica,Arial,sans-serif;color:#000;background-color:#fff}tags-input .autocomplete .suggestion-item.selected,tags-input .autocomplete .suggestion-item.selected em{color:#fff;background-color:#0097cf}tags-input .autocomplete .suggestion-item em{font:normal 700 16px \"Helvetica Neue\",Helvetica,Arial,sans-serif;color:#000;background-color:#fff}", ""]);

// exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(559);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/index.js!./ng-tags-input.bootstrap.min.css", function() {
			var newContent = require("!!../../css-loader/index.js!../../postcss-loader/index.js!./ng-tags-input.bootstrap.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "tags-input{box-shadow:none;border:none;padding:0;min-height:34px}tags-input .host{margin:0}tags-input .tags{-moz-appearance:none;-webkit-appearance:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;-moz-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s}tags-input .tags .tag-item{color:#fff;background:#428bca;border:1px solid #357ebd;border-radius:4px}tags-input .tags .tag-item.selected{color:#fff;background:#d9534f;border:1px solid #d43f3a}tags-input .tags .tag-item .remove-button:hover{text-decoration:none}tags-input .tags.focused{border:1px solid #66afe9;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}tags-input .autocomplete{border-radius:4px}tags-input .autocomplete .suggestion-item.selected,tags-input .autocomplete .suggestion-item.selected em{color:#262626;background-color:#f5f5f5}tags-input .autocomplete .suggestion-item em{color:#000;background-color:#fff}tags-input.ng-invalid .tags{border-color:#843534;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}tags-input[disabled] .tags{background-color:#eee}tags-input[disabled] .tags .tag-item{background:#337ab7;opacity:.65}tags-input[disabled] .tags .input{background-color:#eee}.input-group tags-input{padding:0;display:table-cell}.input-group tags-input:not(:first-child) .tags{border-top-left-radius:0;border-bottom-left-radius:0}.input-group tags-input:not(:last-child) .tags{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-lg tags-input:first-child .tags{border-top-left-radius:6px;border-bottom-left-radius:6px}.input-group-lg tags-input:last-child .tags{border-top-right-radius:6px;border-bottom-right-radius:6px}.input-group-sm tags-input:first-child .tags{border-top-left-radius:3px;border-bottom-left-radius:3px}.input-group-sm tags-input:last-child .tags{border-top-right-radius:3px;border-bottom-right-radius:3px}.input-group-lg tags-input,tags-input.ti-input-lg{min-height:46px}.input-group-lg tags-input .tags,tags-input.ti-input-lg .tags{border-radius:6px}.input-group-lg tags-input .tags .tag-item,tags-input.ti-input-lg .tags .tag-item{height:38px;line-height:37px;font-size:18px;border-radius:6px}.input-group-lg tags-input .tags .tag-item .remove-button,tags-input.ti-input-lg .tags .tag-item .remove-button{font-size:20px}.input-group-lg tags-input .tags .input,tags-input.ti-input-lg .tags .input{height:38px;font-size:18px}.input-group-sm tags-input,tags-input.ti-input-sm{min-height:30px}.input-group-sm tags-input .tags,tags-input.ti-input-sm .tags{border-radius:3px}.input-group-sm tags-input .tags .tag-item,tags-input.ti-input-sm .tags .tag-item{height:22px;line-height:21px;font-size:12px;border-radius:3px}.input-group-sm tags-input .tags .tag-item .remove-button,tags-input.ti-input-sm .tags .tag-item .remove-button{font-size:16px}.input-group-sm tags-input .tags .input,tags-input.ti-input-sm .tags .input{height:22px;font-size:12px}.has-feedback tags-input .tags{padding-right:30px}.has-success tags-input .tags{border-color:#3c763d}.has-success tags-input .tags.focused{border-color:#2b542c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-error tags-input .tags{border-color:#a94442}.has-error tags-input .tags.focused{border-color:#843534;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-warning tags-input .tags{border-color:#8a6d3b}.has-warning tags-input .tags.focused{border-color:#66512c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}", ""]);

// exports


/***/ }),
/* 560 */
/***/ (function(module, exports) {

function _toConsumableArray(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}function _defineProperty(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function _sliceIterator(e,t){var n=[],r=!0,o=!1,a=void 0;try{for(var s,i=e[Symbol.iterator]();!(r=(s=i.next()).done)&&(n.push(s.value),!t||n.length!==t);r=!0);}catch(e){o=!0,a=e}finally{try{r||null==i.return||i.return()}finally{if(o)throw a}}return n}function _slicedToArray(e,t){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return _sliceIterator(e,t);throw new TypeError("Invalid attempt to destructure non-iterable instance")}!function(Y,U){var X=U.element.prototype.closest;if(!X){var r=["matches","matchesSelector","webkitMatches","webkitMatchesSelector","msMatches","msMatchesSelector","mozMatches","mozMatchesSelector"].reduce(function(e,t){var n;return null!==(n=e)&&void 0!==n?n:t in document.documentElement?t:null},null);X=function(e){for(var t,n=this[0].parentNode;n!==document.documentElement&&null!=n&&!n[r](e);)n=n.parentNode;return(null===(t=n)||void 0===t?void 0:t[r](e))?U.element(n):U.element()}}function G(){var e,t,n,r;return"pageYOffset"in Y?{scrollTop:Y.pageYOffset,scrollLeft:Y.pageXOffset}:{scrollTop:null!==(e=null!==(t=document.documentElement.scrollTop)&&void 0!==t?t:document.body.scrollTop)&&void 0!==e?e:0,scrollLeft:null!==(n=null!==(r=document.documentElement.scrollLeft)&&void 0!==r?r:document.body.scrollLeft)&&void 0!==n?n:0}}function K(e,t){return e===Y?"clientWidth"===t?Y.innerWidth:Y.innerHeight:e[t]}function c(e,t){var n,r;n=t,r="".concat(e," attribute is deprecated. Pass the options object to vs-repeat attribute instead https://github.com/kamilkp/angular-vs-repeat#options"),console.warn("vs-repeat deprecation: ".concat(r),n[0])}var Q={latch:!1,container:null,scrollParent:null,size:null,offsetBefore:0,offsetAfter:0,scrolledToBeginning:U.noop,scrolledToEnd:U.noop,scrolledToBeginningOffset:0,scrolledToEndOffset:0,scrollMargin:0,horizontal:!1,autoresize:!1,hunked:!1,hunkSize:0},e=U.module("vs-repeat",[]).directive("vsRepeat",["$compile","$parse",function(F,J){return{restrict:"A",scope:!0,compile:function(t,n){var e="vsRepeatContainer"in n?U.element(t[0].querySelector(n.vsRepeatContainer)):t,r=e.children(),o=r.eq(0),L=o[0].outerHTML,q="$vs_collection";["vsSize","vsScrollParent","vsSizeProperty","vsHorizontal","vsOffsetBefore","vsOffsetAfter","vsScrolledToEndOffset","vsScrolledToBeginningOffset","vsExcess","vsScrollMargin"].forEach(function(e){e in n&&c(e,t)});var a=_slicedToArray(function(e){for(var t=["ng-repeat","data-ng-repeat","ng-repeat-start","data-ng-repeat-start"],n=0;n<t.length;n++){var r=t[n];if(e.attr(r))return[r,e.attr(r),0<=r.indexOf("-start")]}throw new Error("angular-vs-repeat: no ng-repeat directive on a child element")}(o),3),H=a[0],s=a[1],W=a[2],i=_slicedToArray(/^\s*(\S+)\s+in\s+([\S\s]+?)(track\s+by\s+\S+)?$/.exec(s),4),j=i[1],N=i[2],D=i[3];if(W)for(var l=0,d=r.eq(l);null==d.attr("ng-repeat-end")&&null==d.attr("data-ng-repeat-end");)l++,d=r.eq(l),L+=d[0].outerHTML;return e.empty(),{pre:function(g,m,e){var t;function n(e){if("number"==typeof e.size)e.getSize=function(){return e.size};else{var t=J(String(e.size));e.getSize=function(e){return t(g,_defineProperty({},j,e))}}}g.vsRepeat={options:_extends({},Q,null!==(t=g.$eval(e.vsRepeat))&&void 0!==t?t:{})};var R=g.vsRepeat.options;n(R);var x,z=U.isDefined(e.vsRepeatContainer)?U.element(m[0].querySelector(e.vsRepeatContainer)):m,r=U.element(L),o=r[0].tagName.toLowerCase(),y=[],$=U.element("<"+o+' class="vs-repeat-before-content"></'+o+">"),b=U.element("<"+o+' class="vs-repeat-after-content"></'+o+">"),I=null===R.size,w=R.scrollParent?"window"===R.scrollParent?U.element(Y):X.call(z,R.scrollParent):z,S=R.horizontal?"clientWidth":"clientHeight",a=R.horizontal?"offsetWidth":"offsetHeight",T=R.horizontal?"scrollWidth":"scrollHeight",A=R.horizontal?"scrollLeft":"scrollTop";if((g.vsRepeat.totalSize=0)===w.length)throw"Specified scroll parent selector did not match any element";if(g.vsRepeat.$scrollParent=w,g.vsRepeat.sizesCumulative=[],R.debug){var s="window"===R.scrollParent?U.element(document.body):w,i=U.element('<div class="vs-repeat-debug-element"></div>');i.css("position","window"===R.scrollParent?"fixed":"absolute"),s.append(i),g.$on("$destroy",function(){i.remove()})}var C,O,M,_,l,d=K(w[0],S)||50;function c(){!y||y.length<1?(g[q]=[],x=0,g.vsRepeat.sizesCumulative=[0]):(x=y.length,R.size?u():p()),h()}function u(){var n=0<arguments.length&&void 0!==arguments[0]?arguments[0]:null,e=y.map(function(e){var t;return null!==(t=n)&&void 0!==t?t:R.getSize(e)}),t=0;g.vsRepeat.sizesCumulative=[0].concat(_toConsumableArray(e.map(function(e){return t+=e})))}function p(){I?g.$$postDigest(function(){if(z[0].offsetHeight||z[0].offsetWidth){for(var e=z.children(),t=0,n=!1,r=!1;t<e.length;){if(null!=e[t].attributes[H]||r){if(n||(d=0),n=!0,e[t][a]&&(d+=e[t][a]),!W)break;if(null!=e[t].attributes["ng-repeat-end"]||null!=e[t].attributes["data-ng-repeat-end"])break;r=!0}t++}n&&(u(d),h(),I=!1,g.$root&&!g.$root.$$phase&&g.$digest())}else var o=g.$watch(function(){(z[0].offsetHeight||z[0].offsetWidth)&&(o(),p())})}):u(d)}function B(n){var r=R.horizontal?"width":"height";return["","min-","max-"].reduce(function(e,t){return e["".concat(t).concat(r)]=n,e},{})}function v(){var e=w[0][A];k()&&(g.$digest(),R._ensureScrollIntegrity&&(w[0][A]=e))}function f(){R.autoresize&&(I=!0,p(),g.$root&&!g.$root.$$phase&&g.$digest()),k()&&g.$digest()}function h(){var e;O=C=void 0,M=x,_=0,e=g.vsRepeat.sizesCumulative[x],g.vsRepeat.totalSize=R.offsetBefore+e+R.offsetAfter,k(),g.$emit("vsRepeatReinitialized",g.vsRepeat.startIndex,g.vsRepeat.endIndex)}function E(){var e=K(w[0],S);e!==l&&(h(),g.$root&&!g.$root.$$phase&&g.$digest()),l=e}function P(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:0,r=3<arguments.length&&void 0!==arguments[3]?arguments[3]:e.length-1,o=4<arguments.length&&void 0!==arguments[4]?arguments[4]:1;if(e[n]===t)return[n,n,o];if(e[r]===t)return[r,r,o];if(1<r-n){var a=Math.floor((n+r)/2);return e[a]>t?P(e,t,n,a,o+1):P(e,t,a,r,o+1)}return[t>e[r]?r:n,t<e[n]?n:r,o]}function k(){var e,t,n=(e=w[0],t=A,e===Y?G()[t]:e[t]),r=K(w[0],S);R.debug&&(r/=2);var o,a,s,i=z[0]===w[0]?0:(o=z[0],a=w[0],s=R.horizontal,o.getBoundingClientRect()[s?"left":"top"]-(a===Y?0:a.getBoundingClientRect()[s?"left":"top"])+(a===Y?G():a)[s?"scrollLeft":"scrollTop"]),l=g.vsRepeat.startIndex,d=g.vsRepeat.endIndex;if(I&&!R.size)l=0,d=1;else{g.$$postDigest(function(){Y.requestAnimationFrame(function(){var e=g.vsRepeat.sizesCumulative[x],n=Y.getComputedStyle(z[0]),t=R.horizontal?["paddingLeft","paddingRight"]:["paddingTop","paddingBottom"],r=z[0][T]-t.reduce(function(e,t){return e+Number(n[t].slice(0,-2))},0);z[0][T]&&e!==r&&console.warn("vsRepeat: size mismatch. Expected size "+e+"px whereas actual size is "+r+"px. Fix vsSize on element:",m[0])})});var c=n-R.offsetBefore-i;l=_slicedToArray(P(g.vsRepeat.sizesCumulative,c-R.scrollMargin),1)[0],l=Math.max(l,0),d=_slicedToArray(P(g.vsRepeat.sizesCumulative,c+R.scrollMargin+r,l),2)[1],d=Math.min(d,x)}M=Math.min(l,M),_=Math.max(d,_),g.vsRepeat.startIndex=R.latch?M:l,g.vsRepeat.endIndex=R.latch?_:d,_<g.vsRepeat.startIndex&&(g.vsRepeat.startIndex=_);var u=!1;if(null==C?u=!0:null==O&&(u=!0),u||(R.hunked?Math.abs(g.vsRepeat.startIndex-C)>=R.hunkSize||0===g.vsRepeat.startIndex&&0!==C?u=!0:(Math.abs(g.vsRepeat.endIndex-O)>=R.hunkSize||g.vsRepeat.endIndex===x&&O!==x)&&(u=!0):u=g.vsRepeat.startIndex!==C||g.vsRepeat.endIndex!==O),u){var p;g[q]=y.slice(g.vsRepeat.startIndex,g.vsRepeat.endIndex),g.$emit("vsRepeatInnerCollectionUpdated",g.vsRepeat.startIndex,g.vsRepeat.endIndex,C,O),R.scrolledToEnd&&(p=y.length-R.scrolledToEndOffset,(g.vsRepeat.endIndex>=p&&O<p||y.length&&g.vsRepeat.endIndex===y.length)&&g.$eval(R.scrolledToEnd)),R.scrolledToBeginning&&(p=R.scrolledToBeginningOffset,g.vsRepeat.startIndex<=p&&C>g.vsRepeat.startIndex&&g.$eval(R.scrolledToBeginning)),C=g.vsRepeat.startIndex,O=g.vsRepeat.endIndex;var v=g.vsRepeat.sizesCumulative[g.vsRepeat.startIndex]+R.offsetBefore,f=g.vsRepeat.sizesCumulative[g.vsRepeat.startIndex+g[q].length]+R.offsetBefore,h=g.vsRepeat.totalSize;$.css(B(v+"px")),b.css(B(h-f+"px"))}return u}R.horizontal?($.css("height","100%"),b.css("height","100%")):($.css("width","100%"),b.css("width","100%")),e.vsRepeatOptions&&g.$watchCollection(e.vsRepeatOptions,function(e){var t=_extends({},R,e);JSON.stringify(t)!==JSON.stringify(R)&&(Object.assign(R,e),n(R),h())}),g.$watchCollection(N,function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:[];y=e,c()}),r.eq(0).attr(H,j+" in "+q+(D?" "+D:"")),r.addClass("vs-repeat-repeated-element"),z.append($),z.append(r),F(r)(g),z.append(b),g.vsRepeat.startIndex=0,g.vsRepeat.endIndex=0,w.on("scroll",v),U.element(Y).on("resize",f),g.$on("$destroy",function(){U.element(Y).off("resize",f),w.off("scroll",v)}),g.$on("vsRepeatTrigger",c),g.$on("vsRepeatResize",function(){I=!0,p()}),g.$on("vsRenderAll",function(){R.latch&&(g.vsRepeat.endIndex!==x?setTimeout(function(){var e=x;_=Math.max(e,_),g.vsRepeat.endIndex=R.latch?_:e,g[q]=y.slice(g.vsRepeat.startIndex,g.vsRepeat.endIndex),O=g.vsRepeat.endIndex,$.css(B(0)),b.css(B(0)),g.$emit("vsRenderAllDone"),g.$root&&!g.$root.$$phase&&g.$digest()}):g.$emit("vsRenderAllDone"))}),g.$watch(function(){"function"==typeof Y.requestAnimationFrame?Y.requestAnimationFrame(E):E()})}}}}}]);U.element(document.head).append('<style id="angular-vs-repeat-style">\n\t  \t.vs-repeat-debug-element {\n        top: 50%;\n        left: 0;\n        right: 0;\n        height: 1px;\n        background: red;\n        z-index: 99999999;\n        box-shadow: 0 0 20px red;\n      }\n\n      .vs-repeat-debug-element + .vs-repeat-debug-element {\n        display: none;\n      }\n\n      .vs-repeat-before-content,\n      .vs-repeat-after-content {\n        border: none !important;\n        padding: 0 !important;\n      }\n    </style>'),"undefined"!=typeof module&&module.exports&&(module.exports=e.name)}(window,window.angular);

/***/ }),
/* 561 */
/***/ (function(module, exports) {

/*
 * BlockAdBlock 3.2.1
 * Copyright (c) 2015 Valentin Allaire <valentin.allaire@sitexw.fr>
 * Released under the MIT license
 * https://github.com/sitexw/BlockAdBlock
 */

(function(window) {
	var BlockAdBlock = function(options) {
		this._options = {
			checkOnLoad:		false,
			resetOnEnd:			false,
			loopCheckTime:		50,
			loopMaxNumber:		5,
			baitClass:			'pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads text-ad-links',
			baitStyle:			'width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important;',
			debug:				false
		};
		this._var = {
			version:			'3.2.1',
			bait:				null,
			checking:			false,
			loop:				null,
			loopNumber:			0,
			event:				{ detected: [], notDetected: [] }
		};
		if(options !== undefined) {
			this.setOption(options);
		}
		var self = this;
		var eventCallback = function() {
			setTimeout(function() {
				if(self._options.checkOnLoad === true) {
					if(self._options.debug === true) {
						self._log('onload->eventCallback', 'A check loading is launched');
					}
					if(self._var.bait === null) {
						self._creatBait();
					}
					setTimeout(function() {
						self.check();
					}, 1);
				}
			}, 1);
		};
		if(window.addEventListener !== undefined) {
			window.addEventListener('load', eventCallback, false);
		} else {
			window.attachEvent('onload', eventCallback);
		}
	};
	BlockAdBlock.prototype._options = null;
	BlockAdBlock.prototype._var = null;
	BlockAdBlock.prototype._bait = null;
	
	BlockAdBlock.prototype._log = function(method, message) {
		console.log('[BlockAdBlock]['+method+'] '+message);
	};
	
	BlockAdBlock.prototype.setOption = function(options, value) {
		if(value !== undefined) {
			var key = options;
			options = {};
			options[key] = value;
		}
		for(var option in options) {
			this._options[option] = options[option];
			if(this._options.debug === true) {
				this._log('setOption', 'The option "'+option+'" he was assigned to "'+options[option]+'"');
			}
		}
		return this;
	};
	
	BlockAdBlock.prototype._creatBait = function() {
		var bait = document.createElement('div');
			bait.setAttribute('class', this._options.baitClass);
			bait.setAttribute('style', this._options.baitStyle);
		this._var.bait = window.document.body.appendChild(bait);
		
		this._var.bait.offsetParent;
		this._var.bait.offsetHeight;
		this._var.bait.offsetLeft;
		this._var.bait.offsetTop;
		this._var.bait.offsetWidth;
		this._var.bait.clientHeight;
		this._var.bait.clientWidth;
		
		if(this._options.debug === true) {
			this._log('_creatBait', 'Bait has been created');
		}
	};
	BlockAdBlock.prototype._destroyBait = function() {
		window.document.body.removeChild(this._var.bait);
		this._var.bait = null;
		
		if(this._options.debug === true) {
			this._log('_destroyBait', 'Bait has been removed');
		}
	};
	
	BlockAdBlock.prototype.check = function(loop) {
		if(loop === undefined) {
			loop = true;
		}
		
		if(this._options.debug === true) {
			this._log('check', 'An audit was requested '+(loop===true?'with a':'without')+' loop');
		}
		
		if(this._var.checking === true) {
			if(this._options.debug === true) {
				this._log('check', 'A check was canceled because there is already an ongoing');
			}
			return false;
		}
		this._var.checking = true;
		
		if(this._var.bait === null) {
			this._creatBait();
		}
		
		var self = this;
		this._var.loopNumber = 0;
		if(loop === true) {
			this._var.loop = setInterval(function() {
				self._checkBait(loop);
			}, this._options.loopCheckTime);
		}
		setTimeout(function() {
			self._checkBait(loop);
		}, 1);
		if(this._options.debug === true) {
			this._log('check', 'A check is in progress ...');
		}
		
		return true;
	};
	BlockAdBlock.prototype._checkBait = function(loop) {
		var detected = false;
		
		if(this._var.bait === null) {
			this._creatBait();
		}
		
		if(window.document.body.getAttribute('abp') !== null
		|| this._var.bait.offsetParent === null
		|| this._var.bait.offsetHeight == 0
		|| this._var.bait.offsetLeft == 0
		|| this._var.bait.offsetTop == 0
		|| this._var.bait.offsetWidth == 0
		|| this._var.bait.clientHeight == 0
		|| this._var.bait.clientWidth == 0) {
			detected = true;
		}
		if(window.getComputedStyle !== undefined) {
			var baitTemp = window.getComputedStyle(this._var.bait, null);
			if(baitTemp && (baitTemp.getPropertyValue('display') == 'none' || baitTemp.getPropertyValue('visibility') == 'hidden')) {
				detected = true;
			}
		}
		
		if(this._options.debug === true) {
			this._log('_checkBait', 'A check ('+(this._var.loopNumber+1)+'/'+this._options.loopMaxNumber+' ~'+(1+this._var.loopNumber*this._options.loopCheckTime)+'ms) was conducted and detection is '+(detected===true?'positive':'negative'));
		}
		
		if(loop === true) {
			this._var.loopNumber++;
			if(this._var.loopNumber >= this._options.loopMaxNumber) {
				this._stopLoop();
			}
		}
		
		if(detected === true) {
			this._stopLoop();
			this._destroyBait();
			this.emitEvent(true);
			if(loop === true) {
				this._var.checking = false;
			}
		} else if(this._var.loop === null || loop === false) {
			this._destroyBait();
			this.emitEvent(false);
			if(loop === true) {
				this._var.checking = false;
			}
		}
	};
	BlockAdBlock.prototype._stopLoop = function(detected) {
		clearInterval(this._var.loop);
		this._var.loop = null;
		this._var.loopNumber = 0;
		
		if(this._options.debug === true) {
			this._log('_stopLoop', 'A loop has been stopped');
		}
	};
	
	BlockAdBlock.prototype.emitEvent = function(detected) {
		if(this._options.debug === true) {
			this._log('emitEvent', 'An event with a '+(detected===true?'positive':'negative')+' detection was called');
		}
		
		var fns = this._var.event[(detected===true?'detected':'notDetected')];
		for(var i in fns) {
			if(this._options.debug === true) {
				this._log('emitEvent', 'Call function '+(parseInt(i)+1)+'/'+fns.length);
			}
			if(fns.hasOwnProperty(i)) {
				fns[i]();
			}
		}
		if(this._options.resetOnEnd === true) {
			this.clearEvent();
		}
		return this;
	};
	BlockAdBlock.prototype.clearEvent = function() {
		this._var.event.detected = [];
		this._var.event.notDetected = [];
		
		if(this._options.debug === true) {
			this._log('clearEvent', 'The event list has been cleared');
		}
	};
	
	BlockAdBlock.prototype.on = function(detected, fn) {
		this._var.event[(detected===true?'detected':'notDetected')].push(fn);
		if(this._options.debug === true) {
			this._log('on', 'A type of event "'+(detected===true?'detected':'notDetected')+'" was added');
		}
		
		return this;
	};
	BlockAdBlock.prototype.onDetected = function(fn) {
		return this.on(true, fn);
	};
	BlockAdBlock.prototype.onNotDetected = function(fn) {
		return this.on(false, fn);
	};
	
	window.BlockAdBlock = BlockAdBlock;
	
	if(window.blockAdBlock === undefined) {
		window.blockAdBlock = new BlockAdBlock({
			checkOnLoad: true,
			resetOnEnd: true
		});
	}
})(window);


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(563);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./main.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./main.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@600;700;800&display=swap);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap);", ""]);

// module
exports.push([module.i, "@charset \"UTF-8\";\n/* white navbar */\n:root {\n  --color-bx-arctic: #0cd6e9;\n  --color-bx-accessible-blue: #00a3bb;\n  --color-bx-accessible-grey: rgb(94 105 122);\n  --color-bx-lagoon: rgb(0, 108, 128);\n  --color-bx-denim: rgb(0, 38, 62);\n  --color-bx-black: rgb(29, 31, 42);\n  --color-bx-grey: rgb(157, 158, 163);\n  --color-bx-grey-lighten-5: rgb(250, 250, 250);\n  --color-bx-grey-lighten-4: rgb(245, 245, 245);\n  --color-bx-grey-lighten-3: rgb(238, 238, 238);\n  --color-bx-grey-lighten-2: rgb(222, 222, 224);\n  --color-bx-grey-lighten-1: rgb(187, 187, 191);\n  --color-bx-grey-darken-1: rgb(116, 116, 122);\n  --color-bx-grey-darken-2: rgb(93, 96, 102);\n  --color-bx-grey-darken-3: rgb(58, 63, 71);\n  --color-bx-grey-darken-4: rgb(46, 47, 56);\n  --color-bx-green-lighten-1: #0ab50c;\n  --color-bx-green: #238341;\n  --color-bx-green-darken-1: #145e2b;\n  --color-bx-red: rgba(211, 47, 47, 1);\n  --color-bx-red-darken-1: rgb(179 32 28);\n  --color-bx-shallot: #8c4ee8;\n  --color-bx-lagoon: #006c80;\n  --color-bx-accessible-blue-opacity-1: rgb(0, 163, 187, 0.08);\n  --color-bx-accessible-blue-opacity-2: rgb(0, 163, 187, 0.12);\n  --color-bx-accessible-blue-opacity-3: rgb(0, 163, 187, 0.32); }\n\n@font-face {\n  font-family: stratum2-medium;\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-medium-webfont-b2c4f8dc.eot\") format(\"embedded-opentype\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-medium-webfont-b9328e20.woff\") format(\"woff\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-medium-webfont-1056a27c.ttf\") format(\"truetype\"); }\n\n@font-face {\n  font-family: 'stratum2-regular';\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-regular-webfont-4f027594.eot\") format(\"embedded-opentype\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-regular-webfont-85ed058d.woff\") format(\"woff\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-regular-webfont-1d7ec4d0.ttf\") format(\"truetype\"); }\n\n@font-face {\n  font-family: 'stratum2-bold';\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-bold-webfont-be5f65fc.eot\") format(\"embedded-opentype\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-bold-webfont-98176c3d.woff\") format(\"woff\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-bold-webfont-38fd0ee0.ttf\") format(\"truetype\"); }\n\n@font-face {\n  font-family: stratum2-medium;\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-medium-webfont-b2c4f8dc.eot\") format(\"embedded-opentype\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-medium-webfont-b9328e20.woff\") format(\"woff\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-medium-webfont-1056a27c.ttf\") format(\"truetype\"); }\n\nbody {\n  font-family: 'Roboto', Arial, sans-serif !important;\n  background-color: #edecec !important;\n  -webkit-font-smoothing: antialiased; }\n  body small {\n    font-size: 14px; }\n\na {\n  color: #337ab7; }\n\n.body-1 {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 1.8rem;\n  line-height: 30px;\n  color: #1d1f2a; }\n\n/*Body-2*/\n.body-2 {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 1.6rem;\n  line-height: 28px;\n  color: #1d1f2a; }\n\n/*Body-3*/\n.body-3, .home-card__heading {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 24px;\n  color: #1d1f2a; }\n\n.subtle-link {\n  cursor: pointer;\n  color: var(--color-bx-accessible-grey);\n  text-decoration: none;\n  border-bottom: 1px dotted #ccc; }\n  .subtle-link:hover {\n    color: #111;\n    text-decoration: none;\n    border-bottom: 1px dotted #aaa; }\n\n.small-link {\n  cursor: pointer;\n  color: #1aa8a1;\n  text-decoration: none;\n  border-bottom: none;\n  font-weight: bold;\n  font-size: 0.8em; }\n  .small-link:hover {\n    text-decoration: none; }\n\n.block {\n  display: block; }\n\n/**\nText Colors\n*/\n.text-black {\n  color: var(--color-bx-black); }\n\n.text-denim {\n  color: var(--color-bx-denim); }\n\n.text-bx-lagoon {\n  color: var(--color-bx-lagoon); }\n\n.text-bx-accessible-blue {\n  color: var(--color-bx-accessible-blue); }\n\n.text-bx-accessible-grey {\n  color: var(--color-bx-accessible-grey); }\n\n.text-bx-green {\n  color: var(--color-bx-green); }\n\n/**\nFont Weights \n*/\n.font-normal {\n  font-weight: 400; }\n\n.font-medium {\n  font-weight: 500; }\n\n.font-bold {\n  font-weight: 700; }\n\n.mb-0 {\n  margin-bottom: 0; }\n\n.mb-tight {\n  margin-bottom: 0.4rem; }\n\n.mb-base {\n  margin-bottom: 0.8rem; }\n\n.mb-base {\n  margin-bottom: 1.2rem; }\n\n.mt-0 {\n  margin-top: 0; }\n\n.mt-tight {\n  margin-top: 0.4rem; }\n\n.mt-base {\n  margin-top: 0.8rem; }\n\n.mt-base {\n  margin-top: 1.2rem; }\n\n/**\nFont Sizes\n*/\n.text-xs {\n  font-size: 1.2rem; }\n\n.text-sm {\n  font-size: 1.4rem; }\n\nol ul,\nol ol,\nul ul,\nul ol {\n  margin-top: 0.25em;\n  margin-bottom: 0.25em;\n  padding-left: 1.5rem; }\n\n.underline {\n  text-decoration: underline; }\n\n.main-content {\n  margin-left: 230px;\n  margin-top: 70px;\n  padding-bottom: 20px; }\n\n.with-eyebrow .main-content {\n  margin-top: 112px; }\n\nmain.container-fluid {\n  position: relative;\n  padding-right: 0;\n  padding-left: 0; }\n\n.flex-grid {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center; }\n\n.flex-cell-33 {\n  width: 33%; }\n\n.broadcast-card {\n  /*\n    .play-button {\n        position:absolute;\n        left:50%;top:50%;\n        width:70px;height:70px;\n        margin-left:-35px;margin-top:-35px;\n        background-image:radial-gradient(circle at center, rgba(255,255,255,0.65) 0%,rgba(255,255,255,0) 80%);\n        text-align: center;\n    }\n    */ }\n  .broadcast-card img.preview {\n    margin: 0;\n    padding: 0;\n    border: none; }\n  .broadcast-card-image-wrapper {\n    position: relative;\n    cursor: pointer; }\n    .broadcast-card-image-wrapper__message {\n      overflow: hidden; }\n  .broadcast-card-image-wrapper:after {\n    padding-top: 56.25%;\n    /* 16:9 ratio */\n    display: block;\n    content: ''; }\n  .broadcast-card-image-preview {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    background-size: cover;\n    background-color: #000;\n    background-position: center; }\n  .broadcast-card .message {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding-top: 20px;\n    text-align: center;\n    color: #ddd;\n    background: rgba(0, 0, 0, 0.5); }\n  .broadcast-card .action-link {\n    color: #6cbce0; }\n  .broadcast-card .view-stats {\n    position: absolute;\n    bottom: 0;\n    left: 0px;\n    right: 0px;\n    padding: 3px 5px;\n    background: rgba(0, 0, 0, 0.8);\n    color: #fff;\n    z-index: 2; }\n  .broadcast-card__description {\n    margin-top: 0.25rem;\n    font-size: 1.4rem;\n    letter-spacing: -0.5px;\n    color: var(--color-bx-grey-darken-3); }\n    .broadcast-card__description small {\n      font-size: 1.4rem;\n      letter-spacing: 0.025px; }\n  .broadcast-card__name {\n    letter-spacing: -0.25px;\n    font-weight: 500;\n    font-size: 1.8rem; }\n  .broadcast-card__duration, .broadcast-card__views-count, .broadcast-card__ticket-label, .broadcast-card__private-label {\n    font-weight: 500; }\n  .broadcast-card__edit-toggle {\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    background-color: rgba(0, 0, 0, 0.5);\n    transition: background-color 0.1s ease-out;\n    display: inline-block;\n    padding: 1px 4px;\n    border-radius: 0px 0px 0px 5px; }\n    .broadcast-card__edit-toggle .action-link {\n      transition: color 0.1s ease-out;\n      color: white; }\n    .broadcast-card__edit-toggle:active, .broadcast-card__edit-toggle:focus {\n      text-decoration: none; }\n    .broadcast-card__edit-toggle:hover {\n      background: white; }\n      .broadcast-card__edit-toggle:hover a {\n        text-decoration: none;\n        color: var(--color-bx-denim); }\n\n.multi-view-broadcast-details h4 {\n  margin: 10px 0 0 0; }\n\n.multi-view-broadcast-details p {\n  margin: 0; }\n\n@media screen and (min-width: 1200px) {\n  .channel-row-details .broadcast-card__duration, .channel-row-details .broadcast-card__views-count, .channel-row-details .broadcast-card__ticket-label, .channel-row-details .broadcast-card__private-label {\n    font-size: 1.2rem; } }\n\n@media screen and (min-width: 1900px) {\n  .channel-row-details .broadcast-card__duration, .channel-row-details .broadcast-card__views-count, .channel-row-details .broadcast-card__ticket-label, .channel-row-details .broadcast-card__private-label {\n    font-size: 1.4rem; } }\n\n.channel-row-details .broadcast-card-image-wrapper__message small {\n  font-size: 1.2rem; }\n  @media screen and (min-width: 1900px) {\n    .channel-row-details .broadcast-card-image-wrapper__message small {\n      font-size: 1.4rem; } }\n\n.facebook-embed {\n  position: relative;\n  padding-bottom: 56.25%;\n  /* 16:9 */\n  padding-top: 25px;\n  height: 0; }\n\n.facebook-embed iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n\n.integration-type-controls {\n  display: flex;\n  gap: 1.5rem;\n  flex-direction: column; }\n  @media screen and (min-width: 1100px) {\n    .integration-type-controls {\n      flex-direction: row; } }\n  @media screen and (min-width: 1100px) {\n    .integration-type-controls__info {\n      flex: 1; } }\n\n.label-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px; }\n  .label-list.justify-end {\n    justify-content: flex-end; }\n\n.left-rail {\n  background-color: #191c22;\n  position: fixed;\n  left: 0;\n  width: 230px;\n  top: 50px;\n  height: calc(100vh - 50px);\n  overflow-y: auto;\n  z-index: 0;\n  padding-bottom: 100px; }\n  .left-rail .user {\n    margin: 15px 0;\n    text-align: center; }\n  .left-rail .nav > li > a {\n    color: #ccc;\n    font-size: 1.4rem;\n    font-weight: 500;\n    background-color: #191c22;\n    padding: 10px 15px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    transition: color 0.2s ease-out; }\n    .left-rail .nav > li > a.secondary-link {\n      font-size: 11px;\n      padding: 5px 15px; }\n  .left-rail .nav > li > a:hover {\n    color: white;\n    background-color: #191c22; }\n  .left-rail .nav > li > a:focus,\n  .left-rail .nav > li.active > a {\n    background-color: #121419;\n    color: white; }\n    .left-rail .nav > li > a:focus .nav-icon,\n    .left-rail .nav > li.active > a .nav-icon {\n      background: #2c313a; }\n  .left-rail .nav > li.active > a {\n    border-right: 6px solid var(--color-bx-accessible-blue); }\n  .left-rail .nav-icon {\n    display: inline-block;\n    width: 28px;\n    height: 28px;\n    line-height: 29px;\n    text-align: center;\n    border-radius: 14px;\n    background: #121419;\n    margin-right: 10px; }\n  .left-rail .navProducts {\n    background-color: #FFF;\n    display: none; }\n  .left-rail .navProducts__heading {\n    margin: 0;\n    padding-top: 12px;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    font-size: 16px;\n    line-height: 1.5;\n    font-weight: bold; }\n  .left-rail .navProducts__list {\n    list-style: none;\n    margin: 0;\n    padding: 0; }\n  .left-rail .navProducts__button {\n    width: 100%;\n    border: 0;\n    padding: 1rem;\n    background-color: transparent;\n    display: flex;\n    align-items: center; }\n    .left-rail .navProducts__button:hover {\n      background-color: rgba(0, 163, 187, 0.08); }\n  .left-rail .navProducts__icon {\n    background: #00263e;\n    border-radius: 6px;\n    width: 32px;\n    height: 32px;\n    margin-right: .75rem;\n    display: flex;\n    align-items: center;\n    color: #FFF;\n    justify-content: center; }\n  .left-rail .navProducts__label {\n    color: #00263e; }\n  .left-rail .divider {\n    margin-left: 15px;\n    margin-right: 15px;\n    margin-top: 5px;\n    padding-top: 5px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    box-shadow: 0 -1px 1px rgba(0, 0, 0, 0.5); }\n  .left-rail .need-help {\n    display: block;\n    margin-bottom: 20px;\n    font-size: 14px;\n    font-weight: bold;\n    color: rgba(255, 255, 255, 0.6);\n    border: 1px solid;\n    padding: 5px 20px;\n    border-radius: 4px;\n    text-decoration: none; }\n    .left-rail .need-help:hover {\n      color: white; }\n\n.with-eyebrow .left-rail {\n  top: 92px;\n  height: calc(100vh - 92px); }\n\n.low-latency-wrapper {\n  background: #000; }\n  .low-latency-wrapper .close-btn {\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    right: 5px;\n    color: #fff;\n    text-shadow: 0 0 5px rgba(0, 0, 0, 0.8);\n    text-decoration: none;\n    font-weight: bold;\n    font-size: 25px; }\n  .low-latency-wrapper .indicator-overlay {\n    position: absolute;\n    z-index: 1;\n    top: 15px;\n    left: 15px;\n    text-decoration: none; }\n\n.cap-player-width-container {\n  max-width: 720px;\n  margin: 0 auto;\n  position: relative; }\n\n.stat-block {\n  text-align: center;\n  padding: 5px 0;\n  border: 1px solid #b9b9b9;\n  border-bottom-width: 0; }\n  .stat-block h2 {\n    margin: 0; }\n  .stat-block h5 {\n    margin: 0; }\n  .stat-block.half-l {\n    border-right-width: 0; }\n\n.stat-row-label {\n  margin-bottom: 10px;\n  padding: 3px;\n  background: rgba(0, 0, 0, 0.7);\n  font-size: 8pt;\n  font-weight: bold;\n  color: #aaa;\n  text-align: center; }\n\n.diagnostics--icon-OK {\n  color: green; }\n\n.diagnostics--icon-Warning {\n  color: orange; }\n\n.diagnostics--icon-Critical {\n  color: red; }\n\n.diagnostics--title-OK {\n  border-bottom: 3px solid green; }\n\n.diagnostics--title-Warning {\n  border-bottom: 3px solid orange; }\n\n.diagnostics--title-Critical {\n  border-bottom: 3px solid red; }\n\n.diagnostics--title-Unknown {\n  border-bottom: 3px solid #ccc; }\n\n.diagnostics--alert-inactive {\n  opacity: 0.5; }\n\n.diagnostics--summary h1 {\n  margin: 0; }\n\n.diagnostics--alerts-overlay {\n  position: relative;\n  width: auto;\n  height: auto; }\n  .diagnostics--alerts-overlay .diagnostics--alerts-content {\n    height: 100%;\n    width: 100%;\n    max-height: 120px;\n    overflow-y: scroll; }\n  .diagnostics--alerts-overlay .shadowContainer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none; }\n  .diagnostics--alerts-overlay .shadow {\n    position: absolute;\n    z-index: 1; }\n  .diagnostics--alerts-overlay .linearShadowTop {\n    top: 0;\n    left: 0;\n    background: linear-gradient(rgba(0, 0, 0, 0.3) 10%, rgba(255, 255, 255, 0)) 100% 0;\n    background-repeat: no-repeat;\n    background-size: 100% 4px;\n    width: inherit;\n    height: 5px; }\n  .diagnostics--alerts-overlay .linearShadowBottom {\n    bottom: 0;\n    left: 0;\n    background: linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.3) 90%) 0 100%;\n    background-repeat: no-repeat;\n    background-size: 100% 4px;\n    width: inherit;\n    height: 5px; }\n  .diagnostics--alerts-overlay .shadowCoverTop {\n    height: 5px;\n    width: 100%;\n    background: #fff;\n    background-size: 100% 12px;\n    background-repeat: no-repeat;\n    position: relative;\n    z-index: 2; }\n  .diagnostics--alerts-overlay .shadowCoverBottom {\n    height: 5px;\n    width: 100%;\n    background: #fff;\n    background-size: 100% 12px;\n    background-repeat: no-repeat;\n    position: relative;\n    z-index: 2; }\n\n.scoreboard-diagnostics-status {\n  font-size: 10px;\n  text-align: center;\n  margin-bottom: 30px; }\n  .scoreboard-diagnostics-status td {\n    vertical-align: top;\n    padding: 0 5px; }\n  .scoreboard-diagnostics-status.five-wide td {\n    width: 20%; }\n  .scoreboard-diagnostics-status.four-wide td {\n    width: 25%; }\n  .scoreboard-diagnostics-status.three-wide td {\n    width: 33%; }\n  .scoreboard-diagnostics-status i.fa {\n    display: block;\n    font-size: 25px;\n    margin-bottom: 5px; }\n\n.opacity-80 {\n  opacity: 0.8; }\n\n.opacity-40 {\n  opacity: 0.4; }\n\n.scoreboard-link-status--strike {\n  height: 10px;\n  width: 65px;\n  background: #444;\n  position: absolute;\n  top: 10px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  transform: rotate(35deg);\n  border: 2px solid #fff;\n  border-radius: 5px; }\n\n.top-rail .navbar {\n  margin-bottom: 0;\n  border-radius: 0;\n  border: 0;\n  height: 50px;\n  background: #fff;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.23); }\n  .top-rail .navbar img.logo {\n    height: 20px;\n    margin: 0;\n    display: inline;\n    vertical-align: middle;\n    position: relative;\n    top: -2px; }\n  .top-rail .navbar h3 {\n    margin-top: 0;\n    margin-bottom: 0;\n    line-height: 50px;\n    font-size: 20px;\n    color: rgba(0, 0, 0, 0.8); }\n  .top-rail .navbar .notification-icons {\n    line-height: 50px;\n    padding-right: 15px; }\n  .top-rail .navbar .navbar-header {\n    width: 230px;\n    height: 49px;\n    background: #fff; }\n    .top-rail .navbar .navbar-header a {\n      padding: 0 15px;\n      line-height: 50px;\n      color: #fd4c4c;\n      font-size: 30px; }\n    .top-rail .navbar .navbar-header .productSwitcher {\n      margin-left: 15px; }\n      .top-rail .navbar .navbar-header .productSwitcher .dropdown-toggle {\n        background-color: transparent;\n        border: 0;\n        margin: 0;\n        padding: 0;\n        font-size: 20px;\n        line-height: 50px; }\n      .top-rail .navbar .navbar-header .productSwitcher .dropdown-menu {\n        width: 192px; }\n        .top-rail .navbar .navbar-header .productSwitcher .dropdown-menu .productSwitcher__button {\n          width: 100%;\n          background-color: transparent;\n          border: none;\n          display: flex;\n          align-items: center;\n          padding: 8px 16px; }\n          .top-rail .navbar .navbar-header .productSwitcher .dropdown-menu .productSwitcher__button .productSwitcher__button__icon {\n            background: #00263e;\n            border-radius: 6px;\n            width: 32px;\n            height: 32px;\n            margin-right: .75rem;\n            display: flex;\n            align-items: center;\n            color: #FFF;\n            justify-content: center; }\n          .top-rail .navbar .navbar-header .productSwitcher .dropdown-menu .productSwitcher__button .productSwitcher__button__label {\n            color: #00263e;\n            font-size: 16px;\n            line-height: 1; }\n          .top-rail .navbar .navbar-header .productSwitcher .dropdown-menu .productSwitcher__button:hover {\n            background-color: rgba(0, 163, 187, 0.08); }\n    .top-rail .navbar .navbar-header.mobile {\n      width: 100%;\n      color: #333;\n      text-align: center; }\n  .top-rail .navbar .nav > li > a {\n    padding: 0 15px;\n    line-height: 50px;\n    color: #000; }\n  .top-rail .navbar .navbar-brand .spin-box,\n  .top-rail .navbar .navbar-brand .spin-box-bg {\n    position: absolute;\n    left: 32px;\n    top: 0;\n    width: 15px;\n    height: 20px;\n    top: 15px;\n    background: #fff; }\n  .top-rail .navbar .navbar-brand .spin-box {\n    border: 4px solid #20998b;\n    animation-name: box-3d-rotate;\n    animation-duration: 1500ms;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear; }\n\n@keyframes box-3d-rotate {\n  from {\n    transform: rotateY(0deg); }\n  to {\n    transform: rotateY(360deg); } }\n\n.with-eyebrow .top-rail .navbar {\n  height: 92px; }\n\n.eyebrow {\n  background: var(--color-bx-lagoon);\n  transition: background-color 0.2s ease-in;\n  padding: 10px 30px;\n  font-size: 16px; }\n  .eyebrow a {\n    color: #fff;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n\n.eyebrow:hover {\n  background: #0094b8; }\n\n.recording-trimmer .zoom-scroll-pan-container {\n  overflow-x: scroll;\n  overflow-y: hidden;\n  position: relative;\n  top: -15px;\n  height: 120px;\n  padding: 10px 10px 0 10px;\n  /* left and right only ...\n        box-shadow: inset 25px 0px 25px -25px rgba(0,0,0,0.45),\n                    inset -25px 0px 25px -25px rgba(0,0,0,0.45);\n        */\n  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3); }\n  .recording-trimmer .zoom-scroll-pan-container::-webkit-scrollbar {\n    width: 0.5em;\n    height: 0.5em; }\n  .recording-trimmer .zoom-scroll-pan-container::-webkit-scrollbar-thumb {\n    background: slategray; }\n  .recording-trimmer .zoom-scroll-pan-container::-webkit-scrollbar-track {\n    background: #b8c0c8; }\n  .recording-trimmer .zoom-scroll-pan-container {\n    scrollbar-face-color: slategray;\n    scrollbar-track-color: #b8c0c8; }\n\n.recording-trimmer .mosaic {\n  position: relative;\n  z-index: 1; }\n  .recording-trimmer .mosaic div {\n    display: inline-block;\n    height: 75px;\n    background-size: cover; }\n\n.recording-trimmer .hidden-region-mask {\n  z-index: 2;\n  position: absolute;\n  top: 0;\n  height: 75px;\n  background-color: #4e5c69;\n  background-image: url(/img/textures/ps-neutral.png);\n  opacity: 0.8; }\n  .recording-trimmer .hidden-region-mask.start-point-mask {\n    left: 0; }\n  .recording-trimmer .hidden-region-mask.end-point-mask {\n    margin-left: 10px;\n    right: 0px; }\n\n.recording-trimmer .start-point-preview,\n.recording-trimmer .end-point-preview {\n  position: absolute; }\n  .recording-trimmer .start-point-preview div,\n  .recording-trimmer .end-point-preview div {\n    margin-left: -58px; }\n    .recording-trimmer .start-point-preview div img,\n    .recording-trimmer .end-point-preview div img {\n      position: absolute;\n      height: 75px;\n      top: -109px;\n      z-index: 3;\n      border: 1px solid #000; }\n\nrzslider.trim {\n  margin-top: 0;\n  margin-bottom: 30px;\n  position: relative;\n  top: -75px;\n  z-index: 4; }\n  rzslider.trim .rz-pointer {\n    -webkit-border-radius: 2px;\n    -moz-border-radius: 2px;\n    border-radius: 2px;\n    width: 16px;\n    height: 75px;\n    top: 0;\n    background-color: #dacd17;\n    display: block !important; }\n  rzslider.trim .rz-pointer:after,\n  rzslider.trim .rz-pointer:hover:after,\n  rzslider.trim .rz-pointer.rz-active:hover:after,\n  rzslider.trim .rz-pointer.rz-active:after {\n    background-color: transparent;\n    top: 6px;\n    left: 3px; }\n  rzslider.trim .rz-pointer:after {\n    font-size: 20px;\n    font-weight: bold;\n    line-height: 62px;\n    color: #000;\n    content: '\\2016'; }\n  rzslider.trim .rz-bar {\n    background: transparent;\n    height: 75px; }\n  rzslider.trim .rz-bar.rz-selection {\n    background: transparent;\n    border: 4px solid #dacd17;\n    border-radius: 4px; }\n  rzslider.trim .rz-bubble {\n    bottom: -90px;\n    padding: 1px 3px;\n    color: #55637d;\n    cursor: default; }\n\nrzslider.trim-blue-solid {\n  margin-top: 0;\n  margin-bottom: 40px; }\n  rzslider.trim-blue-solid .rz-pointer {\n    -webkit-border-radius: 2px;\n    -moz-border-radius: 2px;\n    border-radius: 2px;\n    width: 16px;\n    height: 40px;\n    top: 0;\n    background-color: #333;\n    display: block !important; }\n  rzslider.trim-blue-solid .rz-pointer:after,\n  rzslider.trim-blue-solid .rz-pointer:hover:after,\n  rzslider.trim-blue-solid .rz-pointer.rz-active:hover:after,\n  rzslider.trim-blue-solid .rz-pointer.rz-active:after {\n    background-color: transparent;\n    top: 6px;\n    left: 3px; }\n  rzslider.trim-blue-solid .rz-pointer:after {\n    font-size: 20px;\n    font-weight: bold;\n    color: #989898;\n    text-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\n    content: '\\2016'; }\n  rzslider.trim-blue-solid .rz-bar {\n    background-color: #4e5c69;\n    background-image: url(/img/textures/ps-neutral.png);\n    height: 40px; }\n  rzslider.trim-blue-solid .rz-bar.rz-selection {\n    background-color: #337ab7;\n    background-image: url(/img/textures/subtle-dots.png); }\n  rzslider.trim-blue-solid .rz-bubble {\n    bottom: -53px;\n    padding: 1px 3px;\n    color: #55637d;\n    cursor: default; }\n\nrzslider.playhead {\n  margin-top: 0;\n  margin-bottom: 0; }\n  rzslider.playhead .rz-bar {\n    background-color: #ccc; }\n  rzslider.playhead .rz-pointer {\n    box-shadow: 0 0 6px rgba(0, 0, 0, 0.6);\n    background-color: #d24e37;\n    height: 16px;\n    width: 16px;\n    top: -6px; }\n  rzslider.playhead .rz-pointer:after {\n    display: none; }\n  rzslider.playhead .rz-bubble {\n    display: none; }\n\n.slider-zoom-trapezoid {\n  border-top: 30px solid rgba(234, 211, 165, 0.47);\n  border-left: 50px solid transparent;\n  border-right: 50px solid transparent;\n  height: 0;\n  width: 100%;\n  position: relative;\n  top: -22px;\n  margin-bottom: -22px; }\n\n.drop-box {\n  text-align: center;\n  padding: 10px; }\n  .drop-box .drop-target {\n    border: 3px dashed #ccc;\n    border-radius: 12px; }\n    .drop-box .drop-target i.fa {\n      font-size: 10em;\n      color: #cdcfd1; }\n  .drop-box img,\n  .drop-box video {\n    width: 100%;\n    max-width: 320px;\n    max-height: 240px; }\n  .drop-box.dragover {\n    /* highlight in blue when dragging file over target region */ }\n    .drop-box.dragover .drop-target {\n      background-color: #ecf3f9;\n      border-color: #428bca; }\n  .drop-box .browse-link {\n    color: #3366bb;\n    cursor: pointer; }\n  .drop-box .browse-link:hover {\n    text-decoration: underline; }\n  .drop-box .no-file {\n    color: #676;\n    margin: 25px 0; }\n  .drop-box [hidden] {\n    display: none !important; }\n\n.drop-box.compact {\n  padding: 0;\n  border-radius: 12px;\n  font-size: 1.4rem; }\n  .drop-box.compact .supported-filetypes,\n  .drop-box.compact i.fa {\n    display: none; }\n  .drop-box.compact img,\n  .drop-box.compact video {\n    max-width: 100%; }\n\n.upload-modal .right-col {\n  padding: 15px 30px 0 0; }\n  @media (max-width: 767px) {\n    .upload-modal .right-col {\n      padding-left: 30px; } }\n  .upload-modal .right-col label {\n    white-space: nowrap; }\n\n.has-file {\n  border-radius: 5px;\n  padding-bottom: 15px; }\n  .has-file .remove-icon {\n    color: #3f3f3f;\n    font-size: 1.25em; }\n    .has-file .remove-icon:hover {\n      transform: scale(1.1); }\n  .has-file .file-icon {\n    font-size: 5em;\n    color: #3f3f3f;\n    margin-left: 10px; }\n  .has-file img,\n  .has-file video {\n    width: 100%;\n    height: auto;\n    padding: 0 15px; }\n\n.wifi-icon {\n  background-color: transparent;\n  border: 4px solid transparent;\n  border-top-color: #444;\n  border-radius: 4px;\n  height: 8px;\n  left: 50%;\n  position: relative;\n  top: 50%;\n  transition: border-top-color 0.3s linear;\n  width: 8px;\n  transform: translate(-25%); }\n  .wifi-icon:before, .wifi-icon:after {\n    content: '';\n    background-color: transparent;\n    border: 2.83688px solid transparent;\n    border-top-color: #444;\n    position: absolute;\n    transition: border-top-color 0.3s linear; }\n  .wifi-icon:before {\n    border-radius: 8px;\n    height: 16px;\n    left: -8px;\n    top: -8px;\n    width: 16px; }\n  .wifi-icon:after {\n    border-radius: 24px;\n    height: 24px;\n    left: -12px;\n    top: -12px;\n    width: 24px; }\n  .wifi-icon.none {\n    border-top-color: rgba(68, 68, 68, 0.4); }\n    .wifi-icon.none:before, .wifi-icon.none:after {\n      border-top-color: rgba(68, 68, 68, 0.4); }\n  .wifi-icon.weak:before, .wifi-icon.weak:after {\n    border-top-color: rgba(68, 68, 68, 0.4); }\n  .wifi-icon.medium:after {\n    border-top-color: rgba(68, 68, 68, 0.4); }\n\n.wifi-icon-large {\n  background-color: transparent;\n  border: 10px solid transparent;\n  border-top-color: #444;\n  border-radius: 10px;\n  height: 20px;\n  left: 50%;\n  position: relative;\n  top: 50%;\n  transition: border-top-color 0.3s linear;\n  width: 20px;\n  transform: translate(-50%); }\n  .wifi-icon-large:before, .wifi-icon-large:after {\n    content: '';\n    background-color: transparent;\n    border: 7.0922px solid transparent;\n    border-top-color: #444;\n    position: absolute;\n    transition: border-top-color 0.3s linear; }\n  .wifi-icon-large:before {\n    border-radius: 20px;\n    height: 40px;\n    left: -20px;\n    top: -20px;\n    width: 40px; }\n  .wifi-icon-large:after {\n    border-radius: 60px;\n    height: 60px;\n    left: -30px;\n    top: -30px;\n    width: 60px; }\n  .wifi-icon-large.none {\n    border-top-color: rgba(68, 68, 68, 0.4); }\n    .wifi-icon-large.none:before, .wifi-icon-large.none:after {\n      border-top-color: rgba(68, 68, 68, 0.4); }\n  .wifi-icon-large.weak:before, .wifi-icon-large.weak:after {\n    border-top-color: rgba(68, 68, 68, 0.4); }\n  .wifi-icon-large.medium:after {\n    border-top-color: rgba(68, 68, 68, 0.4); }\n\n.wifi-icon-large-green {\n  background-color: transparent;\n  border: 10px solid transparent;\n  border-top-color: green;\n  border-radius: 10px;\n  height: 20px;\n  left: 50%;\n  position: relative;\n  top: 50%;\n  transition: border-top-color 0.3s linear;\n  width: 20px;\n  transform: translate(-50%); }\n  .wifi-icon-large-green:before, .wifi-icon-large-green:after {\n    content: '';\n    background-color: transparent;\n    border: 7.0922px solid transparent;\n    border-top-color: green;\n    position: absolute;\n    transition: border-top-color 0.3s linear; }\n  .wifi-icon-large-green:before {\n    border-radius: 20px;\n    height: 40px;\n    left: -20px;\n    top: -20px;\n    width: 40px; }\n  .wifi-icon-large-green:after {\n    border-radius: 60px;\n    height: 60px;\n    left: -30px;\n    top: -30px;\n    width: 60px; }\n  .wifi-icon-large-green.none {\n    border-top-color: rgba(0, 128, 0, 0.4); }\n    .wifi-icon-large-green.none:before, .wifi-icon-large-green.none:after {\n      border-top-color: rgba(0, 128, 0, 0.4); }\n  .wifi-icon-large-green.weak:before, .wifi-icon-large-green.weak:after {\n    border-top-color: rgba(0, 128, 0, 0.4); }\n  .wifi-icon-large-green.medium:after {\n    border-top-color: rgba(0, 128, 0, 0.4); }\n\n.wifi-icon-large-red {\n  background-color: transparent;\n  border: 10px solid transparent;\n  border-top-color: red;\n  border-radius: 10px;\n  height: 20px;\n  left: 50%;\n  position: relative;\n  top: 50%;\n  transition: border-top-color 0.3s linear;\n  width: 20px;\n  transform: translate(-50%); }\n  .wifi-icon-large-red:before, .wifi-icon-large-red:after {\n    content: '';\n    background-color: transparent;\n    border: 7.0922px solid transparent;\n    border-top-color: red;\n    position: absolute;\n    transition: border-top-color 0.3s linear; }\n  .wifi-icon-large-red:before {\n    border-radius: 20px;\n    height: 40px;\n    left: -20px;\n    top: -20px;\n    width: 40px; }\n  .wifi-icon-large-red:after {\n    border-radius: 60px;\n    height: 60px;\n    left: -30px;\n    top: -30px;\n    width: 60px; }\n  .wifi-icon-large-red.none {\n    border-top-color: rgba(255, 0, 0, 0.4); }\n    .wifi-icon-large-red.none:before, .wifi-icon-large-red.none:after {\n      border-top-color: rgba(255, 0, 0, 0.4); }\n  .wifi-icon-large-red.weak:before, .wifi-icon-large-red.weak:after {\n    border-top-color: rgba(255, 0, 0, 0.4); }\n  .wifi-icon-large-red.medium:after {\n    border-top-color: rgba(255, 0, 0, 0.4); }\n\n.wifi-icon-large-orange {\n  background-color: transparent;\n  border: 10px solid transparent;\n  border-top-color: orange;\n  border-radius: 10px;\n  height: 20px;\n  left: 50%;\n  position: relative;\n  top: 50%;\n  transition: border-top-color 0.3s linear;\n  width: 20px;\n  transform: translate(-50%); }\n  .wifi-icon-large-orange:before, .wifi-icon-large-orange:after {\n    content: '';\n    background-color: transparent;\n    border: 7.0922px solid transparent;\n    border-top-color: orange;\n    position: absolute;\n    transition: border-top-color 0.3s linear; }\n  .wifi-icon-large-orange:before {\n    border-radius: 20px;\n    height: 40px;\n    left: -20px;\n    top: -20px;\n    width: 40px; }\n  .wifi-icon-large-orange:after {\n    border-radius: 60px;\n    height: 60px;\n    left: -30px;\n    top: -30px;\n    width: 60px; }\n  .wifi-icon-large-orange.none {\n    border-top-color: rgba(255, 165, 0, 0.4); }\n    .wifi-icon-large-orange.none:before, .wifi-icon-large-orange.none:after {\n      border-top-color: rgba(255, 165, 0, 0.4); }\n  .wifi-icon-large-orange.weak:before, .wifi-icon-large-orange.weak:after {\n    border-top-color: rgba(255, 165, 0, 0.4); }\n  .wifi-icon-large-orange.medium:after {\n    border-top-color: rgba(255, 165, 0, 0.4); }\n\n.wizard-steps {\n  display: flex;\n  width: 100%;\n  position: relative; }\n  .wizard-steps .step {\n    flex: 1;\n    text-align: center; }\n    .wizard-steps .step .bounding-box {\n      display: inline-block; }\n    .wizard-steps .step span.label {\n      font-size: 1.6rem;\n      margin-bottom: 10px;\n      display: inline-block;\n      background-color: #aaa;\n      font-weight: 700; }\n    .wizard-steps .step.done .bounding-box {\n      cursor: pointer; }\n    .wizard-steps .step.done span.label {\n      background-color: #5cb85c; }\n    .wizard-steps .step.active span.label {\n      background-color: #337ab7; }\n    .wizard-steps .step p {\n      font-weight: bold;\n      font-size: 12px; }\n    .wizard-steps .step:first-child::before {\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 10px;\n      height: 4px;\n      background-color: #ccc;\n      border-radius: 2px;\n      content: ' ';\n      z-index: -1; }\n\n.resource-card {\n  max-width: 1024px;\n  padding: 0; }\n  .resource-card .img-container {\n    width: 25%; }\n  .resource-card .content-container {\n    width: 75%;\n    padding: 15px; }\n  .resource-card .label {\n    float: right;\n    margin-bottom: 15px;\n    display: block; }\n  @media (max-width: 767px) {\n    .resource-card .img-container {\n      display: none; }\n    .resource-card .content-container {\n      width: 100%; }\n    .resource-card .label {\n      display: none; } }\n  .resource-card h3 {\n    border-bottom: 1px solid #149eda;\n    padding-bottom: 5px; }\n  .resource-card h4 {\n    margin-bottom: 5px;\n    font-size: 15px;\n    font-weight: bold; }\n  .resource-card p {\n    font-size: 13px;\n    color: #676767; }\n  .resource-card li {\n    border-bottom: 1px solid #ddd; }\n  .resource-card li:last-child {\n    border-bottom: none; }\n\n.platform-banner-text {\n  font-size: 1em;\n  color: #fff; }\n\n.platform-description {\n  font-size: 1.2em;\n  margin-bottom: 30px;\n  border-left: 2px solid #1aa8a1;\n  line-height: 2; }\n\n@media (min-width: 768px) {\n  /* large screens have 9 icons across + 1 empty space at beginning and end .. thus 11 x 100/11% equally spaced columns */\n  .platform-banner {\n    background-image: url(//cdn2.hubspot.net/hubfs/484866/BoxCast_May2016/Platform-Background-Lines.png?t=1472503471940);\n    background-size: cover;\n    background-color: #1aa8a1;\n    margin-top: 40px;\n    margin-bottom: 30px; }\n  .platform-banner li {\n    width: 8.8%;\n    display: block;\n    float: left;\n    margin: 0;\n    padding: 15px 0;\n    background: transparent;\n    text-align: center;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .platform-banner li img {\n    max-width: 80%; }\n  .platform-banner li.hover {\n    background: rgba(0, 0, 0, 0.2); }\n  .platform-banner li.active {\n    background: rgba(0, 0, 0, 0.3); }\n  .building-graphic {\n    max-width: 300px;\n    margin: 15px auto; } }\n\n@media (max-width: 767px) {\n  /* small screens need to hide the first and last empty spaces, and stack 3-across otherwise (3x3 grid) */\n  .platform-banner {\n    background-image: none;\n    background-color: #1aa8a1;\n    margin-top: 40px;\n    margin-bottom: 50px; }\n  .platform-banner li {\n    width: 33%;\n    display: block;\n    float: left;\n    padding: 15px;\n    background: transparent; }\n  .platform-banner li.empty-space {\n    display: none; }\n  .platform-banner li.hover {\n    background: rgba(0, 0, 0, 0.2); }\n  .platform-banner li.active {\n    background: rgba(0, 0, 0, 0.3); }\n  .building-graphic {\n    max-width: 200px;\n    margin: 15px auto; } }\n\n.market-icon {\n  max-width: 20%; }\n\n.radio-button-well {\n  opacity: 1;\n  background-color: white;\n  border: 1px solid;\n  border-color: #d0d0d0;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  padding: 10px; }\n  .radio-button-well a {\n    border-bottom: none;\n    color: black;\n    text-decoration: none; }\n  .radio-button-well i {\n    width: 20px;\n    text-align: center; }\n\n.radio-button-well-selected {\n  opacity: 1;\n  background-color: white;\n  border: 2px solid #5cb85c;\n  padding: 8px;\n  /* absorb the extra padding */\n  border-radius: 4px; }\n\n@keyframes fade-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 100%; } }\n\n.modal-checkout .add-on-alert {\n  background-color: #d9edf7;\n  padding: 8px 8px 8px 8px !important;\n  margin-left: 20px;\n  border-radius: 5px;\n  margin-top: 8px; }\n\n.modal-checkout .alert {\n  margin-bottom: 0;\n  text-align: left;\n  padding: 10px;\n  opacity: 100%;\n  animation-name: fade-in;\n  animation-duration: 500ms; }\n\n.modal-checkout .checkout-message {\n  opacity: 0.75;\n  font-weight: normal;\n  font-size: 8pt;\n  line-height: 1.1em; }\n\n.modal-checkout .alert-danger {\n  color: white;\n  background-color: #a94442;\n  border-color: #a94442; }\n\n.modal-checkout .add-on-alert div {\n  padding-left: 0 !important; }\n\n.modal-checkout .btn-breadcrumb {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr); }\n  .modal-checkout .btn-breadcrumb .btn {\n    width: 100%; }\n  .modal-checkout .btn-breadcrumb .btn.active {\n    width: auto;\n    padding-right: 6px; }\n    .modal-checkout .btn-breadcrumb .btn.active .step-label {\n      display: inline;\n      font-size: 16px;\n      width: min-content; }\n  .modal-checkout .btn-breadcrumb .step-label {\n    display: none;\n    font-size: 16px; }\n  .modal-checkout .btn-breadcrumb .fa-check-circle,\n  .modal-checkout .btn-breadcrumb .fa-circle-o {\n    font-size: 19px;\n    margin: 0; }\n  .modal-checkout .btn-breadcrumb .fa-circle-o {\n    color: slategray; }\n  .modal-checkout .btn-breadcrumb .fa-check-circle {\n    color: #1aa8a1; }\n  @media (min-width: 576px) {\n    .modal-checkout .btn-breadcrumb .fa-check-circle {\n      margin-right: 10px; }\n    .modal-checkout .btn-breadcrumb .breadcrumb-mobile {\n      display: none; }\n    .modal-checkout .btn-breadcrumb .step-label {\n      display: inline; } }\n\n.modal-checkout .compare-options {\n  font-size: 12px; }\n  @media (min-width: 576px) {\n    .modal-checkout .compare-options {\n      float: right;\n      font-size: 14px; } }\n\n.modal-checkout .overview {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 10px; }\n  .modal-checkout .overview .toggle-icon {\n    transition: all 0.3s;\n    font-size: 20px;\n    font-weight: 300;\n    color: #006c80;\n    margin-left: 10px;\n    transform: rotate(0deg); }\n    @media (min-width: 576px) {\n      .modal-checkout .overview .toggle-icon {\n        display: none; } }\n  .modal-checkout .overview .toggle-icon.collapse {\n    transform: rotate(45deg); }\n  .modal-checkout .overview .price {\n    margin-bottom: 0; }\n  .modal-checkout .overview > * {\n    height: 100%;\n    align-self: center; }\n  @media (min-width: 576px) {\n    .modal-checkout .overview {\n      display: flex;\n      flex-direction: column;\n      padding-left: 0; }\n      .modal-checkout .overview .price {\n        margin-bottom: 10px; } }\n\n.modal-checkout .plan-details {\n  overflow: hidden;\n  max-height: 0;\n  transition: max-height 0.35s ease-in-out; }\n  @media (min-width: 576px) {\n    .modal-checkout .plan-details {\n      display: flex;\n      flex-direction: column;\n      max-height: 100%;\n      height: 100%; } }\n\n.modal-checkout .show {\n  transition: max-height 0.35s ease-in-out;\n  max-height: 300px; }\n\n.pricing-table-row {\n  display: flex;\n  flex-wrap: wrap;\n  text-align: center;\n  flex: 1; }\n  .pricing-table-row .pricing-col {\n    display: flex;\n    flex: 1; }\n    @media (max-width: 575px) {\n      .pricing-table-row .pricing-col {\n        width: 100%;\n        padding-bottom: 15px; } }\n    @media (min-width: 576px) {\n      .pricing-table-row .pricing-col {\n        padding-bottom: 0; } }\n  .pricing-table-row .pricing-col > div {\n    flex: 1;\n    border: 2px solid transparent;\n    border-radius: 4px;\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);\n    padding: 6px;\n    display: flex;\n    flex-direction: column;\n    position: relative; }\n    .pricing-table-row .pricing-col > div .current-plan-flag {\n      position: absolute;\n      left: -2px;\n      right: -2px;\n      top: -20px;\n      background: #1aa8a1;\n      color: white;\n      text-align: center;\n      font-size: 10px;\n      font-weight: bold;\n      border-radius: 4px 4px 0 0;\n      padding: 5px 0; }\n  .pricing-table-row h3 {\n    font-size: 12pt;\n    font-weight: bold;\n    margin: -10px -10px 0px -10px;\n    padding: 10px 0; }\n  .pricing-table-row .price {\n    font-size: 14px;\n    font-weight: bold; }\n  .pricing-table-row .subtitle {\n    font-size: 9pt;\n    font-weight: bold;\n    margin-bottom: 10px; }\n  .pricing-table-row .subtext {\n    line-height: 1.2em;\n    opacity: 1;\n    font-weight: normal;\n    font-size: 12px; }\n  .pricing-table-row .checkout-divider {\n    border-top: 1px solid #70707080; }\n  .pricing-table-row .small-text {\n    font-size: 8pt; }\n  .pricing-table-row ul {\n    flex: 0 1 auto; }\n    .pricing-table-row ul li {\n      margin-bottom: 2px;\n      font-size: 14px; }\n  .pricing-table-row .pricing-col.active > div {\n    border: 2px solid #1aa; }\n  .pricing-table-row .pricing-col .cta {\n    margin-top: auto; }\n  .pricing-table-row .pricing-col .btn-block {\n    margin-top: 5px; }\n  .pricing-table-row .pricing-col.encoder-options {\n    text-align: left;\n    width: 100%;\n    margin-top: 10px; }\n  .pricing-table-row .pricing-col.encoder-options > div {\n    display: block;\n    /*not a flex column*/\n    line-height: 1em;\n    overflow: scroll; }\n  .pricing-table-row .pricing-col.encoder-options .price {\n    float: right; }\n  .pricing-table-row .pricing-col.encoder-options .radio label,\n  .pricing-table-row .pricing-col.encoder-options .checkbox label,\n  .pricing-table-row p.section-head {\n    font-weight: bold;\n    margin-bottom: 0;\n    line-height: 1.2; }\n  .pricing-table-row .promo-copy {\n    line-height: 1.2;\n    margin-bottom: 0; }\n  .pricing-table-row .radio label,\n  .pricing-table-row .checkbox label {\n    font-weight: bold;\n    margin-bottom: 0; }\n  .pricing-table-row .pricing-col.encoder-options .radio div,\n  .pricing-table-row .pricing-col.encoder-options .checkbox div {\n    padding-left: 20px; }\n  .pricing-table-row .radio div.subtext,\n  .pricing-table-row .checkbox div.subtext:first-of-type {\n    max-width: 75%; }\n  .pricing-table-row .form-control {\n    width: unset;\n    padding: 3px;\n    height: 28px; }\n  .pricing-table-row .info-input {\n    width: unset;\n    padding: 3px;\n    height: 28px;\n    border: 2px solid green; }\n  .pricing-table-row .radio + .radio,\n  .pricing-table-row .checkbox + .checkbox {\n    margin-top: 10px; }\n  .pricing-table-row .interval-radio div.subtext {\n    max-width: 100%; }\n  .pricing-table-row .add-on-quantity {\n    display: flex;\n    margin-top: 8px;\n    align-items: center; }\n  .pricing-table-row .add-on-quantity input {\n    max-width: 40px;\n    max-height: 30px; }\n  .pricing-table-row .add-on-container {\n    display: block;\n    line-height: 1em;\n    max-height: 200px;\n    overflow-y: scroll; }\n    .pricing-table-row .add-on-container div:first-child {\n      margin-top: 10px; }\n    .pricing-table-row .add-on-container > div {\n      display: grid;\n      grid-template-columns: 1fr auto; }\n      .pricing-table-row .add-on-container > div .price {\n        grid-column: 2;\n        grid-row: 1; }\n      .pricing-table-row .add-on-container > div > div {\n        grid-column: 1;\n        grid-row: 1;\n        margin-top: 0; }\n  @media (max-width: 767px) {\n    .pricing-table-row .interval-radio {\n      margin-left: 16px;\n      width: 100%; } }\n  @media (min-width: 768px) {\n    .pricing-table-row .interval-radio {\n      margin-left: 16px;\n      width: 45%; } }\n  @media (min-width: 992px) {\n    .pricing-table-row .interval-radio {\n      margin-left: 16px; } }\n\n.sm-storagePolicy {\n  border: 2px solid transparent;\n  border-radius: 4px;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);\n  padding: 2rem;\n  display: flex;\n  margin-bottom: 2rem;\n  align-items: center;\n  font-weight: normal; }\n  .sm-storagePolicy__input {\n    padding-right: 2rem; }\n  .sm-storagePolicy__message p:first-child {\n    margin-bottom: 3px; }\n  .sm-storagePolicy__message p:last-child {\n    margin-bottom: 0; }\n  .sm-storagePolicy__price {\n    margin-left: auto; }\n\n@media (min-width: 768px) {\n  .payment .payment-details {\n    border-left: 3px #eee solid; } }\n\n.order-summary .order-summary-head {\n  display: flex;\n  justify-content: space-between; }\n\n.order-summary div#order-summary-container {\n  max-height: 182px;\n  overflow-y: scroll; }\n\n.order-summary .order-summary-table tbody tr th,\n.order-summary .order-summary-table tbody tr td {\n  font-size: 12px; }\n\n.order-summary .order-summary-table tbody tr th {\n  padding-left: 0; }\n\n.order-summary .order-summary-scroll.btn-breadcrumb {\n  width: initial;\n  display: none; }\n\n.order-summary .btn-breadcrumb .btn {\n  width: initial; }\n\n.order-summary .btn-breadcrumb .btn,\n.order-summary .btn-breadcrumb .btn:first-child,\n.order-summary .btn-breadcrumb .btn:last-child {\n  padding: 1px 6px 1px 6px; }\n\n.order-summary .btn-group-vertical > .btn,\n.order-summary .btn-group > .btn {\n  position: initial;\n  float: left; }\n\n.order-summary .btn-breadcrumb .btn:not(:last-child):after {\n  content: ' ';\n  border-top: none;\n  border-bottom: none;\n  border-left: none;\n  position: absolute; }\n\n.order-summary .btn-breadcrumb .btn:not(:last-child):before {\n  content: ' ';\n  border-top: none;\n  border-bottom: none;\n  border-left: none;\n  position: absolute; }\n\n.modal-footer {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  flex-flow: column-reverse; }\n  .modal-footer span,\n  .modal-footer span > .btn {\n    width: 100%;\n    margin-left: 0 !important; }\n  .modal-footer .back-button {\n    margin: 10px 0; }\n  @media (min-width: 768px) {\n    .modal-footer {\n      display: block; }\n      .modal-footer span,\n      .modal-footer span > .btn {\n        width: auto; }\n      .modal-footer .back-button {\n        margin: 0 10px; } }\n  .modal-footer p {\n    margin-bottom: 0.5rem;\n    margin-top: 0.5rem; }\n\n.order-status-modal .icon {\n  padding: 5px 25px; }\n\n.order-status-modal .icon img {\n  height: 60px; }\n\n.order-status-modal .line img {\n  width: 75px; }\n\n.order-status-modal .line div {\n  border: 2px solid #59b659;\n  width: 75px; }\n\n.order-status-modal .order-info div {\n  margin: 0px;\n  padding: 0px;\n  text-align: left; }\n\n.order-status-modal .order-info label {\n  margin-bottom: 0px; }\n\n.order-status-modal .order-status td {\n  vertical-align: text-top; }\n\n.sport-tiles {\n  margin: 1rem 0;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); }\n  @media screen and (min-width: 768px) {\n    .sport-tiles {\n      gap: 1rem;\n      grid-template-columns: repeat(4, 1fr);\n      grid-template-rows: repeat(2, 1fr); } }\n\n.sport-tile {\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n  display: flex; }\n  @media screen and (min-width: 768px) {\n    .sport-tile {\n      width: auto; } }\n  .sport-tile__inner {\n    padding: 12px;\n    line-height: 1;\n    white-space: normal; }\n    @media screen and (max-width: 767px) {\n      .sport-tile__inner {\n        border-color: #e7e7e7; } }\n  .sport-tile__icon {\n    display: block;\n    margin: 0 auto 0.4rem; }\n  .sport-tile__label {\n    display: inline-block;\n    margin-top: 4px;\n    line-height: 1; }\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 42px;\n  height: 24px;\n  line-height: 24px;\n  margin-bottom: 0;\n  vertical-align: bottom; }\n  .toggle-switch input {\n    display: none; }\n  .toggle-switch .slider {\n    display: inline-block;\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    transition: 0.2s;\n    border-radius: 24px; }\n  .toggle-switch .slider:before {\n    position: absolute;\n    content: '';\n    height: 16px;\n    width: 16px;\n    left: 4px;\n    bottom: 4px;\n    background-color: white;\n    transition: 0.2s;\n    border-radius: 50%; }\n  .toggle-switch--green input:checked + .slider {\n    background-color: #5cb85c; }\n  .toggle-switch--green input:focus + .slider {\n    box-shadow: 0 0 1px #5cb85c; }\n  .toggle-switch--blue input:checked + .slider {\n    background-color: #2196f3; }\n  .toggle-switch--blue input:focus + .slider {\n    box-shadow: 0 0 1px #2196f3; }\n  .toggle-switch input:checked + .slider:before {\n    transform: translateX(18px); }\n\n.table-fixed {\n  table-layout: fixed; }\n\n.analytics h3,\n.analytics h4 {\n  margin-top: 0; }\n\n.analytics h4 {\n  border-bottom: 1px solid #149eda;\n  margin-bottom: 15px;\n  padding-bottom: 5px;\n  text-align: center; }\n\n.analytics h1 {\n  font-weight: bold;\n  font-size: 2.6em; }\n\n.analytics .achievements {\n  text-align: center; }\n  .analytics .achievements achievements-cell {\n    margin: 10px 0; }\n\n.analytics .achievements .locked {\n  opacity: 0.2; }\n\n.analytics .achievements .unlocked .fa {\n  color: #f5e174; }\n\n.analytics .achievements label {\n  display: block;\n  font-size: 1.4rem;\n  font-weight: bold; }\n\n.analytics .achievements .locked label {\n  opacity: 0; }\n\n.analytics .col-xs-12:last-of-type .well {\n  margin-bottom: 0; }\n\n.broadcast-details-right-col h4 {\n  margin-top: 0;\n  font-size: 1.4rem;\n  font-weight: bold;\n  color: var(--color-bx-grey-darken-2);\n  text-transform: uppercase; }\n\n.broadcast-details-right-col .destination-details {\n  background: #fff;\n  border: 1px solid #ccc;\n  position: relative;\n  top: -2px;\n  border-top: none;\n  border-radius: 0 0 4px 4px;\n  padding: 5px 10px;\n  font-size: 1.4rem; }\n\n.broadcast-details-right-col .diagnostics--icon-,\n.broadcast-details-right-col .diagnostics--icon-unknown {\n  color: #ccc; }\n\n.broadcast-details-right-col .diagnostics--icon-connected {\n  color: var(--color-bx-green-lighten-1); }\n\n.broadcast-details-right-col .diagnostics--icon-warning {\n  color: orange; }\n\n.broadcast-details-right-col .btn .fa.pull-right {\n  margin-top: 5px;\n  font-size: 0.7em; }\n\n@media (min-width: 768px) {\n  .broadcast-details-right-col {\n    padding-left: 0; } }\n\n.table-no-border {\n  border: none; }\n  .table-no-border td,\n  .table-no-border th,\n  .table-no-border tr {\n    border: none !important; }\n\n.caption-upload-cell .drop-box {\n  background: #fff;\n  padding: 0; }\n  .caption-upload-cell .drop-box.drag-over {\n    background: #ffffd4; }\n\n.caption-table .caption-table--header {\n  background: #555;\n  color: #fff;\n  line-height: 23px !important;\n  border-radius: 4px 4px 0 0;\n  padding: 10px; }\n\n.caption-table .caption--row {\n  margin-left: 0;\n  margin-right: 0;\n  padding: 5px; }\n\n.caption-table .caption--text textarea {\n  border: none;\n  box-shadow: none;\n  resize: none;\n  outline: none;\n  width: 100%;\n  background: transparent;\n  padding: 0;\n  line-height: 20px;\n  border-bottom: 2px solid transparent; }\n  .caption-table .caption--text textarea:hover {\n    border-color: rgba(0, 0, 0, 0.1); }\n  .caption-table .caption--text textarea:focus, .caption-table .caption--text textarea:active {\n    border-color: rgba(0, 0, 0, 0.25); }\n\n.caption-table .caption--start,\n.caption-table .caption--stop {\n  font-weight: bold;\n  font-size: 10pt; }\n  .caption-table .caption--start input,\n  .caption-table .caption--stop input {\n    padding: 0;\n    line-height: 25px; }\n\n.caption-table .caption--stop {\n  color: #ccc; }\n\n.caption-table .caption--row .caption--actions .fa {\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out; }\n\n.caption-table .caption--row:hover .caption--actions .fa {\n  opacity: 1; }\n\n.caption-table .caption--text {\n  padding-left: 15px; }\n\n.caption-table .caption--low-confidence .caption--text {\n  border-left: 8px solid #f1a74b !important;\n  padding-left: 7px;\n  /*7px padding + 8px border == 15px normal confidence padding*/ }\n\n.caption-table .caption--low-confidence .caption--text {\n  background: #fff5e6; }\n\n.caption-table .caption--playback-active {\n  background: aliceblue; }\n\n.caption-table .fa {\n  width: 22px;\n  height: 22px;\n  line-height: 20px;\n  color: #999;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  text-align: center; }\n\n.caption-table .fa-play {\n  padding-left: 2px; }\n\n.caption-table-scroll {\n  height: calc(100vh - 215px);\n  background: #fff;\n  overflow-y: scroll; }\n\n.caption--preview {\n  position: absolute;\n  bottom: 60px;\n  left: 0;\n  right: 0;\n  width: 100%;\n  text-align: center; }\n  .caption--preview span {\n    font-weight: bold;\n    color: #fff;\n    background: rgba(0, 0, 0, 0.8);\n    border-radius: 4px;\n    padding: 5px; }\n\n.channel-card .broadcast-card {\n  padding: 0 !important;\n  padding-bottom: 15px !important; }\n\n.channel-card .broadcast-card--name a {\n  font-size: 10pt;\n  font-weight: bold;\n  color: #000;\n  text-decoration: none; }\n\n.channel-card .broadcast-card--name {\n  margin: 0 !important; }\n\n.channel-card .broadcast-card--name a:hover {\n  color: #000;\n  text-decoration: none; }\n\n.channel-card .broadcast-card--date {\n  margin-top: -2px; }\n\n.channel-card .broadcast-card--date .date-range {\n  font-weight: normal; }\n\n.channel-card .broadcast-card--description {\n  display: none; }\n\n.checkout-complete .cg-busy {\n  margin-top: 0; }\n\n.checkout-complete .cg-busy-backdrop {\n  margin-left: 0;\n  margin-right: 0;\n  margin-bottom: 0; }\n\n.checkout-complete .radio-button-well {\n  opacity: 1;\n  background-color: white;\n  border: 1px solid;\n  border-color: #d0d0d0;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  padding: 10px; }\n\n.checkout-complete .radio-button-well-selected {\n  border: 3px solid #3b763d;\n  padding: 8px;\n  /* absorb the extra padding */ }\n\n.fa.disabled {\n  opacity: 0.5; }\n\n.modal-checkout .btn-success {\n  text-transform: uppercase; }\n\n@keyframes turn-off {\n  0% {\n    transform: scale(1, 1.3) translate3d(0, 0, 0);\n    -webkit-filter: brightness(1);\n    filter: brightness(1);\n    opacity: 1; }\n  60% {\n    transform: scale(1.3, 0.001) translate3d(0, 0, 0);\n    -webkit-filter: brightness(10);\n    filter: brightness(10); }\n  100% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: scale(0, 0.0001) translate3d(0, 0, 0);\n    -webkit-filter: brightness(50);\n    filter: brightness(50); } }\n\n.screen {\n  border: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  background: #fff; }\n\n.turn-off.screen {\n  animation: turn-off 0.55s cubic-bezier(0.23, 1, 0.32, 1);\n  animation-fill-mode: forwards; }\n\nonboarding .onboarding-list {\n  display: inline-flex !important; }\n\nonboarding .onboarding-list .btn {\n  text-align: left !important;\n  white-space: normal !important;\n  min-height: 50px;\n  width: 100%;\n  text-transform: capitalize; }\n\nonboarding .onboarding-list span {\n  margin-right: 10px;\n  flex: 1;\n  max-width: 270px; }\n\n@media (max-width: 767px) {\n  onboarding .onboarding-list {\n    display: block !important;\n    white-space: normal !important; }\n  onboarding .onboarding-list .btn {\n    display: block !important;\n    height: 40px;\n    width: auto;\n    margin: 5px; }\n  onboarding .onboarding-list span {\n    margin-right: 0; } }\n\nonboarding .active .btn {\n  border-radius: 6px !important;\n  font-size: 1.2em;\n  color: white;\n  transform: scale(1.01); }\n  onboarding .active .btn i {\n    display: none; }\n\nonboarding .active .btn:hover {\n  box-shadow: 0px 0px 5px #888888;\n  color: white; }\n\nonboarding .complete .btn {\n  background-color: white;\n  color: #afb2b6;\n  border: 1px solid #449d44; }\n  onboarding .complete .btn span {\n    display: none; }\n\nonboarding .complete .btn:hover {\n  background-color: white;\n  color: #afb2b6; }\n\nonboarding .pending .btn {\n  background-color: white;\n  color: #343434;\n  border: 1px solid #343434; }\n  onboarding .pending .btn i {\n    display: none; }\n\nonboarding .pending .btn:hover {\n  background-color: white;\n  color: #343434; }\n\nonboarding .onboarding-item-heading {\n  margin: 5px 10px 0 0 !important;\n  font-size: 16pt; }\n\nonboarding .no-click {\n  pointer-events: none; }\n\n.account-settings .data-value {\n  float: right;\n  text-transform: capitalize; }\n\n.account-settings p.subsection-header {\n  font-weight: bold;\n  font-size: 0.8em;\n  opacity: 0.7;\n  margin-top: 15px;\n  border-bottom: 1px solid #ddd; }\n\n.boxcaster-card,\n.integration-card {\n  display: block;\n  border-radius: 4px;\n  padding: 0;\n  transition: transform 100ms ease-in;\n  background: #fafafa;\n  border: 1px solid #eee;\n  color: #333; }\n  .boxcaster-card .color--red,\n  .integration-card .color--red {\n    color: #d03532; }\n  .boxcaster-card .color--green,\n  .integration-card .color--green {\n    color: var(--color-bx-green); }\n  .boxcaster-card .color--online,\n  .integration-card .color--online {\n    color: var(--color-bx-green-lighten-1); }\n  .boxcaster-card .color--grey,\n  .integration-card .color--grey {\n    color: #ddd; }\n\n@media (max-width: 767px) {\n  .boxcaster-card,\n  .integration-card {\n    padding: 5px;\n    margin-left: -5px;\n    margin-right: -5px; }\n    .boxcaster-card .boxcaster-card-details,\n    .boxcaster-card .integration-card-details,\n    .integration-card .boxcaster-card-details,\n    .integration-card .integration-card-details {\n      margin-left: -5px;\n      margin-right: -5px;\n      margin-bottom: -5px; } }\n\n.boxcaster-card-header,\n.integration-card-header {\n  cursor: pointer; }\n\n.integration-card-header .label-list {\n  margin-top: 12px;\n  margin-bottom: 12px; }\n  .integration-card-header .label-list > li {\n    padding: 0; }\n\n.boxcaster-card .row,\n.integration-card .row {\n  display: flex;\n  align-items: center; }\n\n/* statuses: offline, ready, preparing_broadcast, broadcasting */\n.icon-power,\n.icon-streaming,\n.icon-video {\n  color: #34c335; }\n\n.status-offline .icon-power,\n.status-offline .icon-streaming,\n.status-offline .icon-video {\n  color: rgba(255, 255, 255, 0.4); }\n\n.status-ready .icon-streaming {\n  color: rgba(255, 255, 255, 0.4); }\n\n/* firmware issues should be highlighted */\n.firmware-invalid {\n  border-color: #ce5d5d; }\n\n/* badges */\n.boxcaster-badge,\n.boxcaster-pro-badge,\n.rtmp-badge,\n.broadcaster-badge,\n.integration-badge,\n.producer-badge,\n.bg-image-badge {\n  width: 75px;\n  height: 75px;\n  color: #fafafa;\n  font-size: 8pt;\n  letter-spacing: 0.3px;\n  text-align: center;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n  border-radius: 4px 0 0 4px; }\n\n.boxcaster-card-expanded .boxcaster-badge,\n.boxcaster-card-expanded .boxcaster-pro-badge,\n.integration-card-expanded .boxcaster-badge,\n.integration-card-expanded .boxcaster-pro-badge {\n  border-radius: 4px 0 0 0; }\n\n.channel-card i.fa-chevron-up {\n  display: none; }\n\n.channel-card.channel-card-expanded i.fa-chevron-down {\n  display: none; }\n\n.channel-card.channel-card-expanded i.fa-chevron-up {\n  display: inline-block; }\n\n.boxcaster-badge {\n  background: var(--color-bx-accessible-blue);\n  color: white;\n  font-weight: 500; }\n\n.boxcaster-pro-badge {\n  background: #343434;\n  color: white;\n  font-weight: 500; }\n  .boxcaster-pro-badge .pro-text {\n    font-weight: 300; }\n\n.rtmp-badge {\n  background: #ddd;\n  color: #333; }\n\n.producer-badge {\n  background: var(--color-bx-accessible-blue);\n  color: var(--color-bx-black); }\n\n.broadcaster-badge,\n.bg-image-badge {\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%;\n  color: transparent; }\n\n.broadcaster-badge {\n  background: url(\"/img/source-vendors/Video-Source_BroadcasterApp.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%; }\n\n.integration-badge--facebook {\n  background: url(/img/icon_facebook@2x.png); }\n\n.integration-badge--youtube {\n  background: url(/img/icon_youtube@2x.png); }\n\n.integration-badge--twitter {\n  background: url(/img/icon_x-twitter@2x.png); }\n\n.integration-badge--vimeo {\n  background: url(/img/icon_vimeo@2x.png); }\n\n.integration-badge--ss {\n  background: url(/img/ss-144x144.png); }\n\n.integration-badge--facebook, .integration-badge--youtube, .integration-badge--twitter, .integration-badge--vimeo, .integration-badge--ss {\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%;\n  color: transparent; }\n\n.integration-badge--rtmp_push {\n  background: #ddd;\n  color: #333; }\n\n.integration-badge--sportzcast {\n  background: #bb1115;\n  color: #fff;\n  font-weight: bold; }\n\n.integration-badge img,\n.integration-badge i {\n  display: none; }\n\n.boxcaster-card-details,\n.integration-card-details {\n  border-top: 1px solid #eee;\n  background: #fff;\n  padding: 15px; }\n  .boxcaster-card-details table,\n  .integration-card-details table {\n    width: auto; }\n    .boxcaster-card-details table td,\n    .boxcaster-card-details table th,\n    .integration-card-details table td,\n    .integration-card-details table th {\n      border: none !important; }\n\n.add-integration li {\n  margin-bottom: 15px; }\n\n.add-integration .btn-block {\n  background: #eee;\n  text-align: left;\n  border: none;\n  font-size: 16px;\n  font-weight: bold;\n  padding: 0 15px 0 0;\n  line-height: 55px; }\n  .add-integration .btn-block .integration-badge {\n    width: 55px;\n    height: 55px;\n    margin-right: 15px; }\n    .add-integration .btn-block .integration-badge i {\n      font-size: 22px; }\n    .add-integration .btn-block .integration-badge--rtmp_push span {\n      white-space: normal;\n      line-height: 13px; }\n  .add-integration .btn-block > * {\n    line-height: 55px; }\n\n/* source selector dropdown on new-event and broadcast edit */\n.source-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin-bottom: -6px;\n  margin-right: 10px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%;\n  color: transparent; }\n\n.source-icon--boxcaster {\n  background-image: url(\"/img/source-icon--boxcaster.jpg\"); }\n\n.source-icon--boxcaster_pro {\n  background-image: url(\"/img/source-icon--pro.jpg\"); }\n\n.source-icon--producer {\n  background-image: url(\"/img/BoxCast_logo_400px.png\"); }\n\n.source-icon--switcher {\n  background-image: url(\"/img/source-icon--switcher.jpg\"); }\n\n.source-icon--broadcaster {\n  background-image: url(\"/img/broadcaster-icon.jpg\"); }\n\n.source-icon--static_rtmp {\n  background-image: url(\"/img/source-icon--rtmp.jpg\"); }\n\n.source-icon--rtmp {\n  background-image: url(\"/img/source-icon--rtmp.jpg\"); }\n\n.source-icon--ready,\n.source-icon--in-use {\n  color: #34c335; }\n\n.source-icon--offline {\n  color: #ccc; }\n\n.source-icon--issue {\n  color: #ce5d5d; }\n\n.source-chooser--option {\n  width: 100%;\n  padding: 5px 8px; }\n\n.source-chooser--selected {\n  width: calc(100% - 30px); }\n\n.btn-add-source {\n  width: 100%;\n  height: auto;\n  max-height: 200px;\n  max-width: 200px; }\n\n.btn-add-source:hover {\n  transform: scale(1.05); }\n\n.btn-rtmp-guide {\n  margin: 10px 12px 0 12px;\n  border: 1px solid gray;\n  border-radius: 4px; }\n  .btn-rtmp-guide .img {\n    padding: 10px 12px 0 12px;\n    width: 100%;\n    height: auto;\n    max-height: 150px;\n    max-width: 150px; }\n\n.btn-rtmp-guide:hover {\n  transform: scale(1.05); }\n\n.storage-button-group {\n  visibility: hidden; }\n\ntbody tr:hover td span.storage-button-group {\n  visibility: visible; }\n\n.table-hover tbody tr:hover td,\n.table-hover tbody tr:hover th {\n  background-color: #f5f5f5; }\n\n.btn-payment {\n  border: 2px solid #eee;\n  opacity: 0.75; }\n\n.btn-payment:active:hover {\n  background-color: white;\n  border: 2px solid #5cb85c;\n  outline: none; }\n\n.btn-payment-selected {\n  border: 2px solid #5cb85c;\n  background-color: white;\n  pointer-events: none;\n  outline: none; }\n\n.btn-payment-selected:focus {\n  border: 2px solid #5cb85c;\n  background-color: white;\n  outline: none; }\n\n.btn-payment-selected:active {\n  border: 2px solid #5cb85c;\n  background-color: white;\n  outline: none; }\n\n.table-fix-head {\n  overflow-y: auto;\n  height: calc(100vh - 500px); }\n\n.table-fix-head thead th {\n  position: sticky;\n  top: 0;\n  background-color: #fff; }\n\n.table-horiz-scroll-container {\n  margin: 15px 0;\n  position: relative; }\n  .table-horiz-scroll-container > .scroll-container {\n    overflow-y: none;\n    overflow-x: scroll; }\n    .table-horiz-scroll-container > .scroll-container::-webkit-scrollbar {\n      -webkit-appearance: none;\n      width: 8px; }\n    .table-horiz-scroll-container > .scroll-container::-webkit-scrollbar-track {\n      border-radius: 8px;\n      background-color: rgba(0, 0, 0, 0.1); }\n    .table-horiz-scroll-container > .scroll-container::-webkit-scrollbar-thumb {\n      border-radius: 8px;\n      background-color: rgba(0, 0, 0, 0.2);\n      -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5); }\n  .table-horiz-scroll-container > .scroll-shadow {\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    pointer-events: none;\n    box-shadow: inset -7px 0 7px -7px rgba(0, 0, 0, 0.4), inset 7px 0 7px -7px rgba(0, 0, 0, 0.4); }\n  .table-horiz-scroll-container > .table {\n    width: auto;\n    max-width: none;\n    margin-bottom: 0; }\n\n.account__pw-change .account__pw-change-label--container {\n  display: flex; }\n  .account__pw-change .account__pw-change-label--container label {\n    flex: 1; }\n  .account__pw-change .account__pw-change-label--container .account__pw-change-label--toggle {\n    color: blue;\n    cursor: pointer; }\n\n.account__pw-validation-rules {\n  list-style-type: none;\n  margin: 0 0 0 10px;\n  padding: 0; }\n\n.account__pw-validation .account__pw-standard.initial::before {\n  content: '\\2022';\n  font-size: 16px;\n  width: 7px;\n  font-family: FontAwesome;\n  margin-left: 5px;\n  margin-right: 10px;\n  color: #343434;\n  display: inline-block; }\n\n.account__pw-validation .account__pw-standard.valid::before {\n  content: '\\F00C';\n  color: #1ba8a1;\n  font-size: 16px;\n  width: 17px;\n  font-family: FontAwesome;\n  margin-right: 5px;\n  margin-left: 0;\n  display: inline-block; }\n\n.account__pw-validation .account__pw-standard.invalid::before {\n  content: '\\F05E';\n  color: #a94442;\n  font-size: 16px;\n  width: 17px;\n  font-family: FontAwesome;\n  margin-right: 5px;\n  margin-left: 0;\n  display: inline-block; }\n\n@media (min-width: 768px) {\n  .home-container .tab-container {\n    min-height: calc(100vh - 210px); } }\n\n.trial-video-container {\n  max-width: calc(100vh);\n  margin: 45px auto 0; }\n\n.home-container.has-chat {\n  margin-bottom: 200px; }\n\n.home-cards {\n  display: flex;\n  flex-direction: column; }\n  @media screen and (min-width: 768px) {\n    .home-cards {\n      flex-direction: row;\n      gap: 2rem;\n      max-width: 920px;\n      margin: 0 auto;\n      justify-content: center; } }\n\n.home-card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--color-bx-grey-lighten-2);\n  border-radius: 0.5rem;\n  padding: 4rem 1.5rem;\n  color: var(--color-bx-grey-darken-2);\n  text-decoration: none;\n  margin-bottom: 2rem;\n  box-shadow: 0 0 #0000;\n  transition: all 0.2s ease-in;\n  transform: translateY(0);\n  will-change: box-shadow transform; }\n  @media screen and (min-width: 768px) {\n    .home-card {\n      flex-basis: 0;\n      flex-grow: 1;\n      max-width: 232px; } }\n  .home-card:hover {\n    text-decoration: none;\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);\n    transform: translateY(-0.5rem); }\n  .home-card__icon {\n    font-size: 4rem;\n    margin-bottom: 1.6rem;\n    color: var(--color-bx-black); }\n  .home-card__header {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    left: 0;\n    right: 0;\n    padding: 0.25rem 0.5rem;\n    font-weight: 500;\n    border-radius: 0.5rem 0.5rem 0 0; }\n    .home-card__header--lagoon {\n      background-color: var(--color-bx-lagoon);\n      color: white; }\n\nembed-copy-paste label {\n  font-size: 1.2em;\n  line-height: 40px; }\n\nembed-copy-paste textarea.form-control[readonly] {\n  background: #243548;\n  color: #8bacbf;\n  font-family: monospace;\n  border: none;\n  font-size: 9pt; }\n\n.source-card-row {\n  max-width: 900px;\n  margin: 15px auto; }\n\n.source-cards {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.5rem; }\n  @media screen and (min-width: 600px) {\n    .source-cards {\n      padding: 0 1rem;\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      gap: 2%; } }\n\n@media screen and (min-width: 600px) {\n  .source-card-wrapper {\n    width: calc(50% - 1%); } }\n\n@media screen and (min-width: 992px) {\n  .source-card-wrapper {\n    width: calc(33% - 1%); } }\n\n@media screen and (min-width: 1200px) {\n  .source-card-wrapper {\n    width: calc(24% - 1%); } }\n\n@media screen and (min-width: 1200px) {\n  .modal-body .source-card-wrapper {\n    width: calc(33% - 1%); } }\n\n.source-card {\n  min-height: 300px;\n  position: relative;\n  border-radius: 4px;\n  border: 1px solid #fafafa;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\n  padding: 2.4rem 1.2rem 1.2rem;\n  margin-bottom: 2rem; }\n  .source-card--recommended {\n    position: absolute;\n    top: -1px;\n    left: -1px;\n    right: -1px;\n    background: var(--color-bx-lagoon);\n    color: #fff;\n    font-size: 10pt;\n    font-weight: 700;\n    padding: 3px;\n    border-radius: 4px 4px 0 0; }\n  .source-card--icon {\n    height: 80px;\n    margin: 20px auto;\n    text-align: center; }\n    .source-card--icon img {\n      max-width: 100%;\n      max-height: 100%; }\n  .source-card--description {\n    height: 100px;\n    overflow: hidden; }\n  .source-card--actions .btn-default {\n    font-weight: bold; }\n  .source-card--actions .btn-bcgreen {\n    font-weight: bold; }\n  .source-card--actions li {\n    display: block; }\n    .source-card--actions li:first-child {\n      margin-bottom: 0.5rem; }\n    .source-card--actions li button,\n    .source-card--actions li a {\n      display: block;\n      width: 100%; }\n\n@media (max-width: 1056px) {\n  .left-rail {\n    z-index: 3;\n    transform: translateX(-230px);\n    transition: 200ms ease-in-out;\n    top: 50px;\n    height: calc(100vh - 50px); }\n    .left-rail .navProducts {\n      display: block; }\n  .nav-open .left-rail {\n    transform: translateX(0); }\n  .main-content {\n    margin-left: 0 !important;\n    margin-top: 70px; }\n  .top-rail .navbar {\n    height: 50px; }\n    .top-rail .navbar .navbar-links {\n      display: none; } }\n\n@media (min-width: 992px) and (max-width: 1056px) {\n  .visible-md-lg {\n    display: block !important; }\n  table.visible-md-lg {\n    display: table !important; }\n  tr.visible-md-lg {\n    display: table-row !important; }\n  td.visible-md-lg, th.visible-md-lg {\n    display: table-cell !important; } }\n\n@media (min-width: 992px) and (max-width: 1056px) {\n  .hidden-md-lg {\n    display: none !important; } }\n\n@media (min-width: 1700px) {\n  .col-xxl-3,\n  .col-xxl-4 {\n    float: left; }\n  .col-xxl-3 {\n    width: 25%; }\n  .col-xxl-4 {\n    width: 33.33333333%; } }\n\nuib-tab-heading .label-as-badge {\n  position: relative;\n  top: -3px;\n  left: 3px; }\n\n.well.well-with-inline-tabs {\n  border-radius: 0;\n  background: #fff; }\n\n.list-inline.inline-tabs {\n  margin: 0 -15px;\n  border-bottom: 1px solid #ddd; }\n  .list-inline.inline-tabs > li h3 {\n    line-height: 21px; }\n  .list-inline.inline-tabs > li {\n    padding: 0 0 10px; }\n    .list-inline.inline-tabs > li a {\n      color: var(--color-bx-grey-darken-2);\n      font-weight: bold;\n      padding: 0 10px 12px;\n      text-decoration: none;\n      outline: none;\n      white-space: nowrap; }\n  .list-inline.inline-tabs > li a:hover {\n    color: var(--color-bx-lagoon); }\n  .list-inline.inline-tabs > li.active a {\n    color: var(--color-bx-black);\n    border-bottom: 2px solid; }\n  @media screen and (min-width: 1280px) {\n    .list-inline.inline-tabs:not(.inline-tabs--dont-increase-font-size) > li {\n      font-size: 16px; } }\n\n.table-unstyled td,\n.table-unstyled th {\n  border: none !important; }\n\n/* underlined tab ui */\n.nav-tabs > li.active > a,\n.nav-tabs > li.active > a:focus,\n.nav-tabs > li.active > a:hover {\n  background-color: transparent;\n  border: none;\n  font-weight: bold;\n  border-bottom: 2px solid;\n  color: var(--color-bx-denim); }\n\n.nav-tabs > li > a {\n  color: var(--color-bx-grey-darken-3);\n  font-weight: bold; }\n\n.btn-default,\n.btn-bcgreen,\n.btn-bcorange,\n.btn-lagoon,\n.btn-success,\n.btn-primary,\n.btn-warning,\n.btn-danger {\n  transition: background-color 0.2s ease-in; }\n\n/* additional button styles */\n.btn-square {\n  height: 80px;\n  width: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: normal;\n  flex-direction: column; }\n\n.btn-square img {\n  width: 80px; }\n\n.btn-bcorange {\n  background-color: #fc672c;\n  color: #fff; }\n  .btn-bcorange:hover, .btn-bcorange:active, .btn-bcorange:focus {\n    color: #fff; }\n\n.btn-bcorange-outline {\n  background-color: #fff;\n  border: 1px solid #fc672c;\n  color: #fc672c; }\n  .btn-bcorange-outline:hover, .btn-bcorange-outline:active, .btn-bcorange-outline:focus {\n    color: #fc672c; }\n\n.btn-bcgreen {\n  background-color: #1aa8a1;\n  color: #fff; }\n  .btn-bcgreen:hover, .btn-bcgreen:active, .btn-bcgreen:focus {\n    color: #fff;\n    background-color: #17928c; }\n\n.btn-lagoon {\n  background-color: var(--color-bx-lagoon);\n  color: #fff; }\n  .btn-lagoon:hover, .btn-lagoon:active, .btn-lagoon:focus {\n    color: #fff;\n    background-color: #005667; }\n\n/* btn group breadcrumbs */\n.btn-breadcrumb .btn {\n  z-index: auto !important;\n  outline: none !important;\n  box-shadow: none !important;\n  cursor: default !important; }\n\n.btn-breadcrumb .btn:not(:last-child):after {\n  content: ' ';\n  display: block;\n  width: 0;\n  height: 0;\n  border-top: 17px solid transparent;\n  border-bottom: 17px solid transparent;\n  border-left: 10px solid white;\n  position: absolute;\n  top: 50%;\n  margin-top: -17px;\n  left: 100%;\n  z-index: 3; }\n\n.btn-breadcrumb .btn:not(:last-child):before {\n  content: ' ';\n  display: block;\n  width: 0;\n  height: 0;\n  border-top: 17px solid transparent;\n  border-bottom: 17px solid transparent;\n  border-left: 10px solid #adadad;\n  position: absolute;\n  top: 50%;\n  margin-top: -17px;\n  margin-left: 1px;\n  left: 100%;\n  z-index: 3; }\n\n.btn-breadcrumb .btn {\n  padding: 6px 12px 6px 24px; }\n\n.btn-breadcrumb .btn:first-child {\n  padding: 6px 6px 6px 10px; }\n\n.btn-breadcrumb .btn:last-child {\n  padding: 6px 18px 6px 24px; }\n\n.btn-breadcrumb .btn.btn-default:hover,\n.btn-breadcrumb .btn.btn-default:focus,\n.btn-breadcrumb .btn.btn-default:active {\n  background-color: transparent; }\n\n.btn-breadcrumb .btn.btn-default.active:hover,\n.btn-breadcrumb .btn.btn-default.active:focus,\n.btn-breadcrumb .btn.btn-default.active:active {\n  background-color: #e6e6e6; }\n\n.btn-breadcrumb .btn.btn-default.active {\n  font-weight: bold; }\n\n.btn-breadcrumb .btn.btn-default:not(:last-child):after {\n  border-left: 10px solid #fff; }\n\n.btn-breadcrumb .btn.btn-default:not(:last-child):before {\n  border-left: 10px solid #ccc; }\n\n.btn-breadcrumb .btn.btn-default.active:not(:last-child):after {\n  border-left: 10px solid #e6e6e6; }\n\n.btn-breadcrumb .btn.btn-default.active:not(:last-child):before {\n  border-left: 10px solid #adadad; }\n\n.btn-breadcrumb .btn-default.active,\n.btn-breadcrumb .btn-default:active,\n.btn-breadcrumb .open > .dropdown-toggle.btn-default {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #e2e2e2; }\n\ninput[type='checkbox'],\ninput[type='radio'] {\n  margin: 2px 0 0; }\n\n.checkbox-teal [type='checkbox']:checked + label:before {\n  border-color: transparent #009688 #009688 transparent; }\n\n.label {\n  display: inline-block;\n  padding: 0.4rem 0.8rem; }\n  .label-default {\n    background: var(--color-bx-grey-darken-1); }\n\n.btn-group-flex {\n  display: flex; }\n  .btn-group-flex .btn {\n    width: auto; }\n\n.grsf-global {\n  font-size: 16px !important; }\n  .grsf-global .grsf-form-control, .grsf-global .grsf-window-progress-number, .grsf-global button, .grsf-global .grsf-window-tabs a, .grsf-global .grsf-referral-status-step-list *:not(a), .grsf-global .grsf-rewards-list *:not(h4) {\n    font-size: 16px !important; }\n  .grsf-global .grsf-window-progress-text, .grsf-global a, .grsf-global .grsf-collapsible-inner label, .grsf-global .grsf-referral-status-header > .grsf-referral-status-header-label {\n    font-size: 12px !important; }\n  .grsf-global .grsf-rewards-list h4 {\n    font-size: 20px !important; }\n\n.boxcast-audio-only {\n  z-index: 1 !important; }\n\n.cg-busy {\n  margin-top: -20px; }\n\n.cg-busy-backdrop {\n  margin-left: -15px;\n  margin-right: -15px;\n  margin-bottom: -20px; }\n\n.modal-header {\n  padding: 15px 15px 10px 15px; }\n  .modal-header h3 {\n    font-size: 1.4rem;\n    margin: 0; }\n\n.modal-body.upload-modal .drop-box {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px; }\n\n.well {\n  background: #fff;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.23);\n  border-radius: 0;\n  border: none; }\n\n.well h3 {\n  margin-top: 0; }\n\n.list-inline {\n  padding-bottom: 0;\n  margin-bottom: 0; }\n  .list-inline > li {\n    padding-right: 0;\n    padding-bottom: 5px; }\n\n.tab-container {\n  background-color: #fff;\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  padding: 5px 15px 5px 15px; }\n\n.breadcrumb .active a {\n  text-decoration: none;\n  color: #333;\n  cursor: default; }\n\n.datepicker table {\n  background: #fff; }\n\n.datepicker .btn {\n  border: none; }\n\n.datepicker tbody .btn {\n  border-radius: 15px; }\n\n.datepicker .btn-info {\n  /* today's date */ }\n\n.datepicker .text-info {\n  /* today's date */\n  font-weight: bold; }\n\n.datepicker .btn.disabled,\n.datepicker .btn[disabled],\n.datepicker fieldset[disabled] .btn {\n  opacity: 0.5;\n  /* make disabled more so */ }\n\n.datepicker .text-muted {\n  /* other month ...*/\n  color: #666; }\n\n.timepicker a {\n  /* chevron buttons */\n  padding: 0; }\n\n.table-hover > tbody > tr {\n  cursor: pointer; }\n  .table-hover > tbody > tr:hover {\n    background-color: #f4f5c3; }\n\n.table-noborders.table > tbody > tr > td,\n.table-noborders.table > tbody > tr > th,\n.table-noborders.table > tfoot > tr > td,\n.table-noborders.table > tfoot > tr > th,\n.table-noborders.table > thead > tr > td,\n.table-noborders.table > thead > tr > th {\n  border-top: none;\n  border-bottom: none; }\n\n.nav-pills > li > a {\n  color: #eee; }\n\n.nav-pills > li > a:hover,\n.nav-pills > li > a:focus {\n  background-color: #121419; }\n\n.nav-pills > li.active > a,\n.nav-pills > li.active > a:hover,\n.nav-pills > li.active > a:focus {\n  color: #fff;\n  background-color: #121419; }\n\n.label-as-badge {\n  border-radius: 1em; }\n\n.label-podcast {\n  background-color: var(--color-bx-shallot); }\n\n.label-lagoon {\n  background-color: var(--color-bx-lagoon); }\n\n.overflow-ellipse, .selectize-option__content {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.action-link {\n  font-weight: bold; }\n  .action-link:hover {\n    text-decoration: none; }\n\n.no-padding {\n  padding: 0; }\n\n.radio-links-inline a,\n.radio-links-inline a:active,\n.radio-links-inline a:focus,\n.radio-links-inline a:hover {\n  color: #666;\n  text-decoration: none; }\n\n.radio-links-inline a.active {\n  color: #333; }\n\n.fixed-square {\n  position: relative;\n  padding-bottom: 100%;\n  height: 0;\n  background: black; }\n  .fixed-square > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; }\n\n.fixed-16-9 {\n  position: relative;\n  padding-bottom: 56.25%;\n  /* 16:9 */\n  height: 0;\n  background: black; }\n  .fixed-16-9 > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; }\n\n.date-range {\n  font-size: 1.4rem;\n  letter-spacing: -0.5px;\n  font-weight: 500; }\n\n/**********************************************************\n * overlay gallery / editor\n **********************************************************/\n.transparent-grid-bg {\n  background-color: #fff;\n  background-image: linear-gradient(45deg, #e5e5e5 25%, transparent 25%), linear-gradient(-45deg, #e5e5e5 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e5e5e5 75%), linear-gradient(-45deg, transparent 75%, #e5e5e5 75%);\n  background-size: 20px 20px;\n  background-position: 0 0, 0 10px, 10px -10px, -10px 0px; }\n\n.crop-marks {\n  position: relative;\n  padding: 3px; }\n  .crop-marks div:before {\n    display: block;\n    content: '';\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    border-top: 2px dotted #3f3f3f;\n    border-left: 2px dotted #3f3f3f; }\n  .crop-marks div:after {\n    display: block;\n    content: '';\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    border-top: 2px dotted #3f3f3f;\n    border-right: 2px dotted #3f3f3f; }\n  .crop-marks span:before {\n    display: block;\n    content: '';\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    bottom: 0px;\n    left: 0px;\n    border-bottom: 2px dotted #3f3f3f;\n    border-left: 2px dotted #3f3f3f; }\n  .crop-marks span:after {\n    display: block;\n    content: '';\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    bottom: 0px;\n    right: 0px;\n    border-bottom: 2px dotted #3f3f3f;\n    border-right: 2px dotted #3f3f3f; }\n\n.overlay-gallery .upload-image {\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  background-size: contain; }\n  .overlay-gallery .upload-image.active {\n    border: 2px solid #f00;\n    box-sizing: content-box !important; }\n  .overlay-gallery .upload-image .upload-details {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding: 5px;\n    text-align: center;\n    background: rgba(0, 0, 0, 0.6); }\n    .overlay-gallery .upload-image .upload-details p {\n      color: #fff;\n      font-size: 0.75em;\n      white-space: nowrap;\n      text-overflow: ellipsis; }\n\n.overlay-canvas {\n  border: none; }\n\n.overlay-image:hover {\n  border: 2px solid rgba(19, 101, 224, 0.5); }\n\n.icon-image {\n  max-width: 28px; }\n\n.icon-image-small {\n  max-width: 20px; }\n\n/*\n * Responsive text aligning\n * http://ohryan.ca/2014/08/14/set-responsive-text-alignment-bootstrap-3/\n */\n.text-xs-left {\n  text-align: left; }\n\n.text-xs-right {\n  text-align: right; }\n\n.text-xs-center {\n  text-align: center; }\n\n.text-xs-justify {\n  text-align: justify; }\n\n@media (min-width: 768px) {\n  .text-sm-left {\n    text-align: left; }\n  .text-sm-right {\n    text-align: right; }\n  .text-sm-center {\n    text-align: center; }\n  .text-sm-justify {\n    text-align: justify; } }\n\n@media (min-width: 992px) {\n  .text-md-left {\n    text-align: left; }\n  .text-md-right {\n    text-align: right; }\n  .text-md-center {\n    text-align: center; }\n  .text-md-justify {\n    text-align: justify; } }\n\n@media (min-width: 1200px) {\n  .text-lg-left {\n    text-align: left; }\n  .text-lg-right {\n    text-align: right; }\n  .text-lg-center {\n    text-align: center; }\n  .text-lg-justify {\n    text-align: justify; } }\n\n/* inner-border only on table */\ntable.inner-border-only {\n  border-collapse: collapse; }\n  table.inner-border-only td,\n  table.inner-border-only th {\n    border: 1px solid #e4e4e4;\n    padding: 8px; }\n  table.inner-border-only tr:first-child td,\n  table.inner-border-only tr:first-child th {\n    border-top: 0; }\n  table.inner-border-only tr:last-child td,\n  table.inner-border-only tr:last-child th {\n    border-bottom: 0; }\n  table.inner-border-only tr td:first-child,\n  table.inner-border-only tr th:first-child {\n    border-left: 0; }\n  table.inner-border-only tr td:last-child,\n  table.inner-border-only tr th:last-child {\n    border-right: 0; }\n\n/* throbbing style for rtmp bandwidth test */\n.throb-in-progress {\n  animation: throb 1.5s infinite; }\n\n@keyframes throb {\n  from {\n    opacity: 0.5;\n    transform: scale(0.9); }\n  50% {\n    opacity: 1;\n    transform: scale(1); }\n  to {\n    opacity: 0.5;\n    transform: scale(0.9); } }\n\n/* nested form groups shouldn't get double negative margin */\n.form-horizontal .form-group .form-group {\n  margin-right: 0px;\n  margin-left: 0px; }\n\n/* form groups inside of wells should be spaced evenly */\n.well .form-group {\n  margin-top: 10px;\n  margin-bottom: 10px; }\n\n/* get rid of extra margin... not sure where it comes from ¯\\_(ツ)_/¯ */\ndiv.selectize-control {\n  margin-bottom: -5px; }\n\n/* except in the Facebook Live destination control, where we actually want it (smh) */\nfb-live-simulcast-settings div.selectize-control {\n  margin-bottom: 0px; }\n\n/* make selectize more bootstrap-like */\n.selectize-input {\n  background-image: none !important;\n  background-color: #fff !important;\n  border-color: #ccc !important;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;\n  border-radius: 4px !important;\n  font-size: 1.4rem; }\n  .selectize-input input {\n    font-size: 1.4rem; }\n\n.selectize-option {\n  display: inline-flex;\n  align-items: center;\n  font-size: 1.2rem; }\n  .selectize-option__icon-wrapper {\n    flex: 0 0 2rem;\n    margin-right: 0.5rem; }\n    @media screen and (min-width: 992px) {\n      .selectize-option__icon-wrapper {\n        margin-right: 1rem;\n        flex: 0 0 3.5rem; } }\n  .selectize-option__icon {\n    max-width: 100%; }\n  .selectize-option__content {\n    display: inline-flex;\n    flex-direction: column; }\n  @media screen and (min-width: 768px) {\n    .selectize-option__label {\n      font-size: 1.4rem; } }\n  .selectize-option__label-indicator {\n    margin-left: 5px;\n    margin-bottom: 0; }\n  .selectize-option__description {\n    font-size: 1.2rem; }\n\n.visually-hidden {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px; }\n\n/* boxcast-color-picker overrides */\n.color-picker-wrapper .input-group .input-group-addon {\n  padding: 6px 18px; }\n\nlabel,\n.label {\n  font-size: 1.4rem;\n  font-weight: 500; }\n\n.form-control::-webkit-input-placeholder {\n  /* Chrome/Opera/Safari */\n  color: #303030 !important; }\n\n.form-control::-moz-placeholder {\n  /* Firefox 19+ */\n  color: #303030 !important; }\n\n.form-control:-ms-input-placeholder {\n  /* IE 10+ */\n  color: #303030 !important; }\n\n.form-control:-moz-placeholder {\n  /* Firefox 18- */\n  color: #303030 !important; }\n\n.pagination-sm > li.disabled > a {\n  color: var(--color-bx-accessible-grey); }\n\n.pagination-sm > li > a {\n  font-size: 1.4rem; }\n\n.text-muted {\n  color: var(--color-bx-accessible-grey); }\n\n.help-block {\n  color: var(--color-bx-grey-darken-3); }\n\n.uib-day .btn-sm,\n.uib-title.btn-sm {\n  font-size: 1.4rem; }\n\n.uib-day .btn-info .text-info {\n  color: white; }\n\n.label-default {\n  background-color: var(--color-bx-accessible-grey); }\n\n.label-success,\n.btn-success {\n  background-color: var(--color-bx-green); }\n\n.btn-success {\n  background-color: var(--color-bx-green);\n  border-color: var(--color-bx-green); }\n  .btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success:active:focus {\n    background-color: var(--color-bx-green-darken-1);\n    border-color: var(--color-bx-green-darken-1); }\n\n.label-danger,\n.btn-danger {\n  background-color: var(--color-bx-red); }\n\n.btn-danger {\n  background-color: var(--color-bx-red);\n  border-color: var(--color-bx-red); }\n  .btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger:active:focus {\n    background-color: var(--color-bx-red-darken-1);\n    border-color: var(--color-bx-red-darken-1); }\n\n.btn-sm {\n  font-size: 1.4rem; }\n", ""]);

// exports


/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = "<div id=\"loading\" ng-if=\"vm.loading\">\n  <div>\n    <div class=\"frosted-o\"></div>\n  </div>\n</div>\n<div ng-if=\"!vm.loading\">\n  <!-- this houses all UI elements intended to be present across all routes -->\n  <div class=\"app container-fluid\" ng-class=\"vm.showEyebrow ? 'with-eyebrow' : ''\" ng-if=\"vm.account.id && $state.current.name.indexOf('switcher-studio')!=0\">\n    <div class=\"row\">\n      <top-navbar class=\"top-rail\"></top-navbar>\n      <toaster-container toaster-options=\"{'close-button': true}\"></toaster-container>\n    </div>\n\n    <!-- unauthorized users may not see a nav or a UI at all  -->\n    <div class=\"row\" ng-if=\"!vm.account.authorized() && vm.Capabilities.canUserVisitState($state.current)\">\n      <div ng-if=\"$state.current.name == 'home'\">\n        <!-- only show the left nav on the home page, since a modal will block access to it -->\n        <left-navbar class=\"left-rail\"></left-navbar>\n        <div class=\"main-content\">\n          <div class=\"container-fluid\">\n            <div ui-view></div>\n          </div>\n        </div>\n      </div>\n      <div ng-if=\"$state.current.name != 'home'\">\n        <div class=\"col-xs-12\">\n          <div style=\"margin-top:95px\" ui-view></div>\n        </div>\n      </div>\n    </div>\n\n    <!-- most users will see nav and the content beside it -->\n    <div class=\"row\" ng-if=\"vm.account.authorized()\">\n      <left-navbar class=\"left-rail\"></left-navbar>\n      <div class=\"main-content\">\n        <div class=\"container-fluid\">\n          <div ui-view></div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <!-- switcher studio goes full-bleed with no header/nav -->\n  <div ng-if=\"$state.current.name.indexOf('switcher-studio')==0 && vm.account.authorized()\">\n    <toaster-container toaster-options=\"{'close-button': true}\"></toaster-container>\n    <div ui-view></div>\n  </div>\n</div>\n"

/***/ })
],[256]);


// WEBPACK FOOTER //
// app.d63993786938b3096032.js